/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1238);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(449)();
}


/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeLanguage", function() { return changeLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneInstance", function() { return cloneInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createInstance", function() { return createInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dir", function() { return dir; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exists", function() { return exists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFixedT", function() { return getFixedT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadLanguages", function() { return loadLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadNamespaces", function() { return loadNamespaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadResources", function() { return loadResources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "off", function() { return off; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "on", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDefaultNamespace", function() { return setDefaultNamespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return t; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "use", function() { return use; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18next_js__ = __webpack_require__(316);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);

var changeLanguage = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].changeLanguage.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var cloneInstance = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].cloneInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var createInstance = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].createInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var dir = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].dir.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var exists = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].exists.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var getFixedT = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].getFixedT.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var init = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].init.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadLanguages = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadLanguages.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadNamespaces = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadNamespaces.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadResources = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadResources.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var off = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].off.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var on = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].on.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var setDefaultNamespace = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].setDefaultNamespace.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var t = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].t.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var use = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].use.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.checkDefined = checkDefined;
exports.checkType = checkType;
exports.isType = isType;
exports.isString = isString;
exports.isArray = isArray;
exports.isObject = isObject;
exports.isDefined = isDefined;
exports.isInteger = isInteger;
exports.isNumeric = isNumeric;
exports.contains = contains;
exports.isValidUid = isValidUid;
exports.areDefinedAndEqual = areDefinedAndEqual;
/**
 * @module lib/check
 */

/**
 *
 * @param value
 * @param name
 * @returns {boolean}
 */
function checkDefined(value, name) {
    if (value !== undefined) {
        return true;
    }
    throw new Error([name || 'Value', 'should be provided'].join(' '));
}

// TODO: Decide if checkType([], 'object') is a 'false' positive
function checkType(value, type, name) {
    checkDefined(value, name);
    checkDefined(type, 'Type');

    if (typeof type === 'function' && value instanceof type || typeof type === 'string' && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === type) {
        // eslint-disable-line valid-typeof
        return true;
    }
    throw new Error(['Expected', name || value, 'to have type', type].join(' '));
}

// TODO: Log type error?
function isType(value, type) {
    function noop() {}

    try {
        checkType(value, type);
        return true;
    } catch (e) {
        noop();
    }

    return false;
}

function isString(value) {
    return isType(value, 'string');
}

function isArray(value) {
    return Array.isArray(value);
}

function isObject(value) {
    return isType(value, Object);
}

function isDefined(value) {
    return value != null;
}

function isInteger(nVal) {
    return typeof nVal === 'number' && isFinite(nVal) && nVal > -9007199254740992 && nVal < 9007199254740992 && Math.floor(nVal) === nVal;
}

// Polyfill for the isInteger function that will be added in ES6
// http://wiki.ecmascript.org/doku.php?id=harmony:number.isinteger
/* istanbul ignore if  */
if (!Number.isInteger) {
    Number.isInteger = isInteger;
}

function isNumeric(nVal) {
    return typeof nVal === 'number' && isFinite(nVal) && nVal - parseFloat(nVal) + 1 >= 0;
}

function contains(item, list) {
    var listToCheck = isArray(list) && list || [];

    return listToCheck.indexOf(item) >= 0;
}

var isEmpty = exports.isEmpty = function isEmpty(list) {
    return list.length >= 0;
};

/**
 * @deprecated Use isValidUid from the `uid.js` file.
 */
function isValidUid(value) {
    return value && value.length === 11;
}

var hasKeys = exports.hasKeys = function hasKeys(object) {
    return object && Object.keys(object).length > 0;
};

function areDefinedAndEqual(left, right) {
    return isDefined(left) && isDefined(right) && right === left;
}

var toBe = exports.toBe = function toBe(left, right) {
    return left === right;
};
var toBeAny = exports.toBeAny = function toBeAny(values) {
    return function (left) {
        return values.some(function (right) {
            return toBe(left, right);
        });
    };
};
var isNullUndefinedOrEmptyString = exports.isNullUndefinedOrEmptyString = toBeAny([undefined, null, '']);

var isFunction = exports.isFunction = function isFunction(fun) {
    return typeof fun === 'function';
};

var hasOwnProperty = exports.hasOwnProperty = function hasOwnProperty(object, propertyName) {
    return Object.prototype.hasOwnProperty.call(object, propertyName);
};
//# sourceMappingURL=check.js.map

/***/ }),
/* 16 */
/***/ (function(module, exports) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var baseConvert = __webpack_require__(325),
    util = __webpack_require__(327);

/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */
function convert(name, func, options) {
  return baseConvert(util, name, func, options);
}

module.exports = convert;


/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.config = undefined;
exports.getManifest = getManifest;
exports.getUserSettings = getUserSettings;
exports.init = init;
exports.getInstance = getInstance;

__webpack_require__(167);

var _utils = __webpack_require__(29);

var _Logger = __webpack_require__(168);

var _Logger2 = _interopRequireDefault(_Logger);

var _model = __webpack_require__(278);

var _model2 = _interopRequireDefault(_model);

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

var _System = __webpack_require__(170);

var _System2 = _interopRequireDefault(_System);

var _I18n = __webpack_require__(299);

var _I18n2 = _interopRequireDefault(_I18n);

var _config = __webpack_require__(300);

var _config2 = _interopRequireDefault(_config);

var _CurrentUser = __webpack_require__(301);

var _CurrentUser2 = _interopRequireDefault(_CurrentUser);

var _config3 = __webpack_require__(173);

var _DataStore = __webpack_require__(306);

var _DataStore2 = _interopRequireDefault(_DataStore);

var _Analytics = __webpack_require__(308);

var _Analytics2 = _interopRequireDefault(_Analytics);

var _GeoFeatures = __webpack_require__(315);

var _GeoFeatures2 = _interopRequireDefault(_GeoFeatures);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
                                                                                                                                                                                                     * @module d2
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * @description
                                                                                                                                                                                                     * Module that contains the entry points for working with the d2 instance. Most of the api related functionality will be available through this package.
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * The most important functions from the module are {@link module:d2.init|init} and {@link module:d2.init|getInstance} these are used to create and to get
                                                                                                                                                                                                     * a hold of the initialized instance of {@link module:d2.init~d2|d2}. The initialized instance is the object that allows you access most of d2's functionality.
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * @example
                                                                                                                                                                                                     * import { init } from 'd2/lib/d2';
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * init({ baseUrl: 'https://play.dhis2.org/demo/api/27/' })
                                                                                                                                                                                                     *  .then(d2 => console.log(d2.currentUser.name));
                                                                                                                                                                                                     */


var firstRun = true;
var deferredD2Init = _utils.Deferred.create();

var preInitConfig = _config2.default.create();

/**
 * Utility function to load the app manifest.
 *
 * The manifest well be enhanced with a `getBaseUrl()` utility function that will return the base url of the DHIS2 instance.
 * This is a simple getter for the `activities.dhis.href` property on the manifest.
 *
 * @example
 * import { getManifest } from 'd2/lib/d2';
 *
 * getManifest()
 *   .then(manifest => {
 *      console.log(manifest.getBaseUrl());
 *   });
 *
 * @param {string} url The location of the manifest. Generally this is located in the root of your app folder. (e.g. './manifest.webapp)
 * @param {Api} [ApiClass] An implementation of the Api class that will be used to fetch the manifest.
 *
 * @returns {Promise} Returns a Promise to  the DHIS2 app manifest with the added `getBaseUrl` method.
 */
function getManifest(url) {
    var ApiClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Api2.default;

    var api = ApiClass.getApi();
    api.setBaseUrl('');

    var manifestUtilities = {
        getBaseUrl: function getBaseUrl() {
            return this.activities.dhis.href;
        }
    };

    return api.get('' + url).then(function (manifest) {
        return Object.assign({}, manifest, manifestUtilities);
    });
}

/**
 * @function getUserSettings
 *
 * @returns {Promise} A promise to the current user settings
 *
 * @description
 * The object that is the result of the promise will have the following properties
 *
 * @example
 * import {getUserSettings} from 'd2/lib/d2';
 *
 * getUserSettings()
 *  .then(userSettings => {
 *      console.log(userSettings);
 *  });
 */
function getUserSettings() {
    var ApiClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Api2.default;

    var api = ApiClass.getApi();

    if (preInitConfig.baseUrl && firstRun) {
        api.setBaseUrl(preInitConfig.baseUrl);
    }

    return api.get('userSettings');
}

function getModelRequests(api, schemaNames) {
    var modelRequests = [];
    var loadSchemaForName = function loadSchemaForName(schemaName) {
        return api.get('schemas/' + schemaName, { fields: _config3.fieldsForSchemas });
    };

    if (Array.isArray(schemaNames)) {
        var individualSchemaRequests = schemaNames.map(loadSchemaForName).concat([]);

        var schemasPromise = Promise.all(individualSchemaRequests).then(function (schemas) {
            return { schemas: schemas };
        });

        modelRequests.push(schemasPromise);

        if (schemaNames.length > 0) {
            // If schemas are loaded, attributes should be as well
            modelRequests.push(api.get('attributes', { fields: ':all,optionSet[:all,options[:all]]', paging: false }));
        } else {
            // Otherwise, just return an empty list of attributes
            modelRequests.push({ attributes: [] });
        }
    } else {
        // If no schemas are specified, load all schemas and attributes
        modelRequests.push(api.get('schemas', { fields: _config3.fieldsForSchemas }));
        modelRequests.push(api.get('attributes', { fields: ':all,optionSet[:all,options[:all]]', paging: false }));
    }

    return modelRequests;
}

/**
 * Init function that used to initialise {@link module:d2.init~d2|d2}. This will load the schemas from the DHIS2 api and configure your {@link module:d2.init~d2|d2} instance.
 *
 * The `config` object that can be passed into init can have the following properties:
 *
 * baseUrl: Set this when the url is something different then `/api`. If you are running your dhis instance in a subdirectory of the actual domain
 * for example http://localhost/dhis/ you should set the base url to `/dhis/api`
 *
 * @param {Object} initConfig Configuration object that will be used to configure to define D2 Setting.
 * See the description for more information on the available settings.
 * @returns {Promise.<D2>} A promise that resolves with the intialized {@link init~d2|d2} object.
 *
 * @example
 * import init from 'd2';
 *
 * init({baseUrl: '/dhis/api'})
 *   .then((d2) => {
 *     console.log(d2.model.dataElement.list());
 *   });
 */
function init(initConfig) {
    var ApiClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Api2.default;
    var logger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _Logger2.default.getLogger();

    var api = ApiClass.getApi();

    var config = _config2.default.create(preInitConfig, initConfig);

    if (config.headers) {
        api.setDefaultHeaders(config.headers);
    }

    /**
     * @namespace
     */
    var d2 = {
        /**
         * @description
         * This is the entry point for the modelDefinitions that were loaded. To start interacting with the metadata api
         * you would pick a modelDefinition from this object to interact with.
         *
         * @type {Object.<string, ModelDefinition>}
         * @instance
         */
        models: undefined,
        /**
         * Collection of the {@link module:model} classes
         *
         * @deprecated There is probably no point to expose this.
         * @instance
         */
        model: _model2.default, // TODO: Remove (Breaking)
        /**
         * Api class that is used throughout the api interaction. This can be used to get hold of the module:Api singleton.
         *
         * @example
         * d2.Api.getApi()      // Returns the api object
         *  .get('resources')   // Do a get request for /api/resources
         *  .then(resources => {
         *      console.log(resources);
         *  });
         *
         * @see {@link module:api~Api#getApi}
         *
         * @instance
         */
        Api: ApiClass,
        /**
         * System instance to interact with system information like system settings, system info etc.
         *
         * @example
         * console.log(d2.system.version.major); // 2 for DHIS 2.27
         *
         * @see {@link module:system/System~System|System}
         * @instance
         */
        system: _System2.default.getSystem(),
        /**
         * I18n instance with the loaded translations.
         *
         * Usually used for retrieving translations for a given key using `getTranslation(key: string)`
         *
         * @example
         * d2.i18n.getTranslation('success'); // Returns "Success" for the english locale
         *
         * @see {@link module:i18n~I18n#getTranslation|getTranslation}
         *
         * @instance
         */
        i18n: _I18n2.default.getI18n(),
        /**
         * Instance of the DataStore class for interaction with the dataStore api.
         *
         * @see {@link module:datastore.DataStore DataStore}
         *
         * @instance
         */
        dataStore: _DataStore2.default.getDataStore(),

        /**
         * Analytics instance for requesting analytics data from various endpoints.
         *
         * @example
         * d2.analytics.aggregate
         *  .addDimensions([
         *   'dx:Uvn6LCg7dVU;OdiHJayrsKo',
         *   'pe:LAST_4_QUARTERS',
         *   'ou:lc3eMKXaEfw;PMa2VCrupOd',
         *  ])
         *  .addFilter('pe:2016Q1;2016Q2')
         *  .getRawData({
         *    startDate: '2017-10-01',
         *    endDate: '2017-10-31'
         *  })
         *  .then(console.log)
         *
         * @see {@link module:analytics.Analytics Analytics}
         * @instance
         */
        analytics: _Analytics2.default.getAnalytics(),

        /*
         * GeoFeatures instance
         *
         * @see {@link module:geoFeatures.GeoFeatures GeoFeatures}
         * @instance
         */
        geoFeatures: _GeoFeatures2.default.getGeoFeatures()
    };

    // Process the config in a the config class to keep all config calls together.
    _config2.default.processConfigForD2(config, d2);

    // Because when importing the getInstance method in dependencies the getInstance could run before
    // init we have to resolve the current promise on first run and for consecutive ones replace the
    // old one with a fresh promise.
    if (firstRun) {
        firstRun = false;
    } else {
        deferredD2Init = _utils.Deferred.create();
    }

    var modelRequests = getModelRequests(api, config.schemas);

    var userRequests = [api.get('me', { fields: ':all,organisationUnits[id],userGroups[id],userCredentials[:all,!user,userRoles[id]' }), api.get('me/authorization'), getUserSettings(ApiClass)];

    var systemRequests = [api.get('system/info'), api.get('apps')];

    return Promise.all([].concat(_toConsumableArray(modelRequests), userRequests, systemRequests, [d2.i18n.load()])).then(function (res) {
        var responses = {
            schemas: (0, _utils.pick)('schemas')(res[0]),
            attributes: (0, _utils.pick)('attributes')(res[1]),
            currentUser: res[2],
            authorities: res[3],
            userSettings: res[4],
            systemInfo: res[5],
            apps: res[6]
        };

        responses.schemas
        // We only deal with metadata schemas
        .filter(function (schema) {
            return schema.metadata;
        })
        // TODO: Remove this when the schemas endpoint is versioned or shows the correct urls for the requested version
        // The schemas endpoint is not versioned which will result into the modelDefinitions always using the
        // "default" endpoint, we therefore modify the endpoint url based on the given baseUrl.
        .map(function (schema) {
            schema.apiEndpoint = (0, _utils.updateAPIUrlWithBaseUrlVersionNumber)(schema.apiEndpoint, config.baseUrl); // eslint-disable-line no-param-reassign

            return schema;
        }).forEach(function (schema) {
            // Attributes that do not have values do not by default get returned with the data,
            // therefore we need to grab the attributes that are attached to this particular schema to be able to know about them
            var schemaAttributes = responses.attributes.filter(function (attributeDescriptor) {
                var attributeNameFilter = [schema.singular, 'Attribute'].join('');
                return attributeDescriptor[attributeNameFilter] === true;
            });

            if (!Object.prototype.hasOwnProperty.call(d2.models, schema.singular)) {
                d2.models.add(_model2.default.ModelDefinition.createFromSchema(schema, schemaAttributes));
            }
        });

        /**
         * An instance of {@link module:current-user/CurrentUser~CurrentUser|CurrentUser}
         *
         * The currentUser can be used to retrieve data related to the currentUser.
         *
         * These things primarily include:
         * - currentUser properties retrieved from `/api/me`
         * - Lazily request collections related to the user such as
         *      - userRoles
         *      - userGroups
         *      - organisationUnits
         *      - dataViewOrganisationUnits
         * - authorities
         * - userSettings
         * - utility methods for ACL
         *
         * @example
         * d2.currentUser.canCreate(d2.models.dataElement); // Returns true when the user can create either a private/public dataElement
         * d2.currentUser.canCreate(d2.models.organisationUnit); // Returns true the user can create an organisationUnit
         *
         * @see {@link module:current-user/CurrentUser~CurrentUser|CurrentUser}
         * @instance
         */
        d2.currentUser = _CurrentUser2.default.create(responses.currentUser, responses.authorities, d2.models, responses.userSettings);
        d2.system.setSystemInfo(responses.systemInfo);
        d2.system.setInstalledApps(responses.apps);

        deferredD2Init.resolve(d2);
        return deferredD2Init.promise;
    }).catch(function (error) {
        logger.error('Unable to get schemas from the api', JSON.stringify(error), error);

        deferredD2Init.reject('Unable to get schemas from the DHIS2 API');
        return deferredD2Init.promise;
    });
}

/**
 * This function can be used to retrieve the `singleton` instance of d2. The instance is being created by calling
 * the `init` method.
 *
 * @returns {Promise.<D2>} A promise to the initialized {@link module:d2.init~d2|d2} instance.
 *
 * @example
 * import {init, getInstance} from 'd2';
 *
 * init({baseUrl: '/dhis2/api/'});
 * getInstance()
 *   .then(d2 => {
 *      d2.models.dataElement.list();
 *      // and all your other d2 magic.
 *   });
 */
function getInstance() {
    return deferredD2Init.promise;
}

/**
 * Can be used to set config options before initialisation of d2.
 *
 * @example
 * import {config, init} from 'd2';
 *
 * config.baseUrl = '/demo/api';
 * config.i18n.sources.add('i18n/systemsettingstranslations.properties');
 *
 * init()
 *   .then(d2 => {
 *     d2.system.settings.all()
 *       .then(systemSettings => Object.keys())
 *       .then(systemSettingsKey => {
 *         d2.i18n.getTranslation(systemSettingsKey);
 *       });
 *   });
 *   @type Config
 */
var config = exports.config = preInitConfig; // Alias preInitConfig to be able to `import {config} from 'd2';`

exports.default = {
    init: init,
    config: config,
    getInstance: getInstance,
    getUserSettings: getUserSettings,
    getManifest: getManifest
};
//# sourceMappingURL=d2.js.map

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @module api
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
/* global window fetch Headers */


__webpack_require__(167);

var _check = __webpack_require__(15);

var _utils = __webpack_require__(29);

var _System = __webpack_require__(170);

var _System2 = _interopRequireDefault(_System);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getMergeStrategyParam() {
    var mergeType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'REPLACE';

    var system = _System2.default.getSystem();

    if (system.version && Number(system.version.minor) <= 22) {
        return 'mergeStrategy=' + mergeType;
    }

    return 'mergeMode=' + mergeType;
}

function getUrl(baseUrl, url) {
    // If we are dealing with an absolute url use that instead
    if (new RegExp('^(:?https?:)?//').test(url)) {
        return url;
    }

    var urlParts = [];

    if (baseUrl) {
        urlParts.push(baseUrl);
    }
    urlParts.push(url);

    return urlParts.join('/').replace(new RegExp('(.(?:[^:]))//+', 'g'), '$1/').replace(new RegExp('/$'), '');
}

/**
 * @description
 * Used for interaction with the dhis2 api.
 *
 * This class is used as the backbone for d2 and handles all the interaction with the server. There is a singleton
 * available to be reused across your applications. The singleton can be grabbed from the d2 instance.
 *
 * ```js
 * import { getInstance } from 'd2/lib/d2';
 *
 * getInstance()
 *  .then(d2 => {
 *      const api = d2.Api.getApi() // Returns the Api singleton.
 *
 *      api.get('resources');
 *  });
 * ```
 *
 * Uses {@link https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API|Fetch} to do network requests.
 *
 * @memberof module:api
 */

var Api = function () {
    /**
     * @constructor
     *
     * @param {Fetch} [fetchImpl] The fetch implementation to use. Can be used to pass a different implementation
     * similar to the fetch Api. Will default to `window.fetch` in a browser context.
     */
    function Api(fetchImpl) {
        _classCallCheck(this, Api);

        // Optionally provide fetch to the constructor so it can be mocked during testing
        if (typeof fetchImpl === 'function') {
            this.fetch = fetchImpl.bind(typeof window !== 'undefined' ? window : global);
        } else if (typeof fetch !== 'undefined') {
            this.fetch = fetch.bind(typeof window !== 'undefined' ? window : global);
        } else {
            throw new Error('Failed to initialise D2 Api: No fetch implementation is available');
        }

        this.baseUrl = '/api';
        this.defaultFetchOptions = {
            mode: 'cors', // requests to different origins fail
            credentials: 'include', // include cookies with same-origin requests
            cache: 'default' // See https://fetch.spec.whatwg.org/#concept-request-cache-mode
        };
        this.defaultHeaders = {};
    }

    /**
     * Used for setting default headers that should be send with every request.
     *
     * @example
     * const api = Api.getApi();
     *
     * api.setDefaultHeaders({
     *  'x-requested-with': 'XMLHttpRequest', // Make sure the Api does not redirect when authorization is expired.
     * });
     *
     * @param {Object.<string, string>} headers Default headers that should be set on every request.
     */


    _createClass(Api, [{
        key: 'setDefaultHeaders',
        value: function setDefaultHeaders(headers) {
            this.defaultHeaders = headers;
        }

        /**
         * Performs a GET request.
         *
         * @param {string} url The url for the request
         * @param {*} data Any data that should be send with the request. For a GET request these are turned into
         * query parameters. For POST and PUT requests it becomes the body.
         * @param {Object.<string, any>} options The request options are passed as options to the fetch request.
         * These options are passed as the {@link https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch#Parameters|init}
         * parameter to the fetch request.
         *
         * @returns {Promise.<*>} The response body.
         */

    }, {
        key: 'get',
        value: function get(url, data, options) {
            return this.request('GET', getUrl(this.baseUrl, url), data, options);
        }

        /* eslint-disable complexity */
        /**
         * Performs a POST request.
         *
         * @param {string} url The url for the request
         * @param {*} data Any data that should be send with the request this becomes the body for the POST request
         * @param {Object.<string, any>} options The request options are passed as options to the fetch request.
         * These options are passed as the {@link https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch#Parameters|init}
         * parameter to the fetch request.
         *
         * @returns {Promise.<*>} The response body.
         */

    }, {
        key: 'post',
        value: function post(url, data) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var requestUrl = getUrl(this.baseUrl, url);
            var payload = data;

            // Ensure that headers are defined and are treated without case sensitivity
            options.headers = new Headers(options.headers || {}); // eslint-disable-line

            if (data !== undefined) {
                if (data.constructor.name === 'FormData') {
                    // Ensure that the browser will set the correct Content-Type header for FormData, including boundary
                    options.headers.delete('Content-Type');
                    payload = data;
                } else if (options.headers.has('Content-Type') && options.headers.get('Content-Type').toLocaleLowerCase().startsWith('text/')) {
                    payload = String(data);
                } else {
                    // Send JSON data by default
                    options.headers.set('Content-Type', 'application/json');
                    payload = JSON.stringify(data);
                }
            }

            return this.request('POST', requestUrl, payload, options);
        }
        /**
         * Performs a DELETE request.
         *
         * @param {string} url The url for the request
         * @param {Object.<string, any>} options The request options are passed as options to the fetch request.
         * These options are passed as the {@link https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch#Parameters|init}
         * parameter to the fetch request.
         *
         * @returns {Promise.<*>} The response body.
         */
        /* eslint-enable complexity */

    }, {
        key: 'delete',
        value: function _delete(url, options) {
            return this.request('DELETE', getUrl(this.baseUrl, url), undefined, options);
        }

        /**
         * Perform a PUT request.
         *
         * @param {string} url The url for the request
         * @param {*} data Any data that should be send with the request. This becomes the body of the PUT request.
         * @param {boolean} [useMergeStrategy=false]
         *
         * @returns {Promise.<*>} The response body.
         */

    }, {
        key: 'update',
        value: function update(url, data) {
            var useMergeStrategy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            // Since we are currently using PUT to save the full state back, we have to use mergeMode=REPLACE
            // to clear out existing values
            var urlForUpdate = useMergeStrategy === true ? url + '?' + getMergeStrategyParam() : url;

            return this.request('PUT', getUrl(this.baseUrl, urlForUpdate), JSON.stringify(data));
        }

        /**
         * Perform a PATCH request.
         *
         * @param {string} url The url for the request
         * @param {*} data Any data that should be send with the request. This becomes the body of the PATCH request.
         *
         * @returns {Promise.<*>} The response body.
         */

    }, {
        key: 'patch',
        value: function patch(url, data) {
            return this.request('PATCH', getUrl(this.baseUrl, url), JSON.stringify(data));
        }

        /**
         * General purpose request function for making http requests.
         *
         * The more specific functions like `delete`, `post` and `get`, utilize this function to make the requests.
         *
         * @param {string} method The HTTP request method (e.g. POST/GET/PATCH)
         * @param {string} url The url for the request
         * @param {*} data Any data that should be send with the request. For a GET request these are turned into
         * query parameters. For POST and PUT requests it becomes the body.
         * @param {Object.<string, any>} options The request options are passed as options to the fetch request.
         * These options are passed as the {@link https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch#Parameters|init}
         * parameter to the fetch request.
         *
         * @returns {Promise.<*>} The response body.
         */
        /* eslint-disable complexity */

    }, {
        key: 'request',
        value: function request(method, url, data) {
            var _this = this;

            var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            (0, _check.checkType)(method, 'string', 'Request type');
            (0, _check.checkType)(url, 'string', 'Url');
            var api = this;
            var requestUrl = url;
            var query = '';

            if (requestUrl.indexOf('?') !== -1) {
                query = requestUrl.substr(requestUrl.indexOf('?') + 1);
                requestUrl = requestUrl.substr(0, requestUrl.indexOf('?'));
            }

            // Transfer filter properties from the data object to the query string
            if (data && Array.isArray(data.filter)) {
                var encodedFilters = data.filter.map(function (filter) {
                    return filter.split(':').map(encodeURIComponent).join(':');
                });

                query = '' + (0, _utils.customEncodeURIComponent)(query) + (query.length ? '&' : '') + ('filter=' + encodedFilters.join('&filter='));
                delete data.filter; // eslint-disable-line no-param-reassign
            }

            // When using the GET method, transform the data object to query parameters
            if (data && method === 'GET') {
                Object.keys(data).forEach(function (key) {
                    query = '' + query + (query.length > 0 ? '&' : '') + (encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
                });
            }

            function getOptions(defaultHeaders, mergeOptions, requestData) {
                var resultOptions = Object.assign({}, api.defaultFetchOptions, mergeOptions);
                var headers = new Headers(mergeOptions.headers || {});

                Object.keys(defaultHeaders).filter(function (header) {
                    return !headers.get(header);
                }).forEach(function (header) {
                    return headers.set(header, defaultHeaders[header]);
                });

                resultOptions.method = method;

                // Only set content type when there is data to send
                // GET requests and requests without data do not need a Content-Type header
                // 0 and false are valid requestData values and therefore should have a content type
                if (resultOptions.method === 'GET' || !requestData && requestData !== 0 && requestData !== false) {
                    headers.delete('Content-Type');
                } else if (requestData) {
                    if (data.constructor.name === 'FormData') {
                        headers.delete('Content-Type');
                    } else if (!headers.get('Content-Type')) {
                        headers.set('Content-Type', 'application/json');
                    }
                    resultOptions.body = requestData;
                }

                resultOptions.headers = headers;
                return resultOptions;
            }

            if (query.length) {
                requestUrl = requestUrl + '?' + query;
            }
            var requestOptions = getOptions(this.defaultHeaders, options, data);

            // If the provided value is valid JSON, return the parsed JSON object. If not, return the raw value as is.
            function parseResponseData(value) {
                try {
                    return JSON.parse(value);
                } catch (e) {
                    return value;
                }
            }

            return new Promise(function (resolve, reject) {
                // fetch returns a promise that will resolve with any response received from the server
                // It will be rejected ONLY if no response is received from the server, i.e. because there's no internet
                _this.fetch(requestUrl, requestOptions).then(function (response) {
                    // If the request failed, response.ok will be false and response.status will be the status code
                    if (response.ok) {
                        response.text().then(function (text) {
                            return resolve(parseResponseData(text));
                        });
                    } else {
                        response.text().then(function (text) {
                            if (!Object({"NODE_ENV":"production"}) || Object({"NODE_ENV":"production"}).npm_lifecycle_event !== 'test') {
                                console.warn( // eslint-disable-line
                                'API request failed with status ' + response.status + ' ' + response.statusText + '\n', 'Request: ' + requestOptions.method + ' ' + requestUrl);
                            }
                            reject(parseResponseData(text));
                        });
                    }
                }).catch(function (err) {
                    // It's not usually possible to get much info about the cause of the error programmatically, but
                    // the user can check the browser console for more info
                    if (!Object({"NODE_ENV":"production"}) || Object({"NODE_ENV":"production"}).npm_lifecycle_event !== 'test') {
                        console.error('Server connection error:', err); // eslint-disable-line
                    }
                    reject('Server connection failed for API request: ' + requestOptions.method + ' ' + requestUrl);
                });
            });
        }
        /* eslint-enable complexity */

        /**
         * Sets the baseUrl that should be used for the api.
         *
         * When working against the dhis2 demo instance at {@link https://play.dhis2.org/demo} the
         * baseUrl would be set as `https://play.dhis2.org/demo/api`.
         *
         * This method is used when calling the `d2.init` method with the `baseUrl` config property
         * to configure the Api singleton.
         *
         * @param {string} baseUrl The base url to be used for the API.
         *
         * @returns {this} Itself for chaining purposes
         */

    }, {
        key: 'setBaseUrl',
        value: function setBaseUrl(baseUrl) {
            (0, _check.checkType)(baseUrl, 'string', 'Base url');

            this.baseUrl = baseUrl;

            return this;
        }
    }]);

    return Api;
}();

/**
 * Retrieve the Api singleton or create one.
 *
 * When called for the first time it creates and Api singleton object.
 * Any subsequent calls will return the previously created singleton.
 *
 * @returns {Api} The Api singleton.
 * @memberof module:api~Api
 */


function getApi() {
    if (getApi.api) {
        return getApi.api;
    }
    return getApi.api = new Api();
}

Api.getApi = getApi;

exports.default = Api;
//# sourceMappingURL=Api.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 21 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(181);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.throwError = throwError;
exports.curry = curry;
exports.addLockedProperty = addLockedProperty;
exports.copyOwnProperties = copyOwnProperties;
exports.pick = pick;
exports.updateAPIUrlWithBaseUrlVersionNumber = updateAPIUrlWithBaseUrlVersionNumber;
exports.customEncodeURIComponent = customEncodeURIComponent;
exports.identity = identity;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @module lib/utils
 */

function throwError(message) {
    throw new Error(message);
}

// TODO: Throw an error when `toCurry` is not a function
function curry(toCurry, parameter) {
    return function curried() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return toCurry.apply(this, [parameter].concat(args));
    };
}

function addLockedProperty(object, name, value) {
    var propertyDescriptor = {
        enumerable: true,
        configurable: false,
        writable: false,
        value: value
    };
    Object.defineProperty(object, name, propertyDescriptor);
}

function copyOwnProperties(to, from) {
    Object.keys(from).filter(function (key) {
        return from.hasOwnProperty(key);
    }).forEach(function (key) {
        to[key] = from[key]; // eslint-disable-line no-param-reassign
    });

    return to;
}

/**
 * Curried get function to pick a property from an object
 * Will safely pick a property from an object and guards against the infamous "can not read property of undefined".
 *
 * @param {String} propertyPath
 * @param {Any} defaultValue A default value to be returned when no value was found at the path
 * @returns Function
 *
 * get :: String -> Object -> Any
 */
function pick(propertyPath) {
    var propertiesToGet = propertyPath.split('.');

    return function (item) {
        return propertiesToGet.reduce(function (result, property) {
            if (result) {
                return result[property];
            }
            return undefined;
        }, item);
    };
}

var pickOr = exports.pickOr = function pickOr(pathProperty, defaultValue) {
    return function (item) {
        var pathResult = pick(pathProperty)(item);

        return pathResult !== undefined ? pathResult : defaultValue;
    };
};

var Deferred = exports.Deferred = function () {
    function Deferred() {
        var _this = this;

        _classCallCheck(this, Deferred);

        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }

    _createClass(Deferred, null, [{
        key: 'create',
        value: function create() {
            return new Deferred();
        }
    }]);

    return Deferred;
}();

function updateAPIUrlWithBaseUrlVersionNumber(apiUrl, baseUrl) {
    if (!baseUrl || !apiUrl) {
        return apiUrl;
    }

    var apiUrlWithVersionRexExp = /api\/([1-9][0-9])/;
    var apiVersionMatch = baseUrl.match(apiUrlWithVersionRexExp);

    var baseUrlHasVersion = apiVersionMatch && apiVersionMatch[1];
    var apiUrlHasVersion = apiUrl && !apiUrlWithVersionRexExp.test(apiUrl);

    if (baseUrlHasVersion && apiUrlHasVersion) {
        var version = apiVersionMatch[1];

        // Inject the current api version number into the endPoint urls
        return apiUrl.replace(/api/, 'api/' + version);
    }

    return apiUrl;
}

// Define our very own special list of characters that we don't want to encode in the URI
var whitelistURI = ',&$=/;:';
var whitelistURICodes = whitelistURI.split('').map(function (c) {
    return encodeURIComponent(c);
});
var whitelistRegExp = new RegExp('(?:' + whitelistURICodes.join('|') + ')', 'g');

/**
 * Encode all invalid URI characters, except the ones we've decided we don't want to
 */
function customEncodeURIComponent(uri) {
    // return uri;
    return encodeURIComponent(uri).replace(whitelistRegExp, decodeURIComponent);
}

function identity(value) {
    return value;
}
//# sourceMappingURL=utils.js.map

/***/ }),
/* 30 */,
/* 31 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getApiResponseNames = exports.removeEmptyItems = exports.combineDataItems = exports.getFilterValueName = exports.getFilterOperatorAsText = exports.getFiltersAsText = exports.getFiltersFromColumns = exports.setFiltersFromPeriod = exports.getPeriodNameFromId = exports.getPeriodFromFilters = exports.addUserOrgUnitsToRows = exports.getUserOrgUnitsFromRows = exports.setOrgUnitPathInRows = exports.addOrgUnitGroupsToRows = exports.getOrgUnitGroupsFromRows = exports.addOrgUnitLevelsToRows = exports.getOrgUnitLevelsFromRows = exports.toggleOrgUnitNodeInRows = exports.getOrgUnitNodesFromRows = exports.getOrgUnitsFromRows = exports.setDataItemInColumns = exports.getDataItemFromColumns = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _sortBy = __webpack_require__(43);

var _sortBy2 = _interopRequireDefault(_sortBy);

var _negate = __webpack_require__(447);

var _negate2 = _interopRequireDefault(_negate);

var _uid = __webpack_require__(50);

var _periods = __webpack_require__(220);

var _dimension = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* DIMENSIONS */

var createDimension = function createDimension(dimension, items, props) {
    return _extends({
        dimension: dimension,
        items: items
    }, props);
};

var getDimension = function getDimension(dimension, arr) {
    return arr.filter(function (item) {
        return item.dimension === dimension;
    })[0];
};

var getDimensionItems = function getDimensionItems(dimension, arr) {
    var dataItems = getDimension(dimension, arr);
    return dataItems && dataItems.items ? dataItems.items : [];
};

/* DATA ITEM */

var getDataItemFromColumns = exports.getDataItemFromColumns = function getDataItemFromColumns() {
    var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return getDimensionItems('dx', columns)[0];
};

var setDataItemInColumns = exports.setDataItemInColumns = function setDataItemInColumns(dataItem, dimension) {
    var dim = _dimension.dimConf[dimension];
    return dim ? [createDimension(dim.dimensionName, [{
        id: dataItem.id + (dimension === 'reportingRate' ? '.REPORTING_RATE' : ''),
        name: dataItem.name,
        dimensionItemType: dim.itemType,
        legendSet: dataItem.legendSet // TODO: Keep outside of columns?
    }], { objectName: dim.objectName })] : [];
};

/* ORGANISATION UNIT */

var getOrgUnitsFromRows = exports.getOrgUnitsFromRows = function getOrgUnitsFromRows() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return getDimensionItems('ou', rows) || [];
};

/* ORGANISATION UNIT NODES */

var isOrgUnitNode = function isOrgUnitNode(ou) {
    return (0, _uid.isValidUid)(ou.id);
};

var getOrgUnitNodesFromRows = exports.getOrgUnitNodesFromRows = function getOrgUnitNodesFromRows() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return getOrgUnitsFromRows(rows).filter(isOrgUnitNode);
};

var toggleOrgUnitNodeInRows = exports.toggleOrgUnitNodeInRows = function toggleOrgUnitNodeInRows() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var orgUnit = arguments[1];

    var orgUnits = getOrgUnitsFromRows(rows);
    var hasOrgUnit = orgUnits.some(function (ou) {
        return ou.id === orgUnit.id;
    });
    return [createDimension('ou', hasOrgUnit ? orgUnits.filter(function (ou) {
        return ou.id !== orgUnit.id;
    }) : [].concat(_toConsumableArray(orgUnits), [_extends({}, orgUnit)]))];
};

/* ORGANISATION UNIT LEVELS */

var isOrgUnitLevel = function isOrgUnitLevel(ou) {
    return ou.id.substring(0, 6) === 'LEVEL-';
};
var getIdFromOrgUnitLevel = function getIdFromOrgUnitLevel(ou) {
    return ou.id.substring(6);
};
var createOrgUnitLevel = function createOrgUnitLevel(id) {
    return { id: 'LEVEL-' + id };
};

var getOrgUnitLevelsFromRows = exports.getOrgUnitLevelsFromRows = function getOrgUnitLevelsFromRows() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return getOrgUnitsFromRows(rows).filter(isOrgUnitLevel).map(getIdFromOrgUnitLevel);
};

var addOrgUnitLevelsToRows = exports.addOrgUnitLevelsToRows = function addOrgUnitLevelsToRows() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var levels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return [createDimension('ou', [].concat(_toConsumableArray(getOrgUnitsFromRows(rows).filter((0, _negate2.default)(isOrgUnitLevel))), _toConsumableArray(levels.map(createOrgUnitLevel))))];
};

/* ORGANISATION UNIT GROUPS */

var isOrgUnitGroup = function isOrgUnitGroup(ou) {
    return ou.id.substring(0, 9) === 'OU_GROUP-';
};
var getIdFromOrgUnitGroup = function getIdFromOrgUnitGroup(ou) {
    return ou.id.substring(9);
};
var createOrgUnitGroup = function createOrgUnitGroup(id) {
    return { id: 'OU_GROUP-' + id };
};

var getOrgUnitGroupsFromRows = exports.getOrgUnitGroupsFromRows = function getOrgUnitGroupsFromRows() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return getOrgUnitsFromRows(rows).filter(isOrgUnitGroup).map(getIdFromOrgUnitGroup);
};

var addOrgUnitGroupsToRows = exports.addOrgUnitGroupsToRows = function addOrgUnitGroupsToRows() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var levels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return [createDimension('ou', [].concat(_toConsumableArray(getOrgUnitsFromRows(rows).filter((0, _negate2.default)(isOrgUnitGroup))), _toConsumableArray(levels.map(createOrgUnitGroup))))];
};

/* ORGANISATION UNIT PATH */
// Set organisation unit tree path (temporary solution, as favorites don't include paths)
var setOrgUnitPathInRows = exports.setOrgUnitPathInRows = function setOrgUnitPathInRows() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var id = arguments[1];
    var path = arguments[2];

    var orgUnits = getOrgUnitsFromRows(rows);
    var orgUnit = orgUnits.find(function (ou) {
        return ou.id === id;
    });
    return [createDimension('ou', [].concat(_toConsumableArray(orgUnits.filter(function (ou) {
        return ou.id !== id;
    })), [_extends({}, orgUnit, { path: path })]))];
};

/* USER ORGANISATION UNITS */

var isUserOrgUnit = function isUserOrgUnit(ou) {
    return ou.id.substring(0, 12) === 'USER_ORGUNIT';
};
var getIdFromUserOrgUnit = function getIdFromUserOrgUnit(ou) {
    return ou.id;
};
var createUserOrgUnit = function createUserOrgUnit(id) {
    return { id: id };
};

var getUserOrgUnitsFromRows = exports.getUserOrgUnitsFromRows = function getUserOrgUnitsFromRows() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return getOrgUnitsFromRows(rows).filter(isUserOrgUnit).map(getIdFromUserOrgUnit);
};

var addUserOrgUnitsToRows = exports.addUserOrgUnitsToRows = function addUserOrgUnitsToRows() {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var userOrgUnits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return [createDimension('ou', [].concat(_toConsumableArray(getOrgUnitsFromRows(rows).filter((0, _negate2.default)(isUserOrgUnit))), _toConsumableArray(userOrgUnits.map(createUserOrgUnit))))];
};

/* PERIODS */

var getPeriodFromFilters = exports.getPeriodFromFilters = function getPeriodFromFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return getDimensionItems('pe', filters)[0];
};

var getPeriodNameFromId = exports.getPeriodNameFromId = function getPeriodNameFromId(id) {
    var period = _periods.relativePeriods.filter(function (period) {
        return period.id === id;
    })[0];
    return period ? _i18next2.default.t(period.name) : null;
};

var setFiltersFromPeriod = exports.setFiltersFromPeriod = function setFiltersFromPeriod(period) {
    return [createDimension('pe', [_extends({}, period)])];
};

var getFiltersFromColumns = exports.getFiltersFromColumns = function getFiltersFromColumns() {
    var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var filters = columns.filter(function (item) {
        return item.filter;
    });
    return filters.length ? filters : null;
};

var getFiltersAsText = exports.getFiltersAsText = function getFiltersAsText() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var names = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return filters.map(function (_ref) {
        var name = _ref.name,
            filter = _ref.filter;

        var _filter$split = filter.split(':'),
            _filter$split2 = _slicedToArray(_filter$split, 2),
            operator = _filter$split2[0],
            value = _filter$split2[1];

        return name + ' ' + getFilterOperatorAsText(operator) + ' [' + getFilterValueName(value, names) + ']';
    });
};

// TODO: Cache?
var getFilterOperatorAsText = exports.getFilterOperatorAsText = function getFilterOperatorAsText(id) {
    return {
        EQ: '=',
        GT: '>',
        GE: '>=',
        LT: '<',
        LE: '<=',
        NE: '!=',
        IN: _i18next2.default.t('one of'),
        '!IN': _i18next2.default.t('not one of'),
        LIKE: _i18next2.default.t('contains'),
        '!LIKE': _i18next2.default.t("doesn't contains")
    }[id];
};

var getFilterValueName = exports.getFilterValueName = function getFilterValueName(value, names) {
    return value.split(';').map(function (val) {
        return names[val] || val;
    }).join(', ');
};

// Combine data items into one array and exclude certain value types
var combineDataItems = exports.combineDataItems = function combineDataItems() {
    var dataItemsA = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var dataItemsB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var excludeTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    return (0, _sortBy2.default)('name', [].concat(_toConsumableArray(dataItemsA), _toConsumableArray(dataItemsB)).filter(function (item) {
        return !excludeTypes.includes(item.valueType);
    }));
};

// Some favorites have emtpy items in dx dimension
var removeEmptyItems = exports.removeEmptyItems = function removeEmptyItems(items) {
    return items.filter(function (item) {
        return !item.items || item.items && item.items.length;
    });
};

// Builds an object with key/names pairs from an API response
var getApiResponseNames = exports.getApiResponseNames = function getApiResponseNames(_ref2) {
    var metaData = _ref2.metaData,
        headers = _ref2.headers;
    return _extends({}, Object.keys(metaData.items).reduce(function (names, key) {
        return _extends({}, names, _defineProperty({}, key, metaData.items[key].name));
    }, {}), headers.reduce(function (names, header) {
        return _extends({}, names, _defineProperty({}, header.name, header.column));
    }, {}), {
        true: _i18next2.default.t('Yes'),
        false: _i18next2.default.t('No')
    });
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target) {
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(530);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(51),
    getRawTag = __webpack_require__(330),
    objectToString = __webpack_require__(331);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.legendSetFields = exports.legendFields = exports.mapFields = exports.getDisplayPropertyUrl = exports.getDisplayProperty = undefined;

var _d = __webpack_require__(19);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// import store from '../store';
var defaultKeyAnalysisDisplayProperty = 'displayName';

var propertyMap = {
    name: 'name',
    displayName: 'name',
    shortName: 'shortName',
    displayShortName: 'shortName'
};

var displayPropertyMap = {
    name: 'displayName',
    displayName: 'displayName',
    shortName: 'displayShortName',
    displayShortName: 'displayShortName'
};

var getDisplayProperty = exports.getDisplayProperty = function getDisplayProperty(d2, displayProperty) {
    var keyAnalysisDisplayProperty = d2.currentUser.settings.keyAnalysisDisplayProperty;
    return propertyMap[keyAnalysisDisplayProperty] || propertyMap[displayProperty] || 'name'; // TODO: check
};

var getDisplayPropertyUrl = exports.getDisplayPropertyUrl = function getDisplayPropertyUrl(d2) {
    // return `${getDisplayProperty(d2)}~rename(name)`; // TODO
    return 'displayName~rename(name)';
};

var baseFields = ['id', 'user', 'displayName~rename(name)', 'longitude', 'latitude', 'zoom', 'basemap'];

var analysisFields = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var d2, namePropertyUrl;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return (0, _d.getInstance)();

                    case 2:
                        d2 = _context.sent;
                        _context.next = 5;
                        return getDisplayPropertyUrl(d2);

                    case 5:
                        namePropertyUrl = _context.sent;
                        return _context.abrupt('return', ['*', 'columns[dimension,filter,items[dimensionItem~rename(id),dimensionItemType,' + namePropertyUrl + ']]', 'rows[dimension,filter,items[dimensionItem~rename(id),dimensionItemType,' + namePropertyUrl + ']]', 'filters[dimension,filter,items[dimensionItem~rename(id),dimensionItemType,' + namePropertyUrl + ']]', 'dataDimensionItems', 'program[id,' + namePropertyUrl + ']', 'programStage[id,displayName~rename(name)]', 'legendSet[id,displayName~rename(name)]', '!lastUpdated', '!href', '!created', '!publicAccess', '!rewindRelativePeriods', '!userOrganisationUnit', '!userOrganisationUnitChildren', '!userOrganisationUnitGrandChildren', '!externalAccess', '!access', '!relativePeriods', '!columnDimensions', '!rowDimensions', '!filterDimensions', '!user', '!organisationUnitGroups', '!itemOrganisationUnitGroups', '!userGroupAccesses', '!indicators', '!dataElements', '!dataElementOperands', '!dataElementGroups', '!dataSets', '!periods', '!organisationUnitLevels', '!organisationUnits', '!sortOrder', '!topLimit']);

                    case 7:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function analysisFields() {
        return _ref.apply(this, arguments);
    };
}();

var mapFields = exports.mapFields = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var fields;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return analysisFields();

                    case 2:
                        fields = _context2.sent;
                        return _context2.abrupt('return', baseFields.join(',') + ', mapViews[' + fields.join(',') + ']');

                    case 4:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    return function mapFields() {
        return _ref2.apply(this, arguments);
    };
}();

var legendFields = exports.legendFields = ['*', '!created', '!lastUpdated', '!displayName', '!externalAccess', '!access', '!userGroupAccesses'];

var legendSetFields = exports.legendSetFields = ['id,displayName~rename(name),legends[' + legendFields.join(',') + ']'];

/***/ }),
/* 37 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(405),
    baseMatchesProperty = __webpack_require__(415),
    identity = __webpack_require__(57),
    isArray = __webpack_require__(21),
    property = __webpack_require__(422);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = {
  'cap': false,
  'curry': false,
  'fixed': false,
  'immutable': false,
  'rearg': false
};


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var consoleLogger = {
  type: 'logger',

  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    var _console;

    /* eslint no-console: 0 */
    if (console && console[type]) (_console = console)[type].apply(_console, _toConsumableArray(args));
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  Logger.prototype.init = function init(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug;
  };

  Logger.prototype.setDebug = function setDebug(bool) {
    this.debug = bool;
  };

  Logger.prototype.log = function log() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return this.forward(args, 'log', '', true);
  };

  Logger.prototype.warn = function warn() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return this.forward(args, 'warn', '', true);
  };

  Logger.prototype.error = function error() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return this.forward(args, 'error', '');
  };

  Logger.prototype.deprecate = function deprecate() {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
  };

  Logger.prototype.forward = function forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return null;
    if (typeof args[0] === 'string') args[0] = '' + prefix + this.prefix + ' ' + args[0];
    return this.logger[lvl](args);
  };

  Logger.prototype.create = function create(moduleName) {
    return new Logger(this.logger, _extends({ prefix: this.prefix + ':' + moduleName + ':' }, this.options));
  };

  return Logger;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Logger());

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(329),
    getValue = __webpack_require__(334);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(116),
    isLength = __webpack_require__(124);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('sortBy', __webpack_require__(245));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Layer = function (_PureComponent) {
    _inherits(Layer, _PureComponent);

    function Layer() {
        _classCallCheck(this, Layer);

        return _possibleConstructorReturn(this, (Layer.__proto__ || Object.getPrototypeOf(Layer)).apply(this, arguments));
    }

    _createClass(Layer, [{
        key: 'componentWillMount',


        // Create pane and layer
        value: function componentWillMount() {
            this.createPane();
            this.createLayer();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var map = this.context.map;
            map.addLayer(this.layer);
            this.onLayerAdd();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prev) {
            var _props = this.props,
                id = _props.id,
                data = _props.data,
                index = _props.index,
                opacity = _props.opacity,
                isVisible = _props.isVisible,
                editCounter = _props.editCounter,
                dataFilters = _props.dataFilters;

            var map = this.context.map;

            // Create new map if new id of editCounter is increased
            if (id !== prev.id || data !== prev.data || editCounter !== prev.editCounter || dataFilters !== prev.dataFilters) {
                this.removeLayer();
                this.createPane();
                this.createLayer();
                map.addLayer(this.layer);
                this.onLayerAdd();
            }

            if (index !== undefined && index !== prev.index) {
                this.setLayerOrder();
            }

            if (opacity !== prev.opacity) {
                this.setLayerOpacity();
            }

            if (isVisible !== prev.isVisible) {
                this.setLayerVisibility();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeLayer();
        }

        // Create custom pane to control layer ordering: http://leafletjs.com/examples/map-panes/

    }, {
        key: 'createPane',
        value: function createPane() {
            var _props2 = this.props,
                id = _props2.id,
                labels = _props2.labels,
                areaRadius = _props2.areaRadius;

            var map = this.context.map;

            this.pane = map.createPane(id);

            if (labels) {
                this.labelPane = map.createPane(id + '-labels');
            }

            if (areaRadius) {
                this.areaPane = map.createPane(id + '-area');
            }
        }

        // Create new layer from config object (override in subclasses)

    }, {
        key: 'createLayer',
        value: function createLayer() {
            var _props3 = this.props,
                id = _props3.id,
                index = _props3.index,
                config = _props3.config;

            var map = this.context.map;
            var layerConfig = _extends({}, config);

            if (index !== undefined) {
                // If not a basemap
                layerConfig.pane = id;
            }

            this.layer = map.createLayer(layerConfig);
        }
    }, {
        key: 'onLayerAdd',
        value: function onLayerAdd() {
            this.setLayerOpacity();
            this.setLayerVisibility();

            if (this.props.index !== undefined) {
                // Basemap don't have index
                this.setLayerOrder();
            }
        }
    }, {
        key: 'setLayerOpacity',
        value: function setLayerOpacity() {
            this.layer.setOpacity(this.props.opacity);
        }

        // Set layer order using custom panes and z-index: http://leafletjs.com/examples/map-panes/

    }, {
        key: 'setLayerOrder',
        value: function setLayerOrder() {
            var index = this.props.index;

            var zIndex = 600 - index * 10;

            if (this.pane) {
                this.pane.style.zIndex = zIndex;
            }

            if (this.areaPane) {
                this.areaPane.style.zIndex = zIndex - 1;
            }

            if (this.labelPane) {
                this.labelPane.style.zIndex = zIndex + 1;
            }
        }
    }, {
        key: 'setLayerVisibility',
        value: function setLayerVisibility() {
            var isVisible = this.props.isVisible;
            var map = this.context.map;
            var layer = this.layer;

            if (isVisible && map.hasLayer(layer) === false) {
                map.addLayer(layer);
            } else if (!isVisible && map.hasLayer(layer) === true) {
                map.removeLayer(layer);
            }
        }
    }, {
        key: 'removeLayer',
        value: function removeLayer() {
            var layer = this.layer;
            var map = this.context.map;

            if (map.hasLayer(layer)) {
                map.removeLayer(layer);
            }

            delete this.layer;
            delete this.pane;
            delete this.labelPane;
            delete this.areaPane;
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);

    return Layer;
}(_react.PureComponent);

Layer.contextTypes = {
    map: _propTypes2.default.object,
    d2: _propTypes2.default.object
};
Layer.propTypes = {
    id: _propTypes2.default.string.isRequired,
    index: _propTypes2.default.number,
    editCounter: _propTypes2.default.number,
    opacity: _propTypes2.default.number,
    isVisible: _propTypes2.default.bool,
    config: _propTypes2.default.object
    // labels: PropTypes.object, // TODO: Is sometimes boolean
};
Layer.defaultProps = {
    opacity: 1,
    isVisible: true
};
exports.default = Layer;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(52);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('isString', __webpack_require__(253), __webpack_require__(39));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateUid = generateUid;
exports.isValidUid = isValidUid;
/**
 * @module uid
 *
 * @description
 * Client side implementation of the DHIS2 code (uid) generator.
 * ({@link https://github.com/dhis2/dhis2-core/blob/ad2d5dea959aff3146d8fe5796cf0b75eb6ee5d8/dhis-2/dhis-api/src/main/java/org/hisp/dhis/common/CodeGenerator.java|CodeGenerator.java})
 *
 * This module is used to generate and validate DHIS2 uids. A valid DHIS2 uid is a 11 character string which starts with a letter from the ISO basic Latin alphabet.
 */

var abc = 'abcdefghijklmnopqrstuvwxyz';
var letters = abc.concat(abc.toUpperCase());

var ALLOWED_CHARS = '0123456789' + letters;

var NUMBER_OF_CODEPOINTS = ALLOWED_CHARS.length;
var CODESIZE = 11;

var CODE_PATTERN = /^[a-zA-Z]{1}[a-zA-Z0-9]{10}$/;

function randomWithMax(max) {
    return Math.floor(Math.random() * max);
}

/**
 * Generate a valid DHIS2 uid. A valid DHIS2 uid is a 11 character string which starts with a letter from the ISO basic Latin alphabet.
 *
 * @return {string} A 11 character uid that always starts with a letter.
 *
 * @example
 * import { generateUid } from 'd2/lib/uid';
 *
 * generateUid();
 */
function generateUid() {
    // First char should be a letter
    var randomChars = letters.charAt(randomWithMax(letters.length));

    for (var i = 1; i < CODESIZE; i += 1) {
        randomChars += ALLOWED_CHARS.charAt(randomWithMax(NUMBER_OF_CODEPOINTS));
    }

    // return new String( randomChars );
    return randomChars;
}

/**
 * Tests whether the given code is valid.
 *
 * @param {string} code The code to validate.
 * @return {boolean} Returns true if the code is valid, false otherwise.
 *
 * @example
 * import { isValidUid } from 'd2/lib/uid';
 *
 * isValidUid('JkWynlWMjJR'); // true
 * isValidUid('0kWynlWMjJR'); // false (Uid can not start with a number)
 * isValidUid('AkWy$lWMjJR'); // false (Uid can only contain alphanumeric characters.
 */
function isValidUid(code) {
    if (code == null) {
        // eslint-disable-line eqeqeq
        return false;
    }

    return CODE_PATTERN.test(code);
}
//# sourceMappingURL=uid.js.map

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(23);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(35),
    isObjectLike = __webpack_require__(25);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(389),
    Map = __webpack_require__(129),
    Promise = __webpack_require__(390),
    Set = __webpack_require__(205),
    WeakMap = __webpack_require__(180),
    baseGetTag = __webpack_require__(35),
    toSource = __webpack_require__(182);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(198),
    baseKeys = __webpack_require__(126),
    isArrayLike = __webpack_require__(42);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.apiFetch = undefined;

var _isString = __webpack_require__(48);

var _isString2 = _interopRequireDefault(_isString);

var _isObject = __webpack_require__(221);

var _isObject2 = _interopRequireDefault(_isObject);

var _d = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// TODO: Channel all api request through d2

var apiFetch = exports.apiFetch = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, method, body) {
        var options;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        options = {
                            headers: {}
                        };


                        if (_d.config.context && _d.config.context.auth) {
                            options.headers['Authorization'] = 'Basic ' + btoa(_d.config.context.auth);
                        } else {
                            options.credentials = 'include';
                        }

                        if (method && body) {
                            options.method = method;

                            if ((0, _isString2.default)(body)) {
                                options.headers['Content-Type'] = 'text/html';
                                options.body = body;
                            } else if ((0, _isObject2.default)(body)) {
                                options.headers['Content-Type'] = 'application/json';
                                options.body = JSON.stringify(body);
                            }
                        }

                        return _context.abrupt('return', fetch(encodeURI(_d.config.baseUrl + url), options).then(function (response) {
                            return method !== 'PUT' && method !== 'PATCH' ? response.json() : response;
                        }) // Avoids error
                        .catch(function (error) {
                            return console.log('Error: ', error);
                        }));

                    case 4:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function apiFetch(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  EventEmitter.prototype.on = function on(events, listener) {
    var _this = this;

    events.split(' ').forEach(function (event) {
      _this.observers[event] = _this.observers[event] || [];
      _this.observers[event].push(listener);
    });
  };

  EventEmitter.prototype.off = function off(event, listener) {
    var _this2 = this;

    if (!this.observers[event]) {
      return;
    }

    this.observers[event].forEach(function () {
      if (!listener) {
        delete _this2.observers[event];
      } else {
        var index = _this2.observers[event].indexOf(listener);
        if (index > -1) {
          _this2.observers[event].splice(index, 1);
        }
      }
    });
  };

  EventEmitter.prototype.emit = function emit(event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (this.observers[event]) {
      var cloned = [].concat(this.observers[event]);
      cloned.forEach(function (observer) {
        observer.apply(undefined, args);
      });
    }

    if (this.observers['*']) {
      var _cloned = [].concat(this.observers['*']);
      _cloned.forEach(function (observer) {
        var _ref;

        observer.apply(observer, (_ref = [event]).concat.apply(_ref, args));
      });
    }
  };

  return EventEmitter;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventEmitter);

/***/ }),
/* 63 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(21),
    isKey = __webpack_require__(137),
    stringToPath = __webpack_require__(214),
    toString = __webpack_require__(215);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 65 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.drillUpDown = exports.toGeoJson = exports.isValidCoordinate = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _compact = __webpack_require__(472);

var _compact2 = _interopRequireDefault(_compact);

var _sortBy = __webpack_require__(43);

var _sortBy2 = _interopRequireDefault(_sortBy);

var _isString = __webpack_require__(48);

var _isString2 = _interopRequireDefault(_isString);

var _dimension = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isValidCoordinate = exports.isValidCoordinate = function isValidCoordinate(coord) {
    return Array.isArray(coord) && coord.length === 2 && coord[0] >= -180 && coord[0] <= 180 && coord[1] >= -90 && coord[1] <= 90;
};

var toGeoJson = exports.toGeoJson = function toGeoJson(organisationUnits) {
    return (0, _sortBy2.default)('le', organisationUnits).map(function (ou) {
        var coord = JSON.parse(ou.co);
        var gpid = '';
        var gppg = '';
        var type = 'Point';

        if (ou.ty === 2) {
            type = 'Polygon';
            if (ou.co.substring(0, 4) === '[[[[') {
                type = 'MultiPolygon';
            }
        }

        // Grand parent
        if ((0, _isString2.default)(ou.pg) && ou.pg.length) {
            var ids = (0, _compact2.default)(ou.pg.split('/'));

            // Grand parent id
            if (ids.length >= 2) {
                gpid = ids[ids.length - 2];
            }

            // Grand parent parent graph
            if (ids.length > 2) {
                gppg = '/' + ids.slice(0, ids.length - 2).join('/');
            }
        }

        return {
            type: 'Feature',
            id: ou.id,
            geometry: {
                type: type,
                coordinates: coord
            },
            properties: {
                id: ou.id,
                name: ou.na,
                hasCoordinatesDown: ou.hcd,
                hasCoordinatesUp: ou.hcu,
                level: ou.le,
                grandParentParentGraph: gppg,
                grandParentId: gpid,
                parentGraph: ou.pg,
                parentId: ou.pi,
                parentName: ou.pn
            }
        };
    }).filter(function (_ref) {
        var geometry = _ref.geometry;
        return Array.isArray(geometry.coordinates) && geometry.coordinates.length;
    });
};

// TODO: parentGraph is not used
var drillUpDown = exports.drillUpDown = function drillUpDown(layerConfig, parentId, parentGraph, level) {
    return _extends({}, layerConfig, {
        rows: [{
            dimension: _dimension.dimConf.organisationUnit.objectName,
            items: [{ id: parentId }, { id: 'LEVEL-' + level }]
        }],
        parentGraphMap: {}
    });
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.classificationTypes = exports.CLASSIFICATION_EQUAL_COUNTS = exports.CLASSIFICATION_EQUAL_INTERVALS = exports.CLASSIFICATION_PREDEFINED = exports.EVENT_RADIUS = exports.EVENT_COLOR = exports.EVENT_END_DATE = exports.EVENT_START_DATE = undefined;

var _d3TimeFormat = __webpack_require__(139);

var formatTime = (0, _d3TimeFormat.timeFormat)('%Y-%m-%d');

/* EVENT LAYER */
var EVENT_START_DATE = exports.EVENT_START_DATE = formatTime(new Date().setFullYear(new Date().getFullYear() - 1));
var EVENT_END_DATE = exports.EVENT_END_DATE = formatTime(new Date());
var EVENT_COLOR = exports.EVENT_COLOR = '#333333';
var EVENT_RADIUS = exports.EVENT_RADIUS = 6;

/* CLASSIFICATION */

var CLASSIFICATION_PREDEFINED = exports.CLASSIFICATION_PREDEFINED = 1;
var CLASSIFICATION_EQUAL_INTERVALS = exports.CLASSIFICATION_EQUAL_INTERVALS = 2;
var CLASSIFICATION_EQUAL_COUNTS = exports.CLASSIFICATION_EQUAL_COUNTS = 3;

var classificationTypes = exports.classificationTypes = [{
    id: CLASSIFICATION_EQUAL_INTERVALS,
    name: 'Equal intervals'
}, {
    id: CLASSIFICATION_EQUAL_COUNTS,
    name: 'Equal counts'
}];

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(122),
    baseAssignValue = __webpack_require__(150);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AnalyticsRequestDimensionsMixin = __webpack_require__(311);

var _AnalyticsRequestDimensionsMixin2 = _interopRequireDefault(_AnalyticsRequestDimensionsMixin);

var _AnalyticsRequestFiltersMixin = __webpack_require__(312);

var _AnalyticsRequestFiltersMixin2 = _interopRequireDefault(_AnalyticsRequestFiltersMixin);

var _AnalyticsRequestPropertiesMixin = __webpack_require__(313);

var _AnalyticsRequestPropertiesMixin2 = _interopRequireDefault(_AnalyticsRequestPropertiesMixin);

var _AnalyticsRequestBase = __webpack_require__(314);

var _AnalyticsRequestBase2 = _interopRequireDefault(_AnalyticsRequestBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @description
 * Class for constructing a request object to use for communicating with the analytics API endpoint.
 *
 * @param {!Object} options Object with analytics request options
 *
 * @memberof module:analytics
 *
 * @extends module:analytics.AnalyticsRequestDimensionsMixin
 * @extends module:analytics.AnalyticsRequestFiltersMixin
 * @extends module:analytics.AnalyticsRequestPropertiesMixin
 * @extends module:analytics.AnalyticsRequestBase
 */
var AnalyticsRequest = function (_AnalyticsRequestDime) {
    _inherits(AnalyticsRequest, _AnalyticsRequestDime);

    function AnalyticsRequest() {
        _classCallCheck(this, AnalyticsRequest);

        return _possibleConstructorReturn(this, (AnalyticsRequest.__proto__ || Object.getPrototypeOf(AnalyticsRequest)).apply(this, arguments));
    }

    return AnalyticsRequest;
}((0, _AnalyticsRequestDimensionsMixin2.default)((0, _AnalyticsRequestFiltersMixin2.default)((0, _AnalyticsRequestPropertiesMixin2.default)(_AnalyticsRequestBase2.default))));

exports.default = AnalyticsRequest;
//# sourceMappingURL=AnalyticsRequest.js.map

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = makeString;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["h"] = setPath;
/* harmony export (immutable) */ __webpack_exports__["f"] = pushPath;
/* harmony export (immutable) */ __webpack_exports__["d"] = getPath;
/* harmony export (immutable) */ __webpack_exports__["b"] = deepExtend;
/* harmony export (immutable) */ __webpack_exports__["g"] = regexEscape;
/* harmony export (immutable) */ __webpack_exports__["c"] = escape;
function makeString(object) {
  if (object == null) return '';
  /* eslint prefer-template: 0 */
  return '' + object;
}

function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};

    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}

function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}

function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}

function deepExtend(target, source, overwrite) {
  /* eslint no-restricted-syntax: 0 */
  for (var prop in source) {
    if (prop in target) {
      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }
  return target;
}

function regexEscape(str) {
  /* eslint no-useless-escape: 0 */
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

/* eslint-disable */
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': '&quot;',
  "'": '&#39;',
  "/": '&#x2F;'
};
/* eslint-enable */

function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(178),
    createBind = __webpack_require__(335),
    createCurry = __webpack_require__(336),
    createHybrid = __webpack_require__(183),
    createPartial = __webpack_require__(352),
    getData = __webpack_require__(187),
    mergeData = __webpack_require__(353),
    setData = __webpack_require__(190),
    setWrapToString = __webpack_require__(192),
    toInteger = __webpack_require__(97);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(78),
    isObject = __webpack_require__(26);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 79 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 80 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(355),
    isObjectLike = __webpack_require__(25);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(23),
    stubFalse = __webpack_require__(356);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(83)(module)))

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(360),
    listCacheDelete = __webpack_require__(361),
    listCacheGet = __webpack_require__(362),
    listCacheHas = __webpack_require__(363),
    listCacheSet = __webpack_require__(364);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(80);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(378);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var dimConf = exports.dimConf = {
    data: {
        id: 'data',
        value: 'data',
        param: 'dx',
        dimensionName: 'dx',
        objectName: 'dx'
    },
    category: {
        name: 'categories',
        dimensionName: 'co',
        objectName: 'co'
    },
    indicator: {
        id: 'indicator',
        value: 'indicators',
        param: 'in',
        dimensionName: 'dx',
        objectName: 'in',
        itemType: 'INDICATOR'
    },
    dataElement: {
        id: 'dataElement',
        value: 'dataElement',
        param: 'de',
        dimensionName: 'dx',
        objectName: 'de',
        itemType: 'DATA_ELEMENT' // AGGREGATE_DATA_ELEMENT
    },
    operand: {
        id: 'operand',
        value: 'operand',
        param: 'dc',
        dimensionName: 'dx',
        objectName: 'dc',
        itemType: 'DATA_ELEMENT_OPERAND'
    },
    dataSet: {
        value: 'dataSets',
        dimensionName: 'dx',
        objectName: 'ds',
        itemType: 'DATA_SET'
    },
    eventDataItem: {
        value: 'eventDataItem',
        dimensionName: 'dx',
        objectName: 'di'
    },
    programDataElement: {
        value: 'programDataElement',
        dimensionName: 'dx',
        objectName: 'di',
        itemType: 'PROGRAM_DATA_ELEMENT'
    },
    programAttribute: {
        value: 'programAttribute',
        dimensionName: 'dx',
        objectName: 'di',
        itemType: 'PROGRAM_ATTRIBUTE'
    },
    programIndicator: {
        value: 'programIndicator',
        dimensionName: 'dx',
        objectName: 'pi',
        itemType: 'PROGRAM_INDICATOR'
    },
    period: {
        id: 'period',
        value: 'period',
        param: 'pe',
        dimensionName: 'pe',
        objectName: 'pe'
    },
    organisationUnit: {
        id: 'organisationUnit',
        value: 'organisationUnit',
        param: 'ou',
        dimensionName: 'ou',
        objectName: 'ou'
    },
    reportingRate: {
        value: 'reportingRate',
        dimensionName: 'dx',
        objectName: 'ds',
        itemType: 'REPORTING_RATE'
    },
    value: {
        id: 'value',
        value: 'value',
        param: 'value',
        dimensionName: 'value',
        objectName: 'value'
    }
};

/***/ }),
/* 91 */,
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(141);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = __webpack_require__(15);

var _utils = __webpack_require__(29);

var _ModelBase = __webpack_require__(113);

var _ModelBase2 = _interopRequireDefault(_ModelBase);

var _attibutes = __webpack_require__(282);

var _attibutes2 = _interopRequireDefault(_attibutes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pickAttributeValues = (0, _utils.pickOr)('attributeValues', []);

// TODO: Perhaps we can generate model classes dynamically based on the schemas and inherit from this.
/**
 * @extends ModelBase
 *
 * @description
 * A Model represents an object from the DHIS2 Api. A model is created based of a ModelDefinition. The ModelDefinition
 * has the properties that the model should have.
 *
 * @memberof module:model
 */

var Model = function () {
  /**
   * @constructor
   *
   * @param {ModelDefinition} modelDefinition The model definition that corresponds with the model.
   * This is essential defining what type the model is representing.
   *
   * @description
   * Will create a new model instanced based on the model definition. When creating a new instance the model
   * definition needs to have both the modelValidations and modelProperties.
   *
   * The model properties will depend on the ModelDefinition. A model definition is based on a DHIS2 Schema.
   */
  function Model(modelDefinition) {
    var _this = this;

    _classCallCheck(this, Model);

    (0, _check.checkType)(modelDefinition, 'object', 'modelDefinition');
    (0, _check.checkType)(modelDefinition.modelProperties, 'object', 'modelProperties');

    /**
     * @property {ModelDefinition} modelDefinition Stores reference to the modelDefinition that was used when
     * creating the model. This property is not enumerable or writable and will therefore not show up when looping
     * over the object properties.
     */
    Object.defineProperty(this, 'modelDefinition', { value: modelDefinition });

    /**
     * @property {Boolean} dirty Represents the state of the model. When the model is concidered `dirty`
     * there are pending changes.
     * This property is not enumerable or writable and will therefore not show up when looping
     * over the object properties.
     */
    Object.defineProperty(this, 'dirty', { writable: true, value: false });

    /**
     * @private
     * @property {Object} dataValues Values object used to store the actual model values. Normally access to the
     * Model data will be done through accessor properties that are generated from the modelDefinition.
     *
     * @note {warning} This should not be accessed directly.
     */
    Object.defineProperty(this, 'dataValues', { configurable: true, writable: true, value: {} });

    /**
     * Attach the modelDefinition modelProperties (the properties from the schema) onto the Model.
     *
     * For a data element model the modelProperties would be the following
     * https://play.dhis2.org/demo/api/schemas/dataElement.json?fields=properties
     */
    Object.defineProperties(this, modelDefinition.modelProperties);

    var attributes = {};
    var attributeProperties = modelDefinition.attributeProperties;
    if ((0, _check.hasKeys)(attributeProperties)) {
      /**
       * @property {Object} attributes The attributes objects contains references to custom attributes defined
       * on the metadata object.
       *
       * @description
       * These properties are generated based of the attributes that are created for the the specific schema.
       * As these properties are not defined on the schemas they're put on a separate attributes object.
       * When there are no attributes defined for the object type, the attributes property will not be attached
       * to the model.
       *
       * @see https://docs.dhis2.org/2.27/en/user/html/dhis2_user_manual_en_full.html#manage_attribute
       */
      Object.defineProperty(this, 'attributes', { value: attributes });

      var getAttributeValues = function getAttributeValues() {
        return pickAttributeValues(_this);
      };
      var setAttributeValues = function setAttributeValues(attributeValues) {
        return _this.attributeValues = attributeValues;
      };
      var setDirty = function setDirty() {
        return _this.dirty = true;
      };
      var attributeDefinitions = (0, _attibutes2.default)(attributeProperties, getAttributeValues, setAttributeValues, setDirty);

      Object.defineProperties(attributes, attributeDefinitions);
    }

    this[_ModelBase.DIRTY_PROPERTY_LIST] = new Set([]);
  }

  /**
   * @static
   *
   * @param {ModelDefinition} modelDefinition ModelDefinition from which the model should be created
   * @returns {Model} Returns an instance of the model.
   *
   * @description The static method is a factory method to create Model objects. It calls `new Model()` with the passed `ModelDefinition`.
   *
   * ```js
   * let myModel = Model.create(modelDefinition);
   * ```
   */


  _createClass(Model, null, [{
    key: 'create',
    value: function create(modelDefinition) {
      return new Model(modelDefinition);
    }
  }]);

  return Model;
}();

// Set the prototype of the Model class, this way we're able to extend from an single object


Model.prototype = _ModelBase2.default;

exports.default = Model;
//# sourceMappingURL=Model.js.map

/***/ }),
/* 96 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(243);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(64),
    toKey = __webpack_require__(46);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMapAlerts = exports.createAlert = undefined;

var _uid = __webpack_require__(50);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var createAlert = exports.createAlert = function createAlert(title, description) {
    return {
        id: (0, _uid.generateUid)(),
        title: title,
        description: description
    };
};

// Returns array of all alerts from map config and layers (mapViews)
var getMapAlerts = exports.getMapAlerts = function getMapAlerts(mapConfig) {
    var _concat, _ref;

    return (_concat = (_ref = []).concat.apply(_ref, _toConsumableArray(mapConfig && mapConfig.alerts ? mapConfig.alerts : []))).concat.apply(_concat, _toConsumableArray(mapConfig && mapConfig.mapViews && mapConfig.mapViews.filter(function (layer) {
        return layer.alerts;
    }).map(function (layer) {
        return layer.alerts;
    })));
};

/***/ }),
/* 101 */,
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultColorScale = exports.defaultClasses = exports.defaultColorScaleName = exports.getColorScale = exports.getColorPalette = exports.colorScales = undefined;

var _colorbrewer = __webpack_require__(257);

var _colorbrewer2 = _interopRequireDefault(_colorbrewer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Allowed color scales from ColorBrewer for EE (needs to have at least 9 classes)
var colorScales = exports.colorScales = ['YlOrBr', 'Reds', 'YlGn', 'Greens', 'Blues', 'BuPu', 'RdPu', 'PuRd', 'Greys', 'YlOrBr_reverse', 'Reds_reverse', 'YlGn_reverse', 'Greens_reverse', 'Blues_reverse', 'BuPu_reverse', 'RdPu_reverse', 'PuRd_reverse', 'Greys_reverse', 'PuOr', 'BrBG', 'PRGn', 'PiYG', 'RdBu', 'RdGy', 'RdYlBu', 'Spectral', 'RdYlGn', 'Paired', 'Pastel1', 'Set1', 'Set3'];

// Returns a color brewer scale for a number of classes
var getColorPalette = exports.getColorPalette = function getColorPalette(scale, classes) {
    return _colorbrewer2.default[scale][classes].join(',');
};

// Returns color scale name for a palette
var getColorScale = exports.getColorScale = function getColorScale(palette) {
    var classes = palette.split(',').length;
    return colorScales.find(function (name) {
        return _colorbrewer2.default[name][classes].join(',') === palette;
    });
};

var defaultColorScaleName = exports.defaultColorScaleName = 'YlOrBr';
var defaultClasses = exports.defaultClasses = 5;
var defaultColorScale = exports.defaultColorScale = getColorPalette(defaultColorScaleName, defaultClasses);

/***/ }),
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numericFilter = exports.stringFilter = exports.filterData = undefined;

var _isNumeric = __webpack_require__(274);

var _isNumeric2 = _interopRequireDefault(_isNumeric);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Filters an array of object with a set of filters
var filterData = exports.filterData = function filterData(data, filters) {
    if (!filters) {
        return data;
    }

    var filteredData = [].concat(_toConsumableArray(data));

    Object.keys(filters).forEach(function (field) {
        // Loop through all filters
        var filter = filters[field];

        filteredData = filteredData.filter(function (d) {
            // Loop through all data items
            var props = d.properties || d; // GeoJSON or plain object
            var value = props[field];

            return (0, _isNumeric2.default)(value) ? numericFilter(value, filter) : stringFilter(value, filter);
        });
    });

    return filteredData;
};

// Simple check if string contains another string
var stringFilter = exports.stringFilter = function stringFilter(string, filter) {
    return ('' + string).toLowerCase().indexOf(filter.toLowerCase()) !== -1;
};

// Numeric filter supporting AND, OR, GREATER THAN, LESS THAN or equal number
var numericFilter = exports.numericFilter = function numericFilter(value, filter) {
    // TODO: Syntax error handling
    return filter.split(',').some(function (orFilter) {
        // OR filter
        return orFilter.split('&').every(function (filter) {
            return isTrueFilter(value, filter);
        }); // AND filter
    });
};

// Returns true if the filter is true
var isTrueFilter = function isTrueFilter(value, filter) {
    if (filter.indexOf('>') > -1) {
        // GREATER THAN
        return value >= Number(filter.split('>')[1]);
    }

    if (filter.indexOf('<') > -1) {
        // LESS THAN
        return value <= Number(filter.split('<')[1]);
    }

    return value === Number(filter); // Equal number
};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DIRTY_PROPERTY_LIST = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ModelValidation = __webpack_require__(169);

var _ModelValidation2 = _interopRequireDefault(_ModelValidation);

var _json = __webpack_require__(114);

var _models = __webpack_require__(281);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var modelValidator = _ModelValidation2.default.getModelValidation();

var DIRTY_PROPERTY_LIST = exports.DIRTY_PROPERTY_LIST = Symbol('List to keep track of dirty properties');

/**
 * Base class that supplies functionality to the Model classes
 *
 * @memberof module:model
 */

var ModelBase = function () {
    function ModelBase() {
        _classCallCheck(this, ModelBase);

        this.modelDefinition = {
            modelValidations: {}
        };
    }
    /**
     * @returns {Promise} Returns a promise that resolves when the model has been saved or rejected with the result from
     * the `validate()` call.
     *
     * @definition
     * Will save model as a new object to the server using a POST request. This method would generally be used if
     * you're creating models with pre-specified IDs. Note that this does not check if the model is marked as dirty.
     */


    _createClass(ModelBase, [{
        key: 'create',
        value: function create() {
            var _this = this;

            return this.validate().then(function (validationState) {
                if (!validationState.status) {
                    return Promise.reject(validationState);
                }

                return _this.modelDefinition.saveNew(_this).then(function (apiResponse) {
                    return _models.updateModelFromResponseStatus.call(_this, apiResponse);
                });
            });
        }

        /**
         * @returns {Promise} Returns a promise that resolves when the model has been saved
         * or rejects with the result from the `validate()` call.
         *
         * @description
         * Checks if the model is dirty. When the model is dirty it will check if the values of the model are valid by calling
         * `validate`. If this is correct it will attempt to save the [Model](#/model/Model) to the api.
         *
         * ```js
         * myModel.save()
         *   .then((message) => console.log(message));
         * ```
         */

    }, {
        key: 'save',
        value: function save(includeChildren) {
            var _this2 = this;

            // Calling save when there's nothing to be saved is a no-op
            if (!this.isDirty(includeChildren)) {
                return Promise.resolve({});
            }

            return this.validate().then(function (validationState) {
                if (!validationState.status) {
                    return Promise.reject(validationState);
                }

                return _this2.modelDefinition.save(_this2).then(function (apiResponse) {
                    return _models.updateModelFromResponseStatus.call(_this2, apiResponse);
                });
            });
        }

        /**
         * @returns {Promise} Promise that resolves with an object with a status property that represents if the model
         * is valid or not the fields array will return the names of the fields that are invalid.
         *
         * @description
         * This will run the validations on the properties which have validations set. Normally these validations are defined
         * through the DHIS2 schema. It will check min/max for strings/numbers etc. Additionally it will
         * run model validations against the schema.
         *
         * ```js
         * myModel.validate()
         *  .then(myModelStatus => {
         *    if (myModelStatus.status === false) {
         *      myModelStatus.fields.forEach((fieldName) => console.log(fieldName));
         *    }
         * });
         * ```
         *
         * @deprecated The api now validates the object on save, so doing the additional request to validate the object
         * is not very useful anymore as the validation on POST/PUT is more extensive than the /api/schemas validation.
         */

    }, {
        key: 'validate',
        value: function validate() {
            var _this3 = this;

            return new Promise(function (resolve, reject) {
                var validationMessages = [];

                function unique(current, property) {
                    if (property && current.indexOf(property) === -1) {
                        current.push(property);
                    }
                    return current;
                }

                function asyncRemoteValidation(model) {
                    return modelValidator.validateAgainstSchema(model);
                }

                // Run async validation against the api
                asyncRemoteValidation(_this3).catch(function (remoteMessages) {
                    // Errors are ok in this case
                    if (Array.isArray(remoteMessages)) {
                        return remoteMessages;
                    }
                    return Promise.reject(remoteMessages);
                }).then(function (remoteMessages) {
                    validationMessages = validationMessages.concat(remoteMessages);

                    var validationState = {
                        status: remoteMessages.length === 0,
                        fields: validationMessages.map(function (validationMessage) {
                            return validationMessage.property;
                        }).reduce(unique, []),
                        messages: validationMessages
                    };
                    resolve(validationState);
                }).catch(function (message) {
                    return reject(message);
                });
            });
        }

        // TODO: Cloning large graphs is very slow

    }, {
        key: 'clone',
        value: function clone() {
            var modelClone = this.modelDefinition.create((0, _json.getJSONForProperties)(this, Object.keys(this.modelDefinition.modelValidations), true));

            if (this.isDirty()) {
                modelClone.dirty = this.isDirty(true);
            }

            return modelClone;
        }

        /**
         * Deletes the object from the server.
         *
         * This will fire a DELETE request to have the object be removed from the system.
         *
         * @returns {Promise} Resolves when the object was successfully deleted.
         */

    }, {
        key: 'delete',
        value: function _delete() {
            return this.modelDefinition.delete(this);
        }

        /**
         * Check if the model is in a dirty state and is a candidate to be saved.
         *
         * It will check for direct properties that have been changed and if any of the children have been changed.
         *
         * @param {boolean} includeChildren If set to false only the models direct properties will be checked.
         * @returns {boolean} Returns true when the model is in a dirty state.
         */

    }, {
        key: 'isDirty',
        value: function isDirty() {
            var includeChildren = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            return this.dirty || includeChildren === true && this.hasDirtyChildren();
        }

        /**
         * Utility method to reset the dirty state of the object.
         *
         * This is called after a successful save operation was done.
         *
         * @returns {ModelBase} Returns itself for potential chaining
         */

    }, {
        key: 'resetDirtyState',
        value: function resetDirtyState() {
            this.dirty = false;

            // Also set it's children to be clean
            this.getDirtyChildren().forEach(function (value) {
                if (value.resetDirtyState) {
                    value.resetDirtyState();
                } else {
                    value.dirty = false; // eslint-disable-line no-param-reassign
                }
            });

            this[DIRTY_PROPERTY_LIST].clear();

            return this;
        }

        /**
         * Returns a list of properties that have been changed.
         *
         * @returns {Array<string>} The names of the properties that were changed.
         */

    }, {
        key: 'getDirtyPropertyNames',
        value: function getDirtyPropertyNames() {
            return Array.from(this[DIRTY_PROPERTY_LIST].values());
        }

        /**
         * This will return the properties that are marked as `owner: true` in the schema definition for the model.
         *
         * @returns {Array<any>} Returns an array of properties that are owned by the object
         */
        // TODO: This name is very misleading and should probably be renamed to something like `getOwnerProperties` (would be a breaking change)

    }, {
        key: 'getCollectionChildren',
        value: function getCollectionChildren() {
            var _this4 = this;

            return Object.keys(this).filter(function (propertyName) {
                return _this4[propertyName] && (0, _models.hasModelValidationForProperty)(_this4, propertyName) && (0, _models.pickOwnerFromModelValidation)(propertyName, _this4);
            }).map(function (propertyName) {
                return _this4[propertyName];
            });
        }

        /**
         * Gets the names of the properties that are collections on the object.
         *
         * These are usually the properties that contain ModelCollectionProperties.
         *
         * @returns {Array<string>} A list of property names that are marked as type `COLLECTION` in the schema.
         */

    }, {
        key: 'getCollectionChildrenPropertyNames',
        value: function getCollectionChildrenPropertyNames() {
            var _this5 = this;

            return Object.keys(this).filter(function (propertyName) {
                return (0, _models.pickTypeFromModelValidation)(propertyName, _this5) === 'COLLECTION';
            });
        }

        /**
         * Gets the names of the properties that are references on the object.
         *
         * These are usually the properties that contain a Model of a different type. (e.g DataElement -> CategoryCombo)
         *
         * @returns {Array<string>} A list of property names that are marked as type `REFERENCE` in the schema.
         */

    }, {
        key: 'getReferenceProperties',
        value: function getReferenceProperties() {
            var _this6 = this;

            return Object.keys(this).filter(function (propertyName) {
                return (0, _models.pickTypeFromModelValidation)(propertyName, _this6) === 'REFERENCE' && (0, _models.pickEmbeddedObjectFromModelValidation)(propertyName, _this6) === false;
            });
        }

        /**
         * Gets the names of the properties that are embedded objects.
         *
         * These the properties that are not represented by a different Model, but are just plain objects that are
         * embedded within the current object.
         *
         * @returns {Array<string>} A list of property names of embedded objects.
         */

    }, {
        key: 'getEmbeddedObjectCollectionPropertyNames',
        value: function getEmbeddedObjectCollectionPropertyNames() {
            var _this7 = this;

            return this.getCollectionChildrenPropertyNames().filter(function (propertyName) {
                return (0, _models.pickEmbeddedObjectFromModelValidation)(propertyName, _this7);
            });
        }

        /**
         * Returns a list of child properties that are marked as dirty. This uses the `getCollectionChildren()` method
         * to retrieve the children properties and then checks if they are marked as dirty.
         *
         * The method does not check if direct properties are dirty as those are tracked on the Model itself.
         *
         * @returns {Array<any>}
         */

    }, {
        key: 'getDirtyChildren',
        value: function getDirtyChildren() {
            return this.getCollectionChildren().filter(function (property) {
                return property && property.dirty === true;
            });
        }

        /**
         * Check if any of the Model's child collections are dirty.
         *
         * @returns {boolean} True when one of the children is dirty.
         */

    }, {
        key: 'hasDirtyChildren',
        value: function hasDirtyChildren() {
            return this.getDirtyChildren().length > 0;
        }

        /**
         * This method is generally intended to, by default, usefully serialize Model objects during JSON serialization.
         *
         * This method will take all the properties that are defined on the schema and create an object with the keys and
         * values for those properties. This will remove any circular dependencies that could have occurred otherwise.
         *
         * @returns {Object}
         */

    }, {
        key: 'toJSON',
        value: function toJSON() {
            return (0, _json.getJSONForProperties)(this, Object.keys(this.modelDefinition.modelValidations));
        }
    }]);

    return ModelBase;
}();

exports.default = new ModelBase();
//# sourceMappingURL=ModelBase.js.map

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getJSONForProperties = getJSONForProperties;
exports.getOwnedPropertyJSON = getOwnedPropertyJSON;

var _check = __webpack_require__(15);

var _utils = __webpack_require__(29);

/**
 * Map propertyName to modelType
 * The model with propertyName will be treated as a regular array
 * (no collection) if the combination of [propertyName, modelType] exists in the object
 * Empty arrays means it applies to any modelType.
 *
 * @private
 */
var NON_MODEL_COLLECTIONS = {
    aggregationLevels: ['dataElement'],
    grantTypes: ['oAuth2Client'],
    translations: [],
    deliveryChannels: ['programNotificationTemplate'],
    redirectUris: ['oAuth2Client'],
    organisationUnitLevels: ['validationRule'],
    favorites: []
};

var isNonModelCollection = function isNonModelCollection(propertyName, modelType) {
    var modelTypes = NON_MODEL_COLLECTIONS[propertyName];

    if (!modelTypes) {
        return false;
    }

    return (0, _check.contains)(modelType, modelTypes) || (0, _check.isEmpty)(modelTypes);
};
function isPlainValue(collection) {
    return function isPlainValueInCollection(property) {
        return collection.indexOf(property) === -1;
    };
}

function isCollectionProperty(collection) {
    return function (property) {
        return !isPlainValue(collection)(property);
    };
}

function isReferenceProperty(collection) {
    return function (property) {
        return collection.indexOf(property) >= 0;
    };
}

// TODO: Misnamed as it does not actually return JSON
function getJSONForProperties(model, properties) {
    var keepFullModels = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var objectToSave = {};
    var collectionPropertiesNames = model.getCollectionChildrenPropertyNames()
    // Even though attributeValues are considered collections, they are handled separately due to their
    // difference in structure.
    .filter(function (propertyName) {
        return propertyName !== 'attributeValues';
    });

    var propertyNames = Object.keys(model.modelDefinition.modelValidations).filter(function (propertyName) {
        return properties.indexOf(propertyName) >= 0;
    }).filter(function (propertyName) {
        return model.dataValues[propertyName] !== undefined && model.dataValues[propertyName] !== null;
    });

    // Handle plain values
    propertyNames.filter(isPlainValue(collectionPropertiesNames)).filter(function (v) {
        return !isReferenceProperty(model.getReferenceProperties())(v);
    }).forEach(function (propertyName) {
        objectToSave[propertyName] = model.dataValues[propertyName];
    });

    // Handle reference properties
    propertyNames.filter(isPlainValue(collectionPropertiesNames)).filter(isReferenceProperty(model.getReferenceProperties())).forEach(function (propertyName) {
        objectToSave[propertyName] = { id: model.dataValues[propertyName].id };
    });

    // Handle non-embedded collection properties
    propertyNames.filter(isCollectionProperty(collectionPropertiesNames)).forEach(function (propertyName) {
        // TODO: This is not the proper way to do this. We should check if the array contains Models
        // These objects are not marked as embedded objects but they behave like they are
        if (isNonModelCollection(propertyName, model.modelDefinition.name)) {
            objectToSave[propertyName] = Array.from(model.dataValues[propertyName]);
            return;
        }

        var values = Array.isArray(model.dataValues[propertyName]) ? model.dataValues[propertyName] : Array.from(model.dataValues[propertyName].values());

        // If the collection is a embedded collection we can save it as is.
        if (model.getEmbeddedObjectCollectionPropertyNames().indexOf(propertyName) !== -1) {
            objectToSave[propertyName] = values;
            return;
        }

        // Transform an object collection to an array of objects with id properties
        objectToSave[propertyName] = values.filter((0, _utils.pick)('id'))
        // For any other types we return an object with just an id
        .map(function (childModel) {
            if (keepFullModels && (0, _check.isFunction)(childModel.clone)) {
                return childModel.clone();
            }
            return { id: childModel.id };
        });
    });

    return objectToSave;
}

// TODO: Misnamed as it does not actually return JSON
function getOwnedPropertyJSON(model) {
    var ownedProperties = model.modelDefinition.getOwnedPropertyNames();

    return getJSONForProperties(model, ownedProperties);
}
//# sourceMappingURL=json.js.map

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

var _check = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @private
 * @description
 * Represents a namespace in the dataStore that can be used to be used to interact with
 * the remote API.
 *
 * @property {Array} keys an array of the loaded keys.
 * @property {String} namespace name of this namespace as on the server.
 *
 * @memberof module:datastore
 */
var BaseStoreNamespace = function () {
    /**
     * @param {string} namespace - the name of the namespace this represents.
     * @param {string[]} keys - preloaded keys for this namespace.
     * @param {module:api.Api} api - the api implementation, used for testing.
     * @param {string} endPoint - the relative API-endpoint, one of ['dataStore, userDataStore'].
     */
    function BaseStoreNamespace(namespace, keys) {
        var api = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _Api2.default.getApi();
        var endPoint = arguments[3];

        _classCallCheck(this, BaseStoreNamespace);

        if (!(0, _check.isString)(namespace)) {
            throw new Error('BaseStoreNamespace must be called with a string to identify the Namespace');
        }
        if (!(0, _check.isString)(endPoint)) {
            throw new Error('BaseStoreNamespace must be called with an endPoint');
        }
        if (this.constructor === BaseStoreNamespace) {
            throw new Error('Can\'t instantiate abstract class!');
        }

        this.api = api;

        /**
         * The name of the namespace
         * @type {string}
         */
        this.namespace = namespace;

        /**
         * an array of the loaded keys.
         * @type {string[]}
         */
        this.keys = keys || [];
        this.endPoint = endPoint;
    }

    /**
     * Get the keys for this namespace.
     *
     * @returns {Promise} - The internal list of keys for current namespace.
     */


    _createClass(BaseStoreNamespace, [{
        key: 'getKeys',
        value: function getKeys() {
            var _this = this;

            return this.api.get([this.endPoint, this.namespace].join('/')).then(function (response) {
                if (response && (0, _check.isArray)(response)) {
                    _this.keys = response;
                    return response;
                }
                return Promise.reject(new Error('The requested namespace has no keys or does not exist.'));
            });
        }

        /**
         * Retrieves the value of given key in current namespace.
         *
         * @param key - key to retrieve.
         * @returns {Promise} - The value of the given key.
         */

    }, {
        key: 'get',
        value: function get(key) {
            return this.api.get([this.endPoint, this.namespace, key].join('/'));
        }

        /**
         * Sets the value of given key to given value.
         *
         * This will also create a new namespace on the API-end if it does not exist.
         * If the key exists <a href='#update'> update</a> will be called, unless <code>overrideUpdate</code> equals
         * true.
         *
         * @param key - key in this namespace to set.
         * @param value - JSON-value to be set.
         * @param [overrideUpdate=false] - If true a post-request is sent even if key exists.
         * @param [encrypt=false] - If the value should be encrypted on the server.
         * @returns {Promise} - the response body from the {@link module:api.Api#get API}.
         */

    }, {
        key: 'set',
        value: function set(key, value) {
            var _this2 = this;

            var overrideUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var encrypt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            if (!overrideUpdate && this.keys.includes(key)) {
                return this.update(key, value);
            }
            var queryParams = encrypt === true ? '?encrypt=true' : '';
            return this.api.post([this.endPoint, this.namespace, key + queryParams].join('/'), value).then(function (resp) {
                _this2.keys = [].concat(_toConsumableArray(_this2.keys), [key]);
                return resp;
            });
        }

        /**
         * Deletes given key from the API.
         * @param {string} key - key to delete.
         * @returns {Promise} - the response body from the {@link module:api.Api#get API}.
         */

    }, {
        key: 'delete',
        value: function _delete(key) {
            var _this3 = this;

            if (!(0, _check.isString)(key)) {
                return Promise.reject(new Error('Expected key to be string, but got ' + (typeof key === 'undefined' ? 'undefined' : _typeof(key))));
            }
            return this.api.delete([this.endPoint, this.namespace, key].join('/')).then(function (resp) {
                _this3.keys = _this3.keys.filter(function (elem) {
                    return elem !== key;
                });
                return resp;
            });
        }

        /**
         * Updates a key with given value.
         * @param key - key to update.
         * @param value - value to update to.
         * @returns {Promise} - the response body from the {@link module:api.Api#get API}.
         */

    }, {
        key: 'update',
        value: function update(key, value) {
            return this.api.update([this.endPoint, this.namespace, key].join('/'), value);
        }
    }]);

    return BaseStoreNamespace;
}();

exports.default = BaseStoreNamespace;
//# sourceMappingURL=BaseStoreNamespace.js.map

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(35),
    isObject = __webpack_require__(26);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 117 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(78),
    baseLodash = __webpack_require__(119);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 119 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(345),
    shortOut = __webpack_require__(191);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 121 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(150),
    eq = __webpack_require__(80);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(357),
    baseUnary = __webpack_require__(84),
    nodeUtil = __webpack_require__(125);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 124 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(181);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(83)(module)))

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(85),
    nativeKeys = __webpack_require__(358);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(128),
    arrayEach = __webpack_require__(96),
    assignValue = __webpack_require__(122),
    baseAssign = __webpack_require__(197),
    baseAssignIn = __webpack_require__(382),
    cloneBuffer = __webpack_require__(385),
    copyArray = __webpack_require__(79),
    copySymbols = __webpack_require__(386),
    copySymbolsIn = __webpack_require__(388),
    getAllKeys = __webpack_require__(203),
    getAllKeysIn = __webpack_require__(151),
    getTag = __webpack_require__(53),
    initCloneArray = __webpack_require__(391),
    initCloneByTag = __webpack_require__(392),
    initCloneObject = __webpack_require__(397),
    isArray = __webpack_require__(21),
    isBuffer = __webpack_require__(82),
    isMap = __webpack_require__(398),
    isObject = __webpack_require__(26),
    isSet = __webpack_require__(400),
    keys = __webpack_require__(58);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(86),
    stackClear = __webpack_require__(365),
    stackDelete = __webpack_require__(366),
    stackGet = __webpack_require__(367),
    stackHas = __webpack_require__(368),
    stackSet = __webpack_require__(369);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41),
    root = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(370),
    mapCacheDelete = __webpack_require__(377),
    mapCacheGet = __webpack_require__(379),
    mapCacheHas = __webpack_require__(380),
    mapCacheSet = __webpack_require__(381);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(387),
    stubArray = __webpack_require__(201);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 132 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(199);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(206);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(35),
    getPrototype = __webpack_require__(133),
    isObjectLike = __webpack_require__(25);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 136 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(21),
    isSymbol = __webpack_require__(52);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 138 */,
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timeFormatDefaultLocale", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timeFormat", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timeParse", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "utcFormat", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "utcParse", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(222);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timeFormatLocale", function() { return __WEBPACK_IMPORTED_MODULE_1__src_locale__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_isoFormat__ = __webpack_require__(223);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isoFormat", function() { return __WEBPACK_IMPORTED_MODULE_2__src_isoFormat__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_isoParse__ = __webpack_require__(468);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isoParse", function() { return __WEBPACK_IMPORTED_MODULE_3__src_isoParse__["a"]; });






/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return timeFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return timeParse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return utcParse; });
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(222);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
});


/***/ }),
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = __webpack_require__(15);

var _utils = __webpack_require__(29);

var _Model = __webpack_require__(95);

var _Model2 = _interopRequireDefault(_Model);

var _ModelDefinition = __webpack_require__(171);

var _ModelDefinition2 = _interopRequireDefault(_ModelDefinition);

var _Pager = __webpack_require__(283);

var _Pager2 = _interopRequireDefault(_Pager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _throwIfContainsOtherThanModelObjects(values) {
    if (values && values[Symbol.iterator]) {
        var toCheck = [].concat(_toConsumableArray(values));
        toCheck.forEach(function (value) {
            if (!(value instanceof _Model2.default)) {
                (0, _utils.throwError)('Values of a ModelCollection must be instances of Model');
            }
        });
    }
}

function _throwIfContainsModelWithoutUid(values) {
    if (values && values[Symbol.iterator]) {
        var toCheck = [].concat(_toConsumableArray(values));
        toCheck.forEach(function (value) {
            if (!(0, _check.isValidUid)(value.id)) {
                (0, _utils.throwError)('Can not add a Model without id to a ModelCollection');
            }
        });
    }
}

/**
 * Collection of `Model` objects that can be interacted upon. Can contain a pager object to easily navigate
 * pages within the system.
 *
 * @memberof module:model
 */

var ModelCollection = function () {
    /**
     * @constructor
     *
     * @param {ModelDefinition} modelDefinition The `ModelDefinition` that this collection is for. This defines the type of models that
     * are allowed to be added to the collection.
     * @param {Model[]} values Initial values that should be added to the collection.
     * @param {Object} pagerData Object with pager data. This object contains data that will be put into the `Pager` instance.
     *
     * @description
     *
     * Creates a new `ModelCollection` object based on the passed `modelDefinition`. Additionally values can be added by passing
     * `Model` objects in the `values` parameter. The collection also exposes a pager object which can be used to navigate through
     * the pages in the collection. For more information see the `Pager` class.
     */
    function ModelCollection(modelDefinition, values, pagerData) {
        var _this = this;

        _classCallCheck(this, ModelCollection);

        (0, _check.checkType)(modelDefinition, _ModelDefinition2.default);
        /**
         * @property {ModelDefinition} modelDefinition The `ModelDefinition` that this collection is for. This defines the type of models that
         * are allowed to be added to the collection.
         */
        this.modelDefinition = modelDefinition;

        /**
         * @property {Pager} pager Pager object that is created from the pagerData that was passed when the collection was constructed. If no pager data was present
         * the pager will have default values.
         */
        this.pager = new _Pager2.default(pagerData, modelDefinition);

        // We can not extend the Map object right away in v8 contexts.
        this.valuesContainerMap = new Map();
        this[Symbol.iterator] = this.valuesContainerMap[Symbol.iterator].bind(this.valuesContainerMap);

        _throwIfContainsOtherThanModelObjects(values);
        _throwIfContainsModelWithoutUid(values);

        // Add the values separately as not all Iterators return the same values
        if ((0, _check.isArray)(values)) {
            values.forEach(function (value) {
                return _this.valuesContainerMap.set(value.id, value);
            });
        }
    }

    /**
     * @property {Number} size The number of Model objects that are in the collection.
     *
     * @description
     * Contains the number of Model objects that are in this collection. If the collection is a collection with a pager. This
     * does not take into account all the items in the database. Therefore when a pager is present on the collection
     * the size will return the items on that page. To get the total number of items consult the pager.
     */


    _createClass(ModelCollection, [{
        key: 'add',


        /**
         * Adds a Model instance to the collection. The model is checked if it is a correct instance of `Model` and if it has
         * a valid id. A valid id is a uid string of 11 alphanumeric characters.
         *
         * @param {Model} value Model instance to add to the collection.
         * @returns {ModelCollection} Returns itself for chaining purposes.
         *
         * @throws {Error} When the passed value is not an instance of `Model`
         * @throws {Error} Throws error when the passed value does not have a valid id.
         */
        value: function add(value) {
            _throwIfContainsOtherThanModelObjects([value]);
            _throwIfContainsModelWithoutUid([value]);

            this.set(value.id, value);
            return this;
        }

        /**
         * If working with the Map type object is inconvenient this method can be used to return the values
         * of the collection as an Array object.
         *
         * @returns {Array} Returns the values of the collection as an array.
         */

    }, {
        key: 'toArray',
        value: function toArray() {
            var resultArray = [];

            this.forEach(function (model) {
                resultArray.push(model);
            });

            return resultArray;
        }
    }, {
        key: 'clear',


        /**
         * Clear the collection and remove all it's values.
         *
         * @returns {this} Returns itself for chaining purposes;
         */
        // TODO: Reset the pager?
        value: function clear() {
            return this.valuesContainerMap.clear.call(this.valuesContainerMap);
        }
    }, {
        key: 'delete',
        value: function _delete() {
            var _valuesContainerMap$d;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return (_valuesContainerMap$d = this.valuesContainerMap.delete).call.apply(_valuesContainerMap$d, [this.valuesContainerMap].concat(args));
        }
    }, {
        key: 'entries',
        value: function entries() {
            return this.valuesContainerMap.entries.call(this.valuesContainerMap);
        }

        // FIXME: This calls the forEach function with the values Map and not with the ModelCollection as the third argument

    }, {
        key: 'forEach',
        value: function forEach() {
            var _valuesContainerMap$f;

            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            return (_valuesContainerMap$f = this.valuesContainerMap.forEach).call.apply(_valuesContainerMap$f, [this.valuesContainerMap].concat(args));
        }
    }, {
        key: 'get',
        value: function get() {
            var _valuesContainerMap$g;

            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
            }

            return (_valuesContainerMap$g = this.valuesContainerMap.get).call.apply(_valuesContainerMap$g, [this.valuesContainerMap].concat(args));
        }
    }, {
        key: 'has',
        value: function has() {
            var _valuesContainerMap$h;

            for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
            }

            return (_valuesContainerMap$h = this.valuesContainerMap.has).call.apply(_valuesContainerMap$h, [this.valuesContainerMap].concat(args));
        }
    }, {
        key: 'keys',
        value: function keys() {
            return this.valuesContainerMap.keys.call(this.valuesContainerMap);
        }
    }, {
        key: 'set',
        value: function set() {
            var _valuesContainerMap$s;

            for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                args[_key5] = arguments[_key5];
            }

            return (_valuesContainerMap$s = this.valuesContainerMap.set).call.apply(_valuesContainerMap$s, [this.valuesContainerMap].concat(args));
        }
    }, {
        key: 'values',
        value: function values() {
            return this.valuesContainerMap.values.call(this.valuesContainerMap);
        }
    }, {
        key: 'size',
        get: function get() {
            return this.valuesContainerMap.size;
        }
    }], [{
        key: 'create',
        value: function create(modelDefinition, values, pagerData) {
            return new ModelCollection(modelDefinition, values, pagerData);
        }
    }, {
        key: 'throwIfContainsOtherThanModelObjects',
        value: function throwIfContainsOtherThanModelObjects(value) {
            return _throwIfContainsOtherThanModelObjects(value);
        }
    }, {
        key: 'throwIfContainsModelWithoutUid',
        value: function throwIfContainsModelWithoutUid(value) {
            return _throwIfContainsModelWithoutUid(value);
        }
    }]);

    return ModelCollection;
}();

exports.default = ModelCollection;
//# sourceMappingURL=ModelCollection.js.map

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(193);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(204),
    getSymbolsIn = __webpack_require__(202),
    keysIn = __webpack_require__(200);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(426),
    overRest = __webpack_require__(217),
    setToString = __webpack_require__(120);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(132),
    isFlattenable = __webpack_require__(427);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global window */


var _check = __webpack_require__(15);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Logger = function () {
    function Logger(logging) {
        _classCallCheck(this, Logger);

        (0, _check.checkType)(logging, 'object', 'console');
        this.logger = logging;
    }

    _createClass(Logger, [{
        key: 'canLog',
        value: function canLog(type) {
            return !!(type && console && (0, _check.isType)(this.logger[type], 'function'));
        }
    }, {
        key: 'logMessage',
        value: function logMessage() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'log';

            if (this.canLog(type) && this.logger[type]) {
                var _logger;

                for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    rest[_key - 1] = arguments[_key];
                }

                (_logger = this.logger)[type].apply(_logger, rest);
                return true;
            }
            return false;
        }
    }, {
        key: 'debug',
        value: function debug() {
            for (var _len2 = arguments.length, rest = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                rest[_key2] = arguments[_key2];
            }

            return this.logMessage.apply(this, ['debug'].concat(rest));
        }
    }, {
        key: 'error',
        value: function error() {
            for (var _len3 = arguments.length, rest = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                rest[_key3] = arguments[_key3];
            }

            return this.logMessage.apply(this, ['error'].concat(rest));
        }
    }, {
        key: 'log',
        value: function log() {
            for (var _len4 = arguments.length, rest = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                rest[_key4] = arguments[_key4];
            }

            return this.logMessage.apply(this, ['log'].concat(rest));
        }
    }, {
        key: 'warn',
        value: function warn() {
            for (var _len5 = arguments.length, rest = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                rest[_key5] = arguments[_key5];
            }

            return this.logMessage.apply(this, ['warn'].concat(rest));
        }
    }], [{
        key: 'getLogger',
        value: function getLogger() {
            var logger = void 0;

            // TODO: This is not very clean try to figure out a better way to do this.
            try {
                // Node version
                logger = global.console;
            } catch (e) {
                // Browser version fallback
                /* istanbul ignore next */
                logger = window.console;
            }

            if (this.logger) {
                return this.logger;
            }
            return this.logger = new Logger(logger);
        }
    }]);

    return Logger;
}();

exports.default = Logger;
//# sourceMappingURL=Logger.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = __webpack_require__(15);

var _Logger = __webpack_require__(168);

var _Logger2 = _interopRequireDefault(_Logger);

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

var _json = __webpack_require__(114);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Handles validation of Model objects based on their modelDefinition.
 *
 * @memberof module:model
 */
var ModelValidation = function () {
    function ModelValidation(providedLogger) {
        _classCallCheck(this, ModelValidation);

        (0, _check.checkType)(providedLogger, 'object', 'logger (Logger)');
        this.logger = providedLogger;
    }

    /**
     * @deprecated Client side model validation is deprecated in favour of server side validation only.
     *
     * @returns {{status: boolean, messages: Array}} Returns {status: true, messages: []}
     */


    _createClass(ModelValidation, [{
        key: 'validate',
        value: function validate() {
            this.logger.warn('Client side model validation is deprecated');
            throw new Error('Client side model validation is deprecated');
        }

        /**
         * Sends a POST request against the `api/schemas` endpoint to check if the model is valid.
         *
         * @param {Model} model The model that should be validated.
         * @returns {Array} Returns an array with validation messages if there are any.
         *
         * @note {warn} Currently only checks
         */

    }, {
        key: 'validateAgainstSchema',
        value: function validateAgainstSchema(model) {
            // eslint-disable-line class-methods-use-this
            if (!(model && model.modelDefinition && model.modelDefinition.name)) {
                return Promise.reject('model.modelDefinition.name can not be found');
            }

            function extractValidationViolations(webmessage) {
                if (webmessage.response && webmessage.response.errorReports) {
                    return webmessage.response.errorReports;
                }
                throw new Error('Response was not a WebMessage with the expected format');
            }

            var url = 'schemas/' + model.modelDefinition.name;

            // TODO: The function getOwnedPropertyJSON should probably not be exposed, perhaps we could have a getJSONForModel(ownedPropertiesOnly=true) method.
            return _Api2.default.getApi().post(url, (0, _json.getOwnedPropertyJSON)(model)).catch(function (e) {
                return Promise.reject(e);
            }).then(function (webMessage) {
                if (webMessage.status === 'OK') {
                    return [];
                }
                return Promise.reject(webMessage);
            }).catch(extractValidationViolations);
        }

        /**
         * Returns the `ModelValidation` singleton. Creates a new one if it does not yet exist.
         * Grabs a logger instance by calling `Logger.getLogger`
         *
         * @returns {ModelValidation} New or memoized instance of `ModelInstance`
         */

    }], [{
        key: 'getModelValidation',
        value: function getModelValidation() {
            if (this.modelValidation) {
                return this.modelValidation;
            }
            return this.modelValidation = new ModelValidation(_Logger2.default.getLogger(console));
        }
    }]);

    return ModelValidation;
}();

exports.default = ModelValidation;
//# sourceMappingURL=ModelValidation.js.map

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @module system
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @requires module:api/Api
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

var _SystemSettings = __webpack_require__(279);

var _SystemSettings2 = _interopRequireDefault(_SystemSettings);

var _SystemConfiguration = __webpack_require__(280);

var _SystemConfiguration2 = _interopRequireDefault(_SystemConfiguration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @description
 * Represents the system that can be interacted with. There is a single instance of this pre-defined onto the d2
 * object after initialisation. This can be interacted with using its property objects to among other be used
 * to get and save systemSettings.
 *
 * @memberof module:system
 */
var System = function () {
    function System(settings, configuration) {
        _classCallCheck(this, System);

        /**
         * Contains a reference to a `SystemSettings` instance that can be used
         * to retrieve and save system settings.
         *
         * ```js
         * d2.system.settings.get('keyLastSuccessfulResourceTablesUpdate')
         *  .then(systemSettingsValue => {
         *    console.log('Analytics was last updated on: ' + systemSettingsValue);
         *  });
         * ```
         * @type {SystemSettings}
         *
         */
        this.settings = settings;

        /**
         * A representation of the system configuration,
         * that can be used to retrieve and change system configuration options.
         * @type {SystemConfiguration}
         */
        this.configuration = configuration;

        /**
         * An object containing system information about the DHIS2 instance
         * @type {Object}
         */
        this.systemInfo = undefined;

        /**
         * An object containing version information about the DHIS2 instance
         * @type {Object}
         */
        this.version = undefined;

        /**
         * An array of all the webapps that are installed on the current DHIS2 instance
         * @type {Array}
         */
        this.installedApps = undefined;
    }

    /**
     * Sets the systemInfo and version properties
     *
     * @param systemInfo
     */


    _createClass(System, [{
        key: 'setSystemInfo',
        value: function setSystemInfo(systemInfo) {
            this.version = System.parseVersionString(systemInfo.version);
            this.systemInfo = systemInfo;
        }

        /**
         * Sets the list of currently installed webapps
         *
         * @param apps
         */

    }, {
        key: 'setInstalledApps',
        value: function setInstalledApps(apps) {
            this.installedApps = apps;
        }

        /**
         * Refreshes the list of currently installed webapps
         *
         * @returns {Promise} A promise that resolves to the list of installed apps
         */

    }, {
        key: 'loadInstalledApps',
        value: function loadInstalledApps() {
            var _this = this;

            var api = _Api2.default.getApi();

            return api.get('apps').then(function (apps) {
                _this.setInstalledApps(apps);

                return apps;
            });
        }

        /**
         * Upload and install a zip file containing a new webapp
         *
         * @param zipFile Zip file data from a file input form field
         * @param onProgress An optional callback that will be called whenever file upload progress info is available
         * @returns {Promise}
         */

    }, {
        key: 'uploadApp',
        value: function uploadApp(zipFile, onProgress) {
            // eslint-disable-line class-methods-use-this
            var api = _Api2.default.getApi();
            var data = new FormData();
            var xhr = void 0;
            data.append('file', zipFile);

            if (onProgress !== undefined) {
                xhr = new XMLHttpRequest();
                xhr.upload.onprogress = function (progress) {
                    if (progress.lengthComputable) {
                        onProgress(progress.loaded / progress.total);
                    }
                };
            }

            return api.post('apps', data, {
                contentType: false,
                processData: false,
                xhr: xhr !== undefined ? function () {
                    return xhr;
                } : undefined
            });
        }

        /**
         * Load the list of apps available in the DHIS 2 app store
         *
         * @param compatibleOnly If true, apps that are incompatible with the current system will be filtered out
         * @returns {Promise}
         */

    }, {
        key: 'loadAppStore',
        value: function loadAppStore() {
            var _this2 = this;

            var compatibleOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            return new Promise(function (resolve, reject) {
                var api = _Api2.default.getApi();
                api.get('appStore').then(function (appStoreData) {
                    return resolve(appStoreData.map(function (appData) {
                        var app = Object.assign({}, appData);

                        if (compatibleOnly) {
                            app.versions = app.versions.filter(function (versionData) {
                                return System.isVersionCompatible(_this2.version, versionData);
                            });
                        }

                        return app;
                    }).filter(function (appData) {
                        return appData.versions.length > 0;
                    }));
                }).catch(function (err) {
                    return reject(err);
                });
            });
        }

        /**
         * Install the specified app version from the DHIS 2 app store
         *
         * @param uid The uid of the app version to install
         * @returns {Promise}
         */

    }, {
        key: 'installAppVersion',
        value: function installAppVersion(uid) {
            // eslint-disable-line class-methods-use-this
            var api = _Api2.default.getApi();
            return new Promise(function (resolve, reject) {
                api.post(['appStore', uid].join('/'), '', { dataType: 'text' }).then(function () {
                    resolve();
                }).catch(function (err) {
                    reject(err);
                });
            });
        }

        /**
         * Remove the specified app from the system
         *
         * @param appKey The key of the app to remove
         * @returns {Promise}
         */

    }, {
        key: 'uninstallApp',
        value: function uninstallApp(appKey) {
            // eslint-disable-line class-methods-use-this
            var api = _Api2.default.getApi();

            return api.delete(['apps', appKey].join('/'))
            // TODO: Stop jQuery from rejecting successful promises
            .catch(function () {
                return undefined;
            });
        }

        /**
         * Refresh the list of apps that are installed on the server
         *
         * @returns {Promise} A promise that resolves to the updated list of installed apps
         */

    }, {
        key: 'reloadApps',
        value: function reloadApps() {
            var _this3 = this;

            var api = _Api2.default.getApi();
            return api.update('apps').then(function () {
                return _this3.loadInstalledApps();
            });
        }

        /**
         * @static
         * @typedef {Object} ParsedVersion
         * @property {number} major - Major version of the parsed-string (before .)
         * @property {number} minor - Minor version of the parsed-string (after .)
         * @property {boolean} snapshot - If it's a snapshot-version
         */
        // TODO: Validate string
        // TODO: Handle valid version objects too
        /**
         * Parses a version string into an object describing the version.
         * @param {string} version Version-string to parse
         * @returns {module:system.ParsedVersion}
         */

    }], [{
        key: 'parseVersionString',
        value: function parseVersionString(version) {
            return {
                major: Number.parseInt(version, 10),
                minor: Number.parseInt(version.substring(version.indexOf('.') + 1), 10),
                snapshot: version.indexOf('-SNAPSHOT') >= 0
            };
        }

        // Disable eslint complexity warning
        /* eslint-disable complexity */
        /**
         * Compares version a to version b.
         * @param a {string|module:system.ParsedVersion}
         * @param b {string|module:system.ParsedVersion}
         * @returns {number} 0 if same version, else a - b.
         */

    }, {
        key: 'compareVersions',
        value: function compareVersions(a, b) {
            var from = typeof a === 'string' || a instanceof String ? System.parseVersionString(a) : a;
            var to = typeof b === 'string' || b instanceof String ? System.parseVersionString(b) : b;

            if (from.major !== to.major) {
                return from.major - to.major;
            } else if (from.minor !== to.minor) {
                return from.minor - to.minor;
            }

            return (from.snapshot ? 0 : 1) - (to.snapshot ? 0 : 1);
        }

        /**
         * Checks if systemVersion is compatible with appVersion.
         * Versions are compatible if appVersion.minDhisVersion <= parsed systemVersion and
         * if appVersion.maxDhisVersion >= parsed systemVersion.
         * @param systemVersion {string|module:system.ParsedVersion} systemVersion to check
         * @param {Object} appVersion - AppVersion object to check
         * @returns {boolean} true if compatible, false otherwise.
         */

    }, {
        key: 'isVersionCompatible',
        value: function isVersionCompatible(systemVersion, appVersion) {
            var minVersion = appVersion.minDhisVersion || appVersion.min_platform_version || null;
            var maxVersion = appVersion.maxDhisVersion || appVersion.max_platform_version || null;

            var isNewEnough = minVersion ? System.compareVersions(systemVersion, minVersion) >= 0 : true;
            var isNotTooOld = maxVersion ? System.compareVersions(systemVersion, maxVersion) <= 0 : true;

            return isNewEnough && isNotTooOld;
        }
        /* eslint-enable */

        /**
         * Get a new instance of the system object. This will function as a singleton, when a System object has been created
         * when requesting getSystem again the original version will be returned.
         *
         * @returns {System} Object with the system interaction properties
         */

    }, {
        key: 'getSystem',
        value: function getSystem() {
            if (!System.getSystem.system) {
                System.getSystem.system = new System(new _SystemSettings2.default(), new _SystemConfiguration2.default());
            }

            return System.getSystem.system;
        }
    }]);

    return System;
}();

exports.default = System;
//# sourceMappingURL=System.js.map

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = __webpack_require__(15);

var _utils = __webpack_require__(29);

var _ModelDefinitions = __webpack_require__(172);

var _ModelDefinitions2 = _interopRequireDefault(_ModelDefinitions);

var _Model = __webpack_require__(95);

var _Model2 = _interopRequireDefault(_Model);

var _ModelCollection = __webpack_require__(149);

var _ModelCollection2 = _interopRequireDefault(_ModelCollection);

var _ModelCollectionProperty = __webpack_require__(284);

var _ModelCollectionProperty2 = _interopRequireDefault(_ModelCollectionProperty);

var _SchemaTypes = __webpack_require__(285);

var _SchemaTypes2 = _interopRequireDefault(_SchemaTypes);

var _Filters = __webpack_require__(286);

var _Filters2 = _interopRequireDefault(_Filters);

var _ModelBase = __webpack_require__(113);

var _config = __webpack_require__(173);

var _json = __webpack_require__(114);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createModelPropertyDescriptor(propertiesObject, schemaProperty) {
    var propertyName = schemaProperty.collection ? schemaProperty.collectionName : schemaProperty.name;
    var propertyDetails = {
        // Actual property descriptor properties
        configurable: false,
        enumerable: true,
        get: function get() {
            return this.dataValues[propertyName];
        }
    };

    // Store available constants for ENUM type properties
    if (schemaProperty.constants) {
        propertyDetails.constants = schemaProperty.constants;
    }

    // Only add a setter for writable properties
    if (schemaProperty.writable) {
        propertyDetails.set = function dynamicPropertySetter(value) {
            // TODO: Objects and Arrays are considered unequal when their data is the same and therefore trigger a dirty
            if (!(0, _check.isObject)(value) && value !== this.dataValues[propertyName] || (0, _check.isObject)(value)) {
                this.dirty = true;
                this[_ModelBase.DIRTY_PROPERTY_LIST].add(propertyName);
                this.dataValues[propertyName] = value;
            }
        };
    }

    if (propertyName) {
        propertiesObject[propertyName] = propertyDetails; // eslint-disable-line no-param-reassign
    }
}

function createPropertiesObject(schemaProperties) {
    var propertiesObject = {};
    var createModelPropertyDescriptorOn = (0, _utils.curry)(createModelPropertyDescriptor, propertiesObject);

    (schemaProperties || []).forEach(createModelPropertyDescriptorOn);

    return propertiesObject;
}

function createValidationSetting(validationObject, schemaProperty) {
    var propertyName = schemaProperty.collection ? schemaProperty.collectionName : schemaProperty.name;
    var validationDetails = {
        persisted: schemaProperty.persisted,
        type: _SchemaTypes2.default.typeLookup(schemaProperty.propertyType),
        required: schemaProperty.required,
        min: schemaProperty.min,
        max: schemaProperty.max,
        owner: schemaProperty.owner,
        unique: schemaProperty.unique,
        writable: schemaProperty.writable,
        ordered: Boolean(schemaProperty.ordered),
        embeddedObject: Boolean(schemaProperty.embeddedObject)
    };

    function getReferenceTypeFrom(property) {
        if (property.href) {
            return property.href.split('/').pop();
        }

        return undefined;
    }

    // Add a referenceType to be able to get a hold of the reference objects model.
    if (validationDetails.type === 'REFERENCE' || validationDetails.type === 'COLLECTION' && schemaProperty.itemPropertyType === 'REFERENCE') {
        validationDetails.referenceType = getReferenceTypeFrom(schemaProperty);
    }

    if (propertyName) {
        validationObject[propertyName] = validationDetails; // eslint-disable-line no-param-reassign
    }
}

function createValidations(schemaProperties) {
    var validationsObject = {};
    var createModelPropertyOn = (0, _utils.curry)(createValidationSetting, validationsObject);

    (schemaProperties || []).forEach(createModelPropertyOn);

    return validationsObject;
}

function shouldBeModelCollectionProperty(model, models) {
    return function shouldBeModelCollectionPropertyIterator(modelProperty) {
        return model && models && model.modelDefinition && model.modelDefinition.modelValidations && model.modelDefinition.modelValidations[modelProperty] && model.modelDefinition.modelValidations[modelProperty].type === 'COLLECTION' && models.hasOwnProperty(model.modelDefinition.modelValidations[modelProperty].referenceType);
    };
}

function isAnUpdate(modelToCheck) {
    return Boolean(modelToCheck.id);
}

var translatableProperties = new WeakMap();

/**
 * Definition of a Model. Basically this object contains the meta data related to the Model. Like `name`, `apiEndPoint`, `modelValidation`, etc.
 * It also has methods to create and load Models that are based on this definition. The Data element `ModelDefinition` would be used to create Data Element `Model`s
 *
 * Note: ModelDefinition has a property `api` that is used for the communication with the dhis2 api. The value of this
 * property is an instance of `Api`.
 *
 * @memberof module:model
 */

var ModelDefinition = function () {
    function ModelDefinition() {
        var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var properties = arguments[1];
        var validations = arguments[2];
        var attributes = arguments[3];
        var authorities = arguments[4];

        _classCallCheck(this, ModelDefinition);

        (0, _check.checkType)(schema.singular, 'string');
        (0, _check.checkType)(schema.plural, 'string', 'Plural');

        (0, _utils.addLockedProperty)(this, 'name', schema.singular);
        (0, _utils.addLockedProperty)(this, 'displayName', schema.displayName);
        (0, _utils.addLockedProperty)(this, 'plural', schema.plural);
        (0, _utils.addLockedProperty)(this, 'isShareable', schema.shareable || false);
        (0, _utils.addLockedProperty)(this, 'isMetaData', schema.metadata || false);
        (0, _utils.addLockedProperty)(this, 'apiEndpoint', schema.apiEndpoint);
        (0, _utils.addLockedProperty)(this, 'javaClass', schema.klass);
        (0, _utils.addLockedProperty)(this, 'identifiableObject', schema && schema.identifiableObject);
        (0, _utils.addLockedProperty)(this, 'modelProperties', properties);
        (0, _utils.addLockedProperty)(this, 'modelValidations', validations);
        (0, _utils.addLockedProperty)(this, 'attributeProperties', attributes);
        (0, _utils.addLockedProperty)(this, 'authorities', authorities);
        (0, _utils.addLockedProperty)(this, 'translatable', schema.translatable || false);

        this.filters = _Filters2.default.getFilters(this);

        translatableProperties.set(this, (schema.properties || []).filter(function (prop) {
            return prop.translationKey;
        }).map(function (_ref) {
            var name = _ref.name,
                translationKey = _ref.translationKey;
            return { name: name, translationKey: translationKey };
        }));

        // TODO: The function getOwnedPropertyJSON should probably not be exposed, perhaps we could have a getJSONForModel(ownedPropertiesOnly=true) method.
        this.getOwnedPropertyJSON = _json.getOwnedPropertyJSON.bind(this);
    }

    _createClass(ModelDefinition, [{
        key: 'filter',
        value: function filter() {
            return this.clone().filters;
        }

        /**
         * Creates a fresh Model instance based on the `ModelDefinition`. If data is passed into the method that
         * data will be loaded into the matching properties of the model.
         *
         * @param {Object} [data] Data values that should be loaded into the model.
         *
         * @returns {Model} Returns the newly created model instance.
         *
         * @example
         * dataElement.create({name: 'ANC', id: 'd2sf33s3ssf'});
         */

    }, {
        key: 'create',
        value: function create(data) {
            var model = _Model2.default.create(this);
            var models = _ModelDefinitions2.default.getModelDefinitions();
            var dataValues = data ? Object.assign({}, data) : (0, _config.getDefaultValuesForModelType)(model.modelDefinition.name);

            Object.keys(model).filter(shouldBeModelCollectionProperty(model, models)).forEach(function (modelProperty) {
                var referenceType = model.modelDefinition.modelValidations[modelProperty].referenceType;
                var values = [];

                if (Array.isArray(dataValues[modelProperty])) {
                    values = dataValues[modelProperty].map(function (value) {
                        return models[referenceType].create(value);
                    });
                } else if (dataValues[modelProperty] === true || dataValues[modelProperty] === undefined) {
                    values = dataValues[modelProperty];
                }

                dataValues[modelProperty] = _ModelCollectionProperty2.default.create(model, models[referenceType], modelProperty, values);
                model.dataValues[modelProperty] = dataValues[modelProperty];
            });

            Object.keys(model).filter(function (modelProperty) {
                return !shouldBeModelCollectionProperty(model, models)(modelProperty);
            }).forEach(function (modelProperty) {
                model.dataValues[modelProperty] = dataValues[modelProperty];
            });

            return model;
        }
    }, {
        key: 'clone',
        value: function clone() {
            var ModelDefinitionPrototype = Object.getPrototypeOf(this);
            var priorFilters = this.filters.getFilterList();
            var clonedDefinition = (0, _utils.copyOwnProperties)(Object.create(ModelDefinitionPrototype), this);

            clonedDefinition.filters = _Filters2.default.getFilters(clonedDefinition, priorFilters);

            return clonedDefinition;
        }

        /**
         * Get a `Model` instance from the api loaded with data that relates to `identifier`.
         * This will do an API call and return a Promise that resolves with a `Model` or rejects with the api error message.
         *
         * @param {String} identifier
         * @param {Object} [queryParams={fields: ':all'}] Query parameters that should be passed to the GET query.
         * @returns {Promise} Resolves with a `Model` instance or an error message.
         *
         * @example
         * //Do a get request for the dataElement with given id (d2sf33s3ssf) and print it's name
         * //when that request is complete and the model is loaded.
         * dataElement.get('d2sf33s3ssf')
         *   .then(model => console.log(model.name));
         */

    }, {
        key: 'get',
        value: function get(identifier) {
            var _this = this;

            var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { fields: ':all,attributeValues[:all,attribute[id,name,displayName]]' };

            (0, _check.checkDefined)(identifier, 'Identifier');

            if (Array.isArray(identifier)) {
                return this.list({ filter: ['id:in:[' + identifier.join(',') + ']'] });
            }

            // TODO: should throw error if API has not been defined
            return this.api.get([this.apiEndpoint, identifier].join('/'), queryParams).then(function (data) {
                return _this.create(data);
            }).catch(function (response) {
                if (response.message) {
                    return Promise.reject(response.message);
                }

                return Promise.reject(response);
            });
        }

        /**
         * Loads a list of models.
         *
         * @param {Object} [listParams={fields: ':all'}] Query parameters that should be passed to the GET query.
         * @returns {Promise} ModelCollection collection of models objects of the `ModelDefinition` type.
         *
         * @example
         * // Loads a list of models and prints their name.
         * dataElement.list()
         *   .then(modelCollection => {
         *     modelCollection.forEach(model => console.log(model.name));
         *   });
         */

    }, {
        key: 'list',
        value: function list() {
            var _this2 = this;

            var listParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var apiEndpoint = listParams.apiEndpoint,
                extraParams = _objectWithoutProperties(listParams, ['apiEndpoint']);

            var params = Object.assign({ fields: ':all' }, extraParams);
            var definedFilters = this.filters.getQueryFilterValues();

            if (!(0, _check.isDefined)(params.filter)) {
                delete params.filter;
                if (definedFilters.length) {
                    params.filter = definedFilters;
                }
            }

            // If listParams.apiEndpoint exists, send the request there in stead of this.apiEndpoint
            return this.api.get(apiEndpoint || this.apiEndpoint, params).then(function (responseData) {
                return _ModelCollection2.default.create(_this2, responseData[_this2.plural].map(function (data) {
                    return _this2.create(data);
                }), Object.assign(responseData.pager || {}, { query: params }));
            });
        }

        /**
         * This method is used by the `Model` instances to save the model when calling `model.save()`.
         *
         * @param {Model} model The model that should be saved to the server.
         * @returns {Promise} A promise which resolves when the save was successful
         * or rejects when it failed. The promise will resolve with the data that is
         * returned from the server.
         *
         * @note {warning} This should generally not be called directly.
         */
        // TODO: check the return status of the save to see if it was actually successful and not ignored

    }, {
        key: 'save',
        value: function save(model) {
            if (isAnUpdate(model)) {
                var jsonPayload = _json.getOwnedPropertyJSON.bind(this)(model);
                var updateUrl = (0, _utils.updateAPIUrlWithBaseUrlVersionNumber)(model.dataValues.href, this.api.baseUrl);

                // Save the existing model
                return this.api.update(updateUrl, jsonPayload, true);
            }

            return this.saveNew(model);
        }
    }, {
        key: 'saveNew',
        value: function saveNew(model) {
            var jsonPayload = _json.getOwnedPropertyJSON.bind(this)(model);

            // Its a new object
            return this.api.post(this.apiEndpoint, jsonPayload);
        }

        /**
         * This method returns a list of property names that that are defined
         * as "owner" properties on this schema. This means these properties are used
         * when saving the model to the server.
         *
         * @returns {String[]} Returns an array of property names.
         *
         * @example
         * dataElement.getOwnedPropertyNames()
         */

    }, {
        key: 'getOwnedPropertyNames',
        value: function getOwnedPropertyNames() {
            var _this3 = this;

            return Object.keys(this.modelValidations).filter(function (propertyName) {
                return _this3.modelValidations[propertyName].owner;
            });
        }

        /**
         * This method is used by the `Model` instances to delete the model when calling `model.delete()`.
         *
         * @returns {Promise} Returns a promise to the deletion operation
         *
         * @note {warning} This should generally not be called directly.
         */

    }, {
        key: 'delete',
        value: function _delete(model) {
            if (model.dataValues.href) {
                return this.api.delete(model.dataValues.href);
            }
            return this.api.delete([model.modelDefinition.apiEndpoint, model.dataValues.id].join('/'));
        }

        /**
         * Check for if the Model supports translations
         *
         * @returns {Boolean} True when the schema can be translated, false otherwise
         */

    }, {
        key: 'isTranslatable',
        value: function isTranslatable() {
            return this.translatable;
        }

        /**
         * These properties can be translated using the DHIS2 _database_ translations.
         *
         * @returns {String[]} Returns a list of property names on the object that are translatable.
         */

    }, {
        key: 'getTranslatableProperties',
        value: function getTranslatableProperties() {
            return translatableProperties.get(this).map((0, _utils.pick)('name'));
        }

        /**
         * This method is similar to getTranslatableProperties() but in addition to the property names also returns the
         * `translationKey` that is used to save the translations for the property names.
         *
         * @returns {Object[]} Returns an array with objects that have `name` and `translationKey` properties.
         */

    }, {
        key: 'getTranslatablePropertiesWithKeys',
        value: function getTranslatablePropertiesWithKeys() {
            return translatableProperties.get(this);
        }

        /**
         * @static
         *
         * This method creates a new `ModelDefinition` based on a JSON structure called
         * a schema. A schema represents the structure of a domain model as it is
         * required by DHIS. Since these schemas can not be altered on the server from
         * the modelDefinition is frozen to prevent accidental changes to the definition.
         *
         * @param {Object} schema A schema definition received from the web api (/api/schemas)
         * @param {Object[]} attributes A list of attribute objects that describe custom attributes (/api/attributes)
         *
         * @returns {ModelDefinition} Frozen model definition object.
         *
         * @example
         * ModelDefinition.createFromSchema(schemaDefinition, attributes);
         *
         * @note {info} An example of a schema definition can be found on
         * https://apps.dhis2.org/demo/api/schemas/dataElement
         */

    }], [{
        key: 'createFromSchema',
        value: function createFromSchema(schema) {
            var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            var ModelDefinitionClass = void 0;
            (0, _check.checkType)(schema, Object, 'Schema');

            if (typeof ModelDefinition.specialClasses[schema.singular] === 'function') {
                ModelDefinitionClass = ModelDefinition.specialClasses[schema.singular];
            } else {
                ModelDefinitionClass = ModelDefinition;
            }

            return Object.freeze(new ModelDefinitionClass(schema, Object.freeze(createPropertiesObject(schema.properties)), Object.freeze(createValidations(schema.properties)), attributes.reduce(function (current, attributeDefinition) {
                current[attributeDefinition.name] = attributeDefinition; // eslint-disable-line no-param-reassign
                return current;
            }, {}), schema.authorities));
        }
    }]);

    return ModelDefinition;
}();

var UserModelDefinition = function (_ModelDefinition) {
    _inherits(UserModelDefinition, _ModelDefinition);

    function UserModelDefinition() {
        _classCallCheck(this, UserModelDefinition);

        return _possibleConstructorReturn(this, (UserModelDefinition.__proto__ || Object.getPrototypeOf(UserModelDefinition)).apply(this, arguments));
    }

    _createClass(UserModelDefinition, [{
        key: 'get',

        // TODO: userCredentials should always be included, no matter what the query params, that is currently not the case
        value: function get(identifier) {
            var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { fields: ':all,userCredentials[:owner]' };

            return _get(UserModelDefinition.prototype.__proto__ || Object.getPrototypeOf(UserModelDefinition.prototype), 'get', this).call(this, identifier, queryParams);
        }
    }]);

    return UserModelDefinition;
}(ModelDefinition);

var DataSetModelDefinition = function (_ModelDefinition2) {
    _inherits(DataSetModelDefinition, _ModelDefinition2);

    function DataSetModelDefinition() {
        _classCallCheck(this, DataSetModelDefinition);

        return _possibleConstructorReturn(this, (DataSetModelDefinition.__proto__ || Object.getPrototypeOf(DataSetModelDefinition)).apply(this, arguments));
    }

    _createClass(DataSetModelDefinition, [{
        key: 'create',
        value: function create() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var hasData = Boolean(Object.keys(data).length);

            // Filter out the compulsoryDataElementOperands structure from the retrieved data
            // This structure does not follow the convention of a typical reference. We can not create a proper
            // ModelCollection for this collection.
            var dataClone = Object.keys(data).filter(function (key) {
                return key !== 'compulsoryDataElementOperands';
            }).reduce(function (obj, key) {
                obj[key] = data[key]; // eslint-disable-line no-param-reassign
                return obj;
            }, {});

            // Create the model using the usual way of creating a model
            // Only pass data when there is data in the object passed to the constructor. This will guarantee
            // that the empty ModelCollections are created properly.
            var model = _get(DataSetModelDefinition.prototype.__proto__ || Object.getPrototypeOf(DataSetModelDefinition.prototype), 'create', this).call(this, hasData ? dataClone : undefined);

            // Set the compulsoryDataElementOperands onto the dataValues so it will be included during the save operations
            model.dataValues.compulsoryDataElementOperands = data.compulsoryDataElementOperands;

            return model;
        }
    }]);

    return DataSetModelDefinition;
}(ModelDefinition);

var OrganisationUnitModelDefinition = function (_ModelDefinition3) {
    _inherits(OrganisationUnitModelDefinition, _ModelDefinition3);

    function OrganisationUnitModelDefinition() {
        _classCallCheck(this, OrganisationUnitModelDefinition);

        return _possibleConstructorReturn(this, (OrganisationUnitModelDefinition.__proto__ || Object.getPrototypeOf(OrganisationUnitModelDefinition)).apply(this, arguments));
    }

    _createClass(OrganisationUnitModelDefinition, [{
        key: 'list',

        // If a 'root' is specified when listing organisation units the results will be limited to the root and its
        // descendants. This is special behavior for the organisation unit API endpoint, which is documented here:
        // https://dhis2.github.io/dhis2-docs/master/en/developer/html/webapi_organisation_units.html
        value: function list() {
            var extraParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var root = extraParams.root,
                params = _objectWithoutProperties(extraParams, ['root']);

            if (extraParams.hasOwnProperty('root') && root) {
                params.apiEndpoint = this.apiEndpoint + '/' + root;
            }

            return _get(OrganisationUnitModelDefinition.prototype.__proto__ || Object.getPrototypeOf(OrganisationUnitModelDefinition.prototype), 'list', this).call(this, params);
        }
    }]);

    return OrganisationUnitModelDefinition;
}(ModelDefinition);

ModelDefinition.specialClasses = {
    user: UserModelDefinition,
    dataSet: DataSetModelDefinition,
    organisationUnit: OrganisationUnitModelDefinition
};

exports.default = ModelDefinition;
//# sourceMappingURL=ModelDefinition.js.map

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = __webpack_require__(15);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Contains all the `ModelDefinition`s that are available. The definitions are properties on the object.
 * This would be used as a main entry point to do any interaction.
 *
 * After calling the initialise function `d2({baseUrl: 'dhis/api'})` this object is the `models` property
 * that allows you to access
 *
 * @example
 * models.dataElement.getList();
 *
 * @memberof module:model
 */
var ModelDefinitions = function () {
    function ModelDefinitions() {
        _classCallCheck(this, ModelDefinitions);
    }

    _createClass(ModelDefinitions, [{
        key: 'add',

        // TODO: Elaborate this documentation
        /**
         * This will allow you to add your own custom ModelDefinitions.
         *
         * The Definition object should have the following properties
         * `modelName, modelNamePlural, modelOptions, properties, validations`
         *
         * @param {ModelDefinition} modelDefinition Add a model definition to the definitions collection
         *
         * @example
         * models.add({name: 'MyDefinition', plural: 'MyDefinitions', endPointname: '/myDefinition'});
         */
        value: function add(modelDefinition) {
            try {
                (0, _check.checkType)(modelDefinition.name, 'string');
            } catch (e) {
                throw new Error('Name should be set on the passed ModelDefinition to add one');
            }

            if (this[modelDefinition.name]) {
                throw new Error(['Model', modelDefinition.name, 'already exists'].join(' '));
            }
            this[modelDefinition.name] = modelDefinition;

            if ((0, _check.isType)(modelDefinition.plural, 'string')) {
                this[modelDefinition.plural] = modelDefinition;
            }
        }

        /**
         * Map through the modelDefinitions like you would with a simple `Array.map()`
         *
         * @param {Function} transformer Transformer function that will be run for each `ModelDefinition`
         * @returns {Array} Array with the `ModelDefinition` objects.
         *
         * @example
         * models.mapThroughDefinitions(definition => console.log(definition.name);
         *
         * @note {info} When mapping through the definition list `transformer` is called with the just the definition
         * Unlike other map functions, no index or the full object is being passed.
         *
         * @note {warn} The resulting array contains references to the actual objects. It does not work like immutable array functions.
         *
         */

    }, {
        key: 'mapThroughDefinitions',
        value: function mapThroughDefinitions(transformer) {
            var _this = this;

            (0, _check.checkType)(transformer, 'function', 'transformer');

            return Object.keys(this).filter(function (modelDefinition) {
                return _this.hasOwnProperty(modelDefinition) && !(_this[modelDefinition].plural === modelDefinition);
            }).map(function (modelDefinition) {
                return transformer(_this[modelDefinition]);
            });
        }
    }]);

    return ModelDefinitions;
}();

// Model definitions singleton!


function getModelDefinitions() {
    if (getModelDefinitions.modelDefinitions) {
        return getModelDefinitions.modelDefinitions;
    }
    return getModelDefinitions.modelDefinitions = new ModelDefinitions();
}

ModelDefinitions.getModelDefinitions = getModelDefinitions;

exports.default = ModelDefinitions;
//# sourceMappingURL=ModelDefinitions.js.map

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fieldsForSchemas = exports.defaultValues = undefined;
exports.getDefaultValuesForModelType = getDefaultValuesForModelType;

var _organisationUnitGroupSet = __webpack_require__(288);

var _organisationUnitGroupSet2 = _interopRequireDefault(_organisationUnitGroupSet);

var _category = __webpack_require__(289);

var _category2 = _interopRequireDefault(_category);

var _categoryOptionGroupSet = __webpack_require__(290);

var _categoryOptionGroupSet2 = _interopRequireDefault(_categoryOptionGroupSet);

var _dataElement = __webpack_require__(291);

var _dataElement2 = _interopRequireDefault(_dataElement);

var _dataElementGroupSet = __webpack_require__(292);

var _dataElementGroupSet2 = _interopRequireDefault(_dataElementGroupSet);

var _dataSet = __webpack_require__(293);

var _dataSet2 = _interopRequireDefault(_dataSet);

var _externalMapLayer = __webpack_require__(294);

var _externalMapLayer2 = _interopRequireDefault(_externalMapLayer);

var _validationNotificationTemplate = __webpack_require__(295);

var _validationNotificationTemplate2 = _interopRequireDefault(_validationNotificationTemplate);

var _validationRule = __webpack_require__(296);

var _validationRule2 = _interopRequireDefault(_validationRule);

var _program = __webpack_require__(297);

var _program2 = _interopRequireDefault(_program);

var _programNotificationTemplate = __webpack_require__(298);

var _programNotificationTemplate2 = _interopRequireDefault(_programNotificationTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultValues = exports.defaultValues = new Map([['organisationUnitGroupSet', _organisationUnitGroupSet2.default], ['category', _category2.default], ['categoryOptionGroupSet', _categoryOptionGroupSet2.default], ['dataElement', _dataElement2.default], ['dataElementGroupSet', _dataElementGroupSet2.default], ['dataSet', _dataSet2.default], ['externalMapLayer', _externalMapLayer2.default], ['validationNotificationTemplate', _validationNotificationTemplate2.default], ['validationRule', _validationRule2.default], ['program', _program2.default], ['programNotificationTemplate', _programNotificationTemplate2.default]]);

function getDefaultValuesForModelType(modelDefinitionName) {
    if (defaultValues.has(modelDefinitionName)) {
        return defaultValues.get(modelDefinitionName);
    }
    return {};
}

var schemaFields = ['apiEndpoint', 'name', 'displayName', 'authorities', 'singular', 'plural', 'shareable', 'metadata', 'klass', 'identifiableObject', 'translatable'];

var schemaPropertyFields = ['href', 'writable', 'collection', 'collectionName', 'name', 'propertyType', 'persisted', 'required', 'min', 'max', 'ordered', 'unique', 'constants', 'owner', 'itemPropertyType', 'translationKey', 'embeddedObject'];

var fieldsForSchemas = exports.fieldsForSchemas = schemaFields.concat('properties[' + schemaPropertyFields.join(',') + ']').join(',');
//# sourceMappingURL=index.js.map

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * List of modelDefinition names that should not allow create. Even when their schema authorities allows the user
 * to create them, the user should not be allowed to create these objects for some business logic reason.
 *
 * @private
 * @type {Set<string>}
 * @readonly
 */
var noCreateAllowedFor = exports.noCreateAllowedFor = new Set([
// Creating categoryOptionCombos is not allowed because they are generated by the backend.
'categoryOptionCombo']);

/**
 * Default options to be used when running the `d2.init` function.
 */
exports.default = {
    baseUrl: '/api',
    i18n: {
        sources: new Set(),
        strings: new Set()
    }
};
//# sourceMappingURL=defaultConfig.js.map

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @module datastore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _BaseStoreNamespace = __webpack_require__(115);

var _BaseStoreNamespace2 = _interopRequireDefault(_BaseStoreNamespace);

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

var _check = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @private
 * @description
 * Represents a key-value store that can be interacted with. This can be used to get instances of Namespaces, which
 * can be used to interact with the relating namespace API.
 *
 * @memberof module:datastore
 * @abstract
 */
var BaseStore = function () {
    function BaseStore() {
        var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Api2.default.getApi();
        var endPoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dataStore';
        var NamespaceClass = arguments[2];

        _classCallCheck(this, BaseStore);

        if (this.constructor === BaseStore) {
            throw new Error("Can't instantiate abstract class!");
        }
        if (!(NamespaceClass.prototype instanceof _BaseStoreNamespace2.default)) {
            throw new Error('NamespaceClass must be subclass of ' + (typeof _BaseStoreNamespace2.default === 'undefined' ? 'undefined' : _typeof(_BaseStoreNamespace2.default)));
        }
        this.NamespaceClass = NamespaceClass;
        this.endPoint = endPoint;
        this.api = api;
    }

    /**
     * @description
     * Tries to get the given namespace from the server, and returns an instance of 'RetClass' that
     * may be used to interact with this namespace. See {@link DataStoreNamespace}.
     *
     * @param {string} namespace To get.
     * @param {boolean} [autoLoad=true] If true, autoloads the keys of the namespace from the server.
     * before the namespace is created. If false, an instance of he namespace is returned without any keys.
     * @returns {Promise<BaseStoreNamespace>} An instance of a current store-Namespace-instance representing the namespace that can be interacted with.
     * Or an error if namespace does not exist.
     */


    _createClass(BaseStore, [{
        key: 'get',
        value: function get(namespace) {
            var _this = this;

            var autoLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (!autoLoad) {
                return new Promise(function (resolve) {
                    resolve(new _this.NamespaceClass(namespace));
                });
            }
            return this.api.get([this.endPoint, namespace].join('/')).then(function (response) {
                if (response && (0, _check.isArray)(response)) {
                    if (response.length < 1) {
                        // fix for api bug returning empty array instead of 404
                        return Promise.reject(new Error('The requested namespace has no keys or does not exist.'));
                    }
                    return new _this.NamespaceClass(namespace, response);
                }
                return Promise.reject(new Error('The requested namespace has no keys or does not exist.'));
            });
        }

        /**
         * Retrieves a list of all namespaces on the server.
         * @returns {Promise} An array of namespaces.
         */

    }, {
        key: 'getAll',
        value: function getAll() {
            return this.api.get(this.endPoint).then(function (response) {
                if (response && (0, _check.isArray)(response)) {
                    return response;
                }
                throw new Error('No namespaces exist.');
            });
        }

        /**
         * Convenience method to check if a namespace exists on the server.
         * @param {string} namespace - Namespace to check.
         * @returns {Promise<boolean>} True if namespace exists, false otherwise.
         */

    }, {
        key: 'has',
        value: function has(namespace) {
            return this.api.get([this.endPoint, namespace].join('/')).then(function (response) {
                if (response && (0, _check.isArray)(response)) {
                    if (response.length < 1) {
                        // fix for api bug returning empty array instead of 404
                        return Promise.reject(response);
                    }
                    return true;
                }
                return Promise.reject(new Error('Response is not an array!'));
            }).catch(function (e) {
                if (e.httpStatusCode === 404 || (0, _check.isArray)(e) && e.length < 1) {
                    return Promise.resolve(false);
                }
                throw e;
            });
        }

        /**
         * Deletes a namespace
         *
         * @param {string} namespace The namespace to delete.
         * @returns {Promise} the response body from the {@link module:api.Api#get API}.
         */

    }, {
        key: 'delete',
        value: function _delete(namespace) {
            return this.api.delete([this.endPoint, namespace].join('/'));
        }

        /**
         * Creates a namespace. Ensures that the namespace does not exists on the server.
         * Note that for the namespace to be saved on the server, you need to call {@link module:dataStore.BaseStoreNamespace.set set}.
         *
         * @param {string} namespace The namespace to create.
         * @returns {Promise<BaseStoreNamespace>} An instance of the current store-Namespace-instance representing the namespace that can be interacted with, or
         * an error if namespace exists.
         */

    }, {
        key: 'create',
        value: function create(namespace) {
            var _this2 = this;

            return this.has(namespace).then(function (exists) {
                return exists ? Promise.reject(new Error('Namespace already exists.')) : new _this2.NamespaceClass(namespace);
            });
        }
    }]);

    return BaseStore;
}();

exports.default = BaseStore;
//# sourceMappingURL=BaseStore.js.map

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @private
 * @description
 * Base class for communicating with the analytics API endpoint.
 * Its subclasses can be used to get analytics data.
 *
 * @param {Instance} [api=<Api>] Api instance to use for the requests
 *
 * @requires module:api/Api
 *
 * @memberof module:analytics
 * @abstract
 */
var AnalyticsBase = function () {
    function AnalyticsBase() {
        var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Api2.default.getApi();

        _classCallCheck(this, AnalyticsBase);

        this.api = api;
    }

    /**
     * Loads the analytics data and returns them as an object from the promise.
     *
     * @param {!AnalyticsRequest} req Analytics request object with the request details
     *
     * @returns {Promise} Promise that resolves with the analytics data from the api.
     *
     * @example
     * const req = new d2.analytics.request()
     *  .addDataDimension(['Uvn6LCg7dVU','OdiHJayrsKo'])
     *  .addPeriodDimension('LAST_4_QUARTERS')
     *  .addOrgUnitDimension(['lc3eMKXaEfw','PMa2VCrupOd']);
     *
     * d2.analytics.aggregate
     *  .get(req)
     *  .then(analyticsData => console.log('Analytics data', analyticsData))
     */


    _createClass(AnalyticsBase, [{
        key: 'get',
        value: function get(req) {
            return this.api.get(req.buildUrl(), req.buildQuery()).then(function (data) {
                return Promise.resolve(data);
            });
        }
    }]);

    return AnalyticsBase;
}();

exports.default = AnalyticsBase;
//# sourceMappingURL=AnalyticsBase.js.map

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  processors: {},

  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });

    return value;
  }
});

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(57),
    metaMap = __webpack_require__(179);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(180);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41),
    root = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 182 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(184),
    composeArgsRight = __webpack_require__(185),
    countHolders = __webpack_require__(337),
    createCtor = __webpack_require__(77),
    createRecurry = __webpack_require__(186),
    getHolder = __webpack_require__(196),
    reorder = __webpack_require__(351),
    replaceHolders = __webpack_require__(121),
    root = __webpack_require__(23);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 184 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 185 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(338),
    setData = __webpack_require__(190),
    setWrapToString = __webpack_require__(192);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(179),
    noop = __webpack_require__(188);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(78),
    baseLodash = __webpack_require__(119);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(178),
    shortOut = __webpack_require__(191);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 191 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(343),
    insertWrapDetails = __webpack_require__(344),
    setToString = __webpack_require__(120),
    updateWrapDetails = __webpack_require__(347);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(348);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 195 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 196 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(72),
    keys = __webpack_require__(58);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(354),
    isArguments = __webpack_require__(81),
    isArray = __webpack_require__(21),
    isBuffer = __webpack_require__(82),
    isIndex = __webpack_require__(63),
    isTypedArray = __webpack_require__(123);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 199 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(198),
    baseKeysIn = __webpack_require__(383),
    isArrayLike = __webpack_require__(42);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 201 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(132),
    getPrototype = __webpack_require__(133),
    getSymbols = __webpack_require__(131),
    stubArray = __webpack_require__(201);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(204),
    getSymbols = __webpack_require__(131),
    keys = __webpack_require__(58);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(132),
    isArray = __webpack_require__(21);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41),
    root = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(23);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(76);

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(407),
    isObjectLike = __webpack_require__(25);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(210),
    arraySome = __webpack_require__(410),
    cacheHas = __webpack_require__(211);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(130),
    setCacheAdd = __webpack_require__(408),
    setCacheHas = __webpack_require__(409);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 211 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 213 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(417);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(419);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(420),
    hasPath = __webpack_require__(421);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(117);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(441),
    keys = __webpack_require__(58);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 219 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

module.exports = negate;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var periodTypes = exports.periodTypes = [{ id: 'relativePeriods', name: 'Relative' }, { id: 'Daily', name: 'Daily' }, { id: 'Weekly', name: 'Weekly' }, { id: 'Monthly', name: 'Monthly' }, { id: 'BiMonthly', name: 'Bi-monthly' }, { id: 'Quarterly', name: 'Quarterly' }, { id: 'SixMonthly', name: 'Six-monthly' }, { id: 'SixMonthlyApril', name: 'Six-monthly April' }, { id: 'Yearly', name: 'Yearly' }, { id: 'FinancialOctober', name: 'Financial year (Start October)' }, { id: 'FinancialJuly', name: 'Financial year (Start July)' }, { id: 'FinancialApril', name: 'Financial year (Start April)' }];

var relativePeriods = exports.relativePeriods = [{ id: 'TODAY', name: 'Today' }, { id: 'YESTERDAY', name: 'Yesterday' }, { id: 'THIS_WEEK', name: 'This week' }, { id: 'LAST_WEEK', name: 'Last week' }, { id: 'LAST_4_WEEKS', name: 'Last 4 weeks' }, { id: 'LAST_12_WEEKS', name: 'Last 12 weeks' }, { id: 'LAST_52_WEEKS', name: 'Last 52 weeks' }, { id: 'THIS_MONTH', name: 'This month' }, { id: 'LAST_MONTH', name: 'Last month' }, { id: 'LAST_3_MONTHS', name: 'Last 3 months' }, { id: 'LAST_6_MONTHS', name: 'Last 6 months' }, { id: 'LAST_12_MONTHS', name: 'Last 12 months' }, { id: 'THIS_BIMONTH', name: 'This bi-month' }, { id: 'LAST_BIMONTH', name: 'Last bi-month' }, { id: 'LAST_6_BIMONTHS', name: 'Last 6 bi-months' }, { id: 'THIS_QUARTER', name: 'This quarter' }, { id: 'LAST_QUARTER', name: 'Last quarter' }, { id: 'LAST_4_QUARTERS', name: 'Last 4 quarters' }, { id: 'THIS_SIX_MONTH', name: 'This six-month' }, { id: 'LAST_SIX_MONTH', name: 'Last six-month' }, { id: 'LAST_2_SIX_MONTHS', name: 'Last 2 six-months' }, { id: 'THIS_YEAR', name: 'This year' }, { id: 'LAST_YEAR', name: 'Last year' }, { id: 'LAST_5_YEARS', name: 'Last 5 years' }, { id: 'THIS_FINANCIAL_YEAR', name: 'This financial year' }, { id: 'LAST_FINANCIAL_YEAR', name: 'Last financial year' }, { id: 'LAST_5_FINANCIAL_YEARS', name: 'Last 5 financial years' }];

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('isObject', __webpack_require__(26), __webpack_require__(39));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(453);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newYear(d.y)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["g" /* utcMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["g" /* utcMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["f" /* utcDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = newDate(newYear(d.y)), day = week.getDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["b" /* timeMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["b" /* timeMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["c" /* timeSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeYear */])(d), d), p, 2);
}

function formatWeekNumberISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["d" /* timeThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["d" /* timeThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["d" /* timeThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeYear */])(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["b" /* timeMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeYear */])(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["f" /* utcDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["h" /* utcSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* utcYear */])(d), d), p, 2);
}

function formatUTCWeekNumberISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* utcThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* utcThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* utcThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* utcYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* utcYear */])(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["g" /* utcMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* utcYear */])(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(140);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__["d" /* utcFormat */])(isoSpecifier);

/* harmony default export */ __webpack_exports__["a"] = (formatIso);


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addStyleDataItem = exports.getAnalyticsRequest = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _d = __webpack_require__(19);

var _curry = __webpack_require__(225);

var _curry2 = _interopRequireDefault(_curry);

var _isString = __webpack_require__(48);

var _isString2 = _interopRequireDefault(_isString);

var _isEmpty = __webpack_require__(470);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _map = __webpack_require__(67);

var _classify = __webpack_require__(226);

var _legend = __webpack_require__(231);

var _analytics = __webpack_require__(32);

var _layers = __webpack_require__(68);

var _d3TimeFormat = __webpack_require__(139);

var _colorscale = __webpack_require__(102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// Look at: https://github.com/dhis2/maintenance-app/blob/master/src/App/appStateStore.js

var formatTime = function formatTime(date) {
    return (0, _d3TimeFormat.timeFormat)('%Y-%m-%d')(new Date(date));
};

var eventLoader = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
        var _config$classes, classes, _config$colorScale, colorScale, columns, endDate, eventClustering, eventCoordinateField, eventPointColor, eventPointRadius, filters, _config$method, method, program, programStage, rows, startDate, styleDataItem, orgUnits, period, dataItems, dataFilters, d2, spatialSupport, analyticsRequest, legend, bounds, serverCluster, data, names, response, _response, optionSetHeaders, styleByNumeric, styleByOptionSet, values, bins, colors, getLegendItem;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        // Returns a promise
                        _config$classes = config.classes, classes = _config$classes === undefined ? _colorscale.defaultClasses : _config$classes, _config$colorScale = config.colorScale, colorScale = _config$colorScale === undefined ? _colorscale.defaultColorScale : _config$colorScale, columns = config.columns, endDate = config.endDate, eventClustering = config.eventClustering, eventCoordinateField = config.eventCoordinateField, eventPointColor = config.eventPointColor, eventPointRadius = config.eventPointRadius, filters = config.filters, _config$method = config.method, method = _config$method === undefined ? 2 : _config$method, program = config.program, programStage = config.programStage, rows = config.rows, startDate = config.startDate, styleDataItem = config.styleDataItem;
                        orgUnits = (0, _analytics.getOrgUnitsFromRows)(rows);
                        period = (0, _analytics.getPeriodFromFilters)(filters);
                        dataItems = addStyleDataItem(columns, styleDataItem);
                        dataFilters = (0, _analytics.getFiltersFromColumns)(columns);
                        _context.next = 7;
                        return (0, _d.getInstance)();

                    case 7:
                        d2 = _context.sent;
                        spatialSupport = d2.system.systemInfo.databaseInfo.spatialSupport;
                        _context.next = 11;
                        return getAnalyticsRequest(program, programStage, period, startDate, endDate, orgUnits, dataItems, eventCoordinateField);

                    case 11:
                        analyticsRequest = _context.sent;
                        legend = {
                            period: period ? (0, _analytics.getPeriodNameFromId)(period.id) : formatTime(startDate) + ' - ' + formatTime(endDate),
                            filters: dataFilters && (0, _analytics.getFiltersAsText)(dataFilters)
                        };
                        bounds = void 0;
                        serverCluster = void 0;
                        data = void 0;
                        names = void 0;

                        if (!(spatialSupport && eventClustering)) {
                            _context.next = 23;
                            break;
                        }

                        _context.next = 20;
                        return d2.analytics.events.getCount(analyticsRequest);

                    case 20:
                        response = _context.sent;

                        bounds = getBounds(response.extent);
                        serverCluster = useServerCluster(response.count);

                    case 23:
                        if (serverCluster) {
                            _context.next = 36;
                            break;
                        }

                        _context.next = 26;
                        return d2.analytics.events.getQuery(analyticsRequest);

                    case 26:
                        _response = _context.sent;

                        names = (0, _analytics.getApiResponseNames)(_response);
                        optionSetHeaders = _response.headers.filter(function (header) {
                            return header.optionSet;
                        });

                        // Load option sets used for filtering/styling

                        if (!optionSetHeaders.length) {
                            _context.next = 32;
                            break;
                        }

                        _context.next = 32;
                        return Promise.all(optionSetHeaders.map(function (header) {
                            return d2.models.optionSets.get(header.optionSet, {
                                fields: 'id,options[code,displayName~rename(name)]'
                            }).then(function (model) {
                                return model.options;
                            }).then(function (options) {
                                return options.forEach(function (_ref2) {
                                    var code = _ref2.code,
                                        name = _ref2.name;
                                    return names[code] = name;
                                });
                            });
                        }));

                    case 32:

                        data = _response.rows.map(function (row) {
                            return createEventFeature(_response.headers, names, row, eventCoordinateField);
                        }).filter(function (feature) {
                            return (0, _map.isValidCoordinate)(feature.geometry.coordinates);
                        });

                        styleByNumeric = styleDataItem && styleDataItem.valueType === 'INTEGER';
                        styleByOptionSet = styleDataItem && styleDataItem.optionSet && styleDataItem.optionSet.options;


                        if (Array.isArray(data) && data.length) {
                            if (styleDataItem) {
                                // Set value property to value of styleDataItem
                                data.forEach(function (feature) {
                                    return feature.properties.value = feature.properties[styleDataItem.id];
                                });
                                legend.unit = styleDataItem.name;

                                if (styleByNumeric) {
                                    values = data.map(function (feature) {
                                        return Number(feature.properties.value);
                                    }).sort(function (a, b) {
                                        return a - b;
                                    });
                                    bins = (0, _classify.getClassBins)(values, method, classes);
                                    colors = colorScale ? colorScale.split(',') : [];

                                    legend.items = (0, _legend.getNumericLegendItems)(bins, colors, eventPointRadius || _layers.EVENT_RADIUS);

                                    getLegendItem = (0, _curry2.default)(_classify.getLegendItemForValue)(legend.items);


                                    data.forEach(function (feature) {
                                        return feature.properties.color = getLegendItem(45).color;
                                    });
                                } else if (styleByOptionSet) {
                                    data.forEach(function (feature) {
                                        feature.properties.color = styleDataItem.optionSet.options[feature.properties.value];
                                    });
                                    legend.items = (0, _legend.getCategoryLegendItems)(styleDataItem.optionSet.options, eventPointRadius || _layers.EVENT_RADIUS);
                                }

                                legend.items.push({
                                    name: _i18next2.default.t('Not set'),
                                    color: eventPointColor || _layers.EVENT_COLOR,
                                    radius: eventPointRadius || _layers.EVENT_RADIUS
                                });
                            } else {
                                // Simple style
                                legend.items = [{
                                    name: _i18next2.default.t('Event'),
                                    color: eventPointColor || _layers.EVENT_COLOR,
                                    radius: eventPointRadius || _layers.EVENT_RADIUS
                                }];
                            }
                        }

                    case 36:

                        legend.filters = dataFilters && (0, _analytics.getFiltersAsText)(dataFilters, names);

                        return _context.abrupt('return', _extends({}, config, {
                            name: programStage.name,
                            legend: legend,
                            data: data,
                            bounds: bounds,
                            serverCluster: serverCluster,
                            isLoaded: true,
                            isExpanded: true,
                            isVisible: true
                        }));

                    case 38:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function eventLoader(_x) {
        return _ref.apply(this, arguments);
    };
}();

var getBounds = function getBounds(bbox) {
    if (!bbox) {
        return null;
    }
    var extent = bbox.match(/([-\d\.]+)/g);
    return [[extent[1], extent[0]], [extent[3], extent[2]]];
};

// Server clustering if more than 2000 events
var useServerCluster = function useServerCluster(count) {
    return count > 2000;
}; // TODO: Use constant

// Also used to query for server cluster in map/EventLayer.js
var getAnalyticsRequest = exports.getAnalyticsRequest = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(program, programStage, period, startDate, endDate, orgUnits, dataItems, eventCoordinateField) {
        var d2, analyticsRequest;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return (0, _d.getInstance)();

                    case 2:
                        d2 = _context2.sent;
                        analyticsRequest = new d2.analytics.request().withProgram(program.id).withStage(programStage.id).withCoordinatesOnly(true);


                        analyticsRequest = period ? analyticsRequest.addPeriodFilter(period.id) : analyticsRequest.withStartDate(startDate).withEndDate(endDate);

                        analyticsRequest = analyticsRequest.addOrgUnitDimension(orgUnits.map(function (ou) {
                            return ou.id;
                        }));

                        (0, _analytics.removeEmptyItems)(dataItems).forEach(function (item) {
                            analyticsRequest = analyticsRequest.addDimension(item.dimension, item.filter);
                        });

                        if (eventCoordinateField) {
                            // If coordinate field other than event coordinate
                            analyticsRequest = analyticsRequest.addDimension(eventCoordinateField) // Used by analytics/events/query/
                            .withCoordinateField(eventCoordinateField); // Used by analytics/events/count and analytics/events/cluster
                        }

                        return _context2.abrupt('return', analyticsRequest);

                    case 9:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    return function getAnalyticsRequest(_x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9) {
        return _ref3.apply(this, arguments);
    };
}();

// Include column for data element used for styling
var addStyleDataItem = exports.addStyleDataItem = function addStyleDataItem(dataItems, styleDataItem) {
    return styleDataItem ? [].concat(_toConsumableArray(dataItems), [styleDataItem && {
        dimension: styleDataItem.id,
        name: styleDataItem.name
    }]) : [].concat(_toConsumableArray(dataItems));
};

var createEventFeature = function createEventFeature(headers, names, event, eventCoordinateField) {
    var properties = event.reduce(function (props, value, i) {
        return _extends({}, props, _defineProperty({}, headers[i].name, names[value] || value));
    }, {});

    var coordinates = void 0;

    if (eventCoordinateField) {
        // If coordinate field other than event location
        var eventCoord = properties[eventCoordinateField];

        if (Array.isArray(eventCoord)) {
            coordinates = eventCoord;
        } else if ((0, _isString2.default)(eventCoord) && !(0, _isEmpty2.default)(eventCoord)) {
            coordinates = JSON.parse(eventCoord);
        } else {
            coordinates = [];
        }
    } else {
        // Use event location
        coordinates = [properties.longitude, properties.latitude]; // Event location
    }

    return {
        type: 'Feature',
        id: properties.psi,
        properties: properties,
        geometry: {
            type: 'Point',
            coordinates: coordinates.map(parseFloat)
        }
    };
};

exports.default = eventLoader;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('curry', __webpack_require__(207));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getQuantiles = exports.getEqualIntervals = exports.getClassBins = exports.getLegendItems = exports.getLegendItemForValue = exports.classify = undefined;

var _d3Format = __webpack_require__(474);

var _curryRight = __webpack_require__(484);

var _curryRight2 = _interopRequireDefault(_curryRight);

var _layers = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var classify = exports.classify = function classify(features, options) {
    var method = options.method,
        classes = options.classes,
        colorScale = options.colorScale;

    var values = features.map(function (feature) {
        return Number(feature.properties.value);
    }).sort(function (a, b) {
        return a - b;
    });
    var bins = getClassBins(values, method, classes);
    var getClassIndex = (0, _curryRight2.default)(getClass)(bins);

    if (bins.length) {
        features.forEach(function (feature) {
            feature.properties.color = colorScale[getClassIndex(feature.properties.value) - 1];
        });
    }
};

// Returns legend item where a value belongs
// Utils for thematic mapping
var getLegendItemForValue = exports.getLegendItemForValue = function getLegendItemForValue(legendItems, value) {
    var isLast = function isLast(index) {
        return index === legendItems.length - 1;
    };
    return legendItems.find(function (item, index) {
        return value >= item.startValue && (value < item.endValue || isLast(index) && value === item.endValue);
    });
};

var getLegendItems = exports.getLegendItems = function getLegendItems(values, method, numClasses) {
    var minValue = values[0];
    var maxValue = values[values.length - 1];
    var bins = void 0;

    if (method === _layers.CLASSIFICATION_EQUAL_INTERVALS) {
        bins = getEqualIntervals(minValue, maxValue, numClasses);
    } else if (method === _layers.CLASSIFICATION_EQUAL_COUNTS) {
        bins = getQuantiles(values, numClasses);
    }

    return bins;
};

var getClassBins = exports.getClassBins = function getClassBins(values, method, numClasses) {
    var minValue = values[0];
    var maxValue = values[values.length - 1];
    var bins = void 0;

    if (method === _layers.CLASSIFICATION_EQUAL_INTERVALS) {
        bins = getEqualIntervals(minValue, maxValue, numClasses);
    } else if (method === _layers.CLASSIFICATION_EQUAL_COUNTS) {
        bins = getQuantiles(values, numClasses);
    }

    return bins;
};

var getEqualIntervals = exports.getEqualIntervals = function getEqualIntervals(minValue, maxValue, numClasses) {
    var bins = [];
    var binSize = (maxValue - minValue) / numClasses;
    var precision = (0, _d3Format.precisionRound)(binSize, maxValue);

    var valueFormat = (0, _d3Format.format)('.' + precision + 'f');

    for (var i = 0; i < numClasses; i++) {
        var startValue = minValue + i * binSize;
        var endValue = i < numClasses - 1 ? startValue + binSize : maxValue;

        bins.push({
            startValue: Number(valueFormat(startValue)),
            endValue: Number(valueFormat(endValue))
        });
    }

    return bins;
};

var getQuantiles = exports.getQuantiles = function getQuantiles(values, numClasses) {
    var minValue = values[0];
    var maxValue = values[values.length - 1];
    var bins = [];
    var binCount = values.length / numClasses;
    var precision = (0, _d3Format.precisionRound)((maxValue - minValue) / numClasses, maxValue);
    var valueFormat = (0, _d3Format.format)('.' + precision + 'f');

    var binLastValPos = binCount === 0 ? 0 : binCount;

    if (values.length > 0) {
        bins[0] = minValue;
        for (var i = 1; i < numClasses; i++) {
            bins[i] = values[Math.round(binLastValPos)];
            binLastValPos += binCount;
        }
    }

    // bin can be undefined if few values
    return bins.filter(function (bin) {
        return bin !== undefined;
    }).map(function (value, index) {
        return {
            startValue: Number(valueFormat(value)),
            endValue: Number(valueFormat(bins[index + 1] || maxValue))
        };
    });
};

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTypes__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__identity__ = __webpack_require__(480);








var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping && locale.thousands ? Object(__WEBPACK_IMPORTED_MODULE_1__formatGroup__["a" /* default */])(locale.grouping, locale.thousands) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? Object(__WEBPACK_IMPORTED_MODULE_2__formatNumerals__["a" /* default */])(locale.numerals) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        type = specifier.type;

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_4__formatTypes__["a" /* default */][type],
        maybeSuffix = !type || /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? (type ? 6 : 12)
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__["b" /* prefixExponent */] / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatTypes__ = __webpack_require__(229);


// [[fill]align][sign][symbol][0][width][,][.precision][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

  var match,
      fill = match[1] || " ",
      align = match[2] || ">",
      sign = match[3] || "-",
      symbol = match[4] || "",
      zero = !!match[5],
      width = match[6] && +match[6],
      comma = !!match[7],
      precision = match[8] && +match[8].slice(1),
      type = match[9] || "";

  // The "n" type is an alias for ",g".
  if (type === "n") comma = true, type = "g";

  // Map invalid types to the default format.
  else if (!__WEBPACK_IMPORTED_MODULE_0__formatTypes__["a" /* default */][type]) type = "";

  // If zero fill is specified, padding goes after sign and before digits.
  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

  this.fill = fill;
  this.align = align;
  this.sign = sign;
  this.symbol = symbol;
  this.zero = zero;
  this.width = width;
  this.comma = comma;
  this.precision = precision;
  this.type = type;
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + this.type;
};


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDefault__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatRounded__ = __webpack_require__(479);




/* harmony default export */ __webpack_exports__["a"] = ({
  "": __WEBPACK_IMPORTED_MODULE_0__formatDefault__["a" /* default */],
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return Object(__WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__["a" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(141);


var prefixExponent;

/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCategoryLegendItems = exports.getNumericLegendItems = exports.getLabelsFromLegendItems = exports.getColorScaleFromLegendItems = exports.getBinsFromLegendItems = exports.formatLegendItems = exports.loadDataItemLegendSet = exports.loadLegendSet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _d = __webpack_require__(19);

var _sortBy = __webpack_require__(43);

var _sortBy2 = _interopRequireDefault(_sortBy);

var _api = __webpack_require__(59);

var _helpers = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var loadLegendSet = exports.loadLegendSet = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(legendSet) {
        var fields, d2;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        fields = _helpers.legendSetFields.join(',');
                        _context.next = 3;
                        return (0, _d.getInstance)();

                    case 3:
                        d2 = _context.sent;
                        return _context.abrupt('return', d2.models.legendSet.get(legendSet.id));

                    case 5:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function loadLegendSet(_x) {
        return _ref.apply(this, arguments);
    };
}();

var loadDataItemLegendSet = exports.loadDataItemLegendSet = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dataItem) {
        var type, d2;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        type = (dataItem.dimensionItemType || '').toLowerCase();
                        _context2.next = 3;
                        return (0, _d.getInstance)();

                    case 3:
                        d2 = _context2.sent;

                        if (!(!type || !d2.models[type])) {
                            _context2.next = 6;
                            break;
                        }

                        return _context2.abrupt('return');

                    case 6:
                        return _context2.abrupt('return', d2.models[type].get(dataItem.id, {
                            fields: 'legendSet[id,displayName~rename(name)]'
                        }).then(function (model) {
                            return model.legendSet;
                        }));

                    case 7:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    return function loadDataItemLegendSet(_x2) {
        return _ref2.apply(this, arguments);
    };
}();

var formatLegendItems = exports.formatLegendItems = function formatLegendItems(legendItems) {
    var sortedItems = (0, _sortBy2.default)('startValue', legendItems);
    return sortedItems.map(function (item) {
        return {
            color: item.color,
            name: item.name,
            range: item.startValue + ' - ' + item.endValue
        };
    });
};

var getBinsFromLegendItems = exports.getBinsFromLegendItems = function getBinsFromLegendItems(legendItems) {
    var sortedItems = (0, _sortBy2.default)('startValue', legendItems);
    var lastItem = sortedItems[sortedItems.length - 1];
    var bins = sortedItems.map(function (item) {
        return item.startValue;
    });

    bins.push(lastItem.endValue);
    return bins;
};

var getColorScaleFromLegendItems = exports.getColorScaleFromLegendItems = function getColorScaleFromLegendItems(legendItems) {
    var sortedItems = (0, _sortBy2.default)('startValue', legendItems);
    return sortedItems.map(function (item) {
        return item.color;
    });
};

var getLabelsFromLegendItems = exports.getLabelsFromLegendItems = function getLabelsFromLegendItems(legendItems) {
    var sortedItems = (0, _sortBy2.default)('startValue', legendItems);
    return sortedItems.map(function (item) {
        return item.name;
    });
};

// TODO: Add support for counts in each class?
var getNumericLegendItems = exports.getNumericLegendItems = function getNumericLegendItems(bins, colors, radius) {
    var items = [];

    for (var i = 0; i < bins.length; i++) {
        items.push(_extends({}, bins[i], {
            color: colors[i],
            radius: radius
        }));
    }

    return items;
};

// TODO: Add support for counts in each class?
var getCategoryLegendItems = exports.getCategoryLegendItems = function getCategoryLegendItems(options, radius) {
    return Object.keys(options).map(function (option) {
        return {
            name: option,
            color: options[option],
            radius: radius
        };
    });
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('isPlainObject', __webpack_require__(135), __webpack_require__(39));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('pick', __webpack_require__(489));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(98),
    baseSet = __webpack_require__(491),
    castPath = __webpack_require__(64);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(244);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26),
    isSymbol = __webpack_require__(52);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(153),
    baseOrderBy = __webpack_require__(440),
    baseRest = __webpack_require__(248),
    isIterateeCall = __webpack_require__(249);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(247),
    isArrayLike = __webpack_require__(42);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(218),
    createBaseEach = __webpack_require__(443);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(57),
    overRest = __webpack_require__(217),
    setToString = __webpack_require__(120);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(80),
    isArrayLike = __webpack_require__(42),
    isIndex = __webpack_require__(63),
    isObject = __webpack_require__(26);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 250 */,
/* 251 */,
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(195),
    baseIteratee = __webpack_require__(38),
    toInteger = __webpack_require__(97);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(35),
    isArray = __webpack_require__(21),
    isObjectLike = __webpack_require__(25);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 254 */,
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUrlParameter = exports.getExternalLayer = exports.mapRequest = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _d = __webpack_require__(19);

var _helpers = __webpack_require__(36);

var _isString = __webpack_require__(48);

var _isString2 = _interopRequireDefault(_isString);

var _isObject = __webpack_require__(221);

var _isObject2 = _interopRequireDefault(_isObject);

var _sortBy = __webpack_require__(43);

var _sortBy2 = _interopRequireDefault(_sortBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// API requests

// Fetch one favorite
var mapRequest = exports.mapRequest = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var d2;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return (0, _d.getInstance)();

                    case 2:
                        d2 = _context.sent;
                        _context.t0 = d2.models.map;
                        _context.t1 = id;
                        _context.next = 7;
                        return (0, _helpers.mapFields)();

                    case 7:
                        _context.t2 = _context.sent;
                        _context.t3 = {
                            fields: _context.t2
                        };
                        _context.t4 = getBasemap;

                        _context.t5 = function (config) {
                            return _extends({}, config, {
                                mapViews: upgradeGisAppLayers(config.mapViews)
                            });
                        };

                        return _context.abrupt('return', _context.t0.get.call(_context.t0, _context.t1, _context.t3).then(_context.t4).then(_context.t5));

                    case 12:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function mapRequest(_x) {
        return _ref.apply(this, arguments);
    };
}();

// Fetch one external layer
var getExternalLayer = exports.getExternalLayer = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        var d2;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return (0, _d.getInstance)();

                    case 2:
                        d2 = _context2.sent;
                        return _context2.abrupt('return', d2.models.externalMapLayers.get(id));

                    case 4:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    return function getExternalLayer(_x2) {
        return _ref2.apply(this, arguments);
    };
}();

// Different ways of specifying a basemap - TODO: simplify!
var getBasemap = function getBasemap(config) {
    var externalBasemap = config.mapViews.find(function (view) {
        return view.layer === 'external' && JSON.parse(view.config || {}).mapLayerPosition === 'BASEMAP';
    });
    var basemap = { id: 'osmLight' }; // Default basemap
    var mapViews = config.mapViews;

    if (externalBasemap) {
        basemap = JSON.parse(externalBasemap.config);
        mapViews = config.mapViews.filter(function (view) {
            return view.id !== externalBasemap.id;
        });
    } else if ((0, _isString2.default)(config.basemap)) {
        basemap = config.basemap === 'none' ? { id: 'osmLight', isVisible: false } : { id: config.basemap };
    } else if ((0, _isObject2.default)(config.basemap)) {
        basemap = config.basemap;
    }

    return _extends({}, config, {
        basemap: basemap,
        mapViews: mapViews
    });
};

// Layer order in the previous GIS app (bottom to top)
var gisAppLayerOrder = {
    externalLayer: 1, // TODO: Distinguish between basemaps and overlays
    earthEngine: 2,
    thematic4: 3,
    thematic3: 4,
    thematic2: 5,
    thematic1: 6,
    boundary: 7,
    facility: 8,
    event: 9
};

// Detection if map config is from previous GIS app
// TODO: Better to store app version as part of config object?
var isGisAppFormat = function isGisAppFormat(layers) {
    return layers.some(function (config) {
        return config.layer.match(/thematic[1-4]/);
    });
};

var upgradeGisAppLayers = function upgradeGisAppLayers(layers) {
    if (!isGisAppFormat(layers)) {
        return layers;
    }

    return (0, _sortBy2.default)(function (config) {
        return gisAppLayerOrder[config.layer];
    }, layers).map(function (config) {
        return _extends({}, config, {
            layer: config.layer.replace(/\d$/, '') // Remove thematic number used in previous versions
        });
    });
};

// https://davidwalsh.name/query-string-javascript
var getUrlParameter = exports.getUrlParameter = function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchLayer = undefined;

var _eventLoader = __webpack_require__(224);

var _eventLoader2 = _interopRequireDefault(_eventLoader);

var _facilityLoader = __webpack_require__(486);

var _facilityLoader2 = _interopRequireDefault(_facilityLoader);

var _thematicLoader = __webpack_require__(487);

var _thematicLoader2 = _interopRequireDefault(_thematicLoader);

var _boundaryLoader = __webpack_require__(492);

var _boundaryLoader2 = _interopRequireDefault(_boundaryLoader);

var _earthEngineLoader = __webpack_require__(259);

var _earthEngineLoader2 = _interopRequireDefault(_earthEngineLoader);

var _externalLoader = __webpack_require__(497);

var _externalLoader2 = _interopRequireDefault(_externalLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var layerType = {
    event: _eventLoader2.default,
    facility: _facilityLoader2.default,
    thematic: _thematicLoader2.default,
    boundary: _boundaryLoader2.default,
    earthEngine: _earthEngineLoader2.default,
    external: _externalLoader2.default
};

var fetchLayer = exports.fetchLayer = function fetchLayer(config) {
    var Loader = layerType[config.layer];

    if (Loader) {
        return Loader(config);
    } else {
        console.log('Unknown layer type', config.layer, config);
    }
};

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// This product includes color specifications and designs developed by Cynthia Brewer (http://colorbrewer.org/).
// Please see license at http://colorbrewer.org/export/LICENSE.txt
/* harmony default export */ __webpack_exports__["default"] = ({ YlGn: {
        3: ['#f7fcb9', '#addd8e', '#31a354'],
        4: ['#ffffcc', '#c2e699', '#78c679', '#238443'],
        5: ['#ffffcc', '#c2e699', '#78c679', '#31a354', '#006837'],
        6: ['#ffffcc', '#d9f0a3', '#addd8e', '#78c679', '#31a354', '#006837'],
        7: ['#ffffcc', '#d9f0a3', '#addd8e', '#78c679', '#41ab5d', '#238443', '#005a32'],
        8: ['#ffffe5', '#f7fcb9', '#d9f0a3', '#addd8e', '#78c679', '#41ab5d', '#238443', '#005a32'],
        9: ['#ffffe5', '#f7fcb9', '#d9f0a3', '#addd8e', '#78c679', '#41ab5d', '#238443', '#006837', '#004529']
    },
    YlGnBu: {
        3: ['#edf8b1', '#7fcdbb', '#2c7fb8'],
        4: ['#ffffcc', '#a1dab4', '#41b6c4', '#225ea8'],
        5: ['#ffffcc', '#a1dab4', '#41b6c4', '#2c7fb8', '#253494'],
        6: ['#ffffcc', '#c7e9b4', '#7fcdbb', '#41b6c4', '#2c7fb8', '#253494'],
        7: ['#ffffcc', '#c7e9b4', '#7fcdbb', '#41b6c4', '#1d91c0', '#225ea8', '#0c2c84'],
        8: ['#ffffd9', '#edf8b1', '#c7e9b4', '#7fcdbb', '#41b6c4', '#1d91c0', '#225ea8', '#0c2c84'],
        9: ['#ffffd9', '#edf8b1', '#c7e9b4', '#7fcdbb', '#41b6c4', '#1d91c0', '#225ea8', '#253494', '#081d58']
    },
    GnBu: {
        3: ['#e0f3db', '#a8ddb5', '#43a2ca'],
        4: ['#f0f9e8', '#bae4bc', '#7bccc4', '#2b8cbe'],
        5: ['#f0f9e8', '#bae4bc', '#7bccc4', '#43a2ca', '#0868ac'],
        6: ['#f0f9e8', '#ccebc5', '#a8ddb5', '#7bccc4', '#43a2ca', '#0868ac'],
        7: ['#f0f9e8', '#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#08589e'],
        8: ['#f7fcf0', '#e0f3db', '#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#08589e'],
        9: ['#f7fcf0', '#e0f3db', '#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#0868ac', '#084081']
    },
    BuGn: {
        3: ['#e5f5f9', '#99d8c9', '#2ca25f'],
        4: ['#edf8fb', '#b2e2e2', '#66c2a4', '#238b45'],
        5: ['#edf8fb', '#b2e2e2', '#66c2a4', '#2ca25f', '#006d2c'],
        6: ['#edf8fb', '#ccece6', '#99d8c9', '#66c2a4', '#2ca25f', '#006d2c'],
        7: ['#edf8fb', '#ccece6', '#99d8c9', '#66c2a4', '#41ae76', '#238b45', '#005824'],
        8: ['#f7fcfd', '#e5f5f9', '#ccece6', '#99d8c9', '#66c2a4', '#41ae76', '#238b45', '#005824'],
        9: ['#f7fcfd', '#e5f5f9', '#ccece6', '#99d8c9', '#66c2a4', '#41ae76', '#238b45', '#006d2c', '#00441b']
    },
    PuBuGn: {
        3: ['#ece2f0', '#a6bddb', '#1c9099'],
        4: ['#f6eff7', '#bdc9e1', '#67a9cf', '#02818a'],
        5: ['#f6eff7', '#bdc9e1', '#67a9cf', '#1c9099', '#016c59'],
        6: ['#f6eff7', '#d0d1e6', '#a6bddb', '#67a9cf', '#1c9099', '#016c59'],
        7: ['#f6eff7', '#d0d1e6', '#a6bddb', '#67a9cf', '#3690c0', '#02818a', '#016450'],
        8: ['#fff7fb', '#ece2f0', '#d0d1e6', '#a6bddb', '#67a9cf', '#3690c0', '#02818a', '#016450'],
        9: ['#fff7fb', '#ece2f0', '#d0d1e6', '#a6bddb', '#67a9cf', '#3690c0', '#02818a', '#016c59', '#014636']
    },
    PuBu: {
        3: ['#ece7f2', '#a6bddb', '#2b8cbe'],
        4: ['#f1eef6', '#bdc9e1', '#74a9cf', '#0570b0'],
        5: ['#f1eef6', '#bdc9e1', '#74a9cf', '#2b8cbe', '#045a8d'],
        6: ['#f1eef6', '#d0d1e6', '#a6bddb', '#74a9cf', '#2b8cbe', '#045a8d'],
        7: ['#f1eef6', '#d0d1e6', '#a6bddb', '#74a9cf', '#3690c0', '#0570b0', '#034e7b'],
        8: ['#fff7fb', '#ece7f2', '#d0d1e6', '#a6bddb', '#74a9cf', '#3690c0', '#0570b0', '#034e7b'],
        9: ['#fff7fb', '#ece7f2', '#d0d1e6', '#a6bddb', '#74a9cf', '#3690c0', '#0570b0', '#045a8d', '#023858']
    },
    BuPu: {
        3: ['#e0ecf4', '#9ebcda', '#8856a7'],
        4: ['#edf8fb', '#b3cde3', '#8c96c6', '#88419d'],
        5: ['#edf8fb', '#b3cde3', '#8c96c6', '#8856a7', '#810f7c'],
        6: ['#edf8fb', '#bfd3e6', '#9ebcda', '#8c96c6', '#8856a7', '#810f7c'],
        7: ['#edf8fb', '#bfd3e6', '#9ebcda', '#8c96c6', '#8c6bb1', '#88419d', '#6e016b'],
        8: ['#f7fcfd', '#e0ecf4', '#bfd3e6', '#9ebcda', '#8c96c6', '#8c6bb1', '#88419d', '#6e016b'],
        9: ['#f7fcfd', '#e0ecf4', '#bfd3e6', '#9ebcda', '#8c96c6', '#8c6bb1', '#88419d', '#810f7c', '#4d004b']
    },
    RdPu: {
        3: ['#fde0dd', '#fa9fb5', '#c51b8a'],
        4: ['#feebe2', '#fbb4b9', '#f768a1', '#ae017e'],
        5: ['#feebe2', '#fbb4b9', '#f768a1', '#c51b8a', '#7a0177'],
        6: ['#feebe2', '#fcc5c0', '#fa9fb5', '#f768a1', '#c51b8a', '#7a0177'],
        7: ['#feebe2', '#fcc5c0', '#fa9fb5', '#f768a1', '#dd3497', '#ae017e', '#7a0177'],
        8: ['#fff7f3', '#fde0dd', '#fcc5c0', '#fa9fb5', '#f768a1', '#dd3497', '#ae017e', '#7a0177'],
        9: ['#fff7f3', '#fde0dd', '#fcc5c0', '#fa9fb5', '#f768a1', '#dd3497', '#ae017e', '#7a0177', '#49006a']
    },
    PuRd: {
        3: ['#e7e1ef', '#c994c7', '#dd1c77'],
        4: ['#f1eef6', '#d7b5d8', '#df65b0', '#ce1256'],
        5: ['#f1eef6', '#d7b5d8', '#df65b0', '#dd1c77', '#980043'],
        6: ['#f1eef6', '#d4b9da', '#c994c7', '#df65b0', '#dd1c77', '#980043'],
        7: ['#f1eef6', '#d4b9da', '#c994c7', '#df65b0', '#e7298a', '#ce1256', '#91003f'],
        8: ['#f7f4f9', '#e7e1ef', '#d4b9da', '#c994c7', '#df65b0', '#e7298a', '#ce1256', '#91003f'],
        9: ['#f7f4f9', '#e7e1ef', '#d4b9da', '#c994c7', '#df65b0', '#e7298a', '#ce1256', '#980043', '#67001f']
    },
    OrRd: {
        3: ['#fee8c8', '#fdbb84', '#e34a33'],
        4: ['#fef0d9', '#fdcc8a', '#fc8d59', '#d7301f'],
        5: ['#fef0d9', '#fdcc8a', '#fc8d59', '#e34a33', '#b30000'],
        6: ['#fef0d9', '#fdd49e', '#fdbb84', '#fc8d59', '#e34a33', '#b30000'],
        7: ['#fef0d9', '#fdd49e', '#fdbb84', '#fc8d59', '#ef6548', '#d7301f', '#990000'],
        8: ['#fff7ec', '#fee8c8', '#fdd49e', '#fdbb84', '#fc8d59', '#ef6548', '#d7301f', '#990000'],
        9: ['#fff7ec', '#fee8c8', '#fdd49e', '#fdbb84', '#fc8d59', '#ef6548', '#d7301f', '#b30000', '#7f0000']
    },
    YlOrRd: {
        3: ['#ffeda0', '#feb24c', '#f03b20'],
        4: ['#ffffb2', '#fecc5c', '#fd8d3c', '#e31a1c'],
        5: ['#ffffb2', '#fecc5c', '#fd8d3c', '#f03b20', '#bd0026'],
        6: ['#ffffb2', '#fed976', '#feb24c', '#fd8d3c', '#f03b20', '#bd0026'],
        7: ['#ffffb2', '#fed976', '#feb24c', '#fd8d3c', '#fc4e2a', '#e31a1c', '#b10026'],
        8: ['#ffffcc', '#ffeda0', '#fed976', '#feb24c', '#fd8d3c', '#fc4e2a', '#e31a1c', '#b10026'],
        9: ['#ffffcc', '#ffeda0', '#fed976', '#feb24c', '#fd8d3c', '#fc4e2a', '#e31a1c', '#bd0026', '#800026']
    },
    YlOrBr: {
        3: ['#fff7bc', '#fec44f', '#d95f0e'],
        4: ['#ffffd4', '#fed98e', '#fe9929', '#cc4c02'],
        5: ['#ffffd4', '#fed98e', '#fe9929', '#d95f0e', '#993404'],
        6: ['#ffffd4', '#fee391', '#fec44f', '#fe9929', '#d95f0e', '#993404'],
        7: ['#ffffd4', '#fee391', '#fec44f', '#fe9929', '#ec7014', '#cc4c02', '#8c2d04'],
        8: ['#ffffe5', '#fff7bc', '#fee391', '#fec44f', '#fe9929', '#ec7014', '#cc4c02', '#8c2d04'],
        9: ['#ffffe5', '#fff7bc', '#fee391', '#fec44f', '#fe9929', '#ec7014', '#cc4c02', '#993404', '#662506']
    },
    Purples: {
        3: ['#efedf5', '#bcbddc', '#756bb1'],
        4: ['#f2f0f7', '#cbc9e2', '#9e9ac8', '#6a51a3'],
        5: ['#f2f0f7', '#cbc9e2', '#9e9ac8', '#756bb1', '#54278f'],
        6: ['#f2f0f7', '#dadaeb', '#bcbddc', '#9e9ac8', '#756bb1', '#54278f'],
        7: ['#f2f0f7', '#dadaeb', '#bcbddc', '#9e9ac8', '#807dba', '#6a51a3', '#4a1486'],
        8: ['#fcfbfd', '#efedf5', '#dadaeb', '#bcbddc', '#9e9ac8', '#807dba', '#6a51a3', '#4a1486'],
        9: ['#fcfbfd', '#efedf5', '#dadaeb', '#bcbddc', '#9e9ac8', '#807dba', '#6a51a3', '#54278f', '#3f007d']
    },
    Blues: {
        3: ['#deebf7', '#9ecae1', '#3182bd'],
        4: ['#eff3ff', '#bdd7e7', '#6baed6', '#2171b5'],
        5: ['#eff3ff', '#bdd7e7', '#6baed6', '#3182bd', '#08519c'],
        6: ['#eff3ff', '#c6dbef', '#9ecae1', '#6baed6', '#3182bd', '#08519c'],
        7: ['#eff3ff', '#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#2171b5', '#084594'],
        8: ['#f7fbff', '#deebf7', '#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#2171b5', '#084594'],
        9: ['#f7fbff', '#deebf7', '#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#2171b5', '#08519c', '#08306b']
    },
    Greens: {
        3: ['#e5f5e0', '#a1d99b', '#31a354'],
        4: ['#edf8e9', '#bae4b3', '#74c476', '#238b45'],
        5: ['#edf8e9', '#bae4b3', '#74c476', '#31a354', '#006d2c'],
        6: ['#edf8e9', '#c7e9c0', '#a1d99b', '#74c476', '#31a354', '#006d2c'],
        7: ['#edf8e9', '#c7e9c0', '#a1d99b', '#74c476', '#41ab5d', '#238b45', '#005a32'],
        8: ['#f7fcf5', '#e5f5e0', '#c7e9c0', '#a1d99b', '#74c476', '#41ab5d', '#238b45', '#005a32'],
        9: ['#f7fcf5', '#e5f5e0', '#c7e9c0', '#a1d99b', '#74c476', '#41ab5d', '#238b45', '#006d2c', '#00441b']
    },
    Oranges: {
        3: ['#fee6ce', '#fdae6b', '#e6550d'],
        4: ['#feedde', '#fdbe85', '#fd8d3c', '#d94701'],
        5: ['#feedde', '#fdbe85', '#fd8d3c', '#e6550d', '#a63603'],
        6: ['#feedde', '#fdd0a2', '#fdae6b', '#fd8d3c', '#e6550d', '#a63603'],
        7: ['#feedde', '#fdd0a2', '#fdae6b', '#fd8d3c', '#f16913', '#d94801', '#8c2d04'],
        8: ['#fff5eb', '#fee6ce', '#fdd0a2', '#fdae6b', '#fd8d3c', '#f16913', '#d94801', '#8c2d04'],
        9: ['#fff5eb', '#fee6ce', '#fdd0a2', '#fdae6b', '#fd8d3c', '#f16913', '#d94801', '#a63603', '#7f2704']
    },
    Reds: {
        3: ['#fee0d2', '#fc9272', '#de2d26'],
        4: ['#fee5d9', '#fcae91', '#fb6a4a', '#cb181d'],
        5: ['#fee5d9', '#fcae91', '#fb6a4a', '#de2d26', '#a50f15'],
        6: ['#fee5d9', '#fcbba1', '#fc9272', '#fb6a4a', '#de2d26', '#a50f15'],
        7: ['#fee5d9', '#fcbba1', '#fc9272', '#fb6a4a', '#ef3b2c', '#cb181d', '#99000d'],
        8: ['#fff5f0', '#fee0d2', '#fcbba1', '#fc9272', '#fb6a4a', '#ef3b2c', '#cb181d', '#99000d'],
        9: ['#fff5f0', '#fee0d2', '#fcbba1', '#fc9272', '#fb6a4a', '#ef3b2c', '#cb181d', '#a50f15', '#67000d']
    },
    Greys: {
        3: ['#f0f0f0', '#bdbdbd', '#636363'],
        4: ['#f7f7f7', '#cccccc', '#969696', '#525252'],
        5: ['#f7f7f7', '#cccccc', '#969696', '#636363', '#252525'],
        6: ['#f7f7f7', '#d9d9d9', '#bdbdbd', '#969696', '#636363', '#252525'],
        7: ['#f7f7f7', '#d9d9d9', '#bdbdbd', '#969696', '#737373', '#525252', '#252525'],
        8: ['#ffffff', '#f0f0f0', '#d9d9d9', '#bdbdbd', '#969696', '#737373', '#525252', '#252525'],
        9: ['#ffffff', '#f0f0f0', '#d9d9d9', '#bdbdbd', '#969696', '#737373', '#525252', '#252525', '#000000']
    },
    PuOr: {
        3: ['#f1a340', '#f7f7f7', '#998ec3'],
        4: ['#e66101', '#fdb863', '#b2abd2', '#5e3c99'],
        5: ['#e66101', '#fdb863', '#f7f7f7', '#b2abd2', '#5e3c99'],
        6: ['#b35806', '#f1a340', '#fee0b6', '#d8daeb', '#998ec3', '#542788'],
        7: ['#b35806', '#f1a340', '#fee0b6', '#f7f7f7', '#d8daeb', '#998ec3', '#542788'],
        8: ['#b35806', '#e08214', '#fdb863', '#fee0b6', '#d8daeb', '#b2abd2', '#8073ac', '#542788'],
        9: ['#b35806', '#e08214', '#fdb863', '#fee0b6', '#f7f7f7', '#d8daeb', '#b2abd2', '#8073ac', '#542788'],
        10: ['#7f3b08', '#b35806', '#e08214', '#fdb863', '#fee0b6', '#d8daeb', '#b2abd2', '#8073ac', '#542788', '#2d004b'],
        11: ['#7f3b08', '#b35806', '#e08214', '#fdb863', '#fee0b6', '#f7f7f7', '#d8daeb', '#b2abd2', '#8073ac', '#542788', '#2d004b']
    },
    BrBG: {
        3: ['#d8b365', '#f5f5f5', '#5ab4ac'],
        4: ['#a6611a', '#dfc27d', '#80cdc1', '#018571'],
        5: ['#a6611a', '#dfc27d', '#f5f5f5', '#80cdc1', '#018571'],
        6: ['#8c510a', '#d8b365', '#f6e8c3', '#c7eae5', '#5ab4ac', '#01665e'],
        7: ['#8c510a', '#d8b365', '#f6e8c3', '#f5f5f5', '#c7eae5', '#5ab4ac', '#01665e'],
        8: ['#8c510a', '#bf812d', '#dfc27d', '#f6e8c3', '#c7eae5', '#80cdc1', '#35978f', '#01665e'],
        9: ['#8c510a', '#bf812d', '#dfc27d', '#f6e8c3', '#f5f5f5', '#c7eae5', '#80cdc1', '#35978f', '#01665e'],
        10: ['#543005', '#8c510a', '#bf812d', '#dfc27d', '#f6e8c3', '#c7eae5', '#80cdc1', '#35978f', '#01665e', '#003c30'],
        11: ['#543005', '#8c510a', '#bf812d', '#dfc27d', '#f6e8c3', '#f5f5f5', '#c7eae5', '#80cdc1', '#35978f', '#01665e', '#003c30']
    },
    PRGn: {
        3: ['#af8dc3', '#f7f7f7', '#7fbf7b'],
        4: ['#7b3294', '#c2a5cf', '#a6dba0', '#008837'],
        5: ['#7b3294', '#c2a5cf', '#f7f7f7', '#a6dba0', '#008837'],
        6: ['#762a83', '#af8dc3', '#e7d4e8', '#d9f0d3', '#7fbf7b', '#1b7837'],
        7: ['#762a83', '#af8dc3', '#e7d4e8', '#f7f7f7', '#d9f0d3', '#7fbf7b', '#1b7837'],
        8: ['#762a83', '#9970ab', '#c2a5cf', '#e7d4e8', '#d9f0d3', '#a6dba0', '#5aae61', '#1b7837'],
        9: ['#762a83', '#9970ab', '#c2a5cf', '#e7d4e8', '#f7f7f7', '#d9f0d3', '#a6dba0', '#5aae61', '#1b7837'],
        10: ['#40004b', '#762a83', '#9970ab', '#c2a5cf', '#e7d4e8', '#d9f0d3', '#a6dba0', '#5aae61', '#1b7837', '#00441b'],
        11: ['#40004b', '#762a83', '#9970ab', '#c2a5cf', '#e7d4e8', '#f7f7f7', '#d9f0d3', '#a6dba0', '#5aae61', '#1b7837', '#00441b']
    },
    PiYG: {
        3: ['#e9a3c9', '#f7f7f7', '#a1d76a'],
        4: ['#d01c8b', '#f1b6da', '#b8e186', '#4dac26'],
        5: ['#d01c8b', '#f1b6da', '#f7f7f7', '#b8e186', '#4dac26'],
        6: ['#c51b7d', '#e9a3c9', '#fde0ef', '#e6f5d0', '#a1d76a', '#4d9221'],
        7: ['#c51b7d', '#e9a3c9', '#fde0ef', '#f7f7f7', '#e6f5d0', '#a1d76a', '#4d9221'],
        8: ['#c51b7d', '#de77ae', '#f1b6da', '#fde0ef', '#e6f5d0', '#b8e186', '#7fbc41', '#4d9221'],
        9: ['#c51b7d', '#de77ae', '#f1b6da', '#fde0ef', '#f7f7f7', '#e6f5d0', '#b8e186', '#7fbc41', '#4d9221'],
        10: ['#8e0152', '#c51b7d', '#de77ae', '#f1b6da', '#fde0ef', '#e6f5d0', '#b8e186', '#7fbc41', '#4d9221', '#276419'],
        11: ['#8e0152', '#c51b7d', '#de77ae', '#f1b6da', '#fde0ef', '#f7f7f7', '#e6f5d0', '#b8e186', '#7fbc41', '#4d9221', '#276419']
    },
    RdBu: {
        3: ['#ef8a62', '#f7f7f7', '#67a9cf'],
        4: ['#ca0020', '#f4a582', '#92c5de', '#0571b0'],
        5: ['#ca0020', '#f4a582', '#f7f7f7', '#92c5de', '#0571b0'],
        6: ['#b2182b', '#ef8a62', '#fddbc7', '#d1e5f0', '#67a9cf', '#2166ac'],
        7: ['#b2182b', '#ef8a62', '#fddbc7', '#f7f7f7', '#d1e5f0', '#67a9cf', '#2166ac'],
        8: ['#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#d1e5f0', '#92c5de', '#4393c3', '#2166ac'],
        9: ['#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#f7f7f7', '#d1e5f0', '#92c5de', '#4393c3', '#2166ac'],
        10: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#d1e5f0', '#92c5de', '#4393c3', '#2166ac', '#053061'],
        11: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#f7f7f7', '#d1e5f0', '#92c5de', '#4393c3', '#2166ac', '#053061']
    },
    RdGy: {
        3: ['#ef8a62', '#ffffff', '#999999'],
        4: ['#ca0020', '#f4a582', '#bababa', '#404040'],
        5: ['#ca0020', '#f4a582', '#ffffff', '#bababa', '#404040'],
        6: ['#b2182b', '#ef8a62', '#fddbc7', '#e0e0e0', '#999999', '#4d4d4d'],
        7: ['#b2182b', '#ef8a62', '#fddbc7', '#ffffff', '#e0e0e0', '#999999', '#4d4d4d'],
        8: ['#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#e0e0e0', '#bababa', '#878787', '#4d4d4d'],
        9: ['#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#ffffff', '#e0e0e0', '#bababa', '#878787', '#4d4d4d'],
        10: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#e0e0e0', '#bababa', '#878787', '#4d4d4d', '#1a1a1a'],
        11: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#ffffff', '#e0e0e0', '#bababa', '#878787', '#4d4d4d', '#1a1a1a']
    },
    RdYlBu: {
        3: ['#fc8d59', '#ffffbf', '#91bfdb'],
        4: ['#d7191c', '#fdae61', '#abd9e9', '#2c7bb6'],
        5: ['#d7191c', '#fdae61', '#ffffbf', '#abd9e9', '#2c7bb6'],
        6: ['#d73027', '#fc8d59', '#fee090', '#e0f3f8', '#91bfdb', '#4575b4'],
        7: ['#d73027', '#fc8d59', '#fee090', '#ffffbf', '#e0f3f8', '#91bfdb', '#4575b4'],
        8: ['#d73027', '#f46d43', '#fdae61', '#fee090', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4'],
        9: ['#d73027', '#f46d43', '#fdae61', '#fee090', '#ffffbf', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4'],
        10: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee090', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695'],
        11: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee090', '#ffffbf', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695']
    },
    Spectral: {
        3: ['#fc8d59', '#ffffbf', '#99d594'],
        4: ['#d7191c', '#fdae61', '#abdda4', '#2b83ba'],
        5: ['#d7191c', '#fdae61', '#ffffbf', '#abdda4', '#2b83ba'],
        6: ['#d53e4f', '#fc8d59', '#fee08b', '#e6f598', '#99d594', '#3288bd'],
        7: ['#d53e4f', '#fc8d59', '#fee08b', '#ffffbf', '#e6f598', '#99d594', '#3288bd'],
        8: ['#d53e4f', '#f46d43', '#fdae61', '#fee08b', '#e6f598', '#abdda4', '#66c2a5', '#3288bd'],
        9: ['#d53e4f', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#e6f598', '#abdda4', '#66c2a5', '#3288bd'],
        10: ['#9e0142', '#d53e4f', '#f46d43', '#fdae61', '#fee08b', '#e6f598', '#abdda4', '#66c2a5', '#3288bd', '#5e4fa2'],
        11: ['#9e0142', '#d53e4f', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#e6f598', '#abdda4', '#66c2a5', '#3288bd', '#5e4fa2']
    },
    RdYlGn: {
        3: ['#fc8d59', '#ffffbf', '#91cf60'],
        4: ['#d7191c', '#fdae61', '#a6d96a', '#1a9641'],
        5: ['#d7191c', '#fdae61', '#ffffbf', '#a6d96a', '#1a9641'],
        6: ['#d73027', '#fc8d59', '#fee08b', '#d9ef8b', '#91cf60', '#1a9850'],
        7: ['#d73027', '#fc8d59', '#fee08b', '#ffffbf', '#d9ef8b', '#91cf60', '#1a9850'],
        8: ['#d73027', '#f46d43', '#fdae61', '#fee08b', '#d9ef8b', '#a6d96a', '#66bd63', '#1a9850'],
        9: ['#d73027', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#d9ef8b', '#a6d96a', '#66bd63', '#1a9850'],
        10: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee08b', '#d9ef8b', '#a6d96a', '#66bd63', '#1a9850', '#006837'],
        11: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#d9ef8b', '#a6d96a', '#66bd63', '#1a9850', '#006837']
    },
    Accent: {
        3: ['#7fc97f', '#beaed4', '#fdc086'],
        4: ['#7fc97f', '#beaed4', '#fdc086', '#ffff99'],
        5: ['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0'],
        6: ['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0', '#f0027f'],
        7: ['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0', '#f0027f', '#bf5b17'],
        8: ['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0', '#f0027f', '#bf5b17', '#666666']
    },
    Dark2: {
        3: ['#1b9e77', '#d95f02', '#7570b3'],
        4: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a'],
        5: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e'],
        6: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e', '#e6ab02'],
        7: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e', '#e6ab02', '#a6761d'],
        8: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e', '#e6ab02', '#a6761d', '#666666']
    },
    Paired: {
        3: ['#a6cee3', '#1f78b4', '#b2df8a'],
        4: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c'],
        5: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99'],
        6: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c'],
        7: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f'],
        8: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00'],
        9: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6'],
        10: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a'],
        11: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a', '#ffff99'],
        12: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a', '#ffff99', '#b15928']
    },
    Pastel1: {
        3: ['#fbb4ae', '#b3cde3', '#ccebc5'],
        4: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4'],
        5: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6'],
        6: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffcc'],
        7: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffcc', '#e5d8bd'],
        8: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffcc', '#e5d8bd', '#fddaec'],
        9: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffcc', '#e5d8bd', '#fddaec', '#f2f2f2']
    },
    Pastel2: {
        3: ['#b3e2cd', '#fdcdac', '#cbd5e8'],
        4: ['#b3e2cd', '#fdcdac', '#cbd5e8', '#f4cae4'],
        5: ['#b3e2cd', '#fdcdac', '#cbd5e8', '#f4cae4', '#e6f5c9'],
        6: ['#b3e2cd', '#fdcdac', '#cbd5e8', '#f4cae4', '#e6f5c9', '#fff2ae'],
        7: ['#b3e2cd', '#fdcdac', '#cbd5e8', '#f4cae4', '#e6f5c9', '#fff2ae', '#f1e2cc'],
        8: ['#b3e2cd', '#fdcdac', '#cbd5e8', '#f4cae4', '#e6f5c9', '#fff2ae', '#f1e2cc', '#cccccc']
    },
    Set1: {
        3: ['#e41a1c', '#377eb8', '#4daf4a'],
        4: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3'],
        5: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00'],
        6: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33'],
        7: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628'],
        8: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf'],
        9: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf', '#999999']
    },
    Set2: {
        3: ['#66c2a5', '#fc8d62', '#8da0cb'],
        4: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3'],
        5: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854'],
        6: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854', '#ffd92f'],
        7: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854', '#ffd92f', '#e5c494'],
        8: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854', '#ffd92f', '#e5c494', '#b3b3b3']
    },
    Set3: {
        3: ['#8dd3c7', '#ffffb3', '#bebada'],
        4: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072'],
        5: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3'],
        6: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462'],
        7: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69'],
        8: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5'],
        9: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9'],
        10: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9', '#bc80bd'],
        11: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9', '#bc80bd', '#ccebc5'],
        12: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9', '#bc80bd', '#ccebc5', '#ffed6f']
    },
    YlOrBr_reverse: {
        3: ['#d95f0e', '#fec44f', '#fff7bc'],
        4: ['#cc4c02', '#fe9929', '#fed98e', '#ffffd4'],
        5: ['#993404', '#d95f0e', '#fe9929', '#fed98e', '#ffffd4'],
        6: ['#993404', '#d95f0e', '#fe9929', '#fec44f', '#fee391', '#ffffd4'],
        7: ['#8c2d04', '#cc4c02', '#ec7014', '#fe9929', '#fec44f', '#fee391', '#ffffd4'],
        8: ['#8c2d04', '#cc4c02', '#ec7014', '#fe9929', '#fec44f', '#fee391', '#fff7bc', '#ffffe5'],
        9: ['#662506', '#993404', '#cc4c02', '#ec7014', '#fe9929', '#fec44f', '#fee391', '#fff7bc', '#ffffe5']
    },
    Reds_reverse: {
        3: ['#de2d26', '#fc9272', '#fee0d2'],
        4: ['#cb181d', '#fb6a4a', '#fcae91', '#fee5d9'],
        5: ['#a50f15', '#de2d26', '#fb6a4a', '#fcae91', '#fee5d9'],
        6: ['#a50f15', '#de2d26', '#fb6a4a', '#fc9272', '#fcbba1', '#fee5d9'],
        7: ['#99000d', '#cb181d', '#ef3b2c', '#fb6a4a', '#fc9272', '#fcbba1', '#fee5d9'],
        8: ['#99000d', '#cb181d', '#ef3b2c', '#fb6a4a', '#fc9272', '#fcbba1', '#fee0d2', '#fff5f0'],
        9: ['#67000d', '#a50f15', '#cb181d', '#ef3b2c', '#fb6a4a', '#fc9272', '#fcbba1', '#fee0d2', '#fff5f0']
    },
    YlGn_reverse: {
        3: ['#31a354', '#addd8e', '#f7fcb9'],
        4: ['#238443', '#78c679', '#c2e699', '#ffffcc'],
        5: ['#006837', '#31a354', '#78c679', '#c2e699', '#ffffcc'],
        6: ['#006837', '#31a354', '#78c679', '#addd8e', '#d9f0a3', '#ffffcc'],
        7: ['#005a32', '#238443', '#41ab5d', '#78c679', '#addd8e', '#d9f0a3', '#ffffcc'],
        8: ['#005a32', '#238443', '#41ab5d', '#78c679', '#addd8e', '#d9f0a3', '#f7fcb9', '#ffffe5'],
        9: ['#004529', '#006837', '#238443', '#41ab5d', '#78c679', '#addd8e', '#d9f0a3', '#f7fcb9', '#ffffe5']
    },
    Greens_reverse: {
        3: ['#31a354', '#a1d99b', '#e5f5e0'],
        4: ['#238b45', '#74c476', '#bae4b3', '#edf8e9'],
        5: ['#006d2c', '#31a354', '#74c476', '#bae4b3', '#edf8e9'],
        6: ['#006d2c', '#31a354', '#74c476', '#a1d99b', '#c7e9c0', '#edf8e9'],
        7: ['#005a32', '#238b45', '#41ab5d', '#74c476', '#a1d99b', '#c7e9c0', '#edf8e9'],
        8: ['#005a32', '#238b45', '#41ab5d', '#74c476', '#a1d99b', '#c7e9c0', '#e5f5e0', '#f7fcf5'],
        9: ['#00441b', '#006d2c', '#238b45', '#41ab5d', '#74c476', '#a1d99b', '#c7e9c0', '#e5f5e0', '#f7fcf5']
    },
    Blues_reverse: {
        3: ['#3182bd', '#9ecae1', '#deebf7'],
        4: ['#2171b5', '#6baed6', '#bdd7e7', '#eff3ff'],
        5: ['#08519c', '#3182bd', '#6baed6', '#bdd7e7', '#eff3ff'],
        6: ['#08519c', '#3182bd', '#6baed6', '#9ecae1', '#c6dbef', '#eff3ff'],
        7: ['#084594', '#2171b5', '#4292c6', '#6baed6', '#9ecae1', '#c6dbef', '#eff3ff'],
        8: ['#084594', '#2171b5', '#4292c6', '#6baed6', '#9ecae1', '#c6dbef', '#deebf7', '#f7fbff'],
        9: ['#08306b', '#08519c', '#2171b5', '#4292c6', '#6baed6', '#9ecae1', '#c6dbef', '#deebf7', '#f7fbff']
    },
    BuPu_reverse: {
        3: ['#8856a7', '#9ebcda', '#e0ecf4'],
        4: ['#88419d', '#8c96c6', '#b3cde3', '#edf8fb'],
        5: ['#810f7c', '#8856a7', '#8c96c6', '#b3cde3', '#edf8fb'],
        6: ['#810f7c', '#8856a7', '#8c96c6', '#9ebcda', '#bfd3e6', '#edf8fb'],
        7: ['#6e016b', '#88419d', '#8c6bb1', '#8c96c6', '#9ebcda', '#bfd3e6', '#edf8fb'],
        8: ['#6e016b', '#88419d', '#8c6bb1', '#8c96c6', '#9ebcda', '#bfd3e6', '#e0ecf4', '#f7fcfd'],
        9: ['#4d004b', '#810f7c', '#88419d', '#8c6bb1', '#8c96c6', '#9ebcda', '#bfd3e6', '#e0ecf4', '#f7fcfd']
    },
    RdPu_reverse: {
        3: ['#c51b8a', '#fa9fb5', '#fde0dd'],
        4: ['#ae017e', '#f768a1', '#fbb4b9', '#feebe2'],
        5: ['#7a0177', '#c51b8a', '#f768a1', '#fbb4b9', '#feebe2'],
        6: ['#7a0177', '#c51b8a', '#f768a1', '#fa9fb5', '#fcc5c0', '#feebe2'],
        7: ['#7a0177', '#ae017e', '#dd3497', '#f768a1', '#fa9fb5', '#fcc5c0', '#feebe2'],
        8: ['#7a0177', '#ae017e', '#dd3497', '#f768a1', '#fa9fb5', '#fcc5c0', '#fde0dd', '#fff7f3'],
        9: ['#49006a', '#7a0177', '#ae017e', '#dd3497', '#f768a1', '#fa9fb5', '#fcc5c0', '#fde0dd', '#fff7f3']
    },
    PuRd_reverse: {
        3: ['#dd1c77', '#c994c7', '#e7e1ef'],
        4: ['#ce1256', '#df65b0', '#d7b5d8', '#f1eef6'],
        5: ['#980043', '#dd1c77', '#df65b0', '#d7b5d8', '#f1eef6'],
        6: ['#980043', '#dd1c77', '#df65b0', '#c994c7', '#d4b9da', '#f1eef6'],
        7: ['#91003f', '#ce1256', '#e7298a', '#df65b0', '#c994c7', '#d4b9da', '#f1eef6'],
        8: ['#91003f', '#ce1256', '#e7298a', '#df65b0', '#c994c7', '#d4b9da', '#e7e1ef', '#f7f4f9'],
        9: ['#67001f', '#980043', '#ce1256', '#e7298a', '#df65b0', '#c994c7', '#d4b9da', '#e7e1ef', '#f7f4f9']
    },
    Greys_reverse: {
        3: ['#636363', '#bdbdbd', '#f0f0f0'],
        4: ['#525252', '#969696', '#cccccc', '#f7f7f7'],
        5: ['#252525', '#636363', '#969696', '#cccccc', '#f7f7f7'],
        6: ['#252525', '#636363', '#969696', '#bdbdbd', '#d9d9d9', '#f7f7f7'],
        7: ['#252525', '#525252', '#737373', '#969696', '#bdbdbd', '#d9d9d9', '#f7f7f7'],
        8: ['#252525', '#525252', '#737373', '#969696', '#bdbdbd', '#d9d9d9', '#f0f0f0', '#ffffff'],
        9: ['#000000', '#252525', '#525252', '#737373', '#969696', '#bdbdbd', '#d9d9d9', '#f0f0f0', '#ffffff']
    } });

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(210),
    arrayIncludes = __webpack_require__(194),
    arrayIncludesWith = __webpack_require__(495),
    cacheHas = __webpack_require__(211),
    createSet = __webpack_require__(496),
    setToArray = __webpack_require__(136);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var datasets = {
    'USGS/SRTMGL1_003': {
        name: 'Elevation',
        band: 'elevation',
        mask: true,
        legend: {
            unit: 'metres',
            description: 'Elevation above sea-level.',
            source: 'NASA / USGS / JPL-Caltech / Google Earth Engine',
            sourceUrl: 'https://explorer.earthengine.google.com/#detail/USGS%2FSRTMGL1_003'
        }
    },
    'WorldPop/POP': {
        name: 'Population density',
        aggregation: 'mosaic',
        mask: true,
        methods: {
            multiply: [100] // Convert from people/hectare to people/km2
        },
        resolution: 100,
        projection: 'EPSG:4326',
        value: function value(_value) {
            return Math.round(_value);
        },

        legend: {
            unit: 'people per km²',
            description: 'Population density estimates with national totals adjusted to match UN population division estimates.',
            source: 'WorldPop / Google Earth Engine',
            sourceUrl: 'https://explorer.earthengine.google.com/#detail/WorldPop%2FPOP'
        }
    },
    'NOAA/DMSP-OLS/NIGHTTIME_LIGHTS': {
        name: 'Nighttime lights',
        band: 'stable_lights',
        mask: true,
        popup: '{name}: {value}',
        legend: {
            unit: 'light intensity',
            description: 'Light intensity from cities, towns, and other sites with persistent lighting, including gas flares.',
            source: 'NOAA / Google Earth Engine',
            sourceUrl: 'https://explorer.earthengine.google.com/#detail/NOAA%2FDMSP-OLS%2FNIGHTTIME_LIGHTS'
        }
    },
    'UCSB-CHG/CHIRPS/PENTAD': {
        name: 'Precipitation',
        band: 'precipitation',
        mask: true,
        value: function value(_value2) {
            return _value2.toFixed(1);
        },

        legend: {
            unit: 'millimeter',
            description: 'Precipitation collected from satellite and weather stations on the ground.',
            source: 'UCSB / CHG / Google Earth Engine',
            sourceUrl: 'https://explorer.earthengine.google.com/#detail/UCSB-CHG%2FCHIRPS%2FPENTAD'
        }
    },
    'MODIS/MOD11A2': {
        name: 'Temperature',
        band: 'LST_Day_1km',
        mask: true,
        methods: {
            toFloat: [],
            multiply: [0.02],
            subtract: [273.15]
        },
        value: function value(_value3) {
            return Math.round(_value3);
        },

        popup: '{name}: {value}{unit}',
        legend: {
            unit: '°C during daytime',
            description: 'Land surface temperatures collected from satellite. Blank spots will appear in areas with a persistent cloud cover.',
            source: 'NASA LP DAAC / Google Earth Engine',
            sourceUrl: 'https://explorer.earthengine.google.com/#detail/MODIS%2FMOD11A2'
        }
    },
    'MODIS/051/MCD12Q1': {
        name: 'Landcover',
        band: 'Land_Cover_Type_1',
        params: {
            min: 0,
            max: 17,
            palette: 'aec3d6,162103,235123,399b38,38eb38,39723b,6a2424,c3a55f,b76124,d99125,92af1f,10104c,cdb400,cc0202,332808,d7cdcc,f7e174,743411'
        },
        mask: false,
        legend: {
            description: 'Distinct landcover types collected from satellites.',
            source: 'NASA LP DAAC / Google Earth Engine',
            sourceUrl: 'https://code.earthengine.google.com/dataset/MODIS/051/MCD12Q1',
            items: [{
                color: '#aec3d6',
                name: 'Water'
            }, {
                color: '#162103',
                name: 'Evergreen Needleleaf forest'
            }, {
                color: '#235123',
                name: 'Evergreen Broadleaf forest'
            }, {
                color: '#399b38',
                name: 'Deciduous Needleleaf forest'
            }, {
                color: '#38eb38',
                name: 'Deciduous Broadleaf forest'
            }, {
                color: '#39723b',
                name: 'Mixed forest'
            }, {
                color: '#6a2424',
                name: 'Closed shrublands'
            }, {
                color: '#c3a55f',
                name: 'Open shrublands'
            }, {
                color: '#b76124',
                name: 'Woody savannas'
            }, {
                color: '#d99125',
                name: 'Savannas'
            }, {
                color: '#92af1f',
                name: 'Grasslands'
            }, {
                color: '#10104c',
                name: 'Permanent wetlands'
            }, {
                color: '#cdb400',
                name: 'Croplands'
            }, {
                color: '#cc0202',
                name: 'Urban and built-up'
            }, {
                color: '#332808',
                name: 'Cropland/Natural vegetation mosaic'
            }, {
                color: '#d7cdcc',
                name: 'Snow and ice'
            }, {
                color: '#f7e174',
                name: 'Barren or sparsely vegetated'
            }, {
                color: '#743411',
                name: 'Unclassified'
            }]
        },
        popup: '{name}: {value}'
    }
};

// Returns a promise
var earthEngineLoader = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
        var layerConfig, dataset, layer;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        layerConfig = {};
                        dataset = void 0;


                        if (typeof config.config === 'string') {
                            // From database as favorite
                            layerConfig = JSON.parse(config.config);

                            dataset = datasets[layerConfig.id];

                            if (dataset) {
                                dataset.datasetId = layerConfig.id;
                                delete layerConfig.id;
                            }

                            delete config.config;
                        } else {
                            dataset = datasets[config.datasetId];
                        }

                        layer = _extends({}, config, layerConfig, dataset);

                        // Create legend items from params

                        if (layer.legend && !layer.legend.items && layer.params) {
                            layer.legend = _extends({}, layer.legend, {
                                items: createLegend(layer.params)
                            });
                        }

                        return _context.abrupt('return', _extends({}, layer, {
                            isLoaded: true,
                            isExpanded: true,
                            isVisible: true
                        }));

                    case 6:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function earthEngineLoader(_x) {
        return _ref.apply(this, arguments);
    };
}();

// TODO: This function is currently duplicated from  GIS API
var createLegend = exports.createLegend = function createLegend(params) {
    var min = params.min;
    var max = params.max;
    var palette = params.palette.split(',');
    var step = (params.max - min) / (palette.length - (min > 0 ? 2 : 1));

    var from = min;
    var to = Math.round(min + step);

    return palette.map(function (color, index) {
        var item = {
            color: color
        };

        if (index === 0 && min > 0) {
            // Less than min
            item.name = '< ' + min;
            to = min;
        } else if (from < max) {
            item.name = from + ' - ' + to;
        } else {
            // Higher than max
            item.name = '> ' + from;
        }

        from = to;
        to = Math.round(min + step * (index + (min > 0 ? 1 : 2)));

        return item;
    });
};

exports.default = earthEngineLoader;

/***/ }),
/* 260 */,
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.translateConfig = exports.cleanMapConfig = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _isNil = __webpack_require__(499);

var _isNil2 = _interopRequireDefault(_isNil);

var _omitBy = __webpack_require__(501);

var _omitBy2 = _interopRequireDefault(_omitBy);

var _pick = __webpack_require__(233);

var _pick2 = _interopRequireDefault(_pick);

var _uid = __webpack_require__(50);

var _alerts = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// TODO: get latitude, longitude, zoom from map + basemap: 'none'
var validMapProperties = ['basemap', 'id', 'latitude', 'longitude', 'mapViews', 'name', 'user', 'zoom'];

var validLayerProperties = ['aggregationType', 'areaRadius', 'classes', 'colorHigh', // Deprecated
'colorLow', // Deprecated
'colorScale', 'columns', 'config', 'datasetId', 'displayName', 'endDate', 'eventClustering', 'eventPointColor', 'eventPointRadius', 'filter', 'filters', 'id', 'labels', 'labelFontSize', 'labelFontStyle', 'labelFontWeight', 'labelFontColor', 'layer', 'legendSet', 'method', 'opacity', 'organisationUnitGroupSet', 'params', 'program', 'programStage', 'radiusHigh', 'radiusLow', 'rows', 'serverCluster', 'startDate', 'valueType'];

// TODO:
//  "hidden": false,
//  "userOrganisationUnit": false,
//  "userOrganisationUnitChildren": false,
//  "userOrganisationUnitGrandChildren": false,
//  "parentGraphMap": null,

var models = [
// TODO: Better way to translate models to pure object?
'program', 'programStage', 'organisationUnitGroupSet'];

var validModelProperties = ['id', 'name', 'dimensionType', 'dimensionItemType'];

// TODO: Set hidden attribute
var cleanMapConfig = exports.cleanMapConfig = function cleanMapConfig(config) {
    return _extends({}, (0, _omitBy2.default)(_isNil2.default, (0, _pick2.default)(validMapProperties, config)), {
        basemap: getBasemapString(config.basemap),
        mapViews: config.mapViews.map(cleanLayerConfig)
    });
};

var getBasemapString = function getBasemapString(basemap) {
    if (!basemap) {
        return 'osmLight';
    }

    if (basemap.isVisible === false) {
        return 'none';
    }

    return basemap.id;
};

var cleanLayerConfig = function cleanLayerConfig(config) {
    return _extends({}, models2objects((0, _pick2.default)(validLayerProperties, config)));
};

// TODO: This feels hacky, find better way to clean map configs before saving
var models2objects = function models2objects(config) {
    Object.keys(config).forEach(function (key) {
        config[key] = models.includes(key) ? (0, _pick2.default)(validModelProperties, config[key]) : config[key];
    });

    if (config.rows) {
        config.rows = config.rows.map(cleanDimension);
    }

    if (config.params) {
        // EE layer config
        config.config = JSON.stringify({
            id: config.datasetId,
            params: config.params,
            image: config.filter ? config.filter[0].arguments[1] : null,
            filter: config.filter
        });
        delete config.datasetId;
        delete config.params;
        delete config.filter;
    }

    return config;
};

var cleanDimension = function cleanDimension(dim) {
    return _extends({}, dim, {
        items: dim.items.map(function (item) {
            return (0, _pick2.default)(validModelProperties, item);
        })
    });
};

// Translate from chart/pivot config to map config
var translateConfig = exports.translateConfig = function translateConfig(config) {
    if (!config.mapViews) {
        // TODO: Best way to detect chart/pivot config
        var el = config.el,
            name = config.name;

        var dimensions = [].concat(_toConsumableArray(config.columns || []), _toConsumableArray(config.rows || []), _toConsumableArray(config.filters || []));
        var columns = [dimensions.find(function (dim) {
            return dim.dimension === 'dx';
        })]; // Data item
        var rows = [dimensions.find(function (dim) {
            return dim.dimension === 'ou';
        })]; // Org units
        var filters = [dimensions.find(function (dim) {
            return dim.dimension === 'pe';
        })]; // Period

        if (!columns.length || !rows.length || !filters.length) {
            return {
                el: el,
                name: name,
                alerts: [(0, _alerts.createAlert)(name, i18next.t('Map could not be created'))]
            };
        }

        return {
            el: el,
            name: name,
            mapViews: [{
                layer: 'thematic',
                id: (0, _uid.generateUid)(),
                name: name,
                columns: columns,
                rows: rows,
                filters: filters
            }]
        };
    }

    return config;
};

/***/ }),
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isNumeric;
/**
 * Check if a value is numeric
 *
 * @param param Value to be checked
 * @returns {boolean} Returns true when the `param` is a numeric value
 */
function isNumeric(param) {
    if ((typeof param === 'undefined' ? 'undefined' : _typeof(param)) === 'symbol') {
        return false;
    }

    return !isNaN(parseFloat(param)) && global.isFinite(param);
}
//# sourceMappingURL=isNumeric.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModelBase = __webpack_require__(113);

var _ModelBase2 = _interopRequireDefault(_ModelBase);

var _Model = __webpack_require__(95);

var _Model2 = _interopRequireDefault(_Model);

var _ModelDefinition = __webpack_require__(171);

var _ModelDefinition2 = _interopRequireDefault(_ModelDefinition);

var _ModelDefinitions = __webpack_require__(172);

var _ModelDefinitions2 = _interopRequireDefault(_ModelDefinitions);

var _ModelValidation = __webpack_require__(169);

var _ModelValidation2 = _interopRequireDefault(_ModelValidation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  ModelBase: _ModelBase2.default,
  Model: _Model2.default,
  ModelDefinition: _ModelDefinition2.default,
  ModelDefinitions: _ModelDefinitions2.default,
  ModelValidation: _ModelValidation2.default
}; /**
    * @module model
    *
    * @description
    *
    * This page will give you an introduction on one of the largest and more complex parts of d2, the metadata models.
    *
    * Models are an abstraction on top of the dhis2 metadata api. We can use these models to interact with the dhis2 api.
    * The models are accessible on the `.models` property that is attached to the d2 instance (that is retrieved by calling
    * `getInstance()`).
    *
    * A schema is a description of a type of metadata object. To find out which schemas are available for you to use with
    * d2 take a look at https://play.dhis2.org/demo/api/schemas.json?fields=name,metadata. Any schema that is marked as
    * `metadata: true` can be used with d2.
    *
    * There are a few concepts that you should familiarise yourself with before you start. (More documentation on the following
    * concepts can be found on the classes that represent them.)
    *
    * ### ModelDefinitions
    *
    * A {@link module:model.ModelDefinition} is where it all starts. In d2 the schemas you have loaded are represented by a `ModelDefinition`.
    * A `ModelDefinition` is essentially a wrapper around the schemas that allows you to create `Model` instances for that
    * specific schema (e.g. the dataElementModelDefinition allows you to create dataElement Models).
    * ```js
    * d2.models.dataElement // This is the dataElement ModelDefinition
    *  .create()            // Creates a Model object based of the dataElement ModelDefinition
    * ```
    *
    * When working with the d2 object the `d2.models` object contains modelDefinitions for the schemas that you have loaded.
    * (by default that is all schemas). To get a modelDefinition for a specific schema you ask for it by the name of the schema.
    * A few examples other than the dataElement one from above would be:
    *
    * ```js
    * d2.models.user
    * d2.models.legendSet
    * d2.models.organisationUnit
    * ```
    *
    * The ModelDefinition allows you to load objects from the api. You can either load individual items or items in bulk.
    *
    * We can use it to get specific objects
    * ```js
    * d2.models.organisationUnit.get('ImspTQPwCqd')
    *  .then(organisationUnitModel => console.log(organisationUnitModel));
    * ```
    *
    * or to load a list of objects (by default paging is enabled and it will only load the first 50 entries).
    * ```js
    * d2.models.organisationUnit.list()
    *  .then(organisationUnitCollection => console.log(organisationUnitCollection));
    * ```
    *
    * The ModelDefinition also allows you to filter on properties using a programatic syntax. To find out which
    * filter methods are available you can a look at the {@link module:model.Filter|Filter} class.
    * ```js
    * d2.models.organisationUnit
    *  .filter().on('level').equals(2)
    *  .list()
    *  .then(organisationUnitCollection => console.log(organisationUnitCollection));
    * ```
    * Applying a filter like this will create a clone of the modelDefinition with the filter applied, so you can
    * store the reference to the cloned modelDefinition and use it later, without globally applying the filter everywhere.
    *
    * ```js
    * const organisationUnitsOnLevel3 = d2.models.organisationUnit
    *  .filter().on('level').equals(3);
    *
    * const organisationUnitsOnLevel3WithParent = organisationUnitsOnLevel3
    *  .filter().on('parent.id').equals('O6uvpzGd5pu);
    *
    * organisationUnitsOnLevel3
    *  .list({ paging: false }) // Loads all organisation units on level 3
    *  .then(organisationUnitCollection => console.log(organisationUnitCollection));
    *
    * organisationUnitsOnLevel3WithParent
    *  .list({ paging: false }) // Loads all organisation units on level 3 with O6uvpzGd5pu as their parent
   *   .then(organisationUnitCollection => console.log(organisationUnitCollection));
    * ```
    *
    * As you might have noticed we passed `{ paging: false }` to the `.list` method. Any options passed to the list method
    * (with the exception of filter) will be passed through as regular query parameters.
    *
    * If you ran the above examples you would notice that the `.list` method returns a ModelCollection.
    *
    * ## ModelCollection
    * A {@link module:model.ModelCollection|ModelCollection} is simple a collection of Model objects. The ModelCollection is
    * sometimes somewhat cumbersome to work with and often you would like to transform the ModelCollection to an array using
    * the `.toArray()` method or spreading the values of the ModelCollection.
    *
    * ```js
    * d2.models.organisationUnit
    *  .filter().on('level').equals(2)
    *  .list()
    *  .then(organisationUnitCollection => {
    *    let organisationUnits = organisationUnitCollection.toArray();
    *    // or
    *    organisationUnits = [...organisationUnitCollection.values()];
    * });
    * ```
    *
    * The ModelCollection does not only contain the Models, it also gives you access to a {@link module:model.Pager|Pager}.
    * The pager objects keeps track of which page was loaded and how many pages there are.
    *
    * The following example will load the first page of organisation units and then keep loading a new page every second
    * until we run out of pages.
    * ```js
    * function loadNextPage(pager, callback) {
    *   if (pager.hasNextPage()) {
    *     pager.getNextPage()
    *       .then(organisationUnitCollection  => {
    *         setTimeout(() => {
    *           callback(organisationUnitCollection);
    *           loadNextPage(organisationUnitCollection.pager, callback);
    *         }, 1000);
    *       });
    *   }
    * }
    *
    * const printCollection = collection => console.log(collection.toArray());
    *
    * d2.models.organisationUnit
    *   .list()
    *   .then(organisationUnitCollection => {
    *     printCollection(organisationUnitCollection);
    *     loadNextPage(organisationUnitCollection.pager, printCollection);
    *   });
    * ```
    *
    * ## Model
    * TODO: :(
    */
//# sourceMappingURL=index.js.map

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = __webpack_require__(15);

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @description
 * Handles communication with the systemSettings endpoint. Can be used to get or save systemSettings.
 *
 * @memberof module:system
 * @requires lib/check
 * @requires api/Api
 */
// TODO: Return the values from the local cache if we have not updated it? We could
var SystemSettings = function () {
    function SystemSettings() {
        var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Api2.default.getApi();

        _classCallCheck(this, SystemSettings);

        this.api = api;
    }

    /**
     * Loads all the system settings in the system and returns them as an object from the promise.
     *
     * @returns {Promise} Promise that resolves with the systemsettings object from the api.
     *
     * @example
     * d2.system.settings.all()
     *  .then(systemSettings => {
     *    console.log('Analytics was last updated on: ' + systemSettings.keyLastSuccessfulResourceTablesUpdate);
     *  });
     */


    _createClass(SystemSettings, [{
        key: 'all',
        value: function all() {
            var _this = this;

            return this.settings ? Promise.resolve(this.settings) : this.api.get('systemSettings').then(function (settings) {
                _this.settings = settings;
                return Promise.resolve(_this.settings);
            });
        }

        /**
         * Get a single systemSetting for the given key.
         *
         * This will use the cached value of the key if it has been previously loaded.
         *
         * @param {String} systemSettingsKey The identifier of the system setting that should be retrieved.
         * @returns {Promise} A promise that resolves with the value or will fail if the value is not available.
         *
         * @example
         * d2.system.settings.get('keyLastSuccessfulResourceTablesUpdate')
         *  .then(systemSettingsValue => {
         *    console.log('Analytics was last updated on: ' + systemSettingsValue);
         *  });
         */

    }, {
        key: 'get',
        value: function get(systemSettingsKey) {
            var _this2 = this;

            if (this.settings && this.settings[systemSettingsKey]) {
                return Promise.resolve(this.settings[systemSettingsKey]);
            }

            function processValue(value) {
                // Attempt to parse the response as JSON. If this fails we return the value as is.
                try {
                    return JSON.parse(value);
                } catch (e) {
                    return value;
                }
            }

            return new Promise(function (resolve, reject) {
                if (!(0, _check.isString)(systemSettingsKey)) {
                    throw new TypeError('A "key" parameter should be specified when calling get() on systemSettings');
                }

                var options = { headers: { accept: 'text/plain' } };
                _this2.api.get(['systemSettings', systemSettingsKey].join('/'), undefined, options).then(function (response) {
                    if (response) {
                        resolve(processValue(response));
                    }
                    reject(new Error('The requested systemSetting has no value or does not exist.'));
                });
            });
        }
    }, {
        key: 'set',
        value: function set(systemSettingsKey, value) {
            delete this.settings;

            var settingUrl = ['systemSettings', systemSettingsKey].join('/');
            if (value === null || ('' + value).length === 0) {
                return this.api.delete(settingUrl);
            }
            return this.api.post(settingUrl, value, { headers: { 'Content-Type': 'text/plain' } });
        }
    }]);

    return SystemSettings;
}();

exports.default = SystemSettings;
//# sourceMappingURL=SystemSettings.js.map

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Handles communication with the configuration endpoint. Can be used to get or set configuration options.
 *
 * @memberof module:system
 */
var SystemConfiguration = function () {
    function SystemConfiguration() {
        var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Api2.default.getApi();

        _classCallCheck(this, SystemConfiguration);

        this.api = api;

        this.configuration = undefined;
        this.configPromise = null;
    }

    /**
     * Fetches all system configuration settings from the API and caches them so that future
     * calls to this function won't call the API again.
     *
     * @param {boolean} [ignoreCache=false] If set to true, calls the API regardless of cache status
     * @returns {Promise} Promise that resolves with all the individual configuration options from the api.
     */


    _createClass(SystemConfiguration, [{
        key: 'all',
        value: function all(ignoreCache) {
            var _this = this;

            if (this.configPromise === null || ignoreCache === true) {
                this.configPromise = this.api.get('configuration').then(function (configuration) {
                    _this.configuration = configuration;
                    return _this.configuration;
                });
            }

            return this.configPromise;
        }

        /**
         * Returns the value of the specified configuration option.
         *
         * This is a convenience method that works exactly the same as calling `configuration.all()[name]`.
         *
         * @param key {String}
         * @param {boolean} [ignoreCache=false] If set to true, calls the API regardless of cache status
         * @returns {Promise}
         */

    }, {
        key: 'get',
        value: function get(key, ignoreCache) {
            return this.all(ignoreCache).then(function (config) {
                if (config.hasOwnProperty(key)) {
                    return Promise.resolve(config[key]);
                }

                return Promise.reject('Unknown config option: ' + key);
            });
        }

        /**
         * Send a query to the API to change the value of a configuration key to the specified value.
         *
         * @param key {String}
         * @param value {String|null}
         * @returns {Promise}
         */
        /* eslint-disable complexity */

    }, {
        key: 'set',
        value: function set(key, value) {
            var that = this;
            var req = void 0;

            if (key === 'systemId') {
                return Promise.reject('The system ID can\'t be changed');
            } else if ((key === 'feedbackRecipients' || key === 'selfRegistrationOrgUnit' || key === 'selfRegistrationRole') && (value === 'null' || value === null)) {
                // Only valid UIDs are accepted when POST'ing, so we have to use DELETE in stead of POST'ing a null value.
                req = this.api.delete(['configuration', key].join('/'));
            } else if (key === 'corsWhitelist') {
                // The corsWhitelist endpoint expects a JSON array (of URLs), while here value is expected to be a string.
                req = this.api.post(['configuration', key].join('/'), value.trim().split('\n'));
            } else {
                req = this.api.post(['configuration', key].join('/'), value, {
                    dataType: 'text',
                    contentType: 'text/plain'
                });
            }

            return req.then(function () {
                // Ideally we'd update the cache here, but doing so requires another trip to the server
                // For now, just bust the cache to ensure it's not incorrect
                that.configuration = undefined;
                return Promise.resolve();
            }).catch(function () {
                return Promise.reject('No configuration found for ' + key);
            });
        }
        /* eslint-enable complexity */

    }]);

    return SystemConfiguration;
}();

exports.default = SystemConfiguration;
//# sourceMappingURL=SystemConfiguration.js.map

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pickOwnerFromModelValidation = exports.pickEmbeddedObjectFromModelValidation = exports.pickTypeFromModelValidation = undefined;
exports.hasModelValidationForProperty = hasModelValidationForProperty;
exports.updateModelFromResponseStatus = updateModelFromResponseStatus;

var _uid = __webpack_require__(50);

var _check = __webpack_require__(15);

var _utils = __webpack_require__(29);

var hasPropertyOnModelValidation = function hasPropertyOnModelValidation(property, model) {
    return Boolean((0, _utils.pick)('modelDefinition.modelValidations.' + property)(model));
};

function hasModelValidationForProperty(model, property) {
    return Boolean(hasPropertyOnModelValidation(property, model) && (0, _check.hasOwnProperty)(model.modelDefinition.modelValidations, property));
}

var pickHttpStatus = (0, _utils.pick)('httpStatus');
var pickResponseUid = (0, _utils.pick)('response.uid');
var getModelValidationForProperty = function getModelValidationForProperty(propertyName) {
    return (0, _utils.pick)('modelDefinition.modelValidations.' + propertyName);
};
var pickType = (0, _utils.pick)('type');
var pickEmbeddedObject = (0, _utils.pick)('embeddedObject');
var pickOwner = (0, _utils.pick)('owner');

var pickTypeFromModelValidation = exports.pickTypeFromModelValidation = function pickTypeFromModelValidation(property, model) {
    return pickType(getModelValidationForProperty(property)(model));
};
var pickEmbeddedObjectFromModelValidation = exports.pickEmbeddedObjectFromModelValidation = function pickEmbeddedObjectFromModelValidation(property, model) {
    return pickEmbeddedObject(getModelValidationForProperty(property)(model));
};

var pickOwnerFromModelValidation = exports.pickOwnerFromModelValidation = function pickOwnerFromModelValidation(property, model) {
    return pickOwner(getModelValidationForProperty(property)(model));
};

// This function is called with `.call` with the Model as it's `this`
function updateModelFromResponseStatus(result) {
    var responseUid = pickResponseUid(result);

    // Set the id and href of the newly created object if we got an id in the response
    if (pickHttpStatus(result) === 'Created' && (0, _uid.isValidUid)(responseUid)) {
        this.dataValues.id = responseUid;
        this.dataValues.href = [this.modelDefinition.apiEndpoint, this.dataValues.id].join('/');
    }

    // Object is saved to the api, so it's now clean
    this.resetDirtyState();

    return result;
}
//# sourceMappingURL=models.js.map

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _check = __webpack_require__(15);

var _utils = __webpack_require__(29);

var getValue = (0, _utils.pick)('value');
var getAttributeValueAttributeName = (0, _utils.pick)('attribute.name');

function createPropertyDefinitionsForAttributes(attributeProperties, getAttributeValues, setAttributeValues, setDirty) {
    return Object.keys(attributeProperties).reduce(function (propertyDefinitions, attributeName) {
        propertyDefinitions[attributeName] = { // eslint-disable-line no-param-reassign
            enumerable: true,
            get: function get() {
                var attributeValues = getAttributeValues();

                return attributeValues.filter(function (attributeValue) {
                    return getAttributeValueAttributeName(attributeValue) === attributeName;
                }).reduce(function (current, attributeValue) {
                    return attributeValue.value;
                }, undefined);
            },
            set: function set(value) {
                var attributeValue = getAttributeValues().filter(function (av) {
                    return av.attribute.name === attributeName;
                }).reduce(function (current, av) {
                    return av;
                }, undefined);

                if ((0, _check.areDefinedAndEqual)(getValue(attributeValue), value)) {
                    return; // Don't do anything if the value stayed the same
                }

                if (attributeValue) {
                    // Remove the attributeValue from the array of attributeValues on the object
                    // This is done because the server can not handle them properly when empty strings
                    // as values are sent. It will properly remove the attributeValue
                    // on the server side when they are not being send to the server at all.
                    if ((0, _check.isNullUndefinedOrEmptyString)(value)) {
                        var remainingAttributeValues = getAttributeValues().filter(function (av) {
                            return av !== attributeValue;
                        });
                        setAttributeValues(remainingAttributeValues);
                    }

                    attributeValue.value = value;
                } else {
                    // Add the new attribute value to the attributeValues collection
                    setAttributeValues(getAttributeValues().concat({
                        value: value,
                        attribute: {
                            id: attributeProperties[attributeName].id,
                            name: attributeProperties[attributeName].name
                        }
                    }));
                }

                // Set the model to be dirty
                setDirty();
            }
        };

        return propertyDefinitions;
    }, {});
}

exports.default = createPropertyDefinitionsForAttributes;
//# sourceMappingURL=attibutes.js.map

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = __webpack_require__(15);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @description
 * Pager object that can be used to navigate pages within a `Modelcollection`
 *
 * @memberof module:model
 */

/**
  * @memberof module:model
  */
// TODO: Move to the model map
var Pager = function () {
  /**
   * @constructor
   *
   * @param {Object} [pager={page: 1, pageCount: 1}] Paging information object.
   * @param {Object} [pagingHandler={list: () => Promise.reject('No handler available')}] Paging handler object. The requirement for this object is that it has a list method.
   *
   * @description
   * Returns a newly created pager object with methods to navigate pages.
   */
  function Pager() {
    var pager = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { page: 1, pageCount: 1, query: {} };
    var pagingHandler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { list: function list() {
        return Promise.reject('No handler available');
      } };

    _classCallCheck(this, Pager);

    /**
     * @property {number} page Current page number
     */
    this.page = pager.page;

    /**
     * @property {number} pageCount The total number of pages available
     */
    this.pageCount = pager.pageCount;

    /**
     * @property {number} total The total number of items available.
     *
     * @description
     * This represents the total number of items available in the system. Note it is not the number of items
     * on the current page.
     */
    this.total = pager.total;

    /**
     * @property {string} nextPage The url to the next page.
     *
     * @description
     * If there is no next page then this will be undefined.
     */
    this.nextPage = pager.nextPage;

    /**
     * @property {string} prevPage The url to the previous page
     *
     * @description
     * If there is no previous page then this will be undefined.
     */
    this.prevPage = pager.prevPage;

    /**
     * @property {object} query Query parameters
     *
     * @description
     * Query parameters are used for things like filtering and field selection. Used to guarantee that pages are
     * from the same collection.
     */
    this.query = pager.query;

    this.pagingHandler = pagingHandler;
  }

  /**
   * @returns {Boolean} Result is true when there is a next page, false when there is not.
   *
   * @description
   * Check whether there is a next page.
   */


  _createClass(Pager, [{
    key: 'hasNextPage',
    value: function hasNextPage() {
      return (0, _check.isDefined)(this.nextPage);
    }

    /**
     * Check whether there is a previous page.
     *
     * @returns {Boolean} Result is true when there is a previous page, false when there is not.
     */

  }, {
    key: 'hasPreviousPage',
    value: function hasPreviousPage() {
      return (0, _check.isDefined)(this.prevPage);
    }

    /**
     * @description
     * Loads the next page in the collection if there is one. If no additional pages are available the Promise will reject.
     *
     * @returns {Promise} Promise that resolves with a new `ModelCollection` containing the next page's data. Or rejects with
     * a string when there is no next page for this collection or when the request for the next page failed.
     *
     * @example
     * d2.models.organisationUnit
     *   .list()
     *   .then(collection => {
     *     collection.pager.getNextPage()
     *       .then(secondPageCollection => {
     *         console.log(secondPageCollection.toArray());
     *       });
     *   });
     */

  }, {
    key: 'getNextPage',
    value: function getNextPage() {
      if (this.hasNextPage()) {
        return this.goToPage(this.page + 1);
      }
      return Promise.reject('There is no next page for this collection');
    }

    /**
     * @description
     * Loads the previous page in the collection if there is one. If no previous pages are available the Promise will reject.
     *
     * @returns {Promise} Promise that resolves with a new `ModelCollection` containing the previous page's data. Or rejects with
     * a string when there is no previous page for this collection or when the request for the previous page failed.
     *
     * @example
     * d2.models.organisationUnit
     *   .list()
     *   .then(collection => {
     *     collection.pager.goToPage(3)
     *       .then(collection => collection.pager.getPreviousPage())
     *       .then(secondPageCollection => {
     *         console.log(secondPageCollection.toArray());
     *       });
     *   });
     */

  }, {
    key: 'getPreviousPage',
    value: function getPreviousPage() {
      if (this.hasPreviousPage()) {
        return this.goToPage(this.page - 1);
      }
      return Promise.reject('There is no previous page for this collection');
    }

    /**
     * Loads a specific page for the collection. If the requested page is out of the range of available pages (e.g < 0 or > page count)
     * the Promise will reject with an error.
     *
     * @param {Number} pageNr The number of the page you wish to navigate to.
     * @returns {Promise} Promise that resolves with a new `ModelCollection` containing the data for the requested page.
     *
     * @example
     * d2.models.organisationUnit
     *   .list()
     *   .then(collection => {
     *     collection.pager.goToPage(4)
     *       .then(fourthPageCollection => {
     *         console.log(fourthPageCollection.toArray());
     *       });
     *   });
     */
    // TODO: Throwing the errors here is not really consistent with the rejection of promises for the getNextPage and getPreviousPage

  }, {
    key: 'goToPage',
    value: function goToPage(pageNr) {
      if (pageNr < 1) {
        throw new Error('PageNr can not be less than 1');
      }
      if (pageNr > this.pageCount) {
        throw new Error('PageNr can not be larger than the total page count of ' + this.pageCount);
      }

      return this.pagingHandler.list(Object.assign({}, this.query, { page: pageNr }));
    }
  }]);

  return Pager;
}();

exports.default = Pager;
//# sourceMappingURL=Pager.js.map

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

var _ModelCollection2 = __webpack_require__(149);

var _ModelCollection3 = _interopRequireDefault(_ModelCollection2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A ModelCollectionProperty instance is a ModelCollection that is a property of
 * a model instance. ModelCollectionProperties can be operated on independently of
 * the Model that owns them.
 *
 * @memberof module:model
 */
var ModelCollectionProperty = function (_ModelCollection) {
    _inherits(ModelCollectionProperty, _ModelCollection);

    /**
     * @constructor
     *
     * @param {Model} parentModel The `Model` of the parent of this `ModelCollectionProperty`
     * @param {ModelDefinition} modelDefinition The `ModelDefinition` that this `ModelCollection` property is for
     * @param {String} propName The name of this property on the parent model
     * @param {Model[]|boolean} values Initial values that should be added to the collection property
     * @param {Api} api The class to use for API calls
     *
     * @description
     *
     * Creates a new `ModelCollectionProperty` object. This is a subclass of `ModelCollection`, which adds logic
     * for adding and removing elements to the collection and saving the changes to the API.
     *
     * If the value is `true` or `undefined` is specified instead of an array of data values, this indicates that the
     * collection contains (or may contain) data that has not yet been loaded from the API.
     */
    function ModelCollectionProperty(parentModel, modelDefinition, propName, values, api) {
        _classCallCheck(this, ModelCollectionProperty);

        // The name of this property on the parent object - necessary for loading values lazily
        var _this = _possibleConstructorReturn(this, (ModelCollectionProperty.__proto__ || Object.getPrototypeOf(ModelCollectionProperty)).call(this, modelDefinition, values, undefined));

        _this.propName = propName;

        // Dirty bit - true if any models have been added to or removed from the collection
        _this.dirty = false;

        // Keep track of added and removed elements
        _this.added = new Set();
        _this.removed = new Set();

        // Using field transformers, it's possible to query the API for the presence of data without actually fetching
        // the data. For instance this is used to determine if an organization unit has any children without actually
        // loading the children. If yes, it will be displayed as an expandable branch within the tree.
        // For more information, see the documentation about field transformers, specifically the isNotEmpty operator:
        // https://docs.dhis2.org/master/en/developer/html/dhis2_developer_manual_full.html#webapi_field_transformers
        _this.hasUnloadedData = values === true || values === undefined;

        _this.api = api;

        // Store the parent model of this collection so we can construct the URI for API calls
        _this.parentModel = parentModel;
        return _this;
    }

    /**
     * @param {Model} value Model instance to add to the collection.
     * @returns {ModelCollectionProperty} Returns itself for chaining purposes.
     *
     * @description
     * Calls the `add` method on the parent `ModelCollection` class, and then performs checks to keep track of
     * what, if any, changes that have been made to the collection.
     */


    _createClass(ModelCollectionProperty, [{
        key: 'add',
        value: function add(value) {
            if (this.valuesContainerMap.has(value.id)) {
                return this;
            }

            _get(ModelCollectionProperty.prototype.__proto__ || Object.getPrototypeOf(ModelCollectionProperty.prototype), 'add', this).call(this, value);

            if (this.removed.has(value.id)) {
                this.removed.delete(value.id);
            } else {
                this.added.add(value.id);
            }

            this.updateDirty();
            return this;
        }

        /**
         * If the collection contains an object with the same id as the `value` parameter, that object is removed
         * from the collection. Checks are then performed to keep track of what, if any, changes that have been
         * made to the collection.
         *
         * @param {Model} value Model instance to remove from the collection.
         * @returns {ModelCollectionProperty} Returns itself for chaining purposes.
         */

    }, {
        key: 'remove',
        value: function remove(value) {
            _ModelCollection3.default.throwIfContainsOtherThanModelObjects([value]);
            _ModelCollection3.default.throwIfContainsModelWithoutUid([value]);

            if (this.delete(value.id)) {
                if (this.added.has(value.id)) {
                    this.added.delete(value.id);
                } else {
                    this.removed.add(value.id);
                }
            }

            this.updateDirty();
            return this;
        }

        /**
         * Checks whether any changes have been made to the collection, and updates the dirty flag accordingly.
         *
         * @returns {boolean} True if the collection has changed, false otherwise.
         */

    }, {
        key: 'updateDirty',
        value: function updateDirty() {
            this.dirty = this.added.size > 0 || this.removed.size > 0;
            return this.dirty;
        }

        /**
         * Sets dirty=false and resets the added and removed sets used for dirty state tracking.
         */

    }, {
        key: 'resetDirtyState',
        value: function resetDirtyState() {
            this.dirty = false;
            this.added = new Set();
            this.removed = new Set();
        }

        /**
         * Checks if the collection property has been modified.
         * @param {boolean} [includeValues=true] If true, also checks if any models in the collection
         * has been edited by checking the dirty flag on each model.
         * @returns {boolean} true if any elements have been added to or removed from the collection
         */

    }, {
        key: 'isDirty',
        value: function isDirty() {
            var includeValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            if (includeValues) {
                return this.dirty || this.toArray().filter(function (model) {
                    return model && model.isDirty() === true;
                }).length > 0;
            }
            return this.dirty;
        }

        /**
         * If any changes have been made to the collection, these changes will be submitted to the API. The returned
         * promise will resolve successfully when the changes have been saved to the API, and will be rejected if
         * either the changes weren't saved or if there were no changes to save.
         *
         * @returns {Promise} A `Promise`
         */

    }, {
        key: 'save',
        value: function save() {
            var _this2 = this;

            // Calling save when there's nothing to be saved is a no-op (not an error)
            if (!this.isDirty()) {
                return Promise.resolve({});
            }

            var url = [this.parentModel.href, this.modelDefinition.plural].join('/');
            var data = {
                additions: Array.from(this.added).map(function (id) {
                    return { id: id };
                }),
                deletions: Array.from(this.removed).map(function (id) {
                    return { id: id };
                })
            };

            return this.api.post(url, data).then(function () {
                _this2.resetDirtyState();
                return Promise.resolve({});
            }).catch(function (err) {
                return Promise.reject('Failed to alter collection:', err);
            });
        }
    }, {
        key: 'load',
        value: function load(options) {
            var _this3 = this;

            var forceReload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (!this.hasUnloadedData && !forceReload) {
                return Promise.resolve(this);
            }

            var url = [this.parentModel.modelDefinition.apiEndpoint, this.parentModel.id].join('/');
            var requestOptions = Object.assign({
                paging: false
            }, options, { fields: this.propName + '[' + (options && options.fields || ':all') + ']' });

            return this.api.get(url, requestOptions).then(function (data) {
                return data[_this3.propName];
            }).then(function (values) {
                if (Array.isArray(values)) {
                    values.forEach(function (value) {
                        return _this3.valuesContainerMap.set(value.id, _this3.modelDefinition.create(value));
                    });
                }
                _this3.hasUnloadedData = false;
                return Promise.resolve(_this3);
            });
        }

        /**
         * See `ModelCollectionProperty.constructor`.
         *
         * @param {Model} parentModel
         * @param {ModelDefinition} modelDefinition
         * @param {Model[]} values
         * @returns {ModelCollectionProperty}
         */

    }], [{
        key: 'create',
        value: function create(parentModel, modelDefinition, propName, values) {
            return new ModelCollectionProperty(parentModel, modelDefinition, propName, values, _Api2.default.getApi());
        }
    }]);

    return ModelCollectionProperty;
}(_ModelCollection3.default);

exports.default = ModelCollectionProperty;
//# sourceMappingURL=ModelCollectionProperty.js.map

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(29);

var _check = __webpack_require__(15);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SchemaTypes = function () {
    function SchemaTypes() {
        _classCallCheck(this, SchemaTypes);
    }

    _createClass(SchemaTypes, [{
        key: 'getTypes',
        value: function getTypes() {
            // eslint-disable-line class-methods-use-this
            return ['TEXT', 'NUMBER', 'INTEGER', 'BOOLEAN', 'EMAIL', 'PASSWORD', 'URL', 'PHONENUMBER', 'GEOLOCATION', // TODO: Geo location could be an advanced type of 2 numbers / strings?
            'COLOR', 'COMPLEX', 'COLLECTION', 'REFERENCE', 'DATE', 'COMPLEX', 'IDENTIFIER', 'CONSTANT'];
        }
    }, {
        key: 'typeLookup',
        value: function typeLookup(propertyType) {
            if (this.getTypes().indexOf(propertyType) >= 0 && (0, _check.isString)(propertyType)) {
                return propertyType;
            }

            return (0, _utils.throwError)(['Type from schema "', propertyType, '" not found available type list.'].join(''));
        }
    }]);

    return SchemaTypes;
}();

exports.default = new SchemaTypes();
//# sourceMappingURL=SchemaTypes.js.map

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = __webpack_require__(15);

var _utils = __webpack_require__(29);

var _Filter = __webpack_require__(287);

var _Filter2 = _interopRequireDefault(_Filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @description
 * Collection class that contains filters that are to be applied when loading Model objects from the api.
 *
 * @memberof module:model
 */
var Filters = function () {
  /**
   * Creates a new Filters instance.
   *
   * The Filters instance keeps a list of all the applied filters for a modelDefinition.
   *
   * @param {ModelDefinition} modelDefinition The ModelDefinition for which this Filters object should create filters.
   * @param {Filter[]} filters A list of Filter objects
   */
  function Filters(modelDefinition) {
    var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    _classCallCheck(this, Filters);

    /**
     * @type {Array<Filter>}
     * @private
     */
    this.filters = filters;
    this.modelDefinition = modelDefinition;
  }

  /**
   * Shortcut for triggering the creation of a Filter. This is the function that is triggered when creating new
   * filters on a ModelDefinition. The Filter will receive a callback that can be used to add the finalized filter
   * to the list of filters.
   *
   * @param {string} propertyName The property that the filter should apply to. (e.g. `name`)
   * @returns {Filter} The created filter object for `propertyName`.
   */


  _createClass(Filters, [{
    key: 'on',
    value: function on(propertyName) {
      var addFilter = this.add.bind(this);

      return _Filter2.default.getFilter(addFilter).on(propertyName);
    }

    /**
     * Utility method to add a filter to the list of filters.
     *
     * @private
     * @param {Filter} filter The Filter to be added to the list of current filters.
     * @returns {ModelDefinition} The modelDefiniton that the filter applies to. This is used to support calling `.list()`
     * on the modelDefinition after the filter was created.
     * @throws {TypeError} Thrown when the given filter is not a Filter object.
     */

  }, {
    key: 'add',
    value: function add(filter) {
      if (!(0, _check.isType)(filter, _Filter2.default)) {
        throw new TypeError('filter should be an instance of Filter');
      }
      this.filters.push(filter);

      return this.modelDefinition;
    }

    /**
     * @deprecated
     * @returns {Promise} Proxy the list() call on the filters object.
     */

  }, {
    key: 'list',
    value: function list() {
      return this.modelDefinition.list();
    }

    /**
     * Get an array of DHIS2 metadata filter values to send to the API.
     *
     * This will return ['id:eq:UYXOT4A7JMI', 'name:like:ANC'] for filters created as follows
     * dataElement
     *  .filter().on('id').equals(UYXOT4A7JMI)
     *  .filter().on('name').like('ANC')
     *
     * @returns {Array<string>} A list of query param values to be used with the filter key.
     */

  }, {
    key: 'getQueryFilterValues',
    value: function getQueryFilterValues() {
      return this.filters.map(function (filter) {
        return filter.getQueryParamFormat();
      });
    }

    /**
     * @deprecated Deprecated since 2.28, use getQueryFilterValues instead.
     * @returns {Array.<string>}
     */

  }, {
    key: 'getFilters',
    value: function getFilters() {
      return this.getQueryFilterValues();
    }

    /**
     * Get a list of Filter objects that are in applied in this Filters instance
     *
     * @returns {Array<Filter>} The list of Filter objects.
     */

  }, {
    key: 'getFilterList',
    value: function getFilterList() {
      return this.filters.map(_utils.identity);
    }

    /**
     * Factory method to create a Filters object.
     *
     * @param {ModelDefinition} modelDefinition The modelDefinition that the filters should apply to.
     * @param {Filter[]} priorFilters List of previously applied filters that the new filter list should start with.
     * @returns {Filters} A Filters object for the given modelDefinition.
     */

  }], [{
    key: 'getFilters',
    value: function getFilters(modelDefinition) {
      var priorFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      return new Filters(modelDefinition, priorFilters);
    }
  }]);

  return Filters;
}();

exports.default = Filters;
//# sourceMappingURL=Filters.js.map

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = __webpack_require__(15);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FILTER_COMPARATORS = {
  /**
   * @function equals
   * @memberof module:model.Filter.prototype
   * @returns {Filter} Returns the modified filter for chaining
   *
   * @description
   * This method can be used to add a equals filter value
   */
  equals: 'eq',
  /**
   * @function like
   * @memberof module:model.Filter.prototype
   * @returns {Filter} Returns the modified filter for chaining
   *
   * @description
   * This method can be used to add a like filter value
   */
  like: 'like',
  /**
   * @function ilike
   * @memberof module:model.Filter.prototype
   * @returns {Filter} Returns the modified filter for chaining
   *
   * @description
   * This method can be used to add a ilike filter value
   */
  ilike: 'ilike',
  /**
   * @function
   * @memberof module:model.Filter.prototype
   * @returns {Filter} Returns the modified filter for chaining
   *
   * @description
   * This method can be used to add a ne filter value
   */
  notEqual: 'ne'
};

/**
 * Filter class that can be used to build api endpoint filters using a semi-natural language style.
 *
 * @memberof module:model
 */

var Filter = function () {
  /**
   * @constructor
   * @param {Function} addFilterCallback Callback that will be used to notify Filters that the filter is completed
   * so it can be added to the list of filters.
   */
  function Filter(addFilterCallback) {
    _classCallCheck(this, Filter);

    this.addFilterCallback = addFilterCallback;
    this.propertyName = 'name';
    this.comparator = 'like';
    this.filterValue = undefined;
  }

  /**
   * @param {String} propertyName Property name that the filter should be applied on.
   * @returns {Filter}
   */


  _createClass(Filter, [{
    key: 'on',
    value: function on(propertyName) {
      (0, _check.checkDefined)(propertyName, 'Property name to filter on');

      this.propertyName = propertyName;
      return this;
    }

    /**
     * Utility function used to get the query parameter value in a DHIS2 metadata filter format that can be
     * send to the api. This returned value is appended to the `filter=` part of the query.
     *
     * @private
     * @note {warning} Usually not used directly and only used by Filters to create the query param values.
     *
     * @returns {string} The query param value to be appended to `filter=`
     */

  }, {
    key: 'getQueryParamFormat',
    value: function getQueryParamFormat() {
      return [this.propertyName, this.comparator, this.filterValue].join(':');
    }

    /**
     * @static
     *
     * @param {Function} addFilterCallback Callback to be called when the filter is completed.
     *
     * @returns {Filter} A instance of the Filter class that can be used to create
     * filters.
     *
     * @description
     * Create a filter instance
     */

  }], [{
    key: 'getFilter',
    value: function getFilter(addFilterCallback) {
      return new Filter(addFilterCallback);
    }
  }]);

  return Filter;
}();

// Add the filters to the Filter prototype


Object.keys(FILTER_COMPARATORS).forEach(function (filter) {
  Object.defineProperty(Filter.prototype, filter, {
    value: function filterGetter(filterValue) {
      (0, _check.checkDefined)(filterValue, 'filterValue');

      this.comparator = FILTER_COMPARATORS[filter];
      this.filterValue = filterValue;

      return this.addFilterCallback(this);
    }
  });
});

exports.default = Filter;
//# sourceMappingURL=Filter.js.map

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dataDimension: true
};
//# sourceMappingURL=organisationUnitGroupSet.js.map

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dataDimension: true
};
//# sourceMappingURL=category.js.map

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dataDimension: true
};
//# sourceMappingURL=categoryOptionGroupSet.js.map

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    aggregationType: 'SUM',
    valueType: 'NUMBER'
};
//# sourceMappingURL=dataElement.js.map

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dataDimension: true
};
//# sourceMappingURL=dataElementGroupSet.js.map

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    expiryDays: 0,
    openFuturePeriods: 0,
    timelyDays: 15,
    periodType: 'Monthly'
};
//# sourceMappingURL=dataSet.js.map

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    mapService: 'WMS',
    imageFormat: 'PNG',
    mapLayerPosition: 'BASEMAP'
};
//# sourceMappingURL=externalMapLayer.js.map

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    notificationRecipient: 'ORGANISATION_UNIT_CONTACT',
    deliveryChannels: [],
    notifyUsersInHierarchyOnly: false
};
//# sourceMappingURL=validationNotificationTemplate.js.map

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    importance: 'MEDIUM',
    periodType: 'Monthly',
    operator: 'not_equal_to',
    leftSide: {
        missingValueStrategy: 'NEVER_SKIP',
        description: '',
        expression: ''
    },
    rightSide: {
        missingValueStrategy: 'NEVER_SKIP',
        description: '',
        expression: ''
    }
};
//# sourceMappingURL=validationRule.js.map

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    version: 0,
    completeEventsExpiryDays: 0,
    expiryDays: 0
};
//# sourceMappingURL=program.js.map

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    notificationTrigger: 'COMPLETION',
    notificationRecipient: 'USERS_AT_ORGANISATION_UNIT'
};
//# sourceMappingURL=programNotificationTemplate.js.map

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @module i18n
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * I18n class for dealing with translations
 */
var I18n = function () {
    function I18n() {
        var sources = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Api2.default.getApi();

        _classCallCheck(this, I18n);

        this.sources = sources;
        this.api = api;
        this.strings = new Set();
        this.translations = undefined;
    }

    /**
     * Adds a .properties file to the list of sources to load translations from
     *
     * Files are loaded in the order they're added, and the first translation of each string that's encountered will be
     * used.
     *
     * @param {String} path
     */


    _createClass(I18n, [{
        key: 'addSource',
        value: function addSource(path) {
            this.sources.push(path);
        }

        /**
         * Adds one or more strings to the list of strings to translate
         *
         * @param {(String[]|String)} strings
         */

    }, {
        key: 'addStrings',
        value: function addStrings(strings) {
            var _this = this;

            if (typeof strings === 'string' && strings.trim().length > 0) {
                this.strings.add(strings.trim());
            } else {
                Array.from(strings).filter(function (string) {
                    return string && ('' + string).trim().length > 0;
                }).forEach(function (string) {
                    return _this.strings.add(string);
                });
            }
        }

        /**
         * Load translations
         *
         * First, all properties files (specified with addSource) are loaded.
         * Then, if any untranslated strings remain, these are POSTed to the i18n endpoint of the DHIS2 API.
         *
         * @returns {Promise}
         */

    }, {
        key: 'load',
        value: function load() {
            var _this2 = this;

            var i18n = this;
            i18n.translations = {};

            function parseProperties(text) {
                return text.split('\n').reduce(function (props, line) {
                    var _line$split$map = line.split('=').map(function (out) {
                        return out.trim();
                    }),
                        _line$split$map2 = _slicedToArray(_line$split$map, 2),
                        key = _line$split$map2[0],
                        value = _line$split$map2[1];

                    if (key !== undefined && value !== undefined && !props.hasOwnProperty(key)) {
                        props[key] = value // eslint-disable-line no-param-reassign
                        .replace(/\\u([0-9a-f]{4})/gi, function (match, grp) {
                            return String.fromCharCode(parseInt(grp, 16));
                        });
                    }
                    return props;
                }, {});
            }

            var propFiles = [];

            this.sources.forEach(function (source) {
                propFiles.push(i18n.api.request('GET', source).then(function (data) {
                    return Promise.resolve(parseProperties(data));
                },

                // Resolve errors to an empty object, so that one missing file doesn't prevent
                // the rest from being loaded
                function () {
                    return Promise.resolve({});
                }));
            });

            return Promise.all(propFiles).then(function (propFile) {
                propFile.forEach(function (props) {
                    Object.keys(props).forEach(function (str) {
                        if (!i18n.translations.hasOwnProperty(str)) {
                            i18n.translations[str] = props[str];
                        }
                        _this2.strings.delete(str);
                    });
                });

                if (_this2.strings.size > 0) {
                    return i18n.api.post('i18n', Array.from(i18n.strings)).then(function (res) {
                        Object.keys(res).filter(function (str) {
                            return str !== res[str];
                        }).forEach(function (str) {
                            i18n.translations[str] = res[str];
                            i18n.strings.delete(str);
                        });

                        return Promise.resolve(i18n.translations);
                    });
                }

                return Promise.resolve(i18n.translations);
            });
        }

        /**
         * Gets the translated version of the specified string
         *
         * If no translation exists for the specified string, the string is returned as is with two asterisks on each side,
         * in order to easily identify missing translations in the UI
         *
         * @param string
         * @returns {String}
         */

    }, {
        key: 'getTranslation',
        value: function getTranslation(string) {
            var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (this.translations === undefined) {
                throw new Error('Tried to translate before loading translations!');
            }
            var translatedString = this.translations.hasOwnProperty(string) ? this.translations[string] : '** ' + string + ' **';

            if (Object.keys(variables).length) {
                return translatedString.replace(/\$\$(.+?)\$\$/gi, function (match, partial) {
                    return variables[partial] || '';
                });
            }

            return translatedString;
        }

        /**
         * Check if a translation exists for the specified string
         *
         * @param string
         * @returns {boolean} True if a translation exists, false otherwise
         */

    }, {
        key: 'isTranslated',
        value: function isTranslated(string) {
            if (this.translations === undefined) {
                throw new Error('Tried to translate before loading translations!');
            }
            return this.translations.hasOwnProperty(string);
        }

        /**
         * Get the list of strings that don't have translations
         *
         * If no translations have been loaded yet, `undefined` is returned in stead.
         *
         * @returns {Array|undefined} Array of untranslated strings, or undefined if translations haven't been loaded
         */

    }, {
        key: 'getUntranslatedStrings',
        value: function getUntranslatedStrings() {
            return this.translations ? Array.from(this.strings) : undefined;
        }

        /**
         * Return a new instance of this class
         *
         * @returns {I18n}
         */

    }], [{
        key: 'getI18n',
        value: function getI18n() {
            return new I18n();
        }
    }]);

    return I18n;
}();

exports.default = I18n;
//# sourceMappingURL=I18n.js.map

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _defaultConfig = __webpack_require__(174);

var _defaultConfig2 = _interopRequireDefault(_defaultConfig);

var _check = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Config = function () {
    function Config() {
        _classCallCheck(this, Config);
    }

    _createClass(Config, null, [{
        key: 'create',
        value: function create() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            var configObjects = args.filter(function (arg) {
                return arg;
            });

            if (!configObjects.every(function (configObject) {
                return (0, _check.isType)(configObject, 'object');
            })) {
                throw new Error('Expected Config parameter to have type object');
            }

            return Object.assign.apply(Object, [{}, _defaultConfig2.default].concat(args));
        }
    }, {
        key: 'processConfigForD2',
        value: function processConfigForD2(config, d2) {
            var api = d2.Api.getApi();
            d2.model.ModelDefinition.prototype.api = api; // eslint-disable-line no-param-reassign
            d2.models = d2.model.ModelDefinitions.getModelDefinitions(); // eslint-disable-line no-param-reassign

            if ((0, _check.isString)(config.baseUrl)) {
                api.setBaseUrl(config.baseUrl);
            } else {
                // default to the current version of the `/api`
                api.setBaseUrl('/api');
            }

            if (config.i18n && config.i18n.sources) {
                Array.from(config.i18n.sources).forEach(function (source) {
                    return d2.i18n.addSource(source);
                });
            }

            if (config.i18n && config.i18n.strings) {
                d2.i18n.addStrings(Array.from(config.i18n.strings));
            }
        }
    }]);

    return Config;
}();

exports.default = Config;
//# sourceMappingURL=config.js.map

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @module current-user
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _UserAuthorities = __webpack_require__(302);

var _UserAuthorities2 = _interopRequireDefault(_UserAuthorities);

var _UserSettings = __webpack_require__(303);

var _UserSettings2 = _interopRequireDefault(_UserSettings);

var _defaultConfig = __webpack_require__(174);

var _UserDataStore = __webpack_require__(304);

var _UserDataStore2 = _interopRequireDefault(_UserDataStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var models = Symbol('models');
var propertiesToIgnore = new Set(['userCredentials', 'userGroups', 'userRoles', 'organisationUnits', 'dataViewOrganisationUnits']);

/**
 * Authorities lookup map to be used for determining the list of authorities to check.
 *
 * @private
 * @type {Object.<string, string[]>}
 * @readonly
 * @typedef {Object} AuthorityType
 * @memberof module:current-user
 */
var authTypes = {
    READ: ['READ'],
    CREATE: ['CREATE', 'CREATE_PUBLIC', 'CREATE_PRIVATE'],
    CREATE_PUBLIC: ['CREATE_PUBLIC'],
    CREATE_PRIVATE: ['CREATE_PRIVATE'],
    DELETE: ['DELETE'],
    UPDATE: ['UPDATE'],
    EXTERNALIZE: ['EXTERNALIZE']
};

/**
 * Create a map of `propertyName` -> `Symbol`. This map is used to hide values for these properties. We will instead add
 * add convenience methods for these properties. (e.g. the `userGroups` property on the currentUser object becomes
 * `getUserGroups()`
 *
 * @private
 * @type {Object.<string, Symbol>}
 */
var propertySymbols = Array.from(propertiesToIgnore).reduce(function (result, property) {
    result[property] = Symbol(property); // eslint-disable-line no-param-reassign
    return result;
}, {});

/**
 * Creates a map of propertyName and propertyValue pairs of properties to be attached to the currentUser object.
 * These are all the regular properties that are returned when calling `api/27/me` but with the `userCredentials`
 * merged onto the same object.
 *
 * What would originally be `currentUser.userCredentials.username` would just be `currentUser.username`
 *
 * @private
 * @param {Object} currentUserObject The user payload as it is received from the api. https://play.dhis2.org/demo/api/27/me
 * @returns {Object} A map with propertyName/propertyValue pairs.
 */
function getPropertiesForCurrentUserObject(currentUserObject) {
    var properties = void 0;
    // The userCredentials object on the userObject is confusing so we set the properties straight onto the currentUser
    // object itself
    if (currentUserObject.userCredentials) {
        properties = Object.assign({}, currentUserObject.userCredentials, currentUserObject);
    } else {
        properties = Object.assign({}, currentUserObject);
    }

    return Object.keys(properties).reduce(function (result, property) {
        if (propertiesToIgnore.has(property)) {
            if (properties[property].map) {
                result[propertySymbols[property]] = properties[property] // eslint-disable-line no-param-reassign
                .map(function (value) {
                    return value.id;
                });
            }
        } else {
            result[property] = properties[property]; // eslint-disable-line no-param-reassign
        }
        return result;
    }, {});
}

/**
 * Checks the noCreateAllowedFor list if the object can be created.
 *
 * @private
 * @param {ModelDefinition} modelDefinition The modelDefinition to check for.
 * @returns {boolean} True when it exists in the list, false otherwise.
 */
function isInNoCreateAllowedForList(modelDefinition) {
    return Boolean(modelDefinition && _defaultConfig.noCreateAllowedFor.has(modelDefinition.name));
}

/**
 * Represents the current logged in user
 *
 * @memberof module:current-user
 */

var CurrentUser = function () {
    /**
     * Creates the CurrentUser.
     *
     * @param {Object} userData Payload as returned from the api when requesting the currentUser object.
     * @param {UserAuthorities} userAuthorities The UserAuthorities object for the currentUsers authorities.
     * @param {ModelDefinition[]} modelDefinitions The modelDefinitions that need to be used for checking access.
     * @param {UserSettings} settings The userSettings object to be set onto the current user object.
     */
    function CurrentUser(userData, userAuthorities, modelDefinitions, settings) {
        _classCallCheck(this, CurrentUser);

        Object.assign(this, getPropertiesForCurrentUserObject(userData));

        /**
         *
         * @type {UserAuthorities}
         */
        this.authorities = userAuthorities;

        this[models] = modelDefinitions;

        /**
         * Contains a reference to a `UserSettings` instance that can be used
         * to retrieve and save system settings.
         * @type {UserSettings}
         * @description
         * ```js
         * d2.currentUser.userSettings.get('keyUiLocale')
         *  .then(userSettingsValue => {
         *    console.log('UI Locale: ' + userSettingsValue);
         *  });
         * ```
         */
        this.userSettings = settings;

        /**
         * Contains a reference to {@link module:current-user.UserDataStore UserDataStore}
         * @type UserDataStore
         *
         */
        this.dataStore = _UserDataStore2.default.getUserDataStore();
    }

    /**
     * Get a ModelCollection of userGroup models that are assigned to the currentUser
     *
     * The user groups are lazy loaded on init of the library. This method can be used to load the full representation
     * of the userGroups.
     *
     * The request done is equivalent do doing https://play.dhis2.org/demo/api/27/me.json?fields=userGroups[:all]
     *
     * @returns {Promise<ModelCollection>} The model collection that contains the user's groups.
     */


    _createClass(CurrentUser, [{
        key: 'getUserGroups',
        value: function getUserGroups() {
            var userGroupIds = this[propertySymbols.userGroups];

            return this[models].userGroup.list({ filter: ['id:in:[' + userGroupIds.join(',') + ']'], paging: false });
        }

        /**
         * Get a ModelCollection of userRole models that are assigned to the currentUser
         *
         * The user roles are lazy loaded on init of the library. This method can be used to load the full representation
         * of the userGroups.
         *
         * The request done is equivalent do doing https://play.dhis2.org/demo/api/27/me.json?fields=userCredentials[userRoles[:all]]
         *
         * @returns {Promise<ModelCollection>} A ModelCollection that contains the user's groups.
         */

    }, {
        key: 'getUserRoles',
        value: function getUserRoles() {
            var userRoleIds = this[propertySymbols.userRoles];

            return this[models].userRole.list({ filter: ['id:in:[' + userRoleIds.join(',') + ']'], paging: false });
        }

        /**
         * Requests a users primary organisation units from the api.
         *
         * The users organisation units are lazy loaded on init of the library (just the ids). This method can be used to
         * load the full representation of the organisationUnits.
         *
         * @param {Object} [listOptions={}] Additional query parameters that should be send with the request.
         * @returns {Promise<ModelCollection>} A ModelCollection that contains the user's organisationUnits.
         */

    }, {
        key: 'getOrganisationUnits',
        value: function getOrganisationUnits() {
            var listOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var organisationUnitsIds = this[propertySymbols.organisationUnits];

            return this[models].organisationUnit.list(Object.assign({ fields: ':all,displayName,path,children[id,displayName,path,children::isNotEmpty]', paging: false }, listOptions, { filter: ['id:in:[' + organisationUnitsIds.join(',') + ']'] }));
        }

        /**
         * Requests a users data view organisation units from the api.
         *
         * The users data view organisation units are lazy loaded on init of the library (just the ids). This method can
         * be used to load the full representation of the dataViewOrganisationUnits.
         *
         * @param {Object} [listOptions={}] Additional query parameters that should be send with the request.
         * @returns {Promise<ModelCollection>} A ModelCollection that contains the user's dataViewOrganisationUnits.
         */

    }, {
        key: 'getDataViewOrganisationUnits',
        value: function getDataViewOrganisationUnits(listOptions) {
            var organisationUnitsIds = this[propertySymbols.dataViewOrganisationUnits];

            return this[models].organisationUnit.list(Object.assign({ fields: ':all,displayName,path,children[id,displayName,path,children::isNotEmpty]', paging: false }, listOptions, { filter: ['id:in:[' + organisationUnitsIds.join(',') + ']'] }));
        }

        /**
         * Helper function to check if the currentUser can perform an action.
         *
         * A schema from the api defines the authorities as follows:
         * "authorities": [
         *   {
         *     "type": "CREATE_PUBLIC",
         *     "authorities": [
         *       "F_DATAELEMENT_PUBLIC_ADD"
         *     ]
         *   }, {
         *      "type": "CREATE_PRIVATE",
         *      "authorities": [
         *        "F_DATAELEMENT_PRIVATE_ADD"
         *      ]
         *    }, {
         *      "type": "DELETE",
         *      "authorities": [
         *        "F_DATAELEMENT_DELETE"
         *      ]
         *    }
         *
         * ],
         *
         * So for example, when asking for `currentUser.canCreate(modelDefinition)` we look at the authorities map for CREATE, we
         * collect the authorities from the schema based on the values of `CREATE`. So in the case of above schema authorities
         * we take the authorities for 'CREATE_PUBLIC' and 'CREATE_PRIVATE' and check if the user has at least one of the
         * authorities in the combined list. If we had asked for `currentUser.canCreatePrivate(modelDefinition)` we would only
         * need to check if the user has `F_DATAELEMENT_PRIVATE_ADD` However for just create the user could still create when he
         * has either private or public.
         *
         * @private
         * @param {AuthorityType} authorityType The type of authority to check for.
         * @param {ModelDefinition} modelDefinition The ModelDefinition for the type of object that the authority should
         * be checked for.
         * @returns {boolean} True when the user has the authority to perform the action, otherwise false.
         */

    }, {
        key: 'checkAuthorityForType',
        value: function checkAuthorityForType(authorityType, modelDefinition) {
            var _this = this;

            if (!modelDefinition || !Array.isArray(modelDefinition.authorities)) {
                return false;
            }

            return modelDefinition.authorities
            // Filter the correct authority to check for from the model
            .filter(function (authority) {
                return authorityType.some(function (authToHave) {
                    return authToHave === authority.type;
                });
            })
            // Check the left over schema authority types
            .some(function (schemaAuthority) {
                return schemaAuthority.authorities.some(function (authorityToCheckFor) {
                    return _this.authorities.has(authorityToCheckFor);
                });
            } // Check if one of the schema authorities are available in the users authorities
            );
        }

        /**
         * Helper method to first check the special "not allowed to create list" before checking the users authorities.
         *
         * @private
         * @param {AuthorityType} authType The type of authority that should be checked. (CREATE, CREATE_PRIVATE
         * or CREATE_PUBLIC)
         * @param {ModelDefinition} modelDefinition The modelDefinition that the authorities should be checked for.
         * @returns {boolean} True when the user has the permission to create the object
         */

    }, {
        key: 'checkCreateAuthorityForType',
        value: function checkCreateAuthorityForType(authType, modelDefinition) {
            // When the modelDefinition is mentioned in the the list of modelTypes that are not
            // allowed to be created we return false
            if (isInNoCreateAllowedForList(modelDefinition)) {
                return false;
            }

            // Otherwise we check using the normal procedure for checking authorities
            return this.checkAuthorityForType(authType, modelDefinition);
        }

        /**
         * Check if the user has the authority to create objects of a type of Model (based on it's modelDefinition)
         * If the object supports public and private objects then both are checked, and the method will return true if one
         * of them is true. (e.g. will also return true if the user can only create private objects)
         *
         * @param {ModelDefinition} modelDefinition The modelDefinition that the authorities should be checked for.
         * @returns {boolean} True when the user has the permission to create the object
         */

    }, {
        key: 'canCreate',
        value: function canCreate(modelDefinition) {
            return this.checkCreateAuthorityForType(authTypes.CREATE, modelDefinition);
        }

        /**
         * Check if the user has the authority to create public objects of a type of Model (based on it's modelDefinition)
         *
         * @param {ModelDefinition} modelDefinition The modelDefinition that the authorities should be checked for.
         * @returns {boolean} True when the user has the permission to create the object
         */

    }, {
        key: 'canCreatePublic',
        value: function canCreatePublic(modelDefinition) {
            return this.checkCreateAuthorityForType(authTypes.CREATE_PUBLIC, modelDefinition);
        }

        /**
         * Check if the user has the authority to create private objects of a type of Model (based on it's modelDefinition)
         *
         * @param {ModelDefinition} modelDefinition The modelDefinition that the authorities should be checked for.
         * @returns {boolean} True when the user has the permission to create the object
         */

    }, {
        key: 'canCreatePrivate',
        value: function canCreatePrivate(modelDefinition) {
            return this.checkCreateAuthorityForType(authTypes.CREATE_PRIVATE, modelDefinition);
        }

        /**
         * Check if the user has the authority to delete objects of a type of Model (based on it's modelDefinition)
         *
         * @param {ModelDefinition} modelDefinition The modelDefinition that the authorities should be checked for.
         * @returns {boolean} True when the user has the permission to delete the object
         *
         * @deprecated Delete should be checked through the `Model.access.delete` property instead, as that also takes into
         * account sharing. Just checking if the user has the authority to delete a specific object does not take into account
         * the full ACL.
         */

    }, {
        key: 'canDelete',
        value: function canDelete(modelDefinition) {
            return this.checkAuthorityForType(authTypes.DELETE, modelDefinition);
        }

        /**
         * Check if the user has the authority to update objects of a type of Model (based on it's modelDefinition)
         *
         * @param {ModelDefinition} modelDefinition The modelDefinition that the authorities should be checked for.
         * @returns {boolean} True when the user has the permission to update the object
         *
         * @deprecated Update should be checked through the `Model.access.update` property instead, as that also takes into
         * account sharing. Just checking if the user has the authority to update a specific object does not take into account
         * the full ACL.
         */

    }, {
        key: 'canUpdate',
        value: function canUpdate(modelDefinition) {
            if (this.checkAuthorityForType(authTypes.UPDATE, modelDefinition)) {
                return true;
            }
            return this.checkAuthorityForType(authTypes.CREATE, modelDefinition);
        }

        /**
         * Factory method for creating a CurrentUser instance
         *
         * @param {Object} userData Payload as returned from the api when requesting the currentUser object.
         * @param {string[]} authorities A list of authorities that the currentUser has.
         * @param {ModelDefinition[]} modelDefinitions The modelDefinitions that need to be used for checking access.
         * @param {Object} userSettings Payload as returned from the api when request the userSettings
         * @returns {CurrentUser} The created CurrentUser object based on the data given.
         */

    }], [{
        key: 'create',
        value: function create(userData, authorities, modelDefinitions, userSettings) {
            return new CurrentUser(userData, _UserAuthorities2.default.create(authorities), modelDefinitions, new _UserSettings2.default(userSettings));
        }
    }]);

    return CurrentUser;
}();

exports.default = CurrentUser;
//# sourceMappingURL=CurrentUser.js.map

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var auths = Symbol('authorities');

/**
 * Simple wrapper class for the user authorities list
 *
 * @memberof module:current-user
 */

var UserAuthorities = function () {
    /**
     * Creates the UserAuthorities object based off the given set of the user's authorities.
     *
     * @param {string[]} authorities A set of the user's authorities.
     */
    function UserAuthorities() {
        var authorities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        _classCallCheck(this, UserAuthorities);

        this[auths] = new Set(authorities);
    }

    /**
     * Checks if the given authority is in the user's authority list.
     *
     * If the user has the 'ALL' authority any request for a authority will return `true`.
     *
     * @param {string} authority The authority to check for
     */


    _createClass(UserAuthorities, [{
        key: 'has',
        value: function has(authority) {
            if (this[auths].has('ALL')) {
                return true;
            }
            return this[auths].has(authority);
        }

        /**
         * Factory method for a UserAuthorities instance
         *
         * @param {string[]} authorities A set of the user's authorities as recieved from the api.
         */

    }], [{
        key: 'create',
        value: function create(authorities) {
            return new UserAuthorities(authorities);
        }
    }]);

    return UserAuthorities;
}();

exports.default = UserAuthorities;
//# sourceMappingURL=UserAuthorities.js.map

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

var _check = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @description
 * Handles communication with the userSettings endpoint. Can be used to get or save userSettings.
 *
 * @memberof module:current-user
 */

var UserSettings = function () {
    function UserSettings(userSettings) {
        var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Api2.default.getApi();

        _classCallCheck(this, UserSettings);

        this.api = api;

        if (userSettings) {
            this.settings = userSettings;
        }
    }

    /**
     * @returns {Promise} Promise that resolves with the usersettings object from the api.
     *
     * @description
     * Loads all the user settings of current user and returns them as an object from the promise.
     * ```js
     * d2.currentUser.userSettings.all()
     *  .then(userSettings => {
     *    console.log('UI Locale: ' + userSettings.keyUiLocale);
     *  });
     * ```
     */


    _createClass(UserSettings, [{
        key: 'all',
        value: function all() {
            var _this = this;

            return this.settings ? Promise.resolve(this.settings) : this.api.get('userSettings').then(function (userSettings) {
                _this.settings = userSettings;return Promise.resolve(_this.settings);
            });
        }

        /**
         * @param {String} key The identifier of the user setting that should be retrieved.
         * @returns {Promise} A promise that resolves with the value or will fail if the value is not available.
         *
         * @description
         * ```js
         * d2.currentUser.userSettings.get('keyUiLocale')
         *  .then(userSettingValue => {
         *    console.log('UI Locale: ' + userSettingValue);
         *  });
         * ```
         */

    }, {
        key: 'get',
        value: function get(key) {
            var _this2 = this;

            if (this.settings && this.settings[key]) {
                return Promise.resolve(this.settings[key]);
            }

            function processValue(value) {
                // Attempt to parse the response as JSON. If this fails we return the value as is.
                try {
                    return JSON.parse(value);
                } catch (e) {
                    return value;
                }
            }

            return new Promise(function (resolve, reject) {
                if (!(0, _check.isString)(key)) {
                    throw new TypeError('A "key" parameter should be specified when calling get() on userSettings');
                }

                _this2.api.get(['userSettings', key].join('/')).then(function (response) {
                    var value = processValue(response);
                    // Store the value on the user settings object
                    _this2[key] = value;
                    if (value) {
                        resolve(value);
                    }
                    reject(new Error('The requested userSetting has no value or does not exist.'));
                });
            });
        }

        /**
         * @param {String} key The identifier of the user setting that should be saved.
         * @param {String} value The new value of the user setting.
         * @returns {Promise} A promise that will resolve when the new value has been saved, or fail if saving fails.
         *
         * @description
         * ```js
         * d2.currentUser.userSettings.set('keyUiLocale', 'fr')
         *  .then(() => {
         *   console.log('UI Locale is now "fr");
         *  });
         * ```
         */

    }, {
        key: 'set',
        value: function set(key, value) {
            delete this.settings;

            var settingUrl = ['userSettings', key].join('/');
            if (value === null || ('' + value).length === 0) {
                return this.api.delete(settingUrl);
            }
            return this.api.post(settingUrl, value, { headers: { 'Content-Type': 'text/plain' } });
        }
    }]);

    return UserSettings;
}();

exports.default = UserSettings;
//# sourceMappingURL=UserSettings.js.map

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BaseStore2 = __webpack_require__(175);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _UserDataStoreNamespace = __webpack_require__(305);

var _UserDataStoreNamespace2 = _interopRequireDefault(_UserDataStoreNamespace);

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @augments module:datastore.BaseStore
 * @description
 * Represents the UserDataStore that can be interacted with. This can be used to get instances of UserDataStoreNamespace, which
 * can be used to interact with the {@link module:current-user.UserDataStoreNamespace namespace API}.
 *
 * The store is a key-value store, where a namespace contains a list of keys, and
 * a key corresponds to an arbitrary JSON-object. The store is per-user, and only the currently logged-in user
 * has access to the namespaces.
 *
 * Note that a namespace cannot exist without at least one key-value pair, for this reason
 * you need to call {@link module:current-user.UserDataStoreNamespace#set set()} after {@link module:current-user.UserDataStore#create create()} to save a namespace
 * with a key and a value.
 *
 * @example <caption>Getting a value with promise-syntax</caption>
 * import { init } from 'd2';
 *
 * init({baseUrl: 'https://play.dhis2.org/demo/api'})
 *   .then((d2) => {
 *     d2.currentUser.dataStore.get('namespace').then(namespace => {
 *          namespace.get('key').then(value => console.log(value))
 *      });
 *   });
 *
 * @example <caption>Creation of namespace with async-syntax</caption>
 * const namespace = await d2.currentUser.dataStore.create('new namespace', false);
 * // The namespace is not actually created on the server before 'set' is called
 * await namespace.set('new key', value);
 *
 * @memberof module:current-user
 */
var UserDataStore = function (_BaseStore) {
    _inherits(UserDataStore, _BaseStore);

    function UserDataStore() {
        var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Api2.default.getApi();
        var endPoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'userDataStore';

        _classCallCheck(this, UserDataStore);

        return _possibleConstructorReturn(this, (UserDataStore.__proto__ || Object.getPrototypeOf(UserDataStore)).call(this, api, endPoint, _UserDataStoreNamespace2.default));
    }

    /**
     * @description
     * Tries to get the given namespace from the server, and returns an instance of 'UserDataStore' that
     * may be used to interact with this namespace. See {@link module:current-user.UserDataStoreNamespace UserDataStoreNamespace}.
     *
     * @example <caption>Getting a namespace</caption>
     * d2.currentUser.dataStore.get('namespace').then(namespace => {
     *     namespace.set('new key', value);
     *});
     *
     * @param {string} namespace - Namespace to get.
     * @param {boolean} [autoLoad=true] - If true, autoloads the keys of the namespace from the server.
     * If false, an instance of the namespace is returned without any keys (no request is sent to the server).
     *
     * @returns {Promise<UserDataStoreNamespace>} An instance of a UserDataStoreNamespace representing the namespace that can be interacted with.
     */


    _createClass(UserDataStore, [{
        key: 'get',
        value: function get(namespace) {
            var autoLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            return _get(UserDataStore.prototype.__proto__ || Object.getPrototypeOf(UserDataStore.prototype), 'get', this).call(this, namespace, autoLoad);
        }

        /**
         * Creates a namespace. Ensures that the namespace does not exists on the server.
         * Note that for the namespace to be saved on the server, you need to call {@link module:current-user.UserDataStoreNamespace#set set}.
         *
         * @example <caption>Creating a namespace</caption>
         * d2.currentUser.dataStore.create('new namespace').then(namespace => {
         *     namespace.set('new key', value);
         * });
         * @param {string} namespace The namespace to create.
         * @returns {Promise<UserDataStoreNamespace>} An instance of the current store-Namespace-instance representing the namespace that can be interacted with, or
         * an error if namespace exists.
         */

    }, {
        key: 'create',
        value: function create(namespace) {
            return _get(UserDataStore.prototype.__proto__ || Object.getPrototypeOf(UserDataStore.prototype), 'create', this).call(this, namespace);
        }

        /**
         * @static
         *
         * @returns {UserDataStore} Object with the userDataStore interaction properties
         *
         * @description
         * Get a new instance of the userDataStore object. This will function as a singleton - when a UserDataStore object has been created
         * when requesting getUserDataStore again, the original version will be returned.
         */

    }], [{
        key: 'getUserDataStore',
        value: function getUserDataStore() {
            if (!UserDataStore.getUserDataStore.dataStore) {
                UserDataStore.getUserDataStore.dataStore = new UserDataStore(_Api2.default.getApi(), 'userDataStore');
            }

            return UserDataStore.getUserDataStore.dataStore;
        }
    }]);

    return UserDataStore;
}(_BaseStore3.default);

exports.default = UserDataStore;
//# sourceMappingURL=UserDataStore.js.map

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

var _BaseStoreNamespace2 = __webpack_require__(115);

var _BaseStoreNamespace3 = _interopRequireDefault(_BaseStoreNamespace2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @augments module:datastore.BaseStoreNamespace
 * @description
 * Represents a namespace in the dataStore that can be used to be used to interact with
 * the remote API.
 *
 * @property {array} keys an array of the loaded keys.
 * @property {string} namespace Name of the namespace as on the server.
 *
 * @memberof module:current-user
 */
var UserDataStoreNamespace = function (_BaseStoreNamespace) {
    _inherits(UserDataStoreNamespace, _BaseStoreNamespace);

    function UserDataStoreNamespace(namespace, keys) {
        var api = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _Api2.default.getApi();
        var endPoint = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'userDataStore';

        _classCallCheck(this, UserDataStoreNamespace);

        return _possibleConstructorReturn(this, (UserDataStoreNamespace.__proto__ || Object.getPrototypeOf(UserDataStoreNamespace)).call(this, namespace, keys, api, endPoint));
    }

    return UserDataStoreNamespace;
}(_BaseStoreNamespace3.default);

exports.default = UserDataStoreNamespace;
//# sourceMappingURL=UserDataStoreNamespace.js.map

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BaseStore2 = __webpack_require__(175);

var _BaseStore3 = _interopRequireDefault(_BaseStore2);

var _DataStoreNamespace = __webpack_require__(307);

var _DataStoreNamespace2 = _interopRequireDefault(_DataStoreNamespace);

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @augments module:datastore.BaseStore
 * @description
 * Represents the dataStore that can be interacted with. This can be used to get instances of DataStoreNamespace, which
 * can be used to interact with the {@link module:datastore.DataStoreNamespace namespace API}.
 *
 * The store is a key-value store, where a namespace contains a list of keys, and
 * a key corresponds to an arbitrary JSON-object. The dataStore is DHIS2-instance wide.
 *
 * Note that a namespace cannot exist without at least one key-value pair, for this reason
 * you need to call {@link module:datastore.DataStoreNamespace#set set()} after {@link module:datastore.DataStore#create create()} to save a namespace
 * with a key and a value.
 *
 * @example
 * import { init } from 'd2';
 *
 * init({baseUrl: 'https://play.dhis2.org/demo/api'})
 *   .then((d2) => {
 *     d2.dataStore.get('namespace').then(namespace => {
 *          namespace.get('key').then(value => console.log(value))
 *      });
 *   });
 *
 * @memberof module:datastore
 */
var DataStore = function (_BaseStore) {
    _inherits(DataStore, _BaseStore);

    function DataStore() {
        var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Api2.default.getApi();
        var endPoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dataStore';

        _classCallCheck(this, DataStore);

        return _possibleConstructorReturn(this, (DataStore.__proto__ || Object.getPrototypeOf(DataStore)).call(this, api, endPoint, _DataStoreNamespace2.default));
    }

    /**
     * @description
     * Tries to get the given namespace from the server, and returns an instance of DataStore that
     * may be used to interact with this namespace. See {@link module:datastore.DataStoreNamespace DataStore}.
     *
     * @example <caption>Getting a namespace</caption>
     * d2.dataStore.get('namespace').then(namespace => {
     *     namespace.set('new key', value);
     *});
     * @param namespace - Namespace to get.
     * @param [autoLoad=true] If true, autoloads the keys of the namespace from the server.
     * If false, an instance of the namespace is returned without any keys (no request is sent to the server).
     * @returns {Promise<DataStoreNamespace>} An instance of a DataStore representing the namespace that can be interacted with,
     * or an error if namespace exists.
     */


    _createClass(DataStore, [{
        key: 'get',
        value: function get(namespace) {
            var autoLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            return _get(DataStore.prototype.__proto__ || Object.getPrototypeOf(DataStore.prototype), 'get', this).call(this, namespace, autoLoad);
        }

        /**
         * Creates a namespace. Ensures that the namespace does not exists on the server.
         * Note that for the namespace to be saved on the server, you need to call {@link module:datastore.DataStoreNamespace#set set}.
         *
         * @example <caption>Creating a namespace</caption>
         * d2.dataStore.create('new namespace').then(namespace => {
         *     namespace.set('new key', value);
         * });
         * @param {string} namespace The namespace to create.
         * @returns {Promise<DataStoreNamespace>} An instance of the current store-Namespace-instance representing the namespace that can be interacted with, or
         * an error if namespace exists.
         */

    }, {
        key: 'create',
        value: function create(namespace) {
            return _get(DataStore.prototype.__proto__ || Object.getPrototypeOf(DataStore.prototype), 'create', this).call(this, namespace);
        }

        /**
         * @static
         *
         * @returns {DataStore} Object with the dataStore interaction properties
         *
         * @description
         * Get a new instance of the dataStore object. This will function as a singleton, when a DataStore object has been created
         * when requesting getDataStore again the original version will be returned.
         */

    }], [{
        key: 'getDataStore',
        value: function getDataStore() {
            if (!DataStore.getDataStore.dataStore) {
                DataStore.getDataStore.dataStore = new DataStore();
            }

            return DataStore.getDataStore.dataStore;
        }
    }]);

    return DataStore;
}(_BaseStore3.default);

exports.default = DataStore;
//# sourceMappingURL=DataStore.js.map

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

var _BaseStoreNamespace2 = __webpack_require__(115);

var _BaseStoreNamespace3 = _interopRequireDefault(_BaseStoreNamespace2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @augments module:datastore.BaseStoreNamespace
 * @description
 * Represents a namespace in the dataStore that can be used to be used to interact with
 * the remote API.
 *
 * @property {array} keys an array of the loaded keys.
 * @property {string} namespace Name of the namespace as on the server.
 * @memberof module:datastore
 */
var DataStoreNamespace = function (_BaseStoreNamespace) {
    _inherits(DataStoreNamespace, _BaseStoreNamespace);

    function DataStoreNamespace(namespace, keys) {
        var api = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _Api2.default.getApi();
        var endPoint = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'dataStore';

        _classCallCheck(this, DataStoreNamespace);

        return _possibleConstructorReturn(this, (DataStoreNamespace.__proto__ || Object.getPrototypeOf(DataStoreNamespace)).call(this, namespace, keys, api, endPoint));
    }

    /**
     * Retrieves metaData of given key in current namespace.
     *
     * @param key - the key to retrieve metaData for.
     */


    _createClass(DataStoreNamespace, [{
        key: 'getMetaData',
        value: function getMetaData(key) {
            return this.api.get([this.endPoint, this.namespace, key, 'metaData'].join('/'));
        }
    }]);

    return DataStoreNamespace;
}(_BaseStoreNamespace3.default);

exports.default = DataStoreNamespace;
//# sourceMappingURL=DataStoreNamespace.js.map

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @module analytics
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _AnalyticsAggregate = __webpack_require__(309);

var _AnalyticsAggregate2 = _interopRequireDefault(_AnalyticsAggregate);

var _AnalyticsEvents = __webpack_require__(310);

var _AnalyticsEvents2 = _interopRequireDefault(_AnalyticsEvents);

var _AnalyticsRequest = __webpack_require__(74);

var _AnalyticsRequest2 = _interopRequireDefault(_AnalyticsRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @description
 * Analytics class used to request analytics data from Web API.
 *
 * @requires analytics.AnalyticsAggregate
 * @requires analytics.AnalyticsEvents
 * @requires analytics.AnalyticsRequest
 *
 * @example
 * const d2Analytics = new Analytics(
 *  new AnalyticsAggregate(),
 *  new AnalyticsEvents(),
 *  AnalyticsRequest
 * )
 *
 * @memberof module:analytics
 * @see {@link https://docs.dhis2.org/master/en/developer/html/webapi_analytics.html} Analytics API documentation
 * @see {@link https://docs.dhis2.org/master/en/developer/html/webapi_event_analytics.html} Event analytics API documentation
 */
var Analytics = function () {
    /**
     * @param {!module:analytics.AnalyticsAggregate} analyticsAggregate The AnalyticsAggregate instance
     * @param {!module:analytics.AnalyticsEvents} analyticsEvents The AnalyticsEvents instance
     * @param {!module:analytics.AnalyticsRequest} analyticsRequest The AnalyticsRequest class
     */
    function Analytics(analyticsAggregate, analyticsEvents, analyticsRequest) {
        _classCallCheck(this, Analytics);

        this.aggregate = analyticsAggregate;
        this.events = analyticsEvents;
        this.request = analyticsRequest;
    }

    /**
     * @static
     *
     * @description
     * Get a new instance of the Analytics object. This will function as a singleton, once Analytics object
     * has been created when requesting getAnalytics again the original version will be returned.
     *
     * @returns {Analytics} Object with the analytics interaction properties
     *
     * @example
     * const d2Analytics = d2.getAnalytics();
     */


    _createClass(Analytics, null, [{
        key: 'getAnalytics',
        value: function getAnalytics() {
            if (!Analytics.getAnalytics.analytics) {
                Analytics.getAnalytics.analytics = new Analytics(new _AnalyticsAggregate2.default(), new _AnalyticsEvents2.default(), _AnalyticsRequest2.default);
            }

            return Analytics.getAnalytics.analytics;
        }
    }]);

    return Analytics;
}();

exports.default = Analytics;
//# sourceMappingURL=Analytics.js.map

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AnalyticsBase2 = __webpack_require__(176);

var _AnalyticsBase3 = _interopRequireDefault(_AnalyticsBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @extends module:analytics.AnalyticsBase
 *
 * @description
 * Analytics aggregate class used to request aggregate analytics data from Web API.
 *
 * @memberof module:analytics
 *
 * @see https://docs.dhis2.org/master/en/developer/html/webapi_analytics.html
 */
var AnalyticsAggregate = function (_AnalyticsBase) {
  _inherits(AnalyticsAggregate, _AnalyticsBase);

  function AnalyticsAggregate() {
    _classCallCheck(this, AnalyticsAggregate);

    return _possibleConstructorReturn(this, (AnalyticsAggregate.__proto__ || Object.getPrototypeOf(AnalyticsAggregate)).apply(this, arguments));
  }

  _createClass(AnalyticsAggregate, [{
    key: 'getDataValueSet',

    /**
     * @param {!AnalyticsRequest} req Request object
     *
     * @returns {Promise} Promise that resolves with the analytics data value set data from the API.
     *
     * @example
     * const req = new d2.analytics.request()
     *  .addDataDimension(['Uvn6LCg7dVU','OdiHJayrsKo'])
     *  .addPeriodDimension('LAST_4_QUARTERS')
     *  .addOrgUnitDimension(['lc3eMKXaEfw','PMa2VCrupOd'])
     *  .addOrgUnitFilter('O6uvpzGd5pu')
     *  .withStartDate('2017-10-01')
     *  .withEndDate('2017-10-31');
     *
     * d2.analytics.aggregate.getDataValueSet(req)
     * .then(console.log);
     */
    value: function getDataValueSet(req) {
      return this.get(req.withPath('dataValueSet'));
    }

    /**
     * @param {!AnalyticsRequest} req Request object
     *
     * @returns {Promise} Promise that resolves with the raw data from the API.
     *
     * @example
     * const req = new d2.analytics.request()
     *  .addDataDimension(['Uvn6LCg7dVU','OdiHJayrsKo'])
     *  .addPeriodDimension('LAST_4_QUARTERS')
     *  .addOrgUnitDimension(['lc3eMKXaEfw', 'PMa2VCrupOd'])
     *  .addOrgUnitFilter('O6uvpzGd5pu');
     *  .withStartDate('2017-10-01')
     *  .withEndDate('2017-10-31')
     *  .withFormat('xml');
     *
     *  d2.analytics.aggregate.getRawData(req)
     *  .then(console.log);
     */

  }, {
    key: 'getRawData',
    value: function getRawData(req) {
      return this.get(req.withPath('rawData'));
    }

    /**
     * @param {!AnalyticsRequest} req Request object
     *
     * @returns {Promise} Promise that resolves with the SQL statement used to query the database.
     *
     * @example
     * const req = new d2.analytics.request()
     *  .addDataDimension(['Uvn6LCg7dVU','OdiHJayrsKo'])
     *  .addPeriodDimension('LAST_4_QUARTERS')
     *  .addOrgUnitDimension(['lc3eMKXaEfw', 'PMa2VCrupOd'])
     *  .addOrgUnitFilter('O6uvpzGd5pu');
     *  .withStartDate('2017-10-01')
     *  .withEndDate('2017-10-31');
     *
     *  d2.analytics.aggregate.getDebugSql(req);
     *  .then(console.log);
     */

  }, {
    key: 'getDebugSql',
    value: function getDebugSql(req) {
      return this.get(req.withPath('debug/sql'));
    }
  }]);

  return AnalyticsAggregate;
}(_AnalyticsBase3.default);

exports.default = AnalyticsAggregate;
//# sourceMappingURL=AnalyticsAggregate.js.map

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AnalyticsBase2 = __webpack_require__(176);

var _AnalyticsBase3 = _interopRequireDefault(_AnalyticsBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @extends module:analytics.AnalyticsBase
 *
 * @description
 * Analytics events class used to request analytics events data from Web API.
 *
 * @memberof module:analytics
 *
 * @see https://docs.dhis2.org/master/en/developer/html/webapi_event_analytics.html
 */
var AnalyticsEvents = function (_AnalyticsBase) {
  _inherits(AnalyticsEvents, _AnalyticsBase);

  function AnalyticsEvents() {
    _classCallCheck(this, AnalyticsEvents);

    return _possibleConstructorReturn(this, (AnalyticsEvents.__proto__ || Object.getPrototypeOf(AnalyticsEvents)).apply(this, arguments));
  }

  _createClass(AnalyticsEvents, [{
    key: 'getAggregate',

    /**
     * @param {!AnalyticsRequest} req Request object
     *
     * @returns {Promise} Promise that resolves with the analytics aggregate data from the api.
     *
     * @example
     * const req = d2.analytics.request()
     *  .withProgram('eBAyeGv0exc')
     *  .addDataDimension(['Uvn6LCg7dVU','OdiHJayrsKo'])
     *  .addPeriodDimension('LAST_4_QUARTERS')
     *  .addOrgUnitDimension(['lc3eMKXaEfw','PMa2VCrupOd'])
     *  .addOrgUnitFilter('O6uvpzGd5pu')
     *  .withStartDate('2017-10-01')
     *  .withEndDate('2017-10-31');
     *
     *  d2.analytics.events.getAggregate(req)
     *  .then(console.log);
     */
    value: function getAggregate(req) {
      return this.get(req.withPath('events/aggregate'));
    }

    /**
     * @param {!AnalyticsRequest} req Request object
     *
     * @returns {Promise} Promise that resolves with the analytics count data from the api.
     *
     * @example
     * const req = d2.analytics.request()
     *  .withProgram('eBAyeGv0exc')
     *  .addDataDimension(['Uvn6LCg7dVU','OdiHJayrsKo'])
     *  .addPeriodDimension('LAST_4_QUARTERS')
     *  .addOrgUnitDimension(['lc3eMKXaEfw','PMa2VCrupOd'])
     *  .addOrgUnitFilter('O6uvpzGd5pu')
     *  .withStartDate('2017-10-01')
     *  .withEndDate('2017-10-31');
     *
     *  d2.analytics.events.getCount(req)
     *  .then(console.log);
     */

  }, {
    key: 'getCount',
    value: function getCount(req) {
      return this.get(req.withPath('events/count'));
    }

    /**
     * @param {!AnalyticsRequest} req Request object
     * Must contain clusterSize and bbox parameters.
     *
     * @returns {Promise} Promise that resolves with the analytics cluster data from the api.
     *
     * @example
     * const req = d2.analytics.request()
     *  .withProgram('eBAyeGv0exc')
     *  .addDataDimension(['Uvn6LCg7dVU','OdiHJayrsKo'])
     *  .addPeriodDimension('LAST_4_QUARTERS')
     *  .addOrgUnitDimension(['lc3eMKXaEfw','PMa2VCrupOd'])
     *  .addOrgUnitFilter('O6uvpzGd5pu')
     *  .withStartDate('2017-10-01')
     *  .withEndDate('2017-10-31')
     *  .withClusterSize(100000)
     *  .withBbox('-13.2682125,7.3721619,-10.4261178,9.904012');
     *
     *  d2.analytics.events.getCluster(req)
     *  .then(console.log);
     */

  }, {
    key: 'getCluster',
    value: function getCluster(req) {
      return this.get(req.withPath('events/cluster'));
    }

    /**
     * @param {!AnalyticsRequest} req Request object
     *
     * @returns {Promise} Promise that resolves with the analytics query data from the api.
     *
     * @example
     * const req = d2.analytics.request()
     *  .withProgram('eBAyeGv0exc')
     *  .addDataDimension(['Uvn6LCg7dVU','OdiHJayrsKo'])
     *  .addPeriodDimension('LAST_4_QUARTERS')
     *  .addOrgUnitDimension(['lc3eMKXaEfw','PMa2VCrupOd'])
     *  .addOrgUnitFilter('O6uvpzGd5pu')
     *  .withStartDate('2017-10-01')
     *  .withEndDate('2017-10-31');
     *
     *  d2.analytics.events.getQuery(req)
     *  .then(console.log);
     */

  }, {
    key: 'getQuery',
    value: function getQuery(req) {
      return this.get(req.withPath('events/query'));
    }
  }]);

  return AnalyticsEvents;
}(_AnalyticsBase3.default);

exports.default = AnalyticsEvents;
//# sourceMappingURL=AnalyticsEvents.js.map

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AnalyticsRequest = __webpack_require__(74);

var _AnalyticsRequest2 = _interopRequireDefault(_AnalyticsRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @private
 * @description
 * AnalyticsRequest dimensions mixin function
 *
 * @param {*} base The base class to mix onto
 * @return {module:analytics.AnalyticsRequestDimensionsMixin} The mixin class
 */
var AnalyticsRequestDimensionsMixin = function AnalyticsRequestDimensionsMixin(base) {
    return (
        /**
         * @private
         * @description
         * AnalyticsRequest dimensions mixin class
         *
         * @alias module:analytics.AnalyticsRequestDimensionsMixin
         */
        function (_base) {
            _inherits(_class, _base);

            function _class() {
                _classCallCheck(this, _class);

                return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }

            _createClass(_class, [{
                key: 'addDataDimension',

                /**
                 * Adds/updates the dx dimension to use in the request.
                 *
                 * @param {!(String|Array)} values The dimension items to add to the dx dimension
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .addDataDimension(['fbfJHSPpUQD', 'cYeuwXTCPkU'])
                 *    .addDataDimension('BfMAe6Itzgt.REPORTING_RATE');
                 *
                 * // dimension=dx:fbfJHSPpUQD;cYeuwXTCPkU;BfMAe6Itzgt.REPORTING_RATE
                 *
                 */
                value: function addDataDimension(values) {
                    return this.addDimension('dx', values);
                }

                /**
                 * Adds/updates the pe dimension to use in the request.
                 *
                 * @param {!(String|Array)} values The dimension items to add to the pe dimension
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .addPeriodDimension(['201701', '201702'])
                 *    .addPeriodDimension('LAST_4_QUARTERS');
                 *
                 * // dimension=pe:201701;201702;LAST_4_QUARTERS
                 */

            }, {
                key: 'addPeriodDimension',
                value: function addPeriodDimension(values) {
                    return this.addDimension('pe', values);
                }

                /**
                 * Adds/updates the ou dimension to use in the request.
                 *
                 * @param {!(String|Array)} values The dimension items to add to the ou dimension
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .addOrgUnitDimension(['O6uvpzGd5pu', 'lc3eMKXaEfw'])
                 *    .addOrgUnitDimension('OU_GROUP-w0gFTTmsUcF');
                 *
                 * // dimension=ou:O6uvpzGd5pu;lc3eMKXaEfw;OU_GROUP-w0gFTTmsUcF
                 */

            }, {
                key: 'addOrgUnitDimension',
                value: function addOrgUnitDimension(values) {
                    return this.addDimension('ou', values);
                }

                /**
                 * Adds a new dimension or updates an existing one to use in the request.
                 *
                 * @param {!String} dimension The dimension to add to the request
                 * @param {(String|Array)} values The dimension items to add to the dimension
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .addDimension('Bpx0589u8y0', ['oRVt7g429ZO', 'MAs88nJc9nL'])
                 *    .addDimension('qrur9Dvnyt5-Yf6UHoPkdS6');
                 *
                 * // dimension=Bpx0589u8y0:oRVt7g429ZO;MAs88nJc9nL&dimension=qrur9Dvnyt5-Yf6UHoPkdS6
                 */

            }, {
                key: 'addDimension',
                value: function addDimension(dimension, values) {
                    var existingValues = this.dimensions[dimension] || [];

                    if (typeof values === 'string') {
                        this.dimensions[dimension] = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(existingValues), [values]))));
                    } else if (Array.isArray(values)) {
                        this.dimensions[dimension] = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(existingValues), _toConsumableArray(values)))));
                    } else {
                        this.dimensions[dimension] = existingValues;
                    }

                    return new _AnalyticsRequest2.default(this);
                }
            }]);

            return _class;
        }(base)
    );
};

exports.default = AnalyticsRequestDimensionsMixin;
//# sourceMappingURL=AnalyticsRequestDimensionsMixin.js.map

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AnalyticsRequest = __webpack_require__(74);

var _AnalyticsRequest2 = _interopRequireDefault(_AnalyticsRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @private
 * @description
 * AnalyticsRequest filters mixin function
 *
 * @param {*} base The base class to mix onto
 * @return {module:analytics.AnalyticsRequestFiltersMixin} The mixin class
 * @mixin
 */
var AnalyticsRequestFiltersMixin = function AnalyticsRequestFiltersMixin(base) {
    return (
        /**
         * @private
         * @description
         * AnalyticsRequest filters mixin class
         *
         * @alias module:analytics.AnalyticsRequestFiltersMixin
         */
        function (_base) {
            _inherits(_class, _base);

            function _class() {
                _classCallCheck(this, _class);

                return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }

            _createClass(_class, [{
                key: 'addDataFilter',

                /**
                 * Adds/updates the dx dimension filter to use in the request.
                 *
                 * @param {!(String|Array)} values The dimension items to add to the dx dimension filter
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .addDataFilter(['fbfJHSPpUQD', 'cYeuwXTCPkU'])
                 *    .addDataFilter('BfMAe6Itzgt.REPORTING_RATE');
                 *
                 * // filter=dx:fbfJHSPpUQD;cYeuwXTCPkU;BfMAe6Itzgt.REPORTING_RATE
                 */
                value: function addDataFilter(values) {
                    return this.addFilter('dx', values);
                }

                /**
                 * Adds/updates the pe dimension filter to use in the request.
                 *
                 * @param {!(String|Array)} values The dimension items to add to the pe dimension filter
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .addPeriodFilter(['201701', '201702'])
                 *    .addPeriodFilter('LAST_4_QUARTERS')
                 *
                 * // filter=pe:201701;201702;LAST_4_QUARTERS
                 */

            }, {
                key: 'addPeriodFilter',
                value: function addPeriodFilter(values) {
                    return this.addFilter('pe', values);
                }

                /**
                 * Adds/updates the ou dimension filter to use in the request.
                 *
                 * @param {!(String|Array)} values The dimension items to add to the ou dimension filter
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .addOrgUnitFilter(['O6uvpzGd5pu', 'lc3eMKXaEfw'])
                 *    .addOrgUnitFilter('OU_GROUP-w0gFTTmsUcF')
                 *
                 * // filter=ou:O6uvpzGd5pu;lc3eMKXaEfw;OU_GROUP-w0gFTTmsUcF
                 */

            }, {
                key: 'addOrgUnitFilter',
                value: function addOrgUnitFilter(values) {
                    return this.addFilter('ou', values);
                }

                /**
                 * Adds a filter to the request.
                 *
                 * @param {!String} dimension The dimension to add as filter to the request
                 * @param {(String|Array)} values The dimension items to add to the dimension filter
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .addFilter('Bpx0589u8y0', ['oRVt7g429ZO', 'MAs88nJc9nL'])
                 *    .addFilter('qrur9Dvnyt5-Yf6UHoPkdS6');
                 *
                 * // filter=Bpx0589u8y0:oRVt7g429ZO;MAs88nJc9nL&filter=qrur9Dvnyt5-Yf6UHoPkdS6
                 */

            }, {
                key: 'addFilter',
                value: function addFilter(dimension, values) {
                    var existingValues = this.filters[dimension] || [];

                    if (typeof values === 'string') {
                        this.filters[dimension] = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(existingValues), [values]))));
                    } else if (Array.isArray(values)) {
                        this.filters[dimension] = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(existingValues), _toConsumableArray(values)))));
                    } else {
                        this.filters[dimension] = existingValues;
                    }

                    return new _AnalyticsRequest2.default(this);
                }
            }]);

            return _class;
        }(base)
    );
};

exports.default = AnalyticsRequestFiltersMixin;
//# sourceMappingURL=AnalyticsRequestFiltersMixin.js.map

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AnalyticsRequest = __webpack_require__(74);

var _AnalyticsRequest2 = _interopRequireDefault(_AnalyticsRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-console: 0 */

/**
 * @private
 * @description
 * AnalyticsRequest properties mixin function
 *
 * @param {*} base The base class to mix onto
 * @return {module:analytics.AnalyticsRequestPropertiesMixin} The mixin class
 */
var AnalyticsRequestPropertiesMixin = function AnalyticsRequestPropertiesMixin(base) {
    return (
        /**
         * @private
         * @description
         * AnalyticsRequest properties mixin
         *
         * @alias module:analytics.AnalyticsRequestPropertiesMixin
         */
        function (_base) {
            _inherits(_class, _base);

            function _class() {
                _classCallCheck(this, _class);

                return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }

            _createClass(_class, [{
                key: 'withPath',

                /**
                 * Sets the URL path for the request.
                 * It appends the given path to the request's URL.
                 *
                 * @param {!String} path The path of the response
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withPath('aggregate');
                 */
                value: function withPath(path) {
                    if (path) {
                        this.path = path;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Sets the response format for the request.
                 * It appends the file extension to the request's path.
                 *
                 * @param {String} [format=json] The format of the response
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withFormat('xml');
                 */

            }, {
                key: 'withFormat',
                value: function withFormat() {
                    var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'json';

                    this.format = format;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the aggregationType query parameter to the request.
                 *
                 * @param {String} aggregationType The aggregationType value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withAggregationType('SUM');
                 */

            }, {
                key: 'withAggregationType',
                value: function withAggregationType(value) {
                    var aggregationType = value.toUpperCase();

                    var aggregationTypes = new Set(['AVERAGE', 'AVERAGE_SUM_ORG_UNIT', 'COUNT', 'LAST', 'LAST_AVERAGE_ORG_UNIT', 'MIN', 'MAX', 'STDDEV', 'SUM', 'VARIANCE']);

                    if (aggregationTypes.has(aggregationType)) {
                        this.parameters.aggregationType = aggregationType;
                    } else {
                        console.warn('d2.analytics.request.withAggregationType(): "' + value + '" not listed as possible value');
                        this.parameters.aggregationType = value;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the measureCriteria query parameter to the request.
                 *
                 * @param {!String} measureCriteria The measureCriteria value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withMeasureCriteria('GE:10;LT:50');
                 */

            }, {
                key: 'withMeasureCriteria',
                value: function withMeasureCriteria(criteria) {
                    if (criteria) {
                        this.parameters.measureCriteria = criteria;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the preAggregationMeasureCriteria query parameter to the request.
                 *
                 * @param {!String} preAggregationMeasureCriteria The preAggregationMeasureCriteria value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withPreAggregationMeasureCriteria('GE:10;LT:50');
                 */

            }, {
                key: 'withPreAggregationMeasureCriteria',
                value: function withPreAggregationMeasureCriteria(criteria) {
                    if (criteria) {
                        this.parameters.preAggregationMeasureCriteria = criteria;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the skipMeta query parameter to the request.
                 *
                 * @param {Boolean} [skipMeta=true] The skipMeta value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withSkipMeta();
                 */

            }, {
                key: 'withSkipMeta',
                value: function withSkipMeta() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.skipMeta = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the skipData query parameter to the request.
                 *
                 * @param {Boolean} [skipData=true] The skipData value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withSkipData();
                 */

            }, {
                key: 'withSkipData',
                value: function withSkipData() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.skipData = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the hierarchyMeta query parameter to the request.
                 *
                 * @param {Boolean} [hierarchyMeta=true] The hierarchyMeta value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withHierarchyMeta();
                 */

            }, {
                key: 'withHierarchyMeta',
                value: function withHierarchyMeta() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.hierarchyMeta = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the ignoreLimit query parameter to the request.
                 *
                 * @param {Boolean} [ignoreLimit=true] The ignoreLimit value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withIgnoreLimit();
                 */

            }, {
                key: 'withIgnoreLimit',
                value: function withIgnoreLimit() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.ignoreLimit = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the tableLayout query parameter to the request.
                 *
                 * @param {Boolean} [tableLayout=true] The tableLayout value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withTableLayout();
                 */

            }, {
                key: 'withTableLayout',
                value: function withTableLayout() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.tableLayout = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the hideEmptyRows query parameter to the request.
                 *
                 * @param {Boolean} [hideEmptyRows=true] The hideEmptyRows value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withHideEmptyRows();
                 */

            }, {
                key: 'withHideEmptyRows',
                value: function withHideEmptyRows() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.hideEmptyRows = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the hideEmptyColumns query parameter to the request.
                 *
                 * @param {Boolean} [hideEmptyColumns=true] The hideEmptyColumns value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withHideEmptyColumns();
                 */

            }, {
                key: 'withHideEmptyColumns',
                value: function withHideEmptyColumns() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.hideEmptyColumns = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the showHierarchy query parameter to the request.
                 *
                 * @param {Boolean} [showHierarchy=true] The showHierarchy value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withShowHierarchy();
                 */

            }, {
                key: 'withShowHierarchy',
                value: function withShowHierarchy() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.showHierarchy = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the includeNumDen query parameter to the request.
                 *
                 * @param {Boolean} [includeNumDen=true] The includeNumDen value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withIncludeNumDen();
                 */

            }, {
                key: 'withIncludeNumDen',
                value: function withIncludeNumDen() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.includeNumDen = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the displayProperty query parameter to the request.
                 *
                 * @param {!String} displayProperty The displayProperty value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withDisplayProperty('SHORTNAME');
                 */

            }, {
                key: 'withDisplayProperty',
                value: function withDisplayProperty(value) {
                    var displayProperty = value.toUpperCase();

                    var displayProperties = new Set(['NAME', 'SHORTNAME']);

                    if (displayProperties.has(displayProperty)) {
                        this.parameters.displayProperty = displayProperty;
                    } else {
                        console.warn('d2.analytics.request.withDisplayProperty(): "' + value + '" not listed as possible value');
                        this.parameters.displayProperty = value;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the displayProperty query parameter to the request.
                 *
                 * @param {!String} displayProperty The displayProperty value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withDisplayProperty('SHORTNAME');
                 */

            }, {
                key: 'withOutputIdScheme',
                value: function withOutputIdScheme(scheme) {
                    if (scheme) {
                        this.parameters.outputIdScheme = scheme;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the inputIdScheme query parameter to the request.
                 *
                 * @param {!String} inputIdScheme The inputIdScheme value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withInputIdScheme('CODE');
                 */

            }, {
                key: 'withInputIdScheme',
                value: function withInputIdScheme(scheme) {
                    if (scheme) {
                        this.parameters.inputIdScheme = scheme;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the approvalLevel query parameter to the request.
                 *
                 * @param {!String} approvalLevel The approvalLevel value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withApprovalLevel('');
                 */

            }, {
                key: 'withApprovalLevel',
                value: function withApprovalLevel(level) {
                    if (level) {
                        this.parameters.approvalLevel = level;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the relativePeriodDate query parameter to the request.
                 *
                 * @param {!String} relativePeriodDate The relativePeriodDate value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withRelativePeriodDate('LAST_12_MONTHS');
                 */

            }, {
                key: 'withRelativePeriodDate',
                value: function withRelativePeriodDate(date) {
                    if (date) {
                        this.parameters.relativePeriodDate = date;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the userOrgUnit query parameter to the request.
                 *
                 * @param {!String} userOrgUnit The userOrgUnit value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withUserOrgUnit('O6uvpzGd5pu');
                 */

            }, {
                key: 'withUserOrgUnit',
                value: function withUserOrgUnit(orgUnit) {
                    if (orgUnit) {
                        this.parameters.userOrgUnit = orgUnit;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the columns query parameter to the request.
                 *
                 * @param {!String} columns The dimensions identifiers (separated by ;)
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withColumns('dx;ou');
                 */

            }, {
                key: 'withColumns',
                value: function withColumns(dimensions) {
                    if (dimensions) {
                        this.parameters.columns = dimensions;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the rows query parameter to the request.
                 *
                 * @param {!String} rows The dimensions identifiers (separated by ;)
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withRows('pe');
                 */

            }, {
                key: 'withRows',
                value: function withRows(dimensions) {
                    if (dimensions) {
                        this.parameters.rows = dimensions;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the startDate query parameter to the request.
                 *
                 * @param {!String} startDate The startDate value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withStartDate('2017-11-28');
                 */

            }, {
                key: 'withStartDate',
                value: function withStartDate(date) {
                    if (date) {
                        this.parameters.startDate = date;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the endDate query parameter to the request.
                 *
                 * @param {!String} endDate The endDate value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withEndDate('2017-12-31');
                 */

            }, {
                key: 'withEndDate',
                value: function withEndDate(date) {
                    if (date) {
                        this.parameters.endDate = date;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Sets the program for the request.
                 * It appends the program id to the request's path.
                 *
                 * @param {!String} program The program id
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withProgram('eBAyeGv0exc');
                 */

            }, {
                key: 'withProgram',
                value: function withProgram(program) {
                    if (program) {
                        this.program = program;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the stage query parameter to the request.
                 *
                 * @param {!String} stage The stage value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withStage('Zj7UnCAulEk');
                 */

            }, {
                key: 'withStage',
                value: function withStage(stage) {
                    if (stage) {
                        this.parameters.stage = stage;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the eventStatus query parameter to the request.
                 *
                 * @param {!String} eventStatus The eventStatus value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withEventStatus('COMPLETED');
                 */

            }, {
                key: 'withEventStatus',
                value: function withEventStatus(value) {
                    var eventStatus = value.toUpperCase();

                    var eventStatuses = new Set(['ACTIVE', 'COMPLETED', 'SCHEDULED', 'OVERDUE', 'SKIPPED']);

                    if (eventStatuses.has(eventStatus)) {
                        this.parameters.eventStatus = eventStatus;
                    } else {
                        console.warn('d2.analytics.request.withEventStatus(): "' + value + '" not listed as possible value');
                        this.parameters.eventStatus = value;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the programStatus query parameter to the request.
                 *
                 * @param {!String} programStatus The programStatus value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withProgramStatus('COMPLETED');
                 */

            }, {
                key: 'withProgramStatus',
                value: function withProgramStatus(value) {
                    var programStatus = value.toUpperCase();

                    var programStatuses = new Set(['ACTIVE', 'COMPLETED', 'CANCELLED']);

                    if (programStatuses.has(programStatus)) {
                        this.parameters.programStatus = programStatus;
                    } else {
                        console.warn('d2.analytics.request.withProgramStatus(): "' + value + '" not listed as possible value');
                        this.parameters.programStatus = value;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the ouMode query parameter to the request.
                 *
                 * @param {!String} ouMode The ouMode value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withOuMode('CHILDREN');
                 */

            }, {
                key: 'withOuMode',
                value: function withOuMode(value) {
                    var ouMode = value.toUpperCase();

                    var ouModes = new Set(['DESCENDANTS', 'CHILDREN', 'SELECTED']);

                    if (ouModes.has(ouMode)) {
                        this.parameters.ouMode = ouMode;
                    } else {
                        console.warn('d2.analytics.request.withOuMode(): "' + value + '" not listed as possible value');
                        this.parameters.ouMode = value;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the asc query parameter to the request.
                 *
                 * @param {!String} value The dimensions to be sorted ascending
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withAsc('EVENTDATE');
                 */

            }, {
                key: 'withAsc',
                value: function withAsc(value) {
                    if (value) {
                        this.parameters.asc = value;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the desc query parameter to the request.
                 *
                 * @param {!String} value The dimensions to be sorted descending
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withDesc('OUNAME');
                 */

            }, {
                key: 'withDesc',
                value: function withDesc(value) {
                    if (value) {
                        this.parameters.desc = value;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the coordinatesOnly query parameter to the request.
                 *
                 * @param {Boolean} [coordinatesOnly=true] The coordinatesOnly value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withCoordinatesOnly();
                 */

            }, {
                key: 'withCoordinatesOnly',
                value: function withCoordinatesOnly() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.coordinatesOnly = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the page query parameter to the request.
                 *
                 * @param {!Number} [page=1] The page number
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withPage(2);
                 */

            }, {
                key: 'withPage',
                value: function withPage() {
                    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

                    this.parameters.page = page;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the pageSize query parameter to the request.
                 *
                 * @param {!Number} [size=50] The number of items per page
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withPageSize(10);
                 */

            }, {
                key: 'withPageSize',
                value: function withPageSize() {
                    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;

                    this.parameters.pageSize = size;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the value query parameter to the request.
                 *
                 * @param {!String} value A data element or attribute identifier
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withValue('UXz7xuGCEhU');
                 */

            }, {
                key: 'withValue',
                value: function withValue(value) {
                    // must be a data element or attribute of numeric value type
                    if (value) {
                        this.parameters.value = value;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the sortOrder query parameter to the request.
                 *
                 * @param {!String} sortOrder The sortOrder value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withSortOrder('DESC');
                 */

            }, {
                key: 'withSortOrder',
                value: function withSortOrder(value) {
                    var sortOrder = value.toUpperCase();

                    var sortOrders = new Set(['ASC', 'DESC']);

                    if (sortOrders.has(sortOrder)) {
                        this.parameters.sortOrder = sortOrder;
                    } else {
                        console.warn('d2.analytics.request.withSortOrder(): "' + value + '" not listed as possible value');
                        this.parameters.sortOrder = value;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the limit query parameter to the request.
                 *
                 * @param {!Number} limit The maximum number of records to return
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withLimit('5000');
                 */

            }, {
                key: 'withLimit',
                value: function withLimit(value) {
                    if (value) {
                        var limit = value > 10000 ? 10000 : value;

                        this.parameters.limit = limit;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the outputType query parameter to the request.
                 *
                 * @param {!String} outputType The output type
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withOutputType('ENROLLMENT');
                 */

            }, {
                key: 'withOutputType',
                value: function withOutputType(value) {
                    var type = value.toUpperCase();

                    var outputTypes = new Set(['EVENT', 'ENROLLMENT', 'TRACKED_ENTITY_INSTANCE']);

                    if (outputTypes.has(type)) {
                        this.parameters.outputType = type;
                    } else {
                        console.warn('d2.analytics.request.withOutputType(): "' + value + '" not listed as possible value');
                        this.parameters.outputType = value;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the collapseDataDimensions query parameter to the request.
                 *
                 * @param {Boolean} [collapseDataDimensions=true] The collapseDataDimensions value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withCollapseDataDimensions();
                 */

            }, {
                key: 'withCollapseDataDimensions',
                value: function withCollapseDataDimensions() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.collapseDataDimensions = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the skipRounding query parameter to the request.
                 *
                 * @param {Boolean} [skipRounding=true] The skipRounding value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withSkipRounding();
                 */

            }, {
                key: 'withSkipRounding',
                value: function withSkipRounding() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.skipRounding = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the aggregateData query parameter to the request.
                 *
                 * @param {Boolean} [aggregateData=true] The aggregateData value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withAggregateData();
                 */

            }, {
                key: 'withAggregateData',
                value: function withAggregateData() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.aggregateData = flag;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the clusterSize query parameter to the request.
                 *
                 * @param {!Number} clusterSize The size of cluster in meters
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withClusterSize(1000);
                 */

            }, {
                key: 'withClusterSize',
                value: function withClusterSize(size) {
                    if (size) {
                        this.parameters.clusterSize = size;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the coordinateField query parameter to the request.
                 *
                 * @param {!String} [coordinateField=EVENT] The field to base geospatial event analytics on
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withCoordinateField('<attribute-id>');
                 */

            }, {
                key: 'withCoordinateField',
                value: function withCoordinateField() {
                    var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'EVENT';

                    // EVENT, <attribute-id>, <dataelement-id>
                    this.parameters.coordinateField = field;
                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the bbox query parameter to the request.
                 *
                 * @param {!String} bbox The bounding box coordinates in the format "min lng, min lat, max lng, max lat"
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withBbox('11.1768827285209, 60.141691309755, 11.1694071634997, 60.287796722512');
                 */

            }, {
                key: 'withBbox',
                value: function withBbox(bbox) {
                    if (bbox) {
                        this.parameters.bbox = bbox;
                    }

                    return new _AnalyticsRequest2.default(this);
                }

                /**
                 * Adds the includeClusterPoints query parameter to the request.
                 *
                 * @param {Boolean} [includeClusterPoints=true] The includeClusterPoints value
                 *
                 * @returns {AnalyticsRequest} A new instance of the class for chaining purposes
                 *
                 * @example
                 * const req = new d2.analytics.request()
                 *    .withIncludeClusterPoints();
                 */

            }, {
                key: 'withIncludeClusterPoints',
                value: function withIncludeClusterPoints() {
                    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.parameters.includeClusterPoints = flag;
                    return new _AnalyticsRequest2.default(this);
                }
            }]);

            return _class;
        }(base)
    );
};

exports.default = AnalyticsRequestPropertiesMixin;
//# sourceMappingURL=AnalyticsRequestPropertiesMixin.js.map

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(29);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @private
 * @description
 * Class for constructing a request object to use for communicating with the analytics API endpoint.
 *
 * @param {!Object} options Object with analytics request options
 *
 * @requires module:lib/utils
 *
 * @memberof module:analytics
 * @abstract
 */
var AnalyticsRequestBase = function () {
    function AnalyticsRequestBase() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$endPoint = _ref.endPoint,
            endPoint = _ref$endPoint === undefined ? 'analytics' : _ref$endPoint,
            _ref$format = _ref.format,
            format = _ref$format === undefined ? 'json' : _ref$format,
            path = _ref.path,
            program = _ref.program,
            _ref$dimensions = _ref.dimensions,
            dimensions = _ref$dimensions === undefined ? {} : _ref$dimensions,
            _ref$filters = _ref.filters,
            filters = _ref$filters === undefined ? {} : _ref$filters,
            _ref$parameters = _ref.parameters,
            parameters = _ref$parameters === undefined ? {} : _ref$parameters;

        _classCallCheck(this, AnalyticsRequestBase);

        this.endPoint = endPoint;
        this.format = format.toLowerCase();
        this.path = path;
        this.program = program;

        this.dimensions = _extends({}, dimensions);
        this.filters = _extends({}, filters);
        this.parameters = _extends({}, parameters);
    }

    /**
     * @private
     * @description
     * Builds the URL to pass to the Api object.
     * The URL includes the dimension(s) parameters.
     * Used internally.
     *
     * @returns {String} URL URL for the request with dimensions included
     */


    _createClass(AnalyticsRequestBase, [{
        key: 'buildUrl',
        value: function buildUrl() {
            // at least 1 dimension is required
            var encodedDimensions = Object.entries(this.dimensions).map(function (_ref2) {
                var _ref3 = _slicedToArray(_ref2, 2),
                    dimension = _ref3[0],
                    values = _ref3[1];

                if (Array.isArray(values) && values.length) {
                    return dimension + ':' + values.map(_utils.customEncodeURIComponent).join(';');
                }

                return dimension;
            });

            var endPoint = [this.endPoint, this.path, this.program].filter(function (e) {
                return !!e;
            }).join('/');

            return endPoint + '.' + this.format + '?dimension=' + encodedDimensions.join('&dimension=');
        }

        /**
         * @private
         * @description
         * Builds the query object passed to the API instance.
         * The object includes all the parameters added via with*() methods
         * and the filters added via addDataFilter(), addPeriodFilter(), addOrgUnitFilter(), addFilter().
         * The filters are handled by the API instance when building the final URL.
         * Used internally.
         *
         * @returns {Object} Query parameters
         */

    }, {
        key: 'buildQuery',
        value: function buildQuery() {
            var encodedFilters = Object.entries(this.filters).map(function (_ref4) {
                var _ref5 = _slicedToArray(_ref4, 2),
                    dimension = _ref5[0],
                    values = _ref5[1];

                return dimension + ':' + values.map(_utils.customEncodeURIComponent).join(';');
            });

            if (encodedFilters.length) {
                this.parameters.filter = encodedFilters;
            }

            return this.parameters;
        }
    }]);

    return AnalyticsRequestBase;
}();

exports.default = AnalyticsRequestBase;
//# sourceMappingURL=AnalyticsRequestBase.js.map

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Api = __webpack_require__(20);

var _Api2 = _interopRequireDefault(_Api);

var _uid = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class GeoFeatures
 * @description
 * GeoFeatures class used to request organisation unit coordinates from the Web API.
 */
var GeoFeatures = function () {
    /**
     * @constructor
     *
     * @param {Array} orgUnits Organisation units (UID, level, group, user org. unit) to include in the response.
     * @param {String} displayName The name property to display (NAME|SHORTNAME).
     */
    function GeoFeatures() {
        var orgUnits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var displayName = arguments[1];

        _classCallCheck(this, GeoFeatures);

        this.orgUnits = orgUnits;
        this.displayName = displayName;
    }

    /**
     * @method byOrgUnit
     *
     * @param {Array} orgUnits Organisation units (UID, level, group, user org. unit) to include in the response.
     *
     * @returns {GeoFeatures}
     */


    _createClass(GeoFeatures, [{
        key: 'byOrgUnit',
        value: function byOrgUnit(orgUnits) {
            if (!orgUnits) {
                return this;
            }

            var orgUnitsArray = [].concat(orgUnits);

            if (!orgUnitsArray.every(GeoFeatures.isValidOrgUnit)) {
                throw new Error('Invalid organisation unit: ' + orgUnits);
            }

            return new GeoFeatures(orgUnitsArray, this.displayName);
        }

        /**
         * @method byOrgUnit
         *
         * @param {String} displayName The name property to display (NAME|SHORTNAME).
         *
         * @returns {GeoFeatures}
         */

    }, {
        key: 'displayProperty',
        value: function displayProperty(displayName) {
            if (!displayName) {
                return this;
            }

            if (!GeoFeatures.isValidDisplayName(displayName)) {
                throw new Error('Invalid display property: ' + displayName);
            }

            return new GeoFeatures(this.orgUnits, displayName);
        }

        /**
         * @method getAll
         *
         * @param {Object} params Extra URL params to pass to the Web API endpoint.
         *
         * @returns {Promise} with an array of geofeatures.
         */

    }, {
        key: 'getAll',
        value: function getAll() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var api = _Api2.default.getApi();
            var urlParams = params;

            if (this.orgUnits.length) {
                urlParams.ou = 'ou:' + this.orgUnits.join(';');
            }

            if (this.displayName) {
                urlParams.displayProperty = this.displayName;
            }

            return api.get('geoFeatures', urlParams);
        }

        /**
         * @method isValidOrgUnit
         * @static
         *
         * @returns {boolean} True if the org. unit is valid
         *
         * @description
         * Checks if the org. unit is valid (UID, level, group, user org. unit)
         */

    }], [{
        key: 'isValidOrgUnit',
        value: function isValidOrgUnit(orgUnit) {
            return (0, _uid.isValidUid)(orgUnit) || GeoFeatures.isValidOrgUnitLevel(orgUnit) || GeoFeatures.isValidOrgUnitGroup(orgUnit) || GeoFeatures.isValidUserOrgUnit(orgUnit);
        }

        /**
         * @method isValidOrgUnitLevel
         * @static
         *
         * @returns {boolean} True if the org. unit level is valid
         *
         * @description
         * Checks if the org. unit level is valid.
         */

    }, {
        key: 'isValidOrgUnitLevel',
        value: function isValidOrgUnitLevel(level) {
            return (/^LEVEL-[0-9]+$/.test(level)
            );
        }

        /**
         * @method isValidOrgUnitGroup
         * @static
         *
         * @returns {boolean} True if the org. unit group is valid
         *
         * @description
         * Checks if the org. unit group is valid.
         */

    }, {
        key: 'isValidOrgUnitGroup',
        value: function isValidOrgUnitGroup(group) {
            var match = group.match(/OU_GROUP-(.*)$/);
            return Array.isArray(match) && (0, _uid.isValidUid)(match[1]);
        }

        /**
         * @method isValidUserOrgUnit
         * @static
         *
         * @returns {boolean} True if the user org. unit is valid
         *
         * @description
         * Checks if the user org. unit is valid.
         */

    }, {
        key: 'isValidUserOrgUnit',
        value: function isValidUserOrgUnit(orgUnit) {
            return orgUnit === GeoFeatures.USER_ORGUNIT || orgUnit === GeoFeatures.USER_ORGUNIT_CHILDREN || orgUnit === GeoFeatures.USER_ORGUNIT_GRANDCHILDREN;
        }

        /**
         * @method isValidDisplayName
         * @static
         *
         * @returns {boolean} True if display name is valid
         *
         * @description
         * Checks if the display name is valid.
         */

    }, {
        key: 'isValidDisplayName',
        value: function isValidDisplayName(displayName) {
            return displayName === GeoFeatures.DISPLAY_PROPERTY_NAME || displayName === GeoFeatures.DISPLAY_PROPERTY_SHORTNAME;
        }

        /**
         * @method getGeoFeatures
         * @static
         *
         * @returns {GeoFeatures} Object with interaction properties
         *
         * @description
         * Get a new instance of the GeoFeatures object.
         */

    }, {
        key: 'getGeoFeatures',
        value: function getGeoFeatures() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return new (Function.prototype.bind.apply(GeoFeatures, [null].concat(args)))();
        }
    }]);

    return GeoFeatures;
}();

GeoFeatures.DISPLAY_PROPERTY_NAME = 'NAME';
GeoFeatures.DISPLAY_PROPERTY_SHORTNAME = 'SHORTNAME';
GeoFeatures.USER_ORGUNIT = 'USER_ORGUNIT';
GeoFeatures.USER_ORGUNIT_CHILDREN = 'USER_ORGUNIT_CHILDREN';
GeoFeatures.USER_ORGUNIT_GRANDCHILDREN = 'USER_ORGUNIT_GRANDCHILDREN';
exports.default = GeoFeatures;
//# sourceMappingURL=GeoFeatures.js.map

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourceStore_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Translator_js__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LanguageUtils_js__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PluralResolver_js__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Interpolator_js__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BackendConnector_js__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CacheConnector_js__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__defaults_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__postProcessor_js__ = __webpack_require__(177);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }













function noop() {}

var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  function I18n() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    _classCallCheck(this, I18n);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.options = Object(__WEBPACK_IMPORTED_MODULE_9__defaults_js__["b" /* transformOptions */])(options);
    _this.services = {};
    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */];
    _this.modules = { external: [] };

    if (callback && !_this.isInitialized && !options.isClone) {
      var _ret;

      // https://github.com/i18next/i18next/issues/879
      if (!_this.options.initImmediate) return _ret = _this.init(options, callback), _possibleConstructorReturn(_this, _ret);
      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }

  I18n.prototype.init = function init() {
    var _this2 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_9__defaults_js__["a" /* get */])(), this.options, Object(__WEBPACK_IMPORTED_MODULE_9__defaults_js__["b" /* transformOptions */])(options));

    this.format = this.options.interpolation.format;
    if (!callback) callback = noop;

    function createClassOnDemand(ClassOrObject) {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    }

    // init services
    if (!this.options.isClone) {
      if (this.modules.logger) {
        __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].init(null, this.options);
      }

      var lu = new __WEBPACK_IMPORTED_MODULE_4__LanguageUtils_js__["a" /* default */](this.options);
      this.store = new __WEBPACK_IMPORTED_MODULE_2__ResourceStore_js__["a" /* default */](this.options.resources, this.options);

      var s = this.services;
      s.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */];
      s.resourceStore = this.store;
      s.resourceStore.on('added removed', function (lng, ns) {
        s.cacheConnector.save();
      });
      s.languageUtils = lu;
      s.pluralResolver = new __WEBPACK_IMPORTED_MODULE_5__PluralResolver_js__["a" /* default */](lu, { prepend: this.options.pluralSeparator, compatibilityJSON: this.options.compatibilityJSON, simplifyPluralSuffix: this.options.simplifyPluralSuffix });
      s.interpolator = new __WEBPACK_IMPORTED_MODULE_6__Interpolator_js__["a" /* default */](this.options);

      s.backendConnector = new __WEBPACK_IMPORTED_MODULE_7__BackendConnector_js__["a" /* default */](createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.backendConnector.on('*', function (event) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      s.backendConnector.on('loaded', function (loaded) {
        s.cacheConnector.save();
      });

      s.cacheConnector = new __WEBPACK_IMPORTED_MODULE_8__CacheConnector_js__["a" /* default */](createClassOnDemand(this.modules.cache), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.cacheConnector.on('*', function (event) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        s.languageDetector.init(s, this.options.detection, this.options);
      }

      this.translator = new __WEBPACK_IMPORTED_MODULE_3__Translator_js__["a" /* default */](this.services, this.options);
      // pipe events from translator
      this.translator.on('*', function (event) {
        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      this.modules.external.forEach(function (m) {
        if (m.init) m.init(_this2);
      });
    }

    // append api
    var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle'];
    storeApi.forEach(function (fcName) {
      _this2[fcName] = function () {
        var _store;

        return (_store = _this2.store)[fcName].apply(_store, arguments);
      };
    });

    var load = function load() {
      _this2.changeLanguage(_this2.options.lng, function (err, t) {
        _this2.isInitialized = true;
        _this2.logger.log('initialized', _this2.options);
        _this2.emit('initialized', _this2.options);

        callback(err, t);
      });
    };

    if (this.options.resources || !this.options.initImmediate) {
      load();
    } else {
      setTimeout(load, 0);
    }

    return this;
  };

  /* eslint consistent-return: 0 */


  I18n.prototype.loadResources = function loadResources() {
    var _this3 = this;

    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

    if (!this.options.resources) {
      if (this.language && this.language.toLowerCase() === 'cimode') return callback(); // avoid loading resources for cimode

      var toLoad = [];

      var append = function append(lng) {
        if (!lng) return;
        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };

      if (!this.language) {
        // at least load fallbacks in this case
        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach(function (l) {
          return append(l);
        });
      } else {
        append(this.language);
      }

      if (this.options.preload) {
        this.options.preload.forEach(function (l) {
          return append(l);
        });
      }

      this.services.cacheConnector.load(toLoad, this.options.ns, function () {
        _this3.services.backendConnector.load(toLoad, _this3.options.ns, callback);
      });
    } else {
      callback(null);
    }
  };

  I18n.prototype.reloadResources = function reloadResources(lngs, ns) {
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    this.services.backendConnector.reload(lngs, ns);
  };

  I18n.prototype.use = function use(module) {
    if (module.type === 'backend') {
      this.modules.backend = module;
    }

    if (module.type === 'cache') {
      this.modules.cache = module;
    }

    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }

    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }

    if (module.type === 'postProcessor') {
      __WEBPACK_IMPORTED_MODULE_10__postProcessor_js__["a" /* default */].addPostProcessor(module);
    }

    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }

    return this;
  };

  I18n.prototype.changeLanguage = function changeLanguage(lng, callback) {
    var _this4 = this;

    var done = function done(err, l) {
      _this4.translator.changeLanguage(l);

      if (l) {
        _this4.emit('languageChanged', l);
        _this4.logger.log('languageChanged', l);
      }

      if (callback) callback(err, function () {
        return _this4.t.apply(_this4, arguments);
      });
    };

    var setLng = function setLng(l) {
      if (l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        if (!_this4.translator.language) _this4.translator.changeLanguage(l);

        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
      }

      _this4.loadResources(function (err) {
        done(err, l);
      });
    };

    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      this.services.languageDetector.detect(setLng);
    } else {
      setLng(lng);
    }
  };

  I18n.prototype.getFixedT = function getFixedT(lng, ns) {
    var _this5 = this;

    var fixedT = function fixedT(key, opts) {
      for (var _len4 = arguments.length, rest = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        rest[_key4 - 2] = arguments[_key4];
      }

      var options = _extends({}, opts);
      if ((typeof opts === 'undefined' ? 'undefined' : _typeof(opts)) !== 'object') {
        options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
      }

      options.lng = options.lng || fixedT.lng;
      options.lngs = options.lngs || fixedT.lngs;
      options.ns = options.ns || fixedT.ns;
      return _this5.t(key, options);
    };
    if (typeof lng === 'string') {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }
    fixedT.ns = ns;
    return fixedT;
  };

  I18n.prototype.t = function t() {
    var _translator;

    return this.translator && (_translator = this.translator).translate.apply(_translator, arguments);
  };

  I18n.prototype.exists = function exists() {
    var _translator2;

    return this.translator && (_translator2 = this.translator).exists.apply(_translator2, arguments);
  };

  I18n.prototype.setDefaultNamespace = function setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  };

  I18n.prototype.loadNamespaces = function loadNamespaces(ns, callback) {
    var _this6 = this;

    if (!this.options.ns) return callback && callback();
    if (typeof ns === 'string') ns = [ns];

    ns.forEach(function (n) {
      if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
    });

    this.loadResources(callback);
  };

  I18n.prototype.loadLanguages = function loadLanguages(lngs, callback) {
    if (typeof lngs === 'string') lngs = [lngs];
    var preloaded = this.options.preload || [];

    var newLngs = lngs.filter(function (lng) {
      return preloaded.indexOf(lng) < 0;
    });
    // Exit early if all given languages are already preloaded
    if (!newLngs.length) return callback();

    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(callback);
  };

  I18n.prototype.dir = function dir(lng) {
    if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
    if (!lng) return 'rtl';

    var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];

    return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
  };

  /* eslint class-methods-use-this: 0 */


  I18n.prototype.createInstance = function createInstance() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    return new I18n(options, callback);
  };

  I18n.prototype.cloneInstance = function cloneInstance() {
    var _this7 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

    var mergedOptions = _extends({}, this.options, options, { isClone: true });
    var clone = new I18n(mergedOptions);
    var membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(function (m) {
      clone[m] = _this7[m];
    });
    clone.translator = new __WEBPACK_IMPORTED_MODULE_3__Translator_js__["a" /* default */](clone.services, clone.options);
    clone.translator.on('*', function (event) {
      for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      clone.emit.apply(clone, [event].concat(args));
    });
    clone.init(mergedOptions, callback);
    clone.translator.options = clone.options; // sync options

    return clone;
  };

  return I18n;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new I18n());

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventEmitter_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js__ = __webpack_require__(75);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }




var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { ns: ['translation'], defaultNS: 'translation' };

    _classCallCheck(this, ResourceStore);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.data = data || {};
    _this.options = options;
    return _this;
  }

  ResourceStore.prototype.addNamespaces = function addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  };

  ResourceStore.prototype.removeNamespaces = function removeNamespaces(ns) {
    var index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  };

  ResourceStore.prototype.getResource = function getResource(lng, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var keySeparator = options.keySeparator || this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key && typeof key !== 'string') path = path.concat(key);
    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    }

    return __WEBPACK_IMPORTED_MODULE_1__utils_js__["d" /* getPath */](this.data, path);
  };

  ResourceStore.prototype.addResource = function addResource(lng, ns, key, value) {
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { silent: false };

    var keySeparator = this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    __WEBPACK_IMPORTED_MODULE_1__utils_js__["h" /* setPath */](this.data, path, value);

    if (!options.silent) this.emit('added', lng, ns, key, value);
  };

  ResourceStore.prototype.addResources = function addResources(lng, ns, resources) {
    /* eslint no-restricted-syntax: 0 */
    for (var m in resources) {
      if (typeof resources[m] === 'string') this.addResource(lng, ns, m, resources[m], { silent: true });
    }
    this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.addResourceBundle = function addResourceBundle(lng, ns, resources, deep, overwrite) {
    var path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    var pack = __WEBPACK_IMPORTED_MODULE_1__utils_js__["d" /* getPath */](this.data, path) || {};

    if (deep) {
      __WEBPACK_IMPORTED_MODULE_1__utils_js__["b" /* deepExtend */](pack, resources, overwrite);
    } else {
      pack = _extends({}, pack, resources);
    }

    __WEBPACK_IMPORTED_MODULE_1__utils_js__["h" /* setPath */](this.data, path, pack);

    this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.removeResourceBundle = function removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);

    this.emit('removed', lng, ns);
  };

  ResourceStore.prototype.hasResourceBundle = function hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  };

  ResourceStore.prototype.getResourceBundle = function getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;

    // COMPATIBILITY: remove extend in v2.1.0
    if (this.options.compatibilityAPI === 'v1') return _extends({}, this.getResource(lng, ns));

    return this.getResource(lng, ns);
  };

  ResourceStore.prototype.toJSON = function toJSON() {
    return this.data;
  };

  return ResourceStore;
}(__WEBPACK_IMPORTED_MODULE_0__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ResourceStore);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__postProcessor_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_js__ = __webpack_require__(75);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }






var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  function Translator(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Translator);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* copy */](['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector'], services, _this);

    _this.options = options;
    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('translator');
    return _this;
  }

  Translator.prototype.changeLanguage = function changeLanguage(lng) {
    if (lng) this.language = lng;
  };

  Translator.prototype.exists = function exists(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { interpolation: {} };

    var resolved = this.resolve(key, options);
    return resolved && resolved.res !== undefined;
  };

  Translator.prototype.extractFromKey = function extractFromKey(key, options) {
    var nsSeparator = options.nsSeparator || this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';
    var keySeparator = options.keySeparator || this.options.keySeparator || '.';

    var namespaces = options.ns || this.options.defaultNS;
    if (nsSeparator && key.indexOf(nsSeparator) > -1) {
      var parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    if (typeof namespaces === 'string') namespaces = [namespaces];

    return {
      key: key,
      namespaces: namespaces
    };
  };

  Translator.prototype.translate = function translate(keys, options) {
    var _this2 = this;

    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object' && this.options.overloadTranslationOptionHandler) {
      /* eslint prefer-rest-params: 0 */
      options = this.options.overloadTranslationOptionHandler(arguments);
    }
    if (!options) options = {};

    // non valid keys handling
    if (keys === undefined || keys === null || keys === '') return '';
    if (typeof keys === 'number') keys = String(keys);
    if (typeof keys === 'string') keys = [keys];

    // separators
    var keySeparator = options.keySeparator || this.options.keySeparator || '.';

    // get namespace(s)

    var _extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
        key = _extractFromKey.key,
        namespaces = _extractFromKey.namespaces;

    var namespace = namespaces[namespaces.length - 1];

    // return key on CIMode
    var lng = options.lng || this.language;
    var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng && lng.toLowerCase() === 'cimode') {
      if (appendNamespaceToCIMode) {
        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
        return namespace + nsSeparator + key;
      }

      return key;
    }

    // resolve from store
    var resolved = this.resolve(keys, options);
    var res = resolved && resolved.res;
    var resUsedKey = resolved && resolved.usedKey || key;

    var resType = Object.prototype.toString.apply(res);
    var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;

    // object
    var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
    if (res && handleAsObject && noObject.indexOf(resType) < 0 && !(joinArrays && resType === '[object Array]')) {
      if (!options.returnObjects && !this.options.returnObjects) {
        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : 'key \'' + key + ' (' + this.language + ')\' returned an object instead of string.';
      }

      // if we got a separator we loop over children - else we just return object as is
      // as having it set to false means no hierarchy so no lookup for nested values
      if (options.keySeparator || this.options.keySeparator) {
        var copy = resType === '[object Array]' ? [] : {}; // apply child translation on a copy

        /* eslint no-restricted-syntax: 0 */
        for (var m in res) {
          if (Object.prototype.hasOwnProperty.call(res, m)) {
            var deepKey = '' + resUsedKey + keySeparator + m;
            copy[m] = this.translate(deepKey, _extends({}, options, { joinArrays: false, ns: namespaces }));
            if (copy[m] === deepKey) copy[m] = res[m]; // if nothing found use orginal value as fallback
          }
        }
        res = copy;
      }
    } else if (joinArrays && resType === '[object Array]') {
      // array special treatment
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, keys, options);
    } else {
      // string, empty or null
      var usedDefault = false;
      var usedKey = false;

      // fallback value
      if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
        usedDefault = true;
        res = options.defaultValue;
      }
      if (!this.isValidLookup(res)) {
        usedKey = true;
        res = key;
      }

      // save missing
      var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;
      if (usedKey || usedDefault || updateMissing) {
        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);

        var lngs = [];
        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
          for (var i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === 'all') {
          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
        } else {
          lngs.push(options.lng || this.language);
        }

        var send = function send(l, k) {
          if (_this2.options.missingKeyHandler) {
            _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
          } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
            _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
          }
          _this2.emit('missingKey', l, namespace, k, res);
        };

        if (this.options.saveMissing) {
          if (this.options.saveMissingPlurals && options.count) {
            lngs.forEach(function (l) {
              var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);

              plurals.forEach(function (p) {
                return send([l], p);
              });
            });
          } else {
            send(lngs, key);
          }
        }
      }

      // extend
      res = this.extendTranslation(res, keys, options);

      // append namespace if still key
      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = namespace + ':' + key;

      // parseMissingKeyHandler
      if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
    }

    // return
    return res;
  };

  Translator.prototype.extendTranslation = function extendTranslation(res, key, options) {
    var _this3 = this;

    if (options.interpolation) this.interpolator.init(_extends({}, options, { interpolation: _extends({}, this.options.interpolation, options.interpolation) }));

    // interpolate
    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
    if (this.options.interpolation.defaultVariables) data = _extends({}, this.options.interpolation.defaultVariables, data);
    res = this.interpolator.interpolate(res, data, options.lng || this.language);

    // nesting
    if (options.nest !== false) res = this.interpolator.nest(res, function () {
      return _this3.translate.apply(_this3, arguments);
    }, options);

    if (options.interpolation) this.interpolator.reset();

    // post process
    var postProcess = options.postProcess || this.options.postProcess;
    var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

    if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
      res = __WEBPACK_IMPORTED_MODULE_2__postProcessor_js__["a" /* default */].handle(postProcessorNames, res, key, options, this);
    }

    return res;
  };

  Translator.prototype.resolve = function resolve(keys) {
    var _this4 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var found = void 0;
    var usedKey = void 0;

    if (typeof keys === 'string') keys = [keys];

    // forEach possible key
    keys.forEach(function (k) {
      if (_this4.isValidLookup(found)) return;
      var extracted = _this4.extractFromKey(k, options);
      var key = extracted.key;
      usedKey = key;
      var namespaces = extracted.namespaces;
      if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);

      var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
      var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';

      var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language);

      namespaces.forEach(function (ns) {
        if (_this4.isValidLookup(found)) return;

        codes.forEach(function (code) {
          if (_this4.isValidLookup(found)) return;

          var finalKey = key;
          var finalKeys = [finalKey];

          var pluralSuffix = void 0;
          if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);

          // fallback for plural if context not found
          if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);

          // get key for context if needed
          if (needsContextHandling) finalKeys.push(finalKey += '' + _this4.options.contextSeparator + options.context);

          // get key for plural if needed
          if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);

          // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only
          var possibleKey = void 0;
          /* eslint no-cond-assign: 0 */
          while (possibleKey = finalKeys.pop()) {
            if (!_this4.isValidLookup(found)) {
              found = _this4.getResource(code, ns, possibleKey, options);
            }
          }
        });
      });
    });

    return { res: found, usedKey: usedKey };
  };

  Translator.prototype.isValidLookup = function isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  };

  Translator.prototype.getResource = function getResource(code, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    return this.resourceStore.getResource(code, ns, key, options);
  };

  return Translator;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Translator);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(40);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);

    this.options = options;

    this.whitelist = this.options.whitelist || false;
    this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('languageUtils');
  }

  LanguageUtil.prototype.getScriptPartFromCode = function getScriptPartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return null;

    var p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    return this.formatLanguageCode(p.join('-'));
  };

  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return code;

    var p = code.split('-');
    return this.formatLanguageCode(p[0]);
  };

  LanguageUtil.prototype.formatLanguageCode = function formatLanguageCode(code) {
    // http://www.iana.org/assignments/language-tags/language-tags.xhtml
    if (typeof code === 'string' && code.indexOf('-') > -1) {
      var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
      var p = code.split('-');

      if (this.options.lowerCaseLng) {
        p = p.map(function (part) {
          return part.toLowerCase();
        });
      } else if (p.length === 2) {
        p[0] = p[0].toLowerCase();
        p[1] = p[1].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      } else if (p.length === 3) {
        p[0] = p[0].toLowerCase();

        // if lenght 2 guess it's a country
        if (p[1].length === 2) p[1] = p[1].toUpperCase();
        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
      }

      return p.join('-');
    }

    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  };

  LanguageUtil.prototype.isWhitelisted = function isWhitelisted(code) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
  };

  LanguageUtil.prototype.getFallbackCodes = function getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;

    if (!code) return fallbacks.default || [];

    // asume we have an object defining fallbacks
    var found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks.default;

    return found || [];
  };

  LanguageUtil.prototype.toResolveHierarchy = function toResolveHierarchy(code, fallbackCode) {
    var _this = this;

    var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);

    var codes = [];
    var addCode = function addCode(c) {
      if (!c) return;
      if (_this.isWhitelisted(c)) {
        codes.push(c);
      } else {
        _this.logger.warn('rejecting non-whitelisted language code: ' + c);
      }
    };

    if (typeof code === 'string' && code.indexOf('-') > -1) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (typeof code === 'string') {
      addCode(this.formatLanguageCode(code));
    }

    fallbackCodes.forEach(function (fc) {
      if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
    });

    return codes;
  };

  return LanguageUtil;
}();

/* harmony default export */ __webpack_exports__["a"] = (LanguageUtil);

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(40);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// definition http://translate.sourceforge.net/wiki/l10n/pluralforms
/* eslint-disable */
var sets = [{ lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'], nr: [1, 2], fc: 1 }, { lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'he', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'], nr: [1, 2], fc: 2 }, { lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'], nr: [1], fc: 3 }, { lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'], nr: [1, 2, 5], fc: 4 }, { lngs: ['ar'], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ['cs', 'sk'], nr: [1, 2, 5], fc: 6 }, { lngs: ['csb', 'pl'], nr: [1, 2, 5], fc: 7 }, { lngs: ['cy'], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ['fr'], nr: [1, 2], fc: 9 }, { lngs: ['ga'], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ['gd'], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ['is'], nr: [1, 2], fc: 12 }, { lngs: ['jv'], nr: [0, 1], fc: 13 }, { lngs: ['kw'], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ['lt'], nr: [1, 2, 10], fc: 15 }, { lngs: ['lv'], nr: [1, 2, 0], fc: 16 }, { lngs: ['mk'], nr: [1, 2], fc: 17 }, { lngs: ['mnk'], nr: [0, 1, 2], fc: 18 }, { lngs: ['mt'], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ['or'], nr: [2, 1], fc: 2 }, { lngs: ['ro'], nr: [1, 2, 20], fc: 20 }, { lngs: ['sl'], nr: [5, 1, 2, 3], fc: 21 }];

var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  }
};
/* eslint-enable */

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;

    this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('pluralResolver');

    this.rules = createRules();
  }

  PluralResolver.prototype.addRule = function addRule(lng, obj) {
    this.rules[lng] = obj;
  };

  PluralResolver.prototype.getRule = function getRule(code) {
    return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
  };

  PluralResolver.prototype.needsPlural = function needsPlural(code) {
    var rule = this.getRule(code);

    return rule && rule.numbers.length > 1;
  };

  PluralResolver.prototype.getPluralFormsOfKey = function getPluralFormsOfKey(code, key) {
    var _this = this;

    var ret = [];

    var rule = this.getRule(code);

    rule.numbers.forEach(function (n) {
      var suffix = _this.getSuffix(code, n);
      ret.push('' + key + suffix);
    });

    return ret;
  };

  PluralResolver.prototype.getSuffix = function getSuffix(code, count) {
    var _this2 = this;

    var rule = this.getRule(code);

    if (rule) {
      // if (rule.numbers.length === 1) return ''; // only singular

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      // special treatment for lngs only having singular and plural
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };

      // COMPATIBILITY JSON
      // v1
      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return '_plural_' + suffix.toString();
        return returnSuffix();
      } else if ( /* v2 */this.options.compatibilityJSON === 'v2' || rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      } else if ( /* v3 - gettext index */rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }

    this.logger.warn('no plural rule found for: ' + code);
    return '';
  };

  return PluralResolver;
}();

/* harmony default export */ __webpack_exports__["a"] = (PluralResolver);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_js__ = __webpack_require__(40);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Interpolator);

    this.logger = __WEBPACK_IMPORTED_MODULE_1__logger_js__["a" /* default */].create('interpolator');

    this.init(options, true);
  }

  /* eslint no-param-reassign: 0 */


  Interpolator.prototype.init = function init() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var reset = arguments[1];

    if (reset) {
      this.options = options;
      this.format = options.interpolation && options.interpolation.format || function (value) {
        return value;
      };
      this.escape = options.interpolation && options.interpolation.escape || __WEBPACK_IMPORTED_MODULE_0__utils_js__["c" /* escape */];
    }
    if (!options.interpolation) options.interpolation = { escapeValue: true };

    var iOpts = options.interpolation;

    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;

    this.prefix = iOpts.prefix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.prefix) : iOpts.prefixEscaped || '{{';
    this.suffix = iOpts.suffix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.suffix) : iOpts.suffixEscaped || '}}';

    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';

    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';

    this.nestingPrefix = iOpts.nestingPrefix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */]('$t(');
    this.nestingSuffix = iOpts.nestingSuffix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](')');

    this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;

    // the regexp
    this.resetRegExp();
  };

  Interpolator.prototype.reset = function reset() {
    if (this.options) this.init(this.options);
  };

  Interpolator.prototype.resetRegExp = function resetRegExp() {
    // the regexp
    var regexpStr = this.prefix + '(.+?)' + this.suffix;
    this.regexp = new RegExp(regexpStr, 'g');

    var regexpUnescapeStr = '' + this.prefix + this.unescapePrefix + '(.+?)' + this.unescapeSuffix + this.suffix;
    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');

    var nestingRegexpStr = this.nestingPrefix + '(.+?)' + this.nestingSuffix;
    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
  };

  Interpolator.prototype.interpolate = function interpolate(str, data, lng) {
    var _this = this;

    var match = void 0;
    var value = void 0;
    var replaces = void 0;

    function regexSafe(val) {
      return val.replace(/\$/g, '$$$$');
    }

    var handleFormat = function handleFormat(key) {
      if (key.indexOf(_this.formatSeparator) < 0) return __WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, key);

      var p = key.split(_this.formatSeparator);
      var k = p.shift().trim();
      var f = p.join(_this.formatSeparator).trim();

      return _this.format(__WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, k), f, lng);
    };

    this.resetRegExp();

    replaces = 0;
    // unescape if has unescapePrefix/Suffix
    /* eslint no-cond-assign: 0 */
    while (match = this.regexpUnescape.exec(str)) {
      value = handleFormat(match[1].trim());
      str = str.replace(match[0], value);
      this.regexpUnescape.lastIndex = 0;
      replaces++;
      if (replaces >= this.maxReplaces) {
        break;
      }
    }

    replaces = 0;
    // regular escape on demand
    while (match = this.regexp.exec(str)) {
      value = handleFormat(match[1].trim());
      if (typeof value !== 'string') value = __WEBPACK_IMPORTED_MODULE_0__utils_js__["e" /* makeString */](value);
      if (!value) {
        this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
        value = '';
      }
      value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
      replaces++;
      if (replaces >= this.maxReplaces) {
        break;
      }
    }
    return str;
  };

  Interpolator.prototype.nest = function nest(str, fc) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var match = void 0;
    var value = void 0;

    var clonedOptions = _extends({}, options);
    clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup

    // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"
    function handleHasOptions(key, inheritedOptions) {
      if (key.indexOf(',') < 0) return key;

      var p = key.split(',');
      key = p.shift();
      var optionsString = p.join(',');
      optionsString = this.interpolate(optionsString, clonedOptions);
      optionsString = optionsString.replace(/'/g, '"');

      try {
        clonedOptions = JSON.parse(optionsString);

        if (inheritedOptions) clonedOptions = _extends({}, inheritedOptions, clonedOptions);
      } catch (e) {
        this.logger.error('failed parsing options string in nesting for key ' + key, e);
      }

      return key;
    }

    // regular escape on demand
    while (match = this.nestingRegexp.exec(str)) {
      value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);

      // is only the nesting key (key1 = '$(key2)') return the value without stringify
      if (value && match[0] === str && typeof value !== 'string') return value;

      // no string to include or empty
      if (typeof value !== 'string') value = __WEBPACK_IMPORTED_MODULE_0__utils_js__["e" /* makeString */](value);
      if (!value) {
        this.logger.warn('missed to resolve ' + match[1] + ' for nesting ' + str);
        value = '';
      }
      // Nested keys should not be escaped by default #854
      // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  };

  return Interpolator;
}();

/* harmony default export */ __webpack_exports__["a"] = (Interpolator);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventEmitter_js__ = __webpack_require__(62);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }





function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.backend = backend;
    _this.store = store;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = __WEBPACK_IMPORTED_MODULE_1__logger_js__["a" /* default */].create('backendConnector');

    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }

  Connector.prototype.queueLoad = function queueLoad(languages, namespaces, callback) {
    var _this2 = this;

    // find what needs to be loaded
    var toLoad = [];
    var pending = [];
    var toLoadLanguages = [];
    var toLoadNamespaces = [];

    languages.forEach(function (lng) {
      var hasAllNamespaces = true;

      namespaces.forEach(function (ns) {
        var name = lng + '|' + ns;

        if (_this2.store.hasResourceBundle(lng, ns)) {
          _this2.state[name] = 2; // loaded
        } else if (_this2.state[name] < 0) {
          // nothing to do for err
        } else if (_this2.state[name] === 1) {
          if (pending.indexOf(name) < 0) pending.push(name);
        } else {
          _this2.state[name] = 1; // pending

          hasAllNamespaces = false;

          if (pending.indexOf(name) < 0) pending.push(name);
          if (toLoad.indexOf(name) < 0) toLoad.push(name);
          if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
        }
      });

      if (!hasAllNamespaces) toLoadLanguages.push(lng);
    });

    if (toLoad.length || pending.length) {
      this.queue.push({
        pending: pending,
        loaded: {},
        errors: [],
        callback: callback
      });
    }

    return {
      toLoad: toLoad,
      pending: pending,
      toLoadLanguages: toLoadLanguages,
      toLoadNamespaces: toLoadNamespaces
    };
  };

  Connector.prototype.loaded = function loaded(name, err, data) {
    var _this3 = this;

    var _name$split = name.split('|'),
        _name$split2 = _slicedToArray(_name$split, 2),
        lng = _name$split2[0],
        ns = _name$split2[1];

    if (err) this.emit('failedLoading', lng, ns, err);

    if (data) {
      this.store.addResourceBundle(lng, ns, data);
    }

    // set loaded
    this.state[name] = err ? -1 : 2;

    // callback if ready
    this.queue.forEach(function (q) {
      __WEBPACK_IMPORTED_MODULE_0__utils_js__["f" /* pushPath */](q.loaded, [lng], ns);
      remove(q.pending, name);

      if (err) q.errors.push(err);

      if (q.pending.length === 0 && !q.done) {
        _this3.emit('loaded', q.loaded);
        /* eslint no-param-reassign: 0 */
        q.done = true;
        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    });

    // remove done load requests
    this.queue = this.queue.filter(function (q) {
      return !q.done;
    });
  };

  Connector.prototype.read = function read(lng, ns, fcName) {
    var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    var _this4 = this;

    var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
    var callback = arguments[5];

    if (!lng.length) return callback(null, {}); // noting to load

    return this.backend[fcName](lng, ns, function (err, data) {
      if (err && data /* = retryFlag */ && tried < 5) {
        setTimeout(function () {
          _this4.read.call(_this4, lng, ns, fcName, tried + 1, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    });
  };

  /* eslint consistent-return: 0 */


  Connector.prototype.load = function load(languages, namespaces, callback) {
    var _this5 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }
    var options = _extends({}, this.backend.options, this.options.backend);

    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    var toLoad = this.queueLoad(languages, namespaces, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now
      return null; // pendings will trigger callback
    }

    // load with multi-load
    if (options.allowMultiLoading && this.backend.readMulti) {
      this.read(toLoad.toLoadLanguages, toLoad.toLoadNamespaces, 'readMulti', null, null, function (err, data) {
        if (err) _this5.logger.warn('loading namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading failed', err);
        if (!err && data) _this5.logger.log('successfully loaded namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading', data);

        toLoad.toLoad.forEach(function (name) {
          var _name$split3 = name.split('|'),
              _name$split4 = _slicedToArray(_name$split3, 2),
              l = _name$split4[0],
              n = _name$split4[1];

          var bundle = __WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, [l, n]);
          if (bundle) {
            _this5.loaded(name, err, bundle);
          } else {
            var error = 'loading namespace ' + n + ' for language ' + l + ' via multiloading failed';
            _this5.loaded(name, error);
            _this5.logger.error(error);
          }
        });
      });
    } else {
      toLoad.toLoad.forEach(function (name) {
        _this5.loadOne(name);
      });
    }
  };

  Connector.prototype.reload = function reload(languages, namespaces) {
    var _this6 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
    }
    var options = _extends({}, this.backend.options, this.options.backend);

    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    // load with multi-load
    if (options.allowMultiLoading && this.backend.readMulti) {
      this.read(languages, namespaces, 'readMulti', null, null, function (err, data) {
        if (err) _this6.logger.warn('reloading namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading failed', err);
        if (!err && data) _this6.logger.log('successfully reloaded namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading', data);

        languages.forEach(function (l) {
          namespaces.forEach(function (n) {
            var bundle = __WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, [l, n]);
            if (bundle) {
              _this6.loaded(l + '|' + n, err, bundle);
            } else {
              var error = 'reloading namespace ' + n + ' for language ' + l + ' via multiloading failed';
              _this6.loaded(l + '|' + n, error);
              _this6.logger.error(error);
            }
          });
        });
      });
    } else {
      languages.forEach(function (l) {
        namespaces.forEach(function (n) {
          _this6.loadOne(l + '|' + n, 're');
        });
      });
    }
  };

  Connector.prototype.loadOne = function loadOne(name) {
    var _this7 = this;

    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var _name$split5 = name.split('|'),
        _name$split6 = _slicedToArray(_name$split5, 2),
        lng = _name$split6[0],
        ns = _name$split6[1];

    this.read(lng, ns, 'read', null, null, function (err, data) {
      if (err) _this7.logger.warn(prefix + 'loading namespace ' + ns + ' for language ' + lng + ' failed', err);
      if (!err && data) _this7.logger.log(prefix + 'loaded namespace ' + ns + ' for language ' + lng, data);

      _this7.loaded(name, err, data);
    });
  };

  Connector.prototype.saveMissing = function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

    if (this.backend && this.backend.create) {
      this.backend.create(languages, namespace, key, fallbackValue, null /* unused callback */, _extends({}, options, { isUpdate: isUpdate }));
    }

    // write to store to avoid resending
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  };

  return Connector;
}(__WEBPACK_IMPORTED_MODULE_2__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Connector);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__ = __webpack_require__(62);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }




var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(cache, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.cache = cache;
    _this.store = store;
    _this.services = services;
    _this.options = options;
    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('cacheConnector');

    if (_this.cache && _this.cache.init) _this.cache.init(services, options.cache, options);
    return _this;
  }

  /* eslint consistent-return: 0 */


  Connector.prototype.load = function load(languages, namespaces, callback) {
    var _this2 = this;

    if (!this.cache) return callback && callback();
    var options = _extends({}, this.cache.options, this.options.cache);

    var loadLngs = typeof languages === 'string' ? this.services.languageUtils.toResolveHierarchy(languages) : languages;

    if (options.enabled) {
      this.cache.load(loadLngs, function (err, data) {
        if (err) _this2.logger.error('loading languages ' + loadLngs.join(', ') + ' from cache failed', err);
        if (data) {
          /* eslint no-restricted-syntax: 0 */
          for (var l in data) {
            if (Object.prototype.hasOwnProperty.call(data, l)) {
              for (var n in data[l]) {
                if (Object.prototype.hasOwnProperty.call(data[l], n)) {
                  if (n !== 'i18nStamp') {
                    var bundle = data[l][n];
                    if (bundle) _this2.store.addResourceBundle(l, n, bundle);
                  }
                }
              }
            }
          }
        }
        if (callback) callback();
      });
    } else if (callback) {
      callback();
    }
  };

  Connector.prototype.save = function save() {
    if (this.cache && this.options.cache && this.options.cache.enabled) this.cache.save(this.store.data);
  };

  return Connector;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Connector);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* harmony export (immutable) */ __webpack_exports__["b"] = transformOptions;

function get() {
  return {
    debug: false,
    initImmediate: true,

    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false, // string or array of namespaces

    whitelist: false, // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all', // | currentOnly | languageOnly
    preload: false, // array with preload languages

    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',

    saveMissing: false, // enable to send missing values
    updateMissing: false, // enable to update default values if different from translated value (only useful on initial development, or when keeping code as source of truth)
    saveMissingTo: 'fallback', // 'current' || 'all'
    saveMissingPlurals: true, // will save all forms not only singular key
    missingKeyHandler: false, // function(lng, ns, key, fallbackValue) -> override if prefer on handling

    postProcess: false, // string or array of postProcessor names
    returnNull: true, // allows null value as valid translation
    returnEmptyString: true, // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false, // or string to join array
    returnedObjectHandler: function returnedObjectHandler() {}, // function(key, value, options) triggered if key returns object but returnObjects is set to false
    parseMissingKeyHandler: false, // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (args[1]) ret.defaultValue = args[1];
      if (args[2]) ret.tDescription = args[2];
      return ret;
    },

    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',

      nestingPrefix: '$t(',
      nestingSuffix: ')',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',
      // defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
      maxReplaces: 1000 // max replaces to prevent endless loop
    }
  };
}

/* eslint no-param-reassign: 0 */
function transformOptions(options) {
  // create namespace object if namespace is passed in as string
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  // extend whitelist with cimode
  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) options.whitelist.push('cimode');

  return options;
}

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var mapping = __webpack_require__(326),
    fallbackHolder = __webpack_require__(16);

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2
    ? function(a, b) { return func.apply(undefined, arguments); }
    : function(a) { return func.apply(undefined, arguments); };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2
    ? function(a, b) { return func(a, b); }
    : function(a) { return func(a); };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function() {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var setPlaceholder,
      isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError;
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var forceCurry = ('curry' in options) && options.curry,
      forceFixed = ('fixed' in options) && options.fixed,
      forceRearg = ('rearg' in options) && options.rearg,
      placeholder = isLib ? func : fallbackHolder,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isError': util.isError,
    'isFunction': util.isFunction,
    'isWeakMap': util.isWeakMap,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isError = helpers.isError,
      isFunction = helpers.isFunction,
      isWeakMap = helpers.isWeakMap,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray(value)
          ? castArray(cloneArray(value))
          : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function(iteratee) {
      return function() {
        var func = arguments[0],
            arity = arguments[1],
            result = iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? (arity - 2) : 1;
          return (length && length <= arity) ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function(mixin) {
      return function(source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function(key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        mixin(func, Object(source));

        each(pairs, function(pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function(nthArg) {
      return function(n) {
        var arity = n < 0 ? 1 : (toInteger(n) + 1);
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function(rearg) {
      return function(func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function(runInContext) {
      return function(context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return (forceCurry || (config.curry && n > 1))
      ? curry(func, n)
      : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start  === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
      : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null &&
          !(isFunction(value) || isError(value) || isWeakMap(value))) {
        nested[key] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function(options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function(func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function(func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : (length - 1);
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    }
    else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      }
      else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      }
      else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg
            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function() {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    if (mapping.placeholder[realName]) {
      setPlaceholder = true;
      result.placeholder = func.placeholder = placeholder;
    }
    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function(aryKey) {
    each(mapping.aryMethod[aryKey], function(key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function(key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function(pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  if (setPlaceholder) {
    _.placeholder = placeholder;
  }
  // Assign aliases.
  each(keys(_), function(key) {
    each(mapping.realToAlias[key] || [], function(alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;


/***/ }),
/* 326 */
/***/ (function(module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': [
    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
    'uniqueId', 'words', 'zipAll'
  ],
  '2': [
    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
    'zipObjectDeep'
  ],
  '3': [
    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
    'xorWith', 'zipWith'
  ],
  '4': [
    'fill', 'setWith', 'updateWith'
  ]
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true,
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to track methods with placeholder support */
exports.placeholder = {
  'bind': true,
  'bindKey': true,
  'curry': true,
  'curryRight': true,
  'partial': true,
  'partialRight': true
};

/** Used to map real names to their aliases. */
exports.realToAlias = (function() {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}());

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'ary': __webpack_require__(328),
  'assign': __webpack_require__(197),
  'clone': __webpack_require__(359),
  'curry': __webpack_require__(207),
  'forEach': __webpack_require__(96),
  'isArray': __webpack_require__(21),
  'isError': __webpack_require__(402),
  'isFunction': __webpack_require__(116),
  'isWeakMap': __webpack_require__(403),
  'iteratee': __webpack_require__(404),
  'keys': __webpack_require__(126),
  'rearg': __webpack_require__(425),
  'toInteger': __webpack_require__(97),
  'toPath': __webpack_require__(428)
};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(76);

/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

module.exports = ary;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(116),
    isMasked = __webpack_require__(332),
    isObject = __webpack_require__(26),
    toSource = __webpack_require__(182);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(51);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 331 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(333);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(23);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 334 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(77),
    root = __webpack_require__(23);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(117),
    createCtor = __webpack_require__(77),
    createHybrid = __webpack_require__(183),
    createRecurry = __webpack_require__(186),
    getHolder = __webpack_require__(196),
    replaceHolders = __webpack_require__(121),
    root = __webpack_require__(23);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 337 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(118),
    getData = __webpack_require__(187),
    getFuncName = __webpack_require__(339),
    lodash = __webpack_require__(341);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(340);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 340 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(118),
    LodashWrapper = __webpack_require__(189),
    baseLodash = __webpack_require__(119),
    isArray = __webpack_require__(21),
    isObjectLike = __webpack_require__(25),
    wrapperClone = __webpack_require__(342);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(118),
    LodashWrapper = __webpack_require__(189),
    copyArray = __webpack_require__(79);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 343 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 344 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(346),
    defineProperty = __webpack_require__(193),
    identity = __webpack_require__(57);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 346 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(96),
    arrayIncludes = __webpack_require__(194);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(195),
    baseIsNaN = __webpack_require__(349),
    strictIndexOf = __webpack_require__(350);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 349 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 350 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(79),
    isIndex = __webpack_require__(63);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(117),
    createCtor = __webpack_require__(77),
    root = __webpack_require__(23);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(184),
    composeArgsRight = __webpack_require__(185),
    replaceHolders = __webpack_require__(121);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 354 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(35),
    isObjectLike = __webpack_require__(25);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 356 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(35),
    isLength = __webpack_require__(124),
    isObjectLike = __webpack_require__(25);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(199);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(127);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 360 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(87);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(87);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(87);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(87);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(86);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 366 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 367 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 368 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(86),
    Map = __webpack_require__(129),
    MapCache = __webpack_require__(130);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(371),
    ListCache = __webpack_require__(86),
    Map = __webpack_require__(129);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(372),
    hashDelete = __webpack_require__(373),
    hashGet = __webpack_require__(374),
    hashHas = __webpack_require__(375),
    hashSet = __webpack_require__(376);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(88);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 373 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(88);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(88);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(88);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(89);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 378 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(89);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(89);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(89);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(72),
    keysIn = __webpack_require__(200);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26),
    isPrototype = __webpack_require__(85),
    nativeKeysIn = __webpack_require__(384);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 384 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(23);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(83)(module)))

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(72),
    getSymbols = __webpack_require__(131);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 387 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(72),
    getSymbolsIn = __webpack_require__(202);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41),
    root = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41),
    root = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 391 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(134),
    cloneDataView = __webpack_require__(393),
    cloneRegExp = __webpack_require__(394),
    cloneSymbol = __webpack_require__(395),
    cloneTypedArray = __webpack_require__(396);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(134);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 394 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(51);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(134);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(78),
    getPrototype = __webpack_require__(133),
    isPrototype = __webpack_require__(85);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(399),
    baseUnary = __webpack_require__(84),
    nodeUtil = __webpack_require__(125);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(53),
    isObjectLike = __webpack_require__(25);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(401),
    baseUnary = __webpack_require__(84),
    nodeUtil = __webpack_require__(125);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(53),
    isObjectLike = __webpack_require__(25);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(35),
    isObjectLike = __webpack_require__(25),
    isPlainObject = __webpack_require__(135);

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == errorTag || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
}

module.exports = isError;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(53),
    isObjectLike = __webpack_require__(25);

/** `Object#toString` result references. */
var weakMapTag = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return isObjectLike(value) && getTag(value) == weakMapTag;
}

module.exports = isWeakMap;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(127),
    baseIteratee = __webpack_require__(38);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
}

module.exports = iteratee;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(406),
    getMatchData = __webpack_require__(414),
    matchesStrictComparable = __webpack_require__(213);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(128),
    baseIsEqual = __webpack_require__(208);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(128),
    equalArrays = __webpack_require__(209),
    equalByTag = __webpack_require__(411),
    equalObjects = __webpack_require__(413),
    getTag = __webpack_require__(53),
    isArray = __webpack_require__(21),
    isBuffer = __webpack_require__(82),
    isTypedArray = __webpack_require__(123);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 408 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 409 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 410 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(51),
    Uint8Array = __webpack_require__(206),
    eq = __webpack_require__(80),
    equalArrays = __webpack_require__(209),
    mapToArray = __webpack_require__(412),
    setToArray = __webpack_require__(136);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 412 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(203);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(212),
    keys = __webpack_require__(58);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(208),
    get = __webpack_require__(416),
    hasIn = __webpack_require__(216),
    isKey = __webpack_require__(137),
    isStrictComparable = __webpack_require__(212),
    matchesStrictComparable = __webpack_require__(213),
    toKey = __webpack_require__(46);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(98);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(418);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(130);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(51),
    arrayMap = __webpack_require__(65),
    isArray = __webpack_require__(21),
    isSymbol = __webpack_require__(52);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 420 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(64),
    isArguments = __webpack_require__(81),
    isArray = __webpack_require__(21),
    isIndex = __webpack_require__(63),
    isLength = __webpack_require__(124),
    toKey = __webpack_require__(46);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(423),
    basePropertyDeep = __webpack_require__(424),
    isKey = __webpack_require__(137),
    toKey = __webpack_require__(46);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 423 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(98);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(76),
    flatRest = __webpack_require__(152);

/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = flatRest(function(func, indexes) {
  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

module.exports = rearg;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(153);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(51),
    isArguments = __webpack_require__(81),
    isArray = __webpack_require__(21);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(65),
    copyArray = __webpack_require__(79),
    isArray = __webpack_require__(21),
    isSymbol = __webpack_require__(52),
    stringToPath = __webpack_require__(214),
    toKey = __webpack_require__(46),
    toString = __webpack_require__(215);

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var defaultBasemaps = exports.defaultBasemaps = [{
    id: 'osmLight',
    name: 'OSM Light',
    img: 'images/osmlight.png',
    config: {
        type: 'tileLayer',
        url: '//cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="http://cartodb.com/attributions">CartoDB</a>'
    }
}, {
    id: 'openStreetMap',
    name: 'OSM Detailed',
    img: 'images/osm.png',
    config: {
        type: 'tileLayer',
        url: '//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }
}, {
    id: 'googleStreets',
    name: 'Google Streets',
    img: 'images/googlestreets.png',
    config: {
        type: 'googleLayer',
        style: 'ROADMAP',
        apiKey: 'AIzaSyBjlDmwuON9lJbPMDlh_LI3zGpGtpK9erc'
    }
}, {
    id: 'googleHybrid',
    name: 'Google Hybrid',
    img: 'images/googlehybrid.jpeg',
    config: {
        type: 'googleLayer',
        style: 'HYBRID',
        apiKey: 'AIzaSyBjlDmwuON9lJbPMDlh_LI3zGpGtpK9erc'
    }
}];

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(65),
    baseIteratee = __webpack_require__(38),
    baseMap = __webpack_require__(246),
    baseSortBy = __webpack_require__(444),
    baseUnary = __webpack_require__(84),
    compareMultiple = __webpack_require__(445),
    identity = __webpack_require__(57);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(442);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 442 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(42);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 444 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(446);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(52);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('negate', __webpack_require__(219), __webpack_require__(39));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 448 */,
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(450);
var invariant = __webpack_require__(451);
var ReactPropTypesSecret = __webpack_require__(452);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_interval__ = __webpack_require__(22);
/* unused harmony reexport timeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_millisecond__ = __webpack_require__(454);
/* unused harmony reexport timeMillisecond */
/* unused harmony reexport timeMilliseconds */
/* unused harmony reexport utcMillisecond */
/* unused harmony reexport utcMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_second__ = __webpack_require__(455);
/* unused harmony reexport timeSecond */
/* unused harmony reexport timeSeconds */
/* unused harmony reexport utcSecond */
/* unused harmony reexport utcSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_minute__ = __webpack_require__(456);
/* unused harmony reexport timeMinute */
/* unused harmony reexport timeMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_hour__ = __webpack_require__(457);
/* unused harmony reexport timeHour */
/* unused harmony reexport timeHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_day__ = __webpack_require__(458);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__src_day__["a"]; });
/* unused harmony reexport timeDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_week__ = __webpack_require__(459);
/* unused harmony reexport timeWeek */
/* unused harmony reexport timeWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["b"]; });
/* unused harmony reexport timeSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
/* unused harmony reexport timeMondays */
/* unused harmony reexport timeTuesday */
/* unused harmony reexport timeTuesdays */
/* unused harmony reexport timeWednesday */
/* unused harmony reexport timeWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["c"]; });
/* unused harmony reexport timeThursdays */
/* unused harmony reexport timeFriday */
/* unused harmony reexport timeFridays */
/* unused harmony reexport timeSaturday */
/* unused harmony reexport timeSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_month__ = __webpack_require__(460);
/* unused harmony reexport timeMonth */
/* unused harmony reexport timeMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_year__ = __webpack_require__(461);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__src_year__["a"]; });
/* unused harmony reexport timeYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__ = __webpack_require__(462);
/* unused harmony reexport utcMinute */
/* unused harmony reexport utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcHour__ = __webpack_require__(463);
/* unused harmony reexport utcHour */
/* unused harmony reexport utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_utcDay__ = __webpack_require__(464);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_11__src_utcDay__["a"]; });
/* unused harmony reexport utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__ = __webpack_require__(465);
/* unused harmony reexport utcWeek */
/* unused harmony reexport utcWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["b"]; });
/* unused harmony reexport utcSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
/* unused harmony reexport utcMondays */
/* unused harmony reexport utcTuesday */
/* unused harmony reexport utcTuesdays */
/* unused harmony reexport utcWednesday */
/* unused harmony reexport utcWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["c"]; });
/* unused harmony reexport utcThursdays */
/* unused harmony reexport utcFriday */
/* unused harmony reexport utcFridays */
/* unused harmony reexport utcSaturday */
/* unused harmony reexport utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__ = __webpack_require__(466);
/* unused harmony reexport utcMonth */
/* unused harmony reexport utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_utcYear__ = __webpack_require__(467);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_14__src_utcYear__["a"]; });
/* unused harmony reexport utcYears */































/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export milliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);


var millisecond = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* unused harmony default export */ var _unused_webpack_default_export = (millisecond);
var milliseconds = millisecond.range;


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export seconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(34);



var second = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */];
}, function(date) {
  return date.getUTCSeconds();
});

/* unused harmony default export */ var _unused_webpack_default_export = (second);
var seconds = second.range;


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(34);



var minute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */];
}, function(date) {
  return date.getMinutes();
});

/* unused harmony default export */ var _unused_webpack_default_export = (minute);
var minutes = minute.range;


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(34);



var hour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  var offset = date.getTimezoneOffset() * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */] % __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
  if (offset < 0) offset += __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
  date.setTime(Math.floor((+date - offset) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */] + offset);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
}, function(date) {
  return date.getHours();
});

/* unused harmony default export */ var _unused_webpack_default_export = (hour);
var hours = hour.range;


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export days */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(34);



var day = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationDay */];
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (day);
var days = day.range;


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return monday; });
/* unused harmony export tuesday */
/* unused harmony export wednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return thursday; });
/* unused harmony export friday */
/* unused harmony export saturday */
/* unused harmony export sundays */
/* unused harmony export mondays */
/* unused harmony export tuesdays */
/* unused harmony export wednesdays */
/* unused harmony export thursdays */
/* unused harmony export fridays */
/* unused harmony export saturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(34);



function weekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export months */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);


var month = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* unused harmony default export */ var _unused_webpack_default_export = (month);
var months = month.range;


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export years */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);


var year = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(34);



var utcMinute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */];
}, function(date) {
  return date.getUTCMinutes();
});

/* unused harmony default export */ var _unused_webpack_default_export = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(34);



var utcHour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
}, function(date) {
  return date.getUTCHours();
});

/* unused harmony default export */ var _unused_webpack_default_export = (utcHour);
var utcHours = utcHour.range;


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(34);



var utcDay = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationDay */];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcMonday; });
/* unused harmony export utcTuesday */
/* unused harmony export utcWednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcThursday; });
/* unused harmony export utcFriday */
/* unused harmony export utcSaturday */
/* unused harmony export utcSundays */
/* unused harmony export utcMondays */
/* unused harmony export utcTuesdays */
/* unused harmony export utcWednesdays */
/* unused harmony export utcThursdays */
/* unused harmony export utcFridays */
/* unused harmony export utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(34);



function utcWeekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);


var utcMonth = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* unused harmony default export */ var _unused_webpack_default_export = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(22);


var utcYear = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale__ = __webpack_require__(140);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__["e" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat__["b" /* isoSpecifier */]);

/* harmony default export */ __webpack_exports__["a"] = (parseIso);


/***/ }),
/* 469 */,
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('isEmpty', __webpack_require__(471), __webpack_require__(39));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(126),
    getTag = __webpack_require__(53),
    isArguments = __webpack_require__(81),
    isArray = __webpack_require__(21),
    isArrayLike = __webpack_require__(42),
    isBuffer = __webpack_require__(82),
    isPrototype = __webpack_require__(85),
    isTypedArray = __webpack_require__(123);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('compact', __webpack_require__(473), __webpack_require__(39));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 473 */
/***/ (function(module, exports) {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(475);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatDefaultLocale", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "format", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatPrefix", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(227);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatLocale", function() { return __WEBPACK_IMPORTED_MODULE_1__src_locale__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__ = __webpack_require__(228);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatSpecifier", function() { return __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__ = __webpack_require__(481);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "precisionFixed", function() { return __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__ = __webpack_require__(482);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "precisionPrefix", function() { return __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__ = __webpack_require__(483);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "precisionRound", function() { return __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__["a"]; });








/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatPrefix; });
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(227);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  x = x.toPrecision(p);

  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (x[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      case "e": break out;
      default: if (i0 > 0) i0 = 0; break;
    }
  }

  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
});


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(141);


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(92);


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(92);


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3 - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(92);


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(max) - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(step)) + 1;
});


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('curryRight', __webpack_require__(485));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(76);

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_RIGHT_FLAG = 16;

/**
 * This method is like `_.curry` except that arguments are applied to `func`
 * in the manner of `_.partialRight` instead of `_.partial`.
 *
 * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curryRight(abc);
 *
 * curried(3)(2)(1);
 * // => [1, 2, 3]
 *
 * curried(2, 3)(1);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(3)(1, _)(2);
 * // => [1, 2, 3]
 */
function curryRight(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curryRight.placeholder;
  return result;
}

// Assign default placeholders.
curryRight.placeholder = {};

module.exports = curryRight;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _isPlainObject = __webpack_require__(232);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _d2 = __webpack_require__(19);

var _map = __webpack_require__(67);

var _helpers = __webpack_require__(36);

var _analytics = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var facilityLoader = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
        var organisationUnitGroupSet, rows, groupSetId, orgUnits, orgUnitParams, d2, contextPath, displayProperty, groupSetReq, facilitiesReq, _ref2, _ref3, groupSet, facilities, features;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        // Returns a promise
                        organisationUnitGroupSet = config.organisationUnitGroupSet, rows = config.rows;
                        groupSetId = organisationUnitGroupSet.id;
                        orgUnits = (0, _analytics.getOrgUnitsFromRows)(rows);
                        orgUnitParams = orgUnits.map(function (item) {
                            return item.id;
                        });
                        _context.next = 6;
                        return (0, _d2.getInstance)();

                    case 6:
                        d2 = _context.sent;
                        contextPath = d2.system.systemInfo.contextPath;
                        displayProperty = (0, _helpers.getDisplayProperty)(d2);
                        groupSetReq = d2.models.organisationUnitGroupSet.get(groupSetId, {
                            fields: 'organisationUnitGroups[id,' + displayProperty + '~rename(name),symbol]'
                        }).then(parseGroupSet);
                        facilitiesReq = d2.geoFeatures.byOrgUnit(orgUnitParams).displayProperty(displayProperty.toUpperCase()).getAll({
                            includeGroupSets: true
                        }).then(function (facilities) {
                            return parseFacilities(facilities, groupSetId);
                        });
                        _context.next = 13;
                        return Promise.all([groupSetReq, facilitiesReq]);

                    case 13:
                        _ref2 = _context.sent;
                        _ref3 = _slicedToArray(_ref2, 2);
                        groupSet = _ref3[0];
                        facilities = _ref3[1];


                        // Convert API response to GeoJSON features
                        features = facilities.map(function (facility) {
                            var id = facility.dimensions[groupSetId];
                            return toGeoJson(facility, groupSet[id], contextPath);
                        });
                        return _context.abrupt('return', _extends({}, config, {
                            data: features,
                            name: _i18next2.default.t('Facilities'),
                            legend: {
                                unit: organisationUnitGroupSet.name,
                                items: Object.keys(groupSet).map(function (id) {
                                    return {
                                        image: contextPath + '/images/orgunitgroup/' + groupSet[id].symbol,
                                        name: groupSet[id].name
                                    };
                                })
                            },
                            isLoaded: true,
                            isExpanded: true,
                            isVisible: true
                        }));

                    case 19:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function facilityLoader(_x) {
        return _ref.apply(this, arguments);
    };
}();

var parseFacilities = function parseFacilities(facilities, groupSetId) {
    return facilities.filter(function (facility // Only add valid points belonging to an org.unit group
    ) {
        return facility.ty === 1 && (0, _isPlainObject2.default)(facility.dimensions) && facility.dimensions[groupSetId] && (0, _map.isValidCoordinate)(JSON.parse(facility.co));
    });
};

var parseGroupSet = function parseGroupSet(groupSet) {
    return groupSet.organisationUnitGroups.toArray().reduce(function (symbols, group, index) {
        // Easier lookup of unit group symbols
        group.symbol = group.symbol || 21 + index + '.png'; // Default symbol 21-25 are coloured circles
        symbols[group.id] = group;
        return symbols;
    }, {});
};

var toGeoJson = function toGeoJson(facility, group, contextPath) {
    return {
        type: 'Feature',
        id: facility.id,
        properties: {
            id: facility.id,
            name: facility.na,
            label: facility.na + ' (' + group.name + ')',
            icon: {
                iconUrl: contextPath + '/images/orgunitgroup/' + group.symbol,
                iconSize: [16, 16]
            },
            type: 'Point' // Accessible in data table
        },
        geometry: {
            type: 'Point',
            coordinates: JSON.parse(facility.co)
        }
    };
};

exports.default = facilityLoader;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _d2 = __webpack_require__(19);

var _isString = __webpack_require__(48);

var _isString2 = _interopRequireDefault(_isString);

var _findIndex = __webpack_require__(488);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _sortBy = __webpack_require__(43);

var _sortBy2 = _interopRequireDefault(_sortBy);

var _pick = __webpack_require__(233);

var _pick2 = _interopRequireDefault(_pick);

var _curry = __webpack_require__(225);

var _curry2 = _interopRequireDefault(_curry);

var _map = __webpack_require__(67);

var _dimension = __webpack_require__(90);

var _classify = __webpack_require__(226);

var _helpers = __webpack_require__(36);

var _legend = __webpack_require__(231);

var _analytics = __webpack_require__(32);

var _colorscale = __webpack_require__(102);

var _alerts = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var thematicLoader = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
        var columns, radiusLow, radiusHigh, _ref2, _ref3, features, data, names, valueById, valueFeatures, orderedValues, minValue, maxValue, dataItem, name, legendSet, method, legend, getLegendItem, alerts;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        columns = config.columns, radiusLow = config.radiusLow, radiusHigh = config.radiusHigh;
                        _context.next = 3;
                        return loadData(config);

                    case 3:
                        _ref2 = _context.sent;
                        _ref3 = _slicedToArray(_ref2, 2);
                        features = _ref3[0];
                        data = _ref3[1];
                        names = (0, _analytics.getApiResponseNames)(data);
                        valueById = getValueById(data);
                        valueFeatures = features.filter(function (_ref4) {
                            var id = _ref4.id;
                            return valueById[id] !== undefined;
                        });
                        orderedValues = getOrderedValues(data);
                        minValue = orderedValues[0];
                        maxValue = orderedValues[orderedValues.length - 1];
                        dataItem = (0, _analytics.getDataItemFromColumns)(columns);
                        name = names[dataItem.id];
                        legendSet = config.legendSet;
                        method = legendSet ? 1 : config.method; // Favorites often have wrong method

                        // Check if data item has legend set (needed if config is converted for chart/pivot layout)

                        if (!(!legendSet && !method)) {
                            _context.next = 21;
                            break;
                        }

                        _context.next = 20;
                        return (0, _legend.loadDataItemLegendSet)(dataItem);

                    case 20:
                        legendSet = _context.sent;

                    case 21:
                        if (!legendSet) {
                            _context.next = 27;
                            break;
                        }

                        _context.next = 24;
                        return createLegendFromLegendSet(legendSet);

                    case 24:
                        _context.t0 = _context.sent;
                        _context.next = 28;
                        break;

                    case 27:
                        _context.t0 = createLegendFromConfig(orderedValues, config);

                    case 28:
                        legend = _context.t0;
                        getLegendItem = (0, _curry2.default)(_classify.getLegendItemForValue)(legend.items);
                        alerts = [];


                        legend.title = name;
                        legend.items.forEach(function (item) {
                            return item.count = 0;
                        });
                        legend.period = names[data.metaData.dimensions.pe[0]];

                        if (!valueFeatures.length) {
                            alerts.push((0, _alerts.createAlert)(name, _i18next2.default.t('No data found')));
                        }

                        valueFeatures.forEach(function (_ref5) {
                            var id = _ref5.id,
                                geometry = _ref5.geometry,
                                properties = _ref5.properties;

                            var value = valueById[id];
                            var item = getLegendItem(value);

                            item.count++;
                            properties.value = value;
                            properties.color = item && item.color;
                            properties.radius = (value - minValue) / (maxValue - minValue) * (radiusHigh - radiusLow) + radiusLow;
                            properties.legend = item.name; // Shown in data table
                            properties.range = item.startValue + ' - ' + item.endValue; // Shown in data table
                            properties.type = geometry.type; // Shown in data table
                        });

                        return _context.abrupt('return', _extends({}, config, {
                            data: valueFeatures,
                            name: name,
                            legend: legend,
                            method: method
                        }, alerts.length ? { alerts: alerts } : {}, {
                            isLoaded: true,
                            isExpanded: true,
                            isVisible: true
                        }));

                    case 37:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function thematicLoader(_x) {
        return _ref.apply(this, arguments);
    };
}();

// Returns an object mapping org. units and values
var getValueById = function getValueById(data) {
    var headers = data.headers,
        rows = data.rows;

    var ouIndex = (0, _findIndex2.default)(['name', 'ou'], headers);
    var valueIndex = (0, _findIndex2.default)(['name', 'value'], headers);

    return rows.reduce(function (obj, row) {
        obj[row[ouIndex]] = parseFloat(row[valueIndex]);
        return obj;
    }, {});
};

// Returns an array of ordered values
var getOrderedValues = function getOrderedValues(data) {
    var headers = data.headers,
        rows = data.rows;

    var valueIndex = (0, _findIndex2.default)(['name', 'value'], headers);

    return rows.map(function (row) {
        return parseFloat(row[valueIndex]);
    }).sort(function (a, b) {
        return a - b;
    });
};

// Returns a legend created from a pre-defined legend set
var createLegendFromLegendSet = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(legendSet) {
        var d2, _ref7, legends, pickSome;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return (0, _d2.getInstance)();

                    case 2:
                        d2 = _context2.sent;
                        _context2.next = 5;
                        return d2.models.legendSet.get(legendSet.id);

                    case 5:
                        _ref7 = _context2.sent;
                        legends = _ref7.legends;
                        pickSome = (0, _pick2.default)(['name', 'startValue', 'endValue', 'color']);
                        return _context2.abrupt('return', {
                            items: (0, _sortBy2.default)('startValue', legends).map(pickSome)
                        });

                    case 9:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    return function createLegendFromLegendSet(_x2) {
        return _ref6.apply(this, arguments);
    };
}();

var createLegendFromConfig = function createLegendFromConfig(data, config) {
    var _config$method = config.method,
        method = _config$method === undefined ? 2 : _config$method,
        _config$classes = config.classes,
        classes = _config$classes === undefined ? _colorscale.defaultClasses : _config$classes,
        _config$colorScale = config.colorScale,
        colorScale = _config$colorScale === undefined ? _colorscale.defaultColorScale : _config$colorScale;


    var items = data.length ? (0, _classify.getLegendItems)(data, method, classes) : [];
    var colors = colorScale.split(',');

    return {
        items: items.map(function (item, index) {
            return _extends({}, item, {
                color: colors[index]
            });
        })
    };
};

// Load features and data values from api
var loadData = function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(config) {
        var rows, columns, filters, displayProperty, userOrgUnit, valueType, relativePeriodDate, aggregationType, orgUnits, period, dataItem, isOperand, d2, displayPropertyUpper, orgUnitParams, dataDimension, analyticsRequest, orgUnitReq, dataReq;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        rows = config.rows, columns = config.columns, filters = config.filters, displayProperty = config.displayProperty, userOrgUnit = config.userOrgUnit, valueType = config.valueType, relativePeriodDate = config.relativePeriodDate, aggregationType = config.aggregationType;
                        orgUnits = (0, _analytics.getOrgUnitsFromRows)(rows);
                        period = (0, _analytics.getPeriodFromFilters)(filters);
                        dataItem = (0, _analytics.getDataItemFromColumns)(columns);
                        isOperand = columns[0].dimension === _dimension.dimConf.operand.objectName;
                        _context3.next = 7;
                        return (0, _d2.getInstance)();

                    case 7:
                        d2 = _context3.sent;
                        displayPropertyUpper = (0, _helpers.getDisplayProperty)(d2, displayProperty).toUpperCase();
                        orgUnitParams = orgUnits.map(function (item) {
                            return item.id;
                        });
                        dataDimension = isOperand ? dataItem.id.split('.')[0] : dataItem.id;


                        if (valueType === 'ds') {
                            dataDimension += '.REPORTING_RATE';
                        }

                        analyticsRequest = new d2.analytics.request().addOrgUnitDimension(orgUnits.map(function (ou) {
                            return ou.id;
                        })).addDataDimension(dataDimension).addPeriodFilter(period.id).withDisplayProperty(displayPropertyUpper);


                        if (Array.isArray(userOrgUnit) && userOrgUnit.length) {
                            orgUnitParams += '&userOrgUnit=' + userOrgUnit.join(';');
                            analyticsRequest = analyticsRequest.withUserOrgUnit(userOrgUnit.join(';'));
                        }

                        if (relativePeriodDate) {
                            analyticsRequest = analyticsRequest.withRelativePeriodDate(relativePeriodDate);
                        }

                        if (aggregationType) {
                            analyticsRequest = analyticsRequest.withAggregationType(aggregationType);
                        }

                        if (Array.isArray(userOrgUnit) && userOrgUnit.length) {
                            analyticsRequest = analyticsRequest.addUserOrgUnit(userOrgUnit.map(function (ou) {
                                return ou;
                            }));
                        }

                        if (isOperand) {
                            analyticsRequest = analyticsRequest.addDimension('co');
                        }

                        // Features request
                        orgUnitReq = d2.geoFeatures.byOrgUnit(orgUnitParams).displayProperty(displayPropertyUpper).getAll().then(_map.toGeoJson);

                        // Data request

                        dataReq = d2.analytics.aggregate.get(analyticsRequest);

                        // Return promise with both requests

                        return _context3.abrupt('return', Promise.all([orgUnitReq, dataReq]));

                    case 21:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, undefined);
    }));

    return function loadData(_x3) {
        return _ref8.apply(this, arguments);
    };
}();

exports.default = thematicLoader;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('findIndex', __webpack_require__(252));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(490),
    flatRest = __webpack_require__(152);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(234),
    hasIn = __webpack_require__(216);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(122),
    castPath = __webpack_require__(64),
    isIndex = __webpack_require__(63),
    isObject = __webpack_require__(26),
    toKey = __webpack_require__(46);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _uniqBy = __webpack_require__(493);

var _uniqBy2 = _interopRequireDefault(_uniqBy);

var _d = __webpack_require__(19);

var _map = __webpack_require__(67);

var _analytics = __webpack_require__(32);

var _helpers = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var colors = ['black', 'blue', 'red', 'green', 'yellow'];
var weights = [2, 1, 0.75, 0.5, 0.5];

var boundaryLoader = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
        var rows, radiusLow, orgUnits, orgUnitParams, d2, displayProperty, features, levels, levelStyle;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        // Returns a promise
                        rows = config.rows, radiusLow = config.radiusLow;
                        orgUnits = (0, _analytics.getOrgUnitsFromRows)(rows);
                        orgUnitParams = orgUnits.map(function (item) {
                            return item.id;
                        });
                        _context.next = 5;
                        return (0, _d.getInstance)();

                    case 5:
                        d2 = _context.sent;
                        displayProperty = (0, _helpers.getDisplayProperty)(d2).toUpperCase();
                        _context.next = 9;
                        return d2.geoFeatures.byOrgUnit(orgUnitParams).displayProperty(displayProperty).getAll().then(_map.toGeoJson);

                    case 9:
                        features = _context.sent;

                        if (features.length) {
                            _context.next = 12;
                            break;
                        }

                        return _context.abrupt('return');

                    case 12:
                        levels = (0, _uniqBy2.default)(function (f) {
                            return f.properties.level;
                        }, features).map(function (f) {
                            return f.properties.level;
                        }).sort();
                        levelStyle = levels.reduce(function (obj, level, index) {
                            return _extends({}, obj, _defineProperty({}, level, {
                                color: colors[index],
                                weight: levels.length === 1 ? 1 : weights[index]
                            }));
                        }, {});


                        features.forEach(function (feature) {
                            feature.properties.style = levelStyle[feature.properties.level];
                            feature.properties.labelStyle = {
                                paddingTop: feature.geometry.type === 'Point' ? 5 + (radiusLow || 5) + 'px' : '0'
                            };
                            feature.properties.type = feature.geometry.type;
                        });

                        return _context.abrupt('return', _extends({}, config, {
                            data: features,
                            name: _i18next2.default.t('Boundaries'),
                            isLoaded: true,
                            isExpanded: true,
                            isVisible: true
                        }));

                    case 16:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function boundaryLoader(_x) {
        return _ref.apply(this, arguments);
    };
}();

exports.default = boundaryLoader;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('uniqBy', __webpack_require__(494));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(38),
    baseUniq = __webpack_require__(258);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 495 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(205),
    noop = __webpack_require__(188),
    setToArray = __webpack_require__(136);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _isString = __webpack_require__(48);

var _isString2 = _interopRequireDefault(_isString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var externalLoader = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        // Returns a promise
                        if ((0, _isString2.default)(config.config)) {
                            // From database as favorite
                            config.config = JSON.parse(config.config);
                            config.name = config.config.name;
                        }

                        return _context.abrupt('return', _extends({}, config, {
                            type: 'external',
                            isLoaded: true,
                            isExpanded: true,
                            isVisible: true
                        }));

                    case 2:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function externalLoader(_x) {
        return _ref.apply(this, arguments);
    };
}();

exports.default = externalLoader;

/***/ }),
/* 498 */,
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('isNil', __webpack_require__(500), __webpack_require__(39));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 500 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('omitBy', __webpack_require__(502));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(38),
    negate = __webpack_require__(219),
    pickBy = __webpack_require__(503);

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee(predicate)));
}

module.exports = omitBy;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(65),
    baseIteratee = __webpack_require__(38),
    basePickBy = __webpack_require__(234),
    getAllKeysIn = __webpack_require__(151);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */
/***/ (function(module, exports) {

module.exports=function(modules){function __webpack_require__(moduleId){if(installedModules[moduleId])return installedModules[moduleId].exports;var module=installedModules[moduleId]={i:moduleId,l:!1,exports:{}};return modules[moduleId].call(module.exports,module,module.exports,__webpack_require__),module.l=!0,module.exports}var installedModules={};return __webpack_require__.m=modules,__webpack_require__.c=installedModules,__webpack_require__.d=function(exports,name,getter){__webpack_require__.o(exports,name)||Object.defineProperty(exports,name,{configurable:!1,enumerable:!0,get:getter})},__webpack_require__.n=function(module){var getter=module&&module.__esModule?function(){return module.default}:function(){return module};return __webpack_require__.d(getter,"a",getter),getter},__webpack_require__.o=function(object,property){return Object.prototype.hasOwnProperty.call(object,property)},__webpack_require__.p="",__webpack_require__(__webpack_require__.s=63)}([function(module,__webpack_exports__,__webpack_require__){"use strict";function newInterval(floori,offseti,count,field){function interval(date){return floori(date=new Date(+date)),date}return interval.floor=interval,interval.ceil=function(date){return floori(date=new Date(date-1)),offseti(date,1),floori(date),date},interval.round=function(date){var d0=interval(date),d1=interval.ceil(date);return date-d0<d1-date?d0:d1},interval.offset=function(date,step){return offseti(date=new Date(+date),null==step?1:Math.floor(step)),date},interval.range=function(start,stop,step){var range=[];if(start=interval.ceil(start),step=null==step?1:Math.floor(step),!(start<stop&&step>0))return range;do{range.push(new Date(+start))}while(offseti(start,step),floori(start),start<stop);return range},interval.filter=function(test){return newInterval(function(date){if(date>=date)for(;floori(date),!test(date);)date.setTime(date-1)},function(date,step){if(date>=date)for(;--step>=0;)for(;offseti(date,1),!test(date););})},count&&(interval.count=function(start,end){return t0.setTime(+start),t1.setTime(+end),floori(t0),floori(t1),Math.floor(count(t0,t1))},interval.every=function(step){return step=Math.floor(step),isFinite(step)&&step>0?step>1?interval.filter(field?function(d){return field(d)%step==0}:function(d){return interval.count(0,d)%step==0}):interval:null}),interval}__webpack_exports__.a=newInterval;var t0=new Date,t1=new Date},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__src_bisect__=__webpack_require__(31);__webpack_require__.d(__webpack_exports__,"b",function(){return __WEBPACK_IMPORTED_MODULE_0__src_bisect__.a});var __WEBPACK_IMPORTED_MODULE_1__src_ascending__=__webpack_require__(5);__webpack_require__.d(__webpack_exports__,"a",function(){return __WEBPACK_IMPORTED_MODULE_1__src_ascending__.a});var __WEBPACK_IMPORTED_MODULE_2__src_bisector__=__webpack_require__(32);__webpack_require__.d(__webpack_exports__,"c",function(){return __WEBPACK_IMPORTED_MODULE_2__src_bisector__.a});var __WEBPACK_IMPORTED_MODULE_18__src_quantile__=(__webpack_require__(86),__webpack_require__(87),__webpack_require__(34),__webpack_require__(36),__webpack_require__(88),__webpack_require__(91),__webpack_require__(92),__webpack_require__(40),__webpack_require__(93),__webpack_require__(94),__webpack_require__(95),__webpack_require__(96),__webpack_require__(41),__webpack_require__(33),__webpack_require__(97),__webpack_require__(18));__webpack_require__.d(__webpack_exports__,"d",function(){return __WEBPACK_IMPORTED_MODULE_18__src_quantile__.a});var __WEBPACK_IMPORTED_MODULE_19__src_range__=__webpack_require__(38);__webpack_require__.d(__webpack_exports__,"e",function(){return __WEBPACK_IMPORTED_MODULE_19__src_range__.a});var __WEBPACK_IMPORTED_MODULE_23__src_ticks__=(__webpack_require__(98),__webpack_require__(99),__webpack_require__(100),__webpack_require__(39));__webpack_require__.d(__webpack_exports__,"h",function(){return __WEBPACK_IMPORTED_MODULE_23__src_ticks__.a}),__webpack_require__.d(__webpack_exports__,"f",function(){return __WEBPACK_IMPORTED_MODULE_23__src_ticks__.b}),__webpack_require__.d(__webpack_exports__,"g",function(){return __WEBPACK_IMPORTED_MODULE_23__src_ticks__.c});__webpack_require__(42),__webpack_require__(35),__webpack_require__(101)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.d(__webpack_exports__,"d",function(){return durationSecond}),__webpack_require__.d(__webpack_exports__,"c",function(){return durationMinute}),__webpack_require__.d(__webpack_exports__,"b",function(){return durationHour}),__webpack_require__.d(__webpack_exports__,"a",function(){return durationDay}),__webpack_require__.d(__webpack_exports__,"e",function(){return durationWeek});var durationSecond=1e3,durationMinute=6e4,durationHour=36e5,durationDay=864e5,durationWeek=6048e5},function(module,__webpack_exports__,__webpack_require__){"use strict";Object.defineProperty(__webpack_exports__,"__esModule",{value:!0});var __WEBPACK_IMPORTED_MODULE_0__src_color__=__webpack_require__(16);__webpack_require__.d(__webpack_exports__,"color",function(){return __WEBPACK_IMPORTED_MODULE_0__src_color__.e}),__webpack_require__.d(__webpack_exports__,"rgb",function(){return __WEBPACK_IMPORTED_MODULE_0__src_color__.g}),__webpack_require__.d(__webpack_exports__,"hsl",function(){return __WEBPACK_IMPORTED_MODULE_0__src_color__.f});var __WEBPACK_IMPORTED_MODULE_1__src_lab__=__webpack_require__(83);__webpack_require__.d(__webpack_exports__,"lab",function(){return __WEBPACK_IMPORTED_MODULE_1__src_lab__.a}),__webpack_require__.d(__webpack_exports__,"hcl",function(){return __WEBPACK_IMPORTED_MODULE_1__src_lab__.b});var __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__=__webpack_require__(84);__webpack_require__.d(__webpack_exports__,"cubehelix",function(){return __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__.a})},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.d(__webpack_exports__,"a",function(){return map}),__webpack_require__.d(__webpack_exports__,"b",function(){return slice});var array=Array.prototype,map=array.map,slice=array.slice},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(a,b){return a<b?-1:a>b?1:a>=b?0:NaN}},function(module,exports,__webpack_require__){"use strict";function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function geoJson(options){return new GeoJson(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.GeoJson=void 0,exports.default=geoJson;var _Label=__webpack_require__(72),_Label2=_interopRequireDefault(_Label),_polylabel=__webpack_require__(73),_polylabel2=_interopRequireDefault(_polylabel);__webpack_require__(75);var geojsonArea=__webpack_require__(76),GeoJson=exports.GeoJson=L.GeoJSON.extend({options:{highlightStyle:{weight:2},resetStyle:{weight:1}},initialize:function(){var options=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};options.label&&(this._labels=L.layerGroup({margin:2})),L.GeoJSON.prototype.initialize.call(this,options.data,options)},addLayer:function(layer){var options=this.options,feature=layer.feature;if(options.label&&this.addLabel(layer,L.Util.template(options.label,feature.properties)),options.hoverLabel||options.label){var tooltip=L.Util.template(options.hoverLabel||options.label,feature.properties);layer.bindTooltip(tooltip,{sticky:!0})}!options.popup||options.popup instanceof Function||layer.bindPopup(L.Util.template(options.popup,feature.properties)),L.GeoJSON.prototype.addLayer.call(this,layer)},addLabel:function(layer,text){var prop=layer.feature.properties,geometry=layer.feature.geometry,labelStyle=L.extend(prop.labelStyle||{},this.options.labelStyle),latlng=this._getLabelLatlng(geometry);prop.style&&prop.style.color&&(labelStyle.color=prop.style.color),layer._label=(0,_Label2.default)(latlng,{html:text,position:"Point"===geometry.type?"below":"middle",labelStyle:labelStyle,pane:this.options.labelPane||"markerPane"}),this._labels.addLayer(layer._label)},setOpacity:function(opacity){this.setStyle({opacity:opacity,fillOpacity:opacity})},findById:function(id){for(var i in this._layers)if(this._layers[i].feature.id===id)return this._layers[i];return null},onAdd:function(map){L.GeoJSON.prototype.onAdd.call(this,map),this._labels&&map.addLayer(this._labels),this.options.highlightStyle&&(this.on("mouseover",this.onMouseOver,this),this.on("mouseout",this.onMouseOut,this)),this.options.contextmenu&&this.on("contextmenu",this.options.contextmenu),this.fire("ready")},onRemove:function(map){L.GeoJSON.prototype.onRemove.call(this,map),this._labels&&map.removeLayer(this._labels),this.options.highlightStyle&&(this.off("mouseover",this.onMouseOver,this),this.off("mouseout",this.onMouseOut,this)),this.options.contextmenu&&this.off("contextmenu",this.options.contextmenu)},onMouseOver:function(evt){evt.layer.setStyle(this.options.highlightStyle)},onMouseOut:function(evt){evt.layer.feature.isSelected||evt.layer.setStyle(this.options.resetStyle)},_getLabelLatlng:function(geometry){var coords=geometry.coordinates,biggestRing=void 0;if("Point"===geometry.type)return[coords[1],coords[0]];if("Polygon"===geometry.type)biggestRing=coords;else if("MultiPolygon"===geometry.type&&(biggestRing=coords[0],coords.length>1)){var biggestSize=0;coords.forEach(function(ring){var size=geojsonArea.ring(ring[0]);size>biggestSize&&(biggestRing=ring,biggestSize=size)})}return(0,_polylabel2.default)(biggestRing,2).reverse()}})},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(x){return null===x?NaN:+x}},function(module,__webpack_exports__,__webpack_require__){"use strict";function linearish(scale){var domain=scale.domain;return scale.ticks=function(count){var d=domain();return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.h)(d[0],d[d.length-1],null==count?10:count)},scale.tickFormat=function(count,specifier){return Object(__WEBPACK_IMPORTED_MODULE_3__tickFormat__.a)(domain(),count,specifier)},scale.nice=function(count){null==count&&(count=10);var step,d=domain(),i0=0,i1=d.length-1,start=d[i0],stop=d[i1];return stop<start&&(step=start,start=stop,stop=step,step=i0,i0=i1,i1=step),step=Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.f)(start,stop,count),step>0?(start=Math.floor(start/step)*step,stop=Math.ceil(stop/step)*step,step=Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.f)(start,stop,count)):step<0&&(start=Math.ceil(start*step)/step,stop=Math.floor(stop*step)/step,step=Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.f)(start,stop,count)),step>0?(d[i0]=Math.floor(start/step)*step,d[i1]=Math.ceil(stop/step)*step,domain(d)):step<0&&(d[i0]=Math.ceil(start*step)/step,d[i1]=Math.floor(stop*step)/step,domain(d)),scale},scale}function linear(){var scale=Object(__WEBPACK_IMPORTED_MODULE_2__continuous__.b)(__WEBPACK_IMPORTED_MODULE_2__continuous__.c,__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__.b);return scale.copy=function(){return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__.a)(scale,linear())},linearish(scale)}__webpack_exports__.b=linearish,__webpack_exports__.a=linear;var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(1),__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__=__webpack_require__(20),__WEBPACK_IMPORTED_MODULE_2__continuous__=__webpack_require__(13),__WEBPACK_IMPORTED_MODULE_3__tickFormat__=__webpack_require__(119)},function(module,__webpack_exports__,__webpack_require__){"use strict";function linear(a,d){return function(t){return a+t*d}}function exponential(a,b,y){return a=Math.pow(a,y),b=Math.pow(b,y)-a,y=1/y,function(t){return Math.pow(a+t*b,y)}}function hue(a,b){var d=b-a;return d?linear(a,d>180||d<-180?d-360*Math.round(d/360):d):Object(__WEBPACK_IMPORTED_MODULE_0__constant__.a)(isNaN(a)?b:a)}function gamma(y){return 1==(y=+y)?nogamma:function(a,b){return b-a?exponential(a,b,y):Object(__WEBPACK_IMPORTED_MODULE_0__constant__.a)(isNaN(a)?b:a)}}function nogamma(a,b){var d=b-a;return d?linear(a,d):Object(__WEBPACK_IMPORTED_MODULE_0__constant__.a)(isNaN(a)?b:a)}__webpack_exports__.c=hue,__webpack_exports__.b=gamma,__webpack_exports__.a=nogamma;var __WEBPACK_IMPORTED_MODULE_0__constant__=__webpack_require__(46)},function(module,exports){function cssWithMappingToString(item,useSourceMap){var content=item[1]||"",cssMapping=item[3];if(!cssMapping)return content;if(useSourceMap&&"function"==typeof btoa){var sourceMapping=toComment(cssMapping);return[content].concat(cssMapping.sources.map(function(source){return"/*# sourceURL="+cssMapping.sourceRoot+source+" */"})).concat([sourceMapping]).join("\n")}return[content].join("\n")}function toComment(sourceMap){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))))+" */"}module.exports=function(useSourceMap){var list=[];return list.toString=function(){return this.map(function(item){var content=cssWithMappingToString(item,useSourceMap);return item[2]?"@media "+item[2]+"{"+content+"}":content}).join("")},list.i=function(modules,mediaQuery){"string"==typeof modules&&(modules=[[null,modules,""]]);for(var alreadyImportedModules={},i=0;i<this.length;i++){var id=this[i][0];"number"==typeof id&&(alreadyImportedModules[id]=!0)}for(i=0;i<modules.length;i++){var item=modules[i];"number"==typeof item[0]&&alreadyImportedModules[item[0]]||(mediaQuery&&!item[2]?item[2]=mediaQuery:mediaQuery&&(item[2]="("+item[2]+") and ("+mediaQuery+")"),list.push(item))}},list}},function(module,exports,__webpack_require__){"use strict";function circleMarker(feature,options){return new CircleMarker(feature,options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=circleMarker;var CircleMarker=exports.CircleMarker=L.CircleMarker.extend({options:{strokeColor:"#fff",weight:.5,radius:6},initialize:function(feature,opts){var options=L.setOptions(this,opts);options.fillColor=feature.properties.color||options.color,options.fillOpacity=options.opacity,options.color=options.strokeColor,this._feature=feature,this._latlng=L.GeoJSON.coordsToLatLng(feature.geometry.coordinates),this._radius=this.options.radius},getFeature:function(){return this._feature},showPopup:function(content){var popup=content||this.options.popup;"string"==typeof popup?this.bindPopup(L.Util.template(popup,this._feature.properties)).openPopup():popup instanceof Function&&popup(this._feature,L.bind(function(response){this.bindPopup(response).openPopup()},this))},setOpacity:function(opacity){this.setStyle({opacity:opacity,fillOpacity:opacity})}})},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(a,b){return a=+a,b-=a,function(t){return a+b*t}}},function(module,__webpack_exports__,__webpack_require__){"use strict";function deinterpolateLinear(a,b){return(b-=a=+a)?function(x){return(x-a)/b}:Object(__WEBPACK_IMPORTED_MODULE_3__constant__.a)(b)}function deinterpolateClamp(deinterpolate){return function(a,b){var d=deinterpolate(a=+a,b=+b);return function(x){return x<=a?0:x>=b?1:d(x)}}}function reinterpolateClamp(reinterpolate){return function(a,b){var r=reinterpolate(a=+a,b=+b);return function(t){return t<=0?a:t>=1?b:r(t)}}}function bimap(domain,range,deinterpolate,reinterpolate){var d0=domain[0],d1=domain[1],r0=range[0],r1=range[1];return d1<d0?(d0=deinterpolate(d1,d0),r0=reinterpolate(r1,r0)):(d0=deinterpolate(d0,d1),r0=reinterpolate(r0,r1)),function(x){return r0(d0(x))}}function polymap(domain,range,deinterpolate,reinterpolate){var j=Math.min(domain.length,range.length)-1,d=new Array(j),r=new Array(j),i=-1;for(domain[j]<domain[0]&&(domain=domain.slice().reverse(),range=range.slice().reverse());++i<j;)d[i]=deinterpolate(domain[i],domain[i+1]),r[i]=reinterpolate(range[i],range[i+1]);return function(x){var i=Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.b)(domain,x,1,j)-1;return r[i](d[i](x))}}function copy(source,target){return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp())}function continuous(deinterpolate,reinterpolate){function rescale(){return piecewise=Math.min(domain.length,range.length)>2?polymap:bimap,output=input=null,scale}function scale(x){return(output||(output=piecewise(domain,range,clamp?deinterpolateClamp(deinterpolate):deinterpolate,interpolate)))(+x)}var piecewise,output,input,domain=unit,range=unit,interpolate=__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__.a,clamp=!1;return scale.invert=function(y){return(input||(input=piecewise(range,domain,deinterpolateLinear,clamp?reinterpolateClamp(reinterpolate):reinterpolate)))(+y)},scale.domain=function(_){return arguments.length?(domain=__WEBPACK_IMPORTED_MODULE_2__array__.a.call(_,__WEBPACK_IMPORTED_MODULE_4__number__.a),rescale()):domain.slice()},scale.range=function(_){return arguments.length?(range=__WEBPACK_IMPORTED_MODULE_2__array__.b.call(_),rescale()):range.slice()},scale.rangeRound=function(_){return range=__WEBPACK_IMPORTED_MODULE_2__array__.b.call(_),interpolate=__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__.c,rescale()},scale.clamp=function(_){return arguments.length?(clamp=!!_,rescale()):clamp},scale.interpolate=function(_){return arguments.length?(interpolate=_,rescale()):interpolate},rescale()}__webpack_exports__.c=deinterpolateLinear,__webpack_exports__.a=copy,__webpack_exports__.b=continuous;var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(1),__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__=__webpack_require__(20),__WEBPACK_IMPORTED_MODULE_2__array__=__webpack_require__(4),__WEBPACK_IMPORTED_MODULE_3__constant__=__webpack_require__(23),__WEBPACK_IMPORTED_MODULE_4__number__=__webpack_require__(51),unit=[0,1]},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__=__webpack_require__(24);__webpack_exports__.a=function(x){return x=Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__.a)(Math.abs(x)),x?x[1]:NaN}},function(module,exports){var g;g=function(){return this}();try{g=g||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(g=window)}module.exports=g},function(module,__webpack_exports__,__webpack_require__){"use strict";function Color(){}function color(format){var m;return format=(format+"").trim().toLowerCase(),(m=reHex3.exec(format))?(m=parseInt(m[1],16),new Rgb(m>>8&15|m>>4&240,m>>4&15|240&m,(15&m)<<4|15&m,1)):(m=reHex6.exec(format))?rgbn(parseInt(m[1],16)):(m=reRgbInteger.exec(format))?new Rgb(m[1],m[2],m[3],1):(m=reRgbPercent.exec(format))?new Rgb(255*m[1]/100,255*m[2]/100,255*m[3]/100,1):(m=reRgbaInteger.exec(format))?rgba(m[1],m[2],m[3],m[4]):(m=reRgbaPercent.exec(format))?rgba(255*m[1]/100,255*m[2]/100,255*m[3]/100,m[4]):(m=reHslPercent.exec(format))?hsla(m[1],m[2]/100,m[3]/100,1):(m=reHslaPercent.exec(format))?hsla(m[1],m[2]/100,m[3]/100,m[4]):named.hasOwnProperty(format)?rgbn(named[format]):"transparent"===format?new Rgb(NaN,NaN,NaN,0):null}function rgbn(n){return new Rgb(n>>16&255,n>>8&255,255&n,1)}function rgba(r,g,b,a){return a<=0&&(r=g=b=NaN),new Rgb(r,g,b,a)}function rgbConvert(o){return o instanceof Color||(o=color(o)),o?(o=o.rgb(),new Rgb(o.r,o.g,o.b,o.opacity)):new Rgb}function rgb(r,g,b,opacity){return 1===arguments.length?rgbConvert(r):new Rgb(r,g,b,null==opacity?1:opacity)}function Rgb(r,g,b,opacity){this.r=+r,this.g=+g,this.b=+b,this.opacity=+opacity}function hsla(h,s,l,a){return a<=0?h=s=l=NaN:l<=0||l>=1?h=s=NaN:s<=0&&(h=NaN),new Hsl(h,s,l,a)}function hslConvert(o){if(o instanceof Hsl)return new Hsl(o.h,o.s,o.l,o.opacity);if(o instanceof Color||(o=color(o)),!o)return new Hsl;if(o instanceof Hsl)return o;o=o.rgb();var r=o.r/255,g=o.g/255,b=o.b/255,min=Math.min(r,g,b),max=Math.max(r,g,b),h=NaN,s=max-min,l=(max+min)/2;return s?(h=r===max?(g-b)/s+6*(g<b):g===max?(b-r)/s+2:(r-g)/s+4,s/=l<.5?max+min:2-max-min,h*=60):s=l>0&&l<1?0:h,new Hsl(h,s,l,o.opacity)}function hsl(h,s,l,opacity){return 1===arguments.length?hslConvert(h):new Hsl(h,s,l,null==opacity?1:opacity)}function Hsl(h,s,l,opacity){this.h=+h,this.s=+s,this.l=+l,this.opacity=+opacity}function hsl2rgb(h,m1,m2){return 255*(h<60?m1+(m2-m1)*h/60:h<180?m2:h<240?m1+(m2-m1)*(240-h)/60:m1)}__webpack_exports__.a=Color,__webpack_require__.d(__webpack_exports__,"d",function(){return darker}),__webpack_require__.d(__webpack_exports__,"c",function(){return brighter}),__webpack_exports__.e=color,__webpack_exports__.h=rgbConvert,__webpack_exports__.g=rgb,__webpack_exports__.b=Rgb,__webpack_exports__.f=hsl;var __WEBPACK_IMPORTED_MODULE_0__define__=__webpack_require__(17),darker=.7,brighter=1/darker,reI="\\s*([+-]?\\d+)\\s*",reN="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",reP="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",reHex3=/^#([0-9a-f]{3})$/,reHex6=/^#([0-9a-f]{6})$/,reRgbInteger=new RegExp("^rgb\\("+[reI,reI,reI]+"\\)$"),reRgbPercent=new RegExp("^rgb\\("+[reP,reP,reP]+"\\)$"),reRgbaInteger=new RegExp("^rgba\\("+[reI,reI,reI,reN]+"\\)$"),reRgbaPercent=new RegExp("^rgba\\("+[reP,reP,reP,reN]+"\\)$"),reHslPercent=new RegExp("^hsl\\("+[reN,reP,reP]+"\\)$"),reHslaPercent=new RegExp("^hsla\\("+[reN,reP,reP,reN]+"\\)$"),named={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};Object(__WEBPACK_IMPORTED_MODULE_0__define__.a)(Color,color,{displayable:function(){return this.rgb().displayable()},toString:function(){return this.rgb()+""}}),Object(__WEBPACK_IMPORTED_MODULE_0__define__.a)(Rgb,rgb,Object(__WEBPACK_IMPORTED_MODULE_0__define__.b)(Color,{brighter:function(k){return k=null==k?brighter:Math.pow(brighter,k),new Rgb(this.r*k,this.g*k,this.b*k,this.opacity)},darker:function(k){return k=null==k?darker:Math.pow(darker,k),new Rgb(this.r*k,this.g*k,this.b*k,this.opacity)},rgb:function(){return this},displayable:function(){return 0<=this.r&&this.r<=255&&0<=this.g&&this.g<=255&&0<=this.b&&this.b<=255&&0<=this.opacity&&this.opacity<=1},toString:function(){var a=this.opacity;return a=isNaN(a)?1:Math.max(0,Math.min(1,a)),(1===a?"rgb(":"rgba(")+Math.max(0,Math.min(255,Math.round(this.r)||0))+", "+Math.max(0,Math.min(255,Math.round(this.g)||0))+", "+Math.max(0,Math.min(255,Math.round(this.b)||0))+(1===a?")":", "+a+")")}})),Object(__WEBPACK_IMPORTED_MODULE_0__define__.a)(Hsl,hsl,Object(__WEBPACK_IMPORTED_MODULE_0__define__.b)(Color,{brighter:function(k){return k=null==k?brighter:Math.pow(brighter,k),new Hsl(this.h,this.s,this.l*k,this.opacity)},darker:function(k){return k=null==k?darker:Math.pow(darker,k),new Hsl(this.h,this.s,this.l*k,this.opacity)},rgb:function(){var h=this.h%360+360*(this.h<0),s=isNaN(h)||isNaN(this.s)?0:this.s,l=this.l,m2=l+(l<.5?l:1-l)*s,m1=2*l-m2;return new Rgb(hsl2rgb(h>=240?h-240:h+120,m1,m2),hsl2rgb(h,m1,m2),hsl2rgb(h<120?h+240:h-120,m1,m2),this.opacity)},displayable:function(){return(0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1}}))},function(module,__webpack_exports__,__webpack_require__){"use strict";function extend(parent,definition){var prototype=Object.create(parent.prototype);for(var key in definition)prototype[key]=definition[key];return prototype}__webpack_exports__.b=extend,__webpack_exports__.a=function(constructor,factory,prototype){constructor.prototype=factory.prototype=prototype,prototype.constructor=constructor}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__number__=__webpack_require__(7);__webpack_exports__.a=function(values,p,valueof){if(null==valueof&&(valueof=__WEBPACK_IMPORTED_MODULE_0__number__.a),n=values.length){if((p=+p)<=0||n<2)return+valueof(values[0],0,values);if(p>=1)return+valueof(values[n-1],n-1,values);var n,i=(n-1)*p,i0=Math.floor(i),value0=+valueof(values[i0],i0,values);return value0+(+valueof(values[i0+1],i0+1,values)-value0)*(i-i0)}}},function(module,__webpack_exports__,__webpack_require__){"use strict";function Map(){}function map(object,f){var map=new Map;if(object instanceof Map)object.each(function(value,key){map.set(key,value)});else if(Array.isArray(object)){var o,i=-1,n=object.length;if(null==f)for(;++i<n;)map.set(i,object[i]);else for(;++i<n;)map.set(f(o=object[i],i,object),o)}else if(object)for(var key in object)map.set(key,object[key]);return map}__webpack_require__.d(__webpack_exports__,"b",function(){return prefix});var prefix="$";Map.prototype=map.prototype={constructor:Map,has:function(key){return prefix+key in this},get:function(key){return this[prefix+key]},set:function(key,value){return this[prefix+key]=value,this},remove:function(key){var property=prefix+key;return property in this&&delete this[property]},clear:function(){for(var property in this)property[0]===prefix&&delete this[property]},keys:function(){var keys=[];for(var property in this)property[0]===prefix&&keys.push(property.slice(1));return keys},values:function(){var values=[];for(var property in this)property[0]===prefix&&values.push(this[property]);return values},entries:function(){var entries=[];for(var property in this)property[0]===prefix&&entries.push({key:property.slice(1),value:this[property]});return entries},size:function(){var size=0;for(var property in this)property[0]===prefix&&++size;return size},empty:function(){for(var property in this)if(property[0]===prefix)return!1;return!0},each:function(f){for(var property in this)property[0]===prefix&&f(this[property],property.slice(1),this)}},__webpack_exports__.a=map},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__src_value__=__webpack_require__(21);__webpack_require__.d(__webpack_exports__,"a",function(){return __WEBPACK_IMPORTED_MODULE_0__src_value__.a});var __WEBPACK_IMPORTED_MODULE_5__src_number__=(__webpack_require__(47),__webpack_require__(22),__webpack_require__(45),__webpack_require__(48),__webpack_require__(12));__webpack_require__.d(__webpack_exports__,"b",function(){return __WEBPACK_IMPORTED_MODULE_5__src_number__.a});var __WEBPACK_IMPORTED_MODULE_7__src_round__=(__webpack_require__(49),__webpack_require__(109));__webpack_require__.d(__webpack_exports__,"c",function(){return __WEBPACK_IMPORTED_MODULE_7__src_round__.a});__webpack_require__(50),__webpack_require__(110),__webpack_require__(113),__webpack_require__(44),__webpack_require__(114),__webpack_require__(115),__webpack_require__(116),__webpack_require__(117),__webpack_require__(118)},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0_d3_color__=__webpack_require__(3),__WEBPACK_IMPORTED_MODULE_1__rgb__=__webpack_require__(44),__WEBPACK_IMPORTED_MODULE_2__array__=__webpack_require__(47),__WEBPACK_IMPORTED_MODULE_3__date__=__webpack_require__(48),__WEBPACK_IMPORTED_MODULE_4__number__=__webpack_require__(12),__WEBPACK_IMPORTED_MODULE_5__object__=__webpack_require__(49),__WEBPACK_IMPORTED_MODULE_6__string__=__webpack_require__(50),__WEBPACK_IMPORTED_MODULE_7__constant__=__webpack_require__(46);__webpack_exports__.a=function(a,b){var c,t=typeof b;return null==b||"boolean"===t?Object(__WEBPACK_IMPORTED_MODULE_7__constant__.a)(b):("number"===t?__WEBPACK_IMPORTED_MODULE_4__number__.a:"string"===t?(c=Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__.color)(b))?(b=c,__WEBPACK_IMPORTED_MODULE_1__rgb__.a):__WEBPACK_IMPORTED_MODULE_6__string__.a:b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__.color?__WEBPACK_IMPORTED_MODULE_1__rgb__.a:b instanceof Date?__WEBPACK_IMPORTED_MODULE_3__date__.a:Array.isArray(b)?__WEBPACK_IMPORTED_MODULE_2__array__.a:isNaN(b)?__WEBPACK_IMPORTED_MODULE_5__object__.a:__WEBPACK_IMPORTED_MODULE_4__number__.a)(a,b)}},function(module,__webpack_exports__,__webpack_require__){"use strict";function basis(t1,v0,v1,v2,v3){var t2=t1*t1,t3=t2*t1;return((1-3*t1+3*t2-t3)*v0+(4-6*t2+3*t3)*v1+(1+3*t1+3*t2-3*t3)*v2+t3*v3)/6}__webpack_exports__.a=basis,__webpack_exports__.b=function(values){var n=values.length-1;return function(t){var i=t<=0?t=0:t>=1?(t=1,n-1):Math.floor(t*n),v1=values[i],v2=values[i+1],v0=i>0?values[i-1]:2*v1-v2,v3=i<n-1?values[i+2]:2*v2-v1;return basis((t-i/n)*n,v0,v1,v2,v3)}}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(x){return function(){return x}}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(x,p){if((i=(x=p?x.toExponential(p-1):x.toExponential()).indexOf("e"))<0)return null;var i,coefficient=x.slice(0,i);return[coefficient.length>1?coefficient[0]+coefficient.slice(2):coefficient,+x.slice(i+1)]}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_1__src_millisecond__=(__webpack_require__(0),__webpack_require__(132));__webpack_require__.d(__webpack_exports__,"c",function(){return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__.a}),__webpack_require__.d(__webpack_exports__,"m",function(){return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__.a});var __WEBPACK_IMPORTED_MODULE_2__src_second__=__webpack_require__(133);__webpack_require__.d(__webpack_exports__,"g",function(){return __WEBPACK_IMPORTED_MODULE_2__src_second__.a}),__webpack_require__.d(__webpack_exports__,"q",function(){return __WEBPACK_IMPORTED_MODULE_2__src_second__.a});var __WEBPACK_IMPORTED_MODULE_3__src_minute__=__webpack_require__(134);__webpack_require__.d(__webpack_exports__,"d",function(){return __WEBPACK_IMPORTED_MODULE_3__src_minute__.a});var __WEBPACK_IMPORTED_MODULE_4__src_hour__=__webpack_require__(135);__webpack_require__.d(__webpack_exports__,"b",function(){return __WEBPACK_IMPORTED_MODULE_4__src_hour__.a});var __WEBPACK_IMPORTED_MODULE_5__src_day__=__webpack_require__(136);__webpack_require__.d(__webpack_exports__,"a",function(){return __WEBPACK_IMPORTED_MODULE_5__src_day__.a});var __WEBPACK_IMPORTED_MODULE_6__src_week__=__webpack_require__(137);__webpack_require__.d(__webpack_exports__,"i",function(){return __WEBPACK_IMPORTED_MODULE_6__src_week__.b}),__webpack_require__.d(__webpack_exports__,"h",function(){return __WEBPACK_IMPORTED_MODULE_6__src_week__.b}),__webpack_require__.d(__webpack_exports__,"e",function(){return __WEBPACK_IMPORTED_MODULE_6__src_week__.a});var __WEBPACK_IMPORTED_MODULE_7__src_month__=__webpack_require__(138);__webpack_require__.d(__webpack_exports__,"f",function(){return __WEBPACK_IMPORTED_MODULE_7__src_month__.a});var __WEBPACK_IMPORTED_MODULE_8__src_year__=__webpack_require__(139);__webpack_require__.d(__webpack_exports__,"j",function(){return __WEBPACK_IMPORTED_MODULE_8__src_year__.a});var __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__=__webpack_require__(140);__webpack_require__.d(__webpack_exports__,"n",function(){return __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__.a});var __WEBPACK_IMPORTED_MODULE_10__src_utcHour__=__webpack_require__(141);__webpack_require__.d(__webpack_exports__,"l",function(){return __WEBPACK_IMPORTED_MODULE_10__src_utcHour__.a});var __WEBPACK_IMPORTED_MODULE_11__src_utcDay__=__webpack_require__(142);__webpack_require__.d(__webpack_exports__,"k",function(){return __WEBPACK_IMPORTED_MODULE_11__src_utcDay__.a});var __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__=__webpack_require__(143);__webpack_require__.d(__webpack_exports__,"s",function(){return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__.b}),__webpack_require__.d(__webpack_exports__,"r",function(){return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__.b}),__webpack_require__.d(__webpack_exports__,"o",function(){return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__.a});var __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__=__webpack_require__(144);__webpack_require__.d(__webpack_exports__,"p",function(){return __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__.a});var __WEBPACK_IMPORTED_MODULE_14__src_utcYear__=__webpack_require__(145);__webpack_require__.d(__webpack_exports__,"t",function(){return __WEBPACK_IMPORTED_MODULE_14__src_utcYear__.a})},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.d(__webpack_exports__,"a",function(){return timeFormat}),__webpack_require__.d(__webpack_exports__,"b",function(){return utcFormat}),__webpack_require__.d(__webpack_exports__,"c",function(){return utcParse});var locale,timeFormat,timeParse,utcFormat,utcParse,__WEBPACK_IMPORTED_MODULE_0__locale__=__webpack_require__(60);!function(definition){locale=Object(__WEBPACK_IMPORTED_MODULE_0__locale__.a)(definition),timeFormat=locale.format,timeParse=locale.parse,utcFormat=locale.utcFormat,utcParse=locale.utcParse}({dateTime:"%x, %X",date:"%-m/%-d/%Y",time:"%-I:%M:%S %p",periods:["AM","PM"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]})},function(module,exports){module.exports=function(url){return"string"!=typeof url?url:(/^['"].*['"]$/.test(url)&&(url=url.slice(1,-1)),/["'() \t\n]/.test(url)?'"'+url.replace(/"/g,'\\"').replace(/\n/g,"\\n")+'"':url)}},function(module,exports,__webpack_require__){"use strict";function clusterIcon(options){return new ClusterIcon(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.ClusterIcon=void 0,exports.default=clusterIcon;var _d3Color=__webpack_require__(3),ClusterIcon=exports.ClusterIcon=L.Icon.extend({options:{className:"leaflet-cluster-icon"},createIcon:function(oldIcon){var options=this.options;return this._div=oldIcon&&"DIV"===oldIcon.tagName?oldIcon:document.createElement("div"),this.setSize(options.size),this.setCount(options.count),this.setColor(options.color),this.setOpacity(options.opacity),this._div},setSize:function(size){this.options.iconSize=[size,size],this._setIconStyles(this._div,"icon")},setCount:function(count){var num=void 0;count>=1e3&&count<9500?num=(count/1e3).toFixed(1)+"k":count>=9500&&count<999500?num=Math.round(count/1e3)+"k":count>=999500&&count<195e4?num=(count/1e6).toFixed(1)+"M":count>195e4&&(num=Math.round(count/1e6)+"M"),this._div.innerHTML="<span>"+(num||count)+"</span>"},setColor:function(color){this._div.style.background=color,this._div.style.color=(0,_d3Color.hcl)(color).l<70?"#fff":"#000"},setOpacity:function(opacity){this._div.style.opacity=opacity},createShadow:function(){return null}})},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.d(__webpack_exports__,"a",function(){return deg2rad}),__webpack_require__.d(__webpack_exports__,"b",function(){return rad2deg});var deg2rad=Math.PI/180,rad2deg=180/Math.PI},function(module,__webpack_exports__,__webpack_require__){"use strict";Object.defineProperty(__webpack_exports__,"__esModule",{value:!0});var __WEBPACK_IMPORTED_MODULE_0__src_band__=__webpack_require__(85);__webpack_require__.d(__webpack_exports__,"scaleBand",function(){return __WEBPACK_IMPORTED_MODULE_0__src_band__.a}),__webpack_require__.d(__webpack_exports__,"scalePoint",function(){return __WEBPACK_IMPORTED_MODULE_0__src_band__.b});var __WEBPACK_IMPORTED_MODULE_1__src_identity__=__webpack_require__(108);__webpack_require__.d(__webpack_exports__,"scaleIdentity",function(){return __WEBPACK_IMPORTED_MODULE_1__src_identity__.a});var __WEBPACK_IMPORTED_MODULE_2__src_linear__=__webpack_require__(8);__webpack_require__.d(__webpack_exports__,"scaleLinear",function(){return __WEBPACK_IMPORTED_MODULE_2__src_linear__.a});var __WEBPACK_IMPORTED_MODULE_3__src_log__=__webpack_require__(127);__webpack_require__.d(__webpack_exports__,"scaleLog",function(){return __WEBPACK_IMPORTED_MODULE_3__src_log__.a});var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__=__webpack_require__(43);__webpack_require__.d(__webpack_exports__,"scaleOrdinal",function(){return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__.a}),__webpack_require__.d(__webpack_exports__,"scaleImplicit",function(){return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__.b});var __WEBPACK_IMPORTED_MODULE_5__src_pow__=__webpack_require__(128);__webpack_require__.d(__webpack_exports__,"scalePow",function(){return __WEBPACK_IMPORTED_MODULE_5__src_pow__.a}),__webpack_require__.d(__webpack_exports__,"scaleSqrt",function(){return __WEBPACK_IMPORTED_MODULE_5__src_pow__.b});var __WEBPACK_IMPORTED_MODULE_6__src_quantile__=__webpack_require__(129);__webpack_require__.d(__webpack_exports__,"scaleQuantile",function(){return __WEBPACK_IMPORTED_MODULE_6__src_quantile__.a});var __WEBPACK_IMPORTED_MODULE_7__src_quantize__=__webpack_require__(130);__webpack_require__.d(__webpack_exports__,"scaleQuantize",function(){return __WEBPACK_IMPORTED_MODULE_7__src_quantize__.a});var __WEBPACK_IMPORTED_MODULE_8__src_threshold__=__webpack_require__(131);__webpack_require__.d(__webpack_exports__,"scaleThreshold",function(){return __WEBPACK_IMPORTED_MODULE_8__src_threshold__.a});var __WEBPACK_IMPORTED_MODULE_9__src_time__=__webpack_require__(58);__webpack_require__.d(__webpack_exports__,"scaleTime",function(){return __WEBPACK_IMPORTED_MODULE_9__src_time__.b});var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__=__webpack_require__(147);__webpack_require__.d(__webpack_exports__,"scaleUtc",function(){return __WEBPACK_IMPORTED_MODULE_10__src_utcTime__.a});var __WEBPACK_IMPORTED_MODULE_11__src_sequential__=__webpack_require__(148);__webpack_require__.d(__webpack_exports__,"scaleSequential",function(){return __WEBPACK_IMPORTED_MODULE_11__src_sequential__.a})},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__ascending__=__webpack_require__(5),__WEBPACK_IMPORTED_MODULE_1__bisector__=__webpack_require__(32),ascendingBisect=Object(__WEBPACK_IMPORTED_MODULE_1__bisector__.a)(__WEBPACK_IMPORTED_MODULE_0__ascending__.a),bisectRight=ascendingBisect.right;ascendingBisect.left;__webpack_exports__.a=bisectRight},function(module,__webpack_exports__,__webpack_require__){"use strict";function ascendingComparator(f){return function(d,x){return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__.a)(f(d),x)}}var __WEBPACK_IMPORTED_MODULE_0__ascending__=__webpack_require__(5);__webpack_exports__.a=function(compare){return 1===compare.length&&(compare=ascendingComparator(compare)),{left:function(a,x,lo,hi){for(null==lo&&(lo=0),null==hi&&(hi=a.length);lo<hi;){var mid=lo+hi>>>1;compare(a[mid],x)<0?lo=mid+1:hi=mid}return lo},right:function(a,x,lo,hi){for(null==lo&&(lo=0),null==hi&&(hi=a.length);lo<hi;){var mid=lo+hi>>>1;compare(a[mid],x)>0?hi=mid:lo=mid+1}return lo}}}},function(module,__webpack_exports__,__webpack_require__){"use strict";function pair(a,b){return[a,b]}__webpack_exports__.a=pair},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__variance__=__webpack_require__(35);__webpack_exports__.a=function(array,f){var v=Object(__WEBPACK_IMPORTED_MODULE_0__variance__.a)(array,f);return v?Math.sqrt(v):v}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__number__=__webpack_require__(7);__webpack_exports__.a=function(values,valueof){var value,delta,n=values.length,m=0,i=-1,mean=0,sum=0;if(null==valueof)for(;++i<n;)isNaN(value=Object(__WEBPACK_IMPORTED_MODULE_0__number__.a)(values[i]))||(delta=value-mean,mean+=delta/++m,sum+=delta*(value-mean));else for(;++i<n;)isNaN(value=Object(__WEBPACK_IMPORTED_MODULE_0__number__.a)(valueof(values[i],i,values)))||(delta=value-mean,mean+=delta/++m,sum+=delta*(value-mean));if(m>1)return sum/(m-1)}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(values,valueof){var value,min,max,n=values.length,i=-1;if(null==valueof){for(;++i<n;)if(null!=(value=values[i])&&value>=value)for(min=max=value;++i<n;)null!=(value=values[i])&&(min>value&&(min=value),max<value&&(max=value))}else for(;++i<n;)if(null!=(value=valueof(values[i],i,values))&&value>=value)for(min=max=value;++i<n;)null!=(value=valueof(values[i],i,values))&&(min>value&&(min=value),max<value&&(max=value));return[min,max]}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.d(__webpack_exports__,"b",function(){return slice}),__webpack_require__.d(__webpack_exports__,"a",function(){return map});var array=Array.prototype,slice=array.slice,map=array.map},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(start,stop,step){start=+start,stop=+stop,step=(n=arguments.length)<2?(stop=start,start=0,1):n<3?1:+step;for(var i=-1,n=0|Math.max(0,Math.ceil((stop-start)/step)),range=new Array(n);++i<n;)range[i]=start+i*step;return range}},function(module,__webpack_exports__,__webpack_require__){"use strict";function tickIncrement(start,stop,count){var step=(stop-start)/Math.max(0,count),power=Math.floor(Math.log(step)/Math.LN10),error=step/Math.pow(10,power);return power>=0?(error>=e10?10:error>=e5?5:error>=e2?2:1)*Math.pow(10,power):-Math.pow(10,-power)/(error>=e10?10:error>=e5?5:error>=e2?2:1)}function tickStep(start,stop,count){var step0=Math.abs(stop-start)/Math.max(0,count),step1=Math.pow(10,Math.floor(Math.log(step0)/Math.LN10)),error=step0/step1;return error>=e10?step1*=10:error>=e5?step1*=5:error>=e2&&(step1*=2),stop<start?-step1:step1}__webpack_exports__.b=tickIncrement,__webpack_exports__.c=tickStep;var e10=Math.sqrt(50),e5=Math.sqrt(10),e2=Math.sqrt(2);__webpack_exports__.a=function(start,stop,count){var reverse,n,ticks,step,i=-1;if(stop=+stop,start=+start,count=+count,start===stop&&count>0)return[start];if((reverse=stop<start)&&(n=start,start=stop,stop=n),0===(step=tickIncrement(start,stop,count))||!isFinite(step))return[];if(step>0)for(start=Math.ceil(start/step),stop=Math.floor(stop/step),ticks=new Array(n=Math.ceil(stop-start+1));++i<n;)ticks[i]=(start+i)*step;else for(start=Math.floor(start*step),stop=Math.ceil(stop*step),ticks=new Array(n=Math.ceil(start-stop+1));++i<n;)ticks[i]=(start-i)/step;return reverse&&ticks.reverse(),ticks}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(values){return Math.ceil(Math.log(values.length)/Math.LN2)+1}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(values,valueof){var value,min,n=values.length,i=-1;if(null==valueof){for(;++i<n;)if(null!=(value=values[i])&&value>=value)for(min=value;++i<n;)null!=(value=values[i])&&min>value&&(min=value)}else for(;++i<n;)if(null!=(value=valueof(values[i],i,values))&&value>=value)for(min=value;++i<n;)null!=(value=valueof(values[i],i,values))&&min>value&&(min=value);return min}},function(module,__webpack_exports__,__webpack_require__){"use strict";function length(d){return d.length}var __WEBPACK_IMPORTED_MODULE_0__min__=__webpack_require__(41);__webpack_exports__.a=function(matrix){if(!(n=matrix.length))return[];for(var i=-1,m=Object(__WEBPACK_IMPORTED_MODULE_0__min__.a)(matrix,length),transpose=new Array(m);++i<m;)for(var n,j=-1,row=transpose[i]=new Array(n);++j<n;)row[j]=matrix[j][i];return transpose}},function(module,__webpack_exports__,__webpack_require__){"use strict";function ordinal(range){function scale(d){var key=d+"",i=index.get(key);if(!i){if(unknown!==implicit)return unknown;index.set(key,i=domain.push(d))}return range[(i-1)%range.length]}var index=Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__.a)(),domain=[],unknown=implicit;return range=null==range?[]:__WEBPACK_IMPORTED_MODULE_1__array__.b.call(range),scale.domain=function(_){if(!arguments.length)return domain.slice();domain=[],index=Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__.a)();for(var d,key,i=-1,n=_.length;++i<n;)index.has(key=(d=_[i])+"")||index.set(key,domain.push(d));return scale},scale.range=function(_){return arguments.length?(range=__WEBPACK_IMPORTED_MODULE_1__array__.b.call(_),scale):range.slice()},scale.unknown=function(_){return arguments.length?(unknown=_,scale):unknown},scale.copy=function(){return ordinal().domain(domain).range(range).unknown(unknown)},scale}__webpack_require__.d(__webpack_exports__,"b",function(){return implicit}),__webpack_exports__.a=ordinal;var __WEBPACK_IMPORTED_MODULE_0_d3_collection__=__webpack_require__(102),__WEBPACK_IMPORTED_MODULE_1__array__=__webpack_require__(4),implicit={name:"implicit"}},function(module,__webpack_exports__,__webpack_require__){"use strict";function rgbSpline(spline){return function(colors){var i,color,n=colors.length,r=new Array(n),g=new Array(n),b=new Array(n);for(i=0;i<n;++i)color=Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__.rgb)(colors[i]),r[i]=color.r||0,g[i]=color.g||0,b[i]=color.b||0;return r=spline(r),g=spline(g),b=spline(b),color.opacity=1,function(t){return color.r=r(t),color.g=g(t),color.b=b(t),color+""}}}var __WEBPACK_IMPORTED_MODULE_0_d3_color__=__webpack_require__(3),__WEBPACK_IMPORTED_MODULE_1__basis__=__webpack_require__(22),__WEBPACK_IMPORTED_MODULE_2__basisClosed__=__webpack_require__(45),__WEBPACK_IMPORTED_MODULE_3__color__=__webpack_require__(9);__webpack_exports__.a=function rgbGamma(y){function rgb(start,end){var r=color((start=Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__.rgb)(start)).r,(end=Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__.rgb)(end)).r),g=color(start.g,end.g),b=color(start.b,end.b),opacity=Object(__WEBPACK_IMPORTED_MODULE_3__color__.a)(start.opacity,end.opacity);return function(t){return start.r=r(t),start.g=g(t),start.b=b(t),start.opacity=opacity(t),start+""}}var color=Object(__WEBPACK_IMPORTED_MODULE_3__color__.b)(y);return rgb.gamma=rgbGamma,rgb}(1);rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__.b),rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__.a)},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__basis__=__webpack_require__(22);__webpack_exports__.a=function(values){var n=values.length;return function(t){var i=Math.floor(((t%=1)<0?++t:t)*n),v0=values[(i+n-1)%n],v1=values[i%n],v2=values[(i+1)%n],v3=values[(i+2)%n];return Object(__WEBPACK_IMPORTED_MODULE_0__basis__.a)((t-i/n)*n,v0,v1,v2,v3)}}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(x){return function(){return x}}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__value__=__webpack_require__(21);__webpack_exports__.a=function(a,b){var i,nb=b?b.length:0,na=a?Math.min(nb,a.length):0,x=new Array(nb),c=new Array(nb);for(i=0;i<na;++i)x[i]=Object(__WEBPACK_IMPORTED_MODULE_0__value__.a)(a[i],b[i]);for(;i<nb;++i)c[i]=b[i];return function(t){for(i=0;i<na;++i)c[i]=x[i](t);return c}}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(a,b){var d=new Date;return a=+a,b-=a,function(t){return d.setTime(a+b*t),d}}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__value__=__webpack_require__(21);__webpack_exports__.a=function(a,b){var k,i={},c={};null!==a&&"object"==typeof a||(a={}),null!==b&&"object"==typeof b||(b={});for(k in b)k in a?i[k]=Object(__WEBPACK_IMPORTED_MODULE_0__value__.a)(a[k],b[k]):c[k]=b[k];return function(t){for(k in i)c[k]=i[k](t);return c}}},function(module,__webpack_exports__,__webpack_require__){"use strict";function zero(b){return function(){return b}}function one(b){return function(t){return b(t)+""}}var __WEBPACK_IMPORTED_MODULE_0__number__=__webpack_require__(12),reA=/[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,reB=new RegExp(reA.source,"g");__webpack_exports__.a=function(a,b){var am,bm,bs,bi=reA.lastIndex=reB.lastIndex=0,i=-1,s=[],q=[];for(a+="",b+="";(am=reA.exec(a))&&(bm=reB.exec(b));)(bs=bm.index)>bi&&(bs=b.slice(bi,bs),s[i]?s[i]+=bs:s[++i]=bs),(am=am[0])===(bm=bm[0])?s[i]?s[i]+=bm:s[++i]=bm:(s[++i]=null,q.push({i:i,x:Object(__WEBPACK_IMPORTED_MODULE_0__number__.a)(am,bm)})),bi=reB.lastIndex;return bi<b.length&&(bs=b.slice(bi),s[i]?s[i]+=bs:s[++i]=bs),s.length<2?q[0]?one(q[0].x):zero(b):(b=q.length,function(t){for(var o,i=0;i<b;++i)s[(o=q[i]).i]=o.x(t);return s.join("")})}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(x){return+x}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__=__webpack_require__(120);__webpack_require__.d(__webpack_exports__,"a",function(){return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__.a}),__webpack_require__.d(__webpack_exports__,"b",function(){return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__.b});var __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__=(__webpack_require__(53),__webpack_require__(54));__webpack_require__.d(__webpack_exports__,"c",function(){return __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__.a});var __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__=__webpack_require__(124);__webpack_require__.d(__webpack_exports__,"d",function(){return __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__.a});var __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__=__webpack_require__(125);__webpack_require__.d(__webpack_exports__,"e",function(){return __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__.a});var __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__=__webpack_require__(126);__webpack_require__.d(__webpack_exports__,"f",function(){return __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__.a})},function(module,__webpack_exports__,__webpack_require__){"use strict";function identity(x){return x}var __WEBPACK_IMPORTED_MODULE_0__exponent__=__webpack_require__(14),__WEBPACK_IMPORTED_MODULE_1__formatGroup__=__webpack_require__(121),__WEBPACK_IMPORTED_MODULE_2__formatSpecifier__=__webpack_require__(54),__WEBPACK_IMPORTED_MODULE_3__formatTypes__=__webpack_require__(55),__WEBPACK_IMPORTED_MODULE_4__formatPrefixAuto__=__webpack_require__(56),prefixes=["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];__webpack_exports__.a=function(locale){function newFormat(specifier){function format(value){var i,n,c,valuePrefix=prefix,valueSuffix=suffix;if("c"===type)valueSuffix=formatType(value)+valueSuffix,value="";else{value=+value;var valueNegative=(value<0||1/value<0)&&(value*=-1,!0);if(value=formatType(value,precision),valueNegative)for(i=-1,n=value.length,valueNegative=!1;++i<n;)if(48<(c=value.charCodeAt(i))&&c<58||"x"===type&&96<c&&c<103||"X"===type&&64<c&&c<71){valueNegative=!0;break}if(valuePrefix=(valueNegative?"("===sign?sign:"-":"-"===sign||"("===sign?"":sign)+valuePrefix,valueSuffix=valueSuffix+("s"===type?prefixes[8+__WEBPACK_IMPORTED_MODULE_4__formatPrefixAuto__.b/3]:"")+(valueNegative&&"("===sign?")":""),maybeSuffix)for(i=-1,n=value.length;++i<n;)if(48>(c=value.charCodeAt(i))||c>57){valueSuffix=(46===c?decimal+value.slice(i+1):value.slice(i))+valueSuffix,value=value.slice(0,i);break}}comma&&!zero&&(value=group(value,1/0));var length=valuePrefix.length+value.length+valueSuffix.length,padding=length<width?new Array(width-length+1).join(fill):"";switch(comma&&zero&&(value=group(padding+value,padding.length?width-valueSuffix.length:1/0),padding=""),align){case"<":return valuePrefix+value+valueSuffix+padding;case"=":return valuePrefix+padding+value+valueSuffix;case"^":return padding.slice(0,length=padding.length>>1)+valuePrefix+value+valueSuffix+padding.slice(length)}return padding+valuePrefix+value+valueSuffix}specifier=Object(__WEBPACK_IMPORTED_MODULE_2__formatSpecifier__.a)(specifier);var fill=specifier.fill,align=specifier.align,sign=specifier.sign,symbol=specifier.symbol,zero=specifier.zero,width=specifier.width,comma=specifier.comma,precision=specifier.precision,type=specifier.type,prefix="$"===symbol?currency[0]:"#"===symbol&&/[boxX]/.test(type)?"0"+type.toLowerCase():"",suffix="$"===symbol?currency[1]:/[%p]/.test(type)?"%":"",formatType=__WEBPACK_IMPORTED_MODULE_3__formatTypes__.a[type],maybeSuffix=!type||/[defgprs%]/.test(type);return precision=null==precision?type?6:12:/[gprs]/.test(type)?Math.max(1,Math.min(21,precision)):Math.max(0,Math.min(20,precision)),format.toString=function(){return specifier+""},format}function formatPrefix(specifier,value){var f=newFormat((specifier=Object(__WEBPACK_IMPORTED_MODULE_2__formatSpecifier__.a)(specifier),specifier.type="f",specifier)),e=3*Math.max(-8,Math.min(8,Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__.a)(value)/3))),k=Math.pow(10,-e),prefix=prefixes[8+e/3];return function(value){return f(k*value)+prefix}}var group=locale.grouping&&locale.thousands?Object(__WEBPACK_IMPORTED_MODULE_1__formatGroup__.a)(locale.grouping,locale.thousands):identity,currency=locale.currency,decimal=locale.decimal;return{format:newFormat,formatPrefix:formatPrefix}}},function(module,__webpack_exports__,__webpack_require__){"use strict";function FormatSpecifier(specifier){if(!(match=re.exec(specifier)))throw new Error("invalid format: "+specifier);var match,fill=match[1]||" ",align=match[2]||">",sign=match[3]||"-",symbol=match[4]||"",zero=!!match[5],width=match[6]&&+match[6],comma=!!match[7],precision=match[8]&&+match[8].slice(1),type=match[9]||"";"n"===type?(comma=!0,type="g"):__WEBPACK_IMPORTED_MODULE_0__formatTypes__.a[type]||(type=""),(zero||"0"===fill&&"="===align)&&(zero=!0,fill="0",align="="),this.fill=fill,this.align=align,this.sign=sign,this.symbol=symbol,this.zero=zero,this.width=width,this.comma=comma,this.precision=precision,this.type=type}var __WEBPACK_IMPORTED_MODULE_0__formatTypes__=__webpack_require__(55),re=/^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;__webpack_exports__.a=function(specifier){return new FormatSpecifier(specifier)},FormatSpecifier.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?"0":"")+(null==this.width?"":Math.max(1,0|this.width))+(this.comma?",":"")+(null==this.precision?"":"."+Math.max(0,0|this.precision))+this.type}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__formatDefault__=__webpack_require__(122),__WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__=__webpack_require__(56),__WEBPACK_IMPORTED_MODULE_2__formatRounded__=__webpack_require__(123);__webpack_exports__.a={"":__WEBPACK_IMPORTED_MODULE_0__formatDefault__.a,"%":function(x,p){return(100*x).toFixed(p)},b:function(x){return Math.round(x).toString(2)},c:function(x){return x+""},d:function(x){return Math.round(x).toString(10)},e:function(x,p){return x.toExponential(p)},f:function(x,p){return x.toFixed(p)},g:function(x,p){return x.toPrecision(p)},o:function(x){return Math.round(x).toString(8)},p:function(x,p){return Object(__WEBPACK_IMPORTED_MODULE_2__formatRounded__.a)(100*x,p)},r:__WEBPACK_IMPORTED_MODULE_2__formatRounded__.a,s:__WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__.a,X:function(x){return Math.round(x).toString(16).toUpperCase()},x:function(x){return Math.round(x).toString(16)}}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.d(__webpack_exports__,"b",function(){return prefixExponent});var prefixExponent,__WEBPACK_IMPORTED_MODULE_0__formatDecimal__=__webpack_require__(24);__webpack_exports__.a=function(x,p){var d=Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__.a)(x,p);if(!d)return x+"";var coefficient=d[0],exponent=d[1],i=exponent-(prefixExponent=3*Math.max(-8,Math.min(8,Math.floor(exponent/3))))+1,n=coefficient.length;return i===n?coefficient:i>n?coefficient+new Array(i-n+1).join("0"):i>0?coefficient.slice(0,i)+"."+coefficient.slice(i):"0."+new Array(1-i).join("0")+Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__.a)(x,Math.max(0,p+i-1))[0]}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(domain,interval){domain=domain.slice();var t,i0=0,i1=domain.length-1,x0=domain[i0],x1=domain[i1];return x1<x0&&(t=i0,i0=i1,i1=t,t=x0,x0=x1,x1=t),domain[i0]=interval.floor(x0),domain[i1]=interval.ceil(x1),domain}},function(module,__webpack_exports__,__webpack_require__){"use strict";function date(t){return new Date(t)}function number(t){return t instanceof Date?+t:+new Date(+t)}function calendar(year,month,week,day,hour,minute,second,millisecond,format){function tickFormat(date){return(second(date)<date?formatMillisecond:minute(date)<date?formatSecond:hour(date)<date?formatMinute:day(date)<date?formatHour:month(date)<date?week(date)<date?formatDay:formatWeek:year(date)<date?formatMonth:formatYear)(date)}function tickInterval(interval,start,stop,step){if(null==interval&&(interval=10),"number"==typeof interval){var target=Math.abs(stop-start)/interval,i=Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.c)(function(i){return i[2]}).right(tickIntervals,target);i===tickIntervals.length?(step=Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.g)(start/durationYear,stop/durationYear,interval),interval=year):i?(i=tickIntervals[target/tickIntervals[i-1][2]<tickIntervals[i][2]/target?i-1:i],step=i[1],interval=i[0]):(step=Math.max(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.g)(start,stop,interval),1),interval=millisecond)}return null==step?interval:interval.every(step)}var scale=Object(__WEBPACK_IMPORTED_MODULE_5__continuous__.b)(__WEBPACK_IMPORTED_MODULE_5__continuous__.c,__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__.b),invert=scale.invert,domain=scale.domain,formatMillisecond=format(".%L"),formatSecond=format(":%S"),formatMinute=format("%I:%M"),formatHour=format("%I %p"),formatDay=format("%a %d"),formatWeek=format("%b %d"),formatMonth=format("%B"),formatYear=format("%Y"),tickIntervals=[[second,1,durationSecond],[second,5,5*durationSecond],[second,15,15*durationSecond],[second,30,30*durationSecond],[minute,1,durationMinute],[minute,5,5*durationMinute],[minute,15,15*durationMinute],[minute,30,30*durationMinute],[hour,1,durationHour],[hour,3,3*durationHour],[hour,6,6*durationHour],[hour,12,12*durationHour],[day,1,durationDay],[day,2,2*durationDay],[week,1,durationWeek],[month,1,durationMonth],[month,3,3*durationMonth],[year,1,durationYear]];return scale.invert=function(y){return new Date(invert(y))},scale.domain=function(_){return arguments.length?domain(__WEBPACK_IMPORTED_MODULE_4__array__.a.call(_,number)):domain().map(date)},scale.ticks=function(interval,step){var t,d=domain(),t0=d[0],t1=d[d.length-1],r=t1<t0;return r&&(t=t0,t0=t1,t1=t),t=tickInterval(interval,t0,t1,step),t=t?t.range(t0,t1+1):[],r?t.reverse():t},scale.tickFormat=function(count,specifier){return null==specifier?tickFormat:format(specifier)},scale.nice=function(interval,step){var d=domain();return(interval=tickInterval(interval,d[0],d[d.length-1],step))?domain(Object(__WEBPACK_IMPORTED_MODULE_6__nice__.a)(d,interval)):scale},scale.copy=function(){return Object(__WEBPACK_IMPORTED_MODULE_5__continuous__.a)(scale,calendar(year,month,week,day,hour,minute,second,millisecond,format))},scale}__webpack_exports__.a=calendar;var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(1),__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__=__webpack_require__(20),__WEBPACK_IMPORTED_MODULE_2_d3_time__=__webpack_require__(25),__WEBPACK_IMPORTED_MODULE_3_d3_time_format__=__webpack_require__(59),__WEBPACK_IMPORTED_MODULE_4__array__=__webpack_require__(4),__WEBPACK_IMPORTED_MODULE_5__continuous__=__webpack_require__(13),__WEBPACK_IMPORTED_MODULE_6__nice__=__webpack_require__(57),durationSecond=1e3,durationMinute=60*durationSecond,durationHour=60*durationMinute,durationDay=24*durationHour,durationWeek=7*durationDay,durationMonth=30*durationDay,durationYear=365*durationDay;__webpack_exports__.b=function(){return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__.j,__WEBPACK_IMPORTED_MODULE_2_d3_time__.f,__WEBPACK_IMPORTED_MODULE_2_d3_time__.i,__WEBPACK_IMPORTED_MODULE_2_d3_time__.a,__WEBPACK_IMPORTED_MODULE_2_d3_time__.b,__WEBPACK_IMPORTED_MODULE_2_d3_time__.d,__WEBPACK_IMPORTED_MODULE_2_d3_time__.g,__WEBPACK_IMPORTED_MODULE_2_d3_time__.c,__WEBPACK_IMPORTED_MODULE_3_d3_time_format__.a).domain([new Date(2e3,0,1),new Date(2e3,0,2)])}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__=__webpack_require__(26);__webpack_require__.d(__webpack_exports__,"a",function(){return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__.a}),__webpack_require__.d(__webpack_exports__,"b",function(){return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__.b});__webpack_require__(60),__webpack_require__(61),__webpack_require__(146)},function(module,__webpack_exports__,__webpack_require__){"use strict";function localDate(d){if(0<=d.y&&d.y<100){var date=new Date(-1,d.m,d.d,d.H,d.M,d.S,d.L);return date.setFullYear(d.y),date}return new Date(d.y,d.m,d.d,d.H,d.M,d.S,d.L)}function utcDate(d){if(0<=d.y&&d.y<100){var date=new Date(Date.UTC(-1,d.m,d.d,d.H,d.M,d.S,d.L));return date.setUTCFullYear(d.y),date}return new Date(Date.UTC(d.y,d.m,d.d,d.H,d.M,d.S,d.L))}function newYear(y){return{y:y,m:0,d:1,H:0,M:0,S:0,L:0}}function formatLocale(locale){function newFormat(specifier,formats){return function(date){var c,pad,format,string=[],i=-1,j=0,n=specifier.length;for(date instanceof Date||(date=new Date(+date));++i<n;)37===specifier.charCodeAt(i)&&(string.push(specifier.slice(j,i)),null!=(pad=pads[c=specifier.charAt(++i)])?c=specifier.charAt(++i):pad="e"===c?" ":"0",(format=formats[c])&&(c=format(date,pad)),string.push(c),j=i+1);return string.push(specifier.slice(j,i)),string.join("")}}function newParse(specifier,newDate){return function(string){var d=newYear(1900);if(parseSpecifier(d,specifier,string+="",0)!=string.length)return null;if("p"in d&&(d.H=d.H%12+12*d.p),"W"in d||"U"in d){"w"in d||(d.w="W"in d?1:0);var day="Z"in d?utcDate(newYear(d.y)).getUTCDay():newDate(newYear(d.y)).getDay();d.m=0,d.d="W"in d?(d.w+6)%7+7*d.W-(day+5)%7:d.w+7*d.U-(day+6)%7}return"Z"in d?(d.H+=d.Z/100|0,d.M+=d.Z%100,utcDate(d)):newDate(d)}}function parseSpecifier(d,specifier,string,j){for(var c,parse,i=0,n=specifier.length,m=string.length;i<n;){if(j>=m)return-1;if(37===(c=specifier.charCodeAt(i++))){if(c=specifier.charAt(i++),!(parse=parses[c in pads?specifier.charAt(i++):c])||(j=parse(d,string,j))<0)return-1}else if(c!=string.charCodeAt(j++))return-1}return j}function parsePeriod(d,string,i){var n=periodRe.exec(string.slice(i));return n?(d.p=periodLookup[n[0].toLowerCase()],i+n[0].length):-1}function parseShortWeekday(d,string,i){var n=shortWeekdayRe.exec(string.slice(i));return n?(d.w=shortWeekdayLookup[n[0].toLowerCase()],i+n[0].length):-1}function parseWeekday(d,string,i){var n=weekdayRe.exec(string.slice(i));return n?(d.w=weekdayLookup[n[0].toLowerCase()],i+n[0].length):-1}function parseShortMonth(d,string,i){var n=shortMonthRe.exec(string.slice(i));return n?(d.m=shortMonthLookup[n[0].toLowerCase()],i+n[0].length):-1}function parseMonth(d,string,i){var n=monthRe.exec(string.slice(i));return n?(d.m=monthLookup[n[0].toLowerCase()],i+n[0].length):-1}function parseLocaleDateTime(d,string,i){return parseSpecifier(d,locale_dateTime,string,i)}function parseLocaleDate(d,string,i){return parseSpecifier(d,locale_date,string,i)}function parseLocaleTime(d,string,i){return parseSpecifier(d,locale_time,string,i)}function formatShortWeekday(d){return locale_shortWeekdays[d.getDay()]}function formatWeekday(d){return locale_weekdays[d.getDay()]}function formatShortMonth(d){return locale_shortMonths[d.getMonth()]}function formatMonth(d){return locale_months[d.getMonth()]}function formatPeriod(d){return locale_periods[+(d.getHours()>=12)]}function formatUTCShortWeekday(d){return locale_shortWeekdays[d.getUTCDay()]}function formatUTCWeekday(d){return locale_weekdays[d.getUTCDay()]}function formatUTCShortMonth(d){return locale_shortMonths[d.getUTCMonth()]}function formatUTCMonth(d){return locale_months[d.getUTCMonth()]}function formatUTCPeriod(d){return locale_periods[+(d.getUTCHours()>=12)]}var locale_dateTime=locale.dateTime,locale_date=locale.date,locale_time=locale.time,locale_periods=locale.periods,locale_weekdays=locale.days,locale_shortWeekdays=locale.shortDays,locale_months=locale.months,locale_shortMonths=locale.shortMonths,periodRe=formatRe(locale_periods),periodLookup=formatLookup(locale_periods),weekdayRe=formatRe(locale_weekdays),weekdayLookup=formatLookup(locale_weekdays),shortWeekdayRe=formatRe(locale_shortWeekdays),shortWeekdayLookup=formatLookup(locale_shortWeekdays),monthRe=formatRe(locale_months),monthLookup=formatLookup(locale_months),shortMonthRe=formatRe(locale_shortMonths),shortMonthLookup=formatLookup(locale_shortMonths),formats={a:formatShortWeekday,A:formatWeekday,b:formatShortMonth,B:formatMonth,c:null,d:formatDayOfMonth,e:formatDayOfMonth,H:formatHour24,I:formatHour12,j:formatDayOfYear,L:formatMilliseconds,m:formatMonthNumber,M:formatMinutes,p:formatPeriod,S:formatSeconds,U:formatWeekNumberSunday,w:formatWeekdayNumber,W:formatWeekNumberMonday,x:null,X:null,y:formatYear,Y:formatFullYear,Z:formatZone,"%":formatLiteralPercent},utcFormats={a:formatUTCShortWeekday,A:formatUTCWeekday,b:formatUTCShortMonth,B:formatUTCMonth,c:null,d:formatUTCDayOfMonth,e:formatUTCDayOfMonth,H:formatUTCHour24,I:formatUTCHour12,j:formatUTCDayOfYear,L:formatUTCMilliseconds,m:formatUTCMonthNumber,M:formatUTCMinutes,p:formatUTCPeriod,S:formatUTCSeconds,U:formatUTCWeekNumberSunday,w:formatUTCWeekdayNumber,W:formatUTCWeekNumberMonday,x:null,X:null,y:formatUTCYear,Y:formatUTCFullYear,Z:formatUTCZone,"%":formatLiteralPercent},parses={a:parseShortWeekday,A:parseWeekday,b:parseShortMonth,B:parseMonth,c:parseLocaleDateTime,d:parseDayOfMonth,e:parseDayOfMonth,H:parseHour24,I:parseHour24,j:parseDayOfYear,L:parseMilliseconds,m:parseMonthNumber,M:parseMinutes,p:parsePeriod,S:parseSeconds,U:parseWeekNumberSunday,w:parseWeekdayNumber,W:parseWeekNumberMonday,x:parseLocaleDate,X:parseLocaleTime,y:parseYear,Y:parseFullYear,Z:parseZone,"%":parseLiteralPercent};return formats.x=newFormat(locale_date,formats),formats.X=newFormat(locale_time,formats),formats.c=newFormat(locale_dateTime,formats),utcFormats.x=newFormat(locale_date,utcFormats),utcFormats.X=newFormat(locale_time,utcFormats),utcFormats.c=newFormat(locale_dateTime,utcFormats),{format:function(specifier){var f=newFormat(specifier+="",formats);return f.toString=function(){return specifier},f},parse:function(specifier){var p=newParse(specifier+="",localDate);return p.toString=function(){return specifier},p},utcFormat:function(specifier){var f=newFormat(specifier+="",utcFormats);return f.toString=function(){return specifier},f},utcParse:function(specifier){var p=newParse(specifier,utcDate);return p.toString=function(){return specifier},p}}}function pad(value,fill,width){var sign=value<0?"-":"",string=(sign?-value:value)+"",length=string.length;return sign+(length<width?new Array(width-length+1).join(fill)+string:string)}function requote(s){return s.replace(requoteRe,"\\$&")}function formatRe(names){return new RegExp("^(?:"+names.map(requote).join("|")+")","i")}function formatLookup(names){for(var map={},i=-1,n=names.length;++i<n;)map[names[i].toLowerCase()]=i;return map}function parseWeekdayNumber(d,string,i){var n=numberRe.exec(string.slice(i,i+1));return n?(d.w=+n[0],i+n[0].length):-1}function parseWeekNumberSunday(d,string,i){var n=numberRe.exec(string.slice(i));return n?(d.U=+n[0],i+n[0].length):-1}function parseWeekNumberMonday(d,string,i){var n=numberRe.exec(string.slice(i));return n?(d.W=+n[0],i+n[0].length):-1}function parseFullYear(d,string,i){var n=numberRe.exec(string.slice(i,i+4));return n?(d.y=+n[0],i+n[0].length):-1}function parseYear(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.y=+n[0]+(+n[0]>68?1900:2e3),i+n[0].length):-1}function parseZone(d,string,i){var n=/^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i,i+6));return n?(d.Z=n[1]?0:-(n[2]+(n[3]||"00")),i+n[0].length):-1}function parseMonthNumber(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.m=n[0]-1,i+n[0].length):-1}function parseDayOfMonth(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.d=+n[0],i+n[0].length):-1}function parseDayOfYear(d,string,i){var n=numberRe.exec(string.slice(i,i+3));return n?(d.m=0,d.d=+n[0],i+n[0].length):-1}function parseHour24(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.H=+n[0],i+n[0].length):-1}function parseMinutes(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.M=+n[0],i+n[0].length):-1}function parseSeconds(d,string,i){var n=numberRe.exec(string.slice(i,i+2));return n?(d.S=+n[0],i+n[0].length):-1}function parseMilliseconds(d,string,i){var n=numberRe.exec(string.slice(i,i+3));return n?(d.L=+n[0],i+n[0].length):-1}function parseLiteralPercent(d,string,i){var n=percentRe.exec(string.slice(i,i+1));return n?i+n[0].length:-1}function formatDayOfMonth(d,p){return pad(d.getDate(),p,2)}function formatHour24(d,p){return pad(d.getHours(),p,2)}function formatHour12(d,p){return pad(d.getHours()%12||12,p,2)}function formatDayOfYear(d,p){return pad(1+__WEBPACK_IMPORTED_MODULE_0_d3_time__.a.count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__.j)(d),d),p,3)}function formatMilliseconds(d,p){return pad(d.getMilliseconds(),p,3)}function formatMonthNumber(d,p){return pad(d.getMonth()+1,p,2)}function formatMinutes(d,p){return pad(d.getMinutes(),p,2)}function formatSeconds(d,p){return pad(d.getSeconds(),p,2)}function formatWeekNumberSunday(d,p){return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__.h.count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__.j)(d),d),p,2)}function formatWeekdayNumber(d){return d.getDay()}function formatWeekNumberMonday(d,p){return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__.e.count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__.j)(d),d),p,2)}function formatYear(d,p){return pad(d.getFullYear()%100,p,2)}function formatFullYear(d,p){return pad(d.getFullYear()%1e4,p,4)}function formatZone(d){var z=d.getTimezoneOffset();return(z>0?"-":(z*=-1,"+"))+pad(z/60|0,"0",2)+pad(z%60,"0",2)}function formatUTCDayOfMonth(d,p){return pad(d.getUTCDate(),p,2)}function formatUTCHour24(d,p){return pad(d.getUTCHours(),p,2)}function formatUTCHour12(d,p){return pad(d.getUTCHours()%12||12,p,2)}function formatUTCDayOfYear(d,p){return pad(1+__WEBPACK_IMPORTED_MODULE_0_d3_time__.k.count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__.t)(d),d),p,3)}function formatUTCMilliseconds(d,p){return pad(d.getUTCMilliseconds(),p,3)}function formatUTCMonthNumber(d,p){return pad(d.getUTCMonth()+1,p,2)}function formatUTCMinutes(d,p){return pad(d.getUTCMinutes(),p,2)}function formatUTCSeconds(d,p){return pad(d.getUTCSeconds(),p,2)}function formatUTCWeekNumberSunday(d,p){return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__.r.count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__.t)(d),d),p,2)}function formatUTCWeekdayNumber(d){return d.getUTCDay()}function formatUTCWeekNumberMonday(d,p){return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__.o.count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__.t)(d),d),p,2)}function formatUTCYear(d,p){return pad(d.getUTCFullYear()%100,p,2)}function formatUTCFullYear(d,p){return pad(d.getUTCFullYear()%1e4,p,4)}function formatUTCZone(){return"+0000"}function formatLiteralPercent(){return"%"}__webpack_exports__.a=formatLocale;var __WEBPACK_IMPORTED_MODULE_0_d3_time__=__webpack_require__(25),pads={"-":"",_:" ",0:"0"},numberRe=/^\s*\d+/,percentRe=/^%/,requoteRe=/[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g},function(module,__webpack_exports__,__webpack_require__){"use strict";function formatIsoNative(date){return date.toISOString()}__webpack_require__.d(__webpack_exports__,"a",function(){return isoSpecifier});var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__=__webpack_require__(26),isoSpecifier="%Y-%m-%dT%H:%M:%S.%LZ";Date.prototype.toISOString||Object(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__.b)(isoSpecifier)},function(module,exports){module.exports=function(src){function log(error){"undefined"!=typeof console&&(console.error||console.log)("[Script Loader]",error)}try{"undefined"!=typeof execScript&&function(){return"undefined"!=typeof attachEvent&&"undefined"==typeof addEventListener}()?execScript(src):"undefined"!=typeof eval?eval.call(null,src):log("EvalError: No eval function available")}catch(error){log(error)}}},function(module,exports,__webpack_require__){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var _Map=__webpack_require__(64),_Map2=function(obj){return obj&&obj.__esModule?obj:{default:obj}}(_Map);__webpack_require__(159),__webpack_require__(184),__webpack_require__(186),exports.default=_Map2.default},function(module,exports,__webpack_require__){"use strict";function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function map(id,options){return new D2Map(id,options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.D2Map=void 0,exports.default=map;var _leaflet=__webpack_require__(65),_leaflet2=_interopRequireDefault(_leaflet),_TileLayer=__webpack_require__(67),_TileLayer2=_interopRequireDefault(_TileLayer),_WmsLayer=__webpack_require__(68),_WmsLayer2=_interopRequireDefault(_WmsLayer),_GoogleLayer=__webpack_require__(69),_GoogleLayer2=_interopRequireDefault(_GoogleLayer),_Boundary=__webpack_require__(71),_Boundary2=_interopRequireDefault(_Boundary),_Dots=__webpack_require__(78),_Dots2=_interopRequireDefault(_Dots),_Markers=__webpack_require__(79),_Markers2=_interopRequireDefault(_Markers),_Circles=__webpack_require__(80),_Circles2=_interopRequireDefault(_Circles),_Choropleth=__webpack_require__(81),_Choropleth2=_interopRequireDefault(_Choropleth),_ClientCluster=__webpack_require__(82),_ClientCluster2=_interopRequireDefault(_ClientCluster),_ServerCluster=__webpack_require__(150),_ServerCluster2=_interopRequireDefault(_ServerCluster),_EarthEngine=__webpack_require__(152),_EarthEngine2=_interopRequireDefault(_EarthEngine),_Legend=__webpack_require__(153),_Legend2=_interopRequireDefault(_Legend),_FitBounds=__webpack_require__(154),_FitBounds2=_interopRequireDefault(_FitBounds),_Search=__webpack_require__(155),_Search2=_interopRequireDefault(_Search),_Measure=__webpack_require__(157),_Measure2=_interopRequireDefault(_Measure),D2Map=exports.D2Map=_leaflet2.default.Map.extend({options:{className:"leaflet-dhis2",layerTypes:{tileLayer:_TileLayer2.default,wmsLayer:_WmsLayer2.default,googleLayer:_GoogleLayer2.default,boundary:_Boundary2.default,dots:_Dots2.default,markers:_Markers2.default,circles:_Circles2.default,choropleth:_Choropleth2.default,clientCluster:_ClientCluster2.default,serverCluster:_ServerCluster2.default,earthEngine:_EarthEngine2.default},controlTypes:{legend:_Legend2.default,fitBounds:_FitBounds2.default,search:_Search2.default,measure:_Measure2.default},zoomControl:!1,controls:[],worldCopyJump:!0,maxZoom:18},initialize:function(id,opts){var options=_leaflet2.default.setOptions(this,opts);this._baseLayers={},this._overlays={},_leaflet2.default.Map.prototype.initialize.call(this,id,options),this.attributionControl.setPrefix(""),_leaflet2.default.DomUtil.addClass(this.getContainer(),options.className),_leaflet2.default.Icon.Default.imagePath="/images/",this.on("mousedown",function(e){e.originalEvent.stopPropagation()}),options.bounds&&this.fitBounds(options.bounds);for(var control in options.controls)options.controls.hasOwnProperty(control)&&this.addControl(control)},addLayer:function(layer){var layerTypes=this.options.layerTypes,newLayer=layer;return layer.type&&layerTypes[layer.type]&&(newLayer=this.createLayer(layer),!0===layer.baseLayer?this._baseLayers[layer.name]=newLayer:!0===layer.overlay&&(this._overlays[layer.name]=newLayer)),_leaflet2.default.Map.prototype.addLayer.call(this,newLayer),newLayer},createLayer:function(layer){return this.options.layerTypes[layer.type](layer)},addControl:function(control){var controlTypes=this.options.controlTypes,newControl=control;return control.type&&controlTypes[control.type]?newControl=controlTypes[control.type](control):control.type&&_leaflet2.default.control[control.type]&&(newControl=_leaflet2.default.control[control.type](control)),_leaflet2.default.Map.prototype.addControl.call(this,newControl),newControl},getLayersBounds:function(){var bounds=new _leaflet2.default.LatLngBounds;return this.eachLayer(function(layer){layer.getBounds&&"circles"!==layer.options.type&&bounds.extend(layer.getBounds())}),bounds}})},function(module,exports,__webpack_require__){(function(global){module.exports=global.L=__webpack_require__(66)}).call(exports,__webpack_require__(15))},function(module,exports,__webpack_require__){/* @preserve
 * Leaflet 1.3.1, a JS library for interactive maps. http://leafletjs.com
 * (c) 2010-2017 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */
!function(global,factory){factory(exports)}(0,function(exports){"use strict";function extend(dest){var i,j,len,src;for(j=1,len=arguments.length;j<len;j++){src=arguments[j];for(i in src)dest[i]=src[i]}return dest}function bind(fn,obj){var slice=Array.prototype.slice;if(fn.bind)return fn.bind.apply(fn,slice.call(arguments,1));var args=slice.call(arguments,2);return function(){return fn.apply(obj,args.length?args.concat(slice.call(arguments)):arguments)}}function stamp(obj){return obj._leaflet_id=obj._leaflet_id||++lastId,obj._leaflet_id}function throttle(fn,time,context){var lock,args,wrapperFn,later;return later=function(){lock=!1,args&&(wrapperFn.apply(context,args),args=!1)},wrapperFn=function(){lock?args=arguments:(fn.apply(context,arguments),setTimeout(later,time),lock=!0)}}function wrapNum(x,range,includeMax){var max=range[1],min=range[0],d=max-min;return x===max&&includeMax?x:((x-min)%d+d)%d+min}function falseFn(){return!1}function formatNum(num,digits){var pow=Math.pow(10,void 0===digits?6:digits);return Math.round(num*pow)/pow}function trim(str){return str.trim?str.trim():str.replace(/^\s+|\s+$/g,"")}function splitWords(str){return trim(str).split(/\s+/)}function setOptions(obj,options){obj.hasOwnProperty("options")||(obj.options=obj.options?create(obj.options):{});for(var i in options)obj.options[i]=options[i];return obj.options}function getParamString(obj,existingUrl,uppercase){var params=[];for(var i in obj)params.push(encodeURIComponent(uppercase?i.toUpperCase():i)+"="+encodeURIComponent(obj[i]));return(existingUrl&&-1!==existingUrl.indexOf("?")?"&":"?")+params.join("&")}function template(str,data){return str.replace(templateRe,function(str,key){var value=data[key];if(void 0===value)throw new Error("No value provided for variable "+str);return"function"==typeof value&&(value=value(data)),value})}function indexOf(array,el){for(var i=0;i<array.length;i++)if(array[i]===el)return i;return-1}function getPrefixed(name){return window["webkit"+name]||window["moz"+name]||window["ms"+name]}function timeoutDefer(fn){var time=+new Date,timeToCall=Math.max(0,16-(time-lastTime));return lastTime=time+timeToCall,window.setTimeout(fn,timeToCall)}function requestAnimFrame(fn,context,immediate){if(!immediate||requestFn!==timeoutDefer)return requestFn.call(window,bind(fn,context));fn.call(context)}function cancelAnimFrame(id){id&&cancelFn.call(window,id)}function Class(){}function checkDeprecatedMixinEvents(includes){if("undefined"!=typeof L&&L&&L.Mixin){includes=isArray(includes)?includes:[includes];for(var i=0;i<includes.length;i++)includes[i]===L.Mixin.Events&&console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.",(new Error).stack)}}function Point(x,y,round){this.x=round?Math.round(x):x,this.y=round?Math.round(y):y}function toPoint(x,y,round){return x instanceof Point?x:isArray(x)?new Point(x[0],x[1]):void 0===x||null===x?x:"object"==typeof x&&"x"in x&&"y"in x?new Point(x.x,x.y):new Point(x,y,round)}function Bounds(a,b){if(a)for(var points=b?[a,b]:a,i=0,len=points.length;i<len;i++)this.extend(points[i])}function toBounds(a,b){return!a||a instanceof Bounds?a:new Bounds(a,b)}function LatLngBounds(corner1,corner2){if(corner1)for(var latlngs=corner2?[corner1,corner2]:corner1,i=0,len=latlngs.length;i<len;i++)this.extend(latlngs[i])}function toLatLngBounds(a,b){return a instanceof LatLngBounds?a:new LatLngBounds(a,b)}function LatLng(lat,lng,alt){if(isNaN(lat)||isNaN(lng))throw new Error("Invalid LatLng object: ("+lat+", "+lng+")");this.lat=+lat,this.lng=+lng,void 0!==alt&&(this.alt=+alt)}function toLatLng(a,b,c){return a instanceof LatLng?a:isArray(a)&&"object"!=typeof a[0]?3===a.length?new LatLng(a[0],a[1],a[2]):2===a.length?new LatLng(a[0],a[1]):null:void 0===a||null===a?a:"object"==typeof a&&"lat"in a?new LatLng(a.lat,"lng"in a?a.lng:a.lon,a.alt):void 0===b?null:new LatLng(a,b,c)}function Transformation(a,b,c,d){if(isArray(a))return this._a=a[0],this._b=a[1],this._c=a[2],void(this._d=a[3]);this._a=a,this._b=b,this._c=c,this._d=d}function toTransformation(a,b,c,d){return new Transformation(a,b,c,d)}function svgCreate(name){return document.createElementNS("http://www.w3.org/2000/svg",name)}function pointsToPath(rings,closed){var i,j,len,len2,points,p,str="";for(i=0,len=rings.length;i<len;i++){for(points=rings[i],j=0,len2=points.length;j<len2;j++)p=points[j],str+=(j?"L":"M")+p.x+" "+p.y;str+=closed?svg?"z":"x":""}return str||"M0 0"}function userAgentContains(str){return navigator.userAgent.toLowerCase().indexOf(str)>=0}function addPointerListener(obj,type,handler,id){return"touchstart"===type?_addPointerStart(obj,handler,id):"touchmove"===type?_addPointerMove(obj,handler,id):"touchend"===type&&_addPointerEnd(obj,handler,id),this}function removePointerListener(obj,type,id){var handler=obj["_leaflet_"+type+id];return"touchstart"===type?obj.removeEventListener(POINTER_DOWN,handler,!1):"touchmove"===type?obj.removeEventListener(POINTER_MOVE,handler,!1):"touchend"===type&&(obj.removeEventListener(POINTER_UP,handler,!1),obj.removeEventListener(POINTER_CANCEL,handler,!1)),this}function _addPointerStart(obj,handler,id){var onDown=bind(function(e){if("mouse"!==e.pointerType&&e.MSPOINTER_TYPE_MOUSE&&e.pointerType!==e.MSPOINTER_TYPE_MOUSE){if(!(TAG_WHITE_LIST.indexOf(e.target.tagName)<0))return;preventDefault(e)}_handlePointer(e,handler)});obj["_leaflet_touchstart"+id]=onDown,obj.addEventListener(POINTER_DOWN,onDown,!1),_pointerDocListener||(document.documentElement.addEventListener(POINTER_DOWN,_globalPointerDown,!0),document.documentElement.addEventListener(POINTER_MOVE,_globalPointerMove,!0),document.documentElement.addEventListener(POINTER_UP,_globalPointerUp,!0),document.documentElement.addEventListener(POINTER_CANCEL,_globalPointerUp,!0),_pointerDocListener=!0)}function _globalPointerDown(e){_pointers[e.pointerId]=e,_pointersCount++}function _globalPointerMove(e){_pointers[e.pointerId]&&(_pointers[e.pointerId]=e)}function _globalPointerUp(e){delete _pointers[e.pointerId],_pointersCount--}function _handlePointer(e,handler){e.touches=[];for(var i in _pointers)e.touches.push(_pointers[i]);e.changedTouches=[e],handler(e)}function _addPointerMove(obj,handler,id){var onMove=function(e){(e.pointerType!==e.MSPOINTER_TYPE_MOUSE&&"mouse"!==e.pointerType||0!==e.buttons)&&_handlePointer(e,handler)};obj["_leaflet_touchmove"+id]=onMove,obj.addEventListener(POINTER_MOVE,onMove,!1)}function _addPointerEnd(obj,handler,id){var onUp=function(e){_handlePointer(e,handler)};obj["_leaflet_touchend"+id]=onUp,obj.addEventListener(POINTER_UP,onUp,!1),obj.addEventListener(POINTER_CANCEL,onUp,!1)}function addDoubleTapListener(obj,handler,id){function onTouchStart(e){var count;if(pointer){if(!edge||"mouse"===e.pointerType)return;count=_pointersCount}else count=e.touches.length;if(!(count>1)){var now=Date.now(),delta=now-(last||now);touch$$1=e.touches?e.touches[0]:e,doubleTap=delta>0&&delta<=delay,last=now}}function onTouchEnd(e){if(doubleTap&&!touch$$1.cancelBubble){if(pointer){if(!edge||"mouse"===e.pointerType)return;var prop,i,newTouch={};for(i in touch$$1)prop=touch$$1[i],newTouch[i]=prop&&prop.bind?prop.bind(touch$$1):prop;touch$$1=newTouch}touch$$1.type="dblclick",handler(touch$$1),last=null}}var last,touch$$1,doubleTap=!1,delay=250;return obj[_pre+_touchstart+id]=onTouchStart,obj[_pre+_touchend+id]=onTouchEnd,obj[_pre+"dblclick"+id]=handler,obj.addEventListener(_touchstart,onTouchStart,!1),obj.addEventListener(_touchend,onTouchEnd,!1),obj.addEventListener("dblclick",handler,!1),this}function removeDoubleTapListener(obj,id){var touchstart=obj[_pre+_touchstart+id],touchend=obj[_pre+_touchend+id],dblclick=obj[_pre+"dblclick"+id];return obj.removeEventListener(_touchstart,touchstart,!1),obj.removeEventListener(_touchend,touchend,!1),edge||obj.removeEventListener("dblclick",dblclick,!1),this}function on(obj,types,fn,context){if("object"==typeof types)for(var type in types)addOne(obj,type,types[type],fn);else{types=splitWords(types);for(var i=0,len=types.length;i<len;i++)addOne(obj,types[i],fn,context)}return this}function off(obj,types,fn,context){if("object"==typeof types)for(var type in types)removeOne(obj,type,types[type],fn);else if(types){types=splitWords(types);for(var i=0,len=types.length;i<len;i++)removeOne(obj,types[i],fn,context)}else{for(var j in obj[eventsKey])removeOne(obj,j,obj[eventsKey][j]);delete obj[eventsKey]}return this}function addOne(obj,type,fn,context){var id=type+stamp(fn)+(context?"_"+stamp(context):"");if(obj[eventsKey]&&obj[eventsKey][id])return this;var handler=function(e){return fn.call(context||obj,e||window.event)},originalHandler=handler;pointer&&0===type.indexOf("touch")?addPointerListener(obj,type,handler,id):!touch||"dblclick"!==type||!addDoubleTapListener||pointer&&chrome?"addEventListener"in obj?"mousewheel"===type?obj.addEventListener("onwheel"in obj?"wheel":"mousewheel",handler,!1):"mouseenter"===type||"mouseleave"===type?(handler=function(e){e=e||window.event,isExternalTarget(obj,e)&&originalHandler(e)},obj.addEventListener("mouseenter"===type?"mouseover":"mouseout",handler,!1)):("click"===type&&android&&(handler=function(e){filterClick(e,originalHandler)}),obj.addEventListener(type,handler,!1)):"attachEvent"in obj&&obj.attachEvent("on"+type,handler):addDoubleTapListener(obj,handler,id),obj[eventsKey]=obj[eventsKey]||{},obj[eventsKey][id]=handler}function removeOne(obj,type,fn,context){var id=type+stamp(fn)+(context?"_"+stamp(context):""),handler=obj[eventsKey]&&obj[eventsKey][id];if(!handler)return this;pointer&&0===type.indexOf("touch")?removePointerListener(obj,type,id):!touch||"dblclick"!==type||!removeDoubleTapListener||pointer&&chrome?"removeEventListener"in obj?"mousewheel"===type?obj.removeEventListener("onwheel"in obj?"wheel":"mousewheel",handler,!1):obj.removeEventListener("mouseenter"===type?"mouseover":"mouseleave"===type?"mouseout":type,handler,!1):"detachEvent"in obj&&obj.detachEvent("on"+type,handler):removeDoubleTapListener(obj,id),obj[eventsKey][id]=null}function stopPropagation(e){return e.stopPropagation?e.stopPropagation():e.originalEvent?e.originalEvent._stopped=!0:e.cancelBubble=!0,skipped(e),this}function disableScrollPropagation(el){return addOne(el,"mousewheel",stopPropagation),this}function disableClickPropagation(el){return on(el,"mousedown touchstart dblclick",stopPropagation),addOne(el,"click",fakeStop),this}function preventDefault(e){return e.preventDefault?e.preventDefault():e.returnValue=!1,this}function stop(e){return preventDefault(e),stopPropagation(e),this}function getMousePosition(e,container){if(!container)return new Point(e.clientX,e.clientY);var rect=container.getBoundingClientRect(),scaleX=rect.width/container.offsetWidth||1,scaleY=rect.height/container.offsetHeight||1;return new Point(e.clientX/scaleX-rect.left-container.clientLeft,e.clientY/scaleY-rect.top-container.clientTop)}function getWheelDelta(e){return edge?e.wheelDeltaY/2:e.deltaY&&0===e.deltaMode?-e.deltaY/wheelPxFactor:e.deltaY&&1===e.deltaMode?20*-e.deltaY:e.deltaY&&2===e.deltaMode?60*-e.deltaY:e.deltaX||e.deltaZ?0:e.wheelDelta?(e.wheelDeltaY||e.wheelDelta)/2:e.detail&&Math.abs(e.detail)<32765?20*-e.detail:e.detail?e.detail/-32765*60:0}function fakeStop(e){skipEvents[e.type]=!0}function skipped(e){var events=skipEvents[e.type];return skipEvents[e.type]=!1,events}function isExternalTarget(el,e){var related=e.relatedTarget;if(!related)return!0;try{for(;related&&related!==el;)related=related.parentNode}catch(err){return!1}return related!==el}function filterClick(e,handler){var timeStamp=e.timeStamp||e.originalEvent&&e.originalEvent.timeStamp,elapsed=lastClick&&timeStamp-lastClick;if(elapsed&&elapsed>100&&elapsed<500||e.target._simulatedClick&&!e._simulated)return void stop(e);lastClick=timeStamp,handler(e)}function get(id){return"string"==typeof id?document.getElementById(id):id}function getStyle(el,style){var value=el.style[style]||el.currentStyle&&el.currentStyle[style];if((!value||"auto"===value)&&document.defaultView){var css=document.defaultView.getComputedStyle(el,null);value=css?css[style]:null}return"auto"===value?null:value}function create$1(tagName,className,container){var el=document.createElement(tagName);return el.className=className||"",container&&container.appendChild(el),el}function remove(el){var parent=el.parentNode;parent&&parent.removeChild(el)}function empty(el){for(;el.firstChild;)el.removeChild(el.firstChild)}function toFront(el){var parent=el.parentNode;parent.lastChild!==el&&parent.appendChild(el)}function toBack(el){var parent=el.parentNode;parent.firstChild!==el&&parent.insertBefore(el,parent.firstChild)}function hasClass(el,name){if(void 0!==el.classList)return el.classList.contains(name);var className=getClass(el);return className.length>0&&new RegExp("(^|\\s)"+name+"(\\s|$)").test(className)}function addClass(el,name){if(void 0!==el.classList)for(var classes=splitWords(name),i=0,len=classes.length;i<len;i++)el.classList.add(classes[i]);else if(!hasClass(el,name)){var className=getClass(el);setClass(el,(className?className+" ":"")+name)}}function removeClass(el,name){void 0!==el.classList?el.classList.remove(name):setClass(el,trim((" "+getClass(el)+" ").replace(" "+name+" "," ")))}function setClass(el,name){void 0===el.className.baseVal?el.className=name:el.className.baseVal=name}function getClass(el){return void 0===el.className.baseVal?el.className:el.className.baseVal}function setOpacity(el,value){"opacity"in el.style?el.style.opacity=value:"filter"in el.style&&_setOpacityIE(el,value)}function _setOpacityIE(el,value){var filter=!1,filterName="DXImageTransform.Microsoft.Alpha";try{filter=el.filters.item(filterName)}catch(e){if(1===value)return}value=Math.round(100*value),filter?(filter.Enabled=100!==value,filter.Opacity=value):el.style.filter+=" progid:"+filterName+"(opacity="+value+")"}function testProp(props){for(var style=document.documentElement.style,i=0;i<props.length;i++)if(props[i]in style)return props[i];return!1}function setTransform(el,offset,scale){var pos=offset||new Point(0,0);el.style[TRANSFORM]=(ie3d?"translate("+pos.x+"px,"+pos.y+"px)":"translate3d("+pos.x+"px,"+pos.y+"px,0)")+(scale?" scale("+scale+")":"")}function setPosition(el,point){el._leaflet_pos=point,any3d?setTransform(el,point):(el.style.left=point.x+"px",el.style.top=point.y+"px")}function getPosition(el){return el._leaflet_pos||new Point(0,0)}function disableImageDrag(){on(window,"dragstart",preventDefault)}function enableImageDrag(){off(window,"dragstart",preventDefault)}function preventOutline(element){for(;-1===element.tabIndex;)element=element.parentNode;element.style&&(restoreOutline(),_outlineElement=element,_outlineStyle=element.style.outline,element.style.outline="none",on(window,"keydown",restoreOutline))}function restoreOutline(){_outlineElement&&(_outlineElement.style.outline=_outlineStyle,_outlineElement=void 0,_outlineStyle=void 0,off(window,"keydown",restoreOutline))}function createMap(id,options){return new Map(id,options)}function simplify(points,tolerance){if(!tolerance||!points.length)return points.slice();var sqTolerance=tolerance*tolerance;return points=_reducePoints(points,sqTolerance),points=_simplifyDP(points,sqTolerance)}function pointToSegmentDistance(p,p1,p2){return Math.sqrt(_sqClosestPointOnSegment(p,p1,p2,!0))}function closestPointOnSegment(p,p1,p2){return _sqClosestPointOnSegment(p,p1,p2)}function _simplifyDP(points,sqTolerance){var len=points.length,ArrayConstructor=typeof Uint8Array!=void 0+""?Uint8Array:Array,markers=new ArrayConstructor(len);markers[0]=markers[len-1]=1,_simplifyDPStep(points,markers,sqTolerance,0,len-1);var i,newPoints=[];for(i=0;i<len;i++)markers[i]&&newPoints.push(points[i]);return newPoints}function _simplifyDPStep(points,markers,sqTolerance,first,last){var index,i,sqDist,maxSqDist=0;for(i=first+1;i<=last-1;i++)(sqDist=_sqClosestPointOnSegment(points[i],points[first],points[last],!0))>maxSqDist&&(index=i,maxSqDist=sqDist);maxSqDist>sqTolerance&&(markers[index]=1,_simplifyDPStep(points,markers,sqTolerance,first,index),_simplifyDPStep(points,markers,sqTolerance,index,last))}function _reducePoints(points,sqTolerance){for(var reducedPoints=[points[0]],i=1,prev=0,len=points.length;i<len;i++)_sqDist(points[i],points[prev])>sqTolerance&&(reducedPoints.push(points[i]),prev=i);return prev<len-1&&reducedPoints.push(points[len-1]),reducedPoints}function clipSegment(a,b,bounds,useLastCode,round){var codeOut,p,newCode,codeA=useLastCode?_lastCode:_getBitCode(a,bounds),codeB=_getBitCode(b,bounds);for(_lastCode=codeB;;){if(!(codeA|codeB))return[a,b];if(codeA&codeB)return!1;codeOut=codeA||codeB,p=_getEdgeIntersection(a,b,codeOut,bounds,round),newCode=_getBitCode(p,bounds),codeOut===codeA?(a=p,codeA=newCode):(b=p,codeB=newCode)}}function _getEdgeIntersection(a,b,code,bounds,round){var x,y,dx=b.x-a.x,dy=b.y-a.y,min=bounds.min,max=bounds.max;return 8&code?(x=a.x+dx*(max.y-a.y)/dy,y=max.y):4&code?(x=a.x+dx*(min.y-a.y)/dy,y=min.y):2&code?(x=max.x,y=a.y+dy*(max.x-a.x)/dx):1&code&&(x=min.x,y=a.y+dy*(min.x-a.x)/dx),new Point(x,y,round)}function _getBitCode(p,bounds){var code=0;return p.x<bounds.min.x?code|=1:p.x>bounds.max.x&&(code|=2),p.y<bounds.min.y?code|=4:p.y>bounds.max.y&&(code|=8),code}function _sqDist(p1,p2){var dx=p2.x-p1.x,dy=p2.y-p1.y;return dx*dx+dy*dy}function _sqClosestPointOnSegment(p,p1,p2,sqDist){var t,x=p1.x,y=p1.y,dx=p2.x-x,dy=p2.y-y,dot=dx*dx+dy*dy;return dot>0&&(t=((p.x-x)*dx+(p.y-y)*dy)/dot,t>1?(x=p2.x,y=p2.y):t>0&&(x+=dx*t,y+=dy*t)),dx=p.x-x,dy=p.y-y,sqDist?dx*dx+dy*dy:new Point(x,y)}function isFlat(latlngs){return!isArray(latlngs[0])||"object"!=typeof latlngs[0][0]&&void 0!==latlngs[0][0]}function _flat(latlngs){return console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead."),isFlat(latlngs)}function clipPolygon(points,bounds,round){var clippedPoints,i,j,k,a,b,len,edge,p,edges=[1,4,2,8];for(i=0,len=points.length;i<len;i++)points[i]._code=_getBitCode(points[i],bounds);for(k=0;k<4;k++){for(edge=edges[k],clippedPoints=[],i=0,len=points.length,j=len-1;i<len;j=i++)a=points[i],b=points[j],a._code&edge?b._code&edge||(p=_getEdgeIntersection(b,a,edge,bounds,round),p._code=_getBitCode(p,bounds),clippedPoints.push(p)):(b._code&edge&&(p=_getEdgeIntersection(b,a,edge,bounds,round),p._code=_getBitCode(p,bounds),clippedPoints.push(p)),clippedPoints.push(a));points=clippedPoints}return points}function icon(options){return new Icon(options)}function marker(latlng,options){return new Marker(latlng,options)}function circleMarker(latlng,options){return new CircleMarker(latlng,options)}function circle(latlng,options,legacyOptions){return new Circle(latlng,options,legacyOptions)}function polyline(latlngs,options){return new Polyline(latlngs,options)}function polygon(latlngs,options){return new Polygon(latlngs,options)}function geometryToLayer(geojson,options){var latlng,latlngs,i,len,geometry="Feature"===geojson.type?geojson.geometry:geojson,coords=geometry?geometry.coordinates:null,layers=[],pointToLayer=options&&options.pointToLayer,_coordsToLatLng=options&&options.coordsToLatLng||coordsToLatLng;if(!coords&&!geometry)return null;switch(geometry.type){case"Point":return latlng=_coordsToLatLng(coords),pointToLayer?pointToLayer(geojson,latlng):new Marker(latlng);case"MultiPoint":for(i=0,len=coords.length;i<len;i++)latlng=_coordsToLatLng(coords[i]),layers.push(pointToLayer?pointToLayer(geojson,latlng):new Marker(latlng));return new FeatureGroup(layers);case"LineString":case"MultiLineString":return latlngs=coordsToLatLngs(coords,"LineString"===geometry.type?0:1,_coordsToLatLng),new Polyline(latlngs,options);case"Polygon":case"MultiPolygon":return latlngs=coordsToLatLngs(coords,"Polygon"===geometry.type?1:2,_coordsToLatLng),new Polygon(latlngs,options);case"GeometryCollection":for(i=0,len=geometry.geometries.length;i<len;i++){var layer=geometryToLayer({geometry:geometry.geometries[i],type:"Feature",properties:geojson.properties},options);layer&&layers.push(layer)}return new FeatureGroup(layers);default:throw new Error("Invalid GeoJSON object.")}}function coordsToLatLng(coords){return new LatLng(coords[1],coords[0],coords[2])}function coordsToLatLngs(coords,levelsDeep,_coordsToLatLng){for(var latlng,latlngs=[],i=0,len=coords.length;i<len;i++)latlng=levelsDeep?coordsToLatLngs(coords[i],levelsDeep-1,_coordsToLatLng):(_coordsToLatLng||coordsToLatLng)(coords[i]),latlngs.push(latlng);return latlngs}function latLngToCoords(latlng,precision){return precision="number"==typeof precision?precision:6,void 0!==latlng.alt?[formatNum(latlng.lng,precision),formatNum(latlng.lat,precision),formatNum(latlng.alt,precision)]:[formatNum(latlng.lng,precision),formatNum(latlng.lat,precision)]}function latLngsToCoords(latlngs,levelsDeep,closed,precision){for(var coords=[],i=0,len=latlngs.length;i<len;i++)coords.push(levelsDeep?latLngsToCoords(latlngs[i],levelsDeep-1,closed,precision):latLngToCoords(latlngs[i],precision));return!levelsDeep&&closed&&coords.push(coords[0]),coords}function getFeature(layer,newGeometry){return layer.feature?extend({},layer.feature,{geometry:newGeometry}):asFeature(newGeometry)}function asFeature(geojson){return"Feature"===geojson.type||"FeatureCollection"===geojson.type?geojson:{type:"Feature",properties:{},geometry:geojson}}function geoJSON(geojson,options){return new GeoJSON(geojson,options)}function videoOverlay(video,bounds,options){return new VideoOverlay(video,bounds,options)}function divIcon(options){return new DivIcon(options)}function gridLayer(options){return new GridLayer(options)}function tileLayer(url,options){return new TileLayer(url,options)}function tileLayerWMS(url,options){return new TileLayerWMS(url,options)}function canvas$1(options){return canvas?new Canvas(options):null}function svg$1(options){return svg||vml?new SVG(options):null}function rectangle(latLngBounds,options){return new Rectangle(latLngBounds,options)}function noConflict(){return window.L=oldL,this}var freeze=Object.freeze;Object.freeze=function(obj){return obj};var create=Object.create||function(){function F(){}return function(proto){return F.prototype=proto,new F}}(),lastId=0,templateRe=/\{ *([\w_-]+) *\}/g,isArray=Array.isArray||function(obj){return"[object Array]"===Object.prototype.toString.call(obj)},emptyImageUrl="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=",lastTime=0,requestFn=window.requestAnimationFrame||getPrefixed("RequestAnimationFrame")||timeoutDefer,cancelFn=window.cancelAnimationFrame||getPrefixed("CancelAnimationFrame")||getPrefixed("CancelRequestAnimationFrame")||function(id){window.clearTimeout(id)},Util=(Object.freeze||Object)({freeze:freeze,extend:extend,create:create,bind:bind,lastId:lastId,stamp:stamp,throttle:throttle,wrapNum:wrapNum,falseFn:falseFn,formatNum:formatNum,trim:trim,splitWords:splitWords,setOptions:setOptions,getParamString:getParamString,template:template,isArray:isArray,indexOf:indexOf,emptyImageUrl:emptyImageUrl,requestFn:requestFn,cancelFn:cancelFn,requestAnimFrame:requestAnimFrame,cancelAnimFrame:cancelAnimFrame});Class.extend=function(props){var NewClass=function(){this.initialize&&this.initialize.apply(this,arguments),this.callInitHooks()},parentProto=NewClass.__super__=this.prototype,proto=create(parentProto);proto.constructor=NewClass,NewClass.prototype=proto;for(var i in this)this.hasOwnProperty(i)&&"prototype"!==i&&"__super__"!==i&&(NewClass[i]=this[i]);return props.statics&&(extend(NewClass,props.statics),delete props.statics),props.includes&&(checkDeprecatedMixinEvents(props.includes),extend.apply(null,[proto].concat(props.includes)),delete props.includes),proto.options&&(props.options=extend(create(proto.options),props.options)),extend(proto,props),proto._initHooks=[],proto.callInitHooks=function(){if(!this._initHooksCalled){parentProto.callInitHooks&&parentProto.callInitHooks.call(this),this._initHooksCalled=!0;for(var i=0,len=proto._initHooks.length;i<len;i++)proto._initHooks[i].call(this)}},NewClass},Class.include=function(props){return extend(this.prototype,props),this},Class.mergeOptions=function(options){return extend(this.prototype.options,options),this},Class.addInitHook=function(fn){var args=Array.prototype.slice.call(arguments,1),init="function"==typeof fn?fn:function(){this[fn].apply(this,args)};return this.prototype._initHooks=this.prototype._initHooks||[],this.prototype._initHooks.push(init),this};var Events={on:function(types,fn,context){if("object"==typeof types)for(var type in types)this._on(type,types[type],fn);else{types=splitWords(types);for(var i=0,len=types.length;i<len;i++)this._on(types[i],fn,context)}return this},off:function(types,fn,context){if(types)if("object"==typeof types)for(var type in types)this._off(type,types[type],fn);else{types=splitWords(types);for(var i=0,len=types.length;i<len;i++)this._off(types[i],fn,context)}else delete this._events;return this},_on:function(type,fn,context){this._events=this._events||{};var typeListeners=this._events[type];typeListeners||(typeListeners=[],this._events[type]=typeListeners),context===this&&(context=void 0);for(var newListener={fn:fn,ctx:context},listeners=typeListeners,i=0,len=listeners.length;i<len;i++)if(listeners[i].fn===fn&&listeners[i].ctx===context)return;listeners.push(newListener)},_off:function(type,fn,context){var listeners,i,len;if(this._events&&(listeners=this._events[type])){if(!fn){for(i=0,len=listeners.length;i<len;i++)listeners[i].fn=falseFn;return void delete this._events[type]}if(context===this&&(context=void 0),listeners)for(i=0,len=listeners.length;i<len;i++){var l=listeners[i];if(l.ctx===context&&l.fn===fn)return l.fn=falseFn,this._firingCount&&(this._events[type]=listeners=listeners.slice()),void listeners.splice(i,1)}}},fire:function(type,data,propagate){if(!this.listens(type,propagate))return this;var event=extend({},data,{type:type,target:this,sourceTarget:data&&data.sourceTarget||this});if(this._events){var listeners=this._events[type];if(listeners){this._firingCount=this._firingCount+1||1;for(var i=0,len=listeners.length;i<len;i++){var l=listeners[i];l.fn.call(l.ctx||this,event)}this._firingCount--}}return propagate&&this._propagateEvent(event),this},listens:function(type,propagate){var listeners=this._events&&this._events[type];if(listeners&&listeners.length)return!0;if(propagate)for(var id in this._eventParents)if(this._eventParents[id].listens(type,propagate))return!0;return!1},once:function(types,fn,context){if("object"==typeof types){for(var type in types)this.once(type,types[type],fn);return this}var handler=bind(function(){this.off(types,fn,context).off(types,handler,context)},this);return this.on(types,fn,context).on(types,handler,context)},addEventParent:function(obj){return this._eventParents=this._eventParents||{},this._eventParents[stamp(obj)]=obj,this},removeEventParent:function(obj){return this._eventParents&&delete this._eventParents[stamp(obj)],this},_propagateEvent:function(e){for(var id in this._eventParents)this._eventParents[id].fire(e.type,extend({layer:e.target,propagatedFrom:e.target},e),!0)}};Events.addEventListener=Events.on,Events.removeEventListener=Events.clearAllEventListeners=Events.off,Events.addOneTimeEventListener=Events.once,Events.fireEvent=Events.fire,Events.hasEventListeners=Events.listens;var Evented=Class.extend(Events),trunc=Math.trunc||function(v){return v>0?Math.floor(v):Math.ceil(v)};Point.prototype={clone:function(){return new Point(this.x,this.y)},add:function(point){return this.clone()._add(toPoint(point))},_add:function(point){return this.x+=point.x,this.y+=point.y,this},subtract:function(point){return this.clone()._subtract(toPoint(point))},_subtract:function(point){return this.x-=point.x,this.y-=point.y,this},divideBy:function(num){return this.clone()._divideBy(num)},_divideBy:function(num){return this.x/=num,this.y/=num,this},multiplyBy:function(num){return this.clone()._multiplyBy(num)},_multiplyBy:function(num){return this.x*=num,this.y*=num,this},scaleBy:function(point){return new Point(this.x*point.x,this.y*point.y)},unscaleBy:function(point){return new Point(this.x/point.x,this.y/point.y)},round:function(){return this.clone()._round()},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this},floor:function(){return this.clone()._floor()},_floor:function(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this},ceil:function(){return this.clone()._ceil()},_ceil:function(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this},trunc:function(){return this.clone()._trunc()},_trunc:function(){return this.x=trunc(this.x),this.y=trunc(this.y),this},distanceTo:function(point){point=toPoint(point);var x=point.x-this.x,y=point.y-this.y;return Math.sqrt(x*x+y*y)},equals:function(point){return point=toPoint(point),point.x===this.x&&point.y===this.y},contains:function(point){return point=toPoint(point),Math.abs(point.x)<=Math.abs(this.x)&&Math.abs(point.y)<=Math.abs(this.y)},toString:function(){return"Point("+formatNum(this.x)+", "+formatNum(this.y)+")"}},Bounds.prototype={extend:function(point){return point=toPoint(point),this.min||this.max?(this.min.x=Math.min(point.x,this.min.x),this.max.x=Math.max(point.x,this.max.x),this.min.y=Math.min(point.y,this.min.y),this.max.y=Math.max(point.y,this.max.y)):(this.min=point.clone(),this.max=point.clone()),this},getCenter:function(round){return new Point((this.min.x+this.max.x)/2,(this.min.y+this.max.y)/2,round)},getBottomLeft:function(){return new Point(this.min.x,this.max.y)},getTopRight:function(){return new Point(this.max.x,this.min.y)},getTopLeft:function(){return this.min},getBottomRight:function(){return this.max},getSize:function(){return this.max.subtract(this.min)},contains:function(obj){var min,max;return obj="number"==typeof obj[0]||obj instanceof Point?toPoint(obj):toBounds(obj),obj instanceof Bounds?(min=obj.min,max=obj.max):min=max=obj,min.x>=this.min.x&&max.x<=this.max.x&&min.y>=this.min.y&&max.y<=this.max.y},intersects:function(bounds){bounds=toBounds(bounds);var min=this.min,max=this.max,min2=bounds.min,max2=bounds.max,xIntersects=max2.x>=min.x&&min2.x<=max.x,yIntersects=max2.y>=min.y&&min2.y<=max.y;return xIntersects&&yIntersects},overlaps:function(bounds){bounds=toBounds(bounds);var min=this.min,max=this.max,min2=bounds.min,max2=bounds.max,xOverlaps=max2.x>min.x&&min2.x<max.x,yOverlaps=max2.y>min.y&&min2.y<max.y;return xOverlaps&&yOverlaps},isValid:function(){return!(!this.min||!this.max)}},LatLngBounds.prototype={extend:function(obj){var sw2,ne2,sw=this._southWest,ne=this._northEast;if(obj instanceof LatLng)sw2=obj,ne2=obj;else{if(!(obj instanceof LatLngBounds))return obj?this.extend(toLatLng(obj)||toLatLngBounds(obj)):this;if(sw2=obj._southWest,ne2=obj._northEast,!sw2||!ne2)return this}return sw||ne?(sw.lat=Math.min(sw2.lat,sw.lat),sw.lng=Math.min(sw2.lng,sw.lng),ne.lat=Math.max(ne2.lat,ne.lat),ne.lng=Math.max(ne2.lng,ne.lng)):(this._southWest=new LatLng(sw2.lat,sw2.lng),this._northEast=new LatLng(ne2.lat,ne2.lng)),this},pad:function(bufferRatio){var sw=this._southWest,ne=this._northEast,heightBuffer=Math.abs(sw.lat-ne.lat)*bufferRatio,widthBuffer=Math.abs(sw.lng-ne.lng)*bufferRatio;return new LatLngBounds(new LatLng(sw.lat-heightBuffer,sw.lng-widthBuffer),new LatLng(ne.lat+heightBuffer,ne.lng+widthBuffer))},getCenter:function(){return new LatLng((this._southWest.lat+this._northEast.lat)/2,(this._southWest.lng+this._northEast.lng)/2)},getSouthWest:function(){return this._southWest},getNorthEast:function(){return this._northEast},getNorthWest:function(){return new LatLng(this.getNorth(),this.getWest())},getSouthEast:function(){return new LatLng(this.getSouth(),this.getEast())},getWest:function(){return this._southWest.lng},getSouth:function(){return this._southWest.lat},getEast:function(){return this._northEast.lng},getNorth:function(){return this._northEast.lat},contains:function(obj){obj="number"==typeof obj[0]||obj instanceof LatLng||"lat"in obj?toLatLng(obj):toLatLngBounds(obj);var sw2,ne2,sw=this._southWest,ne=this._northEast;return obj instanceof LatLngBounds?(sw2=obj.getSouthWest(),ne2=obj.getNorthEast()):sw2=ne2=obj,sw2.lat>=sw.lat&&ne2.lat<=ne.lat&&sw2.lng>=sw.lng&&ne2.lng<=ne.lng},intersects:function(bounds){bounds=toLatLngBounds(bounds);var sw=this._southWest,ne=this._northEast,sw2=bounds.getSouthWest(),ne2=bounds.getNorthEast(),latIntersects=ne2.lat>=sw.lat&&sw2.lat<=ne.lat,lngIntersects=ne2.lng>=sw.lng&&sw2.lng<=ne.lng;return latIntersects&&lngIntersects},overlaps:function(bounds){bounds=toLatLngBounds(bounds);var sw=this._southWest,ne=this._northEast,sw2=bounds.getSouthWest(),ne2=bounds.getNorthEast(),latOverlaps=ne2.lat>sw.lat&&sw2.lat<ne.lat,lngOverlaps=ne2.lng>sw.lng&&sw2.lng<ne.lng;return latOverlaps&&lngOverlaps},toBBoxString:function(){return[this.getWest(),this.getSouth(),this.getEast(),this.getNorth()].join(",")},equals:function(bounds,maxMargin){return!!bounds&&(bounds=toLatLngBounds(bounds),this._southWest.equals(bounds.getSouthWest(),maxMargin)&&this._northEast.equals(bounds.getNorthEast(),maxMargin))},isValid:function(){return!(!this._southWest||!this._northEast)}},LatLng.prototype={equals:function(obj,maxMargin){return!!obj&&(obj=toLatLng(obj),Math.max(Math.abs(this.lat-obj.lat),Math.abs(this.lng-obj.lng))<=(void 0===maxMargin?1e-9:maxMargin))},toString:function(precision){return"LatLng("+formatNum(this.lat,precision)+", "+formatNum(this.lng,precision)+")"},distanceTo:function(other){return Earth.distance(this,toLatLng(other))},wrap:function(){return Earth.wrapLatLng(this)},toBounds:function(sizeInMeters){var latAccuracy=180*sizeInMeters/40075017,lngAccuracy=latAccuracy/Math.cos(Math.PI/180*this.lat);return toLatLngBounds([this.lat-latAccuracy,this.lng-lngAccuracy],[this.lat+latAccuracy,this.lng+lngAccuracy])},clone:function(){return new LatLng(this.lat,this.lng,this.alt)}};var CRS={latLngToPoint:function(latlng,zoom){var projectedPoint=this.projection.project(latlng),scale=this.scale(zoom);return this.transformation._transform(projectedPoint,scale)},pointToLatLng:function(point,zoom){var scale=this.scale(zoom),untransformedPoint=this.transformation.untransform(point,scale);return this.projection.unproject(untransformedPoint)},project:function(latlng){return this.projection.project(latlng)},unproject:function(point){return this.projection.unproject(point)},scale:function(zoom){return 256*Math.pow(2,zoom)},zoom:function(scale){return Math.log(scale/256)/Math.LN2},getProjectedBounds:function(zoom){if(this.infinite)return null;var b=this.projection.bounds,s=this.scale(zoom);return new Bounds(this.transformation.transform(b.min,s),this.transformation.transform(b.max,s))},infinite:!1,wrapLatLng:function(latlng){var lng=this.wrapLng?wrapNum(latlng.lng,this.wrapLng,!0):latlng.lng;return new LatLng(this.wrapLat?wrapNum(latlng.lat,this.wrapLat,!0):latlng.lat,lng,latlng.alt)},wrapLatLngBounds:function(bounds){var center=bounds.getCenter(),newCenter=this.wrapLatLng(center),latShift=center.lat-newCenter.lat,lngShift=center.lng-newCenter.lng;if(0===latShift&&0===lngShift)return bounds;var sw=bounds.getSouthWest(),ne=bounds.getNorthEast();return new LatLngBounds(new LatLng(sw.lat-latShift,sw.lng-lngShift),new LatLng(ne.lat-latShift,ne.lng-lngShift))}},Earth=extend({},CRS,{wrapLng:[-180,180],R:6371e3,distance:function(latlng1,latlng2){var rad=Math.PI/180,lat1=latlng1.lat*rad,lat2=latlng2.lat*rad,sinDLat=Math.sin((latlng2.lat-latlng1.lat)*rad/2),sinDLon=Math.sin((latlng2.lng-latlng1.lng)*rad/2),a=sinDLat*sinDLat+Math.cos(lat1)*Math.cos(lat2)*sinDLon*sinDLon,c=2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));return this.R*c}}),SphericalMercator={R:6378137,MAX_LATITUDE:85.0511287798,project:function(latlng){var d=Math.PI/180,max=this.MAX_LATITUDE,lat=Math.max(Math.min(max,latlng.lat),-max),sin=Math.sin(lat*d);return new Point(this.R*latlng.lng*d,this.R*Math.log((1+sin)/(1-sin))/2)},unproject:function(point){var d=180/Math.PI;return new LatLng((2*Math.atan(Math.exp(point.y/this.R))-Math.PI/2)*d,point.x*d/this.R)},bounds:function(){var d=6378137*Math.PI;return new Bounds([-d,-d],[d,d])}()};Transformation.prototype={transform:function(point,scale){return this._transform(point.clone(),scale)},_transform:function(point,scale){return scale=scale||1,point.x=scale*(this._a*point.x+this._b),point.y=scale*(this._c*point.y+this._d),point},untransform:function(point,scale){return scale=scale||1,new Point((point.x/scale-this._b)/this._a,(point.y/scale-this._d)/this._c)}};var lastClick,disableTextSelection,enableTextSelection,_userSelect,EPSG3857=extend({},Earth,{code:"EPSG:3857",projection:SphericalMercator,transformation:function(){var scale=.5/(Math.PI*SphericalMercator.R);return toTransformation(scale,.5,-scale,.5)}()}),EPSG900913=extend({},EPSG3857,{code:"EPSG:900913"}),style$1=document.documentElement.style,ie="ActiveXObject"in window,ielt9=ie&&!document.addEventListener,edge="msLaunchUri"in navigator&&!("documentMode"in document),webkit=userAgentContains("webkit"),android=userAgentContains("android"),android23=userAgentContains("android 2")||userAgentContains("android 3"),webkitVer=parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1],10),androidStock=android&&userAgentContains("Google")&&webkitVer<537&&!("AudioNode"in window),opera=!!window.opera,chrome=userAgentContains("chrome"),gecko=userAgentContains("gecko")&&!webkit&&!opera&&!ie,safari=!chrome&&userAgentContains("safari"),phantom=userAgentContains("phantom"),opera12="OTransition"in style$1,win=0===navigator.platform.indexOf("Win"),ie3d=ie&&"transition"in style$1,webkit3d="WebKitCSSMatrix"in window&&"m11"in new window.WebKitCSSMatrix&&!android23,gecko3d="MozPerspective"in style$1,any3d=!window.L_DISABLE_3D&&(ie3d||webkit3d||gecko3d)&&!opera12&&!phantom,mobile="undefined"!=typeof orientation||userAgentContains("mobile"),mobileWebkit=mobile&&webkit,mobileWebkit3d=mobile&&webkit3d,msPointer=!window.PointerEvent&&window.MSPointerEvent,pointer=!(!window.PointerEvent&&!msPointer),touch=!window.L_NO_TOUCH&&(pointer||"ontouchstart"in window||window.DocumentTouch&&document instanceof window.DocumentTouch),mobileOpera=mobile&&opera,mobileGecko=mobile&&gecko,retina=(window.devicePixelRatio||window.screen.deviceXDPI/window.screen.logicalXDPI)>1,canvas=function(){return!!document.createElement("canvas").getContext}(),svg=!(!document.createElementNS||!svgCreate("svg").createSVGRect),vml=!svg&&function(){try{var div=document.createElement("div");div.innerHTML='<v:shape adj="1"/>';var shape=div.firstChild;return shape.style.behavior="url(#default#VML)",shape&&"object"==typeof shape.adj}catch(e){return!1}}(),Browser=(Object.freeze||Object)({ie:ie,ielt9:ielt9,edge:edge,webkit:webkit,android:android,android23:android23,androidStock:androidStock,opera:opera,chrome:chrome,gecko:gecko,safari:safari,phantom:phantom,opera12:opera12,win:win,ie3d:ie3d,webkit3d:webkit3d,gecko3d:gecko3d,any3d:any3d,mobile:mobile,mobileWebkit:mobileWebkit,mobileWebkit3d:mobileWebkit3d,msPointer:msPointer,pointer:pointer,touch:touch,mobileOpera:mobileOpera,mobileGecko:mobileGecko,retina:retina,canvas:canvas,svg:svg,vml:vml}),POINTER_DOWN=msPointer?"MSPointerDown":"pointerdown",POINTER_MOVE=msPointer?"MSPointerMove":"pointermove",POINTER_UP=msPointer?"MSPointerUp":"pointerup",POINTER_CANCEL=msPointer?"MSPointerCancel":"pointercancel",TAG_WHITE_LIST=["INPUT","SELECT","OPTION"],_pointers={},_pointerDocListener=!1,_pointersCount=0,_touchstart=msPointer?"MSPointerDown":pointer?"pointerdown":"touchstart",_touchend=msPointer?"MSPointerUp":pointer?"pointerup":"touchend",_pre="_leaflet_",eventsKey="_leaflet_events",wheelPxFactor=win&&chrome?2*window.devicePixelRatio:gecko?window.devicePixelRatio:1,skipEvents={},DomEvent=(Object.freeze||Object)({on:on,off:off,stopPropagation:stopPropagation,disableScrollPropagation:disableScrollPropagation,disableClickPropagation:disableClickPropagation,preventDefault:preventDefault,stop:stop,getMousePosition:getMousePosition,getWheelDelta:getWheelDelta,fakeStop:fakeStop,skipped:skipped,isExternalTarget:isExternalTarget,addListener:on,removeListener:off}),TRANSFORM=testProp(["transform","WebkitTransform","OTransform","MozTransform","msTransform"]),TRANSITION=testProp(["webkitTransition","transition","OTransition","MozTransition","msTransition"]),TRANSITION_END="webkitTransition"===TRANSITION||"OTransition"===TRANSITION?TRANSITION+"End":"transitionend";if("onselectstart"in document)disableTextSelection=function(){on(window,"selectstart",preventDefault)},enableTextSelection=function(){off(window,"selectstart",preventDefault)};else{var userSelectProperty=testProp(["userSelect","WebkitUserSelect","OUserSelect","MozUserSelect","msUserSelect"]);disableTextSelection=function(){if(userSelectProperty){var style=document.documentElement.style;_userSelect=style[userSelectProperty],style[userSelectProperty]="none"}},enableTextSelection=function(){userSelectProperty&&(document.documentElement.style[userSelectProperty]=_userSelect,_userSelect=void 0)}}var _outlineElement,_outlineStyle,DomUtil=(Object.freeze||Object)({TRANSFORM:TRANSFORM,TRANSITION:TRANSITION,TRANSITION_END:TRANSITION_END,get:get,getStyle:getStyle,create:create$1,remove:remove,empty:empty,toFront:toFront,toBack:toBack,hasClass:hasClass,addClass:addClass,removeClass:removeClass,setClass:setClass,getClass:getClass,setOpacity:setOpacity,testProp:testProp,setTransform:setTransform,setPosition:setPosition,getPosition:getPosition,disableTextSelection:disableTextSelection,enableTextSelection:enableTextSelection,disableImageDrag:disableImageDrag,enableImageDrag:enableImageDrag,preventOutline:preventOutline,restoreOutline:restoreOutline}),PosAnimation=Evented.extend({run:function(el,newPos,duration,easeLinearity){this.stop(),this._el=el,this._inProgress=!0,this._duration=duration||.25,this._easeOutPower=1/Math.max(easeLinearity||.5,.2),this._startPos=getPosition(el),this._offset=newPos.subtract(this._startPos),this._startTime=+new Date,this.fire("start"),this._animate()},stop:function(){this._inProgress&&(this._step(!0),this._complete())},_animate:function(){this._animId=requestAnimFrame(this._animate,this),this._step()},_step:function(round){var elapsed=+new Date-this._startTime,duration=1e3*this._duration;elapsed<duration?this._runFrame(this._easeOut(elapsed/duration),round):(this._runFrame(1),this._complete())},_runFrame:function(progress,round){var pos=this._startPos.add(this._offset.multiplyBy(progress));round&&pos._round(),setPosition(this._el,pos),this.fire("step")},_complete:function(){cancelAnimFrame(this._animId),this._inProgress=!1,this.fire("end")},_easeOut:function(t){return 1-Math.pow(1-t,this._easeOutPower)}}),Map=Evented.extend({options:{crs:EPSG3857,center:void 0,zoom:void 0,minZoom:void 0,maxZoom:void 0,layers:[],maxBounds:void 0,renderer:void 0,zoomAnimation:!0,zoomAnimationThreshold:4,fadeAnimation:!0,markerZoomAnimation:!0,transform3DLimit:8388608,zoomSnap:1,zoomDelta:1,trackResize:!0},initialize:function(id,options){options=setOptions(this,options),this._initContainer(id),this._initLayout(),this._onResize=bind(this._onResize,this),this._initEvents(),options.maxBounds&&this.setMaxBounds(options.maxBounds),void 0!==options.zoom&&(this._zoom=this._limitZoom(options.zoom)),options.center&&void 0!==options.zoom&&this.setView(toLatLng(options.center),options.zoom,{reset:!0}),this._handlers=[],this._layers={},this._zoomBoundLayers={},this._sizeChanged=!0,this.callInitHooks(),this._zoomAnimated=TRANSITION&&any3d&&!mobileOpera&&this.options.zoomAnimation,this._zoomAnimated&&(this._createAnimProxy(),on(this._proxy,TRANSITION_END,this._catchTransitionEnd,this)),this._addLayers(this.options.layers)},setView:function(center,zoom,options){if(zoom=void 0===zoom?this._zoom:this._limitZoom(zoom),center=this._limitCenter(toLatLng(center),zoom,this.options.maxBounds),options=options||{},this._stop(),this._loaded&&!options.reset&&!0!==options){void 0!==options.animate&&(options.zoom=extend({animate:options.animate},options.zoom),options.pan=extend({animate:options.animate,duration:options.duration},options.pan));if(this._zoom!==zoom?this._tryAnimatedZoom&&this._tryAnimatedZoom(center,zoom,options.zoom):this._tryAnimatedPan(center,options.pan))return clearTimeout(this._sizeTimer),this}return this._resetView(center,zoom),this},setZoom:function(zoom,options){return this._loaded?this.setView(this.getCenter(),zoom,{zoom:options}):(this._zoom=zoom,this)},zoomIn:function(delta,options){return delta=delta||(any3d?this.options.zoomDelta:1),this.setZoom(this._zoom+delta,options)},zoomOut:function(delta,options){return delta=delta||(any3d?this.options.zoomDelta:1),this.setZoom(this._zoom-delta,options)},setZoomAround:function(latlng,zoom,options){var scale=this.getZoomScale(zoom),viewHalf=this.getSize().divideBy(2),containerPoint=latlng instanceof Point?latlng:this.latLngToContainerPoint(latlng),centerOffset=containerPoint.subtract(viewHalf).multiplyBy(1-1/scale),newCenter=this.containerPointToLatLng(viewHalf.add(centerOffset));return this.setView(newCenter,zoom,{zoom:options})},_getBoundsCenterZoom:function(bounds,options){options=options||{},bounds=bounds.getBounds?bounds.getBounds():toLatLngBounds(bounds);var paddingTL=toPoint(options.paddingTopLeft||options.padding||[0,0]),paddingBR=toPoint(options.paddingBottomRight||options.padding||[0,0]),zoom=this.getBoundsZoom(bounds,!1,paddingTL.add(paddingBR));if((zoom="number"==typeof options.maxZoom?Math.min(options.maxZoom,zoom):zoom)===1/0)return{center:bounds.getCenter(),zoom:zoom};var paddingOffset=paddingBR.subtract(paddingTL).divideBy(2),swPoint=this.project(bounds.getSouthWest(),zoom),nePoint=this.project(bounds.getNorthEast(),zoom);return{center:this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset),zoom),zoom:zoom}},fitBounds:function(bounds,options){if(bounds=toLatLngBounds(bounds),!bounds.isValid())throw new Error("Bounds are not valid.");var target=this._getBoundsCenterZoom(bounds,options);return this.setView(target.center,target.zoom,options)},fitWorld:function(options){return this.fitBounds([[-90,-180],[90,180]],options)},panTo:function(center,options){return this.setView(center,this._zoom,{pan:options})},panBy:function(offset,options){if(offset=toPoint(offset).round(),options=options||{},!offset.x&&!offset.y)return this.fire("moveend");if(!0!==options.animate&&!this.getSize().contains(offset))return this._resetView(this.unproject(this.project(this.getCenter()).add(offset)),this.getZoom()),this;if(this._panAnim||(this._panAnim=new PosAnimation,this._panAnim.on({step:this._onPanTransitionStep,end:this._onPanTransitionEnd},this)),options.noMoveStart||this.fire("movestart"),!1!==options.animate){addClass(this._mapPane,"leaflet-pan-anim");var newPos=this._getMapPanePos().subtract(offset).round();this._panAnim.run(this._mapPane,newPos,options.duration||.25,options.easeLinearity)}else this._rawPanBy(offset),this.fire("move").fire("moveend");return this},flyTo:function(targetCenter,targetZoom,options){function r(i){var s1=i?-1:1,s2=i?w1:w0,t1=w1*w1-w0*w0+s1*rho2*rho2*u1*u1,b1=2*s2*rho2*u1,b=t1/b1,sq=Math.sqrt(b*b+1)-b;return sq<1e-9?-18:Math.log(sq)}function sinh(n){return(Math.exp(n)-Math.exp(-n))/2}function cosh(n){return(Math.exp(n)+Math.exp(-n))/2}function tanh(n){return sinh(n)/cosh(n)}function w(s){return w0*(cosh(r0)/cosh(r0+rho*s))}function u(s){return w0*(cosh(r0)*tanh(r0+rho*s)-sinh(r0))/rho2}function easeOut(t){return 1-Math.pow(1-t,1.5)}function frame(){var t=(Date.now()-start)/duration,s=easeOut(t)*S;t<=1?(this._flyToFrame=requestAnimFrame(frame,this),this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s)/u1)),startZoom),this.getScaleZoom(w0/w(s),startZoom),{flyTo:!0})):this._move(targetCenter,targetZoom)._moveEnd(!0)}if(options=options||{},!1===options.animate||!any3d)return this.setView(targetCenter,targetZoom,options);this._stop();var from=this.project(this.getCenter()),to=this.project(targetCenter),size=this.getSize(),startZoom=this._zoom;targetCenter=toLatLng(targetCenter),targetZoom=void 0===targetZoom?startZoom:targetZoom;var w0=Math.max(size.x,size.y),w1=w0*this.getZoomScale(startZoom,targetZoom),u1=to.distanceTo(from)||1,rho=1.42,rho2=rho*rho,r0=r(0),start=Date.now(),S=(r(1)-r0)/rho,duration=options.duration?1e3*options.duration:1e3*S*.8;return this._moveStart(!0,options.noMoveStart),frame.call(this),this},flyToBounds:function(bounds,options){var target=this._getBoundsCenterZoom(bounds,options);return this.flyTo(target.center,target.zoom,options)},setMaxBounds:function(bounds){return bounds=toLatLngBounds(bounds),bounds.isValid()?(this.options.maxBounds&&this.off("moveend",this._panInsideMaxBounds),this.options.maxBounds=bounds,this._loaded&&this._panInsideMaxBounds(),this.on("moveend",this._panInsideMaxBounds)):(this.options.maxBounds=null,this.off("moveend",this._panInsideMaxBounds))},setMinZoom:function(zoom){var oldZoom=this.options.minZoom;return this.options.minZoom=zoom,this._loaded&&oldZoom!==zoom&&(this.fire("zoomlevelschange"),this.getZoom()<this.options.minZoom)?this.setZoom(zoom):this},setMaxZoom:function(zoom){var oldZoom=this.options.maxZoom;return this.options.maxZoom=zoom,this._loaded&&oldZoom!==zoom&&(this.fire("zoomlevelschange"),this.getZoom()>this.options.maxZoom)?this.setZoom(zoom):this},panInsideBounds:function(bounds,options){this._enforcingBounds=!0;var center=this.getCenter(),newCenter=this._limitCenter(center,this._zoom,toLatLngBounds(bounds));return center.equals(newCenter)||this.panTo(newCenter,options),this._enforcingBounds=!1,this},invalidateSize:function(options){if(!this._loaded)return this;options=extend({animate:!1,pan:!0},!0===options?{animate:!0}:options);var oldSize=this.getSize();this._sizeChanged=!0,this._lastCenter=null;var newSize=this.getSize(),oldCenter=oldSize.divideBy(2).round(),newCenter=newSize.divideBy(2).round(),offset=oldCenter.subtract(newCenter);return offset.x||offset.y?(options.animate&&options.pan?this.panBy(offset):(options.pan&&this._rawPanBy(offset),this.fire("move"),options.debounceMoveend?(clearTimeout(this._sizeTimer),this._sizeTimer=setTimeout(bind(this.fire,this,"moveend"),200)):this.fire("moveend")),this.fire("resize",{oldSize:oldSize,newSize:newSize})):this},stop:function(){return this.setZoom(this._limitZoom(this._zoom)),this.options.zoomSnap||this.fire("viewreset"),this._stop()},locate:function(options){if(options=this._locateOptions=extend({timeout:1e4,watch:!1},options),!("geolocation"in navigator))return this._handleGeolocationError({code:0,message:"Geolocation not supported."}),this;var onResponse=bind(this._handleGeolocationResponse,this),onError=bind(this._handleGeolocationError,this);return options.watch?this._locationWatchId=navigator.geolocation.watchPosition(onResponse,onError,options):navigator.geolocation.getCurrentPosition(onResponse,onError,options),this},stopLocate:function(){return navigator.geolocation&&navigator.geolocation.clearWatch&&navigator.geolocation.clearWatch(this._locationWatchId),this._locateOptions&&(this._locateOptions.setView=!1),this},_handleGeolocationError:function(error){var c=error.code,message=error.message||(1===c?"permission denied":2===c?"position unavailable":"timeout");this._locateOptions.setView&&!this._loaded&&this.fitWorld(),this.fire("locationerror",{code:c,message:"Geolocation error: "+message+"."})},_handleGeolocationResponse:function(pos){var lat=pos.coords.latitude,lng=pos.coords.longitude,latlng=new LatLng(lat,lng),bounds=latlng.toBounds(pos.coords.accuracy),options=this._locateOptions;if(options.setView){var zoom=this.getBoundsZoom(bounds);this.setView(latlng,options.maxZoom?Math.min(zoom,options.maxZoom):zoom)}var data={latlng:latlng,bounds:bounds,timestamp:pos.timestamp};for(var i in pos.coords)"number"==typeof pos.coords[i]&&(data[i]=pos.coords[i]);this.fire("locationfound",data)},addHandler:function(name,HandlerClass){if(!HandlerClass)return this;var handler=this[name]=new HandlerClass(this);return this._handlers.push(handler),this.options[name]&&handler.enable(),this},remove:function(){if(this._initEvents(!0),this._containerId!==this._container._leaflet_id)throw new Error("Map container is being reused by another instance");try{delete this._container._leaflet_id,delete this._containerId}catch(e){this._container._leaflet_id=void 0,this._containerId=void 0}void 0!==this._locationWatchId&&this.stopLocate(),this._stop(),remove(this._mapPane),this._clearControlPos&&this._clearControlPos(),this._clearHandlers(),this._loaded&&this.fire("unload");var i;for(i in this._layers)this._layers[i].remove();for(i in this._panes)remove(this._panes[i]);return this._layers=[],this._panes=[],delete this._mapPane,delete this._renderer,this},createPane:function(name,container){var className="leaflet-pane"+(name?" leaflet-"+name.replace("Pane","")+"-pane":""),pane=create$1("div",className,container||this._mapPane);return name&&(this._panes[name]=pane),pane},getCenter:function(){return this._checkIfLoaded(),this._lastCenter&&!this._moved()?this._lastCenter:this.layerPointToLatLng(this._getCenterLayerPoint())},getZoom:function(){return this._zoom},getBounds:function(){var bounds=this.getPixelBounds();return new LatLngBounds(this.unproject(bounds.getBottomLeft()),this.unproject(bounds.getTopRight()))},getMinZoom:function(){return void 0===this.options.minZoom?this._layersMinZoom||0:this.options.minZoom},getMaxZoom:function(){return void 0===this.options.maxZoom?void 0===this._layersMaxZoom?1/0:this._layersMaxZoom:this.options.maxZoom},getBoundsZoom:function(bounds,inside,padding){bounds=toLatLngBounds(bounds),padding=toPoint(padding||[0,0]);var zoom=this.getZoom()||0,min=this.getMinZoom(),max=this.getMaxZoom(),nw=bounds.getNorthWest(),se=bounds.getSouthEast(),size=this.getSize().subtract(padding),boundsSize=toBounds(this.project(se,zoom),this.project(nw,zoom)).getSize(),snap=any3d?this.options.zoomSnap:1,scalex=size.x/boundsSize.x,scaley=size.y/boundsSize.y,scale=inside?Math.max(scalex,scaley):Math.min(scalex,scaley);return zoom=this.getScaleZoom(scale,zoom),snap&&(zoom=Math.round(zoom/(snap/100))*(snap/100),zoom=inside?Math.ceil(zoom/snap)*snap:Math.floor(zoom/snap)*snap),Math.max(min,Math.min(max,zoom))},getSize:function(){return this._size&&!this._sizeChanged||(this._size=new Point(this._container.clientWidth||0,this._container.clientHeight||0),this._sizeChanged=!1),this._size.clone()},getPixelBounds:function(center,zoom){var topLeftPoint=this._getTopLeftPoint(center,zoom);return new Bounds(topLeftPoint,topLeftPoint.add(this.getSize()))},getPixelOrigin:function(){return this._checkIfLoaded(),this._pixelOrigin},getPixelWorldBounds:function(zoom){return this.options.crs.getProjectedBounds(void 0===zoom?this.getZoom():zoom)},getPane:function(pane){return"string"==typeof pane?this._panes[pane]:pane},getPanes:function(){return this._panes},getContainer:function(){return this._container},getZoomScale:function(toZoom,fromZoom){var crs=this.options.crs;return fromZoom=void 0===fromZoom?this._zoom:fromZoom,crs.scale(toZoom)/crs.scale(fromZoom)},getScaleZoom:function(scale,fromZoom){var crs=this.options.crs;fromZoom=void 0===fromZoom?this._zoom:fromZoom;var zoom=crs.zoom(scale*crs.scale(fromZoom));return isNaN(zoom)?1/0:zoom},project:function(latlng,zoom){return zoom=void 0===zoom?this._zoom:zoom,this.options.crs.latLngToPoint(toLatLng(latlng),zoom)},unproject:function(point,zoom){return zoom=void 0===zoom?this._zoom:zoom,this.options.crs.pointToLatLng(toPoint(point),zoom)},layerPointToLatLng:function(point){var projectedPoint=toPoint(point).add(this.getPixelOrigin());return this.unproject(projectedPoint)},latLngToLayerPoint:function(latlng){return this.project(toLatLng(latlng))._round()._subtract(this.getPixelOrigin())},wrapLatLng:function(latlng){return this.options.crs.wrapLatLng(toLatLng(latlng))},wrapLatLngBounds:function(latlng){return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng))},distance:function(latlng1,latlng2){return this.options.crs.distance(toLatLng(latlng1),toLatLng(latlng2))},containerPointToLayerPoint:function(point){return toPoint(point).subtract(this._getMapPanePos())},layerPointToContainerPoint:function(point){return toPoint(point).add(this._getMapPanePos())},containerPointToLatLng:function(point){var layerPoint=this.containerPointToLayerPoint(toPoint(point));return this.layerPointToLatLng(layerPoint)},latLngToContainerPoint:function(latlng){return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)))},mouseEventToContainerPoint:function(e){return getMousePosition(e,this._container)},mouseEventToLayerPoint:function(e){return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e))},mouseEventToLatLng:function(e){return this.layerPointToLatLng(this.mouseEventToLayerPoint(e))},_initContainer:function(id){var container=this._container=get(id);if(!container)throw new Error("Map container not found.");if(container._leaflet_id)throw new Error("Map container is already initialized.");on(container,"scroll",this._onScroll,this),this._containerId=stamp(container)},_initLayout:function(){var container=this._container;this._fadeAnimated=this.options.fadeAnimation&&any3d,addClass(container,"leaflet-container"+(touch?" leaflet-touch":"")+(retina?" leaflet-retina":"")+(ielt9?" leaflet-oldie":"")+(safari?" leaflet-safari":"")+(this._fadeAnimated?" leaflet-fade-anim":""));var position=getStyle(container,"position");"absolute"!==position&&"relative"!==position&&"fixed"!==position&&(container.style.position="relative"),this._initPanes(),this._initControlPos&&this._initControlPos()},_initPanes:function(){var panes=this._panes={};this._paneRenderers={},this._mapPane=this.createPane("mapPane",this._container),setPosition(this._mapPane,new Point(0,0)),this.createPane("tilePane"),this.createPane("shadowPane"),this.createPane("overlayPane"),this.createPane("markerPane"),this.createPane("tooltipPane"),this.createPane("popupPane"),this.options.markerZoomAnimation||(addClass(panes.markerPane,"leaflet-zoom-hide"),addClass(panes.shadowPane,"leaflet-zoom-hide"))},_resetView:function(center,zoom){setPosition(this._mapPane,new Point(0,0));var loading=!this._loaded;this._loaded=!0,zoom=this._limitZoom(zoom),this.fire("viewprereset");var zoomChanged=this._zoom!==zoom;this._moveStart(zoomChanged,!1)._move(center,zoom)._moveEnd(zoomChanged),this.fire("viewreset"),loading&&this.fire("load")},_moveStart:function(zoomChanged,noMoveStart){return zoomChanged&&this.fire("zoomstart"),noMoveStart||this.fire("movestart"),this},_move:function(center,zoom,data){void 0===zoom&&(zoom=this._zoom);var zoomChanged=this._zoom!==zoom;return this._zoom=zoom,this._lastCenter=center,this._pixelOrigin=this._getNewPixelOrigin(center),(zoomChanged||data&&data.pinch)&&this.fire("zoom",data),this.fire("move",data)},_moveEnd:function(zoomChanged){return zoomChanged&&this.fire("zoomend"),this.fire("moveend")},_stop:function(){return cancelAnimFrame(this._flyToFrame),this._panAnim&&this._panAnim.stop(),this},_rawPanBy:function(offset){setPosition(this._mapPane,this._getMapPanePos().subtract(offset))},_getZoomSpan:function(){return this.getMaxZoom()-this.getMinZoom()},_panInsideMaxBounds:function(){this._enforcingBounds||this.panInsideBounds(this.options.maxBounds)},_checkIfLoaded:function(){if(!this._loaded)throw new Error("Set map center and zoom first.")},_initEvents:function(remove$$1){this._targets={},this._targets[stamp(this._container)]=this;var onOff=remove$$1?off:on;onOff(this._container,"click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress",this._handleDOMEvent,this),this.options.trackResize&&onOff(window,"resize",this._onResize,this),any3d&&this.options.transform3DLimit&&(remove$$1?this.off:this.on).call(this,"moveend",this._onMoveEnd)},_onResize:function(){cancelAnimFrame(this._resizeRequest),this._resizeRequest=requestAnimFrame(function(){this.invalidateSize({debounceMoveend:!0})},this)},_onScroll:function(){this._container.scrollTop=0,this._container.scrollLeft=0},_onMoveEnd:function(){var pos=this._getMapPanePos();Math.max(Math.abs(pos.x),Math.abs(pos.y))>=this.options.transform3DLimit&&this._resetView(this.getCenter(),this.getZoom())},_findEventTargets:function(e,type){for(var target,targets=[],isHover="mouseout"===type||"mouseover"===type,src=e.target||e.srcElement,dragging=!1;src;){if((target=this._targets[stamp(src)])&&("click"===type||"preclick"===type)&&!e._simulated&&this._draggableMoved(target)){dragging=!0;break}if(target&&target.listens(type,!0)){if(isHover&&!isExternalTarget(src,e))break;if(targets.push(target),isHover)break}if(src===this._container)break;src=src.parentNode}return targets.length||dragging||isHover||!isExternalTarget(src,e)||(targets=[this]),targets},_handleDOMEvent:function(e){if(this._loaded&&!skipped(e)){var type=e.type;"mousedown"!==type&&"keypress"!==type||preventOutline(e.target||e.srcElement),this._fireDOMEvent(e,type)}},_mouseEvents:["click","dblclick","mouseover","mouseout","contextmenu"],_fireDOMEvent:function(e,type,targets){if("click"===e.type){var synth=extend({},e);synth.type="preclick",this._fireDOMEvent(synth,synth.type,targets)}if(!e._stopped&&(targets=(targets||[]).concat(this._findEventTargets(e,type)),targets.length)){var target=targets[0];"contextmenu"===type&&target.listens(type,!0)&&preventDefault(e);var data={originalEvent:e};if("keypress"!==e.type){var isMarker=target.getLatLng&&(!target._radius||target._radius<=10);data.containerPoint=isMarker?this.latLngToContainerPoint(target.getLatLng()):this.mouseEventToContainerPoint(e),data.layerPoint=this.containerPointToLayerPoint(data.containerPoint),data.latlng=isMarker?target.getLatLng():this.layerPointToLatLng(data.layerPoint)}for(var i=0;i<targets.length;i++)if(targets[i].fire(type,data,!0),data.originalEvent._stopped||!1===targets[i].options.bubblingMouseEvents&&-1!==indexOf(this._mouseEvents,type))return}},_draggableMoved:function(obj){return obj=obj.dragging&&obj.dragging.enabled()?obj:this,obj.dragging&&obj.dragging.moved()||this.boxZoom&&this.boxZoom.moved()},_clearHandlers:function(){for(var i=0,len=this._handlers.length;i<len;i++)this._handlers[i].disable()},whenReady:function(callback,context){return this._loaded?callback.call(context||this,{target:this}):this.on("load",callback,context),this},_getMapPanePos:function(){return getPosition(this._mapPane)||new Point(0,0)},_moved:function(){var pos=this._getMapPanePos();return pos&&!pos.equals([0,0])},_getTopLeftPoint:function(center,zoom){return(center&&void 0!==zoom?this._getNewPixelOrigin(center,zoom):this.getPixelOrigin()).subtract(this._getMapPanePos())},_getNewPixelOrigin:function(center,zoom){var viewHalf=this.getSize()._divideBy(2);return this.project(center,zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round()},_latLngToNewLayerPoint:function(latlng,zoom,center){var topLeft=this._getNewPixelOrigin(center,zoom);return this.project(latlng,zoom)._subtract(topLeft)},_latLngBoundsToNewLayerBounds:function(latLngBounds,zoom,center){var topLeft=this._getNewPixelOrigin(center,zoom);return toBounds([this.project(latLngBounds.getSouthWest(),zoom)._subtract(topLeft),this.project(latLngBounds.getNorthWest(),zoom)._subtract(topLeft),this.project(latLngBounds.getSouthEast(),zoom)._subtract(topLeft),this.project(latLngBounds.getNorthEast(),zoom)._subtract(topLeft)])},_getCenterLayerPoint:function(){return this.containerPointToLayerPoint(this.getSize()._divideBy(2))},_getCenterOffset:function(latlng){return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint())},_limitCenter:function(center,zoom,bounds){if(!bounds)return center;var centerPoint=this.project(center,zoom),viewHalf=this.getSize().divideBy(2),viewBounds=new Bounds(centerPoint.subtract(viewHalf),centerPoint.add(viewHalf)),offset=this._getBoundsOffset(viewBounds,bounds,zoom);return offset.round().equals([0,0])?center:this.unproject(centerPoint.add(offset),zoom)},_limitOffset:function(offset,bounds){if(!bounds)return offset;var viewBounds=this.getPixelBounds(),newBounds=new Bounds(viewBounds.min.add(offset),viewBounds.max.add(offset));return offset.add(this._getBoundsOffset(newBounds,bounds))},_getBoundsOffset:function(pxBounds,maxBounds,zoom){var projectedMaxBounds=toBounds(this.project(maxBounds.getNorthEast(),zoom),this.project(maxBounds.getSouthWest(),zoom)),minOffset=projectedMaxBounds.min.subtract(pxBounds.min),maxOffset=projectedMaxBounds.max.subtract(pxBounds.max);return new Point(this._rebound(minOffset.x,-maxOffset.x),this._rebound(minOffset.y,-maxOffset.y))},_rebound:function(left,right){return left+right>0?Math.round(left-right)/2:Math.max(0,Math.ceil(left))-Math.max(0,Math.floor(right))},_limitZoom:function(zoom){var min=this.getMinZoom(),max=this.getMaxZoom(),snap=any3d?this.options.zoomSnap:1;return snap&&(zoom=Math.round(zoom/snap)*snap),Math.max(min,Math.min(max,zoom))},_onPanTransitionStep:function(){this.fire("move")},_onPanTransitionEnd:function(){removeClass(this._mapPane,"leaflet-pan-anim"),this.fire("moveend")},_tryAnimatedPan:function(center,options){var offset=this._getCenterOffset(center)._trunc();return!(!0!==(options&&options.animate)&&!this.getSize().contains(offset))&&(this.panBy(offset,options),!0)},_createAnimProxy:function(){var proxy=this._proxy=create$1("div","leaflet-proxy leaflet-zoom-animated");this._panes.mapPane.appendChild(proxy),this.on("zoomanim",function(e){var prop=TRANSFORM,transform=this._proxy.style[prop];setTransform(this._proxy,this.project(e.center,e.zoom),this.getZoomScale(e.zoom,1)),transform===this._proxy.style[prop]&&this._animatingZoom&&this._onZoomTransitionEnd()},this),this.on("load moveend",function(){var c=this.getCenter(),z=this.getZoom();setTransform(this._proxy,this.project(c,z),this.getZoomScale(z,1))},this),this._on("unload",this._destroyAnimProxy,this)},_destroyAnimProxy:function(){remove(this._proxy),delete this._proxy},_catchTransitionEnd:function(e){this._animatingZoom&&e.propertyName.indexOf("transform")>=0&&this._onZoomTransitionEnd()},_nothingToAnimate:function(){return!this._container.getElementsByClassName("leaflet-zoom-animated").length},_tryAnimatedZoom:function(center,zoom,options){if(this._animatingZoom)return!0;if(options=options||{},!this._zoomAnimated||!1===options.animate||this._nothingToAnimate()||Math.abs(zoom-this._zoom)>this.options.zoomAnimationThreshold)return!1;var scale=this.getZoomScale(zoom),offset=this._getCenterOffset(center)._divideBy(1-1/scale);return!(!0!==options.animate&&!this.getSize().contains(offset))&&(requestAnimFrame(function(){this._moveStart(!0,!1)._animateZoom(center,zoom,!0)},this),!0)},_animateZoom:function(center,zoom,startAnim,noUpdate){this._mapPane&&(startAnim&&(this._animatingZoom=!0,this._animateToCenter=center,this._animateToZoom=zoom,addClass(this._mapPane,"leaflet-zoom-anim")),this.fire("zoomanim",{center:center,zoom:zoom,noUpdate:noUpdate}),setTimeout(bind(this._onZoomTransitionEnd,this),250))},_onZoomTransitionEnd:function(){this._animatingZoom&&(this._mapPane&&removeClass(this._mapPane,"leaflet-zoom-anim"),this._animatingZoom=!1,this._move(this._animateToCenter,this._animateToZoom),requestAnimFrame(function(){this._moveEnd(!0)},this))}}),Control=Class.extend({options:{position:"topright"},initialize:function(options){setOptions(this,options)},getPosition:function(){return this.options.position},setPosition:function(position){var map=this._map;return map&&map.removeControl(this),this.options.position=position,map&&map.addControl(this),this},getContainer:function(){return this._container},addTo:function(map){this.remove(),this._map=map;var container=this._container=this.onAdd(map),pos=this.getPosition(),corner=map._controlCorners[pos];return addClass(container,"leaflet-control"),-1!==pos.indexOf("bottom")?corner.insertBefore(container,corner.firstChild):corner.appendChild(container),this},remove:function(){return this._map?(remove(this._container),this.onRemove&&this.onRemove(this._map),this._map=null,this):this},_refocusOnMap:function(e){this._map&&e&&e.screenX>0&&e.screenY>0&&this._map.getContainer().focus()}}),control=function(options){return new Control(options)};Map.include({addControl:function(control){return control.addTo(this),this},removeControl:function(control){return control.remove(),this},_initControlPos:function(){function createCorner(vSide,hSide){var className=l+vSide+" "+l+hSide;corners[vSide+hSide]=create$1("div",className,container)}var corners=this._controlCorners={},l="leaflet-",container=this._controlContainer=create$1("div",l+"control-container",this._container);createCorner("top","left"),createCorner("top","right"),createCorner("bottom","left"),createCorner("bottom","right")},_clearControlPos:function(){for(var i in this._controlCorners)remove(this._controlCorners[i]);remove(this._controlContainer),delete this._controlCorners,delete this._controlContainer}});var Layers=Control.extend({options:{collapsed:!0,position:"topright",autoZIndex:!0,hideSingleBase:!1,sortLayers:!1,sortFunction:function(layerA,layerB,nameA,nameB){return nameA<nameB?-1:nameB<nameA?1:0}},initialize:function(baseLayers,overlays,options){setOptions(this,options),this._layerControlInputs=[],this._layers=[],this._lastZIndex=0,this._handlingClick=!1;for(var i in baseLayers)this._addLayer(baseLayers[i],i);for(i in overlays)this._addLayer(overlays[i],i,!0)},onAdd:function(map){this._initLayout(),this._update(),this._map=map,map.on("zoomend",this._checkDisabledLayers,this);for(var i=0;i<this._layers.length;i++)this._layers[i].layer.on("add remove",this._onLayerChange,this);return this._container},addTo:function(map){return Control.prototype.addTo.call(this,map),this._expandIfNotCollapsed()},onRemove:function(){this._map.off("zoomend",this._checkDisabledLayers,this);for(var i=0;i<this._layers.length;i++)this._layers[i].layer.off("add remove",this._onLayerChange,this)},addBaseLayer:function(layer,name){return this._addLayer(layer,name),this._map?this._update():this},addOverlay:function(layer,name){return this._addLayer(layer,name,!0),this._map?this._update():this},removeLayer:function(layer){layer.off("add remove",this._onLayerChange,this);var obj=this._getLayer(stamp(layer));return obj&&this._layers.splice(this._layers.indexOf(obj),1),this._map?this._update():this},expand:function(){addClass(this._container,"leaflet-control-layers-expanded"),this._form.style.height=null;var acceptableHeight=this._map.getSize().y-(this._container.offsetTop+50);return acceptableHeight<this._form.clientHeight?(addClass(this._form,"leaflet-control-layers-scrollbar"),this._form.style.height=acceptableHeight+"px"):removeClass(this._form,"leaflet-control-layers-scrollbar"),this._checkDisabledLayers(),this},collapse:function(){return removeClass(this._container,"leaflet-control-layers-expanded"),this},_initLayout:function(){var className="leaflet-control-layers",container=this._container=create$1("div",className),collapsed=this.options.collapsed;container.setAttribute("aria-haspopup",!0),disableClickPropagation(container),disableScrollPropagation(container);var form=this._form=create$1("form",className+"-list");collapsed&&(this._map.on("click",this.collapse,this),android||on(container,{mouseenter:this.expand,mouseleave:this.collapse},this));var link=this._layersLink=create$1("a",className+"-toggle",container);link.href="#",link.title="Layers",touch?(on(link,"click",stop),on(link,"click",this.expand,this)):on(link,"focus",this.expand,this),collapsed||this.expand(),this._baseLayersList=create$1("div",className+"-base",form),this._separator=create$1("div",className+"-separator",form),this._overlaysList=create$1("div",className+"-overlays",form),container.appendChild(form)},_getLayer:function(id){for(var i=0;i<this._layers.length;i++)if(this._layers[i]&&stamp(this._layers[i].layer)===id)return this._layers[i]},_addLayer:function(layer,name,overlay){this._map&&layer.on("add remove",this._onLayerChange,this),this._layers.push({layer:layer,name:name,overlay:overlay}),this.options.sortLayers&&this._layers.sort(bind(function(a,b){return this.options.sortFunction(a.layer,b.layer,a.name,b.name)},this)),this.options.autoZIndex&&layer.setZIndex&&(this._lastZIndex++,layer.setZIndex(this._lastZIndex)),this._expandIfNotCollapsed()},_update:function(){if(!this._container)return this;empty(this._baseLayersList),empty(this._overlaysList),this._layerControlInputs=[];var baseLayersPresent,overlaysPresent,i,obj,baseLayersCount=0;for(i=0;i<this._layers.length;i++)obj=this._layers[i],this._addItem(obj),overlaysPresent=overlaysPresent||obj.overlay,baseLayersPresent=baseLayersPresent||!obj.overlay,baseLayersCount+=obj.overlay?0:1;return this.options.hideSingleBase&&(baseLayersPresent=baseLayersPresent&&baseLayersCount>1,this._baseLayersList.style.display=baseLayersPresent?"":"none"),this._separator.style.display=overlaysPresent&&baseLayersPresent?"":"none",this},_onLayerChange:function(e){this._handlingClick||this._update();var obj=this._getLayer(stamp(e.target)),type=obj.overlay?"add"===e.type?"overlayadd":"overlayremove":"add"===e.type?"baselayerchange":null;type&&this._map.fire(type,obj)},_createRadioElement:function(name,checked){var radioHtml='<input type="radio" class="leaflet-control-layers-selector" name="'+name+'"'+(checked?' checked="checked"':"")+"/>",radioFragment=document.createElement("div");return radioFragment.innerHTML=radioHtml,radioFragment.firstChild},_addItem:function(obj){var input,label=document.createElement("label"),checked=this._map.hasLayer(obj.layer);obj.overlay?(input=document.createElement("input"),input.type="checkbox",input.className="leaflet-control-layers-selector",input.defaultChecked=checked):input=this._createRadioElement("leaflet-base-layers",checked),this._layerControlInputs.push(input),input.layerId=stamp(obj.layer),on(input,"click",this._onInputClick,this);var name=document.createElement("span");name.innerHTML=" "+obj.name;var holder=document.createElement("div");return label.appendChild(holder),holder.appendChild(input),holder.appendChild(name),(obj.overlay?this._overlaysList:this._baseLayersList).appendChild(label),this._checkDisabledLayers(),label},_onInputClick:function(){var input,layer,inputs=this._layerControlInputs,addedLayers=[],removedLayers=[];this._handlingClick=!0;for(var i=inputs.length-1;i>=0;i--)input=inputs[i],layer=this._getLayer(input.layerId).layer,input.checked?addedLayers.push(layer):input.checked||removedLayers.push(layer);for(i=0;i<removedLayers.length;i++)this._map.hasLayer(removedLayers[i])&&this._map.removeLayer(removedLayers[i]);for(i=0;i<addedLayers.length;i++)this._map.hasLayer(addedLayers[i])||this._map.addLayer(addedLayers[i]);this._handlingClick=!1,this._refocusOnMap()},_checkDisabledLayers:function(){for(var input,layer,inputs=this._layerControlInputs,zoom=this._map.getZoom(),i=inputs.length-1;i>=0;i--)input=inputs[i],layer=this._getLayer(input.layerId).layer,input.disabled=void 0!==layer.options.minZoom&&zoom<layer.options.minZoom||void 0!==layer.options.maxZoom&&zoom>layer.options.maxZoom},_expandIfNotCollapsed:function(){return this._map&&!this.options.collapsed&&this.expand(),this},_expand:function(){return this.expand()},_collapse:function(){return this.collapse()}}),layers=function(baseLayers,overlays,options){return new Layers(baseLayers,overlays,options)},Zoom=Control.extend({options:{position:"topleft",zoomInText:"+",zoomInTitle:"Zoom in",zoomOutText:"&#x2212;",zoomOutTitle:"Zoom out"},onAdd:function(map){var zoomName="leaflet-control-zoom",container=create$1("div",zoomName+" leaflet-bar"),options=this.options;return this._zoomInButton=this._createButton(options.zoomInText,options.zoomInTitle,zoomName+"-in",container,this._zoomIn),this._zoomOutButton=this._createButton(options.zoomOutText,options.zoomOutTitle,zoomName+"-out",container,this._zoomOut),this._updateDisabled(),map.on("zoomend zoomlevelschange",this._updateDisabled,this),container},onRemove:function(map){map.off("zoomend zoomlevelschange",this._updateDisabled,this)},disable:function(){return this._disabled=!0,this._updateDisabled(),this},enable:function(){return this._disabled=!1,this._updateDisabled(),this},_zoomIn:function(e){!this._disabled&&this._map._zoom<this._map.getMaxZoom()&&this._map.zoomIn(this._map.options.zoomDelta*(e.shiftKey?3:1))},_zoomOut:function(e){!this._disabled&&this._map._zoom>this._map.getMinZoom()&&this._map.zoomOut(this._map.options.zoomDelta*(e.shiftKey?3:1))},_createButton:function(html,title,className,container,fn){var link=create$1("a",className,container);return link.innerHTML=html,link.href="#",link.title=title,link.setAttribute("role","button"),link.setAttribute("aria-label",title),disableClickPropagation(link),on(link,"click",stop),on(link,"click",fn,this),on(link,"click",this._refocusOnMap,this),link},_updateDisabled:function(){var map=this._map,className="leaflet-disabled";removeClass(this._zoomInButton,className),removeClass(this._zoomOutButton,className),(this._disabled||map._zoom===map.getMinZoom())&&addClass(this._zoomOutButton,className),(this._disabled||map._zoom===map.getMaxZoom())&&addClass(this._zoomInButton,className)}});Map.mergeOptions({zoomControl:!0}),Map.addInitHook(function(){this.options.zoomControl&&(this.zoomControl=new Zoom,this.addControl(this.zoomControl))});var zoom=function(options){return new Zoom(options)},Scale=Control.extend({options:{position:"bottomleft",maxWidth:100,metric:!0,imperial:!0},onAdd:function(map){var container=create$1("div","leaflet-control-scale"),options=this.options;return this._addScales(options,"leaflet-control-scale-line",container),map.on(options.updateWhenIdle?"moveend":"move",this._update,this),map.whenReady(this._update,this),container},onRemove:function(map){map.off(this.options.updateWhenIdle?"moveend":"move",this._update,this)},_addScales:function(options,className,container){options.metric&&(this._mScale=create$1("div",className,container)),options.imperial&&(this._iScale=create$1("div",className,container))},_update:function(){var map=this._map,y=map.getSize().y/2,maxMeters=map.distance(map.containerPointToLatLng([0,y]),map.containerPointToLatLng([this.options.maxWidth,y]));this._updateScales(maxMeters)},_updateScales:function(maxMeters){this.options.metric&&maxMeters&&this._updateMetric(maxMeters),this.options.imperial&&maxMeters&&this._updateImperial(maxMeters)},_updateMetric:function(maxMeters){var meters=this._getRoundNum(maxMeters),label=meters<1e3?meters+" m":meters/1e3+" km";this._updateScale(this._mScale,label,meters/maxMeters)},_updateImperial:function(maxMeters){var maxMiles,miles,feet,maxFeet=3.2808399*maxMeters;maxFeet>5280?(maxMiles=maxFeet/5280,miles=this._getRoundNum(maxMiles),this._updateScale(this._iScale,miles+" mi",miles/maxMiles)):(feet=this._getRoundNum(maxFeet),this._updateScale(this._iScale,feet+" ft",feet/maxFeet))},_updateScale:function(scale,text,ratio){scale.style.width=Math.round(this.options.maxWidth*ratio)+"px",scale.innerHTML=text},_getRoundNum:function(num){var pow10=Math.pow(10,(Math.floor(num)+"").length-1),d=num/pow10;return d=d>=10?10:d>=5?5:d>=3?3:d>=2?2:1,pow10*d}}),scale=function(options){return new Scale(options)},Attribution=Control.extend({options:{position:"bottomright",prefix:'<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'},initialize:function(options){setOptions(this,options),this._attributions={}},onAdd:function(map){map.attributionControl=this,this._container=create$1("div","leaflet-control-attribution"),disableClickPropagation(this._container);for(var i in map._layers)map._layers[i].getAttribution&&this.addAttribution(map._layers[i].getAttribution());return this._update(),this._container},setPrefix:function(prefix){return this.options.prefix=prefix,this._update(),this},addAttribution:function(text){return text?(this._attributions[text]||(this._attributions[text]=0),this._attributions[text]++,this._update(),this):this},removeAttribution:function(text){return text?(this._attributions[text]&&(this._attributions[text]--,this._update()),this):this},_update:function(){if(this._map){var attribs=[];for(var i in this._attributions)this._attributions[i]&&attribs.push(i);var prefixAndAttribs=[];this.options.prefix&&prefixAndAttribs.push(this.options.prefix),attribs.length&&prefixAndAttribs.push(attribs.join(", ")),this._container.innerHTML=prefixAndAttribs.join(" | ")}}});Map.mergeOptions({attributionControl:!0}),Map.addInitHook(function(){this.options.attributionControl&&(new Attribution).addTo(this)});var attribution=function(options){return new Attribution(options)};Control.Layers=Layers,Control.Zoom=Zoom,Control.Scale=Scale,Control.Attribution=Attribution,control.layers=layers,control.zoom=zoom,control.scale=scale,control.attribution=attribution;var Handler=Class.extend({initialize:function(map){this._map=map},enable:function(){return this._enabled?this:(this._enabled=!0,this.addHooks(),this)},disable:function(){return this._enabled?(this._enabled=!1,this.removeHooks(),this):this},enabled:function(){return!!this._enabled}});Handler.addTo=function(map,name){return map.addHandler(name,this),this};var _lastCode,Mixin={Events:Events},START=touch?"touchstart mousedown":"mousedown",END={mousedown:"mouseup",touchstart:"touchend",pointerdown:"touchend",MSPointerDown:"touchend"},MOVE={mousedown:"mousemove",touchstart:"touchmove",pointerdown:"touchmove",MSPointerDown:"touchmove"},Draggable=Evented.extend({options:{clickTolerance:3},initialize:function(element,dragStartTarget,preventOutline$$1,options){setOptions(this,options),this._element=element,this._dragStartTarget=dragStartTarget||element,this._preventOutline=preventOutline$$1},enable:function(){this._enabled||(on(this._dragStartTarget,START,this._onDown,this),this._enabled=!0)},disable:function(){this._enabled&&(Draggable._dragging===this&&this.finishDrag(),off(this._dragStartTarget,START,this._onDown,this),this._enabled=!1,this._moved=!1)},_onDown:function(e){if(!e._simulated&&this._enabled&&(this._moved=!1,!hasClass(this._element,"leaflet-zoom-anim")&&!(Draggable._dragging||e.shiftKey||1!==e.which&&1!==e.button&&!e.touches||(Draggable._dragging=this,this._preventOutline&&preventOutline(this._element),disableImageDrag(),disableTextSelection(),this._moving)))){this.fire("down");var first=e.touches?e.touches[0]:e;this._startPoint=new Point(first.clientX,first.clientY),on(document,MOVE[e.type],this._onMove,this),on(document,END[e.type],this._onUp,this)}},_onMove:function(e){if(!e._simulated&&this._enabled){if(e.touches&&e.touches.length>1)return void(this._moved=!0);var first=e.touches&&1===e.touches.length?e.touches[0]:e,newPoint=new Point(first.clientX,first.clientY),offset=newPoint.subtract(this._startPoint);(offset.x||offset.y)&&(Math.abs(offset.x)+Math.abs(offset.y)<this.options.clickTolerance||(preventDefault(e),this._moved||(this.fire("dragstart"),this._moved=!0,this._startPos=getPosition(this._element).subtract(offset),addClass(document.body,"leaflet-dragging"),this._lastTarget=e.target||e.srcElement,window.SVGElementInstance&&this._lastTarget instanceof SVGElementInstance&&(this._lastTarget=this._lastTarget.correspondingUseElement),addClass(this._lastTarget,"leaflet-drag-target")),this._newPos=this._startPos.add(offset),this._moving=!0,cancelAnimFrame(this._animRequest),this._lastEvent=e,this._animRequest=requestAnimFrame(this._updatePosition,this,!0)))}},_updatePosition:function(){var e={originalEvent:this._lastEvent};this.fire("predrag",e),setPosition(this._element,this._newPos),this.fire("drag",e)},_onUp:function(e){!e._simulated&&this._enabled&&this.finishDrag()},finishDrag:function(){removeClass(document.body,"leaflet-dragging"),this._lastTarget&&(removeClass(this._lastTarget,"leaflet-drag-target"),this._lastTarget=null);for(var i in MOVE)off(document,MOVE[i],this._onMove,this),off(document,END[i],this._onUp,this);enableImageDrag(),enableTextSelection(),this._moved&&this._moving&&(cancelAnimFrame(this._animRequest),this.fire("dragend",{distance:this._newPos.distanceTo(this._startPos)})),this._moving=!1,Draggable._dragging=!1}}),LineUtil=(Object.freeze||Object)({simplify:simplify,pointToSegmentDistance:pointToSegmentDistance,closestPointOnSegment:closestPointOnSegment,clipSegment:clipSegment,_getEdgeIntersection:_getEdgeIntersection,_getBitCode:_getBitCode,_sqClosestPointOnSegment:_sqClosestPointOnSegment,isFlat:isFlat,_flat:_flat}),PolyUtil=(Object.freeze||Object)({clipPolygon:clipPolygon}),LonLat={project:function(latlng){return new Point(latlng.lng,latlng.lat)},unproject:function(point){return new LatLng(point.y,point.x)},bounds:new Bounds([-180,-90],[180,90])},Mercator={R:6378137,R_MINOR:6356752.314245179,bounds:new Bounds([-20037508.34279,-15496570.73972],[20037508.34279,18764656.23138]),project:function(latlng){var d=Math.PI/180,r=this.R,y=latlng.lat*d,tmp=this.R_MINOR/r,e=Math.sqrt(1-tmp*tmp),con=e*Math.sin(y),ts=Math.tan(Math.PI/4-y/2)/Math.pow((1-con)/(1+con),e/2);return y=-r*Math.log(Math.max(ts,1e-10)),new Point(latlng.lng*d*r,y)},unproject:function(point){for(var con,d=180/Math.PI,r=this.R,tmp=this.R_MINOR/r,e=Math.sqrt(1-tmp*tmp),ts=Math.exp(-point.y/r),phi=Math.PI/2-2*Math.atan(ts),i=0,dphi=.1;i<15&&Math.abs(dphi)>1e-7;i++)con=e*Math.sin(phi),con=Math.pow((1-con)/(1+con),e/2),dphi=Math.PI/2-2*Math.atan(ts*con)-phi,phi+=dphi;return new LatLng(phi*d,point.x*d/r)}},index=(Object.freeze||Object)({LonLat:LonLat,Mercator:Mercator,SphericalMercator:SphericalMercator}),EPSG3395=extend({},Earth,{code:"EPSG:3395",projection:Mercator,transformation:function(){var scale=.5/(Math.PI*Mercator.R);return toTransformation(scale,.5,-scale,.5)}()}),EPSG4326=extend({},Earth,{code:"EPSG:4326",projection:LonLat,transformation:toTransformation(1/180,1,-1/180,.5)}),Simple=extend({},CRS,{projection:LonLat,transformation:toTransformation(1,0,-1,0),scale:function(zoom){return Math.pow(2,zoom)},zoom:function(scale){return Math.log(scale)/Math.LN2},distance:function(latlng1,latlng2){var dx=latlng2.lng-latlng1.lng,dy=latlng2.lat-latlng1.lat;return Math.sqrt(dx*dx+dy*dy)},infinite:!0});CRS.Earth=Earth,CRS.EPSG3395=EPSG3395,CRS.EPSG3857=EPSG3857,CRS.EPSG900913=EPSG900913,CRS.EPSG4326=EPSG4326,CRS.Simple=Simple;var Layer=Evented.extend({options:{pane:"overlayPane",attribution:null,bubblingMouseEvents:!0},addTo:function(map){return map.addLayer(this),this},remove:function(){return this.removeFrom(this._map||this._mapToAdd)},removeFrom:function(obj){return obj&&obj.removeLayer(this),this},getPane:function(name){return this._map.getPane(name?this.options[name]||name:this.options.pane)},addInteractiveTarget:function(targetEl){return this._map._targets[stamp(targetEl)]=this,this},removeInteractiveTarget:function(targetEl){return delete this._map._targets[stamp(targetEl)],this},getAttribution:function(){return this.options.attribution},_layerAdd:function(e){var map=e.target;if(map.hasLayer(this)){if(this._map=map,this._zoomAnimated=map._zoomAnimated,this.getEvents){var events=this.getEvents();map.on(events,this),this.once("remove",function(){map.off(events,this)},this)}this.onAdd(map),this.getAttribution&&map.attributionControl&&map.attributionControl.addAttribution(this.getAttribution()),this.fire("add"),map.fire("layeradd",{layer:this})}}});Map.include({addLayer:function(layer){if(!layer._layerAdd)throw new Error("The provided object is not a Layer.");var id=stamp(layer);return this._layers[id]?this:(this._layers[id]=layer,layer._mapToAdd=this,layer.beforeAdd&&layer.beforeAdd(this),this.whenReady(layer._layerAdd,layer),this)},removeLayer:function(layer){var id=stamp(layer);return this._layers[id]?(this._loaded&&layer.onRemove(this),layer.getAttribution&&this.attributionControl&&this.attributionControl.removeAttribution(layer.getAttribution()),delete this._layers[id],this._loaded&&(this.fire("layerremove",{layer:layer}),layer.fire("remove")),layer._map=layer._mapToAdd=null,this):this},hasLayer:function(layer){return!!layer&&stamp(layer)in this._layers},eachLayer:function(method,context){for(var i in this._layers)method.call(context,this._layers[i]);return this},_addLayers:function(layers){layers=layers?isArray(layers)?layers:[layers]:[];for(var i=0,len=layers.length;i<len;i++)this.addLayer(layers[i])},_addZoomLimit:function(layer){!isNaN(layer.options.maxZoom)&&isNaN(layer.options.minZoom)||(this._zoomBoundLayers[stamp(layer)]=layer,this._updateZoomLevels())},_removeZoomLimit:function(layer){var id=stamp(layer);this._zoomBoundLayers[id]&&(delete this._zoomBoundLayers[id],this._updateZoomLevels())},_updateZoomLevels:function(){var minZoom=1/0,maxZoom=-1/0,oldZoomSpan=this._getZoomSpan();for(var i in this._zoomBoundLayers){var options=this._zoomBoundLayers[i].options;minZoom=void 0===options.minZoom?minZoom:Math.min(minZoom,options.minZoom),maxZoom=void 0===options.maxZoom?maxZoom:Math.max(maxZoom,options.maxZoom)}this._layersMaxZoom=maxZoom===-1/0?void 0:maxZoom,this._layersMinZoom=minZoom===1/0?void 0:minZoom,oldZoomSpan!==this._getZoomSpan()&&this.fire("zoomlevelschange"),void 0===this.options.maxZoom&&this._layersMaxZoom&&this.getZoom()>this._layersMaxZoom&&this.setZoom(this._layersMaxZoom),void 0===this.options.minZoom&&this._layersMinZoom&&this.getZoom()<this._layersMinZoom&&this.setZoom(this._layersMinZoom)}});var LayerGroup=Layer.extend({initialize:function(layers,options){setOptions(this,options),this._layers={};var i,len;if(layers)for(i=0,len=layers.length;i<len;i++)this.addLayer(layers[i])},addLayer:function(layer){var id=this.getLayerId(layer);return this._layers[id]=layer,this._map&&this._map.addLayer(layer),this},removeLayer:function(layer){var id=layer in this._layers?layer:this.getLayerId(layer);return this._map&&this._layers[id]&&this._map.removeLayer(this._layers[id]),delete this._layers[id],this},hasLayer:function(layer){return!!layer&&(layer in this._layers||this.getLayerId(layer)in this._layers)},clearLayers:function(){return this.eachLayer(this.removeLayer,this)},invoke:function(methodName){var i,layer,args=Array.prototype.slice.call(arguments,1);for(i in this._layers)layer=this._layers[i],layer[methodName]&&layer[methodName].apply(layer,args);return this},onAdd:function(map){this.eachLayer(map.addLayer,map)},onRemove:function(map){this.eachLayer(map.removeLayer,map)},eachLayer:function(method,context){for(var i in this._layers)method.call(context,this._layers[i]);return this},getLayer:function(id){return this._layers[id]},getLayers:function(){var layers=[];return this.eachLayer(layers.push,layers),layers},setZIndex:function(zIndex){return this.invoke("setZIndex",zIndex)},getLayerId:function(layer){return stamp(layer)}}),layerGroup=function(layers,options){return new LayerGroup(layers,options)},FeatureGroup=LayerGroup.extend({addLayer:function(layer){return this.hasLayer(layer)?this:(layer.addEventParent(this),LayerGroup.prototype.addLayer.call(this,layer),this.fire("layeradd",{layer:layer}))},removeLayer:function(layer){return this.hasLayer(layer)?(layer in this._layers&&(layer=this._layers[layer]),layer.removeEventParent(this),LayerGroup.prototype.removeLayer.call(this,layer),this.fire("layerremove",{layer:layer})):this},setStyle:function(style){return this.invoke("setStyle",style)},bringToFront:function(){return this.invoke("bringToFront")},bringToBack:function(){return this.invoke("bringToBack")},getBounds:function(){var bounds=new LatLngBounds;for(var id in this._layers){var layer=this._layers[id];bounds.extend(layer.getBounds?layer.getBounds():layer.getLatLng())}return bounds}}),featureGroup=function(layers){return new FeatureGroup(layers)},Icon=Class.extend({options:{popupAnchor:[0,0],tooltipAnchor:[0,0]},initialize:function(options){setOptions(this,options)},createIcon:function(oldIcon){return this._createIcon("icon",oldIcon)},createShadow:function(oldIcon){return this._createIcon("shadow",oldIcon)},_createIcon:function(name,oldIcon){var src=this._getIconUrl(name);if(!src){if("icon"===name)throw new Error("iconUrl not set in Icon options (see the docs).");return null}var img=this._createImg(src,oldIcon&&"IMG"===oldIcon.tagName?oldIcon:null);return this._setIconStyles(img,name),img},_setIconStyles:function(img,name){var options=this.options,sizeOption=options[name+"Size"];"number"==typeof sizeOption&&(sizeOption=[sizeOption,sizeOption]);var size=toPoint(sizeOption),anchor=toPoint("shadow"===name&&options.shadowAnchor||options.iconAnchor||size&&size.divideBy(2,!0));img.className="leaflet-marker-"+name+" "+(options.className||""),anchor&&(img.style.marginLeft=-anchor.x+"px",img.style.marginTop=-anchor.y+"px"),size&&(img.style.width=size.x+"px",img.style.height=size.y+"px")},_createImg:function(src,el){return el=el||document.createElement("img"),el.src=src,el},_getIconUrl:function(name){return retina&&this.options[name+"RetinaUrl"]||this.options[name+"Url"]}}),IconDefault=Icon.extend({options:{iconUrl:"marker-icon.png",iconRetinaUrl:"marker-icon-2x.png",shadowUrl:"marker-shadow.png",iconSize:[25,41],iconAnchor:[12,41],popupAnchor:[1,-34],tooltipAnchor:[16,-28],shadowSize:[41,41]},_getIconUrl:function(name){return IconDefault.imagePath||(IconDefault.imagePath=this._detectIconPath()),(this.options.imagePath||IconDefault.imagePath)+Icon.prototype._getIconUrl.call(this,name)},_detectIconPath:function(){var el=create$1("div","leaflet-default-icon-path",document.body),path=getStyle(el,"background-image")||getStyle(el,"backgroundImage");return document.body.removeChild(el),path=null===path||0!==path.indexOf("url")?"":path.replace(/^url\(["']?/,"").replace(/marker-icon\.png["']?\)$/,"")}}),MarkerDrag=Handler.extend({initialize:function(marker){this._marker=marker},addHooks:function(){var icon=this._marker._icon;this._draggable||(this._draggable=new Draggable(icon,icon,!0)),this._draggable.on({dragstart:this._onDragStart,predrag:this._onPreDrag,drag:this._onDrag,dragend:this._onDragEnd},this).enable(),addClass(icon,"leaflet-marker-draggable")},removeHooks:function(){this._draggable.off({dragstart:this._onDragStart,predrag:this._onPreDrag,drag:this._onDrag,dragend:this._onDragEnd},this).disable(),this._marker._icon&&removeClass(this._marker._icon,"leaflet-marker-draggable")},moved:function(){return this._draggable&&this._draggable._moved},_adjustPan:function(e){var marker=this._marker,map=marker._map,speed=this._marker.options.autoPanSpeed,padding=this._marker.options.autoPanPadding,iconPos=L.DomUtil.getPosition(marker._icon),bounds=map.getPixelBounds(),origin=map.getPixelOrigin(),panBounds=toBounds(bounds.min._subtract(origin).add(padding),bounds.max._subtract(origin).subtract(padding));if(!panBounds.contains(iconPos)){var movement=toPoint((Math.max(panBounds.max.x,iconPos.x)-panBounds.max.x)/(bounds.max.x-panBounds.max.x)-(Math.min(panBounds.min.x,iconPos.x)-panBounds.min.x)/(bounds.min.x-panBounds.min.x),(Math.max(panBounds.max.y,iconPos.y)-panBounds.max.y)/(bounds.max.y-panBounds.max.y)-(Math.min(panBounds.min.y,iconPos.y)-panBounds.min.y)/(bounds.min.y-panBounds.min.y)).multiplyBy(speed);map.panBy(movement,{animate:!1}),this._draggable._newPos._add(movement),this._draggable._startPos._add(movement),L.DomUtil.setPosition(marker._icon,this._draggable._newPos),this._onDrag(e),this._panRequest=requestAnimFrame(this._adjustPan.bind(this,e))}},_onDragStart:function(){this._oldLatLng=this._marker.getLatLng(),this._marker.closePopup().fire("movestart").fire("dragstart")},_onPreDrag:function(e){this._marker.options.autoPan&&(cancelAnimFrame(this._panRequest),this._panRequest=requestAnimFrame(this._adjustPan.bind(this,e)))},_onDrag:function(e){var marker=this._marker,shadow=marker._shadow,iconPos=getPosition(marker._icon),latlng=marker._map.layerPointToLatLng(iconPos);shadow&&setPosition(shadow,iconPos),marker._latlng=latlng,e.latlng=latlng,e.oldLatLng=this._oldLatLng,marker.fire("move",e).fire("drag",e)},_onDragEnd:function(e){cancelAnimFrame(this._panRequest),delete this._oldLatLng,this._marker.fire("moveend").fire("dragend",e)}}),Marker=Layer.extend({options:{icon:new IconDefault,interactive:!0,draggable:!1,autoPan:!1,autoPanPadding:[50,50],autoPanSpeed:10,keyboard:!0,title:"",alt:"",zIndexOffset:0,opacity:1,riseOnHover:!1,riseOffset:250,pane:"markerPane",bubblingMouseEvents:!1},initialize:function(latlng,options){setOptions(this,options),this._latlng=toLatLng(latlng)},onAdd:function(map){this._zoomAnimated=this._zoomAnimated&&map.options.markerZoomAnimation,this._zoomAnimated&&map.on("zoomanim",this._animateZoom,this),this._initIcon(),this.update()},onRemove:function(map){this.dragging&&this.dragging.enabled()&&(this.options.draggable=!0,this.dragging.removeHooks()),delete this.dragging,this._zoomAnimated&&map.off("zoomanim",this._animateZoom,this),this._removeIcon(),this._removeShadow()},getEvents:function(){return{zoom:this.update,viewreset:this.update}},getLatLng:function(){return this._latlng},setLatLng:function(latlng){var oldLatLng=this._latlng;return this._latlng=toLatLng(latlng),this.update(),this.fire("move",{oldLatLng:oldLatLng,latlng:this._latlng})},setZIndexOffset:function(offset){return this.options.zIndexOffset=offset,this.update()},setIcon:function(icon){return this.options.icon=icon,this._map&&(this._initIcon(),this.update()),this._popup&&this.bindPopup(this._popup,this._popup.options),this},getElement:function(){return this._icon},update:function(){if(this._icon&&this._map){var pos=this._map.latLngToLayerPoint(this._latlng).round();this._setPos(pos)}return this},_initIcon:function(){var options=this.options,classToAdd="leaflet-zoom-"+(this._zoomAnimated?"animated":"hide"),icon=options.icon.createIcon(this._icon),addIcon=!1;icon!==this._icon&&(this._icon&&this._removeIcon(),addIcon=!0,options.title&&(icon.title=options.title),"IMG"===icon.tagName&&(icon.alt=options.alt||"")),addClass(icon,classToAdd),options.keyboard&&(icon.tabIndex="0"),this._icon=icon,options.riseOnHover&&this.on({mouseover:this._bringToFront,mouseout:this._resetZIndex});var newShadow=options.icon.createShadow(this._shadow),addShadow=!1;newShadow!==this._shadow&&(this._removeShadow(),addShadow=!0),newShadow&&(addClass(newShadow,classToAdd),newShadow.alt=""),this._shadow=newShadow,options.opacity<1&&this._updateOpacity(),addIcon&&this.getPane().appendChild(this._icon),this._initInteraction(),newShadow&&addShadow&&this.getPane("shadowPane").appendChild(this._shadow)},_removeIcon:function(){this.options.riseOnHover&&this.off({mouseover:this._bringToFront,mouseout:this._resetZIndex}),remove(this._icon),this.removeInteractiveTarget(this._icon),this._icon=null},_removeShadow:function(){this._shadow&&remove(this._shadow),this._shadow=null},_setPos:function(pos){setPosition(this._icon,pos),this._shadow&&setPosition(this._shadow,pos),this._zIndex=pos.y+this.options.zIndexOffset,this._resetZIndex()},_updateZIndex:function(offset){this._icon.style.zIndex=this._zIndex+offset},_animateZoom:function(opt){var pos=this._map._latLngToNewLayerPoint(this._latlng,opt.zoom,opt.center).round();this._setPos(pos)},_initInteraction:function(){if(this.options.interactive&&(addClass(this._icon,"leaflet-interactive"),this.addInteractiveTarget(this._icon),MarkerDrag)){var draggable=this.options.draggable;this.dragging&&(draggable=this.dragging.enabled(),this.dragging.disable()),this.dragging=new MarkerDrag(this),draggable&&this.dragging.enable()}},setOpacity:function(opacity){return this.options.opacity=opacity,this._map&&this._updateOpacity(),this},_updateOpacity:function(){var opacity=this.options.opacity;setOpacity(this._icon,opacity),this._shadow&&setOpacity(this._shadow,opacity)},_bringToFront:function(){this._updateZIndex(this.options.riseOffset)},_resetZIndex:function(){this._updateZIndex(0)},_getPopupAnchor:function(){return this.options.icon.options.popupAnchor},_getTooltipAnchor:function(){return this.options.icon.options.tooltipAnchor}}),Path=Layer.extend({options:{stroke:!0,color:"#3388ff",weight:3,opacity:1,lineCap:"round",lineJoin:"round",dashArray:null,dashOffset:null,fill:!1,fillColor:null,fillOpacity:.2,fillRule:"evenodd",interactive:!0,bubblingMouseEvents:!0},beforeAdd:function(map){this._renderer=map.getRenderer(this)},onAdd:function(){this._renderer._initPath(this),this._reset(),this._renderer._addPath(this)},onRemove:function(){this._renderer._removePath(this)},redraw:function(){return this._map&&this._renderer._updatePath(this),this},setStyle:function(style){return setOptions(this,style),this._renderer&&this._renderer._updateStyle(this),this},bringToFront:function(){return this._renderer&&this._renderer._bringToFront(this),this},bringToBack:function(){return this._renderer&&this._renderer._bringToBack(this),this},getElement:function(){return this._path},_reset:function(){this._project(),this._update()},_clickTolerance:function(){return(this.options.stroke?this.options.weight/2:0)+this._renderer.options.tolerance}}),CircleMarker=Path.extend({options:{fill:!0,radius:10},initialize:function(latlng,options){setOptions(this,options),this._latlng=toLatLng(latlng),this._radius=this.options.radius},setLatLng:function(latlng){return this._latlng=toLatLng(latlng),this.redraw(),this.fire("move",{latlng:this._latlng})},getLatLng:function(){return this._latlng},setRadius:function(radius){return this.options.radius=this._radius=radius,this.redraw()},getRadius:function(){return this._radius},setStyle:function(options){var radius=options&&options.radius||this._radius;return Path.prototype.setStyle.call(this,options),this.setRadius(radius),this},_project:function(){this._point=this._map.latLngToLayerPoint(this._latlng),this._updateBounds()},_updateBounds:function(){var r=this._radius,r2=this._radiusY||r,w=this._clickTolerance(),p=[r+w,r2+w];this._pxBounds=new Bounds(this._point.subtract(p),this._point.add(p))},_update:function(){this._map&&this._updatePath()},_updatePath:function(){this._renderer._updateCircle(this)},_empty:function(){return this._radius&&!this._renderer._bounds.intersects(this._pxBounds)},_containsPoint:function(p){return p.distanceTo(this._point)<=this._radius+this._clickTolerance()}}),Circle=CircleMarker.extend({initialize:function(latlng,options,legacyOptions){if("number"==typeof options&&(options=extend({},legacyOptions,{radius:options})),setOptions(this,options),this._latlng=toLatLng(latlng),isNaN(this.options.radius))throw new Error("Circle radius cannot be NaN");this._mRadius=this.options.radius},setRadius:function(radius){return this._mRadius=radius,this.redraw()},getRadius:function(){return this._mRadius},getBounds:function(){var half=[this._radius,this._radiusY||this._radius];return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)),this._map.layerPointToLatLng(this._point.add(half)))},setStyle:Path.prototype.setStyle,_project:function(){var lng=this._latlng.lng,lat=this._latlng.lat,map=this._map,crs=map.options.crs;if(crs.distance===Earth.distance){var d=Math.PI/180,latR=this._mRadius/Earth.R/d,top=map.project([lat+latR,lng]),bottom=map.project([lat-latR,lng]),p=top.add(bottom).divideBy(2),lat2=map.unproject(p).lat,lngR=Math.acos((Math.cos(latR*d)-Math.sin(lat*d)*Math.sin(lat2*d))/(Math.cos(lat*d)*Math.cos(lat2*d)))/d;(isNaN(lngR)||0===lngR)&&(lngR=latR/Math.cos(Math.PI/180*lat)),this._point=p.subtract(map.getPixelOrigin()),this._radius=isNaN(lngR)?0:p.x-map.project([lat2,lng-lngR]).x,this._radiusY=p.y-top.y}else{var latlng2=crs.unproject(crs.project(this._latlng).subtract([this._mRadius,0]));this._point=map.latLngToLayerPoint(this._latlng),this._radius=this._point.x-map.latLngToLayerPoint(latlng2).x}this._updateBounds()}}),Polyline=Path.extend({options:{smoothFactor:1,noClip:!1},initialize:function(latlngs,options){setOptions(this,options),this._setLatLngs(latlngs)},getLatLngs:function(){return this._latlngs},setLatLngs:function(latlngs){return this._setLatLngs(latlngs),this.redraw()},isEmpty:function(){return!this._latlngs.length},closestLayerPoint:function(p){for(var p1,p2,minDistance=1/0,minPoint=null,closest=_sqClosestPointOnSegment,j=0,jLen=this._parts.length;j<jLen;j++)for(var points=this._parts[j],i=1,len=points.length;i<len;i++){p1=points[i-1],p2=points[i];var sqDist=closest(p,p1,p2,!0);sqDist<minDistance&&(minDistance=sqDist,minPoint=closest(p,p1,p2))}return minPoint&&(minPoint.distance=Math.sqrt(minDistance)),minPoint},getCenter:function(){if(!this._map)throw new Error("Must add layer to map before using getCenter()");var i,halfDist,segDist,dist,p1,p2,ratio,points=this._rings[0],len=points.length;if(!len)return null;for(i=0,halfDist=0;i<len-1;i++)halfDist+=points[i].distanceTo(points[i+1])/2;if(0===halfDist)return this._map.layerPointToLatLng(points[0]);for(i=0,dist=0;i<len-1;i++)if(p1=points[i],p2=points[i+1],segDist=p1.distanceTo(p2),(dist+=segDist)>halfDist)return ratio=(dist-halfDist)/segDist,this._map.layerPointToLatLng([p2.x-ratio*(p2.x-p1.x),p2.y-ratio*(p2.y-p1.y)])},getBounds:function(){return this._bounds},addLatLng:function(latlng,latlngs){return latlngs=latlngs||this._defaultShape(),latlng=toLatLng(latlng),latlngs.push(latlng),this._bounds.extend(latlng),this.redraw()},_setLatLngs:function(latlngs){this._bounds=new LatLngBounds,this._latlngs=this._convertLatLngs(latlngs)},_defaultShape:function(){return isFlat(this._latlngs)?this._latlngs:this._latlngs[0]},_convertLatLngs:function(latlngs){for(var result=[],flat=isFlat(latlngs),i=0,len=latlngs.length;i<len;i++)flat?(result[i]=toLatLng(latlngs[i]),this._bounds.extend(result[i])):result[i]=this._convertLatLngs(latlngs[i]);return result},_project:function(){var pxBounds=new Bounds;this._rings=[],this._projectLatlngs(this._latlngs,this._rings,pxBounds);var w=this._clickTolerance(),p=new Point(w,w);this._bounds.isValid()&&pxBounds.isValid()&&(pxBounds.min._subtract(p),pxBounds.max._add(p),this._pxBounds=pxBounds)},_projectLatlngs:function(latlngs,result,projectedBounds){var i,ring,flat=latlngs[0]instanceof LatLng,len=latlngs.length;if(flat){for(ring=[],i=0;i<len;i++)ring[i]=this._map.latLngToLayerPoint(latlngs[i]),projectedBounds.extend(ring[i]);result.push(ring)}else for(i=0;i<len;i++)this._projectLatlngs(latlngs[i],result,projectedBounds)},_clipPoints:function(){var bounds=this._renderer._bounds;if(this._parts=[],this._pxBounds&&this._pxBounds.intersects(bounds)){if(this.options.noClip)return void(this._parts=this._rings);var i,j,k,len,len2,segment,points,parts=this._parts;for(i=0,k=0,len=this._rings.length;i<len;i++)for(points=this._rings[i],j=0,len2=points.length;j<len2-1;j++)(segment=clipSegment(points[j],points[j+1],bounds,j,!0))&&(parts[k]=parts[k]||[],parts[k].push(segment[0]),segment[1]===points[j+1]&&j!==len2-2||(parts[k].push(segment[1]),k++))}},_simplifyPoints:function(){for(var parts=this._parts,tolerance=this.options.smoothFactor,i=0,len=parts.length;i<len;i++)parts[i]=simplify(parts[i],tolerance)},_update:function(){this._map&&(this._clipPoints(),this._simplifyPoints(),this._updatePath())},_updatePath:function(){this._renderer._updatePoly(this)},_containsPoint:function(p,closed){var i,j,k,len,len2,part,w=this._clickTolerance();if(!this._pxBounds||!this._pxBounds.contains(p))return!1;for(i=0,len=this._parts.length;i<len;i++)for(part=this._parts[i],j=0,len2=part.length,k=len2-1;j<len2;k=j++)if((closed||0!==j)&&pointToSegmentDistance(p,part[k],part[j])<=w)return!0;return!1}});Polyline._flat=_flat;var Polygon=Polyline.extend({options:{fill:!0},isEmpty:function(){return!this._latlngs.length||!this._latlngs[0].length},getCenter:function(){if(!this._map)throw new Error("Must add layer to map before using getCenter()");var i,j,p1,p2,f,area,x,y,center,points=this._rings[0],len=points.length;if(!len)return null;for(area=x=y=0,i=0,j=len-1;i<len;j=i++)p1=points[i],p2=points[j],f=p1.y*p2.x-p2.y*p1.x,x+=(p1.x+p2.x)*f,y+=(p1.y+p2.y)*f,area+=3*f;return center=0===area?points[0]:[x/area,y/area],this._map.layerPointToLatLng(center)},_convertLatLngs:function(latlngs){var result=Polyline.prototype._convertLatLngs.call(this,latlngs),len=result.length;return len>=2&&result[0]instanceof LatLng&&result[0].equals(result[len-1])&&result.pop(),result},_setLatLngs:function(latlngs){Polyline.prototype._setLatLngs.call(this,latlngs),isFlat(this._latlngs)&&(this._latlngs=[this._latlngs])},_defaultShape:function(){return isFlat(this._latlngs[0])?this._latlngs[0]:this._latlngs[0][0]},_clipPoints:function(){var bounds=this._renderer._bounds,w=this.options.weight,p=new Point(w,w);if(bounds=new Bounds(bounds.min.subtract(p),bounds.max.add(p)),this._parts=[],this._pxBounds&&this._pxBounds.intersects(bounds)){if(this.options.noClip)return void(this._parts=this._rings);for(var clipped,i=0,len=this._rings.length;i<len;i++)clipped=clipPolygon(this._rings[i],bounds,!0),clipped.length&&this._parts.push(clipped)}},_updatePath:function(){this._renderer._updatePoly(this,!0)},_containsPoint:function(p){var part,p1,p2,i,j,k,len,len2,inside=!1;if(!this._pxBounds.contains(p))return!1;for(i=0,len=this._parts.length;i<len;i++)for(part=this._parts[i],j=0,len2=part.length,k=len2-1;j<len2;k=j++)p1=part[j],p2=part[k],p1.y>p.y!=p2.y>p.y&&p.x<(p2.x-p1.x)*(p.y-p1.y)/(p2.y-p1.y)+p1.x&&(inside=!inside);return inside||Polyline.prototype._containsPoint.call(this,p,!0)}}),GeoJSON=FeatureGroup.extend({initialize:function(geojson,options){setOptions(this,options),this._layers={},geojson&&this.addData(geojson)},addData:function(geojson){var i,len,feature,features=isArray(geojson)?geojson:geojson.features;if(features){for(i=0,len=features.length;i<len;i++)feature=features[i],(feature.geometries||feature.geometry||feature.features||feature.coordinates)&&this.addData(feature);return this}var options=this.options;if(options.filter&&!options.filter(geojson))return this;var layer=geometryToLayer(geojson,options);return layer?(layer.feature=asFeature(geojson),layer.defaultOptions=layer.options,this.resetStyle(layer),options.onEachFeature&&options.onEachFeature(geojson,layer),this.addLayer(layer)):this},resetStyle:function(layer){return layer.options=extend({},layer.defaultOptions),this._setLayerStyle(layer,this.options.style),this},setStyle:function(style){return this.eachLayer(function(layer){this._setLayerStyle(layer,style)},this)},_setLayerStyle:function(layer,style){"function"==typeof style&&(style=style(layer.feature)),layer.setStyle&&layer.setStyle(style)}}),PointToGeoJSON={toGeoJSON:function(precision){return getFeature(this,{type:"Point",coordinates:latLngToCoords(this.getLatLng(),precision)})}};Marker.include(PointToGeoJSON),Circle.include(PointToGeoJSON),CircleMarker.include(PointToGeoJSON),Polyline.include({toGeoJSON:function(precision){var multi=!isFlat(this._latlngs),coords=latLngsToCoords(this._latlngs,multi?1:0,!1,precision);return getFeature(this,{type:(multi?"Multi":"")+"LineString",coordinates:coords})}}),Polygon.include({toGeoJSON:function(precision){var holes=!isFlat(this._latlngs),multi=holes&&!isFlat(this._latlngs[0]),coords=latLngsToCoords(this._latlngs,multi?2:holes?1:0,!0,precision);return holes||(coords=[coords]),getFeature(this,{type:(multi?"Multi":"")+"Polygon",coordinates:coords})}}),LayerGroup.include({toMultiPoint:function(precision){var coords=[];return this.eachLayer(function(layer){coords.push(layer.toGeoJSON(precision).geometry.coordinates)}),getFeature(this,{type:"MultiPoint",coordinates:coords})},toGeoJSON:function(precision){var type=this.feature&&this.feature.geometry&&this.feature.geometry.type;if("MultiPoint"===type)return this.toMultiPoint(precision);var isGeometryCollection="GeometryCollection"===type,jsons=[];return this.eachLayer(function(layer){if(layer.toGeoJSON){var json=layer.toGeoJSON(precision);if(isGeometryCollection)jsons.push(json.geometry);else{var feature=asFeature(json);"FeatureCollection"===feature.type?jsons.push.apply(jsons,feature.features):jsons.push(feature)}}}),isGeometryCollection?getFeature(this,{geometries:jsons,type:"GeometryCollection"}):{type:"FeatureCollection",features:jsons}}});var geoJson=geoJSON,ImageOverlay=Layer.extend({options:{opacity:1,alt:"",interactive:!1,crossOrigin:!1,errorOverlayUrl:"",zIndex:1,className:""},initialize:function(url,bounds,options){this._url=url,this._bounds=toLatLngBounds(bounds),setOptions(this,options)},onAdd:function(){this._image||(this._initImage(),this.options.opacity<1&&this._updateOpacity()),this.options.interactive&&(addClass(this._image,"leaflet-interactive"),this.addInteractiveTarget(this._image)),this.getPane().appendChild(this._image),this._reset()},onRemove:function(){remove(this._image),this.options.interactive&&this.removeInteractiveTarget(this._image)},setOpacity:function(opacity){return this.options.opacity=opacity,this._image&&this._updateOpacity(),this},setStyle:function(styleOpts){return styleOpts.opacity&&this.setOpacity(styleOpts.opacity),this},bringToFront:function(){return this._map&&toFront(this._image),this},bringToBack:function(){return this._map&&toBack(this._image),this},setUrl:function(url){return this._url=url,this._image&&(this._image.src=url),this},setBounds:function(bounds){return this._bounds=toLatLngBounds(bounds),this._map&&this._reset(),this},getEvents:function(){var events={zoom:this._reset,viewreset:this._reset};return this._zoomAnimated&&(events.zoomanim=this._animateZoom),events},setZIndex:function(value){return this.options.zIndex=value,this._updateZIndex(),this},getBounds:function(){return this._bounds},getElement:function(){return this._image},_initImage:function(){var wasElementSupplied="IMG"===this._url.tagName,img=this._image=wasElementSupplied?this._url:create$1("img");if(addClass(img,"leaflet-image-layer"),this._zoomAnimated&&addClass(img,"leaflet-zoom-animated"),this.options.className&&addClass(img,this.options.className),img.onselectstart=falseFn,img.onmousemove=falseFn,img.onload=bind(this.fire,this,"load"),img.onerror=bind(this._overlayOnError,this,"error"),this.options.crossOrigin&&(img.crossOrigin=""),this.options.zIndex&&this._updateZIndex(),wasElementSupplied)return void(this._url=img.src);img.src=this._url,img.alt=this.options.alt},_animateZoom:function(e){var scale=this._map.getZoomScale(e.zoom),offset=this._map._latLngBoundsToNewLayerBounds(this._bounds,e.zoom,e.center).min;setTransform(this._image,offset,scale)},_reset:function(){var image=this._image,bounds=new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()),this._map.latLngToLayerPoint(this._bounds.getSouthEast())),size=bounds.getSize();setPosition(image,bounds.min),image.style.width=size.x+"px",image.style.height=size.y+"px"},_updateOpacity:function(){setOpacity(this._image,this.options.opacity)},_updateZIndex:function(){this._image&&void 0!==this.options.zIndex&&null!==this.options.zIndex&&(this._image.style.zIndex=this.options.zIndex)},_overlayOnError:function(){this.fire("error");var errorUrl=this.options.errorOverlayUrl;errorUrl&&this._url!==errorUrl&&(this._url=errorUrl,this._image.src=errorUrl)}}),imageOverlay=function(url,bounds,options){return new ImageOverlay(url,bounds,options)},VideoOverlay=ImageOverlay.extend({options:{autoplay:!0,loop:!0},_initImage:function(){var wasElementSupplied="VIDEO"===this._url.tagName,vid=this._image=wasElementSupplied?this._url:create$1("video");if(addClass(vid,"leaflet-image-layer"),this._zoomAnimated&&addClass(vid,"leaflet-zoom-animated"),vid.onselectstart=falseFn,vid.onmousemove=falseFn,vid.onloadeddata=bind(this.fire,this,"load"),wasElementSupplied){for(var sourceElements=vid.getElementsByTagName("source"),sources=[],j=0;j<sourceElements.length;j++)sources.push(sourceElements[j].src);return void(this._url=sourceElements.length>0?sources:[vid.src])}isArray(this._url)||(this._url=[this._url]),vid.autoplay=!!this.options.autoplay,vid.loop=!!this.options.loop;for(var i=0;i<this._url.length;i++){var source=create$1("source");source.src=this._url[i],vid.appendChild(source)}}}),DivOverlay=Layer.extend({options:{offset:[0,7],className:"",pane:"popupPane"},initialize:function(options,source){setOptions(this,options),this._source=source},onAdd:function(map){this._zoomAnimated=map._zoomAnimated,this._container||this._initLayout(),map._fadeAnimated&&setOpacity(this._container,0),clearTimeout(this._removeTimeout),this.getPane().appendChild(this._container),this.update(),map._fadeAnimated&&setOpacity(this._container,1),this.bringToFront()},onRemove:function(map){map._fadeAnimated?(setOpacity(this._container,0),this._removeTimeout=setTimeout(bind(remove,void 0,this._container),200)):remove(this._container)},getLatLng:function(){return this._latlng},setLatLng:function(latlng){return this._latlng=toLatLng(latlng),this._map&&(this._updatePosition(),this._adjustPan()),this},getContent:function(){return this._content},setContent:function(content){return this._content=content,this.update(),this},getElement:function(){return this._container},update:function(){this._map&&(this._container.style.visibility="hidden",this._updateContent(),this._updateLayout(),this._updatePosition(),this._container.style.visibility="",this._adjustPan())},getEvents:function(){var events={zoom:this._updatePosition,viewreset:this._updatePosition};return this._zoomAnimated&&(events.zoomanim=this._animateZoom),events},isOpen:function(){return!!this._map&&this._map.hasLayer(this)},bringToFront:function(){return this._map&&toFront(this._container),this},bringToBack:function(){return this._map&&toBack(this._container),this},_updateContent:function(){if(this._content){var node=this._contentNode,content="function"==typeof this._content?this._content(this._source||this):this._content;if("string"==typeof content)node.innerHTML=content;else{for(;node.hasChildNodes();)node.removeChild(node.firstChild);node.appendChild(content)}this.fire("contentupdate")}},_updatePosition:function(){if(this._map){var pos=this._map.latLngToLayerPoint(this._latlng),offset=toPoint(this.options.offset),anchor=this._getAnchor();this._zoomAnimated?setPosition(this._container,pos.add(anchor)):offset=offset.add(pos).add(anchor);var bottom=this._containerBottom=-offset.y,left=this._containerLeft=-Math.round(this._containerWidth/2)+offset.x;this._container.style.bottom=bottom+"px",this._container.style.left=left+"px"}},_getAnchor:function(){return[0,0]}}),Popup=DivOverlay.extend({options:{maxWidth:300,minWidth:50,maxHeight:null,autoPan:!0,autoPanPaddingTopLeft:null,autoPanPaddingBottomRight:null,autoPanPadding:[5,5],keepInView:!1,closeButton:!0,autoClose:!0,closeOnEscapeKey:!0,className:""},openOn:function(map){return map.openPopup(this),this},onAdd:function(map){DivOverlay.prototype.onAdd.call(this,map),map.fire("popupopen",{popup:this}),this._source&&(this._source.fire("popupopen",{popup:this},!0),this._source instanceof Path||this._source.on("preclick",stopPropagation))},onRemove:function(map){DivOverlay.prototype.onRemove.call(this,map),map.fire("popupclose",{popup:this}),this._source&&(this._source.fire("popupclose",{popup:this},!0),this._source instanceof Path||this._source.off("preclick",stopPropagation))},getEvents:function(){var events=DivOverlay.prototype.getEvents.call(this);return(void 0!==this.options.closeOnClick?this.options.closeOnClick:this._map.options.closePopupOnClick)&&(events.preclick=this._close),this.options.keepInView&&(events.moveend=this._adjustPan),events},_close:function(){this._map&&this._map.closePopup(this)},_initLayout:function(){var prefix="leaflet-popup",container=this._container=create$1("div",prefix+" "+(this.options.className||"")+" leaflet-zoom-animated"),wrapper=this._wrapper=create$1("div",prefix+"-content-wrapper",container);if(this._contentNode=create$1("div",prefix+"-content",wrapper),disableClickPropagation(wrapper),disableScrollPropagation(this._contentNode),on(wrapper,"contextmenu",stopPropagation),this._tipContainer=create$1("div",prefix+"-tip-container",container),this._tip=create$1("div",prefix+"-tip",this._tipContainer),this.options.closeButton){var closeButton=this._closeButton=create$1("a",prefix+"-close-button",container);closeButton.href="#close",closeButton.innerHTML="&#215;",on(closeButton,"click",this._onCloseButtonClick,this)}},_updateLayout:function(){var container=this._contentNode,style=container.style;style.width="",style.whiteSpace="nowrap";var width=container.offsetWidth;width=Math.min(width,this.options.maxWidth),width=Math.max(width,this.options.minWidth),style.width=width+1+"px",style.whiteSpace="",style.height="";var height=container.offsetHeight,maxHeight=this.options.maxHeight;maxHeight&&height>maxHeight?(style.height=maxHeight+"px",addClass(container,"leaflet-popup-scrolled")):removeClass(container,"leaflet-popup-scrolled"),this._containerWidth=this._container.offsetWidth},_animateZoom:function(e){var pos=this._map._latLngToNewLayerPoint(this._latlng,e.zoom,e.center),anchor=this._getAnchor();setPosition(this._container,pos.add(anchor))},_adjustPan:function(){if(!(!this.options.autoPan||this._map._panAnim&&this._map._panAnim._inProgress)){var map=this._map,marginBottom=parseInt(getStyle(this._container,"marginBottom"),10)||0,containerHeight=this._container.offsetHeight+marginBottom,containerWidth=this._containerWidth,layerPos=new Point(this._containerLeft,-containerHeight-this._containerBottom);layerPos._add(getPosition(this._container));var containerPos=map.layerPointToContainerPoint(layerPos),padding=toPoint(this.options.autoPanPadding),paddingTL=toPoint(this.options.autoPanPaddingTopLeft||padding),paddingBR=toPoint(this.options.autoPanPaddingBottomRight||padding),size=map.getSize(),dx=0,dy=0;containerPos.x+containerWidth+paddingBR.x>size.x&&(dx=containerPos.x+containerWidth-size.x+paddingBR.x),containerPos.x-dx-paddingTL.x<0&&(dx=containerPos.x-paddingTL.x),containerPos.y+containerHeight+paddingBR.y>size.y&&(dy=containerPos.y+containerHeight-size.y+paddingBR.y),containerPos.y-dy-paddingTL.y<0&&(dy=containerPos.y-paddingTL.y),(dx||dy)&&map.fire("autopanstart").panBy([dx,dy])}},_onCloseButtonClick:function(e){this._close(),stop(e)},_getAnchor:function(){return toPoint(this._source&&this._source._getPopupAnchor?this._source._getPopupAnchor():[0,0])}}),popup=function(options,source){return new Popup(options,source)};Map.mergeOptions({closePopupOnClick:!0}),Map.include({openPopup:function(popup,latlng,options){return popup instanceof Popup||(popup=new Popup(options).setContent(popup)),latlng&&popup.setLatLng(latlng),this.hasLayer(popup)?this:(this._popup&&this._popup.options.autoClose&&this.closePopup(),this._popup=popup,this.addLayer(popup))},closePopup:function(popup){return popup&&popup!==this._popup||(popup=this._popup,this._popup=null),popup&&this.removeLayer(popup),this}}),Layer.include({bindPopup:function(content,options){return content instanceof Popup?(setOptions(content,options),this._popup=content,content._source=this):(this._popup&&!options||(this._popup=new Popup(options,this)),this._popup.setContent(content)),this._popupHandlersAdded||(this.on({click:this._openPopup,keypress:this._onKeyPress,remove:this.closePopup,move:this._movePopup}),this._popupHandlersAdded=!0),this},unbindPopup:function(){return this._popup&&(this.off({click:this._openPopup,keypress:this._onKeyPress,remove:this.closePopup,move:this._movePopup}),this._popupHandlersAdded=!1,this._popup=null),this},openPopup:function(layer,latlng){if(layer instanceof Layer||(latlng=layer,layer=this),layer instanceof FeatureGroup)for(var id in this._layers){layer=this._layers[id];break}return latlng||(latlng=layer.getCenter?layer.getCenter():layer.getLatLng()),this._popup&&this._map&&(this._popup._source=layer,this._popup.update(),this._map.openPopup(this._popup,latlng)),this},closePopup:function(){return this._popup&&this._popup._close(),this},togglePopup:function(target){return this._popup&&(this._popup._map?this.closePopup():this.openPopup(target)),this},isPopupOpen:function(){return!!this._popup&&this._popup.isOpen()},setPopupContent:function(content){return this._popup&&this._popup.setContent(content),this},getPopup:function(){return this._popup},_openPopup:function(e){var layer=e.layer||e.target;if(this._popup&&this._map){if(stop(e),layer instanceof Path)return void this.openPopup(e.layer||e.target,e.latlng);this._map.hasLayer(this._popup)&&this._popup._source===layer?this.closePopup():this.openPopup(layer,e.latlng)}},_movePopup:function(e){this._popup.setLatLng(e.latlng)},_onKeyPress:function(e){13===e.originalEvent.keyCode&&this._openPopup(e)}});var Tooltip=DivOverlay.extend({options:{pane:"tooltipPane",offset:[0,0],direction:"auto",permanent:!1,sticky:!1,interactive:!1,opacity:.9},onAdd:function(map){DivOverlay.prototype.onAdd.call(this,map),this.setOpacity(this.options.opacity),map.fire("tooltipopen",{tooltip:this}),this._source&&this._source.fire("tooltipopen",{tooltip:this},!0)},onRemove:function(map){DivOverlay.prototype.onRemove.call(this,map),map.fire("tooltipclose",{tooltip:this}),this._source&&this._source.fire("tooltipclose",{tooltip:this},!0)},getEvents:function(){var events=DivOverlay.prototype.getEvents.call(this);return touch&&!this.options.permanent&&(events.preclick=this._close),events},_close:function(){this._map&&this._map.closeTooltip(this)},_initLayout:function(){var className="leaflet-tooltip "+(this.options.className||"")+" leaflet-zoom-"+(this._zoomAnimated?"animated":"hide");this._contentNode=this._container=create$1("div",className)},_updateLayout:function(){},_adjustPan:function(){},_setPosition:function(pos){var map=this._map,container=this._container,centerPoint=map.latLngToContainerPoint(map.getCenter()),tooltipPoint=map.layerPointToContainerPoint(pos),direction=this.options.direction,tooltipWidth=container.offsetWidth,tooltipHeight=container.offsetHeight,offset=toPoint(this.options.offset),anchor=this._getAnchor();"top"===direction?pos=pos.add(toPoint(-tooltipWidth/2+offset.x,-tooltipHeight+offset.y+anchor.y,!0)):"bottom"===direction?pos=pos.subtract(toPoint(tooltipWidth/2-offset.x,-offset.y,!0)):"center"===direction?pos=pos.subtract(toPoint(tooltipWidth/2+offset.x,tooltipHeight/2-anchor.y+offset.y,!0)):"right"===direction||"auto"===direction&&tooltipPoint.x<centerPoint.x?(direction="right",pos=pos.add(toPoint(offset.x+anchor.x,anchor.y-tooltipHeight/2+offset.y,!0))):(direction="left",pos=pos.subtract(toPoint(tooltipWidth+anchor.x-offset.x,tooltipHeight/2-anchor.y-offset.y,!0))),removeClass(container,"leaflet-tooltip-right"),removeClass(container,"leaflet-tooltip-left"),removeClass(container,"leaflet-tooltip-top"),removeClass(container,"leaflet-tooltip-bottom"),addClass(container,"leaflet-tooltip-"+direction),setPosition(container,pos)},_updatePosition:function(){var pos=this._map.latLngToLayerPoint(this._latlng);this._setPosition(pos)},setOpacity:function(opacity){this.options.opacity=opacity,this._container&&setOpacity(this._container,opacity)},_animateZoom:function(e){var pos=this._map._latLngToNewLayerPoint(this._latlng,e.zoom,e.center);this._setPosition(pos)},_getAnchor:function(){return toPoint(this._source&&this._source._getTooltipAnchor&&!this.options.sticky?this._source._getTooltipAnchor():[0,0])}}),tooltip=function(options,source){return new Tooltip(options,source)};Map.include({openTooltip:function(tooltip,latlng,options){return tooltip instanceof Tooltip||(tooltip=new Tooltip(options).setContent(tooltip)),latlng&&tooltip.setLatLng(latlng),this.hasLayer(tooltip)?this:this.addLayer(tooltip)},closeTooltip:function(tooltip){return tooltip&&this.removeLayer(tooltip),this}}),Layer.include({bindTooltip:function(content,options){return content instanceof Tooltip?(setOptions(content,options),this._tooltip=content,content._source=this):(this._tooltip&&!options||(this._tooltip=new Tooltip(options,this)),this._tooltip.setContent(content)),this._initTooltipInteractions(),this._tooltip.options.permanent&&this._map&&this._map.hasLayer(this)&&this.openTooltip(),this},unbindTooltip:function(){return this._tooltip&&(this._initTooltipInteractions(!0),this.closeTooltip(),this._tooltip=null),this},_initTooltipInteractions:function(remove$$1){if(remove$$1||!this._tooltipHandlersAdded){var onOff=remove$$1?"off":"on",events={remove:this.closeTooltip,move:this._moveTooltip};this._tooltip.options.permanent?events.add=this._openTooltip:(events.mouseover=this._openTooltip,events.mouseout=this.closeTooltip,this._tooltip.options.sticky&&(events.mousemove=this._moveTooltip),touch&&(events.click=this._openTooltip)),this[onOff](events),this._tooltipHandlersAdded=!remove$$1}},openTooltip:function(layer,latlng){if(layer instanceof Layer||(latlng=layer,layer=this),layer instanceof FeatureGroup)for(var id in this._layers){layer=this._layers[id];break}return latlng||(latlng=layer.getCenter?layer.getCenter():layer.getLatLng()),this._tooltip&&this._map&&(this._tooltip._source=layer,this._tooltip.update(),this._map.openTooltip(this._tooltip,latlng),this._tooltip.options.interactive&&this._tooltip._container&&(addClass(this._tooltip._container,"leaflet-clickable"),this.addInteractiveTarget(this._tooltip._container))),this},closeTooltip:function(){return this._tooltip&&(this._tooltip._close(),this._tooltip.options.interactive&&this._tooltip._container&&(removeClass(this._tooltip._container,"leaflet-clickable"),this.removeInteractiveTarget(this._tooltip._container))),this},toggleTooltip:function(target){return this._tooltip&&(this._tooltip._map?this.closeTooltip():this.openTooltip(target)),this},isTooltipOpen:function(){return this._tooltip.isOpen()},setTooltipContent:function(content){return this._tooltip&&this._tooltip.setContent(content),this},getTooltip:function(){return this._tooltip},_openTooltip:function(e){var layer=e.layer||e.target;this._tooltip&&this._map&&this.openTooltip(layer,this._tooltip.options.sticky?e.latlng:void 0)},_moveTooltip:function(e){var containerPoint,layerPoint,latlng=e.latlng;this._tooltip.options.sticky&&e.originalEvent&&(containerPoint=this._map.mouseEventToContainerPoint(e.originalEvent),layerPoint=this._map.containerPointToLayerPoint(containerPoint),latlng=this._map.layerPointToLatLng(layerPoint)),this._tooltip.setLatLng(latlng)}});var DivIcon=Icon.extend({options:{iconSize:[12,12],html:!1,bgPos:null,className:"leaflet-div-icon"},createIcon:function(oldIcon){var div=oldIcon&&"DIV"===oldIcon.tagName?oldIcon:document.createElement("div"),options=this.options;if(div.innerHTML=!1!==options.html?options.html:"",options.bgPos){var bgPos=toPoint(options.bgPos);div.style.backgroundPosition=-bgPos.x+"px "+-bgPos.y+"px"}return this._setIconStyles(div,"icon"),div},createShadow:function(){return null}});Icon.Default=IconDefault;var GridLayer=Layer.extend({options:{tileSize:256,opacity:1,updateWhenIdle:mobile,updateWhenZooming:!0,updateInterval:200,zIndex:1,bounds:null,minZoom:0,maxZoom:void 0,maxNativeZoom:void 0,minNativeZoom:void 0,noWrap:!1,pane:"tilePane",className:"",keepBuffer:2},initialize:function(options){setOptions(this,options)},onAdd:function(){this._initContainer(),this._levels={},this._tiles={},this._resetView(),this._update()},beforeAdd:function(map){map._addZoomLimit(this)},onRemove:function(map){this._removeAllTiles(),remove(this._container),map._removeZoomLimit(this),this._container=null,this._tileZoom=void 0},bringToFront:function(){return this._map&&(toFront(this._container),this._setAutoZIndex(Math.max)),this},bringToBack:function(){return this._map&&(toBack(this._container),this._setAutoZIndex(Math.min)),this},getContainer:function(){return this._container},setOpacity:function(opacity){return this.options.opacity=opacity,this._updateOpacity(),this},setZIndex:function(zIndex){return this.options.zIndex=zIndex,this._updateZIndex(),this},isLoading:function(){return this._loading},redraw:function(){return this._map&&(this._removeAllTiles(),this._update()),this},getEvents:function(){var events={viewprereset:this._invalidateAll,viewreset:this._resetView,zoom:this._resetView,moveend:this._onMoveEnd};return this.options.updateWhenIdle||(this._onMove||(this._onMove=throttle(this._onMoveEnd,this.options.updateInterval,this)),events.move=this._onMove),this._zoomAnimated&&(events.zoomanim=this._animateZoom),events},createTile:function(){return document.createElement("div")},getTileSize:function(){var s=this.options.tileSize;return s instanceof Point?s:new Point(s,s)},_updateZIndex:function(){this._container&&void 0!==this.options.zIndex&&null!==this.options.zIndex&&(this._container.style.zIndex=this.options.zIndex)},_setAutoZIndex:function(compare){for(var zIndex,layers=this.getPane().children,edgeZIndex=-compare(-1/0,1/0),i=0,len=layers.length;i<len;i++)zIndex=layers[i].style.zIndex,layers[i]!==this._container&&zIndex&&(edgeZIndex=compare(edgeZIndex,+zIndex));isFinite(edgeZIndex)&&(this.options.zIndex=edgeZIndex+compare(-1,1),this._updateZIndex())},_updateOpacity:function(){if(this._map&&!ielt9){setOpacity(this._container,this.options.opacity);var now=+new Date,nextFrame=!1,willPrune=!1;for(var key in this._tiles){var tile=this._tiles[key];if(tile.current&&tile.loaded){var fade=Math.min(1,(now-tile.loaded)/200);setOpacity(tile.el,fade),fade<1?nextFrame=!0:(tile.active?willPrune=!0:this._onOpaqueTile(tile),tile.active=!0)}}willPrune&&!this._noPrune&&this._pruneTiles(),nextFrame&&(cancelAnimFrame(this._fadeFrame),this._fadeFrame=requestAnimFrame(this._updateOpacity,this))}},_onOpaqueTile:falseFn,_initContainer:function(){this._container||(this._container=create$1("div","leaflet-layer "+(this.options.className||"")),this._updateZIndex(),this.options.opacity<1&&this._updateOpacity(),this.getPane().appendChild(this._container))},_updateLevels:function(){var zoom=this._tileZoom,maxZoom=this.options.maxZoom;if(void 0!==zoom){for(var z in this._levels)this._levels[z].el.children.length||z===zoom?(this._levels[z].el.style.zIndex=maxZoom-Math.abs(zoom-z),this._onUpdateLevel(z)):(remove(this._levels[z].el),this._removeTilesAtZoom(z),this._onRemoveLevel(z),delete this._levels[z]);var level=this._levels[zoom],map=this._map;return level||(level=this._levels[zoom]={},level.el=create$1("div","leaflet-tile-container leaflet-zoom-animated",this._container),level.el.style.zIndex=maxZoom,level.origin=map.project(map.unproject(map.getPixelOrigin()),zoom).round(),level.zoom=zoom,this._setZoomTransform(level,map.getCenter(),map.getZoom()),level.el.offsetWidth,this._onCreateLevel(level)),this._level=level,level}},_onUpdateLevel:falseFn,_onRemoveLevel:falseFn,_onCreateLevel:falseFn,_pruneTiles:function(){if(this._map){var key,tile,zoom=this._map.getZoom();if(zoom>this.options.maxZoom||zoom<this.options.minZoom)return void this._removeAllTiles();for(key in this._tiles)tile=this._tiles[key],tile.retain=tile.current;for(key in this._tiles)if(tile=this._tiles[key],tile.current&&!tile.active){var coords=tile.coords;this._retainParent(coords.x,coords.y,coords.z,coords.z-5)||this._retainChildren(coords.x,coords.y,coords.z,coords.z+2)}for(key in this._tiles)this._tiles[key].retain||this._removeTile(key)}},_removeTilesAtZoom:function(zoom){for(var key in this._tiles)this._tiles[key].coords.z===zoom&&this._removeTile(key)},_removeAllTiles:function(){for(var key in this._tiles)this._removeTile(key)},_invalidateAll:function(){for(var z in this._levels)remove(this._levels[z].el),this._onRemoveLevel(z),delete this._levels[z];this._removeAllTiles(),this._tileZoom=void 0},_retainParent:function(x,y,z,minZoom){var x2=Math.floor(x/2),y2=Math.floor(y/2),z2=z-1,coords2=new Point(+x2,+y2);coords2.z=+z2;var key=this._tileCoordsToKey(coords2),tile=this._tiles[key];return tile&&tile.active?(tile.retain=!0,!0):(tile&&tile.loaded&&(tile.retain=!0),z2>minZoom&&this._retainParent(x2,y2,z2,minZoom))},_retainChildren:function(x,y,z,maxZoom){for(var i=2*x;i<2*x+2;i++)for(var j=2*y;j<2*y+2;j++){var coords=new Point(i,j);coords.z=z+1;var key=this._tileCoordsToKey(coords),tile=this._tiles[key];tile&&tile.active?tile.retain=!0:(tile&&tile.loaded&&(tile.retain=!0),z+1<maxZoom&&this._retainChildren(i,j,z+1,maxZoom))}},_resetView:function(e){var animating=e&&(e.pinch||e.flyTo);this._setView(this._map.getCenter(),this._map.getZoom(),animating,animating)},_animateZoom:function(e){this._setView(e.center,e.zoom,!0,e.noUpdate)},_clampZoom:function(zoom){var options=this.options;return void 0!==options.minNativeZoom&&zoom<options.minNativeZoom?options.minNativeZoom:void 0!==options.maxNativeZoom&&options.maxNativeZoom<zoom?options.maxNativeZoom:zoom},_setView:function(center,zoom,noPrune,noUpdate){var tileZoom=this._clampZoom(Math.round(zoom));(void 0!==this.options.maxZoom&&tileZoom>this.options.maxZoom||void 0!==this.options.minZoom&&tileZoom<this.options.minZoom)&&(tileZoom=void 0);var tileZoomChanged=this.options.updateWhenZooming&&tileZoom!==this._tileZoom;noUpdate&&!tileZoomChanged||(this._tileZoom=tileZoom,this._abortLoading&&this._abortLoading(),this._updateLevels(),this._resetGrid(),void 0!==tileZoom&&this._update(center),noPrune||this._pruneTiles(),this._noPrune=!!noPrune),this._setZoomTransforms(center,zoom)},_setZoomTransforms:function(center,zoom){for(var i in this._levels)this._setZoomTransform(this._levels[i],center,zoom)},_setZoomTransform:function(level,center,zoom){var scale=this._map.getZoomScale(zoom,level.zoom),translate=level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center,zoom)).round();any3d?setTransform(level.el,translate,scale):setPosition(level.el,translate)},_resetGrid:function(){var map=this._map,crs=map.options.crs,tileSize=this._tileSize=this.getTileSize(),tileZoom=this._tileZoom,bounds=this._map.getPixelWorldBounds(this._tileZoom);bounds&&(this._globalTileRange=this._pxBoundsToTileRange(bounds)),this._wrapX=crs.wrapLng&&!this.options.noWrap&&[Math.floor(map.project([0,crs.wrapLng[0]],tileZoom).x/tileSize.x),Math.ceil(map.project([0,crs.wrapLng[1]],tileZoom).x/tileSize.y)],this._wrapY=crs.wrapLat&&!this.options.noWrap&&[Math.floor(map.project([crs.wrapLat[0],0],tileZoom).y/tileSize.x),Math.ceil(map.project([crs.wrapLat[1],0],tileZoom).y/tileSize.y)]},_onMoveEnd:function(){this._map&&!this._map._animatingZoom&&this._update()},_getTiledPixelBounds:function(center){var map=this._map,mapZoom=map._animatingZoom?Math.max(map._animateToZoom,map.getZoom()):map.getZoom(),scale=map.getZoomScale(mapZoom,this._tileZoom),pixelCenter=map.project(center,this._tileZoom).floor(),halfSize=map.getSize().divideBy(2*scale);return new Bounds(pixelCenter.subtract(halfSize),pixelCenter.add(halfSize))},_update:function(center){var map=this._map;if(map){var zoom=this._clampZoom(map.getZoom());if(void 0===center&&(center=map.getCenter()),void 0!==this._tileZoom){var pixelBounds=this._getTiledPixelBounds(center),tileRange=this._pxBoundsToTileRange(pixelBounds),tileCenter=tileRange.getCenter(),queue=[],margin=this.options.keepBuffer,noPruneRange=new Bounds(tileRange.getBottomLeft().subtract([margin,-margin]),tileRange.getTopRight().add([margin,-margin]));if(!(isFinite(tileRange.min.x)&&isFinite(tileRange.min.y)&&isFinite(tileRange.max.x)&&isFinite(tileRange.max.y)))throw new Error("Attempted to load an infinite number of tiles");for(var key in this._tiles){var c=this._tiles[key].coords;c.z===this._tileZoom&&noPruneRange.contains(new Point(c.x,c.y))||(this._tiles[key].current=!1)}if(Math.abs(zoom-this._tileZoom)>1)return void this._setView(center,zoom);for(var j=tileRange.min.y;j<=tileRange.max.y;j++)for(var i=tileRange.min.x;i<=tileRange.max.x;i++){var coords=new Point(i,j);if(coords.z=this._tileZoom,this._isValidTile(coords)){var tile=this._tiles[this._tileCoordsToKey(coords)];tile?tile.current=!0:queue.push(coords)}}if(queue.sort(function(a,b){return a.distanceTo(tileCenter)-b.distanceTo(tileCenter)}),0!==queue.length){this._loading||(this._loading=!0,this.fire("loading"));var fragment=document.createDocumentFragment();for(i=0;i<queue.length;i++)this._addTile(queue[i],fragment);this._level.el.appendChild(fragment)}}}},_isValidTile:function(coords){var crs=this._map.options.crs;if(!crs.infinite){var bounds=this._globalTileRange;if(!crs.wrapLng&&(coords.x<bounds.min.x||coords.x>bounds.max.x)||!crs.wrapLat&&(coords.y<bounds.min.y||coords.y>bounds.max.y))return!1}if(!this.options.bounds)return!0;var tileBounds=this._tileCoordsToBounds(coords);return toLatLngBounds(this.options.bounds).overlaps(tileBounds)},_keyToBounds:function(key){return this._tileCoordsToBounds(this._keyToTileCoords(key))},_tileCoordsToNwSe:function(coords){var map=this._map,tileSize=this.getTileSize(),nwPoint=coords.scaleBy(tileSize),sePoint=nwPoint.add(tileSize);return[map.unproject(nwPoint,coords.z),map.unproject(sePoint,coords.z)]},_tileCoordsToBounds:function(coords){var bp=this._tileCoordsToNwSe(coords),bounds=new LatLngBounds(bp[0],bp[1]);return this.options.noWrap||(bounds=this._map.wrapLatLngBounds(bounds)),bounds},_tileCoordsToKey:function(coords){return coords.x+":"+coords.y+":"+coords.z},_keyToTileCoords:function(key){var k=key.split(":"),coords=new Point(+k[0],+k[1]);return coords.z=+k[2],coords},_removeTile:function(key){var tile=this._tiles[key];tile&&(androidStock||tile.el.setAttribute("src",emptyImageUrl),remove(tile.el),delete this._tiles[key],this.fire("tileunload",{tile:tile.el,coords:this._keyToTileCoords(key)}))},_initTile:function(tile){addClass(tile,"leaflet-tile");var tileSize=this.getTileSize();tile.style.width=tileSize.x+"px",tile.style.height=tileSize.y+"px",tile.onselectstart=falseFn,tile.onmousemove=falseFn,ielt9&&this.options.opacity<1&&setOpacity(tile,this.options.opacity),android&&!android23&&(tile.style.WebkitBackfaceVisibility="hidden")},_addTile:function(coords,container){var tilePos=this._getTilePos(coords),key=this._tileCoordsToKey(coords),tile=this.createTile(this._wrapCoords(coords),bind(this._tileReady,this,coords));this._initTile(tile),this.createTile.length<2&&requestAnimFrame(bind(this._tileReady,this,coords,null,tile)),setPosition(tile,tilePos),this._tiles[key]={el:tile,coords:coords,current:!0},container.appendChild(tile),this.fire("tileloadstart",{tile:tile,coords:coords})},_tileReady:function(coords,err,tile){if(this._map){err&&this.fire("tileerror",{error:err,tile:tile,coords:coords});var key=this._tileCoordsToKey(coords);tile=this._tiles[key],tile&&(tile.loaded=+new Date,this._map._fadeAnimated?(setOpacity(tile.el,0),cancelAnimFrame(this._fadeFrame),this._fadeFrame=requestAnimFrame(this._updateOpacity,this)):(tile.active=!0,this._pruneTiles()),err||(addClass(tile.el,"leaflet-tile-loaded"),this.fire("tileload",{tile:tile.el,coords:coords})),this._noTilesToLoad()&&(this._loading=!1,this.fire("load"),ielt9||!this._map._fadeAnimated?requestAnimFrame(this._pruneTiles,this):setTimeout(bind(this._pruneTiles,this),250)))}},_getTilePos:function(coords){return coords.scaleBy(this.getTileSize()).subtract(this._level.origin)},_wrapCoords:function(coords){var newCoords=new Point(this._wrapX?wrapNum(coords.x,this._wrapX):coords.x,this._wrapY?wrapNum(coords.y,this._wrapY):coords.y);return newCoords.z=coords.z,newCoords},_pxBoundsToTileRange:function(bounds){var tileSize=this.getTileSize();return new Bounds(bounds.min.unscaleBy(tileSize).floor(),bounds.max.unscaleBy(tileSize).ceil().subtract([1,1]))},_noTilesToLoad:function(){for(var key in this._tiles)if(!this._tiles[key].loaded)return!1;return!0}}),TileLayer=GridLayer.extend({options:{minZoom:0,maxZoom:18,subdomains:"abc",errorTileUrl:"",zoomOffset:0,tms:!1,zoomReverse:!1,detectRetina:!1,crossOrigin:!1},initialize:function(url,options){this._url=url,options=setOptions(this,options),options.detectRetina&&retina&&options.maxZoom>0&&(options.tileSize=Math.floor(options.tileSize/2),options.zoomReverse?(options.zoomOffset--,options.minZoom++):(options.zoomOffset++,options.maxZoom--),options.minZoom=Math.max(0,options.minZoom)),"string"==typeof options.subdomains&&(options.subdomains=options.subdomains.split("")),android||this.on("tileunload",this._onTileRemove)},setUrl:function(url,noRedraw){return this._url=url,noRedraw||this.redraw(),this},createTile:function(coords,done){var tile=document.createElement("img");return on(tile,"load",bind(this._tileOnLoad,this,done,tile)),on(tile,"error",bind(this._tileOnError,this,done,tile)),this.options.crossOrigin&&(tile.crossOrigin=""),tile.alt="",tile.setAttribute("role","presentation"),tile.src=this.getTileUrl(coords),tile},getTileUrl:function(coords){var data={r:retina?"@2x":"",s:this._getSubdomain(coords),x:coords.x,y:coords.y,z:this._getZoomForUrl()};if(this._map&&!this._map.options.crs.infinite){var invertedY=this._globalTileRange.max.y-coords.y;this.options.tms&&(data.y=invertedY),data["-y"]=invertedY}return template(this._url,extend(data,this.options))},_tileOnLoad:function(done,tile){ielt9?setTimeout(bind(done,this,null,tile),0):done(null,tile)},_tileOnError:function(done,tile,e){var errorUrl=this.options.errorTileUrl;errorUrl&&tile.getAttribute("src")!==errorUrl&&(tile.src=errorUrl),done(e,tile)},_onTileRemove:function(e){e.tile.onload=null},_getZoomForUrl:function(){var zoom=this._tileZoom,maxZoom=this.options.maxZoom,zoomReverse=this.options.zoomReverse,zoomOffset=this.options.zoomOffset;return zoomReverse&&(zoom=maxZoom-zoom),zoom+zoomOffset},_getSubdomain:function(tilePoint){var index=Math.abs(tilePoint.x+tilePoint.y)%this.options.subdomains.length;return this.options.subdomains[index]},_abortLoading:function(){var i,tile;for(i in this._tiles)this._tiles[i].coords.z!==this._tileZoom&&(tile=this._tiles[i].el,tile.onload=falseFn,tile.onerror=falseFn,tile.complete||(tile.src=emptyImageUrl,remove(tile),delete this._tiles[i]))}}),TileLayerWMS=TileLayer.extend({defaultWmsParams:{service:"WMS",request:"GetMap",layers:"",styles:"",format:"image/jpeg",transparent:!1,version:"1.1.1"},options:{crs:null,uppercase:!1},initialize:function(url,options){this._url=url;var wmsParams=extend({},this.defaultWmsParams);for(var i in options)i in this.options||(wmsParams[i]=options[i]);options=setOptions(this,options);var realRetina=options.detectRetina&&retina?2:1,tileSize=this.getTileSize();wmsParams.width=tileSize.x*realRetina,wmsParams.height=tileSize.y*realRetina,this.wmsParams=wmsParams},onAdd:function(map){this._crs=this.options.crs||map.options.crs,this._wmsVersion=parseFloat(this.wmsParams.version);var projectionKey=this._wmsVersion>=1.3?"crs":"srs";this.wmsParams[projectionKey]=this._crs.code,TileLayer.prototype.onAdd.call(this,map)},getTileUrl:function(coords){var tileBounds=this._tileCoordsToNwSe(coords),crs=this._crs,bounds=toBounds(crs.project(tileBounds[0]),crs.project(tileBounds[1])),min=bounds.min,max=bounds.max,bbox=(this._wmsVersion>=1.3&&this._crs===EPSG4326?[min.y,min.x,max.y,max.x]:[min.x,min.y,max.x,max.y]).join(","),url=L.TileLayer.prototype.getTileUrl.call(this,coords);return url+getParamString(this.wmsParams,url,this.options.uppercase)+(this.options.uppercase?"&BBOX=":"&bbox=")+bbox},setParams:function(params,noRedraw){return extend(this.wmsParams,params),noRedraw||this.redraw(),this}});TileLayer.WMS=TileLayerWMS,tileLayer.wms=tileLayerWMS;var Renderer=Layer.extend({options:{padding:.1,tolerance:0},initialize:function(options){setOptions(this,options),stamp(this),this._layers=this._layers||{}},onAdd:function(){this._container||(this._initContainer(),this._zoomAnimated&&addClass(this._container,"leaflet-zoom-animated")),this.getPane().appendChild(this._container),this._update(),this.on("update",this._updatePaths,this)},onRemove:function(){this.off("update",this._updatePaths,this),this._destroyContainer()},getEvents:function(){var events={viewreset:this._reset,zoom:this._onZoom,moveend:this._update,zoomend:this._onZoomEnd};return this._zoomAnimated&&(events.zoomanim=this._onAnimZoom),events},_onAnimZoom:function(ev){this._updateTransform(ev.center,ev.zoom)},_onZoom:function(){this._updateTransform(this._map.getCenter(),this._map.getZoom())},_updateTransform:function(center,zoom){var scale=this._map.getZoomScale(zoom,this._zoom),position=getPosition(this._container),viewHalf=this._map.getSize().multiplyBy(.5+this.options.padding),currentCenterPoint=this._map.project(this._center,zoom),destCenterPoint=this._map.project(center,zoom),centerOffset=destCenterPoint.subtract(currentCenterPoint),topLeftOffset=viewHalf.multiplyBy(-scale).add(position).add(viewHalf).subtract(centerOffset);any3d?setTransform(this._container,topLeftOffset,scale):setPosition(this._container,topLeftOffset)},_reset:function(){this._update(),this._updateTransform(this._center,this._zoom);for(var id in this._layers)this._layers[id]._reset()},_onZoomEnd:function(){for(var id in this._layers)this._layers[id]._project()},_updatePaths:function(){for(var id in this._layers)this._layers[id]._update()},_update:function(){var p=this.options.padding,size=this._map.getSize(),min=this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();this._bounds=new Bounds(min,min.add(size.multiplyBy(1+2*p)).round()),this._center=this._map.getCenter(),this._zoom=this._map.getZoom()}}),Canvas=Renderer.extend({getEvents:function(){var events=Renderer.prototype.getEvents.call(this);return events.viewprereset=this._onViewPreReset,events},_onViewPreReset:function(){this._postponeUpdatePaths=!0},onAdd:function(){Renderer.prototype.onAdd.call(this),this._draw()},_initContainer:function(){var container=this._container=document.createElement("canvas");on(container,"mousemove",throttle(this._onMouseMove,32,this),this),on(container,"click dblclick mousedown mouseup contextmenu",this._onClick,this),on(container,"mouseout",this._handleMouseOut,this),this._ctx=container.getContext("2d")},_destroyContainer:function(){delete this._ctx,remove(this._container),off(this._container),delete this._container},_updatePaths:function(){if(!this._postponeUpdatePaths){var layer;this._redrawBounds=null;for(var id in this._layers)layer=this._layers[id],layer._update();this._redraw()}},_update:function(){if(!this._map._animatingZoom||!this._bounds){this._drawnLayers={},Renderer.prototype._update.call(this);var b=this._bounds,container=this._container,size=b.getSize(),m=retina?2:1;setPosition(container,b.min),container.width=m*size.x,container.height=m*size.y,container.style.width=size.x+"px",container.style.height=size.y+"px",retina&&this._ctx.scale(2,2),this._ctx.translate(-b.min.x,-b.min.y),this.fire("update")}},_reset:function(){Renderer.prototype._reset.call(this),this._postponeUpdatePaths&&(this._postponeUpdatePaths=!1,this._updatePaths())},_initPath:function(layer){this._updateDashArray(layer),this._layers[stamp(layer)]=layer;var order=layer._order={layer:layer,prev:this._drawLast,next:null};this._drawLast&&(this._drawLast.next=order),this._drawLast=order,this._drawFirst=this._drawFirst||this._drawLast},_addPath:function(layer){this._requestRedraw(layer)},_removePath:function(layer){var order=layer._order,next=order.next,prev=order.prev;next?next.prev=prev:this._drawLast=prev,prev?prev.next=next:this._drawFirst=next,delete layer._order,delete this._layers[L.stamp(layer)],this._requestRedraw(layer)},_updatePath:function(layer){this._extendRedrawBounds(layer),layer._project(),layer._update(),this._requestRedraw(layer)},_updateStyle:function(layer){this._updateDashArray(layer),this._requestRedraw(layer)},_updateDashArray:function(layer){if(layer.options.dashArray){var i,parts=layer.options.dashArray.split(","),dashArray=[];for(i=0;i<parts.length;i++)dashArray.push(Number(parts[i]));layer.options._dashArray=dashArray}},_requestRedraw:function(layer){this._map&&(this._extendRedrawBounds(layer),this._redrawRequest=this._redrawRequest||requestAnimFrame(this._redraw,this))},_extendRedrawBounds:function(layer){if(layer._pxBounds){var padding=(layer.options.weight||0)+1;this._redrawBounds=this._redrawBounds||new Bounds,this._redrawBounds.extend(layer._pxBounds.min.subtract([padding,padding])),this._redrawBounds.extend(layer._pxBounds.max.add([padding,padding]))}},_redraw:function(){this._redrawRequest=null,this._redrawBounds&&(this._redrawBounds.min._floor(),this._redrawBounds.max._ceil()),this._clear(),this._draw(),this._redrawBounds=null},_clear:function(){var bounds=this._redrawBounds;if(bounds){var size=bounds.getSize();this._ctx.clearRect(bounds.min.x,bounds.min.y,size.x,size.y)}else this._ctx.clearRect(0,0,this._container.width,this._container.height)},_draw:function(){var layer,bounds=this._redrawBounds;if(this._ctx.save(),bounds){var size=bounds.getSize();this._ctx.beginPath(),this._ctx.rect(bounds.min.x,bounds.min.y,size.x,size.y),this._ctx.clip()}this._drawing=!0;for(var order=this._drawFirst;order;order=order.next)layer=order.layer,(!bounds||layer._pxBounds&&layer._pxBounds.intersects(bounds))&&layer._updatePath();this._drawing=!1,this._ctx.restore()},_updatePoly:function(layer,closed){if(this._drawing){var i,j,len2,p,parts=layer._parts,len=parts.length,ctx=this._ctx;if(len){for(this._drawnLayers[layer._leaflet_id]=layer,ctx.beginPath(),i=0;i<len;i++){for(j=0,len2=parts[i].length;j<len2;j++)p=parts[i][j],ctx[j?"lineTo":"moveTo"](p.x,p.y);closed&&ctx.closePath()}this._fillStroke(ctx,layer)}}},_updateCircle:function(layer){if(this._drawing&&!layer._empty()){var p=layer._point,ctx=this._ctx,r=Math.max(Math.round(layer._radius),1),s=(Math.max(Math.round(layer._radiusY),1)||r)/r;this._drawnLayers[layer._leaflet_id]=layer,1!==s&&(ctx.save(),ctx.scale(1,s)),ctx.beginPath(),ctx.arc(p.x,p.y/s,r,0,2*Math.PI,!1),1!==s&&ctx.restore(),this._fillStroke(ctx,layer)}},_fillStroke:function(ctx,layer){var options=layer.options;options.fill&&(ctx.globalAlpha=options.fillOpacity,ctx.fillStyle=options.fillColor||options.color,ctx.fill(options.fillRule||"evenodd")),options.stroke&&0!==options.weight&&(ctx.setLineDash&&ctx.setLineDash(layer.options&&layer.options._dashArray||[]),ctx.globalAlpha=options.opacity,ctx.lineWidth=options.weight,ctx.strokeStyle=options.color,ctx.lineCap=options.lineCap,ctx.lineJoin=options.lineJoin,ctx.stroke())},_onClick:function(e){for(var layer,clickedLayer,point=this._map.mouseEventToLayerPoint(e),order=this._drawFirst;order;order=order.next)layer=order.layer,layer.options.interactive&&layer._containsPoint(point)&&!this._map._draggableMoved(layer)&&(clickedLayer=layer);clickedLayer&&(fakeStop(e),this._fireEvent([clickedLayer],e))},_onMouseMove:function(e){if(this._map&&!this._map.dragging.moving()&&!this._map._animatingZoom){var point=this._map.mouseEventToLayerPoint(e);this._handleMouseHover(e,point)}},_handleMouseOut:function(e){var layer=this._hoveredLayer;layer&&(removeClass(this._container,"leaflet-interactive"),this._fireEvent([layer],e,"mouseout"),this._hoveredLayer=null)},_handleMouseHover:function(e,point){for(var layer,candidateHoveredLayer,order=this._drawFirst;order;order=order.next)layer=order.layer,layer.options.interactive&&layer._containsPoint(point)&&(candidateHoveredLayer=layer);candidateHoveredLayer!==this._hoveredLayer&&(this._handleMouseOut(e),candidateHoveredLayer&&(addClass(this._container,"leaflet-interactive"),this._fireEvent([candidateHoveredLayer],e,"mouseover"),this._hoveredLayer=candidateHoveredLayer)),this._hoveredLayer&&this._fireEvent([this._hoveredLayer],e)},_fireEvent:function(layers,e,type){this._map._fireDOMEvent(e,type||e.type,layers)},_bringToFront:function(layer){var order=layer._order,next=order.next,prev=order.prev;next&&(next.prev=prev,prev?prev.next=next:next&&(this._drawFirst=next),order.prev=this._drawLast,this._drawLast.next=order,order.next=null,this._drawLast=order,this._requestRedraw(layer))},_bringToBack:function(layer){var order=layer._order,next=order.next,prev=order.prev;prev&&(prev.next=next,next?next.prev=prev:prev&&(this._drawLast=prev),order.prev=null,order.next=this._drawFirst,this._drawFirst.prev=order,this._drawFirst=order,this._requestRedraw(layer))}}),vmlCreate=function(){try{return document.namespaces.add("lvml","urn:schemas-microsoft-com:vml"),function(name){return document.createElement("<lvml:"+name+' class="lvml">')}}catch(e){return function(name){return document.createElement("<"+name+' xmlns="urn:schemas-microsoft.com:vml" class="lvml">')}}}(),vmlMixin={_initContainer:function(){this._container=create$1("div","leaflet-vml-container")},_update:function(){this._map._animatingZoom||(Renderer.prototype._update.call(this),this.fire("update"))},_initPath:function(layer){var container=layer._container=vmlCreate("shape");addClass(container,"leaflet-vml-shape "+(this.options.className||"")),container.coordsize="1 1",layer._path=vmlCreate("path"),container.appendChild(layer._path),this._updateStyle(layer),this._layers[stamp(layer)]=layer},_addPath:function(layer){var container=layer._container;this._container.appendChild(container),layer.options.interactive&&layer.addInteractiveTarget(container)},_removePath:function(layer){var container=layer._container;remove(container),layer.removeInteractiveTarget(container),delete this._layers[stamp(layer)]},_updateStyle:function(layer){var stroke=layer._stroke,fill=layer._fill,options=layer.options,container=layer._container;container.stroked=!!options.stroke,container.filled=!!options.fill,options.stroke?(stroke||(stroke=layer._stroke=vmlCreate("stroke")),container.appendChild(stroke),stroke.weight=options.weight+"px",stroke.color=options.color,stroke.opacity=options.opacity,options.dashArray?stroke.dashStyle=isArray(options.dashArray)?options.dashArray.join(" "):options.dashArray.replace(/( *, *)/g," "):stroke.dashStyle="",stroke.endcap=options.lineCap.replace("butt","flat"),stroke.joinstyle=options.lineJoin):stroke&&(container.removeChild(stroke),layer._stroke=null),options.fill?(fill||(fill=layer._fill=vmlCreate("fill")),container.appendChild(fill),fill.color=options.fillColor||options.color,fill.opacity=options.fillOpacity):fill&&(container.removeChild(fill),layer._fill=null)},_updateCircle:function(layer){var p=layer._point.round(),r=Math.round(layer._radius),r2=Math.round(layer._radiusY||r);this._setPath(layer,layer._empty()?"M0 0":"AL "+p.x+","+p.y+" "+r+","+r2+" 0,23592600")},_setPath:function(layer,path){layer._path.v=path},_bringToFront:function(layer){toFront(layer._container)},_bringToBack:function(layer){toBack(layer._container)}},create$2=vml?vmlCreate:svgCreate,SVG=Renderer.extend({getEvents:function(){var events=Renderer.prototype.getEvents.call(this);return events.zoomstart=this._onZoomStart,events},_initContainer:function(){this._container=create$2("svg"),this._container.setAttribute("pointer-events","none"),this._rootGroup=create$2("g"),this._container.appendChild(this._rootGroup)},_destroyContainer:function(){remove(this._container),off(this._container),delete this._container,delete this._rootGroup,delete this._svgSize},_onZoomStart:function(){this._update()},_update:function(){if(!this._map._animatingZoom||!this._bounds){Renderer.prototype._update.call(this);var b=this._bounds,size=b.getSize(),container=this._container;this._svgSize&&this._svgSize.equals(size)||(this._svgSize=size,container.setAttribute("width",size.x),container.setAttribute("height",size.y)),setPosition(container,b.min),container.setAttribute("viewBox",[b.min.x,b.min.y,size.x,size.y].join(" ")),this.fire("update")}},_initPath:function(layer){var path=layer._path=create$2("path");layer.options.className&&addClass(path,layer.options.className),layer.options.interactive&&addClass(path,"leaflet-interactive"),this._updateStyle(layer),this._layers[stamp(layer)]=layer},_addPath:function(layer){this._rootGroup||this._initContainer(),this._rootGroup.appendChild(layer._path),layer.addInteractiveTarget(layer._path)},_removePath:function(layer){remove(layer._path),layer.removeInteractiveTarget(layer._path),delete this._layers[stamp(layer)]},_updatePath:function(layer){layer._project(),layer._update()},_updateStyle:function(layer){var path=layer._path,options=layer.options;path&&(options.stroke?(path.setAttribute("stroke",options.color),path.setAttribute("stroke-opacity",options.opacity),path.setAttribute("stroke-width",options.weight),path.setAttribute("stroke-linecap",options.lineCap),path.setAttribute("stroke-linejoin",options.lineJoin),options.dashArray?path.setAttribute("stroke-dasharray",options.dashArray):path.removeAttribute("stroke-dasharray"),options.dashOffset?path.setAttribute("stroke-dashoffset",options.dashOffset):path.removeAttribute("stroke-dashoffset")):path.setAttribute("stroke","none"),options.fill?(path.setAttribute("fill",options.fillColor||options.color),path.setAttribute("fill-opacity",options.fillOpacity),path.setAttribute("fill-rule",options.fillRule||"evenodd")):path.setAttribute("fill","none"))},_updatePoly:function(layer,closed){this._setPath(layer,pointsToPath(layer._parts,closed))},_updateCircle:function(layer){var p=layer._point,r=Math.max(Math.round(layer._radius),1),r2=Math.max(Math.round(layer._radiusY),1)||r,arc="a"+r+","+r2+" 0 1,0 ",d=layer._empty()?"M0 0":"M"+(p.x-r)+","+p.y+arc+2*r+",0 "+arc+2*-r+",0 ";this._setPath(layer,d)},_setPath:function(layer,path){layer._path.setAttribute("d",path)},_bringToFront:function(layer){toFront(layer._path)},_bringToBack:function(layer){toBack(layer._path)}});vml&&SVG.include(vmlMixin),Map.include({getRenderer:function(layer){var renderer=layer.options.renderer||this._getPaneRenderer(layer.options.pane)||this.options.renderer||this._renderer;return renderer||(renderer=this._renderer=this.options.preferCanvas&&canvas$1()||svg$1()),this.hasLayer(renderer)||this.addLayer(renderer),renderer},_getPaneRenderer:function(name){if("overlayPane"===name||void 0===name)return!1;var renderer=this._paneRenderers[name];return void 0===renderer&&(renderer=SVG&&svg$1({pane:name})||Canvas&&canvas$1({pane:name}),this._paneRenderers[name]=renderer),renderer}});var Rectangle=Polygon.extend({initialize:function(latLngBounds,options){Polygon.prototype.initialize.call(this,this._boundsToLatLngs(latLngBounds),options)},setBounds:function(latLngBounds){return this.setLatLngs(this._boundsToLatLngs(latLngBounds))},_boundsToLatLngs:function(latLngBounds){return latLngBounds=toLatLngBounds(latLngBounds),[latLngBounds.getSouthWest(),latLngBounds.getNorthWest(),latLngBounds.getNorthEast(),latLngBounds.getSouthEast()]}});SVG.create=create$2,SVG.pointsToPath=pointsToPath,GeoJSON.geometryToLayer=geometryToLayer,GeoJSON.coordsToLatLng=coordsToLatLng,GeoJSON.coordsToLatLngs=coordsToLatLngs,GeoJSON.latLngToCoords=latLngToCoords,GeoJSON.latLngsToCoords=latLngsToCoords,GeoJSON.getFeature=getFeature,GeoJSON.asFeature=asFeature,Map.mergeOptions({boxZoom:!0});var BoxZoom=Handler.extend({initialize:function(map){this._map=map,this._container=map._container,this._pane=map._panes.overlayPane,this._resetStateTimeout=0,map.on("unload",this._destroy,this)},addHooks:function(){on(this._container,"mousedown",this._onMouseDown,this)},removeHooks:function(){off(this._container,"mousedown",this._onMouseDown,this)},moved:function(){return this._moved},_destroy:function(){remove(this._pane),delete this._pane},_resetState:function(){this._resetStateTimeout=0,this._moved=!1},_clearDeferredResetState:function(){0!==this._resetStateTimeout&&(clearTimeout(this._resetStateTimeout),this._resetStateTimeout=0)},_onMouseDown:function(e){if(!e.shiftKey||1!==e.which&&1!==e.button)return!1;this._clearDeferredResetState(),this._resetState(),disableTextSelection(),disableImageDrag(),this._startPoint=this._map.mouseEventToContainerPoint(e),on(document,{contextmenu:stop,mousemove:this._onMouseMove,mouseup:this._onMouseUp,keydown:this._onKeyDown},this)},_onMouseMove:function(e){this._moved||(this._moved=!0,this._box=create$1("div","leaflet-zoom-box",this._container),addClass(this._container,"leaflet-crosshair"),this._map.fire("boxzoomstart")),this._point=this._map.mouseEventToContainerPoint(e);var bounds=new Bounds(this._point,this._startPoint),size=bounds.getSize();setPosition(this._box,bounds.min),this._box.style.width=size.x+"px",this._box.style.height=size.y+"px"},_finish:function(){this._moved&&(remove(this._box),removeClass(this._container,"leaflet-crosshair")),enableTextSelection(),enableImageDrag(),off(document,{contextmenu:stop,mousemove:this._onMouseMove,mouseup:this._onMouseUp,keydown:this._onKeyDown},this)},_onMouseUp:function(e){if((1===e.which||1===e.button)&&(this._finish(),this._moved)){this._clearDeferredResetState(),this._resetStateTimeout=setTimeout(bind(this._resetState,this),0);var bounds=new LatLngBounds(this._map.containerPointToLatLng(this._startPoint),this._map.containerPointToLatLng(this._point));this._map.fitBounds(bounds).fire("boxzoomend",{boxZoomBounds:bounds})}},_onKeyDown:function(e){27===e.keyCode&&this._finish()}});Map.addInitHook("addHandler","boxZoom",BoxZoom),Map.mergeOptions({doubleClickZoom:!0});var DoubleClickZoom=Handler.extend({addHooks:function(){this._map.on("dblclick",this._onDoubleClick,this)},removeHooks:function(){this._map.off("dblclick",this._onDoubleClick,this)},_onDoubleClick:function(e){var map=this._map,oldZoom=map.getZoom(),delta=map.options.zoomDelta,zoom=e.originalEvent.shiftKey?oldZoom-delta:oldZoom+delta;"center"===map.options.doubleClickZoom?map.setZoom(zoom):map.setZoomAround(e.containerPoint,zoom)}});Map.addInitHook("addHandler","doubleClickZoom",DoubleClickZoom),Map.mergeOptions({dragging:!0,inertia:!android23,inertiaDeceleration:3400,inertiaMaxSpeed:1/0,easeLinearity:.2,worldCopyJump:!1,maxBoundsViscosity:0});var Drag=Handler.extend({addHooks:function(){if(!this._draggable){var map=this._map;this._draggable=new Draggable(map._mapPane,map._container),this._draggable.on({dragstart:this._onDragStart,drag:this._onDrag,dragend:this._onDragEnd},this),this._draggable.on("predrag",this._onPreDragLimit,this),map.options.worldCopyJump&&(this._draggable.on("predrag",this._onPreDragWrap,this),map.on("zoomend",this._onZoomEnd,this),map.whenReady(this._onZoomEnd,this))}addClass(this._map._container,"leaflet-grab leaflet-touch-drag"),this._draggable.enable(),this._positions=[],this._times=[]},removeHooks:function(){removeClass(this._map._container,"leaflet-grab"),removeClass(this._map._container,"leaflet-touch-drag"),this._draggable.disable()},moved:function(){return this._draggable&&this._draggable._moved},moving:function(){return this._draggable&&this._draggable._moving},_onDragStart:function(){var map=this._map;if(map._stop(),this._map.options.maxBounds&&this._map.options.maxBoundsViscosity){var bounds=toLatLngBounds(this._map.options.maxBounds);this._offsetLimit=toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1),this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize())),this._viscosity=Math.min(1,Math.max(0,this._map.options.maxBoundsViscosity))}else this._offsetLimit=null;map.fire("movestart").fire("dragstart"),map.options.inertia&&(this._positions=[],this._times=[])},_onDrag:function(e){if(this._map.options.inertia){var time=this._lastTime=+new Date,pos=this._lastPos=this._draggable._absPos||this._draggable._newPos;this._positions.push(pos),this._times.push(time),this._prunePositions(time)}this._map.fire("move",e).fire("drag",e)},_prunePositions:function(time){for(;this._positions.length>1&&time-this._times[0]>50;)this._positions.shift(),this._times.shift()},_onZoomEnd:function(){var pxCenter=this._map.getSize().divideBy(2),pxWorldCenter=this._map.latLngToLayerPoint([0,0]);this._initialWorldOffset=pxWorldCenter.subtract(pxCenter).x,this._worldWidth=this._map.getPixelWorldBounds().getSize().x},_viscousLimit:function(value,threshold){return value-(value-threshold)*this._viscosity},_onPreDragLimit:function(){if(this._viscosity&&this._offsetLimit){var offset=this._draggable._newPos.subtract(this._draggable._startPos),limit=this._offsetLimit;offset.x<limit.min.x&&(offset.x=this._viscousLimit(offset.x,limit.min.x)),offset.y<limit.min.y&&(offset.y=this._viscousLimit(offset.y,limit.min.y)),offset.x>limit.max.x&&(offset.x=this._viscousLimit(offset.x,limit.max.x)),offset.y>limit.max.y&&(offset.y=this._viscousLimit(offset.y,limit.max.y)),this._draggable._newPos=this._draggable._startPos.add(offset)}},_onPreDragWrap:function(){var worldWidth=this._worldWidth,halfWidth=Math.round(worldWidth/2),dx=this._initialWorldOffset,x=this._draggable._newPos.x,newX1=(x-halfWidth+dx)%worldWidth+halfWidth-dx,newX2=(x+halfWidth+dx)%worldWidth-halfWidth-dx,newX=Math.abs(newX1+dx)<Math.abs(newX2+dx)?newX1:newX2;this._draggable._absPos=this._draggable._newPos.clone(),this._draggable._newPos.x=newX},_onDragEnd:function(e){var map=this._map,options=map.options,noInertia=!options.inertia||this._times.length<2;if(map.fire("dragend",e),noInertia)map.fire("moveend");else{this._prunePositions(+new Date);var direction=this._lastPos.subtract(this._positions[0]),duration=(this._lastTime-this._times[0])/1e3,ease=options.easeLinearity,speedVector=direction.multiplyBy(ease/duration),speed=speedVector.distanceTo([0,0]),limitedSpeed=Math.min(options.inertiaMaxSpeed,speed),limitedSpeedVector=speedVector.multiplyBy(limitedSpeed/speed),decelerationDuration=limitedSpeed/(options.inertiaDeceleration*ease),offset=limitedSpeedVector.multiplyBy(-decelerationDuration/2).round();offset.x||offset.y?(offset=map._limitOffset(offset,map.options.maxBounds),requestAnimFrame(function(){map.panBy(offset,{duration:decelerationDuration,easeLinearity:ease,noMoveStart:!0,animate:!0})})):map.fire("moveend")}}});Map.addInitHook("addHandler","dragging",Drag),Map.mergeOptions({keyboard:!0,keyboardPanDelta:80});var Keyboard=Handler.extend({keyCodes:{left:[37],right:[39],down:[40],up:[38],zoomIn:[187,107,61,171],zoomOut:[189,109,54,173]},initialize:function(map){this._map=map,this._setPanDelta(map.options.keyboardPanDelta),this._setZoomDelta(map.options.zoomDelta)},addHooks:function(){var container=this._map._container;container.tabIndex<=0&&(container.tabIndex="0"),on(container,{focus:this._onFocus,blur:this._onBlur,mousedown:this._onMouseDown},this),this._map.on({focus:this._addHooks,blur:this._removeHooks},this)},removeHooks:function(){this._removeHooks(),off(this._map._container,{focus:this._onFocus,blur:this._onBlur,mousedown:this._onMouseDown},this),this._map.off({focus:this._addHooks,blur:this._removeHooks},this)},_onMouseDown:function(){if(!this._focused){var body=document.body,docEl=document.documentElement,top=body.scrollTop||docEl.scrollTop,left=body.scrollLeft||docEl.scrollLeft;this._map._container.focus(),window.scrollTo(left,top)}},_onFocus:function(){this._focused=!0,this._map.fire("focus")},_onBlur:function(){this._focused=!1,this._map.fire("blur")},_setPanDelta:function(panDelta){var i,len,keys=this._panKeys={},codes=this.keyCodes;for(i=0,len=codes.left.length;i<len;i++)keys[codes.left[i]]=[-1*panDelta,0];for(i=0,len=codes.right.length;i<len;i++)keys[codes.right[i]]=[panDelta,0];for(i=0,len=codes.down.length;i<len;i++)keys[codes.down[i]]=[0,panDelta];for(i=0,len=codes.up.length;i<len;i++)keys[codes.up[i]]=[0,-1*panDelta]},_setZoomDelta:function(zoomDelta){var i,len,keys=this._zoomKeys={},codes=this.keyCodes;for(i=0,len=codes.zoomIn.length;i<len;i++)keys[codes.zoomIn[i]]=zoomDelta;for(i=0,len=codes.zoomOut.length;i<len;i++)keys[codes.zoomOut[i]]=-zoomDelta},_addHooks:function(){on(document,"keydown",this._onKeyDown,this)},_removeHooks:function(){off(document,"keydown",this._onKeyDown,this)},_onKeyDown:function(e){if(!(e.altKey||e.ctrlKey||e.metaKey)){var offset,key=e.keyCode,map=this._map;if(key in this._panKeys){if(map._panAnim&&map._panAnim._inProgress)return;offset=this._panKeys[key],e.shiftKey&&(offset=toPoint(offset).multiplyBy(3)),map.panBy(offset),map.options.maxBounds&&map.panInsideBounds(map.options.maxBounds)}else if(key in this._zoomKeys)map.setZoom(map.getZoom()+(e.shiftKey?3:1)*this._zoomKeys[key]);else{if(27!==key||!map._popup||!map._popup.options.closeOnEscapeKey)return;map.closePopup()}stop(e)}}});Map.addInitHook("addHandler","keyboard",Keyboard),Map.mergeOptions({scrollWheelZoom:!0,wheelDebounceTime:40,wheelPxPerZoomLevel:60});var ScrollWheelZoom=Handler.extend({addHooks:function(){on(this._map._container,"mousewheel",this._onWheelScroll,this),this._delta=0},removeHooks:function(){off(this._map._container,"mousewheel",this._onWheelScroll,this)},_onWheelScroll:function(e){var delta=getWheelDelta(e),debounce=this._map.options.wheelDebounceTime;this._delta+=delta,this._lastMousePos=this._map.mouseEventToContainerPoint(e),this._startTime||(this._startTime=+new Date);var left=Math.max(debounce-(+new Date-this._startTime),0);clearTimeout(this._timer),this._timer=setTimeout(bind(this._performZoom,this),left),stop(e)},_performZoom:function(){var map=this._map,zoom=map.getZoom(),snap=this._map.options.zoomSnap||0;map._stop();var d2=this._delta/(4*this._map.options.wheelPxPerZoomLevel),d3=4*Math.log(2/(1+Math.exp(-Math.abs(d2))))/Math.LN2,d4=snap?Math.ceil(d3/snap)*snap:d3,delta=map._limitZoom(zoom+(this._delta>0?d4:-d4))-zoom;this._delta=0,this._startTime=null,delta&&("center"===map.options.scrollWheelZoom?map.setZoom(zoom+delta):map.setZoomAround(this._lastMousePos,zoom+delta))}});Map.addInitHook("addHandler","scrollWheelZoom",ScrollWheelZoom),Map.mergeOptions({tap:!0,tapTolerance:15});var Tap=Handler.extend({addHooks:function(){on(this._map._container,"touchstart",this._onDown,this)},removeHooks:function(){off(this._map._container,"touchstart",this._onDown,this)},_onDown:function(e){if(e.touches){if(preventDefault(e),this._fireClick=!0,e.touches.length>1)return this._fireClick=!1,void clearTimeout(this._holdTimeout);var first=e.touches[0],el=first.target;this._startPos=this._newPos=new Point(first.clientX,first.clientY),el.tagName&&"a"===el.tagName.toLowerCase()&&addClass(el,"leaflet-active"),this._holdTimeout=setTimeout(bind(function(){this._isTapValid()&&(this._fireClick=!1,this._onUp(),this._simulateEvent("contextmenu",first))},this),1e3),this._simulateEvent("mousedown",first),on(document,{touchmove:this._onMove,touchend:this._onUp},this)}},_onUp:function(e){if(clearTimeout(this._holdTimeout),off(document,{touchmove:this._onMove,touchend:this._onUp},this),this._fireClick&&e&&e.changedTouches){var first=e.changedTouches[0],el=first.target;el&&el.tagName&&"a"===el.tagName.toLowerCase()&&removeClass(el,"leaflet-active"),this._simulateEvent("mouseup",first),this._isTapValid()&&this._simulateEvent("click",first)}},_isTapValid:function(){return this._newPos.distanceTo(this._startPos)<=this._map.options.tapTolerance},_onMove:function(e){var first=e.touches[0];this._newPos=new Point(first.clientX,first.clientY),this._simulateEvent("mousemove",first)},_simulateEvent:function(type,e){var simulatedEvent=document.createEvent("MouseEvents");simulatedEvent._simulated=!0,e.target._simulatedClick=!0,simulatedEvent.initMouseEvent(type,!0,!0,window,1,e.screenX,e.screenY,e.clientX,e.clientY,!1,!1,!1,!1,0,null),e.target.dispatchEvent(simulatedEvent)}});touch&&!pointer&&Map.addInitHook("addHandler","tap",Tap),Map.mergeOptions({touchZoom:touch&&!android23,bounceAtZoomLimits:!0});var TouchZoom=Handler.extend({addHooks:function(){addClass(this._map._container,"leaflet-touch-zoom"),on(this._map._container,"touchstart",this._onTouchStart,this)},removeHooks:function(){removeClass(this._map._container,"leaflet-touch-zoom"),off(this._map._container,"touchstart",this._onTouchStart,this)},_onTouchStart:function(e){var map=this._map;if(e.touches&&2===e.touches.length&&!map._animatingZoom&&!this._zooming){var p1=map.mouseEventToContainerPoint(e.touches[0]),p2=map.mouseEventToContainerPoint(e.touches[1]);this._centerPoint=map.getSize()._divideBy(2),this._startLatLng=map.containerPointToLatLng(this._centerPoint),"center"!==map.options.touchZoom&&(this._pinchStartLatLng=map.containerPointToLatLng(p1.add(p2)._divideBy(2))),this._startDist=p1.distanceTo(p2),this._startZoom=map.getZoom(),this._moved=!1,this._zooming=!0,map._stop(),on(document,"touchmove",this._onTouchMove,this),on(document,"touchend",this._onTouchEnd,this),preventDefault(e)}},_onTouchMove:function(e){if(e.touches&&2===e.touches.length&&this._zooming){var map=this._map,p1=map.mouseEventToContainerPoint(e.touches[0]),p2=map.mouseEventToContainerPoint(e.touches[1]),scale=p1.distanceTo(p2)/this._startDist;if(this._zoom=map.getScaleZoom(scale,this._startZoom),!map.options.bounceAtZoomLimits&&(this._zoom<map.getMinZoom()&&scale<1||this._zoom>map.getMaxZoom()&&scale>1)&&(this._zoom=map._limitZoom(this._zoom)),"center"===map.options.touchZoom){if(this._center=this._startLatLng,1===scale)return}else{var delta=p1._add(p2)._divideBy(2)._subtract(this._centerPoint);if(1===scale&&0===delta.x&&0===delta.y)return;this._center=map.unproject(map.project(this._pinchStartLatLng,this._zoom).subtract(delta),this._zoom)}this._moved||(map._moveStart(!0,!1),this._moved=!0),cancelAnimFrame(this._animRequest);var moveFn=bind(map._move,map,this._center,this._zoom,{pinch:!0,round:!1});this._animRequest=requestAnimFrame(moveFn,this,!0),preventDefault(e)}},_onTouchEnd:function(){if(!this._moved||!this._zooming)return void(this._zooming=!1);this._zooming=!1,cancelAnimFrame(this._animRequest),off(document,"touchmove",this._onTouchMove),off(document,"touchend",this._onTouchEnd),this._map.options.zoomAnimation?this._map._animateZoom(this._center,this._map._limitZoom(this._zoom),!0,this._map.options.zoomSnap):this._map._resetView(this._center,this._map._limitZoom(this._zoom))}});Map.addInitHook("addHandler","touchZoom",TouchZoom),Map.BoxZoom=BoxZoom,Map.DoubleClickZoom=DoubleClickZoom,Map.Drag=Drag,Map.Keyboard=Keyboard,Map.ScrollWheelZoom=ScrollWheelZoom,Map.Tap=Tap,Map.TouchZoom=TouchZoom;var oldL=window.L;window.L=exports,Object.freeze=freeze,exports.version="1.3.1",exports.noConflict=noConflict,exports.Control=Control,exports.control=control,exports.Browser=Browser,exports.Evented=Evented,exports.Mixin=Mixin,exports.Util=Util,exports.Class=Class,exports.Handler=Handler,exports.extend=extend,exports.bind=bind,exports.stamp=stamp,exports.setOptions=setOptions,exports.DomEvent=DomEvent,exports.DomUtil=DomUtil,exports.PosAnimation=PosAnimation,exports.Draggable=Draggable,exports.LineUtil=LineUtil,exports.PolyUtil=PolyUtil,exports.Point=Point,exports.point=toPoint,exports.Bounds=Bounds,exports.bounds=toBounds,exports.Transformation=Transformation,exports.transformation=toTransformation,exports.Projection=index,exports.LatLng=LatLng,exports.latLng=toLatLng,exports.LatLngBounds=LatLngBounds,exports.latLngBounds=toLatLngBounds,exports.CRS=CRS,exports.GeoJSON=GeoJSON,exports.geoJSON=geoJSON,exports.geoJson=geoJson,exports.Layer=Layer,exports.LayerGroup=LayerGroup,exports.layerGroup=layerGroup,exports.FeatureGroup=FeatureGroup,exports.featureGroup=featureGroup,exports.ImageOverlay=ImageOverlay,exports.imageOverlay=imageOverlay,exports.VideoOverlay=VideoOverlay,exports.videoOverlay=videoOverlay,exports.DivOverlay=DivOverlay,exports.Popup=Popup,exports.popup=popup,exports.Tooltip=Tooltip,exports.tooltip=tooltip,exports.Icon=Icon,exports.icon=icon,exports.DivIcon=DivIcon,exports.divIcon=divIcon,exports.Marker=Marker,exports.marker=marker,exports.TileLayer=TileLayer,exports.tileLayer=tileLayer,exports.GridLayer=GridLayer,exports.gridLayer=gridLayer,exports.SVG=SVG,exports.svg=svg$1,exports.Renderer=Renderer,exports.Canvas=Canvas,exports.canvas=canvas$1,exports.Path=Path,exports.CircleMarker=CircleMarker,exports.circleMarker=circleMarker,exports.Circle=Circle,exports.circle=circle,exports.Polyline=Polyline,exports.polyline=polyline,exports.Polygon=Polygon,exports.polygon=polygon,exports.Rectangle=Rectangle,exports.rectangle=rectangle,exports.Map=Map,exports.map=createMap})},function(module,exports,__webpack_require__){"use strict";function tileLayer(options){return new TileLayer(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=tileLayer;var TileLayer=exports.TileLayer=L.TileLayer.extend({options:{errorTileUrl:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="},initialize:function(){var opts=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},options=L.setOptions(this,opts);L.TileLayer.prototype.initialize.call(this,options.url,options),this.on("load",this.onLoad,this)},onLoad:function(){this.fire("ready"),this.off("load",this.onLoad,this)}})},function(module,exports,__webpack_require__){"use strict";function wmsLayer(options){return new WmsLayer(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=wmsLayer;var WmsLayer=exports.WmsLayer=L.TileLayer.WMS.extend({initialize:function(opts){var options=L.extend({errorTileUrl:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",format:"image/png",transparent:!0},opts);L.TileLayer.WMS.prototype.initialize.call(this,options.url,options)}})},function(module,exports,__webpack_require__){"use strict";function googleLayer(options){return new GoogleLayer(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.GoogleLayer=void 0,exports.default=googleLayer,__webpack_require__(70);var GoogleLayer=exports.GoogleLayer=L.GridLayer.GoogleMutant.extend({options:{style:"ROADMAP",version:"3.30",apiKey:"AIzaSyBjlDmwuON9lJbPMDlh_LI3zGpGtpK9erc"},initialize:function(){var opts=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},options=L.setOptions(this,opts);options.type=options.style.toLowerCase(),this.googleMapsApiLoaded()||GoogleLayer._mapsApiLoading||this.loadGoogleMapsApi(),L.GridLayer.GoogleMutant.prototype.initialize.call(this)},setOpacity:function(opacity){opacity!==this.options.opacity&&(this.options.opacity=opacity,this.googleMapsApiLoaded()&&(this.onRemove(this._map),this.onAdd(this._map)))},onAdd:function(map){L.DomUtil.addClass(map.getContainer(),"leaflet-google"),L.GridLayer.GoogleMutant.prototype.onAdd.call(this,map)},onRemove:function(map){L.DomUtil.removeClass(map.getContainer(),"leaflet-google"),L.GridLayer.prototype.onRemove.call(this,map),map._container.removeChild(this._mutantContainer),this._mutantContainer=void 0,google.maps.event.clearListeners(map,"idle"),this._mutant&&google.maps.event.clearListeners(this._mutant,"idle"),map.off("viewreset",this._reset,this),map.off("move",this._update,this),map.off("zoomend",this._handleZoomAnim,this),map.off("resize",this._resize,this),map._controlCorners&&(map._controlCorners.bottomright.style.marginBottom="0em",map._controlCorners.bottomleft.style.marginBottom="0em")},googleMapsApiLoaded:function(){return"undefined"!=typeof google&&void 0!==google.maps},loadGoogleMapsApi:function(){GoogleLayer._mapsApiLoading=!0;var script=document.createElement("script");script.src="//maps.googleapis.com/maps/api/js?key="+this.options.apiKey+"&v="+this.options.version,document.getElementsByTagName("head")[0].appendChild(script)}})},function(module,exports){L.GridLayer.GoogleMutant=L.GridLayer.extend({options:{minZoom:0,maxZoom:23,tileSize:256,subdomains:"abc",errorTileUrl:"",attribution:"",opacity:1,continuousWorld:!1,noWrap:!1,type:"roadmap",maxNativeZoom:21},initialize:function(options){L.GridLayer.prototype.initialize.call(this,options),this._ready=!!window.google&&!!window.google.maps&&!!window.google.maps.Map,this._GAPIPromise=this._ready?Promise.resolve(window.google):new Promise(function(resolve,reject){var checkCounter=0,intervalId=null;intervalId=setInterval(function(){return checkCounter>=10?(clearInterval(intervalId),reject(new Error("window.google not found after 10 attempts"))):window.google&&window.google.maps&&window.google.maps.Map?(clearInterval(intervalId),resolve(window.google)):void checkCounter++},500)}),this._tileCallbacks={},this._freshTiles={},this._imagesPerTile="hybrid"===this.options.type?2:1},onAdd:function(map){L.GridLayer.prototype.onAdd.call(this,map),this._initMutantContainer(),this._GAPIPromise.then(function(){if(this._ready=!0,this._map=map,this._initMutant(),map.on("viewreset",this._reset,this),map.on("move",this._update,this),map.on("zoomend",this._handleZoomAnim,this),map.on("resize",this._resize,this),google.maps.event.addListenerOnce(this._mutant,"idle",function(){this._checkZoomLevels(),this._mutantIsReady=!0}.bind(this)),map._controlCorners.bottomright.style.marginBottom="20px",map._controlCorners.bottomleft.style.marginBottom="20px",this._reset(),this._update(),this._subLayers)for(var layerName in this._subLayers)this._subLayers[layerName].setMap(this._mutant)}.bind(this))},onRemove:function(map){L.GridLayer.prototype.onRemove.call(this,map),map._container.removeChild(this._mutantContainer),this._mutantContainer=void 0,google.maps.event.clearListeners(map,"idle"),google.maps.event.clearListeners(this._mutant,"idle"),map.off("viewreset",this._reset,this),map.off("move",this._update,this),map.off("zoomend",this._handleZoomAnim,this),map.off("resize",this._resize,this),map._controlCorners&&(map._controlCorners.bottomright.style.marginBottom="0em",map._controlCorners.bottomleft.style.marginBottom="0em")},getAttribution:function(){return this.options.attribution},setOpacity:function(opacity){this.options.opacity=opacity,opacity<1&&L.DomUtil.setOpacity(this._mutantContainer,opacity)},setElementSize:function(e,size){e.style.width=size.x+"px",e.style.height=size.y+"px"},addGoogleLayer:function(googleLayerName,options){return this._subLayers||(this._subLayers={}),this._GAPIPromise.then(function(){var Constructor=google.maps[googleLayerName],googleLayer=new Constructor(options);return googleLayer.setMap(this._mutant),this._subLayers[googleLayerName]=googleLayer,googleLayer}.bind(this))},removeGoogleLayer:function(googleLayerName){var googleLayer=this._subLayers&&this._subLayers[googleLayerName];googleLayer&&(googleLayer.setMap(null),delete this._subLayers[googleLayerName])},_initMutantContainer:function(){this._mutantContainer||(this._mutantContainer=L.DomUtil.create("div","leaflet-google-mutant leaflet-top leaflet-left"),this._mutantContainer.id="_MutantContainer_"+L.Util.stamp(this._mutantContainer),this._mutantContainer.style.zIndex="800",this._mutantContainer.style.pointerEvents="none",this._map.getContainer().appendChild(this._mutantContainer)),this.setOpacity(this.options.opacity),this.setElementSize(this._mutantContainer,this._map.getSize()),this._attachObserver(this._mutantContainer)},_initMutant:function(){if(this._ready&&this._mutantContainer){this._mutantCenter=new google.maps.LatLng(0,0);var map=new google.maps.Map(this._mutantContainer,{center:this._mutantCenter,zoom:0,tilt:0,mapTypeId:this.options.type,disableDefaultUI:!0,keyboardShortcuts:!1,draggable:!1,disableDoubleClickZoom:!0,scrollwheel:!1,streetViewControl:!1,styles:this.options.styles||{},backgroundColor:"transparent"});this._mutant=map,google.maps.event.addListenerOnce(map,"idle",function(){for(var nodes=this._mutantContainer.querySelectorAll("a"),i=0;i<nodes.length;i++)nodes[i].style.pointerEvents="auto"}.bind(this)),this.fire("spawned",{mapObject:map})}},_attachObserver:function(node){new MutationObserver(this._onMutations.bind(this)).observe(node,{childList:!0,subtree:!0})},_onMutations:function(mutations){for(var i=0;i<mutations.length;++i)for(var mutation=mutations[i],j=0;j<mutation.addedNodes.length;++j){var node=mutation.addedNodes[j];node instanceof HTMLImageElement?this._onMutatedImage(node):node instanceof HTMLElement&&Array.prototype.forEach.call(node.querySelectorAll("img"),this._onMutatedImage.bind(this))}},_roadRegexp:/!1i(\d+)!2i(\d+)!3i(\d+)!/,_satRegexp:/x=(\d+)&y=(\d+)&z=(\d+)/,_staticRegExp:/StaticMapService\.GetMapImage/,_onMutatedImage:function(imgNode){var coords,match=imgNode.src.match(this._roadRegexp),sublayer=0;if(match?(coords={z:match[1],x:match[2],y:match[3]},this._imagesPerTile>1&&(imgNode.style.zIndex=1,sublayer=1)):(match=imgNode.src.match(this._satRegexp),match&&(coords={x:match[1],y:match[2],z:match[3]}),sublayer=0),coords){var tileKey=this._tileCoordsToKey(coords);imgNode.style.position="absolute",imgNode.style.visibility="hidden";var key=tileKey+"/"+sublayer;if(this._freshTiles[key]=imgNode,key in this._tileCallbacks&&this._tileCallbacks[key])this._tileCallbacks[key].pop()(imgNode),this._tileCallbacks[key].length||delete this._tileCallbacks[key];else if(this._tiles[tileKey]){var c=this._tiles[tileKey].el,oldImg=0===sublayer?c.firstChild:c.firstChild.nextSibling,cloneImgNode=this._clone(imgNode);c.replaceChild(cloneImgNode,oldImg)}}else imgNode.src.match(this._staticRegExp)&&(imgNode.style.visibility="hidden")},createTile:function(coords,done){var key=this._tileCoordsToKey(coords),tileContainer=L.DomUtil.create("div");tileContainer.dataset.pending=this._imagesPerTile,done=done.bind(this,null,tileContainer);for(var i=0;i<this._imagesPerTile;i++){var key2=key+"/"+i;if(key2 in this._freshTiles){var imgNode=this._freshTiles[key2];tileContainer.appendChild(this._clone(imgNode)),tileContainer.dataset.pending--}else this._tileCallbacks[key2]=this._tileCallbacks[key2]||[],this._tileCallbacks[key2].push(function(c){return function(imgNode){c.appendChild(this._clone(imgNode)),c.dataset.pending--,parseInt(c.dataset.pending)||done()}.bind(this)}.bind(this)(tileContainer))}return parseInt(tileContainer.dataset.pending)||L.Util.requestAnimFrame(done),tileContainer},_clone:function(imgNode){var clonedImgNode=imgNode.cloneNode(!0);return clonedImgNode.style.visibility="visible",clonedImgNode},_checkZoomLevels:function(){var zoomLevel=this._map.getZoom(),gMapZoomLevel=this._mutant.getZoom();zoomLevel&&gMapZoomLevel&&(gMapZoomLevel!==zoomLevel||gMapZoomLevel>this.options.maxNativeZoom)&&this._setMaxNativeZoom(gMapZoomLevel)},_setMaxNativeZoom:function(zoomLevel){zoomLevel!=this.options.maxNativeZoom&&(this.options.maxNativeZoom=zoomLevel,this._resetView())},_reset:function(){this._initContainer()},_update:function(){if(this._mutant){var center=this._map.getCenter(),_center=new google.maps.LatLng(center.lat,center.lng);this._mutant.setCenter(_center);var zoom=this._map.getZoom(),fractionalLevel=zoom!==Math.round(zoom),mutantZoom=this._mutant.getZoom();fractionalLevel||zoom==mutantZoom||(this._mutant.setZoom(zoom),this._mutantIsReady&&this._checkZoomLevels())}L.GridLayer.prototype._update.call(this)},_resize:function(){var size=this._map.getSize();this._mutantContainer.style.width===size.x&&this._mutantContainer.style.height===size.y||(this.setElementSize(this._mutantContainer,size),this._mutant&&google.maps.event.trigger(this._mutant,"resize"))},_handleZoomAnim:function(){if(this._mutant){var center=this._map.getCenter(),_center=new google.maps.LatLng(center.lat,center.lng);this._mutant.setCenter(_center),this._mutant.setZoom(Math.round(this._map.getZoom()))}},_removeTile:function(key){if(this._mutant)return setTimeout(this._pruneTile.bind(this,key),1e3),L.GridLayer.prototype._removeTile.call(this,key)},_pruneTile:function(key){for(var gZoom=this._mutant.getZoom(),tileZoom=key.split(":")[2],googleBounds=this._mutant.getBounds(),sw=googleBounds.getSouthWest(),ne=googleBounds.getNorthEast(),gMapBounds=L.latLngBounds([[sw.lat(),sw.lng()],[ne.lat(),ne.lng()]]),i=0;i<this._imagesPerTile;i++){var key2=key+"/"+i;if(key2 in this._freshTiles){var tileBounds=this._map&&this._keyToBounds(key);this._map&&tileBounds.overlaps(gMapBounds)&&tileZoom==gZoom||delete this._freshTiles[key2]}}}}),L.gridLayer.googleMutant=function(options){return new L.GridLayer.GoogleMutant(options)}},function(module,exports,__webpack_require__){"use strict";function boundary(options){return new Boundary(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.Boundary=void 0,exports.default=boundary;var _GeoJson=__webpack_require__(6),Boundary=exports.Boundary=_GeoJson.GeoJson.extend({options:{style:{opacity:1,fillOpacity:0,fill:!1,radius:5},highlightStyle:{weight:3}},initialize:function(){var options=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};options.pointToLayer||(options.pointToLayer=this.pointToLayer.bind(this)),_GeoJson.GeoJson.prototype.initialize.call(this,options)},addLayer:function(layer){var prop=layer.feature.properties;prop.style&&layer.setStyle(prop.style),_GeoJson.GeoJson.prototype.addLayer.call(this,layer)},setOpacity:function(opacity){this.setStyle({opacity:opacity})},pointToLayer:function(geojson,latlng){return this.options.style.pane=this.options.pane,new L.CircleMarker(latlng,this.options.style)},highlight:function(id){var layer=this.findById(id);if(this.removeHighlight(),layer)return this._highlight=layer.setStyle({fillOpacity:.5}),layer},removeHighlight:function(){this._highlight&&this._highlight.setStyle({fillOpacity:0})}})},function(module,exports,__webpack_require__){"use strict";function label(latlng,options){return new Label(latlng,options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=label;var Label=exports.Label=L.Marker.extend({options:{html:"Label",className:"leaflet-div-label",iconSize:null},initialize:function(latlng,opts){var options=L.setOptions(this,opts);this._latlng=L.latLng(latlng),options.icon=L.divIcon(options)},onAdd:function(map){L.Marker.prototype.onAdd.call(this,map);var options=this.options,iconDiv=this._icon;options.labelStyle&&L.extend(iconDiv.style,options.labelStyle),iconDiv.style.marginLeft="-"+iconDiv.offsetWidth/2+"px","below"!==options.position&&(iconDiv.style.marginTop="-"+iconDiv.offsetHeight/2+"px")}})},function(module,exports,__webpack_require__){"use strict";function polylabel(polygon,precision,debug){precision=precision||1;for(var minX,minY,maxX,maxY,i=0;i<polygon[0].length;i++){var p=polygon[0][i];(!i||p[0]<minX)&&(minX=p[0]),(!i||p[1]<minY)&&(minY=p[1]),(!i||p[0]>maxX)&&(maxX=p[0]),(!i||p[1]>maxY)&&(maxY=p[1])}var width=maxX-minX,height=maxY-minY,cellSize=Math.min(width,height),h=cellSize/2,cellQueue=new Queue(null,compareMax);if(0===cellSize)return[minX,minY];for(var x=minX;x<maxX;x+=cellSize)for(var y=minY;y<maxY;y+=cellSize)cellQueue.push(new Cell(x+h,y+h,h,polygon));var bestCell=getCentroidCell(polygon),bboxCell=new Cell(minX+width/2,minY+height/2,0,polygon);bboxCell.d>bestCell.d&&(bestCell=bboxCell);for(var numProbes=cellQueue.length;cellQueue.length;){var cell=cellQueue.pop();cell.d>bestCell.d&&(bestCell=cell,debug&&console.log("found best %d after %d probes",Math.round(1e4*cell.d)/1e4,numProbes)),cell.max-bestCell.d<=precision||(h=cell.h/2,cellQueue.push(new Cell(cell.x-h,cell.y-h,h,polygon)),cellQueue.push(new Cell(cell.x+h,cell.y-h,h,polygon)),cellQueue.push(new Cell(cell.x-h,cell.y+h,h,polygon)),cellQueue.push(new Cell(cell.x+h,cell.y+h,h,polygon)),numProbes+=4)}return debug&&(console.log("num probes: "+numProbes),console.log("best distance: "+bestCell.d)),[bestCell.x,bestCell.y]}function compareMax(a,b){return b.max-a.max}function Cell(x,y,h,polygon){this.x=x,this.y=y,this.h=h,this.d=pointToPolygonDist(x,y,polygon),this.max=this.d+this.h*Math.SQRT2}function pointToPolygonDist(x,y,polygon){for(var inside=!1,minDistSq=1/0,k=0;k<polygon.length;k++)for(var ring=polygon[k],i=0,len=ring.length,j=len-1;i<len;j=i++){var a=ring[i],b=ring[j];a[1]>y!=b[1]>y&&x<(b[0]-a[0])*(y-a[1])/(b[1]-a[1])+a[0]&&(inside=!inside),minDistSq=Math.min(minDistSq,getSegDistSq(x,y,a,b))}return(inside?1:-1)*Math.sqrt(minDistSq)}function getCentroidCell(polygon){for(var area=0,x=0,y=0,points=polygon[0],i=0,len=points.length,j=len-1;i<len;j=i++){var a=points[i],b=points[j],f=a[0]*b[1]-b[0]*a[1];x+=(a[0]+b[0])*f,y+=(a[1]+b[1])*f,area+=3*f}return 0===area?new Cell(points[0][0],points[0][1],0,polygon):new Cell(x/area,y/area,0,polygon)}function getSegDistSq(px,py,a,b){var x=a[0],y=a[1],dx=b[0]-x,dy=b[1]-y;if(0!==dx||0!==dy){var t=((px-x)*dx+(py-y)*dy)/(dx*dx+dy*dy);t>1?(x=b[0],y=b[1]):t>0&&(x+=dx*t,y+=dy*t)}return dx=px-x,dy=py-y,dx*dx+dy*dy}var Queue=__webpack_require__(74);module.exports=polylabel,module.exports.default=polylabel},function(module,exports,__webpack_require__){"use strict";function TinyQueue(data,compare){if(!(this instanceof TinyQueue))return new TinyQueue(data,compare);if(this.data=data||[],this.length=this.data.length,this.compare=compare||defaultCompare,data)for(var i=Math.floor(this.length/2);i>=0;i--)this._down(i)}function defaultCompare(a,b){return a<b?-1:a>b?1:0}function swap(data,i,j){var tmp=data[i];data[i]=data[j],data[j]=tmp}module.exports=TinyQueue,TinyQueue.prototype={push:function(item){this.data.push(item),this.length++,this._up(this.length-1)},pop:function(){var top=this.data[0];return this.data[0]=this.data[this.length-1],this.length--,this.data.pop(),this._down(0),top},peek:function(){return this.data[0]},_up:function(pos){for(var data=this.data,compare=this.compare;pos>0;){var parent=Math.floor((pos-1)/2);if(!(compare(data[pos],data[parent])<0))break;swap(data,parent,pos),pos=parent}},_down:function(pos){for(var data=this.data,compare=this.compare,len=this.length;;){var left=2*pos+1,right=left+1,min=pos;if(left<len&&compare(data[left],data[min])<0&&(min=left),right<len&&compare(data[right],data[min])<0&&(min=right),min===pos)return;swap(data,min,pos),pos=min}}}},function(module,exports){function extensions(parentClass){return{initialize:function(options){parentClass.prototype.initialize.call(this,options),this._originalLayers=[],this._visibleLayers=[],this._staticLayers=[],this._rbush=[],this._cachedRelativeBoxes=[],this._margin=options.margin||0,this._rbush=null},addLayer:function(layer){if(!("options"in layer&&"icon"in layer.options))return this._staticLayers.push(layer),void parentClass.prototype.addLayer.call(this,layer);this._originalLayers.push(layer),this._map&&this._maybeAddLayerToRBush(layer)},removeLayer:function(layer){this._rbush.remove(this._cachedRelativeBoxes[layer._leaflet_id]),delete this._cachedRelativeBoxes[layer._leaflet_id],parentClass.prototype.removeLayer.call(this,layer);var i;i=this._originalLayers.indexOf(layer),-1!==i&&this._originalLayers.splice(i,1),i=this._visibleLayers.indexOf(layer),-1!==i&&this._visibleLayers.splice(i,1),-1!==(i=this._staticLayers.indexOf(layer))&&this._staticLayers.splice(i,1)},clearLayers:function(){this._rbush=rbush(),this._originalLayers=[],this._visibleLayers=[],this._staticLayers=[],this._cachedRelativeBoxes=[],parentClass.prototype.clearLayers.call(this)},onAdd:function(map){this._map=map;for(var i in this._staticLayers)map.addLayer(this._staticLayers[i]);this._onZoomEnd(),map.on("zoomend",this._onZoomEnd,this)},onRemove:function(map){for(var i in this._staticLayers)map.removeLayer(this._staticLayers[i]);map.off("zoomend",this._onZoomEnd,this),parentClass.prototype.onRemove.call(this,map)},_maybeAddLayerToRBush:function(layer){var bush=(this._map.getZoom(),this._rbush),boxes=this._cachedRelativeBoxes[layer._leaflet_id],visible=!1;if(!boxes){parentClass.prototype.addLayer.call(this,layer);var visible=!0,box=this._getIconBox(layer._icon);boxes=this._getRelativeBoxes(layer._icon.children,box),boxes.push(box),this._cachedRelativeBoxes[layer._leaflet_id]=boxes}boxes=this._positionBoxes(this._map.latLngToLayerPoint(layer.getLatLng()),boxes);for(var collision=!1,i=0;i<boxes.length&&!collision;i++)collision=bush.search(boxes[i]).length>0;collision?parentClass.prototype.removeLayer.call(this,layer):(visible||parentClass.prototype.addLayer.call(this,layer),this._visibleLayers.push(layer),bush.load(boxes))},_getIconBox:function(el){if(isMSIE8)return[0,0,el.offsetWidth,el.offsetHeight];var styles=window.getComputedStyle(el);return[parseInt(styles.marginLeft),parseInt(styles.marginTop),parseInt(styles.marginLeft)+parseInt(styles.width),parseInt(styles.marginTop)+parseInt(styles.height)]},_getRelativeBoxes:function(els,baseBox){for(var boxes=[],i=0;i<els.length;i++){var el=els[i],box=[el.offsetLeft,el.offsetTop,el.offsetLeft+el.offsetWidth,el.offsetTop+el.offsetHeight];if(box=this._offsetBoxes(box,baseBox),boxes.push(box),el.children.length){var parentBox=baseBox;if(!isMSIE8){var positionStyle=window.getComputedStyle(el).position;"absolute"!==positionStyle&&"relative"!==positionStyle||(parentBox=box)}boxes=boxes.concat(this._getRelativeBoxes(el.children,parentBox))}}return boxes},_offsetBoxes:function(a,b){return[a[0]+b[0],a[1]+b[1],a[2]+b[0],a[3]+b[1]]},_positionBoxes:function(offset,boxes){for(var newBoxes=[],i=0;i<boxes.length;i++)newBoxes.push(this._positionBox(offset,boxes[i]));return newBoxes},_positionBox:function(offset,box){return[box[0]+offset.x-this._margin,box[1]+offset.y-this._margin,box[2]+offset.x+this._margin,box[3]+offset.y+this._margin]},_onZoomEnd:function(){for(var i=0;i<this._visibleLayers.length;i++)parentClass.prototype.removeLayer.call(this,this._visibleLayers[i]);this._rbush=rbush();for(var i=0;i<this._originalLayers.length;i++)this._maybeAddLayerToRBush(this._originalLayers[i])}}}var isMSIE8=!("getComputedStyle"in window&&"function"==typeof window.getComputedStyle);L.LayerGroup.Collision=L.LayerGroup.extend(extensions(L.LayerGroup)),L.FeatureGroup.Collision=L.FeatureGroup.extend(extensions(L.FeatureGroup)),L.GeoJSON.Collision=L.GeoJSON.extend(extensions(L.GeoJSON)),L.LayerGroup.collision=function(options){return new L.LayerGroup.Collision(options||{})},L.FeatureGroup.collision=function(options){return new L.FeatureGroup.Collision(options||{})},L.GeoJSON.collision=function(options){return new L.GeoJSON.Collision(options||{})},L.layerGroup.collision=function(options){return new L.LayerGroup.Collision(options||{})},L.featureGroup.collision=function(options){return new L.FeatureGroup.Collision(options||{})},L.geoJson.collision=function(options){return new L.GeoJSON.Collision(options||{})}},function(module,exports,__webpack_require__){function geometry(_){var i,area=0;switch(_.type){case"Polygon":return polygonArea(_.coordinates);case"MultiPolygon":for(i=0;i<_.coordinates.length;i++)area+=polygonArea(_.coordinates[i]);return area;case"Point":case"MultiPoint":case"LineString":case"MultiLineString":return 0;case"GeometryCollection":for(i=0;i<_.geometries.length;i++)area+=geometry(_.geometries[i]);return area}}function polygonArea(coords){var area=0;if(coords&&coords.length>0){area+=Math.abs(ringArea(coords[0]));for(var i=1;i<coords.length;i++)area-=Math.abs(ringArea(coords[i]))}return area}function ringArea(coords){var p1,p2,p3,lowerIndex,middleIndex,upperIndex,area=0,coordsLength=coords.length;if(coordsLength>2){for(i=0;i<coordsLength;i++)i===coordsLength-2?(lowerIndex=coordsLength-2,middleIndex=coordsLength-1,upperIndex=0):i===coordsLength-1?(lowerIndex=coordsLength-1,middleIndex=0,upperIndex=1):(lowerIndex=i,middleIndex=i+1,upperIndex=i+2),p1=coords[lowerIndex],p2=coords[middleIndex],p3=coords[upperIndex],area+=(rad(p3[0])-rad(p1[0]))*Math.sin(rad(p2[1]));area=area*wgs84.RADIUS*wgs84.RADIUS/2}return area}function rad(_){return _*Math.PI/180}var wgs84=__webpack_require__(77);module.exports.geometry=geometry,module.exports.ring=ringArea},function(module,exports){module.exports.RADIUS=6378137,module.exports.FLATTENING=1/298.257223563,module.exports.POLAR_RADIUS=6356752.3142},function(module,exports,__webpack_require__){"use strict";function dots(options){return new Dots(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.Dots=void 0,exports.default=dots;var _GeoJson=__webpack_require__(6),_CircleMarker=__webpack_require__(11),_CircleMarker2=function(obj){return obj&&obj.__esModule?obj:{default:obj}}(_CircleMarker),Dots=exports.Dots=_GeoJson.GeoJson.extend({initialize:function(){var options=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};options.pointToLayer||(options.pointToLayer=this.pointToLayer.bind(this)),_GeoJson.GeoJson.prototype.initialize.call(this,options),this.on("click",this.onMarkerClick,this)},onMarkerClick:function(evt){evt.layer.showPopup()},pointToLayer:function(feature){return(0,_CircleMarker2.default)(feature,this.options)}})},function(module,exports,__webpack_require__){"use strict";function markers(options){return new Markers(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.Markers=void 0,exports.default=markers;var _GeoJson=__webpack_require__(6),Markers=exports.Markers=_GeoJson.GeoJson.extend({options:{highlightStyle:!1,markerOptions:{riseOnHover:!0},iconProperty:"icon"},initialize:function(){var options=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};options.pointToLayer||(options.pointToLayer=this.pointToLayer.bind(this)),_GeoJson.GeoJson.prototype.initialize.call(this,options)},pointToLayer:function(feature,latlng){var iconProperty=this.options.iconProperty,markerOptions=L.extend({},this.options.markerOptions);return this.options.pane&&(markerOptions.pane=this.options.pane),this.options.label&&(markerOptions.label=L.Util.template(this.options.label,feature.properties),markerOptions.labelStyle=this.options.labelStyle),iconProperty&&feature.properties[iconProperty]&&(markerOptions.icon=L.icon(feature.properties[iconProperty])),L.marker(latlng,markerOptions)},setOpacity:function(opacity){this.eachLayer(function(layer){layer.setOpacity(opacity)})},highlight:function(id){var layer=this.findById(id);if(this.removeHighlight(),layer)return this._highlight=L.circleMarker(layer.getLatLng(),{radius:5,color:"orange",fillOpacity:0,className:"leaflet-marker-highlight"}).addTo(this._map),layer},removeHighlight:function(){this._highlight&&this._map.removeLayer(this._highlight)}})},function(module,exports,__webpack_require__){"use strict";function circles(options){return new Circles(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.Circles=void 0,exports.default=circles;var _GeoJson=__webpack_require__(6),Circles=exports.Circles=_GeoJson.GeoJson.extend({options:{radius:1e3,style:{color:"#95c8fb",weight:1}},initialize:function(){var options=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};options.pointToLayer||(options.pointToLayer=this.pointToLayer.bind(this)),_GeoJson.GeoJson.prototype.initialize.call(this,options)},pointToLayer:function(feature,latlng){return L.circle(latlng,{radius:this.options.radius,pane:this.options.pane})}})},function(module,exports,__webpack_require__){"use strict";function choropleth(options){return new Choropleth(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.Choropleth=void 0,exports.default=choropleth;var _GeoJson=__webpack_require__(6),Choropleth=exports.Choropleth=_GeoJson.GeoJson.extend({options:{style:{color:"#333",weight:1,fillOpacity:.8},highlightStyle:{weight:3},valueKey:"value",colorKey:"color",radiusKey:"radius"},initialize:function(){var options=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};options.pointToLayer||(options.pointToLayer=this.pointToLayer.bind(this)),_GeoJson.GeoJson.prototype.initialize.call(this,options)},addLayer:function(layer){var feature=layer.feature,prop=feature.properties,color=prop[this.options.colorKey],radius=prop[this.options.radiusKey];color&&layer.setStyle&&layer.setStyle({fillColor:color}),feature.isSelected&&layer.setStyle(this.options.highlightStyle),radius&&layer.setRadius&&layer.setRadius(radius),_GeoJson.GeoJson.prototype.addLayer.call(this,layer)},highlight:function(id){var layer=this.findById(id);if(layer)return layer.setStyle(this.options.highlightStyle)},removeHighlight:function(id){var layer=this.findById(id);if(layer)return layer.setStyle(this.options.resetStyle)},pointToLayer:function(feature,latlng){return L.circleMarker(latlng,{pane:this.options.pane})}})},function(module,exports,__webpack_require__){"use strict";function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function clientCluster(options){return new ClientCluster(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.ClientCluster=void 0,exports.default=clientCluster;var _ClusterIcon=__webpack_require__(28),_ClusterIcon2=_interopRequireDefault(_ClusterIcon),_CircleMarker=__webpack_require__(11),_CircleMarker2=_interopRequireDefault(_CircleMarker),_d3Scale=__webpack_require__(30);__webpack_require__(149);var ClientCluster=exports.ClientCluster=L.MarkerClusterGroup.extend({options:{maxClusterRadius:40,showCoverageOnHover:!1,iconCreateFunction:function(cluster){var count=cluster.getChildCount();return cluster.options.opacity=this.opacity,(0,_ClusterIcon2.default)({color:this.color,opacity:this.opacity,size:this.scale(count),count:count})},domain:[1,1e3],range:[16,40],radius:6},initialize:function(opts){var options=L.setOptions(this,opts);L.MarkerClusterGroup.prototype.initialize.call(this,options),options.data&&this.addData(options.data),this.on("click",this.onMarkerClick,this)},onMarkerClick:function(evt){evt.layer.showPopup()},addData:function(data){var options=this.options;data.length&&(options.domain=[1,data.length],options.scale=(0,_d3Scale.scaleLog)().domain(options.domain).range(options.range).clamp(!0),this.addLayers(data.map(function(d){return(0,_CircleMarker2.default)(d,options)})))},setOpacity:function(opacity){this.options.opacity=opacity,this.eachLayer(function(layer){return layer.setOpacity(opacity)}),this._featureGroup.eachLayer(function(layer){return layer.setOpacity(opacity)})}})},function(module,__webpack_exports__,__webpack_require__){"use strict";function labConvert(o){if(o instanceof Lab)return new Lab(o.l,o.a,o.b,o.opacity);if(o instanceof Hcl){var h=o.h*__WEBPACK_IMPORTED_MODULE_2__math__.a;return new Lab(o.l,Math.cos(h)*o.c,Math.sin(h)*o.c,o.opacity)}o instanceof __WEBPACK_IMPORTED_MODULE_1__color__.b||(o=Object(__WEBPACK_IMPORTED_MODULE_1__color__.h)(o));var b=rgb2xyz(o.r),a=rgb2xyz(o.g),l=rgb2xyz(o.b),x=xyz2lab((.4124564*b+.3575761*a+.1804375*l)/Xn),y=xyz2lab((.2126729*b+.7151522*a+.072175*l)/Yn);return new Lab(116*y-16,500*(x-y),200*(y-xyz2lab((.0193339*b+.119192*a+.9503041*l)/Zn)),o.opacity)}function lab(l,a,b,opacity){return 1===arguments.length?labConvert(l):new Lab(l,a,b,null==opacity?1:opacity)}function Lab(l,a,b,opacity){this.l=+l,this.a=+a,this.b=+b,this.opacity=+opacity}function xyz2lab(t){return t>t3?Math.pow(t,1/3):t/t2+t0}function lab2xyz(t){return t>t1?t*t*t:t2*(t-t0)}function xyz2rgb(x){return 255*(x<=.0031308?12.92*x:1.055*Math.pow(x,1/2.4)-.055)}function rgb2xyz(x){return(x/=255)<=.04045?x/12.92:Math.pow((x+.055)/1.055,2.4)}function hclConvert(o){if(o instanceof Hcl)return new Hcl(o.h,o.c,o.l,o.opacity);o instanceof Lab||(o=labConvert(o));var h=Math.atan2(o.b,o.a)*__WEBPACK_IMPORTED_MODULE_2__math__.b;return new Hcl(h<0?h+360:h,Math.sqrt(o.a*o.a+o.b*o.b),o.l,o.opacity)}function hcl(h,c,l,opacity){return 1===arguments.length?hclConvert(h):new Hcl(h,c,l,null==opacity?1:opacity)}function Hcl(h,c,l,opacity){this.h=+h,this.c=+c,this.l=+l,this.opacity=+opacity}__webpack_exports__.a=lab,__webpack_exports__.b=hcl;var __WEBPACK_IMPORTED_MODULE_0__define__=__webpack_require__(17),__WEBPACK_IMPORTED_MODULE_1__color__=__webpack_require__(16),__WEBPACK_IMPORTED_MODULE_2__math__=__webpack_require__(29),Xn=.95047,Yn=1,Zn=1.08883,t0=4/29,t1=6/29,t2=3*t1*t1,t3=t1*t1*t1;Object(__WEBPACK_IMPORTED_MODULE_0__define__.a)(Lab,lab,Object(__WEBPACK_IMPORTED_MODULE_0__define__.b)(__WEBPACK_IMPORTED_MODULE_1__color__.a,{brighter:function(k){return new Lab(this.l+18*(null==k?1:k),this.a,this.b,this.opacity)},darker:function(k){return new Lab(this.l-18*(null==k?1:k),this.a,this.b,this.opacity)},rgb:function(){var y=(this.l+16)/116,x=isNaN(this.a)?y:y+this.a/500,z=isNaN(this.b)?y:y-this.b/200;return y=Yn*lab2xyz(y),x=Xn*lab2xyz(x),z=Zn*lab2xyz(z),new __WEBPACK_IMPORTED_MODULE_1__color__.b(xyz2rgb(3.2404542*x-1.5371385*y-.4985314*z),xyz2rgb(-.969266*x+1.8760108*y+.041556*z),xyz2rgb(.0556434*x-.2040259*y+1.0572252*z),this.opacity)}})),Object(__WEBPACK_IMPORTED_MODULE_0__define__.a)(Hcl,hcl,Object(__WEBPACK_IMPORTED_MODULE_0__define__.b)(__WEBPACK_IMPORTED_MODULE_1__color__.a,{brighter:function(k){return new Hcl(this.h,this.c,this.l+18*(null==k?1:k),this.opacity)},darker:function(k){return new Hcl(this.h,this.c,this.l-18*(null==k?1:k),this.opacity)},rgb:function(){return labConvert(this).rgb()}}))},function(module,__webpack_exports__,__webpack_require__){"use strict";function cubehelixConvert(o){if(o instanceof Cubehelix)return new Cubehelix(o.h,o.s,o.l,o.opacity);o instanceof __WEBPACK_IMPORTED_MODULE_1__color__.b||(o=Object(__WEBPACK_IMPORTED_MODULE_1__color__.h)(o));var r=o.r/255,g=o.g/255,b=o.b/255,l=(BC_DA*b+ED*r-EB*g)/(BC_DA+ED-EB),bl=b-l,k=(E*(g-l)-C*bl)/D,s=Math.sqrt(k*k+bl*bl)/(E*l*(1-l)),h=s?Math.atan2(k,bl)*__WEBPACK_IMPORTED_MODULE_2__math__.b-120:NaN;return new Cubehelix(h<0?h+360:h,s,l,o.opacity)}function cubehelix(h,s,l,opacity){return 1===arguments.length?cubehelixConvert(h):new Cubehelix(h,s,l,null==opacity?1:opacity)}function Cubehelix(h,s,l,opacity){this.h=+h,this.s=+s,this.l=+l,this.opacity=+opacity}__webpack_exports__.a=cubehelix;var __WEBPACK_IMPORTED_MODULE_0__define__=__webpack_require__(17),__WEBPACK_IMPORTED_MODULE_1__color__=__webpack_require__(16),__WEBPACK_IMPORTED_MODULE_2__math__=__webpack_require__(29),A=-.14861,B=1.78277,C=-.29227,D=-.90649,E=1.97294,ED=E*D,EB=E*B,BC_DA=B*C-D*A;Object(__WEBPACK_IMPORTED_MODULE_0__define__.a)(Cubehelix,cubehelix,Object(__WEBPACK_IMPORTED_MODULE_0__define__.b)(__WEBPACK_IMPORTED_MODULE_1__color__.a,{brighter:function(k){return k=null==k?__WEBPACK_IMPORTED_MODULE_1__color__.c:Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__.c,k),new Cubehelix(this.h,this.s,this.l*k,this.opacity)},darker:function(k){return k=null==k?__WEBPACK_IMPORTED_MODULE_1__color__.d:Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__.d,k),new Cubehelix(this.h,this.s,this.l*k,this.opacity)},rgb:function(){var h=isNaN(this.h)?0:(this.h+120)*__WEBPACK_IMPORTED_MODULE_2__math__.a,l=+this.l,a=isNaN(this.s)?0:this.s*l*(1-l),cosh=Math.cos(h),sinh=Math.sin(h);return new __WEBPACK_IMPORTED_MODULE_1__color__.b(255*(l+a*(A*cosh+B*sinh)),255*(l+a*(C*cosh+D*sinh)),255*(l+a*(E*cosh)),this.opacity)}}))},function(module,__webpack_exports__,__webpack_require__){"use strict";function band(){function rescale(){var n=domain().length,reverse=range[1]<range[0],start=range[reverse-0],stop=range[1-reverse];step=(stop-start)/Math.max(1,n-paddingInner+2*paddingOuter),round&&(step=Math.floor(step)),start+=(stop-start-step*(n-paddingInner))*align,bandwidth=step*(1-paddingInner),round&&(start=Math.round(start),bandwidth=Math.round(bandwidth));var values=Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.e)(n).map(function(i){return start+step*i});return ordinalRange(reverse?values.reverse():values)}var step,bandwidth,scale=Object(__WEBPACK_IMPORTED_MODULE_1__ordinal__.a)().unknown(void 0),domain=scale.domain,ordinalRange=scale.range,range=[0,1],round=!1,paddingInner=0,paddingOuter=0,align=.5;return delete scale.unknown,scale.domain=function(_){return arguments.length?(domain(_),rescale()):domain()},scale.range=function(_){return arguments.length?(range=[+_[0],+_[1]],rescale()):range.slice()},scale.rangeRound=function(_){return range=[+_[0],+_[1]],round=!0,rescale()},scale.bandwidth=function(){return bandwidth},scale.step=function(){return step},scale.round=function(_){return arguments.length?(round=!!_,rescale()):round},scale.padding=function(_){return arguments.length?(paddingInner=paddingOuter=Math.max(0,Math.min(1,_)),rescale()):paddingInner},scale.paddingInner=function(_){return arguments.length?(paddingInner=Math.max(0,Math.min(1,_)),rescale()):paddingInner},scale.paddingOuter=function(_){return arguments.length?(paddingOuter=Math.max(0,Math.min(1,_)),rescale()):paddingOuter},scale.align=function(_){return arguments.length?(align=Math.max(0,Math.min(1,_)),rescale()):align},scale.copy=function(){return band().domain(domain()).range(range).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align)},rescale()}function pointish(scale){var copy=scale.copy;return scale.padding=scale.paddingOuter,delete scale.paddingInner,delete scale.paddingOuter,scale.copy=function(){return pointish(copy())},scale}function point(){return pointish(band().paddingInner(1))}__webpack_exports__.a=band,__webpack_exports__.b=point;var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(1),__WEBPACK_IMPORTED_MODULE_1__ordinal__=__webpack_require__(43)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__(33)},function(module,__webpack_exports__,__webpack_require__){"use strict"},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__(37),__webpack_require__(31),__webpack_require__(89),__webpack_require__(36),__webpack_require__(90),__webpack_require__(38),__webpack_require__(39),__webpack_require__(40)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(x){return function(){return x}}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(x){return x}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__(37),__webpack_require__(5),__webpack_require__(7),__webpack_require__(18)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__(34)},function(module,__webpack_exports__,__webpack_require__){"use strict"},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__(7)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__(5),__webpack_require__(7),__webpack_require__(18)},function(module,__webpack_exports__,__webpack_require__){"use strict"},function(module,__webpack_exports__,__webpack_require__){"use strict"},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__(5)},function(module,__webpack_exports__,__webpack_require__){"use strict"},function(module,__webpack_exports__,__webpack_require__){"use strict"},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__(42)},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_2__src_map__=(__webpack_require__(103),__webpack_require__(104),__webpack_require__(19));__webpack_require__.d(__webpack_exports__,"a",function(){return __WEBPACK_IMPORTED_MODULE_2__src_map__.a});__webpack_require__(105),__webpack_require__(106),__webpack_require__(107)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__(19)},function(module,__webpack_exports__,__webpack_require__){"use strict";function Set(){}function set(object,f){var set=new Set;if(object instanceof Set)object.each(function(value){set.add(value)});else if(object){var i=-1,n=object.length;if(null==f)for(;++i<n;)set.add(object[i]);else for(;++i<n;)set.add(f(object[i],i,object))}return set}var __WEBPACK_IMPORTED_MODULE_0__map__=__webpack_require__(19),proto=__WEBPACK_IMPORTED_MODULE_0__map__.a.prototype;Set.prototype=set.prototype={constructor:Set,has:proto.has,add:function(value){return value+="",this[__WEBPACK_IMPORTED_MODULE_0__map__.b+value]=value,this},remove:proto.remove,clear:proto.clear,values:proto.keys,size:proto.size,empty:proto.empty,each:proto.each}},function(module,__webpack_exports__,__webpack_require__){"use strict"},function(module,__webpack_exports__,__webpack_require__){"use strict"},function(module,__webpack_exports__,__webpack_require__){"use strict"},function(module,__webpack_exports__,__webpack_require__){"use strict";function identity(){function scale(x){return+x}var domain=[0,1];return scale.invert=scale,scale.domain=scale.range=function(_){return arguments.length?(domain=__WEBPACK_IMPORTED_MODULE_0__array__.a.call(_,__WEBPACK_IMPORTED_MODULE_2__number__.a),scale):domain.slice()},scale.copy=function(){return identity().domain(domain)},Object(__WEBPACK_IMPORTED_MODULE_1__linear__.b)(scale)}__webpack_exports__.a=identity;var __WEBPACK_IMPORTED_MODULE_0__array__=__webpack_require__(4),__WEBPACK_IMPORTED_MODULE_1__linear__=__webpack_require__(8),__WEBPACK_IMPORTED_MODULE_2__number__=__webpack_require__(51)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(a,b){return a=+a,b-=a,function(t){return Math.round(a+b*t)}}},function(module,__webpack_exports__,__webpack_require__){"use strict";function interpolateTransform(parse,pxComma,pxParen,degParen){function pop(s){return s.length?s.pop()+" ":""}function translate(xa,ya,xb,yb,s,q){if(xa!==xb||ya!==yb){var i=s.push("translate(",null,pxComma,null,pxParen);q.push({i:i-4,x:Object(__WEBPACK_IMPORTED_MODULE_0__number__.a)(xa,xb)},{i:i-2,x:Object(__WEBPACK_IMPORTED_MODULE_0__number__.a)(ya,yb)})}else(xb||yb)&&s.push("translate("+xb+pxComma+yb+pxParen)}function rotate(a,b,s,q){a!==b?(a-b>180?b+=360:b-a>180&&(a+=360),q.push({i:s.push(pop(s)+"rotate(",null,degParen)-2,x:Object(__WEBPACK_IMPORTED_MODULE_0__number__.a)(a,b)})):b&&s.push(pop(s)+"rotate("+b+degParen)}function skewX(a,b,s,q){a!==b?q.push({i:s.push(pop(s)+"skewX(",null,degParen)-2,x:Object(__WEBPACK_IMPORTED_MODULE_0__number__.a)(a,b)}):b&&s.push(pop(s)+"skewX("+b+degParen)}function scale(xa,ya,xb,yb,s,q){if(xa!==xb||ya!==yb){var i=s.push(pop(s)+"scale(",null,",",null,")");q.push({i:i-4,x:Object(__WEBPACK_IMPORTED_MODULE_0__number__.a)(xa,xb)},{i:i-2,x:Object(__WEBPACK_IMPORTED_MODULE_0__number__.a)(ya,yb)})}else 1===xb&&1===yb||s.push(pop(s)+"scale("+xb+","+yb+")")}return function(a,b){var s=[],q=[];return a=parse(a),b=parse(b),translate(a.translateX,a.translateY,b.translateX,b.translateY,s,q),rotate(a.rotate,b.rotate,s,q),skewX(a.skewX,b.skewX,s,q),scale(a.scaleX,a.scaleY,b.scaleX,b.scaleY,s,q),a=b=null,function(t){for(var o,i=-1,n=q.length;++i<n;)s[(o=q[i]).i]=o.x(t);return s.join("")}}}var __WEBPACK_IMPORTED_MODULE_0__number__=__webpack_require__(12),__WEBPACK_IMPORTED_MODULE_1__parse__=__webpack_require__(111);interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__.a,"px, ","px)","deg)"),interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__.b,", ",")",")")},function(module,__webpack_exports__,__webpack_require__){"use strict";function parseCss(value){return"none"===value?__WEBPACK_IMPORTED_MODULE_0__decompose__.b:(cssNode||(cssNode=document.createElement("DIV"),cssRoot=document.documentElement,cssView=document.defaultView),cssNode.style.transform=value,value=cssView.getComputedStyle(cssRoot.appendChild(cssNode),null).getPropertyValue("transform"),cssRoot.removeChild(cssNode),value=value.slice(7,-1).split(","),Object(__WEBPACK_IMPORTED_MODULE_0__decompose__.a)(+value[0],+value[1],+value[2],+value[3],+value[4],+value[5]))}function parseSvg(value){return null==value?__WEBPACK_IMPORTED_MODULE_0__decompose__.b:(svgNode||(svgNode=document.createElementNS("http://www.w3.org/2000/svg","g")),svgNode.setAttribute("transform",value),(value=svgNode.transform.baseVal.consolidate())?(value=value.matrix,Object(__WEBPACK_IMPORTED_MODULE_0__decompose__.a)(value.a,value.b,value.c,value.d,value.e,value.f)):__WEBPACK_IMPORTED_MODULE_0__decompose__.b)}__webpack_exports__.a=parseCss,__webpack_exports__.b=parseSvg;var cssNode,cssRoot,cssView,svgNode,__WEBPACK_IMPORTED_MODULE_0__decompose__=__webpack_require__(112)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.d(__webpack_exports__,"b",function(){return identity});var degrees=180/Math.PI,identity={translateX:0,translateY:0,rotate:0,skewX:0,scaleX:1,scaleY:1};__webpack_exports__.a=function(a,b,c,d,e,f){var scaleX,scaleY,skewX;return(scaleX=Math.sqrt(a*a+b*b))&&(a/=scaleX,b/=scaleX),(skewX=a*c+b*d)&&(c-=a*skewX,d-=b*skewX),(scaleY=Math.sqrt(c*c+d*d))&&(c/=scaleY,d/=scaleY,skewX/=scaleY),a*d<b*c&&(a=-a,b=-b,skewX=-skewX,scaleX=-scaleX),{translateX:e,translateY:f,rotate:Math.atan2(b,a)*degrees,skewX:Math.atan(skewX)*degrees,scaleX:scaleX,scaleY:scaleY}}},function(module,__webpack_exports__,__webpack_require__){"use strict";Math.SQRT2},function(module,__webpack_exports__,__webpack_require__){"use strict";function hsl(hue){return function(start,end){var h=hue((start=Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__.hsl)(start)).h,(end=Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__.hsl)(end)).h),s=Object(__WEBPACK_IMPORTED_MODULE_1__color__.a)(start.s,end.s),l=Object(__WEBPACK_IMPORTED_MODULE_1__color__.a)(start.l,end.l),opacity=Object(__WEBPACK_IMPORTED_MODULE_1__color__.a)(start.opacity,end.opacity);return function(t){return start.h=h(t),start.s=s(t),start.l=l(t),start.opacity=opacity(t),start+""}}}var __WEBPACK_IMPORTED_MODULE_0_d3_color__=__webpack_require__(3),__WEBPACK_IMPORTED_MODULE_1__color__=__webpack_require__(9);hsl(__WEBPACK_IMPORTED_MODULE_1__color__.c),hsl(__WEBPACK_IMPORTED_MODULE_1__color__.a)},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__(3),__webpack_require__(9)},function(module,__webpack_exports__,__webpack_require__){"use strict";function hcl(hue){return function(start,end){var h=hue((start=Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__.hcl)(start)).h,(end=Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__.hcl)(end)).h),c=Object(__WEBPACK_IMPORTED_MODULE_1__color__.a)(start.c,end.c),l=Object(__WEBPACK_IMPORTED_MODULE_1__color__.a)(start.l,end.l),opacity=Object(__WEBPACK_IMPORTED_MODULE_1__color__.a)(start.opacity,end.opacity);return function(t){return start.h=h(t),start.c=c(t),start.l=l(t),start.opacity=opacity(t),start+""}}}var __WEBPACK_IMPORTED_MODULE_0_d3_color__=__webpack_require__(3),__WEBPACK_IMPORTED_MODULE_1__color__=__webpack_require__(9);hcl(__WEBPACK_IMPORTED_MODULE_1__color__.c),hcl(__WEBPACK_IMPORTED_MODULE_1__color__.a)},function(module,__webpack_exports__,__webpack_require__){"use strict";function cubehelix(hue){return function cubehelixGamma(y){function cubehelix(start,end){var h=hue((start=Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__.cubehelix)(start)).h,(end=Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__.cubehelix)(end)).h),s=Object(__WEBPACK_IMPORTED_MODULE_1__color__.a)(start.s,end.s),l=Object(__WEBPACK_IMPORTED_MODULE_1__color__.a)(start.l,end.l),opacity=Object(__WEBPACK_IMPORTED_MODULE_1__color__.a)(start.opacity,end.opacity);return function(t){return start.h=h(t),start.s=s(t),start.l=l(Math.pow(t,y)),start.opacity=opacity(t),start+""}}return y=+y,cubehelix.gamma=cubehelixGamma,cubehelix}(1)}var __WEBPACK_IMPORTED_MODULE_0_d3_color__=__webpack_require__(3),__WEBPACK_IMPORTED_MODULE_1__color__=__webpack_require__(9);cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__.c),cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__.a)},function(module,__webpack_exports__,__webpack_require__){"use strict"},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(1),__WEBPACK_IMPORTED_MODULE_1_d3_format__=__webpack_require__(52);__webpack_exports__.a=function(domain,count,specifier){var precision,start=domain[0],stop=domain[domain.length-1],step=Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.g)(start,stop,null==count?10:count);switch(specifier=Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__.c)(null==specifier?",f":specifier),specifier.type){case"s":var value=Math.max(Math.abs(start),Math.abs(stop));return null!=specifier.precision||isNaN(precision=Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__.e)(step,value))||(specifier.precision=precision),Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__.b)(specifier,value);case"":case"e":case"g":case"p":case"r":null!=specifier.precision||isNaN(precision=Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__.f)(step,Math.max(Math.abs(start),Math.abs(stop))))||(specifier.precision=precision-("e"===specifier.type));break;case"f":case"%":null!=specifier.precision||isNaN(precision=Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__.d)(step))||(specifier.precision=precision-2*("%"===specifier.type))}return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__.a)(specifier)}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.d(__webpack_exports__,"a",function(){return format}),__webpack_require__.d(__webpack_exports__,"b",function(){return formatPrefix});var locale,format,formatPrefix,__WEBPACK_IMPORTED_MODULE_0__locale__=__webpack_require__(53);!function(definition){locale=Object(__WEBPACK_IMPORTED_MODULE_0__locale__.a)(definition),format=locale.format,formatPrefix=locale.formatPrefix}({decimal:".",thousands:",",grouping:[3],currency:["$",""]})},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(grouping,thousands){return function(value,width){for(var i=value.length,t=[],j=0,g=grouping[0],length=0;i>0&&g>0&&(length+g+1>width&&(g=Math.max(1,width-length)),t.push(value.substring(i-=g,i+g)),!((length+=g+1)>width));)g=grouping[j=(j+1)%grouping.length];return t.reverse().join(thousands)}}},function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_exports__.a=function(x,p){x=x.toPrecision(p);out:for(var i1,n=x.length,i=1,i0=-1;i<n;++i)switch(x[i]){case".":i0=i1=i;break;case"0":0===i0&&(i0=i),i1=i;break;case"e":break out;default:i0>0&&(i0=0)}return i0>0?x.slice(0,i0)+x.slice(i1+1):x}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__=__webpack_require__(24);__webpack_exports__.a=function(x,p){var d=Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__.a)(x,p);if(!d)return x+"";var coefficient=d[0],exponent=d[1];return exponent<0?"0."+new Array(-exponent).join("0")+coefficient:coefficient.length>exponent+1?coefficient.slice(0,exponent+1)+"."+coefficient.slice(exponent+1):coefficient+new Array(exponent-coefficient.length+2).join("0")}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__exponent__=__webpack_require__(14);__webpack_exports__.a=function(step){return Math.max(0,-Object(__WEBPACK_IMPORTED_MODULE_0__exponent__.a)(Math.abs(step)))}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__exponent__=__webpack_require__(14);__webpack_exports__.a=function(step,value){return Math.max(0,3*Math.max(-8,Math.min(8,Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__.a)(value)/3)))-Object(__WEBPACK_IMPORTED_MODULE_0__exponent__.a)(Math.abs(step)))}},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__exponent__=__webpack_require__(14);__webpack_exports__.a=function(step,max){return step=Math.abs(step),max=Math.abs(max)-step,Math.max(0,Object(__WEBPACK_IMPORTED_MODULE_0__exponent__.a)(max)-Object(__WEBPACK_IMPORTED_MODULE_0__exponent__.a)(step))+1}},function(module,__webpack_exports__,__webpack_require__){"use strict";function deinterpolate(a,b){return(b=Math.log(b/a))?function(x){return Math.log(x/a)/b}:Object(__WEBPACK_IMPORTED_MODULE_2__constant__.a)(b)}function reinterpolate(a,b){return a<0?function(t){return-Math.pow(-b,t)*Math.pow(-a,1-t)}:function(t){return Math.pow(b,t)*Math.pow(a,1-t)}}function pow10(x){return isFinite(x)?+("1e"+x):x<0?0:x}function powp(base){return 10===base?pow10:base===Math.E?Math.exp:function(x){return Math.pow(base,x)}}function logp(base){return base===Math.E?Math.log:10===base&&Math.log10||2===base&&Math.log2||(base=Math.log(base),function(x){return Math.log(x)/base})}function reflect(f){return function(x){return-f(-x)}}function log(){function rescale(){return logs=logp(base),pows=powp(base),domain()[0]<0&&(logs=reflect(logs),pows=reflect(pows)),scale}var scale=Object(__WEBPACK_IMPORTED_MODULE_4__continuous__.b)(deinterpolate,reinterpolate).domain([1,10]),domain=scale.domain,base=10,logs=logp(10),pows=powp(10);return scale.base=function(_){return arguments.length?(base=+_,rescale()):base},scale.domain=function(_){return arguments.length?(domain(_),rescale()):domain()},scale.ticks=function(count){var r,d=domain(),u=d[0],v=d[d.length-1];(r=v<u)&&(i=u,u=v,v=i);var p,k,t,i=logs(u),j=logs(v),n=null==count?10:+count,z=[];if(!(base%1)&&j-i<n){if(i=Math.round(i)-1,j=Math.round(j)+1,u>0){for(;i<j;++i)for(k=1,p=pows(i);k<base;++k)if(!((t=p*k)<u)){if(t>v)break;z.push(t)}}else for(;i<j;++i)for(k=base-1,p=pows(i);k>=1;--k)if(!((t=p*k)<u)){if(t>v)break;z.push(t)}}else z=Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.h)(i,j,Math.min(j-i,n)).map(pows);return r?z.reverse():z},scale.tickFormat=function(count,specifier){if(null==specifier&&(specifier=10===base?".0e":","),"function"!=typeof specifier&&(specifier=Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__.a)(specifier)),count===1/0)return specifier;null==count&&(count=10);var k=Math.max(1,base*count/scale.ticks().length);return function(d){var i=d/pows(Math.round(logs(d)));return i*base<base-.5&&(i*=base),i<=k?specifier(d):""}},scale.nice=function(){return domain(Object(__WEBPACK_IMPORTED_MODULE_3__nice__.a)(domain(),{floor:function(x){return pows(Math.floor(logs(x)))},ceil:function(x){return pows(Math.ceil(logs(x)))}}))},scale.copy=function(){return Object(__WEBPACK_IMPORTED_MODULE_4__continuous__.a)(scale,log().base(base))},scale}__webpack_exports__.a=log;var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(1),__WEBPACK_IMPORTED_MODULE_1_d3_format__=__webpack_require__(52),__WEBPACK_IMPORTED_MODULE_2__constant__=__webpack_require__(23),__WEBPACK_IMPORTED_MODULE_3__nice__=__webpack_require__(57),__WEBPACK_IMPORTED_MODULE_4__continuous__=__webpack_require__(13)},function(module,__webpack_exports__,__webpack_require__){"use strict";function raise(x,exponent){return x<0?-Math.pow(-x,exponent):Math.pow(x,exponent)}function pow(){function deinterpolate(a,b){return(b=raise(b,exponent)-(a=raise(a,exponent)))?function(x){return(raise(x,exponent)-a)/b}:Object(__WEBPACK_IMPORTED_MODULE_0__constant__.a)(b)}function reinterpolate(a,b){return b=raise(b,exponent)-(a=raise(a,exponent)),function(t){return raise(a+b*t,1/exponent)}}var exponent=1,scale=Object(__WEBPACK_IMPORTED_MODULE_2__continuous__.b)(deinterpolate,reinterpolate),domain=scale.domain;return scale.exponent=function(_){return arguments.length?(exponent=+_,domain(domain())):exponent},scale.copy=function(){return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__.a)(scale,pow().exponent(exponent))},Object(__WEBPACK_IMPORTED_MODULE_1__linear__.b)(scale)}function sqrt(){return pow().exponent(.5)}__webpack_exports__.a=pow,__webpack_exports__.b=sqrt;var __WEBPACK_IMPORTED_MODULE_0__constant__=__webpack_require__(23),__WEBPACK_IMPORTED_MODULE_1__linear__=__webpack_require__(8),__WEBPACK_IMPORTED_MODULE_2__continuous__=__webpack_require__(13)},function(module,__webpack_exports__,__webpack_require__){"use strict";function quantile(){function rescale(){var i=0,n=Math.max(1,range.length);for(thresholds=new Array(n-1);++i<n;)thresholds[i-1]=Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.d)(domain,i/n);return scale}function scale(x){if(!isNaN(x=+x))return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.b)(thresholds,x)]}var domain=[],range=[],thresholds=[];return scale.invertExtent=function(y){var i=range.indexOf(y);return i<0?[NaN,NaN]:[i>0?thresholds[i-1]:domain[0],i<thresholds.length?thresholds[i]:domain[domain.length-1]]},scale.domain=function(_){if(!arguments.length)return domain.slice();domain=[];for(var d,i=0,n=_.length;i<n;++i)null==(d=_[i])||isNaN(d=+d)||domain.push(d);return domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__.a),rescale()},scale.range=function(_){return arguments.length?(range=__WEBPACK_IMPORTED_MODULE_1__array__.b.call(_),rescale()):range.slice()},scale.quantiles=function(){return thresholds.slice()},scale.copy=function(){return quantile().domain(domain).range(range)},scale}__webpack_exports__.a=quantile;var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(1),__WEBPACK_IMPORTED_MODULE_1__array__=__webpack_require__(4)},function(module,__webpack_exports__,__webpack_require__){"use strict";function quantize(){function scale(x){if(x<=x)return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.b)(domain,x,0,n)]}function rescale(){var i=-1;for(domain=new Array(n);++i<n;)domain[i]=((i+1)*x1-(i-n)*x0)/(n+1);return scale}var x0=0,x1=1,n=1,domain=[.5],range=[0,1];return scale.domain=function(_){return arguments.length?(x0=+_[0],x1=+_[1],rescale()):[x0,x1]},scale.range=function(_){return arguments.length?(n=(range=__WEBPACK_IMPORTED_MODULE_1__array__.b.call(_)).length-1,rescale()):range.slice()},scale.invertExtent=function(y){var i=range.indexOf(y);return i<0?[NaN,NaN]:i<1?[x0,domain[0]]:i>=n?[domain[n-1],x1]:[domain[i-1],domain[i]]},scale.copy=function(){return quantize().domain([x0,x1]).range(range)},Object(__WEBPACK_IMPORTED_MODULE_2__linear__.b)(scale)}__webpack_exports__.a=quantize;var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(1),__WEBPACK_IMPORTED_MODULE_1__array__=__webpack_require__(4),__WEBPACK_IMPORTED_MODULE_2__linear__=__webpack_require__(8)},function(module,__webpack_exports__,__webpack_require__){"use strict";function threshold(){function scale(x){if(x<=x)return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__.b)(domain,x,0,n)]}var domain=[.5],range=[0,1],n=1;return scale.domain=function(_){return arguments.length?(domain=__WEBPACK_IMPORTED_MODULE_1__array__.b.call(_),n=Math.min(domain.length,range.length-1),scale):domain.slice()},scale.range=function(_){return arguments.length?(range=__WEBPACK_IMPORTED_MODULE_1__array__.b.call(_),n=Math.min(domain.length,range.length-1),scale):range.slice()},scale.invertExtent=function(y){var i=range.indexOf(y);return[domain[i-1],domain[i]]},scale.copy=function(){return threshold().domain(domain).range(range)},scale}__webpack_exports__.a=threshold;var __WEBPACK_IMPORTED_MODULE_0_d3_array__=__webpack_require__(1),__WEBPACK_IMPORTED_MODULE_1__array__=__webpack_require__(4)},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),millisecond=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(){},function(date,step){date.setTime(+date+step)},function(start,end){return end-start});millisecond.every=function(k){return k=Math.floor(k),isFinite(k)&&k>0?k>1?Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setTime(Math.floor(date/k)*k)},function(date,step){date.setTime(+date+step*k)},function(start,end){return(end-start)/k}):millisecond:null},__webpack_exports__.a=millisecond;millisecond.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),__WEBPACK_IMPORTED_MODULE_1__duration__=__webpack_require__(2),second=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setTime(Math.floor(date/__WEBPACK_IMPORTED_MODULE_1__duration__.d)*__WEBPACK_IMPORTED_MODULE_1__duration__.d)},function(date,step){date.setTime(+date+step*__WEBPACK_IMPORTED_MODULE_1__duration__.d)},function(start,end){return(end-start)/__WEBPACK_IMPORTED_MODULE_1__duration__.d},function(date){return date.getUTCSeconds()});__webpack_exports__.a=second;second.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),__WEBPACK_IMPORTED_MODULE_1__duration__=__webpack_require__(2),minute=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setTime(Math.floor(date/__WEBPACK_IMPORTED_MODULE_1__duration__.c)*__WEBPACK_IMPORTED_MODULE_1__duration__.c)},function(date,step){date.setTime(+date+step*__WEBPACK_IMPORTED_MODULE_1__duration__.c)},function(start,end){return(end-start)/__WEBPACK_IMPORTED_MODULE_1__duration__.c},function(date){return date.getMinutes()});__webpack_exports__.a=minute;minute.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),__WEBPACK_IMPORTED_MODULE_1__duration__=__webpack_require__(2),hour=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){var offset=date.getTimezoneOffset()*__WEBPACK_IMPORTED_MODULE_1__duration__.c%__WEBPACK_IMPORTED_MODULE_1__duration__.b;offset<0&&(offset+=__WEBPACK_IMPORTED_MODULE_1__duration__.b),date.setTime(Math.floor((+date-offset)/__WEBPACK_IMPORTED_MODULE_1__duration__.b)*__WEBPACK_IMPORTED_MODULE_1__duration__.b+offset)},function(date,step){date.setTime(+date+step*__WEBPACK_IMPORTED_MODULE_1__duration__.b)},function(start,end){return(end-start)/__WEBPACK_IMPORTED_MODULE_1__duration__.b},function(date){return date.getHours()});__webpack_exports__.a=hour;hour.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),__WEBPACK_IMPORTED_MODULE_1__duration__=__webpack_require__(2),day=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setHours(0,0,0,0)},function(date,step){date.setDate(date.getDate()+step)},function(start,end){return(end-start-(end.getTimezoneOffset()-start.getTimezoneOffset())*__WEBPACK_IMPORTED_MODULE_1__duration__.c)/__WEBPACK_IMPORTED_MODULE_1__duration__.a},function(date){return date.getDate()-1});__webpack_exports__.a=day;day.range},function(module,__webpack_exports__,__webpack_require__){"use strict";function weekday(i){return Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setDate(date.getDate()-(date.getDay()+7-i)%7),date.setHours(0,0,0,0)},function(date,step){date.setDate(date.getDate()+7*step)},function(start,end){return(end-start-(end.getTimezoneOffset()-start.getTimezoneOffset())*__WEBPACK_IMPORTED_MODULE_1__duration__.c)/__WEBPACK_IMPORTED_MODULE_1__duration__.e})}__webpack_require__.d(__webpack_exports__,"b",function(){return sunday}),__webpack_require__.d(__webpack_exports__,"a",function(){return monday});var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),__WEBPACK_IMPORTED_MODULE_1__duration__=__webpack_require__(2),sunday=weekday(0),monday=weekday(1),tuesday=weekday(2),wednesday=weekday(3),thursday=weekday(4),friday=weekday(5),saturday=weekday(6);sunday.range,monday.range,tuesday.range,wednesday.range,thursday.range,friday.range,saturday.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),month=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setDate(1),date.setHours(0,0,0,0)},function(date,step){date.setMonth(date.getMonth()+step)},function(start,end){return end.getMonth()-start.getMonth()+12*(end.getFullYear()-start.getFullYear())},function(date){return date.getMonth()});__webpack_exports__.a=month;month.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),year=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setMonth(0,1),date.setHours(0,0,0,0)},function(date,step){date.setFullYear(date.getFullYear()+step)},function(start,end){return end.getFullYear()-start.getFullYear()},function(date){return date.getFullYear()});year.every=function(k){return isFinite(k=Math.floor(k))&&k>0?Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setFullYear(Math.floor(date.getFullYear()/k)*k),date.setMonth(0,1),date.setHours(0,0,0,0)},function(date,step){date.setFullYear(date.getFullYear()+step*k)}):null},__webpack_exports__.a=year;year.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),__WEBPACK_IMPORTED_MODULE_1__duration__=__webpack_require__(2),utcMinute=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setUTCSeconds(0,0)},function(date,step){date.setTime(+date+step*__WEBPACK_IMPORTED_MODULE_1__duration__.c)},function(start,end){return(end-start)/__WEBPACK_IMPORTED_MODULE_1__duration__.c},function(date){return date.getUTCMinutes()});__webpack_exports__.a=utcMinute;utcMinute.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),__WEBPACK_IMPORTED_MODULE_1__duration__=__webpack_require__(2),utcHour=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setUTCMinutes(0,0,0)},function(date,step){date.setTime(+date+step*__WEBPACK_IMPORTED_MODULE_1__duration__.b)},function(start,end){return(end-start)/__WEBPACK_IMPORTED_MODULE_1__duration__.b},function(date){return date.getUTCHours()});__webpack_exports__.a=utcHour;utcHour.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),__WEBPACK_IMPORTED_MODULE_1__duration__=__webpack_require__(2),utcDay=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setUTCHours(0,0,0,0)},function(date,step){date.setUTCDate(date.getUTCDate()+step)},function(start,end){return(end-start)/__WEBPACK_IMPORTED_MODULE_1__duration__.a},function(date){return date.getUTCDate()-1});__webpack_exports__.a=utcDay;utcDay.range},function(module,__webpack_exports__,__webpack_require__){"use strict";function utcWeekday(i){return Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setUTCDate(date.getUTCDate()-(date.getUTCDay()+7-i)%7),date.setUTCHours(0,0,0,0)},function(date,step){date.setUTCDate(date.getUTCDate()+7*step)},function(start,end){return(end-start)/__WEBPACK_IMPORTED_MODULE_1__duration__.e})}__webpack_require__.d(__webpack_exports__,"b",function(){return utcSunday}),__webpack_require__.d(__webpack_exports__,"a",function(){return utcMonday});var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),__WEBPACK_IMPORTED_MODULE_1__duration__=__webpack_require__(2),utcSunday=utcWeekday(0),utcMonday=utcWeekday(1),utcTuesday=utcWeekday(2),utcWednesday=utcWeekday(3),utcThursday=utcWeekday(4),utcFriday=utcWeekday(5),utcSaturday=utcWeekday(6);utcSunday.range,utcMonday.range,utcTuesday.range,utcWednesday.range,utcThursday.range,utcFriday.range,utcSaturday.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),utcMonth=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setUTCDate(1),date.setUTCHours(0,0,0,0)},function(date,step){date.setUTCMonth(date.getUTCMonth()+step)},function(start,end){return end.getUTCMonth()-start.getUTCMonth()+12*(end.getUTCFullYear()-start.getUTCFullYear())},function(date){return date.getUTCMonth()});__webpack_exports__.a=utcMonth;utcMonth.range},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__interval__=__webpack_require__(0),utcYear=Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setUTCMonth(0,1),date.setUTCHours(0,0,0,0)},function(date,step){date.setUTCFullYear(date.getUTCFullYear()+step)},function(start,end){return end.getUTCFullYear()-start.getUTCFullYear()},function(date){return date.getUTCFullYear()});utcYear.every=function(k){return isFinite(k=Math.floor(k))&&k>0?Object(__WEBPACK_IMPORTED_MODULE_0__interval__.a)(function(date){date.setUTCFullYear(Math.floor(date.getUTCFullYear()/k)*k),date.setUTCMonth(0,1),date.setUTCHours(0,0,0,0)},function(date,step){date.setUTCFullYear(date.getUTCFullYear()+step*k)}):null},__webpack_exports__.a=utcYear;utcYear.range},function(module,__webpack_exports__,__webpack_require__){"use strict";function parseIsoNative(string){var date=new Date(string);return isNaN(date)?null:date}var __WEBPACK_IMPORTED_MODULE_0__isoFormat__=__webpack_require__(61),__WEBPACK_IMPORTED_MODULE_1__defaultLocale__=__webpack_require__(26);+new Date("2000-01-01T00:00:00.000Z")||Object(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__.c)(__WEBPACK_IMPORTED_MODULE_0__isoFormat__.a)},function(module,__webpack_exports__,__webpack_require__){"use strict";var __WEBPACK_IMPORTED_MODULE_0__time__=__webpack_require__(58),__WEBPACK_IMPORTED_MODULE_1_d3_time_format__=__webpack_require__(59),__WEBPACK_IMPORTED_MODULE_2_d3_time__=__webpack_require__(25);__webpack_exports__.a=function(){return Object(__WEBPACK_IMPORTED_MODULE_0__time__.a)(__WEBPACK_IMPORTED_MODULE_2_d3_time__.t,__WEBPACK_IMPORTED_MODULE_2_d3_time__.p,__WEBPACK_IMPORTED_MODULE_2_d3_time__.s,__WEBPACK_IMPORTED_MODULE_2_d3_time__.k,__WEBPACK_IMPORTED_MODULE_2_d3_time__.l,__WEBPACK_IMPORTED_MODULE_2_d3_time__.n,__WEBPACK_IMPORTED_MODULE_2_d3_time__.q,__WEBPACK_IMPORTED_MODULE_2_d3_time__.m,__WEBPACK_IMPORTED_MODULE_1_d3_time_format__.b).domain([Date.UTC(2e3,0,1),Date.UTC(2e3,0,2)])}},function(module,__webpack_exports__,__webpack_require__){"use strict";function sequential(interpolator){function scale(x){var t=(x-x0)/(x1-x0);return interpolator(clamp?Math.max(0,Math.min(1,t)):t)}var x0=0,x1=1,clamp=!1;return scale.domain=function(_){return arguments.length?(x0=+_[0],x1=+_[1],scale):[x0,x1]},scale.clamp=function(_){return arguments.length?(clamp=!!_,scale):clamp},scale.interpolator=function(_){return arguments.length?(interpolator=_,scale):interpolator},scale.copy=function(){return sequential(interpolator).domain([x0,x1]).clamp(clamp)},Object(__WEBPACK_IMPORTED_MODULE_0__linear__.b)(scale)}__webpack_exports__.a=sequential;var __WEBPACK_IMPORTED_MODULE_0__linear__=__webpack_require__(8)},function(module,exports,__webpack_require__){!function(global,factory){factory(exports)}(0,function(exports){"use strict";var MarkerClusterGroup=L.MarkerClusterGroup=L.FeatureGroup.extend({options:{maxClusterRadius:80,iconCreateFunction:null,clusterPane:L.Marker.prototype.options.pane,spiderfyOnMaxZoom:!0,showCoverageOnHover:!0,zoomToBoundsOnClick:!0,singleMarkerMode:!1,disableClusteringAtZoom:null,removeOutsideVisibleBounds:!0,animate:!0,animateAddingMarkers:!1,spiderfyDistanceMultiplier:1,spiderLegPolylineOptions:{weight:1.5,color:"#222",opacity:.5},chunkedLoading:!1,chunkInterval:200,chunkDelay:50,chunkProgress:null,polygonOptions:{}},initialize:function(options){L.Util.setOptions(this,options),this.options.iconCreateFunction||(this.options.iconCreateFunction=this._defaultIconCreateFunction),this._featureGroup=L.featureGroup(),this._featureGroup.addEventParent(this),this._nonPointGroup=L.featureGroup(),this._nonPointGroup.addEventParent(this),this._inZoomAnimation=0,this._needsClustering=[],this._needsRemoving=[],this._currentShownBounds=null,this._queue=[],this._childMarkerEventHandlers={dragstart:this._childMarkerDragStart,move:this._childMarkerMoved,dragend:this._childMarkerDragEnd};var animate=L.DomUtil.TRANSITION&&this.options.animate;L.extend(this,animate?this._withAnimation:this._noAnimation),this._markerCluster=animate?L.MarkerCluster:L.MarkerClusterNonAnimated},addLayer:function(layer){if(layer instanceof L.LayerGroup)return this.addLayers([layer]);if(!layer.getLatLng)return this._nonPointGroup.addLayer(layer),this.fire("layeradd",{layer:layer}),this;if(!this._map)return this._needsClustering.push(layer),this.fire("layeradd",{layer:layer}),this;if(this.hasLayer(layer))return this;this._unspiderfy&&this._unspiderfy(),this._addLayer(layer,this._maxZoom),this.fire("layeradd",{layer:layer}),this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons();var visibleLayer=layer,currentZoom=this._zoom;if(layer.__parent)for(;visibleLayer.__parent._zoom>=currentZoom;)visibleLayer=visibleLayer.__parent;return this._currentShownBounds.contains(visibleLayer.getLatLng())&&(this.options.animateAddingMarkers?this._animationAddLayer(layer,visibleLayer):this._animationAddLayerNonAnimated(layer,visibleLayer)),this},removeLayer:function(layer){return layer instanceof L.LayerGroup?this.removeLayers([layer]):layer.getLatLng?this._map?layer.__parent?(this._unspiderfy&&(this._unspiderfy(),this._unspiderfyLayer(layer)),this._removeLayer(layer,!0),this.fire("layerremove",{layer:layer}),this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),layer.off(this._childMarkerEventHandlers,this),this._featureGroup.hasLayer(layer)&&(this._featureGroup.removeLayer(layer),layer.clusterShow&&layer.clusterShow()),this):this:(!this._arraySplice(this._needsClustering,layer)&&this.hasLayer(layer)&&this._needsRemoving.push({layer:layer,latlng:layer._latlng}),this.fire("layerremove",{layer:layer}),this):(this._nonPointGroup.removeLayer(layer),this.fire("layerremove",{layer:layer}),this)},addLayers:function(layersArray,skipLayerAddEvent){if(!L.Util.isArray(layersArray))return this.addLayer(layersArray);var m,fg=this._featureGroup,npg=this._nonPointGroup,chunked=this.options.chunkedLoading,chunkInterval=this.options.chunkInterval,chunkProgress=this.options.chunkProgress,l=layersArray.length,offset=0,originalArray=!0;if(this._map){var started=(new Date).getTime(),process=L.bind(function(){for(var start=(new Date).getTime();offset<l;offset++){if(chunked&&offset%200==0){if((new Date).getTime()-start>chunkInterval)break}if((m=layersArray[offset])instanceof L.LayerGroup)originalArray&&(layersArray=layersArray.slice(),originalArray=!1),this._extractNonGroupLayers(m,layersArray),l=layersArray.length;else if(m.getLatLng){if(!this.hasLayer(m)&&(this._addLayer(m,this._maxZoom),skipLayerAddEvent||this.fire("layeradd",{layer:m}),m.__parent&&2===m.__parent.getChildCount())){var markers=m.__parent.getAllChildMarkers(),otherMarker=markers[0]===m?markers[1]:markers[0];fg.removeLayer(otherMarker)}}else npg.addLayer(m),skipLayerAddEvent||this.fire("layeradd",{layer:m})}chunkProgress&&chunkProgress(offset,l,(new Date).getTime()-started),offset===l?(this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),this._topClusterLevel._recursivelyAddChildrenToMap(null,this._zoom,this._currentShownBounds)):setTimeout(process,this.options.chunkDelay)},this);process()}else for(var needsClustering=this._needsClustering;offset<l;offset++)m=layersArray[offset],m instanceof L.LayerGroup?(originalArray&&(layersArray=layersArray.slice(),originalArray=!1),this._extractNonGroupLayers(m,layersArray),l=layersArray.length):m.getLatLng?this.hasLayer(m)||needsClustering.push(m):npg.addLayer(m);return this},removeLayers:function(layersArray){var i,m,l=layersArray.length,fg=this._featureGroup,npg=this._nonPointGroup,originalArray=!0;if(!this._map){for(i=0;i<l;i++)m=layersArray[i],m instanceof L.LayerGroup?(originalArray&&(layersArray=layersArray.slice(),originalArray=!1),this._extractNonGroupLayers(m,layersArray),l=layersArray.length):(this._arraySplice(this._needsClustering,m),npg.removeLayer(m),this.hasLayer(m)&&this._needsRemoving.push({layer:m,latlng:m._latlng}),this.fire("layerremove",{layer:m}));return this}if(this._unspiderfy){this._unspiderfy();var layersArray2=layersArray.slice(),l2=l;for(i=0;i<l2;i++)m=layersArray2[i],m instanceof L.LayerGroup?(this._extractNonGroupLayers(m,layersArray2),l2=layersArray2.length):this._unspiderfyLayer(m)}for(i=0;i<l;i++)m=layersArray[i],m instanceof L.LayerGroup?(originalArray&&(layersArray=layersArray.slice(),originalArray=!1),this._extractNonGroupLayers(m,layersArray),l=layersArray.length):m.__parent?(this._removeLayer(m,!0,!0),this.fire("layerremove",{layer:m}),fg.hasLayer(m)&&(fg.removeLayer(m),m.clusterShow&&m.clusterShow())):(npg.removeLayer(m),this.fire("layerremove",{layer:m}));return this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),this._topClusterLevel._recursivelyAddChildrenToMap(null,this._zoom,this._currentShownBounds),this},clearLayers:function(){return this._map||(this._needsClustering=[],delete this._gridClusters,delete this._gridUnclustered),this._noanimationUnspiderfy&&this._noanimationUnspiderfy(),this._featureGroup.clearLayers(),this._nonPointGroup.clearLayers(),this.eachLayer(function(marker){marker.off(this._childMarkerEventHandlers,this),delete marker.__parent},this),this._map&&this._generateInitialClusters(),this},getBounds:function(){var bounds=new L.LatLngBounds;this._topClusterLevel&&bounds.extend(this._topClusterLevel._bounds);for(var i=this._needsClustering.length-1;i>=0;i--)bounds.extend(this._needsClustering[i].getLatLng());return bounds.extend(this._nonPointGroup.getBounds()),bounds},eachLayer:function(method,context){var thisNeedsRemoving,i,j,markers=this._needsClustering.slice(),needsRemoving=this._needsRemoving;for(this._topClusterLevel&&this._topClusterLevel.getAllChildMarkers(markers),i=markers.length-1;i>=0;i--){for(thisNeedsRemoving=!0,j=needsRemoving.length-1;j>=0;j--)if(needsRemoving[j].layer===markers[i]){thisNeedsRemoving=!1;break}thisNeedsRemoving&&method.call(context,markers[i])}this._nonPointGroup.eachLayer(method,context)},getLayers:function(){var layers=[];return this.eachLayer(function(l){layers.push(l)}),layers},getLayer:function(id){var result=null;return id=parseInt(id,10),this.eachLayer(function(l){L.stamp(l)===id&&(result=l)}),result},hasLayer:function(layer){if(!layer)return!1;var i,anArray=this._needsClustering;for(i=anArray.length-1;i>=0;i--)if(anArray[i]===layer)return!0;for(anArray=this._needsRemoving,i=anArray.length-1;i>=0;i--)if(anArray[i].layer===layer)return!1;return!(!layer.__parent||layer.__parent._group!==this)||this._nonPointGroup.hasLayer(layer)},zoomToShowLayer:function(layer,callback){"function"!=typeof callback&&(callback=function(){});var showMarker=function(){!layer._icon&&!layer.__parent._icon||this._inZoomAnimation||(this._map.off("moveend",showMarker,this),this.off("animationend",showMarker,this),layer._icon?callback():layer.__parent._icon&&(this.once("spiderfied",callback,this),layer.__parent.spiderfy()))};layer._icon&&this._map.getBounds().contains(layer.getLatLng())?callback():layer.__parent._zoom<Math.round(this._map._zoom)?(this._map.on("moveend",showMarker,this),this._map.panTo(layer.getLatLng())):(this._map.on("moveend",showMarker,this),this.on("animationend",showMarker,this),layer.__parent.zoomToBounds())},onAdd:function(map){this._map=map;var i,l,layer;if(!isFinite(this._map.getMaxZoom()))throw"Map has no maxZoom specified";for(this._featureGroup.addTo(map),this._nonPointGroup.addTo(map),this._gridClusters||this._generateInitialClusters(),this._maxLat=map.options.crs.projection.MAX_LATITUDE,i=0,l=this._needsRemoving.length;i<l;i++)layer=this._needsRemoving[i],layer.newlatlng=layer.layer._latlng,layer.layer._latlng=layer.latlng;for(i=0,l=this._needsRemoving.length;i<l;i++)layer=this._needsRemoving[i],this._removeLayer(layer.layer,!0),layer.layer._latlng=layer.newlatlng;this._needsRemoving=[],this._zoom=Math.round(this._map._zoom),this._currentShownBounds=this._getExpandedVisibleBounds(),this._map.on("zoomend",this._zoomEnd,this),this._map.on("moveend",this._moveEnd,this),this._spiderfierOnAdd&&this._spiderfierOnAdd(),this._bindEvents(),l=this._needsClustering,this._needsClustering=[],this.addLayers(l,!0)},onRemove:function(map){map.off("zoomend",this._zoomEnd,this),map.off("moveend",this._moveEnd,this),this._unbindEvents(),this._map._mapPane.className=this._map._mapPane.className.replace(" leaflet-cluster-anim",""),this._spiderfierOnRemove&&this._spiderfierOnRemove(),delete this._maxLat,this._hideCoverage(),this._featureGroup.remove(),this._nonPointGroup.remove(),this._featureGroup.clearLayers(),this._map=null},getVisibleParent:function(marker){for(var vMarker=marker;vMarker&&!vMarker._icon;)vMarker=vMarker.__parent;return vMarker||null},_arraySplice:function(anArray,obj){for(var i=anArray.length-1;i>=0;i--)if(anArray[i]===obj)return anArray.splice(i,1),!0},_removeFromGridUnclustered:function(marker,z){for(var map=this._map,gridUnclustered=this._gridUnclustered,minZoom=Math.floor(this._map.getMinZoom());z>=minZoom&&gridUnclustered[z].removeObject(marker,map.project(marker.getLatLng(),z));z--);},_childMarkerDragStart:function(e){e.target.__dragStart=e.target._latlng},_childMarkerMoved:function(e){if(!this._ignoreMove&&!e.target.__dragStart){var isPopupOpen=e.target._popup&&e.target._popup.isOpen();this._moveChild(e.target,e.oldLatLng,e.latlng),isPopupOpen&&e.target.openPopup()}},_moveChild:function(layer,from,to){layer._latlng=from,this.removeLayer(layer),layer._latlng=to,this.addLayer(layer)},_childMarkerDragEnd:function(e){e.target.__dragStart&&this._moveChild(e.target,e.target.__dragStart,e.target._latlng),delete e.target.__dragStart},_removeLayer:function(marker,removeFromDistanceGrid,dontUpdateMap){var gridClusters=this._gridClusters,gridUnclustered=this._gridUnclustered,fg=this._featureGroup,map=this._map,minZoom=Math.floor(this._map.getMinZoom());removeFromDistanceGrid&&this._removeFromGridUnclustered(marker,this._maxZoom);var otherMarker,cluster=marker.__parent,markers=cluster._markers;for(this._arraySplice(markers,marker);cluster&&(cluster._childCount--,cluster._boundsNeedUpdate=!0,!(cluster._zoom<minZoom));)removeFromDistanceGrid&&cluster._childCount<=1?(otherMarker=cluster._markers[0]===marker?cluster._markers[1]:cluster._markers[0],gridClusters[cluster._zoom].removeObject(cluster,map.project(cluster._cLatLng,cluster._zoom)),gridUnclustered[cluster._zoom].addObject(otherMarker,map.project(otherMarker.getLatLng(),cluster._zoom)),this._arraySplice(cluster.__parent._childClusters,cluster),cluster.__parent._markers.push(otherMarker),otherMarker.__parent=cluster.__parent,cluster._icon&&(fg.removeLayer(cluster),dontUpdateMap||fg.addLayer(otherMarker))):cluster._iconNeedsUpdate=!0,cluster=cluster.__parent;delete marker.__parent},_isOrIsParent:function(el,oel){for(;oel;){if(el===oel)return!0;oel=oel.parentNode}return!1},fire:function(type,data,propagate){if(data&&data.layer instanceof L.MarkerCluster){if(data.originalEvent&&this._isOrIsParent(data.layer._icon,data.originalEvent.relatedTarget))return;type="cluster"+type}L.FeatureGroup.prototype.fire.call(this,type,data,propagate)},listens:function(type,propagate){return L.FeatureGroup.prototype.listens.call(this,type,propagate)||L.FeatureGroup.prototype.listens.call(this,"cluster"+type,propagate)},_defaultIconCreateFunction:function(cluster){var childCount=cluster.getChildCount(),c=" marker-cluster-";return c+=childCount<10?"small":childCount<100?"medium":"large",new L.DivIcon({html:"<div><span>"+childCount+"</span></div>",className:"marker-cluster"+c,iconSize:new L.Point(40,40)})},_bindEvents:function(){var map=this._map,spiderfyOnMaxZoom=this.options.spiderfyOnMaxZoom,showCoverageOnHover=this.options.showCoverageOnHover,zoomToBoundsOnClick=this.options.zoomToBoundsOnClick;(spiderfyOnMaxZoom||zoomToBoundsOnClick)&&this.on("clusterclick",this._zoomOrSpiderfy,this),showCoverageOnHover&&(this.on("clustermouseover",this._showCoverage,this),this.on("clustermouseout",this._hideCoverage,this),map.on("zoomend",this._hideCoverage,this))},_zoomOrSpiderfy:function(e){for(var cluster=e.layer,bottomCluster=cluster;1===bottomCluster._childClusters.length;)bottomCluster=bottomCluster._childClusters[0];bottomCluster._zoom===this._maxZoom&&bottomCluster._childCount===cluster._childCount&&this.options.spiderfyOnMaxZoom?cluster.spiderfy():this.options.zoomToBoundsOnClick&&cluster.zoomToBounds(),e.originalEvent&&13===e.originalEvent.keyCode&&this._map._container.focus()},_showCoverage:function(e){var map=this._map;this._inZoomAnimation||(this._shownPolygon&&map.removeLayer(this._shownPolygon),e.layer.getChildCount()>2&&e.layer!==this._spiderfied&&(this._shownPolygon=new L.Polygon(e.layer.getConvexHull(),this.options.polygonOptions),map.addLayer(this._shownPolygon)))},_hideCoverage:function(){this._shownPolygon&&(this._map.removeLayer(this._shownPolygon),this._shownPolygon=null)},_unbindEvents:function(){var spiderfyOnMaxZoom=this.options.spiderfyOnMaxZoom,showCoverageOnHover=this.options.showCoverageOnHover,zoomToBoundsOnClick=this.options.zoomToBoundsOnClick,map=this._map;(spiderfyOnMaxZoom||zoomToBoundsOnClick)&&this.off("clusterclick",this._zoomOrSpiderfy,this),showCoverageOnHover&&(this.off("clustermouseover",this._showCoverage,this),this.off("clustermouseout",this._hideCoverage,this),map.off("zoomend",this._hideCoverage,this))},_zoomEnd:function(){this._map&&(this._mergeSplitClusters(),this._zoom=Math.round(this._map._zoom),this._currentShownBounds=this._getExpandedVisibleBounds())},_moveEnd:function(){if(!this._inZoomAnimation){var newBounds=this._getExpandedVisibleBounds();this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),this._zoom,newBounds),this._topClusterLevel._recursivelyAddChildrenToMap(null,Math.round(this._map._zoom),newBounds),this._currentShownBounds=newBounds}},_generateInitialClusters:function(){var maxZoom=Math.ceil(this._map.getMaxZoom()),minZoom=Math.floor(this._map.getMinZoom()),radius=this.options.maxClusterRadius,radiusFn=radius;"function"!=typeof radius&&(radiusFn=function(){return radius}),null!==this.options.disableClusteringAtZoom&&(maxZoom=this.options.disableClusteringAtZoom-1),this._maxZoom=maxZoom,this._gridClusters={},this._gridUnclustered={};for(var zoom=maxZoom;zoom>=minZoom;zoom--)this._gridClusters[zoom]=new L.DistanceGrid(radiusFn(zoom)),this._gridUnclustered[zoom]=new L.DistanceGrid(radiusFn(zoom));this._topClusterLevel=new this._markerCluster(this,minZoom-1)},_addLayer:function(layer,zoom){var markerPoint,z,gridClusters=this._gridClusters,gridUnclustered=this._gridUnclustered,minZoom=Math.floor(this._map.getMinZoom());for(this.options.singleMarkerMode&&this._overrideMarkerIcon(layer),layer.on(this._childMarkerEventHandlers,this);zoom>=minZoom;zoom--){markerPoint=this._map.project(layer.getLatLng(),zoom);var closest=gridClusters[zoom].getNearObject(markerPoint);if(closest)return closest._addChild(layer),void(layer.__parent=closest);if(closest=gridUnclustered[zoom].getNearObject(markerPoint)){var parent=closest.__parent;parent&&this._removeLayer(closest,!1);var newCluster=new this._markerCluster(this,zoom,closest,layer);gridClusters[zoom].addObject(newCluster,this._map.project(newCluster._cLatLng,zoom)),closest.__parent=newCluster,layer.__parent=newCluster;var lastParent=newCluster;for(z=zoom-1;z>parent._zoom;z--)lastParent=new this._markerCluster(this,z,lastParent),gridClusters[z].addObject(lastParent,this._map.project(closest.getLatLng(),z));return parent._addChild(lastParent),void this._removeFromGridUnclustered(closest,zoom)}gridUnclustered[zoom].addObject(layer,markerPoint)}this._topClusterLevel._addChild(layer),layer.__parent=this._topClusterLevel},_refreshClustersIcons:function(){this._featureGroup.eachLayer(function(c){c instanceof L.MarkerCluster&&c._iconNeedsUpdate&&c._updateIcon()})},_enqueue:function(fn){this._queue.push(fn),this._queueTimeout||(this._queueTimeout=setTimeout(L.bind(this._processQueue,this),300))},_processQueue:function(){for(var i=0;i<this._queue.length;i++)this._queue[i].call(this);this._queue.length=0,clearTimeout(this._queueTimeout),this._queueTimeout=null},_mergeSplitClusters:function(){var mapZoom=Math.round(this._map._zoom);this._processQueue(),this._zoom<mapZoom&&this._currentShownBounds.intersects(this._getExpandedVisibleBounds())?(this._animationStart(),this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),this._zoom,this._getExpandedVisibleBounds()),this._animationZoomIn(this._zoom,mapZoom)):this._zoom>mapZoom?(this._animationStart(),this._animationZoomOut(this._zoom,mapZoom)):this._moveEnd()},_getExpandedVisibleBounds:function(){return this.options.removeOutsideVisibleBounds?L.Browser.mobile?this._checkBoundsMaxLat(this._map.getBounds()):this._checkBoundsMaxLat(this._map.getBounds().pad(1)):this._mapBoundsInfinite},_checkBoundsMaxLat:function(bounds){var maxLat=this._maxLat;return void 0!==maxLat&&(bounds.getNorth()>=maxLat&&(bounds._northEast.lat=1/0),bounds.getSouth()<=-maxLat&&(bounds._southWest.lat=-1/0)),bounds},_animationAddLayerNonAnimated:function(layer,newCluster){if(newCluster===layer)this._featureGroup.addLayer(layer);else if(2===newCluster._childCount){newCluster._addToMap();var markers=newCluster.getAllChildMarkers();this._featureGroup.removeLayer(markers[0]),this._featureGroup.removeLayer(markers[1])}else newCluster._updateIcon()},_extractNonGroupLayers:function(group,output){var layer,layers=group.getLayers(),i=0;for(output=output||[];i<layers.length;i++)layer=layers[i],layer instanceof L.LayerGroup?this._extractNonGroupLayers(layer,output):output.push(layer);return output},_overrideMarkerIcon:function(layer){return layer.options.icon=this.options.iconCreateFunction({getChildCount:function(){return 1},getAllChildMarkers:function(){return[layer]}})}});L.MarkerClusterGroup.include({_mapBoundsInfinite:new L.LatLngBounds(new L.LatLng(-1/0,-1/0),new L.LatLng(1/0,1/0))}),L.MarkerClusterGroup.include({_noAnimation:{_animationStart:function(){},_animationZoomIn:function(previousZoomLevel,newZoomLevel){this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),previousZoomLevel),this._topClusterLevel._recursivelyAddChildrenToMap(null,newZoomLevel,this._getExpandedVisibleBounds()),this.fire("animationend")},_animationZoomOut:function(previousZoomLevel,newZoomLevel){this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),previousZoomLevel),this._topClusterLevel._recursivelyAddChildrenToMap(null,newZoomLevel,this._getExpandedVisibleBounds()),this.fire("animationend")},_animationAddLayer:function(layer,newCluster){this._animationAddLayerNonAnimated(layer,newCluster)}},_withAnimation:{_animationStart:function(){this._map._mapPane.className+=" leaflet-cluster-anim",this._inZoomAnimation++},_animationZoomIn:function(previousZoomLevel,newZoomLevel){var i,bounds=this._getExpandedVisibleBounds(),fg=this._featureGroup,minZoom=Math.floor(this._map.getMinZoom());this._ignoreMove=!0,this._topClusterLevel._recursively(bounds,previousZoomLevel,minZoom,function(c){var m,startPos=c._latlng,markers=c._markers;for(bounds.contains(startPos)||(startPos=null),c._isSingleParent()&&previousZoomLevel+1===newZoomLevel?(fg.removeLayer(c),c._recursivelyAddChildrenToMap(null,newZoomLevel,bounds)):(c.clusterHide(),c._recursivelyAddChildrenToMap(startPos,newZoomLevel,bounds)),i=markers.length-1;i>=0;i--)m=markers[i],bounds.contains(m._latlng)||fg.removeLayer(m)}),this._forceLayout(),this._topClusterLevel._recursivelyBecomeVisible(bounds,newZoomLevel),fg.eachLayer(function(n){n instanceof L.MarkerCluster||!n._icon||n.clusterShow()}),this._topClusterLevel._recursively(bounds,previousZoomLevel,newZoomLevel,function(c){c._recursivelyRestoreChildPositions(newZoomLevel)}),this._ignoreMove=!1,this._enqueue(function(){this._topClusterLevel._recursively(bounds,previousZoomLevel,minZoom,function(c){fg.removeLayer(c),c.clusterShow()}),this._animationEnd()})},_animationZoomOut:function(previousZoomLevel,newZoomLevel){this._animationZoomOutSingle(this._topClusterLevel,previousZoomLevel-1,newZoomLevel),this._topClusterLevel._recursivelyAddChildrenToMap(null,newZoomLevel,this._getExpandedVisibleBounds()),this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),previousZoomLevel,this._getExpandedVisibleBounds())},_animationAddLayer:function(layer,newCluster){var me=this,fg=this._featureGroup;fg.addLayer(layer),newCluster!==layer&&(newCluster._childCount>2?(newCluster._updateIcon(),this._forceLayout(),this._animationStart(),layer._setPos(this._map.latLngToLayerPoint(newCluster.getLatLng())),layer.clusterHide(),this._enqueue(function(){fg.removeLayer(layer),layer.clusterShow(),me._animationEnd()})):(this._forceLayout(),me._animationStart(),me._animationZoomOutSingle(newCluster,this._map.getMaxZoom(),this._zoom)))}},_animationZoomOutSingle:function(cluster,previousZoomLevel,newZoomLevel){var bounds=this._getExpandedVisibleBounds(),minZoom=Math.floor(this._map.getMinZoom());cluster._recursivelyAnimateChildrenInAndAddSelfToMap(bounds,minZoom,previousZoomLevel+1,newZoomLevel);var me=this;this._forceLayout(),cluster._recursivelyBecomeVisible(bounds,newZoomLevel),this._enqueue(function(){if(1===cluster._childCount){var m=cluster._markers[0];this._ignoreMove=!0,m.setLatLng(m.getLatLng()),this._ignoreMove=!1,m.clusterShow&&m.clusterShow()}else cluster._recursively(bounds,newZoomLevel,minZoom,function(c){c._recursivelyRemoveChildrenFromMap(bounds,minZoom,previousZoomLevel+1)});me._animationEnd()})},_animationEnd:function(){this._map&&(this._map._mapPane.className=this._map._mapPane.className.replace(" leaflet-cluster-anim","")),this._inZoomAnimation--,this.fire("animationend")},_forceLayout:function(){L.Util.falseFn(document.body.offsetWidth)}}),L.markerClusterGroup=function(options){return new L.MarkerClusterGroup(options)};var MarkerCluster=L.MarkerCluster=L.Marker.extend({options:L.Icon.prototype.options,initialize:function(group,zoom,a,b){L.Marker.prototype.initialize.call(this,a?a._cLatLng||a.getLatLng():new L.LatLng(0,0),{icon:this,pane:group.options.clusterPane}),this._group=group,this._zoom=zoom,this._markers=[],this._childClusters=[],this._childCount=0,this._iconNeedsUpdate=!0,this._boundsNeedUpdate=!0,this._bounds=new L.LatLngBounds,a&&this._addChild(a),b&&this._addChild(b)},getAllChildMarkers:function(storageArray){storageArray=storageArray||[];for(var i=this._childClusters.length-1;i>=0;i--)this._childClusters[i].getAllChildMarkers(storageArray);for(var j=this._markers.length-1;j>=0;j--)storageArray.push(this._markers[j]);return storageArray},getChildCount:function(){return this._childCount},zoomToBounds:function(fitBoundsOptions){for(var i,childClusters=this._childClusters.slice(),map=this._group._map,boundsZoom=map.getBoundsZoom(this._bounds),zoom=this._zoom+1,mapZoom=map.getZoom();childClusters.length>0&&boundsZoom>zoom;){zoom++;var newClusters=[];for(i=0;i<childClusters.length;i++)newClusters=newClusters.concat(childClusters[i]._childClusters);childClusters=newClusters}boundsZoom>zoom?this._group._map.setView(this._latlng,zoom):boundsZoom<=mapZoom?this._group._map.setView(this._latlng,mapZoom+1):this._group._map.fitBounds(this._bounds,fitBoundsOptions)},getBounds:function(){var bounds=new L.LatLngBounds;return bounds.extend(this._bounds),bounds},_updateIcon:function(){this._iconNeedsUpdate=!0,this._icon&&this.setIcon(this)},createIcon:function(){return this._iconNeedsUpdate&&(this._iconObj=this._group.options.iconCreateFunction(this),this._iconNeedsUpdate=!1),this._iconObj.createIcon()},createShadow:function(){return this._iconObj.createShadow()},_addChild:function(new1,isNotificationFromChild){this._iconNeedsUpdate=!0,this._boundsNeedUpdate=!0,this._setClusterCenter(new1),new1 instanceof L.MarkerCluster?(isNotificationFromChild||(this._childClusters.push(new1),new1.__parent=this),this._childCount+=new1._childCount):(isNotificationFromChild||this._markers.push(new1),this._childCount++),this.__parent&&this.__parent._addChild(new1,!0)},_setClusterCenter:function(child){this._cLatLng||(this._cLatLng=child._cLatLng||child._latlng)},_resetBounds:function(){var bounds=this._bounds;bounds._southWest&&(bounds._southWest.lat=1/0,bounds._southWest.lng=1/0),bounds._northEast&&(bounds._northEast.lat=-1/0,bounds._northEast.lng=-1/0)},_recalculateBounds:function(){var i,child,childLatLng,childCount,markers=this._markers,childClusters=this._childClusters,latSum=0,lngSum=0,totalCount=this._childCount;if(0!==totalCount){for(this._resetBounds(),i=0;i<markers.length;i++)childLatLng=markers[i]._latlng,this._bounds.extend(childLatLng),latSum+=childLatLng.lat,lngSum+=childLatLng.lng;for(i=0;i<childClusters.length;i++)child=childClusters[i],child._boundsNeedUpdate&&child._recalculateBounds(),this._bounds.extend(child._bounds),childLatLng=child._wLatLng,childCount=child._childCount,latSum+=childLatLng.lat*childCount,lngSum+=childLatLng.lng*childCount;this._latlng=this._wLatLng=new L.LatLng(latSum/totalCount,lngSum/totalCount),this._boundsNeedUpdate=!1}},_addToMap:function(startPos){startPos&&(this._backupLatlng=this._latlng,this.setLatLng(startPos)),this._group._featureGroup.addLayer(this)},_recursivelyAnimateChildrenIn:function(bounds,center,maxZoom){this._recursively(bounds,this._group._map.getMinZoom(),maxZoom-1,function(c){var i,m,markers=c._markers;for(i=markers.length-1;i>=0;i--)m=markers[i],m._icon&&(m._setPos(center),m.clusterHide())},function(c){var j,cm,childClusters=c._childClusters;for(j=childClusters.length-1;j>=0;j--)cm=childClusters[j],cm._icon&&(cm._setPos(center),cm.clusterHide())})},_recursivelyAnimateChildrenInAndAddSelfToMap:function(bounds,mapMinZoom,previousZoomLevel,newZoomLevel){this._recursively(bounds,newZoomLevel,mapMinZoom,function(c){c._recursivelyAnimateChildrenIn(bounds,c._group._map.latLngToLayerPoint(c.getLatLng()).round(),previousZoomLevel),c._isSingleParent()&&previousZoomLevel-1===newZoomLevel?(c.clusterShow(),c._recursivelyRemoveChildrenFromMap(bounds,mapMinZoom,previousZoomLevel)):c.clusterHide(),c._addToMap()})},_recursivelyBecomeVisible:function(bounds,zoomLevel){this._recursively(bounds,this._group._map.getMinZoom(),zoomLevel,null,function(c){c.clusterShow()})},_recursivelyAddChildrenToMap:function(startPos,zoomLevel,bounds){this._recursively(bounds,this._group._map.getMinZoom()-1,zoomLevel,function(c){if(zoomLevel!==c._zoom)for(var i=c._markers.length-1;i>=0;i--){var nm=c._markers[i];bounds.contains(nm._latlng)&&(startPos&&(nm._backupLatlng=nm.getLatLng(),nm.setLatLng(startPos),nm.clusterHide&&nm.clusterHide()),c._group._featureGroup.addLayer(nm))}},function(c){c._addToMap(startPos)})},_recursivelyRestoreChildPositions:function(zoomLevel){for(var i=this._markers.length-1;i>=0;i--){var nm=this._markers[i];nm._backupLatlng&&(nm.setLatLng(nm._backupLatlng),delete nm._backupLatlng)}if(zoomLevel-1===this._zoom)for(var j=this._childClusters.length-1;j>=0;j--)this._childClusters[j]._restorePosition();else for(var k=this._childClusters.length-1;k>=0;k--)this._childClusters[k]._recursivelyRestoreChildPositions(zoomLevel)},_restorePosition:function(){this._backupLatlng&&(this.setLatLng(this._backupLatlng),delete this._backupLatlng)},_recursivelyRemoveChildrenFromMap:function(previousBounds,mapMinZoom,zoomLevel,exceptBounds){var m,i;this._recursively(previousBounds,mapMinZoom-1,zoomLevel-1,function(c){for(i=c._markers.length-1;i>=0;i--)m=c._markers[i],exceptBounds&&exceptBounds.contains(m._latlng)||(c._group._featureGroup.removeLayer(m),m.clusterShow&&m.clusterShow())},function(c){for(i=c._childClusters.length-1;i>=0;i--)m=c._childClusters[i],exceptBounds&&exceptBounds.contains(m._latlng)||(c._group._featureGroup.removeLayer(m),m.clusterShow&&m.clusterShow())})},_recursively:function(boundsToApplyTo,zoomLevelToStart,zoomLevelToStop,runAtEveryLevel,runAtBottomLevel){var i,c,childClusters=this._childClusters,zoom=this._zoom;if(zoomLevelToStart<=zoom&&(runAtEveryLevel&&runAtEveryLevel(this),runAtBottomLevel&&zoom===zoomLevelToStop&&runAtBottomLevel(this)),zoom<zoomLevelToStart||zoom<zoomLevelToStop)for(i=childClusters.length-1;i>=0;i--)c=childClusters[i],boundsToApplyTo.intersects(c._bounds)&&c._recursively(boundsToApplyTo,zoomLevelToStart,zoomLevelToStop,runAtEveryLevel,runAtBottomLevel)},_isSingleParent:function(){return this._childClusters.length>0&&this._childClusters[0]._childCount===this._childCount}});L.Marker.include({clusterHide:function(){return this.options.opacityWhenUnclustered=this.options.opacity||1,this.setOpacity(0)},clusterShow:function(){var ret=this.setOpacity(this.options.opacity||this.options.opacityWhenUnclustered);return delete this.options.opacityWhenUnclustered,ret}}),L.DistanceGrid=function(cellSize){this._cellSize=cellSize,this._sqCellSize=cellSize*cellSize,this._grid={},this._objectPoint={}},L.DistanceGrid.prototype={addObject:function(obj,point){var x=this._getCoord(point.x),y=this._getCoord(point.y),grid=this._grid,row=grid[y]=grid[y]||{},cell=row[x]=row[x]||[],stamp=L.Util.stamp(obj);this._objectPoint[stamp]=point,cell.push(obj)},updateObject:function(obj,point){this.removeObject(obj),this.addObject(obj,point)},removeObject:function(obj,point){var i,len,x=this._getCoord(point.x),y=this._getCoord(point.y),grid=this._grid,row=grid[y]=grid[y]||{},cell=row[x]=row[x]||[];for(delete this._objectPoint[L.Util.stamp(obj)],i=0,len=cell.length;i<len;i++)if(cell[i]===obj)return cell.splice(i,1),1===len&&delete row[x],!0},eachObject:function(fn,context){var i,j,k,len,row,cell,grid=this._grid;for(i in grid){row=grid[i];for(j in row)for(cell=row[j],k=0,len=cell.length;k<len;k++)fn.call(context,cell[k])&&(k--,len--)}},getNearObject:function(point){var i,j,k,row,cell,len,obj,dist,x=this._getCoord(point.x),y=this._getCoord(point.y),objectPoint=this._objectPoint,closestDistSq=this._sqCellSize,closest=null;for(i=y-1;i<=y+1;i++)if(row=this._grid[i])for(j=x-1;j<=x+1;j++)if(cell=row[j])for(k=0,len=cell.length;k<len;k++)obj=cell[k],((dist=this._sqDist(objectPoint[L.Util.stamp(obj)],point))<closestDistSq||dist<=closestDistSq&&null===closest)&&(closestDistSq=dist,closest=obj);return closest},_getCoord:function(x){var coord=Math.floor(x/this._cellSize);return isFinite(coord)?coord:x},_sqDist:function(p,p2){var dx=p2.x-p.x,dy=p2.y-p.y;return dx*dx+dy*dy}},function(){L.QuickHull={getDistant:function(cpt,bl){var vY=bl[1].lat-bl[0].lat;return(bl[0].lng-bl[1].lng)*(cpt.lat-bl[0].lat)+vY*(cpt.lng-bl[0].lng)},findMostDistantPointFromBaseLine:function(baseLine,latLngs){var i,pt,d,maxD=0,maxPt=null,newPoints=[];for(i=latLngs.length-1;i>=0;i--)pt=latLngs[i],(d=this.getDistant(pt,baseLine))>0&&(newPoints.push(pt),d>maxD&&(maxD=d,maxPt=pt));return{maxPoint:maxPt,newPoints:newPoints}},buildConvexHull:function(baseLine,latLngs){var convexHullBaseLines=[],t=this.findMostDistantPointFromBaseLine(baseLine,latLngs);return t.maxPoint?(convexHullBaseLines=convexHullBaseLines.concat(this.buildConvexHull([baseLine[0],t.maxPoint],t.newPoints)),convexHullBaseLines=convexHullBaseLines.concat(this.buildConvexHull([t.maxPoint,baseLine[1]],t.newPoints))):[baseLine[0]]},getConvexHull:function(latLngs){var i,maxLat=!1,minLat=!1,maxLng=!1,minLng=!1,maxLatPt=null,minLatPt=null,maxLngPt=null,minLngPt=null,maxPt=null,minPt=null;for(i=latLngs.length-1;i>=0;i--){var pt=latLngs[i];(!1===maxLat||pt.lat>maxLat)&&(maxLatPt=pt,maxLat=pt.lat),(!1===minLat||pt.lat<minLat)&&(minLatPt=pt,minLat=pt.lat),(!1===maxLng||pt.lng>maxLng)&&(maxLngPt=pt,maxLng=pt.lng),(!1===minLng||pt.lng<minLng)&&(minLngPt=pt,minLng=pt.lng)}return minLat!==maxLat?(minPt=minLatPt,maxPt=maxLatPt):(minPt=minLngPt,maxPt=maxLngPt),[].concat(this.buildConvexHull([minPt,maxPt],latLngs),this.buildConvexHull([maxPt,minPt],latLngs))}}}(),L.MarkerCluster.include({getConvexHull:function(){var p,i,childMarkers=this.getAllChildMarkers(),points=[];for(i=childMarkers.length-1;i>=0;i--)p=childMarkers[i].getLatLng(),points.push(p);return L.QuickHull.getConvexHull(points)}}),L.MarkerCluster.include({_2PI:2*Math.PI,_circleFootSeparation:25,_circleStartAngle:0,_spiralFootSeparation:28,_spiralLengthStart:11,_spiralLengthFactor:5,_circleSpiralSwitchover:9,spiderfy:function(){if(this._group._spiderfied!==this&&!this._group._inZoomAnimation){var positions,childMarkers=this.getAllChildMarkers(),group=this._group,map=group._map,center=map.latLngToLayerPoint(this._latlng);this._group._unspiderfy(),this._group._spiderfied=this,childMarkers.length>=this._circleSpiralSwitchover?positions=this._generatePointsSpiral(childMarkers.length,center):(center.y+=10,positions=this._generatePointsCircle(childMarkers.length,center)),this._animationSpiderfy(childMarkers,positions)}},unspiderfy:function(zoomDetails){this._group._inZoomAnimation||(this._animationUnspiderfy(zoomDetails),this._group._spiderfied=null)},_generatePointsCircle:function(count,centerPt){var i,angle,circumference=this._group.options.spiderfyDistanceMultiplier*this._circleFootSeparation*(2+count),legLength=circumference/this._2PI,angleStep=this._2PI/count,res=[];for(legLength=Math.max(legLength,35),res.length=count,i=0;i<count;i++)angle=this._circleStartAngle+i*angleStep,res[i]=new L.Point(centerPt.x+legLength*Math.cos(angle),centerPt.y+legLength*Math.sin(angle))._round();return res},_generatePointsSpiral:function(count,centerPt){var i,spiderfyDistanceMultiplier=this._group.options.spiderfyDistanceMultiplier,legLength=spiderfyDistanceMultiplier*this._spiralLengthStart,separation=spiderfyDistanceMultiplier*this._spiralFootSeparation,lengthFactor=spiderfyDistanceMultiplier*this._spiralLengthFactor*this._2PI,angle=0,res=[];for(res.length=count,i=count;i>=0;i--)i<count&&(res[i]=new L.Point(centerPt.x+legLength*Math.cos(angle),centerPt.y+legLength*Math.sin(angle))._round()),angle+=separation/legLength+5e-4*i,legLength+=lengthFactor/angle;return res},_noanimationUnspiderfy:function(){var m,i,group=this._group,map=group._map,fg=group._featureGroup,childMarkers=this.getAllChildMarkers();for(group._ignoreMove=!0,this.setOpacity(1),i=childMarkers.length-1;i>=0;i--)m=childMarkers[i],fg.removeLayer(m),m._preSpiderfyLatlng&&(m.setLatLng(m._preSpiderfyLatlng),delete m._preSpiderfyLatlng),m.setZIndexOffset&&m.setZIndexOffset(0),m._spiderLeg&&(map.removeLayer(m._spiderLeg),delete m._spiderLeg);group.fire("unspiderfied",{cluster:this,markers:childMarkers}),group._ignoreMove=!1,group._spiderfied=null}}),L.MarkerClusterNonAnimated=L.MarkerCluster.extend({_animationSpiderfy:function(childMarkers,positions){var i,m,leg,newPos,group=this._group,map=group._map,fg=group._featureGroup,legOptions=this._group.options.spiderLegPolylineOptions;for(group._ignoreMove=!0,i=0;i<childMarkers.length;i++)newPos=map.layerPointToLatLng(positions[i]),m=childMarkers[i],leg=new L.Polyline([this._latlng,newPos],legOptions),map.addLayer(leg),m._spiderLeg=leg,m._preSpiderfyLatlng=m._latlng,m.setLatLng(newPos),m.setZIndexOffset&&m.setZIndexOffset(1e6),fg.addLayer(m);this.setOpacity(.3),group._ignoreMove=!1,group.fire("spiderfied",{cluster:this,markers:childMarkers})},_animationUnspiderfy:function(){this._noanimationUnspiderfy()}}),L.MarkerCluster.include({_animationSpiderfy:function(childMarkers,positions){var i,m,leg,legPath,legLength,newPos,me=this,group=this._group,map=group._map,fg=group._featureGroup,thisLayerLatLng=this._latlng,thisLayerPos=map.latLngToLayerPoint(thisLayerLatLng),svg=L.Path.SVG,legOptions=L.extend({},this._group.options.spiderLegPolylineOptions),finalLegOpacity=legOptions.opacity;for(void 0===finalLegOpacity&&(finalLegOpacity=L.MarkerClusterGroup.prototype.options.spiderLegPolylineOptions.opacity),svg?(legOptions.opacity=0,legOptions.className=(legOptions.className||"")+" leaflet-cluster-spider-leg"):legOptions.opacity=finalLegOpacity,group._ignoreMove=!0,i=0;i<childMarkers.length;i++)m=childMarkers[i],newPos=map.layerPointToLatLng(positions[i]),leg=new L.Polyline([thisLayerLatLng,newPos],legOptions),map.addLayer(leg),m._spiderLeg=leg,svg&&(legPath=leg._path,legLength=legPath.getTotalLength()+.1,legPath.style.strokeDasharray=legLength,legPath.style.strokeDashoffset=legLength),m.setZIndexOffset&&m.setZIndexOffset(1e6),m.clusterHide&&m.clusterHide(),fg.addLayer(m),m._setPos&&m._setPos(thisLayerPos);for(group._forceLayout(),group._animationStart(),i=childMarkers.length-1;i>=0;i--)newPos=map.layerPointToLatLng(positions[i]),m=childMarkers[i],m._preSpiderfyLatlng=m._latlng,m.setLatLng(newPos),m.clusterShow&&m.clusterShow(),svg&&(leg=m._spiderLeg,legPath=leg._path,legPath.style.strokeDashoffset=0,leg.setStyle({opacity:finalLegOpacity}));this.setOpacity(.3),group._ignoreMove=!1,setTimeout(function(){group._animationEnd(),group.fire("spiderfied",{cluster:me,markers:childMarkers})},200)},_animationUnspiderfy:function(zoomDetails){var m,i,leg,legPath,legLength,nonAnimatable,me=this,group=this._group,map=group._map,fg=group._featureGroup,thisLayerPos=zoomDetails?map._latLngToNewLayerPoint(this._latlng,zoomDetails.zoom,zoomDetails.center):map.latLngToLayerPoint(this._latlng),childMarkers=this.getAllChildMarkers(),svg=L.Path.SVG;for(group._ignoreMove=!0,group._animationStart(),this.setOpacity(1),i=childMarkers.length-1;i>=0;i--)m=childMarkers[i],m._preSpiderfyLatlng&&(m.closePopup(),m.setLatLng(m._preSpiderfyLatlng),delete m._preSpiderfyLatlng,nonAnimatable=!0,m._setPos&&(m._setPos(thisLayerPos),nonAnimatable=!1),m.clusterHide&&(m.clusterHide(),nonAnimatable=!1),nonAnimatable&&fg.removeLayer(m),svg&&(leg=m._spiderLeg,legPath=leg._path,legLength=legPath.getTotalLength()+.1,legPath.style.strokeDashoffset=legLength,leg.setStyle({opacity:0})));group._ignoreMove=!1,setTimeout(function(){var stillThereChildCount=0;for(i=childMarkers.length-1;i>=0;i--)m=childMarkers[i],m._spiderLeg&&stillThereChildCount++;for(i=childMarkers.length-1;i>=0;i--)m=childMarkers[i],m._spiderLeg&&(m.clusterShow&&m.clusterShow(),m.setZIndexOffset&&m.setZIndexOffset(0),stillThereChildCount>1&&fg.removeLayer(m),map.removeLayer(m._spiderLeg),delete m._spiderLeg);group._animationEnd(),group.fire("unspiderfied",{cluster:me,markers:childMarkers})},200)}}),L.MarkerClusterGroup.include({_spiderfied:null,unspiderfy:function(){this._unspiderfy.apply(this,arguments)},_spiderfierOnAdd:function(){this._map.on("click",this._unspiderfyWrapper,this),this._map.options.zoomAnimation&&this._map.on("zoomstart",this._unspiderfyZoomStart,this),this._map.on("zoomend",this._noanimationUnspiderfy,this),L.Browser.touch||this._map.getRenderer(this)},_spiderfierOnRemove:function(){this._map.off("click",this._unspiderfyWrapper,this),this._map.off("zoomstart",this._unspiderfyZoomStart,this),this._map.off("zoomanim",this._unspiderfyZoomAnim,this),this._map.off("zoomend",this._noanimationUnspiderfy,this),this._noanimationUnspiderfy()},_unspiderfyZoomStart:function(){this._map&&this._map.on("zoomanim",this._unspiderfyZoomAnim,this)},_unspiderfyZoomAnim:function(zoomDetails){L.DomUtil.hasClass(this._map._mapPane,"leaflet-touching")||(this._map.off("zoomanim",this._unspiderfyZoomAnim,this),this._unspiderfy(zoomDetails))},_unspiderfyWrapper:function(){this._unspiderfy()},_unspiderfy:function(zoomDetails){this._spiderfied&&this._spiderfied.unspiderfy(zoomDetails)},_noanimationUnspiderfy:function(){this._spiderfied&&this._spiderfied._noanimationUnspiderfy()},_unspiderfyLayer:function(layer){layer._spiderLeg&&(this._featureGroup.removeLayer(layer),layer.clusterShow&&layer.clusterShow(),layer.setZIndexOffset&&layer.setZIndexOffset(0),this._map.removeLayer(layer._spiderLeg),delete layer._spiderLeg)}}),L.MarkerClusterGroup.include({refreshClusters:function(layers){return layers?layers instanceof L.MarkerClusterGroup?layers=layers._topClusterLevel.getAllChildMarkers():layers instanceof L.LayerGroup?layers=layers._layers:layers instanceof L.MarkerCluster?layers=layers.getAllChildMarkers():layers instanceof L.Marker&&(layers=[layers]):layers=this._topClusterLevel.getAllChildMarkers(),this._flagParentsIconsNeedUpdate(layers),this._refreshClustersIcons(),this.options.singleMarkerMode&&this._refreshSingleMarkerModeMarkers(layers),this},_flagParentsIconsNeedUpdate:function(layers){var id,parent;for(id in layers)for(parent=layers[id].__parent;parent;)parent._iconNeedsUpdate=!0,parent=parent.__parent},_refreshSingleMarkerModeMarkers:function(layers){var id,layer;for(id in layers)layer=layers[id],this.hasLayer(layer)&&layer.setIcon(this._overrideMarkerIcon(layer))}}),L.Marker.include({refreshIconOptions:function(options,directlyRefreshClusters){var icon=this.options.icon;return L.setOptions(icon,options),this.setIcon(icon),directlyRefreshClusters&&this.__parent&&this.__parent._group.refreshClusters(this),this}}),exports.MarkerClusterGroup=MarkerClusterGroup,exports.MarkerCluster=MarkerCluster})},function(module,exports,__webpack_require__){"use strict";function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function serverCluster(options){return new ServerCluster(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.ServerCluster=void 0,exports.default=serverCluster;var _d3Scale=__webpack_require__(30),_ClusterMarker=__webpack_require__(151),_ClusterMarker2=_interopRequireDefault(_ClusterMarker),_CircleMarker=__webpack_require__(11),_CircleMarker2=_interopRequireDefault(_CircleMarker),ServerCluster=exports.ServerCluster=L.GridLayer.extend({options:{pane:"markerPane",tileSize:512,clusterSize:110,color:"red",opacity:1,domain:[1,1e4],range:[16,40]},initialize:function(opts){var options=L.setOptions(this,opts);this._clusters=L.featureGroup(),this._tileClusters={},this._scale=(0,_d3Scale.scaleLog)().base(Math.E).domain(options.domain).range(options.range).clamp(!0),this._clusters.on("click",this.onClusterClick,this),this._bounds=options.bounds},onAdd:function(map){this._levels={},this._tiles={},this._resetView(),this._update(),map.addLayer(this._clusters),map.on("zoomstart",this._onZoomStart,this)},onRemove:function(map){this._clusters.clearLayers(),map.removeLayer(this._clusters),map.off("zoomstart",this._onZoomStart,this)},createTile:function(coords){var _this=this,tileId=this._tileCoordsToKey(coords),clusters=this._tileClusters[tileId];if(clusters)return void clusters.forEach(function(cluster){return _this._clusters.addLayer(cluster)});var options=this.options,map=this._map,bounds=this._tileCoordsToBounds(coords),params={tileId:tileId,bbox:bounds.toBBoxString(),clusterSize:Math.round(this.getResolution(coords.z)*options.clusterSize),includeClusterPoints:map.getZoom()===map.getMaxZoom()};options.load&&this._isWithinWorldBounds(bounds)&&options.load(params,L.bind(this.addClusters,this),this)},_addTile:function(coords){var key=this._tileCoordsToKey(coords);this._tiles[key]={coords:coords,current:!0},this.createTile(this._wrapCoords(coords)),this.fire("tileloadstart",{key:key,coords:coords})},onClusterClick:function(evt){var marker=evt.layer,map=this._map;marker.getBounds?map.getZoom()!==map.getMaxZoom()?map.fitBounds(marker.getBounds()):(this._spider&&this._spider.unspiderify(),this._spider=marker.spiderify()):this.options.popup&&marker.showPopup()},addClusters:function(tileId,clusters){var _this2=this,tileClusters=[];clusters.forEach(function(d){var cluster=_this2.createCluster(d);_this2._tiles[tileId]&&_this2._clusters.addLayer(cluster),tileClusters.push(cluster)}),this._tileClusters[tileId]=tileClusters},createCluster:function(feature){var marker=void 0;return 1===feature.properties.count?marker=(0,_CircleMarker2.default)(feature,this.options):(feature.properties.size=this._scale(feature.properties.count),marker=(0,_ClusterMarker2.default)(feature,this.options)),marker},getResolution:function(zoom){return Math.PI*L.Projection.SphericalMercator.R*2/256/Math.pow(2,zoom)},getBounds:function(){return this._bounds?L.latLngBounds(this._bounds):this._clusters.getBounds()},setOpacity:function(opacity){var tileClusters=this._tileClusters,tileId=void 0,layer=void 0;for(tileId in tileClusters)if(tileClusters.hasOwnProperty(tileId)){var _iteratorNormalCompletion=!0,_didIteratorError=!1,_iteratorError=void 0;try{for(var _step,_iterator=tileClusters[tileId][Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=!0)layer=_step.value,layer.setOpacity(opacity)}catch(err){_didIteratorError=!0,_iteratorError=err}finally{try{!_iteratorNormalCompletion&&_iterator.return&&_iterator.return()}finally{if(_didIteratorError)throw _iteratorError}}}this.options.opacity=opacity},_removeTile:function(key){var _this3=this;if(this._tiles[key]){var clusters=this._tileClusters[key];clusters&&clusters.forEach(function(layer){return _this3._clusters.removeLayer(layer)}),delete this._tiles[key],this.fire("tileunload",{tileId:key,coords:this._keyToTileCoords(key)})}},_onZoomStart:function(){this._clusters.clearLayers()},_animateZoom:function(){},_isWithinWorldBounds:function(bounds){return bounds.getWest()>=-180&&bounds.getEast()<=180&&bounds.getSouth()>=-90&&bounds.getNorth()<=90}})},function(module,exports,__webpack_require__){"use strict";function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function clusterMarker(feature,options){return new ClusterMarker(feature,options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.ClusterMarker=void 0,exports.default=clusterMarker;var _ClusterIcon=__webpack_require__(28),_ClusterIcon2=_interopRequireDefault(_ClusterIcon),_CircleMarker=__webpack_require__(11),_CircleMarker2=_interopRequireDefault(_CircleMarker),ClusterMarker=exports.ClusterMarker=L.Marker.extend({initialize:function(feature,options){this._feature=feature,this._latlng=L.GeoJSON.coordsToLatLng(feature.geometry.coordinates),options.icon=(0,_ClusterIcon2.default)({size:feature.properties.size,count:feature.properties.count,color:options.color}),L.setOptions(this,options)},getFeature:function(){return this._feature},getBounds:function(){return this._feature.properties.bounds},spiderify:function(){if(!this._spiderified){var feature=this._feature,options=this.options,map=this._map,latlng=this.getLatLng(),center=map.latLngToLayerPoint(latlng),ids=(this._feature.id||"").split(","),count=feature.properties.count,legOptions={weight:1.5,color:"#222",opacity:.5},_2PI=2*Math.PI,circumference=13*(2+count),startAngle=Math.PI/6,legLength=circumference/_2PI,angleStep=_2PI/count;this._spiderLegs=L.featureGroup(),this._spiderMarkers=L.featureGroup(),this._spiderMarkers.on("click",this.onSpiderMarkerClick,this);for(var angle,point,id,newPos,i=count-1;i>=0;i--)angle=startAngle+i*angleStep,point=L.point(center.x+legLength*Math.cos(angle),center.y+legLength*Math.sin(angle))._round(),id=ids[i],newPos=map.layerPointToLatLng(point),this._spiderLegs.addLayer(L.polyline([latlng,newPos],legOptions)),this._spiderMarkers.addLayer((0,_CircleMarker2.default)({id:id,type:"Feature",geometry:{type:"Point",coordinates:[newPos.lng,newPos.lat]}},this.options));this._spiderLegs.addTo(map),this._spiderMarkers.addTo(map),this._originalOpacity=options.opacity,this.setOpacity(.1),this._spiderified=!0}return this},unspiderify:function(){var map=this._map;return this.setOpacity(this._originalOpacity),this._spiderLegs&&map.hasLayer(this._spiderLegs)&&map.removeLayer(this._spiderLegs),this._spiderMarkers&&map.hasLayer(this._spiderMarkers)&&(map.removeLayer(this._spiderMarkers),this._spiderMarkers.off("click",this.onSpiderMarkerClick,this)),this._spiderified=!1,this},onSpiderMarkerClick:function(evt){evt.layer.showPopup()},onRemove:function(map){this._spiderified&&this.unspiderify(),L.Marker.prototype.onRemove.call(this,map)}})},function(module,exports,__webpack_require__){"use strict";function earthEngine(options){return new EarthEngine(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=earthEngine;var EarthEngine=exports.EarthEngine=L.LayerGroup.extend({options:{url:"https://earthengine.googleapis.com/map/{mapid}/{z}/{x}/{y}?token={token}",tokenType:"Bearer",aggregation:"none",popup:"{name}: {value} {unit}"},initialize:function(){var options=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};L.setOptions(this,options),this._layers={},this._legend=options.legend||this.createLegend()},onAdd:function(){this.getAuthToken(this.onValidAuthToken.bind(this))},onRemove:function(map){this._popup&&map.closePopup(this._popup),L.GeoJSON.prototype.onRemove.call(this,map)},getAuthToken:function(callback){var accessToken=this.options.accessToken;accessToken&&(accessToken instanceof Function?accessToken(callback):callback(accessToken))},onValidAuthToken:function(token){var _this=this;ee.data.setAuthToken(token.client_id,this.options.tokenType,token.access_token,token.expires_in,null,null,!1),ee.data.setAuthTokenRefresher(this.refreshAccessToken.bind(this)),ee.initialize(null,null,function(){_this.createImage(),_this.fire("initialized")})},refreshAccessToken:function(authArgs,callback){var self=this;this.getAuthToken(function(token){callback({token_type:self.options.tokenType,access_token:token.access_token,state:authArgs.scope,expires_in:token.expires_in})})},createImage:function(){var options=this.options,eeCollection=void 0,eeImage=void 0;options.filter?(eeCollection=ee.ImageCollection(options.id),eeCollection=this.applyFilter(eeCollection),"mosaic"===options.aggregation?(this.eeCollection=eeCollection,eeImage=eeCollection.mosaic()):eeImage=ee.Image(eeCollection.first())):eeImage=ee.Image(options.id),options.band&&(eeImage=eeImage.select(options.band)),options.mask&&(eeImage=eeImage.updateMask(eeImage.gt(0))),eeImage=this.runMethods(eeImage),this.eeImage=eeImage,options.legend||(eeImage=this.classifyImage(eeImage)),this.addLayer(this.visualize(eeImage))},addLayer:function(eeImage){var _this2=this;eeImage.getMap(null,function(eeMap){var layer=L.tileLayer(_this2.options.url,L.extend({token:eeMap.token,mapid:eeMap.mapid},_this2.options));L.LayerGroup.prototype.addLayer.call(_this2,layer)})},applyFilter:function(collection,filterOpt){var _this3=this,filter=filterOpt||this.options.filter;return filter&&filter.forEach(function(item){collection=collection.filter(ee.Filter[item.type].apply(_this3,item.arguments))}),collection},runMethods:function(image){var methods=this.options.methods,eeImage=image;return methods&&Object.keys(methods).forEach(function(method){eeImage[method]&&(eeImage=eeImage[method].apply(eeImage,methods[method]))}),eeImage},classifyImage:function(eeImage){for(var item,legend=this._legend,zones=void 0,i=0;i<legend.length-1;i++)item=legend[i],zones=zones?zones.add(eeImage.gt(item.to)):eeImage.gt(item.to);return zones},visualize:function(eeImage){var options=this.options;return eeImage.visualize(options.legend?options.params:{min:0,max:this._legend.length-1,palette:options.params.palette})},createLegend:function(){var params=this.options.params,min=params.min,max=params.max,palette=params.palette.split(","),step=(params.max-min)/(palette.length-(min>0?2:1)),from=min,to=Math.round(min+step);return palette.map(function(color,index){var item={color:color};return 0===index&&min>0?(item.from=0,item.to=min,item.name="< "+item.to,to=min):from<max?(item.from=from,item.to=to,item.name=item.from+" - "+item.to):(item.from=from,item.name="> "+item.from),from=to,to=Math.round(min+step*(index+(min>0?1:2))),item})},getLegend:function(){var options=this.options,legend='<div class="dhis2-legend">';legend+="<h2>"+options.name,options.image&&(legend+=" "+options.image),legend+="</h2>",options.description&&(legend+="<p>"+options.description+"</p>"),legend+="<dl>",options.unit&&(legend+="<dt></dt><dd><strong>"+options.unit+"</strong></dd>");for(var item,i=0;i<this._legend.length;i++)item=this._legend[i],legend+='<dt style="background-color:'+item.color+';box-shadow:1px 1px 2px #aaa;"></dt>',legend+="<dd>"+item.name;return legend+="</dl>",options.attribution&&(legend+="<p>Data: "+options.attribution+"</p>"),legend+="<div>"},setOpacity:function(opacity){this.options.opacity=opacity,this.eachLayer(function(layer){return layer.setOpacity(opacity)})},getValue:function(latlng,callback){var point=ee.Geometry.Point(latlng.lng,latlng.lat),options=this.options,dictionary=void 0;dictionary="mosaic"===options.aggregation?this.eeImage.reduceRegion(ee.Reducer.mean(),point,options.resolution,options.projection):this.eeImage.reduceRegion(ee.Reducer.mean(),point),dictionary.getInfo(function(valueObj){var band=options.band||Object.keys(valueObj)[0],value=valueObj[band];options.legend&&options.legend[value]?value=options.legend[value].name:options.value&&(value=options.value(value)),callback(value)})},showValue:function(latlng){var _this4=this,options=this.options;this.getValue(latlng,function(value){_this4._popup=L.popup().setLatLng(latlng).setContent(L.Util.template(options.popup,L.extend({},options,{value:value}))).openOn(_this4._map)})}})},function(module,exports,__webpack_require__){"use strict";function legend(options){return new Legend(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=legend;var Legend=exports.Legend=L.Control.extend({options:{position:"topright",collapsed:!0,offset:[0,0]},initialize:function(opts){var options=L.setOptions(this,opts);this._content=options.content||"",this._handlingClick=!1},onAdd:function(map){return this._initLayout(),this._map=map,this._container},setContent:function(content){this._legend.innerHTML=content,this._content=content},getContent:function(){return this._content},_initLayout:function(){var className="leaflet-control-legend",container=this._container=L.DomUtil.create("div",className);if(container.setAttribute("aria-haspopup",!0),L.DomEvent.disableClickPropagation(container),L.Browser.touch||L.DomEvent.disableScrollPropagation(container),this.options.collapsed){L.Browser.android||L.DomEvent.on(container,{mouseenter:this._expand,mouseleave:this._collapse},this);var link=this._legendLink=L.DomUtil.create("a",className+"-toggle",container);link.href="#",link.title="Legend",L.Browser.touch?L.DomEvent.on(link,"click",L.DomEvent.stop).on(link,"click",this._expand,this):L.DomEvent.on(link,"focus",this._expand,this),this._map.on("click",this._collapse,this)}else this._expand();this._legend=L.DomUtil.create("div",className+"-content",container),this.setContent(this._content)},_expand:function(){var offset=L.point(this.options.offset);L.DomUtil.addClass(this._container,"leaflet-control-legend-expanded"),this._container.style.left=offset.x+"px",this._container.style.top=offset.y+"px"},_collapse:function(){L.DomUtil.removeClass(this._container,"leaflet-control-legend-expanded"),this._container.style.left=0,this._container.style.top=0}})},function(module,exports,__webpack_require__){"use strict";function fitBounds(options){return new FitBounds(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=fitBounds;var FitBounds=exports.FitBounds=L.Control.extend({options:{position:"topleft"},onAdd:function(map){return this._map=map,this._initLayout(),this._toggleControl(map.getLayersBounds().isValid()),map.on("layeradd",this._onLayerChange,this),map.on("layerremove",this._onLayerChange,this),this._container},onRemove:function(map){map.off("layeradd",this._onLayerChange,this),map.off("layerremove",this._onLayerChange,this),L.Control.prototype.onRemove.call(this,map)},_initLayout:function(){var container=this._container=L.DomUtil.create("div","leaflet-control-fit-bounds");L.DomEvent.disableClickPropagation(container),L.Browser.touch||L.DomEvent.disableScrollPropagation(container),container.title="Zoom to content",L.DomEvent.on(container,"click",this._onClick,this)},_onClick:function(){var bounds=this._map.getLayersBounds();bounds.isValid()&&this._map.fitBounds(bounds)},_onLayerChange:function(evt){evt.layer instanceof L.FeatureGroup&&this._toggleControl(this._map.getLayersBounds().isValid())},_toggleControl:function(isValidBounds){this._container.style.display=isValidBounds?"block":"none"}})},function(module,exports,__webpack_require__){"use strict";function search(options){return new Search(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.Search=void 0,exports.default=search,__webpack_require__(156);var Search=exports.Search=L.Control.Geocoder.extend({})},function(module,exports,__webpack_require__){(function(global){var require,require;!function(f){module.exports=f()}(function(){return function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a="function"==typeof require&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n||e)},l,l.exports,e,t,n,r)}return n[o].exports}for(var i="function"==typeof require&&require,o=0;o<r.length;o++)s(r[o]);return s}({1:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Nominatim=_dereq_("./geocoders/nominatim").class;module.exports={class:L.Control.extend({options:{showResultIcons:!1,collapsed:!0,expand:"touch",position:"topright",placeholder:"Search...",errorMessage:"Nothing found.",suggestMinLength:3,suggestTimeout:250,defaultMarkGeocode:!0},includes:L.Evented.prototype||L.Mixin.Events,initialize:function(options){L.Util.setOptions(this,options),this.options.geocoder||(this.options.geocoder=new Nominatim),this._requestCount=0},onAdd:function(map){var input,className="leaflet-control-geocoder",container=L.DomUtil.create("div",className+" leaflet-bar"),icon=L.DomUtil.create("button",className+"-icon",container),form=this._form=L.DomUtil.create("div",className+"-form",container);return this._map=map,this._container=container,icon.innerHTML="&nbsp;",icon.type="button",input=this._input=L.DomUtil.create("input","",form),input.type="text",input.placeholder=this.options.placeholder,this._errorElement=L.DomUtil.create("div",className+"-form-no-error",container),this._errorElement.innerHTML=this.options.errorMessage,this._alts=L.DomUtil.create("ul",className+"-alternatives leaflet-control-geocoder-alternatives-minimized",container),L.DomEvent.disableClickPropagation(this._alts),L.DomEvent.addListener(input,"keydown",this._keydown,this),this.options.geocoder.suggest&&L.DomEvent.addListener(input,"input",this._change,this),L.DomEvent.addListener(input,"blur",function(){this.options.collapsed&&!this._preventBlurCollapse&&this._collapse(),this._preventBlurCollapse=!1},this),this.options.collapsed?"click"===this.options.expand?L.DomEvent.addListener(container,"click",function(e){0===e.button&&2!==e.detail&&this._toggle()},this):L.Browser.touch&&"touch"===this.options.expand?L.DomEvent.addListener(container,"touchstart mousedown",function(e){this._toggle(),e.preventDefault(),e.stopPropagation()},this):(L.DomEvent.addListener(container,"mouseover",this._expand,this),L.DomEvent.addListener(container,"mouseout",this._collapse,this),this._map.on("movestart",this._collapse,this)):(this._expand(),L.Browser.touch?L.DomEvent.addListener(container,"touchstart",function(e){this._geocode(e)},this):L.DomEvent.addListener(container,"click",function(e){this._geocode(e)},this)),this.options.defaultMarkGeocode&&this.on("markgeocode",this.markGeocode,this),this.on("startgeocode",function(){L.DomUtil.addClass(this._container,"leaflet-control-geocoder-throbber")},this),this.on("finishgeocode",function(){L.DomUtil.removeClass(this._container,"leaflet-control-geocoder-throbber")},this),L.DomEvent.disableClickPropagation(container),container},_geocodeResult:function(results,suggest){if(suggest||1!==results.length)if(results.length>0){this._alts.innerHTML="",this._results=results,L.DomUtil.removeClass(this._alts,"leaflet-control-geocoder-alternatives-minimized");for(var i=0;i<results.length;i++)this._alts.appendChild(this._createAlt(results[i],i))}else L.DomUtil.addClass(this._errorElement,"leaflet-control-geocoder-error");else this._geocodeResultSelected(results[0])},markGeocode:function(result){return result=result.geocode||result,this._map.fitBounds(result.bbox),this._geocodeMarker&&this._map.removeLayer(this._geocodeMarker),this._geocodeMarker=new L.Marker(result.center).bindPopup(result.html||result.name).addTo(this._map).openPopup(),this},_geocode:function(suggest){var requestCount=++this._requestCount,mode=suggest?"suggest":"geocode",eventData={input:this._input.value};this._lastGeocode=this._input.value,suggest||this._clearResults(),this.fire("start"+mode,eventData),this.options.geocoder[mode](this._input.value,function(results){requestCount===this._requestCount&&(eventData.results=results,this.fire("finish"+mode,eventData),this._geocodeResult(results,suggest))},this)},_geocodeResultSelected:function(result){this.fire("markgeocode",{geocode:result})},_toggle:function(){L.DomUtil.hasClass(this._container,"leaflet-control-geocoder-expanded")?this._collapse():this._expand()},_expand:function(){L.DomUtil.addClass(this._container,"leaflet-control-geocoder-expanded"),this._input.select(),this.fire("expand")},_collapse:function(){L.DomUtil.removeClass(this._container,"leaflet-control-geocoder-expanded"),L.DomUtil.addClass(this._alts,"leaflet-control-geocoder-alternatives-minimized"),L.DomUtil.removeClass(this._errorElement,"leaflet-control-geocoder-error"),this._input.blur(),this.fire("collapse")},_clearResults:function(){L.DomUtil.addClass(this._alts,"leaflet-control-geocoder-alternatives-minimized"),this._selection=null,L.DomUtil.removeClass(this._errorElement,"leaflet-control-geocoder-error")},_createAlt:function(result,index){var li=L.DomUtil.create("li",""),a=L.DomUtil.create("a","",li),icon=this.options.showResultIcons&&result.icon?L.DomUtil.create("img","",a):null,text=result.html?void 0:document.createTextNode(result.name),mouseDownHandler=function(e){this._preventBlurCollapse=!0,L.DomEvent.stop(e),this._geocodeResultSelected(result),L.DomEvent.on(li,"click",function(){this.options.collapsed?this._collapse():this._clearResults()},this)};return icon&&(icon.src=result.icon),li.setAttribute("data-result-index",index),result.html?a.innerHTML=a.innerHTML+result.html:a.appendChild(text),L.DomEvent.addListener(li,"mousedown touchstart",mouseDownHandler,this),li},_keydown:function(e){var _this=this,select=function(dir){_this._selection&&(L.DomUtil.removeClass(_this._selection,"leaflet-control-geocoder-selected"),_this._selection=_this._selection[dir>0?"nextSibling":"previousSibling"]),_this._selection||(_this._selection=_this._alts[dir>0?"firstChild":"lastChild"]),_this._selection&&L.DomUtil.addClass(_this._selection,"leaflet-control-geocoder-selected")};switch(e.keyCode){case 27:this.options.collapsed&&this._collapse();break;case 38:select(-1);break;case 40:select(1);break;case 13:if(this._selection){var index=parseInt(this._selection.getAttribute("data-result-index"),10);this._geocodeResultSelected(this._results[index]),this._clearResults()}else this._geocode()}},_change:function(e){var v=this._input.value;v!==this._lastGeocode&&(clearTimeout(this._suggestTimeout),v.length>=this.options.suggestMinLength?this._suggestTimeout=setTimeout(L.bind(function(){this._geocode(!0)},this),this.options.suggestTimeout):this._clearResults())}}),factory:function(options){return new L.Control.Geocoder(options)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./geocoders/nominatim":9}],2:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Util=_dereq_("../util");module.exports={class:L.Class.extend({options:{service_url:"http://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer"},initialize:function(accessToken,options){L.setOptions(this,options),this._accessToken=accessToken},geocode:function(query,cb,context){var params={SingleLine:query,outFields:"Addr_Type",forStorage:!1,maxLocations:10,f:"json"};this._key&&this._key.length&&(params.token=this._key),Util.getJSON(this.options.service_url+"/findAddressCandidates",params,function(data){var loc,latLng,latLngBounds,results=[];if(data.candidates&&data.candidates.length)for(var i=0;i<=data.candidates.length-1;i++)loc=data.candidates[i],latLng=L.latLng(loc.location.y,loc.location.x),latLngBounds=L.latLngBounds(L.latLng(loc.extent.ymax,loc.extent.xmax),L.latLng(loc.extent.ymin,loc.extent.xmin)),results[i]={name:loc.address,bbox:latLngBounds,center:latLng};cb.call(context,results)})},suggest:function(query,cb,context){return this.geocode(query,cb,context)},reverse:function(location,scale,cb,context){var params={location:encodeURIComponent(location.lng)+","+encodeURIComponent(location.lat),distance:100,f:"json"};Util.getJSON(this.options.service_url+"/reverseGeocode",params,function(data){var loc,result=[];data&&!data.error&&(loc=L.latLng(data.location.y,data.location.x),result.push({name:data.address.Match_addr,center:loc,bounds:L.latLngBounds(loc,loc)})),cb.call(context,result)})}}),factory:function(accessToken,options){return new L.Control.Geocoder.ArcGis(accessToken,options)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../util":13}],3:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Util=_dereq_("../util");module.exports={class:L.Class.extend({initialize:function(key){this.key=key},geocode:function(query,cb,context){Util.jsonp("https://dev.virtualearth.net/REST/v1/Locations",{query:query,key:this.key},function(data){var results=[];if(data.resourceSets.length>0)for(var i=data.resourceSets[0].resources.length-1;i>=0;i--){var resource=data.resourceSets[0].resources[i],bbox=resource.bbox;results[i]={name:resource.name,bbox:L.latLngBounds([bbox[0],bbox[1]],[bbox[2],bbox[3]]),center:L.latLng(resource.point.coordinates)}}cb.call(context,results)},this,"jsonp")},reverse:function(location,scale,cb,context){Util.jsonp("//dev.virtualearth.net/REST/v1/Locations/"+location.lat+","+location.lng,{key:this.key},function(data){for(var results=[],i=data.resourceSets[0].resources.length-1;i>=0;i--){var resource=data.resourceSets[0].resources[i],bbox=resource.bbox;results[i]={name:resource.name,bbox:L.latLngBounds([bbox[0],bbox[1]],[bbox[2],bbox[3]]),center:L.latLng(resource.point.coordinates)}}cb.call(context,results)},this,"jsonp")}}),factory:function(key){return new L.Control.Geocoder.Bing(key)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../util":13}],4:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Util=_dereq_("../util");module.exports={class:L.Class.extend({options:{serviceUrl:"https://maps.googleapis.com/maps/api/geocode/json",geocodingQueryParams:{},reverseQueryParams:{}},initialize:function(key,options){this._key=key,L.setOptions(this,options),this.options.serviceUrl=this.options.service_url||this.options.serviceUrl},geocode:function(query,cb,context){var params={address:query};this._key&&this._key.length&&(params.key=this._key),params=L.Util.extend(params,this.options.geocodingQueryParams),Util.getJSON(this.options.serviceUrl,params,function(data){var loc,latLng,latLngBounds,results=[];if(data.results&&data.results.length)for(var i=0;i<=data.results.length-1;i++)loc=data.results[i],latLng=L.latLng(loc.geometry.location),latLngBounds=L.latLngBounds(L.latLng(loc.geometry.viewport.northeast),L.latLng(loc.geometry.viewport.southwest)),results[i]={name:loc.formatted_address,bbox:latLngBounds,center:latLng,properties:loc.address_components};cb.call(context,results)})},reverse:function(location,scale,cb,context){var params={latlng:encodeURIComponent(location.lat)+","+encodeURIComponent(location.lng)};params=L.Util.extend(params,this.options.reverseQueryParams),this._key&&this._key.length&&(params.key=this._key),Util.getJSON(this.options.serviceUrl,params,function(data){var loc,latLng,latLngBounds,results=[];if(data.results&&data.results.length)for(var i=0;i<=data.results.length-1;i++)loc=data.results[i],latLng=L.latLng(loc.geometry.location),latLngBounds=L.latLngBounds(L.latLng(loc.geometry.viewport.northeast),L.latLng(loc.geometry.viewport.southwest)),results[i]={name:loc.formatted_address,bbox:latLngBounds,center:latLng,properties:loc.address_components};cb.call(context,results)})}}),factory:function(key,options){return new L.Control.Geocoder.Google(key,options)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../util":13}],5:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Util=_dereq_("../util");module.exports={class:L.Class.extend({options:{geocodeUrl:"http://geocoder.api.here.com/6.2/geocode.json",reverseGeocodeUrl:"http://reverse.geocoder.api.here.com/6.2/reversegeocode.json",app_id:"<insert your app_id here>",app_code:"<insert your app_code here>",geocodingQueryParams:{},reverseQueryParams:{}},initialize:function(options){L.setOptions(this,options)},geocode:function(query,cb,context){var params={searchtext:query,gen:9,app_id:this.options.app_id,app_code:this.options.app_code,jsonattributes:1};params=L.Util.extend(params,this.options.geocodingQueryParams),this.getJSON(this.options.geocodeUrl,params,cb,context)},reverse:function(location,scale,cb,context){var params={prox:encodeURIComponent(location.lat)+","+encodeURIComponent(location.lng),mode:"retrieveAddresses",app_id:this.options.app_id,app_code:this.options.app_code,gen:9,jsonattributes:1};params=L.Util.extend(params,this.options.reverseQueryParams),this.getJSON(this.options.reverseGeocodeUrl,params,cb,context)},getJSON:function(url,params,cb,context){Util.getJSON(url,params,function(data){var loc,latLng,latLngBounds,results=[];if(data.response.view&&data.response.view.length)for(var i=0;i<=data.response.view[0].result.length-1;i++)loc=data.response.view[0].result[i].location,latLng=L.latLng(loc.displayPosition.latitude,loc.displayPosition.longitude),latLngBounds=L.latLngBounds(L.latLng(loc.mapView.topLeft.latitude,loc.mapView.topLeft.longitude),L.latLng(loc.mapView.bottomRight.latitude,loc.mapView.bottomRight.longitude)),results[i]={name:loc.address.label,bbox:latLngBounds,center:latLng};cb.call(context,results)})}}),factory:function(options){return new L.Control.Geocoder.HERE(options)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../util":13}],6:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Util=_dereq_("../util");module.exports={class:L.Class.extend({options:{serviceUrl:"https://api.tiles.mapbox.com/v4/geocode/mapbox.places-v1/",geocodingQueryParams:{},reverseQueryParams:{}},initialize:function(accessToken,options){L.setOptions(this,options),this.options.geocodingQueryParams.access_token=accessToken,this.options.reverseQueryParams.access_token=accessToken},geocode:function(query,cb,context){var params=this.options.geocodingQueryParams;void 0!==params.proximity&&params.proximity.hasOwnProperty("lat")&&params.proximity.hasOwnProperty("lng")&&(params.proximity=params.proximity.lng+","+params.proximity.lat),Util.getJSON(this.options.serviceUrl+encodeURIComponent(query)+".json",params,function(data){var loc,latLng,latLngBounds,results=[];if(data.features&&data.features.length)for(var i=0;i<=data.features.length-1;i++)loc=data.features[i],latLng=L.latLng(loc.center.reverse()),latLngBounds=loc.hasOwnProperty("bbox")?L.latLngBounds(L.latLng(loc.bbox.slice(0,2).reverse()),L.latLng(loc.bbox.slice(2,4).reverse())):L.latLngBounds(latLng,latLng),results[i]={name:loc.place_name,bbox:latLngBounds,center:latLng};cb.call(context,results)})},suggest:function(query,cb,context){return this.geocode(query,cb,context)},reverse:function(location,scale,cb,context){Util.getJSON(this.options.serviceUrl+encodeURIComponent(location.lng)+","+encodeURIComponent(location.lat)+".json",this.options.reverseQueryParams,function(data){var loc,latLng,latLngBounds,results=[];if(data.features&&data.features.length)for(var i=0;i<=data.features.length-1;i++)loc=data.features[i],latLng=L.latLng(loc.center.reverse()),latLngBounds=loc.hasOwnProperty("bbox")?L.latLngBounds(L.latLng(loc.bbox.slice(0,2).reverse()),L.latLng(loc.bbox.slice(2,4).reverse())):L.latLngBounds(latLng,latLng),results[i]={name:loc.place_name,bbox:latLngBounds,center:latLng};cb.call(context,results)})}}),factory:function(accessToken,options){return new L.Control.Geocoder.Mapbox(accessToken,options)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../util":13}],7:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Util=_dereq_("../util");module.exports={class:L.Class.extend({options:{serviceUrl:"https://www.mapquestapi.com/geocoding/v1"},initialize:function(key,options){this._key=decodeURIComponent(key),L.Util.setOptions(this,options)},_formatName:function(){var i,r=[];for(i=0;i<arguments.length;i++)arguments[i]&&r.push(arguments[i]);return r.join(", ")},geocode:function(query,cb,context){Util.jsonp(this.options.serviceUrl+"/address",{key:this._key,location:query,limit:5,outFormat:"json"},function(data){var loc,latLng,results=[];if(data.results&&data.results[0].locations)for(var i=data.results[0].locations.length-1;i>=0;i--)loc=data.results[0].locations[i],latLng=L.latLng(loc.latLng),results[i]={name:this._formatName(loc.street,loc.adminArea4,loc.adminArea3,loc.adminArea1),bbox:L.latLngBounds(latLng,latLng),center:latLng};cb.call(context,results)},this)},reverse:function(location,scale,cb,context){Util.jsonp(this.options.serviceUrl+"/reverse",{key:this._key,location:location.lat+","+location.lng,outputFormat:"json"},function(data){var loc,latLng,results=[];if(data.results&&data.results[0].locations)for(var i=data.results[0].locations.length-1;i>=0;i--)loc=data.results[0].locations[i],latLng=L.latLng(loc.latLng),results[i]={name:this._formatName(loc.street,loc.adminArea4,loc.adminArea3,loc.adminArea1),bbox:L.latLngBounds(latLng,latLng),center:latLng};cb.call(context,results)},this)}}),factory:function(key,options){return new L.Control.Geocoder.MapQuest(key,options)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../util":13}],8:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Util=_dereq_("../util");module.exports={class:L.Class.extend({options:{serviceUrl:"https://search.mapzen.com/v1",geocodingQueryParams:{},reverseQueryParams:{}},initialize:function(apiKey,options){L.Util.setOptions(this,options),this._apiKey=apiKey,this._lastSuggest=0},geocode:function(query,cb,context){var _this=this;Util.getJSON(this.options.serviceUrl+"/search",L.extend({api_key:this._apiKey,text:query},this.options.geocodingQueryParams),function(data){cb.call(context,_this._parseResults(data,"bbox"))})},suggest:function(query,cb,context){var _this=this;Util.getJSON(this.options.serviceUrl+"/autocomplete",L.extend({api_key:this._apiKey,text:query},this.options.geocodingQueryParams),L.bind(function(data){data.geocoding.timestamp>this._lastSuggest&&(this._lastSuggest=data.geocoding.timestamp,cb.call(context,_this._parseResults(data,"bbox")))},this))},reverse:function(location,scale,cb,context){var _this=this;Util.getJSON(this.options.serviceUrl+"/reverse",L.extend({api_key:this._apiKey,"point.lat":location.lat,"point.lon":location.lng},this.options.reverseQueryParams),function(data){cb.call(context,_this._parseResults(data,"bounds"))})},_parseResults:function(data,bboxname){var results=[];return L.geoJson(data,{pointToLayer:function(feature,latlng){return L.circleMarker(latlng)},onEachFeature:function(feature,layer){var bbox,center,result={};layer.getBounds?(bbox=layer.getBounds(),center=bbox.getCenter()):(center=layer.getLatLng(),bbox=L.latLngBounds(center,center)),result.name=layer.feature.properties.label,result.center=center,result[bboxname]=bbox,result.properties=layer.feature.properties,results.push(result)}}),results}}),factory:function(apiKey,options){return new L.Control.Geocoder.Mapzen(apiKey,options)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../util":13}],9:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Util=_dereq_("../util");module.exports={class:L.Class.extend({options:{serviceUrl:"https://nominatim.openstreetmap.org/",geocodingQueryParams:{},reverseQueryParams:{},htmlTemplate:function(r){var a=r.address,parts=[];return(a.road||a.building)&&parts.push("{building} {road} {house_number}"),(a.city||a.town||a.village||a.hamlet)&&parts.push('<span class="'+(parts.length>0?"leaflet-control-geocoder-address-detail":"")+'">{postcode} {city} {town} {village} {hamlet}</span>'),(a.state||a.country)&&parts.push('<span class="'+(parts.length>0?"leaflet-control-geocoder-address-context":"")+'">{state} {country}</span>'),Util.template(parts.join("<br/>"),a,!0)}},initialize:function(options){L.Util.setOptions(this,options)},geocode:function(query,cb,context){Util.jsonp(this.options.serviceUrl+"search",L.extend({q:query,limit:5,format:"json",addressdetails:1},this.options.geocodingQueryParams),function(data){for(var results=[],i=data.length-1;i>=0;i--){for(var bbox=data[i].boundingbox,j=0;j<4;j++)bbox[j]=parseFloat(bbox[j]);results[i]={icon:data[i].icon,name:data[i].display_name,html:this.options.htmlTemplate?this.options.htmlTemplate(data[i]):void 0,bbox:L.latLngBounds([bbox[0],bbox[2]],[bbox[1],bbox[3]]),center:L.latLng(data[i].lat,data[i].lon),properties:data[i]}}cb.call(context,results)},this,"json_callback")},reverse:function(location,scale,cb,context){Util.jsonp(this.options.serviceUrl+"reverse",L.extend({lat:location.lat,lon:location.lng,zoom:Math.round(Math.log(scale/256)/Math.log(2)),addressdetails:1,format:"json"},this.options.reverseQueryParams),function(data){var loc,result=[];data&&data.lat&&data.lon&&(loc=L.latLng(data.lat,data.lon),result.push({name:data.display_name,html:this.options.htmlTemplate?this.options.htmlTemplate(data):void 0,center:loc,bounds:L.latLngBounds(loc,loc),properties:data})),cb.call(context,result)},this,"json_callback")}}),factory:function(options){return new L.Control.Geocoder.Nominatim(options)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../util":13}],10:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Util=_dereq_("../util");module.exports={class:L.Class.extend({options:{serviceUrl:"https://photon.komoot.de/api/",reverseUrl:"https://photon.komoot.de/reverse/",nameProperties:["name","street","suburb","hamlet","town","city","state","country"]},initialize:function(options){L.setOptions(this,options)},geocode:function(query,cb,context){var params=L.extend({q:query},this.options.geocodingQueryParams);Util.getJSON(this.options.serviceUrl,params,L.bind(function(data){cb.call(context,this._decodeFeatures(data))},this))},suggest:function(query,cb,context){return this.geocode(query,cb,context)},reverse:function(latLng,scale,cb,context){var params=L.extend({lat:latLng.lat,lon:latLng.lng},this.options.geocodingQueryParams);Util.getJSON(this.options.reverseUrl,params,L.bind(function(data){cb.call(context,this._decodeFeatures(data))},this))},_decodeFeatures:function(data){var i,f,c,latLng,extent,bbox,results=[];if(data&&data.features)for(i=0;i<data.features.length;i++)f=data.features[i],c=f.geometry.coordinates,latLng=L.latLng(c[1],c[0]),extent=f.properties.extent,bbox=extent?L.latLngBounds([extent[1],extent[0]],[extent[3],extent[2]]):L.latLngBounds(latLng,latLng),results.push({name:this._deocodeFeatureName(f),html:this.options.htmlTemplate?this.options.htmlTemplate(f):void 0,center:latLng,bbox:bbox,properties:f.properties});return results},_deocodeFeatureName:function(f){var j,name;for(j=0;!name&&j<this.options.nameProperties.length;j++)name=f.properties[this.options.nameProperties[j]];return name}}),factory:function(options){return new L.Control.Geocoder.Photon(options)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../util":13}],11:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Util=_dereq_("../util");module.exports={class:L.Class.extend({options:{serviceUrl:"https://api.what3words.com/v2/"},initialize:function(accessToken){this._accessToken=accessToken},geocode:function(query,cb,context){Util.getJSON(this.options.serviceUrl+"forward",{key:this._accessToken,addr:query.split(/\s+/).join(".")},function(data){var latLng,latLngBounds,results=[];data.hasOwnProperty("geometry")&&(latLng=L.latLng(data.geometry.lat,data.geometry.lng),latLngBounds=L.latLngBounds(latLng,latLng),results[0]={name:data.words,bbox:latLngBounds,center:latLng}),cb.call(context,results)})},suggest:function(query,cb,context){return this.geocode(query,cb,context)},reverse:function(location,scale,cb,context){Util.getJSON(this.options.serviceUrl+"reverse",{key:this._accessToken,coords:[location.lat,location.lng].join(",")},function(data){var latLng,latLngBounds,results=[];200==data.status.status&&(latLng=L.latLng(data.geometry.lat,data.geometry.lng),latLngBounds=L.latLngBounds(latLng,latLng),results[0]={name:data.words,bbox:latLngBounds,center:latLng}),cb.call(context,results)})}}),factory:function(accessToken){return new L.Control.Geocoder.What3Words(accessToken)}}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../util":13}],12:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,Control=_dereq_("./control"),Nominatim=_dereq_("./geocoders/nominatim"),Bing=_dereq_("./geocoders/bing"),MapQuest=_dereq_("./geocoders/mapquest"),Mapbox=_dereq_("./geocoders/mapbox"),What3Words=_dereq_("./geocoders/what3words"),Google=_dereq_("./geocoders/google"),Photon=_dereq_("./geocoders/photon"),Mapzen=_dereq_("./geocoders/mapzen"),ArcGis=_dereq_("./geocoders/arcgis"),HERE=_dereq_("./geocoders/here");module.exports=L.Util.extend(Control.class,{Nominatim:Nominatim.class,nominatim:Nominatim.factory,Bing:Bing.class,bing:Bing.factory,MapQuest:MapQuest.class,mapQuest:MapQuest.factory,Mapbox:Mapbox.class,mapbox:Mapbox.factory,What3Words:What3Words.class,what3words:What3Words.factory,Google:Google.class,google:Google.factory,Photon:Photon.class,photon:Photon.factory,Mapzen:Mapzen.class,mapzen:Mapzen.factory,ArcGis:ArcGis.class,arcgis:ArcGis.factory,HERE:HERE.class,here:HERE.factory}),L.Util.extend(L.Control,{Geocoder:module.exports,geocoder:Control.factory})}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./control":1,"./geocoders/arcgis":2,"./geocoders/bing":3,"./geocoders/google":4,"./geocoders/here":5,"./geocoders/mapbox":6,"./geocoders/mapquest":7,"./geocoders/mapzen":8,"./geocoders/nominatim":9,"./geocoders/photon":10,"./geocoders/what3words":11}],13:[function(_dereq_,module,exports){(function(global){var L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,lastCallbackId=0,htmlEscape=function(){function escapeChar(chr){return escape[chr]}var badChars=/[&<>"'`]/g,possible=/[&<>"'`]/,escape={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"};return function(string){return null==string?"":string?(string=""+string,possible.test(string)?string.replace(badChars,escapeChar):string):string+""}}();module.exports={jsonp:function(url,params,callback,context,jsonpParam){var callbackId="_l_geocoder_"+lastCallbackId++;params[jsonpParam||"callback"]=callbackId,window[callbackId]=L.Util.bind(callback,context);var script=document.createElement("script");script.type="text/javascript",script.src=url+L.Util.getParamString(params),script.id=callbackId,document.getElementsByTagName("head")[0].appendChild(script)},getJSON:function(url,params,callback){var xmlHttp=new XMLHttpRequest;xmlHttp.onreadystatechange=function(){if(4===xmlHttp.readyState)return 200!==xmlHttp.status&&304!==xmlHttp.status?void callback(""):void callback(JSON.parse(xmlHttp.response))},xmlHttp.open("GET",url+L.Util.getParamString(params),!0),xmlHttp.setRequestHeader("Accept","application/json"),xmlHttp.send(null)},template:function(str,data){return str.replace(/\{ *([\w_]+) *\}/g,function(str,key){var value=data[key];return void 0===value?value="":"function"==typeof value&&(value=value(data)),htmlEscape(value)})},htmlEscape:htmlEscape}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[12])(12)})}).call(exports,__webpack_require__(15))},function(module,exports,__webpack_require__){"use strict";function measure(options){return new Measure(options)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.Measure=void 0,exports.default=measure,__webpack_require__(158);var Measure=exports.Measure=L.Control.Measure.extend({options:{position:"topright",primaryLengthUnit:"kilometers",secondaryLengthUnit:"miles",primaryAreaUnit:"hectares",secondaryAreaUnit:"acres",activeColor:"#ffa500",completedColor:"#ffa500"}})},function(module,exports,__webpack_require__){(function(global){var require,require,__WEBPACK_AMD_DEFINE_RESULT__,__WEBPACK_AMD_DEFINE_ARRAY__,__WEBPACK_AMD_DEFINE_RESULT__;!function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a="function"==typeof require&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n||e)},l,l.exports,e,t,n,r)}return n[o].exports}for(var i="function"==typeof require&&require,o=0;o<r.length;o++)s(r[o]);return s}({1:[function(require,module,exports){},{}],2:[function(require,module,exports){function rgb2hsl(rgb){var h,s,l,r=rgb[0]/255,g=rgb[1]/255,b=rgb[2]/255,min=Math.min(r,g,b),max=Math.max(r,g,b),delta=max-min;return max==min?h=0:r==max?h=(g-b)/delta:g==max?h=2+(b-r)/delta:b==max&&(h=4+(r-g)/delta),h=Math.min(60*h,360),h<0&&(h+=360),l=(min+max)/2,s=max==min?0:l<=.5?delta/(max+min):delta/(2-max-min),[h,100*s,100*l]}function rgb2hsv(rgb){var h,s,v,r=rgb[0],g=rgb[1],b=rgb[2],min=Math.min(r,g,b),max=Math.max(r,g,b),delta=max-min;return s=0==max?0:delta/max*1e3/10,max==min?h=0:r==max?h=(g-b)/delta:g==max?h=2+(b-r)/delta:b==max&&(h=4+(r-g)/delta),h=Math.min(60*h,360),h<0&&(h+=360),v=max/255*1e3/10,[h,s,v]}function rgb2hwb(rgb){var r=rgb[0],g=rgb[1],b=rgb[2],h=rgb2hsl(rgb)[0],w=1/255*Math.min(r,Math.min(g,b)),b=1-1/255*Math.max(r,Math.max(g,b));return[h,100*w,100*b]}function rgb2cmyk(rgb){var c,m,y,k,r=rgb[0]/255,g=rgb[1]/255,b=rgb[2]/255;return k=Math.min(1-r,1-g,1-b),c=(1-r-k)/(1-k)||0,m=(1-g-k)/(1-k)||0,y=(1-b-k)/(1-k)||0,[100*c,100*m,100*y,100*k]}function rgb2keyword(rgb){return reverseKeywords[JSON.stringify(rgb)]}function rgb2xyz(rgb){var r=rgb[0]/255,g=rgb[1]/255,b=rgb[2]/255;return r=r>.04045?Math.pow((r+.055)/1.055,2.4):r/12.92,g=g>.04045?Math.pow((g+.055)/1.055,2.4):g/12.92,b=b>.04045?Math.pow((b+.055)/1.055,2.4):b/12.92,[100*(.4124*r+.3576*g+.1805*b),100*(.2126*r+.7152*g+.0722*b),100*(.0193*r+.1192*g+.9505*b)]}function rgb2lab(rgb){var l,a,b,xyz=rgb2xyz(rgb),x=xyz[0],y=xyz[1],z=xyz[2];return x/=95.047,y/=100,z/=108.883,x=x>.008856?Math.pow(x,1/3):7.787*x+16/116,y=y>.008856?Math.pow(y,1/3):7.787*y+16/116,z=z>.008856?Math.pow(z,1/3):7.787*z+16/116,l=116*y-16,a=500*(x-y),b=200*(y-z),[l,a,b]}function rgb2lch(args){return lab2lch(rgb2lab(args))}function hsl2rgb(hsl){var t1,t2,t3,rgb,val,h=hsl[0]/360,s=hsl[1]/100,l=hsl[2]/100;if(0==s)return val=255*l,[val,val,val];t2=l<.5?l*(1+s):l+s-l*s,t1=2*l-t2,rgb=[0,0,0];for(var i=0;i<3;i++)t3=h+1/3*-(i-1),t3<0&&t3++,t3>1&&t3--,val=6*t3<1?t1+6*(t2-t1)*t3:2*t3<1?t2:3*t3<2?t1+(t2-t1)*(2/3-t3)*6:t1,rgb[i]=255*val;return rgb}function hsl2hsv(hsl){var sv,v,h=hsl[0],s=hsl[1]/100,l=hsl[2]/100;return 0===l?[0,0,0]:(l*=2,s*=l<=1?l:2-l,v=(l+s)/2,sv=2*s/(l+s),[h,100*sv,100*v])}function hsl2hwb(args){return rgb2hwb(hsl2rgb(args))}function hsl2cmyk(args){return rgb2cmyk(hsl2rgb(args))}function hsl2keyword(args){return rgb2keyword(hsl2rgb(args))}function hsv2rgb(hsv){var h=hsv[0]/60,s=hsv[1]/100,v=hsv[2]/100,hi=Math.floor(h)%6,f=h-Math.floor(h),p=255*v*(1-s),q=255*v*(1-s*f),t=255*v*(1-s*(1-f)),v=255*v;switch(hi){case 0:return[v,t,p];case 1:return[q,v,p];case 2:return[p,v,t];case 3:return[p,q,v];case 4:return[t,p,v];case 5:return[v,p,q]}}function hsv2hsl(hsv){var sl,l,h=hsv[0],s=hsv[1]/100,v=hsv[2]/100;return l=(2-s)*v,sl=s*v,sl/=l<=1?l:2-l,sl=sl||0,l/=2,[h,100*sl,100*l]}function hsv2hwb(args){return rgb2hwb(hsv2rgb(args))}function hsv2cmyk(args){return rgb2cmyk(hsv2rgb(args))}function hsv2keyword(args){return rgb2keyword(hsv2rgb(args))}function hwb2rgb(hwb){var i,v,f,n,h=hwb[0]/360,wh=hwb[1]/100,bl=hwb[2]/100,ratio=wh+bl;switch(ratio>1&&(wh/=ratio,bl/=ratio),i=Math.floor(6*h),v=1-bl,f=6*h-i,0!=(1&i)&&(f=1-f),n=wh+f*(v-wh),i){default:case 6:case 0:r=v,g=n,b=wh;break;case 1:r=n,g=v,b=wh;break;case 2:r=wh,g=v,b=n;break;case 3:r=wh,g=n,b=v;break;case 4:r=n,g=wh,b=v;break;case 5:r=v,g=wh,b=n}return[255*r,255*g,255*b]}function hwb2hsl(args){return rgb2hsl(hwb2rgb(args))}function hwb2hsv(args){return rgb2hsv(hwb2rgb(args))}function hwb2cmyk(args){return rgb2cmyk(hwb2rgb(args))}function hwb2keyword(args){return rgb2keyword(hwb2rgb(args))}function cmyk2rgb(cmyk){var r,g,b,c=cmyk[0]/100,m=cmyk[1]/100,y=cmyk[2]/100,k=cmyk[3]/100;return r=1-Math.min(1,c*(1-k)+k),g=1-Math.min(1,m*(1-k)+k),b=1-Math.min(1,y*(1-k)+k),[255*r,255*g,255*b]}function cmyk2hsl(args){return rgb2hsl(cmyk2rgb(args))}function cmyk2hsv(args){return rgb2hsv(cmyk2rgb(args))}function cmyk2hwb(args){return rgb2hwb(cmyk2rgb(args))}function cmyk2keyword(args){return rgb2keyword(cmyk2rgb(args))}function xyz2rgb(xyz){var r,g,b,x=xyz[0]/100,y=xyz[1]/100,z=xyz[2]/100;return r=3.2406*x+-1.5372*y+-.4986*z,g=-.9689*x+1.8758*y+.0415*z,b=.0557*x+-.204*y+1.057*z,r=r>.0031308?1.055*Math.pow(r,1/2.4)-.055:r*=12.92,g=g>.0031308?1.055*Math.pow(g,1/2.4)-.055:g*=12.92,b=b>.0031308?1.055*Math.pow(b,1/2.4)-.055:b*=12.92,r=Math.min(Math.max(0,r),1),g=Math.min(Math.max(0,g),1),b=Math.min(Math.max(0,b),1),[255*r,255*g,255*b]}function xyz2lab(xyz){var l,a,b,x=xyz[0],y=xyz[1],z=xyz[2];return x/=95.047,y/=100,z/=108.883,x=x>.008856?Math.pow(x,1/3):7.787*x+16/116,y=y>.008856?Math.pow(y,1/3):7.787*y+16/116,z=z>.008856?Math.pow(z,1/3):7.787*z+16/116,l=116*y-16,a=500*(x-y),b=200*(y-z),[l,a,b]}function xyz2lch(args){return lab2lch(xyz2lab(args))}function lab2xyz(lab){var x,y,z,y2,l=lab[0],a=lab[1],b=lab[2];return l<=8?(y=100*l/903.3,y2=y/100*7.787+16/116):(y=100*Math.pow((l+16)/116,3),y2=Math.pow(y/100,1/3)),x=x/95.047<=.008856?x=95.047*(a/500+y2-16/116)/7.787:95.047*Math.pow(a/500+y2,3),z=z/108.883<=.008859?z=108.883*(y2-b/200-16/116)/7.787:108.883*Math.pow(y2-b/200,3),[x,y,z]}function lab2lch(lab){var hr,h,c,l=lab[0],a=lab[1],b=lab[2];return hr=Math.atan2(b,a),h=360*hr/2/Math.PI,h<0&&(h+=360),c=Math.sqrt(a*a+b*b),[l,c,h]}function lab2rgb(args){return xyz2rgb(lab2xyz(args))}function lch2lab(lch){var a,b,hr,l=lch[0],c=lch[1],h=lch[2];return hr=h/360*2*Math.PI,a=c*Math.cos(hr),b=c*Math.sin(hr),[l,a,b]}function lch2xyz(args){return lab2xyz(lch2lab(args))}function lch2rgb(args){return lab2rgb(lch2lab(args))}function keyword2rgb(keyword){return cssKeywords[keyword]}function keyword2hsl(args){return rgb2hsl(keyword2rgb(args))}function keyword2hsv(args){return rgb2hsv(keyword2rgb(args))}function keyword2hwb(args){return rgb2hwb(keyword2rgb(args))}function keyword2cmyk(args){return rgb2cmyk(keyword2rgb(args))}function keyword2lab(args){return rgb2lab(keyword2rgb(args))}function keyword2xyz(args){return rgb2xyz(keyword2rgb(args))}module.exports={rgb2hsl:rgb2hsl,rgb2hsv:rgb2hsv,rgb2hwb:rgb2hwb,rgb2cmyk:rgb2cmyk,rgb2keyword:rgb2keyword,rgb2xyz:rgb2xyz,rgb2lab:rgb2lab,rgb2lch:rgb2lch,hsl2rgb:hsl2rgb,hsl2hsv:hsl2hsv,hsl2hwb:hsl2hwb,hsl2cmyk:hsl2cmyk,hsl2keyword:hsl2keyword,hsv2rgb:hsv2rgb,hsv2hsl:hsv2hsl,hsv2hwb:hsv2hwb,hsv2cmyk:hsv2cmyk,hsv2keyword:hsv2keyword,hwb2rgb:hwb2rgb,hwb2hsl:hwb2hsl,hwb2hsv:hwb2hsv,hwb2cmyk:hwb2cmyk,hwb2keyword:hwb2keyword,cmyk2rgb:cmyk2rgb,cmyk2hsl:cmyk2hsl,cmyk2hsv:cmyk2hsv,cmyk2hwb:cmyk2hwb,cmyk2keyword:cmyk2keyword,keyword2rgb:keyword2rgb,keyword2hsl:keyword2hsl,keyword2hsv:keyword2hsv,keyword2hwb:keyword2hwb,keyword2cmyk:keyword2cmyk,keyword2lab:keyword2lab,keyword2xyz:keyword2xyz,xyz2rgb:xyz2rgb,xyz2lab:xyz2lab,xyz2lch:xyz2lch,lab2xyz:lab2xyz,lab2rgb:lab2rgb,lab2lch:lab2lch,lch2lab:lch2lab,lch2xyz:lch2xyz,lch2rgb:lch2rgb};var cssKeywords={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]},reverseKeywords={};for(var key in cssKeywords)reverseKeywords[JSON.stringify(cssKeywords[key])]=key},{}],3:[function(require,module,exports){var conversions=require("./conversions"),convert=function(){return new Converter};for(var func in conversions){convert[func+"Raw"]=function(func){return function(arg){return"number"==typeof arg&&(arg=Array.prototype.slice.call(arguments)),conversions[func](arg)}}(func);var pair=/(\w+)2(\w+)/.exec(func),from=pair[1],to=pair[2];convert[from]=convert[from]||{},convert[from][to]=convert[func]=function(func){return function(arg){"number"==typeof arg&&(arg=Array.prototype.slice.call(arguments));var val=conversions[func](arg);if("string"==typeof val||void 0===val)return val;for(var i=0;i<val.length;i++)val[i]=Math.round(val[i]);return val}}(func)}var Converter=function(){this.convs={}};Converter.prototype.routeSpace=function(space,args){var values=args[0];return void 0===values?this.getValues(space):("number"==typeof values&&(values=Array.prototype.slice.call(args)),this.setValues(space,values))},Converter.prototype.setValues=function(space,values){return this.space=space,this.convs={},this.convs[space]=values,this},Converter.prototype.getValues=function(space){var vals=this.convs[space];if(!vals){var fspace=this.space,from=this.convs[fspace];vals=convert[fspace][space](from),this.convs[space]=vals}return vals},["rgb","hsl","hsv","cmyk","keyword"].forEach(function(space){Converter.prototype[space]=function(vals){return this.routeSpace(space,arguments)}}),module.exports=convert},{"./conversions":2}],4:[function(require,module,exports){module.exports={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]}},{}],5:[function(require,module,exports){function getRgba(string){if(string){var abbr=/^#([a-fA-F0-9]{3})$/,hex=/^#([a-fA-F0-9]{6})$/,rgba=/^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,per=/^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,keyword=/(\D+)/,rgb=[0,0,0],a=1,match=string.match(abbr);if(match){match=match[1];for(var i=0;i<rgb.length;i++)rgb[i]=parseInt(match[i]+match[i],16)}else if(match=string.match(hex)){match=match[1];for(var i=0;i<rgb.length;i++)rgb[i]=parseInt(match.slice(2*i,2*i+2),16)}else if(match=string.match(rgba)){for(var i=0;i<rgb.length;i++)rgb[i]=parseInt(match[i+1]);a=parseFloat(match[4])}else if(match=string.match(per)){for(var i=0;i<rgb.length;i++)rgb[i]=Math.round(2.55*parseFloat(match[i+1]));a=parseFloat(match[4])}else if(match=string.match(keyword)){if("transparent"==match[1])return[0,0,0,0];if(!(rgb=colorNames[match[1]]))return}for(var i=0;i<rgb.length;i++)rgb[i]=scale(rgb[i],0,255);return a=a||0==a?scale(a,0,1):1,rgb[3]=a,rgb}}function getHsla(string){if(string){var hsl=/^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/,match=string.match(hsl);if(match){var alpha=parseFloat(match[4]);return[scale(parseInt(match[1]),0,360),scale(parseFloat(match[2]),0,100),scale(parseFloat(match[3]),0,100),scale(isNaN(alpha)?1:alpha,0,1)]}}}function getHwb(string){if(string){var hwb=/^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/,match=string.match(hwb);if(match){var alpha=parseFloat(match[4]);return[scale(parseInt(match[1]),0,360),scale(parseFloat(match[2]),0,100),scale(parseFloat(match[3]),0,100),scale(isNaN(alpha)?1:alpha,0,1)]}}}function getRgb(string){var rgba=getRgba(string);return rgba&&rgba.slice(0,3)}function getHsl(string){var hsla=getHsla(string);return hsla&&hsla.slice(0,3)}function getAlpha(string){var vals=getRgba(string);return vals?vals[3]:(vals=getHsla(string))?vals[3]:(vals=getHwb(string))?vals[3]:void 0}function hexString(rgb){return"#"+hexDouble(rgb[0])+hexDouble(rgb[1])+hexDouble(rgb[2])}function rgbString(rgba,alpha){return alpha<1||rgba[3]&&rgba[3]<1?rgbaString(rgba,alpha):"rgb("+rgba[0]+", "+rgba[1]+", "+rgba[2]+")"}function rgbaString(rgba,alpha){return void 0===alpha&&(alpha=void 0!==rgba[3]?rgba[3]:1),"rgba("+rgba[0]+", "+rgba[1]+", "+rgba[2]+", "+alpha+")"}function percentString(rgba,alpha){return alpha<1||rgba[3]&&rgba[3]<1?percentaString(rgba,alpha):"rgb("+Math.round(rgba[0]/255*100)+"%, "+Math.round(rgba[1]/255*100)+"%, "+Math.round(rgba[2]/255*100)+"%)"}function percentaString(rgba,alpha){return"rgba("+Math.round(rgba[0]/255*100)+"%, "+Math.round(rgba[1]/255*100)+"%, "+Math.round(rgba[2]/255*100)+"%, "+(alpha||rgba[3]||1)+")"}function hslString(hsla,alpha){return alpha<1||hsla[3]&&hsla[3]<1?hslaString(hsla,alpha):"hsl("+hsla[0]+", "+hsla[1]+"%, "+hsla[2]+"%)"}function hslaString(hsla,alpha){return void 0===alpha&&(alpha=void 0!==hsla[3]?hsla[3]:1),"hsla("+hsla[0]+", "+hsla[1]+"%, "+hsla[2]+"%, "+alpha+")"}function hwbString(hwb,alpha){return void 0===alpha&&(alpha=void 0!==hwb[3]?hwb[3]:1),"hwb("+hwb[0]+", "+hwb[1]+"%, "+hwb[2]+"%"+(void 0!==alpha&&1!==alpha?", "+alpha:"")+")"}function keyword(rgb){return reverseNames[rgb.slice(0,3)]}function scale(num,min,max){return Math.min(Math.max(min,num),max)}function hexDouble(num){var str=num.toString(16).toUpperCase();return str.length<2?"0"+str:str}var colorNames=require("color-name");module.exports={getRgba:getRgba,getHsla:getHsla,getRgb:getRgb,getHsl:getHsl,getHwb:getHwb,getAlpha:getAlpha,hexString:hexString,rgbString:rgbString,rgbaString:rgbaString,percentString:percentString,percentaString:percentaString,hslString:hslString,hslaString:hslaString,hwbString:hwbString,keyword:keyword};var reverseNames={};for(var name in colorNames)reverseNames[colorNames[name]]=name},{"color-name":4}],6:[function(require,module,exports){var convert=require("color-convert"),string=require("color-string"),Color=function(obj){if(obj instanceof Color)return obj;if(!(this instanceof Color))return new Color(obj);if(this.values={rgb:[0,0,0],hsl:[0,0,0],hsv:[0,0,0],hwb:[0,0,0],cmyk:[0,0,0,0],alpha:1},"string"==typeof obj){var vals=string.getRgba(obj);if(vals)this.setValues("rgb",vals);else if(vals=string.getHsla(obj))this.setValues("hsl",vals);else{if(!(vals=string.getHwb(obj)))throw new Error('Unable to parse color from string "'+obj+'"');this.setValues("hwb",vals)}}else if("object"==typeof obj){var vals=obj;if(void 0!==vals.r||void 0!==vals.red)this.setValues("rgb",vals);else if(void 0!==vals.l||void 0!==vals.lightness)this.setValues("hsl",vals);else if(void 0!==vals.v||void 0!==vals.value)this.setValues("hsv",vals);else if(void 0!==vals.w||void 0!==vals.whiteness)this.setValues("hwb",vals);else{if(void 0===vals.c&&void 0===vals.cyan)throw new Error("Unable to parse color from object "+JSON.stringify(obj));this.setValues("cmyk",vals)}}};Color.prototype={rgb:function(vals){return this.setSpace("rgb",arguments)},hsl:function(vals){return this.setSpace("hsl",arguments)},hsv:function(vals){return this.setSpace("hsv",arguments)},hwb:function(vals){return this.setSpace("hwb",arguments)},cmyk:function(vals){return this.setSpace("cmyk",arguments)},rgbArray:function(){return this.values.rgb},hslArray:function(){return this.values.hsl},hsvArray:function(){return this.values.hsv},hwbArray:function(){return 1!==this.values.alpha?this.values.hwb.concat([this.values.alpha]):this.values.hwb},cmykArray:function(){return this.values.cmyk},rgbaArray:function(){return this.values.rgb.concat([this.values.alpha])},hslaArray:function(){return this.values.hsl.concat([this.values.alpha])},alpha:function(val){return void 0===val?this.values.alpha:(this.setValues("alpha",val),this)},red:function(val){return this.setChannel("rgb",0,val)},green:function(val){return this.setChannel("rgb",1,val)},blue:function(val){return this.setChannel("rgb",2,val)},hue:function(val){return this.setChannel("hsl",0,val)},saturation:function(val){return this.setChannel("hsl",1,val)},lightness:function(val){return this.setChannel("hsl",2,val)},saturationv:function(val){return this.setChannel("hsv",1,val)},whiteness:function(val){return this.setChannel("hwb",1,val)},blackness:function(val){return this.setChannel("hwb",2,val)},value:function(val){return this.setChannel("hsv",2,val)},cyan:function(val){return this.setChannel("cmyk",0,val)},magenta:function(val){return this.setChannel("cmyk",1,val)},yellow:function(val){return this.setChannel("cmyk",2,val)},black:function(val){return this.setChannel("cmyk",3,val)},hexString:function(){return string.hexString(this.values.rgb)},rgbString:function(){return string.rgbString(this.values.rgb,this.values.alpha)},rgbaString:function(){return string.rgbaString(this.values.rgb,this.values.alpha)},percentString:function(){return string.percentString(this.values.rgb,this.values.alpha)},hslString:function(){return string.hslString(this.values.hsl,this.values.alpha)},hslaString:function(){return string.hslaString(this.values.hsl,this.values.alpha)},hwbString:function(){return string.hwbString(this.values.hwb,this.values.alpha)},keyword:function(){return string.keyword(this.values.rgb,this.values.alpha)},rgbNumber:function(){return this.values.rgb[0]<<16|this.values.rgb[1]<<8|this.values.rgb[2]},luminosity:function(){for(var rgb=this.values.rgb,lum=[],i=0;i<rgb.length;i++){var chan=rgb[i]/255;lum[i]=chan<=.03928?chan/12.92:Math.pow((chan+.055)/1.055,2.4)}return.2126*lum[0]+.7152*lum[1]+.0722*lum[2]},contrast:function(color2){var lum1=this.luminosity(),lum2=color2.luminosity();return lum1>lum2?(lum1+.05)/(lum2+.05):(lum2+.05)/(lum1+.05)},level:function(color2){var contrastRatio=this.contrast(color2);return contrastRatio>=7.1?"AAA":contrastRatio>=4.5?"AA":""},dark:function(){var rgb=this.values.rgb;return(299*rgb[0]+587*rgb[1]+114*rgb[2])/1e3<128},light:function(){return!this.dark()},negate:function(){for(var rgb=[],i=0;i<3;i++)rgb[i]=255-this.values.rgb[i];return this.setValues("rgb",rgb),this},lighten:function(ratio){return this.values.hsl[2]+=this.values.hsl[2]*ratio,this.setValues("hsl",this.values.hsl),this},darken:function(ratio){return this.values.hsl[2]-=this.values.hsl[2]*ratio,this.setValues("hsl",this.values.hsl),this},saturate:function(ratio){return this.values.hsl[1]+=this.values.hsl[1]*ratio,this.setValues("hsl",this.values.hsl),this},desaturate:function(ratio){return this.values.hsl[1]-=this.values.hsl[1]*ratio,this.setValues("hsl",this.values.hsl),this},whiten:function(ratio){return this.values.hwb[1]+=this.values.hwb[1]*ratio,this.setValues("hwb",this.values.hwb),this},blacken:function(ratio){return this.values.hwb[2]+=this.values.hwb[2]*ratio,this.setValues("hwb",this.values.hwb),this},greyscale:function(){var rgb=this.values.rgb,val=.3*rgb[0]+.59*rgb[1]+.11*rgb[2];return this.setValues("rgb",[val,val,val]),this},clearer:function(ratio){return this.setValues("alpha",this.values.alpha-this.values.alpha*ratio),this},opaquer:function(ratio){return this.setValues("alpha",this.values.alpha+this.values.alpha*ratio),this},rotate:function(degrees){var hue=this.values.hsl[0];return hue=(hue+degrees)%360,hue=hue<0?360+hue:hue,this.values.hsl[0]=hue,this.setValues("hsl",this.values.hsl),this},mix:function(color2,weight){weight=1-(null==weight?.5:weight);for(var t1=2*weight-1,d=this.alpha()-color2.alpha(),weight1=((t1*d==-1?t1:(t1+d)/(1+t1*d))+1)/2,weight2=1-weight1,rgb=this.rgbArray(),rgb2=color2.rgbArray(),i=0;i<rgb.length;i++)rgb[i]=rgb[i]*weight1+rgb2[i]*weight2;this.setValues("rgb",rgb);var alpha=this.alpha()*weight+color2.alpha()*(1-weight);return this.setValues("alpha",alpha),this},toJSON:function(){return this.rgb()},clone:function(){return new Color(this.rgb())}},Color.prototype.getValues=function(space){for(var vals={},i=0;i<space.length;i++)vals[space.charAt(i)]=this.values[space][i];return 1!=this.values.alpha&&(vals.a=this.values.alpha),vals},Color.prototype.setValues=function(space,vals){var spaces={rgb:["red","green","blue"],hsl:["hue","saturation","lightness"],hsv:["hue","saturation","value"],hwb:["hue","whiteness","blackness"],cmyk:["cyan","magenta","yellow","black"]},maxes={rgb:[255,255,255],hsl:[360,100,100],hsv:[360,100,100],hwb:[360,100,100],cmyk:[100,100,100,100]},alpha=1;if("alpha"==space)alpha=vals;else if(vals.length)this.values[space]=vals.slice(0,space.length),alpha=vals[space.length];else if(void 0!==vals[space.charAt(0)]){for(var i=0;i<space.length;i++)this.values[space][i]=vals[space.charAt(i)];alpha=vals.a}else if(void 0!==vals[spaces[space][0]]){for(var chans=spaces[space],i=0;i<space.length;i++)this.values[space][i]=vals[chans[i]];alpha=vals.alpha}if(this.values.alpha=Math.max(0,Math.min(1,void 0!==alpha?alpha:this.values.alpha)),"alpha"!=space){for(var i=0;i<space.length;i++){var capped=Math.max(0,Math.min(maxes[space][i],this.values[space][i]));this.values[space][i]=Math.round(capped)}for(var sname in spaces){sname!=space&&(this.values[sname]=convert[space][sname](this.values[space]));for(var i=0;i<sname.length;i++){var capped=Math.max(0,Math.min(maxes[sname][i],this.values[sname][i]));this.values[sname][i]=Math.round(capped)}}return!0}},Color.prototype.setSpace=function(space,args){var vals=args[0];return void 0===vals?this.getValues(space):("number"==typeof vals&&(vals=Array.prototype.slice.call(args)),this.setValues(space,vals),this)},Color.prototype.setChannel=function(space,index,val){return void 0===val?this.values[space][index]:(this.values[space][index]=val,this.setValues(space,this.values[space]),this)},module.exports=Color},{"color-convert":3,"color-string":5}],7:[function(require,module,exports){module.exports=require("./lib/geocrunch")},{"./lib/geocrunch":12}],8:[function(require,module,exports){var _=require("underscore"),R=require("./constants").EARTHRADIUS,units=require("./units"),flipCoords=require("./flipcoords"),convertFuncs={sqmeters:function(a){return a},sqmiles:function(a){return units.sqMeters.toSqMiles(a)},acres:function(a){return units.sqMeters.toAcres(a)}},calcArea=function(coordArray){var i,l,c1,c2,area=0;for(i=0,l=coordArray.length;i<l;i+=1)c1=coordArray[i],c2=coordArray[(i+1)%coordArray.length],area+=units.degrees.toRadians(c2[0]-c1[0])*(2+Math.sin(units.degrees.toRadians(c1[1]))+Math.sin(units.degrees.toRadians(c2[1])));return Math.abs(area*R*R/2)},calcCenter=function(coordArray){var i,l,c1,c2,f,offset=coordArray[0],twiceArea=0,x=0,y=0;if(1===coordArray.length)return coordArray[0];for(i=0,l=coordArray.length;i<l;i+=1)c1=coordArray[i],c2=coordArray[(i+1)%coordArray.length],f=(c1[1]-offset[1])*(c2[0]-offset[0])-(c2[1]-offset[1])*(c1[0]-offset[0]),twiceArea+=f,x+=(c1[0]+c2[0]-2*offset[0])*f,y+=(c1[1]+c2[1]-2*offset[1])*f;return f=3*twiceArea,[x/f+offset[0],y/f+offset[1]]};module.exports={_internalAreaCalc:function(){this._calcedArea||(this._coords.length<3?this._calcedArea=0:this._calcedArea=calcArea(this._coords))},_internalCenterCalc:function(){!this._calcedCenter&&this._coords.length&&(this._calcedCenter=calcCenter(this._coords))},area:function(options){var opts=_.extend({units:"sqmeters"},options);if(this._internalAreaCalc(),_.isFunction(convertFuncs[opts.units]))return convertFuncs[opts.units](this._calcedArea)},center:function(){return this._internalCenterCalc(),!0===this._options.imBackwards?flipCoords(this._calcedCenter):this._calcedCenter}}},{"./constants":9,"./flipcoords":11,"./units":14,underscore:15}],9:[function(require,module,exports){module.exports={EARTHRADIUS:6371e3}},{}],10:[function(require,module,exports){var _=require("underscore"),R=require("./constants").EARTHRADIUS,units=require("./units"),convertFuncs={meters:function(d){return d},kilometers:function(d){return units.meters.toKilometers(d)},feet:function(d){return units.meters.toFeet(d)},miles:function(d){return units.meters.toMiles(d)}},calcDistance=function(coord1,coord2){var deltaLng=units.degrees.toRadians(coord1[0]-coord2[0]),deltaLat=units.degrees.toRadians(coord1[1]-coord2[1]),lat1=units.degrees.toRadians(coord1[1]),lat2=units.degrees.toRadians(coord2[1]),hvsLng=Math.sin(deltaLng/2),hvsLat=Math.sin(deltaLat/2),a=hvsLat*hvsLat+hvsLng*hvsLng*Math.cos(lat1)*Math.cos(lat2);return 2*R*Math.atan2(Math.sqrt(a),Math.sqrt(1-a))};module.exports={_internalDistanceCalc:function(){var i,l,distance=0;if(!this._calcedDistance){for(i=0,l=this._coords.length;i<l;i+=1)i>0&&(distance+=calcDistance(this._coords[i-1],this._coords[i]));this._calcedDistance=distance}},distance:function(options){var opts=_.extend({units:"meters"},options);if(this._internalDistanceCalc(),_.isFunction(convertFuncs[opts.units]))return convertFuncs[opts.units](this._calcedDistance)}}},{"./constants":9,"./units":14,underscore:15}],11:[function(require,module,exports){var _=require("underscore");module.exports=function(backwardsCoordArray){return _.map(backwardsCoordArray,function(backwardsCoord){return[backwardsCoord[1],backwardsCoord[0]]})}},{underscore:15}],12:[function(require,module,exports){var _=require("underscore"),Path=require("./path"),distanceMixins=require("./distance"),areaMixins=require("./area");_.extend(Path.prototype,distanceMixins,areaMixins),exports.path=function(coords,options){return new Path(coords,options)}},{"./area":8,"./distance":10,"./path":13,underscore:15}],13:[function(require,module,exports){var flipCoords=require("./flipcoords"),Path=function(coords,options){this._options=options||{},coords=coords||[],this._coords=!0===this._options.imBackwards?flipCoords(coords):coords};module.exports=Path},{"./flipcoords":11}],14:[function(require,module,exports){exports.meters={toFeet:function(m){return 3.28084*m},toKilometers:function(m){return.001*m},toMiles:function(m){return 621371e-9*m}},exports.sqMeters={toSqMiles:function(m){return 3.86102e-7*m},toAcres:function(m){return 247105e-9*m}},exports.degrees={toRadians:function(d){return d*Math.PI/180}}},{}],15:[function(require,module,exports){(function(){var root=this,previousUnderscore=root._,breaker={},ArrayProto=Array.prototype,ObjProto=Object.prototype,FuncProto=Function.prototype,push=ArrayProto.push,slice=ArrayProto.slice,concat=ArrayProto.concat,toString=ObjProto.toString,hasOwnProperty=ObjProto.hasOwnProperty,nativeForEach=ArrayProto.forEach,nativeMap=ArrayProto.map,nativeReduce=ArrayProto.reduce,nativeReduceRight=ArrayProto.reduceRight,nativeFilter=ArrayProto.filter,nativeEvery=ArrayProto.every,nativeSome=ArrayProto.some,nativeIndexOf=ArrayProto.indexOf,nativeLastIndexOf=ArrayProto.lastIndexOf,nativeIsArray=Array.isArray,nativeKeys=Object.keys,nativeBind=FuncProto.bind,_=function(obj){return obj instanceof _?obj:this instanceof _?void(this._wrapped=obj):new _(obj)};void 0!==exports?(void 0!==module&&module.exports&&(exports=module.exports=_),exports._=_):root._=_,_.VERSION="1.5.2";var each=_.each=_.forEach=function(obj,iterator,context){if(null!=obj)if(nativeForEach&&obj.forEach===nativeForEach)obj.forEach(iterator,context);else if(obj.length===+obj.length){for(var i=0,length=obj.length;i<length;i++)if(iterator.call(context,obj[i],i,obj)===breaker)return}else for(var keys=_.keys(obj),i=0,length=keys.length;i<length;i++)if(iterator.call(context,obj[keys[i]],keys[i],obj)===breaker)return};_.map=_.collect=function(obj,iterator,context){var results=[];return null==obj?results:nativeMap&&obj.map===nativeMap?obj.map(iterator,context):(each(obj,function(value,index,list){results.push(iterator.call(context,value,index,list))}),results)};var reduceError="Reduce of empty array with no initial value";_.reduce=_.foldl=_.inject=function(obj,iterator,memo,context){var initial=arguments.length>2;if(null==obj&&(obj=[]),nativeReduce&&obj.reduce===nativeReduce)return context&&(iterator=_.bind(iterator,context)),initial?obj.reduce(iterator,memo):obj.reduce(iterator);if(each(obj,function(value,index,list){initial?memo=iterator.call(context,memo,value,index,list):(memo=value,initial=!0)}),!initial)throw new TypeError(reduceError);return memo},_.reduceRight=_.foldr=function(obj,iterator,memo,context){var initial=arguments.length>2;if(null==obj&&(obj=[]),nativeReduceRight&&obj.reduceRight===nativeReduceRight)return context&&(iterator=_.bind(iterator,context)),initial?obj.reduceRight(iterator,memo):obj.reduceRight(iterator);var length=obj.length;if(length!==+length){var keys=_.keys(obj);length=keys.length}if(each(obj,function(value,index,list){index=keys?keys[--length]:--length,initial?memo=iterator.call(context,memo,obj[index],index,list):(memo=obj[index],initial=!0)}),!initial)throw new TypeError(reduceError);return memo},_.find=_.detect=function(obj,iterator,context){var result;return any(obj,function(value,index,list){if(iterator.call(context,value,index,list))return result=value,!0}),result},_.filter=_.select=function(obj,iterator,context){var results=[];return null==obj?results:nativeFilter&&obj.filter===nativeFilter?obj.filter(iterator,context):(each(obj,function(value,index,list){iterator.call(context,value,index,list)&&results.push(value)}),results)},_.reject=function(obj,iterator,context){return _.filter(obj,function(value,index,list){return!iterator.call(context,value,index,list)},context)},_.every=_.all=function(obj,iterator,context){iterator||(iterator=_.identity);var result=!0;return null==obj?result:nativeEvery&&obj.every===nativeEvery?obj.every(iterator,context):(each(obj,function(value,index,list){if(!(result=result&&iterator.call(context,value,index,list)))return breaker}),!!result)};var any=_.some=_.any=function(obj,iterator,context){iterator||(iterator=_.identity);var result=!1;return null==obj?result:nativeSome&&obj.some===nativeSome?obj.some(iterator,context):(each(obj,function(value,index,list){if(result||(result=iterator.call(context,value,index,list)))return breaker}),!!result)};_.contains=_.include=function(obj,target){return null!=obj&&(nativeIndexOf&&obj.indexOf===nativeIndexOf?-1!=obj.indexOf(target):any(obj,function(value){return value===target}))},_.invoke=function(obj,method){var args=slice.call(arguments,2),isFunc=_.isFunction(method);return _.map(obj,function(value){return(isFunc?method:value[method]).apply(value,args)})},_.pluck=function(obj,key){return _.map(obj,function(value){return value[key]})},_.where=function(obj,attrs,first){return _.isEmpty(attrs)?first?void 0:[]:_[first?"find":"filter"](obj,function(value){for(var key in attrs)if(attrs[key]!==value[key])return!1;return!0})},_.findWhere=function(obj,attrs){return _.where(obj,attrs,!0)},_.max=function(obj,iterator,context){if(!iterator&&_.isArray(obj)&&obj[0]===+obj[0]&&obj.length<65535)return Math.max.apply(Math,obj);if(!iterator&&_.isEmpty(obj))return-1/0;var result={computed:-1/0,value:-1/0};return each(obj,function(value,index,list){var computed=iterator?iterator.call(context,value,index,list):value;computed>result.computed&&(result={value:value,computed:computed})}),result.value},_.min=function(obj,iterator,context){if(!iterator&&_.isArray(obj)&&obj[0]===+obj[0]&&obj.length<65535)return Math.min.apply(Math,obj);if(!iterator&&_.isEmpty(obj))return 1/0;var result={computed:1/0,value:1/0};return each(obj,function(value,index,list){var computed=iterator?iterator.call(context,value,index,list):value;computed<result.computed&&(result={value:value,computed:computed})}),result.value},_.shuffle=function(obj){var rand,index=0,shuffled=[];return each(obj,function(value){rand=_.random(index++),shuffled[index-1]=shuffled[rand],shuffled[rand]=value}),shuffled},_.sample=function(obj,n,guard){return arguments.length<2||guard?obj[_.random(obj.length-1)]:_.shuffle(obj).slice(0,Math.max(0,n))};var lookupIterator=function(value){return _.isFunction(value)?value:function(obj){return obj[value]}};_.sortBy=function(obj,value,context){var iterator=lookupIterator(value);return _.pluck(_.map(obj,function(value,index,list){return{value:value,index:index,criteria:iterator.call(context,value,index,list)}}).sort(function(left,right){var a=left.criteria,b=right.criteria;if(a!==b){if(a>b||void 0===a)return 1;if(a<b||void 0===b)return-1}return left.index-right.index}),"value")};var group=function(behavior){return function(obj,value,context){var result={},iterator=null==value?_.identity:lookupIterator(value);return each(obj,function(value,index){var key=iterator.call(context,value,index,obj);behavior(result,key,value)}),result}};_.groupBy=group(function(result,key,value){(_.has(result,key)?result[key]:result[key]=[]).push(value)}),_.indexBy=group(function(result,key,value){result[key]=value}),_.countBy=group(function(result,key){_.has(result,key)?result[key]++:result[key]=1}),_.sortedIndex=function(array,obj,iterator,context){iterator=null==iterator?_.identity:lookupIterator(iterator);for(var value=iterator.call(context,obj),low=0,high=array.length;low<high;){var mid=low+high>>>1;iterator.call(context,array[mid])<value?low=mid+1:high=mid}return low},_.toArray=function(obj){return obj?_.isArray(obj)?slice.call(obj):obj.length===+obj.length?_.map(obj,_.identity):_.values(obj):[]},_.size=function(obj){return null==obj?0:obj.length===+obj.length?obj.length:_.keys(obj).length},_.first=_.head=_.take=function(array,n,guard){if(null!=array)return null==n||guard?array[0]:slice.call(array,0,n)},_.initial=function(array,n,guard){return slice.call(array,0,array.length-(null==n||guard?1:n))},_.last=function(array,n,guard){if(null!=array)return null==n||guard?array[array.length-1]:slice.call(array,Math.max(array.length-n,0))},_.rest=_.tail=_.drop=function(array,n,guard){return slice.call(array,null==n||guard?1:n)},_.compact=function(array){return _.filter(array,_.identity)};var flatten=function(input,shallow,output){return shallow&&_.every(input,_.isArray)?concat.apply(output,input):(each(input,function(value){_.isArray(value)||_.isArguments(value)?shallow?push.apply(output,value):flatten(value,shallow,output):output.push(value)}),output)};_.flatten=function(array,shallow){return flatten(array,shallow,[])},_.without=function(array){return _.difference(array,slice.call(arguments,1))},_.uniq=_.unique=function(array,isSorted,iterator,context){_.isFunction(isSorted)&&(context=iterator,iterator=isSorted,isSorted=!1);var initial=iterator?_.map(array,iterator,context):array,results=[],seen=[];return each(initial,function(value,index){(isSorted?index&&seen[seen.length-1]===value:_.contains(seen,value))||(seen.push(value),results.push(array[index]))}),results},_.union=function(){return _.uniq(_.flatten(arguments,!0))},_.intersection=function(array){var rest=slice.call(arguments,1);return _.filter(_.uniq(array),function(item){return _.every(rest,function(other){return _.indexOf(other,item)>=0})})},_.difference=function(array){var rest=concat.apply(ArrayProto,slice.call(arguments,1));return _.filter(array,function(value){return!_.contains(rest,value)})},_.zip=function(){for(var length=_.max(_.pluck(arguments,"length").concat(0)),results=new Array(length),i=0;i<length;i++)results[i]=_.pluck(arguments,""+i);return results},_.object=function(list,values){if(null==list)return{};for(var result={},i=0,length=list.length;i<length;i++)values?result[list[i]]=values[i]:result[list[i][0]]=list[i][1];return result},_.indexOf=function(array,item,isSorted){if(null==array)return-1;var i=0,length=array.length;if(isSorted){if("number"!=typeof isSorted)return i=_.sortedIndex(array,item),array[i]===item?i:-1;i=isSorted<0?Math.max(0,length+isSorted):isSorted}if(nativeIndexOf&&array.indexOf===nativeIndexOf)return array.indexOf(item,isSorted);for(;i<length;i++)if(array[i]===item)return i;return-1},_.lastIndexOf=function(array,item,from){if(null==array)return-1;var hasIndex=null!=from;if(nativeLastIndexOf&&array.lastIndexOf===nativeLastIndexOf)return hasIndex?array.lastIndexOf(item,from):array.lastIndexOf(item);for(var i=hasIndex?from:array.length;i--;)if(array[i]===item)return i;return-1},_.range=function(start,stop,step){arguments.length<=1&&(stop=start||0,start=0),step=arguments[2]||1;for(var length=Math.max(Math.ceil((stop-start)/step),0),idx=0,range=new Array(length);idx<length;)range[idx++]=start,start+=step;return range};var ctor=function(){};_.bind=function(func,context){var args,bound;if(nativeBind&&func.bind===nativeBind)return nativeBind.apply(func,slice.call(arguments,1));if(!_.isFunction(func))throw new TypeError;return args=slice.call(arguments,2),bound=function(){if(!(this instanceof bound))return func.apply(context,args.concat(slice.call(arguments)));ctor.prototype=func.prototype;var self=new ctor;ctor.prototype=null;var result=func.apply(self,args.concat(slice.call(arguments)));return Object(result)===result?result:self}},_.partial=function(func){var args=slice.call(arguments,1);return function(){return func.apply(this,args.concat(slice.call(arguments)))}},_.bindAll=function(obj){var funcs=slice.call(arguments,1);if(0===funcs.length)throw new Error("bindAll must be passed function names");return each(funcs,function(f){obj[f]=_.bind(obj[f],obj)}),obj},_.memoize=function(func,hasher){var memo={};return hasher||(hasher=_.identity),function(){var key=hasher.apply(this,arguments);return _.has(memo,key)?memo[key]:memo[key]=func.apply(this,arguments)}},_.delay=function(func,wait){var args=slice.call(arguments,2);return setTimeout(function(){return func.apply(null,args)},wait)},_.defer=function(func){return _.delay.apply(_,[func,1].concat(slice.call(arguments,1)))},_.throttle=function(func,wait,options){var context,args,result,timeout=null,previous=0;options||(options={});var later=function(){previous=!1===options.leading?0:new Date,timeout=null,result=func.apply(context,args)};return function(){var now=new Date;previous||!1!==options.leading||(previous=now);var remaining=wait-(now-previous);return context=this,args=arguments,remaining<=0?(clearTimeout(timeout),timeout=null,previous=now,result=func.apply(context,args)):timeout||!1===options.trailing||(timeout=setTimeout(later,remaining)),result}},_.debounce=function(func,wait,immediate){var timeout,args,context,timestamp,result;return function(){context=this,args=arguments,timestamp=new Date;var later=function(){var last=new Date-timestamp;last<wait?timeout=setTimeout(later,wait-last):(timeout=null,immediate||(result=func.apply(context,args)))},callNow=immediate&&!timeout;return timeout||(timeout=setTimeout(later,wait)),callNow&&(result=func.apply(context,args)),result}},_.once=function(func){var memo,ran=!1;return function(){return ran?memo:(ran=!0,memo=func.apply(this,arguments),func=null,memo)}},_.wrap=function(func,wrapper){return function(){var args=[func];return push.apply(args,arguments),wrapper.apply(this,args)}},_.compose=function(){var funcs=arguments;return function(){for(var args=arguments,i=funcs.length-1;i>=0;i--)args=[funcs[i].apply(this,args)];return args[0]}},_.after=function(times,func){return function(){if(--times<1)return func.apply(this,arguments)}},_.keys=nativeKeys||function(obj){if(obj!==Object(obj))throw new TypeError("Invalid object");var keys=[];for(var key in obj)_.has(obj,key)&&keys.push(key);return keys},_.values=function(obj){for(var keys=_.keys(obj),length=keys.length,values=new Array(length),i=0;i<length;i++)values[i]=obj[keys[i]];return values},_.pairs=function(obj){for(var keys=_.keys(obj),length=keys.length,pairs=new Array(length),i=0;i<length;i++)pairs[i]=[keys[i],obj[keys[i]]];return pairs},_.invert=function(obj){for(var result={},keys=_.keys(obj),i=0,length=keys.length;i<length;i++)result[obj[keys[i]]]=keys[i];return result},_.functions=_.methods=function(obj){var names=[];for(var key in obj)_.isFunction(obj[key])&&names.push(key);return names.sort()},_.extend=function(obj){return each(slice.call(arguments,1),function(source){if(source)for(var prop in source)obj[prop]=source[prop]}),obj},_.pick=function(obj){var copy={},keys=concat.apply(ArrayProto,slice.call(arguments,1));return each(keys,function(key){key in obj&&(copy[key]=obj[key])}),copy},_.omit=function(obj){var copy={},keys=concat.apply(ArrayProto,slice.call(arguments,1));for(var key in obj)_.contains(keys,key)||(copy[key]=obj[key]);return copy},_.defaults=function(obj){return each(slice.call(arguments,1),function(source){if(source)for(var prop in source)void 0===obj[prop]&&(obj[prop]=source[prop])}),obj},_.clone=function(obj){return _.isObject(obj)?_.isArray(obj)?obj.slice():_.extend({},obj):obj},_.tap=function(obj,interceptor){return interceptor(obj),obj};var eq=function(a,b,aStack,bStack){if(a===b)return 0!==a||1/a==1/b;if(null==a||null==b)return a===b;a instanceof _&&(a=a._wrapped),b instanceof _&&(b=b._wrapped);var className=toString.call(a);if(className!=toString.call(b))return!1;switch(className){case"[object String]":return a==String(b);case"[object Number]":return a!=+a?b!=+b:0==a?1/a==1/b:a==+b;case"[object Date]":case"[object Boolean]":return+a==+b;case"[object RegExp]":return a.source==b.source&&a.global==b.global&&a.multiline==b.multiline&&a.ignoreCase==b.ignoreCase}if("object"!=typeof a||"object"!=typeof b)return!1;for(var length=aStack.length;length--;)if(aStack[length]==a)return bStack[length]==b;var aCtor=a.constructor,bCtor=b.constructor;if(aCtor!==bCtor&&!(_.isFunction(aCtor)&&aCtor instanceof aCtor&&_.isFunction(bCtor)&&bCtor instanceof bCtor))return!1;aStack.push(a),bStack.push(b);var size=0,result=!0;if("[object Array]"==className){if(size=a.length,result=size==b.length)for(;size--&&(result=eq(a[size],b[size],aStack,bStack)););}else{for(var key in a)if(_.has(a,key)&&(size++,!(result=_.has(b,key)&&eq(a[key],b[key],aStack,bStack))))break;if(result){for(key in b)if(_.has(b,key)&&!size--)break;result=!size}}return aStack.pop(),bStack.pop(),result};_.isEqual=function(a,b){return eq(a,b,[],[])},_.isEmpty=function(obj){if(null==obj)return!0;if(_.isArray(obj)||_.isString(obj))return 0===obj.length;for(var key in obj)if(_.has(obj,key))return!1;return!0},_.isElement=function(obj){return!(!obj||1!==obj.nodeType)},_.isArray=nativeIsArray||function(obj){return"[object Array]"==toString.call(obj)},_.isObject=function(obj){return obj===Object(obj)},each(["Arguments","Function","String","Number","Date","RegExp"],function(name){_["is"+name]=function(obj){return toString.call(obj)=="[object "+name+"]"}}),_.isArguments(arguments)||(_.isArguments=function(obj){return!(!obj||!_.has(obj,"callee"))}),_.isFunction=function(obj){return"function"==typeof obj},_.isFinite=function(obj){return isFinite(obj)&&!isNaN(parseFloat(obj))},_.isNaN=function(obj){return _.isNumber(obj)&&obj!=+obj},_.isBoolean=function(obj){return!0===obj||!1===obj||"[object Boolean]"==toString.call(obj)},_.isNull=function(obj){return null===obj},_.isUndefined=function(obj){return void 0===obj},_.has=function(obj,key){return hasOwnProperty.call(obj,key)},_.noConflict=function(){return root._=previousUnderscore,this},_.identity=function(value){return value},_.times=function(n,iterator,context){for(var accum=Array(Math.max(0,n)),i=0;i<n;i++)accum[i]=iterator.call(context,i);return accum},_.random=function(min,max){return null==max&&(max=min,min=0),min+Math.floor(Math.random()*(max-min+1))};var entityMap={escape:{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;"}};entityMap.unescape=_.invert(entityMap.escape);var entityRegexes={escape:new RegExp("["+_.keys(entityMap.escape).join("")+"]","g"),unescape:new RegExp("("+_.keys(entityMap.unescape).join("|")+")","g")};_.each(["escape","unescape"],function(method){_[method]=function(string){return null==string?"":(""+string).replace(entityRegexes[method],function(match){return entityMap[method][match]})}}),_.result=function(object,property){if(null!=object){var value=object[property];return _.isFunction(value)?value.call(object):value}},_.mixin=function(obj){each(_.functions(obj),function(name){var func=_[name]=obj[name];_.prototype[name]=function(){var args=[this._wrapped];return push.apply(args,arguments),result.call(this,func.apply(_,args))}})};var idCounter=0;_.uniqueId=function(prefix){var id=++idCounter+"";return prefix?prefix+id:id},_.templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var noMatch=/(.)^/,escapes={"'":"'","\\":"\\","\r":"r","\n":"n","\t":"t","\u2028":"u2028","\u2029":"u2029"},escaper=/\\|'|\r|\n|\t|\u2028|\u2029/g;_.template=function(text,data,settings){var render;settings=_.defaults({},settings,_.templateSettings);var matcher=new RegExp([(settings.escape||noMatch).source,(settings.interpolate||noMatch).source,(settings.evaluate||noMatch).source].join("|")+"|$","g"),index=0,source="__p+='";text.replace(matcher,function(match,escape,interpolate,evaluate,offset){return source+=text.slice(index,offset).replace(escaper,function(match){return"\\"+escapes[match]}),escape&&(source+="'+\n((__t=("+escape+"))==null?'':_.escape(__t))+\n'"),interpolate&&(source+="'+\n((__t=("+interpolate+"))==null?'':__t)+\n'"),evaluate&&(source+="';\n"+evaluate+"\n__p+='"),index=offset+match.length,match}),source+="';\n",settings.variable||(source="with(obj||{}){\n"+source+"}\n"),source="var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n"+source+"return __p;\n";try{render=new Function(settings.variable||"obj","_",source)}catch(e){throw e.source=source,e}if(data)return render(data,_);var template=function(data){return render.call(this,data,_)};return template.source="function("+(settings.variable||"obj")+"){\n"+source+"}",template},_.chain=function(obj){return _(obj).chain()};var result=function(obj){return this._chain?_(obj).chain():obj};_.mixin(_),each(["pop","push","reverse","shift","sort","splice","unshift"],function(name){var method=ArrayProto[name];_.prototype[name]=function(){var obj=this._wrapped;return method.apply(obj,arguments),"shift"!=name&&"splice"!=name||0!==obj.length||delete obj[0],result.call(this,obj)}}),each(["concat","join","slice"],function(name){var method=ArrayProto[name];_.prototype[name]=function(){return result.call(this,method.apply(this._wrapped,arguments))}}),_.extend(_.prototype,{chain:function(){return this._chain=!0,this},value:function(){return this._wrapped}})}).call(this)},{}],16:[function(require,module,exports){(function(){var root=this,previousHumanize=root.humanize,humanize={};void 0!==exports?(void 0!==module&&module.exports&&(exports=module.exports=humanize),exports.humanize=humanize):(void 0!==(__WEBPACK_AMD_DEFINE_RESULT__=function(){return humanize}.call(exports,__webpack_require__,exports,module))&&(module.exports=__WEBPACK_AMD_DEFINE_RESULT__),root.humanize=humanize),humanize.noConflict=function(){return root.humanize=previousHumanize,this},humanize.pad=function(str,count,padChar,type){if(str+="",padChar?padChar.length>1&&(padChar=padChar.charAt(0)):padChar=" ","right"===(type=void 0===type?"left":"right"))for(;str.length<count;)str+=padChar;else for(;str.length<count;)str=padChar+str;return str},humanize.time=function(){return(new Date).getTime()/1e3};var dayTableCommon=[0,0,31,59,90,120,151,181,212,243,273,304,334],dayTableLeap=[0,0,31,60,91,121,152,182,213,244,274,305,335];humanize.date=function(format,timestamp){var jsdate=void 0===timestamp?new Date:timestamp instanceof Date?new Date(timestamp):new Date(1e3*timestamp),formatChr=/\\?([a-z])/gi,formatChrCb=function(t,s){return f[t]?f[t]():s},shortDayTxt=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],monthTxt=["January","February","March","April","May","June","July","August","September","October","November","December"],f={d:function(){return humanize.pad(f.j(),2,"0")},D:function(){return f.l().slice(0,3)},j:function(){return jsdate.getDate()},l:function(){return shortDayTxt[f.w()]},N:function(){return f.w()||7},S:function(){var j=f.j();return j>4&&j<21?"th":{1:"st",2:"nd",3:"rd"}[j%10]||"th"},w:function(){return jsdate.getDay()},z:function(){return(f.L()?dayTableLeap[f.n()]:dayTableCommon[f.n()])+f.j()-1},W:function(){var midWeekDaysFromJan4=f.z()-f.N()+1.5;return humanize.pad(1+Math.floor(Math.abs(midWeekDaysFromJan4)/7)+(midWeekDaysFromJan4%7>3.5?1:0),2,"0")},F:function(){return monthTxt[jsdate.getMonth()]},m:function(){return humanize.pad(f.n(),2,"0")},M:function(){return f.F().slice(0,3)},n:function(){return jsdate.getMonth()+1},t:function(){return new Date(f.Y(),f.n(),0).getDate()},L:function(){return 1===new Date(f.Y(),1,29).getMonth()?1:0},o:function(){var n=f.n(),W=f.W();return f.Y()+(12===n&&W<9?-1:1===n&&W>9)},Y:function(){return jsdate.getFullYear()},y:function(){return String(f.Y()).slice(-2)},a:function(){return jsdate.getHours()>11?"pm":"am"},A:function(){return f.a().toUpperCase()},B:function(){var unixTime=jsdate.getTime()/1e3,secondsPassedToday=unixTime%86400+3600;secondsPassedToday<0&&(secondsPassedToday+=86400);var beats=secondsPassedToday/86.4%1e3;return unixTime<0?Math.ceil(beats):Math.floor(beats)},g:function(){return f.G()%12||12},G:function(){return jsdate.getHours()},h:function(){return humanize.pad(f.g(),2,"0")},H:function(){return humanize.pad(f.G(),2,"0")},i:function(){return humanize.pad(jsdate.getMinutes(),2,"0")},s:function(){return humanize.pad(jsdate.getSeconds(),2,"0")},u:function(){return humanize.pad(1e3*jsdate.getMilliseconds(),6,"0")},O:function(){var tzo=jsdate.getTimezoneOffset(),tzoNum=Math.abs(tzo);return(tzo>0?"-":"+")+humanize.pad(100*Math.floor(tzoNum/60)+tzoNum%60,4,"0")},P:function(){var O=f.O();return O.substr(0,3)+":"+O.substr(3,2)},Z:function(){return 60*-jsdate.getTimezoneOffset()},c:function(){return"Y-m-d\\TH:i:sP".replace(formatChr,formatChrCb)},r:function(){return"D, d M Y H:i:s O".replace(formatChr,formatChrCb)},U:function(){return jsdate.getTime()/1e3||0}};return format.replace(formatChr,formatChrCb)},humanize.numberFormat=function(number,decimals,decPoint,thousandsSep){decimals=isNaN(decimals)?2:Math.abs(decimals),decPoint=void 0===decPoint?".":decPoint,thousandsSep=void 0===thousandsSep?",":thousandsSep;var sign=number<0?"-":"";number=Math.abs(+number||0);var intPart=parseInt(number.toFixed(decimals),10)+"",j=intPart.length>3?intPart.length%3:0;return sign+(j?intPart.substr(0,j)+thousandsSep:"")+intPart.substr(j).replace(/(\d{3})(?=\d)/g,"$1"+thousandsSep)+(decimals?decPoint+Math.abs(number-intPart).toFixed(decimals).slice(2):"")},humanize.naturalDay=function(timestamp,format){timestamp=void 0===timestamp?humanize.time():timestamp,format=void 0===format?"Y-m-d":format;var d=new Date,today=new Date(d.getFullYear(),d.getMonth(),d.getDate()).getTime()/1e3;return timestamp<today&&timestamp>=today-86400?"yesterday":timestamp>=today&&timestamp<today+86400?"today":timestamp>=today+86400&&timestamp<today+172800?"tomorrow":humanize.date(format,timestamp)},humanize.relativeTime=function(timestamp){timestamp=void 0===timestamp?humanize.time():timestamp;var currTime=humanize.time(),timeDiff=currTime-timestamp;if(timeDiff<2&&timeDiff>-2)return(timeDiff>=0?"just ":"")+"now";if(timeDiff<60&&timeDiff>-60)return timeDiff>=0?Math.floor(timeDiff)+" seconds ago":"in "+Math.floor(-timeDiff)+" seconds";if(timeDiff<120&&timeDiff>-120)return timeDiff>=0?"about a minute ago":"in about a minute";if(timeDiff<3600&&timeDiff>-3600)return timeDiff>=0?Math.floor(timeDiff/60)+" minutes ago":"in "+Math.floor(-timeDiff/60)+" minutes";if(timeDiff<7200&&timeDiff>-7200)return timeDiff>=0?"about an hour ago":"in about an hour";if(timeDiff<86400&&timeDiff>-86400)return timeDiff>=0?Math.floor(timeDiff/3600)+" hours ago":"in "+Math.floor(-timeDiff/3600)+" hours";if(timeDiff<172800&&timeDiff>-172800)return timeDiff>=0?"1 day ago":"in 1 day";if(timeDiff<2505600&&timeDiff>-2505600)return timeDiff>=0?Math.floor(timeDiff/86400)+" days ago":"in "+Math.floor(-timeDiff/86400)+" days";if(timeDiff<5184e3&&timeDiff>-5184e3)return timeDiff>=0?"about a month ago":"in about a month";var currTimeYears=parseInt(humanize.date("Y",currTime),10),timestampYears=parseInt(humanize.date("Y",timestamp),10),currTimeMonths=12*currTimeYears+parseInt(humanize.date("n",currTime),10),timestampMonths=12*timestampYears+parseInt(humanize.date("n",timestamp),10),monthDiff=currTimeMonths-timestampMonths;if(monthDiff<12&&monthDiff>-12)return monthDiff>=0?monthDiff+" months ago":"in "+-monthDiff+" months";var yearDiff=currTimeYears-timestampYears;return yearDiff<2&&yearDiff>-2?yearDiff>=0?"a year ago":"in a year":yearDiff>=0?yearDiff+" years ago":"in "+-yearDiff+" years"},humanize.ordinal=function(number){number=parseInt(number,10),number=isNaN(number)?0:number;var sign=number<0?"-":"";number=Math.abs(number);var tens=number%100;return sign+number+(tens>4&&tens<21?"th":{1:"st",2:"nd",3:"rd"}[number%10]||"th")},humanize.filesize=function(filesize,kilo,decimals,decPoint,thousandsSep,suffixSep){return kilo=void 0===kilo?1024:kilo,filesize<=0?"0 bytes":(filesize<kilo&&void 0===decimals&&(decimals=0),void 0===suffixSep&&(suffixSep=" "),humanize.intword(filesize,["bytes","KB","MB","GB","TB","PB"],kilo,decimals,decPoint,thousandsSep,suffixSep))},humanize.intword=function(number,units,kilo,decimals,decPoint,thousandsSep,suffixSep){var humanized,unit;units=units||["","K","M","B","T"],unit=units.length-1,kilo=kilo||1e3,decimals=isNaN(decimals)?2:Math.abs(decimals),decPoint=decPoint||".",thousandsSep=thousandsSep||",",suffixSep=suffixSep||"";for(var i=0;i<units.length;i++)if(number<Math.pow(kilo,i+1)){unit=i;break}humanized=number/Math.pow(kilo,unit);var suffix=units[unit]?suffixSep+units[unit]:"";return humanize.numberFormat(humanized,decimals,decPoint,thousandsSep)+suffix},humanize.linebreaks=function(str){return str=str.replace(/^([\n|\r]*)/,""),str=str.replace(/([\n|\r]*)$/,""),str=str.replace(/(\r\n|\n|\r)/g,"\n"),str=str.replace(/(\n{2,})/g,"</p><p>"),"<p>"+(str=str.replace(/\n/g,"<br />"))+"</p>"},humanize.nl2br=function(str){return str.replace(/(\r\n|\n|\r)/g,"<br />")},humanize.truncatechars=function(string,length){return string.length<=length?string:string.substr(0,length)+"…"},humanize.truncatewords=function(string,numWords){var words=string.split(" ");return words.length<numWords?string:words.slice(0,numWords).join(" ")+"…"}}).call(this)},{}],17:[function(require,module,exports){(function(process){function dotNotation(obj,is,value){return obj.hasOwnProperty(is)?obj[is]:"string"==typeof is?dotNotation(obj,is.split("."),value):1===is.length&&void 0!==value?obj[is[0]]=value:0===is.length?obj:obj.hasOwnProperty(is[0])?dotNotation(obj[is[0]],is.slice(1),value):obj[is.join(".")]=is.join(".")}/**
 * @author  John Resig <jeresig@gmail.com>
 * @author  Originally by Marcus Spiegel <marcus.spiegel@gmail.com>
 * @link    https://github.com/jeresig/i18n-node
 * @license http://opensource.org/licenses/MIT
 *
 * @version 0.4.7
 */
var vsprintf=require("sprintf").vsprintf,fs=require("fs"),path=require("path"),i18n=module.exports=function(opt){var self=this;this.devMode="production"!==process.env.NODE_ENV;for(var prop in opt)this[prop]=opt[prop];"object"==typeof this.register&&i18n.resMethods.forEach(function(method){self.register[method]=self[method].bind(self)}),opt.locales&&opt.locales.forEach&&(this.locales={},opt.locales.forEach(function(locale){self.readFile(locale)}),this.defaultLocale=opt.locales[0]),this.setLocale(this.defaultLocale),this.locales[this.defaultLocale]||console.error("Not a valid default locale."),this.request&&(this.subdomain&&this.setLocaleFromSubdomain(this.request),!1!==this.query&&this.setLocaleFromQuery(this.request),!1!==this.session&&this.setLocaleFromSessionVar(this.request),this.prefLocale=this.preferredLocale(),!1!==this.prefLocale&&this.prefLocale!==this.locale&&this.setLocale(this.prefLocale))};i18n.version="0.4.7",i18n.localeCache={},i18n.resMethods=["__","__n","getLocale","isPreferredLocale"],i18n.expressBind=function(app,opt){app&&(app.use(function(req,res,next){opt.request=req,req.i18n=new i18n(opt),res.locals&&i18n.registerMethods(res.locals,req),next()}),app.dynamicHelpers&&app.dynamicHelpers(i18n.registerMethods({})))},i18n.registerMethods=function(helpers,req){return i18n.resMethods.forEach(function(method){helpers[method]=req?req.i18n[method].bind(req.i18n):function(req){return req.i18n[method].bind(req.i18n)}}),helpers},i18n.prototype={defaultLocale:"en",extension:".js",directory:"./locales",cookieName:"lang",sessionVarName:"locale",indent:"\t",parse:JSON.parse,dump:function(data,indent){return JSON.stringify(data,null,indent)},__:function(){var msg=this.translate(this.locale,arguments[0]);return arguments.length>1&&(msg=vsprintf(msg,Array.prototype.slice.call(arguments,1))),msg},__n:function(pathOrSingular,countOrPlural,additionalOrCount){var msg;if("number"==typeof countOrPlural){var path=pathOrSingular,count=countOrPlural;msg=this.translate(this.locale,path),msg=vsprintf(parseInt(count,10)>1?msg.other:msg.one,Array.prototype.slice.call(arguments,1))}else{var singular=pathOrSingular,plural=countOrPlural,count=additionalOrCount;msg=this.translate(this.locale,singular,plural),msg=vsprintf(parseInt(count,10)>1?msg.other:msg.one,[count]),arguments.length>3&&(msg=vsprintf(msg,Array.prototype.slice.call(arguments,3)))}return msg},setLocale:function(locale){if(locale)return this.locales[locale]||(this.devMode&&console.warn("Locale ("+locale+") not found."),locale=this.defaultLocale),this.locale=locale},getLocale:function(){return this.locale},isPreferredLocale:function(){return!this.prefLocale||this.prefLocale===this.getLocale()},setLocaleFromSessionVar:function(req){if((req=req||this.request)&&req.session&&req.session[this.sessionVarName]){var locale=req.session[this.sessionVarName];this.locales[locale]&&(this.devMode&&console.log("Overriding locale from query: "+locale),this.setLocale(locale))}},setLocaleFromQuery:function(req){if((req=req||this.request)&&req.query&&req.query.lang){var locale=(req.query.lang+"").toLowerCase();this.locales[locale]&&(this.devMode&&console.log("Overriding locale from query: "+locale),this.setLocale(locale))}},setLocaleFromSubdomain:function(req){(req=req||this.request)&&req.headers&&req.headers.host&&/^([^.]+)/.test(req.headers.host)&&this.locales[RegExp.$1]&&(this.devMode&&console.log("Overriding locale from host: "+RegExp.$1),this.setLocale(RegExp.$1))},setLocaleFromCookie:function(req){if((req=req||this.request)&&req.cookies&&this.cookieName&&req.cookies[this.cookieName]){var locale=req.cookies[this.cookieName].toLowerCase();this.locales[locale]&&(this.devMode&&console.log("Overriding locale from cookie: "+locale),this.setLocale(locale))}},setLocaleFromEnvironmentVariable:function(){if(process.env.LANG){var locale=process.env.LANG.split("_")[0];this.locales[locale]&&(this.devMode&&console.log("Overriding locale from environment variable: "+locale),this.setLocale(locale))}},preferredLocale:function(req){if((req=req||this.request)&&req.headers){for(var prefLocale,accept=req.headers["accept-language"]||"",regExp=/(^|,\s*)([a-z0-9-]+)/gi,self=this;!prefLocale&&(match=regExp.exec(accept));){var locale=match[2].toLowerCase(),parts=locale.split("-");self.locales[locale]?prefLocale=locale:parts.length>1&&self.locales[parts[0]]&&(prefLocale=parts[0])}return prefLocale||this.defaultLocale}},translate:function(locale,singular,plural){return locale&&this.locales[locale]||(this.devMode&&console.warn("WARN: No locale found. Using the default ("+this.defaultLocale+") as current locale"),locale=this.defaultLocale,this.initLocale(locale,{})),this.locales[locale][singular]||this.devMode&&(dotNotation(this.locales[locale],singular,plural?{one:singular,other:plural}:void 0),this.writeFile(locale)),dotNotation(this.locales[locale],singular,plural?{one:singular,other:plural}:void 0)},readFile:function(locale){var file=this.locateFile(locale);if(!this.devMode&&i18n.localeCache[file])return void this.initLocale(locale,i18n.localeCache[file]);try{var base,localeFile=fs.readFileSync(file);if("function"==typeof this.base){var baseFilename;try{baseFilename=this.base(locale)}catch(e){console.error("base function threw exception for locale %s",locale,e)}if("string"==typeof baseFilename)try{base=this.parse(fs.readFileSync(this.locateFile(baseFilename)))}catch(e){console.error("unable to read or parse base file %s for locale %s",baseFilename,locale,e)}}try{var content=this.parse(localeFile);if(base){for(var prop in content)base[prop]=content[prop];content=base}this.initLocale(locale,content)}catch(e){console.error("unable to parse locales from file (maybe "+file+" is empty or invalid "+this.extension+"?): ",e)}}catch(e){fs.existsSync(file)||this.writeFile(locale)}},writeFile:function(locale){if(!this.devMode)return void this.initLocale(locale,{});try{fs.lstatSync(this.directory)}catch(e){this.devMode&&console.log("creating locales dir in: "+this.directory),fs.mkdirSync(this.directory,493)}this.initLocale(locale,{});try{var target=this.locateFile(locale),tmp=target+".tmp";fs.writeFileSync(tmp,this.dump(this.locales[locale],this.indent),"utf8"),fs.statSync(tmp).isFile()?fs.renameSync(tmp,target):console.error("unable to write locales to file (either "+tmp+" or "+target+" are not writeable?): ")}catch(e){console.error("unexpected error writing files (either "+tmp+" or "+target+" are not writeable?): ",e)}},locateFile:function(locale){return path.normalize(this.directory+"/"+locale+this.extension)},initLocale:function(locale,data){if(!this.locales[locale]&&(this.locales[locale]=data,!this.devMode)){var file=this.locateFile(locale);i18n.localeCache[file]||(i18n.localeCache[file]=data)}}}}).call(this,require("_process"))},{_process:20,fs:1,path:19,sprintf:21}],18:[function(require,module,exports){module.exports=require("./i18n")},{"./i18n":17}],19:[function(require,module,exports){(function(process){function normalizeArray(parts,allowAboveRoot){for(var up=0,i=parts.length-1;i>=0;i--){var last=parts[i];"."===last?parts.splice(i,1):".."===last?(parts.splice(i,1),up++):up&&(parts.splice(i,1),up--)}if(allowAboveRoot)for(;up--;up)parts.unshift("..");return parts}function filter(xs,f){if(xs.filter)return xs.filter(f);for(var res=[],i=0;i<xs.length;i++)f(xs[i],i,xs)&&res.push(xs[i]);return res}var splitPathRe=/^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/,splitPath=function(filename){return splitPathRe.exec(filename).slice(1)};exports.resolve=function(){for(var resolvedPath="",resolvedAbsolute=!1,i=arguments.length-1;i>=-1&&!resolvedAbsolute;i--){var path=i>=0?arguments[i]:process.cwd();if("string"!=typeof path)throw new TypeError("Arguments to path.resolve must be strings");path&&(resolvedPath=path+"/"+resolvedPath,resolvedAbsolute="/"===path.charAt(0))}return resolvedPath=normalizeArray(filter(resolvedPath.split("/"),function(p){return!!p}),!resolvedAbsolute).join("/"),(resolvedAbsolute?"/":"")+resolvedPath||"."},exports.normalize=function(path){var isAbsolute=exports.isAbsolute(path),trailingSlash="/"===substr(path,-1);return path=normalizeArray(filter(path.split("/"),function(p){return!!p}),!isAbsolute).join("/"),path||isAbsolute||(path="."),path&&trailingSlash&&(path+="/"),(isAbsolute?"/":"")+path},exports.isAbsolute=function(path){return"/"===path.charAt(0)},exports.join=function(){var paths=Array.prototype.slice.call(arguments,0);return exports.normalize(filter(paths,function(p,index){if("string"!=typeof p)throw new TypeError("Arguments to path.join must be strings");return p}).join("/"))},exports.relative=function(from,to){function trim(arr){for(var start=0;start<arr.length&&""===arr[start];start++);for(var end=arr.length-1;end>=0&&""===arr[end];end--);return start>end?[]:arr.slice(start,end-start+1)}from=exports.resolve(from).substr(1),to=exports.resolve(to).substr(1);for(var fromParts=trim(from.split("/")),toParts=trim(to.split("/")),length=Math.min(fromParts.length,toParts.length),samePartsLength=length,i=0;i<length;i++)if(fromParts[i]!==toParts[i]){samePartsLength=i;break}for(var outputParts=[],i=samePartsLength;i<fromParts.length;i++)outputParts.push("..");return outputParts=outputParts.concat(toParts.slice(samePartsLength)),outputParts.join("/")},exports.sep="/",exports.delimiter=":",exports.dirname=function(path){var result=splitPath(path),root=result[0],dir=result[1];return root||dir?(dir&&(dir=dir.substr(0,dir.length-1)),root+dir):"."},exports.basename=function(path,ext){var f=splitPath(path)[2];return ext&&f.substr(-1*ext.length)===ext&&(f=f.substr(0,f.length-ext.length)),f},exports.extname=function(path){return splitPath(path)[3]};var substr="b"==="ab".substr(-1)?function(str,start,len){return str.substr(start,len)}:function(str,start,len){return start<0&&(start=str.length+start),str.substr(start,len)}}).call(this,require("_process"))},{_process:20}],20:[function(require,module,exports){function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}function runTimeout(fun){if(cachedSetTimeout===setTimeout)return setTimeout(fun,0);if((cachedSetTimeout===defaultSetTimout||!cachedSetTimeout)&&setTimeout)return cachedSetTimeout=setTimeout,setTimeout(fun,0);try{return cachedSetTimeout(fun,0)}catch(e){try{return cachedSetTimeout.call(null,fun,0)}catch(e){return cachedSetTimeout.call(this,fun,0)}}}function runClearTimeout(marker){if(cachedClearTimeout===clearTimeout)return clearTimeout(marker);if((cachedClearTimeout===defaultClearTimeout||!cachedClearTimeout)&&clearTimeout)return cachedClearTimeout=clearTimeout,clearTimeout(marker);try{return cachedClearTimeout(marker)}catch(e){try{return cachedClearTimeout.call(null,marker)}catch(e){return cachedClearTimeout.call(this,marker)}}}function cleanUpNextTick(){draining&&currentQueue&&(draining=!1,currentQueue.length?queue=currentQueue.concat(queue):queueIndex=-1,queue.length&&drainQueue())}function drainQueue(){if(!draining){var timeout=runTimeout(cleanUpNextTick);draining=!0;for(var len=queue.length;len;){for(currentQueue=queue,queue=[];++queueIndex<len;)currentQueue&&currentQueue[queueIndex].run();queueIndex=-1,len=queue.length}currentQueue=null,draining=!1,runClearTimeout(timeout)}}function Item(fun,array){this.fun=fun,this.array=array}function noop(){}var cachedSetTimeout,cachedClearTimeout,process=module.exports={};!function(){try{cachedSetTimeout="function"==typeof setTimeout?setTimeout:defaultSetTimout}catch(e){cachedSetTimeout=defaultSetTimout}try{cachedClearTimeout="function"==typeof clearTimeout?clearTimeout:defaultClearTimeout}catch(e){cachedClearTimeout=defaultClearTimeout}}();var currentQueue,queue=[],draining=!1,queueIndex=-1;process.nextTick=function(fun){var args=new Array(arguments.length-1);if(arguments.length>1)for(var i=1;i<arguments.length;i++)args[i-1]=arguments[i];queue.push(new Item(fun,args)),1!==queue.length||draining||runTimeout(drainQueue)},Item.prototype.run=function(){this.fun.apply(null,this.array)},process.title="browser",process.browser=!0,process.env={},process.argv=[],process.version="",process.versions={},process.on=noop,process.addListener=noop,process.once=noop,process.off=noop,process.removeListener=noop,process.removeAllListeners=noop,process.emit=noop,process.binding=function(name){throw new Error("process.binding is not supported")},process.cwd=function(){return"/"},process.chdir=function(dir){throw new Error("process.chdir is not supported")},process.umask=function(){return 0}},{}],21:[function(require,module,exports){var sprintf=function(){function get_type(variable){return Object.prototype.toString.call(variable).slice(8,-1).toLowerCase()}function str_repeat(input,multiplier){for(var output=[];multiplier>0;output[--multiplier]=input);return output.join("")}var str_format=function(){return str_format.cache.hasOwnProperty(arguments[0])||(str_format.cache[arguments[0]]=str_format.parse(arguments[0])),str_format.format.call(null,str_format.cache[arguments[0]],arguments)};return str_format.object_stringify=function(obj,depth,maxdepth,seen){var str="";if(null!=obj)switch(typeof obj){case"function":return"[Function"+(obj.name?": "+obj.name:"")+"]";case"object":if(obj instanceof Error)return"["+obj.toString()+"]";if(depth>=maxdepth)return"[Object]";if(seen&&(seen=seen.slice(0),seen.push(obj)),null!=obj.length){str+="[";var arr=[];for(var i in obj)seen&&seen.indexOf(obj[i])>=0?arr.push("[Circular]"):arr.push(str_format.object_stringify(obj[i],depth+1,maxdepth,seen));str+=arr.join(", ")+"]"}else{if("getMonth"in obj)return"Date("+obj+")";str+="{";var arr=[];for(var k in obj)obj.hasOwnProperty(k)&&(seen&&seen.indexOf(obj[k])>=0?arr.push(k+": [Circular]"):arr.push(k+": "+str_format.object_stringify(obj[k],depth+1,maxdepth,seen)));str+=arr.join(", ")+"}"}return str;case"string":return'"'+obj+'"'}return""+obj},str_format.format=function(parse_tree,argv){var arg,i,k,match,pad,pad_character,pad_length,cursor=1,tree_length=parse_tree.length,node_type="",output=[];for(i=0;i<tree_length;i++)if("string"===(node_type=get_type(parse_tree[i])))output.push(parse_tree[i]);else if("array"===node_type){if(match=parse_tree[i],match[2])for(arg=argv[cursor],k=0;k<match[2].length;k++){if(!arg.hasOwnProperty(match[2][k]))throw new Error(sprintf('[sprintf] property "%s" does not exist',match[2][k]));arg=arg[match[2][k]]}else arg=match[1]?argv[match[1]]:argv[cursor++];if(/[^sO]/.test(match[8])&&"number"!=get_type(arg))throw new Error(sprintf('[sprintf] expecting number but found %s "'+arg+'"',get_type(arg)));switch(match[8]){case"b":arg=arg.toString(2);break;case"c":arg=String.fromCharCode(arg);break;case"d":arg=parseInt(arg,10);break;case"e":arg=match[7]?arg.toExponential(match[7]):arg.toExponential();break;case"f":arg=match[7]?parseFloat(arg).toFixed(match[7]):parseFloat(arg);break;case"O":arg=str_format.object_stringify(arg,0,parseInt(match[7])||5);break;case"o":arg=arg.toString(8);break;case"s":arg=(arg=String(arg))&&match[7]?arg.substring(0,match[7]):arg;break;case"u":arg=Math.abs(arg);break;case"x":arg=arg.toString(16);break;case"X":arg=arg.toString(16).toUpperCase()}arg=/[def]/.test(match[8])&&match[3]&&arg>=0?"+"+arg:arg,pad_character=match[4]?"0"==match[4]?"0":match[4].charAt(1):" ",pad_length=match[6]-String(arg).length,pad=match[6]?str_repeat(pad_character,pad_length):"",output.push(match[5]?arg+pad:pad+arg)}return output.join("")},str_format.cache={},str_format.parse=function(fmt){for(var _fmt=fmt,match=[],parse_tree=[],arg_names=0;_fmt;){if(null!==(match=/^[^\x25]+/.exec(_fmt)))parse_tree.push(match[0]);else if(null!==(match=/^\x25{2}/.exec(_fmt)))parse_tree.push("%");else{if(null===(match=/^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-fosOuxX])/.exec(_fmt)))throw new Error("[sprintf] "+_fmt);if(match[2]){arg_names|=1;var field_list=[],replacement_field=match[2],field_match=[];if(null===(field_match=/^([a-z_][a-z_\d]*)/i.exec(replacement_field)))throw new Error("[sprintf] "+replacement_field);for(field_list.push(field_match[1]);""!==(replacement_field=replacement_field.substring(field_match[0].length));)if(null!==(field_match=/^\.([a-z_][a-z_\d]*)/i.exec(replacement_field)))field_list.push(field_match[1]);else{if(null===(field_match=/^\[(\d+)\]/.exec(replacement_field)))throw new Error("[sprintf] "+replacement_field);field_list.push(field_match[1])}match[2]=field_list}else arg_names|=2;if(3===arg_names)throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");parse_tree.push(match)}_fmt=_fmt.substring(match[0].length)}return parse_tree},str_format}(),vsprintf=function(fmt,argv){var argvClone=argv.slice();return argvClone.unshift(fmt),sprintf.apply(null,argvClone)};module.exports=sprintf,sprintf.sprintf=sprintf,sprintf.vsprintf=vsprintf},{}],22:[function(require,module,exports){(function(){function createReduce(dir){function iterator(obj,iteratee,memo,keys,index,length){for(;index>=0&&index<length;index+=dir){var currentKey=keys?keys[index]:index;memo=iteratee(memo,obj[currentKey],currentKey,obj)}return memo}return function(obj,iteratee,memo,context){iteratee=optimizeCb(iteratee,context,4);var keys=!isArrayLike(obj)&&_.keys(obj),length=(keys||obj).length,index=dir>0?0:length-1;return arguments.length<3&&(memo=obj[keys?keys[index]:index],index+=dir),iterator(obj,iteratee,memo,keys,index,length)}}function createPredicateIndexFinder(dir){return function(array,predicate,context){predicate=cb(predicate,context);for(var length=getLength(array),index=dir>0?0:length-1;index>=0&&index<length;index+=dir)if(predicate(array[index],index,array))return index;return-1}}function createIndexFinder(dir,predicateFind,sortedIndex){return function(array,item,idx){var i=0,length=getLength(array);if("number"==typeof idx)dir>0?i=idx>=0?idx:Math.max(idx+length,i):length=idx>=0?Math.min(idx+1,length):idx+length+1;else if(sortedIndex&&idx&&length)return idx=sortedIndex(array,item),array[idx]===item?idx:-1;if(item!==item)return idx=predicateFind(slice.call(array,i,length),_.isNaN),idx>=0?idx+i:-1;for(idx=dir>0?i:length-1;idx>=0&&idx<length;idx+=dir)if(array[idx]===item)return idx;return-1}}function collectNonEnumProps(obj,keys){var nonEnumIdx=nonEnumerableProps.length,constructor=obj.constructor,proto=_.isFunction(constructor)&&constructor.prototype||ObjProto,prop="constructor";for(_.has(obj,prop)&&!_.contains(keys,prop)&&keys.push(prop);nonEnumIdx--;)(prop=nonEnumerableProps[nonEnumIdx])in obj&&obj[prop]!==proto[prop]&&!_.contains(keys,prop)&&keys.push(prop)}var root=this,previousUnderscore=root._,ArrayProto=Array.prototype,ObjProto=Object.prototype,FuncProto=Function.prototype,push=ArrayProto.push,slice=ArrayProto.slice,toString=ObjProto.toString,hasOwnProperty=ObjProto.hasOwnProperty,nativeIsArray=Array.isArray,nativeKeys=Object.keys,nativeBind=FuncProto.bind,nativeCreate=Object.create,Ctor=function(){},_=function(obj){return obj instanceof _?obj:this instanceof _?void(this._wrapped=obj):new _(obj)};void 0!==exports?(void 0!==module&&module.exports&&(exports=module.exports=_),exports._=_):root._=_,_.VERSION="1.8.3";var optimizeCb=function(func,context,argCount){if(void 0===context)return func;switch(null==argCount?3:argCount){case 1:return function(value){return func.call(context,value)};case 2:return function(value,other){return func.call(context,value,other)};case 3:return function(value,index,collection){return func.call(context,value,index,collection)};case 4:return function(accumulator,value,index,collection){return func.call(context,accumulator,value,index,collection)}}return function(){return func.apply(context,arguments)}},cb=function(value,context,argCount){return null==value?_.identity:_.isFunction(value)?optimizeCb(value,context,argCount):_.isObject(value)?_.matcher(value):_.property(value)};_.iteratee=function(value,context){return cb(value,context,1/0)};var createAssigner=function(keysFunc,undefinedOnly){return function(obj){var length=arguments.length;if(length<2||null==obj)return obj;for(var index=1;index<length;index++)for(var source=arguments[index],keys=keysFunc(source),l=keys.length,i=0;i<l;i++){var key=keys[i];undefinedOnly&&void 0!==obj[key]||(obj[key]=source[key])}return obj}},baseCreate=function(prototype){if(!_.isObject(prototype))return{};if(nativeCreate)return nativeCreate(prototype);Ctor.prototype=prototype;var result=new Ctor;return Ctor.prototype=null,result},property=function(key){return function(obj){return null==obj?void 0:obj[key]}},MAX_ARRAY_INDEX=Math.pow(2,53)-1,getLength=property("length"),isArrayLike=function(collection){var length=getLength(collection);return"number"==typeof length&&length>=0&&length<=MAX_ARRAY_INDEX};_.each=_.forEach=function(obj,iteratee,context){iteratee=optimizeCb(iteratee,context);var i,length;if(isArrayLike(obj))for(i=0,length=obj.length;i<length;i++)iteratee(obj[i],i,obj);else{var keys=_.keys(obj);for(i=0,length=keys.length;i<length;i++)iteratee(obj[keys[i]],keys[i],obj)}return obj},_.map=_.collect=function(obj,iteratee,context){iteratee=cb(iteratee,context);for(var keys=!isArrayLike(obj)&&_.keys(obj),length=(keys||obj).length,results=Array(length),index=0;index<length;index++){var currentKey=keys?keys[index]:index;results[index]=iteratee(obj[currentKey],currentKey,obj)}return results},_.reduce=_.foldl=_.inject=createReduce(1),_.reduceRight=_.foldr=createReduce(-1),_.find=_.detect=function(obj,predicate,context){var key;if(void 0!==(key=isArrayLike(obj)?_.findIndex(obj,predicate,context):_.findKey(obj,predicate,context))&&-1!==key)return obj[key]},_.filter=_.select=function(obj,predicate,context){var results=[];return predicate=cb(predicate,context),_.each(obj,function(value,index,list){predicate(value,index,list)&&results.push(value)}),results},_.reject=function(obj,predicate,context){return _.filter(obj,_.negate(cb(predicate)),context)},_.every=_.all=function(obj,predicate,context){predicate=cb(predicate,context);for(var keys=!isArrayLike(obj)&&_.keys(obj),length=(keys||obj).length,index=0;index<length;index++){var currentKey=keys?keys[index]:index;if(!predicate(obj[currentKey],currentKey,obj))return!1}return!0},_.some=_.any=function(obj,predicate,context){predicate=cb(predicate,context);for(var keys=!isArrayLike(obj)&&_.keys(obj),length=(keys||obj).length,index=0;index<length;index++){var currentKey=keys?keys[index]:index;if(predicate(obj[currentKey],currentKey,obj))return!0}return!1},_.contains=_.includes=_.include=function(obj,item,fromIndex,guard){return isArrayLike(obj)||(obj=_.values(obj)),("number"!=typeof fromIndex||guard)&&(fromIndex=0),_.indexOf(obj,item,fromIndex)>=0},_.invoke=function(obj,method){var args=slice.call(arguments,2),isFunc=_.isFunction(method);return _.map(obj,function(value){var func=isFunc?method:value[method];return null==func?func:func.apply(value,args)})},_.pluck=function(obj,key){return _.map(obj,_.property(key))},_.where=function(obj,attrs){return _.filter(obj,_.matcher(attrs))},_.findWhere=function(obj,attrs){return _.find(obj,_.matcher(attrs))},_.max=function(obj,iteratee,context){var value,computed,result=-1/0,lastComputed=-1/0;if(null==iteratee&&null!=obj){obj=isArrayLike(obj)?obj:_.values(obj);for(var i=0,length=obj.length;i<length;i++)(value=obj[i])>result&&(result=value)}else iteratee=cb(iteratee,context),_.each(obj,function(value,index,list){((computed=iteratee(value,index,list))>lastComputed||computed===-1/0&&result===-1/0)&&(result=value,lastComputed=computed)});return result},_.min=function(obj,iteratee,context){var value,computed,result=1/0,lastComputed=1/0;if(null==iteratee&&null!=obj){obj=isArrayLike(obj)?obj:_.values(obj);for(var i=0,length=obj.length;i<length;i++)(value=obj[i])<result&&(result=value)}else iteratee=cb(iteratee,context),_.each(obj,function(value,index,list){((computed=iteratee(value,index,list))<lastComputed||computed===1/0&&result===1/0)&&(result=value,lastComputed=computed)});return result},_.shuffle=function(obj){for(var rand,set=isArrayLike(obj)?obj:_.values(obj),length=set.length,shuffled=Array(length),index=0;index<length;index++)rand=_.random(0,index),rand!==index&&(shuffled[index]=shuffled[rand]),shuffled[rand]=set[index];return shuffled},_.sample=function(obj,n,guard){return null==n||guard?(isArrayLike(obj)||(obj=_.values(obj)),obj[_.random(obj.length-1)]):_.shuffle(obj).slice(0,Math.max(0,n))},_.sortBy=function(obj,iteratee,context){return iteratee=cb(iteratee,context),_.pluck(_.map(obj,function(value,index,list){return{value:value,index:index,criteria:iteratee(value,index,list)}}).sort(function(left,right){var a=left.criteria,b=right.criteria;if(a!==b){if(a>b||void 0===a)return 1;if(a<b||void 0===b)return-1}return left.index-right.index}),"value")};var group=function(behavior){return function(obj,iteratee,context){var result={};return iteratee=cb(iteratee,context),_.each(obj,function(value,index){var key=iteratee(value,index,obj);behavior(result,value,key)}),result}};_.groupBy=group(function(result,value,key){_.has(result,key)?result[key].push(value):result[key]=[value]}),_.indexBy=group(function(result,value,key){result[key]=value}),_.countBy=group(function(result,value,key){_.has(result,key)?result[key]++:result[key]=1}),_.toArray=function(obj){return obj?_.isArray(obj)?slice.call(obj):isArrayLike(obj)?_.map(obj,_.identity):_.values(obj):[]},_.size=function(obj){return null==obj?0:isArrayLike(obj)?obj.length:_.keys(obj).length},_.partition=function(obj,predicate,context){predicate=cb(predicate,context);var pass=[],fail=[];return _.each(obj,function(value,key,obj){(predicate(value,key,obj)?pass:fail).push(value)}),[pass,fail]},_.first=_.head=_.take=function(array,n,guard){if(null!=array)return null==n||guard?array[0]:_.initial(array,array.length-n)},_.initial=function(array,n,guard){return slice.call(array,0,Math.max(0,array.length-(null==n||guard?1:n)))},_.last=function(array,n,guard){if(null!=array)return null==n||guard?array[array.length-1]:_.rest(array,Math.max(0,array.length-n))},_.rest=_.tail=_.drop=function(array,n,guard){return slice.call(array,null==n||guard?1:n)},_.compact=function(array){return _.filter(array,_.identity)};var flatten=function(input,shallow,strict,startIndex){for(var output=[],idx=0,i=startIndex||0,length=getLength(input);i<length;i++){var value=input[i];if(isArrayLike(value)&&(_.isArray(value)||_.isArguments(value))){shallow||(value=flatten(value,shallow,strict));var j=0,len=value.length;for(output.length+=len;j<len;)output[idx++]=value[j++]}else strict||(output[idx++]=value)}return output};_.flatten=function(array,shallow){return flatten(array,shallow,!1)},_.without=function(array){return _.difference(array,slice.call(arguments,1))},_.uniq=_.unique=function(array,isSorted,iteratee,context){_.isBoolean(isSorted)||(context=iteratee,iteratee=isSorted,isSorted=!1),null!=iteratee&&(iteratee=cb(iteratee,context));for(var result=[],seen=[],i=0,length=getLength(array);i<length;i++){var value=array[i],computed=iteratee?iteratee(value,i,array):value;isSorted?(i&&seen===computed||result.push(value),seen=computed):iteratee?_.contains(seen,computed)||(seen.push(computed),result.push(value)):_.contains(result,value)||result.push(value)}return result},_.union=function(){return _.uniq(flatten(arguments,!0,!0))},_.intersection=function(array){for(var result=[],argsLength=arguments.length,i=0,length=getLength(array);i<length;i++){var item=array[i];if(!_.contains(result,item)){for(var j=1;j<argsLength&&_.contains(arguments[j],item);j++);j===argsLength&&result.push(item)}}return result},_.difference=function(array){var rest=flatten(arguments,!0,!0,1);return _.filter(array,function(value){return!_.contains(rest,value)})},_.zip=function(){return _.unzip(arguments)},_.unzip=function(array){for(var length=array&&_.max(array,getLength).length||0,result=Array(length),index=0;index<length;index++)result[index]=_.pluck(array,index);return result},_.object=function(list,values){for(var result={},i=0,length=getLength(list);i<length;i++)values?result[list[i]]=values[i]:result[list[i][0]]=list[i][1];return result},_.findIndex=createPredicateIndexFinder(1),_.findLastIndex=createPredicateIndexFinder(-1),_.sortedIndex=function(array,obj,iteratee,context){iteratee=cb(iteratee,context,1);for(var value=iteratee(obj),low=0,high=getLength(array);low<high;){var mid=Math.floor((low+high)/2);iteratee(array[mid])<value?low=mid+1:high=mid}return low},_.indexOf=createIndexFinder(1,_.findIndex,_.sortedIndex),_.lastIndexOf=createIndexFinder(-1,_.findLastIndex),_.range=function(start,stop,step){null==stop&&(stop=start||0,start=0),step=step||1;for(var length=Math.max(Math.ceil((stop-start)/step),0),range=Array(length),idx=0;idx<length;idx++,start+=step)range[idx]=start;return range};var executeBound=function(sourceFunc,boundFunc,context,callingContext,args){if(!(callingContext instanceof boundFunc))return sourceFunc.apply(context,args);var self=baseCreate(sourceFunc.prototype),result=sourceFunc.apply(self,args);return _.isObject(result)?result:self};_.bind=function(func,context){if(nativeBind&&func.bind===nativeBind)return nativeBind.apply(func,slice.call(arguments,1));if(!_.isFunction(func))throw new TypeError("Bind must be called on a function");var args=slice.call(arguments,2),bound=function(){return executeBound(func,bound,context,this,args.concat(slice.call(arguments)))};return bound},_.partial=function(func){var boundArgs=slice.call(arguments,1),bound=function(){for(var position=0,length=boundArgs.length,args=Array(length),i=0;i<length;i++)args[i]=boundArgs[i]===_?arguments[position++]:boundArgs[i];for(;position<arguments.length;)args.push(arguments[position++]);return executeBound(func,bound,this,this,args)};return bound},_.bindAll=function(obj){var i,key,length=arguments.length;if(length<=1)throw new Error("bindAll must be passed function names");for(i=1;i<length;i++)key=arguments[i],obj[key]=_.bind(obj[key],obj);return obj},_.memoize=function(func,hasher){var memoize=function(key){var cache=memoize.cache,address=""+(hasher?hasher.apply(this,arguments):key);return _.has(cache,address)||(cache[address]=func.apply(this,arguments)),cache[address]};return memoize.cache={},memoize},_.delay=function(func,wait){var args=slice.call(arguments,2);return setTimeout(function(){return func.apply(null,args)},wait)},_.defer=_.partial(_.delay,_,1),_.throttle=function(func,wait,options){var context,args,result,timeout=null,previous=0;options||(options={});var later=function(){previous=!1===options.leading?0:_.now(),timeout=null,result=func.apply(context,args),timeout||(context=args=null)};return function(){var now=_.now();previous||!1!==options.leading||(previous=now);var remaining=wait-(now-previous);return context=this,args=arguments,remaining<=0||remaining>wait?(timeout&&(clearTimeout(timeout),timeout=null),previous=now,result=func.apply(context,args),timeout||(context=args=null)):timeout||!1===options.trailing||(timeout=setTimeout(later,remaining)),result}},_.debounce=function(func,wait,immediate){var timeout,args,context,timestamp,result,later=function(){var last=_.now()-timestamp;last<wait&&last>=0?timeout=setTimeout(later,wait-last):(timeout=null,immediate||(result=func.apply(context,args),timeout||(context=args=null)))};return function(){context=this,args=arguments,timestamp=_.now();var callNow=immediate&&!timeout;return timeout||(timeout=setTimeout(later,wait)),callNow&&(result=func.apply(context,args),context=args=null),result}},_.wrap=function(func,wrapper){return _.partial(wrapper,func)},_.negate=function(predicate){return function(){return!predicate.apply(this,arguments)}},_.compose=function(){var args=arguments,start=args.length-1;return function(){for(var i=start,result=args[start].apply(this,arguments);i--;)result=args[i].call(this,result);return result}},_.after=function(times,func){return function(){if(--times<1)return func.apply(this,arguments)}},_.before=function(times,func){var memo;return function(){return--times>0&&(memo=func.apply(this,arguments)),times<=1&&(func=null),memo}},_.once=_.partial(_.before,2);var hasEnumBug=!{toString:null}.propertyIsEnumerable("toString"),nonEnumerableProps=["valueOf","isPrototypeOf","toString","propertyIsEnumerable","hasOwnProperty","toLocaleString"];_.keys=function(obj){if(!_.isObject(obj))return[];if(nativeKeys)return nativeKeys(obj);var keys=[];for(var key in obj)_.has(obj,key)&&keys.push(key);return hasEnumBug&&collectNonEnumProps(obj,keys),keys},_.allKeys=function(obj){if(!_.isObject(obj))return[];var keys=[];for(var key in obj)keys.push(key);return hasEnumBug&&collectNonEnumProps(obj,keys),keys},_.values=function(obj){for(var keys=_.keys(obj),length=keys.length,values=Array(length),i=0;i<length;i++)values[i]=obj[keys[i]];return values},_.mapObject=function(obj,iteratee,context){iteratee=cb(iteratee,context);for(var currentKey,keys=_.keys(obj),length=keys.length,results={},index=0;index<length;index++)currentKey=keys[index],results[currentKey]=iteratee(obj[currentKey],currentKey,obj);return results},_.pairs=function(obj){for(var keys=_.keys(obj),length=keys.length,pairs=Array(length),i=0;i<length;i++)pairs[i]=[keys[i],obj[keys[i]]];return pairs},_.invert=function(obj){for(var result={},keys=_.keys(obj),i=0,length=keys.length;i<length;i++)result[obj[keys[i]]]=keys[i];return result},_.functions=_.methods=function(obj){var names=[];for(var key in obj)_.isFunction(obj[key])&&names.push(key);return names.sort()},_.extend=createAssigner(_.allKeys),_.extendOwn=_.assign=createAssigner(_.keys),_.findKey=function(obj,predicate,context){predicate=cb(predicate,context);for(var key,keys=_.keys(obj),i=0,length=keys.length;i<length;i++)if(key=keys[i],predicate(obj[key],key,obj))return key},_.pick=function(object,oiteratee,context){var iteratee,keys,result={},obj=object;if(null==obj)return result;_.isFunction(oiteratee)?(keys=_.allKeys(obj),iteratee=optimizeCb(oiteratee,context)):(keys=flatten(arguments,!1,!1,1),iteratee=function(value,key,obj){return key in obj},obj=Object(obj));for(var i=0,length=keys.length;i<length;i++){var key=keys[i],value=obj[key];iteratee(value,key,obj)&&(result[key]=value)}return result},_.omit=function(obj,iteratee,context){if(_.isFunction(iteratee))iteratee=_.negate(iteratee);else{var keys=_.map(flatten(arguments,!1,!1,1),String);iteratee=function(value,key){return!_.contains(keys,key)}}return _.pick(obj,iteratee,context)},_.defaults=createAssigner(_.allKeys,!0),_.create=function(prototype,props){var result=baseCreate(prototype);return props&&_.extendOwn(result,props),result},_.clone=function(obj){return _.isObject(obj)?_.isArray(obj)?obj.slice():_.extend({},obj):obj},_.tap=function(obj,interceptor){return interceptor(obj),obj},_.isMatch=function(object,attrs){var keys=_.keys(attrs),length=keys.length;if(null==object)return!length;for(var obj=Object(object),i=0;i<length;i++){var key=keys[i];if(attrs[key]!==obj[key]||!(key in obj))return!1}return!0};var eq=function(a,b,aStack,bStack){if(a===b)return 0!==a||1/a==1/b;if(null==a||null==b)return a===b;a instanceof _&&(a=a._wrapped),b instanceof _&&(b=b._wrapped);var className=toString.call(a);if(className!==toString.call(b))return!1;switch(className){case"[object RegExp]":case"[object String]":return""+a==""+b;case"[object Number]":return+a!=+a?+b!=+b:0==+a?1/+a==1/b:+a==+b;case"[object Date]":case"[object Boolean]":return+a==+b}var areArrays="[object Array]"===className;if(!areArrays){if("object"!=typeof a||"object"!=typeof b)return!1;var aCtor=a.constructor,bCtor=b.constructor;if(aCtor!==bCtor&&!(_.isFunction(aCtor)&&aCtor instanceof aCtor&&_.isFunction(bCtor)&&bCtor instanceof bCtor)&&"constructor"in a&&"constructor"in b)return!1}aStack=aStack||[],bStack=bStack||[];for(var length=aStack.length;length--;)if(aStack[length]===a)return bStack[length]===b;if(aStack.push(a),bStack.push(b),areArrays){if((length=a.length)!==b.length)return!1;for(;length--;)if(!eq(a[length],b[length],aStack,bStack))return!1}else{var key,keys=_.keys(a);if(length=keys.length,_.keys(b).length!==length)return!1;for(;length--;)if(key=keys[length],!_.has(b,key)||!eq(a[key],b[key],aStack,bStack))return!1}return aStack.pop(),bStack.pop(),!0};_.isEqual=function(a,b){return eq(a,b)},_.isEmpty=function(obj){return null==obj||(isArrayLike(obj)&&(_.isArray(obj)||_.isString(obj)||_.isArguments(obj))?0===obj.length:0===_.keys(obj).length)},_.isElement=function(obj){return!(!obj||1!==obj.nodeType)},_.isArray=nativeIsArray||function(obj){return"[object Array]"===toString.call(obj)},_.isObject=function(obj){var type=typeof obj;return"function"===type||"object"===type&&!!obj},_.each(["Arguments","Function","String","Number","Date","RegExp","Error"],function(name){_["is"+name]=function(obj){return toString.call(obj)==="[object "+name+"]"}}),_.isArguments(arguments)||(_.isArguments=function(obj){return _.has(obj,"callee")}),"function"!=typeof/./&&"object"!=typeof Int8Array&&(_.isFunction=function(obj){return"function"==typeof obj||!1}),_.isFinite=function(obj){return isFinite(obj)&&!isNaN(parseFloat(obj))},_.isNaN=function(obj){return _.isNumber(obj)&&obj!==+obj},_.isBoolean=function(obj){return!0===obj||!1===obj||"[object Boolean]"===toString.call(obj)},_.isNull=function(obj){return null===obj},_.isUndefined=function(obj){return void 0===obj},_.has=function(obj,key){return null!=obj&&hasOwnProperty.call(obj,key)},_.noConflict=function(){return root._=previousUnderscore,this},_.identity=function(value){return value},_.constant=function(value){return function(){return value}},_.noop=function(){},_.property=property,_.propertyOf=function(obj){return null==obj?function(){}:function(key){return obj[key]}},_.matcher=_.matches=function(attrs){return attrs=_.extendOwn({},attrs),function(obj){return _.isMatch(obj,attrs)}},_.times=function(n,iteratee,context){var accum=Array(Math.max(0,n));iteratee=optimizeCb(iteratee,context,1);for(var i=0;i<n;i++)accum[i]=iteratee(i);return accum},_.random=function(min,max){return null==max&&(max=min,min=0),min+Math.floor(Math.random()*(max-min+1))},_.now=Date.now||function(){return(new Date).getTime()};var escapeMap={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"},unescapeMap=_.invert(escapeMap),createEscaper=function(map){var escaper=function(match){return map[match]},source="(?:"+_.keys(map).join("|")+")",testRegexp=RegExp(source),replaceRegexp=RegExp(source,"g");return function(string){return string=null==string?"":""+string,testRegexp.test(string)?string.replace(replaceRegexp,escaper):string}};_.escape=createEscaper(escapeMap),_.unescape=createEscaper(unescapeMap),_.result=function(object,property,fallback){var value=null==object?void 0:object[property];return void 0===value&&(value=fallback),_.isFunction(value)?value.call(object):value};var idCounter=0;_.uniqueId=function(prefix){var id=++idCounter+"";return prefix?prefix+id:id},_.templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var noMatch=/(.)^/,escapes={"'":"'","\\":"\\","\r":"r","\n":"n","\u2028":"u2028","\u2029":"u2029"},escaper=/\\|'|\r|\n|\u2028|\u2029/g,escapeChar=function(match){return"\\"+escapes[match]};_.template=function(text,settings,oldSettings){!settings&&oldSettings&&(settings=oldSettings),settings=_.defaults({},settings,_.templateSettings);var matcher=RegExp([(settings.escape||noMatch).source,(settings.interpolate||noMatch).source,(settings.evaluate||noMatch).source].join("|")+"|$","g"),index=0,source="__p+='";text.replace(matcher,function(match,escape,interpolate,evaluate,offset){return source+=text.slice(index,offset).replace(escaper,escapeChar),index=offset+match.length,escape?source+="'+\n((__t=("+escape+"))==null?'':_.escape(__t))+\n'":interpolate?source+="'+\n((__t=("+interpolate+"))==null?'':__t)+\n'":evaluate&&(source+="';\n"+evaluate+"\n__p+='"),match}),source+="';\n",settings.variable||(source="with(obj||{}){\n"+source+"}\n"),source="var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n"+source+"return __p;\n";try{var render=new Function(settings.variable||"obj","_",source)}catch(e){throw e.source=source,e}var template=function(data){return render.call(this,data,_)};return template.source="function("+(settings.variable||"obj")+"){\n"+source+"}",template},_.chain=function(obj){var instance=_(obj);return instance._chain=!0,instance};var result=function(instance,obj){return instance._chain?_(obj).chain():obj};_.mixin=function(obj){_.each(_.functions(obj),function(name){var func=_[name]=obj[name];_.prototype[name]=function(){var args=[this._wrapped];return push.apply(args,arguments),result(this,func.apply(_,args))}})},_.mixin(_),_.each(["pop","push","reverse","shift","sort","splice","unshift"],function(name){var method=ArrayProto[name];_.prototype[name]=function(){var obj=this._wrapped;return method.apply(obj,arguments),"shift"!==name&&"splice"!==name||0!==obj.length||delete obj[0],result(this,obj)}}),_.each(["concat","join","slice"],function(name){var method=ArrayProto[name];_.prototype[name]=function(){return result(this,method.apply(this._wrapped,arguments))}}),_.prototype.value=function(){return this._wrapped},_.prototype.valueOf=_.prototype.toJSON=_.prototype.value,_.prototype.toString=function(){return""+this._wrapped},__WEBPACK_AMD_DEFINE_ARRAY__=[],void 0!==(__WEBPACK_AMD_DEFINE_RESULT__=function(){return _}.apply(exports,__WEBPACK_AMD_DEFINE_ARRAY__))&&(module.exports=__WEBPACK_AMD_DEFINE_RESULT__)}).call(this)},{}],23:[function(require,module,exports){var _=require("underscore"),geocrunch=require("geocrunch"),pad=function(num){return num<10?"0"+num.toString():num.toString()},ddToDms=function(coordinate,posSymbol,negSymbol){var dd=Math.abs(coordinate),d=Math.floor(dd),m=Math.floor(60*(dd-d)),s=Math.round(3600*(dd-d-m/60)*100)/100,directionSymbol=dd===coordinate?posSymbol:negSymbol;return pad(d)+"&deg; "+pad(m)+"' "+pad(s)+'" '+directionSymbol},measure=function(latlngs){var last=_.last(latlngs),path=geocrunch.path(_.map(latlngs,function(latlng){return[latlng.lng,latlng.lat]})),meters=path.distance({units:"meters"}),sqMeters=path.area({units:"sqmeters"});return{lastCoord:{dd:{x:last.lng,y:last.lat},dms:{x:ddToDms(last.lng,"E","W"),y:ddToDms(last.lat,"N","S")}},length:meters,area:sqMeters}};module.exports={measure:measure}},{geocrunch:7,underscore:22}],24:[function(require,module,exports){var selectOne=function(selector,el){return el||(el=document),el.querySelector(selector)},selectAll=function(selector,el){return el||(el=document),Array.prototype.slice.call(el.querySelectorAll(selector))},hide=function(el){if(el)return el.setAttribute("style","display:none;"),el},show=function(el){if(el)return el.removeAttribute("style"),el};module.exports={$:selectOne,$$:selectAll,hide:hide,show:show}},{}],25:[function(require,module,exports){module.exports={measure:"Medir",measureDistancesAndAreas:"Medeix distancies i àreas",createNewMeasurement:"Crear nova medicio",startCreating:"Començi a crear la medicio afegint punts al mapa",finishMeasurement:"Acabar la medició",lastPoint:"Últim punt",area:"Área",perimeter:"Perómetre",pointLocation:"Localizació del punt",areaMeasurement:"Medició d'área",linearMeasurement:"Medició lineal",pathDistance:"Distancia de ruta",centerOnArea:"Centrar en aquesta área",centerOnLine:"Centrar en aquesta línia",centerOnLocation:"Centrar en aquesta localizació",cancel:"Cancel·lar",delete:"Eliminar",acres:"Acres",feet:"Peus",kilometers:"Quilòmetres",hectares:"Hectàreas",meters:"Metros",miles:"Milles",sqfeet:"Peus cuadrats",sqmeters:"Metres cuadrats",sqmiles:"Milles cuadrades",decPoint:".",thousandsSep:" "}},{}],26:[function(require,module,exports){module.exports={measure:"测量",measureDistancesAndAreas:"同时测量距离和面积",createNewMeasurement:"开始一次新的测量",startCreating:"点击地图加点以开始创建测量",finishMeasurement:"完成测量",lastPoint:"最后点的坐标",area:"面积",perimeter:"周长",pointLocation:"点的坐标",areaMeasurement:"面积测量",linearMeasurement:"距离测量",pathDistance:"路径长度",centerOnArea:"该面积居中",centerOnLine:"该线段居中",centerOnLocation:"该位置居中",cancel:"取消",delete:"删除",acres:"公亩",feet:"英尺",kilometers:"公里",hectares:"公顷",meters:"米",miles:"英里",sqfeet:"平方英尺",sqmeters:"平方米",sqmiles:"平方英里",decPoint:".",thousandsSep:","}},{}],27:[function(require,module,exports){module.exports={measure:"Mål",measureDistancesAndAreas:"Mål afstande og arealer",createNewMeasurement:"Lav en ny måling",startCreating:"Begynd målingen ved at tilføje punkter på kortet",finishMeasurement:"Afslut måling",lastPoint:"Sidste punkt",area:"Areal",perimeter:"Omkreds",pointLocation:"Punkt",areaMeasurement:"Areal",linearMeasurement:"Linje",pathDistance:"Sti afstand",centerOnArea:"Centrér dette område",centerOnLine:"Centrér denne linje",centerOnLocation:"Centrér dette punkt",cancel:"Annuller",delete:"Slet",acres:"acre",feet:"fod",kilometers:"km",hectares:"ha",meters:"m",miles:"mil",sqfeet:"kvadratfod",sqmeters:"m²",sqmiles:"kvadratmil",decPoint:",",thousandsSep:"."}},{}],28:[function(require,module,exports){module.exports={measure:"Messung",measureDistancesAndAreas:"Messung von Abständen und Flächen",createNewMeasurement:"Eine neue Messung durchführen",startCreating:"Führen Sie die Messung durch, indem Sie der Karte Punkte hinzufügen.",finishMeasurement:"Messung beenden",lastPoint:"Letzter Punkt",area:"Fläche",perimeter:"Rand",pointLocation:"Lage des Punkts",areaMeasurement:"Gemessene Fläche",linearMeasurement:"Gemessener Abstand",pathDistance:"Abstand entlang des Pfads",centerOnArea:"Auf diese Fläche zentrieren",centerOnLine:"Auf diesen Linienzug zentrieren",centerOnLocation:"Auf diesen Ort zentrieren",cancel:"Abbrechen",delete:"Löschen",acres:"Morgen",feet:"Fuß",kilometers:"Kilometer",hectares:"Hektar",meters:"Meter",miles:"Meilen",sqfeet:"Quadratfuß",sqmeters:"Quadratmeter",sqmiles:"Quadratmeilen",decPoint:",",thousandsSep:"."}},{}],29:[function(require,module,exports){module.exports={measure:"Messung",measureDistancesAndAreas:"Abstände und Flächen messen",createNewMeasurement:"Eine neue Messung durchführen",startCreating:"Messen sie, indem Sie der Karte Punkte hinzufügen",finishMeasurement:"Messung beenden",lastPoint:"Letzter Punkt",area:"Fläche",perimeter:"Umfang",pointLocation:"Lage des Punkts",areaMeasurement:"Fläche",linearMeasurement:"Abstand",pathDistance:"Umfang",centerOnArea:"Auf diese Fläche zentrieren",centerOnLine:"Auf diese Linie zentrieren",centerOnLocation:"Auf diesen Ort zentrieren",cancel:"Abbrechen",delete:"Löschen",acres:"Morgen",feet:"Fuß",kilometers:"Kilometer",hectares:"Hektar",meters:"Meter",miles:"Meilen",sqfeet:"Quadratfuß",sqmeters:"Quadratmeter",sqmiles:"Quadratmeilen",decPoint:".",thousandsSep:"'"}},{}],30:[function(require,module,exports){module.exports={measure:"Measure",measureDistancesAndAreas:"Measure distances and areas",createNewMeasurement:"Create a new measurement",startCreating:"Start creating a measurement by adding points to the map",finishMeasurement:"Finish measurement",lastPoint:"Last point",area:"Area",perimeter:"Perimeter",pointLocation:"Point location",areaMeasurement:"Area measurement",linearMeasurement:"Linear measurement",pathDistance:"Path distance",centerOnArea:"Center on this area",centerOnLine:"Center on this line",centerOnLocation:"Center on this location",cancel:"Cancel",delete:"Delete",acres:"Acres",feet:"Feet",kilometers:"Kilometers",hectares:"Hectares",meters:"Meters",miles:"Miles",sqfeet:"Sq Feet",sqmeters:"Sq Meters",sqmiles:"Sq Miles",decPoint:".",thousandsSep:","}},{}],31:[function(require,module,exports){module.exports={measure:"Measure",measureDistancesAndAreas:"Measure distances and areas",createNewMeasurement:"Create a new measurement",startCreating:"Start creating a measurement by adding points to the map",finishMeasurement:"Finish measurement",lastPoint:"Last point",area:"Area",perimeter:"Perimeter",pointLocation:"Point location",areaMeasurement:"Area measurement",linearMeasurement:"Linear measurement",pathDistance:"Path distance",centerOnArea:"Centre on this area",centerOnLine:"Centre on this line",centerOnLocation:"Centre on this location",cancel:"Cancel",delete:"Delete",acres:"Acres",feet:"Feet",kilometers:"Kilometres",hectares:"Hectares",meters:"Meters",miles:"Miles",sqfeet:"Sq Feet",sqmeters:"Sq Meters",sqmiles:"Sq Miles",decPoint:".",thousandsSep:","}},{}],32:[function(require,module,exports){module.exports={measure:"Medición",measureDistancesAndAreas:"Mida distancias y áreas",createNewMeasurement:"Crear nueva medición",startCreating:"Empiece a crear la medición añadiendo puntos al mapa",finishMeasurement:"Terminar medición",lastPoint:"Último punto",area:"Área",perimeter:"Perímetro",pointLocation:"Localización del punto",areaMeasurement:"Medición de área",linearMeasurement:"Medición linear",pathDistance:"Distancia de ruta",centerOnArea:"Centrar en este área",centerOnLine:"Centrar en esta línea",centerOnLocation:"Centrar en esta localización",cancel:"Cancelar",delete:"Eliminar",acres:"Acres",feet:"Pies",kilometers:"Kilómetros",hectares:"Hectáreas",meters:"Metros",miles:"Millas",sqfeet:"Pies cuadrados",sqmeters:"Metros cuadrados",sqmiles:"Millas cuadradas",decPoint:".",thousandsSep:" "}},{}],33:[function(require,module,exports){module.exports={measure:"اندازه گیری",measureDistancesAndAreas:"اندازه گیری فاصله و مساحت",createNewMeasurement:"ثبت اندازه گیری جدید",startCreating:"برای ثبت اندازه گیری جدید نقاطی را به نقشه اضافه کنید.",finishMeasurement:"پایان اندازه گیری",lastPoint:"آخرین نقطه",area:"مساحت",perimeter:"محیط",pointLocation:"مکان نقطه",areaMeasurement:"اندازه گیری مساحت",linearMeasurement:"اندازه گیری خطی",pathDistance:"فاصله مسیر",centerOnArea:"مرکز این سطح",centerOnLine:"مرکز این خط",centerOnLocation:"مرکز این مکان",cancel:"لغو",delete:"حذف",acres:"ایکر",feet:"پا",kilometers:"کیلومتر",hectares:"هکتار",meters:"متر",miles:"مایل",sqfeet:"پا مربع",sqmeters:"متر مربع",sqmiles:"مایل مربع",decPoint:"/",thousandsSep:","}},{}],34:[function(require,module,exports){module.exports={measure:"Sukat",measureDistancesAndAreas:"Kalkulahin ang tamang distansya at sukat",createNewMeasurement:"Lumikha ng isang bagong pagsukat",startCreating:"Simulan ang paglikha ng isang pagsukat sa pamamagitan ng pagdaragdag ng mga puntos sa mapa",finishMeasurement:"Tapusin ang pagsukat",lastPoint:"Huling punto sa mapa",area:"Sukat",perimeter:"Palibot",pointLocation:"Lokasyon ng punto",areaMeasurement:"Kabuuang sukat",linearMeasurement:"Pagsukat ng guhit",pathDistance:"Distansya ng daanan",centerOnArea:"I-sentro sa lugar na ito",centerOnLine:"I-sentro sa linya na ito",centerOnLocation:"I-sentro sa lokasyong ito",cancel:"Kanselahin",delete:"Tanggalin",acres:"Acres",feet:"Talampakan",kilometers:"Kilometro",hectares:"Hektarya",meters:"Metro",miles:"Milya",sqfeet:"Talampakang Kwadrado",sqmeters:"Metro Kwadrado",sqmiles:"Milya Kwadrado",decPoint:".",thousandsSep:","}},{}],35:[function(require,module,exports){module.exports={measure:"Mesure",measureDistancesAndAreas:"Mesurer les distances et superficies",createNewMeasurement:"Créer une nouvelle mesure",startCreating:"Débuter la création d'une nouvelle mesure en ajoutant des points sur la carte",finishMeasurement:"Finir la mesure",lastPoint:"Dernier point",area:"Superficie",perimeter:"Périmètre",pointLocation:"Placement du point",areaMeasurement:"Mesure de superficie",linearMeasurement:"Mesure linéaire",pathDistance:"Distance du chemin",centerOnArea:"Centrer sur cette zone",centerOnLine:"Centrer sur cette ligne",centerOnLocation:"Centrer à cet endroit",cancel:"Annuler",delete:"Supprimer",acres:"Acres",feet:"Pieds",kilometers:"Kilomètres",hectares:"Hectares",meters:"Mètres",miles:"Miles",sqfeet:"Pieds carrés",sqmeters:"Mètres carrés",sqmiles:"Miles carrés",decPoint:",",thousandsSep:" "}},{}],36:[function(require,module,exports){module.exports={measure:"Misura",measureDistancesAndAreas:"Misura distanze e aree",createNewMeasurement:"Crea una nuova misurazione",startCreating:"Comincia a creare una misurazione aggiungendo punti alla mappa",finishMeasurement:"Misurazione conclusa",lastPoint:"Ultimo punto",area:"Area",perimeter:"Perimetro",pointLocation:"Posizione punto",areaMeasurement:"Misura area",linearMeasurement:"Misura lineare",pathDistance:"Distanza percorso",centerOnArea:"Centra su questa area",centerOnLine:"Centra su questa linea",centerOnLocation:"Centra su questa posizione",cancel:"Annulla",delete:"Cancella",acres:"Acri",feet:"Piedi",kilometers:"Chilometri",hectares:"Ettari",meters:"Metri",miles:"Miglia",sqfeet:"Piedi quadri",sqmeters:"Metri quadri",sqmiles:"Miglia quadre",decPoint:".",thousandsSep:","}},{}],37:[function(require,module,exports){module.exports={measure:"Meet",measureDistancesAndAreas:"Meet afstanden en oppervlakten",createNewMeasurement:"Maak een nieuwe meting",startCreating:"Begin een meting door punten toe te voegen aan de kaart",finishMeasurement:"Beëindig meting",lastPoint:"Laatste punt",area:"Oppervlakte",perimeter:"Omtrek",pointLocation:"Locatie punt",areaMeasurement:"Oppervlakte meting",linearMeasurement:"Gemeten afstand",pathDistance:"Afstand over de lijn",centerOnArea:"Centreer op dit gebied",centerOnLine:"Centreer op deze lijn",centerOnLocation:"Centreer op deze locatie",cancel:"Annuleer",delete:"Wis",acres:"are",feet:"Voet",kilometers:"km",hectares:"ha",meters:"m",miles:"Mijl",sqfeet:"Vierkante Feet",sqmeters:"m2",sqmiles:"Vierkante Mijl",decPoint:",",thousandsSep:"."}},{}],38:[function(require,module,exports){module.exports={measure:"Pomiar",measureDistancesAndAreas:"Pomiar odległości i powierzchni",createNewMeasurement:"Utwórz nowy pomiar",startCreating:"Rozpocznij tworzenie nowego pomiaru poprzez dodanie punktów na mapie",finishMeasurement:"Zakończ pomiar",lastPoint:"Ostatni punkt",area:"Powierzchnia",perimeter:"Obwód",pointLocation:"Punkt lokalizacji",areaMeasurement:"Pomiar powierzchni",linearMeasurement:"Pomiar liniowy",pathDistance:"Długość ścieżki",centerOnArea:"Środek tego obszaru",centerOnLine:"Środek tej linii",centerOnLocation:"Środek w tej lokalizacji",cancel:"Anuluj",delete:"Skasuj",acres:"akrów",feet:"stóp",kilometers:"kilometrów",hectares:"hektarów",meters:"metrów",miles:"mil",sqfeet:"stóp kwadratowych",sqmeters:"metrów kwadratowych",sqmiles:"mil kwadratowych",decPoint:",",thousandsSep:"."}},{}],39:[function(require,module,exports){module.exports={measure:"Medidas",measureDistancesAndAreas:"Mede distâncias e áreas",createNewMeasurement:"Criar nova medida",startCreating:"Comece criando uma medida, adicionando pontos no mapa",finishMeasurement:"Finalizar medida",lastPoint:"Último ponto",area:"Área",perimeter:"Perímetro",pointLocation:"Localização do ponto",areaMeasurement:"Medida de área",linearMeasurement:"Medida linear",pathDistance:"Distância",centerOnArea:"Centralizar nesta área",centerOnLine:"Centralizar nesta linha",centerOnLocation:"Centralizar nesta localização",cancel:"Cancelar",delete:"Excluir",acres:"Acres",feet:"Pés",kilometers:"Quilômetros",hectares:"Hectares",meters:"Metros",miles:"Milhas",sqfeet:"Pés²",sqmeters:"Metros²",sqmiles:"Milhas²",decPoint:",",thousandsSep:"."}},{}],40:[function(require,module,exports){module.exports={measure:"Medições",measureDistancesAndAreas:"Medir distâncias e áreas",createNewMeasurement:"Criar uma nova medição",startCreating:"Adicione pontos no mapa, para criar uma nova medição",finishMeasurement:"Finalizar medição",lastPoint:"Último ponto",area:"Área",perimeter:"Perímetro",pointLocation:"Localização do ponto",areaMeasurement:"Medição da área",linearMeasurement:"Medição linear",pathDistance:"Distância",centerOnArea:"Centrar nesta área",centerOnLine:"Centrar nesta linha",centerOnLocation:"Centrar nesta localização",cancel:"Cancelar",delete:"Eliminar",acres:"Acres",feet:"Pés",kilometers:"Kilômetros",hectares:"Hectares",meters:"Metros",miles:"Milhas",sqfeet:"Pés²",sqmeters:"Metros²",sqmiles:"Milhas²",decPoint:",",thousandsSep:"."}},{}],41:[function(require,module,exports){module.exports={measure:"Измерение",measureDistancesAndAreas:"Измерение расстояний и площади",createNewMeasurement:"Создать новое измерение",startCreating:"Для начала измерения добавьте точку на карту",finishMeasurement:"Закончить измерение",lastPoint:"Последняя точка",area:"Область",perimeter:"Периметр",pointLocation:"Местоположение точки",areaMeasurement:"Измерение области",linearMeasurement:"Линейное измерение",pathDistance:"Расстояние",centerOnArea:"Сфокусироваться на данной области",centerOnLine:"Сфокусироваться на данной линии",centerOnLocation:"Сфокусироваться на данной местности",cancel:"Отменить",delete:"Удалить",acres:"акры",feet:"фут",kilometers:"км",hectares:"га",meters:"м",miles:"миль",sqfeet:"футов²",sqmeters:"м²",sqmiles:"миль²",decPoint:".",thousandsSep:","}},{}],42:[function(require,module,exports){module.exports={measure:"Mäta",measureDistancesAndAreas:"Mäta avstånd och yta",createNewMeasurement:"Skapa ny mätning",startCreating:"Börja mätning genom att lägga till punkter på kartan",finishMeasurement:"Avsluta mätning",lastPoint:"Sista punkt",area:"Yta",perimeter:"Omkrets",pointLocation:"Punktens Läge",areaMeasurement:"Arealmätning",linearMeasurement:"Längdmätning",pathDistance:"Total linjelängd",centerOnArea:"Centrera på detta område",centerOnLine:"Centrera på denna linje",centerOnLocation:"Centrera på denna punkt",cancel:"Avbryt",delete:"Radera",acres:"Tunnland",feet:"Fot",kilometers:"Kilometer",hectares:"Hektar",meters:"Meter",miles:"Miles",sqfeet:"Kvadratfot",sqmeters:"Kvadratmeter",sqmiles:"Kvadratmiles",decPoint:",",thousandsSep:" "}},{}],43:[function(require,module,exports){module.exports={measure:"Hesapla",measureDistancesAndAreas:"Uzaklık ve alan hesapla",createNewMeasurement:"Yeni hesaplama",startCreating:"Yeni nokta ekleyerek hesaplamaya başla",finishMeasurement:"Hesaplamayı bitir",lastPoint:"Son nokta",area:"Alan",perimeter:"Çevre uzunluğu",pointLocation:"Nokta yeri",areaMeasurement:"Alan hesaplaması",linearMeasurement:"Doğrusal hesaplama",pathDistance:"Yol uzunluğu",centerOnArea:"Bu alana odaklan",centerOnLine:"Bu doğtuya odaklan",centerOnLocation:"Bu yere odaklan",cancel:"Çıkış",delete:"Sil",acres:"Dönüm",feet:"Feet",kilometers:"Kilometre",hectares:"Hektar",meters:"Metre",miles:"Mil",sqfeet:"Feet kare",sqmeters:"Metre kare",sqmiles:"Mil kare",decPoint:".",thousandsSep:","}},{}],44:[function(require,module,exports){(function(global){var _=require("underscore"),L="undefined"!=typeof window?window.L:void 0!==global?global.L:null,humanize=require("humanize"),units=require("./units"),calc=require("./calc"),dom=require("./dom"),$=dom.$,Symbology=require("./mapsymbology"),controlTemplate=_.template('<a class="<%= model.className %>-toggle js-toggle" href="#" title="<%= i18n.__(\'measureDistancesAndAreas\') %>"><%= i18n.__(\'measure\') %></a>\n<div class="<%= model.className %>-interaction js-interaction">\n  <div class="js-startprompt startprompt">\n    <h3><%= i18n.__(\'measureDistancesAndAreas\') %></h3>\n    <ul class="tasks">\n      <a href="#" class="js-start start"><%= i18n.__(\'createNewMeasurement\') %></a>\n    </ul>\n  </div>\n  <div class="js-measuringprompt">\n    <h3><%= i18n.__(\'measureDistancesAndAreas\') %></h3>\n    <p class="js-starthelp"><%= i18n.__(\'startCreating\') %></p>\n    <div class="js-results results"></div>\n    <ul class="js-measuretasks tasks">\n      <li><a href="#" class="js-cancel cancel"><%= i18n.__(\'cancel\') %></a></li>\n      <li><a href="#" class="js-finish finish"><%= i18n.__(\'finishMeasurement\') %></a></li>\n    </ul>\n  </div>\n</div>'),resultsTemplate=_.template('<div class="group">\n<p class="lastpoint heading"><%= i18n.__(\'lastPoint\') %></p>\n<p><%= model.lastCoord.dms.y %> <span class="coorddivider">/</span> <%= model.lastCoord.dms.x %></p>\n<p><%= humanize.numberFormat(model.lastCoord.dd.y, 6) %> <span class="coorddivider">/</span> <%= humanize.numberFormat(model.lastCoord.dd.x, 6) %></p>\n</div>\n<% if (model.pointCount > 1) { %>\n<div class="group">\n<p><span class="heading"><%= i18n.__(\'pathDistance\') %></span> <%= model.lengthDisplay %></p>\n</div>\n<% } %>\n<% if (model.pointCount > 2) { %>\n<div class="group">\n<p><span class="heading"><%= i18n.__(\'area\') %></span> <%= model.areaDisplay %></p>\n</div>\n<% } %>'),pointPopupTemplate=_.template('<h3><%= i18n.__(\'pointLocation\') %></h3>\n<p><%= model.lastCoord.dms.y %> <span class="coorddivider">/</span> <%= model.lastCoord.dms.x %></p>\n<p><%= humanize.numberFormat(model.lastCoord.dd.y, 6) %> <span class="coorddivider">/</span> <%= humanize.numberFormat(model.lastCoord.dd.x, 6) %></p>\n<ul class="tasks">\n  <li><a href="#" class="js-zoomto zoomto"><%= i18n.__(\'centerOnLocation\') %></a></li>\n  <li><a href="#" class="js-deletemarkup deletemarkup"><%= i18n.__(\'delete\') %></a></li>\n</ul>'),linePopupTemplate=_.template('<h3><%= i18n.__(\'linearMeasurement\') %></h3>\n<p><%= model.lengthDisplay %></p>\n<ul class="tasks">\n  <li><a href="#" class="js-zoomto zoomto"><%= i18n.__(\'centerOnLine\') %></a></li>\n  <li><a href="#" class="js-deletemarkup deletemarkup"><%= i18n.__(\'delete\') %></a></li>\n</ul>'),areaPopupTemplate=_.template('<h3><%= i18n.__(\'areaMeasurement\') %></h3>\n<p><%= model.areaDisplay %></p>\n<p><%= model.lengthDisplay %> <%= i18n.__(\'perimeter\') %></p>\n<ul class="tasks">\n  <li><a href="#" class="js-zoomto zoomto"><%= i18n.__(\'centerOnArea\') %></a></li>\n  <li><a href="#" class="js-deletemarkup deletemarkup"><%= i18n.__(\'delete\') %></a></li>\n</ul>'),i18n=new(require("i18n-2"))({devMode:!1,locales:{ca:require("./i18n/ca"),cn:require("./i18n/cn"),da:require("./i18n/da"),de:require("./i18n/de"),de_CH:require("./i18n/de_CH"),en:require("./i18n/en"),en_UK:require("./i18n/en_UK"),es:require("./i18n/es"),fa:require("./i18n/fa"),fil_PH:require("./i18n/fil_PH"),fr:require("./i18n/fr"),it:require("./i18n/it"),nl:require("./i18n/nl"),pl:require("./i18n/pl"),pt_BR:require("./i18n/pt_BR"),pt_PT:require("./i18n/pt_PT"),ru:require("./i18n/ru"),sv:require("./i18n/sv"),tr:require("./i18n/tr")}});L.Control.Measure=L.Control.extend({_className:"leaflet-control-measure",options:{units:{},position:"topright",primaryLengthUnit:"feet",secondaryLengthUnit:"miles",primaryAreaUnit:"acres",activeColor:"#ABE67E",completedColor:"#C8F2BE",captureZIndex:1e4,popupOptions:{className:"leaflet-measure-resultpopup",autoPanPadding:[10,10]}},initialize:function(options){L.setOptions(this,options),this.options.units=L.extend({},units,this.options.units),this._symbols=new Symbology(_.pick(this.options,"activeColor","completedColor")),i18n.setLocale(this.options.localization)},onAdd:function(map){return this._map=map,this._latlngs=[],this._initLayout(),map.on("click",this._collapse,this),this._layer=L.layerGroup().addTo(map),this._container},onRemove:function(map){map.off("click",this._collapse,this),map.removeLayer(this._layer)},_initLayout:function(){var $toggle,$start,$cancel,$finish,className=this._className,container=this._container=L.DomUtil.create("div",className);container.innerHTML=controlTemplate({model:{className:className},i18n:i18n}),container.setAttribute("aria-haspopup",!0),L.Browser.touch?L.DomEvent.on(container,"click",L.DomEvent.stopPropagation):(L.DomEvent.disableClickPropagation(container),L.DomEvent.disableScrollPropagation(container)),$toggle=this.$toggle=$(".js-toggle",container),this.$interaction=$(".js-interaction",container),$start=$(".js-start",container),$cancel=$(".js-cancel",container),$finish=$(".js-finish",container),this.$startPrompt=$(".js-startprompt",container),this.$measuringPrompt=$(".js-measuringprompt",container),this.$startHelp=$(".js-starthelp",container),this.$results=$(".js-results",container),this.$measureTasks=$(".js-measuretasks",container),this._collapse(),this._updateMeasureNotStarted(),L.Browser.android||(L.DomEvent.on(container,"mouseenter",this._expand,this),L.DomEvent.on(container,"mouseleave",this._collapse,this)),L.DomEvent.on($toggle,"click",L.DomEvent.stop),L.Browser.touch?L.DomEvent.on($toggle,"click",this._expand,this):L.DomEvent.on($toggle,"focus",this._expand,this),L.DomEvent.on($start,"click",L.DomEvent.stop),L.DomEvent.on($start,"click",this._startMeasure,this),L.DomEvent.on($cancel,"click",L.DomEvent.stop),L.DomEvent.on($cancel,"click",this._finishMeasure,this),L.DomEvent.on($finish,"click",L.DomEvent.stop),L.DomEvent.on($finish,"click",this._handleMeasureDoubleClick,this)},_expand:function(){dom.hide(this.$toggle),dom.show(this.$interaction)},_collapse:function(){this._locked||(dom.hide(this.$interaction),dom.show(this.$toggle))},_updateMeasureNotStarted:function(){dom.hide(this.$startHelp),dom.hide(this.$results),dom.hide(this.$measureTasks),dom.hide(this.$measuringPrompt),dom.show(this.$startPrompt)},_updateMeasureStartedNoPoints:function(){dom.hide(this.$results),dom.show(this.$startHelp),dom.show(this.$measureTasks),dom.hide(this.$startPrompt),dom.show(this.$measuringPrompt)},_updateMeasureStartedWithPoints:function(){dom.hide(this.$startHelp),dom.show(this.$results),dom.show(this.$measureTasks),dom.hide(this.$startPrompt),dom.show(this.$measuringPrompt)},_startMeasure:function(){this._locked=!0,this._measureVertexes=L.featureGroup().addTo(this._layer),this._captureMarker=L.marker(this._map.getCenter(),{clickable:!0,zIndexOffset:this.options.captureZIndex,opacity:0}).addTo(this._layer),this._setCaptureMarkerIcon(),this._captureMarker.on("mouseout",this._handleMapMouseOut,this).on("dblclick",this._handleMeasureDoubleClick,this).on("click",this._handleMeasureClick,this),this._map.on("mousemove",this._handleMeasureMove,this).on("mouseout",this._handleMapMouseOut,this).on("move",this._centerCaptureMarker,this).on("resize",this._setCaptureMarkerIcon,this),L.DomEvent.on(this._container,"mouseenter",this._handleMapMouseOut,this),this._updateMeasureStartedNoPoints(),this._map.fire("measurestart",null,!1)},_finishMeasure:function(){var model=_.extend({},this._resultsModel,{points:this._latlngs});this._locked=!1,L.DomEvent.off(this._container,"mouseover",this._handleMapMouseOut,this),this._clearMeasure(),this._captureMarker.off("mouseout",this._handleMapMouseOut,this).off("dblclick",this._handleMeasureDoubleClick,this).off("click",this._handleMeasureClick,this),this._map.off("mousemove",this._handleMeasureMove,this).off("mouseout",this._handleMapMouseOut,this).off("move",this._centerCaptureMarker,this).off("resize",this._setCaptureMarkerIcon,this),this._layer.removeLayer(this._measureVertexes).removeLayer(this._captureMarker),this._measureVertexes=null,this._updateMeasureNotStarted(),this._collapse(),this._map.fire("measurefinish",model,!1)},_clearMeasure:function(){this._latlngs=[],this._resultsModel=null,this._measureVertexes.clearLayers(),this._measureDrag&&this._layer.removeLayer(this._measureDrag),this._measureArea&&this._layer.removeLayer(this._measureArea),this._measureBoundary&&this._layer.removeLayer(this._measureBoundary),this._measureDrag=null,this._measureArea=null,this._measureBoundary=null},_centerCaptureMarker:function(){this._captureMarker.setLatLng(this._map.getCenter())},_setCaptureMarkerIcon:function(){this._captureMarker.setIcon(L.divIcon({iconSize:this._map.getSize().multiplyBy(2)}))},_getMeasurementDisplayStrings:function(measurement){function buildDisplay(val,primaryUnit,secondaryUnit,decPoint,thousandsSep){var display;return primaryUnit&&unitDefinitions[primaryUnit]?(display=formatMeasure(val,unitDefinitions[primaryUnit],decPoint,thousandsSep),secondaryUnit&&unitDefinitions[secondaryUnit]&&(display=display+" ("+formatMeasure(val,unitDefinitions[secondaryUnit],decPoint,thousandsSep)+")")):display=formatMeasure(val,null,decPoint,thousandsSep),display}function formatMeasure(val,unit,decPoint,thousandsSep){return unit&&unit.factor&&unit.display?humanize.numberFormat(val*unit.factor,unit.decimals||0,decPoint||i18n.__("decPoint"),thousandsSep||i18n.__("thousandsSep"))+" "+i18n.__([unit.display])||unit.display:humanize.numberFormat(val,0,decPoint||i18n.__("decPoint"),thousandsSep||i18n.__("thousandsSep"))}var unitDefinitions=this.options.units;return{lengthDisplay:buildDisplay(measurement.length,this.options.primaryLengthUnit,this.options.secondaryLengthUnit,this.options.decPoint,this.options.thousandsSep),areaDisplay:buildDisplay(measurement.area,this.options.primaryAreaUnit,this.options.secondaryAreaUnit,this.options.decPoint,this.options.thousandsSep)}},_updateResults:function(){var calced=calc.measure(this._latlngs),resultsModel=this._resultsModel=_.extend({},calced,this._getMeasurementDisplayStrings(calced),{pointCount:this._latlngs.length});this.$results.innerHTML=resultsTemplate({model:resultsModel,humanize:humanize,i18n:i18n})},_handleMeasureMove:function(evt){this._measureDrag?this._measureDrag.setLatLng(evt.latlng):this._measureDrag=L.circleMarker(evt.latlng,this._symbols.getSymbol("measureDrag")).addTo(this._layer),this._measureDrag.bringToFront()},_handleMeasureDoubleClick:function(){var calced,resultFeature,popupContainer,popupContent,zoomLink,deleteLink,latlngs=this._latlngs;this._finishMeasure(),latlngs.length&&(latlngs.length>2&&latlngs.push(_.first(latlngs)),calced=calc.measure(latlngs),1===latlngs.length?(resultFeature=L.circleMarker(latlngs[0],this._symbols.getSymbol("resultPoint")),popupContent=pointPopupTemplate({model:calced,humanize:humanize,i18n:i18n})):2===latlngs.length?(resultFeature=L.polyline(latlngs,this._symbols.getSymbol("resultLine")),popupContent=linePopupTemplate({model:_.extend({},calced,this._getMeasurementDisplayStrings(calced)),humanize:humanize,i18n:i18n})):(resultFeature=L.polygon(latlngs,this._symbols.getSymbol("resultArea")),popupContent=areaPopupTemplate({model:_.extend({},calced,this._getMeasurementDisplayStrings(calced)),humanize:humanize,i18n:i18n})),popupContainer=L.DomUtil.create("div",""),popupContainer.innerHTML=popupContent,zoomLink=$(".js-zoomto",popupContainer),zoomLink&&(L.DomEvent.on(zoomLink,"click",L.DomEvent.stop),L.DomEvent.on(zoomLink,"click",function(){resultFeature.getBounds?this._map.fitBounds(resultFeature.getBounds(),{padding:[20,20],maxZoom:17}):resultFeature.getLatLng&&this._map.panTo(resultFeature.getLatLng())},this)),deleteLink=$(".js-deletemarkup",popupContainer),deleteLink&&(L.DomEvent.on(deleteLink,"click",L.DomEvent.stop),L.DomEvent.on(deleteLink,"click",function(){this._layer.removeLayer(resultFeature)},this)),resultFeature.addTo(this._layer),resultFeature.bindPopup(popupContainer,this.options.popupOptions),resultFeature.getBounds?resultFeature.openPopup(resultFeature.getBounds().getCenter()):resultFeature.getLatLng&&resultFeature.openPopup(resultFeature.getLatLng()))},_handleMeasureClick:function(evt){var latlng=this._map.mouseEventToLatLng(evt.originalEvent),lastClick=_.last(this._latlngs),vertexSymbol=this._symbols.getSymbol("measureVertex");lastClick&&latlng.equals(lastClick)||(this._latlngs.push(latlng),this._addMeasureArea(this._latlngs),this._addMeasureBoundary(this._latlngs),this._measureVertexes.eachLayer(function(layer){layer.setStyle(vertexSymbol),layer._path.setAttribute("class",vertexSymbol.className)}),this._addNewVertex(latlng),this._measureBoundary&&this._measureBoundary.bringToFront(),this._measureVertexes.bringToFront()),this._updateResults(),this._updateMeasureStartedWithPoints()},_handleMapMouseOut:function(){this._measureDrag&&(this._layer.removeLayer(this._measureDrag),this._measureDrag=null)},_addNewVertex:function(latlng){L.circleMarker(latlng,this._symbols.getSymbol("measureVertexActive")).addTo(this._measureVertexes)},_addMeasureArea:function(latlngs){if(latlngs.length<3)return void(this._measureArea&&(this._layer.removeLayer(this._measureArea),this._measureArea=null));this._measureArea?this._measureArea.setLatLngs(latlngs):this._measureArea=L.polygon(latlngs,this._symbols.getSymbol("measureArea")).addTo(this._layer)},_addMeasureBoundary:function(latlngs){if(latlngs.length<2)return void(this._measureBoundary&&(this._layer.removeLayer(this._measureBoundary),this._measureBoundary=null));this._measureBoundary?this._measureBoundary.setLatLngs(latlngs):this._measureBoundary=L.polyline(latlngs,this._symbols.getSymbol("measureBoundary")).addTo(this._layer)}}),L.Map.mergeOptions({measureControl:!1}),L.Map.addInitHook(function(){this.options.measureControl&&(this.measureControl=(new L.Control.Measure).addTo(this))}),L.control.measure=function(options){return new L.Control.Measure(options)}}).call(this,void 0!==global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./calc":23,"./dom":24,"./i18n/ca":25,"./i18n/cn":26,"./i18n/da":27,"./i18n/de":28,"./i18n/de_CH":29,"./i18n/en":30,"./i18n/en_UK":31,"./i18n/es":32,"./i18n/fa":33,"./i18n/fil_PH":34,"./i18n/fr":35,"./i18n/it":36,"./i18n/nl":37,"./i18n/pl":38,"./i18n/pt_BR":39,"./i18n/pt_PT":40,"./i18n/ru":41,"./i18n/sv":42,"./i18n/tr":43,"./mapsymbology":45,"./units":46,humanize:16,"i18n-2":18,underscore:22}],45:[function(require,module,exports){var _=require("underscore"),color=require("color"),Symbology=function(options){this.setOptions(options)};Symbology.DEFAULTS={activeColor:"#ABE67E",completedColor:"#C8F2BE"},_.extend(Symbology.prototype,{setOptions:function(options){return this._options=_.extend({},Symbology.DEFAULTS,this._options,options),this},getSymbol:function(name){return{measureDrag:{clickable:!1,radius:4,color:this._options.activeColor,weight:2,opacity:.7,fillColor:this._options.activeColor,fillOpacity:.5,className:"layer-measuredrag"},measureArea:{clickable:!1,stroke:!1,fillColor:this._options.activeColor,fillOpacity:.2,className:"layer-measurearea"},measureBoundary:{clickable:!1,color:this._options.activeColor,weight:2,opacity:.9,fill:!1,className:"layer-measureboundary"},measureVertex:{clickable:!1,radius:4,color:this._options.activeColor,weight:2,opacity:1,fillColor:this._options.activeColor,fillOpacity:.7,className:"layer-measurevertex"},measureVertexActive:{clickable:!1,radius:4,color:this._options.activeColor,weight:2,opacity:1,fillColor:color(this._options.activeColor).darken(.15),fillOpacity:.7,className:"layer-measurevertex active"},resultArea:{clickable:!0,color:this._options.completedColor,weight:2,opacity:.9,fillColor:this._options.completedColor,fillOpacity:.2,className:"layer-measure-resultarea"},resultLine:{clickable:!0,color:this._options.completedColor,weight:3,opacity:.9,fill:!1,className:"layer-measure-resultline"},resultPoint:{clickable:!0,radius:4,color:this._options.completedColor,weight:2,opacity:1,fillColor:this._options.completedColor,fillOpacity:.7,className:"layer-measure-resultpoint"}}[name]}}),module.exports=Symbology},{color:6,underscore:22}],46:[function(require,module,exports){module.exports={acres:{factor:24711e-8,display:"acres",decimals:2},feet:{factor:3.2808,display:"feet",decimals:0},kilometers:{factor:.001,display:"kilometers",decimals:2},hectares:{factor:1e-4,display:"hectares",decimals:2},meters:{factor:1,display:"meters",decimals:0},miles:{factor:3.2808/5280,display:"miles",decimals:2},sqfeet:{factor:10.7639,display:"sqfeet",decimals:0},sqmeters:{factor:1,display:"sqmeters",decimals:0},sqmiles:{factor:3.86102e-7,display:"sqmiles",decimals:2}}},{}]},{},[44])}).call(exports,__webpack_require__(15))},function(module,exports,__webpack_require__){var content=__webpack_require__(160);"string"==typeof content&&(content=[[module.i,content,""]]);var options={hmr:!0};options.transform=void 0,options.insertInto=void 0;__webpack_require__(182)(content,options);content.locals&&(module.exports=content.locals)},function(module,exports,__webpack_require__){exports=module.exports=__webpack_require__(10)(!1),exports.i(__webpack_require__(161),""),exports.i(__webpack_require__(165),""),exports.i(__webpack_require__(166),""),exports.i(__webpack_require__(169),""),exports.push([module.i,'.leaflet-dhis2 {\n  background: #fff; }\n  .leaflet-dhis2 .leaflet-bar {\n    border-radius: 0; }\n    .leaflet-dhis2 .leaflet-bar a:first-child, .leaflet-dhis2 .leaflet-bar a:last-child {\n      border-radius: 0; }\n  .leaflet-dhis2.leaflet-touch .leaflet-bar {\n    border: 0;\n    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65); }\n    .leaflet-dhis2.leaflet-touch .leaflet-bar a {\n      width: 26px;\n      height: 26px;\n      line-height: 26px;\n      font-size: 20px; }\n  .leaflet-dhis2 .leaflet-control-attribution {\n    font-size: 9px; }\n    .leaflet-dhis2 .leaflet-control-attribution a {\n      color: #333; }\n  .leaflet-dhis2 .leaflet-control-layers {\n    border-radius: 0; }\n  .leaflet-dhis2 .leaflet-control-scale-line {\n    padding: 2px 2px 1px; }\n\n.leaflet-dhis2.leaflet-google .leaflet-control-scale-line {\n  margin-left: 76px; }\n\n.leaflet-dhis2 .leaflet-marker-label {\n  position: absolute;\n  display: inline-block;\n  width: 160px;\n  margin-left: -80px;\n  text-align: center; }\n\n.leaflet-dhis2 .leaflet-div-label {\n  text-align: center;\n  line-height: 12px;\n  text-shadow: -1px 0 #f5f5f5, 0 1px #f5f5f5, 1px 0 #f5f5f5, 0 -1px #f5f5f5;\n  min-width: 80px;\n  pointer-events: none; }\n\n.leaflet-dhis2 .leaflet-marker-highlight {\n  -webkit-animation: pulse 2s ease-out;\n  animation: pulse 2s ease-out;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite; }\n\n@-webkit-keyframes pulse {\n  from {\n    stroke-width: 15;\n    stroke-opacity: 1; }\n  to {\n    stroke-width: 50;\n    stroke-opacity: 0; } }\n\n@keyframes pulse {\n  from {\n    stroke-width: 15;\n    stroke-opacity: 1; }\n  to {\n    stroke-width: 50;\n    stroke-opacity: 0; } }\n\n.leaflet-dhis2 .leaflet-popup-content-wrapper {\n  border-radius: 0; }\n  .leaflet-dhis2 .leaflet-popup-content-wrapper .leaflet-popup-content em {\n    font-style: normal;\n    font-weight: bold; }\n  .leaflet-dhis2 .leaflet-popup-content-wrapper .leaflet-popup-content th {\n    white-space: nowrap;\n    vertical-align: top; }\n\n.leaflet-dhis2 .leaflet-tooltip {\n  border-radius: 0;\n  padding: 0 6px;\n  font: 12px/20px "Helvetica Neue", Arial, Helvetica, sans-serif; }\n\n.leaflet-dhis2 .leaflet-tooltip-left {\n  margin-left: -8px; }\n\n.leaflet-dhis2 .leaflet-tooltip-right {\n  margin-left: 13px; }\n\n.leaflet-dhis2 .leaflet-tooltip-left:before {\n  border-left-color: transparent; }\n\n.leaflet-dhis2 .leaflet-tooltip-right:before {\n  border-right-color: transparent; }\n\n.leaflet-dhis2 .marker-cluster {\n  background-color: rgba(255, 255, 255, 0.6);\n  background-clip: padding-box;\n  border-radius: 20px; }\n  .leaflet-dhis2 .marker-cluster div {\n    background-color: rgba(255, 255, 255, 0.8);\n    width: 30px;\n    height: 30px;\n    margin-left: 5px;\n    margin-top: 5px;\n    text-align: center;\n    border-radius: 15px;\n    font: 12px "Helvetica Neue", Arial, Helvetica, sans-serif; }\n  .leaflet-dhis2 .marker-cluster span {\n    line-height: 30px; }\n\n.leaflet-dhis2 .leaflet-cluster-icon {\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.65);\n  color: #fff;\n  border-radius: 50%;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  background-clip: padding-box; }\n  .leaflet-dhis2 .leaflet-cluster-icon span {\n    align-self: center; }\n\n.leaflet-dhis2 .marker-cluster-small {\n  background-color: rgba(181, 226, 140, 0.6); }\n\n.leaflet-dhis2 .marker-cluster-small div {\n  background-color: rgba(110, 204, 57, 0.6); }\n\n.leaflet-dhis2 .marker-cluster-medium {\n  background-color: rgba(241, 211, 87, 0.6); }\n\n.leaflet-dhis2 .marker-cluster-medium div {\n  background-color: rgba(240, 194, 12, 0.6); }\n\n.leaflet-dhis2 .marker-cluster-large {\n  background-color: rgba(253, 156, 115, 0.6); }\n\n.leaflet-dhis2 .marker-cluster-large div {\n  background-color: rgba(241, 128, 23, 0.6); }\n\n.leaflet-dhis2 .leaflet-tile-cluster-debug {\n  background: rgba(255, 0, 0, 0.1);\n  border: 1px dashed black; }\n\n.leaflet-dhis2 .leaflet-control-measure {\n  border-radius: 0;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65); }\n  .leaflet-dhis2 .leaflet-control-measure .leaflet-control-measure-toggle {\n    width: 26px;\n    height: 26px; }\n\n.leaflet-dhis2 .leaflet-control-fit-bounds {\n  width: 26px;\n  height: 26px;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65);\n  cursor: pointer;\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  background-color: #fff;\n  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAwVpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDcwNzFDMTZDODRBMTFFNTg1MzFEQjY0MEU0MEY4RDciIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDcwNzFDMTVDODRBMTFFNTg1MzFEQjY0MEU0MEY4RDciIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wICI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSI3MTRDNEJCNEM4MEZBOERDRUNDRkMwNEJERkMyRTE5MyIgc3RSZWY6ZG9jdW1lbnRJRD0iNzE0QzRCQjRDODBGQThEQ0VDQ0ZDMDRCREZDMkUxOTMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4nLlFTAAABcklEQVR42mJggIGS8qq///5jAqAgUIoBDRSWlP/HC4AKsKv+9/fP2jWrq6uqKiurVqxc9ePnb3Q9BcWlcKH9e3epqSgh2ywrr7h563a4AqBiBjjnxNGDEEUq6podHR2dHR262loQke2798GVQTX8/f1LVlIcKJeQkoHs9OL8bKAgn6Do1+8/UTRs37QeKCElp4jpXS11FaDUspVrIFwmiKVXrl0DklExCQwYID01CazgBoQL1cDIyAgkf//+hanh1+/fIHWMMD7Eor27tgHZomISmE5SkJUCSq1etxHFD8AI0FBRBEr4BoS8+/AJIvT96+e4qHCgoJmlLXooAcH1KxfZWUAu5OcXysjMys3NERcVhrjC0Nj0+YuXUA3IEXfh3GlzUxNkDzi7uNlYW4ECUEb24eMnIA2YCenggf29YLBr915wYvltqK8LVCYhJX35yhWiEt+Pb1/0dbWByorKaxgIJm8I+PLp/eTJUx49fQ4QYACpprSK2+4o1AAAAABJRU5ErkJggg=="); }\n  .leaflet-retina .leaflet-dhis2 .leaflet-control-fit-bounds {\n    background-image: url("data:image/png;base64,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");\n    background-size: 16px 16px; }\n\n.leaflet-dhis2 .leaflet-control-legend {\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65);\n  background-color: #fff; }\n  .leaflet-dhis2 .leaflet-control-legend .leaflet-control-legend-content {\n    display: none; }\n\n.leaflet-dhis2 .leaflet-control-legend-toggle {\n  width: 26px;\n  height: 26px;\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAy5pVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIEVsZW1lbnRzIDE0LjAgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OUJCQzgyMDdDRTU2MTFFNTk1Q0ZGQzk2MTlGNkY2NjYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OUJCQzgyMDhDRTU2MTFFNTk1Q0ZGQzk2MTlGNkY2NjYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo5QkJDODIwNUNFNTYxMUU1OTVDRkZDOTYxOUY2RjY2NiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo5QkJDODIwNkNFNTYxMUU1OTVDRkZDOTYxOUY2RjY2NiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PnV8j0MAAABmSURBVHjaYqxXZ/nPAAUffoOZjBPu/mEgFrDgkmBkZPxPkQE21lbEuQDqbKyOINYFjAwUAJxeOHzkKHEGZKn9g/vh+U8mBlJdNAhiAersoRwLtj6W8MD6+PnrUIwFqLPJjgWAAAMAR5ghoelZsw4AAAAASUVORK5CYII=");\n  display: block; }\n  .leaflet-retina .leaflet-dhis2 .leaflet-control-legend-toggle {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAy5pVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIEVsZW1lbnRzIDE0LjAgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6M0VDMTEyQzZDRTU4MTFFNTk1Q0ZGQzk2MTlGNkY2NjYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6M0VDMTEyQzdDRTU4MTFFNTk1Q0ZGQzk2MTlGNkY2NjYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo5QkJDODIwOUNFNTYxMUU1OTVDRkZDOTYxOUY2RjY2NiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo5QkJDODIwQUNFNTYxMUU1OTVDRkZDOTYxOUY2RjY2NiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PjzimhsAAACgSURBVHjaYqxXZ/nPgAN8+A2WYgQRE+7+YaAFYGIYYMBCqgZGRsb/wyoEhl4U2FhbDawDjhw9xkhVB0Cz2sCFgAArI14fkepAmofAgCfCw0eODrNsmKX2D2ccPP/JBK8LRgui0bpgtC6gWV0AzWoDFwKS7P/w+ohUB9I8BEbrAqqHgK2PJc6S7ePnr6N1wWhdMFoX0L4ugGa1AQsBgAADAHQ1NZdoV4oTAAAAAElFTkSuQmCC");\n    background-size: 16px 16px; }\n\n.leaflet-dhis2 .leaflet-control-legend-expanded {\n  position: relative; }\n  .leaflet-dhis2 .leaflet-control-legend-expanded .leaflet-control-legend-toggle {\n    display: none; }\n  .leaflet-dhis2 .leaflet-control-legend-expanded .leaflet-control-legend-content {\n    overflow-y: auto;\n    min-width: 150px;\n    max-width: 200px;\n    min-height: 80px;\n    max-height: 260px;\n    padding: 6px 10px 6px 6px;\n    color: #333;\n    display: block; }\n\n.dhis2-legend {\n  display: block;\n  padding-top: 15px; }\n  .dhis2-legend h2 {\n    font-weight: bold;\n    font-size: 13px;\n    line-height: 13px;\n    margin: 0; }\n    .dhis2-legend h2 span {\n      display: block;\n      font-size: 12px;\n      font-weight: normal; }\n  .dhis2-legend p {\n    margin: 5px 0; }\n  .dhis2-legend dl {\n    margin: 10px 0; }\n    .dhis2-legend dl dt {\n      float: left;\n      clear: left;\n      width: 30px;\n      height: 16px; }\n    .dhis2-legend dl dd {\n      margin: 0;\n      padding: 1px 0 1px 38px;\n      height: 16px;\n      font-size: 11px;\n      line-height: 14px;\n      white-space: nowrap; }\n      .dhis2-legend dl dd strong {\n        line-height: 12px;\n        font-weight: bold;\n        display: block; }\n  .dhis2-legend .dhis2-legend-predefined dt {\n    height: 25px; }\n  .dhis2-legend .dhis2-legend-predefined dd {\n    height: 25px; }\n  .dhis2-legend .dhis2-legend-image dt {\n    width: 16px;\n    background-repeat: no-repeat;\n    background-position: center center; }\n  .dhis2-legend .dhis2-legend-image dd {\n    padding-left: 23px; }\n\n.dhis2-legend:first-child {\n  padding-top: 0; }\n\n.leaflet-dhis2.leaflet-touch .leaflet-control-geocoder {\n  border: 0;\n  min-width: 26px;\n  min-height: 26px;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65); }\n\n.leaflet-dhis2.leaflet-touch .leaflet-control-geocoder-icon {\n  width: 26px;\n  height: 26px; }\n\n.leaflet-dhis2.leaflet-touch .leaflet-control-geocoder-alternatives li a {\n  font-size: 14px; }\n',""])},function(module,exports,__webpack_require__){var escape=__webpack_require__(27);exports=module.exports=__webpack_require__(10)(!1),exports.push([module.i,"/* required styles */\r\n\r\n.leaflet-pane,\r\n.leaflet-tile,\r\n.leaflet-marker-icon,\r\n.leaflet-marker-shadow,\r\n.leaflet-tile-container,\r\n.leaflet-pane > svg,\r\n.leaflet-pane > canvas,\r\n.leaflet-zoom-box,\r\n.leaflet-image-layer,\r\n.leaflet-layer {\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\t}\r\n.leaflet-container {\r\n\toverflow: hidden;\r\n\t}\r\n.leaflet-tile,\r\n.leaflet-marker-icon,\r\n.leaflet-marker-shadow {\r\n\t-webkit-user-select: none;\r\n\t   -moz-user-select: none;\r\n\t        user-select: none;\r\n\t  -webkit-user-drag: none;\r\n\t}\r\n/* Safari renders non-retina tile on retina better with this, but Chrome is worse */\r\n.leaflet-safari .leaflet-tile {\r\n\timage-rendering: -webkit-optimize-contrast;\r\n\t}\r\n/* hack that prevents hw layers \"stretching\" when loading new tiles */\r\n.leaflet-safari .leaflet-tile-container {\r\n\twidth: 1600px;\r\n\theight: 1600px;\r\n\t-webkit-transform-origin: 0 0;\r\n\t}\r\n.leaflet-marker-icon,\r\n.leaflet-marker-shadow {\r\n\tdisplay: block;\r\n\t}\r\n/* .leaflet-container svg: reset svg max-width decleration shipped in Joomla! (joomla.org) 3.x */\r\n/* .leaflet-container img: map is broken in FF if you have max-width: 100% on tiles */\r\n.leaflet-container .leaflet-overlay-pane svg,\r\n.leaflet-container .leaflet-marker-pane img,\r\n.leaflet-container .leaflet-shadow-pane img,\r\n.leaflet-container .leaflet-tile-pane img,\r\n.leaflet-container img.leaflet-image-layer {\r\n\tmax-width: none !important;\r\n\tmax-height: none !important;\r\n\t}\r\n\r\n.leaflet-container.leaflet-touch-zoom {\r\n\t-ms-touch-action: pan-x pan-y;\r\n\ttouch-action: pan-x pan-y;\r\n\t}\r\n.leaflet-container.leaflet-touch-drag {\r\n\t-ms-touch-action: pinch-zoom;\r\n\t/* Fallback for FF which doesn't support pinch-zoom */\r\n\ttouch-action: none;\r\n\ttouch-action: pinch-zoom;\r\n}\r\n.leaflet-container.leaflet-touch-drag.leaflet-touch-zoom {\r\n\t-ms-touch-action: none;\r\n\ttouch-action: none;\r\n}\r\n.leaflet-container {\r\n\t-webkit-tap-highlight-color: transparent;\r\n}\r\n.leaflet-container a {\r\n\t-webkit-tap-highlight-color: rgba(51, 181, 229, 0.4);\r\n}\r\n.leaflet-tile {\r\n\tfilter: inherit;\r\n\tvisibility: hidden;\r\n\t}\r\n.leaflet-tile-loaded {\r\n\tvisibility: inherit;\r\n\t}\r\n.leaflet-zoom-box {\r\n\twidth: 0;\r\n\theight: 0;\r\n\t-moz-box-sizing: border-box;\r\n\t     box-sizing: border-box;\r\n\tz-index: 800;\r\n\t}\r\n/* workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=888319 */\r\n.leaflet-overlay-pane svg {\r\n\t-moz-user-select: none;\r\n\t}\r\n\r\n.leaflet-pane         { z-index: 400; }\r\n\r\n.leaflet-tile-pane    { z-index: 200; }\r\n.leaflet-overlay-pane { z-index: 400; }\r\n.leaflet-shadow-pane  { z-index: 500; }\r\n.leaflet-marker-pane  { z-index: 600; }\r\n.leaflet-tooltip-pane   { z-index: 650; }\r\n.leaflet-popup-pane   { z-index: 700; }\r\n\r\n.leaflet-map-pane canvas { z-index: 100; }\r\n.leaflet-map-pane svg    { z-index: 200; }\r\n\r\n.leaflet-vml-shape {\r\n\twidth: 1px;\r\n\theight: 1px;\r\n\t}\r\n.lvml {\r\n\tbehavior: url(#default#VML);\r\n\tdisplay: inline-block;\r\n\tposition: absolute;\r\n\t}\r\n\r\n\r\n/* control positioning */\r\n\r\n.leaflet-control {\r\n\tposition: relative;\r\n\tz-index: 800;\r\n\tpointer-events: visiblePainted; /* IE 9-10 doesn't have auto */\r\n\tpointer-events: auto;\r\n\t}\r\n.leaflet-top,\r\n.leaflet-bottom {\r\n\tposition: absolute;\r\n\tz-index: 1000;\r\n\tpointer-events: none;\r\n\t}\r\n.leaflet-top {\r\n\ttop: 0;\r\n\t}\r\n.leaflet-right {\r\n\tright: 0;\r\n\t}\r\n.leaflet-bottom {\r\n\tbottom: 0;\r\n\t}\r\n.leaflet-left {\r\n\tleft: 0;\r\n\t}\r\n.leaflet-control {\r\n\tfloat: left;\r\n\tclear: both;\r\n\t}\r\n.leaflet-right .leaflet-control {\r\n\tfloat: right;\r\n\t}\r\n.leaflet-top .leaflet-control {\r\n\tmargin-top: 10px;\r\n\t}\r\n.leaflet-bottom .leaflet-control {\r\n\tmargin-bottom: 10px;\r\n\t}\r\n.leaflet-left .leaflet-control {\r\n\tmargin-left: 10px;\r\n\t}\r\n.leaflet-right .leaflet-control {\r\n\tmargin-right: 10px;\r\n\t}\r\n\r\n\r\n/* zoom and fade animations */\r\n\r\n.leaflet-fade-anim .leaflet-tile {\r\n\twill-change: opacity;\r\n\t}\r\n.leaflet-fade-anim .leaflet-popup {\r\n\topacity: 0;\r\n\t-webkit-transition: opacity 0.2s linear;\r\n\t   -moz-transition: opacity 0.2s linear;\r\n\t     -o-transition: opacity 0.2s linear;\r\n\t        transition: opacity 0.2s linear;\r\n\t}\r\n.leaflet-fade-anim .leaflet-map-pane .leaflet-popup {\r\n\topacity: 1;\r\n\t}\r\n.leaflet-zoom-animated {\r\n\t-webkit-transform-origin: 0 0;\r\n\t    -ms-transform-origin: 0 0;\r\n\t        transform-origin: 0 0;\r\n\t}\r\n.leaflet-zoom-anim .leaflet-zoom-animated {\r\n\twill-change: transform;\r\n\t}\r\n.leaflet-zoom-anim .leaflet-zoom-animated {\r\n\t-webkit-transition: -webkit-transform 0.25s cubic-bezier(0,0,0.25,1);\r\n\t   -moz-transition:    -moz-transform 0.25s cubic-bezier(0,0,0.25,1);\r\n\t     -o-transition:      -o-transform 0.25s cubic-bezier(0,0,0.25,1);\r\n\t        transition:         transform 0.25s cubic-bezier(0,0,0.25,1);\r\n\t}\r\n.leaflet-zoom-anim .leaflet-tile,\r\n.leaflet-pan-anim .leaflet-tile {\r\n\t-webkit-transition: none;\r\n\t   -moz-transition: none;\r\n\t     -o-transition: none;\r\n\t        transition: none;\r\n\t}\r\n\r\n.leaflet-zoom-anim .leaflet-zoom-hide {\r\n\tvisibility: hidden;\r\n\t}\r\n\r\n\r\n/* cursors */\r\n\r\n.leaflet-interactive {\r\n\tcursor: pointer;\r\n\t}\r\n.leaflet-grab {\r\n\tcursor: -webkit-grab;\r\n\tcursor:    -moz-grab;\r\n\t}\r\n.leaflet-crosshair,\r\n.leaflet-crosshair .leaflet-interactive {\r\n\tcursor: crosshair;\r\n\t}\r\n.leaflet-popup-pane,\r\n.leaflet-control {\r\n\tcursor: auto;\r\n\t}\r\n.leaflet-dragging .leaflet-grab,\r\n.leaflet-dragging .leaflet-grab .leaflet-interactive,\r\n.leaflet-dragging .leaflet-marker-draggable {\r\n\tcursor: move;\r\n\tcursor: -webkit-grabbing;\r\n\tcursor:    -moz-grabbing;\r\n\t}\r\n\r\n/* marker & overlays interactivity */\r\n.leaflet-marker-icon,\r\n.leaflet-marker-shadow,\r\n.leaflet-image-layer,\r\n.leaflet-pane > svg path,\r\n.leaflet-tile-container {\r\n\tpointer-events: none;\r\n\t}\r\n\r\n.leaflet-marker-icon.leaflet-interactive,\r\n.leaflet-image-layer.leaflet-interactive,\r\n.leaflet-pane > svg path.leaflet-interactive {\r\n\tpointer-events: visiblePainted; /* IE 9-10 doesn't have auto */\r\n\tpointer-events: auto;\r\n\t}\r\n\r\n/* visual tweaks */\r\n\r\n.leaflet-container {\r\n\tbackground: #ddd;\r\n\toutline: 0;\r\n\t}\r\n.leaflet-container a {\r\n\tcolor: #0078A8;\r\n\t}\r\n.leaflet-container a.leaflet-active {\r\n\toutline: 2px solid orange;\r\n\t}\r\n.leaflet-zoom-box {\r\n\tborder: 2px dotted #38f;\r\n\tbackground: rgba(255,255,255,0.5);\r\n\t}\r\n\r\n\r\n/* general typography */\r\n.leaflet-container {\r\n\tfont: 12px/1.5 \"Helvetica Neue\", Arial, Helvetica, sans-serif;\r\n\t}\r\n\r\n\r\n/* general toolbar styles */\r\n\r\n.leaflet-bar {\r\n\tbox-shadow: 0 1px 5px rgba(0,0,0,0.65);\r\n\tborder-radius: 4px;\r\n\t}\r\n.leaflet-bar a,\r\n.leaflet-bar a:hover {\r\n\tbackground-color: #fff;\r\n\tborder-bottom: 1px solid #ccc;\r\n\twidth: 26px;\r\n\theight: 26px;\r\n\tline-height: 26px;\r\n\tdisplay: block;\r\n\ttext-align: center;\r\n\ttext-decoration: none;\r\n\tcolor: black;\r\n\t}\r\n.leaflet-bar a,\r\n.leaflet-control-layers-toggle {\r\n\tbackground-position: 50% 50%;\r\n\tbackground-repeat: no-repeat;\r\n\tdisplay: block;\r\n\t}\r\n.leaflet-bar a:hover {\r\n\tbackground-color: #f4f4f4;\r\n\t}\r\n.leaflet-bar a:first-child {\r\n\tborder-top-left-radius: 4px;\r\n\tborder-top-right-radius: 4px;\r\n\t}\r\n.leaflet-bar a:last-child {\r\n\tborder-bottom-left-radius: 4px;\r\n\tborder-bottom-right-radius: 4px;\r\n\tborder-bottom: none;\r\n\t}\r\n.leaflet-bar a.leaflet-disabled {\r\n\tcursor: default;\r\n\tbackground-color: #f4f4f4;\r\n\tcolor: #bbb;\r\n\t}\r\n\r\n.leaflet-touch .leaflet-bar a {\r\n\twidth: 30px;\r\n\theight: 30px;\r\n\tline-height: 30px;\r\n\t}\r\n.leaflet-touch .leaflet-bar a:first-child {\r\n\tborder-top-left-radius: 2px;\r\n\tborder-top-right-radius: 2px;\r\n\t}\r\n.leaflet-touch .leaflet-bar a:last-child {\r\n\tborder-bottom-left-radius: 2px;\r\n\tborder-bottom-right-radius: 2px;\r\n\t}\r\n\r\n/* zoom control */\r\n\r\n.leaflet-control-zoom-in,\r\n.leaflet-control-zoom-out {\r\n\tfont: bold 18px 'Lucida Console', Monaco, monospace;\r\n\ttext-indent: 1px;\r\n\t}\r\n\r\n.leaflet-touch .leaflet-control-zoom-in, .leaflet-touch .leaflet-control-zoom-out  {\r\n\tfont-size: 22px;\r\n\t}\r\n\r\n\r\n/* layers control */\r\n\r\n.leaflet-control-layers {\r\n\tbox-shadow: 0 1px 5px rgba(0,0,0,0.4);\r\n\tbackground: #fff;\r\n\tborder-radius: 5px;\r\n\t}\r\n.leaflet-control-layers-toggle {\r\n\tbackground-image: url("+escape(__webpack_require__(162))+");\r\n\twidth: 36px;\r\n\theight: 36px;\r\n\t}\r\n.leaflet-retina .leaflet-control-layers-toggle {\r\n\tbackground-image: url("+escape(__webpack_require__(163))+");\r\n\tbackground-size: 26px 26px;\r\n\t}\r\n.leaflet-touch .leaflet-control-layers-toggle {\r\n\twidth: 44px;\r\n\theight: 44px;\r\n\t}\r\n.leaflet-control-layers .leaflet-control-layers-list,\r\n.leaflet-control-layers-expanded .leaflet-control-layers-toggle {\r\n\tdisplay: none;\r\n\t}\r\n.leaflet-control-layers-expanded .leaflet-control-layers-list {\r\n\tdisplay: block;\r\n\tposition: relative;\r\n\t}\r\n.leaflet-control-layers-expanded {\r\n\tpadding: 6px 10px 6px 6px;\r\n\tcolor: #333;\r\n\tbackground: #fff;\r\n\t}\r\n.leaflet-control-layers-scrollbar {\r\n\toverflow-y: scroll;\r\n\toverflow-x: hidden;\r\n\tpadding-right: 5px;\r\n\t}\r\n.leaflet-control-layers-selector {\r\n\tmargin-top: 2px;\r\n\tposition: relative;\r\n\ttop: 1px;\r\n\t}\r\n.leaflet-control-layers label {\r\n\tdisplay: block;\r\n\t}\r\n.leaflet-control-layers-separator {\r\n\theight: 0;\r\n\tborder-top: 1px solid #ddd;\r\n\tmargin: 5px -10px 5px -6px;\r\n\t}\r\n\r\n/* Default icon URLs */\r\n.leaflet-default-icon-path {\r\n\tbackground-image: url("+escape(__webpack_require__(164))+');\r\n\t}\r\n\r\n\r\n/* attribution and scale controls */\r\n\r\n.leaflet-container .leaflet-control-attribution {\r\n\tbackground: #fff;\r\n\tbackground: rgba(255, 255, 255, 0.7);\r\n\tmargin: 0;\r\n\t}\r\n.leaflet-control-attribution,\r\n.leaflet-control-scale-line {\r\n\tpadding: 0 5px;\r\n\tcolor: #333;\r\n\t}\r\n.leaflet-control-attribution a {\r\n\ttext-decoration: none;\r\n\t}\r\n.leaflet-control-attribution a:hover {\r\n\ttext-decoration: underline;\r\n\t}\r\n.leaflet-container .leaflet-control-attribution,\r\n.leaflet-container .leaflet-control-scale {\r\n\tfont-size: 11px;\r\n\t}\r\n.leaflet-left .leaflet-control-scale {\r\n\tmargin-left: 5px;\r\n\t}\r\n.leaflet-bottom .leaflet-control-scale {\r\n\tmargin-bottom: 5px;\r\n\t}\r\n.leaflet-control-scale-line {\r\n\tborder: 2px solid #777;\r\n\tborder-top: none;\r\n\tline-height: 1.1;\r\n\tpadding: 2px 5px 1px;\r\n\tfont-size: 11px;\r\n\twhite-space: nowrap;\r\n\toverflow: hidden;\r\n\t-moz-box-sizing: border-box;\r\n\t     box-sizing: border-box;\r\n\r\n\tbackground: #fff;\r\n\tbackground: rgba(255, 255, 255, 0.5);\r\n\t}\r\n.leaflet-control-scale-line:not(:first-child) {\r\n\tborder-top: 2px solid #777;\r\n\tborder-bottom: none;\r\n\tmargin-top: -2px;\r\n\t}\r\n.leaflet-control-scale-line:not(:first-child):not(:last-child) {\r\n\tborder-bottom: 2px solid #777;\r\n\t}\r\n\r\n.leaflet-touch .leaflet-control-attribution,\r\n.leaflet-touch .leaflet-control-layers,\r\n.leaflet-touch .leaflet-bar {\r\n\tbox-shadow: none;\r\n\t}\r\n.leaflet-touch .leaflet-control-layers,\r\n.leaflet-touch .leaflet-bar {\r\n\tborder: 2px solid rgba(0,0,0,0.2);\r\n\tbackground-clip: padding-box;\r\n\t}\r\n\r\n\r\n/* popup */\r\n\r\n.leaflet-popup {\r\n\tposition: absolute;\r\n\ttext-align: center;\r\n\tmargin-bottom: 20px;\r\n\t}\r\n.leaflet-popup-content-wrapper {\r\n\tpadding: 1px;\r\n\ttext-align: left;\r\n\tborder-radius: 12px;\r\n\t}\r\n.leaflet-popup-content {\r\n\tmargin: 13px 19px;\r\n\tline-height: 1.4;\r\n\t}\r\n.leaflet-popup-content p {\r\n\tmargin: 18px 0;\r\n\t}\r\n.leaflet-popup-tip-container {\r\n\twidth: 40px;\r\n\theight: 20px;\r\n\tposition: absolute;\r\n\tleft: 50%;\r\n\tmargin-left: -20px;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\t}\r\n.leaflet-popup-tip {\r\n\twidth: 17px;\r\n\theight: 17px;\r\n\tpadding: 1px;\r\n\r\n\tmargin: -10px auto 0;\r\n\r\n\t-webkit-transform: rotate(45deg);\r\n\t   -moz-transform: rotate(45deg);\r\n\t    -ms-transform: rotate(45deg);\r\n\t     -o-transform: rotate(45deg);\r\n\t        transform: rotate(45deg);\r\n\t}\r\n.leaflet-popup-content-wrapper,\r\n.leaflet-popup-tip {\r\n\tbackground: white;\r\n\tcolor: #333;\r\n\tbox-shadow: 0 3px 14px rgba(0,0,0,0.4);\r\n\t}\r\n.leaflet-container a.leaflet-popup-close-button {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tpadding: 4px 4px 0 0;\r\n\tborder: none;\r\n\ttext-align: center;\r\n\twidth: 18px;\r\n\theight: 14px;\r\n\tfont: 16px/14px Tahoma, Verdana, sans-serif;\r\n\tcolor: #c3c3c3;\r\n\ttext-decoration: none;\r\n\tfont-weight: bold;\r\n\tbackground: transparent;\r\n\t}\r\n.leaflet-container a.leaflet-popup-close-button:hover {\r\n\tcolor: #999;\r\n\t}\r\n.leaflet-popup-scrolled {\r\n\toverflow: auto;\r\n\tborder-bottom: 1px solid #ddd;\r\n\tborder-top: 1px solid #ddd;\r\n\t}\r\n\r\n.leaflet-oldie .leaflet-popup-content-wrapper {\r\n\tzoom: 1;\r\n\t}\r\n.leaflet-oldie .leaflet-popup-tip {\r\n\twidth: 24px;\r\n\tmargin: 0 auto;\r\n\r\n\t-ms-filter: "progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678)";\r\n\tfilter: progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678);\r\n\t}\r\n.leaflet-oldie .leaflet-popup-tip-container {\r\n\tmargin-top: -1px;\r\n\t}\r\n\r\n.leaflet-oldie .leaflet-control-zoom,\r\n.leaflet-oldie .leaflet-control-layers,\r\n.leaflet-oldie .leaflet-popup-content-wrapper,\r\n.leaflet-oldie .leaflet-popup-tip {\r\n\tborder: 1px solid #999;\r\n\t}\r\n\r\n\r\n/* div icon */\r\n\r\n.leaflet-div-icon {\r\n\tbackground: #fff;\r\n\tborder: 1px solid #666;\r\n\t}\r\n\r\n\r\n/* Tooltip */\r\n/* Base styles for the element that has a tooltip */\r\n.leaflet-tooltip {\r\n\tposition: absolute;\r\n\tpadding: 6px;\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #fff;\r\n\tborder-radius: 3px;\r\n\tcolor: #222;\r\n\twhite-space: nowrap;\r\n\t-webkit-user-select: none;\r\n\t-moz-user-select: none;\r\n\t-ms-user-select: none;\r\n\tuser-select: none;\r\n\tpointer-events: none;\r\n\tbox-shadow: 0 1px 3px rgba(0,0,0,0.4);\r\n\t}\r\n.leaflet-tooltip.leaflet-clickable {\r\n\tcursor: pointer;\r\n\tpointer-events: auto;\r\n\t}\r\n.leaflet-tooltip-top:before,\r\n.leaflet-tooltip-bottom:before,\r\n.leaflet-tooltip-left:before,\r\n.leaflet-tooltip-right:before {\r\n\tposition: absolute;\r\n\tpointer-events: none;\r\n\tborder: 6px solid transparent;\r\n\tbackground: transparent;\r\n\tcontent: "";\r\n\t}\r\n\r\n/* Directions */\r\n\r\n.leaflet-tooltip-bottom {\r\n\tmargin-top: 6px;\r\n}\r\n.leaflet-tooltip-top {\r\n\tmargin-top: -6px;\r\n}\r\n.leaflet-tooltip-bottom:before,\r\n.leaflet-tooltip-top:before {\r\n\tleft: 50%;\r\n\tmargin-left: -6px;\r\n\t}\r\n.leaflet-tooltip-top:before {\r\n\tbottom: 0;\r\n\tmargin-bottom: -12px;\r\n\tborder-top-color: #fff;\r\n\t}\r\n.leaflet-tooltip-bottom:before {\r\n\ttop: 0;\r\n\tmargin-top: -12px;\r\n\tmargin-left: -6px;\r\n\tborder-bottom-color: #fff;\r\n\t}\r\n.leaflet-tooltip-left {\r\n\tmargin-left: -6px;\r\n}\r\n.leaflet-tooltip-right {\r\n\tmargin-left: 6px;\r\n}\r\n.leaflet-tooltip-left:before,\r\n.leaflet-tooltip-right:before {\r\n\ttop: 50%;\r\n\tmargin-top: -6px;\r\n\t}\r\n.leaflet-tooltip-left:before {\r\n\tright: 0;\r\n\tmargin-right: -12px;\r\n\tborder-left-color: #fff;\r\n\t}\r\n.leaflet-tooltip-right:before {\r\n\tleft: 0;\r\n\tmargin-left: -12px;\r\n\tborder-right-color: #fff;\r\n\t}\r\n',""])},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAQAAAADQ4RFAAACf0lEQVR4AY1UM3gkARTePdvdoTxXKc+qTl3aU5U6b2Kbkz3Gtq3Zw6ziLGNPzrYx7946Tr6/ee/XeCQ4D3ykPtL5tHno4n0d/h3+xfuWHGLX81cn7r0iTNzjr7LrlxCqPtkbTQEHeqOrTy4Yyt3VCi/IOB0v7rVC7q45Q3Gr5K6jt+3Gl5nCoDD4MtO+j96Wu8atmhGqcNGHObuf8OM/x3AMx38+4Z2sPqzCxRFK2aF2e5Jol56XTLyggAMTL56XOMoS1W4pOyjUcGGQdZxU6qRh7B9Zp+PfpOFlqt0zyDZckPi1ttmIp03jX8gyJ8a/PG2yutpS/Vol7peZIbZcKBAEEheEIAgFbDkz5H6Zrkm2hVWGiXKiF4Ycw0RWKdtC16Q7qe3X4iOMxruonzegJzWaXFrU9utOSsLUmrc0YjeWYjCW4PDMADElpJSSQ0vQvA1Tm6/JlKnqFs1EGyZiFCqnRZTEJJJiKRYzVYzJck2Rm6P4iH+cmSY0YzimYa8l0EtTODFWhcMIMVqdsI2uiTvKmTisIDHJ3od5GILVhBCarCfVRmo4uTjkhrhzkiBV7SsaqS+TzrzM1qpGGUFt28pIySQHR6h7F6KSwGWm97ay+Z+ZqMcEjEWebE7wxCSQwpkhJqoZA5ivCdZDjJepuJ9IQjGGUmuXJdBFUygxVqVsxFsLMbDe8ZbDYVCGKxs+W080max1hFCarCfV+C1KATwcnvE9gRRuMP2prdbWGowm1KB1y+zwMMENkM755cJ2yPDtqhTI6ED1M/82yIDtC/4j4BijjeObflpO9I9MwXTCsSX8jWAFeHr05WoLTJ5G8IQVS/7vwR6ohirYM7f6HzYpogfS3R2OAAAAAElFTkSuQmCC"},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAQAAABvcdNgAAAEsklEQVR4AWL4TydIhpZK1kpWOlg0w3ZXP6D2soBtG42jeI6ZmQTHzAxiTbSJsYLjO9HhP+WOmcuhciVnmHVQcJnp7DFvScowZorad/+V/fVzMdMT2g9Cv9guXGv/7pYOrXh2U+RRR3dSd9JRx6bIFc/ekqHI29JC6pJ5ZEh1yWkhkbcFeSjxgx3L2m1cb1C7bceyxA+CNjT/Ifff+/kDk2u/w/33/IeCMOSaWZ4glosqT3DNnNZQ7Cs58/3Ce5HL78iZH/vKVIaYlqzfdLu8Vi7dnvUbEza5Idt36tquZFldl6N5Z/POLof0XLK61mZCmJSWjVF9tEjUluu74IUXvgttuVIHE7YxSkaYhJZam7yiM9Pv82JYfl9nptxZaxMJE4YSPty+vF0+Y2up9d3wwijfjZbabqm/3bZ9ecKHsiGmRflnn1MW4pjHf9oLufyn2z3y1D6n8g8TZhxyzipLNPnAUpsOiuWimg52psrTZYnOWYNDTMuWBWa0tJb4rgq1UvmutpaYEbZlwU3CLJm/ayYjHW5/h7xWLn9Hh1vepDkyf7dE7MtT5LR4e7yYpHrkhOUpEfssBLq2pPhAqoSWKUkk7EDqkmK6RrCEzqDjhNDWNE+XSMvkJRDWlZTmCW0l0PHQGRZY5t1L83kT0Y3l2SItk5JAWHl2dCOBm+fPu3fo5/3v61RMCO9Jx2EEYYhb0rmNQMX/vm7gqOEJLcXTGw3CAuRNeyaPWwjR8PRqKQ1PDA/dpv+on9Shox52WFnx0KY8onHayrJzm87i5h9xGw/tfkev0jGsQizqezUKjk12hBMKJ4kbCqGPVNXudyyrShovGw5CgxsRICxF6aRmSjlBnHRzg7Gx8fKqEubI2rahQYdR1YgDIRQO7JvQyD52hoIQx0mxa0ODtW2Iozn1le2iIRdzwWewedyZzewidueOGqlsn1MvcnQpuVwLGG3/IR1hIKxCjelIDZ8ldqWz25jWAsnldEnK0Zxro19TGVb2ffIZEsIO89EIEDvKMPrzmBOQcKQ+rroye6NgRRxqR4U8EAkz0CL6uSGOm6KQCdWjvjRiSP1BPalCRS5iQYiEIvxuBMJEWgzSoHADcVMuN7IuqqTeyUPq22qFimFtxDyBBJEwNyt6TM88blFHao/6tWWhuuOM4SAK4EI4QmFHA+SEyWlp4EQoJ13cYGzMu7yszEIBOm2rVmHUNqwAIQabISNMRstmdhNWcFLsSm+0tjJH1MdRxO5Nx0WDMhCtgD6OKgZeljJqJKc9po8juskR9XN0Y1lZ3mWjLR9JCO1jRDMd0fpYC2VnvjBSEFg7wBENc0R9HFlb0xvF1+TBEpF68d+DHR6IOWVv2BECtxo46hOFUBd/APU57WIoEwJhIi2CdpyZX0m93BZicktMj1AS9dClteUFAUNUIEygRZCtik5zSxI9MubTBH1GOiHsiLJ3OCoSZkILa9PxiN0EbvhsAo8tdAf9Seepd36lGWHmtNANTv5Jd0z4QYyeo/UEJqxKRpg5LZx6btLPsOaEmdMyxYdlc8LMaJnikDlhclqmPiQnTEpLUIZEwkRagjYkEibQErwhkTAKCLQEbUgkzJQWc/0PstHHcfEdQ+UAAAAASUVORK5CYII="},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII="},function(module,exports,__webpack_require__){exports=module.exports=__webpack_require__(10)(!1),exports.push([module.i,".leaflet-cluster-anim .leaflet-marker-icon, .leaflet-cluster-anim .leaflet-marker-shadow {\r\n\t-webkit-transition: -webkit-transform 0.3s ease-out, opacity 0.3s ease-in;\r\n\t-moz-transition: -moz-transform 0.3s ease-out, opacity 0.3s ease-in;\r\n\t-o-transition: -o-transform 0.3s ease-out, opacity 0.3s ease-in;\r\n\ttransition: transform 0.3s ease-out, opacity 0.3s ease-in;\r\n}\r\n\r\n.leaflet-cluster-spider-leg {\r\n\t/* stroke-dashoffset (duration and function) should match with leaflet-marker-icon transform in order to track it exactly */\r\n\t-webkit-transition: -webkit-stroke-dashoffset 0.3s ease-out, -webkit-stroke-opacity 0.3s ease-in;\r\n\t-moz-transition: -moz-stroke-dashoffset 0.3s ease-out, -moz-stroke-opacity 0.3s ease-in;\r\n\t-o-transition: -o-stroke-dashoffset 0.3s ease-out, -o-stroke-opacity 0.3s ease-in;\r\n\ttransition: stroke-dashoffset 0.3s ease-out, stroke-opacity 0.3s ease-in;\r\n}\r\n",""])},function(module,exports,__webpack_require__){var escape=__webpack_require__(27);exports=module.exports=__webpack_require__(10)(!1),exports.push([module.i,".leaflet-control-geocoder {\n\tborder-radius: 4px;\n\tbackground: white;\n\tmin-width: 26px;\n\tmin-height: 26px;\n}\n\n.leaflet-touch .leaflet-control-geocoder {\n\tmin-width: 30px;\n\tmin-height: 30px;\n}\n\n.leaflet-control-geocoder a, .leaflet-control-geocoder .leaflet-control-geocoder-icon {\n\tborder-bottom: none;\n\tdisplay: inline-block;\n}\n\n.leaflet-control-geocoder .leaflet-control-geocoder-alternatives a {\n\twidth: inherit;\n\theight: inherit;\n\tline-height: inherit;\n}\n\n.leaflet-control-geocoder a:hover, .leaflet-control-geocoder .leaflet-control-geocoder-icon:hover {\n\tborder-bottom: none;\n\tdisplay: inline-block;\n}\n\n.leaflet-control-geocoder-form {\n\tdisplay: none;\n\tvertical-align: middle;\n}\n.leaflet-control-geocoder-expanded .leaflet-control-geocoder-form {\n\tdisplay: inline-block;\n}\n.leaflet-control-geocoder-form input {\n\tfont-size: 120%;\n\tborder: 0;\n\tbackground-color: transparent;\n\twidth: 246px;\n}\n\n.leaflet-control-geocoder-icon {\n\tborder-radius: 4px;\n\twidth: 26px;\n\theight: 26px;\n\tborder: none;\n\tbackground-color: white;\n\tbackground-image: url("+escape(__webpack_require__(167))+");\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tcursor: pointer;\n}\n\n.leaflet-touch .leaflet-control-geocoder-icon {\n\twidth: 30px;\n\theight: 30px;\n}\n\n.leaflet-control-geocoder-throbber .leaflet-control-geocoder-icon {\n\tbackground-image: url("+escape(__webpack_require__(168))+");\n}\n\n.leaflet-control-geocoder-form-no-error {\n\tdisplay: none;\n}\n\n.leaflet-control-geocoder-form input:focus {\n\toutline: none;\n}\n\n.leaflet-control-geocoder-form button {\n\tdisplay: none;\n}\n.leaflet-control-geocoder-error {\n\tmargin-top: 8px;\n\tmargin-left: 8px;\n\tdisplay: block;\n\tcolor: #444;\n}\n.leaflet-control-geocoder-alternatives {\n\tdisplay: block;\n\twidth: 272px;\n\tlist-style: none;\n\tpadding: 0;\n\tmargin: 0;\n}\n\n.leaflet-control-geocoder-alternatives-minimized {\n\tdisplay: none;\n\theight: 0;\n}\n.leaflet-control-geocoder-alternatives li {\n\twhite-space: nowrap;\n\tdisplay: block;\n\toverflow: hidden;\n\tpadding: 5px 8px;\n\ttext-overflow: ellipsis;\n\tborder-bottom: 1px solid #ccc;\n\tcursor: pointer;\n}\n\n.leaflet-control-geocoder-alternatives li a, .leaflet-control-geocoder-alternatives li a:hover {\n\twidth: inherit;\n\theight: inherit;\n\tline-height: inherit;\n\tbackground: inherit;\n\tborder-radius: inherit;\n\ttext-align: left;\n}\n\n.leaflet-control-geocoder-alternatives li:last-child {\n\tborder-bottom: none;\n}\n.leaflet-control-geocoder-alternatives li:hover, .leaflet-control-geocoder-selected {\n\tbackground-color: #f5f5f5;\n}\n.leaflet-control-geocoder-address-detail {\n\t\n}\n.leaflet-control-geocoder-address-context {\n\tcolor: #666;\n}",""])},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAMAAACelLz8AAAAz1BMVEUAAAAkJCQmJiYmJiYlJSUkJCQAAAAqKiokJCQmJiYzMzMlJSUkJCQmJiYlJSUmJiYoKCgmJiYmJiYnJycmJiYAAAAmJiYmJiYlJSUZGRklJSUmJiYmJiYlJSUlJSUmJiYmJiYtLS0mJiYlJSUmJiYnJyccHBwmJiYmJiYlJSUiIiImJiYmJiYmJiYlJSUkJCQlJSUjIyMuLi4mJiYmJiYlJSUlJSUlJSUAAAAmJiYlJSUoKCglJSUlJSUmJiYmJiYlJSUlJSUlJSUlJSUmJiawjvnZAAAARHRSTlMARfbw3jEDBkb+BatNZMu1GfHGDdQBoPjyCsOfFD2C/LQRaqiTVQmMcFkW4uR961pnOQshyWDgnAKuzDP5uPVW+tp5S3AUDfcAAACGSURBVBgZzcFFAoMwAATARQN1d3d3d9n/v6n0SsKdGYROrW7ZUMlWm+SsD1kkw1ZnPnXHkMTZADAxFwP4JdMCnhU1+CVy+NO4hF+02IbnwzX8YuwKwDLeNiQFHo7nG7+Q5UcmX/eH/oTK5oQLjS3Urjp3Amp7cogAPboO1ESl5CBAOYVQ+QEjbg1iCZEUOgAAAABJRU5ErkJggg=="},function(module,exports){module.exports="data:image/gif;base64,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"},function(module,exports,__webpack_require__){var escape=__webpack_require__(27);exports=module.exports=__webpack_require__(10)(!1),exports.push([module.i,".leaflet-control-measure h3,.leaflet-measure-resultpopup h3{margin:0 0 12px 0;padding-bottom:10px;line-height:1em;font-weight:normal;font-size:1.1em;border-bottom:solid 1px #DDD}.leaflet-control-measure p,.leaflet-measure-resultpopup p{margin:10px 0 0;line-height:1em}.leaflet-control-measure p:first-child,.leaflet-measure-resultpopup p:first-child{margin-top:0}.leaflet-control-measure a,.leaflet-measure-resultpopup a{color:#5E66CC;text-decoration:none}.leaflet-control-measure a:hover,.leaflet-measure-resultpopup a:hover{opacity:0.5;text-decoration:none}.leaflet-control-measure .tasks,.leaflet-measure-resultpopup .tasks{margin:12px 0 0;padding:10px 0 0;border-top:solid 1px #DDD;list-style:none;list-style-image:none}.leaflet-control-measure .tasks li,.leaflet-measure-resultpopup .tasks li{display:inline;margin:0 10px 0 0}.leaflet-control-measure .tasks li:last-child,.leaflet-measure-resultpopup .tasks li:last-child{margin-right:0}.leaflet-control-measure .coorddivider,.leaflet-measure-resultpopup .coorddivider{color:#999}.leaflet-control-measure{background:#fff;border-radius:5px;box-shadow:0 1px 5px rgba(0,0,0,0.4)}.leaflet-control-measure .leaflet-control-measure-toggle,.leaflet-control-measure .leaflet-control-measure-toggle:hover{display:block;width:36px;height:36px;background-position:50% 50%;background-repeat:no-repeat;background-image:url("+escape(__webpack_require__(170))+");border-radius:5px;text-indent:100%;white-space:nowrap;overflow:hidden}.leaflet-retina .leaflet-control-measure .leaflet-control-measure-toggle,.leaflet-retina .leaflet-control-measure .leaflet-control-measure-toggle:hover{background-image:url("+escape(__webpack_require__(171))+");background-size:16px 16px}.leaflet-touch .leaflet-control-measure .leaflet-control-measure-toggle,.leaflet-touch .leaflet-control-measure .leaflet-control-measure-toggle:hover{width:44px;height:44px}.leaflet-control-measure .startprompt h3{margin-bottom:10px}.leaflet-control-measure .startprompt .tasks{margin-top:0;padding-top:0;border-top:0}.leaflet-control-measure .leaflet-control-measure-interaction{padding:10px 12px}.leaflet-control-measure .results .group{margin-top:10px;padding-top:10px;border-top:dotted 1px #eaeaea}.leaflet-control-measure .results .group:first-child{margin-top:0;padding-top:0;border-top:0}.leaflet-control-measure .results .heading{margin-right:5px;color:#999}.leaflet-control-measure a.start{padding-left:18px;background-repeat:no-repeat;background-position:0% 50%;background-image:url("+escape(__webpack_require__(172))+")}.leaflet-retina .leaflet-control-measure a.start{background-image:url("+escape(__webpack_require__(173))+");background-size:12px 12px}.leaflet-control-measure a.cancel{padding-left:18px;background-repeat:no-repeat;background-position:0% 50%;background-image:url("+escape(__webpack_require__(174))+")}.leaflet-retina .leaflet-control-measure a.cancel{background-image:url("+escape(__webpack_require__(175))+");background-size:12px 12px}.leaflet-control-measure a.finish{padding-left:18px;background-repeat:no-repeat;background-position:0% 50%;background-image:url("+escape(__webpack_require__(176))+")}.leaflet-retina .leaflet-control-measure a.finish{background-image:url("+escape(__webpack_require__(177))+");background-size:12px 12px}.leaflet-measure-resultpopup a.zoomto{padding-left:18px;background-repeat:no-repeat;background-position:0% 50%;background-image:url("+escape(__webpack_require__(178))+")}.leaflet-retina .leaflet-measure-resultpopup a.zoomto{background-image:url("+escape(__webpack_require__(179))+");background-size:12px 12px}.leaflet-measure-resultpopup a.deletemarkup{padding-left:18px;background-repeat:no-repeat;background-position:0% 50%;background-image:url("+escape(__webpack_require__(180))+")}.leaflet-retina .leaflet-measure-resultpopup a.deletemarkup{background-image:url("+escape(__webpack_require__(181))+");background-size:11px 12px}\n",""])},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAGJJREFUOI1jYGBgOM3AwPAfCTMwMDA8QxPDhT8xoAlIM5AG/jMi2QoDjKQYwITEkSFRM9w2qrkA5oqBc8EIDYNHDAzkp0I4QE/fMDF5YvnoBsiTwscWBiQBJgYGhpMU6D8CAJDrOVecOVsbAAAAAElFTkSuQmCC"},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAALdJREFUWIXtl0EKwkAMRZ+iR1LwCC5ceekKHsSqN3ARF5pFi41lmGQU8iDQkkB/0k/aATgCV0AmQjkbNaXRAdy+FCmdgwDBSGzwRQBZGgUrZwEALBiOearGAwGwJhDCJwFbXl1rhAsIefdKesASoF5oJiD3QAi5B9IDuQeaeyDU8SNOwEOVRP4LDvirPSAe9yXd7oB1rXzJBKrm50ygasdj5kzAlZ/4FtwbPr8HOLwvPE6+VlyA/ROEjYEpRhLQZgAAAABJRU5ErkJggg=="},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAY1JREFUKJF9kL9PEwEcxd/3y+XaXrwKCZsx4uLQiQQRZHOUmYEU45mL1CCVpH+JwxEx6CB6HfixM7KQ8sM2TB2cHHRzMCTt2cbe+zrUSxsHP+PLey/v+xX8ZaXWKHgddxNAmcYSACjQNpW69jtv9vYe9QBAAKActu44TnpMwlXRyEQuhzW2IMAWgcSZ4OMPOw++yUqtUfC6TgvEl8QflI9eL/3CGJVK0+uB+4TencoV59TruJsk3MwcvLiaCZ635rLA7u79hIm7qqR/3bt+qQDKKhplzTROm6aNp+ufq1kojme7prpNsTWlsTTanKEuRKIn683DtVfnxeGxcqHUkuI/iBj/1RwF2gZbAHCWiST7KlL79G5+Z2TlQwBtNZW6AFuVStMDgHSAHxOwxY9j5jA89QGpQiSWIDjJpzm/qeBXJu5qHM92xyeE4an/W3MHgN2aLEzOCwA827i8PUj1WEnfVLcFcjGaIVUjfxJcrr9f/C5ZUxCc5M29sTF8nZaGqrUhEt/MF99G0b0+APwB15Gn8fy9beQAAAAASUVORK5CYII="},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAA41JREFUSImNlU9oVFcUxn/ne28UxKWIRKiYpRaqZpIUagm6aZfiQlLNRBzyT+nGNmiLe2nUtkLBJhnRxolRoVBc1GXqIoqZTEoW6sZN/VNqTXdWsJl553YxkzSkM5N8m/feved837mP891jNMCx44XmJFEnsA/3nQ6bAEzMG3pMYNIU3Rgb2f1bPQ6rtdjV82A7Fp8j+EFJalSEu7vJfkzKOjVxpeXpqgKZ3kImBIYlbagSlGS6G2Aa+APAjCag3d07JKWqUm/M1T92OX29rkB338xpsK8AHN5aCN/E5eji1at75muedGBus8oLJx1OSloPEEIYzOdav/6fQKa3kDHTNYDg4YlH0YHrI3seN/o9/wkV3rVEt81oroocyedaJ5YEunoebAc9lLQheHgS4tTe8eFdr9ZCvoijJ6a3eCm6Z0Yz7n8HaWd+NP1MAFI8JGmDw1uPogMrybPZ2SYINRtiEWOX2l8G6SD4AtJGgyEAO3a80Fwq8USSQghn87nWMyuTM30zA0Y4UEJdN0bTfzUS6u4pXED63N3dPWpWkqhTkty9FJeji/VT9VHkYe5IT/HDRgK2LlwAEkmKY+8UsA9Aprv1umVJQrY1Er909xa/rPfLxi61vwSmANzDfuG+E6Da52tBhHE201O880lfcVPNiBAKlYK0Q4v2p2qitcJkH0ce5jJ9xb01dn+vPH1zw2tgNUgWVo0xMQ9L9l87AndCKtmVH01P1djcWqV/FRt6DJW7ZU3ETtktnBnPpc9D7RN4oF0G4I9EYBLA3Tu6BuY2N+QOPHfzjvFc67l65NnsbJNkH1TibVKm6Ia7u6SUygsn65EH959tXbJ7PNd2v1ERpTgMAhGQmNlNA8j0zdwy7JC7/0NMeny47eHypKMnpreMXWr7s17Vi8gMFHaHMtOSUrhPXLvcdkQASVmnwN9IWm+Jbh89Mb1leWLFPI3Js9nZJnN+kpRyeJ3gpwEEMHGl5am5+gHMaPZSdK+r/9f3GhGurLwcJ/dB2wAM671++f0Xlfdl6O4tDmKcr3z5As53ti5cqNq/ZtWlOAwG90+XJlsIn13LtX67GFNjZM4cthBGkDZWlxJgqmL/RYeGrR5or3ZLBODw2rDe/GjLreV8NS+sTF/xHYMhdz+02tAHEtxvKcUXP3zf9nzlZsMhcjg7uy2OvdM97Je0A7zqE70Cf+TBJs3sZn40/awex78erYTTwi3/3gAAAABJRU5ErkJggg=="},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAS9JREFUKJGFkDFOAlEURc8dRphJFNmBHYnQYbTHDnsa0BDBRq1YC4naIQbWYEloqKQyswIXQEgwDIn5z2IATUR95X/nvpz7xWqq7XEYztO3QM2wAoCkyLCBt5zf9XrlGEAAtebkwPfdM+iQLWMQpVKu8nh/8qZqexyG7zuT3+DvoVwme+QlGmtYTcMGG8h4MnOtlUpxFs9ufKD2BbjTULqMwZlhobhaoO5mL+q+YQUlVZB0HoMF0EKwwLpC9XVApoL3w9UwgOk00LYuvqQIKK2dEw3rBrmFhSR6wMXqXOQbNhAqJQ9utECJhiAGc7KRZ1oF1FejMQxcZu9FUPznW19zmeyx1+uV41TKVQyiv2DnPs46nfxyU6zRGAaW3r02UZepsHYG9feD7EOnk18CfAKwIX1qvqPBeQAAAABJRU5ErkJggg=="},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAApxJREFUSImtlr1PWlEYxp/ncE1KYWy6Gh3FwUZiOtiYuqlbGwxRaKJRjI5tqon/gf4BpqIxERC1doaNxLaD8SNxUOdqOukoiLHc83YALdwPhLbP+J5zfs977n3OPZeoo7Hp/XbTVGEArwEEBHhWHpErgmcQ5Kg8m+vLL364MehUjEzstZHGIiBvSKp6TYiIBvHFLKnZ9Fr3+aMG0cn9KKg+EXhaD+xgVaDm1PpqcKO6WtPdu9jBHKkSzcMBgD5RSEVjhx9qqtWdkyrRPNguAUaT8WD6wSAysddGZZz8XedODpIXMpCMBy8UAChlLNjgInmIHgTwvQ5qtzxHCjVV0k9gAQDU2PR+u4i8ta4kVSix0pMtGk8GAPnmBNc3xlBipScLkZB9EzI8Mn7UqkxThZ2iKNDzoZkT/85SZ75oeActJrv6xhhKpboKoZkTP6jm7Q1SGYYOK5QPkYP4ylsqZiKRY9/OUmde37QMiMhXK9xbus0C6HUiCNivAAScDcom9P7KRCLHvlSqqyDFlsFG4QBAoIPR2OEdgRZ3E6C6awBoBF7Zw13dz8D/kALk6pE5Nc/8z4t3TVeVeKkInjUK95Zus95SMVMnXRbJqYIg1ygcQG+ddNmkBTlF5dkUEW031wvuaalNF1T51FpkktwiAERjB9sEhy0OBYiEKofILS27Qlmk4DNAn2UsnYgHRw0AMEtq1jD0UO0k+kBmXMD36qOwz7Z54Frr0hxQuQ/Sa93n1Jx6BNaEOLmx+vLngwEArK8GNyD4+M9skffJePf2g5V1PBo7HKHIMkh/U1zgGuBkNRywXJkAkIwH00IGAGw5pssuE0Da49EBKxxw+au418j4Uath6LCA/QQ6AHleWXYJyKkW5EhuJePBCzfGbyl+TiY9AObiAAAAAElFTkSuQmCC"},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAASVJREFUKJF1kDFLAgEYhp/37tQ7KPMftAnZZtjSkg2B7S5KHLRVk3O/IQiEakzQra2h0SannOR+QWuLYKF03teQwkHeO3483/e+7ydWanZGQTDLXwMtwyoAkiLDBs5idt/r1ecAAmhdjHc9L3kF7bFBBpHrJo2nh8MPNTujIPjKjbPg9FKpUDxw/mJkw2Y8G3wL9qfz6ZUDtLLP2l0gQiACMNF21gVX+kzDvnQzx14ENQCZKk7K+s39cSoGkzQMOkmbepIioCpxHOeW57l4ceR5/nITDBZ5hg2EqgBCt7FXyMXY6X8YQH2F4dBPCtvvgv3M8oDBpFQo1pxerz533aRhq09kwUkSn3W75YXWwzAc+pbfujTRlqmyzgzq7/jFx263vAD4BStdctyYQ7zEAAAAAElFTkSuQmCC"},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAlZJREFUSImllr9PU1EYhp/3tJMyGqIuBhYNnQyXhMRJNlcHg0AxIC3pqhFi4iCLCf4FtFaUFgok/AMmBldSqpOwuAhhghFx6r2fAwX641Jy6zu+57vP+30n5+Rc0UYTmXKv77th4CGQMLhxumJHQrsYm3Kx1aXs/d+XMRRmjk1t9Ujx92CPJbl2TZhZgNjwq26mtNi/d2VAMlVOIrcguNYOHBJ1okDTS3lvpd5t6G48vT0ruUJ0OICum2M5ma68bHDrO5dcITq4VQajxZxXOg8Ym9rqkYv/7KzzsAT7Y1KimPP2HYBz8fn/gRv8bTCkLsE8gCYy5d5qVb+uOi1ttOQH1Tcxxb8i7l4MYYHvu17n+264c7h97rnVP7mSHzxAZBqHkIvHg2HH6SXqEO49n5tT8CxduWdGqaUCDTkgERlt9qkeHhjfJG421wn63MX1b8F8waiGwXtve1NXwWvV3aF7b5At5LxHOHtaHxINfioHdtRq6gfICtmBjbOQTuCgQye02zpBsDCerkwB1EIeRIcD2I7GU5XXiHchixaI1HJ24OOZEw0Ogdmsk4utmlkQMp6c8SGZKk92Agd8SWsCSKa314WehNeZmektkIkABygVct6oA/CrbgbsJLxOkpiLAjc49oPqLNTeg9Ji/54CTUfo7goptZIfPDgPAFjKeysYr/6bbfaimOtfP49qXk+mKyMyyyJ1ReLCMShVD4emJxOgmPNKJiWAtfDT1SIfKMViQaIZDpf8VZxpZPL7nXg8GDY0JOgD6659dgi2ExibktaKOW//MsY/pXkXxnBJQFMAAAAASUVORK5CYII="},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAOhJREFUKJGVkTFug0AQRd+sgBOkyT1MvxVdipQpbDcBrsExAq4iipQWpbvt1xeJlBNgsZPCYK1sJ1GmfX//PM3CP0cAXqrjQwqVqmbG4N7b3AFsa29DwIrIeILuo1t9GYAUKqD4pbiYMyQAqpoBrt/lTZyaN7l16RsguzwwBreENq/HZ0TfEFEVrfs2H2Iu17s3pf/E8CSTmCDs+93qMebm9gyiMomZJNyyRWlbe7s4q2itInvBgFJe8wQgBOxc4Po2H4Ahbo15craQESjWpW9++AeLcrgonaBLzw3ZPW+UQxrG9i77a74B+z5bQloZOFAAAAAASUVORK5CYII="},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAXBJREFUSIntlb8uBFEUxn/n7hAV1XoIpazYll5ETbays56AZ+AJGBJBoRPUotVsRCmeACsRiUQx636KRWbHnzvIavi6c/J95zvnzJ174R8BWDaozTdnMK1iNpzNbycV4x3U4qaysVALo76zNnbwknPddm+Lf61bK5snyeaibkan+Ecd55Hn1eKm8g12T9AD9NwgClNgtnE64uRXgAlDQhyb2eJWUjkPaYO7nm2cjpS8P8EYzOYFdw6qIZPgipz8CsYg0l4K5VLqhhEHBkMeloP6EAGYAEjNGrtJ5WZzc7TlS1EMYNLkjw0MCWAgda/rbKcPhY4xFPnI4hhj6jHy63MLZ3E7fbB+F6133O0oJA9PYLYouMOYdr591V/qu8RsCulW/nHpSwa1uKn8/bKVVM4dVAWHSPdI98C+5Ks7G+MXIX2h/+D5KE4X4X46QS/wu1eFUMuwcn6PRd+DZ1xlg9x7QB3p+nu9dop7rP4D/V/EE6UhikMKpx/oAAAAAElFTkSuQmCC"},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAALlJREFUKJFjZEACcWmn5zMwMCbA+P///ZuzeI5ZKozPaF+/n4WBgYFB7gmfKiPj30PfeP/Irem3+h5SeIyT4yvLQxZGFuv7Eh/vMzAwMDDGpJz6wcTExM5AEPz7BbX+zH98ymDyTMiCsamnq7HRMICimJGRsQUbjVUxIUAvxf8ZqrDSSCoY49JO/UtLO8OFzbSkpCO8cSlnfjMwMDCwMDAw/mdgOD3nBwPDp7i0MxiK/0BsmMbAwMAAACl8PxDSJvyvAAAAAElFTkSuQmCC"},function(module,exports){module.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAYCAYAAAD+vg1LAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAW5JREFUSIntlbtKA2EQhc8/axIVrUQFBRsRRLCL+gIRQeuAxbpNLq2laGklpLYxVkkh2lip4AsIZkmZRiy0sPCCoEYwlxmLJLLZi+wmYpXTnRnmm/mHYVfBQ+uJq/EwhfJQHANItWdZAFxWQfrRQfTZrZ68wGEtlIHCshMKNGK0EhLsedW7FDWn1bR7ACGImsllF26teSNVmIaSG2ZUVEQm8/tLLw5wPH6iPc6NtjWYehjaVkrtQnCey0bX3JobKfMMCqsQ7NxNvGesubHSkygjaX6CMOD1pM7EZRJCBUD9L7ECqv0YI22KkTalU5i93vMqutX/g/XkdVlPm29+vV19nh2JBoN43xN3qx64B3bK847B/CFEdd/eLzh3uDgcxNvVXIVYPvTi+lf5Xc4ay465DAAbieJsUKyRKM43EPzaijVXoYSlcEoKutKkZKTNoBM3MXRsAwMRrm5+aeERMMeIKNC1MDMrogvur221Yt/I6IasMWr/dwAAAABJRU5ErkJggg=="},function(module,exports,__webpack_require__){function addStylesToDom(styles,options){for(var i=0;i<styles.length;i++){var item=styles[i],domStyle=stylesInDom[item.id];if(domStyle){domStyle.refs++;for(var j=0;j<domStyle.parts.length;j++)domStyle.parts[j](item.parts[j]);for(;j<item.parts.length;j++)domStyle.parts.push(addStyle(item.parts[j],options))}else{for(var parts=[],j=0;j<item.parts.length;j++)parts.push(addStyle(item.parts[j],options));stylesInDom[item.id]={id:item.id,refs:1,parts:parts}}}}function listToStyles(list,options){for(var styles=[],newStyles={},i=0;i<list.length;i++){var item=list[i],id=options.base?item[0]+options.base:item[0],css=item[1],media=item[2],sourceMap=item[3],part={css:css,media:media,sourceMap:sourceMap};newStyles[id]?newStyles[id].parts.push(part):styles.push(newStyles[id]={id:id,parts:[part]})}return styles}function insertStyleElement(options,style){var target=getElement(options.insertInto);if(!target)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var lastStyleElementInsertedAtTop=stylesInsertedAtTop[stylesInsertedAtTop.length-1];if("top"===options.insertAt)lastStyleElementInsertedAtTop?lastStyleElementInsertedAtTop.nextSibling?target.insertBefore(style,lastStyleElementInsertedAtTop.nextSibling):target.appendChild(style):target.insertBefore(style,target.firstChild),stylesInsertedAtTop.push(style);else if("bottom"===options.insertAt)target.appendChild(style);else{if("object"!=typeof options.insertAt||!options.insertAt.before)throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");var nextSibling=getElement(options.insertInto+" "+options.insertAt.before);target.insertBefore(style,nextSibling)}}function removeStyleElement(style){if(null===style.parentNode)return!1;style.parentNode.removeChild(style);var idx=stylesInsertedAtTop.indexOf(style);idx>=0&&stylesInsertedAtTop.splice(idx,1)}function createStyleElement(options){var style=document.createElement("style");return options.attrs.type="text/css",addAttrs(style,options.attrs),insertStyleElement(options,style),style}function createLinkElement(options){var link=document.createElement("link");return options.attrs.type="text/css",options.attrs.rel="stylesheet",addAttrs(link,options.attrs),insertStyleElement(options,link),link}function addAttrs(el,attrs){Object.keys(attrs).forEach(function(key){el.setAttribute(key,attrs[key])})}function addStyle(obj,options){var style,update,remove,result;if(options.transform&&obj.css){if(!(result=options.transform(obj.css)))return function(){};obj.css=result}if(options.singleton){var styleIndex=singletonCounter++;style=singleton||(singleton=createStyleElement(options)),update=applyToSingletonTag.bind(null,style,styleIndex,!1),remove=applyToSingletonTag.bind(null,style,styleIndex,!0)}else obj.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(style=createLinkElement(options),update=updateLink.bind(null,style,options),remove=function(){removeStyleElement(style),style.href&&URL.revokeObjectURL(style.href)}):(style=createStyleElement(options),update=applyToTag.bind(null,style),remove=function(){removeStyleElement(style)});return update(obj),function(newObj){if(newObj){if(newObj.css===obj.css&&newObj.media===obj.media&&newObj.sourceMap===obj.sourceMap)return;update(obj=newObj)}else remove()}}function applyToSingletonTag(style,index,remove,obj){var css=remove?"":obj.css;if(style.styleSheet)style.styleSheet.cssText=replaceText(index,css);else{var cssNode=document.createTextNode(css),childNodes=style.childNodes;childNodes[index]&&style.removeChild(childNodes[index]),childNodes.length?style.insertBefore(cssNode,childNodes[index]):style.appendChild(cssNode)}}function applyToTag(style,obj){var css=obj.css,media=obj.media;if(media&&style.setAttribute("media",media),style.styleSheet)style.styleSheet.cssText=css;else{for(;style.firstChild;)style.removeChild(style.firstChild);style.appendChild(document.createTextNode(css))}}function updateLink(link,options,obj){var css=obj.css,sourceMap=obj.sourceMap,autoFixUrls=void 0===options.convertToAbsoluteUrls&&sourceMap;(options.convertToAbsoluteUrls||autoFixUrls)&&(css=fixUrls(css)),sourceMap&&(css+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))))+" */");var blob=new Blob([css],{type:"text/css"}),oldSrc=link.href;link.href=URL.createObjectURL(blob),oldSrc&&URL.revokeObjectURL(oldSrc)}var stylesInDom={},isOldIE=function(fn){var memo;return function(){return void 0===memo&&(memo=fn.apply(this,arguments)),memo}}(function(){return window&&document&&document.all&&!window.atob}),getTarget=function(target){return document.querySelector(target)},getElement=function(fn){var memo={};return function(target){if("function"==typeof target)return target();if(void 0===memo[target]){var styleTarget=getTarget.call(this,target);if(window.HTMLIFrameElement&&styleTarget instanceof window.HTMLIFrameElement)try{styleTarget=styleTarget.contentDocument.head}catch(e){styleTarget=null}memo[target]=styleTarget}return memo[target]}}(),singleton=null,singletonCounter=0,stylesInsertedAtTop=[],fixUrls=__webpack_require__(183);module.exports=function(list,options){if("undefined"!=typeof DEBUG&&DEBUG&&"object"!=typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");options=options||{},options.attrs="object"==typeof options.attrs?options.attrs:{},options.singleton||"boolean"==typeof options.singleton||(options.singleton=isOldIE()),options.insertInto||(options.insertInto="head"),options.insertAt||(options.insertAt="bottom");var styles=listToStyles(list,options);return addStylesToDom(styles,options),function(newList){for(var mayRemove=[],i=0;i<styles.length;i++){var item=styles[i],domStyle=stylesInDom[item.id];domStyle.refs--,mayRemove.push(domStyle)}if(newList){addStylesToDom(listToStyles(newList,options),options)}for(var i=0;i<mayRemove.length;i++){var domStyle=mayRemove[i];if(0===domStyle.refs){for(var j=0;j<domStyle.parts.length;j++)domStyle.parts[j]();delete stylesInDom[domStyle.id]}}}};var replaceText=function(){var textStore=[];return function(index,replacement){return textStore[index]=replacement,textStore.filter(Boolean).join("\n")}}()},function(module,exports){module.exports=function(css){var location="undefined"!=typeof window&&window.location;if(!location)throw new Error("fixUrls requires window.location");if(!css||"string"!=typeof css)return css;var baseUrl=location.protocol+"//"+location.host,currentDir=baseUrl+location.pathname.replace(/\/[^\/]*$/,"/");return css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(fullMatch,origUrl){var unquotedOrigUrl=origUrl.trim().replace(/^"(.*)"$/,function(o,$1){return $1}).replace(/^'(.*)'$/,function(o,$1){return $1});if(/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl))return fullMatch;var newUrl;return newUrl=0===unquotedOrigUrl.indexOf("//")?unquotedOrigUrl:0===unquotedOrigUrl.indexOf("/")?baseUrl+unquotedOrigUrl:currentDir+unquotedOrigUrl.replace(/^\.\//,""),"url("+JSON.stringify(newUrl)+")"})}},function(module,exports,__webpack_require__){__webpack_require__(62)(__webpack_require__(185))},function(module,exports){module.exports="(function(f){if(typeof exports===\"object\"&&typeof module!==\"undefined\"){module.exports=f()}else if(typeof define===\"function\"&&define.amd){define([],f)}else{var g;if(typeof window!==\"undefined\"){g=window}else if(typeof global!==\"undefined\"){g=global}else if(typeof self!==\"undefined\"){g=self}else{g=this}g.rbush = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require==\"function\"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error(\"Cannot find module '\"+o+\"'\");throw f.code=\"MODULE_NOT_FOUND\",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require==\"function\"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){\n'use strict';\n\nmodule.exports = rbush;\nmodule.exports.default = rbush;\n\nvar quickselect = require('quickselect');\n\nfunction rbush(maxEntries, format) {\n    if (!(this instanceof rbush)) return new rbush(maxEntries, format);\n\n    // max entries in a node is 9 by default; min node fill is 40% for best performance\n    this._maxEntries = Math.max(4, maxEntries || 9);\n    this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4));\n\n    if (format) {\n        this._initFormat(format);\n    }\n\n    this.clear();\n}\n\nrbush.prototype = {\n\n    all: function () {\n        return this._all(this.data, []);\n    },\n\n    search: function (bbox) {\n\n        var node = this.data,\n            result = [],\n            toBBox = this.toBBox;\n\n        if (!intersects(bbox, node)) return result;\n\n        var nodesToSearch = [],\n            i, len, child, childBBox;\n\n        while (node) {\n            for (i = 0, len = node.children.length; i < len; i++) {\n\n                child = node.children[i];\n                childBBox = node.leaf ? toBBox(child) : child;\n\n                if (intersects(bbox, childBBox)) {\n                    if (node.leaf) result.push(child);\n                    else if (contains(bbox, childBBox)) this._all(child, result);\n                    else nodesToSearch.push(child);\n                }\n            }\n            node = nodesToSearch.pop();\n        }\n\n        return result;\n    },\n\n    collides: function (bbox) {\n\n        var node = this.data,\n            toBBox = this.toBBox;\n\n        if (!intersects(bbox, node)) return false;\n\n        var nodesToSearch = [],\n            i, len, child, childBBox;\n\n        while (node) {\n            for (i = 0, len = node.children.length; i < len; i++) {\n\n                child = node.children[i];\n                childBBox = node.leaf ? toBBox(child) : child;\n\n                if (intersects(bbox, childBBox)) {\n                    if (node.leaf || contains(bbox, childBBox)) return true;\n                    nodesToSearch.push(child);\n                }\n            }\n            node = nodesToSearch.pop();\n        }\n\n        return false;\n    },\n\n    load: function (data) {\n        if (!(data && data.length)) return this;\n\n        if (data.length < this._minEntries) {\n            for (var i = 0, len = data.length; i < len; i++) {\n                this.insert(data[i]);\n            }\n            return this;\n        }\n\n        // recursively build the tree with the given data from scratch using OMT algorithm\n        var node = this._build(data.slice(), 0, data.length - 1, 0);\n\n        if (!this.data.children.length) {\n            // save as is if tree is empty\n            this.data = node;\n\n        } else if (this.data.height === node.height) {\n            // split root if trees have the same height\n            this._splitRoot(this.data, node);\n\n        } else {\n            if (this.data.height < node.height) {\n                // swap trees if inserted one is bigger\n                var tmpNode = this.data;\n                this.data = node;\n                node = tmpNode;\n            }\n\n            // insert the small tree into the large tree at appropriate level\n            this._insert(node, this.data.height - node.height - 1, true);\n        }\n\n        return this;\n    },\n\n    insert: function (item) {\n        if (item) this._insert(item, this.data.height - 1);\n        return this;\n    },\n\n    clear: function () {\n        this.data = createNode([]);\n        return this;\n    },\n\n    remove: function (item, equalsFn) {\n        if (!item) return this;\n\n        var node = this.data,\n            bbox = this.toBBox(item),\n            path = [],\n            indexes = [],\n            i, parent, index, goingUp;\n\n        // depth-first iterative tree traversal\n        while (node || path.length) {\n\n            if (!node) { // go up\n                node = path.pop();\n                parent = path[path.length - 1];\n                i = indexes.pop();\n                goingUp = true;\n            }\n\n            if (node.leaf) { // check current node\n                index = findItem(item, node.children, equalsFn);\n\n                if (index !== -1) {\n                    // item found, remove the item and condense tree upwards\n                    node.children.splice(index, 1);\n                    path.push(node);\n                    this._condense(path);\n                    return this;\n                }\n            }\n\n            if (!goingUp && !node.leaf && contains(node, bbox)) { // go down\n                path.push(node);\n                indexes.push(i);\n                i = 0;\n                parent = node;\n                node = node.children[0];\n\n            } else if (parent) { // go right\n                i++;\n                node = parent.children[i];\n                goingUp = false;\n\n            } else node = null; // nothing found\n        }\n\n        return this;\n    },\n\n    toBBox: function (item) { return item; },\n\n    compareMinX: compareNodeMinX,\n    compareMinY: compareNodeMinY,\n\n    toJSON: function () { return this.data; },\n\n    fromJSON: function (data) {\n        this.data = data;\n        return this;\n    },\n\n    _all: function (node, result) {\n        var nodesToSearch = [];\n        while (node) {\n            if (node.leaf) result.push.apply(result, node.children);\n            else nodesToSearch.push.apply(nodesToSearch, node.children);\n\n            node = nodesToSearch.pop();\n        }\n        return result;\n    },\n\n    _build: function (items, left, right, height) {\n\n        var N = right - left + 1,\n            M = this._maxEntries,\n            node;\n\n        if (N <= M) {\n            // reached leaf level; return leaf\n            node = createNode(items.slice(left, right + 1));\n            calcBBox(node, this.toBBox);\n            return node;\n        }\n\n        if (!height) {\n            // target height of the bulk-loaded tree\n            height = Math.ceil(Math.log(N) / Math.log(M));\n\n            // target number of root entries to maximize storage utilization\n            M = Math.ceil(N / Math.pow(M, height - 1));\n        }\n\n        node = createNode([]);\n        node.leaf = false;\n        node.height = height;\n\n        // split the items into M mostly square tiles\n\n        var N2 = Math.ceil(N / M),\n            N1 = N2 * Math.ceil(Math.sqrt(M)),\n            i, j, right2, right3;\n\n        multiSelect(items, left, right, N1, this.compareMinX);\n\n        for (i = left; i <= right; i += N1) {\n\n            right2 = Math.min(i + N1 - 1, right);\n\n            multiSelect(items, i, right2, N2, this.compareMinY);\n\n            for (j = i; j <= right2; j += N2) {\n\n                right3 = Math.min(j + N2 - 1, right2);\n\n                // pack each entry recursively\n                node.children.push(this._build(items, j, right3, height - 1));\n            }\n        }\n\n        calcBBox(node, this.toBBox);\n\n        return node;\n    },\n\n    _chooseSubtree: function (bbox, node, level, path) {\n\n        var i, len, child, targetNode, area, enlargement, minArea, minEnlargement;\n\n        while (true) {\n            path.push(node);\n\n            if (node.leaf || path.length - 1 === level) break;\n\n            minArea = minEnlargement = Infinity;\n\n            for (i = 0, len = node.children.length; i < len; i++) {\n                child = node.children[i];\n                area = bboxArea(child);\n                enlargement = enlargedArea(bbox, child) - area;\n\n                // choose entry with the least area enlargement\n                if (enlargement < minEnlargement) {\n                    minEnlargement = enlargement;\n                    minArea = area < minArea ? area : minArea;\n                    targetNode = child;\n\n                } else if (enlargement === minEnlargement) {\n                    // otherwise choose one with the smallest area\n                    if (area < minArea) {\n                        minArea = area;\n                        targetNode = child;\n                    }\n                }\n            }\n\n            node = targetNode || node.children[0];\n        }\n\n        return node;\n    },\n\n    _insert: function (item, level, isNode) {\n\n        var toBBox = this.toBBox,\n            bbox = isNode ? item : toBBox(item),\n            insertPath = [];\n\n        // find the best node for accommodating the item, saving all nodes along the path too\n        var node = this._chooseSubtree(bbox, this.data, level, insertPath);\n\n        // put the item into the node\n        node.children.push(item);\n        extend(node, bbox);\n\n        // split on node overflow; propagate upwards if necessary\n        while (level >= 0) {\n            if (insertPath[level].children.length > this._maxEntries) {\n                this._split(insertPath, level);\n                level--;\n            } else break;\n        }\n\n        // adjust bboxes along the insertion path\n        this._adjustParentBBoxes(bbox, insertPath, level);\n    },\n\n    // split overflowed node into two\n    _split: function (insertPath, level) {\n\n        var node = insertPath[level],\n            M = node.children.length,\n            m = this._minEntries;\n\n        this._chooseSplitAxis(node, m, M);\n\n        var splitIndex = this._chooseSplitIndex(node, m, M);\n\n        var newNode = createNode(node.children.splice(splitIndex, node.children.length - splitIndex));\n        newNode.height = node.height;\n        newNode.leaf = node.leaf;\n\n        calcBBox(node, this.toBBox);\n        calcBBox(newNode, this.toBBox);\n\n        if (level) insertPath[level - 1].children.push(newNode);\n        else this._splitRoot(node, newNode);\n    },\n\n    _splitRoot: function (node, newNode) {\n        // split root node\n        this.data = createNode([node, newNode]);\n        this.data.height = node.height + 1;\n        this.data.leaf = false;\n        calcBBox(this.data, this.toBBox);\n    },\n\n    _chooseSplitIndex: function (node, m, M) {\n\n        var i, bbox1, bbox2, overlap, area, minOverlap, minArea, index;\n\n        minOverlap = minArea = Infinity;\n\n        for (i = m; i <= M - m; i++) {\n            bbox1 = distBBox(node, 0, i, this.toBBox);\n            bbox2 = distBBox(node, i, M, this.toBBox);\n\n            overlap = intersectionArea(bbox1, bbox2);\n            area = bboxArea(bbox1) + bboxArea(bbox2);\n\n            // choose distribution with minimum overlap\n            if (overlap < minOverlap) {\n                minOverlap = overlap;\n                index = i;\n\n                minArea = area < minArea ? area : minArea;\n\n            } else if (overlap === minOverlap) {\n                // otherwise choose distribution with minimum area\n                if (area < minArea) {\n                    minArea = area;\n                    index = i;\n                }\n            }\n        }\n\n        return index;\n    },\n\n    // sorts node children by the best axis for split\n    _chooseSplitAxis: function (node, m, M) {\n\n        var compareMinX = node.leaf ? this.compareMinX : compareNodeMinX,\n            compareMinY = node.leaf ? this.compareMinY : compareNodeMinY,\n            xMargin = this._allDistMargin(node, m, M, compareMinX),\n            yMargin = this._allDistMargin(node, m, M, compareMinY);\n\n        // if total distributions margin value is minimal for x, sort by minX,\n        // otherwise it's already sorted by minY\n        if (xMargin < yMargin) node.children.sort(compareMinX);\n    },\n\n    // total margin of all possible split distributions where each node is at least m full\n    _allDistMargin: function (node, m, M, compare) {\n\n        node.children.sort(compare);\n\n        var toBBox = this.toBBox,\n            leftBBox = distBBox(node, 0, m, toBBox),\n            rightBBox = distBBox(node, M - m, M, toBBox),\n            margin = bboxMargin(leftBBox) + bboxMargin(rightBBox),\n            i, child;\n\n        for (i = m; i < M - m; i++) {\n            child = node.children[i];\n            extend(leftBBox, node.leaf ? toBBox(child) : child);\n            margin += bboxMargin(leftBBox);\n        }\n\n        for (i = M - m - 1; i >= m; i--) {\n            child = node.children[i];\n            extend(rightBBox, node.leaf ? toBBox(child) : child);\n            margin += bboxMargin(rightBBox);\n        }\n\n        return margin;\n    },\n\n    _adjustParentBBoxes: function (bbox, path, level) {\n        // adjust bboxes along the given tree path\n        for (var i = level; i >= 0; i--) {\n            extend(path[i], bbox);\n        }\n    },\n\n    _condense: function (path) {\n        // go through the path, removing empty nodes and updating bboxes\n        for (var i = path.length - 1, siblings; i >= 0; i--) {\n            if (path[i].children.length === 0) {\n                if (i > 0) {\n                    siblings = path[i - 1].children;\n                    siblings.splice(siblings.indexOf(path[i]), 1);\n\n                } else this.clear();\n\n            } else calcBBox(path[i], this.toBBox);\n        }\n    },\n\n    _initFormat: function (format) {\n        // data format (minX, minY, maxX, maxY accessors)\n\n        // uses eval-type function compilation instead of just accepting a toBBox function\n        // because the algorithms are very sensitive to sorting functions performance,\n        // so they should be dead simple and without inner calls\n\n        var compareArr = ['return a', ' - b', ';'];\n\n        this.compareMinX = new Function('a', 'b', compareArr.join(format[0]));\n        this.compareMinY = new Function('a', 'b', compareArr.join(format[1]));\n\n        this.toBBox = new Function('a',\n            'return {minX: a' + format[0] +\n            ', minY: a' + format[1] +\n            ', maxX: a' + format[2] +\n            ', maxY: a' + format[3] + '};');\n    }\n};\n\nfunction findItem(item, items, equalsFn) {\n    if (!equalsFn) return items.indexOf(item);\n\n    for (var i = 0; i < items.length; i++) {\n        if (equalsFn(item, items[i])) return i;\n    }\n    return -1;\n}\n\n// calculate node's bbox from bboxes of its children\nfunction calcBBox(node, toBBox) {\n    distBBox(node, 0, node.children.length, toBBox, node);\n}\n\n// min bounding rectangle of node children from k to p-1\nfunction distBBox(node, k, p, toBBox, destNode) {\n    if (!destNode) destNode = createNode(null);\n    destNode.minX = Infinity;\n    destNode.minY = Infinity;\n    destNode.maxX = -Infinity;\n    destNode.maxY = -Infinity;\n\n    for (var i = k, child; i < p; i++) {\n        child = node.children[i];\n        extend(destNode, node.leaf ? toBBox(child) : child);\n    }\n\n    return destNode;\n}\n\nfunction extend(a, b) {\n    a.minX = Math.min(a.minX, b.minX);\n    a.minY = Math.min(a.minY, b.minY);\n    a.maxX = Math.max(a.maxX, b.maxX);\n    a.maxY = Math.max(a.maxY, b.maxY);\n    return a;\n}\n\nfunction compareNodeMinX(a, b) { return a.minX - b.minX; }\nfunction compareNodeMinY(a, b) { return a.minY - b.minY; }\n\nfunction bboxArea(a)   { return (a.maxX - a.minX) * (a.maxY - a.minY); }\nfunction bboxMargin(a) { return (a.maxX - a.minX) + (a.maxY - a.minY); }\n\nfunction enlargedArea(a, b) {\n    return (Math.max(b.maxX, a.maxX) - Math.min(b.minX, a.minX)) *\n           (Math.max(b.maxY, a.maxY) - Math.min(b.minY, a.minY));\n}\n\nfunction intersectionArea(a, b) {\n    var minX = Math.max(a.minX, b.minX),\n        minY = Math.max(a.minY, b.minY),\n        maxX = Math.min(a.maxX, b.maxX),\n        maxY = Math.min(a.maxY, b.maxY);\n\n    return Math.max(0, maxX - minX) *\n           Math.max(0, maxY - minY);\n}\n\nfunction contains(a, b) {\n    return a.minX <= b.minX &&\n           a.minY <= b.minY &&\n           b.maxX <= a.maxX &&\n           b.maxY <= a.maxY;\n}\n\nfunction intersects(a, b) {\n    return b.minX <= a.maxX &&\n           b.minY <= a.maxY &&\n           b.maxX >= a.minX &&\n           b.maxY >= a.minY;\n}\n\nfunction createNode(children) {\n    return {\n        children: children,\n        height: 1,\n        leaf: true,\n        minX: Infinity,\n        minY: Infinity,\n        maxX: -Infinity,\n        maxY: -Infinity\n    };\n}\n\n// sort an array so that items come in groups of n unsorted items, with groups sorted between each other;\n// combines selection algorithm with binary divide & conquer approach\n\nfunction multiSelect(arr, left, right, n, compare) {\n    var stack = [left, right],\n        mid;\n\n    while (stack.length) {\n        right = stack.pop();\n        left = stack.pop();\n\n        if (right - left <= n) continue;\n\n        mid = left + Math.ceil((right - left) / n / 2) * n;\n        quickselect(arr, mid, left, right, compare);\n\n        stack.push(left, mid, mid, right);\n    }\n}\n\n},{\"quickselect\":2}],2:[function(require,module,exports){\n'use strict';\n\nmodule.exports = quickselect;\nmodule.exports.default = quickselect;\n\nfunction quickselect(arr, k, left, right, compare) {\n    quickselectStep(arr, k, left || 0, right || (arr.length - 1), compare || defaultCompare);\n};\n\nfunction quickselectStep(arr, k, left, right, compare) {\n\n    while (right > left) {\n        if (right - left > 600) {\n            var n = right - left + 1;\n            var m = k - left + 1;\n            var z = Math.log(n);\n            var s = 0.5 * Math.exp(2 * z / 3);\n            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);\n            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));\n            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));\n            quickselectStep(arr, k, newLeft, newRight, compare);\n        }\n\n        var t = arr[k];\n        var i = left;\n        var j = right;\n\n        swap(arr, left, k);\n        if (compare(arr[right], t) > 0) swap(arr, left, right);\n\n        while (i < j) {\n            swap(arr, i, j);\n            i++;\n            j--;\n            while (compare(arr[i], t) < 0) i++;\n            while (compare(arr[j], t) > 0) j--;\n        }\n\n        if (compare(arr[left], t) === 0) swap(arr, left, j);\n        else {\n            j++;\n            swap(arr, j, right);\n        }\n\n        if (j <= k) left = j + 1;\n        if (k <= j) right = j - 1;\n    }\n}\n\nfunction swap(arr, i, j) {\n    var tmp = arr[i];\n    arr[i] = arr[j];\n    arr[j] = tmp;\n}\n\nfunction defaultCompare(a, b) {\n    return a < b ? -1 : a > b ? 1 : 0;\n}\n\n},{}]},{},[1])(1)\n});"},function(module,exports,__webpack_require__){__webpack_require__(62)(__webpack_require__(187))},function(module,exports){module.exports='"use strict";var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/*\n\n This file is changed from the original on:\n https://github.com/google/earthengine-api/blob/master/javascript/build/ee_api_js_debug.js\n\n Line 2:\n goog.global = window (not this)\n\n window.ee = ee; is added at the end of this file.\n\n This to make it work with the webpack build setup\n\n */var goog=goog||{};goog.global=window;goog.isDef=function(val){return void 0!==val;};goog.isString=function(val){return"string"==typeof val;};goog.isBoolean=function(val){return"boolean"==typeof val;};goog.isNumber=function(val){return"number"==typeof val;};goog.isString=function(val){return"string"==typeof val;};goog.isBoolean=function(val){return"boolean"==typeof val;};goog.isNumber=function(val){return"number"==typeof val;};goog.exportPath_=function(name,opt_object,opt_objectToExportTo){var parts=name.split("."),cur=opt_objectToExportTo||goog.global;parts[0]in cur||!cur.execScript||cur.execScript("var "+parts[0]);for(var part;parts.length&&(part=parts.shift());){!parts.length&&goog.isDef(opt_object)?cur[part]=opt_object:cur=cur[part]&&cur[part]!==Object.prototype[part]?cur[part]:cur[part]={};}};goog.define=function(name,defaultValue){goog.exportPath_(name,defaultValue);};goog.DEBUG=!0;goog.LOCALE="en";goog.TRUSTED_SITE=!0;goog.STRICT_MODE_COMPATIBLE=!1;goog.DISALLOW_TEST_ONLY_CODE=!goog.DEBUG;goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING=!1;goog.provide=function(name){if(goog.isInModuleLoader_()){throw Error("goog.provide can not be used within a goog.module.");}goog.constructNamespace_(name);};goog.constructNamespace_=function(name,opt_obj){var namespace;goog.exportPath_(name,opt_obj);};goog.VALID_MODULE_RE_=/^[a-zA-Z_$][a-zA-Z0-9._$]*$/;goog.module=function(name){if(!goog.isString(name)||!name||-1==name.search(goog.VALID_MODULE_RE_)){throw Error("Invalid module identifier");}if(!goog.isInModuleLoader_()){throw Error("Module "+name+" has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You\'re likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");}if(goog.moduleLoaderState_.moduleName){throw Error("goog.module may only be called once per module.");}goog.moduleLoaderState_.moduleName=name;};goog.module.get=function(name){return goog.module.getInternal_(name);};goog.module.getInternal_=function(name){var ns;return null;};goog.moduleLoaderState_=null;goog.isInModuleLoader_=function(){return null!=goog.moduleLoaderState_;};goog.module.declareLegacyNamespace=function(){goog.moduleLoaderState_.declareLegacyNamespace=!0;};goog.setTestOnly=function(opt_message){if(goog.DISALLOW_TEST_ONLY_CODE){throw opt_message=opt_message||"",Error("Importing test-only code into non-debug environment"+(opt_message?": "+opt_message:"."));}};goog.forwardDeclare=function(name){};goog.getObjectByName=function(name,opt_obj){for(var parts=name.split("."),cur=opt_obj||goog.global,part;part=parts.shift();){if(goog.isDefAndNotNull(cur[part])){cur=cur[part];}else{return null;}}return cur;};goog.globalize=function(obj,opt_global){var global=opt_global||goog.global,x;for(x in obj){global[x]=obj[x];}};goog.addDependency=function(relPath,provides,requires,opt_loadFlags){if(goog.DEPENDENCIES_ENABLED){var provide,require,path=relPath.replace(/\\\\/g,"/"),deps=goog.dependencies_;opt_loadFlags&&"boolean"!==typeof opt_loadFlags||(opt_loadFlags=opt_loadFlags?{module:"goog"}:{});for(var i=0;provide=provides[i];i++){deps.nameToPath[provide]=path,deps.loadFlags[path]=opt_loadFlags;}for(var j=0;require=requires[j];j++){path in deps.requires||(deps.requires[path]={}),deps.requires[path][require]=!0;}}};goog.useStrictRequires=!1;goog.ENABLE_DEBUG_LOADER=!0;goog.logToConsole_=function(msg){goog.global.console&&goog.global.console.error(msg);};goog.require=function(name){var errorMessage,path;};goog.basePath="";goog.nullFunction=function(){};goog.abstractMethod=function(){throw Error("unimplemented abstract method");};goog.addSingletonGetter=function(ctor){ctor.instance_=void 0;ctor.getInstance=function(){if(ctor.instance_){return ctor.instance_;}goog.DEBUG&&(goog.instantiatedSingletons_[goog.instantiatedSingletons_.length]=ctor);return ctor.instance_=new ctor();};};goog.instantiatedSingletons_=[];goog.LOAD_MODULE_USING_EVAL=!0;goog.SEAL_MODULE_EXPORTS=goog.DEBUG;goog.loadedModules_={};goog.DEPENDENCIES_ENABLED=!1;goog.TRANSPILE="detect";goog.TRANSPILER="transpile.js";goog.DEPENDENCIES_ENABLED&&(goog.dependencies_={loadFlags:{},nameToPath:{},requires:{},visited:{},written:{},deferred:{}},goog.inHtmlDocument_=function(){var doc=goog.global.document;return null!=doc&&"write"in doc;},goog.findBasePath_=function(){if(goog.isDef(goog.global.CLOSURE_BASE_PATH)&&goog.isString(goog.global.CLOSURE_BASE_PATH)){goog.basePath=goog.global.CLOSURE_BASE_PATH;}else{if(goog.inHtmlDocument_()){var doc=goog.global.document,currentScript=doc.currentScript;var scripts=currentScript?[currentScript]:doc.getElementsByTagName("SCRIPT");for(var i=scripts.length-1;0<=i;--i){var src=scripts[i].src,qmark=src.lastIndexOf("?"),l=-1==qmark?src.length:qmark;if("base.js"==src.substr(l-7,7)){goog.basePath=src.substr(0,l-7);break;}}}}},goog.importScript_=function(src,opt_sourceText){(goog.global.CLOSURE_IMPORT_SCRIPT||goog.writeScriptTag_)(src,opt_sourceText)&&(goog.dependencies_.written[src]=!0);},goog.IS_OLD_IE_=!(goog.global.atob||!goog.global.document||!goog.global.document.all),goog.oldIeWaiting_=!1,goog.importProcessedScript_=function(src,isModule,needsTranspile){goog.importScript_("",\'goog.retrieveAndExec_("\'+src+\'", \'+isModule+", "+needsTranspile+");");},goog.queuedModules_=[],goog.wrapModule_=function(srcUrl,scriptText){return goog.LOAD_MODULE_USING_EVAL&&goog.isDef(goog.global.JSON)?"goog.loadModule("+goog.global.JSON.stringify(scriptText+"\\n//# sourceURL="+srcUrl+"\\n")+");":\'goog.loadModule(function(exports) {"use strict";\'+scriptText+"\\n;return exports});\\n//# sourceURL="+srcUrl+"\\n";},goog.loadQueuedModules_=function(){var count=goog.queuedModules_.length;if(0<count){var queue=goog.queuedModules_;goog.queuedModules_=[];for(var i=0;i<count;i++){goog.maybeProcessDeferredPath_(queue[i]);}}goog.oldIeWaiting_=!1;},goog.maybeProcessDeferredDep_=function(name){goog.isDeferredModule_(name)&&goog.allDepsAreAvailable_(name)&&goog.maybeProcessDeferredPath_(goog.basePath+goog.getPathFromDeps_(name));},goog.isDeferredModule_=function(name){var path=goog.getPathFromDeps_(name),loadFlags=path&&goog.dependencies_.loadFlags[path]||{},languageLevel=loadFlags.lang||"es3";return path&&("goog"==loadFlags.module||goog.needsTranspile_(languageLevel))?goog.basePath+path in goog.dependencies_.deferred:!1;},goog.allDepsAreAvailable_=function(name){var path=goog.getPathFromDeps_(name);if(path&&path in goog.dependencies_.requires){for(var requireName in goog.dependencies_.requires[path]){if(!goog.isProvided_(requireName)&&!goog.isDeferredModule_(requireName)){return!1;}}}return!0;},goog.maybeProcessDeferredPath_=function(abspath){if(abspath in goog.dependencies_.deferred){var src=goog.dependencies_.deferred[abspath];delete goog.dependencies_.deferred[abspath];goog.globalEval(src);}},goog.loadModuleFromUrl=function(url){},goog.writeScriptSrcNode_=function(src){goog.global.document.write(\'<script type="text/javascript" src="\'+src+\'">\\x3c/script>\');},goog.appendScriptSrcNode_=function(src){var doc=goog.global.document,scriptEl=doc.createElement("script");scriptEl.type="text/javascript";scriptEl.src=src;scriptEl.defer=!1;scriptEl.async=!1;doc.head.appendChild(scriptEl);},goog.writeScriptTag_=function(src,opt_sourceText){if(goog.inHtmlDocument_()){var doc=goog.global.document;if(!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING&&"complete"==doc.readyState){if(/\\bdeps.js$/.test(src)){return!1;}throw Error(\'Cannot write "\'+src+\'" after document load\');}if(void 0===opt_sourceText){if(goog.IS_OLD_IE_){goog.oldIeWaiting_=!0;var state=" onreadystatechange=\'goog.onScriptLoad_(this, "+ ++goog.lastNonModuleScriptIndex_+")\' ";doc.write(\'<script type="text/javascript" src="\'+src+\'"\'+state+">\\x3c/script>");}else{goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING?goog.appendScriptSrcNode_(src):goog.writeScriptSrcNode_(src);}}else{doc.write(\'<script type="text/javascript">\'+goog.protectScriptTag_(opt_sourceText)+"\\x3c/script>");}return!0;}return!1;},goog.protectScriptTag_=function(str){return str.replace(/<\\/(SCRIPT)/ig,"\\\\x3c/$1");},goog.needsTranspile_=function(lang){if("always"==goog.TRANSPILE){return!0;}if("never"==goog.TRANSPILE){return!1;}goog.requiresTranspilation_||(goog.requiresTranspilation_=goog.createRequiresTranspilation_());if(lang in goog.requiresTranspilation_){return goog.requiresTranspilation_[lang];}throw Error("Unknown language mode: "+lang);},goog.requiresTranspilation_=null,goog.lastNonModuleScriptIndex_=0,goog.onScriptLoad_=function(script,scriptIndex){"complete"==script.readyState&&goog.lastNonModuleScriptIndex_==scriptIndex&&goog.loadQueuedModules_();return!0;},goog.writeScripts_=function(pathToLoad){function visitNode(path){if(!(path in deps.written||path in deps.visited)){deps.visited[path]=!0;if(path in deps.requires){for(var requireName in deps.requires[path]){if(!goog.isProvided_(requireName)){if(requireName in deps.nameToPath){visitNode(deps.nameToPath[requireName]);}else{throw Error("Undefined nameToPath for "+requireName);}}}}path in seenScript||(seenScript[path]=!0,scripts.push(path));}}var scripts=[],seenScript={},deps=goog.dependencies_;visitNode(pathToLoad);for(var i=0;i<scripts.length;i++){var path$jscomp$0=scripts[i];goog.dependencies_.written[path$jscomp$0]=!0;}var moduleState=goog.moduleLoaderState_;goog.moduleLoaderState_=null;for(i=0;i<scripts.length;i++){if(path$jscomp$0=scripts[i]){var loadFlags=deps.loadFlags[path$jscomp$0]||{},needsTranspile=goog.needsTranspile_(loadFlags.lang||"es3");"goog"==loadFlags.module||needsTranspile?goog.importProcessedScript_(goog.basePath+path$jscomp$0,"goog"==loadFlags.module,needsTranspile):goog.importScript_(goog.basePath+path$jscomp$0);}else{throw goog.moduleLoaderState_=moduleState,Error("Undefined script input");}}goog.moduleLoaderState_=moduleState;},goog.getPathFromDeps_=function(rule){return rule in goog.dependencies_.nameToPath?goog.dependencies_.nameToPath[rule]:null;},goog.findBasePath_(),goog.global.CLOSURE_NO_DEPS||goog.importScript_(goog.basePath+"deps.js"));goog.hasBadLetScoping=null;goog.useSafari10Workaround=function(){if(null==goog.hasBadLetScoping){try{var hasBadLetScoping=!eval(\'"use strict";let x = 1; function f() { return typeof x; };f() == "number";\');}catch(e){hasBadLetScoping=!1;}goog.hasBadLetScoping=hasBadLetScoping;}return goog.hasBadLetScoping;};goog.workaroundSafari10EvalBug=function(moduleDef){return"(function(){"+moduleDef+"\\n;})();\\n";};goog.loadModule=function(moduleDef){var previousState=goog.moduleLoaderState_;try{goog.moduleLoaderState_={moduleName:void 0,declareLegacyNamespace:!1};if(goog.isFunction(moduleDef)){var exports=moduleDef.call(void 0,{});}else{if(goog.isString(moduleDef)){goog.useSafari10Workaround()&&(moduleDef=goog.workaroundSafari10EvalBug(moduleDef)),exports=goog.loadModuleFromSource_.call(void 0,moduleDef);}else{throw Error("Invalid module definition");}}var moduleName=goog.moduleLoaderState_.moduleName;if(!goog.isString(moduleName)||!moduleName){throw Error(\'Invalid module name "\'+moduleName+\'"\');}goog.moduleLoaderState_.declareLegacyNamespace?goog.constructNamespace_(moduleName,exports):goog.SEAL_MODULE_EXPORTS&&Object.seal&&"object"==(typeof exports==="undefined"?"undefined":_typeof(exports))&&null!=exports&&Object.seal(exports);goog.loadedModules_[moduleName]=exports;}finally{goog.moduleLoaderState_=previousState;}};goog.loadModuleFromSource_=function(JSCompiler_OptimizeArgumentsArray_p0){eval(JSCompiler_OptimizeArgumentsArray_p0);return{};};goog.normalizePath_=function(path){for(var components=path.split("/"),i=0;i<components.length;){"."==components[i]?components.splice(i,1):i&&".."==components[i]&&components[i-1]&&".."!=components[i-1]?components.splice(--i,2):i++;}return components.join("/");};goog.loadFileSync_=function(src){if(goog.global.CLOSURE_LOAD_FILE_SYNC){return goog.global.CLOSURE_LOAD_FILE_SYNC(src);}try{var xhr=new goog.global.XMLHttpRequest();xhr.open("get",src,!1);xhr.send();return 0==xhr.status||200==xhr.status?xhr.responseText:null;}catch(err){return null;}};goog.retrieveAndExec_=function(src,isModule,needsTranspile){var scriptText,importScript,originalPath;};goog.transpile_=function(code$jscomp$0,path$jscomp$0){var jscomp=goog.global.$jscomp;jscomp||(goog.global.$jscomp=jscomp={});var transpile=jscomp.transpile;if(!transpile){var transpilerPath=goog.basePath+goog.TRANSPILER,transpilerCode=goog.loadFileSync_(transpilerPath);if(transpilerCode){eval(transpilerCode+"\\n//# sourceURL="+transpilerPath);if(goog.global.$gwtExport&&goog.global.$gwtExport.$jscomp&&!goog.global.$gwtExport.$jscomp.transpile){throw Error(\'The transpiler did not properly export the "transpile" method. $gwtExport: \'+JSON.stringify(goog.global.$gwtExport));}goog.global.$jscomp.transpile=goog.global.$gwtExport.$jscomp.transpile;jscomp=goog.global.$jscomp;transpile=jscomp.transpile;}}if(!transpile){var suffix=" requires transpilation but no transpiler was found.",suffix=suffix+\' Please add "//javascript/closure:transpiler" as a data dependency to ensure it is included.\',transpile=jscomp.transpile=function(code,path){goog.logToConsole_(path+suffix);return code;};}return transpile(code$jscomp$0,path$jscomp$0);};goog.typeOf=function(value){var s=typeof value==="undefined"?"undefined":_typeof(value);if("object"==s){if(value){if(value instanceof Array){return"array";}if(value instanceof Object){return s;}var className=Object.prototype.toString.call(value);if("[object Window]"==className){return"object";}if("[object Array]"==className||"number"==typeof value.length&&"undefined"!=typeof value.splice&&"undefined"!=typeof value.propertyIsEnumerable&&!value.propertyIsEnumerable("splice")){return"array";}if("[object Function]"==className||"undefined"!=typeof value.call&&"undefined"!=typeof value.propertyIsEnumerable&&!value.propertyIsEnumerable("call")){return"function";}}else{return"null";}}else{if("function"==s&&"undefined"==typeof value.call){return"object";}}return s;};goog.isNull=function(val){return null===val;};goog.isDefAndNotNull=function(val){return null!=val;};goog.isArray=function(val){return"array"==goog.typeOf(val);};goog.isArrayLike=function(val){var type=goog.typeOf(val);return"array"==type||"object"==type&&"number"==typeof val.length;};goog.isDateLike=function(val){return goog.isObject(val)&&"function"==typeof val.getFullYear;};goog.isFunction=function(val){return"function"==goog.typeOf(val);};goog.isObject=function(val){var type=typeof val==="undefined"?"undefined":_typeof(val);return"object"==type&&null!=val||"function"==type;};goog.getUid=function(obj){return obj[goog.UID_PROPERTY_]||(obj[goog.UID_PROPERTY_]=++goog.uidCounter_);};goog.hasUid=function(obj){return!!obj[goog.UID_PROPERTY_];};goog.removeUid=function(obj){null!==obj&&"removeAttribute"in obj&&obj.removeAttribute(goog.UID_PROPERTY_);try{delete obj[goog.UID_PROPERTY_];}catch(ex){}};goog.UID_PROPERTY_="closure_uid_"+(1e9*Math.random()>>>0);goog.uidCounter_=0;goog.getHashCode=goog.getUid;goog.removeHashCode=goog.removeUid;goog.cloneObject=function(obj){var type=goog.typeOf(obj);if("object"==type||"array"==type){if(obj.clone){return obj.clone();}var clone="array"==type?[]:{},key;for(key in obj){clone[key]=goog.cloneObject(obj[key]);}return clone;}return obj;};goog.bindNative_=function(fn,selfObj,var_args){return fn.call.apply(fn.bind,arguments);};goog.bindJs_=function(fn,selfObj,var_args){if(!fn){throw Error();}if(2<arguments.length){var boundArgs=Array.prototype.slice.call(arguments,2);return function(){var newArgs=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(newArgs,boundArgs);return fn.apply(selfObj,newArgs);};}return function(){return fn.apply(selfObj,arguments);};};goog.bind=function(fn,selfObj,var_args){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?goog.bind=goog.bindNative_:goog.bind=goog.bindJs_;return goog.bind.apply(null,arguments);};goog.partial=function(fn,var_args){var args=Array.prototype.slice.call(arguments,1);return function(){var newArgs=args.slice();newArgs.push.apply(newArgs,arguments);return fn.apply(this,newArgs);};};goog.mixin=function(target,source){for(var x in source){target[x]=source[x];}};goog.now=goog.TRUSTED_SITE&&Date.now||function(){return+new Date();};goog.globalEval=function(script){if(goog.global.execScript){goog.global.execScript(script,"JavaScript");}else{if(goog.global.eval){if(null==goog.evalWorksForGlobals_){if(goog.global.eval("var _evalTest_ = 1;"),"undefined"!=typeof goog.global._evalTest_){try{delete goog.global._evalTest_;}catch(ignore){}goog.evalWorksForGlobals_=!0;}else{goog.evalWorksForGlobals_=!1;}}if(goog.evalWorksForGlobals_){goog.global.eval(script);}else{var doc=goog.global.document,scriptElt=doc.createElement("SCRIPT");scriptElt.type="text/javascript";scriptElt.defer=!1;scriptElt.appendChild(doc.createTextNode(script));doc.body.appendChild(scriptElt);doc.body.removeChild(scriptElt);}}else{throw Error("goog.globalEval not available");}}};goog.evalWorksForGlobals_=null;goog.getCssName=function(className,opt_modifier){if("."==String(className).charAt(0)){throw Error(\'className passed in goog.getCssName must not start with ".". You passed: \'+className);}var getMapping=function getMapping(cssName){return goog.cssNameMapping_[cssName]||cssName;},renameByParts=function renameByParts(cssName){for(var parts=cssName.split("-"),mapped=[],i=0;i<parts.length;i++){mapped.push(getMapping(parts[i]));}return mapped.join("-");};var rename=goog.cssNameMapping_?"BY_WHOLE"==goog.cssNameMappingStyle_?getMapping:renameByParts:function(a){return a;};var result=opt_modifier?className+"-"+rename(opt_modifier):rename(className);return goog.global.CLOSURE_CSS_NAME_MAP_FN?goog.global.CLOSURE_CSS_NAME_MAP_FN(result):result;};goog.setCssNameMapping=function(mapping,opt_style){goog.cssNameMapping_=mapping;goog.cssNameMappingStyle_=opt_style;};goog.getMsg=function(str,opt_values){opt_values&&(str=str.replace(/\\{\\$([^}]+)}/g,function(match,key){return null!=opt_values&&key in opt_values?opt_values[key]:match;}));return str;};goog.getMsgWithFallback=function(a,b){return a;};goog.exportSymbol=function(publicPath,object,opt_objectToExportTo){goog.exportPath_(publicPath,object,opt_objectToExportTo);};goog.exportProperty=function(object,publicName,symbol){object[publicName]=symbol;};goog.inherits=function(childCtor,parentCtor){function tempCtor(){}tempCtor.prototype=parentCtor.prototype;childCtor.superClass_=parentCtor.prototype;childCtor.prototype=new tempCtor();childCtor.prototype.constructor=childCtor;childCtor.base=function(me,methodName,var_args){for(var args=Array(arguments.length-2),i=2;i<arguments.length;i++){args[i-2]=arguments[i];}return parentCtor.prototype[methodName].apply(me,args);};};goog.base=function(me,opt_methodName,var_args){var caller=arguments.callee.caller;if(goog.STRICT_MODE_COMPATIBLE||goog.DEBUG&&!caller){throw Error("arguments.caller not defined.  goog.base() cannot be used with strict mode code. See http://www.ecma-international.org/ecma-262/5.1/#sec-C");}if(caller.superClass_){for(var ctorArgs=Array(arguments.length-1),i=1;i<arguments.length;i++){ctorArgs[i-1]=arguments[i];}return caller.superClass_.constructor.apply(me,ctorArgs);}for(var args=Array(arguments.length-2),i=2;i<arguments.length;i++){args[i-2]=arguments[i];}for(var foundCaller=!1,ctor=me.constructor;ctor;ctor=ctor.superClass_&&ctor.superClass_.constructor){if(ctor.prototype[opt_methodName]===caller){foundCaller=!0;}else{if(foundCaller){return ctor.prototype[opt_methodName].apply(me,args);}}}if(me[opt_methodName]===caller){return me.constructor.prototype[opt_methodName].apply(me,args);}throw Error("goog.base called from a method of one name to a method of a different name");};goog.scope=function(fn){if(goog.isInModuleLoader_()){throw Error("goog.scope is not supported within a goog.module.");}fn.call(goog.global);};goog.defineClass=function(superClass,def){var constructor=def.constructor,statics=def.statics;constructor&&constructor!=Object.prototype.constructor||(constructor=function constructor(){throw Error("cannot instantiate an interface (no constructor defined).");});var cls=goog.defineClass.createSealingConstructor_(constructor,superClass);superClass&&goog.inherits(cls,superClass);delete def.constructor;delete def.statics;goog.defineClass.applyProperties_(cls.prototype,def);null!=statics&&(statics instanceof Function?statics(cls):goog.defineClass.applyProperties_(cls,statics));return cls;};goog.defineClass.SEAL_CLASS_INSTANCES=goog.DEBUG;goog.defineClass.createSealingConstructor_=function(ctr,superClass){if(!goog.defineClass.SEAL_CLASS_INSTANCES){return ctr;}var superclassSealable=!goog.defineClass.isUnsealable_(superClass),wrappedCtr=function wrappedCtr(){var instance=ctr.apply(this,arguments)||this;instance[goog.UID_PROPERTY_]=instance[goog.UID_PROPERTY_];this.constructor===wrappedCtr&&superclassSealable&&Object.seal instanceof Function&&Object.seal(instance);return instance;};return wrappedCtr;};goog.defineClass.isUnsealable_=function(ctr){return ctr&&ctr.prototype&&ctr.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_];};goog.defineClass.OBJECT_PROTOTYPE_FIELDS_="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");goog.defineClass.applyProperties_=function(target,source){for(var key in source){Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);}for(var i=0;i<goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length;i++){key=goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[i],Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);}};goog.tagUnsealableClass=function(ctr){};goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_="goog_defineClass_legacy_unsealable";goog.createRequiresTranspilation_=function(){function addNewerLanguageTranspilationCheck(modeName,isSupported){transpilationRequiredForAllLaterModes?requiresTranspilation[modeName]=!0:isSupported()?requiresTranspilation[modeName]=!1:transpilationRequiredForAllLaterModes=requiresTranspilation[modeName]=!0;}function evalCheck(code){try{return!!eval(code);}catch(ignored){return!1;}}var requiresTranspilation={es3:!1},transpilationRequiredForAllLaterModes=!1,userAgent=goog.global.navigator&&goog.global.navigator.userAgent?goog.global.navigator.userAgent:"";addNewerLanguageTranspilationCheck("es5",function(){return evalCheck("[1,].length==1");});addNewerLanguageTranspilationCheck("es6",function(){var edgeUserAgent=userAgent.match(/Edge\\/(\\d+)(\\.\\d)*/i);return edgeUserAgent&&15>Number(edgeUserAgent[1])?!1:evalCheck(\'(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()\');});addNewerLanguageTranspilationCheck("es6-impl",function(){return!0;});addNewerLanguageTranspilationCheck("es7",function(){return evalCheck("2 ** 2 == 4");});addNewerLanguageTranspilationCheck("es8",function(){return evalCheck("async () => 1, true");});return requiresTranspilation;};goog.debug={};goog.debug.Error=function(opt_msg){if(Error.captureStackTrace){Error.captureStackTrace(this,goog.debug.Error);}else{var stack=Error().stack;stack&&(this.stack=stack);}opt_msg&&(this.message=String(opt_msg));this.reportErrorToServer=!0;};goog.inherits(goog.debug.Error,Error);goog.debug.Error.prototype.name="CustomError";goog.dom={};goog.dom.NodeType={ELEMENT:1,ATTRIBUTE:2,TEXT:3,CDATA_SECTION:4,ENTITY_REFERENCE:5,ENTITY:6,PROCESSING_INSTRUCTION:7,COMMENT:8,DOCUMENT:9,DOCUMENT_TYPE:10,DOCUMENT_FRAGMENT:11,NOTATION:12};goog.string={};goog.string.DETECT_DOUBLE_ESCAPING=!1;goog.string.FORCE_NON_DOM_HTML_UNESCAPING=!1;goog.string.Unicode={NBSP:"\\xA0"};goog.string.startsWith=function(str,prefix){return 0==str.lastIndexOf(prefix,0);};goog.string.endsWith=function(str,suffix){var l=str.length-suffix.length;return 0<=l&&str.indexOf(suffix,l)==l;};goog.string.caseInsensitiveStartsWith=function(str,prefix){return 0==goog.string.caseInsensitiveCompare(prefix,str.substr(0,prefix.length));};goog.string.caseInsensitiveEndsWith=function(str,suffix){return 0==goog.string.caseInsensitiveCompare(suffix,str.substr(str.length-suffix.length,suffix.length));};goog.string.caseInsensitiveEquals=function(str1,str2){return str1.toLowerCase()==str2.toLowerCase();};goog.string.subs=function(str,var_args){for(var splitParts=str.split("%s"),returnString="",subsArguments=Array.prototype.slice.call(arguments,1);subsArguments.length&&1<splitParts.length;){returnString+=splitParts.shift()+subsArguments.shift();}return returnString+splitParts.join("%s");};goog.string.collapseWhitespace=function(str){return str.replace(/[\\s\\xa0]+/g," ").replace(/^\\s+|\\s+$/g,"");};goog.string.isEmptyOrWhitespace=function(str){return /^[\\s\\xa0]*$/.test(str);};goog.string.isEmptyString=function(str){return 0==str.length;};goog.string.isEmpty=goog.string.isEmptyOrWhitespace;goog.string.isEmptyOrWhitespaceSafe=function(str){return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(str));};goog.string.isEmptySafe=goog.string.isEmptyOrWhitespaceSafe;goog.string.isBreakingWhitespace=function(str){return!/[^\\t\\n\\r ]/.test(str);};goog.string.isAlpha=function(str){return!/[^a-zA-Z]/.test(str);};goog.string.isNumeric=function(str){return!/[^0-9]/.test(str);};goog.string.isAlphaNumeric=function(str){return!/[^a-zA-Z0-9]/.test(str);};goog.string.isSpace=function(ch){return" "==ch;};goog.string.isUnicodeChar=function(ch){return 1==ch.length&&" "<=ch&&"~">=ch||"\\x80"<=ch&&"\\uFFFD">=ch;};goog.string.stripNewlines=function(str){return str.replace(/(\\r\\n|\\r|\\n)+/g," ");};goog.string.canonicalizeNewlines=function(str){return str.replace(/(\\r\\n|\\r|\\n)/g,"\\n");};goog.string.normalizeWhitespace=function(str){return str.replace(/\\xa0|\\s/g," ");};goog.string.normalizeSpaces=function(str){return str.replace(/\\xa0|[ \\t]+/g," ");};goog.string.collapseBreakingSpaces=function(str){return str.replace(/[\\t\\r\\n ]+/g," ").replace(/^[\\t\\r\\n ]+|[\\t\\r\\n ]+$/g,"");};goog.string.trim=goog.TRUSTED_SITE&&String.prototype.trim?function(str){return str.trim();}:function(str){return str.replace(/^[\\s\\xa0]+|[\\s\\xa0]+$/g,"");};goog.string.trimLeft=function(str){return str.replace(/^[\\s\\xa0]+/,"");};goog.string.trimRight=function(str){return str.replace(/[\\s\\xa0]+$/,"");};goog.string.caseInsensitiveCompare=function(str1,str2){var test1=String(str1).toLowerCase(),test2=String(str2).toLowerCase();return test1<test2?-1:test1==test2?0:1;};goog.string.numberAwareCompare_=function(str1,str2,tokenizerRegExp){if(str1==str2){return 0;}if(!str1){return-1;}if(!str2){return 1;}for(var tokens1=str1.toLowerCase().match(tokenizerRegExp),tokens2=str2.toLowerCase().match(tokenizerRegExp),count=Math.min(tokens1.length,tokens2.length),i=0;i<count;i++){var a=tokens1[i],b=tokens2[i];if(a!=b){var num1=parseInt(a,10);if(!isNaN(num1)){var num2=parseInt(b,10);if(!isNaN(num2)&&num1-num2){return num1-num2;}}return a<b?-1:1;}}return tokens1.length!=tokens2.length?tokens1.length-tokens2.length:str1<str2?-1:1;};goog.string.intAwareCompare=function(str1,str2){return goog.string.numberAwareCompare_(str1,str2,/\\d+|\\D+/g);};goog.string.floatAwareCompare=function(str1,str2){return goog.string.numberAwareCompare_(str1,str2,/\\d+|\\.\\d+|\\D+/g);};goog.string.numerateCompare=goog.string.floatAwareCompare;goog.string.urlEncode=function(str){return encodeURIComponent(String(str));};goog.string.urlDecode=function(str){return decodeURIComponent(str.replace(/\\+/g," "));};goog.string.newLineToBr=function(str,opt_xml){return str.replace(/(\\r\\n|\\r|\\n)/g,opt_xml?"<br />":"<br>");};goog.string.htmlEscape=function(str,opt_isLikelyToContainHtmlChars){if(opt_isLikelyToContainHtmlChars){str=str.replace(goog.string.AMP_RE_,"&amp;").replace(goog.string.LT_RE_,"&lt;").replace(goog.string.GT_RE_,"&gt;").replace(goog.string.QUOT_RE_,"&quot;").replace(goog.string.SINGLE_QUOTE_RE_,"&#39;").replace(goog.string.NULL_RE_,"&#0;"),goog.string.DETECT_DOUBLE_ESCAPING&&(str=str.replace(goog.string.E_RE_,"&#101;"));}else{if(!goog.string.ALL_RE_.test(str)){return str;}-1!=str.indexOf("&")&&(str=str.replace(goog.string.AMP_RE_,"&amp;"));-1!=str.indexOf("<")&&(str=str.replace(goog.string.LT_RE_,"&lt;"));-1!=str.indexOf(">")&&(str=str.replace(goog.string.GT_RE_,"&gt;"));-1!=str.indexOf(\'"\')&&(str=str.replace(goog.string.QUOT_RE_,"&quot;"));-1!=str.indexOf("\'")&&(str=str.replace(goog.string.SINGLE_QUOTE_RE_,"&#39;"));-1!=str.indexOf("\\x00")&&(str=str.replace(goog.string.NULL_RE_,"&#0;"));goog.string.DETECT_DOUBLE_ESCAPING&&-1!=str.indexOf("e")&&(str=str.replace(goog.string.E_RE_,"&#101;"));}return str;};goog.string.AMP_RE_=/&/g;goog.string.LT_RE_=/</g;goog.string.GT_RE_=/>/g;goog.string.QUOT_RE_=/"/g;goog.string.SINGLE_QUOTE_RE_=/\'/g;goog.string.NULL_RE_=/\\x00/g;goog.string.E_RE_=/e/g;goog.string.ALL_RE_=goog.string.DETECT_DOUBLE_ESCAPING?/[\\x00&<>"\'e]/:/[\\x00&<>"\']/;goog.string.unescapeEntities=function(str){return goog.string.contains(str,"&")?!goog.string.FORCE_NON_DOM_HTML_UNESCAPING&&"document"in goog.global?goog.string.unescapeEntitiesUsingDom_(str):goog.string.unescapePureXmlEntities_(str):str;};goog.string.unescapeEntitiesWithDocument=function(str,document){return goog.string.contains(str,"&")?goog.string.unescapeEntitiesUsingDom_(str,document):str;};goog.string.unescapeEntitiesUsingDom_=function(str,opt_document){var seen={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":\'"\'};var div=opt_document?opt_document.createElement("div"):goog.global.document.createElement("div");return str.replace(goog.string.HTML_ENTITY_PATTERN_,function(s,entity){var value=seen[s];if(value){return value;}if("#"==entity.charAt(0)){var n=Number("0"+entity.substr(1));isNaN(n)||(value=String.fromCharCode(n));}value||(div.innerHTML=s+" ",value=div.firstChild.nodeValue.slice(0,-1));return seen[s]=value;});};goog.string.unescapePureXmlEntities_=function(str){return str.replace(/&([^;]+);/g,function(s,entity){switch(entity){case"amp":return"&";case"lt":return"<";case"gt":return">";case"quot":return\'"\';default:if("#"==entity.charAt(0)){var n=Number("0"+entity.substr(1));if(!isNaN(n)){return String.fromCharCode(n);}}return s;}});};goog.string.HTML_ENTITY_PATTERN_=/&([^;\\s<&]+);?/g;goog.string.whitespaceEscape=function(str,opt_xml){return goog.string.newLineToBr(str.replace(/  /g," &#160;"),opt_xml);};goog.string.preserveSpaces=function(str){return str.replace(/(^|[\\n ]) /g,"$1"+goog.string.Unicode.NBSP);};goog.string.stripQuotes=function(str,quoteChars){for(var length=quoteChars.length,i=0;i<length;i++){var quoteChar=1==length?quoteChars:quoteChars.charAt(i);if(str.charAt(0)==quoteChar&&str.charAt(str.length-1)==quoteChar){return str.substring(1,str.length-1);}}return str;};goog.string.truncate=function(str,chars,opt_protectEscapedCharacters){opt_protectEscapedCharacters&&(str=goog.string.unescapeEntities(str));str.length>chars&&(str=str.substring(0,chars-3)+"...");opt_protectEscapedCharacters&&(str=goog.string.htmlEscape(str));return str;};goog.string.truncateMiddle=function(str,chars,opt_protectEscapedCharacters,opt_trailingChars){opt_protectEscapedCharacters&&(str=goog.string.unescapeEntities(str));if(opt_trailingChars&&str.length>chars){opt_trailingChars>chars&&(opt_trailingChars=chars),str=str.substring(0,chars-opt_trailingChars)+"..."+str.substring(str.length-opt_trailingChars);}else{if(str.length>chars){var half=Math.floor(chars/2);str=str.substring(0,half+chars%2)+"..."+str.substring(str.length-half);}}opt_protectEscapedCharacters&&(str=goog.string.htmlEscape(str));return str;};goog.string.specialEscapeChars_={"\\x00":"\\\\0","\\b":"\\\\b","\\f":"\\\\f","\\n":"\\\\n","\\r":"\\\\r","\\t":"\\\\t","\\x0B":"\\\\x0B",\'"\':\'\\\\"\',"\\\\":"\\\\\\\\","<":"<"};goog.string.jsEscapeCache_={"\'":"\\\\\'"};goog.string.quote=function(s){s=String(s);for(var sb=[\'"\'],i=0;i<s.length;i++){var ch=s.charAt(i),cc=ch.charCodeAt(0);sb[i+1]=goog.string.specialEscapeChars_[ch]||(31<cc&&127>cc?ch:goog.string.escapeChar(ch));}sb.push(\'"\');return sb.join("");};goog.string.escapeString=function(str){for(var sb=[],i=0;i<str.length;i++){sb[i]=goog.string.escapeChar(str.charAt(i));}return sb.join("");};goog.string.escapeChar=function(c){if(c in goog.string.jsEscapeCache_){return goog.string.jsEscapeCache_[c];}if(c in goog.string.specialEscapeChars_){return goog.string.jsEscapeCache_[c]=goog.string.specialEscapeChars_[c];}var rv=c,cc=c.charCodeAt(0);if(31<cc&&127>cc){rv=c;}else{if(256>cc){if(rv="\\\\x",16>cc||256<cc){rv+="0";}}else{rv="\\\\u",4096>cc&&(rv+="0");}rv+=cc.toString(16).toUpperCase();}return goog.string.jsEscapeCache_[c]=rv;};goog.string.contains=function(str,subString){return-1!=str.indexOf(subString);};goog.string.caseInsensitiveContains=function(str,subString){return goog.string.contains(str.toLowerCase(),subString.toLowerCase());};goog.string.countOf=function(s,ss){return s&&ss?s.split(ss).length-1:0;};goog.string.removeAt=function(s,index,stringLength){var resultStr=s;0<=index&&index<s.length&&0<stringLength&&(resultStr=s.substr(0,index)+s.substr(index+stringLength,s.length-index-stringLength));return resultStr;};goog.string.remove=function(str,substr){return str.replace(substr,"");};goog.string.removeAll=function(s,ss){var re=new RegExp(goog.string.regExpEscape(ss),"g");return s.replace(re,"");};goog.string.replaceAll=function(s,ss,replacement){var re=new RegExp(goog.string.regExpEscape(ss),"g");return s.replace(re,replacement.replace(/\\$/g,"$$$$"));};goog.string.regExpEscape=function(s){return String(s).replace(/([-()\\[\\]{}+?*.$\\^|,:#<!\\\\])/g,"\\\\$1").replace(/\\x08/g,"\\\\x08");};goog.string.repeat=String.prototype.repeat?function(string,length){return string.repeat(length);}:function(string,length){return Array(length+1).join(string);};goog.string.padNumber=function(num,length,opt_precision){var s=goog.isDef(opt_precision)?num.toFixed(opt_precision):String(num),index=s.indexOf(".");-1==index&&(index=s.length);return goog.string.repeat("0",Math.max(0,length-index))+s;};goog.string.makeSafe=function(obj){return null==obj?"":String(obj);};goog.string.buildString=function(var_args){return Array.prototype.join.call(arguments,"");};goog.string.getRandomString=function(){return Math.floor(2147483648*Math.random()).toString(36)+Math.abs(Math.floor(2147483648*Math.random())^goog.now()).toString(36);};goog.string.compareVersions=function(version1,version2){for(var order=0,v1Subs=goog.string.trim(String(version1)).split("."),v2Subs=goog.string.trim(String(version2)).split("."),subCount=Math.max(v1Subs.length,v2Subs.length),subIdx=0;0==order&&subIdx<subCount;subIdx++){var v1Sub=v1Subs[subIdx]||"",v2Sub=v2Subs[subIdx]||"";do{var v1Comp=/(\\d*)(\\D*)(.*)/.exec(v1Sub)||["","","",""],v2Comp=/(\\d*)(\\D*)(.*)/.exec(v2Sub)||["","","",""];if(0==v1Comp[0].length&&0==v2Comp[0].length){break;}order=goog.string.compareElements_(0==v1Comp[1].length?0:parseInt(v1Comp[1],10),0==v2Comp[1].length?0:parseInt(v2Comp[1],10))||goog.string.compareElements_(0==v1Comp[2].length,0==v2Comp[2].length)||goog.string.compareElements_(v1Comp[2],v2Comp[2]);v1Sub=v1Comp[3];v2Sub=v2Comp[3];}while(0==order);}return order;};goog.string.compareElements_=function(left,right){return left<right?-1:left>right?1:0;};goog.string.hashCode=function(str){for(var result=0,i=0;i<str.length;++i){result=31*result+str.charCodeAt(i)>>>0;}return result;};goog.string.uniqueStringCounter_=2147483648*Math.random()|0;goog.string.createUniqueString=function(){return"goog_"+goog.string.uniqueStringCounter_++;};goog.string.toNumber=function(str){var num=Number(str);return 0==num&&goog.string.isEmptyOrWhitespace(str)?NaN:num;};goog.string.isLowerCamelCase=function(str){return /^[a-z]+([A-Z][a-z]*)*$/.test(str);};goog.string.isUpperCamelCase=function(str){return /^([A-Z][a-z]*)+$/.test(str);};goog.string.toCamelCase=function(str){return String(str).replace(/\\-([a-z])/g,function(all,match){return match.toUpperCase();});};goog.string.toSelectorCase=function(str){return String(str).replace(/([A-Z])/g,"-$1").toLowerCase();};goog.string.toTitleCase=function(str,opt_delimiters){var delimiters=goog.isString(opt_delimiters)?goog.string.regExpEscape(opt_delimiters):"\\\\s";return str.replace(new RegExp("(^"+(delimiters?"|["+delimiters+"]+":"")+")([a-z])","g"),function(all,p1,p2){return p1+p2.toUpperCase();});};goog.string.capitalize=function(str){return String(str.charAt(0)).toUpperCase()+String(str.substr(1)).toLowerCase();};goog.string.parseInt=function(value){isFinite(value)&&(value=String(value));return goog.isString(value)?/^\\s*-?0x/i.test(value)?parseInt(value,16):parseInt(value,10):NaN;};goog.string.splitLimit=function(str,separator,limit){for(var parts=str.split(separator),returnVal=[];0<limit&&parts.length;){returnVal.push(parts.shift()),limit--;}parts.length&&returnVal.push(parts.join(separator));return returnVal;};goog.string.lastComponent=function(str,separators){if(separators){"string"==typeof separators&&(separators=[separators]);}else{return str;}for(var lastSeparatorIndex=-1,i=0;i<separators.length;i++){if(""!=separators[i]){var currentSeparatorIndex=str.lastIndexOf(separators[i]);currentSeparatorIndex>lastSeparatorIndex&&(lastSeparatorIndex=currentSeparatorIndex);}}return-1==lastSeparatorIndex?str:str.slice(lastSeparatorIndex+1);};goog.string.editDistance=function(a,b){var v0=[],v1=[];if(a==b){return 0;}if(!a.length||!b.length){return Math.max(a.length,b.length);}for(var i=0;i<b.length+1;i++){v0[i]=i;}for(i=0;i<a.length;i++){v1[0]=i+1;for(var j=0;j<b.length;j++){v1[j+1]=Math.min(v1[j]+1,v0[j+1]+1,v0[j]+Number(a[i]!=b[j]));}for(j=0;j<v0.length;j++){v0[j]=v1[j];}}return v1[b.length];};goog.asserts={};goog.asserts.ENABLE_ASSERTS=goog.DEBUG;goog.asserts.AssertionError=function(messagePattern,messageArgs){messageArgs.unshift(messagePattern);goog.debug.Error.call(this,goog.string.subs.apply(null,messageArgs));messageArgs.shift();this.messagePattern=messagePattern;};goog.inherits(goog.asserts.AssertionError,goog.debug.Error);goog.asserts.AssertionError.prototype.name="AssertionError";goog.asserts.DEFAULT_ERROR_HANDLER=function(e){throw e;};goog.asserts.errorHandler_=goog.asserts.DEFAULT_ERROR_HANDLER;goog.asserts.doAssertFailure_=function(defaultMessage,defaultArgs,givenMessage,givenArgs){var message="Assertion failed";if(givenMessage){message+=": "+givenMessage;var args=givenArgs;}else{defaultMessage&&(message+=": "+defaultMessage,args=defaultArgs);}var e=new goog.asserts.AssertionError(""+message,args||[]);goog.asserts.errorHandler_(e);};goog.asserts.setErrorHandler=function(errorHandler){goog.asserts.ENABLE_ASSERTS&&(goog.asserts.errorHandler_=errorHandler);};goog.asserts.assert=function(condition,opt_message,var_args){goog.asserts.ENABLE_ASSERTS&&!condition&&goog.asserts.doAssertFailure_("",null,opt_message,Array.prototype.slice.call(arguments,2));return condition;};goog.asserts.fail=function(opt_message,var_args){goog.asserts.ENABLE_ASSERTS&&goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure"+(opt_message?": "+opt_message:""),Array.prototype.slice.call(arguments,1)));};goog.asserts.assertNumber=function(value,opt_message,var_args){goog.asserts.ENABLE_ASSERTS&&!goog.isNumber(value)&&goog.asserts.doAssertFailure_("Expected number but got %s: %s.",[goog.typeOf(value),value],opt_message,Array.prototype.slice.call(arguments,2));return value;};goog.asserts.assertString=function(value,opt_message,var_args){goog.asserts.ENABLE_ASSERTS&&!goog.isString(value)&&goog.asserts.doAssertFailure_("Expected string but got %s: %s.",[goog.typeOf(value),value],opt_message,Array.prototype.slice.call(arguments,2));return value;};goog.asserts.assertFunction=function(value,opt_message,var_args){goog.asserts.ENABLE_ASSERTS&&!goog.isFunction(value)&&goog.asserts.doAssertFailure_("Expected function but got %s: %s.",[goog.typeOf(value),value],opt_message,Array.prototype.slice.call(arguments,2));return value;};goog.asserts.assertObject=function(value,opt_message,var_args){goog.asserts.ENABLE_ASSERTS&&!goog.isObject(value)&&goog.asserts.doAssertFailure_("Expected object but got %s: %s.",[goog.typeOf(value),value],opt_message,Array.prototype.slice.call(arguments,2));return value;};goog.asserts.assertArray=function(value,opt_message,var_args){goog.asserts.ENABLE_ASSERTS&&!goog.isArray(value)&&goog.asserts.doAssertFailure_("Expected array but got %s: %s.",[goog.typeOf(value),value],opt_message,Array.prototype.slice.call(arguments,2));return value;};goog.asserts.assertBoolean=function(value,opt_message,var_args){goog.asserts.ENABLE_ASSERTS&&!goog.isBoolean(value)&&goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.",[goog.typeOf(value),value],opt_message,Array.prototype.slice.call(arguments,2));return value;};goog.asserts.assertElement=function(value,opt_message,var_args){!goog.asserts.ENABLE_ASSERTS||goog.isObject(value)&&value.nodeType==goog.dom.NodeType.ELEMENT||goog.asserts.doAssertFailure_("Expected Element but got %s: %s.",[goog.typeOf(value),value],opt_message,Array.prototype.slice.call(arguments,2));return value;};goog.asserts.assertInstanceof=function(value,type,opt_message,var_args){!goog.asserts.ENABLE_ASSERTS||value instanceof type||goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.",[goog.asserts.getType_(type),goog.asserts.getType_(value)],opt_message,Array.prototype.slice.call(arguments,3));return value;};goog.asserts.assertObjectPrototypeIsIntact=function(){for(var key in Object.prototype){goog.asserts.fail(key+" should not be enumerable in Object.prototype.");}};goog.asserts.getType_=function(value){return value instanceof Function?value.displayName||value.name||"unknown type name":value instanceof Object?value.constructor.displayName||value.constructor.name||Object.prototype.toString.call(value):null===value?"null":typeof value==="undefined"?"undefined":_typeof(value);};goog.array={};goog.NATIVE_ARRAY_PROTOTYPES=goog.TRUSTED_SITE;goog.array.ASSUME_NATIVE_FUNCTIONS=!1;goog.array.peek=function(array){return array[array.length-1];};goog.array.last=goog.array.peek;goog.array.indexOf=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.indexOf)?function(arr,obj,opt_fromIndex){goog.asserts.assert(null!=arr.length);return Array.prototype.indexOf.call(arr,obj,opt_fromIndex);}:function(arr,obj,opt_fromIndex){var fromIndex=null==opt_fromIndex?0:0>opt_fromIndex?Math.max(0,arr.length+opt_fromIndex):opt_fromIndex;if(goog.isString(arr)){return goog.isString(obj)&&1==obj.length?arr.indexOf(obj,fromIndex):-1;}for(var i=fromIndex;i<arr.length;i++){if(i in arr&&arr[i]===obj){return i;}}return-1;};goog.array.lastIndexOf=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.lastIndexOf)?function(arr,obj,opt_fromIndex){goog.asserts.assert(null!=arr.length);return Array.prototype.lastIndexOf.call(arr,obj,null==opt_fromIndex?arr.length-1:opt_fromIndex);}:function(arr,obj,opt_fromIndex){var fromIndex=null==opt_fromIndex?arr.length-1:opt_fromIndex;0>fromIndex&&(fromIndex=Math.max(0,arr.length+fromIndex));if(goog.isString(arr)){return goog.isString(obj)&&1==obj.length?arr.lastIndexOf(obj,fromIndex):-1;}for(var i=fromIndex;0<=i;i--){if(i in arr&&arr[i]===obj){return i;}}return-1;};goog.array.forEach=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.forEach)?function(arr,f,opt_obj){goog.asserts.assert(null!=arr.length);Array.prototype.forEach.call(arr,f,opt_obj);}:function(arr,f,opt_obj){for(var l=arr.length,arr2=goog.isString(arr)?arr.split(""):arr,i=0;i<l;i++){i in arr2&&f.call(opt_obj,arr2[i],i,arr);}};goog.array.forEachRight=function(arr,f,opt_obj){for(var l=arr.length,arr2=goog.isString(arr)?arr.split(""):arr,i=l-1;0<=i;--i){i in arr2&&f.call(opt_obj,arr2[i],i,arr);}};goog.array.filter=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.filter)?function(arr,f,opt_obj){goog.asserts.assert(null!=arr.length);return Array.prototype.filter.call(arr,f,opt_obj);}:function(arr,f,opt_obj){for(var l=arr.length,res=[],resLength=0,arr2=goog.isString(arr)?arr.split(""):arr,i=0;i<l;i++){if(i in arr2){var val=arr2[i];f.call(opt_obj,val,i,arr)&&(res[resLength++]=val);}}return res;};goog.array.map=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.map)?function(arr,f,opt_obj){goog.asserts.assert(null!=arr.length);return Array.prototype.map.call(arr,f,opt_obj);}:function(arr,f,opt_obj){for(var l=arr.length,res=Array(l),arr2=goog.isString(arr)?arr.split(""):arr,i=0;i<l;i++){i in arr2&&(res[i]=f.call(opt_obj,arr2[i],i,arr));}return res;};goog.array.reduce=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.reduce)?function(arr,f,val,opt_obj){goog.asserts.assert(null!=arr.length);opt_obj&&(f=goog.bind(f,opt_obj));return Array.prototype.reduce.call(arr,f,val);}:function(arr,f,val$jscomp$0,opt_obj){var rval=val$jscomp$0;goog.array.forEach(arr,function(val,index){rval=f.call(opt_obj,rval,val,index,arr);});return rval;};goog.array.reduceRight=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.reduceRight)?function(arr,f,val,opt_obj){goog.asserts.assert(null!=arr.length);goog.asserts.assert(null!=f);opt_obj&&(f=goog.bind(f,opt_obj));return Array.prototype.reduceRight.call(arr,f,val);}:function(arr,f,val$jscomp$0,opt_obj){var rval=val$jscomp$0;goog.array.forEachRight(arr,function(val,index){rval=f.call(opt_obj,rval,val,index,arr);});return rval;};goog.array.some=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.some)?function(arr,f,opt_obj){goog.asserts.assert(null!=arr.length);return Array.prototype.some.call(arr,f,opt_obj);}:function(arr,f,opt_obj){for(var l=arr.length,arr2=goog.isString(arr)?arr.split(""):arr,i=0;i<l;i++){if(i in arr2&&f.call(opt_obj,arr2[i],i,arr)){return!0;}}return!1;};goog.array.every=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.every)?function(arr,f,opt_obj){goog.asserts.assert(null!=arr.length);return Array.prototype.every.call(arr,f,opt_obj);}:function(arr,f,opt_obj){for(var l=arr.length,arr2=goog.isString(arr)?arr.split(""):arr,i=0;i<l;i++){if(i in arr2&&!f.call(opt_obj,arr2[i],i,arr)){return!1;}}return!0;};goog.array.count=function(arr$jscomp$0,f,opt_obj){var count=0;goog.array.forEach(arr$jscomp$0,function(element,index,arr){f.call(opt_obj,element,index,arr)&&++count;},opt_obj);return count;};goog.array.find=function(arr,f,opt_obj){var i=goog.array.findIndex(arr,f,opt_obj);return 0>i?null:goog.isString(arr)?arr.charAt(i):arr[i];};goog.array.findIndex=function(arr,f,opt_obj){for(var l=arr.length,arr2=goog.isString(arr)?arr.split(""):arr,i=0;i<l;i++){if(i in arr2&&f.call(opt_obj,arr2[i],i,arr)){return i;}}return-1;};goog.array.findRight=function(arr,f,opt_obj){var i=goog.array.findIndexRight(arr,f,opt_obj);return 0>i?null:goog.isString(arr)?arr.charAt(i):arr[i];};goog.array.findIndexRight=function(arr,f,opt_obj){for(var l=arr.length,arr2=goog.isString(arr)?arr.split(""):arr,i=l-1;0<=i;i--){if(i in arr2&&f.call(opt_obj,arr2[i],i,arr)){return i;}}return-1;};goog.array.contains=function(arr,obj){return 0<=goog.array.indexOf(arr,obj);};goog.array.isEmpty=function(arr){return 0==arr.length;};goog.array.clear=function(arr){if(!goog.isArray(arr)){for(var i=arr.length-1;0<=i;i--){delete arr[i];}}arr.length=0;};goog.array.insert=function(arr,obj){goog.array.contains(arr,obj)||arr.push(obj);};goog.array.insertAt=function(arr,obj,opt_i){goog.array.splice(arr,opt_i,0,obj);};goog.array.insertArrayAt=function(arr,elementsToAdd,opt_i){goog.partial(goog.array.splice,arr,opt_i,0).apply(null,elementsToAdd);};goog.array.insertBefore=function(arr,obj,opt_obj2){var i;2==arguments.length||0>(i=goog.array.indexOf(arr,opt_obj2))?arr.push(obj):goog.array.insertAt(arr,obj,i);};goog.array.remove=function(arr,obj){var i=goog.array.indexOf(arr,obj),rv;(rv=0<=i)&&goog.array.removeAt(arr,i);return rv;};goog.array.removeLast=function(arr,obj){var i=goog.array.lastIndexOf(arr,obj);return 0<=i?(goog.array.removeAt(arr,i),!0):!1;};goog.array.removeAt=function(arr,i){goog.asserts.assert(null!=arr.length);return 1==Array.prototype.splice.call(arr,i,1).length;};goog.array.removeIf=function(arr,f,opt_obj){var i=goog.array.findIndex(arr,f,opt_obj);return 0<=i?(goog.array.removeAt(arr,i),!0):!1;};goog.array.removeAllIf=function(arr,f,opt_obj){var removedCount=0;goog.array.forEachRight(arr,function(val,index){f.call(opt_obj,val,index,arr)&&goog.array.removeAt(arr,index)&&removedCount++;});return removedCount;};goog.array.concat=function(var_args){return Array.prototype.concat.apply([],arguments);};goog.array.join=function(var_args){return Array.prototype.concat.apply([],arguments);};goog.array.toArray=function(object){var length=object.length;if(0<length){for(var rv=Array(length),i=0;i<length;i++){rv[i]=object[i];}return rv;}return[];};goog.array.clone=goog.array.toArray;goog.array.extend=function(arr1,var_args){for(var i=1;i<arguments.length;i++){var arr2=arguments[i];if(goog.isArrayLike(arr2)){var len1=arr1.length||0,len2=arr2.length||0;arr1.length=len1+len2;for(var j=0;j<len2;j++){arr1[len1+j]=arr2[j];}}else{arr1.push(arr2);}}};goog.array.splice=function(arr,index,howMany,var_args){goog.asserts.assert(null!=arr.length);return Array.prototype.splice.apply(arr,goog.array.slice(arguments,1));};goog.array.slice=function(arr,start,opt_end){goog.asserts.assert(null!=arr.length);return 2>=arguments.length?Array.prototype.slice.call(arr,start):Array.prototype.slice.call(arr,start,opt_end);};goog.array.removeDuplicates=function(arr,opt_rv,opt_hashFn){for(var returnArray=opt_rv||arr,defaultHashFn=function defaultHashFn(item){return goog.isObject(item)?"o"+goog.getUid(item):(typeof item==="undefined"?"undefined":_typeof(item)).charAt(0)+item;},hashFn=opt_hashFn||defaultHashFn,seen={},cursorInsert=0,cursorRead=0;cursorRead<arr.length;){var current=arr[cursorRead++],key=hashFn(current);Object.prototype.hasOwnProperty.call(seen,key)||(seen[key]=!0,returnArray[cursorInsert++]=current);}returnArray.length=cursorInsert;};goog.array.binarySearch=function(arr,target,opt_compareFn){return goog.array.binarySearch_(arr,opt_compareFn||goog.array.defaultCompare,!1,target);};goog.array.binarySelect=function(arr,evaluator,opt_obj){return goog.array.binarySearch_(arr,evaluator,!0,void 0,opt_obj);};goog.array.binarySearch_=function(arr,compareFn,isEvaluator,opt_target,opt_selfObj){for(var left=0,right=arr.length,found;left<right;){var middle=left+right>>1;var compareResult=isEvaluator?compareFn.call(opt_selfObj,arr[middle],middle,arr):compareFn(opt_target,arr[middle]);0<compareResult?left=middle+1:(right=middle,found=!compareResult);}return found?left:~left;};goog.array.sort=function(arr,opt_compareFn){arr.sort(opt_compareFn||goog.array.defaultCompare);};goog.array.stableSort=function(arr,opt_compareFn){for(var compArr=Array(arr.length),i=0;i<arr.length;i++){compArr[i]={index:i,value:arr[i]};}var valueCompareFn=opt_compareFn||goog.array.defaultCompare;goog.array.sort(compArr,function stableCompareFn(obj1,obj2){return valueCompareFn(obj1.value,obj2.value)||obj1.index-obj2.index;});for(i=0;i<arr.length;i++){arr[i]=compArr[i].value;}};goog.array.sortByKey=function(arr,keyFn,opt_compareFn){var keyCompareFn=opt_compareFn||goog.array.defaultCompare;goog.array.sort(arr,function(a,b){return keyCompareFn(keyFn(a),keyFn(b));});};goog.array.sortObjectsByKey=function(arr,key,opt_compareFn){goog.array.sortByKey(arr,function(obj){return obj[key];},opt_compareFn);};goog.array.isSorted=function(arr,opt_compareFn,opt_strict){for(var compare=opt_compareFn||goog.array.defaultCompare,i=1;i<arr.length;i++){var compareResult=compare(arr[i-1],arr[i]);if(0<compareResult||0==compareResult&&opt_strict){return!1;}}return!0;};goog.array.equals=function(arr1,arr2,opt_equalsFn){if(!goog.isArrayLike(arr1)||!goog.isArrayLike(arr2)||arr1.length!=arr2.length){return!1;}for(var l=arr1.length,equalsFn=opt_equalsFn||goog.array.defaultCompareEquality,i=0;i<l;i++){if(!equalsFn(arr1[i],arr2[i])){return!1;}}return!0;};goog.array.compare3=function(arr1,arr2,opt_compareFn){for(var compare=opt_compareFn||goog.array.defaultCompare,l=Math.min(arr1.length,arr2.length),i=0;i<l;i++){var result=compare(arr1[i],arr2[i]);if(0!=result){return result;}}return goog.array.defaultCompare(arr1.length,arr2.length);};goog.array.defaultCompare=function(a,b){return a>b?1:a<b?-1:0;};goog.array.inverseDefaultCompare=function(a,b){return-goog.array.defaultCompare(a,b);};goog.array.defaultCompareEquality=function(a,b){return a===b;};goog.array.binaryInsert=function(array,value,opt_compareFn){var index=goog.array.binarySearch(array,value,opt_compareFn);return 0>index?(goog.array.insertAt(array,value,-(index+1)),!0):!1;};goog.array.binaryRemove=function(array,value,opt_compareFn){var index=goog.array.binarySearch(array,value,opt_compareFn);return 0<=index?goog.array.removeAt(array,index):!1;};goog.array.bucket=function(array,sorter,opt_obj){for(var buckets={},i=0;i<array.length;i++){var value=array[i],key=sorter.call(opt_obj,value,i,array);goog.isDef(key)&&(buckets[key]||(buckets[key]=[])).push(value);}return buckets;};goog.array.toObject=function(arr,keyFunc,opt_obj){var ret={};goog.array.forEach(arr,function(element,index){ret[keyFunc.call(opt_obj,element,index,arr)]=element;});return ret;};goog.array.range=function(startOrEnd,opt_end,opt_step){var array=[],start=0,end=startOrEnd,step=opt_step||1;void 0!==opt_end&&(start=startOrEnd,end=opt_end);if(0>step*(end-start)){return[];}if(0<step){for(var i=start;i<end;i+=step){array.push(i);}}else{for(i=start;i>end;i+=step){array.push(i);}}return array;};goog.array.repeat=function(value,n){for(var array=[],i=0;i<n;i++){array[i]=value;}return array;};goog.array.flatten=function(var_args){for(var result=[],i=0;i<arguments.length;i++){var element=arguments[i];if(goog.isArray(element)){for(var c=0;c<element.length;c+=8192){for(var chunk=goog.array.slice(element,c,c+8192),recurseResult=goog.array.flatten.apply(null,chunk),r=0;r<recurseResult.length;r++){result.push(recurseResult[r]);}}}else{result.push(element);}}return result;};goog.array.rotate=function(array,n){goog.asserts.assert(null!=array.length);array.length&&(n%=array.length,0<n?Array.prototype.unshift.apply(array,array.splice(-n,n)):0>n&&Array.prototype.push.apply(array,array.splice(0,-n)));return array;};goog.array.moveItem=function(arr,fromIndex,toIndex){goog.asserts.assert(0<=fromIndex&&fromIndex<arr.length);goog.asserts.assert(0<=toIndex&&toIndex<arr.length);var removedItems=Array.prototype.splice.call(arr,fromIndex,1);Array.prototype.splice.call(arr,toIndex,0,removedItems[0]);};goog.array.zip=function(var_args){if(!arguments.length){return[];}for(var result=[],minLen=arguments[0].length,i=1;i<arguments.length;i++){arguments[i].length<minLen&&(minLen=arguments[i].length);}for(i=0;i<minLen;i++){for(var value=[],j=0;j<arguments.length;j++){value.push(arguments[j][i]);}result.push(value);}return result;};goog.array.shuffle=function(arr,opt_randFn){for(var randFn=opt_randFn||Math.random,i=arr.length-1;0<i;i--){var j=Math.floor(randFn()*(i+1)),tmp=arr[i];arr[i]=arr[j];arr[j]=tmp;}};goog.array.copyByIndex=function(arr,index_arr){var result=[];goog.array.forEach(index_arr,function(index){result.push(arr[index]);});return result;};goog.array.concatMap=function(arr,f,opt_obj){return goog.array.concat.apply([],goog.array.map(arr,f,opt_obj));};goog.disposable={};goog.disposable.IDisposable=function(){};goog.Disposable=function(){goog.Disposable.MONITORING_MODE!=goog.Disposable.MonitoringMode.OFF&&(goog.Disposable.INCLUDE_STACK_ON_CREATION&&(this.creationStack=Error().stack),goog.Disposable.instances_[goog.getUid(this)]=this);this.disposed_=this.disposed_;this.onDisposeCallbacks_=this.onDisposeCallbacks_;};goog.Disposable.MonitoringMode={OFF:0,PERMANENT:1,INTERACTIVE:2};goog.Disposable.MONITORING_MODE=0;goog.Disposable.INCLUDE_STACK_ON_CREATION=!0;goog.Disposable.instances_={};goog.Disposable.getUndisposedObjects=function(){var ret=[],id;for(id in goog.Disposable.instances_){goog.Disposable.instances_.hasOwnProperty(id)&&ret.push(goog.Disposable.instances_[Number(id)]);}return ret;};goog.Disposable.clearUndisposedObjects=function(){goog.Disposable.instances_={};};goog.Disposable.prototype.disposed_=!1;goog.Disposable.prototype.isDisposed=function(){return this.disposed_;};goog.Disposable.prototype.getDisposed=goog.Disposable.prototype.isDisposed;goog.Disposable.prototype.dispose=function(){if(!this.disposed_&&(this.disposed_=!0,this.disposeInternal(),goog.Disposable.MONITORING_MODE!=goog.Disposable.MonitoringMode.OFF)){var uid=goog.getUid(this);if(goog.Disposable.MONITORING_MODE==goog.Disposable.MonitoringMode.PERMANENT&&!goog.Disposable.instances_.hasOwnProperty(uid)){throw Error(this+" did not call the goog.Disposable base constructor or was disposed of after a clearUndisposedObjects call");}delete goog.Disposable.instances_[uid];}};goog.Disposable.prototype.registerDisposable=function(disposable){this.addOnDisposeCallback(goog.partial(goog.dispose,disposable));};goog.Disposable.prototype.addOnDisposeCallback=function(callback,opt_scope){this.disposed_?goog.isDef(opt_scope)?callback.call(opt_scope):callback():(this.onDisposeCallbacks_||(this.onDisposeCallbacks_=[]),this.onDisposeCallbacks_.push(goog.isDef(opt_scope)?goog.bind(callback,opt_scope):callback));};goog.Disposable.prototype.disposeInternal=function(){if(this.onDisposeCallbacks_){for(;this.onDisposeCallbacks_.length;){this.onDisposeCallbacks_.shift()();}}};goog.Disposable.isDisposed=function(obj){return obj&&"function"==typeof obj.isDisposed?obj.isDisposed():!1;};goog.dispose=function(obj){obj&&"function"==typeof obj.dispose&&obj.dispose();};goog.disposeAll=function(var_args){for(var i=0,len=arguments.length;i<len;++i){var disposable=arguments[i];goog.isArrayLike(disposable)?goog.disposeAll.apply(null,disposable):goog.dispose(disposable);}};goog.events={};goog.events.EventId=function(eventId){this.id=eventId;};goog.events.EventId.prototype.toString=function(){return this.id;};goog.events.Event=function(type,opt_target){this.type=type instanceof goog.events.EventId?String(type):type;this.currentTarget=this.target=opt_target;this.defaultPrevented=this.propagationStopped_=!1;this.returnValue_=!0;};goog.events.Event.prototype.stopPropagation=function(){this.propagationStopped_=!0;};goog.events.Event.prototype.preventDefault=function(){this.defaultPrevented=!0;this.returnValue_=!1;};goog.events.Event.stopPropagation=function(e){e.stopPropagation();};goog.events.Event.preventDefault=function(e){e.preventDefault();};goog.debug.entryPointRegistry={};goog.debug.EntryPointMonitor=function(){};goog.debug.entryPointRegistry.refList_=[];goog.debug.entryPointRegistry.monitors_=[];goog.debug.entryPointRegistry.monitorsMayExist_=!1;goog.debug.entryPointRegistry.register=function(callback){goog.debug.entryPointRegistry.refList_[goog.debug.entryPointRegistry.refList_.length]=callback;if(goog.debug.entryPointRegistry.monitorsMayExist_){for(var monitors=goog.debug.entryPointRegistry.monitors_,i=0;i<monitors.length;i++){callback(goog.bind(monitors[i].wrap,monitors[i]));}}};goog.debug.entryPointRegistry.monitorAll=function(monitor){goog.debug.entryPointRegistry.monitorsMayExist_=!0;for(var transformer=goog.bind(monitor.wrap,monitor),i=0;i<goog.debug.entryPointRegistry.refList_.length;i++){goog.debug.entryPointRegistry.refList_[i](transformer);}goog.debug.entryPointRegistry.monitors_.push(monitor);};goog.debug.entryPointRegistry.unmonitorAllIfPossible=function(monitor){var monitors=goog.debug.entryPointRegistry.monitors_;goog.asserts.assert(monitor==monitors[monitors.length-1],"Only the most recent monitor can be unwrapped.");for(var transformer=goog.bind(monitor.unwrap,monitor),i=0;i<goog.debug.entryPointRegistry.refList_.length;i++){goog.debug.entryPointRegistry.refList_[i](transformer);}monitors.length--;};goog.labs={};goog.labs.userAgent={};goog.labs.userAgent.util={};goog.labs.userAgent.util.getNativeUserAgentString_=function(){var navigator=goog.labs.userAgent.util.getNavigator_();if(navigator){var userAgent=navigator.userAgent;if(userAgent){return userAgent;}}return"";};goog.labs.userAgent.util.getNavigator_=function(){return goog.global.navigator;};goog.labs.userAgent.util.userAgent_=goog.labs.userAgent.util.getNativeUserAgentString_();goog.labs.userAgent.util.setUserAgent=function(opt_userAgent){goog.labs.userAgent.util.userAgent_=opt_userAgent||goog.labs.userAgent.util.getNativeUserAgentString_();};goog.labs.userAgent.util.getUserAgent=function(){return goog.labs.userAgent.util.userAgent_;};goog.labs.userAgent.util.matchUserAgent=function(str){return goog.string.contains(goog.labs.userAgent.util.getUserAgent(),str);};goog.labs.userAgent.util.matchUserAgentIgnoreCase=function(str){return goog.string.caseInsensitiveContains(goog.labs.userAgent.util.getUserAgent(),str);};goog.labs.userAgent.util.extractVersionTuples=function(userAgent){for(var versionRegExp=/(\\w[\\w ]+)\\/([^\\s]+)\\s*(?:\\((.*?)\\))?/g,data=[],match;match=versionRegExp.exec(userAgent);){data.push([match[1],match[2],match[3]||void 0]);}return data;};goog.debug.entryPointRegistry={};goog.debug.EntryPointMonitor=function(){};goog.debug.entryPointRegistry.refList_=[];goog.debug.entryPointRegistry.monitors_=[];goog.debug.entryPointRegistry.monitorsMayExist_=!1;goog.debug.entryPointRegistry.register=function(callback){goog.debug.entryPointRegistry.refList_[goog.debug.entryPointRegistry.refList_.length]=callback;if(goog.debug.entryPointRegistry.monitorsMayExist_){for(var monitors=goog.debug.entryPointRegistry.monitors_,i=0;i<monitors.length;i++){callback(goog.bind(monitors[i].wrap,monitors[i]));}}};goog.debug.entryPointRegistry.monitorAll=function(monitor){goog.debug.entryPointRegistry.monitorsMayExist_=!0;for(var transformer=goog.bind(monitor.wrap,monitor),i=0;i<goog.debug.entryPointRegistry.refList_.length;i++){goog.debug.entryPointRegistry.refList_[i](transformer);}goog.debug.entryPointRegistry.monitors_.push(monitor);};goog.debug.entryPointRegistry.unmonitorAllIfPossible=function(monitor){var monitors=goog.debug.entryPointRegistry.monitors_;goog.asserts.assert(monitor==monitors[monitors.length-1],"Only the most recent monitor can be unwrapped.");for(var transformer=goog.bind(monitor.unwrap,monitor),i=0;i<goog.debug.entryPointRegistry.refList_.length;i++){goog.debug.entryPointRegistry.refList_[i](transformer);}monitors.length--;};goog.labs={};goog.labs.userAgent={};goog.labs.userAgent.util={};goog.labs.userAgent.util.getNativeUserAgentString_=function(){var navigator=goog.labs.userAgent.util.getNavigator_();if(navigator){var userAgent=navigator.userAgent;if(userAgent){return userAgent;}}return"";};goog.labs.userAgent.util.getNavigator_=function(){return goog.global.navigator;};goog.labs.userAgent.util.userAgent_=goog.labs.userAgent.util.getNativeUserAgentString_();goog.labs.userAgent.util.setUserAgent=function(opt_userAgent){goog.labs.userAgent.util.userAgent_=opt_userAgent||goog.labs.userAgent.util.getNativeUserAgentString_();};goog.labs.userAgent.util.getUserAgent=function(){return goog.labs.userAgent.util.userAgent_;};goog.labs.userAgent.util.matchUserAgent=function(str){return goog.string.contains(goog.labs.userAgent.util.getUserAgent(),str);};goog.labs.userAgent.util.matchUserAgentIgnoreCase=function(str){return goog.string.caseInsensitiveContains(goog.labs.userAgent.util.getUserAgent(),str);};goog.labs.userAgent.util.extractVersionTuples=function(userAgent){for(var versionRegExp=/(\\w[\\w ]+)\\/([^\\s]+)\\s*(?:\\((.*?)\\))?/g,data=[],match;match=versionRegExp.exec(userAgent);){data.push([match[1],match[2],match[3]||void 0]);}return data;};goog.object={};goog.object.is=function(v,v2){return v===v2?0!==v||1/v===1/v2:v!==v&&v2!==v2;};goog.object.forEach=function(obj,f,opt_obj){for(var key in obj){f.call(opt_obj,obj[key],key,obj);}};goog.object.filter=function(obj,f,opt_obj){var res={},key;for(key in obj){f.call(opt_obj,obj[key],key,obj)&&(res[key]=obj[key]);}return res;};goog.object.map=function(obj,f,opt_obj){var res={},key;for(key in obj){res[key]=f.call(opt_obj,obj[key],key,obj);}return res;};goog.object.some=function(obj,f,opt_obj){for(var key in obj){if(f.call(opt_obj,obj[key],key,obj)){return!0;}}return!1;};goog.object.every=function(obj,f,opt_obj){for(var key in obj){if(!f.call(opt_obj,obj[key],key,obj)){return!1;}}return!0;};goog.object.getCount=function(obj){var rv=0,key;for(key in obj){rv++;}return rv;};goog.object.getAnyKey=function(obj){for(var key in obj){return key;}};goog.object.getAnyValue=function(obj){for(var key in obj){return obj[key];}};goog.object.contains=function(obj,val){return goog.object.containsValue(obj,val);};goog.object.getValues=function(obj){var res=[],i=0,key;for(key in obj){res[i++]=obj[key];}return res;};goog.object.getKeys=function(obj){var res=[],i=0,key;for(key in obj){res[i++]=key;}return res;};goog.object.getValueByKeys=function(obj,var_args){for(var isArrayLike=goog.isArrayLike(var_args),keys=isArrayLike?var_args:arguments,i=isArrayLike?0:1;i<keys.length&&(obj=obj[keys[i]],goog.isDef(obj));i++){}return obj;};goog.object.containsKey=function(obj,key){return null!==obj&&key in obj;};goog.object.containsValue=function(obj,val){for(var key in obj){if(obj[key]==val){return!0;}}return!1;};goog.object.findKey=function(obj,f,opt_this){for(var key in obj){if(f.call(opt_this,obj[key],key,obj)){return key;}}};goog.object.findValue=function(obj,f,opt_this){var key=goog.object.findKey(obj,f,opt_this);return key&&obj[key];};goog.object.isEmpty=function(obj){for(var key in obj){return!1;}return!0;};goog.object.clear=function(obj){for(var i in obj){delete obj[i];}};goog.object.remove=function(obj,key){var rv;(rv=key in obj)&&delete obj[key];return rv;};goog.object.add=function(obj,key,val){if(null!==obj&&key in obj){throw Error(\'The object already contains the key "\'+key+\'"\');}goog.object.set(obj,key,val);};goog.object.get=function(obj,key,opt_val){return null!==obj&&key in obj?obj[key]:opt_val;};goog.object.set=function(obj,key,value){obj[key]=value;};goog.object.setIfUndefined=function(obj,key,value){return key in obj?obj[key]:obj[key]=value;};goog.object.setWithReturnValueIfNotSet=function(obj,key,f){if(key in obj){return obj[key];}var val=f();return obj[key]=val;};goog.object.equals=function(a,b){for(var k in a){if(!(k in b)||a[k]!==b[k]){return!1;}}for(k in b){if(!(k in a)){return!1;}}return!0;};goog.object.clone=function(obj){var res={},key;for(key in obj){res[key]=obj[key];}return res;};goog.object.unsafeClone=function(obj){var type=goog.typeOf(obj);if("object"==type||"array"==type){if(goog.isFunction(obj.clone)){return obj.clone();}var clone="array"==type?[]:{},key;for(key in obj){clone[key]=goog.object.unsafeClone(obj[key]);}return clone;}return obj;};goog.object.transpose=function(obj){var transposed={},key;for(key in obj){transposed[obj[key]]=key;}return transposed;};goog.object.PROTOTYPE_FIELDS_="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");goog.object.extend=function(target,var_args){for(var key,source,i=1;i<arguments.length;i++){source=arguments[i];for(key in source){target[key]=source[key];}for(var j=0;j<goog.object.PROTOTYPE_FIELDS_.length;j++){key=goog.object.PROTOTYPE_FIELDS_[j],Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);}}};goog.object.create=function(var_args){var argLength=arguments.length;if(1==argLength&&goog.isArray(arguments[0])){return goog.object.create.apply(null,arguments[0]);}if(argLength%2){throw Error("Uneven number of arguments");}for(var rv={},i=0;i<argLength;i+=2){rv[arguments[i]]=arguments[i+1];}return rv;};goog.object.createSet=function(var_args){var argLength=arguments.length;if(1==argLength&&goog.isArray(arguments[0])){return goog.object.createSet.apply(null,arguments[0]);}for(var rv={},i=0;i<argLength;i++){rv[arguments[i]]=!0;}return rv;};goog.object.createImmutableView=function(obj){var result=obj;Object.isFrozen&&!Object.isFrozen(obj)&&(result=Object.create(obj),Object.freeze(result));return result;};goog.object.isImmutableView=function(obj){return!!Object.isFrozen&&Object.isFrozen(obj);};goog.object.getAllPropertyNames=function(obj,opt_includeObjectPrototype,opt_includeFunctionPrototype){if(!obj){return[];}if(!Object.getOwnPropertyNames||!Object.getPrototypeOf){return goog.object.getKeys(obj);}for(var visitedSet={},proto=obj;proto&&(proto!==Object.prototype||opt_includeObjectPrototype)&&(proto!==Function.prototype||opt_includeFunctionPrototype);){for(var names=Object.getOwnPropertyNames(proto),i=0;i<names.length;i++){visitedSet[names[i]]=!0;}proto=Object.getPrototypeOf(proto);}return goog.object.getKeys(visitedSet);};goog.labs.userAgent.browser={};goog.labs.userAgent.browser.matchOpera_=function(){return goog.labs.userAgent.util.matchUserAgent("Opera");};goog.labs.userAgent.browser.matchIE_=function(){return goog.labs.userAgent.util.matchUserAgent("Trident")||goog.labs.userAgent.util.matchUserAgent("MSIE");};goog.labs.userAgent.browser.matchEdge_=function(){return goog.labs.userAgent.util.matchUserAgent("Edge");};goog.labs.userAgent.browser.matchFirefox_=function(){return goog.labs.userAgent.util.matchUserAgent("Firefox");};goog.labs.userAgent.browser.matchSafari_=function(){return goog.labs.userAgent.util.matchUserAgent("Safari")&&!(goog.labs.userAgent.browser.matchChrome_()||goog.labs.userAgent.browser.matchCoast_()||goog.labs.userAgent.browser.matchOpera_()||goog.labs.userAgent.browser.matchEdge_()||goog.labs.userAgent.browser.isSilk()||goog.labs.userAgent.util.matchUserAgent("Android"));};goog.labs.userAgent.browser.matchCoast_=function(){return goog.labs.userAgent.util.matchUserAgent("Coast");};goog.labs.userAgent.browser.matchIosWebview_=function(){return(goog.labs.userAgent.util.matchUserAgent("iPad")||goog.labs.userAgent.util.matchUserAgent("iPhone"))&&!goog.labs.userAgent.browser.matchSafari_()&&!goog.labs.userAgent.browser.matchChrome_()&&!goog.labs.userAgent.browser.matchCoast_()&&goog.labs.userAgent.util.matchUserAgent("AppleWebKit");};goog.labs.userAgent.browser.matchChrome_=function(){return(goog.labs.userAgent.util.matchUserAgent("Chrome")||goog.labs.userAgent.util.matchUserAgent("CriOS"))&&!goog.labs.userAgent.browser.matchEdge_();};goog.labs.userAgent.browser.matchAndroidBrowser_=function(){return goog.labs.userAgent.util.matchUserAgent("Android")&&!(goog.labs.userAgent.browser.isChrome()||goog.labs.userAgent.browser.isFirefox()||goog.labs.userAgent.browser.isOpera()||goog.labs.userAgent.browser.isSilk());};goog.labs.userAgent.browser.isOpera=goog.labs.userAgent.browser.matchOpera_;goog.labs.userAgent.browser.isIE=goog.labs.userAgent.browser.matchIE_;goog.labs.userAgent.browser.isEdge=goog.labs.userAgent.browser.matchEdge_;goog.labs.userAgent.browser.isFirefox=goog.labs.userAgent.browser.matchFirefox_;goog.labs.userAgent.browser.isSafari=goog.labs.userAgent.browser.matchSafari_;goog.labs.userAgent.browser.isCoast=goog.labs.userAgent.browser.matchCoast_;goog.labs.userAgent.browser.isIosWebview=goog.labs.userAgent.browser.matchIosWebview_;goog.labs.userAgent.browser.isChrome=goog.labs.userAgent.browser.matchChrome_;goog.labs.userAgent.browser.isAndroidBrowser=goog.labs.userAgent.browser.matchAndroidBrowser_;goog.labs.userAgent.browser.isSilk=function(){return goog.labs.userAgent.util.matchUserAgent("Silk");};goog.labs.userAgent.browser.getVersion=function(){function lookUpValueWithKeys(keys){var key=goog.array.find(keys,versionMapHasKey);return versionMap[key]||"";}var userAgentString=goog.labs.userAgent.util.getUserAgent();if(goog.labs.userAgent.browser.isIE()){return goog.labs.userAgent.browser.getIEVersion_(userAgentString);}var versionTuples=goog.labs.userAgent.util.extractVersionTuples(userAgentString),versionMap={};goog.array.forEach(versionTuples,function(tuple){versionMap[tuple[0]]=tuple[1];});var versionMapHasKey=goog.partial(goog.object.containsKey,versionMap);if(goog.labs.userAgent.browser.isOpera()){return lookUpValueWithKeys(["Version","Opera"]);}if(goog.labs.userAgent.browser.isEdge()){return lookUpValueWithKeys(["Edge"]);}if(goog.labs.userAgent.browser.isChrome()){return lookUpValueWithKeys(["Chrome","CriOS"]);}var tuple=versionTuples[2];return tuple&&tuple[1]||"";};goog.labs.userAgent.browser.isVersionOrHigher=function(version){return 0<=goog.string.compareVersions(goog.labs.userAgent.browser.getVersion(),version);};goog.labs.userAgent.browser.getIEVersion_=function(userAgent){var rv=/rv: *([\\d\\.]*)/.exec(userAgent);if(rv&&rv[1]){return rv[1];}var version="",msie=/MSIE +([\\d\\.]+)/.exec(userAgent);if(msie&&msie[1]){var tridentVersion=/Trident\\/(\\d.\\d)/.exec(userAgent);if("7.0"==msie[1]){if(tridentVersion&&tridentVersion[1]){switch(tridentVersion[1]){case"4.0":version="8.0";break;case"5.0":version="9.0";break;case"6.0":version="10.0";break;case"7.0":version="11.0";}}else{version="7.0";}}else{version=msie[1];}}return version;};goog.labs.userAgent.engine={};goog.labs.userAgent.engine.isPresto=function(){return goog.labs.userAgent.util.matchUserAgent("Presto");};goog.labs.userAgent.engine.isTrident=function(){return goog.labs.userAgent.util.matchUserAgent("Trident")||goog.labs.userAgent.util.matchUserAgent("MSIE");};goog.labs.userAgent.engine.isEdge=function(){return goog.labs.userAgent.util.matchUserAgent("Edge");};goog.labs.userAgent.engine.isWebKit=function(){return goog.labs.userAgent.util.matchUserAgentIgnoreCase("WebKit")&&!goog.labs.userAgent.engine.isEdge();};goog.labs.userAgent.engine.isGecko=function(){return goog.labs.userAgent.util.matchUserAgent("Gecko")&&!goog.labs.userAgent.engine.isWebKit()&&!goog.labs.userAgent.engine.isTrident()&&!goog.labs.userAgent.engine.isEdge();};goog.labs.userAgent.engine.getVersion=function(){var userAgentString=goog.labs.userAgent.util.getUserAgent();if(userAgentString){var tuples=goog.labs.userAgent.util.extractVersionTuples(userAgentString),engineTuple=goog.labs.userAgent.engine.getEngineTuple_(tuples);if(engineTuple){return"Gecko"==engineTuple[0]?goog.labs.userAgent.engine.getVersionForKey_(tuples,"Firefox"):engineTuple[1];}var browserTuple=tuples[0],info;if(browserTuple&&(info=browserTuple[2])){var match=/Trident\\/([^\\s;]+)/.exec(info);if(match){return match[1];}}}return"";};goog.labs.userAgent.engine.getEngineTuple_=function(tuples){if(!goog.labs.userAgent.engine.isEdge()){return tuples[1];}for(var i=0;i<tuples.length;i++){var tuple=tuples[i];if("Edge"==tuple[0]){return tuple;}}};goog.labs.userAgent.engine.isVersionOrHigher=function(version){return 0<=goog.string.compareVersions(goog.labs.userAgent.engine.getVersion(),version);};goog.labs.userAgent.engine.getVersionForKey_=function(tuples,key){var pair=goog.array.find(tuples,function(pair){return key==pair[0];});return pair&&pair[1]||"";};goog.labs.userAgent.platform={};goog.labs.userAgent.platform.isAndroid=function(){return goog.labs.userAgent.util.matchUserAgent("Android");};goog.labs.userAgent.platform.isIpod=function(){return goog.labs.userAgent.util.matchUserAgent("iPod");};goog.labs.userAgent.platform.isIphone=function(){return goog.labs.userAgent.util.matchUserAgent("iPhone")&&!goog.labs.userAgent.util.matchUserAgent("iPod")&&!goog.labs.userAgent.util.matchUserAgent("iPad");};goog.labs.userAgent.platform.isIpad=function(){return goog.labs.userAgent.util.matchUserAgent("iPad");};goog.labs.userAgent.platform.isIos=function(){return goog.labs.userAgent.platform.isIphone()||goog.labs.userAgent.platform.isIpad()||goog.labs.userAgent.platform.isIpod();};goog.labs.userAgent.platform.isMacintosh=function(){return goog.labs.userAgent.util.matchUserAgent("Macintosh");};goog.labs.userAgent.platform.isLinux=function(){return goog.labs.userAgent.util.matchUserAgent("Linux");};goog.labs.userAgent.platform.isWindows=function(){return goog.labs.userAgent.util.matchUserAgent("Windows");};goog.labs.userAgent.platform.isChromeOS=function(){return goog.labs.userAgent.util.matchUserAgent("CrOS");};goog.labs.userAgent.platform.getVersion=function(){var match,userAgentString=goog.labs.userAgent.util.getUserAgent(),version="";if(goog.labs.userAgent.platform.isWindows()){var re=/Windows (?:NT|Phone) ([0-9.]+)/;version=(match=re.exec(userAgentString))?match[1]:"0.0";}else{goog.labs.userAgent.platform.isIos()?(re=/(?:iPhone|iPod|iPad|CPU)\\s+OS\\s+(\\S+)/,version=(match=re.exec(userAgentString))&&match[1].replace(/_/g,".")):goog.labs.userAgent.platform.isMacintosh()?(re=/Mac OS X ([0-9_.]+)/,version=(match=re.exec(userAgentString))?match[1].replace(/_/g,"."):"10"):goog.labs.userAgent.platform.isAndroid()?(re=/Android\\s+([^\\);]+)(\\)|;)/,version=(match=re.exec(userAgentString))&&match[1]):goog.labs.userAgent.platform.isChromeOS()&&(re=/(?:CrOS\\s+(?:i686|x86_64)\\s+([0-9.]+))/,version=(match=re.exec(userAgentString))&&match[1]);}return version||"";};goog.labs.userAgent.platform.isVersionOrHigher=function(version){return 0<=goog.string.compareVersions(goog.labs.userAgent.platform.getVersion(),version);};goog.reflect={};goog.reflect.object=function(type,object){return object;};goog.reflect.objectProperty=function(prop,object){return prop;};goog.reflect.sinkValue=function(x){goog.reflect.sinkValue[" "](x);return x;};goog.reflect.sinkValue[" "]=goog.nullFunction;goog.reflect.canAccessProperty=function(obj,prop){try{return goog.reflect.sinkValue(obj[prop]),!0;}catch(e){}return!1;};goog.reflect.cache=function(cacheObj,key,valueFn,opt_keyFn){var storedKey=opt_keyFn?opt_keyFn(key):key;return Object.prototype.hasOwnProperty.call(cacheObj,storedKey)?cacheObj[storedKey]:cacheObj[storedKey]=valueFn(key);};goog.reflect={};goog.reflect.object=function(type,object){return object;};goog.reflect.objectProperty=function(prop,object){return prop;};goog.reflect.sinkValue=function(x){goog.reflect.sinkValue[" "](x);return x;};goog.reflect.sinkValue[" "]=goog.nullFunction;goog.reflect.canAccessProperty=function(obj,prop){try{return goog.reflect.sinkValue(obj[prop]),!0;}catch(e){}return!1;};goog.reflect.cache=function(cacheObj,key,valueFn,opt_keyFn){var storedKey=opt_keyFn?opt_keyFn(key):key;return Object.prototype.hasOwnProperty.call(cacheObj,storedKey)?cacheObj[storedKey]:cacheObj[storedKey]=valueFn(key);};goog.userAgent={};goog.userAgent.ASSUME_IE=!1;goog.userAgent.ASSUME_EDGE=!1;goog.userAgent.ASSUME_GECKO=!1;goog.userAgent.ASSUME_WEBKIT=!1;goog.userAgent.ASSUME_MOBILE_WEBKIT=!1;goog.userAgent.ASSUME_OPERA=!1;goog.userAgent.ASSUME_ANY_VERSION=!1;goog.userAgent.BROWSER_KNOWN_=goog.userAgent.ASSUME_IE||goog.userAgent.ASSUME_EDGE||goog.userAgent.ASSUME_GECKO||goog.userAgent.ASSUME_MOBILE_WEBKIT||goog.userAgent.ASSUME_WEBKIT||goog.userAgent.ASSUME_OPERA;goog.userAgent.getUserAgentString=function(){return goog.labs.userAgent.util.getUserAgent();};goog.userAgent.getNavigator=function(){return goog.global.navigator||null;};goog.userAgent.OPERA=goog.userAgent.BROWSER_KNOWN_?goog.userAgent.ASSUME_OPERA:goog.labs.userAgent.browser.isOpera();goog.userAgent.IE=goog.userAgent.BROWSER_KNOWN_?goog.userAgent.ASSUME_IE:goog.labs.userAgent.browser.isIE();goog.userAgent.EDGE=goog.userAgent.BROWSER_KNOWN_?goog.userAgent.ASSUME_EDGE:goog.labs.userAgent.engine.isEdge();goog.userAgent.EDGE_OR_IE=goog.userAgent.EDGE||goog.userAgent.IE;goog.userAgent.GECKO=goog.userAgent.BROWSER_KNOWN_?goog.userAgent.ASSUME_GECKO:goog.labs.userAgent.engine.isGecko();goog.userAgent.WEBKIT=goog.userAgent.BROWSER_KNOWN_?goog.userAgent.ASSUME_WEBKIT||goog.userAgent.ASSUME_MOBILE_WEBKIT:goog.labs.userAgent.engine.isWebKit();goog.userAgent.isMobile_=function(){return goog.userAgent.WEBKIT&&goog.labs.userAgent.util.matchUserAgent("Mobile");};goog.userAgent.MOBILE=goog.userAgent.ASSUME_MOBILE_WEBKIT||goog.userAgent.isMobile_();goog.userAgent.SAFARI=goog.userAgent.WEBKIT;goog.userAgent.determinePlatform_=function(){var navigator=goog.userAgent.getNavigator();return navigator&&navigator.platform||"";};goog.userAgent.PLATFORM=goog.userAgent.determinePlatform_();goog.userAgent.ASSUME_MAC=!1;goog.userAgent.ASSUME_WINDOWS=!1;goog.userAgent.ASSUME_LINUX=!1;goog.userAgent.ASSUME_X11=!1;goog.userAgent.ASSUME_ANDROID=!1;goog.userAgent.ASSUME_IPHONE=!1;goog.userAgent.ASSUME_IPAD=!1;goog.userAgent.ASSUME_IPOD=!1;goog.userAgent.PLATFORM_KNOWN_=goog.userAgent.ASSUME_MAC||goog.userAgent.ASSUME_WINDOWS||goog.userAgent.ASSUME_LINUX||goog.userAgent.ASSUME_X11||goog.userAgent.ASSUME_ANDROID||goog.userAgent.ASSUME_IPHONE||goog.userAgent.ASSUME_IPAD||goog.userAgent.ASSUME_IPOD;goog.userAgent.MAC=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_MAC:goog.labs.userAgent.platform.isMacintosh();goog.userAgent.WINDOWS=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_WINDOWS:goog.labs.userAgent.platform.isWindows();goog.userAgent.isLegacyLinux_=function(){return goog.labs.userAgent.platform.isLinux()||goog.labs.userAgent.platform.isChromeOS();};goog.userAgent.LINUX=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_LINUX:goog.userAgent.isLegacyLinux_();goog.userAgent.isX11_=function(){var navigator=goog.userAgent.getNavigator();return!!navigator&&goog.string.contains(navigator.appVersion||"","X11");};goog.userAgent.X11=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_X11:goog.userAgent.isX11_();goog.userAgent.ANDROID=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_ANDROID:goog.labs.userAgent.platform.isAndroid();goog.userAgent.IPHONE=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_IPHONE:goog.labs.userAgent.platform.isIphone();goog.userAgent.IPAD=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_IPAD:goog.labs.userAgent.platform.isIpad();goog.userAgent.IPOD=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_IPOD:goog.labs.userAgent.platform.isIpod();goog.userAgent.IOS=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_IPHONE||goog.userAgent.ASSUME_IPAD||goog.userAgent.ASSUME_IPOD:goog.labs.userAgent.platform.isIos();goog.userAgent.determineVersion_=function(){var version="",arr=goog.userAgent.getVersionRegexResult_();arr&&(version=arr?arr[1]:"");if(goog.userAgent.IE){var docMode=goog.userAgent.getDocumentMode_();if(null!=docMode&&docMode>parseFloat(version)){return String(docMode);}}return version;};goog.userAgent.getVersionRegexResult_=function(){var userAgent=goog.userAgent.getUserAgentString();if(goog.userAgent.GECKO){return /rv\\:([^\\);]+)(\\)|;)/.exec(userAgent);}if(goog.userAgent.EDGE){return /Edge\\/([\\d\\.]+)/.exec(userAgent);}if(goog.userAgent.IE){return /\\b(?:MSIE|rv)[: ]([^\\);]+)(\\)|;)/.exec(userAgent);}if(goog.userAgent.WEBKIT){return /WebKit\\/(\\S+)/.exec(userAgent);}if(goog.userAgent.OPERA){return /(?:Version)[ \\/]?(\\S+)/.exec(userAgent);}};goog.userAgent.getDocumentMode_=function(){var doc=goog.global.document;return doc?doc.documentMode:void 0;};goog.userAgent.VERSION=goog.userAgent.determineVersion_();goog.userAgent.compare=function(v1,v2){return goog.string.compareVersions(v1,v2);};goog.userAgent.isVersionOrHigherCache_={};goog.userAgent.isVersionOrHigher=function(version){return goog.userAgent.ASSUME_ANY_VERSION||goog.reflect.cache(goog.userAgent.isVersionOrHigherCache_,version,function(){return 0<=goog.string.compareVersions(goog.userAgent.VERSION,version);});};goog.userAgent.isVersion=goog.userAgent.isVersionOrHigher;goog.userAgent.isDocumentModeOrHigher=function(documentMode){return Number(goog.userAgent.DOCUMENT_MODE)>=documentMode;};goog.userAgent.isDocumentMode=goog.userAgent.isDocumentModeOrHigher;goog.userAgent.DOCUMENT_MODE=function(){var doc=goog.global.document;if(doc&&goog.userAgent.IE){return goog.userAgent.getDocumentMode_()||("CSS1Compat"==doc.compatMode?parseInt(goog.userAgent.VERSION,10):5);}}();goog.events.BrowserFeature={HAS_W3C_BUTTON:!goog.userAgent.IE||goog.userAgent.isDocumentModeOrHigher(9),HAS_W3C_EVENT_SUPPORT:!goog.userAgent.IE||goog.userAgent.isDocumentModeOrHigher(9),SET_KEY_CODE_TO_PREVENT_DEFAULT:goog.userAgent.IE&&!goog.userAgent.isVersionOrHigher("9"),HAS_NAVIGATOR_ONLINE_PROPERTY:!goog.userAgent.WEBKIT||goog.userAgent.isVersionOrHigher("528"),HAS_HTML5_NETWORK_EVENT_SUPPORT:goog.userAgent.GECKO&&goog.userAgent.isVersionOrHigher("1.9b")||goog.userAgent.IE&&goog.userAgent.isVersionOrHigher("8")||goog.userAgent.OPERA&&goog.userAgent.isVersionOrHigher("9.5")||goog.userAgent.WEBKIT&&goog.userAgent.isVersionOrHigher("528"),HTML5_NETWORK_EVENTS_FIRE_ON_BODY:goog.userAgent.GECKO&&!goog.userAgent.isVersionOrHigher("8")||goog.userAgent.IE&&!goog.userAgent.isVersionOrHigher("9"),TOUCH_ENABLED:"ontouchstart"in goog.global||!!(goog.global.document&&document.documentElement&&"ontouchstart"in document.documentElement)||!(!goog.global.navigator||!goog.global.navigator.msMaxTouchPoints)};goog.events.getVendorPrefixedName_=function(eventName){return goog.userAgent.WEBKIT?"webkit"+eventName:goog.userAgent.OPERA?"o"+eventName.toLowerCase():eventName.toLowerCase();};goog.events.EventType={CLICK:"click",RIGHTCLICK:"rightclick",DBLCLICK:"dblclick",MOUSEDOWN:"mousedown",MOUSEUP:"mouseup",MOUSEOVER:"mouseover",MOUSEOUT:"mouseout",MOUSEMOVE:"mousemove",MOUSEENTER:"mouseenter",MOUSELEAVE:"mouseleave",SELECTIONCHANGE:"selectionchange",SELECTSTART:"selectstart",WHEEL:"wheel",KEYPRESS:"keypress",KEYDOWN:"keydown",KEYUP:"keyup",BLUR:"blur",FOCUS:"focus",DEACTIVATE:"deactivate",FOCUSIN:goog.userAgent.IE?"focusin":"DOMFocusIn",FOCUSOUT:goog.userAgent.IE?"focusout":"DOMFocusOut",CHANGE:"change",RESET:"reset",SELECT:"select",SUBMIT:"submit",INPUT:"input",PROPERTYCHANGE:"propertychange",DRAGSTART:"dragstart",DRAG:"drag",DRAGENTER:"dragenter",DRAGOVER:"dragover",DRAGLEAVE:"dragleave",DROP:"drop",DRAGEND:"dragend",TOUCHSTART:"touchstart",TOUCHMOVE:"touchmove",TOUCHEND:"touchend",TOUCHCANCEL:"touchcancel",BEFOREUNLOAD:"beforeunload",CONSOLEMESSAGE:"consolemessage",CONTEXTMENU:"contextmenu",DEVICEMOTION:"devicemotion",DEVICEORIENTATION:"deviceorientation",DOMCONTENTLOADED:"DOMContentLoaded",ERROR:"error",HELP:"help",LOAD:"load",LOSECAPTURE:"losecapture",ORIENTATIONCHANGE:"orientationchange",READYSTATECHANGE:"readystatechange",RESIZE:"resize",SCROLL:"scroll",UNLOAD:"unload",CANPLAY:"canplay",CANPLAYTHROUGH:"canplaythrough",DURATIONCHANGE:"durationchange",EMPTIED:"emptied",ENDED:"ended",LOADEDDATA:"loadeddata",LOADEDMETADATA:"loadedmetadata",PAUSE:"pause",PLAY:"play",PLAYING:"playing",RATECHANGE:"ratechange",SEEKED:"seeked",SEEKING:"seeking",STALLED:"stalled",SUSPEND:"suspend",TIMEUPDATE:"timeupdate",VOLUMECHANGE:"volumechange",WAITING:"waiting",SOURCEOPEN:"sourceopen",SOURCEENDED:"sourceended",SOURCECLOSED:"sourceclosed",ABORT:"abort",UPDATE:"update",UPDATESTART:"updatestart",UPDATEEND:"updateend",HASHCHANGE:"hashchange",PAGEHIDE:"pagehide",PAGESHOW:"pageshow",POPSTATE:"popstate",COPY:"copy",PASTE:"paste",CUT:"cut",BEFORECOPY:"beforecopy",BEFORECUT:"beforecut",BEFOREPASTE:"beforepaste",ONLINE:"online",OFFLINE:"offline",MESSAGE:"message",CONNECT:"connect",INSTALL:"install",ACTIVATE:"activate",FETCH:"fetch",FOREIGNFETCH:"foreignfetch",MESSAGEERROR:"messageerror",STATECHANGE:"statechange",UPDATEFOUND:"updatefound",CONTROLLERCHANGE:"controllerchange",ANIMATIONSTART:goog.events.getVendorPrefixedName_("AnimationStart"),ANIMATIONEND:goog.events.getVendorPrefixedName_("AnimationEnd"),ANIMATIONITERATION:goog.events.getVendorPrefixedName_("AnimationIteration"),TRANSITIONEND:goog.events.getVendorPrefixedName_("TransitionEnd"),POINTERDOWN:"pointerdown",POINTERUP:"pointerup",POINTERCANCEL:"pointercancel",POINTERMOVE:"pointermove",POINTEROVER:"pointerover",POINTEROUT:"pointerout",POINTERENTER:"pointerenter",POINTERLEAVE:"pointerleave",GOTPOINTERCAPTURE:"gotpointercapture",LOSTPOINTERCAPTURE:"lostpointercapture",MSGESTURECHANGE:"MSGestureChange",MSGESTUREEND:"MSGestureEnd",MSGESTUREHOLD:"MSGestureHold",MSGESTURESTART:"MSGestureStart",MSGESTURETAP:"MSGestureTap",MSGOTPOINTERCAPTURE:"MSGotPointerCapture",MSINERTIASTART:"MSInertiaStart",MSLOSTPOINTERCAPTURE:"MSLostPointerCapture",MSPOINTERCANCEL:"MSPointerCancel",MSPOINTERDOWN:"MSPointerDown",MSPOINTERENTER:"MSPointerEnter",MSPOINTERHOVER:"MSPointerHover",MSPOINTERLEAVE:"MSPointerLeave",MSPOINTERMOVE:"MSPointerMove",MSPOINTEROUT:"MSPointerOut",MSPOINTEROVER:"MSPointerOver",MSPOINTERUP:"MSPointerUp",TEXT:"text",TEXTINPUT:goog.userAgent.IE?"textinput":"textInput",COMPOSITIONSTART:"compositionstart",COMPOSITIONUPDATE:"compositionupdate",COMPOSITIONEND:"compositionend",BEFOREINPUT:"beforeinput",EXIT:"exit",LOADABORT:"loadabort",LOADCOMMIT:"loadcommit",LOADREDIRECT:"loadredirect",LOADSTART:"loadstart",LOADSTOP:"loadstop",RESPONSIVE:"responsive",SIZECHANGED:"sizechanged",UNRESPONSIVE:"unresponsive",VISIBILITYCHANGE:"visibilitychange",STORAGE:"storage",DOMSUBTREEMODIFIED:"DOMSubtreeModified",DOMNODEINSERTED:"DOMNodeInserted",DOMNODEREMOVED:"DOMNodeRemoved",DOMNODEREMOVEDFROMDOCUMENT:"DOMNodeRemovedFromDocument",DOMNODEINSERTEDINTODOCUMENT:"DOMNodeInsertedIntoDocument",DOMATTRMODIFIED:"DOMAttrModified",DOMCHARACTERDATAMODIFIED:"DOMCharacterDataModified",BEFOREPRINT:"beforeprint",AFTERPRINT:"afterprint"};goog.events.BrowserEvent=function(opt_e,opt_currentTarget){goog.events.Event.call(this,opt_e?opt_e.type:"");this.relatedTarget=this.currentTarget=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=this.offsetY=this.offsetX=0;this.key="";this.charCode=this.keyCode=0;this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.state=null;this.platformModifierKey=!1;this.event_=null;opt_e&&this.init(opt_e,opt_currentTarget);};goog.inherits(goog.events.BrowserEvent,goog.events.Event);goog.events.BrowserEvent.MouseButton={LEFT:0,MIDDLE:1,RIGHT:2};goog.events.BrowserEvent.IEButtonMap=[1,4,2];goog.events.BrowserEvent.prototype.init=function(e,opt_currentTarget){var type=this.type=e.type,relevantTouch=e.changedTouches?e.changedTouches[0]:null;this.target=e.target||e.srcElement;this.currentTarget=opt_currentTarget;var relatedTarget=e.relatedTarget;relatedTarget?goog.userAgent.GECKO&&(goog.reflect.canAccessProperty(relatedTarget,"nodeName")||(relatedTarget=null)):type==goog.events.EventType.MOUSEOVER?relatedTarget=e.fromElement:type==goog.events.EventType.MOUSEOUT&&(relatedTarget=e.toElement);this.relatedTarget=relatedTarget;goog.isNull(relevantTouch)?(this.offsetX=goog.userAgent.WEBKIT||void 0!==e.offsetX?e.offsetX:e.layerX,this.offsetY=goog.userAgent.WEBKIT||void 0!==e.offsetY?e.offsetY:e.layerY,this.clientX=void 0!==e.clientX?e.clientX:e.pageX,this.clientY=void 0!==e.clientY?e.clientY:e.pageY,this.screenX=e.screenX||0,this.screenY=e.screenY||0):(this.clientX=void 0!==relevantTouch.clientX?relevantTouch.clientX:relevantTouch.pageX,this.clientY=void 0!==relevantTouch.clientY?relevantTouch.clientY:relevantTouch.pageY,this.screenX=relevantTouch.screenX||0,this.screenY=relevantTouch.screenY||0);this.button=e.button;this.keyCode=e.keyCode||0;this.key=e.key||"";this.charCode=e.charCode||("keypress"==type?e.keyCode:0);this.ctrlKey=e.ctrlKey;this.altKey=e.altKey;this.shiftKey=e.shiftKey;this.metaKey=e.metaKey;this.platformModifierKey=goog.userAgent.MAC?e.metaKey:e.ctrlKey;this.state=e.state;this.event_=e;e.defaultPrevented&&this.preventDefault();};goog.events.BrowserEvent.prototype.isButton=function(button){return goog.events.BrowserFeature.HAS_W3C_BUTTON?this.event_.button==button:"click"==this.type?button==goog.events.BrowserEvent.MouseButton.LEFT:!!(this.event_.button&goog.events.BrowserEvent.IEButtonMap[button]);};goog.events.BrowserEvent.prototype.isMouseActionButton=function(){return this.isButton(goog.events.BrowserEvent.MouseButton.LEFT)&&!(goog.userAgent.WEBKIT&&goog.userAgent.MAC&&this.ctrlKey);};goog.events.BrowserEvent.prototype.stopPropagation=function(){goog.events.BrowserEvent.superClass_.stopPropagation.call(this);this.event_.stopPropagation?this.event_.stopPropagation():this.event_.cancelBubble=!0;};goog.events.BrowserEvent.prototype.preventDefault=function(){goog.events.BrowserEvent.superClass_.preventDefault.call(this);var be=this.event_;if(be.preventDefault){be.preventDefault();}else{if(be.returnValue=!1,goog.events.BrowserFeature.SET_KEY_CODE_TO_PREVENT_DEFAULT){try{if(be.ctrlKey||112<=be.keyCode&&123>=be.keyCode){be.keyCode=-1;}}catch(ex){}}}};goog.events.BrowserEvent.prototype.getBrowserEvent=function(){return this.event_;};goog.events.Listenable=function(){};goog.events.Listenable.IMPLEMENTED_BY_PROP="closure_listenable_"+(1e6*Math.random()|0);goog.events.Listenable.addImplementation=function(cls){cls.prototype[goog.events.Listenable.IMPLEMENTED_BY_PROP]=!0;};goog.events.Listenable.isImplementedBy=function(obj){return!(!obj||!obj[goog.events.Listenable.IMPLEMENTED_BY_PROP]);};goog.events.ListenableKey=function(){};goog.events.ListenableKey.counter_=0;goog.events.ListenableKey.reserveKey=function(){return++goog.events.ListenableKey.counter_;};goog.events.Listener=function(listener,proxy,src,type,capture,opt_handler){goog.events.Listener.ENABLE_MONITORING&&(this.creationStack=Error().stack);this.listener=listener;this.proxy=proxy;this.src=src;this.type=type;this.capture=!!capture;this.handler=opt_handler;this.key=goog.events.ListenableKey.reserveKey();this.removed=this.callOnce=!1;};goog.events.Listener.ENABLE_MONITORING=!1;goog.events.Listener.prototype.markAsRemoved=function(){this.removed=!0;this.handler=this.src=this.proxy=this.listener=null;};goog.events.ListenerMap=function(src){this.src=src;this.listeners={};this.typeCount_=0;};goog.events.ListenerMap.prototype.getTypeCount=function(){return this.typeCount_;};goog.events.ListenerMap.prototype.getListenerCount=function(){var count=0,type;for(type in this.listeners){count+=this.listeners[type].length;}return count;};goog.events.ListenerMap.prototype.add=function(type,listener,callOnce,opt_useCapture,opt_listenerScope){var typeStr=type.toString(),listenerArray=this.listeners[typeStr];listenerArray||(listenerArray=this.listeners[typeStr]=[],this.typeCount_++);var index=goog.events.ListenerMap.findListenerIndex_(listenerArray,listener,opt_useCapture,opt_listenerScope);if(-1<index){var listenerObj=listenerArray[index];callOnce||(listenerObj.callOnce=!1);}else{listenerObj=new goog.events.Listener(listener,null,this.src,typeStr,!!opt_useCapture,opt_listenerScope),listenerObj.callOnce=callOnce,listenerArray.push(listenerObj);}return listenerObj;};goog.events.ListenerMap.prototype.remove=function(type,listener,opt_useCapture,opt_listenerScope){var typeStr=type.toString();if(!(typeStr in this.listeners)){return!1;}var listenerArray=this.listeners[typeStr],index=goog.events.ListenerMap.findListenerIndex_(listenerArray,listener,opt_useCapture,opt_listenerScope);return-1<index?(listenerArray[index].markAsRemoved(),goog.array.removeAt(listenerArray,index),0==listenerArray.length&&(delete this.listeners[typeStr],this.typeCount_--),!0):!1;};goog.events.ListenerMap.prototype.removeByKey=function(listener){var type=listener.type;if(!(type in this.listeners)){return!1;}var removed=goog.array.remove(this.listeners[type],listener);removed&&(listener.markAsRemoved(),0==this.listeners[type].length&&(delete this.listeners[type],this.typeCount_--));return removed;};goog.events.ListenerMap.prototype.removeAll=function(opt_type){var typeStr=opt_type&&opt_type.toString(),count=0,type;for(type in this.listeners){if(!typeStr||type==typeStr){for(var listenerArray=this.listeners[type],i=0;i<listenerArray.length;i++){++count,listenerArray[i].markAsRemoved();}delete this.listeners[type];this.typeCount_--;}}return count;};goog.events.ListenerMap.prototype.getListeners=function(type,capture){var listenerArray=this.listeners[type.toString()],rv=[];if(listenerArray){for(var i=0;i<listenerArray.length;++i){var listenerObj=listenerArray[i];listenerObj.capture==capture&&rv.push(listenerObj);}}return rv;};goog.events.ListenerMap.prototype.getListener=function(type,listener,capture,opt_listenerScope){var listenerArray=this.listeners[type.toString()],i=-1;listenerArray&&(i=goog.events.ListenerMap.findListenerIndex_(listenerArray,listener,capture,opt_listenerScope));return-1<i?listenerArray[i]:null;};goog.events.ListenerMap.prototype.hasListener=function(opt_type,opt_capture){var hasType=goog.isDef(opt_type),typeStr=hasType?opt_type.toString():"",hasCapture=goog.isDef(opt_capture);return goog.object.some(this.listeners,function(listenerArray,type){for(var i=0;i<listenerArray.length;++i){if(!(hasType&&listenerArray[i].type!=typeStr||hasCapture&&listenerArray[i].capture!=opt_capture)){return!0;}}return!1;});};goog.events.ListenerMap.findListenerIndex_=function(listenerArray,listener,opt_useCapture,opt_listenerScope){for(var i=0;i<listenerArray.length;++i){var listenerObj=listenerArray[i];if(!listenerObj.removed&&listenerObj.listener==listener&&listenerObj.capture==!!opt_useCapture&&listenerObj.handler==opt_listenerScope){return i;}}return-1;};goog.events.LISTENER_MAP_PROP_="closure_lm_"+(1e6*Math.random()|0);goog.events.onString_="on";goog.events.onStringMap_={};goog.events.CaptureSimulationMode={OFF_AND_FAIL:0,OFF_AND_SILENT:1,ON:2};goog.events.CAPTURE_SIMULATION_MODE=2;goog.events.listenerCountEstimate_=0;goog.events.listen=function(src,type,listener,opt_capt,opt_handler){if(goog.isArray(type)){for(var i=0;i<type.length;i++){goog.events.listen(src,type[i],listener,opt_capt,opt_handler);}return null;}listener=goog.events.wrapListener(listener);return goog.events.Listenable.isImplementedBy(src)?src.listen(type,listener,opt_capt,opt_handler):goog.events.listen_(src,type,listener,!1,opt_capt,opt_handler);};goog.events.listen_=function(src,type,listener,callOnce,opt_capt,opt_handler){if(!type){throw Error("Invalid event type");}var capture=!!opt_capt;if(capture&&!goog.events.BrowserFeature.HAS_W3C_EVENT_SUPPORT){if(goog.events.CAPTURE_SIMULATION_MODE==goog.events.CaptureSimulationMode.OFF_AND_FAIL){return goog.asserts.fail("Can not register capture listener in IE8-."),null;}if(goog.events.CAPTURE_SIMULATION_MODE==goog.events.CaptureSimulationMode.OFF_AND_SILENT){return null;}}var listenerMap=goog.events.getListenerMap_(src);listenerMap||(src[goog.events.LISTENER_MAP_PROP_]=listenerMap=new goog.events.ListenerMap(src));var listenerObj=listenerMap.add(type,listener,callOnce,opt_capt,opt_handler);if(listenerObj.proxy){return listenerObj;}var proxy=goog.events.getProxy();listenerObj.proxy=proxy;proxy.src=src;proxy.listener=listenerObj;if(src.addEventListener){src.addEventListener(type.toString(),proxy,capture);}else{if(src.attachEvent){src.attachEvent(goog.events.getOnString_(type.toString()),proxy);}else{throw Error("addEventListener and attachEvent are unavailable.");}}goog.events.listenerCountEstimate_++;return listenerObj;};goog.events.getProxy=function(){var proxyCallbackFunction=goog.events.handleBrowserEvent_,f=goog.events.BrowserFeature.HAS_W3C_EVENT_SUPPORT?function(eventObject){return proxyCallbackFunction.call(f.src,f.listener,eventObject);}:function(eventObject){var v=proxyCallbackFunction.call(f.src,f.listener,eventObject);if(!v){return v;}};return f;};goog.events.listenOnce=function(src,type,listener,opt_capt,opt_handler){if(goog.isArray(type)){for(var i=0;i<type.length;i++){goog.events.listenOnce(src,type[i],listener,opt_capt,opt_handler);}return null;}listener=goog.events.wrapListener(listener);return goog.events.Listenable.isImplementedBy(src)?src.listenOnce(type,listener,opt_capt,opt_handler):goog.events.listen_(src,type,listener,!0,opt_capt,opt_handler);};goog.events.listenWithWrapper=function(src,wrapper,listener,opt_capt,opt_handler){wrapper.listen(src,listener,opt_capt,opt_handler);};goog.events.unlisten=function(src,type,listener,opt_capt,opt_handler){if(goog.isArray(type)){for(var i=0;i<type.length;i++){goog.events.unlisten(src,type[i],listener,opt_capt,opt_handler);}return null;}listener=goog.events.wrapListener(listener);if(goog.events.Listenable.isImplementedBy(src)){return src.unlisten(type,listener,opt_capt,opt_handler);}if(!src){return!1;}var capture,listenerMap=goog.events.getListenerMap_(src);if(listenerMap){var listenerObj=listenerMap.getListener(type,listener,!!opt_capt,opt_handler);if(listenerObj){return goog.events.unlistenByKey(listenerObj);}}return!1;};goog.events.unlistenByKey=function(key){if(goog.isNumber(key)||!key||key.removed){return!1;}var src=key.src;if(goog.events.Listenable.isImplementedBy(src)){return src.unlistenByKey(key);}var type=key.type,proxy=key.proxy;src.removeEventListener?src.removeEventListener(type,proxy,key.capture):src.detachEvent&&src.detachEvent(goog.events.getOnString_(type),proxy);goog.events.listenerCountEstimate_--;var listenerMap=goog.events.getListenerMap_(src);listenerMap?(listenerMap.removeByKey(key),0==listenerMap.getTypeCount()&&(listenerMap.src=null,src[goog.events.LISTENER_MAP_PROP_]=null)):key.markAsRemoved();return!0;};goog.events.unlistenWithWrapper=function(src,wrapper,listener,opt_capt,opt_handler){wrapper.unlisten(src,listener,opt_capt,opt_handler);};goog.events.removeAll=function(obj,opt_type){if(!obj){return 0;}if(goog.events.Listenable.isImplementedBy(obj)){return obj.removeAllListeners(opt_type);}var listenerMap=goog.events.getListenerMap_(obj);if(!listenerMap){return 0;}var count=0,typeStr=opt_type&&opt_type.toString(),type;for(type in listenerMap.listeners){if(!typeStr||type==typeStr){for(var listeners=listenerMap.listeners[type].concat(),i=0;i<listeners.length;++i){goog.events.unlistenByKey(listeners[i])&&++count;}}}return count;};goog.events.getListeners=function(obj,type,capture){if(goog.events.Listenable.isImplementedBy(obj)){return obj.getListeners(type,capture);}if(!obj){return[];}var listenerMap=goog.events.getListenerMap_(obj);return listenerMap?listenerMap.getListeners(type,capture):[];};goog.events.getListener=function(src,type,listener,opt_capt,opt_handler){listener=goog.events.wrapListener(listener);var capture=!!opt_capt;if(goog.events.Listenable.isImplementedBy(src)){return src.getListener(type,listener,capture,opt_handler);}if(!src){return null;}var listenerMap=goog.events.getListenerMap_(src);return listenerMap?listenerMap.getListener(type,listener,capture,opt_handler):null;};goog.events.hasListener=function(obj,opt_type,opt_capture){if(goog.events.Listenable.isImplementedBy(obj)){return obj.hasListener(opt_type,opt_capture);}var listenerMap=goog.events.getListenerMap_(obj);return!!listenerMap&&listenerMap.hasListener(opt_type,opt_capture);};goog.events.expose=function(e){var str=[],key;for(key in e){e[key]&&e[key].id?str.push(key+" = "+e[key]+" ("+e[key].id+")"):str.push(key+" = "+e[key]);}return str.join("\\n");};goog.events.getOnString_=function(type){return type in goog.events.onStringMap_?goog.events.onStringMap_[type]:goog.events.onStringMap_[type]=goog.events.onString_+type;};goog.events.fireListeners=function(obj,type,capture,eventObject){return goog.events.Listenable.isImplementedBy(obj)?obj.fireListeners(type,capture,eventObject):goog.events.fireListeners_(obj,type,capture,eventObject);};goog.events.fireListeners_=function(obj,type,capture,eventObject){var retval=!0,listenerMap=goog.events.getListenerMap_(obj);if(listenerMap){var listenerArray=listenerMap.listeners[type.toString()];if(listenerArray){for(var listenerArray=listenerArray.concat(),i=0;i<listenerArray.length;i++){var listener=listenerArray[i];if(listener&&listener.capture==capture&&!listener.removed){var result=goog.events.fireListener(listener,eventObject),retval=retval&&!1!==result;}}}}return retval;};goog.events.fireListener=function(listener,eventObject){var listenerFn=listener.listener,listenerHandler=listener.handler||listener.src;listener.callOnce&&goog.events.unlistenByKey(listener);return listenerFn.call(listenerHandler,eventObject);};goog.events.getTotalListenerCount=function(){return goog.events.listenerCountEstimate_;};goog.events.dispatchEvent=function(src,e){goog.asserts.assert(goog.events.Listenable.isImplementedBy(src),"Can not use goog.events.dispatchEvent with non-goog.events.Listenable instance.");return src.dispatchEvent(e);};goog.events.protectBrowserEventEntryPoint=function(errorHandler){goog.events.handleBrowserEvent_=errorHandler.protectEntryPoint(goog.events.handleBrowserEvent_);};goog.events.handleBrowserEvent_=function(listener,opt_evt){if(listener.removed){return!0;}if(!goog.events.BrowserFeature.HAS_W3C_EVENT_SUPPORT){var ieEvent=opt_evt||goog.getObjectByName("window.event");var evt=new goog.events.BrowserEvent(ieEvent,this);var retval=!0;if(goog.events.CAPTURE_SIMULATION_MODE==goog.events.CaptureSimulationMode.ON){if(!goog.events.isMarkedIeEvent_(ieEvent)){goog.events.markIeEvent_(ieEvent);var ancestors=[];for(var parent=evt.currentTarget;parent;parent=parent.parentNode){ancestors.push(parent);}var type=listener.type;for(var i=ancestors.length-1;!evt.propagationStopped_&&0<=i;i--){evt.currentTarget=ancestors[i];var result=goog.events.fireListeners_(ancestors[i],type,!0,evt);retval=retval&&result;}for(i=0;!evt.propagationStopped_&&i<ancestors.length;i++){evt.currentTarget=ancestors[i],result=goog.events.fireListeners_(ancestors[i],type,!1,evt),retval=retval&&result;}}}else{retval=goog.events.fireListener(listener,evt);}return retval;}return goog.events.fireListener(listener,new goog.events.BrowserEvent(opt_evt,this));};goog.events.markIeEvent_=function(e){var useReturnValue=!1;if(0==e.keyCode){try{e.keyCode=-1;return;}catch(ex){useReturnValue=!0;}}if(useReturnValue||void 0==e.returnValue){e.returnValue=!0;}};goog.events.isMarkedIeEvent_=function(e){return 0>e.keyCode||void 0!=e.returnValue;};goog.events.uniqueIdCounter_=0;goog.events.getUniqueId=function(identifier){return identifier+"_"+goog.events.uniqueIdCounter_++;};goog.events.getListenerMap_=function(src){var listenerMap=src[goog.events.LISTENER_MAP_PROP_];return listenerMap instanceof goog.events.ListenerMap?listenerMap:null;};goog.events.LISTENER_WRAPPER_PROP_="__closure_events_fn_"+(1e9*Math.random()>>>0);goog.events.wrapListener=function(listener){goog.asserts.assert(listener,"Listener can not be null.");if(goog.isFunction(listener)){return listener;}goog.asserts.assert(listener.handleEvent,"An object listener must have handleEvent method.");listener[goog.events.LISTENER_WRAPPER_PROP_]||(listener[goog.events.LISTENER_WRAPPER_PROP_]=function(e){return listener.handleEvent(e);});return listener[goog.events.LISTENER_WRAPPER_PROP_];};goog.debug.entryPointRegistry.register(function(transformer){goog.events.handleBrowserEvent_=transformer(goog.events.handleBrowserEvent_);});goog.events.EventHandler=function(opt_scope){goog.Disposable.call(this);this.handler_=opt_scope;this.keys_={};};goog.inherits(goog.events.EventHandler,goog.Disposable);goog.events.EventHandler.typeArray_=[];goog.events.EventHandler.prototype.listen=function(src,type,opt_fn,opt_capture){return this.listen_(src,type,opt_fn,opt_capture);};goog.events.EventHandler.prototype.listenWithScope=function(src,type,fn,capture,scope){return this.listen_(src,type,fn,capture,scope);};goog.events.EventHandler.prototype.listen_=function(src,type,opt_fn,opt_capture,opt_scope){goog.isArray(type)||(type&&(goog.events.EventHandler.typeArray_[0]=type.toString()),type=goog.events.EventHandler.typeArray_);for(var i=0;i<type.length;i++){var listenerObj=goog.events.listen(src,type[i],opt_fn||this.handleEvent,opt_capture||!1,opt_scope||this.handler_||this);if(!listenerObj){break;}this.keys_[listenerObj.key]=listenerObj;}return this;};goog.events.EventHandler.prototype.listenOnce=function(src,type,opt_fn,opt_capture){return this.listenOnce_(src,type,opt_fn,opt_capture);};goog.events.EventHandler.prototype.listenOnceWithScope=function(src,type,fn,capture,scope){return this.listenOnce_(src,type,fn,capture,scope);};goog.events.EventHandler.prototype.listenOnce_=function(src,type,opt_fn,opt_capture,opt_scope){if(goog.isArray(type)){for(var i=0;i<type.length;i++){this.listenOnce_(src,type[i],opt_fn,opt_capture,opt_scope);}}else{var listenerObj=goog.events.listenOnce(src,type,opt_fn||this.handleEvent,opt_capture,opt_scope||this.handler_||this);if(!listenerObj){return this;}this.keys_[listenerObj.key]=listenerObj;}return this;};goog.events.EventHandler.prototype.listenWithWrapper=function(src,wrapper,listener,opt_capt){return this.listenWithWrapper_(src,wrapper,listener,opt_capt);};goog.events.EventHandler.prototype.listenWithWrapperAndScope=function(src,wrapper,listener,capture,scope){return this.listenWithWrapper_(src,wrapper,listener,capture,scope);};goog.events.EventHandler.prototype.listenWithWrapper_=function(src,wrapper,listener,opt_capt,opt_scope){wrapper.listen(src,listener,opt_capt,opt_scope||this.handler_||this,this);return this;};goog.events.EventHandler.prototype.getListenerCount=function(){var count=0,key;for(key in this.keys_){Object.prototype.hasOwnProperty.call(this.keys_,key)&&count++;}return count;};goog.events.EventHandler.prototype.unlisten=function(src,type,opt_fn,opt_capture,opt_scope){if(goog.isArray(type)){for(var i=0;i<type.length;i++){this.unlisten(src,type[i],opt_fn,opt_capture,opt_scope);}}else{var listener=goog.events.getListener(src,type,opt_fn||this.handleEvent,opt_capture,opt_scope||this.handler_||this);listener&&(goog.events.unlistenByKey(listener),delete this.keys_[listener.key]);}return this;};goog.events.EventHandler.prototype.unlistenWithWrapper=function(src,wrapper,listener,opt_capt,opt_scope){wrapper.unlisten(src,listener,opt_capt,opt_scope||this.handler_||this,this);return this;};goog.events.EventHandler.prototype.removeAll=function(){goog.object.forEach(this.keys_,function(listenerObj,key){this.keys_.hasOwnProperty(key)&&goog.events.unlistenByKey(listenerObj);},this);this.keys_={};};goog.events.EventHandler.prototype.disposeInternal=function(){goog.events.EventHandler.superClass_.disposeInternal.call(this);this.removeAll();};goog.events.EventHandler.prototype.handleEvent=function(e){throw Error("EventHandler.handleEvent not implemented");};goog.events.EventTarget=function(){goog.Disposable.call(this);this.eventTargetListeners_=new goog.events.ListenerMap(this);this.actualEventTarget_=this;this.parentEventTarget_=null;};goog.inherits(goog.events.EventTarget,goog.Disposable);goog.events.Listenable.addImplementation(goog.events.EventTarget);goog.events.EventTarget.MAX_ANCESTORS_=1000;goog.events.EventTarget.prototype.getParentEventTarget=function(){return this.parentEventTarget_;};goog.events.EventTarget.prototype.setParentEventTarget=function(parent){this.parentEventTarget_=parent;};goog.events.EventTarget.prototype.addEventListener=function(type,handler,opt_capture,opt_handlerScope){goog.events.listen(this,type,handler,opt_capture,opt_handlerScope);};goog.events.EventTarget.prototype.removeEventListener=function(type,handler,opt_capture,opt_handlerScope){goog.events.unlisten(this,type,handler,opt_capture,opt_handlerScope);};goog.events.EventTarget.prototype.dispatchEvent=function(e){this.assertInitialized_();var ancestor=this.getParentEventTarget();if(ancestor){var ancestorsTree=[];for(var ancestorCount=1;ancestor;ancestor=ancestor.getParentEventTarget()){ancestorsTree.push(ancestor),goog.asserts.assert(++ancestorCount<goog.events.EventTarget.MAX_ANCESTORS_,"infinite loop");}}return goog.events.EventTarget.dispatchEventInternal_(this.actualEventTarget_,e,ancestorsTree);};goog.events.EventTarget.prototype.disposeInternal=function(){goog.events.EventTarget.superClass_.disposeInternal.call(this);this.removeAllListeners();this.parentEventTarget_=null;};goog.events.EventTarget.prototype.listen=function(type,listener,opt_useCapture,opt_listenerScope){this.assertInitialized_();return this.eventTargetListeners_.add(String(type),listener,!1,opt_useCapture,opt_listenerScope);};goog.events.EventTarget.prototype.listenOnce=function(type,listener,opt_useCapture,opt_listenerScope){return this.eventTargetListeners_.add(String(type),listener,!0,opt_useCapture,opt_listenerScope);};goog.events.EventTarget.prototype.unlisten=function(type,listener,opt_useCapture,opt_listenerScope){return this.eventTargetListeners_.remove(String(type),listener,opt_useCapture,opt_listenerScope);};goog.events.EventTarget.prototype.unlistenByKey=function(key){return this.eventTargetListeners_.removeByKey(key);};goog.events.EventTarget.prototype.removeAllListeners=function(opt_type){return this.eventTargetListeners_?this.eventTargetListeners_.removeAll(opt_type):0;};goog.events.EventTarget.prototype.fireListeners=function(type,capture,eventObject){var listenerArray=this.eventTargetListeners_.listeners[String(type)];if(!listenerArray){return!0;}for(var listenerArray=listenerArray.concat(),rv=!0,i=0;i<listenerArray.length;++i){var listener=listenerArray[i];if(listener&&!listener.removed&&listener.capture==capture){var listenerFn=listener.listener,listenerHandler=listener.handler||listener.src;listener.callOnce&&this.unlistenByKey(listener);rv=!1!==listenerFn.call(listenerHandler,eventObject)&&rv;}}return rv&&0!=eventObject.returnValue_;};goog.events.EventTarget.prototype.getListeners=function(type,capture){return this.eventTargetListeners_.getListeners(String(type),capture);};goog.events.EventTarget.prototype.getListener=function(type,listener,capture,opt_listenerScope){return this.eventTargetListeners_.getListener(String(type),listener,capture,opt_listenerScope);};goog.events.EventTarget.prototype.hasListener=function(opt_type,opt_capture){return this.eventTargetListeners_.hasListener(goog.isDef(opt_type)?String(opt_type):void 0,opt_capture);};goog.events.EventTarget.prototype.setTargetForTesting=function(target){this.actualEventTarget_=target;};goog.events.EventTarget.prototype.assertInitialized_=function(){goog.asserts.assert(this.eventTargetListeners_,"Event target is not initialized. Did you call the superclass (goog.events.EventTarget) constructor?");};goog.events.EventTarget.dispatchEventInternal_=function(target,e,opt_ancestorsTree){var type=e.type||e;if(goog.isString(e)){e=new goog.events.Event(e,target);}else{if(e instanceof goog.events.Event){e.target=e.target||target;}else{var oldEvent=e;e=new goog.events.Event(type,target);goog.object.extend(e,oldEvent);}}var rv=!0;if(opt_ancestorsTree){for(var i=opt_ancestorsTree.length-1;!e.propagationStopped_&&0<=i;i--){var currentTarget=e.currentTarget=opt_ancestorsTree[i];rv=currentTarget.fireListeners(type,!0,e)&&rv;}}e.propagationStopped_||(currentTarget=e.currentTarget=target,rv=currentTarget.fireListeners(type,!0,e)&&rv,e.propagationStopped_||(rv=currentTarget.fireListeners(type,!1,e)&&rv));if(opt_ancestorsTree){for(i=0;!e.propagationStopped_&&i<opt_ancestorsTree.length;i++){currentTarget=e.currentTarget=opt_ancestorsTree[i],rv=currentTarget.fireListeners(type,!1,e)&&rv;}}return rv;};goog.async={};goog.async.FreeList=function(create,reset,limit){this.limit_=limit;this.create_=create;this.reset_=reset;this.occupants_=0;this.head_=null;};goog.async.FreeList.prototype.get=function(){if(0<this.occupants_){this.occupants_--;var item=this.head_;this.head_=item.next;item.next=null;}else{item=this.create_();}return item;};goog.async.FreeList.prototype.put=function(item){this.reset_(item);this.occupants_<this.limit_&&(this.occupants_++,item.next=this.head_,this.head_=item);};goog.async.FreeList.prototype.occupants=function(){return this.occupants_;};goog.dom.TagName=function(tagName){this.tagName_=tagName;};goog.dom.TagName.prototype.toString=function(){return this.tagName_;};goog.dom.TagName.A=new goog.dom.TagName("A");goog.dom.TagName.ABBR=new goog.dom.TagName("ABBR");goog.dom.TagName.ACRONYM=new goog.dom.TagName("ACRONYM");goog.dom.TagName.ADDRESS=new goog.dom.TagName("ADDRESS");goog.dom.TagName.APPLET=new goog.dom.TagName("APPLET");goog.dom.TagName.AREA=new goog.dom.TagName("AREA");goog.dom.TagName.ARTICLE=new goog.dom.TagName("ARTICLE");goog.dom.TagName.ASIDE=new goog.dom.TagName("ASIDE");goog.dom.TagName.AUDIO=new goog.dom.TagName("AUDIO");goog.dom.TagName.B=new goog.dom.TagName("B");goog.dom.TagName.BASE=new goog.dom.TagName("BASE");goog.dom.TagName.BASEFONT=new goog.dom.TagName("BASEFONT");goog.dom.TagName.BDI=new goog.dom.TagName("BDI");goog.dom.TagName.BDO=new goog.dom.TagName("BDO");goog.dom.TagName.BIG=new goog.dom.TagName("BIG");goog.dom.TagName.BLOCKQUOTE=new goog.dom.TagName("BLOCKQUOTE");goog.dom.TagName.BODY=new goog.dom.TagName("BODY");goog.dom.TagName.BR=new goog.dom.TagName("BR");goog.dom.TagName.BUTTON=new goog.dom.TagName("BUTTON");goog.dom.TagName.CANVAS=new goog.dom.TagName("CANVAS");goog.dom.TagName.CAPTION=new goog.dom.TagName("CAPTION");goog.dom.TagName.CENTER=new goog.dom.TagName("CENTER");goog.dom.TagName.CITE=new goog.dom.TagName("CITE");goog.dom.TagName.CODE=new goog.dom.TagName("CODE");goog.dom.TagName.COL=new goog.dom.TagName("COL");goog.dom.TagName.COLGROUP=new goog.dom.TagName("COLGROUP");goog.dom.TagName.COMMAND=new goog.dom.TagName("COMMAND");goog.dom.TagName.DATA=new goog.dom.TagName("DATA");goog.dom.TagName.DATALIST=new goog.dom.TagName("DATALIST");goog.dom.TagName.DD=new goog.dom.TagName("DD");goog.dom.TagName.DEL=new goog.dom.TagName("DEL");goog.dom.TagName.DETAILS=new goog.dom.TagName("DETAILS");goog.dom.TagName.DFN=new goog.dom.TagName("DFN");goog.dom.TagName.DIALOG=new goog.dom.TagName("DIALOG");goog.dom.TagName.DIR=new goog.dom.TagName("DIR");goog.dom.TagName.DIV=new goog.dom.TagName("DIV");goog.dom.TagName.DL=new goog.dom.TagName("DL");goog.dom.TagName.DT=new goog.dom.TagName("DT");goog.dom.TagName.EM=new goog.dom.TagName("EM");goog.dom.TagName.EMBED=new goog.dom.TagName("EMBED");goog.dom.TagName.FIELDSET=new goog.dom.TagName("FIELDSET");goog.dom.TagName.FIGCAPTION=new goog.dom.TagName("FIGCAPTION");goog.dom.TagName.FIGURE=new goog.dom.TagName("FIGURE");goog.dom.TagName.FONT=new goog.dom.TagName("FONT");goog.dom.TagName.FOOTER=new goog.dom.TagName("FOOTER");goog.dom.TagName.FORM=new goog.dom.TagName("FORM");goog.dom.TagName.FRAME=new goog.dom.TagName("FRAME");goog.dom.TagName.FRAMESET=new goog.dom.TagName("FRAMESET");goog.dom.TagName.H1=new goog.dom.TagName("H1");goog.dom.TagName.H2=new goog.dom.TagName("H2");goog.dom.TagName.H3=new goog.dom.TagName("H3");goog.dom.TagName.H4=new goog.dom.TagName("H4");goog.dom.TagName.H5=new goog.dom.TagName("H5");goog.dom.TagName.H6=new goog.dom.TagName("H6");goog.dom.TagName.HEAD=new goog.dom.TagName("HEAD");goog.dom.TagName.HEADER=new goog.dom.TagName("HEADER");goog.dom.TagName.HGROUP=new goog.dom.TagName("HGROUP");goog.dom.TagName.HR=new goog.dom.TagName("HR");goog.dom.TagName.HTML=new goog.dom.TagName("HTML");goog.dom.TagName.I=new goog.dom.TagName("I");goog.dom.TagName.IFRAME=new goog.dom.TagName("IFRAME");goog.dom.TagName.IMG=new goog.dom.TagName("IMG");goog.dom.TagName.INPUT=new goog.dom.TagName("INPUT");goog.dom.TagName.INS=new goog.dom.TagName("INS");goog.dom.TagName.ISINDEX=new goog.dom.TagName("ISINDEX");goog.dom.TagName.KBD=new goog.dom.TagName("KBD");goog.dom.TagName.KEYGEN=new goog.dom.TagName("KEYGEN");goog.dom.TagName.LABEL=new goog.dom.TagName("LABEL");goog.dom.TagName.LEGEND=new goog.dom.TagName("LEGEND");goog.dom.TagName.LI=new goog.dom.TagName("LI");goog.dom.TagName.LINK=new goog.dom.TagName("LINK");goog.dom.TagName.MAP=new goog.dom.TagName("MAP");goog.dom.TagName.MARK=new goog.dom.TagName("MARK");goog.dom.TagName.MATH=new goog.dom.TagName("MATH");goog.dom.TagName.MENU=new goog.dom.TagName("MENU");goog.dom.TagName.META=new goog.dom.TagName("META");goog.dom.TagName.METER=new goog.dom.TagName("METER");goog.dom.TagName.NAV=new goog.dom.TagName("NAV");goog.dom.TagName.NOFRAMES=new goog.dom.TagName("NOFRAMES");goog.dom.TagName.NOSCRIPT=new goog.dom.TagName("NOSCRIPT");goog.dom.TagName.OBJECT=new goog.dom.TagName("OBJECT");goog.dom.TagName.OL=new goog.dom.TagName("OL");goog.dom.TagName.OPTGROUP=new goog.dom.TagName("OPTGROUP");goog.dom.TagName.OPTION=new goog.dom.TagName("OPTION");goog.dom.TagName.OUTPUT=new goog.dom.TagName("OUTPUT");goog.dom.TagName.P=new goog.dom.TagName("P");goog.dom.TagName.PARAM=new goog.dom.TagName("PARAM");goog.dom.TagName.PRE=new goog.dom.TagName("PRE");goog.dom.TagName.PROGRESS=new goog.dom.TagName("PROGRESS");goog.dom.TagName.Q=new goog.dom.TagName("Q");goog.dom.TagName.RP=new goog.dom.TagName("RP");goog.dom.TagName.RT=new goog.dom.TagName("RT");goog.dom.TagName.RUBY=new goog.dom.TagName("RUBY");goog.dom.TagName.S=new goog.dom.TagName("S");goog.dom.TagName.SAMP=new goog.dom.TagName("SAMP");goog.dom.TagName.SCRIPT=new goog.dom.TagName("SCRIPT");goog.dom.TagName.SECTION=new goog.dom.TagName("SECTION");goog.dom.TagName.SELECT=new goog.dom.TagName("SELECT");goog.dom.TagName.SMALL=new goog.dom.TagName("SMALL");goog.dom.TagName.SOURCE=new goog.dom.TagName("SOURCE");goog.dom.TagName.SPAN=new goog.dom.TagName("SPAN");goog.dom.TagName.STRIKE=new goog.dom.TagName("STRIKE");goog.dom.TagName.STRONG=new goog.dom.TagName("STRONG");goog.dom.TagName.STYLE=new goog.dom.TagName("STYLE");goog.dom.TagName.SUB=new goog.dom.TagName("SUB");goog.dom.TagName.SUMMARY=new goog.dom.TagName("SUMMARY");goog.dom.TagName.SUP=new goog.dom.TagName("SUP");goog.dom.TagName.SVG=new goog.dom.TagName("SVG");goog.dom.TagName.TABLE=new goog.dom.TagName("TABLE");goog.dom.TagName.TBODY=new goog.dom.TagName("TBODY");goog.dom.TagName.TD=new goog.dom.TagName("TD");goog.dom.TagName.TEMPLATE=new goog.dom.TagName("TEMPLATE");goog.dom.TagName.TEXTAREA=new goog.dom.TagName("TEXTAREA");goog.dom.TagName.TFOOT=new goog.dom.TagName("TFOOT");goog.dom.TagName.TH=new goog.dom.TagName("TH");goog.dom.TagName.THEAD=new goog.dom.TagName("THEAD");goog.dom.TagName.TIME=new goog.dom.TagName("TIME");goog.dom.TagName.TITLE=new goog.dom.TagName("TITLE");goog.dom.TagName.TR=new goog.dom.TagName("TR");goog.dom.TagName.TRACK=new goog.dom.TagName("TRACK");goog.dom.TagName.TT=new goog.dom.TagName("TT");goog.dom.TagName.U=new goog.dom.TagName("U");goog.dom.TagName.UL=new goog.dom.TagName("UL");goog.dom.TagName.VAR=new goog.dom.TagName("VAR");goog.dom.TagName.VIDEO=new goog.dom.TagName("VIDEO");goog.dom.TagName.WBR=new goog.dom.TagName("WBR");goog.functions={};goog.functions.constant=function(retValue){return function(){return retValue;};};goog.functions.FALSE=goog.functions.constant(!1);goog.functions.TRUE=goog.functions.constant(!0);goog.functions.NULL=goog.functions.constant(null);goog.functions.identity=function(opt_returnValue,var_args){return opt_returnValue;};goog.functions.error=function(message){return function(){throw Error(message);};};goog.functions.fail=function(err){return function(){throw err;};};goog.functions.lock=function(f,opt_numArgs){opt_numArgs=opt_numArgs||0;return function(){return f.apply(this,Array.prototype.slice.call(arguments,0,opt_numArgs));};};goog.functions.nth=function(n){return function(){return arguments[n];};};goog.functions.partialRight=function(fn,var_args){var rightArgs=Array.prototype.slice.call(arguments,1);return function(){var newArgs=Array.prototype.slice.call(arguments);newArgs.push.apply(newArgs,rightArgs);return fn.apply(this,newArgs);};};goog.functions.withReturnValue=function(f,retValue){return goog.functions.sequence(f,goog.functions.constant(retValue));};goog.functions.equalTo=function(value,opt_useLooseComparison){return function(other){return opt_useLooseComparison?value==other:value===other;};};goog.functions.compose=function(fn,var_args){var functions=arguments,length=functions.length;return function(){var result;length&&(result=functions[length-1].apply(this,arguments));for(var i=length-2;0<=i;i--){result=functions[i].call(this,result);}return result;};};goog.functions.sequence=function(var_args){var functions=arguments,length=functions.length;return function(){for(var result,i=0;i<length;i++){result=functions[i].apply(this,arguments);}return result;};};goog.functions.and=function(var_args){var functions=arguments,length=functions.length;return function(){for(var i=0;i<length;i++){if(!functions[i].apply(this,arguments)){return!1;}}return!0;};};goog.functions.or=function(var_args){var functions=arguments,length=functions.length;return function(){for(var i=0;i<length;i++){if(functions[i].apply(this,arguments)){return!0;}}return!1;};};goog.functions.not=function(f){return function(){return!f.apply(this,arguments);};};goog.functions.create=function(constructor,var_args){var temp=function temp(){};temp.prototype=constructor.prototype;var obj=new temp();constructor.apply(obj,Array.prototype.slice.call(arguments,1));return obj;};goog.functions.CACHE_RETURN_VALUE=!0;goog.functions.cacheReturnValue=function(fn){var called=!1,value;return function(){if(!goog.functions.CACHE_RETURN_VALUE){return fn();}called||(value=fn(),called=!0);return value;};};goog.functions.once=function(f){var inner=f;return function(){if(inner){var tmp=inner;inner=null;tmp();}};};goog.functions.debounce=function(f,interval,opt_scope){var timeout=0;return function(var_args){goog.global.clearTimeout(timeout);var args=arguments;timeout=goog.global.setTimeout(function(){f.apply(opt_scope,args);},interval);};};goog.functions.throttle=function(f,interval,opt_scope){var timeout=0,shouldFire=!1,args=[],handleTimeout=function handleTimeout(){timeout=0;shouldFire&&(shouldFire=!1,fire());},fire=function fire(){timeout=goog.global.setTimeout(handleTimeout,interval);f.apply(opt_scope,args);};return function(var_args){args=arguments;timeout?shouldFire=!0:fire();};};goog.functions.rateLimit=function(f,interval,opt_scope){var timeout=0,handleTimeout=function handleTimeout(){timeout=0;};return function(var_args){timeout||(timeout=goog.global.setTimeout(handleTimeout,interval),f.apply(opt_scope,arguments));};};goog.functions.rateLimit=function(f,interval,opt_scope){var timeout=0,handleTimeout=function handleTimeout(){timeout=0;};return function(var_args){timeout||(timeout=goog.global.setTimeout(handleTimeout,interval),f.apply(opt_scope,arguments));};};goog.async.throwException=function(exception){goog.global.setTimeout(function(){throw exception;},0);};goog.async.nextTick=function(callback,opt_context,opt_useSetImmediate){var cb=callback;opt_context&&(cb=goog.bind(callback,opt_context));cb=goog.async.nextTick.wrapCallback_(cb);goog.isFunction(goog.global.setImmediate)&&(opt_useSetImmediate||goog.async.nextTick.useSetImmediate_())?goog.global.setImmediate(cb):(goog.async.nextTick.setImmediate_||(goog.async.nextTick.setImmediate_=goog.async.nextTick.getSetImmediateEmulator_()),goog.async.nextTick.setImmediate_(cb));};goog.async.nextTick.useSetImmediate_=function(){return goog.global.Window&&goog.global.Window.prototype&&!goog.labs.userAgent.browser.isEdge()&&goog.global.Window.prototype.setImmediate==goog.global.setImmediate?!1:!0;};goog.async.nextTick.getSetImmediateEmulator_=function(){var Channel=goog.global.MessageChannel;"undefined"===typeof Channel&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!goog.labs.userAgent.engine.isPresto()&&(Channel=function Channel(){var iframe=document.createElement("IFRAME");iframe.style.display="none";iframe.src="";document.documentElement.appendChild(iframe);var win=iframe.contentWindow,doc=win.document;doc.open();doc.write("");doc.close();var message="callImmediate"+Math.random(),origin="file:"==win.location.protocol?"*":win.location.protocol+"//"+win.location.host,onmessage=goog.bind(function(e){if(("*"==origin||e.origin==origin)&&e.data==message){this.port1.onmessage();}},this);win.addEventListener("message",onmessage,!1);this.port1={};this.port2={postMessage:function postMessage(){win.postMessage(message,origin);}};});if("undefined"!==typeof Channel&&!goog.labs.userAgent.browser.isIE()){var channel=new Channel(),head={},tail=head;channel.port1.onmessage=function(){if(goog.isDef(head.next)){head=head.next;var cb=head.cb;head.cb=null;cb();}};return function(cb){tail.next={cb:cb};tail=tail.next;channel.port2.postMessage(0);};}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(cb){var script=document.createElement("SCRIPT");script.onreadystatechange=function(){script.onreadystatechange=null;script.parentNode.removeChild(script);script=null;cb();cb=null;};document.documentElement.appendChild(script);}:function(cb){goog.global.setTimeout(cb,0);};};goog.async.nextTick.wrapCallback_=goog.functions.identity;goog.debug.entryPointRegistry.register(function(transformer){goog.async.nextTick.wrapCallback_=transformer;});goog.async.WorkQueue=function(){this.workTail_=this.workHead_=null;};goog.async.WorkQueue.DEFAULT_MAX_UNUSED=100;goog.async.WorkQueue.freelist_=new goog.async.FreeList(function(){return new goog.async.WorkItem();},function(item){item.reset();},goog.async.WorkQueue.DEFAULT_MAX_UNUSED);goog.async.WorkQueue.prototype.add=function(fn,scope){var item=this.getUnusedItem_();item.set(fn,scope);this.workTail_?this.workTail_.next=item:(goog.asserts.assert(!this.workHead_),this.workHead_=item);this.workTail_=item;};goog.async.WorkQueue.prototype.remove=function(){var item=null;this.workHead_&&(item=this.workHead_,this.workHead_=this.workHead_.next,this.workHead_||(this.workTail_=null),item.next=null);return item;};goog.async.WorkQueue.prototype.returnUnused=function(item){goog.async.WorkQueue.freelist_.put(item);};goog.async.WorkQueue.prototype.getUnusedItem_=function(){return goog.async.WorkQueue.freelist_.get();};goog.async.WorkItem=function(){this.next=this.scope=this.fn=null;};goog.async.WorkItem.prototype.set=function(fn,scope){this.fn=fn;this.scope=scope;this.next=null;};goog.async.WorkItem.prototype.reset=function(){this.next=this.scope=this.fn=null;};goog.async.run=function(callback,opt_context){goog.async.run.schedule_||goog.async.run.initializeRunner_();goog.async.run.workQueueScheduled_||(goog.async.run.schedule_(),goog.async.run.workQueueScheduled_=!0);goog.async.run.workQueue_.add(callback,opt_context);};goog.async.run.initializeRunner_=function(){if(-1!=String(goog.global.Promise).indexOf("[native code]")){var promise=goog.global.Promise.resolve(void 0);goog.async.run.schedule_=function(){promise.then(goog.async.run.processWorkQueue);};}else{goog.async.run.schedule_=function(){goog.async.nextTick(goog.async.run.processWorkQueue);};}};goog.async.run.forceNextTick=function(opt_realSetTimeout){goog.async.run.schedule_=function(){goog.async.nextTick(goog.async.run.processWorkQueue);opt_realSetTimeout&&opt_realSetTimeout(goog.async.run.processWorkQueue);};};goog.async.run.workQueueScheduled_=!1;goog.async.run.workQueue_=new goog.async.WorkQueue();goog.DEBUG&&(goog.async.run.resetQueue=function(){goog.async.run.workQueueScheduled_=!1;goog.async.run.workQueue_=new goog.async.WorkQueue();});goog.async.run.processWorkQueue=function(){for(var item=null;item=goog.async.run.workQueue_.remove();){try{item.fn.call(item.scope);}catch(e){goog.async.throwException(e);}goog.async.run.workQueue_.returnUnused(item);}goog.async.run.workQueueScheduled_=!1;};goog.fs={};goog.fs.DOMErrorLike=function(){};goog.fs.Error=function(error,action){goog.isDef(error.name)?(this.name=error.name,this.code=goog.fs.Error.getCodeFromName_(error.name)):(this.code=goog.asserts.assertNumber(error.code),this.name=goog.fs.Error.getNameFromCode_(error.code));goog.debug.Error.call(this,goog.string.subs("%s %s",this.name,action));};goog.inherits(goog.fs.Error,goog.debug.Error);goog.fs.Error.ErrorName={ABORT:"AbortError",ENCODING:"EncodingError",INVALID_MODIFICATION:"InvalidModificationError",INVALID_STATE:"InvalidStateError",NOT_FOUND:"NotFoundError",NOT_READABLE:"NotReadableError",NO_MODIFICATION_ALLOWED:"NoModificationAllowedError",PATH_EXISTS:"PathExistsError",QUOTA_EXCEEDED:"QuotaExceededError",SECURITY:"SecurityError",SYNTAX:"SyntaxError",TYPE_MISMATCH:"TypeMismatchError"};goog.fs.Error.ErrorCode={NOT_FOUND:1,SECURITY:2,ABORT:3,NOT_READABLE:4,ENCODING:5,NO_MODIFICATION_ALLOWED:6,INVALID_STATE:7,SYNTAX:8,INVALID_MODIFICATION:9,QUOTA_EXCEEDED:10,TYPE_MISMATCH:11,PATH_EXISTS:12};goog.fs.Error.getNameFromCode_=function(code){var name=goog.object.findKey(goog.fs.Error.NameToCodeMap_,function(c){return code==c;});if(!goog.isDef(name)){throw Error("Invalid code: "+code);}return name;};goog.fs.Error.getCodeFromName_=function(name){return goog.fs.Error.NameToCodeMap_[name];};goog.fs.Error.NameToCodeMap_=goog.object.create(goog.fs.Error.ErrorName.ABORT,goog.fs.Error.ErrorCode.ABORT,goog.fs.Error.ErrorName.ENCODING,goog.fs.Error.ErrorCode.ENCODING,goog.fs.Error.ErrorName.INVALID_MODIFICATION,goog.fs.Error.ErrorCode.INVALID_MODIFICATION,goog.fs.Error.ErrorName.INVALID_STATE,goog.fs.Error.ErrorCode.INVALID_STATE,goog.fs.Error.ErrorName.NOT_FOUND,goog.fs.Error.ErrorCode.NOT_FOUND,goog.fs.Error.ErrorName.NOT_READABLE,goog.fs.Error.ErrorCode.NOT_READABLE,goog.fs.Error.ErrorName.NO_MODIFICATION_ALLOWED,goog.fs.Error.ErrorCode.NO_MODIFICATION_ALLOWED,goog.fs.Error.ErrorName.PATH_EXISTS,goog.fs.Error.ErrorCode.PATH_EXISTS,goog.fs.Error.ErrorName.QUOTA_EXCEEDED,goog.fs.Error.ErrorCode.QUOTA_EXCEEDED,goog.fs.Error.ErrorName.SECURITY,goog.fs.Error.ErrorCode.SECURITY,goog.fs.Error.ErrorName.SYNTAX,goog.fs.Error.ErrorCode.SYNTAX,goog.fs.Error.ErrorName.TYPE_MISMATCH,goog.fs.Error.ErrorCode.TYPE_MISMATCH);goog.fs.ProgressEvent=function(event,target){goog.events.Event.call(this,event.type,target);this.event_=event;};goog.inherits(goog.fs.ProgressEvent,goog.events.Event);goog.fs.ProgressEvent.prototype.isLengthComputable=function(){return this.event_.lengthComputable;};goog.fs.ProgressEvent.prototype.getLoaded=function(){return this.event_.loaded;};goog.fs.ProgressEvent.prototype.getTotal=function(){return this.event_.total;};goog.fs={};goog.fs.DOMErrorLike=function(){};goog.fs.Error=function(error,action){goog.isDef(error.name)?(this.name=error.name,this.code=goog.fs.Error.getCodeFromName_(error.name)):(this.code=goog.asserts.assertNumber(error.code),this.name=goog.fs.Error.getNameFromCode_(error.code));goog.debug.Error.call(this,goog.string.subs("%s %s",this.name,action));};goog.inherits(goog.fs.Error,goog.debug.Error);goog.fs.Error.ErrorName={ABORT:"AbortError",ENCODING:"EncodingError",INVALID_MODIFICATION:"InvalidModificationError",INVALID_STATE:"InvalidStateError",NOT_FOUND:"NotFoundError",NOT_READABLE:"NotReadableError",NO_MODIFICATION_ALLOWED:"NoModificationAllowedError",PATH_EXISTS:"PathExistsError",QUOTA_EXCEEDED:"QuotaExceededError",SECURITY:"SecurityError",SYNTAX:"SyntaxError",TYPE_MISMATCH:"TypeMismatchError"};goog.fs.Error.ErrorCode={NOT_FOUND:1,SECURITY:2,ABORT:3,NOT_READABLE:4,ENCODING:5,NO_MODIFICATION_ALLOWED:6,INVALID_STATE:7,SYNTAX:8,INVALID_MODIFICATION:9,QUOTA_EXCEEDED:10,TYPE_MISMATCH:11,PATH_EXISTS:12};goog.fs.Error.getNameFromCode_=function(code){var name=goog.object.findKey(goog.fs.Error.NameToCodeMap_,function(c){return code==c;});if(!goog.isDef(name)){throw Error("Invalid code: "+code);}return name;};goog.fs.Error.getCodeFromName_=function(name){return goog.fs.Error.NameToCodeMap_[name];};goog.fs.Error.NameToCodeMap_=goog.object.create(goog.fs.Error.ErrorName.ABORT,goog.fs.Error.ErrorCode.ABORT,goog.fs.Error.ErrorName.ENCODING,goog.fs.Error.ErrorCode.ENCODING,goog.fs.Error.ErrorName.INVALID_MODIFICATION,goog.fs.Error.ErrorCode.INVALID_MODIFICATION,goog.fs.Error.ErrorName.INVALID_STATE,goog.fs.Error.ErrorCode.INVALID_STATE,goog.fs.Error.ErrorName.NOT_FOUND,goog.fs.Error.ErrorCode.NOT_FOUND,goog.fs.Error.ErrorName.NOT_READABLE,goog.fs.Error.ErrorCode.NOT_READABLE,goog.fs.Error.ErrorName.NO_MODIFICATION_ALLOWED,goog.fs.Error.ErrorCode.NO_MODIFICATION_ALLOWED,goog.fs.Error.ErrorName.PATH_EXISTS,goog.fs.Error.ErrorCode.PATH_EXISTS,goog.fs.Error.ErrorName.QUOTA_EXCEEDED,goog.fs.Error.ErrorCode.QUOTA_EXCEEDED,goog.fs.Error.ErrorName.SECURITY,goog.fs.Error.ErrorCode.SECURITY,goog.fs.Error.ErrorName.SYNTAX,goog.fs.Error.ErrorCode.SYNTAX,goog.fs.Error.ErrorName.TYPE_MISMATCH,goog.fs.Error.ErrorCode.TYPE_MISMATCH);goog.fs.ProgressEvent=function(event,target){goog.events.Event.call(this,event.type,target);this.event_=event;};goog.inherits(goog.fs.ProgressEvent,goog.events.Event);goog.fs.ProgressEvent.prototype.isLengthComputable=function(){return this.event_.lengthComputable;};goog.fs.ProgressEvent.prototype.getLoaded=function(){return this.event_.loaded;};goog.fs.ProgressEvent.prototype.getTotal=function(){return this.event_.total;};goog.promise={};goog.promise.Resolver=function(){};goog.Thenable=function(){};goog.Thenable.prototype.then=function(opt_onFulfilled,opt_onRejected,opt_context){};goog.Thenable.IMPLEMENTED_BY_PROP="$goog_Thenable";goog.Thenable.addImplementation=function(ctor){ctor.prototype.then=ctor.prototype.then;ctor.prototype[goog.Thenable.IMPLEMENTED_BY_PROP]=!0;};goog.Thenable.isImplementedBy=function(object){if(!object){return!1;}try{return!!object[goog.Thenable.IMPLEMENTED_BY_PROP];return!!object.$goog_Thenable;}catch(e){return!1;}};goog.Promise=function(resolver,opt_context){this.state_=goog.Promise.State_.PENDING;this.result_=void 0;this.callbackEntriesTail_=this.callbackEntries_=this.parent_=null;this.executing_=!1;0<goog.Promise.UNHANDLED_REJECTION_DELAY?this.unhandledRejectionId_=0:0==goog.Promise.UNHANDLED_REJECTION_DELAY&&(this.hadUnhandledRejection_=!1);goog.Promise.LONG_STACK_TRACES&&(this.stack_=[],this.addStackTrace_(Error("created")),this.currentStep_=0);if(resolver!=goog.nullFunction){try{var self=this;resolver.call(opt_context,function(value){self.resolve_(goog.Promise.State_.FULFILLED,value);},function(reason){if(goog.DEBUG&&!(reason instanceof goog.Promise.CancellationError)){try{if(reason instanceof Error){throw reason;}throw Error("Promise rejected.");}catch(e){}}self.resolve_(goog.Promise.State_.REJECTED,reason);});}catch(e){this.resolve_(goog.Promise.State_.REJECTED,e);}}};goog.Promise.LONG_STACK_TRACES=!1;goog.Promise.UNHANDLED_REJECTION_DELAY=0;goog.Promise.State_={PENDING:0,BLOCKED:1,FULFILLED:2,REJECTED:3};goog.Promise.CallbackEntry_=function(){this.next=this.context=this.onRejected=this.onFulfilled=this.child=null;this.always=!1;};goog.Promise.CallbackEntry_.prototype.reset=function(){this.context=this.onRejected=this.onFulfilled=this.child=null;this.always=!1;};goog.Promise.DEFAULT_MAX_UNUSED=100;goog.Promise.freelist_=new goog.async.FreeList(function(){return new goog.Promise.CallbackEntry_();},function(item){item.reset();},goog.Promise.DEFAULT_MAX_UNUSED);goog.Promise.getCallbackEntry_=function(onFulfilled,onRejected,context){var entry=goog.Promise.freelist_.get();entry.onFulfilled=onFulfilled;entry.onRejected=onRejected;entry.context=context;return entry;};goog.Promise.returnEntry_=function(entry){goog.Promise.freelist_.put(entry);};goog.Promise.resolve=function(opt_value){if(opt_value instanceof goog.Promise){return opt_value;}var promise=new goog.Promise(goog.nullFunction);promise.resolve_(goog.Promise.State_.FULFILLED,opt_value);return promise;};goog.Promise.reject=function(opt_reason){return new goog.Promise(function(resolve,reject){reject(opt_reason);});};goog.Promise.resolveThen_=function(value,onFulfilled,onRejected){goog.Promise.maybeThen_(value,onFulfilled,onRejected,null)||goog.async.run(goog.partial(onFulfilled,value));};goog.Promise.race=function(promises){return new goog.Promise(function(resolve,reject){promises.length||resolve(void 0);for(var i=0,promise;i<promises.length;i++){promise=promises[i],goog.Promise.resolveThen_(promise,resolve,reject);}});};goog.Promise.all=function(promises){return new goog.Promise(function(resolve,reject){var toFulfill=promises.length,values=[];if(toFulfill){for(var onFulfill=function onFulfill(index,value){toFulfill--;values[index]=value;0==toFulfill&&resolve(values);},onReject=function onReject(reason){reject(reason);},i=0,promise;i<promises.length;i++){promise=promises[i],goog.Promise.resolveThen_(promise,goog.partial(onFulfill,i),onReject);}}else{resolve(values);}});};goog.Promise.allSettled=function(promises){return new goog.Promise(function(resolve,reject){var toSettle=promises.length,results=[];if(toSettle){for(var onSettled=function onSettled(index,fulfilled,result){toSettle--;results[index]=fulfilled?{fulfilled:!0,value:result}:{fulfilled:!1,reason:result};0==toSettle&&resolve(results);},i=0,promise;i<promises.length;i++){promise=promises[i],goog.Promise.resolveThen_(promise,goog.partial(onSettled,i,!0),goog.partial(onSettled,i,!1));}}else{resolve(results);}});};goog.Promise.firstFulfilled=function(promises){return new goog.Promise(function(resolve,reject){var toReject=promises.length,reasons=[];if(toReject){for(var onFulfill=function onFulfill(value){resolve(value);},onReject=function onReject(index,reason){toReject--;reasons[index]=reason;0==toReject&&reject(reasons);},i=0,promise;i<promises.length;i++){promise=promises[i],goog.Promise.resolveThen_(promise,onFulfill,goog.partial(onReject,i));}}else{resolve(void 0);}});};goog.Promise.withResolver=function(){var resolve,reject,promise=new goog.Promise(function(rs,rj){resolve=rs;reject=rj;});return new goog.Promise.Resolver_(promise,resolve,reject);};goog.Promise.prototype.then=function(opt_onFulfilled,opt_onRejected,opt_context){null!=opt_onFulfilled&&goog.asserts.assertFunction(opt_onFulfilled,"opt_onFulfilled should be a function.");null!=opt_onRejected&&goog.asserts.assertFunction(opt_onRejected,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");goog.Promise.LONG_STACK_TRACES&&this.addStackTrace_(Error("then"));return this.addChildPromise_(goog.isFunction(opt_onFulfilled)?opt_onFulfilled:null,goog.isFunction(opt_onRejected)?opt_onRejected:null,opt_context);};goog.Thenable.addImplementation(goog.Promise);goog.Promise.prototype.thenVoid=function(opt_onFulfilled,opt_onRejected,opt_context){null!=opt_onFulfilled&&goog.asserts.assertFunction(opt_onFulfilled,"opt_onFulfilled should be a function.");null!=opt_onRejected&&goog.asserts.assertFunction(opt_onRejected,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");goog.Promise.LONG_STACK_TRACES&&this.addStackTrace_(Error("then"));this.addCallbackEntry_(goog.Promise.getCallbackEntry_(opt_onFulfilled||goog.nullFunction,opt_onRejected||null,opt_context));};goog.Promise.prototype.thenAlways=function(onSettled,opt_context){goog.Promise.LONG_STACK_TRACES&&this.addStackTrace_(Error("thenAlways"));var entry=goog.Promise.getCallbackEntry_(onSettled,onSettled,opt_context);entry.always=!0;this.addCallbackEntry_(entry);return this;};goog.Promise.prototype.thenCatch=function(onRejected,opt_context){goog.Promise.LONG_STACK_TRACES&&this.addStackTrace_(Error("thenCatch"));return this.addChildPromise_(null,onRejected,opt_context);};goog.Promise.prototype.cancel=function(opt_message){this.state_==goog.Promise.State_.PENDING&&goog.async.run(function(){var err=new goog.Promise.CancellationError(opt_message);this.cancelInternal_(err);},this);};goog.Promise.prototype.cancelInternal_=function(err){this.state_==goog.Promise.State_.PENDING&&(this.parent_?(this.parent_.cancelChild_(this,err),this.parent_=null):this.resolve_(goog.Promise.State_.REJECTED,err));};goog.Promise.prototype.cancelChild_=function(childPromise,err){if(this.callbackEntries_){for(var childCount=0,childEntry=null,beforeChildEntry=null,entry=this.callbackEntries_;entry&&(entry.always||(childCount++,entry.child==childPromise&&(childEntry=entry),!(childEntry&&1<childCount)));entry=entry.next){childEntry||(beforeChildEntry=entry);}childEntry&&(this.state_==goog.Promise.State_.PENDING&&1==childCount?this.cancelInternal_(err):(beforeChildEntry?this.removeEntryAfter_(beforeChildEntry):this.popEntry_(),this.executeCallback_(childEntry,goog.Promise.State_.REJECTED,err)));}};goog.Promise.prototype.addCallbackEntry_=function(callbackEntry){this.hasEntry_()||this.state_!=goog.Promise.State_.FULFILLED&&this.state_!=goog.Promise.State_.REJECTED||this.scheduleCallbacks_();this.queueEntry_(callbackEntry);};goog.Promise.prototype.addChildPromise_=function(onFulfilled,onRejected,opt_context){var callbackEntry=goog.Promise.getCallbackEntry_(null,null,null);callbackEntry.child=new goog.Promise(function(resolve,reject){callbackEntry.onFulfilled=onFulfilled?function(value){try{var result=onFulfilled.call(opt_context,value);resolve(result);}catch(err){reject(err);}}:resolve;callbackEntry.onRejected=onRejected?function(reason){try{var result=onRejected.call(opt_context,reason);!goog.isDef(result)&&reason instanceof goog.Promise.CancellationError?reject(reason):resolve(result);}catch(err){reject(err);}}:reject;});callbackEntry.child.parent_=this;this.addCallbackEntry_(callbackEntry);return callbackEntry.child;};goog.Promise.prototype.unblockAndFulfill_=function(value){goog.asserts.assert(this.state_==goog.Promise.State_.BLOCKED);this.state_=goog.Promise.State_.PENDING;this.resolve_(goog.Promise.State_.FULFILLED,value);};goog.Promise.prototype.unblockAndReject_=function(reason){goog.asserts.assert(this.state_==goog.Promise.State_.BLOCKED);this.state_=goog.Promise.State_.PENDING;this.resolve_(goog.Promise.State_.REJECTED,reason);};goog.Promise.prototype.resolve_=function(state,x){this.state_==goog.Promise.State_.PENDING&&(this===x&&(state=goog.Promise.State_.REJECTED,x=new TypeError("Promise cannot resolve to itself")),this.state_=goog.Promise.State_.BLOCKED,goog.Promise.maybeThen_(x,this.unblockAndFulfill_,this.unblockAndReject_,this)||(this.result_=x,this.state_=state,this.parent_=null,this.scheduleCallbacks_(),state!=goog.Promise.State_.REJECTED||x instanceof goog.Promise.CancellationError||goog.Promise.addUnhandledRejection_(this,x)));};goog.Promise.maybeThen_=function(value,onFulfilled,onRejected,context){if(value instanceof goog.Promise){return value.thenVoid(onFulfilled,onRejected,context),!0;}if(goog.Thenable.isImplementedBy(value)){return value.then(onFulfilled,onRejected,context),!0;}if(goog.isObject(value)){try{var then=value.then;if(goog.isFunction(then)){return goog.Promise.tryThen_(value,then,onFulfilled,onRejected,context),!0;}}catch(e){return onRejected.call(context,e),!0;}}return!1;};goog.Promise.tryThen_=function(thenable,then,onFulfilled,onRejected,context){var called=!1,resolve=function resolve(value){called||(called=!0,onFulfilled.call(context,value));},reject=function reject(reason){called||(called=!0,onRejected.call(context,reason));};try{then.call(thenable,resolve,reject);}catch(e){reject(e);}};goog.Promise.prototype.scheduleCallbacks_=function(){this.executing_||(this.executing_=!0,goog.async.run(this.executeCallbacks_,this));};goog.Promise.prototype.hasEntry_=function(){return!!this.callbackEntries_;};goog.Promise.prototype.queueEntry_=function(entry){goog.asserts.assert(null!=entry.onFulfilled);this.callbackEntriesTail_?this.callbackEntriesTail_.next=entry:this.callbackEntries_=entry;this.callbackEntriesTail_=entry;};goog.Promise.prototype.popEntry_=function(){var entry=null;this.callbackEntries_&&(entry=this.callbackEntries_,this.callbackEntries_=entry.next,entry.next=null);this.callbackEntries_||(this.callbackEntriesTail_=null);null!=entry&&goog.asserts.assert(null!=entry.onFulfilled);return entry;};goog.Promise.prototype.removeEntryAfter_=function(previous){goog.asserts.assert(this.callbackEntries_);goog.asserts.assert(null!=previous);previous.next==this.callbackEntriesTail_&&(this.callbackEntriesTail_=previous);previous.next=previous.next.next;};goog.Promise.prototype.executeCallbacks_=function(){for(var entry=null;entry=this.popEntry_();){goog.Promise.LONG_STACK_TRACES&&this.currentStep_++,this.executeCallback_(entry,this.state_,this.result_);}this.executing_=!1;};goog.Promise.prototype.executeCallback_=function(callbackEntry,state,result){state==goog.Promise.State_.REJECTED&&callbackEntry.onRejected&&!callbackEntry.always&&this.removeUnhandledRejection_();if(callbackEntry.child){callbackEntry.child.parent_=null,goog.Promise.invokeCallback_(callbackEntry,state,result);}else{try{callbackEntry.always?callbackEntry.onFulfilled.call(callbackEntry.context):goog.Promise.invokeCallback_(callbackEntry,state,result);}catch(err){goog.Promise.handleRejection_.call(null,err);}}goog.Promise.returnEntry_(callbackEntry);};goog.Promise.invokeCallback_=function(callbackEntry,state,result){state==goog.Promise.State_.FULFILLED?callbackEntry.onFulfilled.call(callbackEntry.context,result):callbackEntry.onRejected&&callbackEntry.onRejected.call(callbackEntry.context,result);};goog.Promise.prototype.addStackTrace_=function(err){if(goog.Promise.LONG_STACK_TRACES&&goog.isString(err.stack)){var trace=err.stack.split("\\n",4)[3],message=err.message,message=message+Array(11-message.length).join(" ");this.stack_.push(message+trace);}};goog.Promise.prototype.appendLongStack_=function(err){if(goog.Promise.LONG_STACK_TRACES&&err&&goog.isString(err.stack)&&this.stack_.length){for(var longTrace=["Promise trace:"],promise=this;promise;promise=promise.parent_){for(var i=this.currentStep_;0<=i;i--){longTrace.push(promise.stack_[i]);}longTrace.push("Value: ["+(promise.state_==goog.Promise.State_.REJECTED?"REJECTED":"FULFILLED")+"] <"+String(promise.result_)+">");}err.stack+="\\n\\n"+longTrace.join("\\n");}};goog.Promise.prototype.removeUnhandledRejection_=function(){if(0<goog.Promise.UNHANDLED_REJECTION_DELAY){for(var p=this;p&&p.unhandledRejectionId_;p=p.parent_){goog.global.clearTimeout(p.unhandledRejectionId_),p.unhandledRejectionId_=0;}}else{if(0==goog.Promise.UNHANDLED_REJECTION_DELAY){for(p=this;p&&p.hadUnhandledRejection_;p=p.parent_){p.hadUnhandledRejection_=!1;}}}};goog.Promise.addUnhandledRejection_=function(promise,reason){0<goog.Promise.UNHANDLED_REJECTION_DELAY?promise.unhandledRejectionId_=goog.global.setTimeout(function(){promise.appendLongStack_(reason);goog.Promise.handleRejection_.call(null,reason);},goog.Promise.UNHANDLED_REJECTION_DELAY):0==goog.Promise.UNHANDLED_REJECTION_DELAY&&(promise.hadUnhandledRejection_=!0,goog.async.run(function(){promise.hadUnhandledRejection_&&(promise.appendLongStack_(reason),goog.Promise.handleRejection_.call(null,reason));}));};goog.Promise.handleRejection_=goog.async.throwException;goog.Promise.setUnhandledRejectionHandler=function(handler){goog.Promise.handleRejection_=handler;};goog.Promise.CancellationError=function(opt_message){goog.debug.Error.call(this,opt_message);};goog.inherits(goog.Promise.CancellationError,goog.debug.Error);goog.Promise.CancellationError.prototype.name="cancel";goog.Promise.Resolver_=function(promise,resolve,reject){this.promise=promise;this.resolve=resolve;this.reject=reject;};/*\n Portions of this code are from MochiKit, received by\n The Closure Authors under the MIT license. All other code is Copyright\n 2005-2009 The Closure Authors. All Rights Reserved.\n */goog.async.Deferred=function(opt_onCancelFunction,opt_defaultScope){this.sequence_=[];this.onCancelFunction_=opt_onCancelFunction;this.defaultScope_=opt_defaultScope||null;this.hadError_=this.fired_=!1;this.result_=void 0;this.silentlyCanceled_=this.blocking_=this.blocked_=!1;this.unhandledErrorId_=0;this.parent_=null;this.branches_=0;if(goog.async.Deferred.LONG_STACK_TRACES&&(this.constructorStack_=null,Error.captureStackTrace)){var target={stack:""};Error.captureStackTrace(target,goog.async.Deferred);"string"==typeof target.stack&&(this.constructorStack_=target.stack.replace(/^[^\\n]*\\n/,""));}};goog.async.Deferred.STRICT_ERRORS=!1;goog.async.Deferred.LONG_STACK_TRACES=!1;goog.async.Deferred.prototype.cancel=function(opt_deepCancel){if(this.hasFired()){this.result_ instanceof goog.async.Deferred&&this.result_.cancel();}else{if(this.parent_){var parent=this.parent_;delete this.parent_;opt_deepCancel?parent.cancel(opt_deepCancel):parent.branchCancel_();}this.onCancelFunction_?this.onCancelFunction_.call(this.defaultScope_,this):this.silentlyCanceled_=!0;this.hasFired()||this.errback(new goog.async.Deferred.CanceledError(this));}};goog.async.Deferred.prototype.branchCancel_=function(){this.branches_--;0>=this.branches_&&this.cancel();};goog.async.Deferred.prototype.continue_=function(isSuccess,res){this.blocked_=!1;this.updateResult_(isSuccess,res);};goog.async.Deferred.prototype.updateResult_=function(isSuccess,res){this.fired_=!0;this.result_=res;this.hadError_=!isSuccess;this.fire_();};goog.async.Deferred.prototype.check_=function(){if(this.hasFired()){if(!this.silentlyCanceled_){throw new goog.async.Deferred.AlreadyCalledError(this);}this.silentlyCanceled_=!1;}};goog.async.Deferred.prototype.callback=function(opt_result){this.check_();this.assertNotDeferred_(opt_result);this.updateResult_(!0,opt_result);};goog.async.Deferred.prototype.errback=function(opt_result){this.check_();this.assertNotDeferred_(opt_result);this.makeStackTraceLong_(opt_result);this.updateResult_(!1,opt_result);};goog.async.Deferred.prototype.makeStackTraceLong_=function(error){goog.async.Deferred.LONG_STACK_TRACES&&this.constructorStack_&&goog.isObject(error)&&error.stack&&/^[^\\n]+(\\n   [^\\n]+)+/.test(error.stack)&&(error.stack=error.stack+"\\nDEFERRED OPERATION:\\n"+this.constructorStack_);};goog.async.Deferred.prototype.assertNotDeferred_=function(obj){goog.asserts.assert(!(obj instanceof goog.async.Deferred),"An execution sequence may not be initiated with a blocking Deferred.");};goog.async.Deferred.prototype.addCallback=function(cb,opt_scope){return this.addCallbacks(cb,null,opt_scope);};goog.async.Deferred.prototype.addErrback=function(eb,opt_scope){return this.addCallbacks(null,eb,opt_scope);};goog.async.Deferred.prototype.addBoth=function(f,opt_scope){return this.addCallbacks(f,f,opt_scope);};goog.async.Deferred.prototype.addFinally=function(f,opt_scope){return this.addCallbacks(f,function(err){var result=f.call(this,err);if(!goog.isDef(result)){throw err;}return result;},opt_scope);};goog.async.Deferred.prototype.addCallbacks=function(cb,eb,opt_scope){goog.asserts.assert(!this.blocking_,"Blocking Deferreds can not be re-used");this.sequence_.push([cb,eb,opt_scope]);this.hasFired()&&this.fire_();return this;};goog.async.Deferred.prototype.then=function(opt_onFulfilled,opt_onRejected,opt_context){var resolve,reject,promise=new goog.Promise(function(res,rej){resolve=res;reject=rej;});this.addCallbacks(resolve,function(reason){reason instanceof goog.async.Deferred.CanceledError?promise.cancel():reject(reason);});return promise.then(opt_onFulfilled,opt_onRejected,opt_context);};goog.Thenable.addImplementation(goog.async.Deferred);goog.async.Deferred.prototype.chainDeferred=function(otherDeferred){this.addCallbacks(otherDeferred.callback,otherDeferred.errback,otherDeferred);return this;};goog.async.Deferred.prototype.awaitDeferred=function(otherDeferred){return otherDeferred instanceof goog.async.Deferred?this.addCallback(goog.bind(otherDeferred.branch,otherDeferred)):this.addCallback(function(){return otherDeferred;});};goog.async.Deferred.prototype.branch=function(opt_propagateCancel){var d=new goog.async.Deferred();this.chainDeferred(d);opt_propagateCancel&&(d.parent_=this,this.branches_++);return d;};goog.async.Deferred.prototype.hasFired=function(){return this.fired_;};goog.async.Deferred.prototype.isError=function(res){return res instanceof Error;};goog.async.Deferred.prototype.hasErrback_=function(){return goog.array.some(this.sequence_,function(sequenceRow){return goog.isFunction(sequenceRow[1]);});};goog.async.Deferred.prototype.fire_=function(){this.unhandledErrorId_&&this.hasFired()&&this.hasErrback_()&&(goog.async.Deferred.unscheduleError_(this.unhandledErrorId_),this.unhandledErrorId_=0);this.parent_&&(this.parent_.branches_--,delete this.parent_);for(var res=this.result_,unhandledException=!1,isNewlyBlocked=!1;this.sequence_.length&&!this.blocked_;){var sequenceEntry=this.sequence_.shift(),callback=sequenceEntry[0],errback=sequenceEntry[1],scope=sequenceEntry[2],f=this.hadError_?errback:callback;if(f){try{var ret=f.call(scope||this.defaultScope_,res);goog.isDef(ret)&&(this.hadError_=this.hadError_&&(ret==res||this.isError(ret)),this.result_=res=ret);if(goog.Thenable.isImplementedBy(res)||"function"===typeof goog.global.Promise&&res instanceof goog.global.Promise){this.blocked_=isNewlyBlocked=!0;}}catch(ex){res=ex,this.hadError_=!0,this.makeStackTraceLong_(res),this.hasErrback_()||(unhandledException=!0);}}}this.result_=res;if(isNewlyBlocked){var onCallback=goog.bind(this.continue_,this,!0),onErrback=goog.bind(this.continue_,this,!1);res instanceof goog.async.Deferred?(res.addCallbacks(onCallback,onErrback),res.blocking_=!0):res.then(onCallback,onErrback);}else{!goog.async.Deferred.STRICT_ERRORS||!this.isError(res)||res instanceof goog.async.Deferred.CanceledError||(unhandledException=this.hadError_=!0);}unhandledException&&(this.unhandledErrorId_=goog.async.Deferred.scheduleError_(res));};goog.async.Deferred.succeed=function(opt_result){var d=new goog.async.Deferred();d.callback(opt_result);return d;};goog.async.Deferred.fromPromise=function(promise){var d=new goog.async.Deferred();d.callback();d.addCallback(function(){return promise;});return d;};goog.async.Deferred.fail=function(res){var d=new goog.async.Deferred();d.errback(res);return d;};goog.async.Deferred.canceled=function(){var d=new goog.async.Deferred();d.cancel();return d;};goog.async.Deferred.when=function(value,callback,opt_scope){return value instanceof goog.async.Deferred?value.branch(!0).addCallback(callback,opt_scope):goog.async.Deferred.succeed(value).addCallback(callback,opt_scope);};goog.async.Deferred.AlreadyCalledError=function(deferred){goog.debug.Error.call(this);this.deferred=deferred;};goog.inherits(goog.async.Deferred.AlreadyCalledError,goog.debug.Error);goog.async.Deferred.AlreadyCalledError.prototype.message="Deferred has already fired";goog.async.Deferred.AlreadyCalledError.prototype.name="AlreadyCalledError";goog.async.Deferred.CanceledError=function(deferred){goog.debug.Error.call(this);this.deferred=deferred;};goog.inherits(goog.async.Deferred.CanceledError,goog.debug.Error);goog.async.Deferred.CanceledError.prototype.message="Deferred was canceled";goog.async.Deferred.CanceledError.prototype.name="CanceledError";goog.async.Deferred.Error_=function(error){this.id_=goog.global.setTimeout(goog.bind(this.throwError,this),0);this.error_=error;};goog.async.Deferred.Error_.prototype.throwError=function(){goog.asserts.assert(goog.async.Deferred.errorMap_[this.id_],"Cannot throw an error that is not scheduled.");delete goog.async.Deferred.errorMap_[this.id_];throw this.error_;};goog.async.Deferred.Error_.prototype.resetTimer=function(){goog.global.clearTimeout(this.id_);};goog.async.Deferred.errorMap_={};goog.async.Deferred.scheduleError_=function(error){var deferredError=new goog.async.Deferred.Error_(error);goog.async.Deferred.errorMap_[deferredError.id_]=deferredError;return deferredError.id_;};goog.async.Deferred.unscheduleError_=function(id){var error=goog.async.Deferred.errorMap_[id];error&&(error.resetTimer(),delete goog.async.Deferred.errorMap_[id]);};goog.async.Deferred.assertNoErrors=function(){var map=goog.async.Deferred.errorMap_,key;for(key in map){var error=map[key];error.resetTimer();error.throwError();}};goog.fs.FileReader=function(){goog.events.EventTarget.call(this);this.reader_=new FileReader();this.reader_.onloadstart=goog.bind(this.dispatchProgressEvent_,this);this.reader_.onprogress=goog.bind(this.dispatchProgressEvent_,this);this.reader_.onload=goog.bind(this.dispatchProgressEvent_,this);this.reader_.onabort=goog.bind(this.dispatchProgressEvent_,this);this.reader_.onerror=goog.bind(this.dispatchProgressEvent_,this);this.reader_.onloadend=goog.bind(this.dispatchProgressEvent_,this);};goog.inherits(goog.fs.FileReader,goog.events.EventTarget);goog.fs.FileReader.ReadyState={INIT:0,LOADING:1,DONE:2};goog.fs.FileReader.EventType={LOAD_START:"loadstart",PROGRESS:"progress",LOAD:"load",ABORT:"abort",ERROR:"error",LOAD_END:"loadend"};goog.fs.FileReader.prototype.abort=function(){try{this.reader_.abort();}catch(e){throw new goog.fs.Error(e,"aborting read");}};goog.fs.FileReader.prototype.getReadyState=function(){return this.reader_.readyState;};goog.fs.FileReader.prototype.getResult=function(){return this.reader_.result;};goog.fs.FileReader.prototype.getError=function(){return this.reader_.error&&new goog.fs.Error(this.reader_.error,"reading file");};goog.fs.FileReader.prototype.dispatchProgressEvent_=function(event){this.dispatchEvent(new goog.fs.ProgressEvent(event,this));};goog.fs.FileReader.prototype.disposeInternal=function(){goog.fs.FileReader.superClass_.disposeInternal.call(this);delete this.reader_;};goog.fs.FileReader.prototype.readAsBinaryString=function(blob){this.reader_.readAsBinaryString(blob);};goog.fs.FileReader.readAsBinaryString=function(blob){var reader=new goog.fs.FileReader(),d=goog.fs.FileReader.createDeferred_(reader);reader.readAsBinaryString(blob);return d;};goog.fs.FileReader.prototype.readAsArrayBuffer=function(blob){this.reader_.readAsArrayBuffer(blob);};goog.fs.FileReader.readAsArrayBuffer=function(blob){var reader=new goog.fs.FileReader(),d=goog.fs.FileReader.createDeferred_(reader);reader.readAsArrayBuffer(blob);return d;};goog.fs.FileReader.prototype.readAsText=function(blob,opt_encoding){this.reader_.readAsText(blob,opt_encoding);};goog.fs.FileReader.readAsText=function(blob,opt_encoding){var reader=new goog.fs.FileReader(),d=goog.fs.FileReader.createDeferred_(reader);reader.readAsText(blob,opt_encoding);return d;};goog.fs.FileReader.prototype.readAsDataUrl=function(blob){this.reader_.readAsDataURL(blob);};goog.fs.FileReader.readAsDataUrl=function(blob){var reader=new goog.fs.FileReader(),d=goog.fs.FileReader.createDeferred_(reader);reader.readAsDataUrl(blob);return d;};goog.fs.FileReader.createDeferred_=function(reader){var deferred=new goog.async.Deferred();reader.listen(goog.fs.FileReader.EventType.LOAD_END,goog.partial(function(d,r,e){var result=r.getResult(),error=r.getError();null==result||error?d.errback(error):d.callback(result);r.dispose();},deferred,reader));return deferred;};goog.net={};goog.net.EventType={COMPLETE:"complete",SUCCESS:"success",ERROR:"error",ABORT:"abort",READY:"ready",READY_STATE_CHANGE:"readystatechange",TIMEOUT:"timeout",INCREMENTAL_DATA:"incrementaldata",PROGRESS:"progress",DOWNLOAD_PROGRESS:"downloadprogress",UPLOAD_PROGRESS:"uploadprogress"};goog.net.HttpStatus={CONTINUE:100,SWITCHING_PROTOCOLS:101,OK:200,CREATED:201,ACCEPTED:202,NON_AUTHORITATIVE_INFORMATION:203,NO_CONTENT:204,RESET_CONTENT:205,PARTIAL_CONTENT:206,MULTIPLE_CHOICES:300,MOVED_PERMANENTLY:301,FOUND:302,SEE_OTHER:303,NOT_MODIFIED:304,USE_PROXY:305,TEMPORARY_REDIRECT:307,BAD_REQUEST:400,UNAUTHORIZED:401,PAYMENT_REQUIRED:402,FORBIDDEN:403,NOT_FOUND:404,METHOD_NOT_ALLOWED:405,NOT_ACCEPTABLE:406,PROXY_AUTHENTICATION_REQUIRED:407,REQUEST_TIMEOUT:408,CONFLICT:409,GONE:410,LENGTH_REQUIRED:411,PRECONDITION_FAILED:412,REQUEST_ENTITY_TOO_LARGE:413,REQUEST_URI_TOO_LONG:414,UNSUPPORTED_MEDIA_TYPE:415,REQUEST_RANGE_NOT_SATISFIABLE:416,EXPECTATION_FAILED:417,PRECONDITION_REQUIRED:428,TOO_MANY_REQUESTS:429,REQUEST_HEADER_FIELDS_TOO_LARGE:431,INTERNAL_SERVER_ERROR:500,NOT_IMPLEMENTED:501,BAD_GATEWAY:502,SERVICE_UNAVAILABLE:503,GATEWAY_TIMEOUT:504,HTTP_VERSION_NOT_SUPPORTED:505,NETWORK_AUTHENTICATION_REQUIRED:511,QUIRK_IE_NO_CONTENT:1223};goog.net.HttpStatus.isSuccess=function(status){switch(status){case goog.net.HttpStatus.OK:case goog.net.HttpStatus.CREATED:case goog.net.HttpStatus.ACCEPTED:case goog.net.HttpStatus.NO_CONTENT:case goog.net.HttpStatus.PARTIAL_CONTENT:case goog.net.HttpStatus.NOT_MODIFIED:case goog.net.HttpStatus.QUIRK_IE_NO_CONTENT:return!0;default:return!1;}};goog.debug.LOGGING_ENABLED=goog.DEBUG;goog.debug.FORCE_SLOPPY_STACKS=!1;goog.debug.catchErrors=function(logFunc,opt_cancel,opt_target){var target=opt_target||goog.global,oldErrorHandler=target.onerror,retVal=!!opt_cancel;goog.userAgent.WEBKIT&&!goog.userAgent.isVersionOrHigher("535.3")&&(retVal=!retVal);target.onerror=function(message,url,line,opt_col,opt_error){oldErrorHandler&&oldErrorHandler(message,url,line,opt_col,opt_error);logFunc({message:message,fileName:url,line:line,col:opt_col,error:opt_error});return retVal;};};goog.debug.expose=function(obj,opt_showFn){if("undefined"==typeof obj){return"undefined";}if(null==obj){return"NULL";}var str=[],x;for(x in obj){if(opt_showFn||!goog.isFunction(obj[x])){var s=x+" = ";try{s+=obj[x];}catch(e){s+="*** "+e+" ***";}str.push(s);}}return str.join("\\n");};goog.debug.deepExpose=function(obj$jscomp$0,opt_showFn){var str=[],uidsToCleanup=[],ancestorUids={},helper=function helper(obj,space){var nestspace=space+"  ";try{if(goog.isDef(obj)){if(goog.isNull(obj)){str.push("NULL");}else{if(goog.isString(obj)){str.push(\'"\'+obj.replace(/\\n/g,"\\n"+space)+\'"\');}else{if(goog.isFunction(obj)){str.push(String(obj).replace(/\\n/g,"\\n"+space));}else{if(goog.isObject(obj)){goog.hasUid(obj)||uidsToCleanup.push(obj);var uid=goog.getUid(obj);if(ancestorUids[uid]){str.push("*** reference loop detected (id="+uid+") ***");}else{ancestorUids[uid]=!0;str.push("{");for(var x in obj){if(opt_showFn||!goog.isFunction(obj[x])){str.push("\\n"),str.push(nestspace),str.push(x+" = "),helper(obj[x],nestspace);}}str.push("\\n"+space+"}");delete ancestorUids[uid];}}else{str.push(obj);}}}}}else{str.push("undefined");}}catch(e){str.push("*** "+e+" ***");}};helper(obj$jscomp$0,"");for(var i=0;i<uidsToCleanup.length;i++){goog.removeUid(uidsToCleanup[i]);}return str.join("");};goog.debug.exposeArray=function(arr){for(var str=[],i=0;i<arr.length;i++){goog.isArray(arr[i])?str.push(goog.debug.exposeArray(arr[i])):str.push(arr[i]);}return"[ "+str.join(", ")+" ]";};goog.debug.normalizeErrorObject=function(err){var href=goog.getObjectByName("window.location.href");if(goog.isString(err)){return{message:err,name:"Unknown error",lineNumber:"Not available",fileName:href,stack:"Not available"};}var threwError=!1;try{var lineNumber=err.lineNumber||err.line||"Not available";}catch(e){lineNumber="Not available",threwError=!0;}try{var fileName=err.fileName||err.filename||err.sourceURL||goog.global.$googDebugFname||href;}catch(e$0){fileName="Not available",threwError=!0;}return!threwError&&err.lineNumber&&err.fileName&&err.stack&&err.message&&err.name?err:{message:err.message||"Not available",name:err.name||"UnknownError",lineNumber:lineNumber,fileName:fileName,stack:err.stack||"Not available"};};goog.debug.enhanceError=function(err,opt_message){if(err instanceof Error){var error=err;}else{error=Error(err),Error.captureStackTrace&&Error.captureStackTrace(error,goog.debug.enhanceError);}error.stack||(error.stack=goog.debug.getStacktrace(goog.debug.enhanceError));if(opt_message){for(var x=0;error["message"+x];){++x;}error["message"+x]=String(opt_message);}return error;};goog.debug.getStacktraceSimple=function(opt_depth){if(!goog.debug.FORCE_SLOPPY_STACKS){var stack=goog.debug.getNativeStackTrace_(goog.debug.getStacktraceSimple);if(stack){return stack;}}for(var sb=[],fn=arguments.callee.caller,depth=0;fn&&(!opt_depth||depth<opt_depth);){sb.push(goog.debug.getFunctionName(fn));sb.push("()\\n");try{fn=fn.caller;}catch(e){sb.push("[exception trying to get caller]\\n");break;}depth++;if(depth>=goog.debug.MAX_STACK_DEPTH){sb.push("[...long stack...]");break;}}opt_depth&&depth>=opt_depth?sb.push("[...reached max depth limit...]"):sb.push("[end]");return sb.join("");};goog.debug.MAX_STACK_DEPTH=50;goog.debug.getNativeStackTrace_=function(fn){var tempErr=Error();if(Error.captureStackTrace){return Error.captureStackTrace(tempErr,fn),String(tempErr.stack);}try{throw tempErr;}catch(e){tempErr=e;}var stack=tempErr.stack;return stack?String(stack):null;};goog.debug.getStacktrace=function(fn){var stack;goog.debug.FORCE_SLOPPY_STACKS||(stack=goog.debug.getNativeStackTrace_(fn||goog.debug.getStacktrace));stack||(stack=goog.debug.getStacktraceHelper_(fn||arguments.callee.caller,[]));return stack;};goog.debug.getStacktraceHelper_=function(fn,visited){var sb=[];if(goog.array.contains(visited,fn)){sb.push("[...circular reference...]");}else{if(fn&&visited.length<goog.debug.MAX_STACK_DEPTH){sb.push(goog.debug.getFunctionName(fn)+"(");for(var args=fn.arguments,i=0;args&&i<args.length;i++){0<i&&sb.push(", ");var arg=args[i];switch(typeof arg==="undefined"?"undefined":_typeof(arg)){case"object":var argDesc=arg?"object":"null";break;case"string":argDesc=arg;break;case"number":argDesc=String(arg);break;case"boolean":argDesc=arg?"true":"false";break;case"function":argDesc=(argDesc=goog.debug.getFunctionName(arg))?argDesc:"[fn]";break;default:argDesc=typeof arg==="undefined"?"undefined":_typeof(arg);}40<argDesc.length&&(argDesc=argDesc.substr(0,40)+"...");sb.push(argDesc);}visited.push(fn);sb.push(")\\n");try{sb.push(goog.debug.getStacktraceHelper_(fn.caller,visited));}catch(e){sb.push("[exception trying to get caller]\\n");}}else{fn?sb.push("[...long stack...]"):sb.push("[end]");}}return sb.join("");};goog.debug.setFunctionResolver=function(resolver){goog.debug.fnNameResolver_=resolver;};goog.debug.getFunctionName=function(fn){if(goog.debug.fnNameCache_[fn]){return goog.debug.fnNameCache_[fn];}if(goog.debug.fnNameResolver_){var name=goog.debug.fnNameResolver_(fn);if(name){return goog.debug.fnNameCache_[fn]=name;}}var functionSource=String(fn);if(!goog.debug.fnNameCache_[functionSource]){var matches=/function ([^\\(]+)/.exec(functionSource);goog.debug.fnNameCache_[functionSource]=matches?matches[1]:"[Anonymous]";}return goog.debug.fnNameCache_[functionSource];};goog.debug.makeWhitespaceVisible=function(string){return string.replace(/ /g,"[_]").replace(/\\f/g,"[f]").replace(/\\n/g,"[n]\\n").replace(/\\r/g,"[r]").replace(/\\t/g,"[t]");};goog.debug.runtimeType=function(value){return value instanceof Function?value.displayName||value.name||"unknown type name":value instanceof Object?value.constructor.displayName||value.constructor.name||Object.prototype.toString.call(value):null===value?"null":typeof value==="undefined"?"undefined":_typeof(value);};goog.debug.fnNameCache_={};goog.debug.LogRecord=function(level,msg,loggerName,opt_time,opt_sequenceNumber){this.reset(level,msg,loggerName,opt_time,opt_sequenceNumber);};goog.debug.LogRecord.prototype.sequenceNumber_=0;goog.debug.LogRecord.prototype.exception_=null;goog.debug.LogRecord.ENABLE_SEQUENCE_NUMBERS=!0;goog.debug.LogRecord.nextSequenceNumber_=0;goog.debug.LogRecord.prototype.reset=function(level,msg,loggerName,opt_time,opt_sequenceNumber){goog.debug.LogRecord.ENABLE_SEQUENCE_NUMBERS&&(this.sequenceNumber_="number"==typeof opt_sequenceNumber?opt_sequenceNumber:goog.debug.LogRecord.nextSequenceNumber_++);this.time_=opt_time||goog.now();this.level_=level;this.msg_=msg;this.loggerName_=loggerName;delete this.exception_;};goog.debug.LogRecord.prototype.getLoggerName=function(){return this.loggerName_;};goog.debug.LogRecord.prototype.getException=function(){return this.exception_;};goog.debug.LogRecord.prototype.setException=function(exception){this.exception_=exception;};goog.debug.LogRecord.prototype.setLoggerName=function(loggerName){this.loggerName_=loggerName;};goog.debug.LogRecord.prototype.getLevel=function(){return this.level_;};goog.debug.LogRecord.prototype.setLevel=function(level){this.level_=level;};goog.debug.LogRecord.prototype.getMessage=function(){return this.msg_;};goog.debug.LogRecord.prototype.setMessage=function(msg){this.msg_=msg;};goog.debug.LogRecord.prototype.getMillis=function(){return this.time_;};goog.debug.LogRecord.prototype.setMillis=function(time){this.time_=time;};goog.debug.LogRecord.prototype.getSequenceNumber=function(){return this.sequenceNumber_;};goog.debug.LogBuffer=function(){goog.asserts.assert(goog.debug.LogBuffer.isBufferingEnabled(),"Cannot use goog.debug.LogBuffer without defining goog.debug.LogBuffer.CAPACITY.");this.clear();};goog.debug.LogBuffer.getInstance=function(){goog.debug.LogBuffer.instance_||(goog.debug.LogBuffer.instance_=new goog.debug.LogBuffer());return goog.debug.LogBuffer.instance_;};goog.debug.LogBuffer.CAPACITY=0;goog.debug.LogBuffer.prototype.addRecord=function(level,msg,loggerName){var curIndex=(this.curIndex_+1)%goog.debug.LogBuffer.CAPACITY;this.curIndex_=curIndex;if(this.isFull_){var ret=this.buffer_[curIndex];ret.reset(level,msg,loggerName);return ret;}this.isFull_=curIndex==goog.debug.LogBuffer.CAPACITY-1;return this.buffer_[curIndex]=new goog.debug.LogRecord(level,msg,loggerName);};goog.debug.LogBuffer.isBufferingEnabled=function(){return 0<goog.debug.LogBuffer.CAPACITY;};goog.debug.LogBuffer.prototype.clear=function(){this.buffer_=Array(goog.debug.LogBuffer.CAPACITY);this.curIndex_=-1;this.isFull_=!1;};goog.debug.LogBuffer.prototype.forEachRecord=function(func){var buffer=this.buffer_;if(buffer[0]){var curIndex=this.curIndex_,i=this.isFull_?curIndex:-1;do{i=(i+1)%goog.debug.LogBuffer.CAPACITY,func(buffer[i]);}while(i!=curIndex);}};goog.debug.Logger=function(name){this.name_=name;this.handlers_=this.children_=this.level_=this.parent_=null;};goog.debug.Logger.ROOT_LOGGER_NAME="";goog.debug.Logger.ENABLE_HIERARCHY=!0;goog.debug.Logger.ENABLE_HIERARCHY||(goog.debug.Logger.rootHandlers_=[]);goog.debug.Logger.Level=function(name,value){this.name=name;this.value=value;};goog.debug.Logger.Level.prototype.toString=function(){return this.name;};goog.debug.Logger.Level.OFF=new goog.debug.Logger.Level("OFF",Infinity);goog.debug.Logger.Level.SHOUT=new goog.debug.Logger.Level("SHOUT",1200);goog.debug.Logger.Level.SEVERE=new goog.debug.Logger.Level("SEVERE",1000);goog.debug.Logger.Level.WARNING=new goog.debug.Logger.Level("WARNING",900);goog.debug.Logger.Level.INFO=new goog.debug.Logger.Level("INFO",800);goog.debug.Logger.Level.CONFIG=new goog.debug.Logger.Level("CONFIG",700);goog.debug.Logger.Level.FINE=new goog.debug.Logger.Level("FINE",500);goog.debug.Logger.Level.FINER=new goog.debug.Logger.Level("FINER",400);goog.debug.Logger.Level.FINEST=new goog.debug.Logger.Level("FINEST",300);goog.debug.Logger.Level.ALL=new goog.debug.Logger.Level("ALL",0);goog.debug.Logger.Level.PREDEFINED_LEVELS=[goog.debug.Logger.Level.OFF,goog.debug.Logger.Level.SHOUT,goog.debug.Logger.Level.SEVERE,goog.debug.Logger.Level.WARNING,goog.debug.Logger.Level.INFO,goog.debug.Logger.Level.CONFIG,goog.debug.Logger.Level.FINE,goog.debug.Logger.Level.FINER,goog.debug.Logger.Level.FINEST,goog.debug.Logger.Level.ALL];goog.debug.Logger.Level.predefinedLevelsCache_=null;goog.debug.Logger.Level.createPredefinedLevelsCache_=function(){goog.debug.Logger.Level.predefinedLevelsCache_={};for(var i=0,level;level=goog.debug.Logger.Level.PREDEFINED_LEVELS[i];i++){goog.debug.Logger.Level.predefinedLevelsCache_[level.value]=level,goog.debug.Logger.Level.predefinedLevelsCache_[level.name]=level;}};goog.debug.Logger.Level.getPredefinedLevel=function(name){goog.debug.Logger.Level.predefinedLevelsCache_||goog.debug.Logger.Level.createPredefinedLevelsCache_();return goog.debug.Logger.Level.predefinedLevelsCache_[name]||null;};goog.debug.Logger.Level.getPredefinedLevelByValue=function(value){goog.debug.Logger.Level.predefinedLevelsCache_||goog.debug.Logger.Level.createPredefinedLevelsCache_();if(value in goog.debug.Logger.Level.predefinedLevelsCache_){return goog.debug.Logger.Level.predefinedLevelsCache_[value];}for(var i=0;i<goog.debug.Logger.Level.PREDEFINED_LEVELS.length;++i){var level=goog.debug.Logger.Level.PREDEFINED_LEVELS[i];if(level.value<=value){return level;}}return null;};goog.debug.Logger.getLogger=function(name){return goog.debug.LogManager.getLogger(name);};goog.debug.Logger.logToProfilers=function(msg){goog.global.console&&(goog.global.console.timeStamp?goog.global.console.timeStamp(msg):goog.global.console.markTimeline&&goog.global.console.markTimeline(msg));goog.global.msWriteProfilerMark&&goog.global.msWriteProfilerMark(msg);};goog.debug.Logger.prototype.getName=function(){return this.name_;};goog.debug.Logger.prototype.addHandler=function(handler){goog.debug.LOGGING_ENABLED&&(goog.debug.Logger.ENABLE_HIERARCHY?(this.handlers_||(this.handlers_=[]),this.handlers_.push(handler)):(goog.asserts.assert(!this.name_,"Cannot call addHandler on a non-root logger when goog.debug.Logger.ENABLE_HIERARCHY is false."),goog.debug.Logger.rootHandlers_.push(handler)));};goog.debug.Logger.prototype.removeHandler=function(handler){if(goog.debug.LOGGING_ENABLED){var handlers=goog.debug.Logger.ENABLE_HIERARCHY?this.handlers_:goog.debug.Logger.rootHandlers_;return!!handlers&&goog.array.remove(handlers,handler);}return!1;};goog.debug.Logger.prototype.getParent=function(){return this.parent_;};goog.debug.Logger.prototype.getChildren=function(){this.children_||(this.children_={});return this.children_;};goog.debug.Logger.prototype.setLevel=function(level){goog.debug.LOGGING_ENABLED&&(goog.debug.Logger.ENABLE_HIERARCHY?this.level_=level:(goog.asserts.assert(!this.name_,"Cannot call setLevel() on a non-root logger when goog.debug.Logger.ENABLE_HIERARCHY is false."),goog.debug.Logger.rootLevel_=level));};goog.debug.Logger.prototype.getLevel=function(){return goog.debug.LOGGING_ENABLED?this.level_:goog.debug.Logger.Level.OFF;};goog.debug.Logger.prototype.getEffectiveLevel=function(){if(!goog.debug.LOGGING_ENABLED){return goog.debug.Logger.Level.OFF;}if(!goog.debug.Logger.ENABLE_HIERARCHY){return goog.debug.Logger.rootLevel_;}if(this.level_){return this.level_;}if(this.parent_){return this.parent_.getEffectiveLevel();}goog.asserts.fail("Root logger has no level set.");return null;};goog.debug.Logger.prototype.isLoggable=function(level){return goog.debug.LOGGING_ENABLED&&level.value>=this.getEffectiveLevel().value;};goog.debug.Logger.prototype.log=function(level,msg,opt_exception){goog.debug.LOGGING_ENABLED&&this.isLoggable(level)&&(goog.isFunction(msg)&&(msg=msg()),this.doLogRecord_(this.getLogRecord(level,msg,opt_exception)));};goog.debug.Logger.prototype.getLogRecord=function(level,msg,opt_exception){var logRecord=goog.debug.LogBuffer.isBufferingEnabled()?goog.debug.LogBuffer.getInstance().addRecord(level,msg,this.name_):new goog.debug.LogRecord(level,String(msg),this.name_);opt_exception&&logRecord.setException(opt_exception);return logRecord;};goog.debug.Logger.prototype.shout=function(msg,opt_exception){goog.debug.LOGGING_ENABLED&&this.log(goog.debug.Logger.Level.SHOUT,msg,opt_exception);};goog.debug.Logger.prototype.severe=function(msg,opt_exception){goog.debug.LOGGING_ENABLED&&this.log(goog.debug.Logger.Level.SEVERE,msg,opt_exception);};goog.debug.Logger.prototype.warning=function(msg,opt_exception){goog.debug.LOGGING_ENABLED&&this.log(goog.debug.Logger.Level.WARNING,msg,opt_exception);};goog.debug.Logger.prototype.info=function(msg,opt_exception){goog.debug.LOGGING_ENABLED&&this.log(goog.debug.Logger.Level.INFO,msg,opt_exception);};goog.debug.Logger.prototype.config=function(msg,opt_exception){goog.debug.LOGGING_ENABLED&&this.log(goog.debug.Logger.Level.CONFIG,msg,opt_exception);};goog.debug.Logger.prototype.fine=function(msg,opt_exception){goog.debug.LOGGING_ENABLED&&this.log(goog.debug.Logger.Level.FINE,msg,opt_exception);};goog.debug.Logger.prototype.finer=function(msg,opt_exception){goog.debug.LOGGING_ENABLED&&this.log(goog.debug.Logger.Level.FINER,msg,opt_exception);};goog.debug.Logger.prototype.finest=function(msg,opt_exception){goog.debug.LOGGING_ENABLED&&this.log(goog.debug.Logger.Level.FINEST,msg,opt_exception);};goog.debug.Logger.prototype.logRecord=function(logRecord){goog.debug.LOGGING_ENABLED&&this.isLoggable(logRecord.getLevel())&&this.doLogRecord_(logRecord);};goog.debug.Logger.prototype.doLogRecord_=function(logRecord){goog.debug.Logger.logToProfilers("log:"+logRecord.getMessage());if(goog.debug.Logger.ENABLE_HIERARCHY){for(var target=this;target;){target.callPublish_(logRecord),target=target.getParent();}}else{for(var i=0,handler;handler=goog.debug.Logger.rootHandlers_[i++];){handler(logRecord);}}};goog.debug.Logger.prototype.callPublish_=function(logRecord){if(this.handlers_){for(var i=0,handler;handler=this.handlers_[i];i++){handler(logRecord);}}};goog.debug.Logger.prototype.setParent_=function(parent){this.parent_=parent;};goog.debug.Logger.prototype.addChild_=function(name,logger){this.getChildren()[name]=logger;};goog.debug.LogManager={};goog.debug.LogManager.loggers_={};goog.debug.LogManager.rootLogger_=null;goog.debug.LogManager.initialize=function(){goog.debug.LogManager.rootLogger_||(goog.debug.LogManager.rootLogger_=new goog.debug.Logger(goog.debug.Logger.ROOT_LOGGER_NAME),goog.debug.LogManager.loggers_[goog.debug.Logger.ROOT_LOGGER_NAME]=goog.debug.LogManager.rootLogger_,goog.debug.LogManager.rootLogger_.setLevel(goog.debug.Logger.Level.CONFIG));};goog.debug.LogManager.getLoggers=function(){return goog.debug.LogManager.loggers_;};goog.debug.LogManager.getRoot=function(){goog.debug.LogManager.initialize();return goog.debug.LogManager.rootLogger_;};goog.debug.LogManager.getLogger=function(name){goog.debug.LogManager.initialize();return goog.debug.LogManager.loggers_[name]||goog.debug.LogManager.createLogger_(name);};goog.debug.LogManager.createFunctionForCatchErrors=function(opt_logger){return function(info){(opt_logger||goog.debug.LogManager.getRoot()).severe("Error: "+info.message+" ("+info.fileName+" @ Line: "+info.line+")");};};goog.debug.LogManager.createLogger_=function(name){var logger=new goog.debug.Logger(name);if(goog.debug.Logger.ENABLE_HIERARCHY){var lastDotIndex=name.lastIndexOf("."),leafName=name.substr(lastDotIndex+1),parentLogger=goog.debug.LogManager.getLogger(name.substr(0,lastDotIndex));parentLogger.addChild_(leafName,logger);logger.setParent_(parentLogger);}return goog.debug.LogManager.loggers_[name]=logger;};goog.math={};goog.math.randomInt=function(a){return Math.floor(Math.random()*a);};goog.math.uniformRandom=function(a,b){return a+Math.random()*(b-a);};goog.math.clamp=function(value,min,max){return Math.min(Math.max(value,min),max);};goog.math.modulo=function(a,b){var r=a%b;return 0>r*b?r+b:r;};goog.math.lerp=function(a,b,x){return a+x*(b-a);};goog.math.nearlyEquals=function(a,b,opt_tolerance){return Math.abs(a-b)<=(opt_tolerance||0.000001);};goog.math.standardAngle=function(angle){return goog.math.modulo(angle,360);};goog.math.standardAngleInRadians=function(angle){return goog.math.modulo(angle,2*Math.PI);};goog.math.toRadians=function(angleDegrees){return angleDegrees*Math.PI/180;};goog.math.toDegrees=function(angleRadians){return 180*angleRadians/Math.PI;};goog.math.angleDx=function(degrees,radius){return radius*Math.cos(goog.math.toRadians(degrees));};goog.math.angleDy=function(degrees,radius){return radius*Math.sin(goog.math.toRadians(degrees));};goog.math.angle=function(x1,y1,x2,y2){return goog.math.standardAngle(goog.math.toDegrees(Math.atan2(y2-y1,x2-x1)));};goog.math.angleDifference=function(startAngle,endAngle){var d=goog.math.standardAngle(endAngle)-goog.math.standardAngle(startAngle);180<d?d-=360:-180>=d&&(d=360+d);return d;};goog.math.sign=function(x){return 0<x?1:0>x?-1:x;};goog.math.longestCommonSubsequence=function(array1,array2,opt_compareFn,opt_collectorFn){for(var compare=opt_compareFn||function(a,b){return a==b;},collect=opt_collectorFn||function(i1,i2){return array1[i1];},length1=array1.length,length2=array2.length,arr=[],i=0;i<length1+1;i++){arr[i]=[],arr[i][0]=0;}for(var j=0;j<length2+1;j++){arr[0][j]=0;}for(i=1;i<=length1;i++){for(j=1;j<=length2;j++){compare(array1[i-1],array2[j-1])?arr[i][j]=arr[i-1][j-1]+1:arr[i][j]=Math.max(arr[i-1][j],arr[i][j-1]);}}for(var result=[],i=length1,j=length2;0<i&&0<j;){compare(array1[i-1],array2[j-1])?(result.unshift(collect(i-1,j-1)),i--,j--):arr[i-1][j]>arr[i][j-1]?i--:j--;}return result;};goog.math.sum=function(var_args){return goog.array.reduce(arguments,function(sum,value){return sum+value;},0);};goog.math.average=function(var_args){return goog.math.sum.apply(null,arguments)/arguments.length;};goog.math.sampleVariance=function(var_args){var sampleSize=arguments.length;if(2>sampleSize){return 0;}var mean=goog.math.average.apply(null,arguments);return goog.math.sum.apply(null,goog.array.map(arguments,function(val){return Math.pow(val-mean,2);}))/(sampleSize-1);};goog.math.standardDeviation=function(var_args){return Math.sqrt(goog.math.sampleVariance.apply(null,arguments));};goog.math.isInt=function(num){return isFinite(num)&&0==num%1;};goog.math.isFiniteNumber=function(num){return isFinite(num);};goog.math.isNegativeZero=function(num){return 0==num&&0>1/num;};goog.math.log10Floor=function(num){if(0<num){var x=Math.round(Math.log(num)*Math.LOG10E);return x-(parseFloat("1e"+x)>num?1:0);}return 0==num?-Infinity:NaN;};goog.math.safeFloor=function(num,opt_epsilon){goog.asserts.assert(!goog.isDef(opt_epsilon)||0<opt_epsilon);return Math.floor(num+(opt_epsilon||2e-15));};goog.math.safeCeil=function(num,opt_epsilon){goog.asserts.assert(!goog.isDef(opt_epsilon)||0<opt_epsilon);return Math.ceil(num-(opt_epsilon||2e-15));};goog.iter={};goog.iter.StopIteration="StopIteration"in goog.global?goog.global.StopIteration:{message:"StopIteration",stack:""};goog.iter.Iterator=function(){};goog.iter.Iterator.prototype.next=function(){throw goog.iter.StopIteration;};goog.iter.Iterator.prototype.__iterator__=function(opt_keys){return this;};goog.iter.toIterator=function(iterable){if(iterable instanceof goog.iter.Iterator){return iterable;}if("function"==typeof iterable.__iterator__){return iterable.__iterator__(!1);}if(goog.isArrayLike(iterable)){var i=0,newIter=new goog.iter.Iterator();newIter.next=function(){for(;;){if(i>=iterable.length){throw goog.iter.StopIteration;}if(i in iterable){return iterable[i++];}i++;}};return newIter;}throw Error("Not implemented");};goog.iter.forEach=function(iterable,f,opt_obj){if(goog.isArrayLike(iterable)){try{goog.array.forEach(iterable,f,opt_obj);}catch(ex){if(ex!==goog.iter.StopIteration){throw ex;}}}else{iterable=goog.iter.toIterator(iterable);try{for(;;){f.call(opt_obj,iterable.next(),void 0,iterable);}}catch(ex$1){if(ex$1!==goog.iter.StopIteration){throw ex$1;}}}};goog.iter.filter=function(iterable,f,opt_obj){var iterator=goog.iter.toIterator(iterable),newIter=new goog.iter.Iterator();newIter.next=function(){for(;;){var val=iterator.next();if(f.call(opt_obj,val,void 0,iterator)){return val;}}};return newIter;};goog.iter.filterFalse=function(iterable,f,opt_obj){return goog.iter.filter(iterable,goog.functions.not(f),opt_obj);};goog.iter.range=function(startOrStop,opt_stop,opt_step){var start=0,stop=startOrStop,step=opt_step||1;1<arguments.length&&(start=startOrStop,stop=opt_stop);if(0==step){throw Error("Range step argument must not be zero");}var newIter=new goog.iter.Iterator();newIter.next=function(){if(0<step&&start>=stop||0>step&&start<=stop){throw goog.iter.StopIteration;}var rv=start;start+=step;return rv;};return newIter;};goog.iter.join=function(iterable,deliminator){return goog.iter.toArray(iterable).join(deliminator);};goog.iter.map=function(iterable,f,opt_obj){var iterator=goog.iter.toIterator(iterable),newIter=new goog.iter.Iterator();newIter.next=function(){var val=iterator.next();return f.call(opt_obj,val,void 0,iterator);};return newIter;};goog.iter.reduce=function(iterable,f,val$jscomp$0,opt_obj){var rval=val$jscomp$0;goog.iter.forEach(iterable,function(val){rval=f.call(opt_obj,rval,val);});return rval;};goog.iter.some=function(iterable,f,opt_obj){iterable=goog.iter.toIterator(iterable);try{for(;;){if(f.call(opt_obj,iterable.next(),void 0,iterable)){return!0;}}}catch(ex){if(ex!==goog.iter.StopIteration){throw ex;}}return!1;};goog.iter.every=function(iterable,f,opt_obj){iterable=goog.iter.toIterator(iterable);try{for(;;){if(!f.call(opt_obj,iterable.next(),void 0,iterable)){return!1;}}}catch(ex){if(ex!==goog.iter.StopIteration){throw ex;}}return!0;};goog.iter.chain=function(var_args){return goog.iter.chainFromIterable(arguments);};goog.iter.chainFromIterable=function(iterable){var iterator=goog.iter.toIterator(iterable),iter=new goog.iter.Iterator(),current=null;iter.next=function(){for(;;){if(null==current){var it=iterator.next();current=goog.iter.toIterator(it);}try{return current.next();}catch(ex){if(ex!==goog.iter.StopIteration){throw ex;}current=null;}}};return iter;};goog.iter.dropWhile=function(iterable,f,opt_obj){var iterator=goog.iter.toIterator(iterable),newIter=new goog.iter.Iterator(),dropping=!0;newIter.next=function(){for(;;){var val=iterator.next();if(!dropping||!f.call(opt_obj,val,void 0,iterator)){return dropping=!1,val;}}};return newIter;};goog.iter.takeWhile=function(iterable,f,opt_obj){var iterator=goog.iter.toIterator(iterable),iter=new goog.iter.Iterator();iter.next=function(){var val=iterator.next();if(f.call(opt_obj,val,void 0,iterator)){return val;}throw goog.iter.StopIteration;};return iter;};goog.iter.toArray=function(iterable){if(goog.isArrayLike(iterable)){return goog.array.toArray(iterable);}iterable=goog.iter.toIterator(iterable);var array=[];goog.iter.forEach(iterable,function(val){array.push(val);});return array;};goog.iter.equals=function(iterable1,iterable2,opt_equalsFn){var pairs=goog.iter.zipLongest({},iterable1,iterable2),equalsFn=opt_equalsFn||goog.array.defaultCompareEquality;return goog.iter.every(pairs,function(pair){return equalsFn(pair[0],pair[1]);});};goog.iter.nextOrValue=function(iterable,defaultValue){try{return goog.iter.toIterator(iterable).next();}catch(e){if(e!=goog.iter.StopIteration){throw e;}return defaultValue;}};goog.iter.product=function(var_args){if(goog.array.some(arguments,function(arr){return!arr.length;})||!arguments.length){return new goog.iter.Iterator();}var iter=new goog.iter.Iterator(),arrays=arguments,indicies=goog.array.repeat(0,arrays.length);iter.next=function(){if(indicies){for(var retVal=goog.array.map(indicies,function(valueIndex,arrayIndex){return arrays[arrayIndex][valueIndex];}),i=indicies.length-1;0<=i;i--){goog.asserts.assert(indicies);if(indicies[i]<arrays[i].length-1){indicies[i]++;break;}if(0==i){indicies=null;break;}indicies[i]=0;}return retVal;}throw goog.iter.StopIteration;};return iter;};goog.iter.cycle=function(iterable){var baseIterator=goog.iter.toIterator(iterable),cache=[],cacheIndex=0,iter=new goog.iter.Iterator(),useCache=!1;iter.next=function(){var returnElement=null;if(!useCache){try{return returnElement=baseIterator.next(),cache.push(returnElement),returnElement;}catch(e){if(e!=goog.iter.StopIteration||goog.array.isEmpty(cache)){throw e;}useCache=!0;}}returnElement=cache[cacheIndex];cacheIndex=(cacheIndex+1)%cache.length;return returnElement;};return iter;};goog.iter.count=function(opt_start,opt_step){var counter=opt_start||0,step=goog.isDef(opt_step)?opt_step:1,iter=new goog.iter.Iterator();iter.next=function(){var returnValue=counter;counter+=step;return returnValue;};return iter;};goog.iter.repeat=function(value){var iter=new goog.iter.Iterator();iter.next=goog.functions.constant(value);return iter;};goog.iter.accumulate=function(iterable){var iterator=goog.iter.toIterator(iterable),total=0,iter=new goog.iter.Iterator();iter.next=function(){return total+=iterator.next();};return iter;};goog.iter.zip=function(var_args){var args=arguments,iter=new goog.iter.Iterator();if(0<args.length){var iterators=goog.array.map(args,goog.iter.toIterator);iter.next=function(){return goog.array.map(iterators,function(it){return it.next();});};}return iter;};goog.iter.zipLongest=function(fillValue,var_args){var args=goog.array.slice(arguments,1),iter=new goog.iter.Iterator();if(0<args.length){var iterators=goog.array.map(args,goog.iter.toIterator);iter.next=function(){var iteratorsHaveValues=!1,arr=goog.array.map(iterators,function(it){try{var returnValue=it.next();iteratorsHaveValues=!0;}catch(ex){if(ex!==goog.iter.StopIteration){throw ex;}returnValue=fillValue;}return returnValue;});if(!iteratorsHaveValues){throw goog.iter.StopIteration;}return arr;};}return iter;};goog.iter.compress=function(iterable,selectors){var selectorIterator=goog.iter.toIterator(selectors);return goog.iter.filter(iterable,function(){return!!selectorIterator.next();});};goog.iter.GroupByIterator_=function(iterable,opt_keyFunc){this.iterator=goog.iter.toIterator(iterable);this.keyFunc=opt_keyFunc||goog.functions.identity;};goog.inherits(goog.iter.GroupByIterator_,goog.iter.Iterator);goog.iter.GroupByIterator_.prototype.next=function(){for(;this.currentKey==this.targetKey;){this.currentValue=this.iterator.next(),this.currentKey=this.keyFunc(this.currentValue);}this.targetKey=this.currentKey;return[this.currentKey,this.groupItems_(this.targetKey)];};goog.iter.GroupByIterator_.prototype.groupItems_=function(targetKey){for(var arr=[];this.currentKey==targetKey;){arr.push(this.currentValue);try{this.currentValue=this.iterator.next();}catch(ex){if(ex!==goog.iter.StopIteration){throw ex;}break;}this.currentKey=this.keyFunc(this.currentValue);}return arr;};goog.iter.groupBy=function(iterable,opt_keyFunc){return new goog.iter.GroupByIterator_(iterable,opt_keyFunc);};goog.iter.starMap=function(iterable,f,opt_obj){var iterator=goog.iter.toIterator(iterable),iter=new goog.iter.Iterator();iter.next=function(){var args=goog.iter.toArray(iterator.next());return f.apply(opt_obj,goog.array.concat(args,void 0,iterator));};return iter;};goog.iter.tee=function(iterable,opt_num){var iterator=goog.iter.toIterator(iterable),num=goog.isNumber(opt_num)?opt_num:2,buffers=goog.array.map(goog.array.range(num),function(){return[];}),addNextIteratorValueToBuffers=function addNextIteratorValueToBuffers(){var val=iterator.next();goog.array.forEach(buffers,function(buffer){buffer.push(val);});};return goog.array.map(buffers,function(buffer){var iter=new goog.iter.Iterator();iter.next=function(){goog.array.isEmpty(buffer)&&addNextIteratorValueToBuffers();goog.asserts.assert(!goog.array.isEmpty(buffer));return buffer.shift();};return iter;});};goog.iter.enumerate=function(iterable,opt_start){return goog.iter.zip(goog.iter.count(opt_start),iterable);};goog.iter.limit=function(iterable,limitSize){goog.asserts.assert(goog.math.isInt(limitSize)&&0<=limitSize);var iterator=goog.iter.toIterator(iterable),iter=new goog.iter.Iterator(),remaining=limitSize;iter.next=function(){if(0<remaining--){return iterator.next();}throw goog.iter.StopIteration;};return iter;};goog.iter.consume=function(iterable,count){goog.asserts.assert(goog.math.isInt(count)&&0<=count);for(var iterator=goog.iter.toIterator(iterable);0<count--;){goog.iter.nextOrValue(iterator,null);}return iterator;};goog.iter.slice=function(iterable,start,opt_end){goog.asserts.assert(goog.math.isInt(start)&&0<=start);var iterator=goog.iter.consume(iterable,start);goog.isNumber(opt_end)&&(goog.asserts.assert(goog.math.isInt(opt_end)&&opt_end>=start),iterator=goog.iter.limit(iterator,opt_end-start));return iterator;};goog.iter.hasDuplicates_=function(arr){var deduped=[];goog.array.removeDuplicates(arr,deduped);return arr.length!=deduped.length;};goog.iter.permutations=function(iterable,opt_length){var elements=goog.iter.toArray(iterable),length=goog.isNumber(opt_length)?opt_length:elements.length,sets=goog.array.repeat(elements,length),product=goog.iter.product.apply(void 0,sets);return goog.iter.filter(product,function(arr){return!goog.iter.hasDuplicates_(arr);});};goog.iter.combinations=function(iterable,length){function getIndexFromElements(index){return elements[index];}var elements=goog.iter.toArray(iterable),indexes=goog.iter.range(elements.length),indexIterator=goog.iter.permutations(indexes,length),sortedIndexIterator=goog.iter.filter(indexIterator,function(arr){return goog.array.isSorted(arr);}),iter=new goog.iter.Iterator();iter.next=function(){return goog.array.map(sortedIndexIterator.next(),getIndexFromElements);};return iter;};goog.iter.combinationsWithReplacement=function(iterable,length){function getIndexFromElements(index){return elements[index];}var elements=goog.iter.toArray(iterable),indexes=goog.array.range(elements.length),sets=goog.array.repeat(indexes,length),indexIterator=goog.iter.product.apply(void 0,sets),sortedIndexIterator=goog.iter.filter(indexIterator,function(arr){return goog.array.isSorted(arr);}),iter=new goog.iter.Iterator();iter.next=function(){return goog.array.map(sortedIndexIterator.next(),getIndexFromElements);};return iter;};goog.json={};goog.json.USE_NATIVE_JSON=!1;goog.json.TRY_NATIVE_JSON=!1;goog.json.isValid=function(s){return /^\\s*$/.test(s)?!1:/^[\\],:{}\\s\\u2028\\u2029]*$/.test(s.replace(/\\\\["\\\\\\/bfnrtu]/g,"@").replace(/(?:"[^"\\\\\\n\\r\\u2028\\u2029\\x00-\\x08\\x0a-\\x1f]*"|true|false|null|-?\\d+(?:\\.\\d*)?(?:[eE][+\\-]?\\d+)?)[\\s\\u2028\\u2029]*(?=:|,|]|}|$)/g,"]").replace(/(?:^|:|,)(?:[\\s\\u2028\\u2029]*\\[)+/g,""));};goog.json.errorLogger_=goog.nullFunction;goog.json.setErrorLogger=function(errorLogger){goog.json.errorLogger_=errorLogger;};goog.json.parse=goog.json.USE_NATIVE_JSON?goog.global.JSON.parse:function(s){if(goog.json.TRY_NATIVE_JSON){try{return goog.global.JSON.parse(s);}catch(ex){var error=ex;}}var o=String(s);if(goog.json.isValid(o)){try{var result=eval("("+o+")");error&&goog.json.errorLogger_("Invalid JSON: "+o,error);return result;}catch(ex$2){}}throw Error("Invalid JSON string: "+o);};goog.json.unsafeParse=goog.json.USE_NATIVE_JSON?goog.global.JSON.parse:function(s){if(goog.json.TRY_NATIVE_JSON){try{return goog.global.JSON.parse(s);}catch(ex){var error=ex;}}var result=eval("("+s+")");error&&goog.json.errorLogger_("Invalid JSON: "+s,error);return result;};goog.json.serialize=goog.json.USE_NATIVE_JSON?goog.global.JSON.stringify:function(object,opt_replacer){return new goog.json.Serializer(opt_replacer).serialize(object);};goog.json.Serializer=function(opt_replacer){this.replacer_=opt_replacer;};goog.json.Serializer.prototype.serialize=function(object){var sb=[];this.serializeInternal(object,sb);return sb.join("");};goog.json.Serializer.prototype.serializeInternal=function(object,sb){if(null==object){sb.push("null");}else{if("object"==(typeof object==="undefined"?"undefined":_typeof(object))){if(goog.isArray(object)){this.serializeArray(object,sb);return;}if(object instanceof String||object instanceof Number||object instanceof Boolean){object=object.valueOf();}else{this.serializeObject_(object,sb);return;}}switch(typeof object==="undefined"?"undefined":_typeof(object)){case"string":this.serializeString_(object,sb);break;case"number":this.serializeNumber_(object,sb);break;case"boolean":sb.push(String(object));break;case"function":sb.push("null");break;default:throw Error("Unknown type: "+(typeof object==="undefined"?"undefined":_typeof(object)));}}};goog.json.Serializer.charToJsonCharCache_={\'"\':\'\\\\"\',"\\\\":"\\\\\\\\","/":"\\\\/","\\b":"\\\\b","\\f":"\\\\f","\\n":"\\\\n","\\r":"\\\\r","\\t":"\\\\t","\\x0B":"\\\\u000b"};goog.json.Serializer.charsToReplace_=/\\uffff/.test("\\uFFFF")?/[\\\\\\"\\x00-\\x1f\\x7f-\\uffff]/g:/[\\\\\\"\\x00-\\x1f\\x7f-\\xff]/g;goog.json.Serializer.prototype.serializeString_=function(s,sb){sb.push(\'"\',s.replace(goog.json.Serializer.charsToReplace_,function(c){var rv=goog.json.Serializer.charToJsonCharCache_[c];rv||(rv="\\\\u"+(c.charCodeAt(0)|65536).toString(16).substr(1),goog.json.Serializer.charToJsonCharCache_[c]=rv);return rv;}),\'"\');};goog.json.Serializer.prototype.serializeNumber_=function(n,sb){sb.push(isFinite(n)&&!isNaN(n)?String(n):"null");};goog.json.Serializer.prototype.serializeArray=function(arr,sb){var l=arr.length;sb.push("[");for(var sep="",i=0;i<l;i++){sb.push(sep);var value=arr[i];this.serializeInternal(this.replacer_?this.replacer_.call(arr,String(i),value):value,sb);sep=",";}sb.push("]");};goog.json.Serializer.prototype.serializeObject_=function(obj,sb){sb.push("{");var sep="",key;for(key in obj){if(Object.prototype.hasOwnProperty.call(obj,key)){var value=obj[key];"function"!=typeof value&&(sb.push(sep),this.serializeString_(key,sb),sb.push(":"),this.serializeInternal(this.replacer_?this.replacer_.call(obj,key,value):value,sb),sep=",");}}sb.push("}");};goog.log={};goog.log.ENABLED=goog.debug.LOGGING_ENABLED;goog.log.ROOT_LOGGER_NAME=goog.debug.Logger.ROOT_LOGGER_NAME;goog.log.Logger=goog.debug.Logger;goog.log.Level=goog.debug.Logger.Level;goog.log.LogRecord=goog.debug.LogRecord;goog.log.getLogger=function(name,opt_level){if(goog.log.ENABLED){var logger=goog.debug.LogManager.getLogger(name);opt_level&&logger&&logger.setLevel(opt_level);return logger;}return null;};goog.log.addHandler=function(logger,handler){goog.log.ENABLED&&logger&&logger.addHandler(handler);};goog.log.removeHandler=function(logger,handler){return goog.log.ENABLED&&logger?logger.removeHandler(handler):!1;};goog.log.log=function(logger,level,msg,opt_exception){goog.log.ENABLED&&logger&&logger.log(level,msg,opt_exception);};goog.log.error=function(logger,msg,opt_exception){goog.log.ENABLED&&logger&&logger.severe(msg,opt_exception);};goog.log.warning=function(logger,msg,opt_exception){goog.log.ENABLED&&logger&&logger.warning(msg,opt_exception);};goog.log.info=function(logger,msg,opt_exception){goog.log.ENABLED&&logger&&logger.info(msg,opt_exception);};goog.log.fine=function(logger,msg,opt_exception){goog.log.ENABLED&&logger&&logger.fine(msg,opt_exception);};goog.net.ErrorCode={NO_ERROR:0,ACCESS_DENIED:1,FILE_NOT_FOUND:2,FF_SILENT_ERROR:3,CUSTOM_ERROR:4,EXCEPTION:5,HTTP_ERROR:6,ABORT:7,TIMEOUT:8,OFFLINE:9};goog.net.ErrorCode.getDebugMessage=function(errorCode){switch(errorCode){case goog.net.ErrorCode.NO_ERROR:return"No Error";case goog.net.ErrorCode.ACCESS_DENIED:return"Access denied to content document";case goog.net.ErrorCode.FILE_NOT_FOUND:return"File not found";case goog.net.ErrorCode.FF_SILENT_ERROR:return"Firefox silently errored";case goog.net.ErrorCode.CUSTOM_ERROR:return"Application custom error";case goog.net.ErrorCode.EXCEPTION:return"An exception occurred";case goog.net.ErrorCode.HTTP_ERROR:return"Http response at 400 or 500 level";case goog.net.ErrorCode.ABORT:return"Request was aborted";case goog.net.ErrorCode.TIMEOUT:return"Request timed out";case goog.net.ErrorCode.OFFLINE:return"The resource is not available offline";default:return"Unrecognized error code";}};goog.net.XhrLike=function(){};goog.net.XhrLike.prototype.open=function(method,url,opt_async,opt_user,opt_password){};goog.net.XhrLike.prototype.send=function(opt_data){};goog.net.XhrLike.prototype.abort=function(){};goog.net.XhrLike.prototype.setRequestHeader=function(header,value){};goog.net.XhrLike.prototype.getResponseHeader=function(header){};goog.net.XhrLike.prototype.getAllResponseHeaders=function(){};goog.net.XmlHttpFactory=function(){};goog.net.XmlHttpFactory.prototype.cachedOptions_=null;goog.net.XmlHttpFactory.prototype.getOptions=function(){return this.cachedOptions_||(this.cachedOptions_=this.internalGetOptions());};goog.net.WrapperXmlHttpFactory=function(xhrFactory,optionsFactory){this.xhrFactory_=xhrFactory;this.optionsFactory_=optionsFactory;};goog.inherits(goog.net.WrapperXmlHttpFactory,goog.net.XmlHttpFactory);goog.net.WrapperXmlHttpFactory.prototype.createInstance=function(){return this.xhrFactory_();};goog.net.WrapperXmlHttpFactory.prototype.getOptions=function(){return this.optionsFactory_();};goog.net.XmlHttp=function(){return goog.net.XmlHttp.factory_.createInstance();};goog.net.XmlHttp.ASSUME_NATIVE_XHR=!1;goog.net.XmlHttpDefines={};goog.net.XmlHttpDefines.ASSUME_NATIVE_XHR=!1;goog.net.XmlHttp.getOptions=function(){return goog.net.XmlHttp.factory_.getOptions();};goog.net.XmlHttp.OptionType={USE_NULL_FUNCTION:0,LOCAL_REQUEST_ERROR:1};goog.net.XmlHttp.ReadyState={UNINITIALIZED:0,LOADING:1,LOADED:2,INTERACTIVE:3,COMPLETE:4};goog.net.XmlHttp.setFactory=function(factory,optionsFactory){goog.net.XmlHttp.setGlobalFactory(new goog.net.WrapperXmlHttpFactory(goog.asserts.assert(factory),goog.asserts.assert(optionsFactory)));};goog.net.XmlHttp.setGlobalFactory=function(factory){goog.net.XmlHttp.factory_=factory;};goog.net.DefaultXmlHttpFactory=function(){};goog.inherits(goog.net.DefaultXmlHttpFactory,goog.net.XmlHttpFactory);goog.net.DefaultXmlHttpFactory.prototype.createInstance=function(){var progId=this.getProgId_();return progId?new ActiveXObject(progId):new XMLHttpRequest();};goog.net.DefaultXmlHttpFactory.prototype.internalGetOptions=function(){var options={};this.getProgId_()&&(options[goog.net.XmlHttp.OptionType.USE_NULL_FUNCTION]=!0,options[goog.net.XmlHttp.OptionType.LOCAL_REQUEST_ERROR]=!0);return options;};goog.net.DefaultXmlHttpFactory.prototype.getProgId_=function(){if(goog.net.XmlHttp.ASSUME_NATIVE_XHR||goog.net.XmlHttpDefines.ASSUME_NATIVE_XHR){return"";}if(!this.ieProgId_&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var ACTIVE_X_IDENTS=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],i=0;i<ACTIVE_X_IDENTS.length;i++){var candidate=ACTIVE_X_IDENTS[i];try{return new ActiveXObject(candidate),this.ieProgId_=candidate;}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return this.ieProgId_;};goog.net.XmlHttp.setGlobalFactory(new goog.net.DefaultXmlHttpFactory());goog.structs={};goog.structs.Map=function(opt_map,var_args){this.map_={};this.keys_=[];this.version_=this.count_=0;var argLength=arguments.length;if(1<argLength){if(argLength%2){throw Error("Uneven number of arguments");}for(var i=0;i<argLength;i+=2){this.set(arguments[i],arguments[i+1]);}}else{opt_map&&this.addAll(opt_map);}};goog.structs.Map.prototype.getCount=function(){return this.count_;};goog.structs.Map.prototype.getValues=function(){this.cleanupKeysArray_();for(var rv=[],i=0;i<this.keys_.length;i++){rv.push(this.map_[this.keys_[i]]);}return rv;};goog.structs.Map.prototype.getKeys=function(){this.cleanupKeysArray_();return this.keys_.concat();};goog.structs.Map.prototype.containsKey=function(key){return goog.structs.Map.hasKey_(this.map_,key);};goog.structs.Map.prototype.containsValue=function(val){for(var i=0;i<this.keys_.length;i++){var key=this.keys_[i];if(goog.structs.Map.hasKey_(this.map_,key)&&this.map_[key]==val){return!0;}}return!1;};goog.structs.Map.prototype.equals=function(otherMap,opt_equalityFn){if(this===otherMap){return!0;}if(this.count_!=otherMap.getCount()){return!1;}var equalityFn=opt_equalityFn||goog.structs.Map.defaultEquals;this.cleanupKeysArray_();for(var key,i=0;key=this.keys_[i];i++){if(!equalityFn(this.get(key),otherMap.get(key))){return!1;}}return!0;};goog.structs.Map.defaultEquals=function(a,b){return a===b;};goog.structs.Map.prototype.isEmpty=function(){return 0==this.count_;};goog.structs.Map.prototype.clear=function(){this.map_={};this.version_=this.count_=this.keys_.length=0;};goog.structs.Map.prototype.remove=function(key){return goog.structs.Map.hasKey_(this.map_,key)?(delete this.map_[key],this.count_--,this.version_++,this.keys_.length>2*this.count_&&this.cleanupKeysArray_(),!0):!1;};goog.structs.Map.prototype.cleanupKeysArray_=function(){var destIndex,srcIndex;if(this.count_!=this.keys_.length){for(destIndex=srcIndex=0;srcIndex<this.keys_.length;){var key=this.keys_[srcIndex];goog.structs.Map.hasKey_(this.map_,key)&&(this.keys_[destIndex++]=key);srcIndex++;}this.keys_.length=destIndex;}if(this.count_!=this.keys_.length){var seen={};for(destIndex=srcIndex=0;srcIndex<this.keys_.length;){key=this.keys_[srcIndex],goog.structs.Map.hasKey_(seen,key)||(this.keys_[destIndex++]=key,seen[key]=1),srcIndex++;}this.keys_.length=destIndex;}};goog.structs.Map.prototype.get=function(key,opt_val){return goog.structs.Map.hasKey_(this.map_,key)?this.map_[key]:opt_val;};goog.structs.Map.prototype.set=function(key,value){goog.structs.Map.hasKey_(this.map_,key)||(this.count_++,this.keys_.push(key),this.version_++);this.map_[key]=value;};goog.structs.Map.prototype.addAll=function(map){if(map instanceof goog.structs.Map){var keys=map.getKeys();var values=map.getValues();}else{keys=goog.object.getKeys(map),values=goog.object.getValues(map);}for(var i=0;i<keys.length;i++){this.set(keys[i],values[i]);}};goog.structs.Map.prototype.forEach=function(f,opt_obj){for(var keys=this.getKeys(),i=0;i<keys.length;i++){var key=keys[i],value=this.get(key);f.call(opt_obj,value,key,this);}};goog.structs.Map.prototype.clone=function(){return new goog.structs.Map(this);};goog.structs.Map.prototype.transpose=function(){for(var transposed=new goog.structs.Map(),i=0;i<this.keys_.length;i++){var key=this.keys_[i];transposed.set(this.map_[key],key);}return transposed;};goog.structs.Map.prototype.toObject=function(){this.cleanupKeysArray_();for(var obj={},i=0;i<this.keys_.length;i++){var key=this.keys_[i];obj[key]=this.map_[key];}return obj;};goog.structs.Map.prototype.getKeyIterator=function(){return this.__iterator__(!0);};goog.structs.Map.prototype.getValueIterator=function(){return this.__iterator__(!1);};goog.structs.Map.prototype.__iterator__=function(opt_keys){this.cleanupKeysArray_();var i=0,version=this.version_,selfObj=this,newIter=new goog.iter.Iterator();newIter.next=function(){if(version!=selfObj.version_){throw Error("The map has changed since the iterator was created");}if(i>=selfObj.keys_.length){throw goog.iter.StopIteration;}var key=selfObj.keys_[i++];return opt_keys?key:selfObj.map_[key];};return newIter;};goog.structs.Map.hasKey_=function(obj,key){return Object.prototype.hasOwnProperty.call(obj,key);};goog.structs.getCount=function(col){return col.getCount&&"function"==typeof col.getCount?col.getCount():goog.isArrayLike(col)||goog.isString(col)?col.length:goog.object.getCount(col);};goog.structs.getValues=function(col){if(col.getValues&&"function"==typeof col.getValues){return col.getValues();}if(goog.isString(col)){return col.split("");}if(goog.isArrayLike(col)){for(var rv=[],l=col.length,i=0;i<l;i++){rv.push(col[i]);}return rv;}return goog.object.getValues(col);};goog.structs.getKeys=function(col){if(col.getKeys&&"function"==typeof col.getKeys){return col.getKeys();}if(!col.getValues||"function"!=typeof col.getValues){if(goog.isArrayLike(col)||goog.isString(col)){for(var rv=[],l=col.length,i=0;i<l;i++){rv.push(i);}return rv;}return goog.object.getKeys(col);}};goog.structs.contains=function(col,val){return col.contains&&"function"==typeof col.contains?col.contains(val):col.containsValue&&"function"==typeof col.containsValue?col.containsValue(val):goog.isArrayLike(col)||goog.isString(col)?goog.array.contains(col,val):goog.object.containsValue(col,val);};goog.structs.isEmpty=function(col){return col.isEmpty&&"function"==typeof col.isEmpty?col.isEmpty():goog.isArrayLike(col)||goog.isString(col)?goog.array.isEmpty(col):goog.object.isEmpty(col);};goog.structs.clear=function(col){col.clear&&"function"==typeof col.clear?col.clear():goog.isArrayLike(col)?goog.array.clear(col):goog.object.clear(col);};goog.structs.forEach=function(col,f,opt_obj){if(col.forEach&&"function"==typeof col.forEach){col.forEach(f,opt_obj);}else{if(goog.isArrayLike(col)||goog.isString(col)){goog.array.forEach(col,f,opt_obj);}else{for(var keys=goog.structs.getKeys(col),values=goog.structs.getValues(col),l=values.length,i=0;i<l;i++){f.call(opt_obj,values[i],keys&&keys[i],col);}}}};goog.structs.filter=function(col,f,opt_obj){if("function"==typeof col.filter){return col.filter(f,opt_obj);}if(goog.isArrayLike(col)||goog.isString(col)){return goog.array.filter(col,f,opt_obj);}var keys=goog.structs.getKeys(col),values=goog.structs.getValues(col),l=values.length;if(keys){var rv={};for(var i=0;i<l;i++){f.call(opt_obj,values[i],keys[i],col)&&(rv[keys[i]]=values[i]);}}else{for(rv=[],i=0;i<l;i++){f.call(opt_obj,values[i],void 0,col)&&rv.push(values[i]);}}return rv;};goog.structs.map=function(col,f,opt_obj){if("function"==typeof col.map){return col.map(f,opt_obj);}if(goog.isArrayLike(col)||goog.isString(col)){return goog.array.map(col,f,opt_obj);}var keys=goog.structs.getKeys(col),values=goog.structs.getValues(col),l=values.length;if(keys){var rv={};for(var i=0;i<l;i++){rv[keys[i]]=f.call(opt_obj,values[i],keys[i],col);}}else{for(rv=[],i=0;i<l;i++){rv[i]=f.call(opt_obj,values[i],void 0,col);}}return rv;};goog.structs.some=function(col,f,opt_obj){if("function"==typeof col.some){return col.some(f,opt_obj);}if(goog.isArrayLike(col)||goog.isString(col)){return goog.array.some(col,f,opt_obj);}for(var keys=goog.structs.getKeys(col),values=goog.structs.getValues(col),l=values.length,i=0;i<l;i++){if(f.call(opt_obj,values[i],keys&&keys[i],col)){return!0;}}return!1;};goog.structs.every=function(col,f,opt_obj){if("function"==typeof col.every){return col.every(f,opt_obj);}if(goog.isArrayLike(col)||goog.isString(col)){return goog.array.every(col,f,opt_obj);}for(var keys=goog.structs.getKeys(col),values=goog.structs.getValues(col),l=values.length,i=0;i<l;i++){if(!f.call(opt_obj,values[i],keys&&keys[i],col)){return!1;}}return!0;};goog.Timer=function(opt_interval,opt_timerObject){goog.events.EventTarget.call(this);this.interval_=opt_interval||1;this.timerObject_=opt_timerObject||goog.Timer.defaultTimerObject;this.boundTick_=goog.bind(this.tick_,this);this.last_=goog.now();};goog.inherits(goog.Timer,goog.events.EventTarget);goog.Timer.MAX_TIMEOUT_=2147483647;goog.Timer.INVALID_TIMEOUT_ID_=-1;goog.Timer.prototype.enabled=!1;goog.Timer.defaultTimerObject=goog.global;goog.Timer.intervalScale=0.8;goog.Timer.prototype.timer_=null;goog.Timer.prototype.getInterval=function(){return this.interval_;};goog.Timer.prototype.setInterval=function(interval){this.interval_=interval;this.timer_&&this.enabled?(this.stop(),this.start()):this.timer_&&this.stop();};goog.Timer.prototype.tick_=function(){if(this.enabled){var elapsed=goog.now()-this.last_;0<elapsed&&elapsed<this.interval_*goog.Timer.intervalScale?this.timer_=this.timerObject_.setTimeout(this.boundTick_,this.interval_-elapsed):(this.timer_&&(this.timerObject_.clearTimeout(this.timer_),this.timer_=null),this.dispatchTick(),this.enabled&&(this.timer_=this.timerObject_.setTimeout(this.boundTick_,this.interval_),this.last_=goog.now()));}};goog.Timer.prototype.dispatchTick=function(){this.dispatchEvent(goog.Timer.TICK);};goog.Timer.prototype.start=function(){this.enabled=!0;this.timer_||(this.timer_=this.timerObject_.setTimeout(this.boundTick_,this.interval_),this.last_=goog.now());};goog.Timer.prototype.stop=function(){this.enabled=!1;this.timer_&&(this.timerObject_.clearTimeout(this.timer_),this.timer_=null);};goog.Timer.prototype.disposeInternal=function(){goog.Timer.superClass_.disposeInternal.call(this);this.stop();delete this.timerObject_;};goog.Timer.TICK="tick";goog.Timer.callOnce=function(listener,opt_delay,opt_handler){if(goog.isFunction(listener)){opt_handler&&(listener=goog.bind(listener,opt_handler));}else{if(listener&&"function"==typeof listener.handleEvent){listener=goog.bind(listener.handleEvent,listener);}else{throw Error("Invalid listener argument");}}return Number(opt_delay)>goog.Timer.MAX_TIMEOUT_?goog.Timer.INVALID_TIMEOUT_ID_:goog.Timer.defaultTimerObject.setTimeout(listener,opt_delay||0);};goog.Timer.clear=function(timerId){goog.Timer.defaultTimerObject.clearTimeout(timerId);};goog.Timer.promise=function(delay,opt_result){var timerKey=null;return new goog.Promise(function(resolve,reject){timerKey=goog.Timer.callOnce(function(){resolve(opt_result);},delay);timerKey==goog.Timer.INVALID_TIMEOUT_ID_&&reject(Error("Failed to schedule timer."));}).thenCatch(function(error){goog.Timer.clear(timerKey);throw error;});};goog.uri={};goog.uri.utils={};goog.uri.utils.CharCode_={AMPERSAND:38,EQUAL:61,HASH:35,QUESTION:63};goog.uri.utils.buildFromEncodedParts=function(opt_scheme,opt_userInfo,opt_domain,opt_port,opt_path,opt_queryData,opt_fragment){var out="";opt_scheme&&(out+=opt_scheme+":");opt_domain&&(out+="//",opt_userInfo&&(out+=opt_userInfo+"@"),out+=opt_domain,opt_port&&(out+=":"+opt_port));opt_path&&(out+=opt_path);opt_queryData&&(out+="?"+opt_queryData);opt_fragment&&(out+="#"+opt_fragment);return out;};goog.uri.utils.splitRe_=/^(?:([^:/?#.]+):)?(?:\\/\\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$/;goog.uri.utils.ComponentIndex={SCHEME:1,USER_INFO:2,DOMAIN:3,PORT:4,PATH:5,QUERY_DATA:6,FRAGMENT:7};goog.uri.utils.split=function(uri){return uri.match(goog.uri.utils.splitRe_);};goog.uri.utils.decodeIfPossible_=function(uri,opt_preserveReserved){return uri?opt_preserveReserved?decodeURI(uri):decodeURIComponent(uri):uri;};goog.uri.utils.getComponentByIndex_=function(componentIndex,uri){return goog.uri.utils.split(uri)[componentIndex]||null;};goog.uri.utils.getScheme=function(uri){return goog.uri.utils.getComponentByIndex_(goog.uri.utils.ComponentIndex.SCHEME,uri);};goog.uri.utils.getEffectiveScheme=function(uri){var scheme=goog.uri.utils.getScheme(uri);if(!scheme&&goog.global.self&&goog.global.self.location){var protocol=goog.global.self.location.protocol,scheme=protocol.substr(0,protocol.length-1);}return scheme?scheme.toLowerCase():"";};goog.uri.utils.getUserInfoEncoded=function(uri){return goog.uri.utils.getComponentByIndex_(goog.uri.utils.ComponentIndex.USER_INFO,uri);};goog.uri.utils.getUserInfo=function(uri){return goog.uri.utils.decodeIfPossible_(goog.uri.utils.getUserInfoEncoded(uri));};goog.uri.utils.getDomainEncoded=function(uri){return goog.uri.utils.getComponentByIndex_(goog.uri.utils.ComponentIndex.DOMAIN,uri);};goog.uri.utils.getDomain=function(uri){return goog.uri.utils.decodeIfPossible_(goog.uri.utils.getDomainEncoded(uri),!0);};goog.uri.utils.getPort=function(uri){return Number(goog.uri.utils.getComponentByIndex_(goog.uri.utils.ComponentIndex.PORT,uri))||null;};goog.uri.utils.getPathEncoded=function(uri){return goog.uri.utils.getComponentByIndex_(goog.uri.utils.ComponentIndex.PATH,uri);};goog.uri.utils.getPath=function(uri){return goog.uri.utils.decodeIfPossible_(goog.uri.utils.getPathEncoded(uri),!0);};goog.uri.utils.getQueryData=function(uri){return goog.uri.utils.getComponentByIndex_(goog.uri.utils.ComponentIndex.QUERY_DATA,uri);};goog.uri.utils.getFragmentEncoded=function(uri){var hashIndex=uri.indexOf("#");return 0>hashIndex?null:uri.substr(hashIndex+1);};goog.uri.utils.setFragmentEncoded=function(uri,fragment){return goog.uri.utils.removeFragment(uri)+(fragment?"#"+fragment:"");};goog.uri.utils.getFragment=function(uri){return goog.uri.utils.decodeIfPossible_(goog.uri.utils.getFragmentEncoded(uri));};goog.uri.utils.getHost=function(uri){var pieces=goog.uri.utils.split(uri);return goog.uri.utils.buildFromEncodedParts(pieces[goog.uri.utils.ComponentIndex.SCHEME],pieces[goog.uri.utils.ComponentIndex.USER_INFO],pieces[goog.uri.utils.ComponentIndex.DOMAIN],pieces[goog.uri.utils.ComponentIndex.PORT]);};goog.uri.utils.getOrigin=function(uri){var pieces=goog.uri.utils.split(uri);return goog.uri.utils.buildFromEncodedParts(pieces[goog.uri.utils.ComponentIndex.SCHEME],null,pieces[goog.uri.utils.ComponentIndex.DOMAIN],pieces[goog.uri.utils.ComponentIndex.PORT]);};goog.uri.utils.getPathAndAfter=function(uri){var pieces=goog.uri.utils.split(uri);return goog.uri.utils.buildFromEncodedParts(null,null,null,null,pieces[goog.uri.utils.ComponentIndex.PATH],pieces[goog.uri.utils.ComponentIndex.QUERY_DATA],pieces[goog.uri.utils.ComponentIndex.FRAGMENT]);};goog.uri.utils.removeFragment=function(uri){var hashIndex=uri.indexOf("#");return 0>hashIndex?uri:uri.substr(0,hashIndex);};goog.uri.utils.haveSameDomain=function(uri1,uri2){var pieces1=goog.uri.utils.split(uri1),pieces2=goog.uri.utils.split(uri2);return pieces1[goog.uri.utils.ComponentIndex.DOMAIN]==pieces2[goog.uri.utils.ComponentIndex.DOMAIN]&&pieces1[goog.uri.utils.ComponentIndex.SCHEME]==pieces2[goog.uri.utils.ComponentIndex.SCHEME]&&pieces1[goog.uri.utils.ComponentIndex.PORT]==pieces2[goog.uri.utils.ComponentIndex.PORT];};goog.uri.utils.assertNoFragmentsOrQueries_=function(uri){goog.asserts.assert(0>uri.indexOf("#")&&0>uri.indexOf("?"),"goog.uri.utils: Fragment or query identifiers are not supported: [%s]",uri);};goog.uri.utils.parseQueryData=function(encodedQuery,callback){if(encodedQuery){for(var pairs=encodedQuery.split("&"),i=0;i<pairs.length;i++){var indexOfEquals=pairs[i].indexOf("="),name=null,value=null;0<=indexOfEquals?(name=pairs[i].substring(0,indexOfEquals),value=pairs[i].substring(indexOfEquals+1)):name=pairs[i];callback(name,value?goog.string.urlDecode(value):"");}}};goog.uri.utils.appendQueryData_=function(buffer){if(buffer[1]){var baseUri=buffer[0],hashIndex=baseUri.indexOf("#");0<=hashIndex&&(buffer.push(baseUri.substr(hashIndex)),buffer[0]=baseUri=baseUri.substr(0,hashIndex));var questionIndex=baseUri.indexOf("?");0>questionIndex?buffer[1]="?":questionIndex==baseUri.length-1&&(buffer[1]=void 0);}return buffer.join("");};goog.uri.utils.appendKeyValuePairs_=function(key,value,pairs){goog.asserts.assertString(key);if(goog.isArray(value)){goog.asserts.assertArray(value);for(var j=0;j<value.length;j++){goog.uri.utils.appendKeyValuePairs_(key,String(value[j]),pairs);}}else{null!=value&&pairs.push("&",key,""===value?"":"=",goog.string.urlEncode(value));}};goog.uri.utils.buildQueryDataBuffer_=function(buffer,keysAndValues,opt_startIndex){goog.asserts.assert(0==Math.max(keysAndValues.length-(opt_startIndex||0),0)%2,"goog.uri.utils: Key/value lists must be even in length.");for(var i=opt_startIndex||0;i<keysAndValues.length;i+=2){goog.uri.utils.appendKeyValuePairs_(keysAndValues[i],keysAndValues[i+1],buffer);}return buffer;};goog.uri.utils.buildQueryData=function(keysAndValues,opt_startIndex){var buffer=goog.uri.utils.buildQueryDataBuffer_([],keysAndValues,opt_startIndex);buffer[0]="";return buffer.join("");};goog.uri.utils.buildQueryDataBufferFromMap_=function(buffer,map){for(var key in map){goog.uri.utils.appendKeyValuePairs_(key,map[key],buffer);}return buffer;};goog.uri.utils.buildQueryDataFromMap=function(map){var buffer=goog.uri.utils.buildQueryDataBufferFromMap_([],map);buffer[0]="";return buffer.join("");};goog.uri.utils.appendParams=function(uri,var_args){return goog.uri.utils.appendQueryData_(2==arguments.length?goog.uri.utils.buildQueryDataBuffer_([uri],arguments[1],0):goog.uri.utils.buildQueryDataBuffer_([uri],arguments,1));};goog.uri.utils.appendParamsFromMap=function(uri,map){return goog.uri.utils.appendQueryData_(goog.uri.utils.buildQueryDataBufferFromMap_([uri],map));};goog.uri.utils.appendParam=function(uri,key,opt_value){var paramArr=[uri,"&",key];goog.isDefAndNotNull(opt_value)&&paramArr.push("=",goog.string.urlEncode(opt_value));return goog.uri.utils.appendQueryData_(paramArr);};goog.uri.utils.findParam_=function(uri,startIndex,keyEncoded,hashOrEndIndex){for(var index=startIndex,keyLength=keyEncoded.length;0<=(index=uri.indexOf(keyEncoded,index))&&index<hashOrEndIndex;){var precedingChar=uri.charCodeAt(index-1);if(precedingChar==goog.uri.utils.CharCode_.AMPERSAND||precedingChar==goog.uri.utils.CharCode_.QUESTION){var followingChar=uri.charCodeAt(index+keyLength);if(!followingChar||followingChar==goog.uri.utils.CharCode_.EQUAL||followingChar==goog.uri.utils.CharCode_.AMPERSAND||followingChar==goog.uri.utils.CharCode_.HASH){return index;}}index+=keyLength+1;}return-1;};goog.uri.utils.hashOrEndRe_=/#|$/;goog.uri.utils.hasParam=function(uri,keyEncoded){return 0<=goog.uri.utils.findParam_(uri,0,keyEncoded,uri.search(goog.uri.utils.hashOrEndRe_));};goog.uri.utils.getParamValue=function(uri,keyEncoded){var hashOrEndIndex=uri.search(goog.uri.utils.hashOrEndRe_),foundIndex=goog.uri.utils.findParam_(uri,0,keyEncoded,hashOrEndIndex);if(0>foundIndex){return null;}var endPosition=uri.indexOf("&",foundIndex);if(0>endPosition||endPosition>hashOrEndIndex){endPosition=hashOrEndIndex;}foundIndex+=keyEncoded.length+1;return goog.string.urlDecode(uri.substr(foundIndex,endPosition-foundIndex));};goog.uri.utils.getParamValues=function(uri,keyEncoded){for(var hashOrEndIndex=uri.search(goog.uri.utils.hashOrEndRe_),position=0,foundIndex,result=[];0<=(foundIndex=goog.uri.utils.findParam_(uri,position,keyEncoded,hashOrEndIndex));){position=uri.indexOf("&",foundIndex);if(0>position||position>hashOrEndIndex){position=hashOrEndIndex;}foundIndex+=keyEncoded.length+1;result.push(goog.string.urlDecode(uri.substr(foundIndex,position-foundIndex)));}return result;};goog.uri.utils.trailingQueryPunctuationRe_=/[?&]($|#)/;goog.uri.utils.removeParam=function(uri,keyEncoded){for(var hashOrEndIndex=uri.search(goog.uri.utils.hashOrEndRe_),position=0,foundIndex,buffer=[];0<=(foundIndex=goog.uri.utils.findParam_(uri,position,keyEncoded,hashOrEndIndex));){buffer.push(uri.substring(position,foundIndex)),position=Math.min(uri.indexOf("&",foundIndex)+1||hashOrEndIndex,hashOrEndIndex);}buffer.push(uri.substr(position));return buffer.join("").replace(goog.uri.utils.trailingQueryPunctuationRe_,"$1");};goog.uri.utils.setParam=function(uri,keyEncoded,value){return goog.uri.utils.appendParam(goog.uri.utils.removeParam(uri,keyEncoded),keyEncoded,value);};goog.uri.utils.appendPath=function(baseUri,path){goog.uri.utils.assertNoFragmentsOrQueries_(baseUri);goog.string.endsWith(baseUri,"/")&&(baseUri=baseUri.substr(0,baseUri.length-1));goog.string.startsWith(path,"/")&&(path=path.substr(1));return goog.string.buildString(baseUri,"/",path);};goog.uri.utils.setPath=function(uri,path){goog.string.startsWith(path,"/")||(path="/"+path);var parts=goog.uri.utils.split(uri);return goog.uri.utils.buildFromEncodedParts(parts[goog.uri.utils.ComponentIndex.SCHEME],parts[goog.uri.utils.ComponentIndex.USER_INFO],parts[goog.uri.utils.ComponentIndex.DOMAIN],parts[goog.uri.utils.ComponentIndex.PORT],path,parts[goog.uri.utils.ComponentIndex.QUERY_DATA],parts[goog.uri.utils.ComponentIndex.FRAGMENT]);};goog.uri.utils.StandardQueryParam={RANDOM:"zx"};goog.uri.utils.makeUnique=function(uri){return goog.uri.utils.setParam(uri,goog.uri.utils.StandardQueryParam.RANDOM,goog.string.getRandomString());};goog.net.XhrIo=function(opt_xmlHttpFactory){goog.events.EventTarget.call(this);this.headers=new goog.structs.Map();this.xmlHttpFactory_=opt_xmlHttpFactory||null;this.active_=!1;this.xhrOptions_=this.xhr_=null;this.lastMethod_=this.lastUri_="";this.lastErrorCode_=goog.net.ErrorCode.NO_ERROR;this.lastError_="";this.inAbort_=this.inOpen_=this.inSend_=this.errorDispatched_=!1;this.timeoutInterval_=0;this.timeoutId_=null;this.responseType_=goog.net.XhrIo.ResponseType.DEFAULT;this.useXhr2Timeout_=this.progressEventsEnabled_=this.withCredentials_=!1;};goog.inherits(goog.net.XhrIo,goog.events.EventTarget);goog.net.XhrIo.ResponseType={DEFAULT:"",TEXT:"text",DOCUMENT:"document",BLOB:"blob",ARRAY_BUFFER:"arraybuffer"};goog.net.XhrIo.prototype.logger_=goog.log.getLogger("goog.net.XhrIo");goog.net.XhrIo.CONTENT_TYPE_HEADER="Content-Type";goog.net.XhrIo.CONTENT_TRANSFER_ENCODING="Content-Transfer-Encoding";goog.net.XhrIo.HTTP_SCHEME_PATTERN=/^https?$/i;goog.net.XhrIo.METHODS_WITH_FORM_DATA=["POST","PUT"];goog.net.XhrIo.FORM_CONTENT_TYPE="application/x-www-form-urlencoded;charset=utf-8";goog.net.XhrIo.XHR2_TIMEOUT_="timeout";goog.net.XhrIo.XHR2_ON_TIMEOUT_="ontimeout";goog.net.XhrIo.sendInstances_=[];goog.net.XhrIo.send=function(url,opt_callback,opt_method,opt_content,opt_headers,opt_timeoutInterval,opt_withCredentials){var x=new goog.net.XhrIo();goog.net.XhrIo.sendInstances_.push(x);opt_callback&&x.listen(goog.net.EventType.COMPLETE,opt_callback);x.listenOnce(goog.net.EventType.READY,x.cleanupSend_);opt_timeoutInterval&&x.setTimeoutInterval(opt_timeoutInterval);opt_withCredentials&&x.setWithCredentials(opt_withCredentials);x.send(url,opt_method,opt_content,opt_headers);return x;};goog.net.XhrIo.cleanup=function(){for(var instances=goog.net.XhrIo.sendInstances_;instances.length;){instances.pop().dispose();}};goog.net.XhrIo.protectEntryPoints=function(errorHandler){goog.net.XhrIo.prototype.onReadyStateChangeEntryPoint_=errorHandler.protectEntryPoint(goog.net.XhrIo.prototype.onReadyStateChangeEntryPoint_);};goog.net.XhrIo.prototype.cleanupSend_=function(){this.dispose();goog.array.remove(goog.net.XhrIo.sendInstances_,this);};goog.net.XhrIo.prototype.getTimeoutInterval=function(){return this.timeoutInterval_;};goog.net.XhrIo.prototype.setTimeoutInterval=function(ms){this.timeoutInterval_=Math.max(0,ms);};goog.net.XhrIo.prototype.setResponseType=function(type){this.responseType_=type;};goog.net.XhrIo.prototype.getResponseType=function(){return this.responseType_;};goog.net.XhrIo.prototype.setWithCredentials=function(withCredentials){this.withCredentials_=withCredentials;};goog.net.XhrIo.prototype.getWithCredentials=function(){return this.withCredentials_;};goog.net.XhrIo.prototype.setProgressEventsEnabled=function(enabled){this.progressEventsEnabled_=enabled;};goog.net.XhrIo.prototype.getProgressEventsEnabled=function(){return this.progressEventsEnabled_;};goog.net.XhrIo.prototype.send=function(url,opt_method,opt_content,opt_headers){if(this.xhr_){throw Error("[goog.net.XhrIo] Object is active with another request="+this.lastUri_+"; newUri="+url);}var method=opt_method?opt_method.toUpperCase():"GET";this.lastUri_=url;this.lastError_="";this.lastErrorCode_=goog.net.ErrorCode.NO_ERROR;this.lastMethod_=method;this.errorDispatched_=!1;this.active_=!0;this.xhr_=this.createXhr();this.xhrOptions_=this.xmlHttpFactory_?this.xmlHttpFactory_.getOptions():goog.net.XmlHttp.getOptions();this.xhr_.onreadystatechange=goog.bind(this.onReadyStateChange_,this);this.getProgressEventsEnabled()&&"onprogress"in this.xhr_&&(this.xhr_.onprogress=goog.bind(function(e){this.onProgressHandler_(e,!0);},this),this.xhr_.upload&&(this.xhr_.upload.onprogress=goog.bind(this.onProgressHandler_,this)));try{goog.log.fine(this.logger_,this.formatMsg_("Opening Xhr")),this.inOpen_=!0,this.xhr_.open(method,String(url),!0),this.inOpen_=!1;}catch(err){goog.log.fine(this.logger_,this.formatMsg_("Error opening Xhr: "+err.message));this.error_(goog.net.ErrorCode.EXCEPTION,err);return;}var content=opt_content||"",headers=this.headers.clone();opt_headers&&goog.structs.forEach(opt_headers,function(value,key){headers.set(key,value);});var contentTypeKey=goog.array.find(headers.getKeys(),goog.net.XhrIo.isContentTypeHeader_),contentIsFormData=goog.global.FormData&&content instanceof goog.global.FormData;!goog.array.contains(goog.net.XhrIo.METHODS_WITH_FORM_DATA,method)||contentTypeKey||contentIsFormData||headers.set(goog.net.XhrIo.CONTENT_TYPE_HEADER,goog.net.XhrIo.FORM_CONTENT_TYPE);headers.forEach(function(value,key){this.xhr_.setRequestHeader(key,value);},this);this.responseType_&&(this.xhr_.responseType=this.responseType_);"withCredentials"in this.xhr_&&this.xhr_.withCredentials!==this.withCredentials_&&(this.xhr_.withCredentials=this.withCredentials_);try{this.cleanUpTimeoutTimer_(),0<this.timeoutInterval_&&(this.useXhr2Timeout_=goog.net.XhrIo.shouldUseXhr2Timeout_(this.xhr_),goog.log.fine(this.logger_,this.formatMsg_("Will abort after "+this.timeoutInterval_+"ms if incomplete, xhr2 "+this.useXhr2Timeout_)),this.useXhr2Timeout_?(this.xhr_[goog.net.XhrIo.XHR2_TIMEOUT_]=this.timeoutInterval_,this.xhr_[goog.net.XhrIo.XHR2_ON_TIMEOUT_]=goog.bind(this.timeout_,this)):this.timeoutId_=goog.Timer.callOnce(this.timeout_,this.timeoutInterval_,this)),goog.log.fine(this.logger_,this.formatMsg_("Sending request")),this.inSend_=!0,this.xhr_.send(content),this.inSend_=!1;}catch(err$3){goog.log.fine(this.logger_,this.formatMsg_("Send error: "+err$3.message)),this.error_(goog.net.ErrorCode.EXCEPTION,err$3);}};goog.net.XhrIo.shouldUseXhr2Timeout_=function(xhr){return goog.userAgent.IE&&goog.userAgent.isVersionOrHigher(9)&&goog.isNumber(xhr[goog.net.XhrIo.XHR2_TIMEOUT_])&&goog.isDef(xhr[goog.net.XhrIo.XHR2_ON_TIMEOUT_]);};goog.net.XhrIo.isContentTypeHeader_=function(header){return goog.string.caseInsensitiveEquals(goog.net.XhrIo.CONTENT_TYPE_HEADER,header);};goog.net.XhrIo.prototype.createXhr=function(){return this.xmlHttpFactory_?this.xmlHttpFactory_.createInstance():goog.net.XmlHttp();};goog.net.XhrIo.prototype.timeout_=function(){"undefined"!=typeof goog&&this.xhr_&&(this.lastError_="Timed out after "+this.timeoutInterval_+"ms, aborting",this.lastErrorCode_=goog.net.ErrorCode.TIMEOUT,goog.log.fine(this.logger_,this.formatMsg_(this.lastError_)),this.dispatchEvent(goog.net.EventType.TIMEOUT),this.abort(goog.net.ErrorCode.TIMEOUT));};goog.net.XhrIo.prototype.error_=function(errorCode,err){this.active_=!1;this.xhr_&&(this.inAbort_=!0,this.xhr_.abort(),this.inAbort_=!1);this.lastError_=err;this.lastErrorCode_=errorCode;this.dispatchErrors_();this.cleanUpXhr_();};goog.net.XhrIo.prototype.dispatchErrors_=function(){this.errorDispatched_||(this.errorDispatched_=!0,this.dispatchEvent(goog.net.EventType.COMPLETE),this.dispatchEvent(goog.net.EventType.ERROR));};goog.net.XhrIo.prototype.abort=function(opt_failureCode){this.xhr_&&this.active_&&(goog.log.fine(this.logger_,this.formatMsg_("Aborting")),this.active_=!1,this.inAbort_=!0,this.xhr_.abort(),this.inAbort_=!1,this.lastErrorCode_=opt_failureCode||goog.net.ErrorCode.ABORT,this.dispatchEvent(goog.net.EventType.COMPLETE),this.dispatchEvent(goog.net.EventType.ABORT),this.cleanUpXhr_());};goog.net.XhrIo.prototype.disposeInternal=function(){this.xhr_&&(this.active_&&(this.active_=!1,this.inAbort_=!0,this.xhr_.abort(),this.inAbort_=!1),this.cleanUpXhr_(!0));goog.net.XhrIo.superClass_.disposeInternal.call(this);};goog.net.XhrIo.prototype.onReadyStateChange_=function(){if(!this.isDisposed()){if(this.inOpen_||this.inSend_||this.inAbort_){this.onReadyStateChangeHelper_();}else{this.onReadyStateChangeEntryPoint_();}}};goog.net.XhrIo.prototype.onReadyStateChangeEntryPoint_=function(){this.onReadyStateChangeHelper_();};goog.net.XhrIo.prototype.onReadyStateChangeHelper_=function(){if(this.active_&&"undefined"!=typeof goog){if(this.xhrOptions_[goog.net.XmlHttp.OptionType.LOCAL_REQUEST_ERROR]&&this.getReadyState()==goog.net.XmlHttp.ReadyState.COMPLETE&&2==this.getStatus()){goog.log.fine(this.logger_,this.formatMsg_("Local request error detected and ignored"));}else{if(this.inSend_&&this.getReadyState()==goog.net.XmlHttp.ReadyState.COMPLETE){goog.Timer.callOnce(this.onReadyStateChange_,0,this);}else{if(this.dispatchEvent(goog.net.EventType.READY_STATE_CHANGE),this.isComplete()){goog.log.fine(this.logger_,this.formatMsg_("Request complete"));this.active_=!1;try{this.isSuccess()?(this.dispatchEvent(goog.net.EventType.COMPLETE),this.dispatchEvent(goog.net.EventType.SUCCESS)):(this.lastErrorCode_=goog.net.ErrorCode.HTTP_ERROR,this.lastError_=this.getStatusText()+" ["+this.getStatus()+"]",this.dispatchErrors_());}finally{this.cleanUpXhr_();}}}}}};goog.net.XhrIo.prototype.onProgressHandler_=function(e,opt_isDownload){goog.asserts.assert(e.type===goog.net.EventType.PROGRESS,"goog.net.EventType.PROGRESS is of the same type as raw XHR progress.");this.dispatchEvent(goog.net.XhrIo.buildProgressEvent_(e,goog.net.EventType.PROGRESS));this.dispatchEvent(goog.net.XhrIo.buildProgressEvent_(e,opt_isDownload?goog.net.EventType.DOWNLOAD_PROGRESS:goog.net.EventType.UPLOAD_PROGRESS));};goog.net.XhrIo.buildProgressEvent_=function(e,eventType){return{type:eventType,lengthComputable:e.lengthComputable,loaded:e.loaded,total:e.total};};goog.net.XhrIo.prototype.cleanUpXhr_=function(opt_fromDispose){if(this.xhr_){this.cleanUpTimeoutTimer_();var xhr=this.xhr_,clearedOnReadyStateChange=this.xhrOptions_[goog.net.XmlHttp.OptionType.USE_NULL_FUNCTION]?goog.nullFunction:null;this.xhrOptions_=this.xhr_=null;opt_fromDispose||this.dispatchEvent(goog.net.EventType.READY);try{xhr.onreadystatechange=clearedOnReadyStateChange;}catch(e){goog.log.error(this.logger_,"Problem encountered resetting onreadystatechange: "+e.message);}}};goog.net.XhrIo.prototype.cleanUpTimeoutTimer_=function(){this.xhr_&&this.useXhr2Timeout_&&(this.xhr_[goog.net.XhrIo.XHR2_ON_TIMEOUT_]=null);goog.isNumber(this.timeoutId_)&&(goog.Timer.clear(this.timeoutId_),this.timeoutId_=null);};goog.net.XhrIo.prototype.isActive=function(){return!!this.xhr_;};goog.net.XhrIo.prototype.isComplete=function(){return this.getReadyState()==goog.net.XmlHttp.ReadyState.COMPLETE;};goog.net.XhrIo.prototype.isSuccess=function(){var status=this.getStatus();return goog.net.HttpStatus.isSuccess(status)||0===status&&!this.isLastUriEffectiveSchemeHttp_();};goog.net.XhrIo.prototype.isLastUriEffectiveSchemeHttp_=function(){var scheme=goog.uri.utils.getEffectiveScheme(String(this.lastUri_));return goog.net.XhrIo.HTTP_SCHEME_PATTERN.test(scheme);};goog.net.XhrIo.prototype.getReadyState=function(){return this.xhr_?this.xhr_.readyState:goog.net.XmlHttp.ReadyState.UNINITIALIZED;};goog.net.XhrIo.prototype.getStatus=function(){try{return this.getReadyState()>goog.net.XmlHttp.ReadyState.LOADED?this.xhr_.status:-1;}catch(e){return-1;}};goog.net.XhrIo.prototype.getStatusText=function(){try{return this.getReadyState()>goog.net.XmlHttp.ReadyState.LOADED?this.xhr_.statusText:"";}catch(e){return goog.log.fine(this.logger_,"Can not get status: "+e.message),"";}};goog.net.XhrIo.prototype.getLastUri=function(){return String(this.lastUri_);};goog.net.XhrIo.prototype.getResponseText=function(){try{return this.xhr_?this.xhr_.responseText:"";}catch(e){return goog.log.fine(this.logger_,"Can not get responseText: "+e.message),"";}};goog.net.XhrIo.prototype.getResponseBody=function(){try{if(this.xhr_&&"responseBody"in this.xhr_){return this.xhr_.responseBody;}}catch(e){goog.log.fine(this.logger_,"Can not get responseBody: "+e.message);}return null;};goog.net.XhrIo.prototype.getResponseXml=function(){try{return this.xhr_?this.xhr_.responseXML:null;}catch(e){return goog.log.fine(this.logger_,"Can not get responseXML: "+e.message),null;}};goog.net.XhrIo.prototype.getResponseJson=function(opt_xssiPrefix){if(this.xhr_){var responseText=this.xhr_.responseText;opt_xssiPrefix&&0==responseText.indexOf(opt_xssiPrefix)&&(responseText=responseText.substring(opt_xssiPrefix.length));return goog.json.parse(responseText);}};goog.net.XhrIo.prototype.getResponse=function(){try{if(!this.xhr_){return null;}if("response"in this.xhr_){return this.xhr_.response;}switch(this.responseType_){case goog.net.XhrIo.ResponseType.DEFAULT:case goog.net.XhrIo.ResponseType.TEXT:return this.xhr_.responseText;case goog.net.XhrIo.ResponseType.ARRAY_BUFFER:if("mozResponseArrayBuffer"in this.xhr_){return this.xhr_.mozResponseArrayBuffer;}}goog.log.error(this.logger_,"Response type "+this.responseType_+" is not supported on this browser");return null;}catch(e){return goog.log.fine(this.logger_,"Can not get response: "+e.message),null;}};goog.net.XhrIo.prototype.getResponseHeader=function(key){if(this.xhr_&&this.isComplete()){var value=this.xhr_.getResponseHeader(key);return goog.isNull(value)?void 0:value;}};goog.net.XhrIo.prototype.getAllResponseHeaders=function(){return this.xhr_&&this.isComplete()?this.xhr_.getAllResponseHeaders():"";};goog.net.XhrIo.prototype.getResponseHeaders=function(){for(var headersObject={},headersArray=this.getAllResponseHeaders().split("\\r\\n"),i=0;i<headersArray.length;i++){if(!goog.string.isEmptyOrWhitespace(headersArray[i])){var keyValue=goog.string.splitLimit(headersArray[i],": ",2);headersObject[keyValue[0]]=headersObject[keyValue[0]]?headersObject[keyValue[0]]+(", "+keyValue[1]):keyValue[1];}}return headersObject;};goog.net.XhrIo.prototype.getStreamingResponseHeader=function(key){return this.xhr_?this.xhr_.getResponseHeader(key):null;};goog.net.XhrIo.prototype.getAllStreamingResponseHeaders=function(){return this.xhr_?this.xhr_.getAllResponseHeaders():"";};goog.net.XhrIo.prototype.getLastErrorCode=function(){return this.lastErrorCode_;};goog.net.XhrIo.prototype.getLastError=function(){return goog.isString(this.lastError_)?this.lastError_:String(this.lastError_);};goog.net.XhrIo.prototype.formatMsg_=function(msg){return msg+" ["+this.lastMethod_+" "+this.lastUri_+" "+this.getStatus()+"]";};goog.debug.entryPointRegistry.register(function(transformer){goog.net.XhrIo.prototype.onReadyStateChangeEntryPoint_=transformer(goog.net.XhrIo.prototype.onReadyStateChangeEntryPoint_);});goog.dom.BrowserFeature={CAN_ADD_NAME_OR_TYPE_ATTRIBUTES:!goog.userAgent.IE||goog.userAgent.isDocumentModeOrHigher(9),CAN_USE_CHILDREN_ATTRIBUTE:!goog.userAgent.GECKO&&!goog.userAgent.IE||goog.userAgent.IE&&goog.userAgent.isDocumentModeOrHigher(9)||goog.userAgent.GECKO&&goog.userAgent.isVersionOrHigher("1.9.1"),CAN_USE_INNER_TEXT:goog.userAgent.IE&&!goog.userAgent.isVersionOrHigher("9"),CAN_USE_PARENT_ELEMENT_PROPERTY:goog.userAgent.IE||goog.userAgent.OPERA||goog.userAgent.WEBKIT,INNER_HTML_NEEDS_SCOPED_ELEMENT:goog.userAgent.IE,LEGACY_IE_RANGES:goog.userAgent.IE&&!goog.userAgent.isDocumentModeOrHigher(9)};goog.dom.tags={};goog.dom.tags.VOID_TAGS_={area:!0,base:!0,br:!0,col:!0,command:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0};goog.dom.tags.isVoidTag=function(tagName){return!0===goog.dom.tags.VOID_TAGS_[tagName];};goog.string.TypedString=function(){};goog.string.Const=function(){this.stringConstValueWithSecurityContract__googStringSecurityPrivate_="";this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_=goog.string.Const.TYPE_MARKER_;};goog.string.Const.prototype.implementsGoogStringTypedString=!0;goog.string.Const.prototype.getTypedStringValue=function(){return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;};goog.string.Const.prototype.toString=function(){return"Const{"+this.stringConstValueWithSecurityContract__googStringSecurityPrivate_+"}";};goog.string.Const.unwrap=function(stringConst){if(stringConst instanceof goog.string.Const&&stringConst.constructor===goog.string.Const&&stringConst.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_===goog.string.Const.TYPE_MARKER_){return stringConst.stringConstValueWithSecurityContract__googStringSecurityPrivate_;}goog.asserts.fail("expected object of type Const, got \'"+stringConst+"\'");return"type_error:Const";};goog.string.Const.from=function(s){return goog.string.Const.create__googStringSecurityPrivate_(s);};goog.string.Const.TYPE_MARKER_={};goog.string.Const.create__googStringSecurityPrivate_=function(s){var stringConst=new goog.string.Const();stringConst.stringConstValueWithSecurityContract__googStringSecurityPrivate_=s;return stringConst;};goog.string.Const.EMPTY=goog.string.Const.from("");goog.html={};goog.html.SafeScript=function(){this.privateDoNotAccessOrElseSafeScriptWrappedValue_="";this.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_=goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;};goog.html.SafeScript.prototype.implementsGoogStringTypedString=!0;goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_={};goog.html.SafeScript.fromConstant=function(script){var scriptString=goog.string.Const.unwrap(script);return 0===scriptString.length?goog.html.SafeScript.EMPTY:goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(scriptString);};goog.html.SafeScript.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeScriptWrappedValue_;};goog.DEBUG&&(goog.html.SafeScript.prototype.toString=function(){return"SafeScript{"+this.privateDoNotAccessOrElseSafeScriptWrappedValue_+"}";});goog.html.SafeScript.unwrap=function(safeScript){if(safeScript instanceof goog.html.SafeScript&&safeScript.constructor===goog.html.SafeScript&&safeScript.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_===goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_){return safeScript.privateDoNotAccessOrElseSafeScriptWrappedValue_;}goog.asserts.fail("expected object of type SafeScript, got \'"+safeScript+"\' of type "+goog.typeOf(safeScript));return"type_error:SafeScript";};goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse=function(script){return new goog.html.SafeScript().initSecurityPrivateDoNotAccessOrElse_(script);};goog.html.SafeScript.prototype.initSecurityPrivateDoNotAccessOrElse_=function(script){this.privateDoNotAccessOrElseSafeScriptWrappedValue_=script;return this;};goog.html.SafeScript.EMPTY=goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("");goog.html.SafeStyle=function(){this.privateDoNotAccessOrElseSafeStyleWrappedValue_="";this.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_=goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;};goog.html.SafeStyle.prototype.implementsGoogStringTypedString=!0;goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_={};goog.html.SafeStyle.fromConstant=function(style){var styleString=goog.string.Const.unwrap(style);if(0===styleString.length){return goog.html.SafeStyle.EMPTY;}goog.html.SafeStyle.checkStyle_(styleString);goog.asserts.assert(goog.string.endsWith(styleString,";"),"Last character of style string is not \';\': "+styleString);goog.asserts.assert(goog.string.contains(styleString,":"),"Style string must contain at least one \':\', to specify a \\"name: value\\" pair: "+styleString);return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(styleString);};goog.html.SafeStyle.checkStyle_=function(style){goog.asserts.assert(!/[<>]/.test(style),"Forbidden characters in style string: "+style);};goog.html.SafeStyle.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;};goog.DEBUG&&(goog.html.SafeStyle.prototype.toString=function(){return"SafeStyle{"+this.privateDoNotAccessOrElseSafeStyleWrappedValue_+"}";});goog.html.SafeStyle.unwrap=function(safeStyle){if(safeStyle instanceof goog.html.SafeStyle&&safeStyle.constructor===goog.html.SafeStyle&&safeStyle.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_===goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_){return safeStyle.privateDoNotAccessOrElseSafeStyleWrappedValue_;}goog.asserts.fail("expected object of type SafeStyle, got \'"+safeStyle+"\' of type "+goog.typeOf(safeStyle));return"type_error:SafeStyle";};goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse=function(style){return new goog.html.SafeStyle().initSecurityPrivateDoNotAccessOrElse_(style);};goog.html.SafeStyle.prototype.initSecurityPrivateDoNotAccessOrElse_=function(style){this.privateDoNotAccessOrElseSafeStyleWrappedValue_=style;return this;};goog.html.SafeStyle.EMPTY=goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse("");goog.html.SafeStyle.INNOCUOUS_STRING="zClosurez";goog.html.SafeStyle.create=function(map){var style="",name;for(name in map){if(!/^[-_a-zA-Z0-9]+$/.test(name)){throw Error("Name allows only [-_a-zA-Z0-9], got: "+name);}var value=map[name];null!=value&&(value instanceof goog.string.Const?(value=goog.string.Const.unwrap(value),goog.asserts.assert(!/[{;}]/.test(value),"Value does not allow [{;}].")):goog.html.SafeStyle.VALUE_RE_.test(value)?goog.html.SafeStyle.hasBalancedQuotes_(value)||(goog.asserts.fail("String value requires balanced quotes, got: "+value),value=goog.html.SafeStyle.INNOCUOUS_STRING):(goog.asserts.fail("String value allows only [-,.\\"\'%_!# a-zA-Z0-9], rgb() and rgba(), got: "+value),value=goog.html.SafeStyle.INNOCUOUS_STRING),style+=name+":"+value+";");}if(!style){return goog.html.SafeStyle.EMPTY;}goog.html.SafeStyle.checkStyle_(style);return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(style);};goog.html.SafeStyle.hasBalancedQuotes_=function(value){for(var outsideSingle=!0,outsideDouble=!0,i=0;i<value.length;i++){var c=value.charAt(i);"\'"==c&&outsideDouble?outsideSingle=!outsideSingle:\'"\'==c&&outsideSingle&&(outsideDouble=!outsideDouble);}return outsideSingle&&outsideDouble;};goog.html.SafeStyle.VALUE_RE_=/^([-,."\'%_!# a-zA-Z0-9]+|(?:rgb|hsl)a?\\([0-9.%, ]+\\))$/;goog.html.SafeStyle.concat=function(var_args){var style="",addArgument=function addArgument(argument){goog.isArray(argument)?goog.array.forEach(argument,addArgument):style+=goog.html.SafeStyle.unwrap(argument);};goog.array.forEach(arguments,addArgument);return style?goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(style):goog.html.SafeStyle.EMPTY;};goog.html.SafeStyleSheet=function(){this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_="";this.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_=goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;};goog.html.SafeStyleSheet.prototype.implementsGoogStringTypedString=!0;goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_={};goog.html.SafeStyleSheet.concat=function(var_args){var result="",addArgument=function addArgument(argument){goog.isArray(argument)?goog.array.forEach(argument,addArgument):result+=goog.html.SafeStyleSheet.unwrap(argument);};goog.array.forEach(arguments,addArgument);return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(result);};goog.html.SafeStyleSheet.fromConstant=function(styleSheet){var styleSheetString=goog.string.Const.unwrap(styleSheet);if(0===styleSheetString.length){return goog.html.SafeStyleSheet.EMPTY;}goog.asserts.assert(!goog.string.contains(styleSheetString,"<"),"Forbidden \'<\' character in style sheet string: "+styleSheetString);return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(styleSheetString);};goog.html.SafeStyleSheet.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;};goog.DEBUG&&(goog.html.SafeStyleSheet.prototype.toString=function(){return"SafeStyleSheet{"+this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_+"}";});goog.html.SafeStyleSheet.unwrap=function(safeStyleSheet){if(safeStyleSheet instanceof goog.html.SafeStyleSheet&&safeStyleSheet.constructor===goog.html.SafeStyleSheet&&safeStyleSheet.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_===goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_){return safeStyleSheet.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;}goog.asserts.fail("expected object of type SafeStyleSheet, got \'"+safeStyleSheet+"\' of type "+goog.typeOf(safeStyleSheet));return"type_error:SafeStyleSheet";};goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse=function(styleSheet){return new goog.html.SafeStyleSheet().initSecurityPrivateDoNotAccessOrElse_(styleSheet);};goog.html.SafeStyleSheet.prototype.initSecurityPrivateDoNotAccessOrElse_=function(styleSheet){this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_=styleSheet;return this;};goog.html.SafeStyleSheet.EMPTY=goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse("");goog.fs.url={};goog.fs.url.createObjectUrl=function(blob){return goog.fs.url.getUrlObject_().createObjectURL(blob);};goog.fs.url.revokeObjectUrl=function(url){goog.fs.url.getUrlObject_().revokeObjectURL(url);};goog.fs.url.getUrlObject_=function(){var urlObject=goog.fs.url.findUrlObject_();if(null!=urlObject){return urlObject;}throw Error("This browser doesn\'t seem to support blob URLs");};goog.fs.url.findUrlObject_=function(){return goog.isDef(goog.global.URL)&&goog.isDef(goog.global.URL.createObjectURL)?goog.global.URL:goog.isDef(goog.global.webkitURL)&&goog.isDef(goog.global.webkitURL.createObjectURL)?goog.global.webkitURL:goog.isDef(goog.global.createObjectURL)?goog.global:null;};goog.fs.url.browserSupportsObjectUrls=function(){return null!=goog.fs.url.findUrlObject_();};goog.i18n={};goog.i18n.bidi={};goog.i18n.bidi.FORCE_RTL=!1;goog.i18n.bidi.IS_RTL=goog.i18n.bidi.FORCE_RTL||("ar"==goog.LOCALE.substring(0,2).toLowerCase()||"fa"==goog.LOCALE.substring(0,2).toLowerCase()||"he"==goog.LOCALE.substring(0,2).toLowerCase()||"iw"==goog.LOCALE.substring(0,2).toLowerCase()||"ps"==goog.LOCALE.substring(0,2).toLowerCase()||"sd"==goog.LOCALE.substring(0,2).toLowerCase()||"ug"==goog.LOCALE.substring(0,2).toLowerCase()||"ur"==goog.LOCALE.substring(0,2).toLowerCase()||"yi"==goog.LOCALE.substring(0,2).toLowerCase())&&(2==goog.LOCALE.length||"-"==goog.LOCALE.substring(2,3)||"_"==goog.LOCALE.substring(2,3))||3<=goog.LOCALE.length&&"ckb"==goog.LOCALE.substring(0,3).toLowerCase()&&(3==goog.LOCALE.length||"-"==goog.LOCALE.substring(3,4)||"_"==goog.LOCALE.substring(3,4));goog.i18n.bidi.Format={LRE:"\\u202A",RLE:"\\u202B",PDF:"\\u202C",LRM:"\\u200E",RLM:"\\u200F"};goog.i18n.bidi.Dir={LTR:1,RTL:-1,NEUTRAL:0};goog.i18n.bidi.RIGHT="right";goog.i18n.bidi.LEFT="left";goog.i18n.bidi.I18N_RIGHT=goog.i18n.bidi.IS_RTL?goog.i18n.bidi.LEFT:goog.i18n.bidi.RIGHT;goog.i18n.bidi.I18N_LEFT=goog.i18n.bidi.IS_RTL?goog.i18n.bidi.RIGHT:goog.i18n.bidi.LEFT;goog.i18n.bidi.toDir=function(givenDir,opt_noNeutral){return"number"==typeof givenDir?0<givenDir?goog.i18n.bidi.Dir.LTR:0>givenDir?goog.i18n.bidi.Dir.RTL:opt_noNeutral?null:goog.i18n.bidi.Dir.NEUTRAL:null==givenDir?null:givenDir?goog.i18n.bidi.Dir.RTL:goog.i18n.bidi.Dir.LTR;};goog.i18n.bidi.ltrChars_="A-Za-z\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u02B8\\u0300-\\u0590\\u0800-\\u1FFF\\u200E\\u2C00-\\uFB1C\\uFE00-\\uFE6F\\uFEFD-\\uFFFF";goog.i18n.bidi.rtlChars_="\\u0591-\\u06EF\\u06FA-\\u07FF\\u200F\\uFB1D-\\uFDFF\\uFE70-\\uFEFC";goog.i18n.bidi.htmlSkipReg_=/<[^>]*>|&[^;]+;/g;goog.i18n.bidi.stripHtmlIfNeeded_=function(str,opt_isStripNeeded){return opt_isStripNeeded?str.replace(goog.i18n.bidi.htmlSkipReg_,""):str;};goog.i18n.bidi.rtlCharReg_=new RegExp("["+goog.i18n.bidi.rtlChars_+"]");goog.i18n.bidi.ltrCharReg_=new RegExp("["+goog.i18n.bidi.ltrChars_+"]");goog.i18n.bidi.hasAnyRtl=function(str,opt_isHtml){return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(str,opt_isHtml));};goog.i18n.bidi.hasRtlChar=goog.i18n.bidi.hasAnyRtl;goog.i18n.bidi.hasAnyLtr=function(str,opt_isHtml){return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(str,opt_isHtml));};goog.i18n.bidi.ltrRe_=new RegExp("^["+goog.i18n.bidi.ltrChars_+"]");goog.i18n.bidi.rtlRe_=new RegExp("^["+goog.i18n.bidi.rtlChars_+"]");goog.i18n.bidi.isRtlChar=function(str){return goog.i18n.bidi.rtlRe_.test(str);};goog.i18n.bidi.isLtrChar=function(str){return goog.i18n.bidi.ltrRe_.test(str);};goog.i18n.bidi.isNeutralChar=function(str){return!goog.i18n.bidi.isLtrChar(str)&&!goog.i18n.bidi.isRtlChar(str);};goog.i18n.bidi.ltrDirCheckRe_=new RegExp("^[^"+goog.i18n.bidi.rtlChars_+"]*["+goog.i18n.bidi.ltrChars_+"]");goog.i18n.bidi.rtlDirCheckRe_=new RegExp("^[^"+goog.i18n.bidi.ltrChars_+"]*["+goog.i18n.bidi.rtlChars_+"]");goog.i18n.bidi.startsWithRtl=function(str,opt_isHtml){return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(str,opt_isHtml));};goog.i18n.bidi.isRtlText=goog.i18n.bidi.startsWithRtl;goog.i18n.bidi.startsWithLtr=function(str,opt_isHtml){return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(str,opt_isHtml));};goog.i18n.bidi.isLtrText=goog.i18n.bidi.startsWithLtr;goog.i18n.bidi.isRequiredLtrRe_=/^http:\\/\\/.*/;goog.i18n.bidi.isNeutralText=function(str,opt_isHtml){str=goog.i18n.bidi.stripHtmlIfNeeded_(str,opt_isHtml);return goog.i18n.bidi.isRequiredLtrRe_.test(str)||!goog.i18n.bidi.hasAnyLtr(str)&&!goog.i18n.bidi.hasAnyRtl(str);};goog.i18n.bidi.ltrExitDirCheckRe_=new RegExp("["+goog.i18n.bidi.ltrChars_+"][^"+goog.i18n.bidi.rtlChars_+"]*$");goog.i18n.bidi.rtlExitDirCheckRe_=new RegExp("["+goog.i18n.bidi.rtlChars_+"][^"+goog.i18n.bidi.ltrChars_+"]*$");goog.i18n.bidi.endsWithLtr=function(str,opt_isHtml){return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(str,opt_isHtml));};goog.i18n.bidi.isLtrExitText=goog.i18n.bidi.endsWithLtr;goog.i18n.bidi.endsWithRtl=function(str,opt_isHtml){return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(str,opt_isHtml));};goog.i18n.bidi.isRtlExitText=goog.i18n.bidi.endsWithRtl;goog.i18n.bidi.rtlLocalesRe_=/^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Arab|Hebr|Thaa|Nkoo|Tfng))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i;goog.i18n.bidi.isRtlLanguage=function(lang){return goog.i18n.bidi.rtlLocalesRe_.test(lang);};goog.i18n.bidi.bracketGuardTextRe_=/(\\(.*?\\)+)|(\\[.*?\\]+)|(\\{.*?\\}+)|(<.*?>+)/g;goog.i18n.bidi.guardBracketInText=function(s,opt_isRtlContext){var mark=(void 0===opt_isRtlContext?goog.i18n.bidi.hasAnyRtl(s):opt_isRtlContext)?goog.i18n.bidi.Format.RLM:goog.i18n.bidi.Format.LRM;return s.replace(goog.i18n.bidi.bracketGuardTextRe_,mark+"$&"+mark);};goog.i18n.bidi.enforceRtlInHtml=function(html){return"<"==html.charAt(0)?html.replace(/<\\w+/,"$& dir=rtl"):"\\n<span dir=rtl>"+html+"</span>";};goog.i18n.bidi.enforceRtlInText=function(text){return goog.i18n.bidi.Format.RLE+text+goog.i18n.bidi.Format.PDF;};goog.i18n.bidi.enforceLtrInHtml=function(html){return"<"==html.charAt(0)?html.replace(/<\\w+/,"$& dir=ltr"):"\\n<span dir=ltr>"+html+"</span>";};goog.i18n.bidi.enforceLtrInText=function(text){return goog.i18n.bidi.Format.LRE+text+goog.i18n.bidi.Format.PDF;};goog.i18n.bidi.dimensionsRe_=/:\\s*([.\\d][.\\w]*)\\s+([.\\d][.\\w]*)\\s+([.\\d][.\\w]*)\\s+([.\\d][.\\w]*)/g;goog.i18n.bidi.leftRe_=/left/gi;goog.i18n.bidi.rightRe_=/right/gi;goog.i18n.bidi.tempRe_=/%%%%/g;goog.i18n.bidi.mirrorCSS=function(cssStr){return cssStr.replace(goog.i18n.bidi.dimensionsRe_,":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_,"%%%%").replace(goog.i18n.bidi.rightRe_,goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_,goog.i18n.bidi.RIGHT);};goog.i18n.bidi.doubleQuoteSubstituteRe_=/([\\u0591-\\u05f2])"/g;goog.i18n.bidi.singleQuoteSubstituteRe_=/([\\u0591-\\u05f2])\'/g;goog.i18n.bidi.normalizeHebrewQuote=function(str){return str.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_,"$1\\u05F4").replace(goog.i18n.bidi.singleQuoteSubstituteRe_,"$1\\u05F3");};goog.i18n.bidi.wordSeparatorRe_=/\\s+/;goog.i18n.bidi.hasNumeralsRe_=/[\\d\\u06f0-\\u06f9]/;goog.i18n.bidi.rtlDetectionThreshold_=0.40;goog.i18n.bidi.estimateDirection=function(str,opt_isHtml){for(var rtlCount=0,totalCount=0,hasWeaklyLtr=!1,tokens=goog.i18n.bidi.stripHtmlIfNeeded_(str,opt_isHtml).split(goog.i18n.bidi.wordSeparatorRe_),i=0;i<tokens.length;i++){var token=tokens[i];goog.i18n.bidi.startsWithRtl(token)?(rtlCount++,totalCount++):goog.i18n.bidi.isRequiredLtrRe_.test(token)?hasWeaklyLtr=!0:goog.i18n.bidi.hasAnyLtr(token)?totalCount++:goog.i18n.bidi.hasNumeralsRe_.test(token)&&(hasWeaklyLtr=!0);}return 0==totalCount?hasWeaklyLtr?goog.i18n.bidi.Dir.LTR:goog.i18n.bidi.Dir.NEUTRAL:rtlCount/totalCount>goog.i18n.bidi.rtlDetectionThreshold_?goog.i18n.bidi.Dir.RTL:goog.i18n.bidi.Dir.LTR;};goog.i18n.bidi.detectRtlDirectionality=function(str,opt_isHtml){return goog.i18n.bidi.estimateDirection(str,opt_isHtml)==goog.i18n.bidi.Dir.RTL;};goog.i18n.bidi.setElementDirAndAlign=function(element,dir){element&&(dir=goog.i18n.bidi.toDir(dir))&&(element.style.textAlign=dir==goog.i18n.bidi.Dir.RTL?goog.i18n.bidi.RIGHT:goog.i18n.bidi.LEFT,element.dir=dir==goog.i18n.bidi.Dir.RTL?"rtl":"ltr");};goog.i18n.bidi.setElementDirByTextDirectionality=function(element,text){switch(goog.i18n.bidi.estimateDirection(text)){case goog.i18n.bidi.Dir.LTR:element.dir="ltr";break;case goog.i18n.bidi.Dir.RTL:element.dir="rtl";break;default:element.removeAttribute("dir");}};goog.i18n.bidi.DirectionalString=function(){};goog.html.TrustedResourceUrl=function(){this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_="";this.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_=goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;};goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString=!0;goog.html.TrustedResourceUrl.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_;};goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString=!0;goog.html.TrustedResourceUrl.prototype.getDirection=function(){return goog.i18n.bidi.Dir.LTR;};goog.DEBUG&&(goog.html.TrustedResourceUrl.prototype.toString=function(){return"TrustedResourceUrl{"+this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_+"}";});goog.html.TrustedResourceUrl.unwrap=function(trustedResourceUrl){if(trustedResourceUrl instanceof goog.html.TrustedResourceUrl&&trustedResourceUrl.constructor===goog.html.TrustedResourceUrl&&trustedResourceUrl.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_===goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_){return trustedResourceUrl.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_;}goog.asserts.fail("expected object of type TrustedResourceUrl, got \'"+trustedResourceUrl+"\' of type "+goog.typeOf(trustedResourceUrl));return"type_error:TrustedResourceUrl";};goog.html.TrustedResourceUrl.format=function(format,args){var formatStr=goog.string.Const.unwrap(format);if(!goog.html.TrustedResourceUrl.BASE_URL_.test(formatStr)){throw Error("Invalid TrustedResourceUrl format: "+formatStr);}var result=formatStr.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_,function(match,id){if(!Object.prototype.hasOwnProperty.call(args,id)){throw Error(\'Found marker, "\'+id+\'", in format string, "\'+formatStr+\'", but no valid label mapping found in args: \'+JSON.stringify(args));}var arg=args[id];return arg instanceof goog.string.Const?goog.string.Const.unwrap(arg):encodeURIComponent(String(arg));});return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(result);};goog.html.TrustedResourceUrl.FORMAT_MARKER_=/%{(\\w+)}/g;goog.html.TrustedResourceUrl.BASE_URL_=/^(?:https:)?\\/\\/[0-9a-z.:[\\]-]+\\/|^\\/[^\\/\\\\]|^about:blank(#|$)/i;goog.html.TrustedResourceUrl.fromConstant=function(url){return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(url));};goog.html.TrustedResourceUrl.fromConstants=function(parts){for(var unwrapped="",i=0;i<parts.length;i++){unwrapped+=goog.string.Const.unwrap(parts[i]);}return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(unwrapped);};goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_={};goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse=function(url){var trustedResourceUrl=new goog.html.TrustedResourceUrl();trustedResourceUrl.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_=url;return trustedResourceUrl;};goog.html.SafeUrl=function(){this.privateDoNotAccessOrElseSafeHtmlWrappedValue_="";this.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_=goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;};goog.html.SafeUrl.INNOCUOUS_STRING="about:invalid#zClosurez";goog.html.SafeUrl.prototype.implementsGoogStringTypedString=!0;goog.html.SafeUrl.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_;};goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString=!0;goog.html.SafeUrl.prototype.getDirection=function(){return goog.i18n.bidi.Dir.LTR;};goog.DEBUG&&(goog.html.SafeUrl.prototype.toString=function(){return"SafeUrl{"+this.privateDoNotAccessOrElseSafeHtmlWrappedValue_+"}";});goog.html.SafeUrl.unwrap=function(safeUrl){if(safeUrl instanceof goog.html.SafeUrl&&safeUrl.constructor===goog.html.SafeUrl&&safeUrl.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_===goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_){return safeUrl.privateDoNotAccessOrElseSafeHtmlWrappedValue_;}goog.asserts.fail("expected object of type SafeUrl, got \'"+safeUrl+"\' of type "+goog.typeOf(safeUrl));return"type_error:SafeUrl";};goog.html.SafeUrl.fromConstant=function(url){return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(url));};goog.html.SAFE_MIME_TYPE_PATTERN_=/^(?:image\\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\\/(?:mpeg|mp4|ogg|webm))$/i;goog.html.SafeUrl.fromBlob=function(blob){var url=goog.html.SAFE_MIME_TYPE_PATTERN_.test(blob.type)?goog.fs.url.createObjectUrl(blob):goog.html.SafeUrl.INNOCUOUS_STRING;return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(url);};goog.html.DATA_URL_PATTERN_=/^data:([^;,]*);base64,[a-z0-9+\\/]+=*$/i;goog.html.SafeUrl.fromDataUrl=function(dataUrl){var match=dataUrl.match(goog.html.DATA_URL_PATTERN_),valid=match&&goog.html.SAFE_MIME_TYPE_PATTERN_.test(match[1]);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(valid?dataUrl:goog.html.SafeUrl.INNOCUOUS_STRING);};goog.html.SafeUrl.fromTelUrl=function(telUrl){goog.string.caseInsensitiveStartsWith(telUrl,"tel:")||(telUrl=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(telUrl);};goog.html.SafeUrl.fromTrustedResourceUrl=function(trustedResourceUrl){return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(trustedResourceUrl));};goog.html.SAFE_URL_PATTERN_=/^(?:(?:https?|mailto|ftp):|[^&:/?#]*(?:[/?#]|$))/i;goog.html.SafeUrl.sanitize=function(url){if(url instanceof goog.html.SafeUrl){return url;}url=url.implementsGoogStringTypedString?url.getTypedStringValue():String(url);goog.html.SAFE_URL_PATTERN_.test(url)||(url=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(url);};goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_={};goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse=function(url){var safeUrl=new goog.html.SafeUrl();safeUrl.privateDoNotAccessOrElseSafeHtmlWrappedValue_=url;return safeUrl;};goog.html.SafeUrl.ABOUT_BLANK=goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank");goog.html.SafeHtml=function(){this.privateDoNotAccessOrElseSafeHtmlWrappedValue_="";this.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_=goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;this.dir_=null;};goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString=!0;goog.html.SafeHtml.prototype.getDirection=function(){return this.dir_;};goog.html.SafeHtml.prototype.implementsGoogStringTypedString=!0;goog.html.SafeHtml.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_;};goog.DEBUG&&(goog.html.SafeHtml.prototype.toString=function(){return"SafeHtml{"+this.privateDoNotAccessOrElseSafeHtmlWrappedValue_+"}";});goog.html.SafeHtml.unwrap=function(safeHtml){if(safeHtml instanceof goog.html.SafeHtml&&safeHtml.constructor===goog.html.SafeHtml&&safeHtml.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_===goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_){return safeHtml.privateDoNotAccessOrElseSafeHtmlWrappedValue_;}goog.asserts.fail("expected object of type SafeHtml, got \'"+safeHtml+"\' of type "+goog.typeOf(safeHtml));return"type_error:SafeHtml";};goog.html.SafeHtml.htmlEscape=function(textOrHtml){if(textOrHtml instanceof goog.html.SafeHtml){return textOrHtml;}var dir=null;textOrHtml.implementsGoogI18nBidiDirectionalString&&(dir=textOrHtml.getDirection());return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.htmlEscape(textOrHtml.implementsGoogStringTypedString?textOrHtml.getTypedStringValue():String(textOrHtml)),dir);};goog.html.SafeHtml.htmlEscapePreservingNewlines=function(textOrHtml){if(textOrHtml instanceof goog.html.SafeHtml){return textOrHtml;}var html=goog.html.SafeHtml.htmlEscape(textOrHtml);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.newLineToBr(goog.html.SafeHtml.unwrap(html)),html.getDirection());};goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces=function(textOrHtml){if(textOrHtml instanceof goog.html.SafeHtml){return textOrHtml;}var html=goog.html.SafeHtml.htmlEscape(textOrHtml);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.whitespaceEscape(goog.html.SafeHtml.unwrap(html)),html.getDirection());};goog.html.SafeHtml.from=goog.html.SafeHtml.htmlEscape;goog.html.SafeHtml.VALID_NAMES_IN_TAG_=/^[a-zA-Z0-9-]+$/;goog.html.SafeHtml.URL_ATTRIBUTES_={action:!0,cite:!0,data:!0,formaction:!0,href:!0,manifest:!0,poster:!0,src:!0};goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_={APPLET:!0,BASE:!0,EMBED:!0,IFRAME:!0,LINK:!0,MATH:!0,META:!0,OBJECT:!0,SCRIPT:!0,STYLE:!0,SVG:!0,TEMPLATE:!0};goog.html.SafeHtml.create=function(tagName,opt_attributes,opt_content){goog.html.SafeHtml.verifyTagName(String(tagName));return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(tagName),opt_attributes,opt_content);};goog.html.SafeHtml.verifyTagName=function(tagName){if(!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(tagName)){throw Error("Invalid tag name <"+tagName+">.");}if(tagName.toUpperCase()in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_){throw Error("Tag name <"+tagName+"> is not allowed for SafeHtml.");}};goog.html.SafeHtml.createIframe=function(opt_src,opt_srcdoc,opt_attributes,opt_content){opt_src&&goog.html.TrustedResourceUrl.unwrap(opt_src);var fixedAttributes={};fixedAttributes.src=opt_src||null;fixedAttributes.srcdoc=opt_srcdoc&&goog.html.SafeHtml.unwrap(opt_srcdoc);var attributes=goog.html.SafeHtml.combineAttributes(fixedAttributes,{sandbox:""},opt_attributes);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe",attributes,opt_content);};goog.html.SafeHtml.createSandboxIframe=function(opt_src,opt_srcdoc,opt_attributes,opt_content){if(!goog.html.SafeHtml.canUseSandboxIframe()){throw Error("The browser does not support sandboxed iframes.");}var fixedAttributes={};fixedAttributes.src=opt_src?goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(opt_src)):null;fixedAttributes.srcdoc=opt_srcdoc||null;fixedAttributes.sandbox="";var attributes=goog.html.SafeHtml.combineAttributes(fixedAttributes,{},opt_attributes);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe",attributes,opt_content);};goog.html.SafeHtml.canUseSandboxIframe=function(){return goog.global.HTMLIFrameElement&&"sandbox"in goog.global.HTMLIFrameElement.prototype;};goog.html.SafeHtml.createScriptSrc=function(src,opt_attributes){goog.html.TrustedResourceUrl.unwrap(src);var attributes=goog.html.SafeHtml.combineAttributes({src:src},{},opt_attributes);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script",attributes);};goog.html.SafeHtml.createScript=function(script,opt_attributes){for(var attr in opt_attributes){var attrLower=attr.toLowerCase();if("language"==attrLower||"src"==attrLower||"text"==attrLower||"type"==attrLower){throw Error(\'Cannot set "\'+attrLower+\'" attribute\');}}var content="";script=goog.array.concat(script);for(var i=0;i<script.length;i++){content+=goog.html.SafeScript.unwrap(script[i]);}var htmlContent=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(content,goog.i18n.bidi.Dir.NEUTRAL);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script",opt_attributes,htmlContent);};goog.html.SafeHtml.createStyle=function(styleSheet,opt_attributes){var attributes=goog.html.SafeHtml.combineAttributes({type:"text/css"},{},opt_attributes),content="";styleSheet=goog.array.concat(styleSheet);for(var i=0;i<styleSheet.length;i++){content+=goog.html.SafeStyleSheet.unwrap(styleSheet[i]);}var htmlContent=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(content,goog.i18n.bidi.Dir.NEUTRAL);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style",attributes,htmlContent);};goog.html.SafeHtml.createMetaRefresh=function(url,opt_secs){var unwrappedUrl=goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(url));(goog.labs.userAgent.browser.isIE()||goog.labs.userAgent.browser.isEdge())&&goog.string.contains(unwrappedUrl,";")&&(unwrappedUrl="\'"+unwrappedUrl.replace(/\'/g,"%27")+"\'");return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta",{"http-equiv":"refresh",content:(opt_secs||0)+"; url="+unwrappedUrl});};goog.html.SafeHtml.getAttrNameAndValue_=function(tagName,name,value){if(value instanceof goog.string.Const){value=goog.string.Const.unwrap(value);}else{if("style"==name.toLowerCase()){value=goog.html.SafeHtml.getStyleValue_(value);}else{if(/^on/i.test(name)){throw Error(\'Attribute "\'+name+\'" requires goog.string.Const value, "\'+value+\'" given.\');}if(name.toLowerCase()in goog.html.SafeHtml.URL_ATTRIBUTES_){if(value instanceof goog.html.TrustedResourceUrl){value=goog.html.TrustedResourceUrl.unwrap(value);}else{if(value instanceof goog.html.SafeUrl){value=goog.html.SafeUrl.unwrap(value);}else{if(goog.isString(value)){value=goog.html.SafeUrl.sanitize(value).getTypedStringValue();}else{throw Error(\'Attribute "\'+name+\'" on tag "\'+tagName+\'" requires goog.html.SafeUrl, goog.string.Const, or string, value "\'+value+\'" given.\');}}}}}}value.implementsGoogStringTypedString&&(value=value.getTypedStringValue());goog.asserts.assert(goog.isString(value)||goog.isNumber(value),"String or number value expected, got "+(typeof value==="undefined"?"undefined":_typeof(value))+" with value: "+value);return name+\'="\'+goog.string.htmlEscape(String(value))+\'"\';};goog.html.SafeHtml.getStyleValue_=function(value){if(!goog.isObject(value)){throw Error(\'The "style" attribute requires goog.html.SafeStyle or map of style properties, \'+(typeof value==="undefined"?"undefined":_typeof(value))+" given: "+value);}value instanceof goog.html.SafeStyle||(value=goog.html.SafeStyle.create(value));return goog.html.SafeStyle.unwrap(value);};goog.html.SafeHtml.createWithDir=function(dir,tagName,opt_attributes,opt_content){var html=goog.html.SafeHtml.create(tagName,opt_attributes,opt_content);html.dir_=dir;return html;};goog.html.SafeHtml.concat=function(var_args){var dir=goog.i18n.bidi.Dir.NEUTRAL,content="",addArgument=function addArgument(argument){if(goog.isArray(argument)){goog.array.forEach(argument,addArgument);}else{var html=goog.html.SafeHtml.htmlEscape(argument);content+=goog.html.SafeHtml.unwrap(html);var htmlDir=html.getDirection();dir==goog.i18n.bidi.Dir.NEUTRAL?dir=htmlDir:htmlDir!=goog.i18n.bidi.Dir.NEUTRAL&&dir!=htmlDir&&(dir=null);}};goog.array.forEach(arguments,addArgument);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(content,dir);};goog.html.SafeHtml.concatWithDir=function(dir,var_args){var html=goog.html.SafeHtml.concat(goog.array.slice(arguments,1));html.dir_=dir;return html;};goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_={};goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse=function(html,dir){return new goog.html.SafeHtml().initSecurityPrivateDoNotAccessOrElse_(html,dir);};goog.html.SafeHtml.prototype.initSecurityPrivateDoNotAccessOrElse_=function(html,dir){this.privateDoNotAccessOrElseSafeHtmlWrappedValue_=html;this.dir_=dir;return this;};goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse=function(tagName,opt_attributes,opt_content){var dir=null;var result="<"+tagName+goog.html.SafeHtml.stringifyAttributes(tagName,opt_attributes);var content=opt_content;goog.isDefAndNotNull(content)?goog.isArray(content)||(content=[content]):content=[];if(goog.dom.tags.isVoidTag(tagName.toLowerCase())){goog.asserts.assert(!content.length,"Void tag <"+tagName+"> does not allow content."),result+=">";}else{var html=goog.html.SafeHtml.concat(content);result+=">"+goog.html.SafeHtml.unwrap(html)+"</"+tagName+">";dir=html.getDirection();}var dirAttribute=opt_attributes&&opt_attributes.dir;dirAttribute&&(dir=/^(ltr|rtl|auto)$/i.test(dirAttribute)?goog.i18n.bidi.Dir.NEUTRAL:null);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(result,dir);};goog.html.SafeHtml.stringifyAttributes=function(tagName,opt_attributes){var result="";if(opt_attributes){for(var name in opt_attributes){if(!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(name)){throw Error(\'Invalid attribute name "\'+name+\'".\');}var value=opt_attributes[name];goog.isDefAndNotNull(value)&&(result+=" "+goog.html.SafeHtml.getAttrNameAndValue_(tagName,name,value));}}return result;};goog.html.SafeHtml.combineAttributes=function(fixedAttributes,defaultAttributes,opt_attributes){var combinedAttributes={},name;for(name in fixedAttributes){goog.asserts.assert(name.toLowerCase()==name,"Must be lower case"),combinedAttributes[name]=fixedAttributes[name];}for(name in defaultAttributes){goog.asserts.assert(name.toLowerCase()==name,"Must be lower case"),combinedAttributes[name]=defaultAttributes[name];}for(name in opt_attributes){var nameLower=name.toLowerCase();if(nameLower in fixedAttributes){throw Error(\'Cannot override "\'+nameLower+\'" attribute, got "\'+name+\'" with value "\'+opt_attributes[name]+\'"\');}nameLower in defaultAttributes&&delete combinedAttributes[nameLower];combinedAttributes[name]=opt_attributes[name];}return combinedAttributes;};goog.html.SafeHtml.DOCTYPE_HTML=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>",goog.i18n.bidi.Dir.NEUTRAL);goog.html.SafeHtml.EMPTY=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("",goog.i18n.bidi.Dir.NEUTRAL);goog.html.SafeHtml.BR=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>",goog.i18n.bidi.Dir.NEUTRAL);goog.dom.safe={};goog.dom.safe.InsertAdjacentHtmlPosition={AFTERBEGIN:"afterbegin",AFTEREND:"afterend",BEFOREBEGIN:"beforebegin",BEFOREEND:"beforeend"};goog.dom.safe.insertAdjacentHtml=function(node,position,html){node.insertAdjacentHTML(position,goog.html.SafeHtml.unwrap(html));};goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_={MATH:!0,SCRIPT:!0,STYLE:!0,SVG:!0,TEMPLATE:!0};goog.dom.safe.setInnerHtml=function(elem,html){if(goog.asserts.ENABLE_ASSERTS&&goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[elem.tagName.toUpperCase()]){throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of "+elem.tagName+".");}elem.innerHTML=goog.html.SafeHtml.unwrap(html);};goog.dom.safe.setOuterHtml=function(elem,html){elem.outerHTML=goog.html.SafeHtml.unwrap(html);};goog.dom.safe.setStyle=function(elem,style){elem.style.cssText=goog.html.SafeStyle.unwrap(style);};goog.dom.safe.documentWrite=function(doc,html){doc.write(goog.html.SafeHtml.unwrap(html));};goog.dom.safe.setAnchorHref=function(anchor,url){goog.dom.safe.assertIsHTMLAnchorElement_(anchor);var safeUrl=url instanceof goog.html.SafeUrl?url:goog.html.SafeUrl.sanitize(url);anchor.href=goog.html.SafeUrl.unwrap(safeUrl);};goog.dom.safe.setImageSrc=function(imageElement,url){goog.dom.safe.assertIsHTMLImageElement_(imageElement);var safeUrl=url instanceof goog.html.SafeUrl?url:goog.html.SafeUrl.sanitize(url);imageElement.src=goog.html.SafeUrl.unwrap(safeUrl);};goog.dom.safe.setEmbedSrc=function(embed,url){goog.dom.safe.assertIsHTMLEmbedElement_(embed);embed.src=goog.html.TrustedResourceUrl.unwrap(url);};goog.dom.safe.setFrameSrc=function(frame,url){goog.dom.safe.assertIsHTMLFrameElement_(frame);frame.src=goog.html.TrustedResourceUrl.unwrap(url);};goog.dom.safe.setIframeSrc=function(iframe,url){goog.dom.safe.assertIsHTMLIFrameElement_(iframe);iframe.src=goog.html.TrustedResourceUrl.unwrap(url);};goog.dom.safe.setIframeSrcdoc=function(iframe,html){goog.dom.safe.assertIsHTMLIFrameElement_(iframe);iframe.srcdoc=goog.html.SafeHtml.unwrap(html);};goog.dom.safe.setLinkHrefAndRel=function(link,url,rel){goog.dom.safe.assertIsHTMLLinkElement_(link);link.rel=rel;goog.string.caseInsensitiveContains(rel,"stylesheet")?(goog.asserts.assert(url instanceof goog.html.TrustedResourceUrl,\'URL must be TrustedResourceUrl because "rel" contains "stylesheet"\'),link.href=goog.html.TrustedResourceUrl.unwrap(url)):link.href=url instanceof goog.html.TrustedResourceUrl?goog.html.TrustedResourceUrl.unwrap(url):url instanceof goog.html.SafeUrl?goog.html.SafeUrl.unwrap(url):goog.html.SafeUrl.sanitize(url).getTypedStringValue();};goog.dom.safe.setObjectData=function(object,url){goog.dom.safe.assertIsHTMLObjectElement_(object);object.data=goog.html.TrustedResourceUrl.unwrap(url);};goog.dom.safe.setScriptSrc=function(script,url){goog.dom.safe.assertIsHTMLScriptElement_(script);script.src=goog.html.TrustedResourceUrl.unwrap(url);};goog.dom.safe.setScriptContent=function(script,content){goog.dom.safe.assertIsHTMLScriptElement_(script);script.text=goog.html.SafeScript.unwrap(content);};goog.dom.safe.setLocationHref=function(loc,url){goog.dom.safe.assertIsLocation_(loc);var safeUrl=url instanceof goog.html.SafeUrl?url:goog.html.SafeUrl.sanitize(url);loc.href=goog.html.SafeUrl.unwrap(safeUrl);};goog.dom.safe.openInWindow=function(url,opt_openerWin,opt_name,opt_specs,opt_replace){var safeUrl=url instanceof goog.html.SafeUrl?url:goog.html.SafeUrl.sanitize(url);return(opt_openerWin||window).open(goog.html.SafeUrl.unwrap(safeUrl),opt_name?goog.string.Const.unwrap(opt_name):"",opt_specs,opt_replace);};goog.dom.safe.assertIsLocation_=function(o){goog.asserts.ENABLE_ASSERTS&&"undefined"!=typeof Location&&"undefined"!=typeof Element&&goog.asserts.assert(o&&(o instanceof Location||!(o instanceof Element)),"Argument is not a Location (or a non-Element mock); got: %s",goog.dom.safe.debugStringForType_(o));return o;};goog.dom.safe.assertIsHTMLAnchorElement_=function(o){goog.asserts.ENABLE_ASSERTS&&"undefined"!=typeof HTMLAnchorElement&&"undefined"!=typeof Location&&"undefined"!=typeof Element&&goog.asserts.assert(o&&(o instanceof HTMLAnchorElement||!(o instanceof Location||o instanceof Element)),"Argument is not a HTMLAnchorElement (or a non-Element mock); got: %s",goog.dom.safe.debugStringForType_(o));return o;};goog.dom.safe.assertIsHTMLLinkElement_=function(o){goog.asserts.ENABLE_ASSERTS&&"undefined"!=typeof HTMLLinkElement&&"undefined"!=typeof Location&&"undefined"!=typeof Element&&goog.asserts.assert(o&&(o instanceof HTMLLinkElement||!(o instanceof Location||o instanceof Element)),"Argument is not a HTMLLinkElement (or a non-Element mock); got: %s",goog.dom.safe.debugStringForType_(o));return o;};goog.dom.safe.assertIsHTMLImageElement_=function(o){goog.asserts.ENABLE_ASSERTS&&"undefined"!=typeof HTMLImageElement&&"undefined"!=typeof Element&&goog.asserts.assert(o&&(o instanceof HTMLImageElement||!(o instanceof Element)),"Argument is not a HTMLImageElement (or a non-Element mock); got: %s",goog.dom.safe.debugStringForType_(o));return o;};goog.dom.safe.assertIsHTMLEmbedElement_=function(o){goog.asserts.ENABLE_ASSERTS&&"undefined"!=typeof HTMLEmbedElement&&"undefined"!=typeof Element&&goog.asserts.assert(o&&(o instanceof HTMLEmbedElement||!(o instanceof Element)),"Argument is not a HTMLEmbedElement (or a non-Element mock); got: %s",goog.dom.safe.debugStringForType_(o));return o;};goog.dom.safe.assertIsHTMLFrameElement_=function(o){goog.asserts.ENABLE_ASSERTS&&"undefined"!=typeof HTMLFrameElement&&"undefined"!=typeof Element&&goog.asserts.assert(o&&(o instanceof HTMLFrameElement||!(o instanceof Element)),"Argument is not a HTMLFrameElement (or a non-Element mock); got: %s",goog.dom.safe.debugStringForType_(o));return o;};goog.dom.safe.assertIsHTMLIFrameElement_=function(o){goog.asserts.ENABLE_ASSERTS&&"undefined"!=typeof HTMLIFrameElement&&"undefined"!=typeof Element&&goog.asserts.assert(o&&(o instanceof HTMLIFrameElement||!(o instanceof Element)),"Argument is not a HTMLIFrameElement (or a non-Element mock); got: %s",goog.dom.safe.debugStringForType_(o));return o;};goog.dom.safe.assertIsHTMLObjectElement_=function(o){goog.asserts.ENABLE_ASSERTS&&"undefined"!=typeof HTMLObjectElement&&"undefined"!=typeof Element&&goog.asserts.assert(o&&(o instanceof HTMLObjectElement||!(o instanceof Element)),"Argument is not a HTMLObjectElement (or a non-Element mock); got: %s",goog.dom.safe.debugStringForType_(o));return o;};goog.dom.safe.assertIsHTMLScriptElement_=function(o){goog.asserts.ENABLE_ASSERTS&&"undefined"!=typeof HTMLScriptElement&&"undefined"!=typeof Element&&goog.asserts.assert(o&&(o instanceof HTMLScriptElement||!(o instanceof Element)),"Argument is not a HTMLScriptElement (or a non-Element mock); got: %s",goog.dom.safe.debugStringForType_(o));return o;};goog.dom.safe.debugStringForType_=function(value){return goog.isObject(value)?value.constructor.displayName||value.constructor.name||Object.prototype.toString.call(value):void 0===value?"undefined":null===value?"null":typeof value==="undefined"?"undefined":_typeof(value);};goog.html.uncheckedconversions={};goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract=function(justification,html,opt_dir){goog.asserts.assertString(goog.string.Const.unwrap(justification),"must provide justification");goog.asserts.assert(!goog.string.isEmptyOrWhitespace(goog.string.Const.unwrap(justification)),"must provide non-empty justification");return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(html,opt_dir||null);};goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract=function(justification,script){goog.asserts.assertString(goog.string.Const.unwrap(justification),"must provide justification");goog.asserts.assert(!goog.string.isEmptyOrWhitespace(goog.string.Const.unwrap(justification)),"must provide non-empty justification");return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(script);};goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract=function(justification,style){goog.asserts.assertString(goog.string.Const.unwrap(justification),"must provide justification");goog.asserts.assert(!goog.string.isEmptyOrWhitespace(goog.string.Const.unwrap(justification)),"must provide non-empty justification");return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(style);};goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract=function(justification,styleSheet){goog.asserts.assertString(goog.string.Const.unwrap(justification),"must provide justification");goog.asserts.assert(!goog.string.isEmptyOrWhitespace(goog.string.Const.unwrap(justification)),"must provide non-empty justification");return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(styleSheet);};goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract=function(justification,url){goog.asserts.assertString(goog.string.Const.unwrap(justification),"must provide justification");goog.asserts.assert(!goog.string.isEmptyOrWhitespace(goog.string.Const.unwrap(justification)),"must provide non-empty justification");return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(url);};goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract=function(justification,url){goog.asserts.assertString(goog.string.Const.unwrap(justification),"must provide justification");goog.asserts.assert(!goog.string.isEmptyOrWhitespace(goog.string.Const.unwrap(justification)),"must provide non-empty justification");return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(url);};goog.math.Coordinate=function(opt_x,opt_y){this.x=goog.isDef(opt_x)?opt_x:0;this.y=goog.isDef(opt_y)?opt_y:0;};goog.math.Coordinate.prototype.clone=function(){return new goog.math.Coordinate(this.x,this.y);};goog.DEBUG&&(goog.math.Coordinate.prototype.toString=function(){return"("+this.x+", "+this.y+")";});goog.math.Coordinate.prototype.equals=function(other){return other instanceof goog.math.Coordinate&&goog.math.Coordinate.equals(this,other);};goog.math.Coordinate.equals=function(a,b){return a==b?!0:a&&b?a.x==b.x&&a.y==b.y:!1;};goog.math.Coordinate.distance=function(a,b){var dx=a.x-b.x,dy=a.y-b.y;return Math.sqrt(dx*dx+dy*dy);};goog.math.Coordinate.magnitude=function(a){return Math.sqrt(a.x*a.x+a.y*a.y);};goog.math.Coordinate.azimuth=function(a){return goog.math.angle(0,0,a.x,a.y);};goog.math.Coordinate.squaredDistance=function(a,b){var dx=a.x-b.x,dy=a.y-b.y;return dx*dx+dy*dy;};goog.math.Coordinate.difference=function(a,b){return new goog.math.Coordinate(a.x-b.x,a.y-b.y);};goog.math.Coordinate.sum=function(a,b){return new goog.math.Coordinate(a.x+b.x,a.y+b.y);};goog.math.Coordinate.prototype.ceil=function(){this.x=Math.ceil(this.x);this.y=Math.ceil(this.y);return this;};goog.math.Coordinate.prototype.floor=function(){this.x=Math.floor(this.x);this.y=Math.floor(this.y);return this;};goog.math.Coordinate.prototype.round=function(){this.x=Math.round(this.x);this.y=Math.round(this.y);return this;};goog.math.Coordinate.prototype.translate=function(tx,opt_ty){tx instanceof goog.math.Coordinate?(this.x+=tx.x,this.y+=tx.y):(this.x+=Number(tx),goog.isNumber(opt_ty)&&(this.y+=opt_ty));return this;};goog.math.Coordinate.prototype.scale=function(sx,opt_sy){var sy=goog.isNumber(opt_sy)?opt_sy:sx;this.x*=sx;this.y*=sy;return this;};goog.math.Coordinate.prototype.rotateRadians=function(radians,opt_center){var center=opt_center||new goog.math.Coordinate(0,0),x=this.x,y=this.y,cos=Math.cos(radians),sin=Math.sin(radians);this.x=(x-center.x)*cos-(y-center.y)*sin+center.x;this.y=(x-center.x)*sin+(y-center.y)*cos+center.y;};goog.math.Coordinate.prototype.rotateDegrees=function(degrees,opt_center){this.rotateRadians(goog.math.toRadians(degrees),opt_center);};goog.math.Size=function(width,height){this.width=width;this.height=height;};goog.math.Size.equals=function(a,b){return a==b?!0:a&&b?a.width==b.width&&a.height==b.height:!1;};goog.math.Size.prototype.clone=function(){return new goog.math.Size(this.width,this.height);};goog.DEBUG&&(goog.math.Size.prototype.toString=function(){return"("+this.width+" x "+this.height+")";});goog.math.Size.prototype.getLongest=function(){return Math.max(this.width,this.height);};goog.math.Size.prototype.getShortest=function(){return Math.min(this.width,this.height);};goog.math.Size.prototype.area=function(){return this.width*this.height;};goog.math.Size.prototype.perimeter=function(){return 2*(this.width+this.height);};goog.math.Size.prototype.aspectRatio=function(){return this.width/this.height;};goog.math.Size.prototype.isEmpty=function(){return!this.area();};goog.math.Size.prototype.ceil=function(){this.width=Math.ceil(this.width);this.height=Math.ceil(this.height);return this;};goog.math.Size.prototype.fitsInside=function(target){return this.width<=target.width&&this.height<=target.height;};goog.math.Size.prototype.floor=function(){this.width=Math.floor(this.width);this.height=Math.floor(this.height);return this;};goog.math.Size.prototype.round=function(){this.width=Math.round(this.width);this.height=Math.round(this.height);return this;};goog.math.Size.prototype.scale=function(sx,opt_sy){var sy=goog.isNumber(opt_sy)?opt_sy:sx;this.width*=sx;this.height*=sy;return this;};goog.math.Size.prototype.scaleToCover=function(target){return this.scale(this.aspectRatio()<=target.aspectRatio()?target.width/this.width:target.height/this.height);};goog.math.Size.prototype.scaleToFit=function(target){return this.scale(this.aspectRatio()>target.aspectRatio()?target.width/this.width:target.height/this.height);};goog.dom.ASSUME_QUIRKS_MODE=!1;goog.dom.ASSUME_STANDARDS_MODE=!1;goog.dom.COMPAT_MODE_KNOWN_=goog.dom.ASSUME_QUIRKS_MODE||goog.dom.ASSUME_STANDARDS_MODE;goog.dom.getDomHelper=function(opt_element){return opt_element?new goog.dom.DomHelper(goog.dom.getOwnerDocument(opt_element)):goog.dom.defaultDomHelper_||(goog.dom.defaultDomHelper_=new goog.dom.DomHelper());};goog.dom.getDocument=function(){return document;};goog.dom.getElement=function(element){return goog.dom.getElementHelper_(document,element);};goog.dom.getElementHelper_=function(doc,element){return goog.isString(element)?doc.getElementById(element):element;};goog.dom.getRequiredElement=function(id){return goog.dom.getRequiredElementHelper_(document,id);};goog.dom.getRequiredElementHelper_=function(doc,id){goog.asserts.assertString(id);var element=goog.dom.getElementHelper_(doc,id);return element=goog.asserts.assertElement(element,"No element found with id: "+id);};goog.dom.$=goog.dom.getElement;goog.dom.getElementsByTagName=function(tagName,opt_parent){return(opt_parent||document).getElementsByTagName(String(tagName));};goog.dom.getElementsByTagNameAndClass=function(opt_tag,opt_class,opt_el){return goog.dom.getElementsByTagNameAndClass_(document,opt_tag,opt_class,opt_el);};goog.dom.getElementsByClass=function(className,opt_el){var parent=opt_el||document;return goog.dom.canUseQuerySelector_(parent)?parent.querySelectorAll("."+className):goog.dom.getElementsByTagNameAndClass_(document,"*",className,opt_el);};goog.dom.getElementByClass=function(className,opt_el){var parent=opt_el||document,retVal=null;return(retVal=parent.getElementsByClassName?parent.getElementsByClassName(className)[0]:goog.dom.canUseQuerySelector_(parent)?parent.querySelector("."+className):goog.dom.getElementsByTagNameAndClass_(document,"*",className,opt_el)[0])||null;};goog.dom.getRequiredElementByClass=function(className,opt_root){var retValue=goog.dom.getElementByClass(className,opt_root);return goog.asserts.assert(retValue,"No element found with className: "+className);};goog.dom.canUseQuerySelector_=function(parent){return!(!parent.querySelectorAll||!parent.querySelector);};goog.dom.getElementsByTagNameAndClass_=function(doc,opt_tag,opt_class,opt_el){var len,parent=opt_el||doc,tagName=opt_tag&&"*"!=opt_tag?String(opt_tag).toUpperCase():"";if(goog.dom.canUseQuerySelector_(parent)&&(tagName||opt_class)){return parent.querySelectorAll(tagName+(opt_class?"."+opt_class:""));}if(opt_class&&parent.getElementsByClassName){var els=parent.getElementsByClassName(opt_class);if(tagName){var arrayLike={};for(var i=len=0,el;el=els[i];i++){tagName==el.nodeName&&(arrayLike[len++]=el);}arrayLike.length=len;return arrayLike;}return els;}els=parent.getElementsByTagName(tagName||"*");if(opt_class){arrayLike={};for(i=len=0;el=els[i];i++){var className=el.className;"function"==typeof className.split&&goog.array.contains(className.split(/\\s+/),opt_class)&&(arrayLike[len++]=el);}arrayLike.length=len;return arrayLike;}return els;};goog.dom.$$=goog.dom.getElementsByTagNameAndClass;goog.dom.setProperties=function(element,properties){goog.object.forEach(properties,function(val,key){val&&val.implementsGoogStringTypedString&&(val=val.getTypedStringValue());"style"==key?element.style.cssText=val:"class"==key?element.className=val:"for"==key?element.htmlFor=val:goog.dom.DIRECT_ATTRIBUTE_MAP_.hasOwnProperty(key)?element.setAttribute(goog.dom.DIRECT_ATTRIBUTE_MAP_[key],val):goog.string.startsWith(key,"aria-")||goog.string.startsWith(key,"data-")?element.setAttribute(key,val):element[key]=val;});};goog.dom.DIRECT_ATTRIBUTE_MAP_={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};goog.dom.getViewportSize=function(opt_window){return goog.dom.getViewportSize_(opt_window||window);};goog.dom.getViewportSize_=function(win){var doc=win.document,el=goog.dom.isCss1CompatMode_(doc)?doc.documentElement:doc.body;return new goog.math.Size(el.clientWidth,el.clientHeight);};goog.dom.getDocumentHeight=function(){return goog.dom.getDocumentHeight_(window);};goog.dom.getDocumentHeightForWindow=function(win){return goog.dom.getDocumentHeight_(win);};goog.dom.getDocumentHeight_=function(win){var doc=win.document,height=0;if(doc){var body=doc.body,docEl=doc.documentElement;if(!docEl||!body){return 0;}var vh=goog.dom.getViewportSize_(win).height;if(goog.dom.isCss1CompatMode_(doc)&&docEl.scrollHeight){height=docEl.scrollHeight!=vh?docEl.scrollHeight:docEl.offsetHeight;}else{var sh=docEl.scrollHeight,oh=docEl.offsetHeight;docEl.clientHeight!=oh&&(sh=body.scrollHeight,oh=body.offsetHeight);height=sh>vh?sh>oh?sh:oh:sh<oh?sh:oh;}}return height;};goog.dom.getPageScroll=function(opt_window){return goog.dom.getDomHelper((opt_window||goog.global||window).document).getDocumentScroll();};goog.dom.getDocumentScroll=function(){return goog.dom.getDocumentScroll_(document);};goog.dom.getDocumentScroll_=function(doc){var el=goog.dom.getDocumentScrollElement_(doc),win=goog.dom.getWindow_(doc);return goog.userAgent.IE&&goog.userAgent.isVersionOrHigher("10")&&win.pageYOffset!=el.scrollTop?new goog.math.Coordinate(el.scrollLeft,el.scrollTop):new goog.math.Coordinate(win.pageXOffset||el.scrollLeft,win.pageYOffset||el.scrollTop);};goog.dom.getDocumentScrollElement=function(){return goog.dom.getDocumentScrollElement_(document);};goog.dom.getDocumentScrollElement_=function(doc){return doc.scrollingElement?doc.scrollingElement:!goog.userAgent.WEBKIT&&goog.dom.isCss1CompatMode_(doc)?doc.documentElement:doc.body||doc.documentElement;};goog.dom.getWindow=function(opt_doc){return opt_doc?goog.dom.getWindow_(opt_doc):window;};goog.dom.getWindow_=function(doc){return doc.parentWindow||doc.defaultView;};goog.dom.createDom=function(tagName,opt_properties,var_args){return goog.dom.createDom_(document,arguments);};goog.dom.createDom_=function(doc,args){var tagName=String(args[0]),attributes=args[1];if(!goog.dom.BrowserFeature.CAN_ADD_NAME_OR_TYPE_ATTRIBUTES&&attributes&&(attributes.name||attributes.type)){var tagNameArr=["<",tagName];attributes.name&&tagNameArr.push(\' name="\',goog.string.htmlEscape(attributes.name),\'"\');if(attributes.type){tagNameArr.push(\' type="\',goog.string.htmlEscape(attributes.type),\'"\');var clone={};goog.object.extend(clone,attributes);delete clone.type;attributes=clone;}tagNameArr.push(">");tagName=tagNameArr.join("");}var element=doc.createElement(tagName);attributes&&(goog.isString(attributes)?element.className=attributes:goog.isArray(attributes)?element.className=attributes.join(" "):goog.dom.setProperties(element,attributes));2<args.length&&goog.dom.append_(doc,element,args,2);return element;};goog.dom.append_=function(doc,parent,args,startIndex){function childHandler(child){child&&parent.appendChild(goog.isString(child)?doc.createTextNode(child):child);}for(var i=startIndex;i<args.length;i++){var arg=args[i];goog.isArrayLike(arg)&&!goog.dom.isNodeLike(arg)?goog.array.forEach(goog.dom.isNodeList(arg)?goog.array.toArray(arg):arg,childHandler):childHandler(arg);}};goog.dom.$dom=goog.dom.createDom;goog.dom.createElement=function(name){return goog.dom.createElement_(document,name);};goog.dom.createElement_=function(doc,name){return doc.createElement(String(name));};goog.dom.createTextNode=function(content){return document.createTextNode(String(content));};goog.dom.createTable=function(rows,columns,opt_fillWithNbsp){return goog.dom.createTable_(document,rows,columns,!!opt_fillWithNbsp);};goog.dom.createTable_=function(doc,rows,columns,fillWithNbsp){for(var table=goog.dom.createElement_(doc,"TABLE"),tbody=table.appendChild(goog.dom.createElement_(doc,"TBODY")),i=0;i<rows;i++){for(var tr=goog.dom.createElement_(doc,"TR"),j=0;j<columns;j++){var td=goog.dom.createElement_(doc,"TD");fillWithNbsp&&goog.dom.setTextContent(td,goog.string.Unicode.NBSP);tr.appendChild(td);}tbody.appendChild(tr);}return table;};goog.dom.constHtmlToNode=function(var_args){var stringArray=goog.array.map(arguments,goog.string.Const.unwrap),safeHtml=goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Constant HTML string, that gets turned into a Node later, so it will be automatically balanced."),stringArray.join(""));return goog.dom.safeHtmlToNode(safeHtml);};goog.dom.safeHtmlToNode=function(html){return goog.dom.safeHtmlToNode_(document,html);};goog.dom.safeHtmlToNode_=function(doc,html){var tempDiv=goog.dom.createElement_(doc,"DIV");goog.dom.BrowserFeature.INNER_HTML_NEEDS_SCOPED_ELEMENT?(goog.dom.safe.setInnerHtml(tempDiv,goog.html.SafeHtml.concat(goog.html.SafeHtml.BR,html)),tempDiv.removeChild(tempDiv.firstChild)):goog.dom.safe.setInnerHtml(tempDiv,html);return goog.dom.childrenToNode_(doc,tempDiv);};goog.dom.childrenToNode_=function(doc,tempDiv){if(1==tempDiv.childNodes.length){return tempDiv.removeChild(tempDiv.firstChild);}for(var fragment=doc.createDocumentFragment();tempDiv.firstChild;){fragment.appendChild(tempDiv.firstChild);}return fragment;};goog.dom.isCss1CompatMode=function(){return goog.dom.isCss1CompatMode_(document);};goog.dom.isCss1CompatMode_=function(doc){return goog.dom.COMPAT_MODE_KNOWN_?goog.dom.ASSUME_STANDARDS_MODE:"CSS1Compat"==doc.compatMode;};goog.dom.canHaveChildren=function(node){if(node.nodeType!=goog.dom.NodeType.ELEMENT){return!1;}switch(node.tagName){case"APPLET":case"AREA":case"BASE":case"BR":case"COL":case"COMMAND":case"EMBED":case"FRAME":case"HR":case"IMG":case"INPUT":case"IFRAME":case"ISINDEX":case"KEYGEN":case"LINK":case"NOFRAMES":case"NOSCRIPT":case"META":case"OBJECT":case"PARAM":case"SCRIPT":case"SOURCE":case"STYLE":case"TRACK":case"WBR":return!1;}return!0;};goog.dom.appendChild=function(parent,child){parent.appendChild(child);};goog.dom.append=function(parent,var_args){goog.dom.append_(goog.dom.getOwnerDocument(parent),parent,arguments,1);};goog.dom.removeChildren=function(node){for(var child;child=node.firstChild;){node.removeChild(child);}};goog.dom.insertSiblingBefore=function(newNode,refNode){refNode.parentNode&&refNode.parentNode.insertBefore(newNode,refNode);};goog.dom.insertSiblingAfter=function(newNode,refNode){refNode.parentNode&&refNode.parentNode.insertBefore(newNode,refNode.nextSibling);};goog.dom.insertChildAt=function(parent,child,index){parent.insertBefore(child,parent.childNodes[index]||null);};goog.dom.removeNode=function(node){return node&&node.parentNode?node.parentNode.removeChild(node):null;};goog.dom.replaceNode=function(newNode,oldNode){var parent=oldNode.parentNode;parent&&parent.replaceChild(newNode,oldNode);};goog.dom.flattenElement=function(element){var child,parent=element.parentNode;if(parent&&parent.nodeType!=goog.dom.NodeType.DOCUMENT_FRAGMENT){if(element.removeNode){return element.removeNode(!1);}for(;child=element.firstChild;){parent.insertBefore(child,element);}return goog.dom.removeNode(element);}};goog.dom.getChildren=function(element){return goog.dom.BrowserFeature.CAN_USE_CHILDREN_ATTRIBUTE&&void 0!=element.children?element.children:goog.array.filter(element.childNodes,function(node){return node.nodeType==goog.dom.NodeType.ELEMENT;});};goog.dom.getFirstElementChild=function(node){return goog.isDef(node.firstElementChild)?node.firstElementChild:goog.dom.getNextElementNode_(node.firstChild,!0);};goog.dom.getLastElementChild=function(node){return goog.isDef(node.lastElementChild)?node.lastElementChild:goog.dom.getNextElementNode_(node.lastChild,!1);};goog.dom.getNextElementSibling=function(node){return goog.isDef(node.nextElementSibling)?node.nextElementSibling:goog.dom.getNextElementNode_(node.nextSibling,!0);};goog.dom.getPreviousElementSibling=function(node){return goog.isDef(node.previousElementSibling)?node.previousElementSibling:goog.dom.getNextElementNode_(node.previousSibling,!1);};goog.dom.getNextElementNode_=function(node,forward){for(;node&&node.nodeType!=goog.dom.NodeType.ELEMENT;){node=forward?node.nextSibling:node.previousSibling;}return node;};goog.dom.getNextNode=function(node){if(!node){return null;}if(node.firstChild){return node.firstChild;}for(;node&&!node.nextSibling;){node=node.parentNode;}return node?node.nextSibling:null;};goog.dom.getPreviousNode=function(node){if(!node){return null;}if(!node.previousSibling){return node.parentNode;}for(node=node.previousSibling;node&&node.lastChild;){node=node.lastChild;}return node;};goog.dom.isNodeLike=function(obj){return goog.isObject(obj)&&0<obj.nodeType;};goog.dom.isElement=function(obj){return goog.isObject(obj)&&obj.nodeType==goog.dom.NodeType.ELEMENT;};goog.dom.isWindow=function(obj){return goog.isObject(obj)&&obj.window==obj;};goog.dom.getParentElement=function(element){var parent;if(goog.dom.BrowserFeature.CAN_USE_PARENT_ELEMENT_PROPERTY&&!(goog.userAgent.IE&&goog.userAgent.isVersionOrHigher("9")&&!goog.userAgent.isVersionOrHigher("10")&&goog.global.SVGElement&&element instanceof goog.global.SVGElement)&&(parent=element.parentElement)){return parent;}parent=element.parentNode;return goog.dom.isElement(parent)?parent:null;};goog.dom.contains=function(parent,descendant){if(!parent||!descendant){return!1;}if(parent.contains&&descendant.nodeType==goog.dom.NodeType.ELEMENT){return parent==descendant||parent.contains(descendant);}if("undefined"!=typeof parent.compareDocumentPosition){return parent==descendant||!!(parent.compareDocumentPosition(descendant)&16);}for(;descendant&&parent!=descendant;){descendant=descendant.parentNode;}return descendant==parent;};goog.dom.compareNodeOrder=function(node1,node2){if(node1==node2){return 0;}if(node1.compareDocumentPosition){return node1.compareDocumentPosition(node2)&2?1:-1;}if(goog.userAgent.IE&&!goog.userAgent.isDocumentModeOrHigher(9)){if(node1.nodeType==goog.dom.NodeType.DOCUMENT){return-1;}if(node2.nodeType==goog.dom.NodeType.DOCUMENT){return 1;}}if("sourceIndex"in node1||node1.parentNode&&"sourceIndex"in node1.parentNode){var isElement1=node1.nodeType==goog.dom.NodeType.ELEMENT,isElement2=node2.nodeType==goog.dom.NodeType.ELEMENT;if(isElement1&&isElement2){return node1.sourceIndex-node2.sourceIndex;}var parent1=node1.parentNode,parent2=node2.parentNode;return parent1==parent2?goog.dom.compareSiblingOrder_(node1,node2):!isElement1&&goog.dom.contains(parent1,node2)?-1*goog.dom.compareParentsDescendantNodeIe_(node1,node2):!isElement2&&goog.dom.contains(parent2,node1)?goog.dom.compareParentsDescendantNodeIe_(node2,node1):(isElement1?node1.sourceIndex:parent1.sourceIndex)-(isElement2?node2.sourceIndex:parent2.sourceIndex);}var doc=goog.dom.getOwnerDocument(node1);var range1=doc.createRange();range1.selectNode(node1);range1.collapse(!0);var range2=doc.createRange();range2.selectNode(node2);range2.collapse(!0);return range1.compareBoundaryPoints(goog.global.Range.START_TO_END,range2);};goog.dom.compareParentsDescendantNodeIe_=function(textNode,node){var parent=textNode.parentNode;if(parent==node){return-1;}for(var sibling=node;sibling.parentNode!=parent;){sibling=sibling.parentNode;}return goog.dom.compareSiblingOrder_(sibling,textNode);};goog.dom.compareSiblingOrder_=function(node1,node2){for(var s=node2;s=s.previousSibling;){if(s==node1){return-1;}}return 1;};goog.dom.findCommonAncestor=function(var_args){var i,count=arguments.length;if(!count){return null;}if(1==count){return arguments[0];}var paths=[],minLength=Infinity;for(i=0;i<count;i++){for(var ancestors=[],node=arguments[i];node;){ancestors.unshift(node),node=node.parentNode;}paths.push(ancestors);minLength=Math.min(minLength,ancestors.length);}var output=null;for(i=0;i<minLength;i++){for(var first=paths[0][i],j=1;j<count;j++){if(first!=paths[j][i]){return output;}}output=first;}return output;};goog.dom.getOwnerDocument=function(node){goog.asserts.assert(node,"Node cannot be null or undefined.");return node.nodeType==goog.dom.NodeType.DOCUMENT?node:node.ownerDocument||node.document;};goog.dom.getFrameContentDocument=function(frame){return frame.contentDocument||frame.contentWindow.document;};goog.dom.getFrameContentWindow=function(frame){try{return frame.contentWindow||(frame.contentDocument?goog.dom.getWindow(frame.contentDocument):null);}catch(e){}return null;};goog.dom.setTextContent=function(node,text){goog.asserts.assert(null!=node,"goog.dom.setTextContent expects a non-null value for node");if("textContent"in node){node.textContent=text;}else{if(node.nodeType==goog.dom.NodeType.TEXT){node.data=text;}else{if(node.firstChild&&node.firstChild.nodeType==goog.dom.NodeType.TEXT){for(;node.lastChild!=node.firstChild;){node.removeChild(node.lastChild);}node.firstChild.data=text;}else{goog.dom.removeChildren(node);var doc=goog.dom.getOwnerDocument(node);node.appendChild(doc.createTextNode(String(text)));}}}};goog.dom.getOuterHtml=function(element){goog.asserts.assert(null!==element,"goog.dom.getOuterHtml expects a non-null value for element");if("outerHTML"in element){return element.outerHTML;}var doc=goog.dom.getOwnerDocument(element),div=goog.dom.createElement_(doc,"DIV");div.appendChild(element.cloneNode(!0));return div.innerHTML;};goog.dom.findNode=function(root,p){var rv=[];return goog.dom.findNodes_(root,p,rv,!0)?rv[0]:void 0;};goog.dom.findNodes=function(root,p){var rv=[];goog.dom.findNodes_(root,p,rv,!1);return rv;};goog.dom.findNodes_=function(root,p,rv,findOne){if(null!=root){for(var child=root.firstChild;child;){if(p(child)&&(rv.push(child),findOne)||goog.dom.findNodes_(child,p,rv,findOne)){return!0;}child=child.nextSibling;}}return!1;};goog.dom.TAGS_TO_IGNORE_={SCRIPT:1,STYLE:1,HEAD:1,IFRAME:1,OBJECT:1};goog.dom.PREDEFINED_TAG_VALUES_={IMG:" ",BR:"\\n"};goog.dom.isFocusableTabIndex=function(element){return goog.dom.hasSpecifiedTabIndex_(element)&&goog.dom.isTabIndexFocusable_(element);};goog.dom.setFocusableTabIndex=function(element,enable){enable?element.tabIndex=0:(element.tabIndex=-1,element.removeAttribute("tabIndex"));};goog.dom.isFocusable=function(element){var focusable;return(focusable=goog.dom.nativelySupportsFocus_(element)?!element.disabled&&(!goog.dom.hasSpecifiedTabIndex_(element)||goog.dom.isTabIndexFocusable_(element)):goog.dom.isFocusableTabIndex(element))&&goog.userAgent.IE?goog.dom.hasNonZeroBoundingRect_(element):focusable;};goog.dom.hasSpecifiedTabIndex_=function(element){if(goog.userAgent.IE&&!goog.userAgent.isVersionOrHigher("9")){var attrNode=element.getAttributeNode("tabindex");return goog.isDefAndNotNull(attrNode)&&attrNode.specified;}return element.hasAttribute("tabindex");};goog.dom.isTabIndexFocusable_=function(element){var index=element.tabIndex;return goog.isNumber(index)&&0<=index&&32768>index;};goog.dom.nativelySupportsFocus_=function(element){return"A"==element.tagName||"INPUT"==element.tagName||"TEXTAREA"==element.tagName||"SELECT"==element.tagName||"BUTTON"==element.tagName;};goog.dom.hasNonZeroBoundingRect_=function(element){var rect=!goog.isFunction(element.getBoundingClientRect)||goog.userAgent.IE&&null==element.parentElement?{height:element.offsetHeight,width:element.offsetWidth}:element.getBoundingClientRect();return goog.isDefAndNotNull(rect)&&0<rect.height&&0<rect.width;};goog.dom.getTextContent=function(node){if(goog.dom.BrowserFeature.CAN_USE_INNER_TEXT&&null!==node&&"innerText"in node){var textContent=goog.string.canonicalizeNewlines(node.innerText);}else{var buf=[];goog.dom.getTextContent_(node,buf,!0);textContent=buf.join("");}textContent=textContent.replace(/ \\xAD /g," ").replace(/\\xAD/g,"");textContent=textContent.replace(/\\u200B/g,"");goog.dom.BrowserFeature.CAN_USE_INNER_TEXT||(textContent=textContent.replace(/ +/g," "));" "!=textContent&&(textContent=textContent.replace(/^\\s*/,""));return textContent;};goog.dom.getRawTextContent=function(node){var buf=[];goog.dom.getTextContent_(node,buf,!1);return buf.join("");};goog.dom.getTextContent_=function(node,buf,normalizeWhitespace){if(!(node.nodeName in goog.dom.TAGS_TO_IGNORE_)){if(node.nodeType==goog.dom.NodeType.TEXT){normalizeWhitespace?buf.push(String(node.nodeValue).replace(/(\\r\\n|\\r|\\n)/g,"")):buf.push(node.nodeValue);}else{if(node.nodeName in goog.dom.PREDEFINED_TAG_VALUES_){buf.push(goog.dom.PREDEFINED_TAG_VALUES_[node.nodeName]);}else{for(var child=node.firstChild;child;){goog.dom.getTextContent_(child,buf,normalizeWhitespace),child=child.nextSibling;}}}}};goog.dom.getNodeTextLength=function(node){return goog.dom.getTextContent(node).length;};goog.dom.getNodeTextOffset=function(node,opt_offsetParent){for(var root=opt_offsetParent||goog.dom.getOwnerDocument(node).body,buf=[];node&&node!=root;){for(var cur=node;cur=cur.previousSibling;){buf.unshift(goog.dom.getTextContent(cur));}node=node.parentNode;}return goog.string.trimLeft(buf.join("")).replace(/ +/g," ").length;};goog.dom.getNodeAtOffset=function(parent,offset,opt_result){for(var stack=[parent],pos=0,cur=null;0<stack.length&&pos<offset;){if(cur=stack.pop(),!(cur.nodeName in goog.dom.TAGS_TO_IGNORE_)){if(cur.nodeType==goog.dom.NodeType.TEXT){var text=cur.nodeValue.replace(/(\\r\\n|\\r|\\n)/g,"").replace(/ +/g," "),pos=pos+text.length;}else{if(cur.nodeName in goog.dom.PREDEFINED_TAG_VALUES_){pos+=goog.dom.PREDEFINED_TAG_VALUES_[cur.nodeName].length;}else{for(var i=cur.childNodes.length-1;0<=i;i--){stack.push(cur.childNodes[i]);}}}}}goog.isObject(opt_result)&&(opt_result.remainder=cur?cur.nodeValue.length+offset-pos-1:0,opt_result.node=cur);return cur;};goog.dom.isNodeList=function(val){if(val&&"number"==typeof val.length){if(goog.isObject(val)){return"function"==typeof val.item||"string"==typeof val.item;}if(goog.isFunction(val)){return"function"==typeof val.item;}}return!1;};goog.dom.getAncestorByTagNameAndClass=function(element,opt_tag,opt_class,opt_maxSearchSteps){if(!opt_tag&&!opt_class){return null;}var tagName=opt_tag?String(opt_tag).toUpperCase():null;return goog.dom.getAncestor(element,function(node){return(!tagName||node.nodeName==tagName)&&(!opt_class||goog.isString(node.className)&&goog.array.contains(node.className.split(/\\s+/),opt_class));},!0,opt_maxSearchSteps);};goog.dom.getAncestorByClass=function(element,className,opt_maxSearchSteps){return goog.dom.getAncestorByTagNameAndClass(element,null,className,opt_maxSearchSteps);};goog.dom.getAncestor=function(element,matcher,opt_includeNode,opt_maxSearchSteps){element&&!opt_includeNode&&(element=element.parentNode);for(var steps=0;element&&(null==opt_maxSearchSteps||steps<=opt_maxSearchSteps);){goog.asserts.assert("parentNode"!=element.name);if(matcher(element)){return element;}element=element.parentNode;steps++;}return null;};goog.dom.getActiveElement=function(doc){try{return doc&&doc.activeElement;}catch(e){}return null;};goog.dom.getPixelRatio=function(){var win=goog.dom.getWindow();return goog.isDef(win.devicePixelRatio)?win.devicePixelRatio:win.matchMedia?goog.dom.matchesPixelRatio_(3)||goog.dom.matchesPixelRatio_(2)||goog.dom.matchesPixelRatio_(1.5)||goog.dom.matchesPixelRatio_(1)||.75:1;};goog.dom.matchesPixelRatio_=function(pixelRatio){return goog.dom.getWindow().matchMedia("(min-resolution: "+pixelRatio+"dppx),(min--moz-device-pixel-ratio: "+pixelRatio+"),(min-resolution: "+96*pixelRatio+"dpi)").matches?pixelRatio:0;};goog.dom.getCanvasContext2D=function(canvas){return canvas.getContext("2d");};goog.dom.DomHelper=function(opt_document){this.document_=opt_document||goog.global.document||document;};goog.dom.DomHelper.prototype.getDomHelper=goog.dom.getDomHelper;goog.dom.DomHelper.prototype.setDocument=function(document){this.document_=document;};goog.dom.DomHelper.prototype.getDocument=function(){return this.document_;};goog.dom.DomHelper.prototype.getElement=function(element){return goog.dom.getElementHelper_(this.document_,element);};goog.dom.DomHelper.prototype.getRequiredElement=function(id){return goog.dom.getRequiredElementHelper_(this.document_,id);};goog.dom.DomHelper.prototype.$=goog.dom.DomHelper.prototype.getElement;goog.dom.DomHelper.prototype.getElementsByTagName=function(tagName,opt_parent){return(opt_parent||this.document_).getElementsByTagName(String(tagName));};goog.dom.DomHelper.prototype.getElementsByTagNameAndClass=function(opt_tag,opt_class,opt_el){return goog.dom.getElementsByTagNameAndClass_(this.document_,opt_tag,opt_class,opt_el);};goog.dom.DomHelper.prototype.getElementsByClass=function(className,opt_el){return goog.dom.getElementsByClass(className,opt_el||this.document_);};goog.dom.DomHelper.prototype.getElementByClass=function(className,opt_el){return goog.dom.getElementByClass(className,opt_el||this.document_);};goog.dom.DomHelper.prototype.getRequiredElementByClass=function(className,opt_root){return goog.dom.getRequiredElementByClass(className,opt_root||this.document_);};goog.dom.DomHelper.prototype.$$=goog.dom.DomHelper.prototype.getElementsByTagNameAndClass;goog.dom.DomHelper.prototype.setProperties=goog.dom.setProperties;goog.dom.DomHelper.prototype.getViewportSize=function(opt_window){return goog.dom.getViewportSize(opt_window||this.getWindow());};goog.dom.DomHelper.prototype.getDocumentHeight=function(){return goog.dom.getDocumentHeight_(this.getWindow());};goog.dom.DomHelper.prototype.createDom=function(tagName,opt_attributes,var_args){return goog.dom.createDom_(this.document_,arguments);};goog.dom.DomHelper.prototype.$dom=goog.dom.DomHelper.prototype.createDom;goog.dom.DomHelper.prototype.createElement=function(name){return goog.dom.createElement_(this.document_,name);};goog.dom.DomHelper.prototype.createTextNode=function(content){return this.document_.createTextNode(String(content));};goog.dom.DomHelper.prototype.createTable=function(rows,columns,opt_fillWithNbsp){return goog.dom.createTable_(this.document_,rows,columns,!!opt_fillWithNbsp);};goog.dom.DomHelper.prototype.safeHtmlToNode=function(html){return goog.dom.safeHtmlToNode_(this.document_,html);};goog.dom.DomHelper.prototype.isCss1CompatMode=function(){return goog.dom.isCss1CompatMode_(this.document_);};goog.dom.DomHelper.prototype.getWindow=function(){return goog.dom.getWindow_(this.document_);};goog.dom.DomHelper.prototype.getDocumentScrollElement=function(){return goog.dom.getDocumentScrollElement_(this.document_);};goog.dom.DomHelper.prototype.getDocumentScroll=function(){return goog.dom.getDocumentScroll_(this.document_);};goog.dom.DomHelper.prototype.getActiveElement=function(opt_doc){return goog.dom.getActiveElement(opt_doc||this.document_);};goog.dom.DomHelper.prototype.appendChild=goog.dom.appendChild;goog.dom.DomHelper.prototype.append=goog.dom.append;goog.dom.DomHelper.prototype.canHaveChildren=goog.dom.canHaveChildren;goog.dom.DomHelper.prototype.removeChildren=goog.dom.removeChildren;goog.dom.DomHelper.prototype.insertSiblingBefore=goog.dom.insertSiblingBefore;goog.dom.DomHelper.prototype.insertSiblingAfter=goog.dom.insertSiblingAfter;goog.dom.DomHelper.prototype.insertChildAt=goog.dom.insertChildAt;goog.dom.DomHelper.prototype.removeNode=goog.dom.removeNode;goog.dom.DomHelper.prototype.replaceNode=goog.dom.replaceNode;goog.dom.DomHelper.prototype.flattenElement=goog.dom.flattenElement;goog.dom.DomHelper.prototype.getChildren=goog.dom.getChildren;goog.dom.DomHelper.prototype.getFirstElementChild=goog.dom.getFirstElementChild;goog.dom.DomHelper.prototype.getLastElementChild=goog.dom.getLastElementChild;goog.dom.DomHelper.prototype.getNextElementSibling=goog.dom.getNextElementSibling;goog.dom.DomHelper.prototype.getPreviousElementSibling=goog.dom.getPreviousElementSibling;goog.dom.DomHelper.prototype.getNextNode=goog.dom.getNextNode;goog.dom.DomHelper.prototype.getPreviousNode=goog.dom.getPreviousNode;goog.dom.DomHelper.prototype.isNodeLike=goog.dom.isNodeLike;goog.dom.DomHelper.prototype.isElement=goog.dom.isElement;goog.dom.DomHelper.prototype.isWindow=goog.dom.isWindow;goog.dom.DomHelper.prototype.getParentElement=goog.dom.getParentElement;goog.dom.DomHelper.prototype.contains=goog.dom.contains;goog.dom.DomHelper.prototype.compareNodeOrder=goog.dom.compareNodeOrder;goog.dom.DomHelper.prototype.findCommonAncestor=goog.dom.findCommonAncestor;goog.dom.DomHelper.prototype.getOwnerDocument=goog.dom.getOwnerDocument;goog.dom.DomHelper.prototype.getFrameContentDocument=goog.dom.getFrameContentDocument;goog.dom.DomHelper.prototype.getFrameContentWindow=goog.dom.getFrameContentWindow;goog.dom.DomHelper.prototype.setTextContent=goog.dom.setTextContent;goog.dom.DomHelper.prototype.getOuterHtml=goog.dom.getOuterHtml;goog.dom.DomHelper.prototype.findNode=goog.dom.findNode;goog.dom.DomHelper.prototype.findNodes=goog.dom.findNodes;goog.dom.DomHelper.prototype.isFocusableTabIndex=goog.dom.isFocusableTabIndex;goog.dom.DomHelper.prototype.setFocusableTabIndex=goog.dom.setFocusableTabIndex;goog.dom.DomHelper.prototype.isFocusable=goog.dom.isFocusable;goog.dom.DomHelper.prototype.getTextContent=goog.dom.getTextContent;goog.dom.DomHelper.prototype.getNodeTextLength=goog.dom.getNodeTextLength;goog.dom.DomHelper.prototype.getNodeTextOffset=goog.dom.getNodeTextOffset;goog.dom.DomHelper.prototype.getNodeAtOffset=goog.dom.getNodeAtOffset;goog.dom.DomHelper.prototype.isNodeList=goog.dom.isNodeList;goog.dom.DomHelper.prototype.getAncestorByTagNameAndClass=goog.dom.getAncestorByTagNameAndClass;goog.dom.DomHelper.prototype.getAncestorByClass=goog.dom.getAncestorByClass;goog.dom.DomHelper.prototype.getAncestor=goog.dom.getAncestor;goog.dom.DomHelper.prototype.getCanvasContext2D=goog.dom.getCanvasContext2D;goog.dom.vendor={};goog.dom.vendor.getVendorJsPrefix=function(){return goog.userAgent.WEBKIT?"Webkit":goog.userAgent.GECKO?"Moz":goog.userAgent.IE?"ms":goog.userAgent.OPERA?"O":null;};goog.dom.vendor.getVendorPrefix=function(){return goog.userAgent.WEBKIT?"-webkit":goog.userAgent.GECKO?"-moz":goog.userAgent.IE?"-ms":goog.userAgent.OPERA?"-o":null;};goog.dom.vendor.getPrefixedPropertyName=function(propertyName,opt_object){if(opt_object&&propertyName in opt_object){return propertyName;}var prefix=goog.dom.vendor.getVendorJsPrefix();if(prefix){var prefix=prefix.toLowerCase(),prefixedPropertyName=prefix+goog.string.toTitleCase(propertyName);return!goog.isDef(opt_object)||prefixedPropertyName in opt_object?prefixedPropertyName:null;}return null;};goog.dom.vendor.getPrefixedEventType=function(eventType){return((goog.dom.vendor.getVendorJsPrefix()||"")+eventType).toLowerCase();};goog.html.legacyconversions={};goog.html.legacyconversions.safeHtmlFromString=function(html){goog.html.legacyconversions.reportCallback_();return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(html,null);};goog.html.legacyconversions.safeStyleFromString=function(style){goog.html.legacyconversions.reportCallback_();return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(style);};goog.html.legacyconversions.safeStyleSheetFromString=function(styleSheet){goog.html.legacyconversions.reportCallback_();return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(styleSheet);};goog.html.legacyconversions.safeUrlFromString=function(url){goog.html.legacyconversions.reportCallback_();return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(url);};goog.html.legacyconversions.trustedResourceUrlFromString=function(url){goog.html.legacyconversions.reportCallback_();return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(url);};goog.html.legacyconversions.reportCallback_=goog.nullFunction;goog.html.legacyconversions.setReportCallback=function(callback){goog.html.legacyconversions.reportCallback_=callback;};goog.math.Box=function(top,right,bottom,left){this.top=top;this.right=right;this.bottom=bottom;this.left=left;};goog.math.Box.boundingBox=function(var_args){for(var box=new goog.math.Box(arguments[0].y,arguments[0].x,arguments[0].y,arguments[0].x),i=1;i<arguments.length;i++){box.expandToIncludeCoordinate(arguments[i]);}return box;};goog.math.Box.prototype.getWidth=function(){return this.right-this.left;};goog.math.Box.prototype.getHeight=function(){return this.bottom-this.top;};goog.math.Box.prototype.clone=function(){return new goog.math.Box(this.top,this.right,this.bottom,this.left);};goog.DEBUG&&(goog.math.Box.prototype.toString=function(){return"("+this.top+"t, "+this.right+"r, "+this.bottom+"b, "+this.left+"l)";});goog.math.Box.prototype.contains=function(other){return goog.math.Box.contains(this,other);};goog.math.Box.prototype.expand=function(top,opt_right,opt_bottom,opt_left){goog.isObject(top)?(this.top-=top.top,this.right+=top.right,this.bottom+=top.bottom,this.left-=top.left):(this.top-=top,this.right+=Number(opt_right),this.bottom+=Number(opt_bottom),this.left-=Number(opt_left));return this;};goog.math.Box.prototype.expandToInclude=function(box){this.left=Math.min(this.left,box.left);this.top=Math.min(this.top,box.top);this.right=Math.max(this.right,box.right);this.bottom=Math.max(this.bottom,box.bottom);};goog.math.Box.prototype.expandToIncludeCoordinate=function(coord){this.top=Math.min(this.top,coord.y);this.right=Math.max(this.right,coord.x);this.bottom=Math.max(this.bottom,coord.y);this.left=Math.min(this.left,coord.x);};goog.math.Box.equals=function(a,b){return a==b?!0:a&&b?a.top==b.top&&a.right==b.right&&a.bottom==b.bottom&&a.left==b.left:!1;};goog.math.Box.contains=function(box,other){return box&&other?other instanceof goog.math.Box?other.left>=box.left&&other.right<=box.right&&other.top>=box.top&&other.bottom<=box.bottom:other.x>=box.left&&other.x<=box.right&&other.y>=box.top&&other.y<=box.bottom:!1;};goog.math.Box.relativePositionX=function(box,coord){return coord.x<box.left?coord.x-box.left:coord.x>box.right?coord.x-box.right:0;};goog.math.Box.relativePositionY=function(box,coord){return coord.y<box.top?coord.y-box.top:coord.y>box.bottom?coord.y-box.bottom:0;};goog.math.Box.distance=function(box,coord){var x=goog.math.Box.relativePositionX(box,coord),y=goog.math.Box.relativePositionY(box,coord);return Math.sqrt(x*x+y*y);};goog.math.Box.intersects=function(a,b){return a.left<=b.right&&b.left<=a.right&&a.top<=b.bottom&&b.top<=a.bottom;};goog.math.Box.intersectsWithPadding=function(a,b,padding){return a.left<=b.right+padding&&b.left<=a.right+padding&&a.top<=b.bottom+padding&&b.top<=a.bottom+padding;};goog.math.Box.prototype.ceil=function(){this.top=Math.ceil(this.top);this.right=Math.ceil(this.right);this.bottom=Math.ceil(this.bottom);this.left=Math.ceil(this.left);return this;};goog.math.Box.prototype.floor=function(){this.top=Math.floor(this.top);this.right=Math.floor(this.right);this.bottom=Math.floor(this.bottom);this.left=Math.floor(this.left);return this;};goog.math.Box.prototype.round=function(){this.top=Math.round(this.top);this.right=Math.round(this.right);this.bottom=Math.round(this.bottom);this.left=Math.round(this.left);return this;};goog.math.Box.prototype.translate=function(tx,opt_ty){tx instanceof goog.math.Coordinate?(this.left+=tx.x,this.right+=tx.x,this.top+=tx.y,this.bottom+=tx.y):(goog.asserts.assertNumber(tx),this.left+=tx,this.right+=tx,goog.isNumber(opt_ty)&&(this.top+=opt_ty,this.bottom+=opt_ty));return this;};goog.math.Box.prototype.scale=function(sx,opt_sy){var sy=goog.isNumber(opt_sy)?opt_sy:sx;this.left*=sx;this.right*=sx;this.top*=sy;this.bottom*=sy;return this;};goog.math.IRect=function(){};goog.math.Rect=function(x,y,w,h){this.left=x;this.top=y;this.width=w;this.height=h;};goog.math.Rect.prototype.clone=function(){return new goog.math.Rect(this.left,this.top,this.width,this.height);};goog.math.Rect.prototype.toBox=function(){return new goog.math.Box(this.top,this.left+this.width,this.top+this.height,this.left);};goog.math.Rect.createFromPositionAndSize=function(position,size){return new goog.math.Rect(position.x,position.y,size.width,size.height);};goog.math.Rect.createFromBox=function(box){return new goog.math.Rect(box.left,box.top,box.right-box.left,box.bottom-box.top);};goog.DEBUG&&(goog.math.Rect.prototype.toString=function(){return"("+this.left+", "+this.top+" - "+this.width+"w x "+this.height+"h)";});goog.math.Rect.equals=function(a,b){return a==b?!0:a&&b?a.left==b.left&&a.width==b.width&&a.top==b.top&&a.height==b.height:!1;};goog.math.Rect.prototype.intersection=function(rect){var x0=Math.max(this.left,rect.left),x1=Math.min(this.left+this.width,rect.left+rect.width);if(x0<=x1){var y0=Math.max(this.top,rect.top),y1=Math.min(this.top+this.height,rect.top+rect.height);if(y0<=y1){return this.left=x0,this.top=y0,this.width=x1-x0,this.height=y1-y0,!0;}}return!1;};goog.math.Rect.intersection=function(a,b){var x0=Math.max(a.left,b.left),x1=Math.min(a.left+a.width,b.left+b.width);if(x0<=x1){var y0=Math.max(a.top,b.top),y1=Math.min(a.top+a.height,b.top+b.height);if(y0<=y1){return new goog.math.Rect(x0,y0,x1-x0,y1-y0);}}return null;};goog.math.Rect.intersects=function(a,b){return a.left<=b.left+b.width&&b.left<=a.left+a.width&&a.top<=b.top+b.height&&b.top<=a.top+a.height;};goog.math.Rect.prototype.intersects=function(rect){return goog.math.Rect.intersects(this,rect);};goog.math.Rect.difference=function(a,b){var intersection=goog.math.Rect.intersection(a,b);if(!intersection||!intersection.height||!intersection.width){return[a.clone()];}var result=[],top=a.top,height=a.height,ar=a.left+a.width,ab=a.top+a.height,br=b.left+b.width,bb=b.top+b.height;b.top>a.top&&(result.push(new goog.math.Rect(a.left,a.top,a.width,b.top-a.top)),top=b.top,height-=b.top-a.top);bb<ab&&(result.push(new goog.math.Rect(a.left,bb,a.width,ab-bb)),height=bb-top);b.left>a.left&&result.push(new goog.math.Rect(a.left,top,b.left-a.left,height));br<ar&&result.push(new goog.math.Rect(br,top,ar-br,height));return result;};goog.math.Rect.prototype.difference=function(rect){return goog.math.Rect.difference(this,rect);};goog.math.Rect.prototype.boundingRect=function(rect){var right=Math.max(this.left+this.width,rect.left+rect.width),bottom=Math.max(this.top+this.height,rect.top+rect.height);this.left=Math.min(this.left,rect.left);this.top=Math.min(this.top,rect.top);this.width=right-this.left;this.height=bottom-this.top;};goog.math.Rect.boundingRect=function(a,b){if(!a||!b){return null;}var newRect=new goog.math.Rect(a.left,a.top,a.width,a.height);newRect.boundingRect(b);return newRect;};goog.math.Rect.prototype.contains=function(another){return another instanceof goog.math.Coordinate?another.x>=this.left&&another.x<=this.left+this.width&&another.y>=this.top&&another.y<=this.top+this.height:this.left<=another.left&&this.left+this.width>=another.left+another.width&&this.top<=another.top&&this.top+this.height>=another.top+another.height;};goog.math.Rect.prototype.squaredDistance=function(point){var dx=point.x<this.left?this.left-point.x:Math.max(point.x-(this.left+this.width),0),dy=point.y<this.top?this.top-point.y:Math.max(point.y-(this.top+this.height),0);return dx*dx+dy*dy;};goog.math.Rect.prototype.distance=function(point){return Math.sqrt(this.squaredDistance(point));};goog.math.Rect.prototype.getSize=function(){return new goog.math.Size(this.width,this.height);};goog.math.Rect.prototype.getTopLeft=function(){return new goog.math.Coordinate(this.left,this.top);};goog.math.Rect.prototype.getCenter=function(){return new goog.math.Coordinate(this.left+this.width/2,this.top+this.height/2);};goog.math.Rect.prototype.getBottomRight=function(){return new goog.math.Coordinate(this.left+this.width,this.top+this.height);};goog.math.Rect.prototype.ceil=function(){this.left=Math.ceil(this.left);this.top=Math.ceil(this.top);this.width=Math.ceil(this.width);this.height=Math.ceil(this.height);return this;};goog.math.Rect.prototype.floor=function(){this.left=Math.floor(this.left);this.top=Math.floor(this.top);this.width=Math.floor(this.width);this.height=Math.floor(this.height);return this;};goog.math.Rect.prototype.round=function(){this.left=Math.round(this.left);this.top=Math.round(this.top);this.width=Math.round(this.width);this.height=Math.round(this.height);return this;};goog.math.Rect.prototype.translate=function(tx,opt_ty){tx instanceof goog.math.Coordinate?(this.left+=tx.x,this.top+=tx.y):(this.left+=goog.asserts.assertNumber(tx),goog.isNumber(opt_ty)&&(this.top+=opt_ty));return this;};goog.math.Rect.prototype.scale=function(sx,opt_sy){var sy=goog.isNumber(opt_sy)?opt_sy:sx;this.left*=sx;this.width*=sx;this.top*=sy;this.height*=sy;return this;};goog.style={};goog.style.setStyle=function(element,style,opt_value){if(goog.isString(style)){goog.style.setStyle_(element,opt_value,style);}else{for(var key in style){goog.style.setStyle_(element,style[key],key);}}};goog.style.setStyle_=function(element,value,style){var propertyName=goog.style.getVendorJsStyleName_(element,style);propertyName&&(element.style[propertyName]=value);};goog.style.styleNameCache_={};goog.style.getVendorJsStyleName_=function(element,style){var propertyName=goog.style.styleNameCache_[style];if(!propertyName){var camelStyle=goog.string.toCamelCase(style),propertyName=camelStyle;if(void 0===element.style[camelStyle]){var prefixedStyle=goog.dom.vendor.getVendorJsPrefix()+goog.string.toTitleCase(camelStyle);void 0!==element.style[prefixedStyle]&&(propertyName=prefixedStyle);}goog.style.styleNameCache_[style]=propertyName;}return propertyName;};goog.style.getVendorStyleName_=function(element,style){var camelStyle=goog.string.toCamelCase(style);if(void 0===element.style[camelStyle]){var prefixedStyle=goog.dom.vendor.getVendorJsPrefix()+goog.string.toTitleCase(camelStyle);if(void 0!==element.style[prefixedStyle]){return goog.dom.vendor.getVendorPrefix()+"-"+style;}}return style;};goog.style.getStyle=function(element,property){var styleValue=element.style[goog.string.toCamelCase(property)];return"undefined"!==typeof styleValue?styleValue:element.style[goog.style.getVendorJsStyleName_(element,property)]||"";};goog.style.getComputedStyle=function(element,property){var doc=goog.dom.getOwnerDocument(element);if(doc.defaultView&&doc.defaultView.getComputedStyle){var styles=doc.defaultView.getComputedStyle(element,null);if(styles){return styles[property]||styles.getPropertyValue(property)||"";}}return"";};goog.style.getCascadedStyle=function(element,style){return element.currentStyle?element.currentStyle[style]:null;};goog.style.getStyle_=function(element,style){return goog.style.getComputedStyle(element,style)||goog.style.getCascadedStyle(element,style)||element.style&&element.style[style];};goog.style.getComputedBoxSizing=function(element){return goog.style.getStyle_(element,"boxSizing")||goog.style.getStyle_(element,"MozBoxSizing")||goog.style.getStyle_(element,"WebkitBoxSizing")||null;};goog.style.getComputedPosition=function(element){return goog.style.getStyle_(element,"position");};goog.style.getBackgroundColor=function(element){return goog.style.getStyle_(element,"backgroundColor");};goog.style.getComputedOverflowX=function(element){return goog.style.getStyle_(element,"overflowX");};goog.style.getComputedOverflowY=function(element){return goog.style.getStyle_(element,"overflowY");};goog.style.getComputedZIndex=function(element){return goog.style.getStyle_(element,"zIndex");};goog.style.getComputedTextAlign=function(element){return goog.style.getStyle_(element,"textAlign");};goog.style.getComputedCursor=function(element){return goog.style.getStyle_(element,"cursor");};goog.style.getComputedTransform=function(element){var property=goog.style.getVendorStyleName_(element,"transform");return goog.style.getStyle_(element,property)||goog.style.getStyle_(element,"transform");};goog.style.setPosition=function(el,arg1,opt_arg2){if(arg1 instanceof goog.math.Coordinate){var x=arg1.x;var y=arg1.y;}else{x=arg1,y=opt_arg2;}el.style.left=goog.style.getPixelStyleValue_(x,!1);el.style.top=goog.style.getPixelStyleValue_(y,!1);};goog.style.getPosition=function(element){return new goog.math.Coordinate(element.offsetLeft,element.offsetTop);};goog.style.getClientViewportElement=function(opt_node){var doc=opt_node?goog.dom.getOwnerDocument(opt_node):goog.dom.getDocument();return!goog.userAgent.IE||goog.userAgent.isDocumentModeOrHigher(9)||goog.dom.getDomHelper(doc).isCss1CompatMode()?doc.documentElement:doc.body;};goog.style.getViewportPageOffset=function(doc){var body=doc.body,documentElement=doc.documentElement;return new goog.math.Coordinate(body.scrollLeft||documentElement.scrollLeft,body.scrollTop||documentElement.scrollTop);};goog.style.getBoundingClientRect_=function(el){try{var rect=el.getBoundingClientRect();}catch(e){return{left:0,top:0,right:0,bottom:0};}if(goog.userAgent.IE&&el.ownerDocument.body){var doc=el.ownerDocument;rect.left-=doc.documentElement.clientLeft+doc.body.clientLeft;rect.top-=doc.documentElement.clientTop+doc.body.clientTop;}return rect;};goog.style.getOffsetParent=function(element){if(goog.userAgent.IE&&!goog.userAgent.isDocumentModeOrHigher(8)){return goog.asserts.assert(element&&"offsetParent"in element),element.offsetParent;}for(var doc=goog.dom.getOwnerDocument(element),positionStyle=goog.style.getStyle_(element,"position"),skipStatic="fixed"==positionStyle||"absolute"==positionStyle,parent=element.parentNode;parent&&parent!=doc;parent=parent.parentNode){if(parent.nodeType==goog.dom.NodeType.DOCUMENT_FRAGMENT&&parent.host&&(parent=parent.host),positionStyle=goog.style.getStyle_(parent,"position"),skipStatic=skipStatic&&"static"==positionStyle&&parent!=doc.documentElement&&parent!=doc.body,!skipStatic&&(parent.scrollWidth>parent.clientWidth||parent.scrollHeight>parent.clientHeight||"fixed"==positionStyle||"absolute"==positionStyle||"relative"==positionStyle)){return parent;}}return null;};goog.style.getVisibleRectForElement=function(element){for(var visibleRect=new goog.math.Box(0,Infinity,Infinity,0),dom=goog.dom.getDomHelper(element),body=dom.getDocument().body,documentElement=dom.getDocument().documentElement,scrollEl=dom.getDocumentScrollElement(),el=element;el=goog.style.getOffsetParent(el);){if(!(goog.userAgent.IE&&0==el.clientWidth||goog.userAgent.WEBKIT&&0==el.clientHeight&&el==body)&&el!=body&&el!=documentElement&&"visible"!=goog.style.getStyle_(el,"overflow")){var pos=goog.style.getPageOffset(el),client=goog.style.getClientLeftTop(el);pos.x+=client.x;pos.y+=client.y;visibleRect.top=Math.max(visibleRect.top,pos.y);visibleRect.right=Math.min(visibleRect.right,pos.x+el.clientWidth);visibleRect.bottom=Math.min(visibleRect.bottom,pos.y+el.clientHeight);visibleRect.left=Math.max(visibleRect.left,pos.x);}}var scrollX=scrollEl.scrollLeft,scrollY=scrollEl.scrollTop;visibleRect.left=Math.max(visibleRect.left,scrollX);visibleRect.top=Math.max(visibleRect.top,scrollY);var winSize=dom.getViewportSize();visibleRect.right=Math.min(visibleRect.right,scrollX+winSize.width);visibleRect.bottom=Math.min(visibleRect.bottom,scrollY+winSize.height);return 0<=visibleRect.top&&0<=visibleRect.left&&visibleRect.bottom>visibleRect.top&&visibleRect.right>visibleRect.left?visibleRect:null;};goog.style.getContainerOffsetToScrollInto=function(element,opt_container,opt_center){var container=opt_container||goog.dom.getDocumentScrollElement(),elementPos=goog.style.getPageOffset(element),containerPos=goog.style.getPageOffset(container),containerBorder=goog.style.getBorderBox(container);if(container==goog.dom.getDocumentScrollElement()){var relX=elementPos.x-container.scrollLeft;var relY=elementPos.y-container.scrollTop;goog.userAgent.IE&&!goog.userAgent.isDocumentModeOrHigher(10)&&(relX+=containerBorder.left,relY+=containerBorder.top);}else{relX=elementPos.x-containerPos.x-containerBorder.left,relY=elementPos.y-containerPos.y-containerBorder.top;}var elementSize=goog.style.getSizeWithDisplay_(element),spaceX=container.clientWidth-elementSize.width,spaceY=container.clientHeight-elementSize.height,scrollLeft=container.scrollLeft,scrollTop=container.scrollTop;opt_center?(scrollLeft+=relX-spaceX/2,scrollTop+=relY-spaceY/2):(scrollLeft+=Math.min(relX,Math.max(relX-spaceX,0)),scrollTop+=Math.min(relY,Math.max(relY-spaceY,0)));return new goog.math.Coordinate(scrollLeft,scrollTop);};goog.style.scrollIntoContainerView=function(element,opt_container,opt_center){var container=opt_container||goog.dom.getDocumentScrollElement(),offset=goog.style.getContainerOffsetToScrollInto(element,container,opt_center);container.scrollLeft=offset.x;container.scrollTop=offset.y;};goog.style.getClientLeftTop=function(el){return new goog.math.Coordinate(el.clientLeft,el.clientTop);};goog.style.getPageOffset=function(el){var doc=goog.dom.getOwnerDocument(el);goog.asserts.assertObject(el,"Parameter is required");var pos=new goog.math.Coordinate(0,0),viewportElement=goog.style.getClientViewportElement(doc);if(el==viewportElement){return pos;}var box=goog.style.getBoundingClientRect_(el),scrollCoord=goog.dom.getDomHelper(doc).getDocumentScroll();pos.x=box.left+scrollCoord.x;pos.y=box.top+scrollCoord.y;return pos;};goog.style.getPageOffsetLeft=function(el){return goog.style.getPageOffset(el).x;};goog.style.getPageOffsetTop=function(el){return goog.style.getPageOffset(el).y;};goog.style.getFramedPageOffset=function(el,relativeWin){var position=new goog.math.Coordinate(0,0),currentWin=goog.dom.getWindow(goog.dom.getOwnerDocument(el));if(!goog.reflect.canAccessProperty(currentWin,"parent")){return position;}var currentEl=el;do{var offset=currentWin==relativeWin?goog.style.getPageOffset(currentEl):goog.style.getClientPositionForElement_(goog.asserts.assert(currentEl));position.x+=offset.x;position.y+=offset.y;}while(currentWin&&currentWin!=relativeWin&&currentWin!=currentWin.parent&&(currentEl=currentWin.frameElement)&&(currentWin=currentWin.parent));return position;};goog.style.translateRectForAnotherFrame=function(rect,origBase,newBase){if(origBase.getDocument()!=newBase.getDocument()){var body=origBase.getDocument().body,pos=goog.style.getFramedPageOffset(body,newBase.getWindow()),pos=goog.math.Coordinate.difference(pos,goog.style.getPageOffset(body));!goog.userAgent.IE||goog.userAgent.isDocumentModeOrHigher(9)||origBase.isCss1CompatMode()||(pos=goog.math.Coordinate.difference(pos,origBase.getDocumentScroll()));rect.left+=pos.x;rect.top+=pos.y;}};goog.style.getRelativePosition=function(a,b){var ap=goog.style.getClientPosition(a),bp=goog.style.getClientPosition(b);return new goog.math.Coordinate(ap.x-bp.x,ap.y-bp.y);};goog.style.getClientPositionForElement_=function(el){var box=goog.style.getBoundingClientRect_(el);return new goog.math.Coordinate(box.left,box.top);};goog.style.getClientPosition=function(el){goog.asserts.assert(el);if(el.nodeType==goog.dom.NodeType.ELEMENT){return goog.style.getClientPositionForElement_(el);}var targetEvent=el.changedTouches?el.changedTouches[0]:el;return new goog.math.Coordinate(targetEvent.clientX,targetEvent.clientY);};goog.style.setPageOffset=function(el,x,opt_y){var cur=goog.style.getPageOffset(el);x instanceof goog.math.Coordinate&&(opt_y=x.y,x=x.x);var dx=goog.asserts.assertNumber(x)-cur.x;goog.style.setPosition(el,el.offsetLeft+dx,el.offsetTop+(Number(opt_y)-cur.y));};goog.style.setSize=function(element,w,opt_h){if(w instanceof goog.math.Size){var h=w.height;w=w.width;}else{if(void 0==opt_h){throw Error("missing height argument");}h=opt_h;}goog.style.setWidth(element,w);goog.style.setHeight(element,h);};goog.style.getPixelStyleValue_=function(value,round){"number"==typeof value&&(value=(round?Math.round(value):value)+"px");return value;};goog.style.setHeight=function(element,height){element.style.height=goog.style.getPixelStyleValue_(height,!0);};goog.style.setWidth=function(element,width){element.style.width=goog.style.getPixelStyleValue_(width,!0);};goog.style.getSize=function(element){return goog.style.evaluateWithTemporaryDisplay_(goog.style.getSizeWithDisplay_,element);};goog.style.evaluateWithTemporaryDisplay_=function(fn,element){if("none"!=goog.style.getStyle_(element,"display")){return fn(element);}var style=element.style,originalDisplay=style.display,originalVisibility=style.visibility,originalPosition=style.position;style.visibility="hidden";style.position="absolute";style.display="inline";var retVal=fn(element);style.display=originalDisplay;style.position=originalPosition;style.visibility=originalVisibility;return retVal;};goog.style.getSizeWithDisplay_=function(element){var offsetWidth=element.offsetWidth,offsetHeight=element.offsetHeight,webkitOffsetsZero=goog.userAgent.WEBKIT&&!offsetWidth&&!offsetHeight;if((!goog.isDef(offsetWidth)||webkitOffsetsZero)&&element.getBoundingClientRect){var clientRect=goog.style.getBoundingClientRect_(element);return new goog.math.Size(clientRect.right-clientRect.left,clientRect.bottom-clientRect.top);}return new goog.math.Size(offsetWidth,offsetHeight);};goog.style.getTransformedSize=function(element){if(!element.getBoundingClientRect){return null;}var clientRect=goog.style.evaluateWithTemporaryDisplay_(goog.style.getBoundingClientRect_,element);return new goog.math.Size(clientRect.right-clientRect.left,clientRect.bottom-clientRect.top);};goog.style.getBounds=function(element){var o=goog.style.getPageOffset(element),s=goog.style.getSize(element);return new goog.math.Rect(o.x,o.y,s.width,s.height);};goog.style.toCamelCase=function(selector){return goog.string.toCamelCase(String(selector));};goog.style.toSelectorCase=function(selector){return goog.string.toSelectorCase(selector);};goog.style.getOpacity=function(el){goog.asserts.assert(el);var style=el.style,result="";if("opacity"in style){result=style.opacity;}else{if("MozOpacity"in style){result=style.MozOpacity;}else{if("filter"in style){var match=style.filter.match(/alpha\\(opacity=([\\d.]+)\\)/);match&&(result=String(match[1]/100));}}}return""==result?result:Number(result);};goog.style.setOpacity=function(el,alpha){goog.asserts.assert(el);var style=el.style;"opacity"in style?style.opacity=alpha:"MozOpacity"in style?style.MozOpacity=alpha:"filter"in style&&(style.filter=""===alpha?"":"alpha(opacity="+100*Number(alpha)+")");};goog.style.setTransparentBackgroundImage=function(el,src){var style=el.style;goog.userAgent.IE&&!goog.userAgent.isVersionOrHigher("8")?style.filter=\'progid:DXImageTransform.Microsoft.AlphaImageLoader(src="\'+src+\'", sizingMethod="crop")\':(style.backgroundImage="url("+src+")",style.backgroundPosition="top left",style.backgroundRepeat="no-repeat");};goog.style.clearTransparentBackgroundImage=function(el){var style=el.style;"filter"in style?style.filter="":style.backgroundImage="none";};goog.style.showElement=function(el,display){goog.style.setElementShown(el,display);};goog.style.setElementShown=function(el,isShown){el.style.display=isShown?"":"none";};goog.style.isElementShown=function(el){return"none"!=el.style.display;};goog.style.installStyles=function(stylesString,opt_node){return goog.style.installSafeStyleSheet(goog.html.legacyconversions.safeStyleSheetFromString(stylesString),opt_node);};goog.style.installSafeStyleSheet=function(safeStyleSheet,opt_node){var dh=goog.dom.getDomHelper(opt_node),styleSheet=null,doc=dh.getDocument();if(goog.userAgent.IE&&doc.createStyleSheet){styleSheet=doc.createStyleSheet(),goog.style.setSafeStyleSheet(styleSheet,safeStyleSheet);}else{var head=dh.getElementsByTagNameAndClass("HEAD")[0];if(!head){var body=dh.getElementsByTagNameAndClass("BODY")[0],head=dh.createDom("HEAD");body.parentNode.insertBefore(head,body);}styleSheet=dh.createDom("STYLE");goog.style.setSafeStyleSheet(styleSheet,safeStyleSheet);dh.appendChild(head,styleSheet);}return styleSheet;};goog.style.uninstallStyles=function(styleSheet){goog.dom.removeNode(styleSheet.ownerNode||styleSheet.owningElement||styleSheet);};goog.style.setStyles=function(element,stylesString){goog.style.setSafeStyleSheet(element,goog.html.legacyconversions.safeStyleSheetFromString(stylesString));};goog.style.setSafeStyleSheet=function(element,safeStyleSheet){var stylesString=goog.html.SafeStyleSheet.unwrap(safeStyleSheet);goog.userAgent.IE&&goog.isDef(element.cssText)?element.cssText=stylesString:element.innerHTML=stylesString;};goog.style.setPreWrap=function(el){var style=el.style;goog.userAgent.IE&&!goog.userAgent.isVersionOrHigher("8")?(style.whiteSpace="pre",style.wordWrap="break-word"):style.whiteSpace=goog.userAgent.GECKO?"-moz-pre-wrap":"pre-wrap";};goog.style.setInlineBlock=function(el){var style=el.style;style.position="relative";goog.userAgent.IE&&!goog.userAgent.isVersionOrHigher("8")?(style.zoom="1",style.display="inline"):style.display="inline-block";};goog.style.isRightToLeft=function(el){return"rtl"==goog.style.getStyle_(el,"direction");};goog.style.unselectableStyle_=goog.userAgent.GECKO?"MozUserSelect":goog.userAgent.WEBKIT||goog.userAgent.EDGE?"WebkitUserSelect":null;goog.style.isUnselectable=function(el){return goog.style.unselectableStyle_?"none"==el.style[goog.style.unselectableStyle_].toLowerCase():goog.userAgent.IE||goog.userAgent.OPERA?"on"==el.getAttribute("unselectable"):!1;};goog.style.setUnselectable=function(el,unselectable,opt_noRecurse){var descendants=opt_noRecurse?null:el.getElementsByTagName("*"),name=goog.style.unselectableStyle_;if(name){var value=unselectable?"none":"";el.style&&(el.style[name]=value);if(descendants){for(var i=0,descendant;descendant=descendants[i];i++){descendant.style&&(descendant.style[name]=value);}}}else{if(goog.userAgent.IE||goog.userAgent.OPERA){if(value=unselectable?"on":"",el.setAttribute("unselectable",value),descendants){for(i=0;descendant=descendants[i];i++){descendant.setAttribute("unselectable",value);}}}}};goog.style.getBorderBoxSize=function(element){return new goog.math.Size(element.offsetWidth,element.offsetHeight);};goog.style.setBorderBoxSize=function(element,size){var doc=goog.dom.getOwnerDocument(element),isCss1CompatMode=goog.dom.getDomHelper(doc).isCss1CompatMode();if(!goog.userAgent.IE||goog.userAgent.isVersionOrHigher("10")||isCss1CompatMode&&goog.userAgent.isVersionOrHigher("8")){goog.style.setBoxSizingSize_(element,size,"border-box");}else{var style=element.style;if(isCss1CompatMode){var paddingBox=goog.style.getPaddingBox(element),borderBox=goog.style.getBorderBox(element);style.pixelWidth=size.width-borderBox.left-paddingBox.left-paddingBox.right-borderBox.right;style.pixelHeight=size.height-borderBox.top-paddingBox.top-paddingBox.bottom-borderBox.bottom;}else{style.pixelWidth=size.width,style.pixelHeight=size.height;}}};goog.style.getContentBoxSize=function(element){var doc=goog.dom.getOwnerDocument(element),ieCurrentStyle=goog.userAgent.IE&&element.currentStyle;if(ieCurrentStyle&&goog.dom.getDomHelper(doc).isCss1CompatMode()&&"auto"!=ieCurrentStyle.width&&"auto"!=ieCurrentStyle.height&&!ieCurrentStyle.boxSizing){var width=goog.style.getIePixelValue_(element,ieCurrentStyle.width,"width","pixelWidth"),height=goog.style.getIePixelValue_(element,ieCurrentStyle.height,"height","pixelHeight");return new goog.math.Size(width,height);}var borderBoxSize=goog.style.getBorderBoxSize(element),paddingBox=goog.style.getPaddingBox(element),borderBox=goog.style.getBorderBox(element);return new goog.math.Size(borderBoxSize.width-borderBox.left-paddingBox.left-paddingBox.right-borderBox.right,borderBoxSize.height-borderBox.top-paddingBox.top-paddingBox.bottom-borderBox.bottom);};goog.style.setContentBoxSize=function(element,size){var doc=goog.dom.getOwnerDocument(element),isCss1CompatMode=goog.dom.getDomHelper(doc).isCss1CompatMode();if(!goog.userAgent.IE||goog.userAgent.isVersionOrHigher("10")||isCss1CompatMode&&goog.userAgent.isVersionOrHigher("8")){goog.style.setBoxSizingSize_(element,size,"content-box");}else{var style=element.style;if(isCss1CompatMode){style.pixelWidth=size.width,style.pixelHeight=size.height;}else{var paddingBox=goog.style.getPaddingBox(element),borderBox=goog.style.getBorderBox(element);style.pixelWidth=size.width+borderBox.left+paddingBox.left+paddingBox.right+borderBox.right;style.pixelHeight=size.height+borderBox.top+paddingBox.top+paddingBox.bottom+borderBox.bottom;}}};goog.style.setBoxSizingSize_=function(element,size,boxSizing){var style=element.style;goog.userAgent.GECKO?style.MozBoxSizing=boxSizing:goog.userAgent.WEBKIT?style.WebkitBoxSizing=boxSizing:style.boxSizing=boxSizing;style.width=Math.max(size.width,0)+"px";style.height=Math.max(size.height,0)+"px";};goog.style.getIePixelValue_=function(element,value,name,pixelName){if(/^\\d+px?$/.test(value)){return parseInt(value,10);}var oldStyleValue=element.style[name],oldRuntimeValue=element.runtimeStyle[name];element.runtimeStyle[name]=element.currentStyle[name];element.style[name]=value;var pixelValue=element.style[pixelName];element.style[name]=oldStyleValue;element.runtimeStyle[name]=oldRuntimeValue;return+pixelValue;};goog.style.getIePixelDistance_=function(element,propName){var value=goog.style.getCascadedStyle(element,propName);return value?goog.style.getIePixelValue_(element,value,"left","pixelLeft"):0;};goog.style.getBox_=function(element,stylePrefix){if(goog.userAgent.IE){var left=goog.style.getIePixelDistance_(element,stylePrefix+"Left");var right=goog.style.getIePixelDistance_(element,stylePrefix+"Right");var top=goog.style.getIePixelDistance_(element,stylePrefix+"Top");var bottom=goog.style.getIePixelDistance_(element,stylePrefix+"Bottom");return new goog.math.Box(top,right,bottom,left);}left=goog.style.getComputedStyle(element,stylePrefix+"Left");right=goog.style.getComputedStyle(element,stylePrefix+"Right");top=goog.style.getComputedStyle(element,stylePrefix+"Top");bottom=goog.style.getComputedStyle(element,stylePrefix+"Bottom");return new goog.math.Box(parseFloat(top),parseFloat(right),parseFloat(bottom),parseFloat(left));};goog.style.getPaddingBox=function(element){return goog.style.getBox_(element,"padding");};goog.style.getMarginBox=function(element){return goog.style.getBox_(element,"margin");};goog.style.ieBorderWidthKeywords_={thin:2,medium:4,thick:6};goog.style.getIePixelBorder_=function(element,prop){if("none"==goog.style.getCascadedStyle(element,prop+"Style")){return 0;}var width=goog.style.getCascadedStyle(element,prop+"Width");return width in goog.style.ieBorderWidthKeywords_?goog.style.ieBorderWidthKeywords_[width]:goog.style.getIePixelValue_(element,width,"left","pixelLeft");};goog.style.getBorderBox=function(element){if(goog.userAgent.IE&&!goog.userAgent.isDocumentModeOrHigher(9)){var left=goog.style.getIePixelBorder_(element,"borderLeft");var right=goog.style.getIePixelBorder_(element,"borderRight");var top=goog.style.getIePixelBorder_(element,"borderTop");var bottom=goog.style.getIePixelBorder_(element,"borderBottom");return new goog.math.Box(top,right,bottom,left);}left=goog.style.getComputedStyle(element,"borderLeftWidth");right=goog.style.getComputedStyle(element,"borderRightWidth");top=goog.style.getComputedStyle(element,"borderTopWidth");bottom=goog.style.getComputedStyle(element,"borderBottomWidth");return new goog.math.Box(parseFloat(top),parseFloat(right),parseFloat(bottom),parseFloat(left));};goog.style.getFontFamily=function(el){var doc=goog.dom.getOwnerDocument(el),font="";if(doc.body.createTextRange&&goog.dom.contains(doc,el)){var range=doc.body.createTextRange();range.moveToElementText(el);try{font=range.queryCommandValue("FontName");}catch(e){font="";}}font||(font=goog.style.getStyle_(el,"fontFamily"));var fontsArray=font.split(",");1<fontsArray.length&&(font=fontsArray[0]);return goog.string.stripQuotes(font,"\\"\'");};goog.style.lengthUnitRegex_=/[^\\d]+$/;goog.style.getLengthUnits=function(value){var units=value.match(goog.style.lengthUnitRegex_);return units&&units[0]||null;};goog.style.ABSOLUTE_CSS_LENGTH_UNITS_={cm:1,"in":1,mm:1,pc:1,pt:1};goog.style.CONVERTIBLE_RELATIVE_CSS_UNITS_={em:1,ex:1};goog.style.getFontSize=function(el){var fontSize=goog.style.getStyle_(el,"fontSize"),sizeUnits=goog.style.getLengthUnits(fontSize);if(fontSize&&"px"==sizeUnits){return parseInt(fontSize,10);}if(goog.userAgent.IE){if(String(sizeUnits)in goog.style.ABSOLUTE_CSS_LENGTH_UNITS_){return goog.style.getIePixelValue_(el,fontSize,"left","pixelLeft");}if(el.parentNode&&el.parentNode.nodeType==goog.dom.NodeType.ELEMENT&&String(sizeUnits)in goog.style.CONVERTIBLE_RELATIVE_CSS_UNITS_){var parentElement=el.parentNode,parentSize=goog.style.getStyle_(parentElement,"fontSize");return goog.style.getIePixelValue_(parentElement,fontSize==parentSize?"1em":fontSize,"left","pixelLeft");}}var sizeElement=goog.dom.createDom("SPAN",{style:"visibility:hidden;position:absolute;line-height:0;padding:0;margin:0;border:0;height:1em;"});goog.dom.appendChild(el,sizeElement);fontSize=sizeElement.offsetHeight;goog.dom.removeNode(sizeElement);return fontSize;};goog.style.parseStyleAttribute=function(value){var result={};goog.array.forEach(value.split(/\\s*;\\s*/),function(pair){var keyValue=pair.match(/\\s*([\\w-]+)\\s*\\:(.+)/);if(keyValue){var styleName=keyValue[1],styleValue=goog.string.trim(keyValue[2]);result[goog.string.toCamelCase(styleName.toLowerCase())]=styleValue;}});return result;};goog.style.toStyleAttribute=function(obj){var buffer=[];goog.object.forEach(obj,function(value,key){buffer.push(goog.string.toSelectorCase(key),":",value,";");});return buffer.join("");};goog.style.setFloat=function(el,value){el.style[goog.userAgent.IE?"styleFloat":"cssFloat"]=value;};goog.style.getFloat=function(el){return el.style[goog.userAgent.IE?"styleFloat":"cssFloat"]||"";};goog.style.getScrollbarWidth=function(opt_className){var outerDiv=goog.dom.createElement("DIV");opt_className&&(outerDiv.className=opt_className);outerDiv.style.cssText="overflow:auto;position:absolute;top:0;width:100px;height:100px";var innerDiv=goog.dom.createElement("DIV");goog.style.setSize(innerDiv,"200px","200px");outerDiv.appendChild(innerDiv);goog.dom.appendChild(goog.dom.getDocument().body,outerDiv);var width=outerDiv.offsetWidth-outerDiv.clientWidth;goog.dom.removeNode(outerDiv);return width;};goog.style.MATRIX_TRANSLATION_REGEX_=/matrix\\([0-9\\.\\-]+, [0-9\\.\\-]+, [0-9\\.\\-]+, [0-9\\.\\-]+, ([0-9\\.\\-]+)p?x?, ([0-9\\.\\-]+)p?x?\\)/;goog.style.getCssTranslation=function(element){var transform=goog.style.getComputedTransform(element);if(!transform){return new goog.math.Coordinate(0,0);}var matches=transform.match(goog.style.MATRIX_TRANSLATION_REGEX_);return matches?new goog.math.Coordinate(parseFloat(matches[1]),parseFloat(matches[2])):new goog.math.Coordinate(0,0);};var ee={layers:{}};ee.layers.AbstractOverlay=function(tileSource,opt_options){goog.events.EventTarget.call(this);var options=opt_options||{};this.minZoom=options.minZoom||0;this.maxZoom=options.maxZoom||20;if(!window.google||!window.google.maps){throw Error("Google Maps API hasn\'t been initialized.");}this.tileSize=options.tileSize||new google.maps.Size(ee.layers.AbstractOverlay.DEFAULT_TILE_EDGE_LENGTH,ee.layers.AbstractOverlay.DEFAULT_TILE_EDGE_LENGTH);this.isPng="isPng"in options?options.isPng:!0;this.name=options.name;this.opacity="opacity"in options?options.opacity:1;this.tilesById=new goog.structs.Map();this.tileCounter=0;this.tileSource=tileSource;this.handler=new goog.events.EventHandler(this);this.alt=this.radius=this.projection=void 0;};goog.inherits(ee.layers.AbstractOverlay,goog.events.EventTarget);ee.layers.AbstractOverlay.EventType={TILE_FAIL:"tile-fail",TILE_THROTTLE:"tile-throttle",TILE_LOAD:"tile-load"};ee.layers.AbstractOverlay.DEFAULT_TILE_EDGE_LENGTH=256;ee.layers.AbstractOverlay.prototype.addTileCallback=function(callback){return goog.events.listen(this,ee.layers.AbstractOverlay.EventType.TILE_LOAD,callback);};ee.layers.AbstractOverlay.prototype.removeTileCallback=function(callbackId){goog.events.unlistenByKey(callbackId);};ee.layers.AbstractOverlay.prototype.getLoadingTilesCount=function(){return this.getTileCountForStatus_(ee.layers.AbstractTile.Status.THROTTLED)+this.getTileCountForStatus_(ee.layers.AbstractTile.Status.LOADING)+this.getTileCountForStatus_(ee.layers.AbstractTile.Status.NEW);};ee.layers.AbstractOverlay.prototype.getFailedTilesCount=function(){return this.getTileCountForStatus_(ee.layers.AbstractTile.Status.FAILED);};ee.layers.AbstractOverlay.prototype.getLoadedTilesCount=function(){return this.getTileCountForStatus_(ee.layers.AbstractTile.Status.LOADED);};ee.layers.AbstractOverlay.prototype.setOpacity=function(opacity){this.opacity=opacity;this.tilesById.forEach(function(tile){goog.style.setOpacity(tile.div,this.opacity);},this);};ee.layers.AbstractOverlay.prototype.getTile=function(coord,zoom,ownerDocument){var maxCoord=1<<zoom;if(zoom<this.minZoom||0>coord.y||coord.y>=maxCoord){return ownerDocument.createElement("div");}var x=coord.x%maxCoord;0>x&&(x+=maxCoord);var normalizedCoord=new google.maps.Point(x,coord.y),uniqueId=this.getUniqueTileId_(coord,zoom),tile=this.createTile(normalizedCoord,zoom,ownerDocument,uniqueId);tile.tileSize=this.tileSize;goog.style.setOpacity(tile.div,this.opacity);this.tilesById.set(uniqueId,tile);this.handler.listen(tile,ee.layers.AbstractTile.EventType.STATUS_CHANGED,function(){var Status=ee.layers.AbstractTile.Status;switch(tile.getStatus()){case Status.LOADED:this.dispatchEvent(new ee.layers.TileLoadEvent(this.getLoadingTilesCount()));break;case Status.THROTTLED:this.dispatchEvent(new ee.layers.TileThrottleEvent(tile.sourceUrl));break;case Status.FAILED:this.dispatchEvent(new ee.layers.TileFailEvent(tile.sourceUrl,tile.errorMessage_));}});this.tileSource.loadTile(tile,new Date().getTime()/1000);return tile.div;};ee.layers.AbstractOverlay.prototype.releaseTile=function(tileDiv){var tile=this.tilesById.get(tileDiv.id);this.tilesById.remove(tileDiv.id);tile&&(tile.abort(),goog.dispose(tile));};ee.layers.AbstractOverlay.prototype.getUniqueTileId_=function(coord,z){var tileId=[coord.x,coord.y,z,this.tileCounter].join("-"),sourceId=this.tileSource.getUniqueId();return[tileId,sourceId].join("-");};ee.layers.AbstractOverlay.prototype.disposeInternal=function(){ee.layers.AbstractOverlay.superClass_.disposeInternal.call(this);this.tilesById.forEach(goog.dispose);this.tilesById.clear();this.tilesById=null;goog.dispose(this.handler);this.tileSource=this.handler=null;};ee.layers.AbstractOverlay.prototype.getTileCountForStatus_=function(status){return goog.array.count(this.tilesById.getValues(),function(tile){return tile.getStatus()==status;});};ee.layers.TileLoadEvent=function(loadingTileCount){goog.events.Event.call(this,ee.layers.AbstractOverlay.EventType.TILE_LOAD);this.loadingTileCount=loadingTileCount;};goog.inherits(ee.layers.TileLoadEvent,goog.events.Event);ee.layers.TileThrottleEvent=function(tileUrl){goog.events.Event.call(this,ee.layers.AbstractOverlay.EventType.TILE_THROTTLE);this.tileUrl=tileUrl;};goog.inherits(ee.layers.TileThrottleEvent,goog.events.Event);ee.layers.TileFailEvent=function(tileUrl,opt_errorMessage){goog.events.Event.call(this,ee.layers.AbstractOverlay.EventType.TILE_FAIL);this.tileUrl=tileUrl;this.errorMessage=opt_errorMessage;};goog.inherits(ee.layers.TileFailEvent,goog.events.Event);ee.layers.AbstractTile=function(coord,zoom,ownerDocument,uniqueId){goog.events.EventTarget.call(this);this.coord=coord;this.zoom=zoom;this.div=ownerDocument.createElement("div");this.div.id=uniqueId;this.maxRetries=ee.layers.AbstractTile.DEFAULT_MAX_LOAD_RETRIES_;this.renderer=function(){};this.status_=ee.layers.AbstractTile.Status.NEW;this.retryAttemptCount_=0;this.isRetrying_=!1;};goog.inherits(ee.layers.AbstractTile,goog.events.EventTarget);ee.layers.AbstractTile.EventType={STATUS_CHANGED:"status-changed"};ee.layers.AbstractTile.Status={NEW:"new",LOADING:"loading",THROTTLED:"throttled",LOADED:"loaded",FAILED:"failed",ABORTED:"aborted"};ee.layers.AbstractTile.prototype.startLoad=function(){if(!this.isRetrying_&&this.getStatus()==ee.layers.AbstractTile.Status.LOADING){throw Error("startLoad() can only be invoked once. Use retryLoad() after the first attempt.");}this.setStatus(ee.layers.AbstractTile.Status.LOADING);this.xhrIo_=new goog.net.XhrIo();this.xhrIo_.setResponseType(goog.net.XhrIo.ResponseType.BLOB);this.xhrIo_.listen(goog.net.EventType.COMPLETE,function(event){var blob=this.xhrIo_.getResponse(),status=this.xhrIo_.getStatus(),HttpStatus=goog.net.HttpStatus;status==HttpStatus.TOO_MANY_REQUESTS&&this.setStatus(ee.layers.AbstractTile.Status.THROTTLED);if(status>=HttpStatus.OK&&status<HttpStatus.MULTIPLE_CHOICES){this.sourceResponseHeaders=this.xhrIo_.getResponseHeaders(),this.sourceData=blob,this.finishLoad();}else{if(blob){var reader=new goog.fs.FileReader();reader.listen(goog.fs.FileReader.EventType.LOAD_END,function(){this.retryLoad(reader.getResult());},void 0,this);reader.readAsText(blob);}else{this.retryLoad("Failed to load tile.");}}},!1,this);this.xhrIo_.listenOnce(goog.net.EventType.READY,goog.partial(goog.dispose,this.xhrIo_));this.xhrIo_.send(this.sourceUrl,"GET");};ee.layers.AbstractTile.prototype.finishLoad=function(){this.renderer(this);this.setStatus(ee.layers.AbstractTile.Status.LOADED);};ee.layers.AbstractTile.prototype.cancelLoad=function(){goog.dispose(this.xhrIo_);};ee.layers.AbstractTile.prototype.retryLoad=function(opt_errorMessage){var parseError=function parseError(error){try{if(error=JSON.parse(error),error.error&&error.error.message){return error.error.message;}}catch(e){}return error;};this.retryAttemptCount_>=this.maxRetries?(this.errorMessage_=parseError(opt_errorMessage),this.setStatus(ee.layers.AbstractTile.Status.FAILED)):(this.cancelLoad(),setTimeout(goog.bind(function(){this.isDisposed()||(this.isRetrying_=!0,this.startLoad(),this.isRetrying_=!1);},this),1000*Math.pow(2,this.retryAttemptCount_++)));};ee.layers.AbstractTile.prototype.abort=function(){this.cancelLoad();this.setStatus(ee.layers.AbstractTile.Status.ABORTED);};ee.layers.AbstractTile.prototype.isDone=function(){return this.status_ in ee.layers.AbstractTile.DONE_STATUS_SET_;};ee.layers.AbstractTile.prototype.getStatus=function(){return this.status_;};ee.layers.AbstractTile.prototype.setStatus=function(status){this.status_=status;this.dispatchEvent(ee.layers.AbstractTile.EventType.STATUS_CHANGED);};ee.layers.AbstractTile.DONE_STATUS_SET_=goog.object.createSet(ee.layers.AbstractTile.Status.ABORTED,ee.layers.AbstractTile.Status.FAILED,ee.layers.AbstractTile.Status.LOADED);ee.layers.AbstractTile.prototype.disposeInternal=function(){ee.layers.AbstractTile.superClass_.disposeInternal.call(this);this.cancelLoad();this.div.remove();this.renderer=null;};ee.layers.AbstractTile.DEFAULT_MAX_LOAD_RETRIES_=5;ee.layers.AbstractTileSource=function(){goog.Disposable.call(this);};goog.inherits(ee.layers.AbstractTileSource,goog.Disposable);ee.layers.BinaryOverlay=function(tileSource,opt_options){ee.layers.AbstractOverlay.call(this,tileSource,opt_options);this.buffersByCoord_=new goog.structs.Map();this.divsByCoord_=new goog.structs.Map();};goog.inherits(ee.layers.BinaryOverlay,ee.layers.AbstractOverlay);ee.layers.BinaryOverlay.prototype.createTile=function(coord,zoom,ownerDocument,uniqueId){var tile=new ee.layers.BinaryTile(coord,zoom,ownerDocument,uniqueId);this.handler.listen(tile,ee.layers.AbstractTile.EventType.STATUS_CHANGED,function(){tile.getStatus()==ee.layers.AbstractTile.Status.LOADED&&(this.buffersByCoord_.set(coord,new Float32Array(tile.buffer_)),this.divsByCoord_.set(coord,tile.div));});return tile;};ee.layers.BinaryOverlay.prototype.getBuffersByCoord=function(){return this.buffersByCoord_;};ee.layers.BinaryOverlay.prototype.getDivsByCoord=function(){return this.divsByCoord_;};ee.layers.BinaryOverlay.prototype.disposeInternal=function(){ee.layers.BinaryOverlay.superClass_.disposeInternal.call(this);this.divsByCoord_=this.buffersByCoord_=null;};ee.layers.BinaryTile=function(coord,zoom,ownerDocument,uniqueId){ee.layers.AbstractTile.call(this,coord,zoom,ownerDocument,uniqueId);};goog.inherits(ee.layers.BinaryTile,ee.layers.AbstractTile);ee.layers.BinaryTile.prototype.finishLoad=function(){var reader=new goog.fs.FileReader();reader.listen(goog.fs.FileReader.EventType.LOAD_END,function(){this.buffer_=reader.getResult();ee.layers.AbstractTile.prototype.finishLoad.call(this);},void 0,this);reader.readAsArrayBuffer(this.sourceData);};goog.string.path={};goog.string.path.baseName=function(path){var i=path.lastIndexOf("/")+1;return path.slice(i);};goog.string.path.basename=goog.string.path.baseName;goog.string.path.dirname=function(path){var i=path.lastIndexOf("/")+1,head=path.slice(0,i);/^\\/+$/.test(head)||(head=head.replace(/\\/+$/,""));return head;};goog.string.path.extension=function(path){var baseName=goog.string.path.baseName(path).replace(/\\.+/g,"."),separatorIndex=baseName.lastIndexOf(".");return 0>=separatorIndex?"":baseName.substr(separatorIndex+1);};goog.string.path.join=function(var_args){for(var path=arguments[0],i=1;i<arguments.length;i++){var arg=arguments[i],path=goog.string.startsWith(arg,"/")?arg:""==path||goog.string.endsWith(path,"/")?path+arg:path+("/"+arg);}return path;};goog.string.path.normalizePath=function(path){if(""==path){return".";}var initialSlashes="";goog.string.startsWith(path,"/")&&(initialSlashes="/",goog.string.startsWith(path,"//")&&!goog.string.startsWith(path,"///")&&(initialSlashes="//"));for(var parts=path.split("/"),newParts=[],i=0;i<parts.length;i++){var part=parts[i];""!=part&&"."!=part&&(".."!=part||!initialSlashes&&!newParts.length||".."==goog.array.peek(newParts)?newParts.push(part):newParts.pop());}return initialSlashes+newParts.join("/")||".";};goog.string.path.split=function(path){var head=goog.string.path.dirname(path),tail=goog.string.path.baseName(path);return[head,tail];};ee.layers.CloudStorageTileSource=function(bucket,path,maxZoom,opt_suffix){ee.layers.AbstractTileSource.call(this);this.bucket_=bucket;this.path_=path;this.suffix_=opt_suffix||"";this.maxZoom_=maxZoom;};goog.inherits(ee.layers.CloudStorageTileSource,ee.layers.AbstractTileSource);ee.layers.CloudStorageTileSource.prototype.loadTile=function(tile,opt_priority){if(tile.zoom<=this.maxZoom_){tile.sourceUrl=this.getTileUrl_(tile.coord,tile.zoom);}else{var zoomSteps=tile.zoom-this.maxZoom_,zoomFactor=Math.pow(2,zoomSteps),upperCoord=new google.maps.Point(Math.floor(tile.coord.x/zoomFactor),Math.floor(tile.coord.y/zoomFactor));tile.sourceUrl=this.getTileUrl_(upperCoord,tile.zoom-zoomSteps);tile.renderer=goog.partial(ee.layers.CloudStorageTileSource.zoomTileRenderer_,this.maxZoom_);}var originalRetryLoad=goog.bind(tile.retryLoad,tile);tile.retryLoad=goog.bind(function(opt_errorMessage){opt_errorMessage&&goog.string.contains(opt_errorMessage,ee.layers.CloudStorageTileSource.MISSING_TILE_ERROR_)?tile.setStatus(ee.layers.AbstractTile.Status.LOADED):originalRetryLoad(opt_errorMessage);},tile);tile.startLoad();};ee.layers.CloudStorageTileSource.prototype.getUniqueId=function(){return[this.bucket_,this.path_,this.maxZoom_,this.suffix_].join("-");};ee.layers.CloudStorageTileSource.prototype.getTileUrl_=function(coord,zoom){var url=goog.string.path.join(ee.layers.CloudStorageTileSource.BASE_URL_,this.bucket_,this.path_,String(zoom),String(coord.x),String(coord.y));this.suffix_&&(url+=this.suffix_);return url;};ee.layers.CloudStorageTileSource.zoomTileRenderer_=function(maxZoom,tile){if(!tile.imageEl){throw Error("Tile must have an image element to be rendered.");}var zoomFactor=Math.pow(2,tile.zoom-maxZoom),sideLength=tile.tileSize.width,canv=tile.div.ownerDocument.createElement("canvas");canv.setAttribute("width",sideLength);canv.setAttribute("height",sideLength);tile.div.appendChild(canv);var context=canv.getContext("2d");context.imageSmoothingEnabled=!1;context.mozImageSmoothingEnabled=!1;context.webkitImageSmoothingEnabled=!1;context.drawImage(tile.imageEl,sideLength/zoomFactor*(tile.coord.x%zoomFactor),sideLength/zoomFactor*(tile.coord.y%zoomFactor),sideLength/zoomFactor,sideLength/zoomFactor,0,0,sideLength,sideLength);};ee.layers.CloudStorageTileSource.BASE_URL_="https://storage.googleapis.com";ee.layers.CloudStorageTileSource.MISSING_TILE_ERROR_="The specified key does not exist.";goog.async.Throttle=function(listener,interval,opt_handler){goog.Disposable.call(this);this.listener_=null!=opt_handler?goog.bind(listener,opt_handler):listener;this.interval_=interval;this.callback_=goog.bind(this.onTimer_,this);this.args_=[];};goog.inherits(goog.async.Throttle,goog.Disposable);goog.Throttle=goog.async.Throttle;goog.async.Throttle.prototype.shouldFire_=!1;goog.async.Throttle.prototype.pauseCount_=0;goog.async.Throttle.prototype.timer_=null;goog.async.Throttle.prototype.fire=function(var_args){this.args_=arguments;this.timer_||this.pauseCount_?this.shouldFire_=!0:this.doAction_();};goog.async.Throttle.prototype.stop=function(){this.timer_&&(goog.Timer.clear(this.timer_),this.timer_=null,this.shouldFire_=!1,this.args_=[]);};goog.async.Throttle.prototype.pause=function(){this.pauseCount_++;};goog.async.Throttle.prototype.resume=function(){this.pauseCount_--;this.pauseCount_||!this.shouldFire_||this.timer_||(this.shouldFire_=!1,this.doAction_());};goog.async.Throttle.prototype.disposeInternal=function(){goog.async.Throttle.superClass_.disposeInternal.call(this);this.stop();};goog.async.Throttle.prototype.onTimer_=function(){this.timer_=null;this.shouldFire_&&!this.pauseCount_&&(this.shouldFire_=!1,this.doAction_());};goog.async.Throttle.prototype.doAction_=function(){this.timer_=goog.Timer.callOnce(this.callback_,this.interval_);this.listener_.apply(null,this.args_);};goog.net.jsloader={};goog.net.jsloader.GLOBAL_VERIFY_OBJS_="closure_verification";goog.net.jsloader.DEFAULT_TIMEOUT=5000;goog.net.jsloader.scriptsToLoad_=[];goog.net.jsloader.loadMany=function(uris,opt_options){var trustedUris=goog.array.map(uris,goog.html.legacyconversions.trustedResourceUrlFromString);return goog.net.jsloader.safeLoadMany(trustedUris,opt_options);};goog.net.jsloader.safeLoadMany=function(trustedUris,opt_options){if(!trustedUris.length){return goog.async.Deferred.succeed(null);}var isAnotherModuleLoading=goog.net.jsloader.scriptsToLoad_.length;goog.array.extend(goog.net.jsloader.scriptsToLoad_,trustedUris);if(isAnotherModuleLoading){return goog.net.jsloader.scriptLoadingDeferred_;}trustedUris=goog.net.jsloader.scriptsToLoad_;var popAndLoadNextScript=function popAndLoadNextScript(){var trustedUri=trustedUris.shift(),deferred=goog.net.jsloader.safeLoad(trustedUri,opt_options);trustedUris.length&&deferred.addBoth(popAndLoadNextScript);return deferred;};goog.net.jsloader.scriptLoadingDeferred_=popAndLoadNextScript();return goog.net.jsloader.scriptLoadingDeferred_;};goog.net.jsloader.load=function(uri,opt_options){var trustedUri=goog.html.legacyconversions.trustedResourceUrlFromString(uri);return goog.net.jsloader.safeLoad(trustedUri,opt_options);};goog.net.jsloader.safeLoad=function(trustedUri,opt_options){var options=opt_options||{},doc=options.document||document,uri=goog.html.TrustedResourceUrl.unwrap(trustedUri),script=goog.dom.createElement("SCRIPT"),request={script_:script,timeout_:void 0},deferred=new goog.async.Deferred(goog.net.jsloader.cancel_,request),timeout=null,timeoutDuration=goog.isDefAndNotNull(options.timeout)?options.timeout:goog.net.jsloader.DEFAULT_TIMEOUT;0<timeoutDuration&&(timeout=window.setTimeout(function(){goog.net.jsloader.cleanup_(script,!0);deferred.errback(new goog.net.jsloader.Error(goog.net.jsloader.ErrorCode.TIMEOUT,"Timeout reached for loading script "+uri));},timeoutDuration),request.timeout_=timeout);script.onload=script.onreadystatechange=function(){script.readyState&&"loaded"!=script.readyState&&"complete"!=script.readyState||(goog.net.jsloader.cleanup_(script,options.cleanupWhenDone||!1,timeout),deferred.callback(null));};script.onerror=function(){goog.net.jsloader.cleanup_(script,!0,timeout);deferred.errback(new goog.net.jsloader.Error(goog.net.jsloader.ErrorCode.LOAD_ERROR,"Error while loading script "+uri));};var properties=options.attributes||{};goog.object.extend(properties,{type:"text/javascript",charset:"UTF-8",src:uri});goog.dom.setProperties(script,properties);goog.net.jsloader.getScriptParentElement_(doc).appendChild(script);return deferred;};goog.net.jsloader.loadAndVerify=function(uri,verificationObjName,options){var trustedUri=goog.html.legacyconversions.trustedResourceUrlFromString(uri);return goog.net.jsloader.safeLoadAndVerify(trustedUri,verificationObjName,options);};goog.net.jsloader.safeLoadAndVerify=function(trustedUri,verificationObjName,options){goog.global[goog.net.jsloader.GLOBAL_VERIFY_OBJS_]||(goog.global[goog.net.jsloader.GLOBAL_VERIFY_OBJS_]={});var verifyObjs=goog.global[goog.net.jsloader.GLOBAL_VERIFY_OBJS_],uri=goog.html.TrustedResourceUrl.unwrap(trustedUri);if(goog.isDef(verifyObjs[verificationObjName])){return goog.async.Deferred.fail(new goog.net.jsloader.Error(goog.net.jsloader.ErrorCode.VERIFY_OBJECT_ALREADY_EXISTS,"Verification object "+verificationObjName+" already defined."));}var sendDeferred=goog.net.jsloader.safeLoad(trustedUri,options),deferred=new goog.async.Deferred(goog.bind(sendDeferred.cancel,sendDeferred));sendDeferred.addCallback(function(){var result=verifyObjs[verificationObjName];goog.isDef(result)?(deferred.callback(result),delete verifyObjs[verificationObjName]):deferred.errback(new goog.net.jsloader.Error(goog.net.jsloader.ErrorCode.VERIFY_ERROR,"Script "+uri+" loaded, but verification object "+verificationObjName+" was not defined."));});sendDeferred.addErrback(function(error){goog.isDef(verifyObjs[verificationObjName])&&delete verifyObjs[verificationObjName];deferred.errback(error);});return deferred;};goog.net.jsloader.getScriptParentElement_=function(doc){var headElements=goog.dom.getElementsByTagName("HEAD",doc);return!headElements||goog.array.isEmpty(headElements)?doc.documentElement:headElements[0];};goog.net.jsloader.cancel_=function(){if(this&&this.script_){var scriptNode=this.script_;scriptNode&&"SCRIPT"==scriptNode.tagName&&goog.net.jsloader.cleanup_(scriptNode,!0,this.timeout_);}};goog.net.jsloader.cleanup_=function(scriptNode,removeScriptNode,opt_timeout){goog.isDefAndNotNull(opt_timeout)&&goog.global.clearTimeout(opt_timeout);scriptNode.onload=goog.nullFunction;scriptNode.onerror=goog.nullFunction;scriptNode.onreadystatechange=goog.nullFunction;removeScriptNode&&window.setTimeout(function(){goog.dom.removeNode(scriptNode);},0);};goog.net.jsloader.ErrorCode={LOAD_ERROR:0,TIMEOUT:1,VERIFY_ERROR:2,VERIFY_OBJECT_ALREADY_EXISTS:3};goog.net.jsloader.Error=function(code,opt_message){var msg="Jsloader error (code #"+code+")";opt_message&&(msg+=": "+opt_message);goog.debug.Error.call(this,msg);this.code=code;};goog.inherits(goog.net.jsloader.Error,goog.debug.Error);goog.Uri=function(opt_uri,opt_ignoreCase){this.domain_=this.userInfo_=this.scheme_="";this.port_=null;this.fragment_=this.path_="";this.ignoreCase_=this.isReadOnly_=!1;var m;opt_uri instanceof goog.Uri?(this.ignoreCase_=goog.isDef(opt_ignoreCase)?opt_ignoreCase:opt_uri.getIgnoreCase(),this.setScheme(opt_uri.getScheme()),this.setUserInfo(opt_uri.getUserInfo()),this.setDomain(opt_uri.getDomain()),this.setPort(opt_uri.getPort()),this.setPath(opt_uri.getPath()),this.setQueryData(opt_uri.getQueryData().clone()),this.setFragment(opt_uri.getFragment())):opt_uri&&(m=goog.uri.utils.split(String(opt_uri)))?(this.ignoreCase_=!!opt_ignoreCase,this.setScheme(m[goog.uri.utils.ComponentIndex.SCHEME]||"",!0),this.setUserInfo(m[goog.uri.utils.ComponentIndex.USER_INFO]||"",!0),this.setDomain(m[goog.uri.utils.ComponentIndex.DOMAIN]||"",!0),this.setPort(m[goog.uri.utils.ComponentIndex.PORT]),this.setPath(m[goog.uri.utils.ComponentIndex.PATH]||"",!0),this.setQueryData(m[goog.uri.utils.ComponentIndex.QUERY_DATA]||"",!0),this.setFragment(m[goog.uri.utils.ComponentIndex.FRAGMENT]||"",!0)):(this.ignoreCase_=!!opt_ignoreCase,this.queryData_=new goog.Uri.QueryData(null,null,this.ignoreCase_));};goog.Uri.preserveParameterTypesCompatibilityFlag=!1;goog.Uri.RANDOM_PARAM=goog.uri.utils.StandardQueryParam.RANDOM;goog.Uri.prototype.toString=function(){var out=[],scheme=this.getScheme();scheme&&out.push(goog.Uri.encodeSpecialChars_(scheme,goog.Uri.reDisallowedInSchemeOrUserInfo_,!0),":");var domain=this.getDomain();if(domain||"file"==scheme){out.push("//");var userInfo=this.getUserInfo();userInfo&&out.push(goog.Uri.encodeSpecialChars_(userInfo,goog.Uri.reDisallowedInSchemeOrUserInfo_,!0),"@");out.push(goog.Uri.removeDoubleEncoding_(goog.string.urlEncode(domain)));var port=this.getPort();null!=port&&out.push(":",String(port));}var path=this.getPath();path&&(this.hasDomain()&&"/"!=path.charAt(0)&&out.push("/"),out.push(goog.Uri.encodeSpecialChars_(path,"/"==path.charAt(0)?goog.Uri.reDisallowedInAbsolutePath_:goog.Uri.reDisallowedInRelativePath_,!0)));var query=this.getEncodedQuery();query&&out.push("?",query);var fragment=this.getFragment();fragment&&out.push("#",goog.Uri.encodeSpecialChars_(fragment,goog.Uri.reDisallowedInFragment_));return out.join("");};goog.Uri.prototype.resolve=function(relativeUri){var absoluteUri=this.clone(),overridden=relativeUri.hasScheme();overridden?absoluteUri.setScheme(relativeUri.getScheme()):overridden=relativeUri.hasUserInfo();overridden?absoluteUri.setUserInfo(relativeUri.getUserInfo()):overridden=relativeUri.hasDomain();overridden?absoluteUri.setDomain(relativeUri.getDomain()):overridden=relativeUri.hasPort();var path=relativeUri.getPath();if(overridden){absoluteUri.setPort(relativeUri.getPort());}else{if(overridden=relativeUri.hasPath()){if("/"!=path.charAt(0)){if(this.hasDomain()&&!this.hasPath()){path="/"+path;}else{var lastSlashIndex=absoluteUri.getPath().lastIndexOf("/");-1!=lastSlashIndex&&(path=absoluteUri.getPath().substr(0,lastSlashIndex+1)+path);}}path=goog.Uri.removeDotSegments(path);}}overridden?absoluteUri.setPath(path):overridden=relativeUri.hasQuery();overridden?absoluteUri.setQueryData(relativeUri.getQueryData().clone()):overridden=relativeUri.hasFragment();overridden&&absoluteUri.setFragment(relativeUri.getFragment());return absoluteUri;};goog.Uri.prototype.clone=function(){return new goog.Uri(this);};goog.Uri.prototype.getScheme=function(){return this.scheme_;};goog.Uri.prototype.setScheme=function(newScheme,opt_decode){this.enforceReadOnly();if(this.scheme_=opt_decode?goog.Uri.decodeOrEmpty_(newScheme,!0):newScheme){this.scheme_=this.scheme_.replace(/:$/,"");}return this;};goog.Uri.prototype.hasScheme=function(){return!!this.scheme_;};goog.Uri.prototype.getUserInfo=function(){return this.userInfo_;};goog.Uri.prototype.setUserInfo=function(newUserInfo,opt_decode){this.enforceReadOnly();this.userInfo_=opt_decode?goog.Uri.decodeOrEmpty_(newUserInfo):newUserInfo;return this;};goog.Uri.prototype.hasUserInfo=function(){return!!this.userInfo_;};goog.Uri.prototype.getDomain=function(){return this.domain_;};goog.Uri.prototype.setDomain=function(newDomain,opt_decode){this.enforceReadOnly();this.domain_=opt_decode?goog.Uri.decodeOrEmpty_(newDomain,!0):newDomain;return this;};goog.Uri.prototype.hasDomain=function(){return!!this.domain_;};goog.Uri.prototype.getPort=function(){return this.port_;};goog.Uri.prototype.setPort=function(newPort){this.enforceReadOnly();if(newPort){newPort=Number(newPort);if(isNaN(newPort)||0>newPort){throw Error("Bad port number "+newPort);}this.port_=newPort;}else{this.port_=null;}return this;};goog.Uri.prototype.hasPort=function(){return null!=this.port_;};goog.Uri.prototype.getPath=function(){return this.path_;};goog.Uri.prototype.setPath=function(newPath,opt_decode){this.enforceReadOnly();this.path_=opt_decode?goog.Uri.decodeOrEmpty_(newPath,!0):newPath;return this;};goog.Uri.prototype.hasPath=function(){return!!this.path_;};goog.Uri.prototype.hasQuery=function(){return""!==this.queryData_.toString();};goog.Uri.prototype.setQueryData=function(queryData,opt_decode){this.enforceReadOnly();queryData instanceof goog.Uri.QueryData?(this.queryData_=queryData,this.queryData_.setIgnoreCase(this.ignoreCase_)):(opt_decode||(queryData=goog.Uri.encodeSpecialChars_(queryData,goog.Uri.reDisallowedInQuery_)),this.queryData_=new goog.Uri.QueryData(queryData,null,this.ignoreCase_));return this;};goog.Uri.prototype.setQuery=function(newQuery,opt_decode){return this.setQueryData(newQuery,opt_decode);};goog.Uri.prototype.getEncodedQuery=function(){return this.queryData_.toString();};goog.Uri.prototype.getDecodedQuery=function(){return this.queryData_.toDecodedString();};goog.Uri.prototype.getQueryData=function(){return this.queryData_;};goog.Uri.prototype.getQuery=function(){return this.getEncodedQuery();};goog.Uri.prototype.setParameterValue=function(key,value){this.enforceReadOnly();this.queryData_.set(key,value);return this;};goog.Uri.prototype.setParameterValues=function(key,values){this.enforceReadOnly();goog.isArray(values)||(values=[String(values)]);this.queryData_.setValues(key,values);return this;};goog.Uri.prototype.getParameterValues=function(name){return this.queryData_.getValues(name);};goog.Uri.prototype.getParameterValue=function(paramName){return this.queryData_.get(paramName);};goog.Uri.prototype.getFragment=function(){return this.fragment_;};goog.Uri.prototype.setFragment=function(newFragment,opt_decode){this.enforceReadOnly();this.fragment_=opt_decode?goog.Uri.decodeOrEmpty_(newFragment):newFragment;return this;};goog.Uri.prototype.hasFragment=function(){return!!this.fragment_;};goog.Uri.prototype.hasSameDomainAs=function(uri2){return(!this.hasDomain()&&!uri2.hasDomain()||this.getDomain()==uri2.getDomain())&&(!this.hasPort()&&!uri2.hasPort()||this.getPort()==uri2.getPort());};goog.Uri.prototype.makeUnique=function(){this.enforceReadOnly();this.setParameterValue(goog.Uri.RANDOM_PARAM,goog.string.getRandomString());return this;};goog.Uri.prototype.removeParameter=function(key){this.enforceReadOnly();this.queryData_.remove(key);return this;};goog.Uri.prototype.setReadOnly=function(isReadOnly){this.isReadOnly_=isReadOnly;return this;};goog.Uri.prototype.isReadOnly=function(){return this.isReadOnly_;};goog.Uri.prototype.enforceReadOnly=function(){if(this.isReadOnly_){throw Error("Tried to modify a read-only Uri");}};goog.Uri.prototype.setIgnoreCase=function(ignoreCase){this.ignoreCase_=ignoreCase;this.queryData_&&this.queryData_.setIgnoreCase(ignoreCase);return this;};goog.Uri.prototype.getIgnoreCase=function(){return this.ignoreCase_;};goog.Uri.parse=function(uri,opt_ignoreCase){return uri instanceof goog.Uri?uri.clone():new goog.Uri(uri,opt_ignoreCase);};goog.Uri.create=function(opt_scheme,opt_userInfo,opt_domain,opt_port,opt_path,opt_query,opt_fragment,opt_ignoreCase){var uri=new goog.Uri(null,opt_ignoreCase);opt_scheme&&uri.setScheme(opt_scheme);opt_userInfo&&uri.setUserInfo(opt_userInfo);opt_domain&&uri.setDomain(opt_domain);opt_port&&uri.setPort(opt_port);opt_path&&uri.setPath(opt_path);opt_query&&uri.setQueryData(opt_query);opt_fragment&&uri.setFragment(opt_fragment);return uri;};goog.Uri.resolve=function(base,rel){base instanceof goog.Uri||(base=goog.Uri.parse(base));rel instanceof goog.Uri||(rel=goog.Uri.parse(rel));return base.resolve(rel);};goog.Uri.removeDotSegments=function(path){if(".."==path||"."==path){return"";}if(goog.string.contains(path,"./")||goog.string.contains(path,"/.")){for(var leadingSlash=goog.string.startsWith(path,"/"),segments=path.split("/"),out=[],pos=0;pos<segments.length;){var segment=segments[pos++];"."==segment?leadingSlash&&pos==segments.length&&out.push(""):".."==segment?((1<out.length||1==out.length&&""!=out[0])&&out.pop(),leadingSlash&&pos==segments.length&&out.push("")):(out.push(segment),leadingSlash=!0);}return out.join("/");}return path;};goog.Uri.decodeOrEmpty_=function(val,opt_preserveReserved){return val?opt_preserveReserved?decodeURI(val.replace(/%25/g,"%2525")):decodeURIComponent(val):"";};goog.Uri.encodeSpecialChars_=function(unescapedPart,extra,opt_removeDoubleEncoding){if(goog.isString(unescapedPart)){var encoded=encodeURI(unescapedPart).replace(extra,goog.Uri.encodeChar_);opt_removeDoubleEncoding&&(encoded=goog.Uri.removeDoubleEncoding_(encoded));return encoded;}return null;};goog.Uri.encodeChar_=function(ch){var n=ch.charCodeAt(0);return"%"+(n>>4&15).toString(16)+(n&15).toString(16);};goog.Uri.removeDoubleEncoding_=function(doubleEncodedString){return doubleEncodedString.replace(/%25([0-9a-fA-F]{2})/g,"%$1");};goog.Uri.reDisallowedInSchemeOrUserInfo_=/[#\\/\\?@]/g;goog.Uri.reDisallowedInRelativePath_=/[\\#\\?:]/g;goog.Uri.reDisallowedInAbsolutePath_=/[\\#\\?]/g;goog.Uri.reDisallowedInQuery_=/[\\#\\?@]/g;goog.Uri.reDisallowedInFragment_=/#/g;goog.Uri.haveSameDomain=function(uri1String,uri2String){var pieces1=goog.uri.utils.split(uri1String),pieces2=goog.uri.utils.split(uri2String);return pieces1[goog.uri.utils.ComponentIndex.DOMAIN]==pieces2[goog.uri.utils.ComponentIndex.DOMAIN]&&pieces1[goog.uri.utils.ComponentIndex.PORT]==pieces2[goog.uri.utils.ComponentIndex.PORT];};goog.Uri.QueryData=function(opt_query,opt_uri,opt_ignoreCase){this.count_=this.keyMap_=null;this.encodedQuery_=opt_query||null;this.ignoreCase_=!!opt_ignoreCase;};goog.Uri.QueryData.prototype.ensureKeyMapInitialized_=function(){if(!this.keyMap_&&(this.keyMap_=new goog.structs.Map(),this.count_=0,this.encodedQuery_)){var self=this;goog.uri.utils.parseQueryData(this.encodedQuery_,function(name,value){self.add(goog.string.urlDecode(name),value);});}};goog.Uri.QueryData.createFromMap=function(map,opt_uri,opt_ignoreCase){var keys=goog.structs.getKeys(map);if("undefined"==typeof keys){throw Error("Keys are undefined");}for(var queryData=new goog.Uri.QueryData(null,null,opt_ignoreCase),values=goog.structs.getValues(map),i=0;i<keys.length;i++){var key=keys[i],value=values[i];goog.isArray(value)?queryData.setValues(key,value):queryData.add(key,value);}return queryData;};goog.Uri.QueryData.createFromKeysValues=function(keys,values,opt_uri,opt_ignoreCase){if(keys.length!=values.length){throw Error("Mismatched lengths for keys/values");}for(var queryData=new goog.Uri.QueryData(null,null,opt_ignoreCase),i=0;i<keys.length;i++){queryData.add(keys[i],values[i]);}return queryData;};goog.Uri.QueryData.prototype.getCount=function(){this.ensureKeyMapInitialized_();return this.count_;};goog.Uri.QueryData.prototype.add=function(key,value){this.ensureKeyMapInitialized_();this.invalidateCache_();key=this.getKeyName_(key);var values=this.keyMap_.get(key);values||this.keyMap_.set(key,values=[]);values.push(value);this.count_=goog.asserts.assertNumber(this.count_)+1;return this;};goog.Uri.QueryData.prototype.remove=function(key){this.ensureKeyMapInitialized_();key=this.getKeyName_(key);return this.keyMap_.containsKey(key)?(this.invalidateCache_(),this.count_=goog.asserts.assertNumber(this.count_)-this.keyMap_.get(key).length,this.keyMap_.remove(key)):!1;};goog.Uri.QueryData.prototype.clear=function(){this.invalidateCache_();this.keyMap_=null;this.count_=0;};goog.Uri.QueryData.prototype.isEmpty=function(){this.ensureKeyMapInitialized_();return 0==this.count_;};goog.Uri.QueryData.prototype.containsKey=function(key){this.ensureKeyMapInitialized_();key=this.getKeyName_(key);return this.keyMap_.containsKey(key);};goog.Uri.QueryData.prototype.containsValue=function(value){var vals=this.getValues();return goog.array.contains(vals,value);};goog.Uri.QueryData.prototype.forEach=function(f,opt_scope){this.ensureKeyMapInitialized_();this.keyMap_.forEach(function(values,key){goog.array.forEach(values,function(value){f.call(opt_scope,value,key,this);},this);},this);};goog.Uri.QueryData.prototype.forEach=function(f,opt_scope){this.ensureKeyMapInitialized_();this.keyMap_.forEach(function(values,key){goog.array.forEach(values,function(value){f.call(opt_scope,value,key,this);},this);},this);};goog.Uri.QueryData.prototype.getKeys=function(){this.ensureKeyMapInitialized_();for(var vals=this.keyMap_.getValues(),keys=this.keyMap_.getKeys(),rv=[],i=0;i<keys.length;i++){for(var val=vals[i],j=0;j<val.length;j++){rv.push(keys[i]);}}return rv;};goog.Uri.QueryData.prototype.getValues=function(opt_key){this.ensureKeyMapInitialized_();var rv=[];if(goog.isString(opt_key)){this.containsKey(opt_key)&&(rv=goog.array.concat(rv,this.keyMap_.get(this.getKeyName_(opt_key))));}else{for(var values=this.keyMap_.getValues(),i=0;i<values.length;i++){rv=goog.array.concat(rv,values[i]);}}return rv;};goog.Uri.QueryData.prototype.set=function(key,value){this.ensureKeyMapInitialized_();this.invalidateCache_();key=this.getKeyName_(key);this.containsKey(key)&&(this.count_=goog.asserts.assertNumber(this.count_)-this.keyMap_.get(key).length);this.keyMap_.set(key,[value]);this.count_=goog.asserts.assertNumber(this.count_)+1;return this;};goog.Uri.QueryData.prototype.get=function(key,opt_default){var values=key?this.getValues(key):[];return goog.Uri.preserveParameterTypesCompatibilityFlag?0<values.length?values[0]:opt_default:0<values.length?String(values[0]):opt_default;};goog.Uri.QueryData.prototype.setValues=function(key,values){this.remove(key);0<values.length&&(this.invalidateCache_(),this.keyMap_.set(this.getKeyName_(key),goog.array.clone(values)),this.count_=goog.asserts.assertNumber(this.count_)+values.length);};goog.Uri.QueryData.prototype.toString=function(){if(this.encodedQuery_){return this.encodedQuery_;}if(!this.keyMap_){return"";}for(var sb=[],keys=this.keyMap_.getKeys(),i=0;i<keys.length;i++){for(var key=keys[i],encodedKey=goog.string.urlEncode(key),val=this.getValues(key),j=0;j<val.length;j++){var param=encodedKey;""!==val[j]&&(param+="="+goog.string.urlEncode(val[j]));sb.push(param);}}return this.encodedQuery_=sb.join("&");};goog.Uri.QueryData.prototype.toDecodedString=function(){return goog.Uri.decodeOrEmpty_(this.toString());};goog.Uri.QueryData.prototype.invalidateCache_=function(){this.encodedQuery_=null;};goog.Uri.QueryData.prototype.filterKeys=function(keys){this.ensureKeyMapInitialized_();this.keyMap_.forEach(function(value,key){goog.array.contains(keys,key)||this.remove(key);},this);return this;};goog.Uri.QueryData.prototype.clone=function(){var rv=new goog.Uri.QueryData();rv.encodedQuery_=this.encodedQuery_;this.keyMap_&&(rv.keyMap_=this.keyMap_.clone(),rv.count_=this.count_);return rv;};goog.Uri.QueryData.prototype.getKeyName_=function(arg){var keyName=String(arg);this.ignoreCase_&&(keyName=keyName.toLowerCase());return keyName;};goog.Uri.QueryData.prototype.setIgnoreCase=function(ignoreCase){ignoreCase&&!this.ignoreCase_&&(this.ensureKeyMapInitialized_(),this.invalidateCache_(),this.keyMap_.forEach(function(value,key){var lowerCase=key.toLowerCase();key!=lowerCase&&(this.remove(key),this.setValues(lowerCase,value));},this));this.ignoreCase_=ignoreCase;};goog.Uri.QueryData.prototype.extend=function(var_args){for(var i=0;i<arguments.length;i++){goog.structs.forEach(arguments[i],function(value,key){this.add(key,value);},this);}};ee.data={};ee.data.authenticate=function(clientId,success,opt_error,opt_extraScopes,opt_onImmediateFailed){var scopes=[ee.data.AUTH_SCOPE_];opt_extraScopes&&(goog.array.extend(scopes,opt_extraScopes),goog.array.removeDuplicates(scopes));ee.data.authClientId_=clientId;ee.data.authScopes_=scopes;goog.isNull(clientId)?ee.data.authToken_=null:ee.data.ensureAuthLibLoaded_(function(){var onImmediateFailed=opt_onImmediateFailed||goog.partial(ee.data.authenticateViaPopup,success,opt_error);ee.data.refreshAuthToken(success,opt_error,onImmediateFailed);});};ee.data.authenticateViaPopup=function(opt_success,opt_error){goog.global.gapi.auth.authorize({client_id:ee.data.authClientId_,immediate:!1,scope:ee.data.authScopes_.join(" ")},goog.partial(ee.data.handleAuthResult_,opt_success,opt_error));};ee.data.setAuthToken=function(clientId,tokenType,accessToken,expiresIn,opt_extraScopes,opt_callback,opt_updateAuthLibrary){var scopes=[ee.data.AUTH_SCOPE_];opt_extraScopes&&(goog.array.extend(scopes,opt_extraScopes),goog.array.removeDuplicates(scopes));ee.data.authClientId_=clientId;ee.data.authScopes_=scopes;var tokenObject={token_type:tokenType,access_token:accessToken,state:scopes.join(" "),expires_in:expiresIn};ee.data.handleAuthResult_(void 0,void 0,tokenObject);!1===opt_updateAuthLibrary?opt_callback&&opt_callback():ee.data.ensureAuthLibLoaded_(function(){goog.global.gapi.auth.setToken(tokenObject);opt_callback&&opt_callback();});};ee.data.refreshAuthToken=function(opt_success,opt_error,opt_onImmediateFailed){if(ee.data.isAuthTokenRefreshingEnabled_()){var authArgs={client_id:String(ee.data.authClientId_),immediate:!0,scope:ee.data.authScopes_.join(" ")};ee.data.authTokenRefresher_(authArgs,function(result){"immediate_failed"==result.error&&opt_onImmediateFailed?opt_onImmediateFailed():ee.data.handleAuthResult_(opt_success,opt_error,result);});}};ee.data.setAuthTokenRefresher=function(refresher){ee.data.authTokenRefresher_=refresher;};ee.data.getAuthToken=function(){ee.data.authTokenExpiration_&&0<=goog.now()-ee.data.authTokenExpiration_&&ee.data.clearAuthToken();return ee.data.authToken_;};ee.data.clearAuthToken=function(){ee.data.authToken_=null;ee.data.authTokenExpiration_=null;};ee.data.getAuthClientId=function(){return ee.data.authClientId_;};ee.data.getAuthScopes=function(){return ee.data.authScopes_;};ee.data.initialize=function(opt_apiBaseUrl,opt_tileBaseUrl,opt_xsrfToken){goog.isDefAndNotNull(opt_apiBaseUrl)?ee.data.apiBaseUrl_=opt_apiBaseUrl:ee.data.initialized_||(ee.data.apiBaseUrl_=ee.data.DEFAULT_API_BASE_URL_);goog.isDefAndNotNull(opt_tileBaseUrl)?ee.data.tileBaseUrl_=opt_tileBaseUrl:ee.data.initialized_||(ee.data.tileBaseUrl_=ee.data.DEFAULT_TILE_BASE_URL_);goog.isDef(opt_xsrfToken)&&(ee.data.xsrfToken_=opt_xsrfToken);ee.data.initialized_=!0;};ee.data.reset=function(){ee.data.apiBaseUrl_=null;ee.data.tileBaseUrl_=null;ee.data.xsrfToken_=null;ee.data.initialized_=!1;};ee.data.setDeadline=function(milliseconds){ee.data.deadlineMs_=milliseconds;};ee.data.setParamAugmenter=function(augmenter){ee.data.paramAugmenter_=augmenter||goog.functions.identity;};goog.exportSymbol("ee.data.setParamAugmenter",ee.data.setParamAugmenter);ee.data.getApiBaseUrl=function(){return ee.data.apiBaseUrl_;};ee.data.getTileBaseUrl=function(){return ee.data.tileBaseUrl_;};ee.data.getXsrfToken=function(){return ee.data.xsrfToken_;};ee.data.getAlgorithms=function(opt_callback){return ee.data.send_("/algorithms",null,opt_callback,"GET");};ee.data.getMapId=function(params,opt_callback){params=goog.object.clone(params);return ee.data.send_("/mapid",ee.data.makeRequest_(params),opt_callback);};ee.data.getTileUrl=function(mapid,x,y,z){var width=Math.pow(2,z);x%=width;0>x&&(x+=width);return[ee.data.tileBaseUrl_,"map",mapid.mapid,z,x,y].join("/")+"?token="+mapid.token;};ee.data.getValue=function(params,opt_callback){params=goog.object.clone(params);return ee.data.send_("/value",ee.data.makeRequest_(params),opt_callback);};ee.data.getThumbId=function(params,opt_callback){params=goog.object.clone(params);goog.isArray(params.dimensions)&&(params.dimensions=params.dimensions.join("x"));var request=ee.data.makeRequest_(params).add("getid","1");return ee.data.send_("/thumb",request,opt_callback);};ee.data.makeThumbUrl=function(id){return ee.data.tileBaseUrl_+"/api/thumb?thumbid="+id.thumbid+"&token="+id.token;};ee.data.getDownloadId=function(params,opt_callback){params=goog.object.clone(params);return ee.data.send_("/download",ee.data.makeRequest_(params),opt_callback);};ee.data.makeDownloadUrl=function(id){return ee.data.tileBaseUrl_+"/api/download?docid="+id.docid+"&token="+id.token;};ee.data.getTableDownloadId=function(params,opt_callback){params=goog.object.clone(params);return ee.data.send_("/table",ee.data.makeRequest_(params),opt_callback);};ee.data.makeTableDownloadUrl=function(id){return ee.data.tileBaseUrl_+"/api/table?docid="+id.docid+"&token="+id.token;};ee.data.withProfiling=function(hook,body,opt_this){var saved=ee.data.profileHook_;try{return ee.data.profileHook_=hook,body.call(opt_this);}finally{ee.data.profileHook_=saved;}};goog.exportSymbol("ee.data.withProfiling",ee.data.withProfiling);ee.data.newTaskId=function(opt_count,opt_callback){var params={};goog.isNumber(opt_count)&&(params.count=opt_count);return ee.data.send_("/newtaskid",ee.data.makeRequest_(params),opt_callback);};goog.exportSymbol("ee.data.newTaskId",ee.data.newTaskId);ee.data.getTaskStatus=function(taskId,opt_callback){if(goog.isString(taskId)){taskId=[taskId];}else{if(!goog.isArray(taskId)){throw Error("Invalid taskId: expected a string or an array of strings.");}}var url="/taskstatus?q="+taskId.join();return ee.data.send_(url,null,opt_callback,"GET");};goog.exportSymbol("ee.data.getTaskStatus",ee.data.getTaskStatus);ee.data.getTaskList=function(opt_callback){return ee.data.send_("/tasklist",null,opt_callback,"GET");};goog.exportSymbol("ee.data.getTaskList",ee.data.getTaskList);ee.data.cancelTask=function(taskId,opt_callback){return ee.data.updateTask(taskId,ee.data.TaskUpdateActions.CANCEL,opt_callback);};goog.exportSymbol("ee.data.cancelTask",ee.data.cancelTask);ee.data.updateTask=function(taskId,action,opt_callback){if(goog.isString(taskId)){taskId=[taskId];}else{if(!goog.isArray(taskId)){throw Error("Invalid taskId: expected a string or an array of strings.");}}if(!goog.object.containsValue(ee.data.TaskUpdateActions,action)){throw Error("Invalid action: "+action);}return ee.data.send_("/updatetask",ee.data.makeRequest_({id:taskId,action:action}),opt_callback,"POST");};goog.exportSymbol("ee.data.updateTask",ee.data.updateTask);ee.data.startProcessing=function(taskId,params,opt_callback){params=goog.object.clone(params);params.id=taskId;return ee.data.send_("/processingrequest",ee.data.makeRequest_(params),opt_callback);};goog.exportSymbol("ee.data.startProcessing",ee.data.startProcessing);ee.data.startIngestion=function(taskId,request,opt_callback){var params={id:taskId,request:goog.json.serialize(request)};return ee.data.send_("/ingestionrequest",ee.data.makeRequest_(params),opt_callback);};goog.exportSymbol("ee.data.startIngestion",ee.data.startIngestion);ee.data.startTableIngestion=function(taskId,request,opt_callback){var params={id:taskId,tableRequest:goog.json.serialize(request)};return ee.data.send_("/ingestionrequest",ee.data.makeRequest_(params),opt_callback);};goog.exportSymbol("ee.data.startTableIngestion",ee.data.startTableIngestion);ee.data.getInfo=function(id,opt_callback){return ee.data.send_("/info",new goog.Uri.QueryData().add("id",id),opt_callback);};ee.data.getList=function(params,opt_callback){var request=ee.data.makeRequest_(params);return ee.data.send_("/list",request,opt_callback);};ee.data.getAssetRoots=function(opt_callback){return ee.data.send_("/buckets",null,opt_callback,"GET");};goog.exportSymbol("ee.data.getAssetRoots",ee.data.getAssetRoots);ee.data.createAssetHome=function(requestedId,opt_callback){var request=ee.data.makeRequest_({id:requestedId});ee.data.send_("/createbucket",request,opt_callback);};goog.exportSymbol("ee.data.createAssetHome",ee.data.createAssetHome);ee.data.createAsset=function(value,opt_path,opt_force,opt_callback){goog.isString(value)||(value=goog.json.serialize(value));var args={value:value};void 0!==opt_path&&(args.id=opt_path);args.force=opt_force||!1;return ee.data.send_("/create",ee.data.makeRequest_(args),opt_callback);};goog.exportSymbol("ee.data.createAsset",ee.data.createAsset);ee.data.createFolder=function(path,opt_force,opt_callback){return ee.data.send_("/createfolder",ee.data.makeRequest_({id:path,force:opt_force||!1}),opt_callback);};goog.exportSymbol("ee.data.createFolder",ee.data.createFolder);ee.data.search=function(query,opt_callback){return ee.data.send_("/search",ee.data.makeRequest_({q:query}),opt_callback);};ee.data.renameAsset=function(sourceId,destinationId,opt_callback){ee.data.send_("/rename",ee.data.makeRequest_({sourceId:sourceId,destinationId:destinationId}),opt_callback);};goog.exportSymbol("ee.data.renameAsset",ee.data.renameAsset);ee.data.copyAsset=function(sourceId,destinationId,opt_callback){ee.data.send_("/copy",ee.data.makeRequest_({sourceId:sourceId,destinationId:destinationId}),opt_callback);};goog.exportSymbol("ee.data.copyAsset",ee.data.copyAsset);ee.data.deleteAsset=function(assetId,opt_callback){ee.data.send_("/delete",ee.data.makeRequest_({id:assetId}),opt_callback);};goog.exportSymbol("ee.data.deleteAsset",ee.data.deleteAsset);ee.data.getAssetAcl=function(assetId,opt_callback){return ee.data.send_("/getacl",ee.data.makeRequest_({id:assetId}),opt_callback,"GET");};goog.exportSymbol("ee.data.getAssetAcl",ee.data.getAssetAcl);ee.data.setAssetAcl=function(assetId,aclUpdate,opt_callback){var request={id:assetId,value:goog.json.serialize(aclUpdate)};ee.data.send_("/setacl",ee.data.makeRequest_(request),opt_callback);};goog.exportSymbol("ee.data.setAssetAcl",ee.data.setAssetAcl);ee.data.setAssetProperties=function(assetId,properties,opt_callback){var request={id:assetId,properties:goog.json.serialize(properties)};ee.data.send_("/setproperties",ee.data.makeRequest_(request),opt_callback);};goog.exportSymbol("ee.data.setAssetProperties",ee.data.setAssetProperties);ee.data.getAssetRootQuota=function(rootId,opt_callback){return ee.data.send_("/quota",ee.data.makeRequest_({id:rootId}),opt_callback,"GET");};goog.exportSymbol("ee.data.getAssetRootQuota",ee.data.getAssetRootQuota);ee.data.AssetType={ALGORITHM:"Algorithm",FOLDER:"Folder",IMAGE:"Image",IMAGE_COLLECTION:"ImageCollection",TABLE:"Table",UNKNOWN:"Unknown"};ee.data.ExportType={IMAGE:"EXPORT_IMAGE",MAP:"EXPORT_TILES",TABLE:"EXPORT_FEATURES",VIDEO:"EXPORT_VIDEO"};ee.data.SystemTimeProperty={START:"system:time_start",END:"system:time_end"};ee.data.SYSTEM_ASSET_SIZE_PROPERTY="system:asset_size";ee.data.AssetDetailsProperty={TITLE:"system:title",DESCRIPTION:"system:description",TAGS:"system:tags"};ee.data.ALLOWED_DESCRIPTION_HTML_TABLE_ELEMENTS_="col colgroup caption table tbody td tfoot th thead tr".split(" ");ee.data.ALLOWED_DESCRIPTION_HTML_ELEMENTS=ee.data.ALLOWED_DESCRIPTION_HTML_TABLE_ELEMENTS_.concat("a code em i li ol p strong sub sup ul".split(" "));ee.data.MapZoomRange={MIN:0,MAX:24};ee.data.TaskUpdateActions={CANCEL:"CANCEL",UPDATE:"UPDATE"};ee.data.PyramidingPolicy={MEAN:"MEAN",MODE:"MODE",MIN:"MIN",MAX:"MAX",SAMPLE:"SAMPLE"};ee.data.send_=function(path,params,opt_callback,opt_method){ee.data.initialize();var profileHookAtCallTime=ee.data.profileHook_,headers={"Content-Type":"application/x-www-form-urlencoded"},authToken=ee.data.getAuthToken();if(goog.isDefAndNotNull(authToken)){headers.Authorization=authToken;}else{if(opt_callback&&ee.data.isAuthTokenRefreshingEnabled_()){return ee.data.refreshAuthToken(function(){ee.data.withProfiling(profileHookAtCallTime,function(){ee.data.send_(path,params,opt_callback,opt_method);});}),null;}}var method=opt_method||"POST";params=params?params.clone():new goog.Uri.QueryData();profileHookAtCallTime&&params.add("profiling","1");params=ee.data.paramAugmenter_(params,path);goog.isDefAndNotNull(ee.data.xsrfToken_)&&(headers["X-XSRF-Token"]=ee.data.xsrfToken_);var requestData=params?params.toString():"";"GET"!=method||goog.string.isEmptyOrWhitespace(requestData)||(path+=goog.string.contains(path,"?")?"&":"?",path+=requestData,requestData=null);var url=ee.data.apiBaseUrl_+path;if(opt_callback){var request=ee.data.buildAsyncRequest_(url,opt_callback,method,requestData,headers);ee.data.requestQueue_.push(request);ee.data.RequestThrottle_.fire();return null;}for(var setRequestHeader=function setRequestHeader(value,key){this.setRequestHeader&&this.setRequestHeader(key,value);},xmlHttp,retries=0;;){xmlHttp=goog.net.XmlHttp();xmlHttp.open(method,url,!1);goog.object.forEach(headers,setRequestHeader,xmlHttp);xmlHttp.send(requestData);if(429!=xmlHttp.status||retries>ee.data.MAX_SYNC_RETRIES_){break;}retries++;}return ee.data.handleResponse_(xmlHttp.status,function getResponseHeaderSafe(header){try{return xmlHttp.getResponseHeader(header);}catch(e){return null;}},xmlHttp.responseText,profileHookAtCallTime);};ee.data.buildAsyncRequest_=function(url,callback,method,content,headers){var retries=0,request={url:url,method:method,content:content,headers:headers},profileHookAtCallTime=ee.data.profileHook_;request.callback=function(e){var xhrIo=e.target;return 429==xhrIo.getStatus()&&retries<ee.data.MAX_ASYNC_RETRIES_?(retries++,setTimeout(function(){ee.data.requestQueue_.push(request);ee.data.RequestThrottle_.fire();},ee.data.calculateRetryWait_(retries)),null):ee.data.handleResponse_(xhrIo.getStatus(),goog.bind(xhrIo.getResponseHeader,xhrIo),xhrIo.getResponseText(),profileHookAtCallTime,callback);};return request;};ee.data.handleResponse_=function(status,getResponseHeader,responseText,profileHook,opt_callback){var profileId=getResponseHeader(ee.data.PROFILE_HEADER);profileId&&profileHook&&profileHook(profileId);var contentType=getResponseHeader("Content-Type"),contentType=contentType?contentType.replace(/;.*/,""):"application/json";if("application/json"==contentType||"text/json"==contentType){try{var response=JSON.parse(responseText);var data=response.data;}catch(e){var errorMessage="Invalid JSON: "+responseText;}}else{errorMessage="Response was unexpectedly not JSON, but "+contentType;}if(goog.isObject(response)){"error"in response&&"message"in response.error?errorMessage=response.error.message:"data"in response||(errorMessage="Malformed response: "+responseText);}else{if(0===status){errorMessage="Failed to contact Earth Engine servers. Please check your connection, firewall, or browser extension settings.";}else{if(200>status||300<=status){errorMessage="Server returned HTTP code: "+status;}}}if(opt_callback){return opt_callback(data,errorMessage),null;}if(!errorMessage){return data;}throw Error(errorMessage);};ee.data.ensureAuthLibLoaded_=function(callback){var done=function done(){goog.global.gapi.config.update("client/cors",!0);ee.data.authTokenRefresher_||ee.data.setAuthTokenRefresher(goog.global.gapi.auth.authorize);callback();};if(goog.isObject(goog.global.gapi)&&goog.isObject(goog.global.gapi.auth)&&goog.isFunction(goog.global.gapi.auth.authorize)){done();}else{for(var callbackName=goog.now().toString(36);callbackName in goog.global;){callbackName+="_";}goog.global[callbackName]=function(){delete goog.global[callbackName];done();};goog.net.jsloader.load(ee.data.AUTH_LIBRARY_URL_+"?onload="+callbackName);}};ee.data.handleAuthResult_=function(success,error,result){if(result.access_token){var token=result.token_type+" "+result.access_token;if(isFinite(result.expires_in)){var expiresInMs=900*result.expires_in;setTimeout(ee.data.refreshAuthToken,0.9*expiresInMs);ee.data.authTokenExpiration_=goog.now()+expiresInMs;}ee.data.authToken_=token;success&&success();}else{error&&error(result.error||"Unknown error.");}};ee.data.makeRequest_=function(params){var request=new goog.Uri.QueryData(),item;for(item in params){request.set(item,params[item]);}return request;};ee.data.setupMockSend=function(opt_calls){function getResponse(url,method,data){url=url.replace(apiBaseUrl,"");if(url in calls){var response=calls[url];}else{throw Error(url+" mock response not specified");}goog.isFunction(response)&&(response=response(url,method,data));goog.isString(response)&&(response={text:response,status:200,contentType:"application/json; charset=utf-8"});if(!goog.isString(response.text)){throw Error(url+" mock response missing/invalid text");}if(!goog.isNumber(response.status)&&!goog.isFunction(response.status)){throw Error(url+" mock response missing/invalid status");}return response;}var calls=opt_calls?goog.object.clone(opt_calls):{},apiBaseUrl;goog.net.XhrIo.send=function(url,callback,method,data){apiBaseUrl=apiBaseUrl||ee.data.apiBaseUrl_;var responseData=getResponse(url,method,data),e=new function(){}();e.target={};e.target.getResponseText=function(){return responseData.text;};e.target.getStatus=goog.isFunction(responseData.status)?responseData.status:function(){return responseData.status;};e.target.getResponseHeader=function(header){return"Content-Type"===header?responseData.contentType:null;};setTimeout(goog.bind(callback,e,e),0);return new goog.net.XhrIo();};var fakeXmlHttp=function fakeXmlHttp(){};fakeXmlHttp.prototype.open=function(method,urlIn){apiBaseUrl=apiBaseUrl||ee.data.apiBaseUrl_;this.url=urlIn;this.method=method;};fakeXmlHttp.prototype.setRequestHeader=function(){};fakeXmlHttp.prototype.getResponseHeader=function(header){return"Content-Type"===header?this.contentType_||null:null;};fakeXmlHttp.prototype.send=function(data){var responseData=getResponse(this.url,this.method,data);this.responseText=responseData.text;this.status=goog.isFunction(responseData.status)?responseData.status():responseData.status;this.contentType_=responseData.contentType;};goog.net.XmlHttp=function(){return new fakeXmlHttp();};};ee.data.isAuthTokenRefreshingEnabled_=function(){return!(!ee.data.authTokenRefresher_||!ee.data.authClientId_);};ee.data.calculateRetryWait_=function(retryCount){return Math.min(ee.data.MAX_RETRY_WAIT_,Math.pow(2,retryCount)*ee.data.BASE_RETRY_WAIT_);};ee.data.sleep_=function(timeInMs){for(var end=new Date().getTime()+timeInMs;new Date().getTime()<end;){}};ee.data.requestQueue_=[];ee.data.REQUEST_THROTTLE_INTERVAL_MS_=350;ee.data.RequestThrottle_=new goog.async.Throttle(function(){var request=ee.data.requestQueue_.shift();request&&goog.net.XhrIo.send(request.url,request.callback,request.method,request.content,request.headers,ee.data.deadlineMs_);goog.array.isEmpty(ee.data.requestQueue_)||ee.data.RequestThrottle_.fire();},ee.data.REQUEST_THROTTLE_INTERVAL_MS_);ee.data.apiBaseUrl_=null;ee.data.tileBaseUrl_=null;ee.data.xsrfToken_=null;ee.data.paramAugmenter_=goog.functions.identity;ee.data.authToken_=null;ee.data.authTokenExpiration_=null;ee.data.authClientId_=null;ee.data.authScopes_=[];ee.data.authTokenRefresher_=null;ee.data.AUTH_SCOPE_="https://www.googleapis.com/auth/earthengine";ee.data.AUTH_LIBRARY_URL_="https://apis.google.com/js/client.js";ee.data.initialized_=!1;ee.data.deadlineMs_=0;ee.data.profileHook_=null;ee.data.BASE_RETRY_WAIT_=1000;ee.data.MAX_RETRY_WAIT_=120000;ee.data.MAX_ASYNC_RETRIES_=10;ee.data.MAX_SYNC_RETRIES_=5;ee.data.PROFILE_HEADER="X-Earth-Engine-Computation-Profile";ee.data.DEFAULT_API_BASE_URL_="https://earthengine.googleapis.com/api";ee.data.DEFAULT_TILE_BASE_URL_="https://earthengine.googleapis.com";goog.structs.Collection=function(){};goog.structs.Node=function(key,value){this.key_=key;this.value_=value;};goog.structs.Node.prototype.getKey=function(){return this.key_;};goog.structs.Node.prototype.getValue=function(){return this.value_;};goog.structs.Node.prototype.clone=function(){return new goog.structs.Node(this.key_,this.value_);};goog.structs.Heap=function(opt_heap){this.nodes_=[];opt_heap&&this.insertAll(opt_heap);};goog.structs.Heap.prototype.insert=function(key,value){var node=new goog.structs.Node(key,value),nodes=this.nodes_;nodes.push(node);this.moveUp_(nodes.length-1);};goog.structs.Heap.prototype.insertAll=function(heap){if(heap instanceof goog.structs.Heap){var keys=heap.getKeys();var values=heap.getValues();if(0>=this.getCount()){for(var nodes=this.nodes_,i=0;i<keys.length;i++){nodes.push(new goog.structs.Node(keys[i],values[i]));}return;}}else{keys=goog.object.getKeys(heap),values=goog.object.getValues(heap);}for(i=0;i<keys.length;i++){this.insert(keys[i],values[i]);}};goog.structs.Heap.prototype.remove=function(){var nodes=this.nodes_,count=nodes.length,rootNode=nodes[0];if(!(0>=count)){return 1==count?goog.array.clear(nodes):(nodes[0]=nodes.pop(),this.moveDown_(0)),rootNode.getValue();}};goog.structs.Heap.prototype.peek=function(){var nodes=this.nodes_;if(0!=nodes.length){return nodes[0].getValue();}};goog.structs.Heap.prototype.peekKey=function(){return this.nodes_[0]&&this.nodes_[0].getKey();};goog.structs.Heap.prototype.moveDown_=function(index){for(var nodes=this.nodes_,count=nodes.length,node=nodes[index];index<count>>1;){var leftChildIndex=this.getLeftChildIndex_(index),rightChildIndex=this.getRightChildIndex_(index),smallerChildIndex=rightChildIndex<count&&nodes[rightChildIndex].getKey()<nodes[leftChildIndex].getKey()?rightChildIndex:leftChildIndex;if(nodes[smallerChildIndex].getKey()>node.getKey()){break;}nodes[index]=nodes[smallerChildIndex];index=smallerChildIndex;}nodes[index]=node;};goog.structs.Heap.prototype.moveUp_=function(index){for(var nodes=this.nodes_,node=nodes[index];0<index;){var parentIndex=this.getParentIndex_(index);if(nodes[parentIndex].getKey()>node.getKey()){nodes[index]=nodes[parentIndex],index=parentIndex;}else{break;}}nodes[index]=node;};goog.structs.Heap.prototype.getLeftChildIndex_=function(index){return 2*index+1;};goog.structs.Heap.prototype.getRightChildIndex_=function(index){return 2*index+2;};goog.structs.Heap.prototype.getParentIndex_=function(index){return index-1>>1;};goog.structs.Heap.prototype.getValues=function(){for(var nodes=this.nodes_,rv=[],l=nodes.length,i=0;i<l;i++){rv.push(nodes[i].getValue());}return rv;};goog.structs.Heap.prototype.getKeys=function(){for(var nodes=this.nodes_,rv=[],l=nodes.length,i=0;i<l;i++){rv.push(nodes[i].getKey());}return rv;};goog.structs.Heap.prototype.containsValue=function(val){return goog.array.some(this.nodes_,function(node){return node.getValue()==val;});};goog.structs.Heap.prototype.containsKey=function(key){return goog.array.some(this.nodes_,function(node){return node.getKey()==key;});};goog.structs.Heap.prototype.clone=function(){return new goog.structs.Heap(this);};goog.structs.Heap.prototype.getCount=function(){return this.nodes_.length;};goog.structs.Heap.prototype.isEmpty=function(){return goog.array.isEmpty(this.nodes_);};goog.structs.Heap.prototype.clear=function(){goog.array.clear(this.nodes_);};goog.structs.Queue=function(){this.front_=[];this.back_=[];};goog.structs.Queue.prototype.maybeFlip_=function(){goog.array.isEmpty(this.front_)&&(this.front_=this.back_,this.front_.reverse(),this.back_=[]);};goog.structs.Queue.prototype.enqueue=function(element){this.back_.push(element);};goog.structs.Queue.prototype.dequeue=function(){this.maybeFlip_();return this.front_.pop();};goog.structs.Queue.prototype.peek=function(){this.maybeFlip_();return goog.array.peek(this.front_);};goog.structs.Queue.prototype.getCount=function(){return this.front_.length+this.back_.length;};goog.structs.Queue.prototype.isEmpty=function(){return goog.array.isEmpty(this.front_)&&goog.array.isEmpty(this.back_);};goog.structs.Queue.prototype.clear=function(){this.front_=[];this.back_=[];};goog.structs.Queue.prototype.contains=function(obj){return goog.array.contains(this.front_,obj)||goog.array.contains(this.back_,obj);};goog.structs.Queue.prototype.remove=function(obj){return goog.array.removeLast(this.front_,obj)||goog.array.remove(this.back_,obj);};goog.structs.Queue.prototype.getValues=function(){for(var res=[],i=this.front_.length-1;0<=i;--i){res.push(this.front_[i]);}for(var len=this.back_.length,i=0;i<len;++i){res.push(this.back_[i]);}return res;};goog.structs.Set=function(opt_values){this.map_=new goog.structs.Map();opt_values&&this.addAll(opt_values);};goog.structs.Set.getKey_=function(val){var type=typeof val==="undefined"?"undefined":_typeof(val);return"object"==type&&val||"function"==type?"o"+goog.getUid(val):type.substr(0,1)+val;};goog.structs.Set.prototype.getCount=function(){return this.map_.getCount();};goog.structs.Set.prototype.add=function(element){this.map_.set(goog.structs.Set.getKey_(element),element);};goog.structs.Set.prototype.addAll=function(col){for(var values=goog.structs.getValues(col),l=values.length,i=0;i<l;i++){this.add(values[i]);}};goog.structs.Set.prototype.removeAll=function(col){for(var values=goog.structs.getValues(col),l=values.length,i=0;i<l;i++){this.remove(values[i]);}};goog.structs.Set.prototype.remove=function(element){return this.map_.remove(goog.structs.Set.getKey_(element));};goog.structs.Set.prototype.clear=function(){this.map_.clear();};goog.structs.Set.prototype.isEmpty=function(){return this.map_.isEmpty();};goog.structs.Set.prototype.contains=function(element){return this.map_.containsKey(goog.structs.Set.getKey_(element));};goog.structs.Set.prototype.containsAll=function(col){return goog.structs.every(col,this.contains,this);};goog.structs.Set.prototype.intersection=function(col){for(var result=new goog.structs.Set(),values=goog.structs.getValues(col),i=0;i<values.length;i++){var value=values[i];this.contains(value)&&result.add(value);}return result;};goog.structs.Set.prototype.difference=function(col){var result=this.clone();result.removeAll(col);return result;};goog.structs.Set.prototype.getValues=function(){return this.map_.getValues();};goog.structs.Set.prototype.clone=function(){return new goog.structs.Set(this);};goog.structs.Set.prototype.equals=function(col){return this.getCount()==goog.structs.getCount(col)&&this.isSubsetOf(col);};goog.structs.Set.prototype.isSubsetOf=function(col){var colCount=goog.structs.getCount(col);if(this.getCount()>colCount){return!1;}!(col instanceof goog.structs.Set)&&5<colCount&&(col=new goog.structs.Set(col));return goog.structs.every(this,function(value){return goog.structs.contains(col,value);});};goog.structs.Set.prototype.__iterator__=function(opt_keys){return this.map_.__iterator__(!1);};goog.structs.Set=function(opt_values){this.map_=new goog.structs.Map();opt_values&&this.addAll(opt_values);};goog.structs.Set.getKey_=function(val){var type=typeof val==="undefined"?"undefined":_typeof(val);return"object"==type&&val||"function"==type?"o"+goog.getUid(val):type.substr(0,1)+val;};goog.structs.Set.prototype.getCount=function(){return this.map_.getCount();};goog.structs.Set.prototype.add=function(element){this.map_.set(goog.structs.Set.getKey_(element),element);};goog.structs.Set.prototype.addAll=function(col){for(var values=goog.structs.getValues(col),l=values.length,i=0;i<l;i++){this.add(values[i]);}};goog.structs.Set.prototype.removeAll=function(col){for(var values=goog.structs.getValues(col),l=values.length,i=0;i<l;i++){this.remove(values[i]);}};goog.structs.Set.prototype.remove=function(element){return this.map_.remove(goog.structs.Set.getKey_(element));};goog.structs.Set.prototype.clear=function(){this.map_.clear();};goog.structs.Set.prototype.isEmpty=function(){return this.map_.isEmpty();};goog.structs.Set.prototype.contains=function(element){return this.map_.containsKey(goog.structs.Set.getKey_(element));};goog.structs.Set.prototype.containsAll=function(col){return goog.structs.every(col,this.contains,this);};goog.structs.Set.prototype.intersection=function(col){for(var result=new goog.structs.Set(),values=goog.structs.getValues(col),i=0;i<values.length;i++){var value=values[i];this.contains(value)&&result.add(value);}return result;};goog.structs.Set.prototype.difference=function(col){var result=this.clone();result.removeAll(col);return result;};goog.structs.Set.prototype.getValues=function(){return this.map_.getValues();};goog.structs.Set.prototype.clone=function(){return new goog.structs.Set(this);};goog.structs.Set.prototype.equals=function(col){return this.getCount()==goog.structs.getCount(col)&&this.isSubsetOf(col);};goog.structs.Set.prototype.isSubsetOf=function(col){var colCount=goog.structs.getCount(col);if(this.getCount()>colCount){return!1;}!(col instanceof goog.structs.Set)&&5<colCount&&(col=new goog.structs.Set(col));return goog.structs.every(this,function(value){return goog.structs.contains(col,value);});};goog.structs.Set.prototype.__iterator__=function(opt_keys){return this.map_.__iterator__(!1);};goog.structs.Pool=function(opt_minCount,opt_maxCount){goog.Disposable.call(this);this.minCount_=opt_minCount||0;this.maxCount_=opt_maxCount||10;if(this.minCount_>this.maxCount_){throw Error(goog.structs.Pool.ERROR_MIN_MAX_);}this.freeQueue_=new goog.structs.Queue();this.inUseSet_=new goog.structs.Set();this.delay=0;this.lastAccess=null;this.adjustForMinMax();};goog.inherits(goog.structs.Pool,goog.Disposable);goog.structs.Pool.ERROR_MIN_MAX_="[goog.structs.Pool] Min can not be greater than max";goog.structs.Pool.ERROR_DISPOSE_UNRELEASED_OBJS_="[goog.structs.Pool] Objects not released";goog.structs.Pool.prototype.setMinimumCount=function(min){if(min>this.maxCount_){throw Error(goog.structs.Pool.ERROR_MIN_MAX_);}this.minCount_=min;this.adjustForMinMax();};goog.structs.Pool.prototype.setMaximumCount=function(max){if(max<this.minCount_){throw Error(goog.structs.Pool.ERROR_MIN_MAX_);}this.maxCount_=max;this.adjustForMinMax();};goog.structs.Pool.prototype.setDelay=function(delay){this.delay=delay;};goog.structs.Pool.prototype.getObject=function(){var time=goog.now();if(!(goog.isDefAndNotNull(this.lastAccess)&&time-this.lastAccess<this.delay)){var obj=this.removeFreeObject_();obj&&(this.lastAccess=time,this.inUseSet_.add(obj));return obj;}};goog.structs.Pool.prototype.releaseObject=function(obj){return this.inUseSet_.remove(obj)?(this.addFreeObject(obj),!0):!1;};goog.structs.Pool.prototype.removeFreeObject_=function(){for(var obj;0<this.getFreeCount()&&(obj=this.freeQueue_.dequeue(),!this.objectCanBeReused(obj));){this.adjustForMinMax();}!obj&&this.getCount()<this.maxCount_&&(obj=this.createObject());return obj;};goog.structs.Pool.prototype.addFreeObject=function(obj){this.inUseSet_.remove(obj);this.objectCanBeReused(obj)&&this.getCount()<this.maxCount_?this.freeQueue_.enqueue(obj):this.disposeObject(obj);};goog.structs.Pool.prototype.adjustForMinMax=function(){for(var freeQueue=this.freeQueue_;this.getCount()<this.minCount_;){freeQueue.enqueue(this.createObject());}for(;this.getCount()>this.maxCount_&&0<this.getFreeCount();){this.disposeObject(freeQueue.dequeue());}};goog.structs.Pool.prototype.createObject=function(){return{};};goog.structs.Pool.prototype.disposeObject=function(obj){if("function"==typeof obj.dispose){obj.dispose();}else{for(var i in obj){obj[i]=null;}}};goog.structs.Pool.prototype.objectCanBeReused=function(obj){return"function"==typeof obj.canBeReused?obj.canBeReused():!0;};goog.structs.Pool.prototype.contains=function(obj){return this.freeQueue_.contains(obj)||this.inUseSet_.contains(obj);};goog.structs.Pool.prototype.getCount=function(){return this.freeQueue_.getCount()+this.inUseSet_.getCount();};goog.structs.Pool.prototype.getInUseCount=function(){return this.inUseSet_.getCount();};goog.structs.Pool.prototype.getFreeCount=function(){return this.freeQueue_.getCount();};goog.structs.Pool.prototype.isEmpty=function(){return this.freeQueue_.isEmpty()&&this.inUseSet_.isEmpty();};goog.structs.Pool.prototype.disposeInternal=function(){goog.structs.Pool.superClass_.disposeInternal.call(this);if(0<this.getInUseCount()){throw Error(goog.structs.Pool.ERROR_DISPOSE_UNRELEASED_OBJS_);}delete this.inUseSet_;for(var freeQueue=this.freeQueue_;!freeQueue.isEmpty();){this.disposeObject(freeQueue.dequeue());}delete this.freeQueue_;};goog.structs.PriorityQueue=function(){goog.structs.Heap.call(this);};goog.inherits(goog.structs.PriorityQueue,goog.structs.Heap);goog.structs.PriorityQueue.prototype.enqueue=function(priority,value){this.insert(priority,value);};goog.structs.PriorityQueue.prototype.dequeue=function(){return this.remove();};goog.structs.PriorityPool=function(opt_minCount,opt_maxCount){this.delayTimeout_=void 0;this.requestQueue_=new goog.structs.PriorityQueue();goog.structs.Pool.call(this,opt_minCount,opt_maxCount);};goog.inherits(goog.structs.PriorityPool,goog.structs.Pool);goog.structs.PriorityPool.DEFAULT_PRIORITY_=100;goog.structs.PriorityPool.prototype.setDelay=function(delay){goog.structs.PriorityPool.superClass_.setDelay.call(this,delay);goog.isDefAndNotNull(this.lastAccess)&&(goog.global.clearTimeout(this.delayTimeout_),this.delayTimeout_=goog.global.setTimeout(goog.bind(this.handleQueueRequests_,this),this.delay+this.lastAccess-goog.now()),this.handleQueueRequests_());};goog.structs.PriorityPool.prototype.getObject=function(opt_callback,opt_priority){if(!opt_callback){var result=goog.structs.PriorityPool.superClass_.getObject.call(this);result&&this.delay&&(this.delayTimeout_=goog.global.setTimeout(goog.bind(this.handleQueueRequests_,this),this.delay));return result;}this.requestQueue_.enqueue(goog.isDef(opt_priority)?opt_priority:goog.structs.PriorityPool.DEFAULT_PRIORITY_,opt_callback);this.handleQueueRequests_();};goog.structs.PriorityPool.prototype.handleQueueRequests_=function(){for(var requestQueue=this.requestQueue_;0<requestQueue.getCount();){var obj=this.getObject();if(obj){requestQueue.dequeue().apply(this,[obj]);}else{break;}}};goog.structs.PriorityPool.prototype.addFreeObject=function(obj){goog.structs.PriorityPool.superClass_.addFreeObject.call(this,obj);this.handleQueueRequests_();};goog.structs.PriorityPool.prototype.adjustForMinMax=function(){goog.structs.PriorityPool.superClass_.adjustForMinMax.call(this);this.handleQueueRequests_();};goog.structs.PriorityPool.prototype.disposeInternal=function(){goog.structs.PriorityPool.superClass_.disposeInternal.call(this);goog.global.clearTimeout(this.delayTimeout_);this.requestQueue_.clear();this.requestQueue_=null;};ee.layers.EarthEngineTileSource=function(url,mapId,token,opt_profiler){ee.layers.AbstractTileSource.call(this);this.url_=url;this.mapId_=mapId;this.token_=token;this.profiler_=opt_profiler||null;};goog.inherits(ee.layers.EarthEngineTileSource,ee.layers.AbstractTileSource);ee.layers.EarthEngineTileSource.prototype.loadTile=function(tile,opt_priority){var ProfilerHeader=ee.data.PROFILE_HEADER.toLowerCase(),key=goog.events.listen(tile,ee.layers.AbstractTile.EventType.STATUS_CHANGED,function(){switch(tile.getStatus()){case ee.layers.AbstractTile.Status.LOADED:var profileId=tile.sourceResponseHeaders[ProfilerHeader];this.profiler_&&profileId&&this.profiler_.addTile(tile.div.id,profileId);break;case ee.layers.AbstractTile.Status.FAILED:case ee.layers.AbstractTile.Status.ABORTED:this.profiler_&&""!==tile.div.id&&this.profiler_.removeTile(tile.div.id),goog.events.unlistenByKey(key);}},void 0,this);tile.sourceUrl=this.getTileUrl_(tile.coord,tile.zoom);var handleAvailableToken=goog.bind(this.handleAvailableToken_,this,tile);ee.layers.EarthEngineTileSource.getGlobalTokenPool_().getObject(handleAvailableToken,opt_priority);};ee.layers.EarthEngineTileSource.prototype.getUniqueId=function(){return[this.mapId_,this.token_].join("-");};ee.layers.EarthEngineTileSource.prototype.handleAvailableToken_=function(tile,token){var tokenPool=ee.layers.EarthEngineTileSource.getGlobalTokenPool_();if(tile.isDisposed()||tile.getStatus()==ee.layers.AbstractTile.Status.ABORTED){tokenPool.releaseObject(token);}else{var key=goog.events.listen(tile,ee.layers.AbstractTile.EventType.STATUS_CHANGED,function(){tile.isDone()&&(goog.events.unlistenByKey(key),tokenPool.releaseObject(token));});tile.startLoad();}};ee.layers.EarthEngineTileSource.prototype.getTileUrl_=function(coord,zoom){var url=[this.url_,this.mapId_,zoom,coord.x,coord.y].join("/"),url=url+("?token="+this.token_);this.profiler_&&this.profiler_.isEnabled()&&(url+="&profiling=1");return url;};ee.layers.EarthEngineTileSource.getGlobalTokenPool_=function(){ee.layers.EarthEngineTileSource.TOKEN_POOL_||(ee.layers.EarthEngineTileSource.TOKEN_POOL_=new goog.structs.PriorityPool(0,ee.layers.EarthEngineTileSource.TOKEN_COUNT_));return ee.layers.EarthEngineTileSource.TOKEN_POOL_;};ee.layers.EarthEngineTileSource.TOKEN_POOL_=null;ee.layers.EarthEngineTileSource.TOKEN_COUNT_=4;goog.net.ImageLoader=function(opt_parent){goog.events.EventTarget.call(this);this.imageIdToRequestMap_={};this.imageIdToImageMap_={};this.handler_=new goog.events.EventHandler(this);this.parent_=opt_parent;};goog.inherits(goog.net.ImageLoader,goog.events.EventTarget);goog.net.ImageLoader.CorsRequestType={ANONYMOUS:"anonymous",USE_CREDENTIALS:"use-credentials"};goog.net.ImageLoader.IMAGE_LOAD_EVENTS_=[goog.userAgent.IE&&!goog.userAgent.isVersionOrHigher("11")?goog.net.EventType.READY_STATE_CHANGE:goog.events.EventType.LOAD,goog.net.EventType.ABORT,goog.net.EventType.ERROR];goog.net.ImageLoader.prototype.addImage=function(id,image,opt_corsRequestType){var src=goog.isString(image)?image:image.src;src&&(this.imageIdToRequestMap_[id]={src:src,corsRequestType:goog.isDef(opt_corsRequestType)?opt_corsRequestType:null});};goog.net.ImageLoader.prototype.removeImage=function(id){delete this.imageIdToRequestMap_[id];var image=this.imageIdToImageMap_[id];image&&(delete this.imageIdToImageMap_[id],this.handler_.unlisten(image,goog.net.ImageLoader.IMAGE_LOAD_EVENTS_,this.onNetworkEvent_),goog.object.isEmpty(this.imageIdToImageMap_)&&goog.object.isEmpty(this.imageIdToRequestMap_)&&this.dispatchEvent(goog.net.EventType.COMPLETE));};goog.net.ImageLoader.prototype.start=function(){var imageIdToRequestMap=this.imageIdToRequestMap_;goog.array.forEach(goog.object.getKeys(imageIdToRequestMap),function(id){var imageRequest=imageIdToRequestMap[id];imageRequest&&(delete imageIdToRequestMap[id],this.loadImage_(imageRequest,id));},this);};goog.net.ImageLoader.prototype.loadImage_=function(imageRequest,id){if(!this.isDisposed()){var image=this.parent_?goog.dom.getDomHelper(this.parent_).createDom("IMG"):new Image();imageRequest.corsRequestType&&(image.crossOrigin=imageRequest.corsRequestType);this.handler_.listen(image,goog.net.ImageLoader.IMAGE_LOAD_EVENTS_,this.onNetworkEvent_);this.imageIdToImageMap_[id]=image;image.id=id;image.src=imageRequest.src;}};goog.net.ImageLoader.prototype.onNetworkEvent_=function(evt){var image=evt.currentTarget;if(image){if(evt.type==goog.net.EventType.READY_STATE_CHANGE){if(image.readyState==goog.net.EventType.COMPLETE){evt.type=goog.events.EventType.LOAD;}else{return;}}"undefined"==typeof image.naturalWidth&&(evt.type==goog.events.EventType.LOAD?(image.naturalWidth=image.width,image.naturalHeight=image.height):(image.naturalWidth=0,image.naturalHeight=0));this.dispatchEvent({type:evt.type,target:image});this.isDisposed()||this.removeImage(image.id);}};goog.net.ImageLoader.prototype.disposeInternal=function(){delete this.imageIdToRequestMap_;delete this.imageIdToImageMap_;goog.dispose(this.handler_);goog.net.ImageLoader.superClass_.disposeInternal.call(this);};ee.layers.ImageOverlay=function(tileSource,opt_options){ee.layers.AbstractOverlay.call(this,tileSource,opt_options);};goog.inherits(ee.layers.ImageOverlay,ee.layers.AbstractOverlay);ee.layers.ImageOverlay.prototype.createTile=function(coord,zoom,ownerDocument,uniqueId){return new ee.layers.ImageTile(coord,zoom,ownerDocument,uniqueId);};ee.layers.ImageTile=function(coord,zoom,ownerDocument,uniqueId){ee.layers.AbstractTile.call(this,coord,zoom,ownerDocument,uniqueId);this.renderer=ee.layers.ImageTile.defaultRenderer_;this.imageLoaderListenerKey_=this.imageLoader_=this.imageEl=null;this.objectUrl_="";};goog.inherits(ee.layers.ImageTile,ee.layers.AbstractTile);ee.layers.ImageTile.prototype.finishLoad=function(){try{var imageUrl=this.objectUrl_=URL.createObjectURL(this.sourceData);}catch(e){imageUrl=this.sourceUrl;}this.imageLoader_=new goog.net.ImageLoader();this.imageLoader_.addImage(this.div.id+"-image",imageUrl);this.imageLoaderListenerKey_=goog.events.listenOnce(this.imageLoader_,ee.layers.ImageTile.IMAGE_LOADER_EVENTS_,function(event){event.type==goog.events.EventType.LOAD?(this.imageEl=event.target,ee.layers.AbstractTile.prototype.finishLoad.call(this)):this.retryLoad();},void 0,this);this.imageLoader_.start();};ee.layers.ImageTile.prototype.cancelLoad=function(){ee.layers.ImageTile.superClass_.cancelLoad.call(this);this.imageLoader_&&(goog.events.unlistenByKey(this.imageLoaderListenerKey_),goog.dispose(this.imageLoader_));};ee.layers.ImageTile.prototype.disposeInternal=function(){ee.layers.ImageTile.superClass_.disposeInternal.call(this);this.objectUrl_&&URL.revokeObjectURL(this.objectUrl_);};ee.layers.ImageTile.prototype.disposeInternal=function(){ee.layers.ImageTile.superClass_.disposeInternal.call(this);this.objectUrl_&&URL.revokeObjectURL(this.objectUrl_);};ee.layers.ImageTile.IMAGE_LOADER_EVENTS_=[goog.events.EventType.LOAD,goog.net.EventType.ABORT,goog.net.EventType.ERROR];ee.layers.ImageTile.defaultRenderer_=function(tile){tile.div.appendChild(tile.imageEl);};ee.AbstractOverlay=function(url,mapId,token,opt_init,opt_profiler){goog.events.EventTarget.call(this);this.mapId=mapId;this.token=token;this.tilesLoading=[];this.tilesFailed=new goog.structs.Set();this.tileCounter=0;this.url=url;};goog.inherits(ee.AbstractOverlay,goog.events.EventTarget);ee.AbstractOverlay.EventType={TILE_LOADED:"tileevent"};ee.AbstractOverlay.prototype.getTileId=function(coord,zoom){var maxCoord=1<<zoom,x=coord.x%maxCoord;0>x&&(x+=maxCoord);return[this.mapId,zoom,x,coord.y].join("/");};ee.AbstractOverlay.prototype.getLoadingTilesCount=function(){return this.tilesLoading.length;};ee.AbstractOverlay.prototype.getFailedTilesCount=function(){return this.tilesFailed.getCount();};ee.TileEvent=function(count){goog.events.Event.call(this,ee.AbstractOverlay.EventType.TILE_LOADED);this.count=count;};goog.inherits(ee.TileEvent,goog.events.Event);ee.Encodable=function(){};goog.crypt={};goog.crypt.Hash=function(){this.blockSize=-1;};goog.crypt.Md5=function(){goog.crypt.Hash.call(this);this.blockSize=64;this.chain_=Array(4);this.block_=Array(this.blockSize);this.totalLength_=this.blockLength_=0;this.reset();};goog.inherits(goog.crypt.Md5,goog.crypt.Hash);goog.crypt.Md5.prototype.reset=function(){this.chain_[0]=1732584193;this.chain_[1]=4023233417;this.chain_[2]=2562383102;this.chain_[3]=271733878;this.totalLength_=this.blockLength_=0;};goog.crypt.Md5.prototype.compress_=function(buf,opt_offset){opt_offset||(opt_offset=0);var X=Array(16);if(goog.isString(buf)){for(var i=0;16>i;++i){X[i]=buf.charCodeAt(opt_offset++)|buf.charCodeAt(opt_offset++)<<8|buf.charCodeAt(opt_offset++)<<16|buf.charCodeAt(opt_offset++)<<24;}}else{for(i=0;16>i;++i){X[i]=buf[opt_offset++]|buf[opt_offset++]<<8|buf[opt_offset++]<<16|buf[opt_offset++]<<24;}}var A=this.chain_[0],B=this.chain_[1],C=this.chain_[2],D=this.chain_[3],sum=0,sum=A+(D^B&(C^D))+X[0]+3614090360&4294967295,A=B+(sum<<7&4294967295|sum>>>25),sum=D+(C^A&(B^C))+X[1]+3905402710&4294967295,D=A+(sum<<12&4294967295|sum>>>20),sum=C+(B^D&(A^B))+X[2]+606105819&4294967295,C=D+(sum<<17&4294967295|sum>>>15),sum=B+(A^C&(D^A))+X[3]+3250441966&4294967295,B=C+(sum<<22&4294967295|sum>>>10),sum=A+(D^B&(C^D))+X[4]+4118548399&4294967295,A=B+(sum<<7&4294967295|sum>>>25),sum=D+(C^A&(B^C))+X[5]+1200080426&4294967295,D=A+(sum<<12&4294967295|sum>>>20),sum=C+(B^D&(A^B))+X[6]+2821735955&4294967295,C=D+(sum<<17&4294967295|sum>>>15),sum=B+(A^C&(D^A))+X[7]+4249261313&4294967295,B=C+(sum<<22&4294967295|sum>>>10),sum=A+(D^B&(C^D))+X[8]+1770035416&4294967295,A=B+(sum<<7&4294967295|sum>>>25),sum=D+(C^A&(B^C))+X[9]+2336552879&4294967295,D=A+(sum<<12&4294967295|sum>>>20),sum=C+(B^D&(A^B))+X[10]+4294925233&4294967295,C=D+(sum<<17&4294967295|sum>>>15),sum=B+(A^C&(D^A))+X[11]+2304563134&4294967295,B=C+(sum<<22&4294967295|sum>>>10),sum=A+(D^B&(C^D))+X[12]+1804603682&4294967295,A=B+(sum<<7&4294967295|sum>>>25),sum=D+(C^A&(B^C))+X[13]+4254626195&4294967295,D=A+(sum<<12&4294967295|sum>>>20),sum=C+(B^D&(A^B))+X[14]+2792965006&4294967295,C=D+(sum<<17&4294967295|sum>>>15),sum=B+(A^C&(D^A))+X[15]+1236535329&4294967295,B=C+(sum<<22&4294967295|sum>>>10),sum=A+(C^D&(B^C))+X[1]+4129170786&4294967295,A=B+(sum<<5&4294967295|sum>>>27),sum=D+(B^C&(A^B))+X[6]+3225465664&4294967295,D=A+(sum<<9&4294967295|sum>>>23),sum=C+(A^B&(D^A))+X[11]+643717713&4294967295,C=D+(sum<<14&4294967295|sum>>>18),sum=B+(D^A&(C^D))+X[0]+3921069994&4294967295,B=C+(sum<<20&4294967295|sum>>>12),sum=A+(C^D&(B^C))+X[5]+3593408605&4294967295,A=B+(sum<<5&4294967295|sum>>>27),sum=D+(B^C&(A^B))+X[10]+38016083&4294967295,D=A+(sum<<9&4294967295|sum>>>23),sum=C+(A^B&(D^A))+X[15]+3634488961&4294967295,C=D+(sum<<14&4294967295|sum>>>18),sum=B+(D^A&(C^D))+X[4]+3889429448&4294967295,B=C+(sum<<20&4294967295|sum>>>12),sum=A+(C^D&(B^C))+X[9]+568446438&4294967295,A=B+(sum<<5&4294967295|sum>>>27),sum=D+(B^C&(A^B))+X[14]+3275163606&4294967295,D=A+(sum<<9&4294967295|sum>>>23),sum=C+(A^B&(D^A))+X[3]+4107603335&4294967295,C=D+(sum<<14&4294967295|sum>>>18),sum=B+(D^A&(C^D))+X[8]+1163531501&4294967295,B=C+(sum<<20&4294967295|sum>>>12),sum=A+(C^D&(B^C))+X[13]+2850285829&4294967295,A=B+(sum<<5&4294967295|sum>>>27),sum=D+(B^C&(A^B))+X[2]+4243563512&4294967295,D=A+(sum<<9&4294967295|sum>>>23),sum=C+(A^B&(D^A))+X[7]+1735328473&4294967295,C=D+(sum<<14&4294967295|sum>>>18),sum=B+(D^A&(C^D))+X[12]+2368359562&4294967295,B=C+(sum<<20&4294967295|sum>>>12),sum=A+(B^C^D)+X[5]+4294588738&4294967295,A=B+(sum<<4&4294967295|sum>>>28),sum=D+(A^B^C)+X[8]+2272392833&4294967295,D=A+(sum<<11&4294967295|sum>>>21),sum=C+(D^A^B)+X[11]+1839030562&4294967295,C=D+(sum<<16&4294967295|sum>>>16),sum=B+(C^D^A)+X[14]+4259657740&4294967295,B=C+(sum<<23&4294967295|sum>>>9),sum=A+(B^C^D)+X[1]+2763975236&4294967295,A=B+(sum<<4&4294967295|sum>>>28),sum=D+(A^B^C)+X[4]+1272893353&4294967295,D=A+(sum<<11&4294967295|sum>>>21),sum=C+(D^A^B)+X[7]+4139469664&4294967295,C=D+(sum<<16&4294967295|sum>>>16),sum=B+(C^D^A)+X[10]+3200236656&4294967295,B=C+(sum<<23&4294967295|sum>>>9),sum=A+(B^C^D)+X[13]+681279174&4294967295,A=B+(sum<<4&4294967295|sum>>>28),sum=D+(A^B^C)+X[0]+3936430074&4294967295,D=A+(sum<<11&4294967295|sum>>>21),sum=C+(D^A^B)+X[3]+3572445317&4294967295,C=D+(sum<<16&4294967295|sum>>>16),sum=B+(C^D^A)+X[6]+76029189&4294967295,B=C+(sum<<23&4294967295|sum>>>9),sum=A+(B^C^D)+X[9]+3654602809&4294967295,A=B+(sum<<4&4294967295|sum>>>28),sum=D+(A^B^C)+X[12]+3873151461&4294967295,D=A+(sum<<11&4294967295|sum>>>21),sum=C+(D^A^B)+X[15]+530742520&4294967295,C=D+(sum<<16&4294967295|sum>>>16),sum=B+(C^D^A)+X[2]+3299628645&4294967295,B=C+(sum<<23&4294967295|sum>>>9),sum=A+(C^(B|~D))+X[0]+4096336452&4294967295,A=B+(sum<<6&4294967295|sum>>>26),sum=D+(B^(A|~C))+X[7]+1126891415&4294967295,D=A+(sum<<10&4294967295|sum>>>22),sum=C+(A^(D|~B))+X[14]+2878612391&4294967295,C=D+(sum<<15&4294967295|sum>>>17),sum=B+(D^(C|~A))+X[5]+4237533241&4294967295,B=C+(sum<<21&4294967295|sum>>>11),sum=A+(C^(B|~D))+X[12]+1700485571&4294967295,A=B+(sum<<6&4294967295|sum>>>26),sum=D+(B^(A|~C))+X[3]+2399980690&4294967295,D=A+(sum<<10&4294967295|sum>>>22),sum=C+(A^(D|~B))+X[10]+4293915773&4294967295,C=D+(sum<<15&4294967295|sum>>>17),sum=B+(D^(C|~A))+X[1]+2240044497&4294967295,B=C+(sum<<21&4294967295|sum>>>11),sum=A+(C^(B|~D))+X[8]+1873313359&4294967295,A=B+(sum<<6&4294967295|sum>>>26),sum=D+(B^(A|~C))+X[15]+4264355552&4294967295,D=A+(sum<<10&4294967295|sum>>>22),sum=C+(A^(D|~B))+X[6]+2734768916&4294967295,C=D+(sum<<15&4294967295|sum>>>17),sum=B+(D^(C|~A))+X[13]+1309151649&4294967295,B=C+(sum<<21&4294967295|sum>>>11),sum=A+(C^(B|~D))+X[4]+4149444226&4294967295,A=B+(sum<<6&4294967295|sum>>>26),sum=D+(B^(A|~C))+X[11]+3174756917&4294967295,D=A+(sum<<10&4294967295|sum>>>22),sum=C+(A^(D|~B))+X[2]+718787259&4294967295,C=D+(sum<<15&4294967295|sum>>>17),sum=B+(D^(C|~A))+X[9]+3951481745&4294967295;this.chain_[0]=this.chain_[0]+A&4294967295;this.chain_[1]=this.chain_[1]+(C+(sum<<21&4294967295|sum>>>11))&4294967295;this.chain_[2]=this.chain_[2]+C&4294967295;this.chain_[3]=this.chain_[3]+D&4294967295;};goog.crypt.Md5.prototype.update=function(bytes,opt_length){goog.isDef(opt_length)||(opt_length=bytes.length);for(var lengthMinusBlock=opt_length-this.blockSize,block=this.block_,blockLength=this.blockLength_,i=0;i<opt_length;){if(0==blockLength){for(;i<=lengthMinusBlock;){this.compress_(bytes,i),i+=this.blockSize;}}if(goog.isString(bytes)){for(;i<opt_length;){if(block[blockLength++]=bytes.charCodeAt(i++),blockLength==this.blockSize){this.compress_(block);blockLength=0;break;}}}else{for(;i<opt_length;){if(block[blockLength++]=bytes[i++],blockLength==this.blockSize){this.compress_(block);blockLength=0;break;}}}}this.blockLength_=blockLength;this.totalLength_+=opt_length;};goog.crypt.Md5.prototype.digest=function(){var pad=Array((56>this.blockLength_?this.blockSize:2*this.blockSize)-this.blockLength_);pad[0]=128;for(var i=1;i<pad.length-8;++i){pad[i]=0;}for(var totalBits=8*this.totalLength_,i=pad.length-8;i<pad.length;++i){pad[i]=totalBits&255,totalBits/=256;}this.update(pad);for(var digest=Array(16),n=0,i=0;4>i;++i){for(var j=0;32>j;j+=8){digest[n++]=this.chain_[i]>>>j&255;}}return digest;};ee.Serializer=function(opt_isCompound){this.HASH_KEY="__ee_hash__";this.isCompound_=!1!==opt_isCompound;this.scope_=[];this.encoded_={};this.withHashes_=[];};goog.exportSymbol("ee.Serializer",ee.Serializer);ee.Serializer.jsonSerializer_=new goog.json.Serializer();ee.Serializer.hash_=new goog.crypt.Md5();ee.Serializer.encode=function(obj,opt_isCompound){return new ee.Serializer(goog.isDef(opt_isCompound)?opt_isCompound:!0).encode_(obj);};ee.Serializer.toJSON=function(obj){return ee.Serializer.jsonSerializer_.serialize(ee.Serializer.encode(obj));};ee.Serializer.toReadableJSON=function(obj){var encoded=new ee.Serializer(!1).encode_(obj);return"JSON"in goog.global?goog.global.JSON.stringify(encoded,null,"  "):ee.Serializer.jsonSerializer_.serialize(encoded);};ee.Serializer.prototype.encode_=function(object){var value=this.encodeValue_(object);this.isCompound_&&(value=goog.isObject(value)&&"ValueRef"==value.type&&1==this.scope_.length?this.scope_[0][1]:{type:"CompoundValue",scope:this.scope_,value:value},this.scope_=[],goog.array.forEach(this.withHashes_,goog.bind(function(obj){delete obj[this.HASH_KEY];},this)),this.withHashes_=[],this.encoded_={});return value;};ee.Serializer.prototype.encodeValue_=function(object){if(!goog.isDef(object)){throw Error("Can\'t encode an undefined value.");}var hash=goog.isObject(object)?object[this.HASH_KEY]:null;if(this.isCompound_&&null!=hash&&this.encoded_[hash]){return{type:"ValueRef",value:this.encoded_[hash]};}if(null===object||goog.isBoolean(object)||goog.isNumber(object)||goog.isString(object)){return object;}if(goog.isDateLike(object)){return{type:"Invocation",functionName:"Date",arguments:{value:Math.floor(object.getTime())}};}if(object instanceof ee.Encodable){var result=object.encode(goog.bind(this.encodeValue_,this));if(!(goog.isArray(result)||goog.isObject(result)&&"ArgumentRef"!=result.type)){return result;}}else{if(goog.isArray(object)){result=goog.array.map(object,function(element){return this.encodeValue_(element);},this);}else{if(goog.isObject(object)&&!goog.isFunction(object)){var encodedObject=goog.object.map(object,function(element){if(!goog.isFunction(element)){return this.encodeValue_(element);}},this);goog.object.remove(encodedObject,this.HASH_KEY);result={type:"Dictionary",value:encodedObject};}else{throw Error("Can\'t encode object: "+object);}}}if(this.isCompound_){ee.Serializer.hash_.reset();ee.Serializer.hash_.update(ee.Serializer.jsonSerializer_.serialize(result));var hash=ee.Serializer.hash_.digest().toString();if(this.encoded_[hash]){var name=this.encoded_[hash];}else{name=String(this.scope_.length),this.scope_.push([name,result]),this.encoded_[hash]=name;}object[this.HASH_KEY]=hash;this.withHashes_.push(object);return{type:"ValueRef",value:name};}return result;};ee.ComputedObject=function(func,args,opt_varName){if(!(this instanceof ee.ComputedObject)){return ee.ComputedObject.construct(ee.ComputedObject,arguments);}if(opt_varName&&(func||args)){throw Error(\'When "opt_varName" is specified, "func" and "args" must be null.\');}if(func&&!args){throw Error(\'When "func" is specified, "args" must not be null.\');}this.func=func;this.args=args;this.varName=opt_varName||null;};goog.inherits(ee.ComputedObject,ee.Encodable);goog.exportSymbol("ee.ComputedObject",ee.ComputedObject);ee.ComputedObject.prototype.evaluate=function(callback){if(!callback||!goog.isFunction(callback)){throw Error("evaluate() requires a callback function.");}ee.data.getValue({json:this.serialize()},callback);};ee.ComputedObject.prototype.getInfo=function(opt_callback){return ee.data.getValue({json:this.serialize()},opt_callback);};ee.ComputedObject.prototype.encode=function(encoder){if(this.isVariable()){return{type:"ArgumentRef",value:this.varName};}var encodedArgs={},name;for(name in this.args){goog.isDef(this.args[name])&&(encodedArgs[name]=encoder(this.args[name]));}var result={type:"Invocation",arguments:encodedArgs},func=encoder(this.func);result[goog.isString(func)?"functionName":"function"]=func;return result;};ee.ComputedObject.prototype.serialize=function(){return ee.Serializer.toJSON(this);};ee.ComputedObject.prototype.toString=function(){return"ee."+this.name()+"("+ee.Serializer.toReadableJSON(this)+")";};goog.exportSymbol("ee.ComputedObject.prototype.toString",ee.ComputedObject.prototype.toString);ee.ComputedObject.prototype.isVariable=function(){return goog.isNull(this.func)&&goog.isNull(this.args);};ee.ComputedObject.prototype.name=function(){return"ComputedObject";};ee.ComputedObject.prototype.aside=function(func,var_args){var args=goog.array.clone(arguments);args[0]=this;func.apply(goog.global,args);return this;};ee.ComputedObject.prototype.castInternal=function(obj){if(obj instanceof this.constructor){return obj;}var klass=function klass(){};klass.prototype=this.constructor.prototype;var result=new klass();result.func=obj.func;result.args=obj.args;result.varName=obj.varName;return result;};ee.ComputedObject.construct=function(constructor,argsArray){function F(){return constructor.apply(this,argsArray);}F.prototype=constructor.prototype;return new F();};ee.Types={};ee.Types.registeredClasses_={};ee.Types.registerClasses=function(classes){ee.Types.registeredClasses_=classes;};ee.Types.nameToClass=function(name){return name in ee.Types.registeredClasses_?ee.Types.registeredClasses_[name]:null;};ee.Types.classToName=function(klass){return klass.prototype instanceof ee.ComputedObject?klass.prototype.name.call(null):klass==Number?"Number":klass==String?"String":klass==Array?"Array":klass==Date?"Date":"Object";};ee.Types.isSubtype=function(firstType,secondType){if(secondType==firstType){return!0;}switch(firstType){case"Element":return"Element"==secondType||"Image"==secondType||"Feature"==secondType||"Collection"==secondType||"ImageCollection"==secondType||"FeatureCollection"==secondType;case"FeatureCollection":case"Collection":return"Collection"==secondType||"ImageCollection"==secondType||"FeatureCollection"==secondType;case"Object":return!0;default:return!1;}};ee.Types.isNumber=function(obj){return goog.isNumber(obj)||obj instanceof ee.ComputedObject&&"Number"==obj.name();};ee.Types.isString=function(obj){return goog.isString(obj)||obj instanceof ee.ComputedObject&&"String"==obj.name();};ee.Types.isArray=function(obj){return goog.isArray(obj)||obj instanceof ee.ComputedObject&&"List"==obj.name();};ee.Types.isRegularObject=function(obj){if(goog.isObject(obj)&&!goog.isFunction(obj)){var proto=Object.getPrototypeOf(obj);return!goog.isNull(proto)&&goog.isNull(Object.getPrototypeOf(proto));}return!1;};ee.Function=function(){if(!(this instanceof ee.Function)){return new ee.Function();}};goog.inherits(ee.Function,ee.Encodable);goog.exportSymbol("ee.Function",ee.Function);ee.Function.promoter_=goog.functions.identity;ee.Function.registerPromoter=function(promoter){ee.Function.promoter_=promoter;};ee.Function.prototype.call=function(var_args){return this.apply(this.nameArgs(Array.prototype.slice.call(arguments,0)));};ee.Function.prototype.apply=function(namedArgs){var result=new ee.ComputedObject(this,this.promoteArgs(namedArgs));return ee.Function.promoter_(result,this.getReturnType());};ee.Function.prototype.callOrApply=function(thisValue,args){var isInstance=goog.isDef(thisValue),signature=this.getSignature(),useKeywordArgs=!1;if(1==args.length&&ee.Types.isRegularObject(args[0])){var params=signature.args;isInstance&&(params=params.slice(1));params.length&&(useKeywordArgs=!((1==params.length||params[1].optional)&&"Dictionary"==params[0].type));}if(useKeywordArgs){var namedArgs=goog.object.clone(args[0]);if(isInstance){var firstArgName=signature.args[0].name;if(firstArgName in namedArgs){throw Error("Named args for "+signature.name+" can\'t contain keyword "+firstArgName);}namedArgs[firstArgName]=thisValue;}}else{namedArgs=this.nameArgs(isInstance?[thisValue].concat(args):args);}return this.apply(namedArgs);};ee.Function.prototype.promoteArgs=function(args){for(var specs=this.getSignature().args,promotedArgs={},known={},i=0;i<specs.length;i++){var name=specs[i].name;if(name in args&&goog.isDef(args[name])){promotedArgs[name]=ee.Function.promoter_(args[name],specs[i].type);}else{if(!specs[i].optional){throw Error("Required argument ("+name+") missing to function: "+this);}}known[name]=!0;}var unknown=[],argName;for(argName in args){known[argName]||unknown.push(argName);}if(0<unknown.length){throw Error("Unrecognized arguments ("+unknown+") to function: "+this);}return promotedArgs;};ee.Function.prototype.nameArgs=function(args){var specs=this.getSignature().args;if(specs.length<args.length){throw Error("Too many ("+args.length+") arguments to function: "+this);}for(var namedArgs={},i=0;i<args.length;i++){namedArgs[specs[i].name]=args[i];}return namedArgs;};ee.Function.prototype.getReturnType=function(){return this.getSignature().returns;};ee.Function.prototype.toString=function(opt_name,opt_isInstance){var signature=this.getSignature(),buffer=[];buffer.push(opt_name||signature.name);buffer.push("(");buffer.push(goog.array.map(signature.args.slice(opt_isInstance?1:0),function(elem){return elem.name;}).join(", "));buffer.push(")\\n");buffer.push("\\n");signature.description?buffer.push(signature.description):buffer.push("Undocumented.");buffer.push("\\n");if(signature.args.length){buffer.push("\\nArgs:\\n");for(var i=0;i<signature.args.length;i++){opt_isInstance&&0==i?buffer.push("  this:"):buffer.push("\\n  ");var arg=signature.args[i];buffer.push(arg.name);buffer.push(" (");buffer.push(arg.type);arg.optional&&buffer.push(", optional");buffer.push("): ");arg.description?buffer.push(arg.description):buffer.push("Undocumented.");}}return buffer.join("");};ee.Function.prototype.serialize=function(){return ee.Serializer.toJSON(this);};ee.ApiFunction=function(name,opt_signature){if(!goog.isDef(opt_signature)){return ee.ApiFunction.lookup(name);}if(!(this instanceof ee.ApiFunction)){return ee.ComputedObject.construct(ee.ApiFunction,arguments);}this.signature_=goog.object.unsafeClone(opt_signature);this.signature_.name=name;};goog.inherits(ee.ApiFunction,ee.Function);goog.exportSymbol("ee.ApiFunction",ee.ApiFunction);ee.ApiFunction._call=function(name,var_args){return ee.Function.prototype.call.apply(ee.ApiFunction.lookup(name),Array.prototype.slice.call(arguments,1));};ee.ApiFunction._apply=function(name,namedArgs){return ee.ApiFunction.lookup(name).apply(namedArgs);};ee.ApiFunction.prototype.encode=function(encoder){return this.signature_.name;};ee.ApiFunction.prototype.getSignature=function(){return this.signature_;};ee.ApiFunction.api_=null;ee.ApiFunction.boundSignatures_={};ee.ApiFunction.allSignatures=function(){ee.ApiFunction.initialize();return goog.object.map(ee.ApiFunction.api_,function(func){return func.getSignature();});};ee.ApiFunction.unboundFunctions=function(){ee.ApiFunction.initialize();return goog.object.filter(ee.ApiFunction.api_,function(func,name){return!ee.ApiFunction.boundSignatures_[name];});};ee.ApiFunction.lookup=function(name){var func=ee.ApiFunction.lookupInternal(name);if(!func){throw Error("Unknown built-in function name: "+name);}return func;};ee.ApiFunction.lookupInternal=function(name){ee.ApiFunction.initialize();return ee.ApiFunction.api_[name]||null;};ee.ApiFunction.initialize=function(opt_successCallback,opt_failureCallback){if(ee.ApiFunction.api_){opt_successCallback&&opt_successCallback();}else{var callback=function callback(data,opt_error){opt_error?opt_failureCallback&&opt_failureCallback(Error(opt_error)):(ee.ApiFunction.api_=goog.object.map(data,function(sig,name){sig.returns=sig.returns.replace(/<.*>/,"");for(var i=0;i<sig.args.length;i++){sig.args[i].type=sig.args[i].type.replace(/<.*>/,"");}return new ee.ApiFunction(name,sig);}),opt_successCallback&&opt_successCallback());};opt_successCallback?ee.data.getAlgorithms(callback):callback(ee.data.getAlgorithms());}};ee.ApiFunction.reset=function(){ee.ApiFunction.api_=null;ee.ApiFunction.boundSignatures_={};};ee.ApiFunction.importApi=function(target,prefix,typeName,opt_prepend){ee.ApiFunction.initialize();var prepend=opt_prepend||"";goog.object.forEach(ee.ApiFunction.api_,function(apiFunc,name){var parts=name.split(".");if(2==parts.length&&parts[0]==prefix){var fname=prepend+parts[1],signature=apiFunc.getSignature();ee.ApiFunction.boundSignatures_[name]=!0;var isInstance=!1;if(signature.args.length){var firstArgType=signature.args[0].type,isInstance="Object"!=firstArgType&&ee.Types.isSubtype(firstArgType,typeName);}var destination=isInstance?target.prototype:target;fname in destination&&!destination[fname].signature||(destination[fname]=function(var_args){return apiFunc.callOrApply(isInstance?this:void 0,Array.prototype.slice.call(arguments,0));},destination[fname].toString=goog.bind(apiFunc.toString,apiFunc,fname,isInstance),destination[fname].signature=signature);}});};ee.ApiFunction.clearApi=function(target$jscomp$0){var clear=function clear(target){for(var name in target){goog.isFunction(target[name])&&target[name].signature&&delete target[name];}};clear(target$jscomp$0);clear(target$jscomp$0.prototype);};ee.arguments={};ee.arguments.extract=function(fn,originalArgs){var paramNamesWithOptPrefix=ee.arguments.getParamNames_(fn),paramNames=goog.array.map(paramNamesWithOptPrefix,function(param){return param.replace(/^opt_/,"");}),fnName=ee.arguments.getFnName_(fn),fnNameSnippet=fnName?" to function "+fnName:"",args={},firstArg=originalArgs[0],firstArgCouldBeDictionary=goog.isObject(firstArg)&&!goog.isFunction(firstArg)&&!goog.isArray(firstArg)&&!(firstArg instanceof ee.ComputedObject);if(1<originalArgs.length||!firstArgCouldBeDictionary){if(originalArgs.length>paramNames.length){throw Error("Received too many arguments"+fnNameSnippet+". Expected at most "+paramNames.length+" but got "+originalArgs.length+".");}for(var i=0;i<originalArgs.length;i++){args[paramNames[i]]=originalArgs[i];}}else{var seen=new goog.structs.Set(goog.object.getKeys(firstArg)),expected=new goog.structs.Set(paramNames);if(expected.intersection(seen).isEmpty()){args[paramNames[0]]=originalArgs[0];}else{var unexpected=seen.difference(expected);if(!unexpected.isEmpty()){throw Error("Unexpected arguments"+fnNameSnippet+": "+unexpected.getValues().join(", "));}args=goog.object.clone(firstArg);}}var provided=new goog.structs.Set(goog.object.getKeys(args)),missing=new goog.structs.Set(goog.array.filter(paramNamesWithOptPrefix,function(param){return!goog.string.startsWith(param,"opt_");})).difference(provided);if(!missing.isEmpty()){throw Error("Missing required arguments"+fnNameSnippet+": "+missing.getValues().join(", "));}return args;};ee.arguments.getParamNames_=function(fn){var paramNames=[];if(goog.global.EXPORTED_FN_INFO){var exportedFnInfo=goog.global.EXPORTED_FN_INFO[fn.toString()];goog.asserts.assertObject(exportedFnInfo);paramNames=exportedFnInfo.paramNames;goog.asserts.assertArray(paramNames);}else{paramNames=fn.toString().replace(ee.arguments.JS_COMMENT_MATCHER_,"").match(ee.arguments.JS_PARAM_DECL_MATCHER_)[1].split(",")||[];}return paramNames;};ee.arguments.getFnName_=function(fn){return goog.global.EXPORTED_FN_INFO?goog.global.EXPORTED_FN_INFO[fn.toString()].name.split(".").pop()+"()":null;};ee.arguments.JS_COMMENT_MATCHER_=/((\\/\\/.*$)|(\\/\\*[\\s\\S]*?\\*\\/)|(\\s))/mg;ee.arguments.JS_PARAM_DECL_MATCHER_=/^function\\s*[^\\(]*\\(\\s*([^\\)]*)\\)/m;ee.Element=function(func,args,opt_varName){ee.ComputedObject.call(this,func,args,opt_varName);ee.Element.initialize();};goog.inherits(ee.Element,ee.ComputedObject);goog.exportSymbol("ee.Element",ee.Element);ee.Element.initialized_=!1;ee.Element.initialize=function(){ee.Element.initialized_||(ee.ApiFunction.importApi(ee.Element,"Element","Element"),ee.Element.initialized_=!0);};ee.Element.reset=function(){ee.ApiFunction.clearApi(ee.Element);ee.Element.initialized_=!1;};ee.Element.prototype.name=function(){return"Element";};ee.Element.prototype.set=function(var_args){if(1>=arguments.length){var properties=arguments[0];ee.Types.isRegularObject(properties)&&goog.array.equals(goog.object.getKeys(properties),["properties"])&&goog.isObject(properties.properties)&&(properties=properties.properties);if(ee.Types.isRegularObject(properties)){var result=this;for(key in properties){var value=properties[key];result=ee.ApiFunction._call("Element.set",result,key,value);}}else{if(properties instanceof ee.ComputedObject&&ee.ApiFunction.lookupInternal("Element.setMulti")){result=ee.ApiFunction._call("Element.setMulti",this,properties);}else{throw Error("When Element.set() is passed one argument, it must be a dictionary.");}}}else{if(0!=arguments.length%2){throw Error("When Element.set() is passed multiple arguments, there must be an even number of them.");}result=this;for(var i=0;i<arguments.length;i+=2){var key=arguments[i];value=arguments[i+1];result=ee.ApiFunction._call("Element.set",result,key,value);}}return this.castInternal(result);};ee.Filter=function(opt_filter){if(!(this instanceof ee.Filter)){return ee.ComputedObject.construct(ee.Filter,arguments);}if(opt_filter instanceof ee.Filter){return opt_filter;}ee.Filter.initialize();if(goog.isArray(opt_filter)){if(0==opt_filter.length){throw Error("Empty list specified for ee.Filter().");}if(1==opt_filter.length){return new ee.Filter(opt_filter[0]);}ee.ComputedObject.call(this,new ee.ApiFunction("Filter.and"),{filters:opt_filter});this.filter_=opt_filter;}else{if(opt_filter instanceof ee.ComputedObject){ee.ComputedObject.call(this,opt_filter.func,opt_filter.args,opt_filter.varName),this.filter_=[opt_filter];}else{if(goog.isDef(opt_filter)){throw Error("Invalid argument specified for ee.Filter(): "+opt_filter);}ee.ComputedObject.call(this,null,null);this.filter_=[];}}};goog.inherits(ee.Filter,ee.ComputedObject);ee.Filter.initialized_=!1;ee.Filter.initialize=function(){ee.Filter.initialized_||(ee.ApiFunction.importApi(ee.Filter,"Filter","Filter"),ee.Filter.initialized_=!0);};ee.Filter.reset=function(){ee.ApiFunction.clearApi(ee.Filter);ee.Filter.initialized_=!1;};ee.Filter.functionNames_={equals:"equals",less_than:"lessThan",greater_than:"greaterThan",contains:"stringContains",starts_with:"stringStartsWith",ends_with:"stringEndsWith"};ee.Filter.prototype.append_=function(newFilter){var prev=this.filter_.slice(0);newFilter instanceof ee.Filter?goog.array.extend(prev,newFilter.filter_):newFilter instanceof Array?goog.array.extend(prev,newFilter):prev.push(newFilter);return new ee.Filter(prev);};ee.Filter.prototype.not=function(){return ee.ApiFunction._call("Filter.not",this);};ee.Filter.eq=function(name,value){var args=ee.arguments.extract(ee.Filter.eq,arguments);return ee.ApiFunction._call("Filter.equals",args.name,args.value);};ee.Filter.neq=function(name,value){var args=ee.arguments.extract(ee.Filter.neq,arguments);return ee.Filter.eq(args.name,args.value).not();};ee.Filter.lt=function(name,value){var args=ee.arguments.extract(ee.Filter.lt,arguments);return ee.ApiFunction._call("Filter.lessThan",args.name,args.value);};ee.Filter.gte=function(name,value){var args=ee.arguments.extract(ee.Filter.gte,arguments);return ee.Filter.lt(args.name,args.value).not();};ee.Filter.gt=function(name,value){var args=ee.arguments.extract(ee.Filter.gt,arguments);return ee.ApiFunction._call("Filter.greaterThan",args.name,args.value);};ee.Filter.lte=function(name,value){var args=ee.arguments.extract(ee.Filter.lte,arguments);return ee.Filter.gt(args.name,args.value).not();};ee.Filter.and=function(var_args){var args=Array.prototype.slice.call(arguments);return ee.ApiFunction._call("Filter.and",args);};ee.Filter.or=function(var_args){var args=Array.prototype.slice.call(arguments);return ee.ApiFunction._call("Filter.or",args);};ee.Filter.date=function(start,opt_end){var args=ee.arguments.extract(ee.Filter.date,arguments),range=ee.ApiFunction._call("DateRange",args.start,args.end);return ee.ApiFunction._apply("Filter.dateRangeContains",{leftValue:range,rightField:"system:time_start"});};ee.Filter.inList=function(opt_leftField,opt_rightValue,opt_rightField,opt_leftValue){var args=ee.arguments.extract(ee.Filter.inList,arguments);return ee.ApiFunction._apply("Filter.listContains",{leftField:args.rightField,rightValue:args.leftValue,rightField:args.leftField,leftValue:args.rightValue});};ee.Filter.bounds=function(geometry,opt_errorMargin){return ee.ApiFunction._apply("Filter.intersects",{leftField:".all",rightValue:ee.ApiFunction._call("Feature",geometry),maxError:opt_errorMargin});};ee.Filter.prototype.name=function(){return"Filter";};ee.Filter.metadata=function(name,operator,value){operator=operator.toLowerCase();var negated=!1;goog.string.startsWith(operator,"not_")&&(negated=!0,operator=operator.substring(4));if(!(operator in ee.Filter.functionNames_)){throw Error("Unknown filtering operator: "+operator);}var filter=ee.ApiFunction._call("Filter."+ee.Filter.functionNames_[operator],name,value);return negated?filter.not():filter;};ee.Collection=function(func,args,opt_varName){ee.Element.call(this,func,args,opt_varName);ee.Collection.initialize();};goog.inherits(ee.Collection,ee.Element);goog.exportSymbol("ee.Collection",ee.Collection);ee.Collection.initialized_=!1;ee.Collection.initialize=function(){ee.Collection.initialized_||(ee.ApiFunction.importApi(ee.Collection,"Collection","Collection"),ee.ApiFunction.importApi(ee.Collection,"AggregateFeatureCollection","Collection","aggregate_"),ee.Collection.initialized_=!0);};ee.Collection.reset=function(){ee.ApiFunction.clearApi(ee.Collection);ee.Collection.initialized_=!1;};ee.Collection.prototype.filter=function(newFilter){if(!newFilter){throw Error("Empty filters.");}return this.castInternal(ee.ApiFunction._call("Collection.filter",this,newFilter));};ee.Collection.prototype.filterMetadata=function(name,operator,value){var args=ee.arguments.extract(ee.Collection.prototype.filterMetadata,arguments);return this.filter(ee.Filter.metadata(args.name,args.operator,args.value));};ee.Collection.prototype.filterBounds=function(geometry){return this.filter(ee.Filter.bounds(geometry));};ee.Collection.prototype.filterDate=function(start,opt_end){var args=ee.arguments.extract(ee.Collection.prototype.filterDate,arguments);return this.filter(ee.Filter.date(args.start,args.end));};ee.Collection.prototype.limit=function(max,opt_property,opt_ascending){var args=ee.arguments.extract(ee.Collection.prototype.limit,arguments);return this.castInternal(ee.ApiFunction._call("Collection.limit",this,args.max,args.property,args.ascending));};ee.Collection.prototype.sort=function(property,opt_ascending){var args=ee.arguments.extract(ee.Collection.prototype.sort,arguments);return this.castInternal(ee.ApiFunction._call("Collection.limit",this,void 0,args.property,args.ascending));};ee.Collection.prototype.name=function(){return"Collection";};ee.Collection.prototype.elementType=function(){return ee.Element;};ee.Collection.prototype.map=function(algorithm,opt_dropNulls){var elementType=this.elementType();return this.castInternal(ee.ApiFunction._call("Collection.map",this,function(e){return algorithm(new elementType(e));},opt_dropNulls));};ee.Collection.prototype.iterate=function(algorithm,opt_first){var first=goog.isDef(opt_first)?opt_first:null,elementType=this.elementType();return ee.ApiFunction._call("Collection.iterate",this,function(e,p){return algorithm(new elementType(e),p);},first);};ee.Number=function(number){if(!(this instanceof ee.Number)){return ee.ComputedObject.construct(ee.Number,arguments);}if(number instanceof ee.Number){return number;}ee.Number.initialize();if(goog.isNumber(number)){ee.ComputedObject.call(this,null,null),this.number_=number;}else{if(number instanceof ee.ComputedObject){ee.ComputedObject.call(this,number.func,number.args,number.varName),this.number_=null;}else{throw Error("Invalid argument specified for ee.Number(): "+number);}}};goog.inherits(ee.Number,ee.ComputedObject);ee.Number.initialized_=!1;ee.Number.initialize=function(){ee.Number.initialized_||(ee.ApiFunction.importApi(ee.Number,"Number","Number"),ee.Number.initialized_=!0);};ee.Number.reset=function(){ee.ApiFunction.clearApi(ee.Number);ee.Number.initialized_=!1;};ee.Number.prototype.encode=function(encoder){return goog.isNumber(this.number_)?this.number_:ee.Number.superClass_.encode.call(this,encoder);};ee.Number.prototype.name=function(){return"Number";};ee.String=function(string){if(!(this instanceof ee.String)){return ee.ComputedObject.construct(ee.String,arguments);}if(string instanceof ee.String){return string;}ee.String.initialize();if(goog.isString(string)){ee.ComputedObject.call(this,null,null),this.string_=string;}else{if(string instanceof ee.ComputedObject){this.string_=null,string.func&&"String"==string.func.getSignature().returns?ee.ComputedObject.call(this,string.func,string.args,string.varName):ee.ComputedObject.call(this,new ee.ApiFunction("String"),{input:string},null);}else{throw Error("Invalid argument specified for ee.String(): "+string);}}};goog.inherits(ee.String,ee.ComputedObject);ee.String.initialized_=!1;ee.String.initialize=function(){ee.String.initialized_||(ee.ApiFunction.importApi(ee.String,"String","String"),ee.String.initialized_=!0);};ee.String.reset=function(){ee.ApiFunction.clearApi(ee.String);ee.String.initialized_=!1;};ee.String.prototype.encode=function(encoder){return goog.isString(this.string_)?this.string_:ee.String.superClass_.encode.call(this,encoder);};ee.String.prototype.name=function(){return"String";};ee.CustomFunction=function(signature,body){if(!(this instanceof ee.CustomFunction)){return ee.ComputedObject.construct(ee.CustomFunction,arguments);}for(var vars=[],args=signature.args,i=0;i<args.length;i++){var arg=args[i];vars.push(ee.CustomFunction.variable(ee.Types.nameToClass(arg.type),arg.name));}if(!goog.isDef(body.apply(null,vars))){throw Error("User-defined methods must return a value.");}this.signature_=ee.CustomFunction.resolveNamelessArgs_(signature,vars,body);this.body_=body.apply(null,vars);};goog.inherits(ee.CustomFunction,ee.Function);goog.exportSymbol("ee.CustomFunction",ee.CustomFunction);ee.CustomFunction.prototype.encode=function(encoder){return{type:"Function",argumentNames:goog.array.map(this.signature_.args,function(arg){return arg.name;}),body:encoder(this.body_)};};ee.CustomFunction.prototype.getSignature=function(){return this.signature_;};ee.CustomFunction.variable=function(type,name){type=type||Object;if(!(type.prototype instanceof ee.ComputedObject)){if(type&&type!=Object){if(type==String){type=ee.String;}else{if(type==Number){type=ee.Number;}else{if(type==Array){type=goog.global.ee.List;}else{throw Error("Variables must be of an EE type, e.g. ee.Image or ee.Number.");}}}}else{type=ee.ComputedObject;}}var klass=function klass(){};klass.prototype=type.prototype;var obj=new klass();obj.func=null;obj.args=null;obj.varName=name;return obj;};ee.CustomFunction.create=function(func,returnType,arg_types){var stringifyType=function stringifyType(type){return goog.isString(type)?type:ee.Types.classToName(type);},args=goog.array.map(arg_types,function(argType){return{name:null,type:stringifyType(argType)};}),signature={name:"",returns:stringifyType(returnType),args:args};return new ee.CustomFunction(signature,func);};ee.CustomFunction.resolveNamelessArgs_=function(signature,vars,body){for(var namelessArgIndices=[],i=0;i<vars.length;i++){goog.isNull(vars[i].varName)&&namelessArgIndices.push(i);}if(0==namelessArgIndices.length){return signature;}for(var countFunctions=function countFunctions(expression){var count=0;goog.isObject(expression)&&!goog.isFunction(expression)&&("Function"==expression.type&&count++,goog.object.forEach(expression,function(subExpression){count+=countFunctions(subExpression);}));return count;},serializedBody=ee.Serializer.encode(body.apply(null,vars)),baseName="_MAPPING_VAR_"+countFunctions(serializedBody)+"_",i=0;i<namelessArgIndices.length;i++){var index=namelessArgIndices[i],name=baseName+i;vars[index].varName=name;signature.args[index].name=name;}return signature;};ee.Date=function(date,opt_tz){if(!(this instanceof ee.Date)){return ee.ComputedObject.construct(ee.Date,arguments);}if(date instanceof ee.Date){return date;}ee.Date.initialize();var jsArgs=ee.arguments.extract(ee.Date,arguments);date=jsArgs.date;var tz=jsArgs.tz,func=new ee.ApiFunction("Date"),args={},varName=null;if(ee.Types.isString(date)){if(args.value=date,tz){if(ee.Types.isString(tz)){args.timeZone=tz;}else{throw Error("Invalid argument specified for ee.Date(..., opt_tz): "+tz);}}}else{if(ee.Types.isNumber(date)){args.value=date;}else{if(goog.isDateLike(date)){args.value=Math.floor(date.getTime());}else{if(date instanceof ee.ComputedObject){date.func&&"Date"==date.func.getSignature().returns?(func=date.func,args=date.args,varName=date.varName):args.value=date;}else{throw Error("Invalid argument specified for ee.Date(): "+date);}}}}ee.ComputedObject.call(this,func,args,varName);};goog.inherits(ee.Date,ee.ComputedObject);ee.Date.initialized_=!1;ee.Date.initialize=function(){ee.Date.initialized_||(ee.ApiFunction.importApi(ee.Date,"Date","Date"),ee.Date.initialized_=!0);};ee.Date.reset=function(){ee.ApiFunction.clearApi(ee.Date);ee.Date.initialized_=!1;};ee.Date.prototype.name=function(){return"Date";};ee.Geometry=function(geoJson,opt_proj,opt_geodesic,opt_evenOdd){if(!(this instanceof ee.Geometry)){return ee.ComputedObject.construct(ee.Geometry,arguments);}if(!("type"in geoJson)){var args=ee.arguments.extract(ee.Geometry,arguments);geoJson=args.geoJson;opt_proj=args.proj;opt_geodesic=args.geodesic;opt_evenOdd=args.evenOdd;}ee.Geometry.initialize();var options=goog.isDefAndNotNull(opt_proj)||goog.isDefAndNotNull(opt_geodesic)||goog.isDefAndNotNull(opt_evenOdd);if(geoJson instanceof ee.ComputedObject&&!(geoJson instanceof ee.Geometry&&geoJson.type_)){if(options){throw Error("Setting the CRS, geodesic, or evenOdd flag on a computed Geometry is not supported.  Use Geometry.transform().");}ee.ComputedObject.call(this,geoJson.func,geoJson.args,geoJson.varName);}else{geoJson instanceof ee.Geometry&&(geoJson=geoJson.encode());if(!ee.Geometry.isValidGeometry_(geoJson)){throw Error("Invalid GeoJSON geometry: "+JSON.stringify(geoJson));}ee.ComputedObject.call(this,null,null);this.type_=geoJson.type;this.coordinates_=goog.isDefAndNotNull(geoJson.coordinates)?goog.object.unsafeClone(geoJson.coordinates):null;this.geometries_=geoJson.geometries||null;if(goog.isDefAndNotNull(opt_proj)){this.proj_=opt_proj;}else{if("crs"in geoJson){if(goog.isObject(geoJson.crs)&&"name"==geoJson.crs.type&&goog.isObject(geoJson.crs.properties)&&goog.isString(geoJson.crs.properties.name)){this.proj_=geoJson.crs.properties.name;}else{throw Error("Invalid CRS declaration in GeoJSON: "+new goog.json.Serializer().serialize(geoJson.crs));}}}this.geodesic_=opt_geodesic;!goog.isDef(this.geodesic_)&&"geodesic"in geoJson&&(this.geodesic_=!!geoJson.geodesic);this.evenOdd_=opt_evenOdd;!goog.isDef(this.evenOdd_)&&"evenOdd"in geoJson&&(this.evenOdd_=!!geoJson.evenOdd);}};goog.inherits(ee.Geometry,ee.ComputedObject);ee.Geometry.initialized_=!1;ee.Geometry.initialize=function(){ee.Geometry.initialized_||(ee.ApiFunction.importApi(ee.Geometry,"Geometry","Geometry"),ee.Geometry.initialized_=!0);};ee.Geometry.reset=function(){ee.ApiFunction.clearApi(ee.Geometry);ee.Geometry.initialized_=!1;};ee.Geometry.Point=function(coords,opt_proj){if(!(this instanceof ee.Geometry.Point)){return ee.Geometry.createInstance_(ee.Geometry.Point,arguments);}var init=ee.Geometry.construct_(ee.Geometry.Point,"Point",1,arguments);if(!(init instanceof ee.ComputedObject)){var xy=init.coordinates;if(!goog.isArray(xy)||2!=xy.length){throw Error("The Geometry.Point constructor requires 2 coordinates.");}}ee.Geometry.call(this,init);};goog.inherits(ee.Geometry.Point,ee.Geometry);ee.Geometry.MultiPoint=function(coords,opt_proj){if(!(this instanceof ee.Geometry.MultiPoint)){return ee.Geometry.createInstance_(ee.Geometry.MultiPoint,arguments);}ee.Geometry.call(this,ee.Geometry.construct_(ee.Geometry.MultiPoint,"MultiPoint",2,arguments));};goog.inherits(ee.Geometry.MultiPoint,ee.Geometry);ee.Geometry.Rectangle=function(coords,opt_proj,opt_geodesic,opt_evenOdd){if(!(this instanceof ee.Geometry.Rectangle)){return ee.Geometry.createInstance_(ee.Geometry.Rectangle,arguments);}var init=ee.Geometry.construct_(ee.Geometry.Rectangle,"Rectangle",2,arguments);if(!(init instanceof ee.ComputedObject)){var xy=init.coordinates;if(2!=xy.length){throw Error("The Geometry.Rectangle constructor requires 2 points or 4 coordinates.");}var x1=xy[0][0],y1=xy[0][1],x2=xy[1][0],y2=xy[1][1];init.coordinates=[[[x1,y2],[x1,y1],[x2,y1],[x2,y2]]];init.type="Polygon";}ee.Geometry.call(this,init);};goog.inherits(ee.Geometry.Rectangle,ee.Geometry);ee.Geometry.LineString=function(coords,opt_proj,opt_geodesic,opt_maxError){if(!(this instanceof ee.Geometry.LineString)){return ee.Geometry.createInstance_(ee.Geometry.LineString,arguments);}ee.Geometry.call(this,ee.Geometry.construct_(ee.Geometry.LineString,"LineString",2,arguments));};goog.inherits(ee.Geometry.LineString,ee.Geometry);ee.Geometry.LinearRing=function(coords,opt_proj,opt_geodesic,opt_maxError){if(!(this instanceof ee.Geometry.LinearRing)){return ee.Geometry.createInstance_(ee.Geometry.LinearRing,arguments);}ee.Geometry.call(this,ee.Geometry.construct_(ee.Geometry.LinearRing,"LinearRing",2,arguments));};goog.inherits(ee.Geometry.LinearRing,ee.Geometry);ee.Geometry.MultiLineString=function(coords,opt_proj,opt_geodesic,opt_maxError){if(!(this instanceof ee.Geometry.MultiLineString)){return ee.Geometry.createInstance_(ee.Geometry.MultiLineString,arguments);}ee.Geometry.call(this,ee.Geometry.construct_(ee.Geometry.MultiLineString,"MultiLineString",3,arguments));};goog.inherits(ee.Geometry.MultiLineString,ee.Geometry);ee.Geometry.Polygon=function(coords,opt_proj,opt_geodesic,opt_maxError,opt_evenOdd){if(!(this instanceof ee.Geometry.Polygon)){return ee.Geometry.createInstance_(ee.Geometry.Polygon,arguments);}ee.Geometry.call(this,ee.Geometry.construct_(ee.Geometry.Polygon,"Polygon",3,arguments));};goog.inherits(ee.Geometry.Polygon,ee.Geometry);ee.Geometry.MultiPolygon=function(coords,opt_proj,opt_geodesic,opt_maxError,opt_evenOdd){if(!(this instanceof ee.Geometry.MultiPolygon)){return ee.Geometry.createInstance_(ee.Geometry.MultiPolygon,arguments);}ee.Geometry.call(this,ee.Geometry.construct_(ee.Geometry.MultiPolygon,"MultiPolygon",4,arguments));};goog.inherits(ee.Geometry.MultiPolygon,ee.Geometry);ee.Geometry.prototype.encode=function(opt_encoder){if(!this.type_){if(!opt_encoder){throw Error("Must specify an encode function when encoding a computed geometry.");}return ee.ComputedObject.prototype.encode.call(this,opt_encoder);}var result={type:this.type_};"GeometryCollection"==this.type_?result.geometries=this.geometries_:result.coordinates=this.coordinates_;goog.isDefAndNotNull(this.proj_)&&(result.crs={type:"name",properties:{name:this.proj_}});goog.isDefAndNotNull(this.geodesic_)&&(result.geodesic=this.geodesic_);goog.isDefAndNotNull(this.evenOdd_)&&(result.evenOdd=this.evenOdd_);return result;};ee.Geometry.prototype.toGeoJSON=function(){if(this.func){throw Error("Can\'t convert a computed Geometry to GeoJSON. Use getInfo() instead.");}return this.encode();};ee.Geometry.prototype.toGeoJSONString=function(){if(this.func){throw Error("Can\'t convert a computed Geometry to GeoJSON. Use getInfo() instead.");}return new goog.json.Serializer().serialize(this.toGeoJSON());};ee.Geometry.prototype.serialize=function(){return ee.Serializer.toJSON(this);};ee.Geometry.prototype.toString=function(){return"ee.Geometry("+this.toGeoJSONString()+")";};ee.Geometry.isValidGeometry_=function(geometry){var type=geometry.type;if("GeometryCollection"==type){var geometries=geometry.geometries;if(!goog.isArray(geometries)){return!1;}for(var i=0;i<geometries.length;i++){if(!ee.Geometry.isValidGeometry_(geometries[i])){return!1;}}return!0;}var coords=geometry.coordinates,nesting=ee.Geometry.isValidCoordinates_(coords);return"Point"==type&&1==nesting||"MultiPoint"==type&&(2==nesting||0==coords.length)||"LineString"==type&&2==nesting||"LinearRing"==type&&2==nesting||"MultiLineString"==type&&(3==nesting||0==coords.length)||"Polygon"==type&&3==nesting||"MultiPolygon"==type&&(4==nesting||0==coords.length);};ee.Geometry.isValidCoordinates_=function(shape){if(!goog.isArray(shape)){return-1;}if(goog.isArray(shape[0])){for(var count=ee.Geometry.isValidCoordinates_(shape[0]),i=1;i<shape.length;i++){if(ee.Geometry.isValidCoordinates_(shape[i])!=count){return-1;}}return count+1;}for(i=0;i<shape.length;i++){if(!goog.isNumber(shape[i])){return-1;}}return 0==shape.length%2?1:-1;};ee.Geometry.coordinatesToLine_=function(coordinates){if(!goog.isNumber(coordinates[0])||2==coordinates.length){return coordinates;}if(0!=coordinates.length%2){throw Error("Invalid number of coordinates: "+coordinates.length);}for(var line=[],i=0;i<coordinates.length;i+=2){line.push([coordinates[i],coordinates[i+1]]);}return line;};ee.Geometry.construct_=function(jsConstructorFn,apiConstructorName,depth,originalArgs){var eeArgs=ee.Geometry.getEeApiArgs_(jsConstructorFn,originalArgs);if(ee.Geometry.hasServerValue_(eeArgs.coordinates)||goog.isDefAndNotNull(eeArgs.crs)||goog.isDefAndNotNull(eeArgs.maxError)){return new ee.ApiFunction("GeometryConstructors."+apiConstructorName).apply(eeArgs);}eeArgs.type=apiConstructorName;eeArgs.coordinates=ee.Geometry.fixDepth_(depth,eeArgs.coordinates);var isPolygon=goog.array.contains(["Polygon","Rectangle","MultiPolygon"],apiConstructorName);isPolygon&&!goog.isDefAndNotNull(eeArgs.evenOdd)&&(eeArgs.evenOdd=!0);if(isPolygon&&!1===eeArgs.geodesic&&!1===eeArgs.evenOdd){throw Error("Planar interiors must be even/odd.");}return eeArgs;};ee.Geometry.getEeApiArgs_=function(jsConstructorFn,originalArgs){if(goog.array.every(originalArgs,ee.Types.isNumber)){return{coordinates:goog.array.toArray(originalArgs)};}var args=ee.arguments.extract(jsConstructorFn,originalArgs);args.coordinates=args.coords;delete args.coords;args.crs=args.proj;delete args.proj;return goog.object.filter(args,goog.isDefAndNotNull);};ee.Geometry.hasServerValue_=function(coordinates){return goog.isArray(coordinates)?goog.array.some(coordinates,ee.Geometry.hasServerValue_):coordinates instanceof ee.ComputedObject;};ee.Geometry.fixDepth_=function(depth,coords){if(1>depth||4<depth){throw Error("Unexpected nesting level.");}goog.array.every(coords,goog.isNumber)&&(coords=ee.Geometry.coordinatesToLine_(coords));for(var item=coords,count=0;goog.isArray(item);){item=item[0],count++;}for(;count<depth;){coords=[coords],count++;}if(ee.Geometry.isValidCoordinates_(coords)!=depth){throw Error("Invalid geometry");}for(item=coords;goog.isArray(item)&&1==item.length;){item=item[0];}return goog.isArray(item)&&0==item.length?[]:coords;};ee.Geometry.createInstance_=function(klass,args){var f=function f(){};f.prototype=klass.prototype;var instance=new f(),result=klass.apply(instance,args);return void 0!==result?result:instance;};ee.Geometry.prototype.name=function(){return"Geometry";};ee.Deserializer=function(){};goog.exportSymbol("ee.Deserializer",ee.Deserializer);ee.Deserializer.fromJSON=function(json){return ee.Deserializer.decode(goog.json.parse(json));};ee.Deserializer.decode=function(json){var namedValues={};if(goog.isObject(json)&&"CompoundValue"==json.type){for(var scopes=json.scope,i=0;i<scopes.length;i++){var key=scopes[i][0],value=scopes[i][1];if(key in namedValues){throw Error(\'Duplicate scope key "\'+key+\'" in scope #\'+i+".");}namedValues[key]=ee.Deserializer.decodeValue_(value,namedValues);}json=json.value;}return ee.Deserializer.decodeValue_(json,namedValues);};ee.Deserializer.decodeValue_=function(json,namedValues){if(goog.isNull(json)||goog.isNumber(json)||goog.isBoolean(json)||goog.isString(json)){return json;}if(goog.isArray(json)){return goog.array.map(json,function(element){return ee.Deserializer.decodeValue_(element,namedValues);});}if(!goog.isObject(json)||goog.isFunction(json)){throw Error("Cannot decode object: "+json);}var typeName=json.type;switch(typeName){case"ValueRef":if(json.value in namedValues){return namedValues[json.value];}throw Error("Unknown ValueRef: "+json);case"ArgumentRef":var varName=json.value;if(!goog.isString(varName)){throw Error("Invalid variable name: "+varName);}return ee.CustomFunction.variable(Object,varName);case"Date":var microseconds=json.value;if(!goog.isNumber(microseconds)){throw Error("Invalid date value: "+microseconds);}return new ee.Date(microseconds/1000);case"Bytes":var result=new ee.Encodable();result.encode=function(encoder){return json;};return result;case"Invocation":var func="functionName"in json?ee.ApiFunction.lookup(json.functionName):ee.Deserializer.decodeValue_(json["function"],namedValues);var args=goog.object.map(json.arguments,function(element){return ee.Deserializer.decodeValue_(element,namedValues);});if(func instanceof ee.Function){return func.apply(args);}if(func instanceof ee.ComputedObject){return new ee.ComputedObject(func,args);}throw Error("Invalid function value: "+json["function"]);case"Dictionary":return goog.object.map(json.value,function(element){return ee.Deserializer.decodeValue_(element,namedValues);});case"Function":var body=ee.Deserializer.decodeValue_(json.body,namedValues),signature={name:"",args:goog.array.map(json.argumentNames,function(argName){return{name:argName,type:"Object",optional:!1};}),returns:"Object"};return new ee.CustomFunction(signature,function(){return body;});case"Point":case"MultiPoint":case"LineString":case"MultiLineString":case"Polygon":case"MultiPolygon":case"LinearRing":case"GeometryCollection":return new ee.Geometry(json);case"CompoundValue":throw Error("Nested CompoundValues are disallowed.");default:throw Error("Unknown encoded object type: "+typeName);}};ee.Dictionary=function(opt_dict){if(!(this instanceof ee.Dictionary)){return ee.ComputedObject.construct(ee.Dictionary,arguments);}if(opt_dict instanceof ee.Dictionary){return opt_dict;}ee.Dictionary.initialize();ee.Types.isRegularObject(opt_dict)?(ee.ComputedObject.call(this,null,null),this.dict_=opt_dict):(opt_dict instanceof ee.ComputedObject&&opt_dict.func&&"Dictionary"==opt_dict.func.getSignature().returns?ee.ComputedObject.call(this,opt_dict.func,opt_dict.args,opt_dict.varName):ee.ComputedObject.call(this,new ee.ApiFunction("Dictionary"),{input:opt_dict},null),this.dict_=null);};goog.inherits(ee.Dictionary,ee.ComputedObject);ee.Dictionary.initialized_=!1;ee.Dictionary.initialize=function(){ee.Dictionary.initialized_||(ee.ApiFunction.importApi(ee.Dictionary,"Dictionary","Dictionary"),ee.Dictionary.initialized_=!0);};ee.Dictionary.reset=function(){ee.ApiFunction.clearApi(ee.Dictionary);ee.Dictionary.initialized_=!1;};ee.Dictionary.prototype.encode=function(encoder){return goog.isNull(this.dict_)?ee.Dictionary.superClass_.encode.call(this,encoder):encoder(this.dict_);};ee.Dictionary.prototype.name=function(){return"Dictionary";};ee.Feature=function(geometry,opt_properties){if(!(this instanceof ee.Feature)){return ee.ComputedObject.construct(ee.Feature,arguments);}if(geometry instanceof ee.Feature){if(opt_properties){throw Error("Can\'t create Feature out of a Feature and properties.");}return geometry;}if(2<arguments.length){throw Error("The Feature constructor takes at most 2 arguments ("+arguments.length+" given)");}ee.Feature.initialize();if(geometry instanceof ee.Geometry||null===geometry){ee.Element.call(this,new ee.ApiFunction("Feature"),{geometry:geometry,metadata:opt_properties||null});}else{if(geometry instanceof ee.ComputedObject){ee.Element.call(this,geometry.func,geometry.args,geometry.varName);}else{if("Feature"==geometry.type){var properties=geometry.properties||{};if("id"in geometry){if("system:index"in properties){throw Error(\'Can\\\'t specify both "id" and "system:index".\');}properties=goog.object.clone(properties);properties["system:index"]=geometry.id;}ee.Element.call(this,new ee.ApiFunction("Feature"),{geometry:new ee.Geometry(geometry.geometry),metadata:properties});}else{ee.Element.call(this,new ee.ApiFunction("Feature"),{geometry:new ee.Geometry(geometry),metadata:opt_properties||null});}}}};goog.inherits(ee.Feature,ee.Element);ee.Feature.initialized_=!1;ee.Feature.initialize=function(){ee.Feature.initialized_||(ee.ApiFunction.importApi(ee.Feature,"Feature","Feature"),ee.Feature.initialized_=!0);};ee.Feature.reset=function(){ee.ApiFunction.clearApi(ee.Feature);ee.Feature.initialized_=!1;};ee.Feature.prototype.getMap=function(opt_visParams,opt_callback){var args=ee.arguments.extract(ee.Feature.prototype.getMap,arguments);return ee.ApiFunction._call("Collection",[this]).getMap(args.visParams,args.callback);};ee.Feature.prototype.name=function(){return"Feature";};ee.List=function(list){if(this instanceof ee.List){if(1<arguments.length){throw Error("ee.List() only accepts 1 argument.");}if(list instanceof ee.List){return list;}}else{return ee.ComputedObject.construct(ee.List,arguments);}ee.List.initialize();if(goog.isArray(list)){ee.ComputedObject.call(this,null,null),this.list_=list;}else{if(list instanceof ee.ComputedObject){ee.ComputedObject.call(this,list.func,list.args,list.varName),this.list_=null;}else{throw Error("Invalid argument specified for ee.List(): "+list);}}};goog.inherits(ee.List,ee.ComputedObject);ee.List.initialized_=!1;ee.List.initialize=function(){ee.List.initialized_||(ee.ApiFunction.importApi(ee.List,"List","List"),ee.List.initialized_=!0);};ee.List.reset=function(){ee.ApiFunction.clearApi(ee.List);ee.List.initialized_=!1;};ee.List.prototype.encode=function(opt_encoder){return goog.isArray(this.list_)?goog.array.map(this.list_,function(elem){return opt_encoder(elem);}):ee.List.superClass_.encode.call(this,opt_encoder);};ee.List.prototype.name=function(){return"List";};ee.FeatureCollection=function(args,opt_column){if(!(this instanceof ee.FeatureCollection)){return ee.ComputedObject.construct(ee.FeatureCollection,arguments);}if(args instanceof ee.FeatureCollection){return args;}if(2<arguments.length){throw Error("The FeatureCollection constructor takes at most 2 arguments ("+arguments.length+" given)");}ee.FeatureCollection.initialize();args instanceof ee.Geometry&&(args=new ee.Feature(args));args instanceof ee.Feature&&(args=[args]);if(ee.Types.isNumber(args)||ee.Types.isString(args)){var actualArgs={tableId:args};opt_column&&(actualArgs.geometryColumn=opt_column);ee.Collection.call(this,new ee.ApiFunction("Collection.loadTable"),actualArgs);}else{if(goog.isArray(args)){ee.Collection.call(this,new ee.ApiFunction("Collection"),{features:goog.array.map(args,function(elem){return new ee.Feature(elem);})});}else{if(args instanceof ee.List){ee.Collection.call(this,new ee.ApiFunction("Collection"),{features:args});}else{if(args instanceof ee.ComputedObject){ee.Collection.call(this,args.func,args.args,args.varName);}else{throw Error("Unrecognized argument type to convert to a FeatureCollection: "+args);}}}}};goog.inherits(ee.FeatureCollection,ee.Collection);ee.FeatureCollection.initialized_=!1;ee.FeatureCollection.initialize=function(){ee.FeatureCollection.initialized_||(ee.ApiFunction.importApi(ee.FeatureCollection,"FeatureCollection","FeatureCollection"),ee.FeatureCollection.initialized_=!0);};ee.FeatureCollection.reset=function(){ee.ApiFunction.clearApi(ee.FeatureCollection);ee.FeatureCollection.initialized_=!1;};ee.FeatureCollection.prototype.getMap=function(opt_visParams,opt_callback){var args=ee.arguments.extract(ee.FeatureCollection.prototype.getMap,arguments),painted=ee.ApiFunction._apply("Collection.draw",{collection:this,color:(args.visParams||{}).color||"000000"});if(args.callback){painted.getMap(null,args.callback);}else{return painted.getMap();}};ee.FeatureCollection.prototype.getDownloadURL=function(opt_format,opt_selectors,opt_filename,opt_callback){var args=ee.arguments.extract(ee.FeatureCollection.prototype.getDownloadURL,arguments),request={};request.table=this.serialize();args.format&&(request.format=args.format.toUpperCase());args.filename&&(request.filename=args.filename);if(args.selectors){var selectors=args.selectors;goog.isArrayLike(selectors)&&(selectors=selectors.join(","));request.selectors=selectors;}if(args.callback){ee.data.getTableDownloadId(request,function(downloadId,error){downloadId?args.callback(ee.data.makeTableDownloadUrl(downloadId)):args.callback(null,error);});}else{return ee.data.makeTableDownloadUrl(ee.data.getTableDownloadId(request));}};ee.FeatureCollection.prototype.select=function(selectors,opt_names){var varargs=arguments;return this.map(function(feature){return feature.select.apply(feature,varargs);});};ee.FeatureCollection.prototype.name=function(){return"FeatureCollection";};ee.FeatureCollection.prototype.elementType=function(){return ee.Feature;};ee.Image=function(opt_args){if(!(this instanceof ee.Image)){return ee.ComputedObject.construct(ee.Image,arguments);}if(opt_args instanceof ee.Image){return opt_args;}ee.Image.initialize();var argCount=arguments.length;if(0==argCount||1==argCount&&!goog.isDef(opt_args)){ee.Element.call(this,new ee.ApiFunction("Image.mask"),{image:new ee.Image(0),mask:new ee.Image(0)});}else{if(1==argCount){if(ee.Types.isNumber(opt_args)){ee.Element.call(this,new ee.ApiFunction("Image.constant"),{value:opt_args});}else{if(ee.Types.isString(opt_args)){ee.Element.call(this,new ee.ApiFunction("Image.load"),{id:opt_args});}else{if(goog.isArray(opt_args)){return ee.Image.combine_(goog.array.map(opt_args,function(elem){return new ee.Image(elem);}));}if(opt_args instanceof ee.ComputedObject){"Array"==opt_args.name()?ee.Element.call(this,new ee.ApiFunction("Image.constant"),{value:opt_args}):ee.Element.call(this,opt_args.func,opt_args.args,opt_args.varName);}else{throw Error("Unrecognized argument type to convert to an Image: "+opt_args);}}}}else{if(2==argCount){var id=arguments[0],version=arguments[1];if(ee.Types.isString(id)&&ee.Types.isNumber(version)){ee.Element.call(this,new ee.ApiFunction("Image.load"),{id:id,version:version});}else{throw Error("Unrecognized argument types to convert to an Image: "+arguments);}}else{throw Error("The Image constructor takes at most 2 arguments ("+argCount+" given)");}}}};goog.inherits(ee.Image,ee.Element);ee.Image.initialized_=!1;ee.Image.initialize=function(){ee.Image.initialized_||(ee.ApiFunction.importApi(ee.Image,"Image","Image"),ee.ApiFunction.importApi(ee.Image,"Window","Image","focal_"),ee.Image.initialized_=!0);};ee.Image.reset=function(){ee.ApiFunction.clearApi(ee.Image);ee.Image.initialized_=!1;};ee.Image.prototype.getMap=function(opt_visParams,opt_callback){var args=ee.arguments.extract(ee.Image.prototype.getMap,arguments),request=args.visParams?goog.object.clone(args.visParams):{};request.image=this.serialize();if(args.callback){ee.data.getMapId(request,goog.bind(function(data,error){data&&(data.image=this);args.callback(data,error);},this));}else{var response=ee.data.getMapId(request);response.image=this;return response;}};ee.Image.prototype.getDownloadURL=function(params,opt_callback){var args=ee.arguments.extract(ee.Image.prototype.getDownloadURL,arguments),request=args.params?goog.object.clone(args.params):{};request.image=this.serialize();if(args.callback){var callback=args.callback;ee.data.getDownloadId(request,function(downloadId,error){downloadId?callback(ee.data.makeDownloadUrl(downloadId)):callback(null,error);});}else{return ee.data.makeDownloadUrl(ee.data.getDownloadId(request));}};ee.Image.prototype.getThumbURL=function(params,opt_callback){var args=ee.arguments.extract(ee.Image.prototype.getThumbURL,arguments),request=args.params?goog.object.clone(args.params):{};request.image=this.serialize();if(request.region){if(goog.isArray(request.region)||ee.Types.isRegularObject(request.region)){request.region=goog.json.serialize(request.region);}else{if(!goog.isString(request.region)){throw Error("The region parameter must be an array or a GeoJSON object.");}}}if(args.callback){ee.data.getThumbId(request,function(thumbId,opt_error){var thumbUrl="";if(!goog.isDef(opt_error)){try{thumbUrl=ee.data.makeThumbUrl(thumbId);}catch(e){opt_error=String(e.message);}}args.callback(thumbUrl,opt_error);});}else{return ee.data.makeThumbUrl(ee.data.getThumbId(request));}};ee.Image.rgb=function(r,g,b){var args=ee.arguments.extract(ee.Image.rgb,arguments);return ee.Image.combine_([args.r,args.g,args.b],["vis-red","vis-green","vis-blue"]);};ee.Image.cat=function(var_args){var args=Array.prototype.slice.call(arguments);return ee.Image.combine_(args,null);};ee.Image.combine_=function(images,opt_names){if(0==images.length){return ee.ApiFunction._call("Image.constant",[]);}for(var result=new ee.Image(images[0]),i=1;i<images.length;i++){result=ee.ApiFunction._call("Image.addBands",result,images[i]);}opt_names&&(result=result.select([".*"],opt_names));return result;};ee.Image.prototype.select=function(var_args){var args=Array.prototype.slice.call(arguments),algorithmArgs={input:this,bandSelectors:args[0]||[]};if(2<args.length||ee.Types.isString(args[0])||ee.Types.isNumber(args[0])){for(var i=0;i<args.length;i++){if(!(ee.Types.isString(args[i])||ee.Types.isNumber(args[i])||args[i]instanceof ee.ComputedObject)){throw Error("Illegal argument to select(): "+args[i]);}}algorithmArgs.bandSelectors=args;}else{args[1]&&(algorithmArgs.newNames=args[1]);}return ee.ApiFunction._apply("Image.select",algorithmArgs);};ee.Image.prototype.expression=function(expression,opt_map){var originalArgs=ee.arguments.extract(ee.Image.prototype.expression,arguments),vars=["DEFAULT_EXPRESSION_IMAGE"],eeArgs={DEFAULT_EXPRESSION_IMAGE:this};if(originalArgs.map){var map=originalArgs.map,name$jscomp$0;for(name$jscomp$0 in map){vars.push(name$jscomp$0),eeArgs[name$jscomp$0]=new ee.Image(map[name$jscomp$0]);}}var body=ee.ApiFunction._call("Image.parseExpression",originalArgs.expression,"DEFAULT_EXPRESSION_IMAGE",vars),func=new ee.Function();func.encode=function(encoder){return body.encode(encoder);};func.getSignature=function(){return{name:"",args:goog.array.map(vars,function(name){return{name:name,type:"Image",optional:!1};},this),returns:"Image"};};return func.apply(eeArgs);};ee.Image.prototype.clip=function(geometry){try{geometry=new ee.Geometry(geometry);}catch(e){}return ee.ApiFunction._call("Image.clip",this,geometry);};ee.Image.prototype.rename=function(var_args){var names=1!=arguments.length||ee.Types.isString(arguments[0])?goog.array.clone(arguments):arguments[0];return ee.ApiFunction._call("Image.rename",this,names);};ee.Image.prototype.name=function(){return"Image";};ee.ImageCollection=function(args){if(!(this instanceof ee.ImageCollection)){return ee.ComputedObject.construct(ee.ImageCollection,arguments);}if(args instanceof ee.ImageCollection){return args;}if(1!=arguments.length){throw Error("The ImageCollection constructor takes exactly 1 argument ("+arguments.length+" given)");}ee.ImageCollection.initialize();args instanceof ee.Image&&(args=[args]);if(ee.Types.isString(args)){ee.Collection.call(this,new ee.ApiFunction("ImageCollection.load"),{id:args});}else{if(goog.isArray(args)){ee.Collection.call(this,new ee.ApiFunction("ImageCollection.fromImages"),{images:goog.array.map(args,function(elem){return new ee.Image(elem);})});}else{if(args instanceof ee.List){ee.Collection.call(this,new ee.ApiFunction("ImageCollection.fromImages"),{images:args});}else{if(args instanceof ee.ComputedObject){ee.Collection.call(this,args.func,args.args,args.varName);}else{throw Error("Unrecognized argument type to convert to an ImageCollection: "+args);}}}}};goog.inherits(ee.ImageCollection,ee.Collection);ee.ImageCollection.initialized_=!1;ee.ImageCollection.initialize=function(){ee.ImageCollection.initialized_||(ee.ApiFunction.importApi(ee.ImageCollection,"ImageCollection","ImageCollection"),ee.ApiFunction.importApi(ee.ImageCollection,"reduce","ImageCollection"),ee.ImageCollection.initialized_=!0);};ee.ImageCollection.reset=function(){ee.ApiFunction.clearApi(ee.ImageCollection);ee.ImageCollection.initialized_=!1;};ee.ImageCollection.prototype.getMap=function(opt_visParams,opt_callback){var args=ee.arguments.extract(ee.ImageCollection.prototype.getMap,arguments),mosaic=ee.ApiFunction._call("ImageCollection.mosaic",this);if(args.callback){mosaic.getMap(args.visParams,args.callback);}else{return mosaic.getMap(args.visParams);}};ee.ImageCollection.prototype.select=function(selectors,opt_names){var varargs=arguments;return this.map(function(img){return img.select.apply(img,varargs);});};ee.ImageCollection.prototype.name=function(){return"ImageCollection";};ee.ImageCollection.prototype.elementType=function(){return ee.Image;};ee.Terrain={};ee.Terrain.initialized_=!1;ee.Terrain.initialize=function(){ee.Terrain.initialized_||(ee.ApiFunction.importApi(ee.Terrain,"Terrain","Terrain"),ee.Terrain.initialized_=!0);};ee.Terrain.reset=function(){ee.ApiFunction.clearApi(ee.Terrain);ee.Terrain.initialized_=!1;};ee.initialize=function(opt_baseurl,opt_tileurl,opt_successCallback,opt_errorCallback,opt_xsrfToken){if(ee.ready_!=ee.InitState.READY||opt_baseurl||opt_tileurl){var isAsynchronous=goog.isDefAndNotNull(opt_successCallback);if(opt_errorCallback){if(isAsynchronous){ee.errorCallbacks_.push(opt_errorCallback);}else{throw Error("Can\'t pass an error callback without a success callback.");}}if(ee.ready_==ee.InitState.LOADING&&isAsynchronous){ee.successCallbacks_.push(opt_successCallback);}else{if(ee.ready_=ee.InitState.LOADING,ee.data.initialize(opt_baseurl,opt_tileurl,opt_xsrfToken),isAsynchronous){ee.successCallbacks_.push(opt_successCallback),ee.ApiFunction.initialize(ee.initializationSuccess_,ee.initializationFailure_);}else{try{ee.ApiFunction.initialize(),ee.initializationSuccess_();}catch(e){throw ee.initializationFailure_(e),e;}}}}else{opt_successCallback&&opt_successCallback();}};ee.reset=function(){ee.ready_=ee.InitState.NOT_READY;ee.data.reset();ee.ApiFunction.reset();ee.Date.reset();ee.Dictionary.reset();ee.Element.reset();ee.Image.reset();ee.Feature.reset();ee.Collection.reset();ee.ImageCollection.reset();ee.FeatureCollection.reset();ee.Filter.reset();ee.Geometry.reset();ee.List.reset();ee.Number.reset();ee.String.reset();ee.Terrain.reset();ee.resetGeneratedClasses_();goog.object.clear(ee.Algorithms);};ee.InitState={NOT_READY:"not_ready",LOADING:"loading",READY:"ready"};goog.exportSymbol("ee.InitState.NOT_READY",ee.InitState.NOT_READY);goog.exportSymbol("ee.InitState.LOADING",ee.InitState.LOADING);goog.exportSymbol("ee.InitState.READY",ee.InitState.READY);ee.ready_=ee.InitState.NOT_READY;ee.successCallbacks_=[];ee.errorCallbacks_=[];ee.TILE_SIZE=256;ee.generatedClasses_=[];ee.Algorithms={};ee.ready=function(){return ee.ready_;};ee.call=function(func,var_args){goog.isString(func)&&(func=new ee.ApiFunction(func));var args=Array.prototype.slice.call(arguments,1);return ee.Function.prototype.call.apply(func,args);};ee.apply=function(func,namedArgs){goog.isString(func)&&(func=new ee.ApiFunction(func));return func.apply(namedArgs);};ee.initializationSuccess_=function(){if(ee.ready_==ee.InitState.LOADING){try{ee.Date.initialize(),ee.Dictionary.initialize(),ee.Element.initialize(),ee.Image.initialize(),ee.Feature.initialize(),ee.Collection.initialize(),ee.ImageCollection.initialize(),ee.FeatureCollection.initialize(),ee.Filter.initialize(),ee.Geometry.initialize(),ee.List.initialize(),ee.Number.initialize(),ee.String.initialize(),ee.Terrain.initialize(),ee.initializeGeneratedClasses_(),ee.initializeUnboundMethods_();}catch(e){ee.initializationFailure_(e);return;}ee.ready_=ee.InitState.READY;for(ee.errorCallbacks_=[];0<ee.successCallbacks_.length;){ee.successCallbacks_.shift()();}}};ee.initializationFailure_=function(e){if(ee.ready_==ee.InitState.LOADING){for(ee.ready_=ee.InitState.NOT_READY,ee.successCallbacks_=[];0<ee.errorCallbacks_.length;){ee.errorCallbacks_.shift()(e);}}};ee.promote_=function(arg,klass){if(goog.isNull(arg)){return null;}if(goog.isDef(arg)){var exportedEE=goog.global.ee;switch(klass){case"Image":return new ee.Image(arg);case"Feature":return arg instanceof ee.Collection?ee.ApiFunction._call("Feature",ee.ApiFunction._call("Collection.geometry",arg)):new ee.Feature(arg);case"Element":if(arg instanceof ee.Element){return arg;}if(arg instanceof ee.Geometry){return new ee.Feature(arg);}if(arg instanceof ee.ComputedObject){return new ee.Element(arg.func,arg.args,arg.varName);}throw Error("Cannot convert "+arg+" to Element.");case"Geometry":return arg instanceof ee.FeatureCollection?ee.ApiFunction._call("Collection.geometry",arg):new ee.Geometry(arg);case"FeatureCollection":case"Collection":return arg instanceof ee.Collection?arg:new ee.FeatureCollection(arg);case"ImageCollection":return new ee.ImageCollection(arg);case"Filter":return new ee.Filter(arg);case"Algorithm":if(goog.isString(arg)){return new ee.ApiFunction(arg);}if(goog.isFunction(arg)){return ee.CustomFunction.create(arg,"Object",goog.array.repeat("Object",arg.length));}if(arg instanceof ee.Encodable){return arg;}throw Error("Argument is not a function: "+arg);case"String":return ee.Types.isString(arg)||arg instanceof ee.String||arg instanceof ee.ComputedObject?new ee.String(arg):arg;case"Dictionary":return ee.Types.isRegularObject(arg)?arg:new ee.Dictionary(arg);case"List":return new ee.List(arg);case"Number":case"Float":case"Long":case"Integer":case"Short":case"Byte":return new ee.Number(arg);default:if(klass in exportedEE){var ctor=ee.ApiFunction.lookupInternal(klass);if(arg instanceof exportedEE[klass]){return arg;}if(ctor){return new exportedEE[klass](arg);}if(goog.isString(arg)){if(arg in exportedEE[klass]){return exportedEE[klass][arg].call();}throw Error("Unknown algorithm: "+klass+"."+arg);}return new exportedEE[klass](arg);}return arg;}}};ee.initializeUnboundMethods_=function(){var unbound=ee.ApiFunction.unboundFunctions();goog.object.getKeys(unbound).sort().forEach(function(name){var func=unbound[name],signature=func.getSignature();if(!signature.hidden){var nameParts=name.split("."),target=ee.Algorithms;for(target.signature={};1<nameParts.length;){var first=nameParts[0];first in target||(target[first]={signature:{}});target=target[first];nameParts=goog.array.slice(nameParts,1);}var bound=function bound(var_args){return func.callOrApply(void 0,Array.prototype.slice.call(arguments,0));};bound.signature=signature;bound.toString=goog.bind(func.toString,func);target[nameParts[0]]=bound;}});};ee.initializeGeneratedClasses_=function(){var signatures=ee.ApiFunction.allSignatures(),names={},returnTypes={},sig;for(sig in signatures){var type=-1!=sig.indexOf(".")?sig.slice(0,sig.indexOf(".")):sig;names[type]=!0;var rtype=signatures[sig].returns.replace(/<.*>/,"");returnTypes[rtype]=!0;}var exportedEE=goog.global.ee,name;for(name in names){name in returnTypes&&!(name in exportedEE)&&(exportedEE[name]=ee.makeClass_(name),ee.generatedClasses_.push(name),signatures[name]?(exportedEE[name].signature=signatures[name],exportedEE[name].signature.isConstructor=!0,ee.ApiFunction.boundSignatures_[name]=!0):exportedEE[name].signature={});}ee.Types.registerClasses(exportedEE);};ee.resetGeneratedClasses_=function(){for(var exportedEE=goog.global.ee,i=0;i<ee.generatedClasses_.length;i++){var name=ee.generatedClasses_[i];ee.ApiFunction.clearApi(exportedEE[name]);delete exportedEE[name];}ee.generatedClasses_=[];ee.Types.registerClasses(exportedEE);};ee.makeClass_=function(name){var target=function target(var_args){var klass=goog.global.ee[name],args=Array.prototype.slice.call(arguments),onlyOneArg=1==args.length;if(onlyOneArg&&args[0]instanceof klass){return args[0];}if(!(this instanceof klass)){return ee.ComputedObject.construct(klass,args);}var ctor=ee.ApiFunction.lookupInternal(name),firstArgIsPrimitive=!(args[0]instanceof ee.ComputedObject),shouldUseConstructor=!1;ctor&&(onlyOneArg?firstArgIsPrimitive?shouldUseConstructor=!0:args[0].func!=ctor&&(shouldUseConstructor=!0):shouldUseConstructor=!0);if(shouldUseConstructor){ee.ComputedObject.call(this,ctor,ctor.promoteArgs(ctor.nameArgs(args)));}else{if(!onlyOneArg){throw Error("Too many arguments for ee."+name+"(): "+args);}if(firstArgIsPrimitive){throw Error("Invalid argument for ee."+name+"(): "+args+". Must be a ComputedObject.");}var theOneArg=args[0];ee.ComputedObject.call(this,theOneArg.func,theOneArg.args,theOneArg.varName);}};goog.inherits(target,ee.ComputedObject);target.prototype.name=function(){return name;};ee.ApiFunction.importApi(target,name,name);return target;};ee.Function.registerPromoter(ee.promote_);ee.FloatTileOverlay=function(url,mapId,token){ee.AbstractOverlay.call(this,url,mapId,token);this.tileSize=new google.maps.Size(ee.FloatTileOverlay.TILE_EDGE_LENGTH,ee.FloatTileOverlay.TILE_EDGE_LENGTH);this.floatTiles_=new goog.structs.Map();this.floatTileDivs_=new goog.structs.Map();};goog.inherits(ee.FloatTileOverlay,ee.AbstractOverlay);ee.FloatTileOverlay.prototype.getTile=function(coord,zoom,ownerDocument){var tileId=this.getTileId(coord,zoom),src=[this.url,tileId].join("/")+"?token="+this.token,uniqueTileId=[tileId,this.tileCounter,this.token].join("/");this.tilesLoading.push(uniqueTileId);this.tileCounter+=1;var div=goog.dom.createDom("DIV"),floatTile=this.loadFloatTile_(src,coord,uniqueTileId,div);this.dispatchTileEvent_();return div;};ee.FloatTileOverlay.TILE_EDGE_LENGTH=256;ee.FloatTileOverlay.prototype.loadFloatTile_=function(tileUrl,coord,tileId,div){var tileRequest=goog.net.XmlHttp();tileRequest.open("GET",tileUrl,!0);tileRequest.responseType="arraybuffer";tileRequest.onreadystatechange=goog.bind(function(){if(tileRequest.readyState===XMLHttpRequest.DONE&&200===tileRequest.status){var tileResponse=tileRequest.response;if(tileResponse){var floatBuffer=new Float32Array(tileResponse);this.handleFloatTileLoaded_(floatBuffer,coord,tileId,div);}else{throw this.tilesFailed.add(tileId),Error("Unable to request floating point array buffers.");}}},this);tileRequest.send();};ee.FloatTileOverlay.prototype.handleFloatTileLoaded_=function(floatTile,coord,tileId,div){this.floatTiles_.set(coord,floatTile);this.floatTileDivs_.set(coord,div);goog.array.remove(this.tilesLoading,tileId);this.dispatchTileEvent_();};ee.FloatTileOverlay.prototype.getAllFloatTiles=function(){return this.floatTiles_;};ee.FloatTileOverlay.prototype.getAllFloatTileDivs=function(){return this.floatTileDivs_;};ee.FloatTileOverlay.prototype.getLoadedFloatTilesCount=function(){return this.floatTiles_.getCount();};ee.FloatTileOverlay.prototype.dispatchTileEvent_=function(){this.dispatchEvent(new ee.TileEvent(this.tilesLoading.length));};ee.FloatTileOverlay.prototype.disposeInternal=function(){this.floatTileDivs_=this.floatTiles_=null;ee.FloatTileOverlay.superClass_.disposeInternal.call(this);};ee.MapTileManager=function(){goog.events.EventTarget.call(this);this.tokenPool_=new ee.MapTileManager.TokenPool_(0,60);this.requests_=new goog.structs.Map();};goog.inherits(ee.MapTileManager,goog.events.EventTarget);goog.addSingletonGetter(ee.MapTileManager);ee.MapTileManager.MAX_RETRIES=1;ee.MapTileManager.ERROR_ID_IN_USE_="[ee.MapTileManager] ID in use";ee.MapTileManager.prototype.getOutstandingCount=function(){return this.requests_.getCount();};ee.MapTileManager.prototype.send=function(id,url,opt_priority,opt_imageCompletedCallback,opt_maxRetries){if(this.requests_.get(id)){throw Error(ee.MapTileManager.ERROR_ID_IN_USE_);}var request=new ee.MapTileManager.Request_(id,url,opt_imageCompletedCallback,goog.bind(this.releaseRequest_,this),goog.isDef(opt_maxRetries)?opt_maxRetries:ee.MapTileManager.MAX_RETRIES);this.requests_.set(id,request);var callback=goog.bind(this.handleAvailableToken_,this,request);this.tokenPool_.getObject(callback,opt_priority);return request;};ee.MapTileManager.prototype.abort=function(id){var request=this.requests_.get(id);request&&(request.setAborted(!0),this.releaseRequest_(request));};ee.MapTileManager.prototype.handleAvailableToken_=function(request,token){if(request.getImageLoader()||request.getAborted()){this.releaseObject_(token);}else{if(request.setToken(token),token.setActive(!0),request.setImageLoader(new goog.net.ImageLoader()),!request.retry()){throw Error("Cannot dispatch first request!");}}};ee.MapTileManager.prototype.releaseRequest_=function(request){this.requests_.remove(request.getId());request.getImageLoader()&&(this.releaseObject_(request.getToken()),request.getImageLoader().dispose());request.fireImageEventCallback();};ee.MapTileManager.prototype.releaseObject_=function(token){token.setActive(!1);if(!this.tokenPool_.releaseObject(token)){throw Error("Object not released");}};ee.MapTileManager.prototype.disposeInternal=function(){ee.MapTileManager.superClass_.disposeInternal.call(this);this.tokenPool_.dispose();this.tokenPool_=null;var requests=this.requests_;goog.array.forEach(requests.getValues(),function(value){value.dispose();});requests.clear();this.requests_=null;};ee.MapTileManager.Request_=function(id,url,opt_imageEventCallback,opt_requestCompleteCallback,opt_maxRetries){goog.Disposable.call(this);this.id_=id;this.url_=url;this.maxRetries_=goog.isDef(opt_maxRetries)?opt_maxRetries:ee.MapTileManager.MAX_RETRIES;this.imageEventCallback_=opt_imageEventCallback;this.requestCompleteCallback_=opt_requestCompleteCallback;};goog.inherits(ee.MapTileManager.Request_,goog.Disposable);ee.MapTileManager.Request_.prototype.attemptCount_=0;ee.MapTileManager.Request_.prototype.aborted_=!1;ee.MapTileManager.Request_.prototype.imageLoader_=null;ee.MapTileManager.Request_.prototype.token_=null;ee.MapTileManager.Request_.prototype.event_=null;ee.MapTileManager.Request_.prototype.profileId_=null;ee.MapTileManager.Request_.IMAGE_LOADER_EVENT_TYPES_=[goog.events.EventType.LOAD,goog.net.EventType.ABORT,goog.net.EventType.ERROR];ee.MapTileManager.Request_.prototype.getImageLoader=function(){return this.imageLoader_;};ee.MapTileManager.Request_.prototype.setImageLoader=function(imageLoader){this.imageLoader_=imageLoader;};ee.MapTileManager.Request_.prototype.getToken=function(){return this.token_;};ee.MapTileManager.Request_.prototype.setToken=function(token){this.token_=token;};ee.MapTileManager.Request_.prototype.addImageEventListener=function(){goog.events.listenOnce(this.imageLoader_,ee.MapTileManager.Request_.IMAGE_LOADER_EVENT_TYPES_,goog.bind(this.handleImageEvent_,this));};ee.MapTileManager.Request_.prototype.fireImageEventCallback=function(){this.imageEventCallback_&&this.imageEventCallback_(this.event_,this.profileId_);};ee.MapTileManager.Request_.prototype.getId=function(){return this.id_;};ee.MapTileManager.Request_.prototype.getUrl=function(){return this.url_;};ee.MapTileManager.Request_.prototype.getMaxRetries=function(){return this.maxRetries_;};ee.MapTileManager.Request_.prototype.getAttemptCount=function(){return this.attemptCount_;};ee.MapTileManager.Request_.prototype.increaseAttemptCount=function(){this.attemptCount_++;};ee.MapTileManager.Request_.prototype.hasReachedMaxRetries=function(){return this.attemptCount_>this.maxRetries_;};ee.MapTileManager.Request_.prototype.setAborted=function(aborted){aborted&&!this.aborted_&&(this.aborted_=aborted,this.event_=new goog.events.Event(goog.net.EventType.ABORT));};ee.MapTileManager.Request_.prototype.getAborted=function(){return this.aborted_;};ee.MapTileManager.Request_.prototype.handleImageEvent_=function(e){if(this.getAborted()){this.markCompleted_();}else{switch(e.type){case goog.events.EventType.LOAD:this.handleSuccess_(e);this.markCompleted_();break;case goog.net.EventType.ERROR:case goog.net.EventType.ABORT:this.handleError_(e);}}};ee.MapTileManager.Request_.prototype.markCompleted_=function(){this.requestCompleteCallback_&&this.requestCompleteCallback_(this);};ee.MapTileManager.Request_.prototype.handleSuccess_=function(e){this.event_=e;};ee.MapTileManager.Request_.prototype.handleError_=function(e){this.retry()||(this.event_=e,this.markCompleted_());};ee.MapTileManager.Request_.prototype.disposeInternal=function(){ee.MapTileManager.Request_.superClass_.disposeInternal.call(this);delete this.imageEventCallback_;delete this.requestCompleteCallback_;};ee.MapTileManager.Request_.prototype.retry=function(){if(this.hasReachedMaxRetries()){return!1;}this.increaseAttemptCount();this.imageLoader_.removeImage(this.id_);setTimeout(goog.bind(this.start_,this),0);return!0;};ee.MapTileManager.Request_.prototype.start_=function(){if(!this.getAborted()){var actuallyLoadImage=goog.bind(function(imageUrl){this.getAborted()||(this.imageLoader_.addImage(this.id_,imageUrl),this.addImageEventListener(),this.imageLoader_.start());},this),sourceUrl=this.getUrl();if(goog.Uri.parse(sourceUrl).getQueryData().containsKey("profiling")){var xhrIo=new goog.net.XhrIo();xhrIo.setResponseType(goog.net.XhrIo.ResponseType.BLOB);xhrIo.listen(goog.net.EventType.COMPLETE,goog.bind(function(event){this.profileId_=xhrIo.getResponseHeader(ee.data.PROFILE_HEADER)||null;if(200<=xhrIo.getStatus()&&300>xhrIo.getStatus()){try{var objectUrl=URL.createObjectURL(xhrIo.getResponse());}catch(e){}}actuallyLoadImage(objectUrl||sourceUrl);},this));xhrIo.listenOnce(goog.net.EventType.READY,goog.bind(xhrIo.dispose,xhrIo));xhrIo.send(sourceUrl,"GET");}else{actuallyLoadImage(sourceUrl);}}};ee.MapTileManager.Token_=function(){this.active_=!1;};goog.inherits(ee.MapTileManager.Token_,goog.Disposable);ee.MapTileManager.Token_.prototype.setActive=function(val){this.active_=val;};ee.MapTileManager.Token_.prototype.isActive=function(){return this.active_;};ee.MapTileManager.TokenPool_=function(opt_minCount,opt_maxCount){goog.structs.PriorityPool.call(this,opt_minCount,opt_maxCount);};goog.inherits(ee.MapTileManager.TokenPool_,goog.structs.PriorityPool);ee.MapTileManager.TokenPool_.prototype.createObject=function(){return new ee.MapTileManager.Token_();};ee.MapTileManager.TokenPool_.prototype.disposeObject=function(obj){obj.dispose();};ee.MapTileManager.TokenPool_.prototype.objectCanBeReused=function(obj){return!obj.isDisposed()&&!obj.isActive();};ee.MapLayerOverlay=function(url,mapId,token,init,opt_profiler){ee.AbstractOverlay.call(this,url,mapId,token,init,opt_profiler);this.minZoom=init.minZoom||0;this.maxZoom=init.maxZoom||20;if(!window.google||!window.google.maps){throw Error("Google Maps API hasn\'t been initialized.");}this.tileSize=init.tileSize||new google.maps.Size(256,256);this.isPng=goog.isDef(init.isPng)?init.isPng:!0;this.name=init.name;this.tiles_=new goog.structs.Set();this.opacity_=1.0;this.visible_=!0;this.profiler_=opt_profiler||null;};goog.inherits(ee.MapLayerOverlay,ee.AbstractOverlay);ee.MapLayerOverlay.prototype.addTileCallback=function(callback){return goog.events.listen(this,ee.AbstractOverlay.EventType.TILE_LOADED,callback);};ee.MapLayerOverlay.prototype.removeTileCallback=function(callbackId){goog.events.unlistenByKey(callbackId);};ee.MapLayerOverlay.prototype.dispatchTileEvent_=function(){this.dispatchEvent(new ee.TileEvent(this.tilesLoading.length));};ee.MapLayerOverlay.prototype.getTile=function(coord,zoom,ownerDocument){var maxCoord;if(zoom<this.minZoom||0>coord.y||coord.y>=1<<zoom){var img=ownerDocument.createElement("IMG");img.style.width="0px";img.style.height="0px";return img;}var profiling=this.profiler_&&this.profiler_.isEnabled(),tileId=this.getTileId(coord,zoom),src=[this.url,tileId].join("/")+"?token="+this.token;profiling&&(src+="&profiling=1");var uniqueTileId=[tileId,this.tileCounter,this.token].join("/");this.tileCounter+=1;var div=goog.dom.createDom("DIV",{id:uniqueTileId}),priority=new Date().getTime()/1000;this.tilesLoading.push(uniqueTileId);ee.MapTileManager.getInstance().send(uniqueTileId,src,priority,goog.bind(this.handleImageCompleted_,this,div,uniqueTileId));this.dispatchTileEvent_();return div;};ee.MapLayerOverlay.prototype.getLoadedTilesCount=function(){return this.tiles_.getCount();};ee.MapLayerOverlay.prototype.getLoadingTilesCount=function(){return this.tilesLoading.length;};ee.MapLayerOverlay.prototype.releaseTile=function(tileDiv){ee.MapTileManager.getInstance().abort(tileDiv.id);var tileImg=goog.dom.getFirstElementChild(tileDiv);this.tiles_.remove(tileImg);""!==tileDiv.id&&(this.tilesFailed.remove(tileDiv.id),this.profiler_&&this.profiler_.removeTile(tileDiv.id));};ee.MapLayerOverlay.prototype.setOpacity=function(opacity){this.opacity_=opacity;var iter=this.tiles_.__iterator__();goog.iter.forEach(iter,function(tile){goog.style.setOpacity(tile,opacity);});};goog.exportProperty(ee.MapLayerOverlay.prototype,"getTile",ee.MapLayerOverlay.prototype.getTile);goog.exportProperty(ee.MapLayerOverlay.prototype,"setOpacity",ee.MapLayerOverlay.prototype.setOpacity);goog.exportProperty(ee.MapLayerOverlay.prototype,"releaseTile",ee.MapLayerOverlay.prototype.releaseTile);ee.MapLayerOverlay.prototype.handleImageCompleted_=function(div,tileId,e,profileId){if(e.type==goog.net.EventType.ERROR){goog.array.remove(this.tilesLoading,tileId),this.tilesFailed.add(tileId),this.dispatchEvent(e);}else{goog.array.remove(this.tilesLoading,tileId);if(e.target&&e.type==goog.events.EventType.LOAD){var tile=e.target;this.tiles_.add(tile);1.0!=this.opacity_&&goog.style.setOpacity(tile,this.opacity_);div.appendChild(tile);}this.dispatchTileEvent_();}this.profiler_&&!goog.isNull(profileId)&&this.profiler_.addTile(tileId,profileId);};ee.SavedFunction=function(path,signature){if(!(this instanceof ee.SavedFunction)){return new ee.SavedFunction(path,signature);}this.path_=path;this.signature_=signature;};goog.inherits(ee.SavedFunction,ee.Function);goog.exportSymbol("ee.SavedFunction",ee.SavedFunction);ee.SavedFunction.prototype.encode=function(encoder){return ee.ApiFunction._call("LoadAlgorithmById",this.path_).encode(encoder);};ee.SavedFunction.prototype.getSignature=function(){return this.signature_;};ee.Package=function(opt_path){if(opt_path&&ee.Package.importedPackages_[opt_path]){return ee.Package.importedPackages_[opt_path];}if(!(this instanceof ee.Package)){return new ee.Package(opt_path);}if(opt_path){for(var contents=ee.Package.getFolder(opt_path),i=0;i<contents.length;i++){var parts=contents[i].id.split("/"),name=parts[parts.length-1];this[name]=ee.Package.makeInvocation_(opt_path,name,contents[i]);}ee.Package.importedPackages_[opt_path]=this;}};ee.Package.importedPackages_={};ee.Package.makeFunction=function(signature,body){"string"==typeof signature&&(signature=ee.Package.decodeDecl(signature));var func=function func(){throw Error("Package not saved.");};func.body=body;func.signature=signature;return func;};ee.Package.save=function(pkg,path){var args=ee.arguments.extract(ee.Package.save,arguments);pkg=args.pkg;path=args.path;if(!path){throw Error("No path specified.");}var original={};for(name in pkg){if(pkg.hasOwnProperty(name)){var member=pkg[name];if(member instanceof Function){if(member.isSaved){var expected=path+"/"+name;if(member.path!=expected){throw Error("Function name mismatch.  Expected path: "+expected+" but found: "+member.path);}}else{if("signature"in member){original[name]=member,pkg[name]=ee.Package.makeInvocation_(path,name,member.signature);}else{throw Error("No signature for function: "+name);}}}else{throw Error("Can\'t save constants: "+name);}}}var custom=[];for(name in original){var body=original[name].body,signature=original[name].signature,func=new ee.CustomFunction(signature,body);custom.push({name:name,algorithm:ee.ApiFunction._call("SavedAlgorithm",func,signature,{text:body.toString()})});}if(custom.length){try{ee.data.createFolder(path);}catch(e){if(!e.message.match(/exists/)){throw e;}}for(var index=0;index<custom.length;index++){var name=custom[index].name;var algorithm=custom[index].algorithm.serialize();ee.data.createAsset(algorithm,path+"/"+name);}}};ee.Package.getFolder=function(path){return ee.ApiFunction.lookup("LoadFolder").call(path).getInfo();};ee.Package.decodeDecl=function(decl){var parts=decl.match(/\\w+|\\S/g),cur=0,expect=function expect(regex){var match=parts[cur]&&parts[cur].match(regex);if(match){return cur++,match[0];}throw Error("Unable to decode declaration.");},type=expect(/\\w+/);expect(/\\w+/);expect(/\\(/);for(var collected=[];parts[cur]&&!parts[cur].match("\\\\)");){collected.length&&expect(","),collected.push({type:expect(/\\w+/),name:expect(/\\w+/)});}expect(/\\)/);";"==parts[cur]&&expect(";");if(parts[cur]){throw Error("Unable to decode declaration.  Found extra trailing input.");}return{returns:type,args:collected};};ee.Package.encodeDecl_=function(signature,name){var out=[signature.returns," ",name,"("];if(signature.args){for(var i=0;i<signature.args.length;i++){0<i&&out.push(", "),out.push(signature.args[i].type+" "+signature.args[i].name);}}out.push(")");return out.join("");};ee.Package.makeInvocation_=function(path,name,signature){var savedFunction=new ee.SavedFunction(path+"/"+name,signature),fn=function fn(var_args){var args=Array.prototype.slice.call(arguments);return savedFunction.call.apply(savedFunction,args);};fn.toString=function(){return signature.returns+" "+savedFunction.toString(name);};fn.isSaved=!0;return fn;};goog.async.Delay=function(listener,opt_interval,opt_handler){goog.Disposable.call(this);this.listener_=listener;this.interval_=opt_interval||0;this.handler_=opt_handler;this.callback_=goog.bind(this.doAction_,this);};goog.inherits(goog.async.Delay,goog.Disposable);goog.Delay=goog.async.Delay;goog.async.Delay.prototype.id_=0;goog.async.Delay.prototype.disposeInternal=function(){goog.async.Delay.superClass_.disposeInternal.call(this);this.stop();delete this.listener_;delete this.handler_;};goog.async.Delay.prototype.start=function(opt_interval){this.stop();this.id_=goog.Timer.callOnce(this.callback_,goog.isDef(opt_interval)?opt_interval:this.interval_);};goog.async.Delay.prototype.startIfNotActive=function(opt_interval){this.isActive()||this.start(opt_interval);};goog.async.Delay.prototype.stop=function(){this.isActive()&&goog.Timer.clear(this.id_);this.id_=0;};goog.async.Delay.prototype.fire=function(){this.stop();this.doAction_();};goog.async.Delay.prototype.fireIfActive=function(){this.isActive()&&this.fire();};goog.async.Delay.prototype.isActive=function(){return 0!=this.id_;};goog.async.Delay.prototype.doAction_=function(){this.id_=0;this.listener_&&this.listener_.call(this.handler_);};ee.data.Profiler=function(format){goog.events.EventTarget.call(this);this.format_=format;this.isEnabled_=!1;this.lastRefreshToken_=null;this.profileIds_=Object.create(null);this.tileProfileIds_=Object.create(null);this.showInternal_=!1;this.throttledRefresh_=new goog.async.Delay(goog.bind(this.refresh_,this),ee.data.Profiler.DELAY_BEFORE_REFRESH_);this.profileData_=ee.data.Profiler.getEmptyProfile_(format);};goog.inherits(ee.data.Profiler,goog.events.EventTarget);ee.data.Profiler.DELAY_BEFORE_REFRESH_=500;ee.data.Profiler.prototype.isEnabled=function(){return this.isEnabled_;};ee.data.Profiler.prototype.setEnabled=function(value){this.isEnabled_=!!value;this.dispatchEvent(new goog.events.Event(ee.data.Profiler.EventType.STATE_CHANGED));};ee.data.Profiler.prototype.isLoading=function(){return null!==this.lastRefreshToken_;};ee.data.Profiler.prototype.isError=function(){return goog.isDefAndNotNull(this.profileError_);};ee.data.Profiler.prototype.getStatusText=function(){if(this.profileError_){return this.profileError_;}if(this.lastRefreshToken_){return"Loading...";}var profiles=0,nonTileProfiles=0,tileProfiles=0;goog.object.forEach(this.profileIds_,function(refCount){profiles++;Infinity===refCount?nonTileProfiles++:tileProfiles++;},this);return"Viewing "+profiles+" profiles, "+nonTileProfiles+" from API calls and "+tileProfiles+" from map tiles.";};ee.data.Profiler.prototype.getProfileData=function(){return this.profileData_;};ee.data.Profiler.prototype.clearAndDrop=function(){this.profileIds_=Object.create(null);this.tileProfileIds_=Object.create(null);this.refresh_();};ee.data.Profiler.prototype.getProfileHook=function(){var profileIds=this.profileIds_;return this.isEnabled_?goog.bind(function(profileId){profileIds[profileId]=Infinity;this.throttledRefresh_.start();},this):null;};ee.data.Profiler.prototype.removeProfile_=function(profileId){var count=this.profileIds_[profileId];1<count?this.profileIds_[profileId]--:void 0!==count&&(delete this.profileIds_[profileId],this.throttledRefresh_.start());};ee.data.Profiler.prototype.refresh_=function(){var marker={};this.lastRefreshToken_=marker;var handleResponse=goog.bind(function(result,error){marker==this.lastRefreshToken_&&(this.profileData_=(this.profileError_=error)?ee.data.Profiler.getEmptyProfile_(this.format_):result,this.lastRefreshToken_=null,this.dispatchEvent(ee.data.Profiler.EventType.STATE_CHANGED),this.dispatchEvent(ee.data.Profiler.EventType.DATA_CHANGED));},this),ids=goog.object.getKeys(this.profileIds_);0===ids.length?handleResponse(ee.data.Profiler.getEmptyProfile_(this.format_),void 0):(ee.ApiFunction._apply(this.showInternal_?"Profile.getProfilesInternal":"Profile.getProfiles",{ids:ids,format:this.format_}).getInfo(handleResponse),this.dispatchEvent(ee.data.Profiler.EventType.STATE_CHANGED));};ee.data.Profiler.prototype.addTile=function(tileId,profileId){this.tileProfileIds_[tileId]||(this.tileProfileIds_[tileId]=profileId,this.profileIds_[profileId]=(this.profileIds_[profileId]||0)+1,this.throttledRefresh_.start());};ee.data.Profiler.prototype.removeTile=function(tileId){var profileId=this.tileProfileIds_[tileId];profileId&&(delete this.tileProfileIds_[tileId],this.removeProfile_(profileId));};ee.data.Profiler.prototype.getShowInternal=function(){return this.showInternal_;};ee.data.Profiler.prototype.setShowInternal=function(value){this.showInternal_=!!value;this.throttledRefresh_.fire();};ee.data.Profiler.prototype.setParentEventTarget=function(parent){throw Error("not applicable");};ee.data.Profiler.getEmptyProfile_=function(format){switch(format){case ee.data.Profiler.Format.TEXT:return"";case ee.data.Profiler.Format.JSON:return ee.data.Profiler.EMPTY_JSON_PROFILE_;default:throw Error("Invalid Profiler data format: "+format);}};ee.data.Profiler.EMPTY_JSON_PROFILE_={cols:[],rows:[]};ee.data.Profiler.EventType={STATE_CHANGED:"statechanged",DATA_CHANGED:"datachanged"};ee.data.Profiler.Format={TEXT:"text",JSON:"json"};window.ee=ee;'}]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 528 */,
/* 529 */,
/* 530 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 531 */,
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _d = __webpack_require__(19);

var _api = __webpack_require__(59);

var _eventLoader = __webpack_require__(224);

var _analytics = __webpack_require__(32);

var _layers = __webpack_require__(68);

var _Layer2 = __webpack_require__(45);

var _Layer3 = _interopRequireDefault(_Layer2);

var _helpers = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventLayer = function (_Layer) {
    _inherits(EventLayer, _Layer);

    function EventLayer() {
        _classCallCheck(this, EventLayer);

        return _possibleConstructorReturn(this, (EventLayer.__proto__ || Object.getPrototypeOf(EventLayer)).apply(this, arguments));
    }

    _createClass(EventLayer, [{
        key: 'createLayer',
        value: function createLayer(callback) {
            var _this2 = this;

            var _props = this.props,
                bounds = _props.bounds,
                columns = _props.columns,
                data = _props.data,
                endDate = _props.endDate,
                eventClustering = _props.eventClustering,
                eventCoordinateField = _props.eventCoordinateField,
                eventPointColor = _props.eventPointColor,
                eventPointRadius = _props.eventPointRadius,
                filters = _props.filters,
                id = _props.id,
                program = _props.program,
                programStage = _props.programStage,
                rows = _props.rows,
                serverCluster = _props.serverCluster,
                startDate = _props.startDate,
                styleDataItem = _props.styleDataItem;

            // Some older favorites don't have a valid color code

            var color = eventPointColor && eventPointColor.charAt(0) !== '#' ? '#' + eventPointColor : eventPointColor;

            var orgUnits = (0, _analytics.getOrgUnitsFromRows)(rows);
            var period = (0, _analytics.getPeriodFromFilters)(filters);
            var dataItems = (0, _eventLoader.addStyleDataItem)(columns, styleDataItem);
            var map = this.context.map;
            var d2 = void 0;
            var eventRequest = void 0;

            // Data elements to display in event popup
            this.displayElements = {};

            // Default props = no cluster
            var config = {
                type: 'dots',
                pane: id,
                data: data,
                color: color || _layers.EVENT_COLOR,
                radius: eventPointRadius || _layers.EVENT_RADIUS,
                popup: this.onEventClick.bind(this)
            };

            if (eventClustering) {
                if (serverCluster) {
                    config.type = 'serverCluster';
                    config.bounds = bounds;

                    config.load = function () {
                        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params, callback) {
                            var clusterData;
                            return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                    switch (_context.prev = _context.next) {
                                        case 0:
                                            _context.t0 = d2;

                                            if (_context.t0) {
                                                _context.next = 5;
                                                break;
                                            }

                                            _context.next = 4;
                                            return (0, _d.getInstance)();

                                        case 4:
                                            _context.t0 = _context.sent;

                                        case 5:
                                            d2 = _context.t0;
                                            _context.t1 = eventRequest;

                                            if (_context.t1) {
                                                _context.next = 11;
                                                break;
                                            }

                                            _context.next = 10;
                                            return (0, _eventLoader.getAnalyticsRequest)(program, programStage, period, startDate, endDate, orgUnits, dataItems, eventCoordinateField);

                                        case 10:
                                            _context.t1 = _context.sent;

                                        case 11:
                                            eventRequest = _context.t1;


                                            eventRequest = eventRequest.withBbox(params.bbox).withClusterSize(params.clusterSize).withIncludeClusterPoints(params.includeClusterPoints);

                                            _context.next = 15;
                                            return d2.analytics.events.getCluster(eventRequest);

                                        case 15:
                                            clusterData = _context.sent;


                                            callback(params.tileId, _this2.toGeoJson(clusterData));

                                        case 17:
                                        case 'end':
                                            return _context.stop();
                                    }
                                }
                            }, _callee, _this2);
                        }));

                        return function (_x, _x2) {
                            return _ref.apply(this, arguments);
                        };
                    }();
                } else {
                    config.type = 'clientCluster';
                    config.clusterPane = id;
                }
            }

            // Create and add event layer based on config object
            this.layer = map.createLayer(config).addTo(map);

            var layerBounds = this.layer.getBounds();

            if (layerBounds.isValid()) {
                map.fitBounds(layerBounds);
            }

            if (program && programStage) {
                this.loadDataElements();
            }
        }

        // Load data elements that should be displayed in popups

    }, {
        key: 'loadDataElements',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _this3 = this;

                var props, d2, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                props = this.props;
                                _context2.next = 3;
                                return (0, _d.getInstance)();

                            case 3:
                                d2 = _context2.sent;
                                _context2.next = 6;
                                return d2.models.programStage.get(props.programStage.id, {
                                    fields: 'programStageDataElements[displayInReports,dataElement[id,' + (0, _helpers.getDisplayPropertyUrl)(d2) + ',optionSet]]',
                                    paging: false
                                });

                            case 6:
                                data = _context2.sent;


                                if (data.programStageDataElements) {
                                    data.programStageDataElements.forEach(function (el) {
                                        var dataElement = el.dataElement;

                                        if (el.displayInReports) {
                                            _this3.displayElements[dataElement.id] = dataElement;

                                            if (dataElement.optionSet && dataElement.optionSet.id) {
                                                d2.models.optionSets.get(dataElement.optionSet.id, {
                                                    fields: 'id,displayName~rename(name),options[code,displayName~rename(name)]',
                                                    paging: false
                                                }).then(function (optionSet) {
                                                    optionSet.options.forEach(function (option) {
                                                        return dataElement.optionSet[option.code] = option.name;
                                                    });
                                                });
                                            }
                                        } else if (props.eventCoordinateField && dataElement.id === props.eventCoordinateField) {
                                            _this3.eventCoordinateFieldName = dataElement.name;
                                        }
                                    });
                                }

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function loadDataElements() {
                return _ref2.apply(this, arguments);
            }

            return loadDataElements;
        }()
    }, {
        key: 'onEventClick',
        value: function onEventClick(feature, callback) {
            var _this4 = this;

            var coord = feature.geometry.coordinates;

            (0, _api.apiFetch)('/events/' + feature.id + '.json').then(function (data) {
                var time = data.eventDate.substring(0, 10) + ' ' + data.eventDate.substring(11, 16);
                var dataValues = data.dataValues;
                var content = '<table><tbody>';

                if (Array.isArray(dataValues)) {
                    dataValues.forEach(function (dataValue) {
                        var displayEl = _this4.displayElements[dataValue.dataElement];

                        if (displayEl) {
                            var value = dataValue.value;

                            if (displayEl.optionSet) {
                                value = displayEl.optionSet[value];
                            }

                            content += '<tr><th>' + displayEl.name + '</th><td>' + value + '</td></tr>';
                        }
                    });

                    content += '<tr style="height:5px;"><th></th><td></td></tr>';
                }

                content += '<tr><th>' + _i18next2.default.t('Organisation unit') + '</th><td>' + data.orgUnitName + '</td></tr>\n                            <tr><th>' + _i18next2.default.t('Event time') + '</th><td>' + time + '</td></tr>\n                            <tr><th>' + (_this4.eventCoordinateFieldName || _i18next2.default.t('Event location')) + '</th><td>' + coord[0] + ', ' + coord[1] + '</td></tr> \n                            </tbody></table>';

                callback(content);
            });
        }
    }, {
        key: 'toGeoJson',
        value: function toGeoJson(data) {
            var header = {};
            var features = [];

            // Convert headers to object for easier lookup
            data.headers.forEach(function (h, i) {
                return header[h.name] = i;
            });

            if (Array.isArray(data.rows)) {
                data.rows.forEach(function (row) {
                    var extent = row[header.extent].match(/([-\d\.]+)/g);
                    var coords = row[header.center].match(/([-\d\.]+)/g);

                    // Round to 6 decimals - http://www.jacklmoore.com/notes/rounding-in-javascript/
                    coords[0] = Number(Math.round(coords[0] + 'e6') + 'e-6');
                    coords[1] = Number(Math.round(coords[1] + 'e6') + 'e-6');

                    features.push({
                        type: 'Feature',
                        id: row[header.points],
                        geometry: {
                            type: 'Point',
                            coordinates: coords
                        },
                        properties: {
                            count: parseInt(row[header.count], 10),
                            bounds: [[extent[1], extent[0]], [extent[3], extent[2]]]
                        }
                    });
                });
            }

            return features;
        }
    }]);

    return EventLayer;
}(_Layer3.default);

exports.default = EventLayer;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _isPlainObject = __webpack_require__(232);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _Layer2 = __webpack_require__(45);

var _Layer3 = _interopRequireDefault(_Layer2);

var _filter = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FacilityLayer = function (_Layer) {
    _inherits(FacilityLayer, _Layer);

    function FacilityLayer() {
        _classCallCheck(this, FacilityLayer);

        return _possibleConstructorReturn(this, (FacilityLayer.__proto__ || Object.getPrototypeOf(FacilityLayer)).apply(this, arguments));
    }

    _createClass(FacilityLayer, [{
        key: 'createLayer',
        value: function createLayer(callback) {
            var _props = this.props,
                id = _props.id,
                data = _props.data,
                dataFilters = _props.dataFilters,
                labels = _props.labels,
                areaRadius = _props.areaRadius,
                labelFontColor = _props.labelFontColor,
                labelFontSize = _props.labelFontSize,
                labelFontStyle = _props.labelFontStyle,
                labelFontWeight = _props.labelFontWeight;


            var filteredData = (0, _filter.filterData)(data, dataFilters);

            var map = this.context.map;

            // Create layer config object
            var config = {
                type: 'markers',
                pane: id,
                data: filteredData,
                hoverLabel: '{label}'
            };

            // Labels and label style
            if (labels) {
                config.label = '{name}';
                config.labelStyle = {
                    color: labelFontColor,
                    fontSize: labelFontSize,
                    fontStyle: labelFontStyle,
                    fontWeight: labelFontWeight,
                    paddingTop: '10px'
                };
            }

            // Remove area layer instance if already exist
            if (this.areaInstance && map.hasLayer(this.areaInstance)) {}
            // map.removeLayer(this.areaInstance);


            // Create and add facility layer based on config object
            this.layer = map.createLayer(config).addTo(map);

            // Create and add area layer
            if (areaRadius) {
                this.areaInstance = map.addLayer({
                    type: 'circles',
                    pane: id + '-area',
                    radius: areaRadius,
                    highlightStyle: false,
                    data: filteredData
                });
            }

            // Handle facility click
            this.layer.on('click', this.onFeatureClick, this);
            this.layer.on('contextmenu', this.onFeatureRightClick, this);

            var layerBounds = this.layer.getBounds();

            if (layerBounds.isValid()) {
                map.fitBounds(layerBounds);
            }
        }

        // Show pupup on facility click

    }, {
        key: 'onFeatureClick',
        value: function onFeatureClick(evt) {
            var attr = evt.layer.feature.properties;
            var content = '<div class="leaflet-popup-orgunit"><em>' + attr.name + '</em>';

            if ((0, _isPlainObject2.default)(attr.dimensions)) {
                content += '<br/>' + _i18next2.default.t('Groups') + ': ' + Object.keys(attr.dimensions).map(function (id) {
                    return attr.dimensions[id];
                }).join(', ');
            }

            if (attr.pn) {
                content += '<br/>' + _i18next2.default.t('Parent unit') + ': ' + attr.pn;
            }

            content += '</div>';

            L.popup().setLatLng(evt.latlng).setContent(content).openOn(this.context.map);
        }
    }, {
        key: 'onFeatureRightClick',
        value: function onFeatureRightClick(evt) {
            L.DomEvent.stopPropagation(evt); // Don't propagate to map right-click

            var latlng = evt.latlng;
            var position = [evt.originalEvent.x, evt.originalEvent.pageY || evt.originalEvent.y];
            var props = this.props;

            this.props.openContextMenu({
                position: position,
                coordinate: [latlng[1], latlng[0]],
                layerId: props.id,
                layerType: props.layer,
                feature: evt.layer.feature
            });
        }

        // Remove layer instance (both facilities and areas)

    }, {
        key: 'removeLayer',
        value: function removeLayer() {
            var map = this.context.map;

            if (map.hasLayer(this.areaInstance)) {
                map.removeLayer(this.areaInstance);
            }
            _get(FacilityLayer.prototype.__proto__ || Object.getPrototypeOf(FacilityLayer.prototype), 'removeLayer', this).call(this);
        }
    }]);

    return FacilityLayer;
}(_Layer3.default);

exports.default = FacilityLayer;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(0);

var _Layer2 = __webpack_require__(45);

var _Layer3 = _interopRequireDefault(_Layer2);

var _filter = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThematicLayer = function (_Layer) {
    _inherits(ThematicLayer, _Layer);

    function ThematicLayer() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ThematicLayer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ThematicLayer.__proto__ || Object.getPrototypeOf(ThematicLayer)).call.apply(_ref, [this].concat(args))), _this), _this.getHtmlLegend = function (_ref2) {
            var title = _ref2.title,
                period = _ref2.period,
                items = _ref2.items;
            return '\n        <div class="dhis2-legend">\n            <h2>' + title + '</h2>\n            <span>' + period + '</span>\n            <dl class="dhis2-legend-automatic">\n                ' + items.map(function (item) {
                return '\n                    <dt style="background-color:' + item.color + '"></dt>\n                    <dd>' + (item.name || '') + ' ' + (!isNaN(item.startValue) ? item.startValue + ' - ' + item.endValue : '') + ' (' + item.count + ')</dd>\n                ';
            }).join('') + '\n            </dl>\n        </div>';
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ThematicLayer, [{
        key: 'createLayer',
        value: function createLayer(callback) {
            var _props = this.props,
                id = _props.id,
                data = _props.data,
                dataFilters = _props.dataFilters,
                _props$valueFilter = _props.valueFilter,
                valueFilter = _props$valueFilter === undefined ? { gt: null, lt: null } : _props$valueFilter,
                labels = _props.labels,
                labelFontSize = _props.labelFontSize,
                labelFontStyle = _props.labelFontStyle,
                legend = _props.legend,
                isPlugin = _props.isPlugin;


            var map = this.context.map;

            var config = {
                type: 'choropleth',
                pane: id,
                data: (0, _filter.filterData)(data, dataFilters),
                hoverLabel: '{name} ({value})'
            };

            if (labels) {
                config.label = '{name}';
                config.labelStyle = {
                    fontSize: labelFontSize,
                    fontStyle: labelFontStyle
                };
                config.labelPane = id + '-labels';
            }

            this.layer = map.createLayer(config);
            this.layer.on('click', this.onFeatureClick, this);
            this.layer.on('contextmenu', this.onFeatureRightClick, this);

            if (isPlugin && legend) {
                map.legend = (map.legend || '') + this.getHtmlLegend(legend); // TODO: Better way to assemble the legend?
            }

            var layerBounds = this.layer.getBounds();

            if (layerBounds.isValid()) {
                map.invalidateSize();
                map.fitBounds(layerBounds);
            }
        }

        // Used for legend in map plugins

    }, {
        key: 'onFeatureClick',
        value: function onFeatureClick(evt) {
            var _evt$layer$feature$pr = evt.layer.feature.properties,
                name = _evt$layer$feature$pr.name,
                value = _evt$layer$feature$pr.value;
            var _props2 = this.props,
                columns = _props2.columns,
                aggregationType = _props2.aggregationType,
                legend = _props2.legend;

            var map = this.context.map;
            var indicator = columns[0].items[0].name || '';
            var period = legend.period;
            var content = '\n            <div class="leaflet-popup-orgunit">\n                <em>' + name + '</em><br>\n                ' + indicator + '<br>\n                ' + period + ': ' + value + ' ' + (aggregationType ? '(' + aggregationType + ')' : '') + '\n            </div>';

            L.popup().setLatLng(evt.latlng).setContent(content).openOn(map);
        }
    }, {
        key: 'onFeatureRightClick',
        value: function onFeatureRightClick(evt) {
            L.DomEvent.stopPropagation(evt); // Don't propagate to map right-click

            var latlng = evt.latlng;
            var position = [evt.originalEvent.x, evt.originalEvent.pageY || evt.originalEvent.y];
            var props = this.props;

            this.props.openContextMenu({
                position: position,
                coordinate: [latlng.lng, latlng.lat],
                layerId: props.id,
                layerType: props.layer,
                feature: evt.layer.feature
            });
        }
    }, {
        key: 'removeLayer',
        value: function removeLayer() {
            this.layer.off('click', this.onFeatureClick, this);
            this.layer.off('contextmenu', this.onFeatureRightClick, this);

            _get(ThematicLayer.prototype.__proto__ || Object.getPrototypeOf(ThematicLayer.prototype), 'removeLayer', this).call(this);
        }
    }]);

    return ThematicLayer;
}(_Layer3.default);

exports.default = ThematicLayer;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _Layer2 = __webpack_require__(45);

var _Layer3 = _interopRequireDefault(_Layer2);

var _filter = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BoundaryLayer = function (_Layer) {
    _inherits(BoundaryLayer, _Layer);

    function BoundaryLayer() {
        _classCallCheck(this, BoundaryLayer);

        return _possibleConstructorReturn(this, (BoundaryLayer.__proto__ || Object.getPrototypeOf(BoundaryLayer)).apply(this, arguments));
    }

    _createClass(BoundaryLayer, [{
        key: 'createLayer',
        value: function createLayer() {
            var _props = this.props,
                id = _props.id,
                data = _props.data,
                labels = _props.labels,
                labelFontSize = _props.labelFontSize,
                labelFontStyle = _props.labelFontStyle,
                radiusLow = _props.radiusLow,
                dataFilters = _props.dataFilters;


            var filteredData = (0, _filter.filterData)(data, dataFilters);

            var map = this.context.map;

            var config = {
                type: 'boundary',
                pane: id,
                data: filteredData,
                hoverLabel: '{name}',
                style: {
                    opacity: 1,
                    fillOpacity: 0,
                    fill: false
                }
            };

            if (labels) {
                config.label = '{name}';
                config.labelStyle = {
                    fontSize: labelFontSize,
                    fontStyle: labelFontStyle
                };
            }

            if (radiusLow) {
                config.style.radius = radiusLow;
            }

            this.layer = map.createLayer(config);
            this.layer.on('click', this.onFeatureClick, this);
            this.layer.on('contextmenu', this.onFeatureRightClick, this);

            var layerBounds = this.layer.getBounds();

            if (layerBounds.isValid()) {
                map.invalidateSize();
                map.fitBounds(layerBounds);
            }
        }
    }, {
        key: 'onFeatureClick',
        value: function onFeatureClick(evt) {
            var attr = evt.layer.feature.properties;
            var content = '<div class="leaflet-popup-orgunit"><em>' + attr.name + '</em>';

            if (attr.level) {
                content += '<br/>' + _i18next2.default.t('Level') + ': ' + attr.level;
            }

            if (attr.parentName) {
                content += '<br/>' + _i18next2.default.t('Parent unit') + ': ' + attr.parentName;
            }

            content += '</div>';

            L.popup().setLatLng(evt.latlng).setContent(content).openOn(this.context.map);
        }
    }, {
        key: 'onFeatureRightClick',
        value: function onFeatureRightClick(evt) {
            L.DomEvent.stopPropagation(evt); // Don't propagate to map right-click

            var latlng = evt.latlng;
            var position = [evt.originalEvent.x, evt.originalEvent.pageY || evt.originalEvent.y];
            var props = this.props;

            this.props.openContextMenu({
                position: position,
                coordinate: [latlng.lng, latlng.lat],
                layerId: props.id,
                layerType: props.layer,
                feature: evt.layer.feature
            });
        }
    }, {
        key: 'removeLayer',
        value: function removeLayer() {
            this.layer.off('click', this.onFeatureClick, this);
            this.layer.off('contextmenu', this.onFeatureRightClick, this);

            _get(BoundaryLayer.prototype.__proto__ || Object.getPrototypeOf(BoundaryLayer.prototype), 'removeLayer', this).call(this);
        }
    }]);

    return BoundaryLayer;
}(_Layer3.default);

exports.default = BoundaryLayer;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Layer2 = __webpack_require__(45);

var _Layer3 = _interopRequireDefault(_Layer2);

var _api = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EarthEngineLayer = function (_Layer) {
    _inherits(EarthEngineLayer, _Layer);

    function EarthEngineLayer() {
        _classCallCheck(this, EarthEngineLayer);

        return _possibleConstructorReturn(this, (EarthEngineLayer.__proto__ || Object.getPrototypeOf(EarthEngineLayer)).apply(this, arguments));
    }

    _createClass(EarthEngineLayer, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prev) {
            _get(EarthEngineLayer.prototype.__proto__ || Object.getPrototypeOf(EarthEngineLayer.prototype), 'componentDidUpdate', this).call(this, prev);

            var coordinate = this.props.coordinate;


            if (coordinate && coordinate !== prev.coordinate) {
                try {
                    this.layer.showValue({
                        lng: coordinate[0],
                        lat: coordinate[1]
                    });
                } catch (err) {
                    console.error('Google Earth Engine failed. Is the service configured for this DHIS2 instance?');
                }
            }
        }
    }, {
        key: 'createLayer',
        value: function createLayer() {
            var props = this.props;
            var map = this.context.map;

            var config = {
                type: 'earthEngine',
                pane: props.id,
                id: props.datasetId,
                band: props.band,
                mask: props.mask,
                attribution: props.attribution,
                filter: props.filter,
                methods: props.methods,
                aggregation: props.aggregation,
                name: props.name,
                unit: props.legend.unit,
                value: props.value,
                legend: props.legend && !props.legend.unit ? props.legend.items : null,
                resolution: props.resolution,
                projection: props.projection
            };

            if (props.params) {
                config.params = props.params;
            }

            if (props.popup) {
                config.popup = props.popup;
            }

            config.accessToken = function (callback) {
                return (0, _api.apiFetch)('/tokens/google').then(function (json) {
                    return callback(json);
                });
            };

            this.layer = map.createLayer(config);
        }
    }]);

    return EarthEngineLayer;
}(_Layer3.default);

exports.default = EarthEngineLayer;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Layer2 = __webpack_require__(45);

var _Layer3 = _interopRequireDefault(_Layer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExternalLayer = function (_Layer) {
    _inherits(ExternalLayer, _Layer);

    function ExternalLayer() {
        _classCallCheck(this, ExternalLayer);

        return _possibleConstructorReturn(this, (ExternalLayer.__proto__ || Object.getPrototypeOf(ExternalLayer)).apply(this, arguments));
    }

    _createClass(ExternalLayer, [{
        key: 'createLayer',
        value: function createLayer() {
            // console.log('EXTERNAL LAYER', this.props);

            var props = this.props;
            var config = props.config;
            var map = this.context.map;

            config.type = 'tileLayer'; // TODO: Should be part of config object
            config.pane = props.id;

            this.layer = map.createLayer(config);
        }
    }]);

    return ExternalLayer;
}(_Layer3.default);

exports.default = ExternalLayer;

/***/ }),
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.configI18n = undefined;

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

var _i18nextXhrBackend = __webpack_require__(554);

var _i18nextXhrBackend2 = _interopRequireDefault(_i18nextXhrBackend);

var _d = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configI18n = exports.configI18n = function configI18n(userSettings) {
    var uiLocale = userSettings.keyUiLocale;

    if (uiLocale && uiLocale !== 'en') {
        _d.config.i18n.sources.add('./i18n/i18n_module_' + uiLocale + '.properties');
    }

    _d.config.i18n.sources.add('./i18n/i18n_module_en.properties');

    _i18next2.default.use(_i18nextXhrBackend2.default).init({
        returnEmptyString: false,
        fallbackLng: false,
        keySeparator: '|',
        backend: {
            loadPath: '/i18n/{{lng}}.json'
        }
    }, function (err, t) {
        if (uiLocale && uiLocale !== 'en') {
            _i18next2.default.changeLanguage(uiLocale);
        }
    });
};

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(555).default;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(556);

var utils = _interopRequireWildcard(_utils);

var _ajax = __webpack_require__(557);

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getDefaults() {
  return {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    addPath: '/locales/add/{{lng}}/{{ns}}',
    allowMultiLoading: false,
    parse: JSON.parse,
    crossDomain: false,
    ajax: _ajax2.default
  };
}

var Backend = function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Backend);

    this.init(services, options);

    this.type = 'backend';
  }

  _createClass(Backend, [{
    key: 'init',
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.services = services;
      this.options = utils.defaults(options, this.options || {}, getDefaults());
    }
  }, {
    key: 'readMulti',
    value: function readMulti(languages, namespaces, callback) {
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath(languages, namespaces);
      }

      var url = this.services.interpolator.interpolate(loadPath, { lng: languages.join('+'), ns: namespaces.join('+') });

      this.loadUrl(url, callback);
    }
  }, {
    key: 'read',
    value: function read(language, namespace, callback) {
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath([language], [namespace]);
      }

      var url = this.services.interpolator.interpolate(loadPath, { lng: language, ns: namespace });

      this.loadUrl(url, callback);
    }
  }, {
    key: 'loadUrl',
    value: function loadUrl(url, callback) {
      var _this = this;

      this.options.ajax(url, this.options, function (data, xhr) {
        if (xhr.status >= 500 && xhr.status < 600) return callback('failed loading ' + url, true /* retry */);
        if (xhr.status >= 400 && xhr.status < 500) return callback('failed loading ' + url, false /* no retry */);

        var ret = void 0,
            err = void 0;
        try {
          ret = _this.options.parse(data, url);
        } catch (e) {
          err = 'failed parsing ' + url + ' to json';
        }
        if (err) return callback(err, false);
        callback(null, ret);
      });
    }
  }, {
    key: 'create',
    value: function create(languages, namespace, key, fallbackValue) {
      var _this2 = this;

      if (typeof languages === 'string') languages = [languages];

      var payload = {};
      payload[key] = fallbackValue || '';

      languages.forEach(function (lng) {
        var url = _this2.services.interpolator.interpolate(_this2.options.addPath, { lng: lng, ns: namespace });

        _this2.options.ajax(url, _this2.options, function (data, xhr) {
          //const statusCode = xhr.status.toString();
          // TODO: if statusCode === 4xx do log
        }, payload);
      });
    }
  }]);

  return Backend;
}();

Backend.type = 'backend';

exports.default = Backend;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaults = defaults;
exports.extend = extend;
var arr = [];
var each = arr.forEach;
var slice = arr.slice;

function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

function extend(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function addQueryString(url, params) {
  if (params && (typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
    var queryString = '',
        e = encodeURIComponent;

    // Must encode data
    for (var paramName in params) {
      queryString += '&' + e(paramName) + '=' + e(params[paramName]);
    }

    if (!queryString) {
      return url;
    }

    url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
  }

  return url;
}

// https://gist.github.com/Xeoncross/7663273
function ajax(url, options, callback, data, cache) {

  if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
    if (!cache) {
      data['_t'] = new Date();
    }
    // URL encoded form data must be in querystring format
    data = addQueryString('', data).slice(1);
  }

  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }

  try {
    var x;
    if (XMLHttpRequest) {
      x = new XMLHttpRequest();
    } else {
      x = new ActiveXObject('MSXML2.XMLHTTP.3.0');
    }
    x.open(data ? 'POST' : 'GET', url, 1);
    if (!options.crossDomain) {
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    }
    x.withCredentials = !!options.withCredentials;
    if (data) {
      x.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    }
    if (x.overrideMimeType) {
      x.overrideMimeType("application/json");
    }
    var h = options.customHeaders;
    if (h) {
      for (var i in h) {
        x.setRequestHeader(i, h[i]);
      }
    }
    x.onreadystatechange = function () {
      x.readyState > 3 && callback && callback(x.responseText, x);
    };
    x.send(data);
  } catch (e) {
    console && console.log(e);
  }
}

exports.default = ajax;

/***/ }),
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(24);

var _union = __webpack_require__(1239);

var _union2 = _interopRequireDefault(_union);

var _d = __webpack_require__(19);

var _uid = __webpack_require__(50);

var _PluginMap = __webpack_require__(1242);

var _PluginMap2 = _interopRequireDefault(_PluginMap);

var _requests = __webpack_require__(255);

var _layers = __webpack_require__(256);

var _i18n = __webpack_require__(553);

var _favorites = __webpack_require__(261);

__webpack_require__(1246);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Inspiration:
// pivot: https://github.com/dhis2/pivot-tables-app/blob/master/src/plugin.js
// d2-analysis: https://github.com/dhis2/d2-analysis/blob/master/src/util/Plugin.js

var apiVersion = 29;

var Plugin = function Plugin() {
    var loadLayers = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
            var basemap;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (isUnmounted(config.el)) {
                                _context.next = 7;
                                break;
                            }

                            basemap = void 0;

                            if (!(0, _uid.isValidUid)(config.basemap)) {
                                _context.next = 6;
                                break;
                            }

                            _context.next = 5;
                            return (0, _requests.getExternalLayer)(config.basemap);

                        case 5:
                            basemap = _context.sent;

                        case 6:

                            if (config.mapViews) {
                                Promise.all(config.mapViews.map(_layers.fetchLayer)).then(function (mapViews) {
                                    return drawMap(_extends({}, config, {
                                        mapViews: mapViews,
                                        basemap: basemap || config.basemap
                                    }));
                                });
                            }

                        case 7:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        return function loadLayers(_x) {
            return _ref.apply(this, arguments);
        };
    }();

    var _configs = [];
    var _components = {};
    var _isReady = false;
    var _isPending = false;

    function getType() {
        return 'MAP';
    }

    function add() {
        for (var _len = arguments.length, configs = Array(_len), _key = 0; _key < _len; _key++) {
            configs[_key] = arguments[_key];
        }

        configs = Array.isArray(configs[0]) ? configs[0] : configs;

        if (configs.length) {
            _configs = [].concat(_toConsumableArray(_configs), _toConsumableArray(configs));
            configs.forEach(renderLoadingIndicator);
        }
    }

    function load() {
        for (var _len2 = arguments.length, configs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            configs[_key2] = arguments[_key2];
        }

        add(Array.isArray(configs[0]) ? configs[0] : configs);

        if (_isReady) {
            onInit();
        } else if (!_isPending) {
            _isPending = true;
            var url = this.url,
                username = this.username,
                password = this.password;

            initialize(url, username, password);
        }
    }

    function initialize(url, username, password) {
        if (url) {
            _d.config.baseUrl = url + '/api/' + apiVersion;
        }

        if (username && password) {
            _d.config.context = { auth: username + ':' + password };
        }

        _d.config.schemas = (0, _union2.default)(_d.config.schemas, ['dataElement', 'dataSet', 'externalMapLayer', 'indicator', 'legendSet', 'map', 'optionSet', 'organisationUnitGroup', 'organisationUnitGroupSet', 'programStage']);

        (0, _d.getUserSettings)().then(_i18n.configI18n).then(_d.init).then(onInit);
    }

    function onInit() {
        _isReady = true;

        while (_configs.length) {
            loadMap(_configs.shift());
        }
    }

    function loadMap(config) {
        if (config.id && !isUnmounted(config.el)) {
            // Load favorite
            (0, _requests.mapRequest)(config.id).then(function (favorite) {
                return loadLayers(_extends({}, config, favorite));
            });
        } else {
            loadLayers((0, _favorites.translateConfig)(config));
        }
    }

    function drawMap(config) {
        if (config.el && !isUnmounted(config.el)) {
            var domEl = document.getElementById(config.el);

            if (domEl) {
                _components[config.el] = (0, _reactDom.render)(_react2.default.createElement(_PluginMap2.default, config), domEl);
            }
        }
    }

    function renderLoadingIndicator(config) {
        if (config.el) {
            var domEl = document.getElementById(config.el);

            if (domEl) {
                domEl.innerHTML = ''; // TODO: Remove when unmount is used
                var div = document.createElement('div');
                div.className = 'spinner';
                domEl.appendChild(div);
                _components[config.el] = 'loading';
            }
        }
    }

    function unmount(el) {
        var mapComponent = _components[el];

        if (mapComponent) {
            _components[el] = 'unmounted';

            var domEl = document.getElementById(el);

            if (domEl) {
                if (mapComponent === 'loading') {
                    domEl.innerHTML = ''; // Remove spinner
                    return true;
                } else if (mapComponent instanceof _PluginMap2.default) {
                    return (0, _reactDom.unmountComponentAtNode)(domEl);
                }
            }
        }

        return false;
    }

    function isUnmounted(el) {
        return el && _components[el] === 'unmounted';
    }

    // Should be called if the map container is resized
    function resize(el) {
        var mapComponent = _components[el];

        if (mapComponent && mapComponent instanceof _PluginMap2.default && mapComponent.map) {
            mapComponent.map.invalidateSize();
            return true;
        }

        return false;
    }

    return {
        // Public properties
        url: null,
        username: null,
        password: null,
        loadingIndicator: false,
        getType: getType,
        load: load,
        add: add,
        unmount: unmount,
        resize: resize
    };
};

var mapPlugin = new Plugin();

global.mapPlugin = mapPlugin;

exports.default = mapPlugin;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(17),
    func = convert('union', __webpack_require__(1240));

func.placeholder = __webpack_require__(16);
module.exports = func;


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(153),
    baseRest = __webpack_require__(248),
    baseUniq = __webpack_require__(258),
    isArrayLikeObject = __webpack_require__(1241);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(42),
    isObjectLike = __webpack_require__(25);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _build = __webpack_require__(527);

var _build2 = _interopRequireDefault(_build);

var _PluginContextMenu = __webpack_require__(1243);

var _PluginContextMenu2 = _interopRequireDefault(_PluginContextMenu);

var _Layer = __webpack_require__(45);

var _Layer2 = _interopRequireDefault(_Layer);

var _EventLayer = __webpack_require__(532);

var _EventLayer2 = _interopRequireDefault(_EventLayer);

var _FacilityLayer = __webpack_require__(533);

var _FacilityLayer2 = _interopRequireDefault(_FacilityLayer);

var _ThematicLayer = __webpack_require__(534);

var _ThematicLayer2 = _interopRequireDefault(_ThematicLayer);

var _BoundaryLayer = __webpack_require__(535);

var _BoundaryLayer2 = _interopRequireDefault(_BoundaryLayer);

var _EarthEngineLayer = __webpack_require__(536);

var _EarthEngineLayer2 = _interopRequireDefault(_EarthEngineLayer);

var _ExternalLayer = __webpack_require__(537);

var _ExternalLayer2 = _interopRequireDefault(_ExternalLayer);

var _basemaps = __webpack_require__(439);

var _alerts = __webpack_require__(100);

var _map = __webpack_require__(67);

var _layers = __webpack_require__(256);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var layerType = {
    event: _EventLayer2.default,
    facility: _FacilityLayer2.default,
    thematic: _ThematicLayer2.default,
    boundary: _BoundaryLayer2.default,
    earthEngine: _EarthEngineLayer2.default,
    external: _ExternalLayer2.default
};

var styles = {
    map: {
        width: '100%',
        height: '100%'
    },
    alerts: {
        padding: 20,
        fontSize: 12
    },
    alert: {
        lineHeight: '16px',
        paddingBottom: 8
    }
};

// TODO: Resuse code from Map.js

var PluginMap = function (_Component) {
    _inherits(PluginMap, _Component);

    _createClass(PluginMap, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                map: this.map
            };
        }
    }]);

    function PluginMap(props, context) {
        _classCallCheck(this, PluginMap);

        // Create map div
        var _this = _possibleConstructorReturn(this, (PluginMap.__proto__ || Object.getPrototypeOf(PluginMap)).call(this, props, context));

        var div = document.createElement('div');
        div.style.width = '100%';
        div.style.height = '100%';

        _this.map = (0, _build2.default)(div, {
            scrollWheelZoom: false
        });

        _this.state = {
            mapViews: props.mapViews // Can be changed by drilling
        };
        return _this;
    }

    _createClass(PluginMap, [{
        key: 'onRightClick',
        value: function onRightClick(evt) {
            L.DomEvent.stopPropagation(evt); // Don't propagate to map right-click

            this.setState({
                contextMenuPosition: [evt.originalEvent.x, evt.originalEvent.pageY || evt.originalEvent.y]
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.node && this.map) {
                // If map is rendered
                var _props = this.props,
                    bounds = _props.bounds,
                    latitude = _props.latitude,
                    longitude = _props.longitude,
                    zoom = _props.zoom;

                var map = this.map;

                this.node.appendChild(map.getContainer()); // Append map container to DOM

                // Add zoom control
                map.addControl({
                    type: 'zoom',
                    position: 'topright'
                });

                if (map.legend) {
                    this.legend = map.addControl({
                        type: 'legend',
                        offset: [0, -64],
                        content: map.legend
                    });
                }

                map.invalidateSize();

                var layersBounds = map.getLayersBounds();

                if (layersBounds.isValid()) {
                    map.fitBounds(layersBounds);
                } else if (Array.isArray(bounds)) {
                    map.fitBounds(bounds);
                } else if (latitude && longitude && zoom) {
                    map.setView([latitude, longitude], zoom);
                } else {
                    map.fitWorld();
                }

                map.invalidateSize();

                map.on('click', this.onCloseContextMenu, this);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var map = this.map;

            if (map) {
                map.invalidateSize();

                if (this.legend) {
                    this.legend.setContent(map.legend);
                }
            }
        }

        // Remove map

    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.map) {
                this.map.remove();
            }
        }
    }, {
        key: 'onOpenContextMenu',
        value: function onOpenContextMenu(state) {
            this.setState(state);
        }
    }, {
        key: 'onCloseContextMenu',
        value: function onCloseContextMenu() {
            this.setState({
                position: null,
                feature: null
            });
        }
    }, {
        key: 'onDrill',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(direction) {
                var _state, layerId, feature, mapViews, newConfig, _feature$properties, level, id, parentGraph, grandParentId, grandParentParentGraph, layerConfig, newLayer;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _state = this.state, layerId = _state.layerId, feature = _state.feature, mapViews = _state.mapViews;
                                newConfig = void 0;

                                if (!(layerId && feature)) {
                                    _context.next = 11;
                                    break;
                                }

                                _feature$properties = feature.properties, level = _feature$properties.level, id = _feature$properties.id, parentGraph = _feature$properties.parentGraph, grandParentId = _feature$properties.grandParentId, grandParentParentGraph = _feature$properties.grandParentParentGraph;
                                layerConfig = mapViews.find(function (layer) {
                                    return layer.id === layerId;
                                });


                                if (direction === 'up') {
                                    newConfig = (0, _map.drillUpDown)(layerConfig, grandParentId, grandParentParentGraph, parseInt(level) - 1);
                                } else {
                                    newConfig = (0, _map.drillUpDown)(layerConfig, id, parentGraph, parseInt(level) + 1);
                                }

                                _context.next = 8;
                                return (0, _layers.fetchLayer)(newConfig);

                            case 8:
                                newLayer = _context.sent;


                                this.map.legend = '';

                                this.setState({
                                    mapViews: mapViews.map(function (layer) {
                                        return layer.id === layerId ? newLayer : layer;
                                    }),
                                    position: null,
                                    feature: null
                                });

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function onDrill(_x) {
                return _ref.apply(this, arguments);
            }

            return onDrill;
        }()
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props$basemap = this.props.basemap,
                basemap = _props$basemap === undefined ? { id: 'osmLight' } : _props$basemap;
            var _state2 = this.state,
                mapViews = _state2.mapViews,
                position = _state2.position,
                feature = _state2.feature;


            var selectedBasemap = void 0;

            if (basemap.url) {
                // External layer
                selectedBasemap = {
                    id: basemap.id,
                    config: _extends({
                        type: 'tileLayer'
                    }, basemap)
                };
            } else {
                selectedBasemap = _basemaps.defaultBasemaps.find(function (map) {
                    return map.id === (basemap.id || basemap);
                });
            }

            var alerts = (0, _alerts.getMapAlerts)(this.props);

            return !alerts.length ? _react2.default.createElement(
                'div',
                { ref: function ref(node) {
                        return _this2.node = node;
                    }, style: styles.map },
                mapViews.filter(function (layer) {
                    return layer.isLoaded;
                }).map(function (config) {
                    var Overlay = layerType[config.layer] || _Layer2.default;

                    return _react2.default.createElement(Overlay, _extends({
                        key: config.id,
                        openContextMenu: _this2.onOpenContextMenu.bind(_this2)
                    }, config, {
                        isPlugin: true
                    }));
                }),
                basemap.isVisible !== false && _react2.default.createElement(_Layer2.default, _extends({ key: 'basemap' }, selectedBasemap)),
                _react2.default.createElement(_PluginContextMenu2.default, {
                    position: position,
                    feature: feature,
                    onDrillDown: function onDrillDown() {
                        return _this2.onDrill('down');
                    },
                    onDrillUp: function onDrillUp() {
                        return _this2.onDrill('up');
                    }
                })
            ) : _react2.default.createElement(
                'div',
                { style: styles.alerts },
                alerts.map(function (alert) {
                    return _react2.default.createElement(
                        'div',
                        { key: alert.id, style: styles.alert },
                        _react2.default.createElement(
                            'strong',
                            null,
                            alert.title
                        ),
                        ': ',
                        alert.description
                    );
                })
            );
        }
    }]);

    return PluginMap;
}(_react.Component);

PluginMap.childContextTypes = {
    map: _propTypes2.default.object.isRequired
};

exports.default = PluginMap;

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _i18next = __webpack_require__(7);

var _i18next2 = _interopRequireDefault(_i18next);

__webpack_require__(1244);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContextMenu = function (_Component) {
    _inherits(ContextMenu, _Component);

    function ContextMenu() {
        _classCallCheck(this, ContextMenu);

        return _possibleConstructorReturn(this, (ContextMenu.__proto__ || Object.getPrototypeOf(ContextMenu)).apply(this, arguments));
    }

    _createClass(ContextMenu, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var position = this.props.position;


            if (position) {
                this.el.style.left = position[0] + 'px';
                this.el.style.top = position[1] + 'px';
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                position = _props.position,
                feature = _props.feature,
                onDrillDown = _props.onDrillDown,
                onDrillUp = _props.onDrillUp;


            if (!position || !feature) {
                return null;
            }

            var _feature$properties = feature.properties,
                hasCoordinatesUp = _feature$properties.hasCoordinatesUp,
                hasCoordinatesDown = _feature$properties.hasCoordinatesDown;


            return _react2.default.createElement(
                'div',
                { className: 'MapContextMenu', ref: function ref(el) {
                        return _this2.el = el;
                    } },
                hasCoordinatesUp && _react2.default.createElement(
                    'div',
                    { onClick: onDrillUp },
                    _i18next2.default.t('Drill up one level')
                ),
                hasCoordinatesDown && _react2.default.createElement(
                    'div',
                    { onClick: onDrillDown },
                    _i18next2.default.t('Drill down one level')
                )
            );
        }
    }]);

    return ContextMenu;
}(_react.Component);

exports.default = ContextMenu;

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1245);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(33)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./PluginContextMenu.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./PluginContextMenu.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, ".MapContextMenu {\n  position: absolute;\n  background: #fff;\n  z-index: 1500;\n  cursor: pointer;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n  font-family: Roboto, sans-serif;\n  font-size: 12px;\n  line-height: 24px;\n  padding: 3px 0;\n}\n\n.MapContextMenu div {\n  padding: 0 10px;\n}\n\n.MapContextMenu div:hover {\n  background: #eee;\n}\n", ""]);

// exports


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1247);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(33)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/lib/loader.js!./plugin.scss", function() {
		var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/lib/loader.js!./plugin.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(31)(false);
// imports


// module
exports.push([module.i, ".dhis2-map-widget-container {\n  height: 100%; }\n  .dhis2-map-widget-container .dhis2-map-title {\n    height: 19px;\n    font-weight: bold;\n    font-size: 12px;\n    font-family: LiberationSans, arial, sans-serif;\n    color: #333333;\n    text-align: center;\n    line-height: 14px;\n    letter-spacing: -0.1px; }\n  .dhis2-map-widget-container .leaflet-container {\n    height: calc(100% - 19px);\n    border: 1px solid #d0d0d0; }\n  .dhis2-map-widget-container .dhis2-map-widget-alert {\n    font-size: 11px;\n    padding-left: 20px; }\n  .dhis2-map-widget-container .leaflet-popup {\n    max-height: 250px; }\n    .dhis2-map-widget-container .leaflet-popup .leaflet-popup-content {\n      max-height: 200px;\n      overflow-y: auto; }\n      .dhis2-map-widget-container .leaflet-popup .leaflet-popup-content th {\n        white-space: nowrap;\n        vertical-align: top;\n        color: #333;\n        padding: 0;\n        font-weight: bold;\n        padding-right: 10px;\n        font-size: 12px;\n        border: 0;\n        min-height: 0; }\n", ""]);

// exports


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// map.js